webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var platform_browser_dynamic_1 = __webpack_require__(1);
	var app_component_1 = __webpack_require__(328);
	var app_routes_1 = __webpack_require__(900);
	var http_1 = __webpack_require__(382);
	var forms_1 = __webpack_require__(1030);
	var core_1 = __webpack_require__(5);
	var http_2 = __webpack_require__(382);
	var custom_http_1 = __webpack_require__(1067);
	var error_notifier_1 = __webpack_require__(652);
	var CustomBrowserXhr_1 = __webpack_require__(1068);
	var progress_service_1 = __webpack_require__(980);
	var common_1 = __webpack_require__(2);
	if (({"ENV":"production"}).NODE_ENV == 'production') {
	    core_1.enableProdMode();
	}
	core_1.enableProdMode();
	platform_browser_dynamic_1.bootstrap(app_component_1.AppComponent, [
	    app_routes_1.APP_ROUTER_PROVIDERS,
	    error_notifier_1.ErrorNotifierService,
	    progress_service_1.ProgressService,
	    http_2.HTTP_PROVIDERS,
	    [{
	            provide: http_2.Http,
	            useFactory: function (backend, defaultOptions, errorNotifier) {
	                return new custom_http_1.CustomHttp(backend, defaultOptions, errorNotifier);
	            },
	            deps: [http_2.XHRBackend, http_2.RequestOptions, error_notifier_1.ErrorNotifierService]
	        }],
	    [{
	            provide: http_1.BrowserXhr,
	            useFactory: function (progressService) {
	                return new CustomBrowserXhr_1.CustomBrowserXhr(progressService);
	            },
	            deps: [progress_service_1.ProgressService]
	        }],
	    http_1.JSONP_PROVIDERS, forms_1.provideForms(), forms_1.disableDeprecatedForms(), forms_1.NgForm,
	    [{ provide: (common_1.APP_BASE_HREF, { useValue: "/" }) }],
	    [{ provide: (common_1.LocationStrategy, { useClass: common_1.HashLocationStrategy }) }]
	])
	    .catch(function (err) { return console.error(err); });
	//bootstrap(AppComponent);


/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	var core_1 = __webpack_require__(5);
	var router_1 = __webpack_require__(329);
	var login_service_1 = __webpack_require__(381);
	var login_component_1 = __webpack_require__(418);
	var empresa_service_1 = __webpack_require__(425);
	var provincia_service_1 = __webpack_require__(426);
	var permiso_service_1 = __webpack_require__(427);
	var menu_service_1 = __webpack_require__(428);
	var sucursal_service_1 = __webpack_require__(429);
	var usuario_service_1 = __webpack_require__(430);
	var tipoVariable_service_1 = __webpack_require__(431);
	var rol_service_1 = __webpack_require__(432);
	var nodo_service_1 = __webpack_require__(433);
	var medicion_service_1 = __webpack_require__(434);
	var regAlarma_service_1 = __webpack_require__(572);
	var ubicacion_service_1 = __webpack_require__(573);
	var gateway_service_1 = __webpack_require__(574);
	var sensor_service_1 = __webpack_require__(575);
	var tipoSensor_service_1 = __webpack_require__(576);
	var tipoBateria_service_1 = __webpack_require__(577);
	var alarma_service_1 = __webpack_require__(578);
	var aviso_service_1 = __webpack_require__(579);
	var navLeft_component_1 = __webpack_require__(581);
	var navSup_component_1 = __webpack_require__(587);
	var navRight_component_1 = __webpack_require__(592);
	var error_component_1 = __webpack_require__(651);
	var landingPage_component_1 = __webpack_require__(868);
	var auth_guard_service_1 = __webpack_require__(892);
	var miCuenta_service_1 = __webpack_require__(893);
	var email_service_1 = __webpack_require__(869);
	var notificacion_service_1 = __webpack_require__(894);
	var recargaCredito_service_1 = __webpack_require__(895);
	var informe_service_1 = __webpack_require__(896);
	var logActividad_service_1 = __webpack_require__(897);
	var husoHorario_service_1 = __webpack_require__(898);
	var documento_service_1 = __webpack_require__(588);
	var router_2 = __webpack_require__(329);
	var platform_browser_1 = __webpack_require__(259);
	var plan_service_1 = __webpack_require__(899);
	var AppComponent = (function () {
	    function AppComponent(loginService, empresaService, router, document) {
	        var _this = this;
	        this.loginService = loginService;
	        this.empresaService = empresaService;
	        this.router = router;
	        this.document = document;
	        this.urlLogo = "./img/logo_tbm.png";
	        var indexBarra = this.document.location.href.lastIndexOf("/");
	        this.url = this.document.location.href.substring(indexBarra);
	        if (this.loginService.isLoggedIn()) {
	            this.usuario = this.loginService.getDecodeToken();
	            if (this.usuario != undefined && this.usuario.empresa != null && this.usuario.rol != "Tecnico" && this.usuario.rol != "Administrador")
	                this.cargaFotoPerfil();
	        }
	        this.loginService.logIn.subscribe(function (mode) {
	            _this.usuario = _this.loginService.getDecodeToken();
	            if (_this.usuario != undefined && _this.usuario.empresa != null && mode && _this.usuario.rol != "Tecnico" && _this.usuario.rol != "Administrador")
	                _this.cargaFotoPerfil();
	        });
	        window.addEventListener("storage", function () {
	            if (!loginService.isLoggedIn())
	                loginService.logout();
	            else if (router.url === '/login')
	                location.reload();
	        }, false);
	        this.router.events
	            .subscribe(function (event) {
	            if (event instanceof router_1.NavigationEnd) {
	                _this.url = event.url;
	            }
	        });
	    }
	    AppComponent.prototype.cargaFotoPerfil = function () {
	        var _this = this;
	        this.usuario = this.loginService.getDecodeToken();
	        this.empresaService.getEmpresa(this.usuario.empresa).subscribe(function (empresa) {
	            //Cargo foto
	            if (empresa != null && empresa.logo != undefined && empresa.logo.data != undefined) {
	                var byteArray = new Uint8Array(empresa.logo.data.data);
	                var file = new Blob([byteArray], { type: empresa.logo.contentType });
	                var reader = new FileReader();
	                reader.onloadend = function () {
	                    this.urlLogo = reader.result;
	                }.bind(_this);
	                if (file) {
	                    reader.readAsDataURL(file);
	                }
	                else {
	                    _this.urlLogo = "";
	                }
	            }
	        });
	    };
	    AppComponent = __decorate([
	        core_1.Component({
	            selector: 'my-app',
	            template: " \n                <div id=\"contenedor\" class=\"container-fluid\" >\n      \t\t      <NavLeft *ngIf=\"url!='/'\"></NavLeft>\n      \t\t\t  <NavSup [urlLogo]=\"urlLogo\" *ngIf=\"url!='/'\" [alertaCalibracion]=\"alertaCalibracion\" [cantNotificaciones]=\"cantNotificaciones\"></NavSup>\n                  <NavRight [urlLogo]=\"urlLogo\" *ngIf=\"url!='/'\" (alerta)=\"alertaCalibracion = $event.alerta\" (alertaNotificaciones)=\"cantNotificaciones = $event.alertaNotificaciones\"></NavRight>\n                  <Error *ngIf=\"url!='/'\"></Error>\n                  <div [ngClass]=\"{'login-inicio':(!loginService.isLoggedIn() || loginService.getDecodeToken().cambiarPassword) && url!='/','principal':(loginService.isLoggedIn() && !loginService.getDecodeToken().cambiarPassword) && url!='/'}\">\n                          <router-outlet></router-outlet>                    \n                  </div>\n                  <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 marcoPie\" *ngIf=\"url!='/'\" [ngClass]=\"{'login-inicio':!loginService.isLoggedIn(),'footer':loginService.isLoggedIn()}\" style=\"\">\n                      <div class=\"col-lg-11 col-md-11 col-sm-11 col-xs-9\">\n                          <p style=\"float:right; padding:15px 10px\">\n                          TBM S.R.L. | Rosario, Santa Fe (Argentina) | www.tbmsrl.com.ar | info@tbmsrl.com.ar | Lamadrid 470 - Zona i - Nave 2 - PB Of. 2 (S2001EBJ) | Tel: +54 341 5277920\n                          </p>\n                      </div>\n                      <div class=\"col-lg-1 col-md-1 col-sm-1 col-xs-3\">\n                        <img class=\"tbmLogo\" src=\"./img/logo_tbm.png\" style=\"width: 100%; float:right\"/>\n                      </div>\n                  </div>\n      \t\t\t</div>",
	            styles: [""],
	            directives: [router_1.ROUTER_DIRECTIVES, navLeft_component_1.NavLeftComponent, navSup_component_1.NavSupComponent, error_component_1.ErrorComponent, navRight_component_1.NavRightComponent],
	            providers: [
	                empresa_service_1.EmpresaService, provincia_service_1.ProvinciaService, auth_guard_service_1.AuthGuard, permiso_service_1.PermisoService, menu_service_1.MenuService, sucursal_service_1.SucursalService, nodo_service_1.NodoService, medicion_service_1.MedicionService, usuario_service_1.UsuariosService,
	                regAlarma_service_1.RegAlarmaService, rol_service_1.RolService, ubicacion_service_1.UbicacionService, gateway_service_1.GatewayService, sensor_service_1.SensorService, tipoSensor_service_1.TipoSensorService, alarma_service_1.AlarmaService, aviso_service_1.AvisoService, tipoVariable_service_1.TipoVariableService, miCuenta_service_1.MiCuentaService,
	                email_service_1.EmailService, notificacion_service_1.NotificacionService, recargaCredito_service_1.RecargaCreditoService, tipoBateria_service_1.TipoBateriaService, informe_service_1.InformeService, logActividad_service_1.LogActividadService, husoHorario_service_1.HusoHorarioService, documento_service_1.DocumentoService, plan_service_1.PlanService
	            ],
	            precompile: [login_component_1.LoginComponent, landingPage_component_1.LandingPageComponent]
	        }),
	        __param(3, core_1.Inject(platform_browser_1.DOCUMENT)), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof login_service_1.LoginService !== 'undefined' && login_service_1.LoginService) === 'function' && _a) || Object, (typeof (_b = typeof empresa_service_1.EmpresaService !== 'undefined' && empresa_service_1.EmpresaService) === 'function' && _b) || Object, (typeof (_c = typeof router_2.Router !== 'undefined' && router_2.Router) === 'function' && _c) || Object, Object])
	    ], AppComponent);
	    return AppComponent;
	    var _a, _b, _c;
	}());
	exports.AppComponent = AppComponent;


/***/ }),
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var router_1 = __webpack_require__(329);
	var http_1 = __webpack_require__(382);
	__webpack_require__(374);
	var Observable_1 = __webpack_require__(38);
	__webpack_require__(403);
	__webpack_require__(404);
	__webpack_require__(406);
	var myGlobals = __webpack_require__(414);
	var jwtDecode = __webpack_require__(415);
	var LoginService = (function () {
	    function LoginService(router, http) {
	        var _this = this;
	        this.router = router;
	        this.http = http;
	        this.loggedIn = !!localStorage.getItem('jwtSGDI');
	        this.logIn = new core_1.EventEmitter();
	        this.redirectUrl = "";
	        this.error = Observable_1.Observable.create(function (observer) {
	            _this.errorObserver = observer;
	        }).share();
	    }
	    LoginService.prototype.login = function (usuario, password) {
	        var _this = this;
	        //this.logout();
	        var headers = new http_1.Headers({ 'Content-Type': 'application/json' });
	        this.http
	            .post(myGlobals.default.BASE_URL + '/authenticate', JSON.stringify({ usuario: usuario, password: password }), { headers: headers })
	            .toPromise()
	            .then(function (res) {
	            if (res.json().token != undefined) {
	                localStorage.setItem('jwtSGDI', res.json().token);
	                var base64Url = res.json().token.split('.')[1];
	                var base64 = base64Url.replace('-', '+').replace('_', '/');
	                _this.usuario = JSON.parse(window.atob(base64));
	                //si tengo url guardada redirijo ahi
	                var redirect = _this.redirectUrl ? _this.redirectUrl : '/home';
	                // Redirect the user
	                _this.router.navigate([redirect]);
	                _this.loggedIn = true;
	                _this.logIn.emit(true);
	            }
	        })
	            .catch(function (error) {
	            _this.errorObserver.next(JSON.parse(error._body).message);
	        });
	    };
	    LoginService.prototype.logout = function () {
	        localStorage.removeItem('jwtSGDI');
	        this.loggedIn = false;
	        this.logIn.emit(false);
	        var link = ['/login'];
	        this.router.navigate(link);
	        setTimeout(function () { return location.reload(); }, 1000);
	    };
	    LoginService.prototype.forgotPassword = function (usuario) {
	        var _this = this;
	        var headers = new http_1.Headers({ 'Content-Type': 'application/json' });
	        this.http
	            .post(myGlobals.default.BASE_URL + '/forgot', JSON.stringify({ usuario: usuario }), { headers: headers })
	            .toPromise()
	            .then(function (res) {
	            _this.errorObserver.next(res);
	        })
	            .catch(function (error) {
	            _this.errorObserver.next(JSON.parse(error._body).message);
	        });
	    };
	    LoginService.prototype.validateReset = function (token) {
	        var _this = this;
	        var headers = new http_1.Headers({ 'Content-Type': 'application/json' });
	        this.http
	            .get(myGlobals.default.BASE_URL + '/reset/' + token, { headers: headers })
	            .toPromise()
	            .then(function (res) {
	            //this.errorObserver.next(JSON.parse(res._body).message);
	        })
	            .catch(function (error) {
	            _this.errorObserver.next(JSON.parse(error._body).message);
	        });
	    };
	    LoginService.prototype.resetPassword = function (token, password) {
	        var _this = this;
	        var headers = new http_1.Headers({ 'Content-Type': 'application/json' });
	        this.http
	            .post(myGlobals.default.BASE_URL + '/reset/' + token, JSON.stringify({ password: password }), { headers: headers })
	            .toPromise()
	            .then(function (res) {
	            var redirect = '/login';
	            _this.router.navigate([redirect]);
	            // this.errorObserver.next(JSON.parse(res._body).message);
	        })
	            .catch(function (error) {
	            _this.errorObserver.next(JSON.parse(error._body).message);
	        });
	    };
	    LoginService.prototype.isLoggedIn = function () {
	        return !!localStorage.getItem('jwtSGDI');
	    };
	    LoginService.prototype.getToken = function () {
	        return localStorage.getItem('jwtSGDI');
	    };
	    LoginService.prototype.getDecodeToken = function () {
	        var token = this.getToken();
	        if (token != null) {
	            var datos = jwtDecode(token);
	            this.usuario = datos;
	        }
	        else
	            this.usuario = {};
	        return this.usuario;
	    };
	    LoginService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], LoginService);
	    return LoginService;
	    var _a, _b;
	}());
	exports.LoginService = LoginService;


/***/ }),
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	//
	// ===== File globals.ts
	//
	"use strict";
	// export var BASE_URL = 'http://localhost:3002';
	// export var URL_MQTT = 'http://localhost:5002';
	// export var URL_MQTT_ALARMAS = 'http://localhost:5001';
	//Producción
	// export var BASE_URL = 'http://52.67.144.82:3002';
	// export var URL_MQTT = 'http://52.67.144.82:5002';
	// export var URL_MQTT_ALARMAS = 'http://52.67.144.82:5001';
	//Testing
	// export var BASE_URL = 'http://18.228.93.199:3002';
	// export var URL_MQTT = 'http://18.228.93.199:5002';
	// export var URL_MQTT_ALARMAS = 'http://18.228.93.199:5001';
	// export var BASE_URL = 'http://gornatilabs.com:3002';
	// export var URL_MQTT = 'http://gornatilabs.com:5000';
	// export var URL_MQTT_ALARMAS = 'http://gornatilabs.com:5001';
	//Comarsa
	// export var BASE_URL = 'http://192.168.0.25:3002';
	// export var URL_MQTT = 'http://192.168.0.25:5000';
	// export var URL_MQTT_ALARMAS = 'http://192.168.0.25:5001';
	// TODO: ver estas variables junto al entorno de desarrollo
	if (false) {
	    var BASE_URL = "http://localhost:3002";
	    var URL_MQTT = "http://localhost:5002";
	    var URL_MQTT_ALARMAS = "http://localhost:5001";
	}
	if (true) {
	    var BASE_URL = "https://app.bemakoha.com/api";
	    var URL_MQTT = "https://app.bemakoha.com";
	    var PATH_MQTT = "/mqtt/socket.io";
	    var URL_MQTT_ALARMAS = "https://app.bemakoha.com";
	    var PATH_MQTT_ALARMAS = "/alarms/socket.io";
	}
	if (false) {
	    var BASE_URL = "https://appdev.bemakoha.com/api";
	    var URL_MQTT = "https://appdev.bemakoha.com";
	    var PATH_MQTT = "/mqtt/socket.io";
	    var URL_MQTT_ALARMAS = "https://appdev.bemakoha.com";
	    var PATH_MQTT_ALARMAS = "/alarms/socket.io";
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = {
	    BASE_URL: BASE_URL,
	    URL_MQTT: URL_MQTT,
	    PATH_MQTT: PATH_MQTT,
	    URL_MQTT_ALARMAS: URL_MQTT_ALARMAS,
	    PATH_MQTT_ALARMAS: PATH_MQTT_ALARMAS,
	};


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var base64_url_decode = __webpack_require__(416);
	
	function InvalidTokenError(message) {
	  this.message = message;
	}
	
	InvalidTokenError.prototype = new Error();
	InvalidTokenError.prototype.name = 'InvalidTokenError';
	
	module.exports = function (token,options) {
	  if (typeof token !== 'string') {
	    throw new InvalidTokenError('Invalid token specified');
	  }
	
	  options = options || {};
	  var pos = options.header === true ? 0 : 1;
	  try {
	    return JSON.parse(base64_url_decode(token.split('.')[pos]));
	  } catch (e) {
	    throw new InvalidTokenError('Invalid token specified: ' + e.message);
	  }
	};
	
	module.exports.InvalidTokenError = InvalidTokenError;


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	var atob = __webpack_require__(417);
	
	function b64DecodeUnicode(str) {
	  return decodeURIComponent(atob(str).replace(/(.)/g, function (m, p) {
	    var code = p.charCodeAt(0).toString(16).toUpperCase();
	    if (code.length < 2) {
	      code = '0' + code;
	    }
	    return '%' + code;
	  }));
	}
	
	module.exports = function(str) {
	  var output = str.replace(/-/g, "+").replace(/_/g, "/");
	  switch (output.length % 4) {
	    case 0:
	      break;
	    case 2:
	      output += "==";
	      break;
	    case 3:
	      output += "=";
	      break;
	    default:
	      throw "Illegal base64url string!";
	  }
	
	  try{
	    return b64DecodeUnicode(output);
	  } catch (err) {
	    return atob(output);
	  }
	};


/***/ }),
/* 417 */
/***/ (function(module, exports) {

	/**
	 * The code was extracted from:
	 * https://github.com/davidchambers/Base64.js
	 */
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function InvalidCharacterError(message) {
	  this.message = message;
	}
	
	InvalidCharacterError.prototype = new Error();
	InvalidCharacterError.prototype.name = 'InvalidCharacterError';
	
	function polyfill (input) {
	  var str = String(input).replace(/=+$/, '');
	  if (str.length % 4 == 1) {
	    throw new InvalidCharacterError("'atob' failed: The string to be decoded is not correctly encoded.");
	  }
	  for (
	    // initialize result and counters
	    var bc = 0, bs, buffer, idx = 0, output = '';
	    // get next character
	    buffer = str.charAt(idx++);
	    // character found in table? initialize bit storage and add its ascii value;
	    ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer,
	      // and if not first of each 4 characters,
	      // convert the first 8 bits to one ascii character
	      bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0
	  ) {
	    // try to find character in table (0-63, not found => -1)
	    buffer = chars.indexOf(buffer);
	  }
	  return output;
	}
	
	
	module.exports = typeof window !== 'undefined' && window.atob && window.atob.bind(window) || polyfill;


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var login_service_1 = __webpack_require__(381);
	var router_1 = __webpack_require__(329);
	var LoginComponent = (function () {
	    function LoginComponent(loginService, router) {
	        var _this = this;
	        this.loginService = loginService;
	        this.router = router;
	        this.username = "";
	        this.password = "";
	        this.error = "";
	        if (this.loginService.isLoggedIn() && !this.loginService.getDecodeToken().cambiarPassword) {
	            var link = ['/home'];
	            this.router.navigate(link);
	        }
	        loginService.error.subscribe(function (error) { return _this.error = error; });
	        this.loginService.logIn.subscribe(function (mode) {
	            if (mode == true) {
	                _this.router.navigate(["/home"]);
	            }
	        });
	    }
	    LoginComponent.prototype.ngOnInit = function () {
	    };
	    LoginComponent.prototype.login = function () {
	        this.loginService.login(this.username, this.password);
	    };
	    LoginComponent.prototype.desplegarModal = function () {
	        $("#modalRestablecerPass").modal("show");
	    };
	    LoginComponent.prototype.restablecerPassword = function () {
	        this.loginService.forgotPassword(this.username);
	        $("#modalRestablecerPass").modal("hide");
	    };
	    LoginComponent = __decorate([
	        core_1.Component({
	            selector: 'login',
	            template: __webpack_require__(420),
	            styles: [__webpack_require__(424)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof login_service_1.LoginService !== 'undefined' && login_service_1.LoginService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object])
	    ], LoginComponent);
	    return LoginComponent;
	    var _a, _b;
	}());
	exports.LoginComponent = LoginComponent;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(419)))

/***/ }),
/* 419 */,
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"login-fondo col-xs-12\">\n    <div class=\"col-lg-offset-4 col-md-offset-4 col-lg-4 col-md-4 col-xs-12\">\n        <div class=\"login-all col-xs-12\">\n            <div class=\"login-titulo\">\n                <div class=\"col-xs-12\" style=\"text-align: center;\">\n                    <img id=\"logoSistema\" src=\"" + __webpack_require__(421) + "\" width=\"90%\"/>\n                </div>\n\n            </div>\n            <div class=\"login-cuerpo col-xs-12\">\n                <p>{{error}}</p>\n                <form>\n                    <div class=\"form-group\">\n                        <div class=\"input-group\">\n                            <span class=\"input-group-addon login\" style=\"\"><img src=\"" + __webpack_require__(422) + "\"\n                                                                                style=\"width:20px;\"/></span>\n                            <input id=\"username\" name=\"username\" type=\"text\" [(ngModel)]=\"username\"\n                                   class=\"form-control login\" placeholder=\"DNI\" required\n                                   onfocus=\"$('#borderLogin').addClass('borderFocus');\"\n                                   onfocusout=\"$('#borderLogin').removeClass('borderFocus');\">\n                        </div>\n                        <div class=\"col-md-12 borderLogin\" id=\"borderLogin\"></div>\n                    </div>\n                    <div class=\"form-group\">\n                        <div class=\"input-group\">\n                            <span class=\"input-group-addon login\"><img src=\"" + __webpack_require__(423) + "\"\n                                                                       style=\"width:20px;\"/></span>\n                            <input type=\"password\" id=\"password\" name=\"password\" [(ngModel)]=\"password\"\n                                   class=\"form-control login\" placeholder=\"Contraseña\" required\n                                   onfocus=\"$('#borderLogin1').addClass('borderFocus');\"\n                                   onfocusout=\"$('#borderLogin1').removeClass('borderFocus');\">\n                        </div>\n                        <div class=\"col-md-12 borderLogin\" id=\"borderLogin1\"></div>\n                    </div>\n                    <button type=\"submit\" (click)=\"login()\" class=\"btn btn-primary btn-block login\">Login</button>\n                </form>\n                <a role=\"button\" class=\"btn btn-large btn-link\" (click)=\"desplegarModal()\">Olvide mi contraseña</a>\n            </div>\n        </div>\n    </div>\n</div>\n<div id=\"modalRestablecerPass\" class=\"modal fade\">\n    <div class=\"modal-dialog\">\n        <form>\n            <div class=\"modal-content\" style=\"background-color: #273135;\">\n                <div class=\"modal-header\">\n                    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">&times;</button>\n                    <h4 class=\"modal-title\">Restablecer Contraseña</h4>\n                </div>\n                <div class=\"modal-body\">\n                    <p>Desea restablecer el password para este usuario?</p>\n                    <p class=\"text-warning\">\n                        <small>Se le enviará un mail a su cuenta para informar de pasos a seguir.</small>\n                    </p>\n                    <div class=\"form-group\">\n                        <div class=\"input-group\">\n                            <span class=\"input-group-addon login\" style=\"\"><img src=\"" + __webpack_require__(422) + "\"\n                                                                                style=\"width:20px;\"/></span>\n                            <input id=\"username\" name=\"username\" type=\"text\" [(ngModel)]=\"username\"\n                                   class=\"form-control login\" placeholder=\"Usuario\" required\n                                   onfocus=\"$('#borderLogin2').addClass('borderFocus');\"\n                                   onfocusout=\"$('#borderLogin2').removeClass('borderFocus');\">\n                        </div>\n                        <div class=\"col-md-12 borderLogin\" id=\"borderLogin2\"></div>\n                    </div>\n                </div>\n                <div class=\"modal-footer\" style=\"border: none\">\n                    <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Cerrar</button>\n                    <button type=\"submit\" (click)=\"restablecerPassword()\" class=\"btn\"\n                            style=\"background-color: #E76049;border-color: #E76049;\">Aceptar\n                    </button>\n                </div>\n            </div>\n        </form>\n    </div>\n</div>\n";

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/ojo_bemakoha_contodo.cdd6bd7c4f958ab586df5495ede3e59a.png";

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/social.1f568648632670679fbcd85bb55f56ee.svg";

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/padlock-1.75ea7a7685a1c6e38cf5b6ae1f9acc33.svg";

/***/ }),
/* 424 */
/***/ (function(module, exports) {

	module.exports = ".login-fondo{\n\tbackground-color: #273135;\n\tmin-height: 100vh;\n\twidth: 100vw;\n}\n\n.login-all{\n\twidth: 100%;\n\tborder-radius: 10%;\n\tpadding-top: 20%;\n}\n\n.login-titulo{\n\tbackground-color: #273135;\n\tcolor: white;\n\tpadding: 15px 30px 15px 30px;\n\tmin-height: 118px;\n}\n\n.login-titulo p{\n\tpadding-top: 0px;\n}\n\n.login-cuerpo {\n    margin-top: 20px;\n\tbackground-color: #273135;\n\n}\n\n.login-cuerpo p {\n    text-align: center;\n    color: red;\n}\n\n/*\n.login-cuerpo input{\n\twidth: 100%;\n\tborder: none;\n\tmargin-top: 20px;\n}\n\n.login-cuerpo input:focus{\n\tborder: none;\n\toutline-width: 0px;\n}\n\n.login-cuerpo input:active{\n\tborder: none;\n\tbox-sizing: none;\n}\n*/\ninput.login {\n    border: none;\n    box-shadow: none;\n    border-radius: 0px;\n    background-color: #273135;\n    color: #9C9FA8;\n    margin-top: 15px;\n    text-align: center;\n}\n\ninput.login:-webkit-autofill {\n    -webkit-box-shadow: 0 0 0px 1000px #273135 inset;\n    -webkit-text-fill-color: #9C9FA8 !important;\n    background-color: #273135;\n}\n\ninput.login:focus {\n    box-shadow: none;\n    color:#9C9FA8;\n}\n\ndiv.borderLogin {\n    border-bottom: 1px solid rgba(156, 159, 168,0.5);\n    padding-bottom: 15px;\n    height: 2px;\n    margin-bottom: 25px;\n}\n\n.borderFocus {\n    border-bottom: 2px solid #008094 !important;\n    -webkit-animation: aparecer 0.5s ease-in 0s both;\n    -moz-animation: aparecer 0.5s ease-in 0s both;\n    -ms-animation: aparecer 0.5s ease-in 0s both;\n    -o-animation: aparecer 0.5s ease-in 0s both;\n    animation: aparecer 0.5s ease-in 0s both;\n}\n@keyframes aparecer {\n    0% {\n        -webkit-transform: scaleX(0);\n    }\n    100% {\n        -webkit-transform: scaleX(100%);\n    }\n}\n@-webkit-keyframes aparecer {\n    0% {\n        -webkit-transform: scaleX(0);\n    }\n    100% {\n        -webkit-transform: scaleX(100%);\n    }\n}\n@-moz-keyframes aparecer {\n    0% {\n        -webkit-transform: scaleX(0);\n    }\n    100% {\n        -webkit-transform: scaleX(100%);\n    }\n}\n@-ms-keyframes aparecer {\n    0% {\n        -webkit-transform: scaleX(0);\n    }\n    100% {\n        -webkit-transform: scaleX(100%);\n    }\n}\n@-o-keyframes aparecer {\n    0% {\n        -webkit-transform: scaleX(0);\n    }\n    100% {\n        -webkit-transform: scaleX(100%);\n    }\n}\n\nspan.login {\n    background-color: #273135;\n    border: none;\n}\nimg.login {\n\t    width: 20px;\n}\ndiv.login {\n    margin-top: 20vh;\n}\nbutton.login {\n    border-radius: 0px;\n    height: 50px;\n    background-color: #0d5965;\n    border-color: #0d5965;\n    margin-top: 60px;\n}\nbutton.login:hover {\n  background-color: #008094;\n  border-color: #008094;\n}\n\n.login img{\n\tpadding-top: 9px;\n}\n\n\n"

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var http_1 = __webpack_require__(382);
	__webpack_require__(374);
	var myGlobals = __webpack_require__(414);
	var EmpresaService = (function () {
	    function EmpresaService(http) {
	        this.http = http;
	        this.empresaUrl = myGlobals.default.BASE_URL + '/empresa/'; // URL to web api
	    }
	    //Obtener todas las empresas
	    EmpresaService.prototype.getEmpresas = function () {
	        return this.http.get(this.empresaUrl)
	            .map(function (response) { return response.json(); });
	    };
	    //Obtener una empresa
	    EmpresaService.prototype.getEmpresa = function (_id) {
	        return this.http.get(this.empresaUrl + _id)
	            .map(function (response) { return response.json(); });
	    };
	    EmpresaService.prototype.save = function (empresa, logo) {
	        if (empresa._id) {
	            return this.put(empresa, logo);
	        }
	        //Seteo estado activo
	        empresa.estado = true;
	        return this.post(empresa, logo);
	    };
	    //Desactivar empresa
	    EmpresaService.prototype.delete = function (empresa) {
	        var headers = new http_1.Headers();
	        headers.append('Content-Type', 'application/json');
	        var url = this.empresaUrl + "/" + empresa._id;
	        return this.http
	            .delete(url, { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    // Agregar nueva empresa
	    EmpresaService.prototype.post = function (empresa, logo) {
	        var formData = new FormData();
	        formData.append("logo", logo);
	        formData.append("empresa", JSON.stringify(empresa));
	        var headers = new http_1.Headers();
	        headers.append('enctype', "multipart/form-data");
	        return this.http
	            .post(this.empresaUrl, formData, { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    // Actualizar empresa
	    EmpresaService.prototype.put = function (empresa, logo) {
	        empresa.logo = null;
	        var formData = new FormData();
	        formData.append("logo", logo);
	        formData.append("empresa", JSON.stringify(empresa));
	        var headers = new http_1.Headers();
	        headers.append('enctype', "multipart/form-data");
	        ;
	        var url = this.empresaUrl + "/" + empresa._id;
	        return this.http
	            .put(url, formData, { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    EmpresaService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
	    ], EmpresaService);
	    return EmpresaService;
	    var _a;
	}());
	exports.EmpresaService = EmpresaService;


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var http_1 = __webpack_require__(382);
	__webpack_require__(374);
	var myGlobals = __webpack_require__(414);
	var ProvinciaService = (function () {
	    function ProvinciaService(http) {
	        this.http = http;
	        this.provinciaUrl = myGlobals.default.BASE_URL + '/provincia/'; // URL to web api
	    }
	    //Obtener todas las provincias
	    ProvinciaService.prototype.getProvincias = function () {
	        return this.http.get(this.provinciaUrl)
	            .map(function (response) { return response.json(); });
	    };
	    //Obtener una provincias
	    ProvinciaService.prototype.getProvincia = function (_id) {
	        return this.http.get(this.provinciaUrl + _id)
	            .map(function (response) { return response.json(); });
	    };
	    ProvinciaService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
	    ], ProvinciaService);
	    return ProvinciaService;
	    var _a;
	}());
	exports.ProvinciaService = ProvinciaService;


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var http_1 = __webpack_require__(382);
	__webpack_require__(374);
	var myGlobals = __webpack_require__(414);
	var PermisoService = (function () {
	    function PermisoService(http) {
	        this.http = http;
	        this.permisoUrl = myGlobals.default.BASE_URL + '/permiso/'; // URL to web api
	    }
	    //Obtener todas las empresas
	    PermisoService.prototype.getPermisos = function () {
	        return this.http.get(this.permisoUrl)
	            .map(function (response) { return response.json(); });
	    };
	    //Obtener una empresa
	    PermisoService.prototype.getPermiso = function (codModulo) {
	        return this.http.get(this.permisoUrl + codModulo)
	            .map(function (response) { return response.json(); });
	    };
	    PermisoService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
	    ], PermisoService);
	    return PermisoService;
	    var _a;
	}());
	exports.PermisoService = PermisoService;


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var http_1 = __webpack_require__(382);
	__webpack_require__(374);
	var myGlobals = __webpack_require__(414);
	var MenuService = (function () {
	    function MenuService(http) {
	        this.http = http;
	        this.menuUrl = myGlobals.default.BASE_URL + "/menu/"; // URL to web api
	    }
	    //Obtener todas los menus
	    MenuService.prototype.getMenus = function () {
	        return this.http.get(this.menuUrl).map(function (response) {
	            var menus = response.json();
	            localStorage.setItem("menus", JSON.stringify(menus));
	            return menus;
	        });
	    };
	    //Obtener menus desde localStorage
	    MenuService.prototype.getMenusFromStorage = function () {
	        var menus = localStorage.getItem("menus");
	        return menus ? JSON.parse(menus) : [];
	    };
	    //Verificar si una URL está habilitada para el usuario
	    MenuService.prototype.isUrlEnabled = function (url) {
	        var menus = this.getMenusFromStorage();
	        return menus.some(function (menu) { return menu.url === url && menu.estado; });
	    };
	    MenuService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
	    ], MenuService);
	    return MenuService;
	    var _a;
	}());
	exports.MenuService = MenuService;


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var http_1 = __webpack_require__(382);
	__webpack_require__(374);
	var myGlobals = __webpack_require__(414);
	var SucursalService = (function () {
	    function SucursalService(http) {
	        this.http = http;
	        this.sucursalUrl = myGlobals.default.BASE_URL + '/sucursal/'; // URL to web api
	    }
	    //Obtener todas las sucursales
	    SucursalService.prototype.getSucursales = function () {
	        return this.http.get(this.sucursalUrl)
	            .map(function (response) { return response.json(); });
	    };
	    //Obtener una sucursal
	    SucursalService.prototype.getSucursal = function (_id) {
	        return this.http.get(this.sucursalUrl + _id)
	            .map(function (response) { return response.json(); });
	    };
	    //Obtener sucursales by empresa
	    SucursalService.prototype.getSucursalByEmpresa = function (_id) {
	        return this.http.get(this.sucursalUrl + "empresa/" + _id)
	            .map(function (response) { return response.json(); });
	    };
	    //Obtener sucursales by empresa
	    SucursalService.prototype.getPresupuestoCalibracion = function (_id) {
	        return this.http.get(this.sucursalUrl + "presupuestoCalibracion/" + _id)
	            .map(function (response) { return response.json(); });
	    };
	    SucursalService.prototype.save = function (sucursal) {
	        if (sucursal._id) {
	            return this.put(sucursal);
	        }
	        //Seteo estado activo
	        sucursal.estado = true;
	        return this.post(sucursal);
	    };
	    //Desactivar sucursal
	    SucursalService.prototype.delete = function (sucursal) {
	        var headers = new http_1.Headers();
	        headers.append('Content-Type', 'application/json');
	        var url = this.sucursalUrl + "/" + sucursal._id;
	        return this.http
	            .delete(url, { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    // Agregar nueva sucursal
	    SucursalService.prototype.post = function (sucursal) {
	        var headers = new http_1.Headers({
	            'Content-Type': 'application/json;charset=UTF-8' });
	        headers.append('dataType', 'json');
	        console.log(JSON.stringify(sucursal));
	        var sucursalStr = JSON.stringify(sucursal);
	        return this.http
	            .post(this.sucursalUrl, sucursalStr, { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    // Actualizar sucursal
	    SucursalService.prototype.put = function (sucursal) {
	        var headers = new http_1.Headers();
	        headers.append('Content-Type', 'application/json');
	        var url = this.sucursalUrl + "/" + sucursal._id;
	        return this.http
	            .put(url, JSON.stringify(sucursal), { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    SucursalService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
	    ], SucursalService);
	    return SucursalService;
	    var _a;
	}());
	exports.SucursalService = SucursalService;


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var http_1 = __webpack_require__(382);
	__webpack_require__(374);
	var myGlobals = __webpack_require__(414);
	var UsuariosService = (function () {
	    function UsuariosService(http) {
	        this.http = http;
	        this.usuarioUrl = myGlobals.default.BASE_URL + '/usuarios/'; // URL to web api
	    }
	    //Obtener todas los usuarios
	    UsuariosService.prototype.getUsuarios = function () {
	        return this.http.get(this.usuarioUrl)
	            .map(function (response) { return response.json(); });
	    };
	    //Obtener un usuario
	    UsuariosService.prototype.getUsuario = function (_id) {
	        return this.http.get(this.usuarioUrl + _id)
	            .map(function (response) { return response.json(); });
	    };
	    //Obtener un usuario by sucursal
	    UsuariosService.prototype.getUsuarioBySucursal = function (_idSucursal) {
	        return this.http.get(this.usuarioUrl + "sucursal/" + _idSucursal)
	            .map(function (response) { return response.json(); });
	    };
	    UsuariosService.prototype.getUsuarioByNickname = function (usuario) {
	        return this.http.get(this.usuarioUrl + usuario)
	            .map(function (response) { return response.json(); });
	    };
	    UsuariosService.prototype.save = function (usuario) {
	        if (usuario._id) {
	            return this.put(usuario);
	        }
	        //Seteo estado activo
	        usuario.estado = true;
	        return this.post(usuario);
	    };
	    //Desactivar usuario
	    UsuariosService.prototype.delete = function (usuario) {
	        var headers = new http_1.Headers();
	        headers.append('Content-Type', 'application/json');
	        var url = this.usuarioUrl + "/" + usuario._id;
	        return this.http
	            .delete(url, { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    // Agregar nuevo usuario
	    UsuariosService.prototype.post = function (usuario) {
	        var headers = new http_1.Headers({
	            'Content-Type': 'application/json;charset=UTF-8' });
	        headers.append('dataType', 'json');
	        var usuarioStr = JSON.stringify(usuario);
	        return this.http
	            .post(this.usuarioUrl, usuarioStr, { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    // Actualizar usuario
	    UsuariosService.prototype.put = function (usuario) {
	        var headers = new http_1.Headers();
	        headers.append('Content-Type', 'application/json');
	        var url = this.usuarioUrl + "/" + usuario._id;
	        return this.http
	            .put(url, JSON.stringify(usuario), { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    UsuariosService.prototype.cambiarPassword = function (usuario) {
	        var headers = new http_1.Headers();
	        headers.append('Content-Type', 'application/json');
	        var url = this.usuarioUrl + "cambiarPassword/" + usuario._id;
	        return this.http
	            .put(url, JSON.stringify(usuario), { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    UsuariosService.prototype.probarCelular = function (celular) {
	        var headers = new http_1.Headers();
	        headers.append('Content-Type', 'application/json');
	        var url = this.usuarioUrl + "probarCelular/";
	        var usuarioStr = JSON.stringify({ celular: celular });
	        return this.http
	            .post(url, usuarioStr, { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    UsuariosService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
	    ], UsuariosService);
	    return UsuariosService;
	    var _a;
	}());
	exports.UsuariosService = UsuariosService;


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var http_1 = __webpack_require__(382);
	__webpack_require__(374);
	var myGlobals = __webpack_require__(414);
	var TipoVariableService = (function () {
	    function TipoVariableService(http) {
	        this.http = http;
	        this.tipoVariableUrl = myGlobals.default.BASE_URL + '/tipoVariable/'; // URL to web api
	    }
	    //Obtener todos los tipoVariables habilitados para el usuario
	    TipoVariableService.prototype.getTipoVariables = function () {
	        return this.http.get(this.tipoVariableUrl)
	            .map(function (response) { return response.json(); });
	    };
	    //Obtener un tipoVariable
	    TipoVariableService.prototype.getTipoVariable = function (_id) {
	        return this.http.get(this.tipoVariableUrl + _id)
	            .map(function (response) { return response.json(); });
	    };
	    //Obtener tipoVariables by sucursal
	    TipoVariableService.prototype.getTipoVariableesBySucursal = function (_id) {
	        return this.http.get(this.tipoVariableUrl + "sucursal/" + _id)
	            .map(function (response) { return response.json(); });
	    };
	    TipoVariableService.prototype.save = function (tipoVariable) {
	        if (tipoVariable._id) {
	            return this.put(tipoVariable);
	        }
	        //Seteo estado activo
	        tipoVariable.estado = true;
	        return this.post(tipoVariable);
	    };
	    //Desactivar tipoVariable
	    TipoVariableService.prototype.delete = function (tipoVariable) {
	        var headers = new http_1.Headers();
	        headers.append('Content-Type', 'application/json');
	        var url = this.tipoVariableUrl + "/" + tipoVariable._id;
	        return this.http
	            .delete(url, { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    // Agregar nuevo tipoVariable
	    TipoVariableService.prototype.post = function (tipoVariable) {
	        var headers = new http_1.Headers({
	            'Content-Type': 'application/json;charset=UTF-8'
	        });
	        headers.append('dataType', 'json');
	        console.log(tipoVariable);
	        console.log(JSON.stringify(tipoVariable));
	        var tipoVariableStr = JSON.stringify(tipoVariable);
	        return this.http
	            .post(this.tipoVariableUrl, tipoVariableStr, { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    // Actualizar tipoVariable
	    TipoVariableService.prototype.put = function (tipoVariable) {
	        var headers = new http_1.Headers();
	        headers.append('Content-Type', 'application/json');
	        var url = this.tipoVariableUrl + "/" + tipoVariable._id;
	        return this.http
	            .put(url, JSON.stringify(tipoVariable), { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    TipoVariableService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
	    ], TipoVariableService);
	    return TipoVariableService;
	    var _a;
	}());
	exports.TipoVariableService = TipoVariableService;


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var http_1 = __webpack_require__(382);
	__webpack_require__(374);
	var myGlobals = __webpack_require__(414);
	var RolService = (function () {
	    function RolService(http) {
	        this.http = http;
	        this.rolUrl = myGlobals.default.BASE_URL + '/rol/'; // URL to web api
	    }
	    //Obtener todos los roles
	    RolService.prototype.getRoles = function () {
	        return this.http.get(this.rolUrl)
	            .map(function (response) { return response.json(); });
	    };
	    //Obtener un rol
	    RolService.prototype.getRol = function (_id) {
	        return this.http.get(this.rolUrl + _id)
	            .map(function (response) { return response.json(); });
	    };
	    RolService.prototype.save = function (rol) {
	        if (rol._id) {
	            return this.put(rol);
	        }
	        //Seteo estado activo
	        rol.estado = true;
	        return this.post(rol);
	    };
	    //Desactivar rol
	    RolService.prototype.delete = function (rol) {
	        var headers = new http_1.Headers();
	        headers.append('Content-Type', 'application/json');
	        var url = this.rolUrl + "/" + rol._id;
	        return this.http
	            .delete(url, { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    // Agregar nuevo rol
	    RolService.prototype.post = function (rol) {
	        var headers = new http_1.Headers({
	            'Content-Type': 'application/json;charset=UTF-8' });
	        headers.append('dataType', 'json');
	        console.log(JSON.stringify(rol));
	        var rolStr = JSON.stringify(rol);
	        return this.http
	            .post(this.rolUrl, rolStr, { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    // Actualizar rol
	    RolService.prototype.put = function (rol) {
	        var headers = new http_1.Headers();
	        headers.append('Content-Type', 'application/json');
	        var url = this.rolUrl + "/" + rol._id;
	        return this.http
	            .put(url, JSON.stringify(rol), { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    RolService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
	    ], RolService);
	    return RolService;
	    var _a;
	}());
	exports.RolService = RolService;


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var http_1 = __webpack_require__(382);
	__webpack_require__(374);
	var myGlobals = __webpack_require__(414);
	var NodoService = (function () {
	    function NodoService(http) {
	        this.http = http;
	        this.nodoUrl = myGlobals.default.BASE_URL + '/nodo/'; // URL to web api
	    }
	    //Obtener todos los nodos habilitados para el usuario
	    NodoService.prototype.getNodosInfoBasica = function () {
	        return this.http.get(this.nodoUrl + "infoBasica/todo")
	            .map(function (response) { return response.json(); });
	    };
	    //Obtener todos los nodos habilitados para el usuario
	    NodoService.prototype.getNodos = function () {
	        return this.http.get(this.nodoUrl)
	            .map(function (response) { return response.json(); });
	    };
	    //Obtener un nodo
	    NodoService.prototype.getNodo = function (_id) {
	        return this.http.get(this.nodoUrl + _id)
	            .map(function (response) { return response.json(); });
	    };
	    //Obtener nodos by sucursal
	    NodoService.prototype.getNodosBySucursal = function (_id) {
	        return this.http.get(this.nodoUrl + "sucursal/" + _id)
	            .map(function (response) { return response.json(); });
	    };
	    //Obtener nodos by gateway
	    NodoService.prototype.getNodosByGateway = function (_id) {
	        return this.http.get(this.nodoUrl + "gateway/" + _id)
	            .map(function (response) { return response.json(); });
	    };
	    NodoService.prototype.save = function (nodo) {
	        if (nodo._id) {
	            return this.put(nodo);
	        }
	        //Seteo estado activo
	        nodo.estado = true;
	        return this.post(nodo);
	    };
	    //Desactivar nodo
	    NodoService.prototype.delete = function (nodo) {
	        var headers = new http_1.Headers();
	        headers.append('Content-Type', 'application/json');
	        var url = this.nodoUrl + "/" + nodo._id;
	        return this.http
	            .delete(url, { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    //Eliminar nodo
	    NodoService.prototype.deleteStrict = function (nodo) {
	        var headers = new http_1.Headers();
	        headers.append('Content-Type', 'application/json');
	        var url = this.nodoUrl + "/" + nodo._id + "/true";
	        return this.http
	            .delete(url, { headers: headers });
	    };
	    // Agregar nuevo nodo
	    NodoService.prototype.post = function (nodo) {
	        var headers = new http_1.Headers({
	            'Content-Type': 'application/json;charset=UTF-8' });
	        headers.append('dataType', 'json');
	        var nodoStr = JSON.stringify(nodo);
	        return this.http
	            .post(this.nodoUrl, nodoStr, { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    // Actualizar nodo
	    NodoService.prototype.put = function (nodo) {
	        var headers = new http_1.Headers();
	        headers.append('Content-Type', 'application/json');
	        var url = this.nodoUrl + "/" + nodo._id;
	        return this.http
	            .put(url, JSON.stringify(nodo), { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    NodoService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
	    ], NodoService);
	    return NodoService;
	    var _a;
	}());
	exports.NodoService = NodoService;


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var http_1 = __webpack_require__(382);
	__webpack_require__(374);
	var myGlobals = __webpack_require__(414);
	var moment = __webpack_require__(435);
	var MedicionService = (function () {
	    function MedicionService(http) {
	        this.http = http;
	        this.medicionUrl = myGlobals.default.BASE_URL + '/medicion/'; // URL to web api
	    }
	    //Obtener todas las mediciones
	    MedicionService.prototype.getMediciones = function () {
	        return this.http.get(this.medicionUrl)
	            .map(function (response) { return response.json(); });
	    };
	    //Obtener mediciones por sensor
	    MedicionService.prototype.getMedicionesBySensor = function (_id) {
	        return this.http.get(this.medicionUrl + _id + "/20")
	            .map(function (response) { return response.json(); });
	    };
	    //Obtener mediciones por sensor
	    MedicionService.prototype.getAllMedicionesBySensor = function (_id) {
	        return this.http.get(this.medicionUrl + _id + "/all")
	            .map(function (response) { return response.json(); });
	    };
	    //Obtener mediciones por sensor
	    MedicionService.prototype.getAllMedicionesBySensorYFecha = function (_id, fechaDesde, fechaHasta, offset) {
	        if (!offset)
	            offset = "-03:00";
	        var fechaDesdeStr = moment(fechaDesde).utcOffset(offset).startOf("day").format();
	        var fechaHastaStr = moment(fechaHasta).utcOffset(offset).endOf('day').format();
	        return this.http.get(this.medicionUrl + _id + "/" + fechaDesdeStr + "/" + fechaHastaStr)
	            .map(function (response) { return response.json(); });
	    };
	    //Obtener media por sensor
	    MedicionService.prototype.getPromedioMedicionesBySensorYFecha = function (_id, fechaDesde, fechaHasta, offset) {
	        if (!offset)
	            offset = "-03:00";
	        var fechaDesdeStr = moment(fechaDesde).utcOffset(offset).startOf("day").format();
	        var fechaHastaStr = moment(fechaHasta).utcOffset(offset).endOf('day').format();
	        return this.http.get(this.medicionUrl + "promedio/" + _id + "/" + fechaDesdeStr + "/" + fechaHastaStr)
	            .map(function (response) { return response.json(); });
	    };
	    //Obtener mkt por sensor
	    MedicionService.prototype.getMKTMedicionesBySensorYFecha = function (_id, fechaDesde, fechaHasta, offset) {
	        if (!offset)
	            offset = "-03:00";
	        var fechaDesdeStr = moment(fechaDesde).utcOffset(offset).startOf("day").format();
	        var fechaHastaStr = moment(fechaHasta).utcOffset(offset).endOf('day').format();
	        return this.http.get(this.medicionUrl + "mkt/" + _id + "/" + fechaDesdeStr + "/" + fechaHastaStr)
	            .map(function (response) { return response.json(); });
	    };
	    //Obtener minimo y maximo por sensor
	    MedicionService.prototype.getMinMaxMedicionesBySensorYFecha = function (_id, fechaDesde, fechaHasta, offset) {
	        if (!offset)
	            offset = "-03:00";
	        var fechaDesdeStr = moment(fechaDesde).utcOffset(offset).startOf("day").format();
	        var fechaHastaStr = moment(fechaHasta).utcOffset(offset).endOf('day').format();
	        return this.http.get(this.medicionUrl + "minmax/" + _id + "/" + fechaDesdeStr + "/" + fechaHastaStr)
	            .map(function (response) { return response.json(); });
	    };
	    //Obtener mediciones por sensor
	    MedicionService.prototype.getAllMedicionesBySucursalYFecha = function (_id, fechaDesde, fechaHasta, offset) {
	        if (!offset)
	            offset = "-03:00";
	        var fechaDesdeStr = moment(fechaDesde).utcOffset(offset).startOf("day").format();
	        var fechaHastaStr = moment(fechaHasta).utcOffset(offset).endOf('day').format();
	        return this.http.get(this.medicionUrl + "export/sucursal/" + _id + "/" + fechaDesdeStr + "/" + fechaHastaStr)
	            .map(function (response) {
	            var linkSource = "data:application/zip;base64," + response.text();
	            var downloadLink = document.createElement("a");
	            var fileName = "reporteMedicionesBemakoha-" + fechaDesdeStr.split('T')[0] + '-' + fechaHastaStr.split('T')[0] + ".zip";
	            downloadLink.href = linkSource;
	            downloadLink.download = fileName;
	            downloadLink.click();
	        });
	    };
	    MedicionService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
	    ], MedicionService);
	    return MedicionService;
	    var _a;
	}());
	exports.MedicionService = MedicionService;


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.29.4
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks() {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback(callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return (
	            input instanceof Array ||
	            Object.prototype.toString.call(input) === '[object Array]'
	        );
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return (
	            input != null &&
	            Object.prototype.toString.call(input) === '[object Object]'
	        );
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return Object.getOwnPropertyNames(obj).length === 0;
	        } else {
	            var k;
	            for (k in obj) {
	                if (hasOwnProp(obj, k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return (
	            typeof input === 'number' ||
	            Object.prototype.toString.call(input) === '[object Number]'
	        );
	    }
	
	    function isDate(input) {
	        return (
	            input instanceof Date ||
	            Object.prototype.toString.call(input) === '[object Date]'
	        );
	    }
	
	    function map(arr, fn) {
	        var res = [],
	            i,
	            arrLen = arr.length;
	        for (i = 0; i < arrLen; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty: false,
	            unusedTokens: [],
	            unusedInput: [],
	            overflow: -2,
	            charsLeftOver: 0,
	            nullInput: false,
	            invalidEra: null,
	            invalidMonth: null,
	            invalidFormat: false,
	            userInvalidated: false,
	            iso: false,
	            parsedDateParts: [],
	            era: null,
	            meridiem: null,
	            rfc2822: false,
	            weekdayMismatch: false,
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this),
	                len = t.length >>> 0,
	                i;
	
	            for (i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m),
	                parsedParts = some.call(flags.parsedDateParts, function (i) {
	                    return i != null;
	                }),
	                isNowValid =
	                    !isNaN(m._d.getTime()) &&
	                    flags.overflow < 0 &&
	                    !flags.empty &&
	                    !flags.invalidEra &&
	                    !flags.invalidMonth &&
	                    !flags.invalidWeekday &&
	                    !flags.weekdayMismatch &&
	                    !flags.nullInput &&
	                    !flags.invalidFormat &&
	                    !flags.userInvalidated &&
	                    (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid =
	                    isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            } else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid(flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        } else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = (hooks.momentProperties = []),
	        updateInProgress = false;
	
	    function copyConfig(to, from) {
	        var i,
	            prop,
	            val,
	            momentPropertiesLen = momentProperties.length;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentPropertiesLen > 0) {
	            for (i = 0; i < momentPropertiesLen; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment(obj) {
	        return (
	            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
	        );
	    }
	
	    function warn(msg) {
	        if (
	            hooks.suppressDeprecationWarnings === false &&
	            typeof console !== 'undefined' &&
	            console.warn
	        ) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [],
	                    arg,
	                    i,
	                    key,
	                    argLen = arguments.length;
	                for (i = 0; i < argLen; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (key in arguments[0]) {
	                            if (hasOwnProp(arguments[0], key)) {
	                                arg += key + ': ' + arguments[0][key] + ', ';
	                            }
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(
	                    msg +
	                        '\nArguments: ' +
	                        Array.prototype.slice.call(args).join('') +
	                        '\n' +
	                        new Error().stack
	                );
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    function set(config) {
	        var prop, i;
	        for (i in config) {
	            if (hasOwnProp(config, i)) {
	                prop = config[i];
	                if (isFunction(prop)) {
	                    this[i] = prop;
	                } else {
	                    this['_' + i] = prop;
	                }
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' +
	                /\d{1,2}/.source
	        );
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig),
	            prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (
	                hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])
	            ) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i,
	                res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay: '[Today at] LT',
	        nextDay: '[Tomorrow at] LT',
	        nextWeek: 'dddd [at] LT',
	        lastDay: '[Yesterday at] LT',
	        lastWeek: '[Last] dddd [at] LT',
	        sameElse: 'L',
	    };
	
	    function calendar(key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (
	            (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
	            absNumber
	        );
	    }
	
	    var formattingTokens =
	            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
	        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
	        formatFunctions = {},
	        formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken(token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(
	                    func.apply(this, arguments),
	                    token
	                );
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens),
	            i,
	            length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '',
	                i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i])
	                    ? array[i].call(mom, format)
	                    : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] =
	            formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(
	                localFormattingTokens,
	                replaceLongDateFormatTokens
	            );
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var defaultLongDateFormat = {
	        LTS: 'h:mm:ss A',
	        LT: 'h:mm A',
	        L: 'MM/DD/YYYY',
	        LL: 'MMMM D, YYYY',
	        LLL: 'MMMM D, YYYY h:mm A',
	        LLLL: 'dddd, MMMM D, YYYY h:mm A',
	    };
	
	    function longDateFormat(key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper
	            .match(formattingTokens)
	            .map(function (tok) {
	                if (
	                    tok === 'MMMM' ||
	                    tok === 'MM' ||
	                    tok === 'DD' ||
	                    tok === 'dddd'
	                ) {
	                    return tok.slice(1);
	                }
	                return tok;
	            })
	            .join('');
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate() {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d',
	        defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal(number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future: 'in %s',
	        past: '%s ago',
	        s: 'a few seconds',
	        ss: '%d seconds',
	        m: 'a minute',
	        mm: '%d minutes',
	        h: 'an hour',
	        hh: '%d hours',
	        d: 'a day',
	        dd: '%d days',
	        w: 'a week',
	        ww: '%d weeks',
	        M: 'a month',
	        MM: '%d months',
	        y: 'a year',
	        yy: '%d years',
	    };
	
	    function relativeTime(number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return isFunction(output)
	            ? output(number, withoutSuffix, string, isFuture)
	            : output.replace(/%d/i, number);
	    }
	
	    function pastFuture(diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias(unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string'
	            ? aliases[units] || aliases[units.toLowerCase()]
	            : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [],
	            u;
	        for (u in unitsObj) {
	            if (hasOwnProp(unitsObj, u)) {
	                units.push({ unit: u, priority: priorities[u] });
	            }
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    function absFloor(number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    function makeGetSet(unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get(mom, unit) {
	        return mom.isValid()
	            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
	            : NaN;
	    }
	
	    function set$1(mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (
	                unit === 'FullYear' &&
	                isLeapYear(mom.year()) &&
	                mom.month() === 1 &&
	                mom.date() === 29
	            ) {
	                value = toInt(value);
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
	                    value,
	                    mom.month(),
	                    daysInMonth(value, mom.month())
	                );
	            } else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet(units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	    function stringSet(units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units),
	                i,
	                prioritizedLen = prioritized.length;
	            for (i = 0; i < prioritizedLen; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    var match1 = /\d/, //       0 - 9
	        match2 = /\d\d/, //      00 - 99
	        match3 = /\d{3}/, //     000 - 999
	        match4 = /\d{4}/, //    0000 - 9999
	        match6 = /[+-]?\d{6}/, // -999999 - 999999
	        match1to2 = /\d\d?/, //       0 - 99
	        match3to4 = /\d\d\d\d?/, //     999 - 9999
	        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
	        match1to3 = /\d{1,3}/, //       0 - 999
	        match1to4 = /\d{1,4}/, //       0 - 9999
	        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
	        matchUnsigned = /\d+/, //       0 - inf
	        matchSigned = /[+-]?\d+/, //    -inf - inf
	        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
	        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
	        // any word (or two) characters or numbers including two/three word month in arabic.
	        // includes scottish gaelic two word and hyphenated months
	        matchWord =
	            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
	        regexes;
	
	    regexes = {};
	
	    function addRegexToken(token, regex, strictRegex) {
	        regexes[token] = isFunction(regex)
	            ? regex
	            : function (isStrict, localeData) {
	                  return isStrict && strictRegex ? strictRegex : regex;
	              };
	    }
	
	    function getParseRegexForToken(token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(
	            s
	                .replace('\\', '')
	                .replace(
	                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
	                    function (matched, p1, p2, p3, p4) {
	                        return p1 || p2 || p3 || p4;
	                    }
	                )
	        );
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken(token, callback) {
	        var i,
	            func = callback,
	            tokenLen;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        tokenLen = token.length;
	        for (i = 0; i < tokenLen; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken(token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0,
	        MONTH = 1,
	        DATE = 2,
	        HOUR = 3,
	        MINUTE = 4,
	        SECOND = 5,
	        MILLISECOND = 6,
	        WEEK = 7,
	        WEEKDAY = 8;
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1
	            ? isLeapYear(year)
	                ? 29
	                : 28
	            : 31 - ((modMonth % 7) % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M', match1to2);
	    addRegexToken('MM', match1to2, match2);
	    addRegexToken('MMM', function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var defaultLocaleMonths =
	            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	                '_'
	            ),
	        defaultLocaleMonthsShort =
	            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
	        defaultMonthsShortRegex = matchWord,
	        defaultMonthsRegex = matchWord;
	
	    function localeMonths(m, format) {
	        if (!m) {
	            return isArray(this._months)
	                ? this._months
	                : this._months['standalone'];
	        }
	        return isArray(this._months)
	            ? this._months[m.month()]
	            : this._months[
	                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
	                      ? 'format'
	                      : 'standalone'
	              ][m.month()];
	    }
	
	    function localeMonthsShort(m, format) {
	        if (!m) {
	            return isArray(this._monthsShort)
	                ? this._monthsShort
	                : this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort)
	            ? this._monthsShort[m.month()]
	            : this._monthsShort[
	                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
	              ][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse(monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp(
	                    '^' + this.months(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	                this._shortMonthsParse[i] = new RegExp(
	                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex =
	                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'MMMM' &&
	                this._longMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'MMM' &&
	                this._shortMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth(mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth(value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth() {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    function monthsShortRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict
	                ? this._monthsShortStrictRegex
	                : this._monthsShortRegex;
	        }
	    }
	
	    function monthsRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict
	                ? this._monthsStrictRegex
	                : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._monthsShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY', 4], 0, 'year');
	    addFormatToken(0, ['YYYYY', 5], 0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y', matchSigned);
	    addRegexToken('YY', match1to2, match2);
	    addRegexToken('YYYY', match1to4, match4);
	    addRegexToken('YYYYY', match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] =
	            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear() {
	        return isLeapYear(this.year());
	    }
	
	    function createDate(y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate(y) {
	        var date, args;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear,
	            resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear,
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek,
	            resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear,
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w', match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W', match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(
	        ['w', 'ww', 'W', 'WW'],
	        function (input, week, config, token) {
	            week[token.substr(0, 1)] = toInt(input);
	        }
	    );
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek(mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek() {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear() {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek(input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek(input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d', match1to2);
	    addRegexToken('e', match1to2);
	    addRegexToken('E', match1to2);
	    addRegexToken('dd', function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd', function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd', function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays(ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays =
	            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        defaultWeekdaysRegex = matchWord,
	        defaultWeekdaysShortRegex = matchWord,
	        defaultWeekdaysMinRegex = matchWord;
	
	    function localeWeekdays(m, format) {
	        var weekdays = isArray(this._weekdays)
	            ? this._weekdays
	            : this._weekdays[
	                  m && m !== true && this._weekdays.isFormat.test(format)
	                      ? 'format'
	                      : 'standalone'
	              ];
	        return m === true
	            ? shiftWeekdays(weekdays, this._week.dow)
	            : m
	            ? weekdays[m.day()]
	            : weekdays;
	    }
	
	    function localeWeekdaysShort(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : m
	            ? this._weekdaysShort[m.day()]
	            : this._weekdaysShort;
	    }
	
	    function localeWeekdaysMin(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : m
	            ? this._weekdaysMin[m.day()]
	            : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse(weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._shortWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._minWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	            }
	            if (!this._weekdaysParse[i]) {
	                regex =
	                    '^' +
	                    this.weekdays(mom, '') +
	                    '|^' +
	                    this.weekdaysShort(mom, '') +
	                    '|^' +
	                    this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'dddd' &&
	                this._fullWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'ddd' &&
	                this._shortWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'dd' &&
	                this._minWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    function weekdaysRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict
	                ? this._weekdaysStrictRegex
	                : this._weekdaysRegex;
	        }
	    }
	
	    function weekdaysShortRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict
	                ? this._weekdaysShortStrictRegex
	                : this._weekdaysShortRegex;
	        }
	    }
	
	    function weekdaysMinRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict
	                ? this._weekdaysMinStrictRegex
	                : this._weekdaysMinRegex;
	        }
	    }
	
	    function computeWeekdaysParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [],
	            shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            minp,
	            shortp,
	            longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = regexEscape(this.weekdaysMin(mom, ''));
	            shortp = regexEscape(this.weekdaysShort(mom, ''));
	            longp = regexEscape(this.weekdays(mom, ''));
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysMinStrictRegex = new RegExp(
	            '^(' + minPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return (
	            '' +
	            hFormat.apply(this) +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return (
	            '' +
	            this.hours() +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    function meridiem(token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(
	                this.hours(),
	                this.minutes(),
	                lowercase
	            );
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem(isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a', matchMeridiem);
	    addRegexToken('A', matchMeridiem);
	    addRegexToken('H', match1to2);
	    addRegexToken('h', match1to2);
	    addRegexToken('k', match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM(input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return (input + '').toLowerCase().charAt(0) === 'p';
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
	        // Setting the hour should keep the time, because the user explicitly
	        // specified which hour they want. So trying to maintain the same hour (in
	        // a new timezone) makes sense. Adding/subtracting hours does not follow
	        // this rule.
	        getSetHour = makeGetSet('Hours', true);
	
	    function localeMeridiem(hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse,
	    };
	
	    // internal storage for locale config files
	    var locales = {},
	        localeFamilies = {},
	        globalLocale;
	
	    function commonPrefix(arr1, arr2) {
	        var i,
	            minl = Math.min(arr1.length, arr2.length);
	        for (i = 0; i < minl; i += 1) {
	            if (arr1[i] !== arr2[i]) {
	                return i;
	            }
	        }
	        return minl;
	    }
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0,
	            j,
	            next,
	            locale,
	            split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (
	                    next &&
	                    next.length >= j &&
	                    commonPrefix(split, next) >= j - 1
	                ) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function isLocaleNameSane(name) {
	        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
	        return name.match('^[^/\\\\]*$') != null;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null,
	            aliasedRequire;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (
	            locales[name] === undefined &&
	            typeof module !== 'undefined' &&
	            module &&
	            module.exports &&
	            isLocaleNameSane(name)
	        ) {
	            try {
	                oldLocale = globalLocale._abbr;
	                aliasedRequire = require;
	                __webpack_require__(436)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {
	                // mark as not found to avoid repeating expensive file require call causing high CPU
	                // when trying to find en-US, en_US, en-us for every format call
	                locales[name] = null; // null means not found
	            }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale(key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            } else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            } else {
	                if (typeof console !== 'undefined' && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn(
	                        'Locale ' + key + ' not found. Did you forget to load it?'
	                    );
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale(name, config) {
	        if (config !== null) {
	            var locale,
	                parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple(
	                    'defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
	                );
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config,
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale,
	                tmpLocale,
	                parentConfig = baseConfig;
	
	            if (locales[name] != null && locales[name].parentLocale != null) {
	                // Update existing child locale in-place to avoid memory-leaks
	                locales[name].set(mergeConfigs(locales[name]._config, config));
	            } else {
	                // MERGE
	                tmpLocale = loadLocale(name);
	                if (tmpLocale != null) {
	                    parentConfig = tmpLocale._config;
	                }
	                config = mergeConfigs(parentConfig, config);
	                if (tmpLocale == null) {
	                    // updateLocale is called for creating a new locale
	                    // Set abbr so it will have a name (getters return
	                    // undefined otherwise).
	                    config.abbr = name;
	                }
	                locale = new Locale(config);
	                locale.parentLocale = locales[name];
	                locales[name] = locale;
	            }
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                    if (name === getSetGlobalLocale()) {
	                        getSetGlobalLocale(name);
	                    }
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale(key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow(m) {
	        var overflow,
	            a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH] < 0 || a[MONTH] > 11
	                    ? MONTH
	                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
	                    ? DATE
	                    : a[HOUR] < 0 ||
	                      a[HOUR] > 24 ||
	                      (a[HOUR] === 24 &&
	                          (a[MINUTE] !== 0 ||
	                              a[SECOND] !== 0 ||
	                              a[MILLISECOND] !== 0))
	                    ? HOUR
	                    : a[MINUTE] < 0 || a[MINUTE] > 59
	                    ? MINUTE
	                    : a[SECOND] < 0 || a[SECOND] > 59
	                    ? SECOND
	                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
	                    ? MILLISECOND
	                    : -1;
	
	            if (
	                getParsingFlags(m)._overflowDayOfYear &&
	                (overflow < YEAR || overflow > DATE)
	            ) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex =
	            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        basicIsoRegex =
	            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
	        isoDates = [
	            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	            ['YYYY-DDD', /\d{4}-\d{3}/],
	            ['YYYY-MM', /\d{4}-\d\d/, false],
	            ['YYYYYYMMDD', /[+-]\d{10}/],
	            ['YYYYMMDD', /\d{8}/],
	            ['GGGG[W]WWE', /\d{4}W\d{3}/],
	            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	            ['YYYYDDD', /\d{7}/],
	            ['YYYYMM', /\d{6}/, false],
	            ['YYYY', /\d{4}/, false],
	        ],
	        // iso time formats and regexes
	        isoTimes = [
	            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	            ['HH:mm', /\d\d:\d\d/],
	            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	            ['HHmmss', /\d\d\d\d\d\d/],
	            ['HHmm', /\d\d\d\d/],
	            ['HH', /\d\d/],
	        ],
	        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
	        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	        rfc2822 =
	            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
	        obsOffsets = {
	            UT: 0,
	            GMT: 0,
	            EDT: -4 * 60,
	            EST: -5 * 60,
	            CDT: -5 * 60,
	            CST: -6 * 60,
	            MDT: -6 * 60,
	            MST: -7 * 60,
	            PDT: -7 * 60,
	            PST: -8 * 60,
	        };
	
	    // date from iso format
	    function configFromISO(config) {
	        var i,
	            l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime,
	            dateFormat,
	            timeFormat,
	            tzFormat,
	            isoDatesLen = isoDates.length,
	            isoTimesLen = isoTimes.length;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	            for (i = 0, l = isoDatesLen; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimesLen; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    function extractFromRFC2822Strings(
	        yearStr,
	        monthStr,
	        dayStr,
	        hourStr,
	        minuteStr,
	        secondStr
	    ) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10),
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s
	            .replace(/\([^()]*\)|[\n\t]/g, ' ')
	            .replace(/(\s\s+)/g, ' ')
	            .replace(/^\s\s*/, '')
	            .replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(
	                    parsedInput[0],
	                    parsedInput[1],
	                    parsedInput[2]
	                ).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10),
	                m = hm % 100,
	                h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i)),
	            parsedArray;
	        if (match) {
	            parsedArray = extractFromRFC2822Strings(
	                match[4],
	                match[3],
	                match[2],
	                match[5],
	                match[6],
	                match[7]
	            );
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        if (config._strict) {
	            config._isValid = false;
	        } else {
	            // Final attempt, use Input Fallback
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [
	                nowValue.getUTCFullYear(),
	                nowValue.getUTCMonth(),
	                nowValue.getUTCDate(),
	            ];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray(config) {
	        var i,
	            date,
	            input = [],
	            currentDate,
	            expectedWeekday,
	            yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (
	                config._dayOfYear > daysInYear(yearToUse) ||
	                config._dayOfYear === 0
	            ) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] =
	                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (
	            config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0
	        ) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(
	            null,
	            input
	        );
	        expectedWeekday = config._useUTC
	            ? config._d.getUTCDay()
	            : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (
	            config._w &&
	            typeof config._w.d !== 'undefined' &&
	            config._w.d !== expectedWeekday
	        ) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(
	                w.GG,
	                config._a[YEAR],
	                weekOfYear(createLocal(), 1, 4).year
	            );
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i,
	            parsedInput,
	            tokens,
	            token,
	            skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0,
	            era,
	            tokenLen;
	
	        tokens =
	            expandFormat(config._f, config._locale).match(formattingTokens) || [];
	        tokenLen = tokens.length;
	        for (i = 0; i < tokenLen; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
	                [])[0];
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(
	                    string.indexOf(parsedInput) + parsedInput.length
	                );
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                } else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            } else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver =
	            stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (
	            config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0
	        ) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(
	            config._locale,
	            config._a[HOUR],
	            config._meridiem
	        );
	
	        // handle era
	        era = getParsingFlags(config).era;
	        if (era !== null) {
	            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
	        }
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	    function meridiemFixWrap(locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	            scoreToBeat,
	            i,
	            currentScore,
	            validFormatFound,
	            bestFormatIsValid = false,
	            configfLen = config._f.length;
	
	        if (configfLen === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < configfLen; i++) {
	            currentScore = 0;
	            validFormatFound = false;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (isValid(tempConfig)) {
	                validFormatFound = true;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (!bestFormatIsValid) {
	                if (
	                    scoreToBeat == null ||
	                    currentScore < scoreToBeat ||
	                    validFormatFound
	                ) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                    if (validFormatFound) {
	                        bestFormatIsValid = true;
	                    }
	                }
	            } else {
	                if (currentScore < scoreToBeat) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                }
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i),
	            dayOrDate = i.day === undefined ? i.date : i.day;
	        config._a = map(
	            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
	            function (obj) {
	                return obj && parseInt(obj, 10);
	            }
	        );
	
	        configFromArray(config);
	    }
	
	    function createFromConfig(config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig(config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({ nullInput: true });
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC(input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (format === true || format === false) {
	            strict = format;
	            format = undefined;
	        }
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if (
	            (isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)
	        ) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other < this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        ),
	        prototypeMax = deprecate(
	            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other > this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +new Date();
	    };
	
	    var ordering = [
	        'year',
	        'quarter',
	        'month',
	        'week',
	        'day',
	        'hour',
	        'minute',
	        'second',
	        'millisecond',
	    ];
	
	    function isDurationValid(m) {
	        var key,
	            unitHasDecimal = false,
	            i,
	            orderLen = ordering.length;
	        for (key in m) {
	            if (
	                hasOwnProp(m, key) &&
	                !(
	                    indexOf.call(ordering, key) !== -1 &&
	                    (m[key] == null || !isNaN(m[key]))
	                )
	            ) {
	                return false;
	            }
	        }
	
	        for (i = 0; i < orderLen; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration(duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds =
	            +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days + weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months + quarters * 3 + years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration(obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound(number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if (
	                (dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
	            ) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    // FORMATTING
	
	    function offset(token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset(),
	                sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return (
	                sign +
	                zeroFill(~~(offset / 60), 2) +
	                separator +
	                zeroFill(~~offset % 60, 2)
	            );
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z', matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher),
	            chunk,
	            parts,
	            minutes;
	
	        if (matches === null) {
	            return null;
	        }
	
	        chunk = matches[matches.length - 1] || [];
	        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff =
	                (isMoment(input) || isDate(input)
	                    ? input.valueOf()
	                    : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset(m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset());
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset(input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(
	                        this,
	                        createDuration(input - offset, 'm'),
	                        1,
	                        false
	                    );
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone(input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC(keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal(keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset() {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            } else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset(input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime() {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted() {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {},
	            other;
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted =
	                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal() {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset() {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc() {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
	        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	        // and further modified to allow for strings containing both week and day
	        isoRegex =
	            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration(input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms: input._milliseconds,
	                d: input._days,
	                M: input._months,
	            };
	        } else if (isNumber(input) || !isNaN(+input)) {
	            duration = {};
	            if (key) {
	                duration[key] = +input;
	            } else {
	                duration.milliseconds = +input;
	            }
	        } else if ((match = aspNetRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: 0,
	                d: toInt(match[DATE]) * sign,
	                h: toInt(match[HOUR]) * sign,
	                m: toInt(match[MINUTE]) * sign,
	                s: toInt(match[SECOND]) * sign,
	                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
	            };
	        } else if ((match = isoRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: parseIso(match[2], sign),
	                M: parseIso(match[3], sign),
	                w: parseIso(match[4], sign),
	                d: parseIso(match[5], sign),
	                h: parseIso(match[6], sign),
	                m: parseIso(match[7], sign),
	                s: parseIso(match[8], sign),
	            };
	        } else if (duration == null) {
	            // checks for null or undefined
	            duration = {};
	        } else if (
	            typeof duration === 'object' &&
	            ('from' in duration || 'to' in duration)
	        ) {
	            diffRes = momentsDifference(
	                createLocal(duration.from),
	                createLocal(duration.to)
	            );
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
	            ret._isValid = input._isValid;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso(inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months =
	            other.month() - base.month() + (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +base.clone().add(res.months, 'M');
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return { milliseconds: 0, months: 0 };
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(
	                    name,
	                    'moment().' +
	                        name +
	                        '(period, number) is deprecated. Please use moment().' +
	                        name +
	                        '(number, period). ' +
	                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
	                );
	                tmp = val;
	                val = period;
	                period = tmp;
	            }
	
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract(mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add = createAdder(1, 'add'),
	        subtract = createAdder(-1, 'subtract');
	
	    function isString(input) {
	        return typeof input === 'string' || input instanceof String;
	    }
	
	    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
	    function isMomentInput(input) {
	        return (
	            isMoment(input) ||
	            isDate(input) ||
	            isString(input) ||
	            isNumber(input) ||
	            isNumberOrStringArray(input) ||
	            isMomentInputObject(input) ||
	            input === null ||
	            input === undefined
	        );
	    }
	
	    function isMomentInputObject(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'years',
	                'year',
	                'y',
	                'months',
	                'month',
	                'M',
	                'days',
	                'day',
	                'd',
	                'dates',
	                'date',
	                'D',
	                'hours',
	                'hour',
	                'h',
	                'minutes',
	                'minute',
	                'm',
	                'seconds',
	                'second',
	                's',
	                'milliseconds',
	                'millisecond',
	                'ms',
	            ],
	            i,
	            property,
	            propertyLen = properties.length;
	
	        for (i = 0; i < propertyLen; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function isNumberOrStringArray(input) {
	        var arrayTest = isArray(input),
	            dataTypeTest = false;
	        if (arrayTest) {
	            dataTypeTest =
	                input.filter(function (item) {
	                    return !isNumber(item) && isString(input);
	                }).length === 0;
	        }
	        return arrayTest && dataTypeTest;
	    }
	
	    function isCalendarSpec(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'sameDay',
	                'nextDay',
	                'lastDay',
	                'nextWeek',
	                'lastWeek',
	                'sameElse',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6
	            ? 'sameElse'
	            : diff < -1
	            ? 'lastWeek'
	            : diff < 0
	            ? 'lastDay'
	            : diff < 1
	            ? 'sameDay'
	            : diff < 2
	            ? 'nextDay'
	            : diff < 7
	            ? 'nextWeek'
	            : 'sameElse';
	    }
	
	    function calendar$1(time, formats) {
	        // Support for single parameter, formats only overload to the calendar function
	        if (arguments.length === 1) {
	            if (!arguments[0]) {
	                time = undefined;
	                formats = undefined;
	            } else if (isMomentInput(arguments[0])) {
	                time = arguments[0];
	                formats = undefined;
	            } else if (isCalendarSpec(arguments[0])) {
	                formats = arguments[0];
	                time = undefined;
	            }
	        }
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse',
	            output =
	                formats &&
	                (isFunction(formats[format])
	                    ? formats[format].call(this, now)
	                    : formats[format]);
	
	        return this.format(
	            output || this.localeData().calendar(format, this, createLocal(now))
	        );
	    }
	
	    function clone() {
	        return new Moment(this);
	    }
	
	    function isAfter(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween(from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (
	            (inclusivity[0] === '('
	                ? this.isAfter(localFrom, units)
	                : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')'
	                ? this.isBefore(localTo, units)
	                : !this.isAfter(localTo, units))
	        );
	    }
	
	    function isSame(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return (
	                this.clone().startOf(units).valueOf() <= inputMs &&
	                inputMs <= this.clone().endOf(units).valueOf()
	            );
	        }
	    }
	
	    function isSameOrAfter(input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore(input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff(input, units, asFloat) {
	        var that, zoneDelta, output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year':
	                output = monthDiff(this, that) / 12;
	                break;
	            case 'month':
	                output = monthDiff(this, that);
	                break;
	            case 'quarter':
	                output = monthDiff(this, that) / 3;
	                break;
	            case 'second':
	                output = (this - that) / 1e3;
	                break; // 1000
	            case 'minute':
	                output = (this - that) / 6e4;
	                break; // 1000 * 60
	            case 'hour':
	                output = (this - that) / 36e5;
	                break; // 1000 * 60 * 60
	            case 'day':
	                output = (this - that - zoneDelta) / 864e5;
	                break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week':
	                output = (this - that - zoneDelta) / 6048e5;
	                break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default:
	                output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff(a, b) {
	        if (a.date() < b.date()) {
	            // end-of-month calculations work correct when the start month has more
	            // days than the end month.
	            return -monthDiff(b, a);
	        }
	        // difference in months
	        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2,
	            adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString() {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true,
	            m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(
	                m,
	                utc
	                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
	                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
	            );
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
	                    .toISOString()
	                    .replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(
	            m,
	            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
	        );
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect() {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment',
	            zone = '',
	            prefix,
	            year,
	            datetime,
	            suffix;
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        prefix = '[' + func + '("]';
	        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
	        datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format(inputString) {
	        if (!inputString) {
	            inputString = this.isUtc()
	                ? hooks.defaultFormatUtc
	                : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ to: this, from: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow(withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ from: this, to: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow(withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale(key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData() {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000,
	        MS_PER_MINUTE = 60 * MS_PER_SECOND,
	        MS_PER_HOUR = 60 * MS_PER_MINUTE,
	        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return ((dividend % divisor) + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(
	                    this.year(),
	                    this.month() - (this.month() % 3),
	                    1
	                );
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - this.weekday()
	                );
	                break;
	            case 'isoWeek':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - (this.isoWeekday() - 1)
	                );
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(
	                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                    MS_PER_HOUR
	                );
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month() - (this.month() % 3) + 3,
	                        1
	                    ) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - this.weekday() + 7
	                    ) - 1;
	                break;
	            case 'isoWeek':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - (this.isoWeekday() - 1) + 7
	                    ) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time +=
	                    MS_PER_HOUR -
	                    mod$1(
	                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                        MS_PER_HOUR
	                    ) -
	                    1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf() {
	        return this._d.valueOf() - (this._offset || 0) * 60000;
	    }
	
	    function unix() {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate() {
	        return new Date(this.valueOf());
	    }
	
	    function toArray() {
	        var m = this;
	        return [
	            m.year(),
	            m.month(),
	            m.date(),
	            m.hour(),
	            m.minute(),
	            m.second(),
	            m.millisecond(),
	        ];
	    }
	
	    function toObject() {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds(),
	        };
	    }
	
	    function toJSON() {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2() {
	        return isValid(this);
	    }
	
	    function parsingFlags() {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt() {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict,
	        };
	    }
	
	    addFormatToken('N', 0, 0, 'eraAbbr');
	    addFormatToken('NN', 0, 0, 'eraAbbr');
	    addFormatToken('NNN', 0, 0, 'eraAbbr');
	    addFormatToken('NNNN', 0, 0, 'eraName');
	    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
	
	    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
	    addFormatToken('y', ['yy', 2], 0, 'eraYear');
	    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
	    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
	
	    addRegexToken('N', matchEraAbbr);
	    addRegexToken('NN', matchEraAbbr);
	    addRegexToken('NNN', matchEraAbbr);
	    addRegexToken('NNNN', matchEraName);
	    addRegexToken('NNNNN', matchEraNarrow);
	
	    addParseToken(
	        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
	        function (input, array, config, token) {
	            var era = config._locale.erasParse(input, token, config._strict);
	            if (era) {
	                getParsingFlags(config).era = era;
	            } else {
	                getParsingFlags(config).invalidEra = input;
	            }
	        }
	    );
	
	    addRegexToken('y', matchUnsigned);
	    addRegexToken('yy', matchUnsigned);
	    addRegexToken('yyy', matchUnsigned);
	    addRegexToken('yyyy', matchUnsigned);
	    addRegexToken('yo', matchEraYearOrdinal);
	
	    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
	    addParseToken(['yo'], function (input, array, config, token) {
	        var match;
	        if (config._locale._eraYearOrdinalRegex) {
	            match = input.match(config._locale._eraYearOrdinalRegex);
	        }
	
	        if (config._locale.eraYearOrdinalParse) {
	            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
	        } else {
	            array[YEAR] = parseInt(input, 10);
	        }
	    });
	
	    function localeEras(m, format) {
	        var i,
	            l,
	            date,
	            eras = this._eras || getLocale('en')._eras;
	        for (i = 0, l = eras.length; i < l; ++i) {
	            switch (typeof eras[i].since) {
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].since).startOf('day');
	                    eras[i].since = date.valueOf();
	                    break;
	            }
	
	            switch (typeof eras[i].until) {
	                case 'undefined':
	                    eras[i].until = +Infinity;
	                    break;
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].until).startOf('day').valueOf();
	                    eras[i].until = date.valueOf();
	                    break;
	            }
	        }
	        return eras;
	    }
	
	    function localeErasParse(eraName, format, strict) {
	        var i,
	            l,
	            eras = this.eras(),
	            name,
	            abbr,
	            narrow;
	        eraName = eraName.toUpperCase();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            name = eras[i].name.toUpperCase();
	            abbr = eras[i].abbr.toUpperCase();
	            narrow = eras[i].narrow.toUpperCase();
	
	            if (strict) {
	                switch (format) {
	                    case 'N':
	                    case 'NN':
	                    case 'NNN':
	                        if (abbr === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNN':
	                        if (name === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNNN':
	                        if (narrow === eraName) {
	                            return eras[i];
	                        }
	                        break;
	                }
	            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
	                return eras[i];
	            }
	        }
	    }
	
	    function localeErasConvertYear(era, year) {
	        var dir = era.since <= era.until ? +1 : -1;
	        if (year === undefined) {
	            return hooks(era.since).year();
	        } else {
	            return hooks(era.since).year() + (year - era.offset) * dir;
	        }
	    }
	
	    function getEraName() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].name;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].name;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraNarrow() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].narrow;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].narrow;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraAbbr() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].abbr;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].abbr;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraYear() {
	        var i,
	            l,
	            dir,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            dir = eras[i].since <= eras[i].until ? +1 : -1;
	
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (
	                (eras[i].since <= val && val <= eras[i].until) ||
	                (eras[i].until <= val && val <= eras[i].since)
	            ) {
	                return (
	                    (this.year() - hooks(eras[i].since).year()) * dir +
	                    eras[i].offset
	                );
	            }
	        }
	
	        return this.year();
	    }
	
	    function erasNameRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNameRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNameRegex : this._erasRegex;
	    }
	
	    function erasAbbrRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasAbbrRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasAbbrRegex : this._erasRegex;
	    }
	
	    function erasNarrowRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNarrowRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNarrowRegex : this._erasRegex;
	    }
	
	    function matchEraAbbr(isStrict, locale) {
	        return locale.erasAbbrRegex(isStrict);
	    }
	
	    function matchEraName(isStrict, locale) {
	        return locale.erasNameRegex(isStrict);
	    }
	
	    function matchEraNarrow(isStrict, locale) {
	        return locale.erasNarrowRegex(isStrict);
	    }
	
	    function matchEraYearOrdinal(isStrict, locale) {
	        return locale._eraYearOrdinalRegex || matchUnsigned;
	    }
	
	    function computeErasParse() {
	        var abbrPieces = [],
	            namePieces = [],
	            narrowPieces = [],
	            mixedPieces = [],
	            i,
	            l,
	            eras = this.eras();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            namePieces.push(regexEscape(eras[i].name));
	            abbrPieces.push(regexEscape(eras[i].abbr));
	            narrowPieces.push(regexEscape(eras[i].narrow));
	
	            mixedPieces.push(regexEscape(eras[i].name));
	            mixedPieces.push(regexEscape(eras[i].abbr));
	            mixedPieces.push(regexEscape(eras[i].narrow));
	        }
	
	        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
	        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
	        this._erasNarrowRegex = new RegExp(
	            '^(' + narrowPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken(token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg', 'weekYear');
	    addWeekYearFormatToken('ggggg', 'weekYear');
	    addWeekYearFormatToken('GGGG', 'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	    // PARSING
	
	    addRegexToken('G', matchSigned);
	    addRegexToken('g', matchSigned);
	    addRegexToken('GG', match1to2, match2);
	    addRegexToken('gg', match1to2, match2);
	    addRegexToken('GGGG', match1to4, match4);
	    addRegexToken('gggg', match1to4, match4);
	    addRegexToken('GGGGG', match1to6, match6);
	    addRegexToken('ggggg', match1to6, match6);
	
	    addWeekParseToken(
	        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
	        function (input, week, config, token) {
	            week[token.substr(0, 2)] = toInt(input);
	        }
	    );
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy
	        );
	    }
	
	    function getSetISOWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.isoWeek(),
	            this.isoWeekday(),
	            1,
	            4
	        );
	    }
	
	    function getISOWeeksInYear() {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getISOWeeksInISOWeekYear() {
	        return weeksInYear(this.isoWeekYear(), 1, 4);
	    }
	
	    function getWeeksInYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getWeeksInWeekYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter(input) {
	        return input == null
	            ? Math.ceil((this.month() + 1) / 3)
	            : this.month((input - 1) * 3 + (this.month() % 3));
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D', match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict
	            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
	            : locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD', match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear(input) {
	        var dayOfYear =
	            Math.round(
	                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
	            ) + 1;
	        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m', match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s', match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S', match1to3, match1);
	    addRegexToken('SS', match1to3, match2);
	    addRegexToken('SSS', match1to3, match3);
	
	    var token, getSetMillisecond;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	
	    getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z', 0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr() {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName() {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add = add;
	    proto.calendar = calendar$1;
	    proto.clone = clone;
	    proto.diff = diff;
	    proto.endOf = endOf;
	    proto.format = format;
	    proto.from = from;
	    proto.fromNow = fromNow;
	    proto.to = to;
	    proto.toNow = toNow;
	    proto.get = stringGet;
	    proto.invalidAt = invalidAt;
	    proto.isAfter = isAfter;
	    proto.isBefore = isBefore;
	    proto.isBetween = isBetween;
	    proto.isSame = isSame;
	    proto.isSameOrAfter = isSameOrAfter;
	    proto.isSameOrBefore = isSameOrBefore;
	    proto.isValid = isValid$2;
	    proto.lang = lang;
	    proto.locale = locale;
	    proto.localeData = localeData;
	    proto.max = prototypeMax;
	    proto.min = prototypeMin;
	    proto.parsingFlags = parsingFlags;
	    proto.set = stringSet;
	    proto.startOf = startOf;
	    proto.subtract = subtract;
	    proto.toArray = toArray;
	    proto.toObject = toObject;
	    proto.toDate = toDate;
	    proto.toISOString = toISOString;
	    proto.inspect = inspect;
	    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
	        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
	            return 'Moment<' + this.format() + '>';
	        };
	    }
	    proto.toJSON = toJSON;
	    proto.toString = toString;
	    proto.unix = unix;
	    proto.valueOf = valueOf;
	    proto.creationData = creationData;
	    proto.eraName = getEraName;
	    proto.eraNarrow = getEraNarrow;
	    proto.eraAbbr = getEraAbbr;
	    proto.eraYear = getEraYear;
	    proto.year = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week = proto.weeks = getSetWeek;
	    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
	    proto.weeksInYear = getWeeksInYear;
	    proto.weeksInWeekYear = getWeeksInWeekYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
	    proto.date = getSetDayOfMonth;
	    proto.day = proto.days = getSetDayOfWeek;
	    proto.weekday = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset = getSetOffset;
	    proto.utc = setOffsetToUTC;
	    proto.local = setOffsetToLocal;
	    proto.parseZone = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST = isDaylightSavingTime;
	    proto.isLocal = isLocal;
	    proto.isUtcOffset = isUtcOffset;
	    proto.isUtc = isUtc;
	    proto.isUTC = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates = deprecate(
	        'dates accessor is deprecated. Use date instead.',
	        getSetDayOfMonth
	    );
	    proto.months = deprecate(
	        'months accessor is deprecated. Use month instead',
	        getSetMonth
	    );
	    proto.years = deprecate(
	        'years accessor is deprecated. Use year instead',
	        getSetYear
	    );
	    proto.zone = deprecate(
	        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
	        getSetZone
	    );
	    proto.isDSTShifted = deprecate(
	        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
	        isDaylightSavingTimeShifted
	    );
	
	    function createUnix(input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone() {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat(string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar = calendar;
	    proto$1.longDateFormat = longDateFormat;
	    proto$1.invalidDate = invalidDate;
	    proto$1.ordinal = ordinal;
	    proto$1.preparse = preParsePostFormat;
	    proto$1.postformat = preParsePostFormat;
	    proto$1.relativeTime = relativeTime;
	    proto$1.pastFuture = pastFuture;
	    proto$1.set = set;
	    proto$1.eras = localeEras;
	    proto$1.erasParse = localeErasParse;
	    proto$1.erasConvertYear = localeErasConvertYear;
	    proto$1.erasAbbrRegex = erasAbbrRegex;
	    proto$1.erasNameRegex = erasNameRegex;
	    proto$1.erasNarrowRegex = erasNarrowRegex;
	
	    proto$1.months = localeMonths;
	    proto$1.monthsShort = localeMonthsShort;
	    proto$1.monthsParse = localeMonthsParse;
	    proto$1.monthsRegex = monthsRegex;
	    proto$1.monthsShortRegex = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays = localeWeekdays;
	    proto$1.weekdaysMin = localeWeekdaysMin;
	    proto$1.weekdaysShort = localeWeekdaysShort;
	    proto$1.weekdaysParse = localeWeekdaysParse;
	
	    proto$1.weekdaysRegex = weekdaysRegex;
	    proto$1.weekdaysShortRegex = weekdaysShortRegex;
	    proto$1.weekdaysMinRegex = weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1(format, index, field, setter) {
	        var locale = getLocale(),
	            utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl(format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i,
	            out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl(localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0,
	            i,
	            out = [];
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths(format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort(format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        eras: [
	            {
	                since: '0001-01-01',
	                until: +Infinity,
	                offset: 1,
	                name: 'Anno Domini',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: 'Before Christ',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    toInt((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate(
	        'moment.lang is deprecated. Use moment.locale instead.',
	        getSetGlobalLocale
	    );
	    hooks.langData = deprecate(
	        'moment.langData is deprecated. Use moment.localeData instead.',
	        getLocale
	    );
	
	    var mathAbs = Math.abs;
	
	    function abs() {
	        var data = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days = mathAbs(this._days);
	        this._months = mathAbs(this._months);
	
	        data.milliseconds = mathAbs(data.milliseconds);
	        data.seconds = mathAbs(data.seconds);
	        data.minutes = mathAbs(data.minutes);
	        data.hours = mathAbs(data.hours);
	        data.months = mathAbs(data.months);
	        data.years = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1(duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days += direction * other._days;
	        duration._months += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1(input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1(input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil(number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble() {
	        var milliseconds = this._milliseconds,
	            days = this._days,
	            months = this._months,
	            data = this._data,
	            seconds,
	            minutes,
	            hours,
	            years,
	            monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (
	            !(
	                (milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0)
	            )
	        ) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds = absFloor(milliseconds / 1000);
	        data.seconds = seconds % 60;
	
	        minutes = absFloor(seconds / 60);
	        data.minutes = minutes % 60;
	
	        hours = absFloor(minutes / 60);
	        data.hours = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days = days;
	        data.months = months;
	        data.years = years;
	
	        return this;
	    }
	
	    function daysToMonths(days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return (days * 4800) / 146097;
	    }
	
	    function monthsToDays(months) {
	        // the reverse of daysToMonths
	        return (months * 146097) / 4800;
	    }
	
	    function as(units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days,
	            months,
	            milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':
	                    return months;
	                case 'quarter':
	                    return months / 3;
	                case 'year':
	                    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week':
	                    return days / 7 + milliseconds / 6048e5;
	                case 'day':
	                    return days + milliseconds / 864e5;
	                case 'hour':
	                    return days * 24 + milliseconds / 36e5;
	                case 'minute':
	                    return days * 1440 + milliseconds / 6e4;
	                case 'second':
	                    return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond':
	                    return Math.floor(days * 864e5) + milliseconds;
	                default:
	                    throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1() {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs(alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms'),
	        asSeconds = makeAs('s'),
	        asMinutes = makeAs('m'),
	        asHours = makeAs('h'),
	        asDays = makeAs('d'),
	        asWeeks = makeAs('w'),
	        asMonths = makeAs('M'),
	        asQuarters = makeAs('Q'),
	        asYears = makeAs('y');
	
	    function clone$1() {
	        return createDuration(this);
	    }
	
	    function get$2(units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds'),
	        seconds = makeGetter('seconds'),
	        minutes = makeGetter('minutes'),
	        hours = makeGetter('hours'),
	        days = makeGetter('days'),
	        months = makeGetter('months'),
	        years = makeGetter('years');
	
	    function weeks() {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round,
	        thresholds = {
	            ss: 44, // a few seconds to seconds
	            s: 45, // seconds to minute
	            m: 45, // minutes to hour
	            h: 22, // hours to day
	            d: 26, // days to month/week
	            w: null, // weeks to month
	            M: 11, // months to year
	        };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
	        var duration = createDuration(posNegDuration).abs(),
	            seconds = round(duration.as('s')),
	            minutes = round(duration.as('m')),
	            hours = round(duration.as('h')),
	            days = round(duration.as('d')),
	            months = round(duration.as('M')),
	            weeks = round(duration.as('w')),
	            years = round(duration.as('y')),
	            a =
	                (seconds <= thresholds.ss && ['s', seconds]) ||
	                (seconds < thresholds.s && ['ss', seconds]) ||
	                (minutes <= 1 && ['m']) ||
	                (minutes < thresholds.m && ['mm', minutes]) ||
	                (hours <= 1 && ['h']) ||
	                (hours < thresholds.h && ['hh', hours]) ||
	                (days <= 1 && ['d']) ||
	                (days < thresholds.d && ['dd', days]);
	
	        if (thresholds.w != null) {
	            a =
	                a ||
	                (weeks <= 1 && ['w']) ||
	                (weeks < thresholds.w && ['ww', weeks]);
	        }
	        a = a ||
	            (months <= 1 && ['M']) ||
	            (months < thresholds.M && ['MM', months]) ||
	            (years <= 1 && ['y']) || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding(roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof roundingFunction === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold(threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize(argWithSuffix, argThresholds) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var withSuffix = false,
	            th = thresholds,
	            locale,
	            output;
	
	        if (typeof argWithSuffix === 'object') {
	            argThresholds = argWithSuffix;
	            argWithSuffix = false;
	        }
	        if (typeof argWithSuffix === 'boolean') {
	            withSuffix = argWithSuffix;
	        }
	        if (typeof argThresholds === 'object') {
	            th = Object.assign({}, thresholds, argThresholds);
	            if (argThresholds.s != null && argThresholds.ss == null) {
	                th.ss = argThresholds.s - 1;
	            }
	        }
	
	        locale = this.localeData();
	        output = relativeTime$1(this, !withSuffix, th, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return (x > 0) - (x < 0) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000,
	            days = abs$1(this._days),
	            months = abs$1(this._months),
	            minutes,
	            hours,
	            years,
	            s,
	            total = this.asSeconds(),
	            totalSign,
	            ymSign,
	            daysSign,
	            hmsSign;
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes = absFloor(seconds / 60);
	        hours = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	
	        totalSign = total < 0 ? '-' : '';
	        ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return (
	            totalSign +
	            'P' +
	            (years ? ymSign + years + 'Y' : '') +
	            (months ? ymSign + months + 'M' : '') +
	            (days ? daysSign + days + 'D' : '') +
	            (hours || minutes || seconds ? 'T' : '') +
	            (hours ? hmsSign + hours + 'H' : '') +
	            (minutes ? hmsSign + minutes + 'M' : '') +
	            (seconds ? hmsSign + s + 'S' : '')
	        );
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid = isValid$1;
	    proto$2.abs = abs;
	    proto$2.add = add$1;
	    proto$2.subtract = subtract$1;
	    proto$2.as = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds = asSeconds;
	    proto$2.asMinutes = asMinutes;
	    proto$2.asHours = asHours;
	    proto$2.asDays = asDays;
	    proto$2.asWeeks = asWeeks;
	    proto$2.asMonths = asMonths;
	    proto$2.asQuarters = asQuarters;
	    proto$2.asYears = asYears;
	    proto$2.valueOf = valueOf$1;
	    proto$2._bubble = bubble;
	    proto$2.clone = clone$1;
	    proto$2.get = get$2;
	    proto$2.milliseconds = milliseconds;
	    proto$2.seconds = seconds;
	    proto$2.minutes = minutes;
	    proto$2.hours = hours;
	    proto$2.days = days;
	    proto$2.weeks = weeks;
	    proto$2.months = months;
	    proto$2.years = years;
	    proto$2.humanize = humanize;
	    proto$2.toISOString = toISOString$1;
	    proto$2.toString = toISOString$1;
	    proto$2.toJSON = toISOString$1;
	    proto$2.locale = locale;
	    proto$2.localeData = localeData;
	
	    proto$2.toIsoString = deprecate(
	        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
	        toISOString$1
	    );
	    proto$2.lang = lang;
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    //! moment.js
	
	    hooks.version = '2.29.4';
	
	    setHookCallback(createLocal);
	
	    hooks.fn = proto;
	    hooks.min = min;
	    hooks.max = max;
	    hooks.now = now;
	    hooks.utc = createUTC;
	    hooks.unix = createUnix;
	    hooks.months = listMonths;
	    hooks.isDate = isDate;
	    hooks.locale = getSetGlobalLocale;
	    hooks.invalid = createInvalid;
	    hooks.duration = createDuration;
	    hooks.isMoment = isMoment;
	    hooks.weekdays = listWeekdays;
	    hooks.parseZone = createInZone;
	    hooks.localeData = getLocale;
	    hooks.isDuration = isDuration;
	    hooks.monthsShort = listMonthsShort;
	    hooks.weekdaysMin = listWeekdaysMin;
	    hooks.defineLocale = defineLocale;
	    hooks.updateLocale = updateLocale;
	    hooks.locales = listLocales;
	    hooks.weekdaysShort = listWeekdaysShort;
	    hooks.normalizeUnits = normalizeUnits;
	    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat = getCalendarFormat;
	    hooks.prototype = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD', // <input type="date" />
	        TIME: 'HH:mm', // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW', // <input type="week" />
	        MONTH: 'YYYY-MM', // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(40)(module)))

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 437,
		"./af.js": 437,
		"./ar": 438,
		"./ar-dz": 439,
		"./ar-dz.js": 439,
		"./ar-kw": 440,
		"./ar-kw.js": 440,
		"./ar-ly": 441,
		"./ar-ly.js": 441,
		"./ar-ma": 442,
		"./ar-ma.js": 442,
		"./ar-sa": 443,
		"./ar-sa.js": 443,
		"./ar-tn": 444,
		"./ar-tn.js": 444,
		"./ar.js": 438,
		"./az": 445,
		"./az.js": 445,
		"./be": 446,
		"./be.js": 446,
		"./bg": 447,
		"./bg.js": 447,
		"./bm": 448,
		"./bm.js": 448,
		"./bn": 449,
		"./bn-bd": 450,
		"./bn-bd.js": 450,
		"./bn.js": 449,
		"./bo": 451,
		"./bo.js": 451,
		"./br": 452,
		"./br.js": 452,
		"./bs": 453,
		"./bs.js": 453,
		"./ca": 454,
		"./ca.js": 454,
		"./cs": 455,
		"./cs.js": 455,
		"./cv": 456,
		"./cv.js": 456,
		"./cy": 457,
		"./cy.js": 457,
		"./da": 458,
		"./da.js": 458,
		"./de": 459,
		"./de-at": 460,
		"./de-at.js": 460,
		"./de-ch": 461,
		"./de-ch.js": 461,
		"./de.js": 459,
		"./dv": 462,
		"./dv.js": 462,
		"./el": 463,
		"./el.js": 463,
		"./en-au": 464,
		"./en-au.js": 464,
		"./en-ca": 465,
		"./en-ca.js": 465,
		"./en-gb": 466,
		"./en-gb.js": 466,
		"./en-ie": 467,
		"./en-ie.js": 467,
		"./en-il": 468,
		"./en-il.js": 468,
		"./en-in": 469,
		"./en-in.js": 469,
		"./en-nz": 470,
		"./en-nz.js": 470,
		"./en-sg": 471,
		"./en-sg.js": 471,
		"./eo": 472,
		"./eo.js": 472,
		"./es": 473,
		"./es-do": 474,
		"./es-do.js": 474,
		"./es-mx": 475,
		"./es-mx.js": 475,
		"./es-us": 476,
		"./es-us.js": 476,
		"./es.js": 473,
		"./et": 477,
		"./et.js": 477,
		"./eu": 478,
		"./eu.js": 478,
		"./fa": 479,
		"./fa.js": 479,
		"./fi": 480,
		"./fi.js": 480,
		"./fil": 481,
		"./fil.js": 481,
		"./fo": 482,
		"./fo.js": 482,
		"./fr": 483,
		"./fr-ca": 484,
		"./fr-ca.js": 484,
		"./fr-ch": 485,
		"./fr-ch.js": 485,
		"./fr.js": 483,
		"./fy": 486,
		"./fy.js": 486,
		"./ga": 487,
		"./ga.js": 487,
		"./gd": 488,
		"./gd.js": 488,
		"./gl": 489,
		"./gl.js": 489,
		"./gom-deva": 490,
		"./gom-deva.js": 490,
		"./gom-latn": 491,
		"./gom-latn.js": 491,
		"./gu": 492,
		"./gu.js": 492,
		"./he": 493,
		"./he.js": 493,
		"./hi": 494,
		"./hi.js": 494,
		"./hr": 495,
		"./hr.js": 495,
		"./hu": 496,
		"./hu.js": 496,
		"./hy-am": 497,
		"./hy-am.js": 497,
		"./id": 498,
		"./id.js": 498,
		"./is": 499,
		"./is.js": 499,
		"./it": 500,
		"./it-ch": 501,
		"./it-ch.js": 501,
		"./it.js": 500,
		"./ja": 502,
		"./ja.js": 502,
		"./jv": 503,
		"./jv.js": 503,
		"./ka": 504,
		"./ka.js": 504,
		"./kk": 505,
		"./kk.js": 505,
		"./km": 506,
		"./km.js": 506,
		"./kn": 507,
		"./kn.js": 507,
		"./ko": 508,
		"./ko.js": 508,
		"./ku": 509,
		"./ku.js": 509,
		"./ky": 510,
		"./ky.js": 510,
		"./lb": 511,
		"./lb.js": 511,
		"./lo": 512,
		"./lo.js": 512,
		"./lt": 513,
		"./lt.js": 513,
		"./lv": 514,
		"./lv.js": 514,
		"./me": 515,
		"./me.js": 515,
		"./mi": 516,
		"./mi.js": 516,
		"./mk": 517,
		"./mk.js": 517,
		"./ml": 518,
		"./ml.js": 518,
		"./mn": 519,
		"./mn.js": 519,
		"./mr": 520,
		"./mr.js": 520,
		"./ms": 521,
		"./ms-my": 522,
		"./ms-my.js": 522,
		"./ms.js": 521,
		"./mt": 523,
		"./mt.js": 523,
		"./my": 524,
		"./my.js": 524,
		"./nb": 525,
		"./nb.js": 525,
		"./ne": 526,
		"./ne.js": 526,
		"./nl": 527,
		"./nl-be": 528,
		"./nl-be.js": 528,
		"./nl.js": 527,
		"./nn": 529,
		"./nn.js": 529,
		"./oc-lnc": 530,
		"./oc-lnc.js": 530,
		"./pa-in": 531,
		"./pa-in.js": 531,
		"./pl": 532,
		"./pl.js": 532,
		"./pt": 533,
		"./pt-br": 534,
		"./pt-br.js": 534,
		"./pt.js": 533,
		"./ro": 535,
		"./ro.js": 535,
		"./ru": 536,
		"./ru.js": 536,
		"./sd": 537,
		"./sd.js": 537,
		"./se": 538,
		"./se.js": 538,
		"./si": 539,
		"./si.js": 539,
		"./sk": 540,
		"./sk.js": 540,
		"./sl": 541,
		"./sl.js": 541,
		"./sq": 542,
		"./sq.js": 542,
		"./sr": 543,
		"./sr-cyrl": 544,
		"./sr-cyrl.js": 544,
		"./sr.js": 543,
		"./ss": 545,
		"./ss.js": 545,
		"./sv": 546,
		"./sv.js": 546,
		"./sw": 547,
		"./sw.js": 547,
		"./ta": 548,
		"./ta.js": 548,
		"./te": 549,
		"./te.js": 549,
		"./tet": 550,
		"./tet.js": 550,
		"./tg": 551,
		"./tg.js": 551,
		"./th": 552,
		"./th.js": 552,
		"./tk": 553,
		"./tk.js": 553,
		"./tl-ph": 554,
		"./tl-ph.js": 554,
		"./tlh": 555,
		"./tlh.js": 555,
		"./tr": 556,
		"./tr.js": 556,
		"./tzl": 557,
		"./tzl.js": 557,
		"./tzm": 558,
		"./tzm-latn": 559,
		"./tzm-latn.js": 559,
		"./tzm.js": 558,
		"./ug-cn": 560,
		"./ug-cn.js": 560,
		"./uk": 561,
		"./uk.js": 561,
		"./ur": 562,
		"./ur.js": 562,
		"./uz": 563,
		"./uz-latn": 564,
		"./uz-latn.js": 564,
		"./uz.js": 563,
		"./vi": 565,
		"./vi.js": 565,
		"./x-pseudo": 566,
		"./x-pseudo.js": 566,
		"./yo": 567,
		"./yo.js": 567,
		"./zh-cn": 568,
		"./zh-cn.js": 568,
		"./zh-hk": 569,
		"./zh-hk.js": 569,
		"./zh-mo": 570,
		"./zh-mo.js": 570,
		"./zh-tw": 571,
		"./zh-tw.js": 571
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 436;


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var af = moment.defineLocale('af', {
	        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM: function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Vandag om] LT',
	            nextDay: '[Môre om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[Gister om] LT',
	            lastWeek: '[Laas] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oor %s',
	            past: '%s gelede',
	            s: "'n paar sekondes",
	            ss: '%d sekondes',
	            m: "'n minuut",
	            mm: '%d minute',
	            h: "'n uur",
	            hh: '%d ure',
	            d: "'n dag",
	            dd: '%d dae',
	            M: "'n maand",
	            MM: '%d maande',
	            y: "'n jaar",
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            ); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week: {
	            dow: 1, // Maandag is die eerste dag van die week.
	            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        },
	    });
	
	    return af;
	
	})));


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var ar = moment.defineLocale('ar', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ar;
	
	})));


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Amine Roukh: https://github.com/Amine27
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'جانفي',
	            'فيفري',
	            'مارس',
	            'أفريل',
	            'ماي',
	            'جوان',
	            'جويلية',
	            'أوت',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arDz = moment.defineLocale('ar-dz', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arDz;
	
	})));


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arKw;
	
	})));


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Libya) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '1',
	            2: '2',
	            3: '3',
	            4: '4',
	            5: '5',
	            6: '6',
	            7: '7',
	            8: '8',
	            9: '9',
	            0: '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arLy;
	
	})));


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arMa;
	
	})));


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return arSa;
	
	})));


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arTn;
	
	})));


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı',
	    };
	
	    var az = moment.defineLocale('az', {
	        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays:
	            'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
	                '_'
	            ),
	        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[sabah saat] LT',
	            nextWeek: '[gələn həftə] dddd [saat] LT',
	            lastDay: '[dünən] LT',
	            lastWeek: '[keçən həftə] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s əvvəl',
	            s: 'bir neçə saniyə',
	            ss: '%d saniyə',
	            m: 'bir dəqiqə',
	            mm: '%d dəqiqə',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir il',
	            yy: '%d il',
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM: function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal: function (number) {
	            if (number === 0) {
	                // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = (number % 100) - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return az;
	
	})));


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            dd: 'дзень_дні_дзён',
	            MM: 'месяц_месяцы_месяцаў',
	            yy: 'год_гады_гадоў',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months: {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
	                '_'
	            ),
	            standalone:
	                'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays: {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
	                '_'
	            ),
	            standalone:
	                'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
	                    '_'
	                ),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
	        },
	        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
	        },
	        calendar: {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'праз %s',
	            past: '%s таму',
	            s: 'некалькі секунд',
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithPlural,
	            hh: relativeTimeWithPlural,
	            d: 'дзень',
	            dd: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM: function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) &&
	                        number % 100 !== 12 &&
	                        number % 100 !== 13
	                        ? number + '-і'
	                        : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return be;
	
	})));


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bg = moment.defineLocale('bg', {
	        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Днес в] LT',
	            nextDay: '[Утре в] LT',
	            nextWeek: 'dddd [в] LT',
	            lastDay: '[Вчера в] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Миналата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Миналия] dddd [в] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'след %s',
	            past: 'преди %s',
	            s: 'няколко секунди',
	            ss: '%d секунди',
	            m: 'минута',
	            mm: '%d минути',
	            h: 'час',
	            hh: '%d часа',
	            d: 'ден',
	            dd: '%d дена',
	            w: 'седмица',
	            ww: '%d седмици',
	            M: 'месец',
	            MM: '%d месеца',
	            y: 'година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bg;
	
	})));


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bambara [bm]
	//! author : Estelle Comment : https://github.com/estellecomment
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bm = moment.defineLocale('bm', {
	        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
	            '_'
	        ),
	        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'MMMM [tile] D [san] YYYY',
	            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bi lɛrɛ] LT',
	            nextDay: '[Sini lɛrɛ] LT',
	            nextWeek: 'dddd [don lɛrɛ] LT',
	            lastDay: '[Kunu lɛrɛ] LT',
	            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s kɔnɔ',
	            past: 'a bɛ %s bɔ',
	            s: 'sanga dama dama',
	            ss: 'sekondi %d',
	            m: 'miniti kelen',
	            mm: 'miniti %d',
	            h: 'lɛrɛ kelen',
	            hh: 'lɛrɛ %d',
	            d: 'tile kelen',
	            dd: 'tile %d',
	            M: 'kalo kelen',
	            MM: 'kalo %d',
	            y: 'san kelen',
	            yy: 'san %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return bm;
	
	})));


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bn = moment.defineLocale('bn', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort:
	            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	                '_'
	            ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bn;
	
	})));


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali (Bangladesh) [bn-bd]
	//! author : Asraf Hossain Patoary : https://github.com/ashwoolford
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bnBd = moment.defineLocale('bn-bd', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort:
	            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	                '_'
	            ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	
	        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'রাত') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ভোর') {
	                return hour;
	            } else if (meridiem === 'সকাল') {
	                return hour;
	            } else if (meridiem === 'দুপুর') {
	                return hour >= 3 ? hour : hour + 12;
	            } else if (meridiem === 'বিকাল') {
	                return hour + 12;
	            } else if (meridiem === 'সন্ধ্যা') {
	                return hour + 12;
	            }
	        },
	
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 6) {
	                return 'ভোর';
	            } else if (hour < 12) {
	                return 'সকাল';
	            } else if (hour < 15) {
	                return 'দুপুর';
	            } else if (hour < 18) {
	                return 'বিকাল';
	            } else if (hour < 20) {
	                return 'সন্ধ্যা';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bnBd;
	
	})));


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '༡',
	            2: '༢',
	            3: '༣',
	            4: '༤',
	            5: '༥',
	            6: '༦',
	            7: '༧',
	            8: '༨',
	            9: '༩',
	            0: '༠',
	        },
	        numberMap = {
	            '༡': '1',
	            '༢': '2',
	            '༣': '3',
	            '༤': '4',
	            '༥': '5',
	            '༦': '6',
	            '༧': '7',
	            '༨': '8',
	            '༩': '9',
	            '༠': '0',
	        };
	
	    var bo = moment.defineLocale('bo', {
	        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
	                '_'
	            ),
	        monthsShortRegex: /^(ཟླ་\d{1,2})/,
	        monthsParseExact: true,
	        weekdays:
	            'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
	                '_'
	            ),
	        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
	            '_'
	        ),
	        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[དི་རིང] LT',
	            nextDay: '[སང་ཉིན] LT',
	            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay: '[ཁ་སང] LT',
	            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ལ་',
	            past: '%s སྔན་ལ',
	            s: 'ལམ་སང',
	            ss: '%d སྐར་ཆ།',
	            m: 'སྐར་མ་གཅིག',
	            mm: '%d སྐར་མ',
	            h: 'ཆུ་ཚོད་གཅིག',
	            hh: '%d ཆུ་ཚོད',
	            d: 'ཉིན་གཅིག',
	            dd: '%d ཉིན་',
	            M: 'ཟླ་བ་གཅིག',
	            MM: '%d ཟླ་བ',
	            y: 'ལོ་གཅིག',
	            yy: '%d ལོ',
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bo;
	
	})));


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            mm: 'munutenn',
	            MM: 'miz',
	            dd: 'devezh',
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            m: 'v',
	            b: 'v',
	            d: 'z',
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var monthsParse = [
	            /^gen/i,
	            /^c[ʼ\']hwe/i,
	            /^meu/i,
	            /^ebr/i,
	            /^mae/i,
	            /^(mez|eve)/i,
	            /^gou/i,
	            /^eos/i,
	            /^gwe/i,
	            /^her/i,
	            /^du/i,
	            /^ker/i,
	        ],
	        monthsRegex =
	            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        monthsStrictRegex =
	            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
	        monthsShortStrictRegex =
	            /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        fullWeekdaysParse = [
	            /^sul/i,
	            /^lun/i,
	            /^meurzh/i,
	            /^merc[ʼ\']her/i,
	            /^yaou/i,
	            /^gwener/i,
	            /^sadorn/i,
	        ],
	        shortWeekdaysParse = [
	            /^Sul/i,
	            /^Lun/i,
	            /^Meu/i,
	            /^Mer/i,
	            /^Yao/i,
	            /^Gwe/i,
	            /^Sad/i,
	        ],
	        minWeekdaysParse = [
	            /^Su/i,
	            /^Lu/i,
	            /^Me([^r]|$)/i,
	            /^Mer/i,
	            /^Ya/i,
	            /^Gw/i,
	            /^Sa/i,
	        ];
	
	    var br = moment.defineLocale('br', {
	        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
	            '_'
	        ),
	        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParse: minWeekdaysParse,
	        fullWeekdaysParse: fullWeekdaysParse,
	        shortWeekdaysParse: shortWeekdaysParse,
	        minWeekdaysParse: minWeekdaysParse,
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [a viz] MMMM YYYY',
	            LLL: 'D [a viz] MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hiziv da] LT',
	            nextDay: '[Warcʼhoazh da] LT',
	            nextWeek: 'dddd [da] LT',
	            lastDay: '[Decʼh da] LT',
	            lastWeek: 'dddd [paset da] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'a-benn %s',
	            past: '%s ʼzo',
	            s: 'un nebeud segondennoù',
	            ss: '%d eilenn',
	            m: 'ur vunutenn',
	            mm: relativeTimeWithMutation,
	            h: 'un eur',
	            hh: '%d eur',
	            d: 'un devezh',
	            dd: relativeTimeWithMutation,
	            M: 'ur miz',
	            MM: relativeTimeWithMutation,
	            y: 'ur bloaz',
	            yy: specialMutationForYears,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'añ' : 'vet';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
	        isPM: function (token) {
	            return token === 'g.m.';
	        },
	        meridiem: function (hour, minute, isLower) {
	            return hour < 12 ? 'a.m.' : 'g.m.';
	        },
	    });
	
	    return br;
	
	})));


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bs;
	
	})));


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ca = moment.defineLocale('ca', {
	        months: {
	            standalone:
	                'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
	                    '_'
	                ),
	            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort:
	            'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
	                '_'
	            ),
	        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a les] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextDay: function () {
	                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastDay: function () {
	                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [passat a ' +
	                    (this.hours() !== 1 ? 'les' : 'la') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'uns segons',
	            ss: '%d segons',
	            m: 'un minut',
	            mm: '%d minuts',
	            h: 'una hora',
	            hh: '%d hores',
	            d: 'un dia',
	            dd: '%d dies',
	            M: 'un mes',
	            MM: '%d mesos',
	            y: 'un any',
	            yy: '%d anys',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                    ? 'n'
	                    : number === 3
	                    ? 'r'
	                    : number === 4
	                    ? 't'
	                    : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ca;
	
	})));


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = {
	            format: 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
	                '_'
	            ),
	            standalone:
	                'ledna_února_března_dubna_května_června_července_srpna_září_října_listopadu_prosince'.split(
	                    '_'
	                ),
	        },
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
	        monthsParse = [
	            /^led/i,
	            /^úno/i,
	            /^bře/i,
	            /^dub/i,
	            /^kvě/i,
	            /^(čvn|červen$|června)/i,
	            /^(čvc|červenec|července)/i,
	            /^srp/i,
	            /^zář/i,
	            /^říj/i,
	            /^lis/i,
	            /^pro/i,
	        ],
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsRegex =
	            /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;
	
	    function plural(n) {
	        return n > 1 && n < 5 && ~~(n / 10) !== 1;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsStrictRegex:
	            /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
	        monthsShortStrictRegex:
	            /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	            l: 'D. M. YYYY',
	        },
	        calendar: {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'před %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cs;
	
	})));


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cv = moment.defineLocale('cv', {
	        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
	            '_'
	        ),
	        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays:
	            'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
	                '_'
	            ),
	        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        },
	        calendar: {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (output) {
	                var affix = /сехет$/i.exec(output)
	                    ? 'рен'
	                    : /ҫул$/i.exec(output)
	                    ? 'тан'
	                    : 'ран';
	                return output + affix;
	            },
	            past: '%s каялла',
	            s: 'пӗр-ик ҫеккунт',
	            ss: '%d ҫеккунт',
	            m: 'пӗр минут',
	            mm: '%d минут',
	            h: 'пӗр сехет',
	            hh: '%d сехет',
	            d: 'пӗр кун',
	            dd: '%d кун',
	            M: 'пӗр уйӑх',
	            MM: '%d уйӑх',
	            y: 'пӗр ҫул',
	            yy: '%d ҫул',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal: '%d-мӗш',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return cv;
	
	})));


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
	            '_'
	        ),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
	            '_'
	        ),
	        weekdays:
	            'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
	                '_'
	            ),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact: true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '',
	                    'af',
	                    'il',
	                    'ydd',
	                    'ydd',
	                    'ed',
	                    'ed',
	                    'ed',
	                    'fed',
	                    'fed',
	                    'fed', // 1af to 10fed
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'fed', // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cy;
	
	})));


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var da = moment.defineLocale('da', {
	        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'på dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[i] dddd[s kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'få sekunder',
	            ss: '%d sekunder',
	            m: 'et minut',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dage',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'et år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return da;
	
	})));


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return de;
	
	})));


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deAt;
	
	})));


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deCh;
	
	})));


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'ޖެނުއަރީ',
	            'ފެބްރުއަރީ',
	            'މާރިޗު',
	            'އޭޕްރީލު',
	            'މޭ',
	            'ޖޫން',
	            'ޖުލައި',
	            'އޯގަސްޓު',
	            'ސެޕްޓެމްބަރު',
	            'އޮކްޓޯބަރު',
	            'ނޮވެމްބަރު',
	            'ޑިސެމްބަރު',
	        ],
	        weekdays = [
	            'އާދިއްތަ',
	            'ހޯމަ',
	            'އަންގާރަ',
	            'ބުދަ',
	            'ބުރާސްފަތި',
	            'ހުކުރު',
	            'ހޮނިހިރު',
	        ];
	
	    var dv = moment.defineLocale('dv', {
	        months: months,
	        monthsShort: months,
	        weekdays: weekdays,
	        weekdaysShort: weekdays,
	        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/M/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM: function (input) {
	            return 'މފ' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar: {
	            sameDay: '[މިއަދު] LT',
	            nextDay: '[މާދަމާ] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[އިއްޔެ] LT',
	            lastWeek: '[ފާއިތުވި] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ތެރޭގައި %s',
	            past: 'ކުރިން %s',
	            s: 'ސިކުންތުކޮޅެއް',
	            ss: 'd% ސިކުންތު',
	            m: 'މިނިޓެއް',
	            mm: 'މިނިޓު %d',
	            h: 'ގަޑިއިރެއް',
	            hh: 'ގަޑިއިރު %d',
	            d: 'ދުވަހެއް',
	            dd: 'ދުވަސް %d',
	            M: 'މަހެއް',
	            MM: 'މަސް %d',
	            y: 'އަހަރެއް',
	            yy: 'އަހަރު %d',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 7, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return dv;
	
	})));


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl:
	            'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
	                '_'
	            ),
	        monthsGenitiveEl:
	            'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
	                '_'
	            ),
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (
	                typeof format === 'string' &&
	                /D/.test(format.substring(0, format.indexOf('MMMM')))
	            ) {
	                // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
	            '_'
	        ),
	        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM: function (input) {
	            return (input + '').toLowerCase()[0] === 'μ';
	        },
	        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendarEl: {
	            sameDay: '[Σήμερα {}] LT',
	            nextDay: '[Αύριο {}] LT',
	            nextWeek: 'dddd [{}] LT',
	            lastDay: '[Χθες {}] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        calendar: function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
	        },
	        relativeTime: {
	            future: 'σε %s',
	            past: '%s πριν',
	            s: 'λίγα δευτερόλεπτα',
	            ss: '%d δευτερόλεπτα',
	            m: 'ένα λεπτό',
	            mm: '%d λεπτά',
	            h: 'μία ώρα',
	            hh: '%d ώρες',
	            d: 'μία μέρα',
	            dd: '%d μέρες',
	            M: 'ένας μήνας',
	            MM: '%d μήνες',
	            y: 'ένας χρόνος',
	            yy: '%d χρόνια',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4st is the first week of the year.
	        },
	    });
	
	    return el;
	
	})));


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enAu = moment.defineLocale('en-au', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enAu;
	
	})));


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enCa = moment.defineLocale('en-ca', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'YYYY-MM-DD',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY h:mm A',
	            LLLL: 'dddd, MMMM D, YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enCa;
	
	})));


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enGb = moment.defineLocale('en-gb', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enGb;
	
	})));


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIe = moment.defineLocale('en-ie', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enIe;
	
	})));


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Israel) [en-il]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIl = moment.defineLocale('en-il', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enIl;
	
	})));


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (India) [en-in]
	//! author : Jatin Agrawal : https://github.com/jatinag22
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIn = moment.defineLocale('en-in', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return enIn;
	
	})));


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enNz = moment.defineLocale('en-nz', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enNz;
	
	})));


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Singapore) [en-sg]
	//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enSg = moment.defineLocale('en-sg', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enSg;
	
	})));


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	//! comment : Vivakvo corrected the translation by colindean and miestasmia
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eo = moment.defineLocale('eo', {
	        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
	        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: '[la] D[-an de] MMMM, YYYY',
	            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
	            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
	            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar: {
	            sameDay: '[Hodiaŭ je] LT',
	            nextDay: '[Morgaŭ je] LT',
	            nextWeek: 'dddd[n je] LT',
	            lastDay: '[Hieraŭ je] LT',
	            lastWeek: '[pasintan] dddd[n je] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'post %s',
	            past: 'antaŭ %s',
	            s: 'kelkaj sekundoj',
	            ss: '%d sekundoj',
	            m: 'unu minuto',
	            mm: '%d minutoj',
	            h: 'unu horo',
	            hh: '%d horoj',
	            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
	            dd: '%d tagoj',
	            M: 'unu monato',
	            MM: '%d monatoj',
	            y: 'unu jaro',
	            yy: '%d jaroj',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal: '%da',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eo;
	
	})));


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return es;
	
	})));


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esDo = moment.defineLocale('es-do', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return esDo;
	
	})));


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Mexico) [es-mx]
	//! author : JC Franco : https://github.com/jcfranco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esMx = moment.defineLocale('es-mx', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return esMx;
	
	})));


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (United States) [es-us]
	//! author : bustta : https://github.com/bustta
	//! author : chrisrodz : https://github.com/chrisrodz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esUs = moment.defineLocale('es-us', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'MM/DD/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return esUs;
	
	})));


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            ss: [number + 'sekundi', number + 'sekundit'],
	            m: ['ühe minuti', 'üks minut'],
	            mm: [number + ' minuti', number + ' minutit'],
	            h: ['ühe tunni', 'tund aega', 'üks tund'],
	            hh: [number + ' tunni', number + ' tundi'],
	            d: ['ühe päeva', 'üks päev'],
	            M: ['kuu aja', 'kuu aega', 'üks kuu'],
	            MM: [number + ' kuu', number + ' kuud'],
	            y: ['ühe aasta', 'aasta', 'üks aasta'],
	            yy: [number + ' aasta', number + ' aastat'],
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays:
	            'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
	                '_'
	            ),
	        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Täna,] LT',
	            nextDay: '[Homme,] LT',
	            nextWeek: '[Järgmine] dddd LT',
	            lastDay: '[Eile,] LT',
	            lastWeek: '[Eelmine] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s pärast',
	            past: '%s tagasi',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: '%d päeva',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return et;
	
	})));


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eu = moment.defineLocale('eu', {
	        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
	            '_'
	        ),
	        monthsShort:
	            'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
	                '_'
	            ),
	        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY[ko] MMMM[ren] D[a]',
	            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l: 'YYYY-M-D',
	            ll: 'YYYY[ko] MMM D[a]',
	            lll: 'YYYY[ko] MMM D[a] HH:mm',
	            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
	        },
	        calendar: {
	            sameDay: '[gaur] LT[etan]',
	            nextDay: '[bihar] LT[etan]',
	            nextWeek: 'dddd LT[etan]',
	            lastDay: '[atzo] LT[etan]',
	            lastWeek: '[aurreko] dddd LT[etan]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s barru',
	            past: 'duela %s',
	            s: 'segundo batzuk',
	            ss: '%d segundo',
	            m: 'minutu bat',
	            mm: '%d minutu',
	            h: 'ordu bat',
	            hh: '%d ordu',
	            d: 'egun bat',
	            dd: '%d egun',
	            M: 'hilabete bat',
	            MM: '%d hilabete',
	            y: 'urte bat',
	            yy: '%d urte',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eu;
	
	})));


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '۱',
	            2: '۲',
	            3: '۳',
	            4: '۴',
	            5: '۵',
	            6: '۶',
	            7: '۷',
	            8: '۸',
	            9: '۹',
	            0: '۰',
	        },
	        numberMap = {
	            '۱': '1',
	            '۲': '2',
	            '۳': '3',
	            '۴': '4',
	            '۵': '5',
	            '۶': '6',
	            '۷': '7',
	            '۸': '8',
	            '۹': '9',
	            '۰': '0',
	        };
	
	    var fa = moment.defineLocale('fa', {
	        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	                '_'
	            ),
	        weekdays:
	            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	                '_'
	            ),
	        weekdaysShort:
	            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	                '_'
	            ),
	        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar: {
	            sameDay: '[امروز ساعت] LT',
	            nextDay: '[فردا ساعت] LT',
	            nextWeek: 'dddd [ساعت] LT',
	            lastDay: '[دیروز ساعت] LT',
	            lastWeek: 'dddd [پیش] [ساعت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'در %s',
	            past: '%s پیش',
	            s: 'چند ثانیه',
	            ss: '%d ثانیه',
	            m: 'یک دقیقه',
	            mm: '%d دقیقه',
	            h: 'یک ساعت',
	            hh: '%d ساعت',
	            d: 'یک روز',
	            dd: '%d روز',
	            M: 'یک ماه',
	            MM: '%d ماه',
	            y: 'یک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[۰-۹]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal: '%dم',
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return fa;
	
	})));


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersPast =
	            'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
	                ' '
	            ),
	        numbersFuture = [
	            'nolla',
	            'yhden',
	            'kahden',
	            'kolmen',
	            'neljän',
	            'viiden',
	            'kuuden',
	            numbersPast[7],
	            numbersPast[8],
	            numbersPast[9],
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                result = isFuture ? 'sekunnin' : 'sekuntia';
	                break;
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10
	            ? isFuture
	                ? numbersFuture[number]
	                : numbersPast[number]
	            : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
	            '_'
	        ),
	        monthsShort:
	            'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
	                '_'
	            ),
	        weekdays:
	            'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
	                '_'
	            ),
	        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM[ta] YYYY',
	            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l: 'D.M.YYYY',
	            ll: 'Do MMM YYYY',
	            lll: 'Do MMM YYYY, [klo] HH.mm',
	            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
	        },
	        calendar: {
	            sameDay: '[tänään] [klo] LT',
	            nextDay: '[huomenna] [klo] LT',
	            nextWeek: 'dddd [klo] LT',
	            lastDay: '[eilen] [klo] LT',
	            lastWeek: '[viime] dddd[na] [klo] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s päästä',
	            past: '%s sitten',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fi;
	
	})));


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Filipino [fil]
	//! author : Dan Hagman : https://github.com/hagmandan
	//! author : Matthew Co : https://github.com/matthewdeeco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fil = moment.defineLocale('fil', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fil;
	
	})));


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	//! author : Kristian Sakarisson : https://github.com/sakarisson
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fo = moment.defineLocale('fo', {
	        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays:
	            'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
	                '_'
	            ),
	        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D. MMMM, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Í dag kl.] LT',
	            nextDay: '[Í morgin kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[Í gjár kl.] LT',
	            lastWeek: '[síðstu] dddd [kl] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'um %s',
	            past: '%s síðani',
	            s: 'fá sekund',
	            ss: '%d sekundir',
	            m: 'ein minuttur',
	            mm: '%d minuttir',
	            h: 'ein tími',
	            hh: '%d tímar',
	            d: 'ein dagur',
	            dd: '%d dagar',
	            M: 'ein mánaður',
	            MM: '%d mánaðir',
	            y: 'eitt ár',
	            yy: '%d ár',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fo;
	
	})));


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsStrictRegex =
	            /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsShortStrictRegex =
	            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
	        monthsRegex =
	            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsParse = [
	            /^janv/i,
	            /^févr/i,
	            /^mars/i,
	            /^avr/i,
	            /^mai/i,
	            /^juin/i,
	            /^juil/i,
	            /^août/i,
	            /^sept/i,
	            /^oct/i,
	            /^nov/i,
	            /^déc/i,
	        ];
	
	    var fr = moment.defineLocale('fr', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            w: 'une semaine',
	            ww: '%d semaines',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fr;
	
	})));


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	    });
	
	    return frCa;
	
	})));


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return frCh;
	
	})));


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = moment.defineLocale('fy', {
	        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact: true,
	        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
	            '_'
	        ),
	        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oer %s',
	            past: '%s lyn',
	            s: 'in pear sekonden',
	            ss: '%d sekonden',
	            m: 'ien minút',
	            mm: '%d minuten',
	            h: 'ien oere',
	            hh: '%d oeren',
	            d: 'ien dei',
	            dd: '%d dagen',
	            M: 'ien moanne',
	            MM: '%d moannen',
	            y: 'ien jier',
	            yy: '%d jierren',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fy;
	
	})));


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Irish or Irish Gaelic [ga]
	//! author : André Silva : https://github.com/askpt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Eanáir',
	            'Feabhra',
	            'Márta',
	            'Aibreán',
	            'Bealtaine',
	            'Meitheamh',
	            'Iúil',
	            'Lúnasa',
	            'Meán Fómhair',
	            'Deireadh Fómhair',
	            'Samhain',
	            'Nollaig',
	        ],
	        monthsShort = [
	            'Ean',
	            'Feabh',
	            'Márt',
	            'Aib',
	            'Beal',
	            'Meith',
	            'Iúil',
	            'Lún',
	            'M.F.',
	            'D.F.',
	            'Samh',
	            'Noll',
	        ],
	        weekdays = [
	            'Dé Domhnaigh',
	            'Dé Luain',
	            'Dé Máirt',
	            'Dé Céadaoin',
	            'Déardaoin',
	            'Dé hAoine',
	            'Dé Sathairn',
	        ],
	        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
	        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];
	
	    var ga = moment.defineLocale('ga', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Inniu ag] LT',
	            nextDay: '[Amárach ag] LT',
	            nextWeek: 'dddd [ag] LT',
	            lastDay: '[Inné ag] LT',
	            lastWeek: 'dddd [seo caite] [ag] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i %s',
	            past: '%s ó shin',
	            s: 'cúpla soicind',
	            ss: '%d soicind',
	            m: 'nóiméad',
	            mm: '%d nóiméad',
	            h: 'uair an chloig',
	            hh: '%d uair an chloig',
	            d: 'lá',
	            dd: '%d lá',
	            M: 'mí',
	            MM: '%d míonna',
	            y: 'bliain',
	            yy: '%d bliain',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ga;
	
	})));


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Am Faoilleach',
	            'An Gearran',
	            'Am Màrt',
	            'An Giblean',
	            'An Cèitean',
	            'An t-Ògmhios',
	            'An t-Iuchar',
	            'An Lùnastal',
	            'An t-Sultain',
	            'An Dàmhair',
	            'An t-Samhain',
	            'An Dùbhlachd',
	        ],
	        monthsShort = [
	            'Faoi',
	            'Gear',
	            'Màrt',
	            'Gibl',
	            'Cèit',
	            'Ògmh',
	            'Iuch',
	            'Lùn',
	            'Sult',
	            'Dàmh',
	            'Samh',
	            'Dùbh',
	        ],
	        weekdays = [
	            'Didòmhnaich',
	            'Diluain',
	            'Dimàirt',
	            'Diciadain',
	            'Diardaoin',
	            'Dihaoine',
	            'Disathairne',
	        ],
	        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
	        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[An-diugh aig] LT',
	            nextDay: '[A-màireach aig] LT',
	            nextWeek: 'dddd [aig] LT',
	            lastDay: '[An-dè aig] LT',
	            lastWeek: 'dddd [seo chaidh] [aig] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ann an %s',
	            past: 'bho chionn %s',
	            s: 'beagan diogan',
	            ss: '%d diogan',
	            m: 'mionaid',
	            mm: '%d mionaidean',
	            h: 'uair',
	            hh: '%d uairean',
	            d: 'latha',
	            dd: '%d latha',
	            M: 'mìos',
	            MM: '%d mìosan',
	            y: 'bliadhna',
	            yy: '%d bliadhna',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gd;
	
	})));


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var gl = moment.defineLocale('gl', {
	        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort:
	            'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
	            },
	            lastDay: function () {
	                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past: 'hai %s',
	            s: 'uns segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'unha hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gl;
	
	})));


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Devanagari script [gom-deva]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
	            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
	            m: ['एका मिणटान', 'एक मिनूट'],
	            mm: [number + ' मिणटांनी', number + ' मिणटां'],
	            h: ['एका वरान', 'एक वर'],
	            hh: [number + ' वरांनी', number + ' वरां'],
	            d: ['एका दिसान', 'एक दीस'],
	            dd: [number + ' दिसांनी', number + ' दीस'],
	            M: ['एका म्हयन्यान', 'एक म्हयनो'],
	            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
	            y: ['एका वर्सान', 'एक वर्स'],
	            yy: [number + ' वर्सांनी', number + ' वर्सां'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomDeva = moment.defineLocale('gom-deva', {
	        months: {
	            standalone:
	                'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	                    '_'
	                ),
	            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort:
	            'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
	        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
	        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [वाजतां]',
	            LTS: 'A h:mm:ss [वाजतां]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
	            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
	        },
	        calendar: {
	            sameDay: '[आयज] LT',
	            nextDay: '[फाल्यां] LT',
	            nextWeek: '[फुडलो] dddd[,] LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[फाटलो] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s आदीं',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'वेर' only applies to day of the month
	                case 'D':
	                    return number + 'वेर';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राती') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळीं') {
	                return hour;
	            } else if (meridiem === 'दनपारां') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'सांजे') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'राती';
	            } else if (hour < 12) {
	                return 'सकाळीं';
	            } else if (hour < 16) {
	                return 'दनपारां';
	            } else if (hour < 20) {
	                return 'सांजे';
	            } else {
	                return 'राती';
	            }
	        },
	    });
	
	    return gomDeva;
	
	})));


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['thoddea sekondamni', 'thodde sekond'],
	            ss: [number + ' sekondamni', number + ' sekond'],
	            m: ['eka mintan', 'ek minut'],
	            mm: [number + ' mintamni', number + ' mintam'],
	            h: ['eka voran', 'ek vor'],
	            hh: [number + ' voramni', number + ' voram'],
	            d: ['eka disan', 'ek dis'],
	            dd: [number + ' disamni', number + ' dis'],
	            M: ['eka mhoinean', 'ek mhoino'],
	            MM: [number + ' mhoineamni', number + ' mhoine'],
	            y: ['eka vorsan', 'ek voros'],
	            yy: [number + ' vorsamni', number + ' vorsam'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months: {
	            standalone:
	                'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
	                    '_'
	                ),
	            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort:
	            'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
	        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [vazta]',
	            LTS: 'A h:mm:ss [vazta]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [vazta]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
	        },
	        calendar: {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Fuddlo] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fattlo] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s adim',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /rati|sokallim|donparam|sanje/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokallim') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokallim';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        },
	    });
	
	    return gomLatn;
	
	})));


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Gujarati [gu]
	//! author : Kaushik Thanki : https://github.com/Kaushik1987
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '૧',
	            2: '૨',
	            3: '૩',
	            4: '૪',
	            5: '૫',
	            6: '૬',
	            7: '૭',
	            8: '૮',
	            9: '૯',
	            0: '૦',
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0',
	        };
	
	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
	            '_'
	        ),
	        monthsShort:
	            'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
	            '_'
	        ),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પહેલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ',
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return gu;
	
	})));


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var he = moment.defineLocale('he', {
	        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
	            '_'
	        ),
	        monthsShort:
	            'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [ב]MMMM YYYY',
	            LLL: 'D [ב]MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[היום ב־]LT',
	            nextDay: '[מחר ב־]LT',
	            nextWeek: 'dddd [בשעה] LT',
	            lastDay: '[אתמול ב־]LT',
	            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'בעוד %s',
	            past: 'לפני %s',
	            s: 'מספר שניות',
	            ss: '%d שניות',
	            m: 'דקה',
	            mm: '%d דקות',
	            h: 'שעה',
	            hh: function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d: 'יום',
	            dd: function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M: 'חודש',
	            MM: function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y: 'שנה',
	            yy: function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            },
	        },
	        meridiemParse:
	            /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM: function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        },
	    });
	
	    return he;
	
	})));


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        },
	        monthsParse = [
	            /^जन/i,
	            /^फ़र|फर/i,
	            /^मार्च/i,
	            /^अप्रै/i,
	            /^मई/i,
	            /^जून/i,
	            /^जुल/i,
	            /^अग/i,
	            /^सितं|सित/i,
	            /^अक्टू/i,
	            /^नव|नवं/i,
	            /^दिसं|दिस/i,
	        ],
	        shortMonthsParse = [
	            /^जन/i,
	            /^फ़र/i,
	            /^मार्च/i,
	            /^अप्रै/i,
	            /^मई/i,
	            /^जून/i,
	            /^जुल/i,
	            /^अग/i,
	            /^सित/i,
	            /^अक्टू/i,
	            /^नव/i,
	            /^दिस/i,
	        ];
	
	    var hi = moment.defineLocale('hi', {
	        months: {
	            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
	                '_'
	            ),
	            standalone:
	                'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm बजे',
	            LTS: 'A h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
	        },
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: shortMonthsParse,
	
	        monthsRegex:
	            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
	
	        monthsShortRegex:
	            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
	
	        monthsStrictRegex:
	            /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,
	
	        monthsShortStrictRegex:
	            /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,
	
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[कल] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[कल] LT',
	            lastWeek: '[पिछले] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s में',
	            past: '%s पहले',
	            s: 'कुछ ही क्षण',
	            ss: '%d सेकंड',
	            m: 'एक मिनट',
	            mm: '%d मिनट',
	            h: 'एक घंटा',
	            hh: '%d घंटे',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महीने',
	            MM: '%d महीने',
	            y: 'एक वर्ष',
	            yy: '%d वर्ष',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return hi;
	
	})));


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months: {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
	                '_'
	            ),
	            standalone:
	                'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM YYYY',
	            LLL: 'Do MMMM YYYY H:mm',
	            LLLL: 'dddd, Do MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prošlu] [nedjelju] [u] LT';
	                    case 3:
	                        return '[prošlu] [srijedu] [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hr;
	
	})));


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	//! author : Peter Viszt  : https://github.com/passatgt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var weekEndings =
	        'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return isFuture || withoutSuffix
	                    ? 'néhány másodperc'
	                    : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix)
	                    ? ' másodperc'
	                    : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (
	            (isFuture ? '' : '[múlt] ') +
	            '[' +
	            weekEndings[this.day()] +
	            '] LT[-kor]'
	        );
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY. MMMM D.',
	            LLL: 'YYYY. MMMM D. H:mm',
	            LLLL: 'YYYY. MMMM D., dddd H:mm',
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar: {
	            sameDay: '[ma] LT[-kor]',
	            nextDay: '[holnap] LT[-kor]',
	            nextWeek: function () {
	                return week.call(this, true);
	            },
	            lastDay: '[tegnap] LT[-kor]',
	            lastWeek: function () {
	                return week.call(this, false);
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s múlva',
	            past: '%s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return hu;
	
	})));


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months: {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
	                '_'
	            ),
	            standalone:
	                'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays:
	            'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
	                '_'
	            ),
	        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY թ.',
	            LLL: 'D MMMM YYYY թ., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
	        },
	        calendar: {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s հետո',
	            past: '%s առաջ',
	            s: 'մի քանի վայրկյան',
	            ss: '%d վայրկյան',
	            m: 'րոպե',
	            mm: '%d րոպե',
	            h: 'ժամ',
	            hh: '%d ժամ',
	            d: 'օր',
	            dd: '%d օր',
	            M: 'ամիս',
	            MM: '%d ամիս',
	            y: 'տարի',
	            yy: '%d տարի',
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem: function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hyAm;
	
	})));


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var id = moment.defineLocale('id', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Besok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kemarin pukul] LT',
	            lastWeek: 'dddd [lalu pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lalu',
	            s: 'beberapa detik',
	            ss: '%d detik',
	            m: 'semenit',
	            mm: '%d menit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return id;
	
	})));


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nokkrar sekúndur'
	                    : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
	                    );
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return (
	                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
	                    );
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture
	                            ? 'klukkustundir'
	                            : 'klukkustundum')
	                    );
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays:
	            'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
	                '_'
	            ),
	        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
	        },
	        calendar: {
	            sameDay: '[í dag kl.] LT',
	            nextDay: '[á morgun kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[í gær kl.] LT',
	            lastWeek: '[síðasta] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'eftir %s',
	            past: 'fyrir %s síðan',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: 'klukkustund',
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return is;
	
	})));


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	//! author: Marco : https://github.com/Manfre98
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var it = moment.defineLocale('it', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return (
	                    '[Oggi a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextDay: function () {
	                return (
	                    '[Domani a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextWeek: function () {
	                return (
	                    'dddd [a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastDay: function () {
	                return (
	                    '[Ieri a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return (
	                            '[La scorsa] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                ? ' '
	                                : "ll'") +
	                            ']LT'
	                        );
	                    default:
	                        return (
	                            '[Lo scorso] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                ? ' '
	                                : "ll'") +
	                            ']LT'
	                        );
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'tra %s',
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            w: 'una settimana',
	            ww: '%d settimane',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return it;
	
	})));


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian (Switzerland) [it-ch]
	//! author : xfh : https://github.com/xfh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var itCh = moment.defineLocale('it-ch', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return itCh;
	
	})));


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ja = moment.defineLocale('ja', {
	        eras: [
	            {
	                since: '2019-05-01',
	                offset: 1,
	                name: '令和',
	                narrow: '㋿',
	                abbr: 'R',
	            },
	            {
	                since: '1989-01-08',
	                until: '2019-04-30',
	                offset: 1,
	                name: '平成',
	                narrow: '㍻',
	                abbr: 'H',
	            },
	            {
	                since: '1926-12-25',
	                until: '1989-01-07',
	                offset: 1,
	                name: '昭和',
	                narrow: '㍼',
	                abbr: 'S',
	            },
	            {
	                since: '1912-07-30',
	                until: '1926-12-24',
	                offset: 1,
	                name: '大正',
	                narrow: '㍽',
	                abbr: 'T',
	            },
	            {
	                since: '1873-01-01',
	                until: '1912-07-29',
	                offset: 6,
	                name: '明治',
	                narrow: '㍾',
	                abbr: 'M',
	            },
	            {
	                since: '0001-01-01',
	                until: '1873-12-31',
	                offset: 1,
	                name: '西暦',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: '紀元前',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        eraYearOrdinalRegex: /(元|\d+)年/,
	        eraYearOrdinalParse: function (input, match) {
	            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
	        },
	        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日 dddd HH:mm',
	            l: 'YYYY/MM/DD',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日(ddd) HH:mm',
	        },
	        meridiemParse: /午前|午後/i,
	        isPM: function (input) {
	            return input === '午後';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar: {
	            sameDay: '[今日] LT',
	            nextDay: '[明日] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay: '[昨日] LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}日/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'y':
	                    return number === 1 ? '元年' : number + '年';
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '数秒',
	            ss: '%d秒',
	            m: '1分',
	            mm: '%d分',
	            h: '1時間',
	            hh: '%d時間',
	            d: '1日',
	            dd: '%d日',
	            M: '1ヶ月',
	            MM: '%dヶ月',
	            y: '1年',
	            yy: '%d年',
	        },
	    });
	
	    return ja;
	
	})));


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var jv = moment.defineLocale('jv', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar: {
	            sameDay: '[Dinten puniko pukul] LT',
	            nextDay: '[Mbenjang pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kala wingi pukul] LT',
	            lastWeek: 'dddd [kepengker pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'wonten ing %s',
	            past: '%s ingkang kepengker',
	            s: 'sawetawis detik',
	            ss: '%d detik',
	            m: 'setunggal menit',
	            mm: '%d menit',
	            h: 'setunggal jam',
	            hh: '%d jam',
	            d: 'sedinten',
	            dd: '%d dinten',
	            M: 'sewulan',
	            MM: '%d wulan',
	            y: 'setaun',
	            yy: '%d taun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return jv;
	
	})));


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/IrakliJani
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ka = moment.defineLocale('ka', {
	        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
	            '_'
	        ),
	        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays: {
	            standalone:
	                'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
	                    '_'
	                ),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
	                '_'
	            ),
	            isFormat: /(წინა|შემდეგ)/,
	        },
	        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[დღეს] LT[-ზე]',
	            nextDay: '[ხვალ] LT[-ზე]',
	            lastDay: '[გუშინ] LT[-ზე]',
	            nextWeek: '[შემდეგ] dddd LT[-ზე]',
	            lastWeek: '[წინა] dddd LT-ზე',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return s.replace(
	                    /(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/,
	                    function ($0, $1, $2) {
	                        return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
	                    }
	                );
	            },
	            past: function (s) {
	                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if (/წელი/.test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	                return s;
	            },
	            s: 'რამდენიმე წამი',
	            ss: '%d წამი',
	            m: 'წუთი',
	            mm: '%d წუთი',
	            h: 'საათი',
	            hh: '%d საათი',
	            d: 'დღე',
	            dd: '%d დღე',
	            M: 'თვე',
	            MM: '%d თვე',
	            y: 'წელი',
	            yy: '%d წელი',
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal: function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if (
	                number < 20 ||
	                (number <= 100 && number % 20 === 0) ||
	                number % 100 === 0
	            ) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week: {
	            dow: 1,
	            doy: 7,
	        },
	    });
	
	    return ka;
	
	})));


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші',
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
	            '_'
	        ),
	        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
	            '_'
	        ),
	        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгін сағат] LT',
	            nextDay: '[Ертең сағат] LT',
	            nextWeek: 'dddd [сағат] LT',
	            lastDay: '[Кеше сағат] LT',
	            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ішінде',
	            past: '%s бұрын',
	            s: 'бірнеше секунд',
	            ss: '%d секунд',
	            m: 'бір минут',
	            mm: '%d минут',
	            h: 'бір сағат',
	            hh: '%d сағат',
	            d: 'бір күн',
	            dd: '%d күн',
	            M: 'бір ай',
	            MM: '%d ай',
	            y: 'бір жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return kk;
	
	})));


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '១',
	            2: '២',
	            3: '៣',
	            4: '៤',
	            5: '៥',
	            6: '៦',
	            7: '៧',
	            8: '៨',
	            9: '៩',
	            0: '០',
	        },
	        numberMap = {
	            '១': '1',
	            '២': '2',
	            '៣': '3',
	            '៤': '4',
	            '៥': '5',
	            '៦': '6',
	            '៧': '7',
	            '៨': '8',
	            '៩': '9',
	            '០': '0',
	        };
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort:
	            'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	                '_'
	            ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ',
	        },
	        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
	        ordinal: 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return km;
	
	})));


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '೧',
	            2: '೨',
	            3: '೩',
	            4: '೪',
	            5: '೫',
	            6: '೬',
	            7: '೭',
	            8: '೮',
	            9: '೯',
	            0: '೦',
	        },
	        numberMap = {
	            '೧': '1',
	            '೨': '2',
	            '೩': '3',
	            '೪': '4',
	            '೫': '5',
	            '೬': '6',
	            '೭': '7',
	            '೮': '8',
	            '೯': '9',
	            '೦': '0',
	        };
	
	    var kn = moment.defineLocale('kn', {
	        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
	            '_'
	        ),
	        monthsShort:
	            'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[ಇಂದು] LT',
	            nextDay: '[ನಾಳೆ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ನಿನ್ನೆ] LT',
	            lastWeek: '[ಕೊನೆಯ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ನಂತರ',
	            past: '%s ಹಿಂದೆ',
	            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss: '%d ಸೆಕೆಂಡುಗಳು',
	            m: 'ಒಂದು ನಿಮಿಷ',
	            mm: '%d ನಿಮಿಷ',
	            h: 'ಒಂದು ಗಂಟೆ',
	            hh: '%d ಗಂಟೆ',
	            d: 'ಒಂದು ದಿನ',
	            dd: '%d ದಿನ',
	            M: 'ಒಂದು ತಿಂಗಳು',
	            MM: '%d ತಿಂಗಳು',
	            y: 'ಒಂದು ವರ್ಷ',
	            yy: '%d ವರ್ಷ',
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal: function (number) {
	            return number + 'ನೇ';
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return kn;
	
	})));


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ko = moment.defineLocale('ko', {
	        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
	            '_'
	        ),
	        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY년 MMMM D일',
	            LLL: 'YYYY년 MMMM D일 A h:mm',
	            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
	            l: 'YYYY.MM.DD.',
	            ll: 'YYYY년 MMMM D일',
	            lll: 'YYYY년 MMMM D일 A h:mm',
	            llll: 'YYYY년 MMMM D일 dddd A h:mm',
	        },
	        calendar: {
	            sameDay: '오늘 LT',
	            nextDay: '내일 LT',
	            nextWeek: 'dddd LT',
	            lastDay: '어제 LT',
	            lastWeek: '지난주 dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s 후',
	            past: '%s 전',
	            s: '몇 초',
	            ss: '%d초',
	            m: '1분',
	            mm: '%d분',
	            h: '한 시간',
	            hh: '%d시간',
	            d: '하루',
	            dd: '%d일',
	            M: '한 달',
	            MM: '%d달',
	            y: '일 년',
	            yy: '%d년',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse: /오전|오후/,
	        isPM: function (token) {
	            return token === '오후';
	        },
	        meridiem: function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        },
	    });
	
	    return ko;
	
	})));


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kurdish [ku]
	//! author : Shahram Mebashar : https://github.com/ShahramMebashar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        months = [
	            'کانونی دووەم',
	            'شوبات',
	            'ئازار',
	            'نیسان',
	            'ئایار',
	            'حوزەیران',
	            'تەمموز',
	            'ئاب',
	            'ئەیلوول',
	            'تشرینی یەكەم',
	            'تشرینی دووەم',
	            'كانونی یەکەم',
	        ];
	
	    var ku = moment.defineLocale('ku', {
	        months: months,
	        monthsShort: months,
	        weekdays:
	            'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
	                '_'
	            ),
	        weekdaysShort:
	            'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
	        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ئێواره‌|به‌یانی/,
	        isPM: function (input) {
	            return /ئێواره‌/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'به‌یانی';
	            } else {
	                return 'ئێواره‌';
	            }
	        },
	        calendar: {
	            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
	            nextDay: '[به‌یانی كاتژمێر] LT',
	            nextWeek: 'dddd [كاتژمێر] LT',
	            lastDay: '[دوێنێ كاتژمێر] LT',
	            lastWeek: 'dddd [كاتژمێر] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'له‌ %s',
	            past: '%s',
	            s: 'چه‌ند چركه‌یه‌ك',
	            ss: 'چركه‌ %d',
	            m: 'یه‌ك خوله‌ك',
	            mm: '%d خوله‌ك',
	            h: 'یه‌ك كاتژمێر',
	            hh: '%d كاتژمێر',
	            d: 'یه‌ك ڕۆژ',
	            dd: '%d ڕۆژ',
	            M: 'یه‌ك مانگ',
	            MM: '%d مانگ',
	            y: 'یه‌ك ساڵ',
	            yy: '%d ساڵ',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ku;
	
	})));


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү',
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
	            '_'
	        ),
	        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
	            '_'
	        ),
	        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгүн саат] LT',
	            nextDay: '[Эртең саат] LT',
	            nextWeek: 'dddd [саат] LT',
	            lastDay: '[Кечээ саат] LT',
	            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ичинде',
	            past: '%s мурун',
	            s: 'бирнече секунд',
	            ss: '%d секунд',
	            m: 'бир мүнөт',
	            mm: '%d мүнөт',
	            h: 'бир саат',
	            hh: '%d саат',
	            d: 'бир күн',
	            dd: '%d күн',
	            M: 'бир ай',
	            MM: '%d ай',
	            y: 'бир жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ky;
	
	})));


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eng Minutt', 'enger Minutt'],
	            h: ['eng Stonn', 'enger Stonn'],
	            d: ['een Dag', 'engem Dag'],
	            M: ['ee Mount', 'engem Mount'],
	            y: ['ee Joer', 'engem Joer'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10,
	                firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            },
	        },
	        relativeTime: {
	            future: processFutureTime,
	            past: processPastTime,
	            s: 'e puer Sekonnen',
	            ss: '%d Sekonnen',
	            m: processRelativeTime,
	            mm: '%d Minutten',
	            h: processRelativeTime,
	            hh: '%d Stonnen',
	            d: processRelativeTime,
	            dd: '%d Deeg',
	            M: processRelativeTime,
	            MM: '%d Méint',
	            y: processRelativeTime,
	            yy: '%d Joer',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lb;
	
	})));


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var lo = moment.defineLocale('lo', {
	        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	                '_'
	            ),
	        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar: {
	            sameDay: '[ມື້ນີ້ເວລາ] LT',
	            nextDay: '[ມື້ອື່ນເວລາ] LT',
	            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ອີກ %s',
	            past: '%sຜ່ານມາ',
	            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss: '%d ວິນາທີ',
	            m: '1 ນາທີ',
	            mm: '%d ນາທີ',
	            h: '1 ຊົ່ວໂມງ',
	            hh: '%d ຊົ່ວໂມງ',
	            d: '1 ມື້',
	            dd: '%d ມື້',
	            M: '1 ເດືອນ',
	            MM: '%d ເດືອນ',
	            y: '1 ປີ',
	            yy: '%d ປີ',
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal: function (number) {
	            return 'ທີ່' + number;
	        },
	    });
	
	    return lo;
	
	})));


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundė_sekundžių_sekundes',
	        m: 'minutė_minutės_minutę',
	        mm: 'minutės_minučių_minutes',
	        h: 'valanda_valandos_valandą',
	        hh: 'valandos_valandų_valandas',
	        d: 'diena_dienos_dieną',
	        dd: 'dienos_dienų_dienas',
	        M: 'mėnuo_mėnesio_mėnesį',
	        MM: 'mėnesiai_mėnesių_mėnesius',
	        y: 'metai_metų_metus',
	        yy: 'metai_metų_metus',
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix
	            ? forms(key)[0]
	            : isFuture
	            ? forms(key)[1]
	            : forms(key)[2];
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return (
	                result + translateSingular(number, withoutSuffix, key[0], isFuture)
	            );
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months: {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
	                '_'
	            ),
	            standalone:
	                'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
	                    '_'
	                ),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
	        },
	        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays: {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
	                '_'
	            ),
	            standalone:
	                'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
	                    '_'
	                ),
	            isFormat: /dddd HH:mm/,
	        },
	        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY [m.] MMMM D [d.]',
	            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l: 'YYYY-MM-DD',
	            ll: 'YYYY [m.] MMMM D [d.]',
	            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
	        },
	        calendar: {
	            sameDay: '[Šiandien] LT',
	            nextDay: '[Rytoj] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[Vakar] LT',
	            lastWeek: '[Praėjusį] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'po %s',
	            past: 'prieš %s',
	            s: translateSeconds,
	            ss: translate,
	            m: translateSingular,
	            mm: translate,
	            h: translateSingular,
	            hh: translate,
	            d: translateSingular,
	            dd: translate,
	            M: translateSingular,
	            MM: translate,
	            y: translateSingular,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal: function (number) {
	            return number + '-oji';
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lt;
	
	})));


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        h: 'stundas_stundām_stunda_stundas'.split('_'),
	        hh: 'stundas_stundām_stunda_stundas'.split('_'),
	        d: 'dienas_dienām_diena_dienas'.split('_'),
	        dd: 'dienas_dienām_diena_dienas'.split('_'),
	        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        y: 'gada_gadiem_gads_gadi'.split('_'),
	        yy: 'gada_gadiem_gads_gadi'.split('_'),
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays:
	            'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
	                '_'
	            ),
	        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY.',
	            LL: 'YYYY. [gada] D. MMMM',
	            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
	        },
	        calendar: {
	            sameDay: '[Šodien pulksten] LT',
	            nextDay: '[Rīt pulksten] LT',
	            nextWeek: 'dddd [pulksten] LT',
	            lastDay: '[Vakar pulksten] LT',
	            lastWeek: '[Pagājušā] dddd [pulksten] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'pēc %s',
	            past: 'pirms %s',
	            s: relativeSeconds,
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithSingular,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithSingular,
	            hh: relativeTimeWithPlural,
	            d: relativeTimeWithSingular,
	            dd: relativeTimeWithPlural,
	            M: relativeTimeWithSingular,
	            MM: relativeTimeWithPlural,
	            y: relativeTimeWithSingular,
	            yy: relativeTimeWithPlural,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lv;
	
	})));


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                ? wordKey[1]
	                : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'dan',
	            dd: translator.translate,
	            M: 'mjesec',
	            MM: translator.translate,
	            y: 'godinu',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return me;
	
	})));


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
	            '_'
	        ),
	        monthsShort:
	            'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
	                '_'
	            ),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mi;
	
	})));


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	//! author : Sashko Todorov : https://github.com/bkyceh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mk = moment.defineLocale('mk', {
	        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Денес во] LT',
	            nextDay: '[Утре во] LT',
	            nextWeek: '[Во] dddd [во] LT',
	            lastDay: '[Вчера во] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пред %s',
	            s: 'неколку секунди',
	            ss: '%d секунди',
	            m: 'една минута',
	            mm: '%d минути',
	            h: 'еден час',
	            hh: '%d часа',
	            d: 'еден ден',
	            dd: '%d дена',
	            M: 'еден месец',
	            MM: '%d месеци',
	            y: 'една година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return mk;
	
	})));


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ml = moment.defineLocale('ml', {
	        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
	                '_'
	            ),
	        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm -നു',
	            LTS: 'A h:mm:ss -നു',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm -നു',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
	        },
	        calendar: {
	            sameDay: '[ഇന്ന്] LT',
	            nextDay: '[നാളെ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ഇന്നലെ] LT',
	            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s കഴിഞ്ഞ്',
	            past: '%s മുൻപ്',
	            s: 'അൽപ നിമിഷങ്ങൾ',
	            ss: '%d സെക്കൻഡ്',
	            m: 'ഒരു മിനിറ്റ്',
	            mm: '%d മിനിറ്റ്',
	            h: 'ഒരു മണിക്കൂർ',
	            hh: '%d മണിക്കൂർ',
	            d: 'ഒരു ദിവസം',
	            dd: '%d ദിവസം',
	            M: 'ഒരു മാസം',
	            MM: '%d മാസം',
	            y: 'ഒരു വർഷം',
	            yy: '%d വർഷം',
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        },
	    });
	
	    return ml;
	
	})));


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Mongolian [mn]
	//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    var mn = moment.defineLocale('mn', {
	        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
	            '_'
	        ),
	        monthsShort:
	            '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY оны MMMMын D',
	            LLL: 'YYYY оны MMMMын D HH:mm',
	            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM: function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar: {
	            sameDay: '[Өнөөдөр] LT',
	            nextDay: '[Маргааш] LT',
	            nextWeek: '[Ирэх] dddd LT',
	            lastDay: '[Өчигдөр] LT',
	            lastWeek: '[Өнгөрсөн] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s дараа',
	            past: '%s өмнө',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        },
	    });
	
	    return mn;
	
	})));


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंद';
	                    break;
	                case 'ss':
	                    output = '%d सेकंद';
	                    break;
	                case 'm':
	                    output = 'एक मिनिट';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटे';
	                    break;
	                case 'h':
	                    output = 'एक तास';
	                    break;
	                case 'hh':
	                    output = '%d तास';
	                    break;
	                case 'd':
	                    output = 'एक दिवस';
	                    break;
	                case 'dd':
	                    output = '%d दिवस';
	                    break;
	                case 'M':
	                    output = 'एक महिना';
	                    break;
	                case 'MM':
	                    output = '%d महिने';
	                    break;
	                case 'y':
	                    output = 'एक वर्ष';
	                    break;
	                case 'yy':
	                    output = '%d वर्षे';
	                    break;
	            }
	        } else {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंदां';
	                    break;
	                case 'ss':
	                    output = '%d सेकंदां';
	                    break;
	                case 'm':
	                    output = 'एका मिनिटा';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटां';
	                    break;
	                case 'h':
	                    output = 'एका तासा';
	                    break;
	                case 'hh':
	                    output = '%d तासां';
	                    break;
	                case 'd':
	                    output = 'एका दिवसा';
	                    break;
	                case 'dd':
	                    output = '%d दिवसां';
	                    break;
	                case 'M':
	                    output = 'एका महिन्या';
	                    break;
	                case 'MM':
	                    output = '%d महिन्यां';
	                    break;
	                case 'y':
	                    output = 'एका वर्षा';
	                    break;
	                case 'yy':
	                    output = '%d वर्षां';
	                    break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	            '_'
	        ),
	        monthsShort:
	            'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm वाजता',
	            LTS: 'A h:mm:ss वाजता',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm वाजता',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[उद्या] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr,
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
	                return hour;
	            } else if (
	                meridiem === 'दुपारी' ||
	                meridiem === 'सायंकाळी' ||
	                meridiem === 'रात्री'
	            ) {
	                return hour >= 12 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour >= 0 && hour < 6) {
	                return 'पहाटे';
	            } else if (hour < 12) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return mr;
	
	})));


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ms = moment.defineLocale('ms', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ms;
	
	})));


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var msMy = moment.defineLocale('ms-my', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return msMy;
	
	})));


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maltese (Malta) [mt]
	//! author : Alessandro Maruccia : https://github.com/alesma
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mt = moment.defineLocale('mt', {
	        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays:
	            'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
	                '_'
	            ),
	        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Illum fil-]LT',
	            nextDay: '[Għada fil-]LT',
	            nextWeek: 'dddd [fil-]LT',
	            lastDay: '[Il-bieraħ fil-]LT',
	            lastWeek: 'dddd [li għadda] [fil-]LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'f’ %s',
	            past: '%s ilu',
	            s: 'ftit sekondi',
	            ss: '%d sekondi',
	            m: 'minuta',
	            mm: '%d minuti',
	            h: 'siegħa',
	            hh: '%d siegħat',
	            d: 'ġurnata',
	            dd: '%d ġranet',
	            M: 'xahar',
	            MM: '%d xhur',
	            y: 'sena',
	            yy: '%d sni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mt;
	
	})));


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '၁',
	            2: '၂',
	            3: '၃',
	            4: '၄',
	            5: '၅',
	            6: '၆',
	            7: '၇',
	            8: '၈',
	            9: '၉',
	            0: '၀',
	        },
	        numberMap = {
	            '၁': '1',
	            '၂': '2',
	            '၃': '3',
	            '၄': '4',
	            '၅': '5',
	            '၆': '6',
	            '၇': '7',
	            '၈': '8',
	            '၉': '9',
	            '၀': '0',
	        };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
	            '_'
	        ),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
	            '_'
	        ),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss: '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်',
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return my;
	
	})));


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nb = moment.defineLocale('nb', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'noen sekunder',
	            ss: '%d sekunder',
	            m: 'ett minutt',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dager',
	            w: 'en uke',
	            ww: '%d uker',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nb;
	
	})));


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    var ne = moment.defineLocale('ne', {
	        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
	            '_'
	        ),
	        monthsShort:
	            'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
	            '_'
	        ),
	        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'Aको h:mm बजे',
	            LTS: 'Aको h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[भोलि] LT',
	            nextWeek: '[आउँदो] dddd[,] LT',
	            lastDay: '[हिजो] LT',
	            lastWeek: '[गएको] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमा',
	            past: '%s अगाडि',
	            s: 'केही क्षण',
	            ss: '%d सेकेण्ड',
	            m: 'एक मिनेट',
	            mm: '%d मिनेट',
	            h: 'एक घण्टा',
	            hh: '%d घण्टा',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महिना',
	            MM: '%d महिना',
	            y: 'एक बर्ष',
	            yy: '%d बर्ष',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ne;
	
	})));


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^maart|mrt.?$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex =
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex:
	            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays:
	            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            w: 'één week',
	            ww: '%d weken',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nl;
	
	})));


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^maart|mrt.?$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex =
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex:
	            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays:
	            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nlBe;
	
	})));


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! authors : https://github.com/mechuwind
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nn = moment.defineLocale('nn', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
	        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s sidan',
	            s: 'nokre sekund',
	            ss: '%d sekund',
	            m: 'eit minutt',
	            mm: '%d minutt',
	            h: 'ein time',
	            hh: '%d timar',
	            d: 'ein dag',
	            dd: '%d dagar',
	            w: 'ei veke',
	            ww: '%d veker',
	            M: 'ein månad',
	            MM: '%d månader',
	            y: 'eit år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nn;
	
	})));


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Occitan, lengadocian dialecte [oc-lnc]
	//! author : Quentin PAGÈS : https://github.com/Quenty31
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ocLnc = moment.defineLocale('oc-lnc', {
	        months: {
	            standalone:
	                'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
	                    '_'
	                ),
	            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort:
	            'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
	            '_'
	        ),
	        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: '[uèi a] LT',
	            nextDay: '[deman a] LT',
	            nextWeek: 'dddd [a] LT',
	            lastDay: '[ièr a] LT',
	            lastWeek: 'dddd [passat a] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'unas segondas',
	            ss: '%d segondas',
	            m: 'una minuta',
	            mm: '%d minutas',
	            h: 'una ora',
	            hh: '%d oras',
	            d: 'un jorn',
	            dd: '%d jorns',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                    ? 'n'
	                    : number === 3
	                    ? 'r'
	                    : number === 4
	                    ? 't'
	                    : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4,
	        },
	    });
	
	    return ocLnc;
	
	})));


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '੧',
	            2: '੨',
	            3: '੩',
	            4: '੪',
	            5: '੫',
	            6: '੬',
	            7: '੭',
	            8: '੮',
	            9: '੯',
	            0: '੦',
	        },
	        numberMap = {
	            '੧': '1',
	            '੨': '2',
	            '੩': '3',
	            '੪': '4',
	            '੫': '5',
	            '੬': '6',
	            '੭': '7',
	            '੮': '8',
	            '੯': '9',
	            '੦': '0',
	        };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
	        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	                '_'
	            ),
	        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm ਵਜੇ',
	            LTS: 'A h:mm:ss ਵਜੇ',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
	        },
	        calendar: {
	            sameDay: '[ਅਜ] LT',
	            nextDay: '[ਕਲ] LT',
	            nextWeek: '[ਅਗਲਾ] dddd, LT',
	            lastDay: '[ਕਲ] LT',
	            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ਵਿੱਚ',
	            past: '%s ਪਿਛਲੇ',
	            s: 'ਕੁਝ ਸਕਿੰਟ',
	            ss: '%d ਸਕਿੰਟ',
	            m: 'ਇਕ ਮਿੰਟ',
	            mm: '%d ਮਿੰਟ',
	            h: 'ਇੱਕ ਘੰਟਾ',
	            hh: '%d ਘੰਟੇ',
	            d: 'ਇੱਕ ਦਿਨ',
	            dd: '%d ਦਿਨ',
	            M: 'ਇੱਕ ਮਹੀਨਾ',
	            MM: '%d ਮਹੀਨੇ',
	            y: 'ਇੱਕ ਸਾਲ',
	            yy: '%d ਸਾਲ',
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return paIn;
	
	})));


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsNominative =
	            'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
	                '_'
	            ),
	        monthsSubjective =
	            'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
	                '_'
	            ),
	        monthsParse = [
	            /^sty/i,
	            /^lut/i,
	            /^mar/i,
	            /^kwi/i,
	            /^maj/i,
	            /^cze/i,
	            /^lip/i,
	            /^sie/i,
	            /^wrz/i,
	            /^paź/i,
	            /^lis/i,
	            /^gru/i,
	        ];
	    function plural(n) {
	        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix ? 'godzina' : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'ww':
	                return result + (plural(number) ? 'tygodnie' : 'tygodni');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays:
	            'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: '%s temu',
	            s: 'kilka sekund',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: '1 dzień',
	            dd: '%d dni',
	            w: 'tydzień',
	            ww: translate,
	            M: 'miesiąc',
	            MM: translate,
	            y: 'rok',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pl;
	
	})));


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pt = moment.defineLocale('pt', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays:
	            'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
	                '_'
	            ),
	        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            w: 'uma semana',
	            ww: '%d semanas',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pt;
	
	})));


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays:
	            'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
	                '_'
	            ),
	        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
	        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'poucos segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        invalidDate: 'Data inválida',
	    });
	
	    return ptBr;
	
	})));


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	//! author : Emanuel Cepoi : https://github.com/cepem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                ss: 'secunde',
	                mm: 'minute',
	                hh: 'ore',
	                dd: 'zile',
	                ww: 'săptămâni',
	                MM: 'luni',
	                yy: 'ani',
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
	            '_'
	        ),
	        monthsShort:
	            'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'peste %s',
	            past: '%s în urmă',
	            s: 'câteva secunde',
	            ss: relativeTimeWithPlural,
	            m: 'un minut',
	            mm: relativeTimeWithPlural,
	            h: 'o oră',
	            hh: relativeTimeWithPlural,
	            d: 'o zi',
	            dd: relativeTimeWithPlural,
	            w: 'o săptămână',
	            ww: relativeTimeWithPlural,
	            M: 'o lună',
	            MM: relativeTimeWithPlural,
	            y: 'un an',
	            yy: relativeTimeWithPlural,
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ro;
	
	})));


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            hh: 'час_часа_часов',
	            dd: 'день_дня_дней',
	            ww: 'неделя_недели_недель',
	            MM: 'месяц_месяца_месяцев',
	            yy: 'год_года_лет',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [
	        /^янв/i,
	        /^фев/i,
	        /^мар/i,
	        /^апр/i,
	        /^ма[йя]/i,
	        /^июн/i,
	        /^июл/i,
	        /^авг/i,
	        /^сен/i,
	        /^окт/i,
	        /^ноя/i,
	        /^дек/i,
	    ];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months: {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
	                '_'
	            ),
	            standalone:
	                'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	                    '_'
	                ),
	        },
	        monthsShort: {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
	                '_'
	            ),
	            standalone:
	                'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
	                    '_'
	                ),
	        },
	        weekdays: {
	            standalone:
	                'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
	                    '_'
	                ),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
	                '_'
	            ),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
	        },
	        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex:
	            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex:
	            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex:
	            /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соответствует только сокращённым формам
	        monthsShortStrictRegex:
	            /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., H:mm',
	            LLLL: 'dddd, D MMMM YYYY г., H:mm',
	        },
	        calendar: {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'через %s',
	            past: '%s назад',
	            s: 'несколько секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'час',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            w: 'неделя',
	            ww: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM: function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ru;
	
	})));


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوري',
	            'فيبروري',
	            'مارچ',
	            'اپريل',
	            'مئي',
	            'جون',
	            'جولاءِ',
	            'آگسٽ',
	            'سيپٽمبر',
	            'آڪٽوبر',
	            'نومبر',
	            'ڊسمبر',
	        ],
	        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];
	
	    var sd = moment.defineLocale('sd', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[اڄ] LT',
	            nextDay: '[سڀاڻي] LT',
	            nextWeek: 'dddd [اڳين هفتي تي] LT',
	            lastDay: '[ڪالهه] LT',
	            lastWeek: '[گزريل هفتي] dddd [تي] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s پوء',
	            past: '%s اڳ',
	            s: 'چند سيڪنڊ',
	            ss: '%d سيڪنڊ',
	            m: 'هڪ منٽ',
	            mm: '%d منٽ',
	            h: 'هڪ ڪلاڪ',
	            hh: '%d ڪلاڪ',
	            d: 'هڪ ڏينهن',
	            dd: '%d ڏينهن',
	            M: 'هڪ مهينو',
	            MM: '%d مهينا',
	            y: 'هڪ سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sd;
	
	})));


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var se = moment.defineLocale('se', {
	        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
	            '_'
	        ),
	        monthsShort:
	            'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	        weekdays:
	            'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
	                '_'
	            ),
	        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'MMMM D. [b.] YYYY',
	            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s geažes',
	            past: 'maŋit %s',
	            s: 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m: 'okta minuhta',
	            mm: '%d minuhtat',
	            h: 'okta diimmu',
	            hh: '%d diimmut',
	            d: 'okta beaivi',
	            dd: '%d beaivvit',
	            M: 'okta mánnu',
	            MM: '%d mánut',
	            y: 'okta jahki',
	            yy: '%d jagit',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return se;
	
	})));


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
	            '_'
	        ),
	        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
	            '_'
	        ),
	        weekdays:
	            'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
	                '_'
	            ),
	        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'a h:mm',
	            LTS: 'a h:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY MMMM D',
	            LLL: 'YYYY MMMM D, a h:mm',
	            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
	        },
	        calendar: {
	            sameDay: '[අද] LT[ට]',
	            nextDay: '[හෙට] LT[ට]',
	            nextWeek: 'dddd LT[ට]',
	            lastDay: '[ඊයේ] LT[ට]',
	            lastWeek: '[පසුගිය] dddd LT[ට]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sකින්',
	            past: '%sකට පෙර',
	            s: 'තත්පර කිහිපය',
	            ss: 'තත්පර %d',
	            m: 'මිනිත්තුව',
	            mm: 'මිනිත්තු %d',
	            h: 'පැය',
	            hh: 'පැය %d',
	            d: 'දිනය',
	            dd: 'දින %d',
	            M: 'මාසය',
	            MM: 'මාස %d',
	            y: 'වසර',
	            yy: 'වසර %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal: function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM: function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        },
	    });
	
	    return si;
	
	})));


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months =
	            'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
	                '_'
	            ),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return n > 1 && n < 5;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months: months,
	        monthsShort: monthsShort,
	        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pred %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sk;
	
	})));


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nekaj sekund'
	                    : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danes ob] LT',
	            nextDay: '[jutri ob] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay: '[včeraj ob] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'čez %s',
	            past: 'pred %s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sl;
	
	})));


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sq = moment.defineLocale('sq', {
	        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
	            '_'
	        ),
	        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Sot në] LT',
	            nextDay: '[Nesër në] LT',
	            nextWeek: 'dddd [në] LT',
	            lastDay: '[Dje në] LT',
	            lastWeek: 'dddd [e kaluar në] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'në %s',
	            past: '%s më parë',
	            s: 'disa sekonda',
	            ss: '%d sekonda',
	            m: 'një minutë',
	            mm: '%d minuta',
	            h: 'një orë',
	            hh: '%d orë',
	            d: 'një ditë',
	            dd: '%d ditë',
	            M: 'një muaj',
	            MM: '%d muaj',
	            y: 'një vit',
	            yy: '%d vite',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sq;
	
	})));


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            d: ['jedan dan', 'jednog dana'],
	            dd: ['dan', 'dana', 'dana'],
	            M: ['jedan mesec', 'jednog meseca'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            y: ['jednu godinu', 'jedne godine'],
	            yy: ['godinu', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            if (
	                number % 10 >= 1 &&
	                number % 10 <= 4 &&
	                (number % 100 < 10 || number % 100 >= 20)
	            ) {
	                return number % 10 === 1 ? wordKey[0] : wordKey[1];
	            }
	            return wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key, isFuture) {
	            var wordKey = translator.words[key],
	                word;
	
	            if (key.length === 1) {
	                // Nominativ
	                if (key === 'y' && withoutSuffix) return 'jedna godina';
	                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
	            }
	
	            word = translator.correctGrammaticalCase(number, wordKey);
	            // Nominativ
	            if (key === 'yy' && withoutSuffix && word === 'godinu') {
	                return number + ' godina';
	            }
	
	            return number + ' ' + word;
	        },
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pre %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: translator.translate,
	            dd: translator.translate,
	            M: translator.translate,
	            MM: translator.translate,
	            y: translator.translate,
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sr;
	
	})));


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једног минута'],
	            mm: ['минут', 'минута', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            d: ['један дан', 'једног дана'],
	            dd: ['дан', 'дана', 'дана'],
	            M: ['један месец', 'једног месеца'],
	            MM: ['месец', 'месеца', 'месеци'],
	            y: ['једну годину', 'једне године'],
	            yy: ['годину', 'године', 'година'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            if (
	                number % 10 >= 1 &&
	                number % 10 <= 4 &&
	                (number % 100 < 10 || number % 100 >= 20)
	            ) {
	                return number % 10 === 1 ? wordKey[0] : wordKey[1];
	            }
	            return wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key, isFuture) {
	            var wordKey = translator.words[key],
	                word;
	
	            if (key.length === 1) {
	                // Nominativ
	                if (key === 'y' && withoutSuffix) return 'једна година';
	                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
	            }
	
	            word = translator.correctGrammaticalCase(number, wordKey);
	            // Nominativ
	            if (key === 'yy' && withoutSuffix && word === 'годину') {
	                return number + ' година';
	            }
	
	            return number + ' ' + word;
	        },
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
	            '_'
	        ),
	        monthsShort:
	            'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay: '[јуче у] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пре %s',
	            s: 'неколико секунди',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: translator.translate,
	            dd: translator.translate,
	            M: translator.translate,
	            MM: translator.translate,
	            y: translator.translate,
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return srCyrl;
	
	})));


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ss = moment.defineLocale('ss', {
	        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
	            '_'
	        ),
	        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays:
	            'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
	                '_'
	            ),
	        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Namuhla nga] LT',
	            nextDay: '[Kusasa nga] LT',
	            nextWeek: 'dddd [nga] LT',
	            lastDay: '[Itolo nga] LT',
	            lastWeek: 'dddd [leliphelile] [nga] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'nga %s',
	            past: 'wenteka nga %s',
	            s: 'emizuzwana lomcane',
	            ss: '%d mzuzwana',
	            m: 'umzuzu',
	            mm: '%d emizuzu',
	            h: 'lihora',
	            hh: '%d emahora',
	            d: 'lilanga',
	            dd: '%d emalanga',
	            M: 'inyanga',
	            MM: '%d tinyanga',
	            y: 'umnyaka',
	            yy: '%d iminyaka',
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: '%d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ss;
	
	})));


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sv = moment.defineLocale('sv', {
	        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: 'för %s sedan',
	            s: 'några sekunder',
	            ss: '%d sekunder',
	            m: 'en minut',
	            mm: '%d minuter',
	            h: 'en timme',
	            hh: '%d timmar',
	            d: 'en dag',
	            dd: '%d dagar',
	            M: 'en månad',
	            MM: '%d månader',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? ':e'
	                        : b === 1
	                        ? ':a'
	                        : b === 2
	                        ? ':a'
	                        : b === 3
	                        ? ':e'
	                        : ':e';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sv;
	
	})));


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sw = moment.defineLocale('sw', {
	        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays:
	            'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
	                '_'
	            ),
	        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'hh:mm A',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[leo saa] LT',
	            nextDay: '[kesho saa] LT',
	            nextWeek: '[wiki ijayo] dddd [saat] LT',
	            lastDay: '[jana] LT',
	            lastWeek: '[wiki iliyopita] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s baadaye',
	            past: 'tokea %s',
	            s: 'hivi punde',
	            ss: 'sekunde %d',
	            m: 'dakika moja',
	            mm: 'dakika %d',
	            h: 'saa limoja',
	            hh: 'masaa %d',
	            d: 'siku moja',
	            dd: 'siku %d',
	            M: 'mwezi mmoja',
	            MM: 'miezi %d',
	            y: 'mwaka mmoja',
	            yy: 'miaka %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sw;
	
	})));


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '௧',
	            2: '௨',
	            3: '௩',
	            4: '௪',
	            5: '௫',
	            6: '௬',
	            7: '௭',
	            8: '௮',
	            9: '௯',
	            0: '௦',
	        },
	        numberMap = {
	            '௧': '1',
	            '௨': '2',
	            '௩': '3',
	            '௪': '4',
	            '௫': '5',
	            '௬': '6',
	            '௭': '7',
	            '௮': '8',
	            '௯': '9',
	            '௦': '0',
	        };
	
	    var ta = moment.defineLocale('ta', {
	        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	            '_'
	        ),
	        monthsShort:
	            'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	                '_'
	            ),
	        weekdays:
	            'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
	                '_'
	            ),
	        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
	            '_'
	        ),
	        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, HH:mm',
	            LLLL: 'dddd, D MMMM YYYY, HH:mm',
	        },
	        calendar: {
	            sameDay: '[இன்று] LT',
	            nextDay: '[நாளை] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[நேற்று] LT',
	            lastWeek: '[கடந்த வாரம்] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s இல்',
	            past: '%s முன்',
	            s: 'ஒரு சில விநாடிகள்',
	            ss: '%d விநாடிகள்',
	            m: 'ஒரு நிமிடம்',
	            mm: '%d நிமிடங்கள்',
	            h: 'ஒரு மணி நேரம்',
	            hh: '%d மணி நேரம்',
	            d: 'ஒரு நாள்',
	            dd: '%d நாட்கள்',
	            M: 'ஒரு மாதம்',
	            MM: '%d மாதங்கள்',
	            y: 'ஒரு வருடம்',
	            yy: '%d ஆண்டுகள்',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal: function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை'; // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ta;
	
	})));


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var te = moment.defineLocale('te', {
	        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
	            '_'
	        ),
	        monthsShort:
	            'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
	                '_'
	            ),
	        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[నేడు] LT',
	            nextDay: '[రేపు] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[నిన్న] LT',
	            lastWeek: '[గత] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s లో',
	            past: '%s క్రితం',
	            s: 'కొన్ని క్షణాలు',
	            ss: '%d సెకన్లు',
	            m: 'ఒక నిమిషం',
	            mm: '%d నిమిషాలు',
	            h: 'ఒక గంట',
	            hh: '%d గంటలు',
	            d: 'ఒక రోజు',
	            dd: '%d రోజులు',
	            M: 'ఒక నెల',
	            MM: '%d నెలలు',
	            y: 'ఒక సంవత్సరం',
	            yy: '%d సంవత్సరాలు',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}వ/,
	        ordinal: '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return te;
	
	})));


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	//! author : Sonia Simoes : https://github.com/soniasimoes
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tet = moment.defineLocale('tet', {
	        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'iha %s',
	            past: '%s liuba',
	            s: 'segundu balun',
	            ss: 'segundu %d',
	            m: 'minutu ida',
	            mm: 'minutu %d',
	            h: 'oras ida',
	            hh: 'oras %d',
	            d: 'loron ida',
	            dd: 'loron %d',
	            M: 'fulan ida',
	            MM: 'fulan %d',
	            y: 'tinan ida',
	            yy: 'tinan %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tet;
	
	})));


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tajik [tg]
	//! author : Orif N. Jr. : https://github.com/orif-jr
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум',
	    };
	
	    var tg = moment.defineLocale('tg', {
	        months: {
	            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
	                '_'
	            ),
	            standalone:
	                'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
	            '_'
	        ),
	        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Имрӯз соати] LT',
	            nextDay: '[Фардо соати] LT',
	            lastDay: '[Дирӯз соати] LT',
	            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'баъди %s',
	            past: '%s пеш',
	            s: 'якчанд сония',
	            m: 'як дақиқа',
	            mm: '%d дақиқа',
	            h: 'як соат',
	            hh: '%d соат',
	            d: 'як рӯз',
	            dd: '%d рӯз',
	            M: 'як моҳ',
	            MM: '%d моҳ',
	            y: 'як сол',
	            yy: '%d сол',
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1th is the first week of the year.
	        },
	    });
	
	    return tg;
	
	})));


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var th = moment.defineLocale('th', {
	        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
	            '_'
	        ),
	        monthsShort:
	            'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY เวลา H:mm',
	            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar: {
	            sameDay: '[วันนี้ เวลา] LT',
	            nextDay: '[พรุ่งนี้ เวลา] LT',
	            nextWeek: 'dddd[หน้า เวลา] LT',
	            lastDay: '[เมื่อวานนี้ เวลา] LT',
	            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'อีก %s',
	            past: '%sที่แล้ว',
	            s: 'ไม่กี่วินาที',
	            ss: '%d วินาที',
	            m: '1 นาที',
	            mm: '%d นาที',
	            h: '1 ชั่วโมง',
	            hh: '%d ชั่วโมง',
	            d: '1 วัน',
	            dd: '%d วัน',
	            w: '1 สัปดาห์',
	            ww: '%d สัปดาห์',
	            M: '1 เดือน',
	            MM: '%d เดือน',
	            y: '1 ปี',
	            yy: '%d ปี',
	        },
	    });
	
	    return th;
	
	})));


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkmen [tk]
	//! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inji",
	        5: "'inji",
	        8: "'inji",
	        70: "'inji",
	        80: "'inji",
	        2: "'nji",
	        7: "'nji",
	        20: "'nji",
	        50: "'nji",
	        3: "'ünji",
	        4: "'ünji",
	        100: "'ünji",
	        6: "'njy",
	        9: "'unjy",
	        10: "'unjy",
	        30: "'unjy",
	        60: "'ynjy",
	        90: "'ynjy",
	    };
	
	    var tk = moment.defineLocale('tk', {
	        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
	        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
	            '_'
	        ),
	        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
	        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün sagat] LT',
	            nextDay: '[ertir sagat] LT',
	            nextWeek: '[indiki] dddd [sagat] LT',
	            lastDay: '[düýn] LT',
	            lastWeek: '[geçen] dddd [sagat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s soň',
	            past: '%s öň',
	            s: 'birnäçe sekunt',
	            m: 'bir minut',
	            mm: '%d minut',
	            h: 'bir sagat',
	            hh: '%d sagat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir aý',
	            MM: '%d aý',
	            y: 'bir ýyl',
	            yy: '%d ýyl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'unjy";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tk;
	
	})));


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tlPh = moment.defineLocale('tl-ph', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlPh;
	
	})));


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'leS'
	                : output.indexOf('jar') !== -1
	                ? time.slice(0, -3) + 'waQ'
	                : output.indexOf('DIS') !== -1
	                ? time.slice(0, -3) + 'nem'
	                : time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'Hu’'
	                : output.indexOf('jar') !== -1
	                ? time.slice(0, -3) + 'wen'
	                : output.indexOf('DIS') !== -1
	                ? time.slice(0, -3) + 'ben'
	                : time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	            ten = Math.floor((number % 100) / 10),
	            one = number % 10,
	            word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[one];
	        }
	        return word === '' ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
	            '_'
	        ),
	        monthsShort:
	            'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        weekdaysShort:
	            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysMin:
	            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: translateFuture,
	            past: translatePast,
	            s: 'puS lup',
	            ss: translate,
	            m: 'wa’ tup',
	            mm: translate,
	            h: 'wa’ rep',
	            hh: translate,
	            d: 'wa’ jaj',
	            dd: translate,
	            M: 'wa’ jar',
	            MM: translate,
	            y: 'wa’ DIS',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlh;
	
	})));


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inci",
	        5: "'inci",
	        8: "'inci",
	        70: "'inci",
	        80: "'inci",
	        2: "'nci",
	        7: "'nci",
	        20: "'nci",
	        50: "'nci",
	        3: "'üncü",
	        4: "'üncü",
	        100: "'üncü",
	        6: "'ncı",
	        9: "'uncu",
	        10: "'uncu",
	        30: "'uncu",
	        60: "'ıncı",
	        90: "'ıncı",
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
	            '_'
	        ),
	        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
	            '_'
	        ),
	        weekdaysShort: 'Paz_Pzt_Sal_Çar_Per_Cum_Cmt'.split('_'),
	        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'öö' : 'ÖÖ';
	            } else {
	                return isLower ? 'ös' : 'ÖS';
	            }
	        },
	        meridiemParse: /öö|ÖÖ|ös|ÖS/,
	        isPM: function (input) {
	            return input === 'ös' || input === 'ÖS';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[yarın saat] LT',
	            nextWeek: '[gelecek] dddd [saat] LT',
	            lastDay: '[dün] LT',
	            lastWeek: '[geçen] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s önce',
	            s: 'birkaç saniye',
	            ss: '%d saniye',
	            m: 'bir dakika',
	            mm: '%d dakika',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            w: 'bir hafta',
	            ww: '%d hafta',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir yıl',
	            yy: '%d yıl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'ıncı";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tr;
	
	})));


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM [dallas] YYYY',
	            LLL: 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM: function (input) {
	            return "d'o" === input.toLowerCase();
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? "d'o" : "D'O";
	            } else {
	                return isLower ? "d'a" : "D'A";
	            }
	        },
	        calendar: {
	            sameDay: '[oxhi à] LT',
	            nextDay: '[demà à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[ieiri à] LT',
	            lastWeek: '[sür el] dddd [lasteu à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'osprei %s',
	            past: 'ja%s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['viensas secunds', "'iensas secunds"],
	            ss: [number + ' secunds', '' + number + ' secunds'],
	            m: ["'n míut", "'iens míut"],
	            mm: [number + ' míuts', '' + number + ' míuts'],
	            h: ["'n þora", "'iensa þora"],
	            hh: [number + ' þoras', '' + number + ' þoras'],
	            d: ["'n ziua", "'iensa ziua"],
	            dd: [number + ' ziuas', '' + number + ' ziuas'],
	            M: ["'n mes", "'iens mes"],
	            MM: [number + ' mesen', '' + number + ' mesen'],
	            y: ["'n ar", "'iens ar"],
	            yy: [number + ' ars', '' + number + ' ars'],
	        };
	        return isFuture
	            ? format[key][0]
	            : withoutSuffix
	            ? format[key][0]
	            : format[key][1];
	    }
	
	    return tzl;
	
	})));


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzm = moment.defineLocale('tzm', {
	        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	                '_'
	            ),
	        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past: 'ⵢⴰⵏ %s',
	            s: 'ⵉⵎⵉⴽ',
	            ss: '%d ⵉⵎⵉⴽ',
	            m: 'ⵎⵉⵏⵓⴺ',
	            mm: '%d ⵎⵉⵏⵓⴺ',
	            h: 'ⵙⴰⵄⴰ',
	            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d: 'ⴰⵙⵙ',
	            dd: '%d oⵙⵙⴰⵏ',
	            M: 'ⴰⵢoⵓⵔ',
	            MM: '%d ⵉⵢⵢⵉⵔⵏ',
	            y: 'ⴰⵙⴳⴰⵙ',
	            yy: '%d ⵉⵙⴳⴰⵙⵏ',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzm;
	
	})));


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	            '_'
	        ),
	        monthsShort:
	            'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	                '_'
	            ),
	        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dadkh s yan %s',
	            past: 'yan %s',
	            s: 'imik',
	            ss: '%d imik',
	            m: 'minuḍ',
	            mm: '%d minuḍ',
	            h: 'saɛa',
	            hh: '%d tassaɛin',
	            d: 'ass',
	            dd: '%d ossan',
	            M: 'ayowr',
	            MM: '%d iyyirn',
	            y: 'asgas',
	            yy: '%d isgasn',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzmLatn;
	
	})));


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uyghur (China) [ug-cn]
	//! author: boyaq : https://github.com/boyaq
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	                '_'
	            ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل',
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return ugCn;
	
	})));


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            dd: 'день_дні_днів',
	            MM: 'місяць_місяці_місяців',
	            yy: 'рік_роки_років',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	                nominative:
	                    'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
	                        '_'
	                    ),
	                accusative:
	                    'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
	                        '_'
	                    ),
	                genitive:
	                    'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
	                        '_'
	                    ),
	            },
	            nounCase;
	
	        if (m === true) {
	            return weekdays['nominative']
	                .slice(1, 7)
	                .concat(weekdays['nominative'].slice(0, 1));
	        }
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
	            ? 'accusative'
	            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
	            ? 'genitive'
	            : 'nominative';
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months: {
	            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
	                '_'
	            ),
	            standalone:
	                'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
	            '_'
	        ),
	        weekdays: weekdaysCaseReplace,
	        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY р.',
	            LLL: 'D MMMM YYYY р., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
	        },
	        calendar: {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: '%s тому',
	            s: 'декілька секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'годину',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            M: 'місяць',
	            MM: relativeTimeWithPlural,
	            y: 'рік',
	            yy: relativeTimeWithPlural,
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uk;
	
	})));


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوری',
	            'فروری',
	            'مارچ',
	            'اپریل',
	            'مئی',
	            'جون',
	            'جولائی',
	            'اگست',
	            'ستمبر',
	            'اکتوبر',
	            'نومبر',
	            'دسمبر',
	        ],
	        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];
	
	    var ur = moment.defineLocale('ur', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[آج بوقت] LT',
	            nextDay: '[کل بوقت] LT',
	            nextWeek: 'dddd [بوقت] LT',
	            lastDay: '[گذشتہ روز بوقت] LT',
	            lastWeek: '[گذشتہ] dddd [بوقت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s بعد',
	            past: '%s قبل',
	            s: 'چند سیکنڈ',
	            ss: '%d سیکنڈ',
	            m: 'ایک منٹ',
	            mm: '%d منٹ',
	            h: 'ایک گھنٹہ',
	            hh: '%d گھنٹے',
	            d: 'ایک دن',
	            dd: '%d دن',
	            M: 'ایک ماہ',
	            MM: '%d ماہ',
	            y: 'ایک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ur;
	
	})));


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uz = moment.defineLocale('uz', {
	        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бугун соат] LT [да]',
	            nextDay: '[Эртага] LT [да]',
	            nextWeek: 'dddd [куни соат] LT [да]',
	            lastDay: '[Кеча соат] LT [да]',
	            lastWeek: '[Утган] dddd [куни соат] LT [да]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Якин %s ичида',
	            past: 'Бир неча %s олдин',
	            s: 'фурсат',
	            ss: '%d фурсат',
	            m: 'бир дакика',
	            mm: '%d дакика',
	            h: 'бир соат',
	            hh: '%d соат',
	            d: 'бир кун',
	            dd: '%d кун',
	            M: 'бир ой',
	            MM: '%d ой',
	            y: 'бир йил',
	            yy: '%d йил',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return uz;
	
	})));


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays:
	            'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
	                '_'
	            ),
	        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bugun soat] LT [da]',
	            nextDay: '[Ertaga] LT [da]',
	            nextWeek: 'dddd [kuni soat] LT [da]',
	            lastDay: '[Kecha soat] LT [da]',
	            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Yaqin %s ichida',
	            past: 'Bir necha %s oldin',
	            s: 'soniya',
	            ss: '%d soniya',
	            m: 'bir daqiqa',
	            mm: '%d daqiqa',
	            h: 'bir soat',
	            hh: '%d soat',
	            d: 'bir kun',
	            dd: '%d kun',
	            M: 'bir oy',
	            MM: '%d oy',
	            y: 'bir yil',
	            yy: '%d yil',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uzLatn;
	
	})));


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	//! author : Chien Kira : https://github.com/chienkira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var vi = moment.defineLocale('vi', {
	        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
	            '_'
	        ),
	        monthsShort:
	            'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
	            '_'
	        ),
	        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /sa|ch/i,
	        isPM: function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [năm] YYYY',
	            LLL: 'D MMMM [năm] YYYY HH:mm',
	            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
	            l: 'DD/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần trước lúc] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s tới',
	            past: '%s trước',
	            s: 'vài giây',
	            ss: '%d giây',
	            m: 'một phút',
	            mm: '%d phút',
	            h: 'một giờ',
	            hh: '%d giờ',
	            d: 'một ngày',
	            dd: '%d ngày',
	            w: 'một tuần',
	            ww: '%d tuần',
	            M: 'một tháng',
	            MM: '%d tháng',
	            y: 'một năm',
	            yy: '%d năm',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return vi;
	
	})));


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
	            '_'
	        ),
	        monthsShort:
	            'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
	                '_'
	            ),
	        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[T~ódá~ý át] LT',
	            nextDay: '[T~ómó~rró~w át] LT',
	            nextWeek: 'dddd [át] LT',
	            lastDay: '[Ý~ést~érdá~ý át] LT',
	            lastWeek: '[L~ást] dddd [át] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'í~ñ %s',
	            past: '%s á~gó',
	            s: 'á ~féw ~sécó~ñds',
	            ss: '%d s~écóñ~ds',
	            m: 'á ~míñ~úté',
	            mm: '%d m~íñú~tés',
	            h: 'á~ñ hó~úr',
	            hh: '%d h~óúrs',
	            d: 'á ~dáý',
	            dd: '%d d~áýs',
	            M: 'á ~móñ~th',
	            MM: '%d m~óñt~hs',
	            y: 'á ~ýéár',
	            yy: '%d ý~éárs',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return xPseudo;
	
	})));


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var yo = moment.defineLocale('yo', {
	        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
	            '_'
	        ),
	        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Ònì ni] LT',
	            nextDay: '[Ọ̀la ni] LT',
	            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
	            lastDay: '[Àna ni] LT',
	            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ní %s',
	            past: '%s kọjá',
	            s: 'ìsẹjú aayá die',
	            ss: 'aayá %d',
	            m: 'ìsẹjú kan',
	            mm: 'ìsẹjú %d',
	            h: 'wákati kan',
	            hh: 'wákati %d',
	            d: 'ọjọ́ kan',
	            dd: 'ọjọ́ %d',
	            M: 'osù kan',
	            MM: 'osù %d',
	            y: 'ọdún kan',
	            yy: 'ọdún %d',
	        },
	        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
	        ordinal: 'ọjọ́ %d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return yo;
	
	})));


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	//! author : uu109 : https://github.com/uu109
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日Ah点mm分',
	            LLLL: 'YYYY年M月D日ddddAh点mm分',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[下]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            lastDay: '[昨天]LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[上]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s后',
	            past: '%s前',
	            s: '几秒',
	            ss: '%d 秒',
	            m: '1 分钟',
	            mm: '%d 分钟',
	            h: '1 小时',
	            hh: '%d 小时',
	            d: '1 天',
	            dd: '%d 天',
	            w: '1 周',
	            ww: '%d 周',
	            M: '1 个月',
	            MM: '%d 个月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return zhCn;
	
	})));


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	//! author : Anthony : https://github.com/anthonylau
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhHk = moment.defineLocale('zh-hk', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1200) {
	                return '上午';
	            } else if (hm === 1200) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: '[下]ddddLT',
	            lastDay: '[昨天]LT',
	            lastWeek: '[上]ddddLT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhHk;
	
	})));


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Macau) [zh-mo]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Tan Yuanhong : https://github.com/le0tan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhMo = moment.defineLocale('zh-mo', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s內',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhMo;
	
	})));


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(435)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhTw = moment.defineLocale('zh-tw', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhTw;
	
	})));


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var http_1 = __webpack_require__(382);
	var Subject_1 = __webpack_require__(37);
	__webpack_require__(374);
	var myGlobals = __webpack_require__(414);
	var moment = __webpack_require__(435);
	var RegAlarmaService = (function () {
	    function RegAlarmaService(http) {
	        this.http = http;
	        this.regAlarmaUrl = myGlobals.default.BASE_URL + '/regAlarma/'; // URL to web api
	        // Observable string sources
	        this.notificaciones = new Subject_1.Subject();
	        // Observable string streams
	        this.notificaciones$ = this.notificaciones.asObservable();
	    }
	    //Obtener todos los regAlarmas
	    RegAlarmaService.prototype.getRegAlarmas = function () {
	        return this.http.get(this.regAlarmaUrl)
	            .map(function (response) { return response.json(); });
	    };
	    //Obtener un regAlarma por sensor
	    RegAlarmaService.prototype.getRegAlarmaActivadasPorSensor = function (_idSensor) {
	        return this.http.get(this.regAlarmaUrl + _idSensor)
	            .map(function (response) { return response.json(); });
	    };
	    //Obtener un regAlarma por sensor
	    RegAlarmaService.prototype.getRegAlarmaActivadasPorNodo = function (_idNodo) {
	        return this.http.get(this.regAlarmaUrl + _idNodo + "/nodo")
	            .map(function (response) { return response.json(); });
	    };
	    //Obtener regAlarmas by sensor y fechas
	    RegAlarmaService.prototype.getRegAlarmasBySensorYFecha = function (_id, fechaDesde, fechaHasta, offset) {
	        if (!offset)
	            offset = "-03:00";
	        var fechaDesdeStr = moment(fechaDesde).utcOffset(offset).startOf("day").format();
	        var fechaHastaStr = moment(fechaHasta).utcOffset(offset).endOf('day').format();
	        return this.http.get(this.regAlarmaUrl + _id + "/" + fechaDesdeStr + "/" + fechaHastaStr)
	            .map(function (response) { return response.json(); });
	    };
	    //Obtener regAlarmas by sensor y fechas
	    RegAlarmaService.prototype.getRegAlarmasByNodoYFecha = function (_id, fechaDesde, fechaHasta, offset) {
	        if (!offset)
	            offset = "-03:00";
	        var fechaDesdeStr = moment(fechaDesde).utcOffset(offset).startOf("day").format();
	        var fechaHastaStr = moment(fechaHasta).utcOffset(offset).endOf('day').format();
	        return this.http.get(this.regAlarmaUrl + _id + "/" + fechaDesdeStr + "/" + fechaHastaStr + "/nodo")
	            .map(function (response) { return response.json(); });
	    };
	    //Obtener regAlarmas activadas
	    RegAlarmaService.prototype.getAllRegAlarmasActivadas = function () {
	        var _this = this;
	        return this.http.get(this.regAlarmaUrl + "todo/todo")
	            .map(function (response) {
	            _this.notificaciones.next(response.json());
	            return response.json();
	        });
	    };
	    RegAlarmaService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
	    ], RegAlarmaService);
	    return RegAlarmaService;
	    var _a;
	}());
	exports.RegAlarmaService = RegAlarmaService;


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var http_1 = __webpack_require__(382);
	__webpack_require__(374);
	var myGlobals = __webpack_require__(414);
	var UbicacionService = (function () {
	    function UbicacionService(http) {
	        this.http = http;
	        this.ubicacionUrl = myGlobals.default.BASE_URL + '/ubicacion/'; // URL to web api
	    }
	    //Obtener todas las ubicacions
	    UbicacionService.prototype.getUbicaciones = function () {
	        return this.http.get(this.ubicacionUrl)
	            .map(function (response) { return response.json(); });
	    };
	    //Obtener una ubicacion
	    UbicacionService.prototype.getUbicacion = function (_id) {
	        return this.http.get(this.ubicacionUrl + _id)
	            .map(function (response) { return response.json(); });
	    };
	    UbicacionService.prototype.save = function (ubicacion) {
	        if (ubicacion._id) {
	            return this.put(ubicacion);
	        }
	        //Seteo estado activo
	        ubicacion.estado = true;
	        return this.post(ubicacion);
	    };
	    //Desactivar ubicacion
	    UbicacionService.prototype.delete = function (ubicacion) {
	        var headers = new http_1.Headers();
	        headers.append('Content-Type', 'application/json');
	        var url = this.ubicacionUrl + "/" + ubicacion._id;
	        return this.http
	            .delete(url, { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    // Agregar nueva ubicacion
	    UbicacionService.prototype.post = function (ubicacion) {
	        var headers = new http_1.Headers({
	            'Content-Type': 'application/json;charset=UTF-8'
	        });
	        headers.append('dataType', 'json');
	        console.log(JSON.stringify(ubicacion));
	        var ubicacionStr = JSON.stringify(ubicacion);
	        return this.http
	            .post(this.ubicacionUrl, ubicacionStr, { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    // Actualizar ubicacion
	    UbicacionService.prototype.put = function (ubicacion) {
	        var headers = new http_1.Headers();
	        headers.append('Content-Type', 'application/json');
	        var url = this.ubicacionUrl + "/" + ubicacion._id;
	        return this.http
	            .put(url, JSON.stringify(ubicacion), { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    UbicacionService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
	    ], UbicacionService);
	    return UbicacionService;
	    var _a;
	}());
	exports.UbicacionService = UbicacionService;


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var http_1 = __webpack_require__(382);
	__webpack_require__(374);
	var myGlobals = __webpack_require__(414);
	var GatewayService = (function () {
	    function GatewayService(http) {
	        this.http = http;
	        this.gatewayUrl = myGlobals.default.BASE_URL + '/gateway/'; // URL to web api
	    }
	    //Obtener todos los gateways habilitados para el usuario
	    GatewayService.prototype.getGateways = function () {
	        return this.http.get(this.gatewayUrl)
	            .map(function (response) { return response.json(); });
	    };
	    //Obtener un gateway
	    GatewayService.prototype.getGateway = function (_id) {
	        return this.http.get(this.gatewayUrl + _id)
	            .map(function (response) { return response.json(); });
	    };
	    //Obtener gateways by sucursal
	    GatewayService.prototype.getGatewaysBySucursal = function (_id) {
	        return this.http.get(this.gatewayUrl + "sucursal/" + _id)
	            .map(function (response) { return response.json(); });
	    };
	    GatewayService.prototype.save = function (gateway) {
	        if (gateway._id) {
	            return this.put(gateway);
	        }
	        //Seteo estado activo
	        gateway.estado = true;
	        return this.post(gateway);
	    };
	    //Desactivar gateway
	    GatewayService.prototype.delete = function (gateway) {
	        var headers = new http_1.Headers();
	        headers.append('Content-Type', 'application/json');
	        var url = this.gatewayUrl + "/" + gateway._id;
	        return this.http
	            .delete(url, { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    // Agregar nuevo gateway
	    GatewayService.prototype.post = function (gateway) {
	        var headers = new http_1.Headers({
	            'Content-Type': 'application/json;charset=UTF-8'
	        });
	        headers.append('dataType', 'json');
	        console.log(gateway);
	        console.log(JSON.stringify(gateway));
	        var gatewayStr = JSON.stringify(gateway);
	        return this.http
	            .post(this.gatewayUrl, gatewayStr, { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    // Actualizar gateway
	    GatewayService.prototype.put = function (gateway) {
	        var headers = new http_1.Headers();
	        headers.append('Content-Type', 'application/json');
	        var url = this.gatewayUrl + "/" + gateway._id;
	        return this.http
	            .put(url, JSON.stringify(gateway), { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    GatewayService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
	    ], GatewayService);
	    return GatewayService;
	    var _a;
	}());
	exports.GatewayService = GatewayService;


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var http_1 = __webpack_require__(382);
	__webpack_require__(374);
	var myGlobals = __webpack_require__(414);
	var SensorService = (function () {
	    function SensorService(http) {
	        this.http = http;
	        this.sensorUrl = myGlobals.default.BASE_URL + '/sensor/'; // URL to web api
	    }
	    //Obtener todos los sensors habilitados para el usuario
	    SensorService.prototype.getSensores = function () {
	        return this.http.get(this.sensorUrl)
	            .map(function (response) { return response.json(); });
	    };
	    //Obtener un sensor
	    SensorService.prototype.getSensor = function (_id) {
	        return this.http.get(this.sensorUrl + _id)
	            .map(function (response) { return response.json(); });
	    };
	    //Obtener sensors by sucursal
	    SensorService.prototype.getSensoresBySucursal = function (_id) {
	        return this.http.get(this.sensorUrl + "sucursal/" + _id)
	            .map(function (response) { return response.json(); });
	    };
	    SensorService.prototype.save = function (sensor) {
	        if (sensor._id) {
	            return this.put(sensor);
	        }
	        //Seteo estado activo
	        sensor.estado = true;
	        return this.post(sensor);
	    };
	    //Desactivar sensor
	    SensorService.prototype.deleteSolo = function (sensor) {
	        var headers = new http_1.Headers();
	        headers.append('Content-Type', 'application/json');
	        var url = this.sensorUrl + "/" + sensor._id;
	        return this.http
	            .delete(url, { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    //Desactivar sensor con body
	    SensorService.prototype.delete = function (sensor) {
	        var headers = new http_1.Headers();
	        headers.append('Content-Type', 'application/json');
	        var url = this.sensorUrl + "/" + sensor._id;
	        return this.http
	            .delete(url, { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    // Agregar nuevo sensor
	    SensorService.prototype.post = function (sensor) {
	        var headers = new http_1.Headers({
	            'Content-Type': 'application/json;charset=UTF-8'
	        });
	        headers.append('dataType', 'json');
	        var sensorStr = JSON.stringify(sensor);
	        return this.http
	            .post(this.sensorUrl, sensorStr, { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    // Actualizar sensor
	    SensorService.prototype.put = function (sensor) {
	        var headers = new http_1.Headers();
	        headers.append('Content-Type', 'application/json');
	        var url = this.sensorUrl + "/" + sensor._id;
	        return this.http
	            .put(url, JSON.stringify(sensor), { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    SensorService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
	    ], SensorService);
	    return SensorService;
	    var _a;
	}());
	exports.SensorService = SensorService;


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var http_1 = __webpack_require__(382);
	__webpack_require__(374);
	var myGlobals = __webpack_require__(414);
	var TipoSensorService = (function () {
	    function TipoSensorService(http) {
	        this.http = http;
	        this.tipoSensorUrl = myGlobals.default.BASE_URL + '/tipoSensor/'; // URL to web api
	    }
	    //Obtener todos los tipoSensors habilitados para el usuario
	    TipoSensorService.prototype.getTipoSensores = function () {
	        return this.http.get(this.tipoSensorUrl)
	            .map(function (response) { return response.json(); });
	    };
	    //Obtener un tipoSensor
	    TipoSensorService.prototype.getTipoSensor = function (_id) {
	        return this.http.get(this.tipoSensorUrl + _id)
	            .map(function (response) { return response.json(); });
	    };
	    //Obtener tipoSensors by sucursal
	    TipoSensorService.prototype.getTipoSensoresBySucursal = function (_id) {
	        return this.http.get(this.tipoSensorUrl + "sucursal/" + _id)
	            .map(function (response) { return response.json(); });
	    };
	    TipoSensorService.prototype.save = function (tipoSensor) {
	        if (tipoSensor._id) {
	            return this.put(tipoSensor);
	        }
	        //Seteo estado activo
	        tipoSensor.estado = true;
	        return this.post(tipoSensor);
	    };
	    //Desactivar tipoSensor
	    TipoSensorService.prototype.delete = function (tipoSensor) {
	        var headers = new http_1.Headers();
	        headers.append('Content-Type', 'application/json');
	        var url = this.tipoSensorUrl + "/" + tipoSensor._id;
	        return this.http
	            .delete(url, { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    // Agregar nuevo tipoSensor
	    TipoSensorService.prototype.post = function (tipoSensor) {
	        var headers = new http_1.Headers({
	            'Content-Type': 'application/json;charset=UTF-8'
	        });
	        headers.append('dataType', 'json');
	        console.log(tipoSensor);
	        console.log(JSON.stringify(tipoSensor));
	        var tipoSensorStr = JSON.stringify(tipoSensor);
	        return this.http
	            .post(this.tipoSensorUrl, tipoSensorStr, { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    // Actualizar tipoSensor
	    TipoSensorService.prototype.put = function (tipoSensor) {
	        var headers = new http_1.Headers();
	        headers.append('Content-Type', 'application/json');
	        var url = this.tipoSensorUrl + "/" + tipoSensor._id;
	        return this.http
	            .put(url, JSON.stringify(tipoSensor), { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    TipoSensorService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
	    ], TipoSensorService);
	    return TipoSensorService;
	    var _a;
	}());
	exports.TipoSensorService = TipoSensorService;


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var http_1 = __webpack_require__(382);
	__webpack_require__(374);
	var myGlobals = __webpack_require__(414);
	var TipoBateriaService = (function () {
	    function TipoBateriaService(http) {
	        this.http = http;
	        this.tipoBateriaUrl = myGlobals.default.BASE_URL + '/tipoBateria/'; // URL to web api
	    }
	    //Obtener todos los tipoBaterias habilitados para el usuario
	    TipoBateriaService.prototype.getTipoBaterias = function () {
	        return this.http.get(this.tipoBateriaUrl)
	            .map(function (response) { return response.json(); });
	    };
	    //Obtener un tipoBateria
	    TipoBateriaService.prototype.getTipoBateria = function (_id) {
	        return this.http.get(this.tipoBateriaUrl + _id)
	            .map(function (response) { return response.json(); });
	    };
	    TipoBateriaService.prototype.save = function (tipoBateria) {
	        if (tipoBateria._id) {
	            return this.put(tipoBateria);
	        }
	        //Seteo estado activo
	        tipoBateria.estado = true;
	        return this.post(tipoBateria);
	    };
	    //Desactivar tipoBateria
	    TipoBateriaService.prototype.delete = function (tipoBateria) {
	        var headers = new http_1.Headers();
	        headers.append('Content-Type', 'application/json');
	        var url = this.tipoBateriaUrl + "/" + tipoBateria._id;
	        return this.http
	            .delete(url, { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    // Agregar nuevo tipoBateria
	    TipoBateriaService.prototype.post = function (tipoBateria) {
	        var headers = new http_1.Headers({
	            'Content-Type': 'application/json;charset=UTF-8'
	        });
	        headers.append('dataType', 'json');
	        console.log(tipoBateria);
	        console.log(JSON.stringify(tipoBateria));
	        var tipoBateriaStr = JSON.stringify(tipoBateria);
	        return this.http
	            .post(this.tipoBateriaUrl, tipoBateriaStr, { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    // Actualizar tipoBateria
	    TipoBateriaService.prototype.put = function (tipoBateria) {
	        var headers = new http_1.Headers();
	        headers.append('Content-Type', 'application/json');
	        var url = this.tipoBateriaUrl + "/" + tipoBateria._id;
	        return this.http
	            .put(url, JSON.stringify(tipoBateria), { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    TipoBateriaService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
	    ], TipoBateriaService);
	    return TipoBateriaService;
	    var _a;
	}());
	exports.TipoBateriaService = TipoBateriaService;


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var http_1 = __webpack_require__(382);
	__webpack_require__(374);
	var myGlobals = __webpack_require__(414);
	var AlarmaService = (function () {
	    function AlarmaService(http) {
	        this.http = http;
	        this.alarmaUrl = myGlobals.default.BASE_URL + '/alarma/'; // URL to web api
	    }
	    //Obtener todos los alarmas habilitados para el usuario
	    AlarmaService.prototype.getAlarmas = function () {
	        return this.http.get(this.alarmaUrl)
	            .map(function (response) { return response.json(); });
	    };
	    //Obtener un alarma
	    AlarmaService.prototype.getAlarma = function (_id) {
	        return this.http.get(this.alarmaUrl + _id)
	            .map(function (response) { return response.json(); });
	    };
	    AlarmaService.prototype.save = function (alarma) {
	        if (alarma._id) {
	            return this.put(alarma);
	        }
	        //Seteo estado activo
	        alarma.estado = true;
	        return this.post(alarma);
	    };
	    //Desactivar alarma
	    AlarmaService.prototype.delete = function (alarma) {
	        var headers = new http_1.Headers();
	        headers.append('Content-Type', 'application/json');
	        var url = this.alarmaUrl + "/" + alarma._id;
	        return this.http
	            .delete(url, { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    // Agregar nueva alarma
	    AlarmaService.prototype.post = function (alarma) {
	        var headers = new http_1.Headers({
	            'Content-Type': 'application/json;charset=UTF-8'
	        });
	        headers.append('dataType', 'json');
	        console.log(alarma);
	        console.log(JSON.stringify(alarma));
	        var alarmaStr = JSON.stringify(alarma);
	        return this.http
	            .post(this.alarmaUrl, alarmaStr, { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    // Actualizar alarma
	    AlarmaService.prototype.put = function (alarma) {
	        var headers = new http_1.Headers();
	        headers.append('Content-Type', 'application/json');
	        var url = this.alarmaUrl + "/" + alarma._id;
	        return this.http
	            .put(url, JSON.stringify(alarma), { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    AlarmaService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
	    ], AlarmaService);
	    return AlarmaService;
	    var _a;
	}());
	exports.AlarmaService = AlarmaService;


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var http_1 = __webpack_require__(382);
	__webpack_require__(374);
	var myGlobals = __webpack_require__(414);
	var _ = __webpack_require__(580);
	var AvisoService = (function () {
	    function AvisoService(http) {
	        this.http = http;
	        this.avisoUrl = myGlobals.default.BASE_URL + '/aviso/'; // URL to web api
	    }
	    //Obtener todos los avisos habilitados para el usuario
	    AvisoService.prototype.getAvisos = function () {
	        return this.http.get(this.avisoUrl)
	            .map(function (response) { return response.json(); });
	    };
	    //Obtener un aviso
	    AvisoService.prototype.getAviso = function (_id) {
	        return this.http.get(this.avisoUrl + _id)
	            .map(function (response) { return response.json(); });
	    };
	    AvisoService.prototype.save = function (aviso, alarma) {
	        var avisoModificado = _.cloneDeep(aviso);
	        if (avisoModificado.horaDesde != undefined)
	            avisoModificado.horaDesde = avisoModificado.horaDesde.replace(":", "");
	        if (avisoModificado.horaHasta != undefined)
	            avisoModificado.horaHasta = avisoModificado.horaHasta.replace(":", "");
	        if (avisoModificado._id) {
	            return this.put(avisoModificado);
	        }
	        //Seteo estado activo
	        avisoModificado.estado = true;
	        return this.post(avisoModificado, alarma);
	    };
	    //Desactivar aviso
	    AvisoService.prototype.delete = function (aviso) {
	        var headers = new http_1.Headers();
	        headers.append('Content-Type', 'application/json');
	        var url = this.avisoUrl + "/" + aviso._id;
	        return this.http
	            .delete(url, { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    // Agregar nueva aviso
	    AvisoService.prototype.post = function (aviso, alarma) {
	        var headers = new http_1.Headers({
	            'Content-Type': 'application/json;charset=UTF-8'
	        });
	        headers.append('dataType', 'json');
	        var avisoStr = JSON.stringify(aviso);
	        var url = this.avisoUrl + "/" + alarma._id;
	        return this.http
	            .post(url, avisoStr, { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    // Actualizar aviso
	    AvisoService.prototype.put = function (aviso) {
	        var headers = new http_1.Headers();
	        headers.append('Content-Type', 'application/json');
	        var url = this.avisoUrl + "/" + aviso._id;
	        return this.http
	            .put(url, JSON.stringify(aviso), { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    AvisoService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
	    ], AvisoService);
	    return AvisoService;
	    var _a;
	}());
	exports.AvisoService = AvisoService;


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.21';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function',
	      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading whitespace. */
	  var reTrimStart = /^\s+/;
	
	  /** Used to match a single whitespace character. */
	  var reWhitespace = /\s/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /**
	   * Used to validate the `validate` option in `_.template` variable.
	   *
	   * Forbids characters which could potentially change the meaning of the function argument definition:
	   * - "()," (modification of function parameters)
	   * - "=" (default value)
	   * - "[]{}" (destructuring of function parameters)
	   * - "/" (beginning of a comment)
	   * - whitespace
	   */
	  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      // Use `util.types` for Node.js 10+.
	      var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	      if (types) {
	        return types;
	      }
	
	      // Legacy `process.binding('util')` for Node.js < 10.
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.trim`.
	   *
	   * @private
	   * @param {string} string The string to trim.
	   * @returns {string} Returns the trimmed string.
	   */
	  function baseTrim(string) {
	    return string
	      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
	      : string;
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the last non-whitespace character.
	   */
	  function trimmedEndIndex(string) {
	    var index = string.length;
	
	    while (index-- && reWhitespace.test(string.charAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	      } else if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	      }
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        stack || (stack = new Stack);
	        if (isObject(srcValue)) {
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || isFunction(objValue)) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      if (iteratees.length) {
	        iteratees = arrayMap(iteratees, function(iteratee) {
	          if (isArray(iteratee)) {
	            return function(value) {
	              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
	            }
	          }
	          return iteratee;
	        });
	      } else {
	        iteratees = [identity];
	      }
	
	      var index = -1;
	      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
	          return object;
	        }
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      var low = 0,
	          high = array == null ? 0 : array.length;
	      if (high === 0) {
	        return 0;
	      }
	
	      value = iteratee(value);
	      var valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision && nativeIsFinite(number)) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Check that cyclic values are equal.
	      var arrStacked = stack.get(array);
	      var othStacked = stack.get(other);
	      if (arrStacked && othStacked) {
	        return arrStacked == other && othStacked == array;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Check that cyclic values are equal.
	      var objStacked = stack.get(object);
	      var othStacked = stack.get(other);
	      if (objStacked && othStacked) {
	        return objStacked == other && othStacked == object;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return new Ctor;
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return new Ctor;
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	
	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the property to get.
	     * @returns {*} Returns the property value.
	     */
	    function safeGet(object, key) {
	      if (key === 'constructor' && typeof object[key] === 'function') {
	        return;
	      }
	
	      if (key == '__proto__') {
	        return;
	      }
	
	      return object[key];
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     *
	     * // Combining several predicates using `_.overEvery` or `_.overSome`.
	     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
	     * // => objects for ['fred', 'barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 30 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;
	
	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            clearTimeout(timerId);
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = baseTrim(value);
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);
	
	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined;
	
	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }
	
	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;
	
	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];
	
	          if (value === undefined ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }
	
	      return object;
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      // The sourceURL gets injected into the source that's eval-ed, so be careful
	      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
	      // and escape the comment, thus injecting code that gets evaled.
	      var sourceURL = '//# sourceURL=' +
	        (hasOwnProperty.call(options, 'sourceURL')
	          ? (options.sourceURL + '').replace(/\s/g, ' ')
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Throw an error if a forbidden character was found in `variable`, to prevent
	      // potential command injection attacks.
	      else if (reForbiddenIdentifierChars.test(variable)) {
	        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
	      }
	
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return baseTrim(string);
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.slice(0, trimmedEndIndex(string) + 1);
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     *
	     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
	     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name + '';
	        if (!hasOwnProperty.call(realNames, key)) {
	          realNames[key] = [];
	        }
	        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(40)(module)))

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var login_service_1 = __webpack_require__(381);
	var menu_service_1 = __webpack_require__(428);
	var router_1 = __webpack_require__(329);
	var filtro_1 = __webpack_require__(582);
	var NavLeftComponent = (function () {
	    function NavLeftComponent(loginService, menuService) {
	        var _this = this;
	        this.loginService = loginService;
	        this.menuService = menuService;
	        this.showNavBar = this.loginService.isLoggedIn() && !this.loginService.getDecodeToken().cambiarPassword;
	        this.loginService.logIn.subscribe(function (mode) {
	            _this.showNavBar = mode && !_this.loginService.getDecodeToken().cambiarPassword;
	            if (mode == true) {
	                _this.usuarioConectado = _this.loginService.getDecodeToken();
	                _this.menuService.getMenus().subscribe(function (menus) {
	                    _this.menus = menus;
	                });
	            }
	        });
	    }
	    NavLeftComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        if (this.showNavBar) {
	            this.usuarioConectado = this.loginService.getDecodeToken();
	            this.menuService.getMenus().subscribe(function (menus) {
	                _this.menus = menus;
	            });
	        }
	        //Ocultar la barra cuando hace click afuera
	        $(document).bind("mouseup touchend", function (e) {
	            var container = $("#menuDesplegable");
	            if (!container.is(e.target) // if the target of the click isn't the container...
	                && container.has(e.target).length === 0
	                && e.target.id != "itemCargaDatos" && e.target.className != "menuSeleccionable" && e.target.id != "dropdownCargaDatos"
	                && e.target.id != "imgCargaDatos" && e.target.id != "spanCargaDatos" && e.target.id != "flechaCargaDatos") {
	                $('#menuDesplegable').css("display", "none");
	            }
	        });
	    };
	    NavLeftComponent.prototype.desplegarMenu = function () {
	        if ($('#menuDesplegable').css("display") == "block")
	            $('#menuDesplegable').css("display", "none");
	        else
	            $('#menuDesplegable').css("display", "block");
	    };
	    NavLeftComponent = __decorate([
	        core_1.Component({
	            selector: 'NavLeft',
	            template: __webpack_require__(583),
	            styles: [__webpack_require__(586)],
	            directives: [router_1.ROUTER_DIRECTIVES],
	            pipes: [filtro_1.FilterPipe]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof login_service_1.LoginService !== 'undefined' && login_service_1.LoginService) === 'function' && _a) || Object, (typeof (_b = typeof menu_service_1.MenuService !== 'undefined' && menu_service_1.MenuService) === 'function' && _b) || Object])
	    ], NavLeftComponent);
	    return NavLeftComponent;
	    var _a, _b;
	}());
	exports.NavLeftComponent = NavLeftComponent;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(419)))

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var FilterPipe = (function () {
	    function FilterPipe() {
	    }
	    FilterPipe.prototype.transform = function (items, field, value) {
	        if (!items)
	            return [];
	        return items.filter(function (it) { return it[field] == value; });
	    };
	    FilterPipe = __decorate([
	        core_1.Pipe({
	            name: 'filter'
	        }),
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [])
	    ], FilterPipe);
	    return FilterPipe;
	}());
	exports.FilterPipe = FilterPipe;


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"hidden-xs navleft\" *ngIf=\"showNavBar && loginService.isLoggedIn()\">\n    <div class=\"menu\">\n        <ul class=\"nav nav-pills nav-stacked\">\n            <li routerLinkActive=\"active\" class=\"itemMenu\">\n                <a class=\"imgItemMenu\" [routerLink]=\"['/home']\">\n                    <img src=\"" + __webpack_require__(584) + "\" style=\"width: 30px\"/>\n                    <span>Home</span>\n                </a>\n            </li>\n            <li routerLinkActive=\"active\" *ngFor=\"let menu of menus | filter : 'menuSuperior' : ''\" class=\"itemMenu\">\n                <a class=\"imgItemMenu\" routerLink={{menu.url}}>\n                    <img [src]=\"'../../img/'+menu.imagen\"/>\n                    <span>{{menu.descripcion}}</span>\n                </a>\n            </li>\n            <li class=\"dropdown\" routerLinkActive=\"active\" class=\"itemMenu\" id=\"itemCargaDatos\" *ngIf=\"usuarioConectado.rol!='Operador'\" >\n                <a class=\"dropdown-toggle imgItemMenu\" style=\"padding: 5px; padding-top: 15px;\"\n                   (click)=\"desplegarMenu()\" id=\"dropdownCargaDatos\">\n                    <img src=\"" + __webpack_require__(585) + "\" style=\"width: 30px\" id=\"imgCargaDatos\"/>\n                    <span style=\"display: block\" id=\"spanCargaDatos\">\n                Carga Datos\n                <b class=\"caret\" id=\"flechaCargaDatos\"></b>\n                </span>\n                </a>\n                <ul class=\"dropdown-menu\" ng-click=\"$event.stopPropagation()\">\n                    <li *ngFor=\"let menu of menus | filter : 'menuSuperior' : 'Carga datos'\" routerLinkActive=\"active\">\n                        <a routerLink={{menu.url}}>{{menu.descripcion}}</a></li>\n                </ul>\n            </li>\n        </ul>\n    </div>\n</div>\n<ul class=\"dropdown-menu\" id=\"menuDesplegable\">\n    <li *ngFor=\"let menu of menus | filter : 'menuSuperior' : 'Carga datos'\" routerLinkActive=\"active\"\n        (click)=\"desplegarMenu()\">\n        <a class=\"menuSeleccionable\" routerLink={{menu.url}}>{{menu.descripcion}}</a></li>\n</ul>\n";

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/home.953f07eeae9f798e5538b30806a50769.svg";

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/cargaDatos.2f6d226f77ae9101f18192698e452a52.svg";

/***/ }),
/* 586 */
/***/ (function(module, exports) {

	module.exports = "/*.navLeft {\n\tbackground-color: #2F4050;\n\theight:100%;\n\tmin-height:100vh;\n\twidth: 200px;\n\tpadding: 0px;\n\tpadding-top: 0px;\n\tmargin: 0px;\n\tz-index: 9999999999;\n  position: fixed;\n  overflow: scroll;\n}*/\n\n.navLeft {\n    background-color: #273135;\n    height: 100%;\n    min-height: 100vh;\n    width: 100px;\n    padding: 0px;\n    padding-top: 60px;\n    margin: 0px;\n    z-index: 10;\n    position: fixed;\n    overflow: scroll;\n}\n\n.perfil {\n    background-image: url(\"../../img/header-profile.png\");\n    height: 156px;\n    padding: 33px 25px;\n    color: #DFE4ED;\n    position: relative;\n}\n\n.datosPerfil {\n    height: 100%;\n}\n\n.menu {\n    position: relative;\n}\n\n\n/*.nav-pills > li.active > a{\n\tborder-radius: 0px;\n\tbackground-color: #293846;\n\tcolor: white;\n}\n\n.nav-pills > li > a{\n\tborder-radius: 0px;\n\tcolor: #8095A8;\n}\n\n/*hover sobre los submenu actua sobre menu\n.nav-pills > li:hover > a{\n\tbackground-color: #293846;\n\tcolor: white;\n}\n/*click sobre los submenu actua sobre menu\n.nav-pills > li:active > a{\n\tbackground-color: #293846;\n\tcolor: white;\n}\n\n.nav-pills li {\n\tmargin: 0px;\n}*/\n\n\n/*.dropdown-menu{\n\twidth: 100%;\n\tborder: 0px;\n\tmargin: 0px;\n\tpadding: 0px;\n\tborder-radius: 0px;\n\tbackground-color: #2F4050;\n\tcolor: #8095A8;\n\tposition: relative;\n\tmargin-bottom: 13px;\n}\n\n.dropdown-menu > li > a{\n\tcolor: #8095A8;\n\tposition: relative;\n\tdisplay: block;\n    padding: 10px 15px;\n    padding-left: 30px;\n}\n\n.dropdown-menu > li:hover > a{\n\tcolor: white;\n\tbackground-color: #2F4050;\n\n}\n\n.dropdown-backdrop {\n    display:none;\n}\n\n.nav .open > a {\n\tbackground-color: #2F4050;\n\tcolor: white;\n\tborder-left: 1px solid white;\n}\n\n\n\n.nav > li > a:hover {\n\tbackground-color: #2F4050;\n}\n\n.nav > li > a:active {\n\tbackground-color: #2F4050;\n}\n\n.menu span{\n\tpadding-right: 10px;\n}*/\n\n\n/*Item Menu NavLeft*/\n\n.itemMenu {\n    height: 95px;\n    padding: 0px;\n    text-align: center;\n    font-size: 13px;\n    border-top: 1px solid rgba(240, 240, 240, 0.1);\n    display: block;\n    text-decoration: none;\n}\n\n.imgItemMenu {\n    display: block;\n    padding: 15px;\n    height: 100%;\n    background-color: transparent !important;\n}\n\n.imgItemMenu:hover {\n    background-color: transparent;\n}\n\n.itemMenu:hover {\n    background-color: #171D20;\n    text-decoration: none;\n}\n\n.itemMenu.active {\n    border-left: solid 3px #E76049;\n    text-decoration: none;\n}\n\n.itemMenu span {\n    color: white;\n}\n\n.itemMenu img {\n    padding-bottom: 10px;\n    width: 35px;\n}\n\n.dropdown-menu {\n    position: fixed;\n    top: 60px;\n    left: 100px;\n    height: 100%;\n    background-color: #364247;\n    color: white;\n    margin: 0px;\n    border-radius: 0px;\n    border: 0px;\n    z-index: 12;\n}\n\n.dropdown-menu > li > a:hover,\n.dropdown-menu > li > a:focus {\n    color: white;\n    background-color: #171D20;\n}\n\n.dropdown-menu > li > a {\n    color: white;\n    padding: 6px 20px;\n    height: 35px;\n}\n"

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var login_service_1 = __webpack_require__(381);
	var regAlarma_service_1 = __webpack_require__(572);
	var menu_service_1 = __webpack_require__(428);
	var filtro_1 = __webpack_require__(582);
	var router_1 = __webpack_require__(329);
	var documento_service_1 = __webpack_require__(588);
	var NavSupComponent = (function () {
	    function NavSupComponent(loginService, regAlarmaService, menuService, documentoService) {
	        var _this = this;
	        this.loginService = loginService;
	        this.regAlarmaService = regAlarmaService;
	        this.menuService = menuService;
	        this.documentoService = documentoService;
	        this.showNavBar = this.loginService.isLoggedIn() && !this.loginService.getDecodeToken().cambiarPassword;
	        this.loginService.logIn.subscribe(function (mode) {
	            _this.usuario = _this.loginService.getDecodeToken();
	            _this.showNavBar = mode && !_this.loginService.getDecodeToken().cambiarPassword;
	            if (mode == true) {
	                _this.menuService.getMenus().subscribe(function (menus) {
	                    _this.menus = menus;
	                });
	            }
	            if (_this.usuario.rol == 'Administrador' || _this.usuario.rol == 'Tecnico' || _this.usuario.rol == 'Empresa')
	                _this.documentoService.getDocumentos().subscribe();
	        });
	        //Cargo usuario
	        if (this.loginService.isLoggedIn())
	            this.usuario = this.loginService.getDecodeToken();
	        this.cantDocumentos = -1;
	        if (this.loginService.isLoggedIn() && (this.usuario.rol == 'Administrador' || this.usuario.rol == 'Tecnico' || this.usuario.rol == 'Empresa'))
	            this.documentoService.getDocumentos().subscribe();
	        this.documentoService.documentos$.subscribe(function (documentos) {
	            var cantDocumentos = documentos.length === 0 ? -1 : 0;
	            documentos.forEach(function (documento) {
	                if (documento.usuariosNotificados.indexOf(_this.usuario.id) === -1 && documento.estado === true)
	                    cantDocumentos++;
	            });
	            _this.cantDocumentos = cantDocumentos;
	        });
	    }
	    NavSupComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        if (this.showNavBar)
	            this.menuService.getMenus().subscribe(function (menus) {
	                _this.menus = menus;
	            });
	        $(document).bind("mouseup touchend", function (e) {
	            var container = $("#right-sidebar-wrapper");
	            if (!container.is(e.target) // if the target of the click isn't the container...
	                && container.has(e.target).length === 0
	                && e.target.id != "logoEmpresa" && e.target.id != "iconoAlarma" && e.target.id != "btnNavRight" && e.target.className != "icon-bar" && e.target.className != "previewFotoPerfil") {
	                $(".wrapper").removeClass("right-toggled");
	            }
	            var container = $("#navLeftRes");
	            if (!container.is(e.target) // if the target of the click isn't the container...
	                && container.has(e.target).length === 0
	                && e.target.id != "btnNavLeft" && e.target.className != "icon-bar") {
	                $('#navbarCollapse').removeClass('in');
	                $('#navbarCollapse').addClass('collapse');
	            }
	        });
	    };
	    NavSupComponent.prototype.ngOnDestroy = function () {
	        this.cantNotificaciones = 0;
	    };
	    NavSupComponent.prototype.logout = function () {
	        this.loginService.logout();
	    };
	    NavSupComponent.prototype.toogleBar = function () {
	        $('.wrapper').toggleClass('right-toggled');
	    };
	    NavSupComponent.prototype.toogleLeftBar = function () {
	        $('#navbarCollapse').toggleClass('collapse in');
	    };
	    NavSupComponent.prototype.toggleRightAlarma = function () {
	        $(".wrapper").toggleClass("right-toggled");
	        $("#notificaciones").addClass('active in');
	        $("#configuracion").removeClass('active in');
	        $("#notificacionesRango").removeClass('active in');
	        $("#error").removeClass('active in');
	        $("#notificacionesLink").addClass('active');
	        $("#configuracionLink").removeClass('active');
	        $("#notificacionesRangoLink").removeClass('active');
	        $("#errorLink").removeClass('active');
	    };
	    NavSupComponent.prototype.toggleRightConfiguracion = function () {
	        $(".wrapper").toggleClass("right-toggled");
	        $("#notificaciones").removeClass('active in');
	        $("#notificacionesRango").removeClass('active in');
	        $("#configuracion").addClass('active in');
	        $("#error").removeClass('active in');
	        $("#notificacionesLink").removeClass('active');
	        $("#notificacionesRangoLink").removeClass('active');
	        $("#configuracionLink").addClass('active');
	        $("#errorLink").removeClass('active');
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], NavSupComponent.prototype, "cantNotificaciones", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], NavSupComponent.prototype, "urlLogo", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], NavSupComponent.prototype, "alertaCalibracion", void 0);
	    NavSupComponent = __decorate([
	        core_1.Component({
	            selector: 'NavSup',
	            template: __webpack_require__(589),
	            styles: [__webpack_require__(591)],
	            directives: [router_1.ROUTER_DIRECTIVES],
	            pipes: [filtro_1.FilterPipe]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof login_service_1.LoginService !== 'undefined' && login_service_1.LoginService) === 'function' && _a) || Object, (typeof (_b = typeof regAlarma_service_1.RegAlarmaService !== 'undefined' && regAlarma_service_1.RegAlarmaService) === 'function' && _b) || Object, (typeof (_c = typeof menu_service_1.MenuService !== 'undefined' && menu_service_1.MenuService) === 'function' && _c) || Object, (typeof (_d = typeof documento_service_1.DocumentoService !== 'undefined' && documento_service_1.DocumentoService) === 'function' && _d) || Object])
	    ], NavSupComponent);
	    return NavSupComponent;
	    var _a, _b, _c, _d;
	}());
	exports.NavSupComponent = NavSupComponent;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(419)))

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var http_1 = __webpack_require__(382);
	__webpack_require__(374);
	var myGlobals = __webpack_require__(414);
	var Subject_1 = __webpack_require__(37);
	var DocumentoService = (function () {
	    function DocumentoService(http) {
	        this.http = http;
	        this.documentoUrl = myGlobals.default.BASE_URL + '/documento/'; // URL to web api
	        this.documentos = new Subject_1.Subject();
	        this.documentos$ = this.documentos.asObservable();
	    }
	    //Obtener todas las documentos
	    DocumentoService.prototype.getDocumentos = function () {
	        var _this = this;
	        return this.http.get(this.documentoUrl)
	            .map(function (response) {
	            _this.documentos.next(response.json());
	            return response.json();
	        });
	    };
	    //Obtener una documento
	    DocumentoService.prototype.getDocumento = function (_id) {
	        return this.http.get(this.documentoUrl + _id)
	            .map(function (response) { return response.json(); });
	    };
	    DocumentoService.prototype.synchronizeDrive = function () {
	        return this.http.post(this.documentoUrl + "synchronizeDrive", null);
	    };
	    // Informe resumen
	    DocumentoService.prototype.getDocumentoFile = function (_id) {
	        var headers = new http_1.Headers({
	            'Content-Type': 'application/json;charset=UTF-8',
	        });
	        headers.append('dataType', 'json');
	        // var sucursalStr = JSON.stringify(reporte);
	        var requestOptions = { headers: headers, responseType: 'arraybuffer' };
	        return this.http
	            .get(this.documentoUrl + "getFile/" + _id, requestOptions)
	            .map(function (response) {
	            return response.text();
	            // const linkSource = `data:application/pdf;base64,${response.text()}`;
	            // const downloadLink = document.createElement("a");
	            // const fileName = "reporteResumenBemakoha" + ".pdf";
	            // downloadLink.href = linkSource;
	            // downloadLink.download = fileName;
	            // downloadLink.click();
	        });
	    };
	    DocumentoService.prototype.save = function (documento, logo) {
	        if (documento._id) {
	            return this.put(documento, logo);
	        }
	        //Seteo estado activo
	        documento.estado = true;
	        return this.post(documento, logo);
	    };
	    //Desactivar documento
	    DocumentoService.prototype.delete = function (documento) {
	        var headers = new http_1.Headers();
	        headers.append('Content-Type', 'application/json');
	        var url = this.documentoUrl + "/" + documento._id;
	        return this.http
	            .delete(url, { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    // Agregar nueva documento
	    DocumentoService.prototype.post = function (documento, logo) {
	        var formData = new FormData();
	        formData.append("logo", logo);
	        formData.append("documento", JSON.stringify(documento));
	        var headers = new http_1.Headers();
	        headers.append('enctype', "multipart/form-data");
	        return this.http
	            .post(this.documentoUrl, formData, { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    // Actualizar documento
	    DocumentoService.prototype.put = function (documento, logo) {
	        documento.logo = null;
	        var formData = new FormData();
	        formData.append("logo", logo);
	        formData.append("documento", JSON.stringify(documento));
	        var headers = new http_1.Headers();
	        headers.append('enctype', "multipart/form-data");
	        ;
	        var url = this.documentoUrl + "/" + documento._id;
	        return this.http
	            .put(url, formData, { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    DocumentoService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
	    ], DocumentoService);
	    return DocumentoService;
	    var _a;
	}());
	exports.DocumentoService = DocumentoService;


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<nav role=\"navigation\" class=\"navbar navbar-default navbar-fixed-top\" style=\"border:none\"\n     *ngIf=\"showNavBar && loginService.isLoggedIn()\">\n    <div id=\"contenedor\" class=\"navSup navbar-left\">\n        <!-- Brand and toggle get grouped for better mobile display -->\n        <div class=\"navbar-header\">\n            <button id=\"btnNavRight\" type=\"button\" class=\"navbar-toggle\" (click)=\"toggleRightConfiguracion()\">\n                <span class=\"sr-only\">Toggle navigation</span>\n                <span class=\"icon-bar\"></span>\n                <span class=\"icon-bar\"></span>\n                <span class=\"icon-bar\"></span>\n            </button>\n            <button id=\"btnNavLeft\" type=\"button\"\n                    class=\"navbar-toggle\" (click)=\"toogleLeftBar()\">\n                <span class=\"sr-only\">Toggle navigation</span>\n                <span class=\"icon-bar\"></span>\n                <span class=\"icon-bar\"></span>\n                <span class=\"icon-bar\"></span>\n            </button>\n            <div class=\"previewFotoPerfilLogo hidden-xs\">\n                <img id=\"logoSistema\" src=\"" + __webpack_require__(590) + "\" class=\"\"/>\n            </div>\n        </div>\n        <!-- Collection of nav links and other content for toggling -->\n        <div id=\"navbarCollapse\" class=\"collapse navbar-collapse\">\n            <ul id=\"navLeftRes\" class=\"nav navbar-nav visible-xs\" style=\"padding-left: 0px\">\n                <li routerLinkActive=\"active\" class=\"itemMenu\" (click)=\"toogleLeftBar()\">\n                    <a class=\"imgItemMenu\" [routerLink]=\"['/home']\">\n                        <img src=\"" + __webpack_require__(584) + "\" style=\"width: 8%\"/>\n                        <span>Home</span>\n                    </a>\n                </li>\n                <li routerLinkActive=\"active\" *ngFor=\"let menu of menus | filter : 'menuSuperior' : ''\"\n                    class=\"itemMenu\" (click)=\"toogleLeftBar()\">\n                    <a class=\"imgItemMenu\" routerLink={{menu.url}}>\n                        <img [src]=\"'../../img/'+menu.imagen\"/>\n                        <span>{{menu.descripcion}}</span>\n                    </a>\n                </li>\n                <li class=\"dropdown\" routerLinkActive=\"active\" class=\"itemMenu\" id=\"itemCargaDatos\">\n                    <a class=\"dropdown-toggle imgItemMenu\"\n                       id=\"dropdownCargaDatos\" data-toggle=\"dropdown\" class=\"dropdown-toggle\">\n                        <img src=\"" + __webpack_require__(585) + "\" id=\"imgCargaDatos\"/>\n                        <span id=\"spanCargaDatos\">\n                Carga Datos\n                <b class=\"caret\" id=\"flechaCargaDatos\"></b>\n                </span>\n                    </a>\n                    <ul class=\"dropdown-menu\" ng-click=\"$event.stopPropagation()\">\n                        <li *ngFor=\"let menu of menus | filter : 'menuSuperior' : 'Carga datos'\"\n                            routerLinkActive=\"active\" class=\"subMenu\" (click)=\"toogleLeftBar()\">\n                            <a routerLink={{menu.url}}>{{menu.descripcion}}</a></li>\n                    </ul>\n                </li>\n\n\n            </ul>\n            <ul class=\"nav navbar-nav navbar-right itemNavSup hidden-xs\"\n                (click)=\"toggleRightConfiguracion()\">\n                <div class=\"previewFotoPerfil\">\n                    <img id=\"logoEmpresa\" [src]=\"urlLogo\" class=\"\"/>\n                </div>\n            </ul>\n            <ul class=\"nav navbar-nav navbar-right itemNavSup hidden-xs\" (click)=\"toggleRightAlarma()\">\n                <li style=\"color: white;\">\n                    <span class=\"glyphicon glyphicon-bell\" style=\"font-size: 20px\" id=\"iconoAlarma\"></span>\n                    <span *ngIf=\"cantNotificaciones>0\" class=\"badge\">{{cantNotificaciones}}</span>\n                </li>\n            </ul>\n            <ul class=\"nav navbar-nav navbar-right itemNavSup hidden-xs\" *ngIf=\"alertaCalibracion\"\n                (click)=\"toggleRightAlarma()\">\n                <li style=\"color: white;padding: 15px;\" class=\"iconoCalibracion\">\n                    <img *ngIf=\"alertaCalibracion == 'Rojo'\" data-toggle=\"tooltip\" title=\"Alerta calibración cercana\"\n                         class=\"verde\" src=\"/img/calibracionRoja.png\">\n                    <img *ngIf=\"alertaCalibracion == 'Amarillo'\"\n                         class=\"amarillo\" src=\"/img/calibracionAmarilla.png\" data-toggle=\"tooltip\"\n                         title=\"Alerta calibración cercana\">\n                    <span style=\"display: none\" class=\"badge\">{{cantDocumentos}}</span>\n                </li>\n            </ul>\n            <ul *ngIf=\"(usuario.rol == 'Administrador' || usuario.rol == 'Tecnico' || usuario.rol == 'Empresa') && cantDocumentos!==-1\" class=\"nav navbar-nav navbar-right itemNavSup hidden-xs\" [routerLink]=\"['/documentos']\">\n                <li style=\"color: white;\">\n                    <span *ngIf=\"cantDocumentos==0\" class=\"glyphicon glyphicon-folder-open\"\n                          style=\"font-size: 19px\"></span>\n                    <span *ngIf=\"cantDocumentos>0\" class=\"glyphicon glyphicon-folder-close\"\n                          style=\"font-size: 19px\"></span>\n                    <span *ngIf=\"cantDocumentos>0\" class=\"badge\">{{cantDocumentos}}</span>\n                </li>\n            </ul>\n        </div>\n    </div>\n</nav>\n";

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/ojo_bemakoha.241f69237860040beec72c032074601a.png";

/***/ }),
/* 591 */
/***/ (function(module, exports) {

	module.exports = ".brand {\n\twidth: 100px;\n\theight: 60px;\n\tbackground-color: #273135;\n\ttext-align: center;\n\tpadding-top: 25px;\n\tmargin:0px !important;\n  \tz-index: 9999;\n}\n\n.navSup{\n\tpadding: 0px !important;\n\tmargin: 0px !important;\n}\n\n.itemNavSup{\n    display: flex !important;\n    align-content: center;\n    align-items: center;\n    justify-content: center;\n    max-height: 65px;\n    height: 65px;\n    padding-left: 10px;\n}\n\n@media (max-width: 768px) {\n    .itemNavSup{\n        display: none !important;\n    }\n}\n\n.itemNavSup a{\n\tpadding-top: 20px;\n\theight: 100%;\n\twidth: 90px;\n\tvertical-align: middle;\n}\n\n.navbar-default {\n  background-color: #273135;\n  border-color: #273135;\n  margin: 0px;\n}\n.navbar-default .navbar-brand {\n  color: #999c9e;\n}\n.navbar-default .navbar-brand:hover,\n.navbar-default .navbar-brand:focus {\n  color: #babcbd;\n}\n.navbar-default .navbar-text {\n  color: #999c9e;\n}\n.navbar-default .navbar-nav > li > a {\n  color: #999c9e;\n}\n.navbar-default .navbar-nav > li > a:hover,\n.navbar-default .navbar-nav > li > a:focus {\n  color: #babcbd;\n}\n.navbar-default .navbar-nav > .active > a,\n.navbar-default .navbar-nav > .active > a:hover,\n.navbar-default .navbar-nav > .active > a:focus {\n  color: #babcbd;\n  background-color: #f3f3f4;\n}\n.navbar-default .navbar-nav > .open > a,\n.navbar-default .navbar-nav > .open > a:hover,\n.navbar-default .navbar-nav > .open > a:focus {\n  color: #babcbd;\n  background-color: #f3f3f4;\n}\n.navbar-default .navbar-toggle {\n  border-color: #f3f3f4;\n}\n.navbar-default .navbar-toggle:hover,\n.navbar-default .navbar-toggle:focus {\n  background-color: #f3f3f4;\n}\n.navbar-default .navbar-toggle .icon-bar {\n  background-color: #999c9e;\n}\n.navbar-default .navbar-collapse,\n.navbar-default .navbar-form {\n  border-color: #999c9e;\n}\n.navbar-default .navbar-link {\n  color: #999c9e;\n}\n.navbar-default .navbar-link:hover {\n  color: #babcbd;\n}\n\n@media (max-width: 767px) {\n  .navbar-default .navbar-nav .open .dropdown-menu > li > a {\n    color: #999c9e;\n  }\n  .navbar-default .navbar-nav .open .dropdown-menu > li > a:hover,\n  .navbar-default .navbar-nav .open .dropdown-menu > li > a:focus {\n    color: #babcbd;\n  }\n  .navbar-default .navbar-nav .open .dropdown-menu > .active > a,\n  .navbar-default .navbar-nav .open .dropdown-menu > .active > a:hover,\n  .navbar-default .navbar-nav .open .dropdown-menu > .active > a:focus {\n    color: #babcbd;\n    background-color: #f3f3f4;\n  }\n}\n\n.badge{\n\tbackground-color: #E76049;\n    margin-left: -8px;\n    z-index: 999999;\n    position: relative;\n}\n\n.boton-reducir{\n\nbackground-color: #1AB394;\nwidth: 38px;\nheight: 34px;\ncolor: white;\n}\n\n.previewFotoPerfilLogo{\n    width: auto;\n    height: 65px;\n    max-height: 65px;\n    margin: auto;\n    padding: 10px;\n}\n\n.previewFotoPerfilLogo img{\n    height: 100%;\n}\n\n.previewFotoPerfil{\n    width: auto;\n    height: 65px;\n    max-height: 65px;\n    margin: auto;\n    padding: 5px;\n    margin-right: 15px;\n}\n .previewFotoPerfil img{\n     width: 100%;\n     height: 100%;\n }\n\n#btnNavLeft{\n    float: left;\n    margin-left: 15px;\n}\n\n.imgItemMenu img, #imgCargaDatos{\n    width: 10%;\n    margin-right: 10px;\n}\n\n@media (max-width: 769px) {\n    .imgItemMenu img, #imgCargaDatos{\n        width: 8%;\n        margin-right: 10px;\n        max-width: 27px;\n    }\n}\n\n.itemMenu.active > a{\n    background-color: #fa7252 !important;\n    color: white !important;\n}\n\n.itemMenu.open > a{\n    background-color: transparent !important;\n    color: #fa7252 !important;\n}\n\n.subMenu.active > a{\n    background-color: #fa7252 !important;\n    color: white !important;\n}\n\n.navbar-default .navbar-toggle{\n    border-color: transparent;\n}\n\n.navbar-default .navbar-toggle:hover, .navbar-default .navbar-toggle:focus{\n    background-color: #fa7252 !important;\n}\n\n.navbar-default .navbar-toggle .icon-bar{\n    background-color: white !important;\n}\n\n.iconoCalibracion img{\n    width: 23px;\n}\n"

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var login_service_1 = __webpack_require__(381);
	var menu_service_1 = __webpack_require__(428);
	var regAlarma_service_1 = __webpack_require__(572);
	var router_1 = __webpack_require__(329);
	var io = __webpack_require__(593);
	var myGlobals = __webpack_require__(414);
	var dateTimeZonePipe_1 = __webpack_require__(645);
	var _ = __webpack_require__(580);
	var moment = __webpack_require__(435);
	var NavRightComponent = (function () {
	    function NavRightComponent(loginService, menuService, regAlarmaService) {
	        var _this = this;
	        this.loginService = loginService;
	        this.menuService = menuService;
	        this.regAlarmaService = regAlarmaService;
	        this.alerta = new core_1.EventEmitter();
	        this.alertaNotificaciones = new core_1.EventEmitter();
	        this.showNavBar = this.loginService.isLoggedIn() && !this.loginService.getDecodeToken().cambiarPassword;
	        this.loginService.logIn.subscribe(function (mode) {
	            _this.showNavBar = mode && !_this.loginService.getDecodeToken().cambiarPassword;
	            if (mode) {
	                _this.usuario = _this.loginService.getDecodeToken();
	                //Obtengo notificaciones cuando se loguea
	                _this.obtenerNotificaciones();
	            }
	        });
	        this.regAlarmas = [];
	        this.regAlarmasRango = [];
	    }
	    NavRightComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.usuario = this.loginService.getDecodeToken();
	        //Conectar al socket con configuración específica
	        this.socket = io.connect(myGlobals.default.URL_MQTT_ALARMAS, {
	            path: myGlobals.default.PATH_MQTT_ALARMAS,
	            transports: ['websocket', 'polling'],
	            upgrade: true,
	            rememberUpgrade: true
	        });
	        // Debug de conexiones
	        this.socket.on('connect', function () {
	            console.log('Socket navRight conectado via:', _this.socket.io.engine.transport.name);
	            _this.socket.io.engine.on('upgrade', function () {
	                console.log('Socket navRight actualizado a:', _this.socket.io.engine.transport.name);
	            });
	        });
	        this.inicializarSocketAlarma();
	        //Obtengo notificaciones 1era vez
	        this.obtenerNotificaciones();
	    };
	    NavRightComponent.prototype.ngOnDestroy = function () {
	        this.socket.disconnect();
	    };
	    NavRightComponent.prototype.inicializarSocketAlarma = function () {
	        //Inicilizo socket para alarmas
	        this.socket.on("alarma", function (alarma) {
	            this.obtenerNotificaciones();
	        }.bind(this));
	    };
	    NavRightComponent.prototype.logout = function () {
	        $('.wrapper').toggleClass('right-toggled');
	        this.loginService.logout();
	    };
	    NavRightComponent.prototype.toogleBar = function () {
	        $('.wrapper').toggleClass('right-toggled');
	    };
	    NavRightComponent.prototype.obtenerNotificaciones = function () {
	        var _this = this;
	        if (this.showNavBar)
	            this.regAlarmaService.getAllRegAlarmasActivadas().subscribe(function (regAlarmas) {
	                var _regAlarmas = new Map();
	                var _regAlarmasRango = new Map();
	                var alertaCalibracion = null;
	                regAlarmas.forEach(function (regAlarma) {
	                    if (!regAlarma.tipoEspecial && regAlarma.alarma_id && regAlarma.alarma_id._id && regAlarma.alarma_id.estado === true && regAlarma.nodo_id.estado === true && regAlarma.nodo_id.ubicacion_id.estado === true && regAlarma.nodo_id.ubicacion_id.sucursal_id.estado === true && regAlarma.nodo_id.ubicacion_id.sucursal_id.empresa.estado === true && regAlarma.sensor_id.estado === true) {
	                        if (!_regAlarmasRango.get(regAlarma.alarma_id._id))
	                            _regAlarmasRango.set(regAlarma.alarma_id._id, _.clone(regAlarma));
	                        var _regAlarma = _regAlarmasRango.get(regAlarma.alarma_id._id);
	                        if (!_regAlarma['color'] || !Array.isArray(_regAlarma['color'])) {
	                            _regAlarma['color'] = [];
	                        }
	                        _regAlarma['color'].push(regAlarma['color']);
	                        _regAlarma["fechaActivado"] = moment(_regAlarma["fechaActivado"]).isBefore(moment(regAlarma.fechaActivado), "minute") ? regAlarma.fechaActivado : _regAlarma["fechaActivado"];
	                    }
	                    if (regAlarma.tipoEspecial == "CALIBRACION" && regAlarma.sucursal_id && regAlarma.sucursal_id._id && regAlarma.sucursal_id.estado === true) {
	                        if (!_regAlarmas.get(regAlarma.sucursal_id._id))
	                            _regAlarmas.set(regAlarma.sucursal_id._id, _.clone(regAlarma));
	                        alertaCalibracion == null ? alertaCalibracion = regAlarma.color : (alertaCalibracion == "Amarillo" ? alertaCalibracion = regAlarma.color : "");
	                        var _regAlarma = _regAlarmas.get(regAlarma.sucursal_id._id);
	                        if (!_regAlarma['color'] || !Array.isArray(_regAlarma['color'])) {
	                            _regAlarma['color'] = [];
	                        }
	                        if (regAlarma['color'] == "Amarillo")
	                            _regAlarma['color'].push("En 60 días");
	                        else
	                            _regAlarma['color'].push("En 30 días");
	                        _regAlarma["fechaActivado"] = moment(_regAlarma["fechaActivado"]).isBefore(moment(regAlarma.fechaActivado), "minute") ? regAlarma.fechaActivado : _regAlarma["fechaActivado"];
	                    }
	                    if (regAlarma.tipoEspecial == "BATERIABAJA" && regAlarma.nodo_id.estado === true && regAlarma.nodo_id.ubicacion_id.estado === true && regAlarma.nodo_id.ubicacion_id.sucursal_id.estado === true && regAlarma.nodo_id.ubicacion_id.sucursal_id.empresa.estado === true && regAlarma.sensor_id.estado === true && (_this.usuario.rol == "Tecnico" || _this.usuario.rol == "Administrador")) {
	                        if (!_regAlarmas.get(regAlarma.nodo_id._id))
	                            _regAlarmas.set(regAlarma.nodo_id._id, _.clone(regAlarma));
	                        var _regAlarma = _regAlarmas.get(regAlarma.nodo_id._id);
	                        if (!_regAlarma['color'] || !Array.isArray(_regAlarma['color'])) {
	                            _regAlarma['color'] = [];
	                        }
	                        if (regAlarma.color == "Amarillo")
	                            _regAlarma['color'].push("Duración estimada");
	                        else
	                            _regAlarma['color'].push("Voltaje bajo");
	                        _regAlarma["fechaActivado"] = moment(_regAlarma["fechaActivado"]).isBefore(moment(regAlarma.fechaActivado), "minute") ? regAlarma.fechaActivado : _regAlarma["fechaActivado"];
	                    }
	                    if (regAlarma.tipoEspecial == "SENSORNULL" && regAlarma.nodo_id.estado === true && regAlarma.nodo_id.ubicacion_id.estado === true && regAlarma.nodo_id.ubicacion_id.sucursal_id.estado === true && regAlarma.nodo_id.ubicacion_id.sucursal_id.empresa.estado === true && regAlarma.sensor_id.estado === true && (_this.usuario.rol == "Tecnico" || _this.usuario.rol == "Administrador")) {
	                        if (!_regAlarmas.get(regAlarma.sensor_id._id))
	                            _regAlarmas.set(regAlarma.sensor_id._id, _.clone(regAlarma));
	                        var _regAlarma = _regAlarmas.get(regAlarma.sensor_id._id);
	                        _regAlarma["fechaActivado"] = moment(_regAlarma["fechaActivado"]).isBefore(moment(regAlarma.fechaActivado), "minute") ? regAlarma.fechaActivado : _regAlarma["fechaActivado"];
	                    }
	                    if (regAlarma.tipoEspecial == "SINACTIVIDAD" && regAlarma.nodo_id.estado === true && regAlarma.nodo_id.ubicacion_id.estado === true && regAlarma.nodo_id.ubicacion_id.sucursal_id.estado === true && regAlarma.nodo_id.ubicacion_id.sucursal_id.empresa.estado === true) {
	                        if (!_regAlarmas.get(regAlarma._id))
	                            _regAlarmas.set(regAlarma._id, _.clone(regAlarma));
	                        var _regAlarma = _regAlarmas.get(regAlarma._id);
	                        _regAlarma["fechaActivado"] = moment(_regAlarma["fechaActivado"]).isBefore(moment(regAlarma.fechaActivado), "minute") ? regAlarma.fechaActivado : _regAlarma["fechaActivado"];
	                    }
	                });
	                _this.regAlarmasRango = Array.from(_regAlarmasRango.values());
	                _this.regAlarmas = Array.from(_regAlarmas.values());
	                _this.alerta.emit({ alerta: alertaCalibracion });
	                _this.alertaNotificaciones.emit({ alertaNotificaciones: _this.regAlarmasRango.length + _this.regAlarmas.length });
	            });
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], NavRightComponent.prototype, "urlLogo", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], NavRightComponent.prototype, "alerta", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], NavRightComponent.prototype, "alertaNotificaciones", void 0);
	    NavRightComponent = __decorate([
	        core_1.Component({
	            selector: 'NavRight',
	            template: __webpack_require__(646),
	            styles: [__webpack_require__(650)],
	            directives: [router_1.ROUTER_DIRECTIVES],
	            pipes: [dateTimeZonePipe_1.DateTimeZonePipe]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof login_service_1.LoginService !== 'undefined' && login_service_1.LoginService) === 'function' && _a) || Object, (typeof (_b = typeof menu_service_1.MenuService !== 'undefined' && menu_service_1.MenuService) === 'function' && _b) || Object, (typeof (_c = typeof regAlarma_service_1.RegAlarmaService !== 'undefined' && regAlarma_service_1.RegAlarmaService) === 'function' && _c) || Object])
	    ], NavRightComponent);
	    return NavRightComponent;
	    var _a, _b, _c;
	}());
	exports.NavRightComponent = NavRightComponent;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(419)))

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var url = __webpack_require__(594);
	var parser = __webpack_require__(600);
	var Manager = __webpack_require__(610);
	var debug = __webpack_require__(596)('socket.io-client');
	
	/**
	 * Module exports.
	 */
	
	module.exports = exports = lookup;
	
	/**
	 * Managers cache.
	 */
	
	var cache = exports.managers = {};
	
	/**
	 * Looks up an existing `Manager` for multiplexing.
	 * If the user summons:
	 *
	 *   `io('http://localhost/a');`
	 *   `io('http://localhost/b');`
	 *
	 * We reuse the existing instance based on same scheme/port/host,
	 * and we initialize sockets for each namespace.
	 *
	 * @api public
	 */
	
	function lookup (uri, opts) {
	  if (typeof uri === 'object') {
	    opts = uri;
	    uri = undefined;
	  }
	
	  opts = opts || {};
	
	  var parsed = url(uri);
	  var source = parsed.source;
	  var id = parsed.id;
	  var path = parsed.path;
	  var sameNamespace = cache[id] && path in cache[id].nsps;
	  var newConnection = opts.forceNew || opts['force new connection'] ||
	                      false === opts.multiplex || sameNamespace;
	
	  var io;
	
	  if (newConnection) {
	    debug('ignoring socket cache for %s', source);
	    io = Manager(source, opts);
	  } else {
	    if (!cache[id]) {
	      debug('new io instance for %s', source);
	      cache[id] = Manager(source, opts);
	    }
	    io = cache[id];
	  }
	  if (parsed.query && !opts.query) {
	    opts.query = parsed.query;
	  } else if (opts && 'object' === typeof opts.query) {
	    opts.query = encodeQueryString(opts.query);
	  }
	  return io.socket(parsed.path, opts);
	}
	/**
	 *  Helper method to parse query objects to string.
	 * @param {object} query
	 * @returns {string}
	 */
	function encodeQueryString (obj) {
	  var str = [];
	  for (var p in obj) {
	    if (obj.hasOwnProperty(p)) {
	      str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
	    }
	  }
	  return str.join('&');
	}
	/**
	 * Protocol version.
	 *
	 * @api public
	 */
	
	exports.protocol = parser.protocol;
	
	/**
	 * `connect`.
	 *
	 * @param {String} uri
	 * @api public
	 */
	
	exports.connect = lookup;
	
	/**
	 * Expose constructors for standalone build.
	 *
	 * @api public
	 */
	
	exports.Manager = __webpack_require__(610);
	exports.Socket = __webpack_require__(640);


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module dependencies.
	 */
	
	var parseuri = __webpack_require__(595);
	var debug = __webpack_require__(596)('socket.io-client:url');
	
	/**
	 * Module exports.
	 */
	
	module.exports = url;
	
	/**
	 * URL parser.
	 *
	 * @param {String} url
	 * @param {Object} An object meant to mimic window.location.
	 *                 Defaults to window.location.
	 * @api public
	 */
	
	function url (uri, loc) {
	  var obj = uri;
	
	  // default to window.location
	  loc = loc || global.location;
	  if (null == uri) uri = loc.protocol + '//' + loc.host;
	
	  // relative path support
	  if ('string' === typeof uri) {
	    if ('/' === uri.charAt(0)) {
	      if ('/' === uri.charAt(1)) {
	        uri = loc.protocol + uri;
	      } else {
	        uri = loc.host + uri;
	      }
	    }
	
	    if (!/^(https?|wss?):\/\//.test(uri)) {
	      debug('protocol-less url %s', uri);
	      if ('undefined' !== typeof loc) {
	        uri = loc.protocol + '//' + uri;
	      } else {
	        uri = 'https://' + uri;
	      }
	    }
	
	    // parse
	    debug('parse %s', uri);
	    obj = parseuri(uri);
	  }
	
	  // make sure we treat `localhost:80` and `localhost` equally
	  if (!obj.port) {
	    if (/^(http|ws)$/.test(obj.protocol)) {
	      obj.port = '80';
	    } else if (/^(http|ws)s$/.test(obj.protocol)) {
	      obj.port = '443';
	    }
	  }
	
	  obj.path = obj.path || '/';
	
	  var ipv6 = obj.host.indexOf(':') !== -1;
	  var host = ipv6 ? '[' + obj.host + ']' : obj.host;
	
	  // define unique id
	  obj.id = obj.protocol + '://' + host + ':' + obj.port;
	  // define href
	  obj.href = obj.protocol + '://' + host + (loc && loc.port === obj.port ? '' : (':' + obj.port));
	
	  return obj;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 595 */
/***/ (function(module, exports) {

	/**
	 * Parses an URI
	 *
	 * @author Steven Levithan <stevenlevithan.com> (MIT license)
	 * @api private
	 */
	
	var re = /^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
	
	var parts = [
	    'source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'
	];
	
	module.exports = function parseuri(str) {
	    var src = str,
	        b = str.indexOf('['),
	        e = str.indexOf(']');
	
	    if (b != -1 && e != -1) {
	        str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
	    }
	
	    var m = re.exec(str || ''),
	        uri = {},
	        i = 14;
	
	    while (i--) {
	        uri[parts[i]] = m[i] || '';
	    }
	
	    if (b != -1 && e != -1) {
	        uri.source = src;
	        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
	        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
	        uri.ipv6uri = true;
	    }
	
	    return uri;
	};


/***/ }),
/* 596 */
[1356, 598],
/* 597 */,
/* 598 */
[1357, 599],
/* 599 */
/***/ (function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000
	var m = s * 60
	var h = m * 60
	var d = h * 24
	var y = d * 365.25
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} options
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function (val, options) {
	  options = options || {}
	  var type = typeof val
	  if (type === 'string' && val.length > 0) {
	    return parse(val)
	  } else if (type === 'number' && isNaN(val) === false) {
	    return options.long ?
				fmtLong(val) :
				fmtShort(val)
	  }
	  throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val))
	}
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = String(str)
	  if (str.length > 10000) {
	    return
	  }
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str)
	  if (!match) {
	    return
	  }
	  var n = parseFloat(match[1])
	  var type = (match[2] || 'ms').toLowerCase()
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n
	    default:
	      return undefined
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtShort(ms) {
	  if (ms >= d) {
	    return Math.round(ms / d) + 'd'
	  }
	  if (ms >= h) {
	    return Math.round(ms / h) + 'h'
	  }
	  if (ms >= m) {
	    return Math.round(ms / m) + 'm'
	  }
	  if (ms >= s) {
	    return Math.round(ms / s) + 's'
	  }
	  return ms + 'ms'
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtLong(ms) {
	  return plural(ms, d, 'day') ||
	    plural(ms, h, 'hour') ||
	    plural(ms, m, 'minute') ||
	    plural(ms, s, 'second') ||
	    ms + ' ms'
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) {
	    return
	  }
	  if (ms < n * 1.5) {
	    return Math.floor(ms / n) + ' ' + name
	  }
	  return Math.ceil(ms / n) + ' ' + name + 's'
	}


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var debug = __webpack_require__(601)('socket.io-parser');
	var json = __webpack_require__(604);
	var Emitter = __webpack_require__(606);
	var binary = __webpack_require__(607);
	var isBuf = __webpack_require__(609);
	
	/**
	 * Protocol version.
	 *
	 * @api public
	 */
	
	exports.protocol = 4;
	
	/**
	 * Packet types.
	 *
	 * @api public
	 */
	
	exports.types = [
	  'CONNECT',
	  'DISCONNECT',
	  'EVENT',
	  'ACK',
	  'ERROR',
	  'BINARY_EVENT',
	  'BINARY_ACK'
	];
	
	/**
	 * Packet type `connect`.
	 *
	 * @api public
	 */
	
	exports.CONNECT = 0;
	
	/**
	 * Packet type `disconnect`.
	 *
	 * @api public
	 */
	
	exports.DISCONNECT = 1;
	
	/**
	 * Packet type `event`.
	 *
	 * @api public
	 */
	
	exports.EVENT = 2;
	
	/**
	 * Packet type `ack`.
	 *
	 * @api public
	 */
	
	exports.ACK = 3;
	
	/**
	 * Packet type `error`.
	 *
	 * @api public
	 */
	
	exports.ERROR = 4;
	
	/**
	 * Packet type 'binary event'
	 *
	 * @api public
	 */
	
	exports.BINARY_EVENT = 5;
	
	/**
	 * Packet type `binary ack`. For acks with binary arguments.
	 *
	 * @api public
	 */
	
	exports.BINARY_ACK = 6;
	
	/**
	 * Encoder constructor.
	 *
	 * @api public
	 */
	
	exports.Encoder = Encoder;
	
	/**
	 * Decoder constructor.
	 *
	 * @api public
	 */
	
	exports.Decoder = Decoder;
	
	/**
	 * A socket.io Encoder instance
	 *
	 * @api public
	 */
	
	function Encoder() {}
	
	/**
	 * Encode a packet as a single string if non-binary, or as a
	 * buffer sequence, depending on packet type.
	 *
	 * @param {Object} obj - packet object
	 * @param {Function} callback - function to handle encodings (likely engine.write)
	 * @return Calls callback with Array of encodings
	 * @api public
	 */
	
	Encoder.prototype.encode = function(obj, callback){
	  debug('encoding packet %j', obj);
	
	  if (exports.BINARY_EVENT == obj.type || exports.BINARY_ACK == obj.type) {
	    encodeAsBinary(obj, callback);
	  }
	  else {
	    var encoding = encodeAsString(obj);
	    callback([encoding]);
	  }
	};
	
	/**
	 * Encode packet as string.
	 *
	 * @param {Object} packet
	 * @return {String} encoded
	 * @api private
	 */
	
	function encodeAsString(obj) {
	  var str = '';
	  var nsp = false;
	
	  // first is type
	  str += obj.type;
	
	  // attachments if we have them
	  if (exports.BINARY_EVENT == obj.type || exports.BINARY_ACK == obj.type) {
	    str += obj.attachments;
	    str += '-';
	  }
	
	  // if we have a namespace other than `/`
	  // we append it followed by a comma `,`
	  if (obj.nsp && '/' != obj.nsp) {
	    nsp = true;
	    str += obj.nsp;
	  }
	
	  // immediately followed by the id
	  if (null != obj.id) {
	    if (nsp) {
	      str += ',';
	      nsp = false;
	    }
	    str += obj.id;
	  }
	
	  // json data
	  if (null != obj.data) {
	    if (nsp) str += ',';
	    str += json.stringify(obj.data);
	  }
	
	  debug('encoded %j as %s', obj, str);
	  return str;
	}
	
	/**
	 * Encode packet as 'buffer sequence' by removing blobs, and
	 * deconstructing packet into object with placeholders and
	 * a list of buffers.
	 *
	 * @param {Object} packet
	 * @return {Buffer} encoded
	 * @api private
	 */
	
	function encodeAsBinary(obj, callback) {
	
	  function writeEncoding(bloblessData) {
	    var deconstruction = binary.deconstructPacket(bloblessData);
	    var pack = encodeAsString(deconstruction.packet);
	    var buffers = deconstruction.buffers;
	
	    buffers.unshift(pack); // add packet info to beginning of data list
	    callback(buffers); // write all the buffers
	  }
	
	  binary.removeBlobs(obj, writeEncoding);
	}
	
	/**
	 * A socket.io Decoder instance
	 *
	 * @return {Object} decoder
	 * @api public
	 */
	
	function Decoder() {
	  this.reconstructor = null;
	}
	
	/**
	 * Mix in `Emitter` with Decoder.
	 */
	
	Emitter(Decoder.prototype);
	
	/**
	 * Decodes an ecoded packet string into packet JSON.
	 *
	 * @param {String} obj - encoded packet
	 * @return {Object} packet
	 * @api public
	 */
	
	Decoder.prototype.add = function(obj) {
	  var packet;
	  if ('string' == typeof obj) {
	    packet = decodeString(obj);
	    if (exports.BINARY_EVENT == packet.type || exports.BINARY_ACK == packet.type) { // binary packet's json
	      this.reconstructor = new BinaryReconstructor(packet);
	
	      // no attachments, labeled binary but no binary data to follow
	      if (this.reconstructor.reconPack.attachments === 0) {
	        this.emit('decoded', packet);
	      }
	    } else { // non-binary full packet
	      this.emit('decoded', packet);
	    }
	  }
	  else if (isBuf(obj) || obj.base64) { // raw binary data
	    if (!this.reconstructor) {
	      throw new Error('got binary data when not reconstructing a packet');
	    } else {
	      packet = this.reconstructor.takeBinaryData(obj);
	      if (packet) { // received final buffer
	        this.reconstructor = null;
	        this.emit('decoded', packet);
	      }
	    }
	  }
	  else {
	    throw new Error('Unknown type: ' + obj);
	  }
	};
	
	/**
	 * Decode a packet String (JSON data)
	 *
	 * @param {String} str
	 * @return {Object} packet
	 * @api private
	 */
	
	function decodeString(str) {
	  var p = {};
	  var i = 0;
	
	  // look up type
	  p.type = Number(str.charAt(0));
	  if (null == exports.types[p.type]) return error();
	
	  // look up attachments if type binary
	  if (exports.BINARY_EVENT == p.type || exports.BINARY_ACK == p.type) {
	    var buf = '';
	    while (str.charAt(++i) != '-') {
	      buf += str.charAt(i);
	      if (i == str.length) break;
	    }
	    if (buf != Number(buf) || str.charAt(i) != '-') {
	      throw new Error('Illegal attachments');
	    }
	    p.attachments = Number(buf);
	  }
	
	  // look up namespace (if any)
	  if ('/' == str.charAt(i + 1)) {
	    p.nsp = '';
	    while (++i) {
	      var c = str.charAt(i);
	      if (',' == c) break;
	      p.nsp += c;
	      if (i == str.length) break;
	    }
	  } else {
	    p.nsp = '/';
	  }
	
	  // look up id
	  var next = str.charAt(i + 1);
	  if ('' !== next && Number(next) == next) {
	    p.id = '';
	    while (++i) {
	      var c = str.charAt(i);
	      if (null == c || Number(c) != c) {
	        --i;
	        break;
	      }
	      p.id += str.charAt(i);
	      if (i == str.length) break;
	    }
	    p.id = Number(p.id);
	  }
	
	  // look up json data
	  if (str.charAt(++i)) {
	    p = tryParse(p, str.substr(i));
	  }
	
	  debug('decoded %s as %j', str, p);
	  return p;
	}
	
	function tryParse(p, str) {
	  try {
	    p.data = json.parse(str);
	  } catch(e){
	    return error();
	  }
	  return p; 
	};
	
	/**
	 * Deallocates a parser's resources
	 *
	 * @api public
	 */
	
	Decoder.prototype.destroy = function() {
	  if (this.reconstructor) {
	    this.reconstructor.finishedReconstruction();
	  }
	};
	
	/**
	 * A manager of a binary event's 'buffer sequence'. Should
	 * be constructed whenever a packet of type BINARY_EVENT is
	 * decoded.
	 *
	 * @param {Object} packet
	 * @return {BinaryReconstructor} initialized reconstructor
	 * @api private
	 */
	
	function BinaryReconstructor(packet) {
	  this.reconPack = packet;
	  this.buffers = [];
	}
	
	/**
	 * Method to be called when binary data received from connection
	 * after a BINARY_EVENT packet.
	 *
	 * @param {Buffer | ArrayBuffer} binData - the raw binary data received
	 * @return {null | Object} returns null if more binary data is expected or
	 *   a reconstructed packet object if all buffers have been received.
	 * @api private
	 */
	
	BinaryReconstructor.prototype.takeBinaryData = function(binData) {
	  this.buffers.push(binData);
	  if (this.buffers.length == this.reconPack.attachments) { // done with buffer list
	    var packet = binary.reconstructPacket(this.reconPack, this.buffers);
	    this.finishedReconstruction();
	    return packet;
	  }
	  return null;
	};
	
	/**
	 * Cleans up binary packet reconstruction variables.
	 *
	 * @api private
	 */
	
	BinaryReconstructor.prototype.finishedReconstruction = function() {
	  this.reconPack = null;
	  this.buffers = [];
	};
	
	function error(data){
	  return {
	    type: exports.ERROR,
	    data: 'parser error'
	  };
	}


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(602);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  return ('WebkitAppearance' in document.documentElement.style) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (window.console && (console.firebug || (console.exception && console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31);
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  return JSON.stringify(v);
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs() {
	  var args = arguments;
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return args;
	
	  var c = 'color: ' + this.color;
	  args = [args[0], c, 'color: inherit'].concat(Array.prototype.slice.call(args, 1));
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	  return args;
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    r = exports.storage.debug;
	  } catch(e) {}
	  return r;
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage(){
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = debug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(603);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lowercased letter, i.e. "n".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previously assigned color.
	 */
	
	var prevColor = 0;
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 *
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor() {
	  return exports.colors[prevColor++ % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function debug(namespace) {
	
	  // define the `disabled` version
	  function disabled() {
	  }
	  disabled.enabled = false;
	
	  // define the `enabled` version
	  function enabled() {
	
	    var self = enabled;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // add the `color` if not set
	    if (null == self.useColors) self.useColors = exports.useColors();
	    if (null == self.color && self.useColors) self.color = selectColor();
	
	    var args = Array.prototype.slice.call(arguments);
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %o
	      args = ['%o'].concat(args);
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    if ('function' === typeof exports.formatArgs) {
	      args = exports.formatArgs.apply(self, args);
	    }
	    var logFn = enabled.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	  enabled.enabled = true;
	
	  var fn = exports.enabled(namespace) ? enabled : disabled;
	
	  fn.namespace = namespace;
	
	  return fn;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  var split = (namespaces || '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ }),
/* 603 */
/***/ (function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var y = d * 365.25;
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} options
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function(val, options){
	  options = options || {};
	  if ('string' == typeof val) return parse(val);
	  return options.long
	    ? long(val)
	    : short(val);
	};
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = '' + str;
	  if (str.length > 10000) return;
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
	  if (!match) return;
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function short(ms) {
	  if (ms >= d) return Math.round(ms / d) + 'd';
	  if (ms >= h) return Math.round(ms / h) + 'h';
	  if (ms >= m) return Math.round(ms / m) + 'm';
	  if (ms >= s) return Math.round(ms / s) + 's';
	  return ms + 'ms';
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function long(ms) {
	  return plural(ms, d, 'day')
	    || plural(ms, h, 'hour')
	    || plural(ms, m, 'minute')
	    || plural(ms, s, 'second')
	    || ms + ' ms';
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) return;
	  if (ms < n * 1.5) return Math.floor(ms / n) + ' ' + name;
	  return Math.ceil(ms / n) + ' ' + name + 's';
	}


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! JSON v3.3.2 | http://bestiejs.github.io/json3 | Copyright 2012-2014, Kit Cambridge | http://kit.mit-license.org */
	;(function () {
	  // Detect the `define` function exposed by asynchronous module loaders. The
	  // strict `define` check is necessary for compatibility with `r.js`.
	  var isLoader = "function" === "function" && __webpack_require__(605);
	
	  // A set of types used to distinguish objects from primitives.
	  var objectTypes = {
	    "function": true,
	    "object": true
	  };
	
	  // Detect the `exports` object exposed by CommonJS implementations.
	  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;
	
	  // Use the `global` object exposed by Node (including Browserify via
	  // `insert-module-globals`), Narwhal, and Ringo as the default context,
	  // and the `window` object in browsers. Rhino exports a `global` function
	  // instead.
	  var root = objectTypes[typeof window] && window || this,
	      freeGlobal = freeExports && objectTypes[typeof module] && module && !module.nodeType && typeof global == "object" && global;
	
	  if (freeGlobal && (freeGlobal["global"] === freeGlobal || freeGlobal["window"] === freeGlobal || freeGlobal["self"] === freeGlobal)) {
	    root = freeGlobal;
	  }
	
	  // Public: Initializes JSON 3 using the given `context` object, attaching the
	  // `stringify` and `parse` functions to the specified `exports` object.
	  function runInContext(context, exports) {
	    context || (context = root["Object"]());
	    exports || (exports = root["Object"]());
	
	    // Native constructor aliases.
	    var Number = context["Number"] || root["Number"],
	        String = context["String"] || root["String"],
	        Object = context["Object"] || root["Object"],
	        Date = context["Date"] || root["Date"],
	        SyntaxError = context["SyntaxError"] || root["SyntaxError"],
	        TypeError = context["TypeError"] || root["TypeError"],
	        Math = context["Math"] || root["Math"],
	        nativeJSON = context["JSON"] || root["JSON"];
	
	    // Delegate to the native `stringify` and `parse` implementations.
	    if (typeof nativeJSON == "object" && nativeJSON) {
	      exports.stringify = nativeJSON.stringify;
	      exports.parse = nativeJSON.parse;
	    }
	
	    // Convenience aliases.
	    var objectProto = Object.prototype,
	        getClass = objectProto.toString,
	        isProperty, forEach, undef;
	
	    // Test the `Date#getUTC*` methods. Based on work by @Yaffle.
	    var isExtended = new Date(-3509827334573292);
	    try {
	      // The `getUTCFullYear`, `Month`, and `Date` methods return nonsensical
	      // results for certain dates in Opera >= 10.53.
	      isExtended = isExtended.getUTCFullYear() == -109252 && isExtended.getUTCMonth() === 0 && isExtended.getUTCDate() === 1 &&
	        // Safari < 2.0.2 stores the internal millisecond time value correctly,
	        // but clips the values returned by the date methods to the range of
	        // signed 32-bit integers ([-2 ** 31, 2 ** 31 - 1]).
	        isExtended.getUTCHours() == 10 && isExtended.getUTCMinutes() == 37 && isExtended.getUTCSeconds() == 6 && isExtended.getUTCMilliseconds() == 708;
	    } catch (exception) {}
	
	    // Internal: Determines whether the native `JSON.stringify` and `parse`
	    // implementations are spec-compliant. Based on work by Ken Snyder.
	    function has(name) {
	      if (has[name] !== undef) {
	        // Return cached feature test result.
	        return has[name];
	      }
	      var isSupported;
	      if (name == "bug-string-char-index") {
	        // IE <= 7 doesn't support accessing string characters using square
	        // bracket notation. IE 8 only supports this for primitives.
	        isSupported = "a"[0] != "a";
	      } else if (name == "json") {
	        // Indicates whether both `JSON.stringify` and `JSON.parse` are
	        // supported.
	        isSupported = has("json-stringify") && has("json-parse");
	      } else {
	        var value, serialized = '{"a":[1,true,false,null,"\\u0000\\b\\n\\f\\r\\t"]}';
	        // Test `JSON.stringify`.
	        if (name == "json-stringify") {
	          var stringify = exports.stringify, stringifySupported = typeof stringify == "function" && isExtended;
	          if (stringifySupported) {
	            // A test function object with a custom `toJSON` method.
	            (value = function () {
	              return 1;
	            }).toJSON = value;
	            try {
	              stringifySupported =
	                // Firefox 3.1b1 and b2 serialize string, number, and boolean
	                // primitives as object literals.
	                stringify(0) === "0" &&
	                // FF 3.1b1, b2, and JSON 2 serialize wrapped primitives as object
	                // literals.
	                stringify(new Number()) === "0" &&
	                stringify(new String()) == '""' &&
	                // FF 3.1b1, 2 throw an error if the value is `null`, `undefined`, or
	                // does not define a canonical JSON representation (this applies to
	                // objects with `toJSON` properties as well, *unless* they are nested
	                // within an object or array).
	                stringify(getClass) === undef &&
	                // IE 8 serializes `undefined` as `"undefined"`. Safari <= 5.1.7 and
	                // FF 3.1b3 pass this test.
	                stringify(undef) === undef &&
	                // Safari <= 5.1.7 and FF 3.1b3 throw `Error`s and `TypeError`s,
	                // respectively, if the value is omitted entirely.
	                stringify() === undef &&
	                // FF 3.1b1, 2 throw an error if the given value is not a number,
	                // string, array, object, Boolean, or `null` literal. This applies to
	                // objects with custom `toJSON` methods as well, unless they are nested
	                // inside object or array literals. YUI 3.0.0b1 ignores custom `toJSON`
	                // methods entirely.
	                stringify(value) === "1" &&
	                stringify([value]) == "[1]" &&
	                // Prototype <= 1.6.1 serializes `[undefined]` as `"[]"` instead of
	                // `"[null]"`.
	                stringify([undef]) == "[null]" &&
	                // YUI 3.0.0b1 fails to serialize `null` literals.
	                stringify(null) == "null" &&
	                // FF 3.1b1, 2 halts serialization if an array contains a function:
	                // `[1, true, getClass, 1]` serializes as "[1,true,],". FF 3.1b3
	                // elides non-JSON values from objects and arrays, unless they
	                // define custom `toJSON` methods.
	                stringify([undef, getClass, null]) == "[null,null,null]" &&
	                // Simple serialization test. FF 3.1b1 uses Unicode escape sequences
	                // where character escape codes are expected (e.g., `\b` => `\u0008`).
	                stringify({ "a": [value, true, false, null, "\x00\b\n\f\r\t"] }) == serialized &&
	                // FF 3.1b1 and b2 ignore the `filter` and `width` arguments.
	                stringify(null, value) === "1" &&
	                stringify([1, 2], null, 1) == "[\n 1,\n 2\n]" &&
	                // JSON 2, Prototype <= 1.7, and older WebKit builds incorrectly
	                // serialize extended years.
	                stringify(new Date(-8.64e15)) == '"-271821-04-20T00:00:00.000Z"' &&
	                // The milliseconds are optional in ES 5, but required in 5.1.
	                stringify(new Date(8.64e15)) == '"+275760-09-13T00:00:00.000Z"' &&
	                // Firefox <= 11.0 incorrectly serializes years prior to 0 as negative
	                // four-digit years instead of six-digit years. Credits: @Yaffle.
	                stringify(new Date(-621987552e5)) == '"-000001-01-01T00:00:00.000Z"' &&
	                // Safari <= 5.1.5 and Opera >= 10.53 incorrectly serialize millisecond
	                // values less than 1000. Credits: @Yaffle.
	                stringify(new Date(-1)) == '"1969-12-31T23:59:59.999Z"';
	            } catch (exception) {
	              stringifySupported = false;
	            }
	          }
	          isSupported = stringifySupported;
	        }
	        // Test `JSON.parse`.
	        if (name == "json-parse") {
	          var parse = exports.parse;
	          if (typeof parse == "function") {
	            try {
	              // FF 3.1b1, b2 will throw an exception if a bare literal is provided.
	              // Conforming implementations should also coerce the initial argument to
	              // a string prior to parsing.
	              if (parse("0") === 0 && !parse(false)) {
	                // Simple parsing test.
	                value = parse(serialized);
	                var parseSupported = value["a"].length == 5 && value["a"][0] === 1;
	                if (parseSupported) {
	                  try {
	                    // Safari <= 5.1.2 and FF 3.1b1 allow unescaped tabs in strings.
	                    parseSupported = !parse('"\t"');
	                  } catch (exception) {}
	                  if (parseSupported) {
	                    try {
	                      // FF 4.0 and 4.0.1 allow leading `+` signs and leading
	                      // decimal points. FF 4.0, 4.0.1, and IE 9-10 also allow
	                      // certain octal literals.
	                      parseSupported = parse("01") !== 1;
	                    } catch (exception) {}
	                  }
	                  if (parseSupported) {
	                    try {
	                      // FF 4.0, 4.0.1, and Rhino 1.7R3-R4 allow trailing decimal
	                      // points. These environments, along with FF 3.1b1 and 2,
	                      // also allow trailing commas in JSON objects and arrays.
	                      parseSupported = parse("1.") !== 1;
	                    } catch (exception) {}
	                  }
	                }
	              }
	            } catch (exception) {
	              parseSupported = false;
	            }
	          }
	          isSupported = parseSupported;
	        }
	      }
	      return has[name] = !!isSupported;
	    }
	
	    if (!has("json")) {
	      // Common `[[Class]]` name aliases.
	      var functionClass = "[object Function]",
	          dateClass = "[object Date]",
	          numberClass = "[object Number]",
	          stringClass = "[object String]",
	          arrayClass = "[object Array]",
	          booleanClass = "[object Boolean]";
	
	      // Detect incomplete support for accessing string characters by index.
	      var charIndexBuggy = has("bug-string-char-index");
	
	      // Define additional utility methods if the `Date` methods are buggy.
	      if (!isExtended) {
	        var floor = Math.floor;
	        // A mapping between the months of the year and the number of days between
	        // January 1st and the first of the respective month.
	        var Months = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
	        // Internal: Calculates the number of days between the Unix epoch and the
	        // first day of the given month.
	        var getDay = function (year, month) {
	          return Months[month] + 365 * (year - 1970) + floor((year - 1969 + (month = +(month > 1))) / 4) - floor((year - 1901 + month) / 100) + floor((year - 1601 + month) / 400);
	        };
	      }
	
	      // Internal: Determines if a property is a direct property of the given
	      // object. Delegates to the native `Object#hasOwnProperty` method.
	      if (!(isProperty = objectProto.hasOwnProperty)) {
	        isProperty = function (property) {
	          var members = {}, constructor;
	          if ((members.__proto__ = null, members.__proto__ = {
	            // The *proto* property cannot be set multiple times in recent
	            // versions of Firefox and SeaMonkey.
	            "toString": 1
	          }, members).toString != getClass) {
	            // Safari <= 2.0.3 doesn't implement `Object#hasOwnProperty`, but
	            // supports the mutable *proto* property.
	            isProperty = function (property) {
	              // Capture and break the object's prototype chain (see section 8.6.2
	              // of the ES 5.1 spec). The parenthesized expression prevents an
	              // unsafe transformation by the Closure Compiler.
	              var original = this.__proto__, result = property in (this.__proto__ = null, this);
	              // Restore the original prototype chain.
	              this.__proto__ = original;
	              return result;
	            };
	          } else {
	            // Capture a reference to the top-level `Object` constructor.
	            constructor = members.constructor;
	            // Use the `constructor` property to simulate `Object#hasOwnProperty` in
	            // other environments.
	            isProperty = function (property) {
	              var parent = (this.constructor || constructor).prototype;
	              return property in this && !(property in parent && this[property] === parent[property]);
	            };
	          }
	          members = null;
	          return isProperty.call(this, property);
	        };
	      }
	
	      // Internal: Normalizes the `for...in` iteration algorithm across
	      // environments. Each enumerated key is yielded to a `callback` function.
	      forEach = function (object, callback) {
	        var size = 0, Properties, members, property;
	
	        // Tests for bugs in the current environment's `for...in` algorithm. The
	        // `valueOf` property inherits the non-enumerable flag from
	        // `Object.prototype` in older versions of IE, Netscape, and Mozilla.
	        (Properties = function () {
	          this.valueOf = 0;
	        }).prototype.valueOf = 0;
	
	        // Iterate over a new instance of the `Properties` class.
	        members = new Properties();
	        for (property in members) {
	          // Ignore all properties inherited from `Object.prototype`.
	          if (isProperty.call(members, property)) {
	            size++;
	          }
	        }
	        Properties = members = null;
	
	        // Normalize the iteration algorithm.
	        if (!size) {
	          // A list of non-enumerable properties inherited from `Object.prototype`.
	          members = ["valueOf", "toString", "toLocaleString", "propertyIsEnumerable", "isPrototypeOf", "hasOwnProperty", "constructor"];
	          // IE <= 8, Mozilla 1.0, and Netscape 6.2 ignore shadowed non-enumerable
	          // properties.
	          forEach = function (object, callback) {
	            var isFunction = getClass.call(object) == functionClass, property, length;
	            var hasProperty = !isFunction && typeof object.constructor != "function" && objectTypes[typeof object.hasOwnProperty] && object.hasOwnProperty || isProperty;
	            for (property in object) {
	              // Gecko <= 1.0 enumerates the `prototype` property of functions under
	              // certain conditions; IE does not.
	              if (!(isFunction && property == "prototype") && hasProperty.call(object, property)) {
	                callback(property);
	              }
	            }
	            // Manually invoke the callback for each non-enumerable property.
	            for (length = members.length; property = members[--length]; hasProperty.call(object, property) && callback(property));
	          };
	        } else if (size == 2) {
	          // Safari <= 2.0.4 enumerates shadowed properties twice.
	          forEach = function (object, callback) {
	            // Create a set of iterated properties.
	            var members = {}, isFunction = getClass.call(object) == functionClass, property;
	            for (property in object) {
	              // Store each property name to prevent double enumeration. The
	              // `prototype` property of functions is not enumerated due to cross-
	              // environment inconsistencies.
	              if (!(isFunction && property == "prototype") && !isProperty.call(members, property) && (members[property] = 1) && isProperty.call(object, property)) {
	                callback(property);
	              }
	            }
	          };
	        } else {
	          // No bugs detected; use the standard `for...in` algorithm.
	          forEach = function (object, callback) {
	            var isFunction = getClass.call(object) == functionClass, property, isConstructor;
	            for (property in object) {
	              if (!(isFunction && property == "prototype") && isProperty.call(object, property) && !(isConstructor = property === "constructor")) {
	                callback(property);
	              }
	            }
	            // Manually invoke the callback for the `constructor` property due to
	            // cross-environment inconsistencies.
	            if (isConstructor || isProperty.call(object, (property = "constructor"))) {
	              callback(property);
	            }
	          };
	        }
	        return forEach(object, callback);
	      };
	
	      // Public: Serializes a JavaScript `value` as a JSON string. The optional
	      // `filter` argument may specify either a function that alters how object and
	      // array members are serialized, or an array of strings and numbers that
	      // indicates which properties should be serialized. The optional `width`
	      // argument may be either a string or number that specifies the indentation
	      // level of the output.
	      if (!has("json-stringify")) {
	        // Internal: A map of control characters and their escaped equivalents.
	        var Escapes = {
	          92: "\\\\",
	          34: '\\"',
	          8: "\\b",
	          12: "\\f",
	          10: "\\n",
	          13: "\\r",
	          9: "\\t"
	        };
	
	        // Internal: Converts `value` into a zero-padded string such that its
	        // length is at least equal to `width`. The `width` must be <= 6.
	        var leadingZeroes = "000000";
	        var toPaddedString = function (width, value) {
	          // The `|| 0` expression is necessary to work around a bug in
	          // Opera <= 7.54u2 where `0 == -0`, but `String(-0) !== "0"`.
	          return (leadingZeroes + (value || 0)).slice(-width);
	        };
	
	        // Internal: Double-quotes a string `value`, replacing all ASCII control
	        // characters (characters with code unit values between 0 and 31) with
	        // their escaped equivalents. This is an implementation of the
	        // `Quote(value)` operation defined in ES 5.1 section 15.12.3.
	        var unicodePrefix = "\\u00";
	        var quote = function (value) {
	          var result = '"', index = 0, length = value.length, useCharIndex = !charIndexBuggy || length > 10;
	          var symbols = useCharIndex && (charIndexBuggy ? value.split("") : value);
	          for (; index < length; index++) {
	            var charCode = value.charCodeAt(index);
	            // If the character is a control character, append its Unicode or
	            // shorthand escape sequence; otherwise, append the character as-is.
	            switch (charCode) {
	              case 8: case 9: case 10: case 12: case 13: case 34: case 92:
	                result += Escapes[charCode];
	                break;
	              default:
	                if (charCode < 32) {
	                  result += unicodePrefix + toPaddedString(2, charCode.toString(16));
	                  break;
	                }
	                result += useCharIndex ? symbols[index] : value.charAt(index);
	            }
	          }
	          return result + '"';
	        };
	
	        // Internal: Recursively serializes an object. Implements the
	        // `Str(key, holder)`, `JO(value)`, and `JA(value)` operations.
	        var serialize = function (property, object, callback, properties, whitespace, indentation, stack) {
	          var value, className, year, month, date, time, hours, minutes, seconds, milliseconds, results, element, index, length, prefix, result;
	          try {
	            // Necessary for host object support.
	            value = object[property];
	          } catch (exception) {}
	          if (typeof value == "object" && value) {
	            className = getClass.call(value);
	            if (className == dateClass && !isProperty.call(value, "toJSON")) {
	              if (value > -1 / 0 && value < 1 / 0) {
	                // Dates are serialized according to the `Date#toJSON` method
	                // specified in ES 5.1 section 15.9.5.44. See section 15.9.1.15
	                // for the ISO 8601 date time string format.
	                if (getDay) {
	                  // Manually compute the year, month, date, hours, minutes,
	                  // seconds, and milliseconds if the `getUTC*` methods are
	                  // buggy. Adapted from @Yaffle's `date-shim` project.
	                  date = floor(value / 864e5);
	                  for (year = floor(date / 365.2425) + 1970 - 1; getDay(year + 1, 0) <= date; year++);
	                  for (month = floor((date - getDay(year, 0)) / 30.42); getDay(year, month + 1) <= date; month++);
	                  date = 1 + date - getDay(year, month);
	                  // The `time` value specifies the time within the day (see ES
	                  // 5.1 section 15.9.1.2). The formula `(A % B + B) % B` is used
	                  // to compute `A modulo B`, as the `%` operator does not
	                  // correspond to the `modulo` operation for negative numbers.
	                  time = (value % 864e5 + 864e5) % 864e5;
	                  // The hours, minutes, seconds, and milliseconds are obtained by
	                  // decomposing the time within the day. See section 15.9.1.10.
	                  hours = floor(time / 36e5) % 24;
	                  minutes = floor(time / 6e4) % 60;
	                  seconds = floor(time / 1e3) % 60;
	                  milliseconds = time % 1e3;
	                } else {
	                  year = value.getUTCFullYear();
	                  month = value.getUTCMonth();
	                  date = value.getUTCDate();
	                  hours = value.getUTCHours();
	                  minutes = value.getUTCMinutes();
	                  seconds = value.getUTCSeconds();
	                  milliseconds = value.getUTCMilliseconds();
	                }
	                // Serialize extended years correctly.
	                value = (year <= 0 || year >= 1e4 ? (year < 0 ? "-" : "+") + toPaddedString(6, year < 0 ? -year : year) : toPaddedString(4, year)) +
	                  "-" + toPaddedString(2, month + 1) + "-" + toPaddedString(2, date) +
	                  // Months, dates, hours, minutes, and seconds should have two
	                  // digits; milliseconds should have three.
	                  "T" + toPaddedString(2, hours) + ":" + toPaddedString(2, minutes) + ":" + toPaddedString(2, seconds) +
	                  // Milliseconds are optional in ES 5.0, but required in 5.1.
	                  "." + toPaddedString(3, milliseconds) + "Z";
	              } else {
	                value = null;
	              }
	            } else if (typeof value.toJSON == "function" && ((className != numberClass && className != stringClass && className != arrayClass) || isProperty.call(value, "toJSON"))) {
	              // Prototype <= 1.6.1 adds non-standard `toJSON` methods to the
	              // `Number`, `String`, `Date`, and `Array` prototypes. JSON 3
	              // ignores all `toJSON` methods on these objects unless they are
	              // defined directly on an instance.
	              value = value.toJSON(property);
	            }
	          }
	          if (callback) {
	            // If a replacement function was provided, call it to obtain the value
	            // for serialization.
	            value = callback.call(object, property, value);
	          }
	          if (value === null) {
	            return "null";
	          }
	          className = getClass.call(value);
	          if (className == booleanClass) {
	            // Booleans are represented literally.
	            return "" + value;
	          } else if (className == numberClass) {
	            // JSON numbers must be finite. `Infinity` and `NaN` are serialized as
	            // `"null"`.
	            return value > -1 / 0 && value < 1 / 0 ? "" + value : "null";
	          } else if (className == stringClass) {
	            // Strings are double-quoted and escaped.
	            return quote("" + value);
	          }
	          // Recursively serialize objects and arrays.
	          if (typeof value == "object") {
	            // Check for cyclic structures. This is a linear search; performance
	            // is inversely proportional to the number of unique nested objects.
	            for (length = stack.length; length--;) {
	              if (stack[length] === value) {
	                // Cyclic structures cannot be serialized by `JSON.stringify`.
	                throw TypeError();
	              }
	            }
	            // Add the object to the stack of traversed objects.
	            stack.push(value);
	            results = [];
	            // Save the current indentation level and indent one additional level.
	            prefix = indentation;
	            indentation += whitespace;
	            if (className == arrayClass) {
	              // Recursively serialize array elements.
	              for (index = 0, length = value.length; index < length; index++) {
	                element = serialize(index, value, callback, properties, whitespace, indentation, stack);
	                results.push(element === undef ? "null" : element);
	              }
	              result = results.length ? (whitespace ? "[\n" + indentation + results.join(",\n" + indentation) + "\n" + prefix + "]" : ("[" + results.join(",") + "]")) : "[]";
	            } else {
	              // Recursively serialize object members. Members are selected from
	              // either a user-specified list of property names, or the object
	              // itself.
	              forEach(properties || value, function (property) {
	                var element = serialize(property, value, callback, properties, whitespace, indentation, stack);
	                if (element !== undef) {
	                  // According to ES 5.1 section 15.12.3: "If `gap` {whitespace}
	                  // is not the empty string, let `member` {quote(property) + ":"}
	                  // be the concatenation of `member` and the `space` character."
	                  // The "`space` character" refers to the literal space
	                  // character, not the `space` {width} argument provided to
	                  // `JSON.stringify`.
	                  results.push(quote(property) + ":" + (whitespace ? " " : "") + element);
	                }
	              });
	              result = results.length ? (whitespace ? "{\n" + indentation + results.join(",\n" + indentation) + "\n" + prefix + "}" : ("{" + results.join(",") + "}")) : "{}";
	            }
	            // Remove the object from the traversed object stack.
	            stack.pop();
	            return result;
	          }
	        };
	
	        // Public: `JSON.stringify`. See ES 5.1 section 15.12.3.
	        exports.stringify = function (source, filter, width) {
	          var whitespace, callback, properties, className;
	          if (objectTypes[typeof filter] && filter) {
	            if ((className = getClass.call(filter)) == functionClass) {
	              callback = filter;
	            } else if (className == arrayClass) {
	              // Convert the property names array into a makeshift set.
	              properties = {};
	              for (var index = 0, length = filter.length, value; index < length; value = filter[index++], ((className = getClass.call(value)), className == stringClass || className == numberClass) && (properties[value] = 1));
	            }
	          }
	          if (width) {
	            if ((className = getClass.call(width)) == numberClass) {
	              // Convert the `width` to an integer and create a string containing
	              // `width` number of space characters.
	              if ((width -= width % 1) > 0) {
	                for (whitespace = "", width > 10 && (width = 10); whitespace.length < width; whitespace += " ");
	              }
	            } else if (className == stringClass) {
	              whitespace = width.length <= 10 ? width : width.slice(0, 10);
	            }
	          }
	          // Opera <= 7.54u2 discards the values associated with empty string keys
	          // (`""`) only if they are used directly within an object member list
	          // (e.g., `!("" in { "": 1})`).
	          return serialize("", (value = {}, value[""] = source, value), callback, properties, whitespace, "", []);
	        };
	      }
	
	      // Public: Parses a JSON source string.
	      if (!has("json-parse")) {
	        var fromCharCode = String.fromCharCode;
	
	        // Internal: A map of escaped control characters and their unescaped
	        // equivalents.
	        var Unescapes = {
	          92: "\\",
	          34: '"',
	          47: "/",
	          98: "\b",
	          116: "\t",
	          110: "\n",
	          102: "\f",
	          114: "\r"
	        };
	
	        // Internal: Stores the parser state.
	        var Index, Source;
	
	        // Internal: Resets the parser state and throws a `SyntaxError`.
	        var abort = function () {
	          Index = Source = null;
	          throw SyntaxError();
	        };
	
	        // Internal: Returns the next token, or `"$"` if the parser has reached
	        // the end of the source string. A token may be a string, number, `null`
	        // literal, or Boolean literal.
	        var lex = function () {
	          var source = Source, length = source.length, value, begin, position, isSigned, charCode;
	          while (Index < length) {
	            charCode = source.charCodeAt(Index);
	            switch (charCode) {
	              case 9: case 10: case 13: case 32:
	                // Skip whitespace tokens, including tabs, carriage returns, line
	                // feeds, and space characters.
	                Index++;
	                break;
	              case 123: case 125: case 91: case 93: case 58: case 44:
	                // Parse a punctuator token (`{`, `}`, `[`, `]`, `:`, or `,`) at
	                // the current position.
	                value = charIndexBuggy ? source.charAt(Index) : source[Index];
	                Index++;
	                return value;
	              case 34:
	                // `"` delimits a JSON string; advance to the next character and
	                // begin parsing the string. String tokens are prefixed with the
	                // sentinel `@` character to distinguish them from punctuators and
	                // end-of-string tokens.
	                for (value = "@", Index++; Index < length;) {
	                  charCode = source.charCodeAt(Index);
	                  if (charCode < 32) {
	                    // Unescaped ASCII control characters (those with a code unit
	                    // less than the space character) are not permitted.
	                    abort();
	                  } else if (charCode == 92) {
	                    // A reverse solidus (`\`) marks the beginning of an escaped
	                    // control character (including `"`, `\`, and `/`) or Unicode
	                    // escape sequence.
	                    charCode = source.charCodeAt(++Index);
	                    switch (charCode) {
	                      case 92: case 34: case 47: case 98: case 116: case 110: case 102: case 114:
	                        // Revive escaped control characters.
	                        value += Unescapes[charCode];
	                        Index++;
	                        break;
	                      case 117:
	                        // `\u` marks the beginning of a Unicode escape sequence.
	                        // Advance to the first character and validate the
	                        // four-digit code point.
	                        begin = ++Index;
	                        for (position = Index + 4; Index < position; Index++) {
	                          charCode = source.charCodeAt(Index);
	                          // A valid sequence comprises four hexdigits (case-
	                          // insensitive) that form a single hexadecimal value.
	                          if (!(charCode >= 48 && charCode <= 57 || charCode >= 97 && charCode <= 102 || charCode >= 65 && charCode <= 70)) {
	                            // Invalid Unicode escape sequence.
	                            abort();
	                          }
	                        }
	                        // Revive the escaped character.
	                        value += fromCharCode("0x" + source.slice(begin, Index));
	                        break;
	                      default:
	                        // Invalid escape sequence.
	                        abort();
	                    }
	                  } else {
	                    if (charCode == 34) {
	                      // An unescaped double-quote character marks the end of the
	                      // string.
	                      break;
	                    }
	                    charCode = source.charCodeAt(Index);
	                    begin = Index;
	                    // Optimize for the common case where a string is valid.
	                    while (charCode >= 32 && charCode != 92 && charCode != 34) {
	                      charCode = source.charCodeAt(++Index);
	                    }
	                    // Append the string as-is.
	                    value += source.slice(begin, Index);
	                  }
	                }
	                if (source.charCodeAt(Index) == 34) {
	                  // Advance to the next character and return the revived string.
	                  Index++;
	                  return value;
	                }
	                // Unterminated string.
	                abort();
	              default:
	                // Parse numbers and literals.
	                begin = Index;
	                // Advance past the negative sign, if one is specified.
	                if (charCode == 45) {
	                  isSigned = true;
	                  charCode = source.charCodeAt(++Index);
	                }
	                // Parse an integer or floating-point value.
	                if (charCode >= 48 && charCode <= 57) {
	                  // Leading zeroes are interpreted as octal literals.
	                  if (charCode == 48 && ((charCode = source.charCodeAt(Index + 1)), charCode >= 48 && charCode <= 57)) {
	                    // Illegal octal literal.
	                    abort();
	                  }
	                  isSigned = false;
	                  // Parse the integer component.
	                  for (; Index < length && ((charCode = source.charCodeAt(Index)), charCode >= 48 && charCode <= 57); Index++);
	                  // Floats cannot contain a leading decimal point; however, this
	                  // case is already accounted for by the parser.
	                  if (source.charCodeAt(Index) == 46) {
	                    position = ++Index;
	                    // Parse the decimal component.
	                    for (; position < length && ((charCode = source.charCodeAt(position)), charCode >= 48 && charCode <= 57); position++);
	                    if (position == Index) {
	                      // Illegal trailing decimal.
	                      abort();
	                    }
	                    Index = position;
	                  }
	                  // Parse exponents. The `e` denoting the exponent is
	                  // case-insensitive.
	                  charCode = source.charCodeAt(Index);
	                  if (charCode == 101 || charCode == 69) {
	                    charCode = source.charCodeAt(++Index);
	                    // Skip past the sign following the exponent, if one is
	                    // specified.
	                    if (charCode == 43 || charCode == 45) {
	                      Index++;
	                    }
	                    // Parse the exponential component.
	                    for (position = Index; position < length && ((charCode = source.charCodeAt(position)), charCode >= 48 && charCode <= 57); position++);
	                    if (position == Index) {
	                      // Illegal empty exponent.
	                      abort();
	                    }
	                    Index = position;
	                  }
	                  // Coerce the parsed value to a JavaScript number.
	                  return +source.slice(begin, Index);
	                }
	                // A negative sign may only precede numbers.
	                if (isSigned) {
	                  abort();
	                }
	                // `true`, `false`, and `null` literals.
	                if (source.slice(Index, Index + 4) == "true") {
	                  Index += 4;
	                  return true;
	                } else if (source.slice(Index, Index + 5) == "false") {
	                  Index += 5;
	                  return false;
	                } else if (source.slice(Index, Index + 4) == "null") {
	                  Index += 4;
	                  return null;
	                }
	                // Unrecognized token.
	                abort();
	            }
	          }
	          // Return the sentinel `$` character if the parser has reached the end
	          // of the source string.
	          return "$";
	        };
	
	        // Internal: Parses a JSON `value` token.
	        var get = function (value) {
	          var results, hasMembers;
	          if (value == "$") {
	            // Unexpected end of input.
	            abort();
	          }
	          if (typeof value == "string") {
	            if ((charIndexBuggy ? value.charAt(0) : value[0]) == "@") {
	              // Remove the sentinel `@` character.
	              return value.slice(1);
	            }
	            // Parse object and array literals.
	            if (value == "[") {
	              // Parses a JSON array, returning a new JavaScript array.
	              results = [];
	              for (;; hasMembers || (hasMembers = true)) {
	                value = lex();
	                // A closing square bracket marks the end of the array literal.
	                if (value == "]") {
	                  break;
	                }
	                // If the array literal contains elements, the current token
	                // should be a comma separating the previous element from the
	                // next.
	                if (hasMembers) {
	                  if (value == ",") {
	                    value = lex();
	                    if (value == "]") {
	                      // Unexpected trailing `,` in array literal.
	                      abort();
	                    }
	                  } else {
	                    // A `,` must separate each array element.
	                    abort();
	                  }
	                }
	                // Elisions and leading commas are not permitted.
	                if (value == ",") {
	                  abort();
	                }
	                results.push(get(value));
	              }
	              return results;
	            } else if (value == "{") {
	              // Parses a JSON object, returning a new JavaScript object.
	              results = {};
	              for (;; hasMembers || (hasMembers = true)) {
	                value = lex();
	                // A closing curly brace marks the end of the object literal.
	                if (value == "}") {
	                  break;
	                }
	                // If the object literal contains members, the current token
	                // should be a comma separator.
	                if (hasMembers) {
	                  if (value == ",") {
	                    value = lex();
	                    if (value == "}") {
	                      // Unexpected trailing `,` in object literal.
	                      abort();
	                    }
	                  } else {
	                    // A `,` must separate each object member.
	                    abort();
	                  }
	                }
	                // Leading commas are not permitted, object property names must be
	                // double-quoted strings, and a `:` must separate each property
	                // name and value.
	                if (value == "," || typeof value != "string" || (charIndexBuggy ? value.charAt(0) : value[0]) != "@" || lex() != ":") {
	                  abort();
	                }
	                results[value.slice(1)] = get(lex());
	              }
	              return results;
	            }
	            // Unexpected token encountered.
	            abort();
	          }
	          return value;
	        };
	
	        // Internal: Updates a traversed object member.
	        var update = function (source, property, callback) {
	          var element = walk(source, property, callback);
	          if (element === undef) {
	            delete source[property];
	          } else {
	            source[property] = element;
	          }
	        };
	
	        // Internal: Recursively traverses a parsed JSON object, invoking the
	        // `callback` function for each value. This is an implementation of the
	        // `Walk(holder, name)` operation defined in ES 5.1 section 15.12.2.
	        var walk = function (source, property, callback) {
	          var value = source[property], length;
	          if (typeof value == "object" && value) {
	            // `forEach` can't be used to traverse an array in Opera <= 8.54
	            // because its `Object#hasOwnProperty` implementation returns `false`
	            // for array indices (e.g., `![1, 2, 3].hasOwnProperty("0")`).
	            if (getClass.call(value) == arrayClass) {
	              for (length = value.length; length--;) {
	                update(value, length, callback);
	              }
	            } else {
	              forEach(value, function (property) {
	                update(value, property, callback);
	              });
	            }
	          }
	          return callback.call(source, property, value);
	        };
	
	        // Public: `JSON.parse`. See ES 5.1 section 15.12.2.
	        exports.parse = function (source, callback) {
	          var result, value;
	          Index = 0;
	          Source = "" + source;
	          result = get(lex());
	          // If a JSON string contains multiple tokens, it is invalid.
	          if (lex() != "$") {
	            abort();
	          }
	          // Reset the parser state.
	          Index = Source = null;
	          return callback && getClass.call(callback) == functionClass ? walk((value = {}, value[""] = result, value), "", callback) : result;
	        };
	      }
	    }
	
	    exports["runInContext"] = runInContext;
	    return exports;
	  }
	
	  if (freeExports && !isLoader) {
	    // Export for CommonJS environments.
	    runInContext(root, freeExports);
	  } else {
	    // Export for web browsers and JavaScript engines.
	    var nativeJSON = root.JSON,
	        previousJSON = root["JSON3"],
	        isRestored = false;
	
	    var JSON3 = runInContext(root, (root["JSON3"] = {
	      // Public: Restores the original value of the global `JSON` object and
	      // returns a reference to the `JSON3` object.
	      "noConflict": function () {
	        if (!isRestored) {
	          isRestored = true;
	          root.JSON = nativeJSON;
	          root["JSON3"] = previousJSON;
	          nativeJSON = previousJSON = null;
	        }
	        return JSON3;
	      }
	    }));
	
	    root.JSON = {
	      "parse": JSON3.parse,
	      "stringify": JSON3.stringify
	    };
	  }
	
	  // Export for asynchronous module loaders.
	  if (isLoader) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return JSON3;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(40)(module), (function() { return this; }())))

/***/ }),
/* 605 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 606 */
/***/ (function(module, exports) {

	
	/**
	 * Expose `Emitter`.
	 */
	
	module.exports = Emitter;
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks[event] = this._callbacks[event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  var self = this;
	  this._callbacks = this._callbacks || {};
	
	  function on() {
	    self.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks[event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks[event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	  var args = [].slice.call(arguments, 1)
	    , callbacks = this._callbacks[event];
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks[event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*global Blob,File*/
	
	/**
	 * Module requirements
	 */
	
	var isArray = __webpack_require__(608);
	var isBuf = __webpack_require__(609);
	
	/**
	 * Replaces every Buffer | ArrayBuffer in packet with a numbered placeholder.
	 * Anything with blobs or files should be fed through removeBlobs before coming
	 * here.
	 *
	 * @param {Object} packet - socket.io event packet
	 * @return {Object} with deconstructed packet and list of buffers
	 * @api public
	 */
	
	exports.deconstructPacket = function(packet){
	  var buffers = [];
	  var packetData = packet.data;
	
	  function _deconstructPacket(data) {
	    if (!data) return data;
	
	    if (isBuf(data)) {
	      var placeholder = { _placeholder: true, num: buffers.length };
	      buffers.push(data);
	      return placeholder;
	    } else if (isArray(data)) {
	      var newData = new Array(data.length);
	      for (var i = 0; i < data.length; i++) {
	        newData[i] = _deconstructPacket(data[i]);
	      }
	      return newData;
	    } else if ('object' == typeof data && !(data instanceof Date)) {
	      var newData = {};
	      for (var key in data) {
	        newData[key] = _deconstructPacket(data[key]);
	      }
	      return newData;
	    }
	    return data;
	  }
	
	  var pack = packet;
	  pack.data = _deconstructPacket(packetData);
	  pack.attachments = buffers.length; // number of binary 'attachments'
	  return {packet: pack, buffers: buffers};
	};
	
	/**
	 * Reconstructs a binary packet from its placeholder packet and buffers
	 *
	 * @param {Object} packet - event packet with placeholders
	 * @param {Array} buffers - binary buffers to put in placeholder positions
	 * @return {Object} reconstructed packet
	 * @api public
	 */
	
	exports.reconstructPacket = function(packet, buffers) {
	  var curPlaceHolder = 0;
	
	  function _reconstructPacket(data) {
	    if (data && data._placeholder) {
	      var buf = buffers[data.num]; // appropriate buffer (should be natural order anyway)
	      return buf;
	    } else if (isArray(data)) {
	      for (var i = 0; i < data.length; i++) {
	        data[i] = _reconstructPacket(data[i]);
	      }
	      return data;
	    } else if (data && 'object' == typeof data) {
	      for (var key in data) {
	        data[key] = _reconstructPacket(data[key]);
	      }
	      return data;
	    }
	    return data;
	  }
	
	  packet.data = _reconstructPacket(packet.data);
	  packet.attachments = undefined; // no longer useful
	  return packet;
	};
	
	/**
	 * Asynchronously removes Blobs or Files from data via
	 * FileReader's readAsArrayBuffer method. Used before encoding
	 * data as msgpack. Calls callback with the blobless data.
	 *
	 * @param {Object} data
	 * @param {Function} callback
	 * @api private
	 */
	
	exports.removeBlobs = function(data, callback) {
	  function _removeBlobs(obj, curKey, containingObject) {
	    if (!obj) return obj;
	
	    // convert any blob
	    if ((global.Blob && obj instanceof Blob) ||
	        (global.File && obj instanceof File)) {
	      pendingBlobs++;
	
	      // async filereader
	      var fileReader = new FileReader();
	      fileReader.onload = function() { // this.result == arraybuffer
	        if (containingObject) {
	          containingObject[curKey] = this.result;
	        }
	        else {
	          bloblessData = this.result;
	        }
	
	        // if nothing pending its callback time
	        if(! --pendingBlobs) {
	          callback(bloblessData);
	        }
	      };
	
	      fileReader.readAsArrayBuffer(obj); // blob -> arraybuffer
	    } else if (isArray(obj)) { // handle array
	      for (var i = 0; i < obj.length; i++) {
	        _removeBlobs(obj[i], i, obj);
	      }
	    } else if (obj && 'object' == typeof obj && !isBuf(obj)) { // and object
	      for (var key in obj) {
	        _removeBlobs(obj[key], key, obj);
	      }
	    }
	  }
	
	  var pendingBlobs = 0;
	  var bloblessData = data;
	  _removeBlobs(bloblessData);
	  if (!pendingBlobs) {
	    callback(bloblessData);
	  }
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 608 */
/***/ (function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 609 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	module.exports = isBuf;
	
	/**
	 * Returns true if obj is a buffer or an arraybuffer.
	 *
	 * @api private
	 */
	
	function isBuf(obj) {
	  return (global.Buffer && global.Buffer.isBuffer(obj)) ||
	         (global.ArrayBuffer && obj instanceof ArrayBuffer);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var eio = __webpack_require__(611);
	var Socket = __webpack_require__(640);
	var Emitter = __webpack_require__(628);
	var parser = __webpack_require__(600);
	var on = __webpack_require__(642);
	var bind = __webpack_require__(643);
	var debug = __webpack_require__(596)('socket.io-client:manager');
	var indexOf = __webpack_require__(638);
	var Backoff = __webpack_require__(644);
	
	/**
	 * IE6+ hasOwnProperty
	 */
	
	var has = Object.prototype.hasOwnProperty;
	
	/**
	 * Module exports
	 */
	
	module.exports = Manager;
	
	/**
	 * `Manager` constructor.
	 *
	 * @param {String} engine instance or engine uri/opts
	 * @param {Object} options
	 * @api public
	 */
	
	function Manager (uri, opts) {
	  if (!(this instanceof Manager)) return new Manager(uri, opts);
	  if (uri && ('object' === typeof uri)) {
	    opts = uri;
	    uri = undefined;
	  }
	  opts = opts || {};
	
	  opts.path = opts.path || '/socket.io';
	  this.nsps = {};
	  this.subs = [];
	  this.opts = opts;
	  this.reconnection(opts.reconnection !== false);
	  this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
	  this.reconnectionDelay(opts.reconnectionDelay || 1000);
	  this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
	  this.randomizationFactor(opts.randomizationFactor || 0.5);
	  this.backoff = new Backoff({
	    min: this.reconnectionDelay(),
	    max: this.reconnectionDelayMax(),
	    jitter: this.randomizationFactor()
	  });
	  this.timeout(null == opts.timeout ? 20000 : opts.timeout);
	  this.readyState = 'closed';
	  this.uri = uri;
	  this.connecting = [];
	  this.lastPing = null;
	  this.encoding = false;
	  this.packetBuffer = [];
	  this.encoder = new parser.Encoder();
	  this.decoder = new parser.Decoder();
	  this.autoConnect = opts.autoConnect !== false;
	  if (this.autoConnect) this.open();
	}
	
	/**
	 * Propagate given event to sockets and emit on `this`
	 *
	 * @api private
	 */
	
	Manager.prototype.emitAll = function () {
	  this.emit.apply(this, arguments);
	  for (var nsp in this.nsps) {
	    if (has.call(this.nsps, nsp)) {
	      this.nsps[nsp].emit.apply(this.nsps[nsp], arguments);
	    }
	  }
	};
	
	/**
	 * Update `socket.id` of all sockets
	 *
	 * @api private
	 */
	
	Manager.prototype.updateSocketIds = function () {
	  for (var nsp in this.nsps) {
	    if (has.call(this.nsps, nsp)) {
	      this.nsps[nsp].id = this.engine.id;
	    }
	  }
	};
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Manager.prototype);
	
	/**
	 * Sets the `reconnection` config.
	 *
	 * @param {Boolean} true/false if it should automatically reconnect
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnection = function (v) {
	  if (!arguments.length) return this._reconnection;
	  this._reconnection = !!v;
	  return this;
	};
	
	/**
	 * Sets the reconnection attempts config.
	 *
	 * @param {Number} max reconnection attempts before giving up
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnectionAttempts = function (v) {
	  if (!arguments.length) return this._reconnectionAttempts;
	  this._reconnectionAttempts = v;
	  return this;
	};
	
	/**
	 * Sets the delay between reconnections.
	 *
	 * @param {Number} delay
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnectionDelay = function (v) {
	  if (!arguments.length) return this._reconnectionDelay;
	  this._reconnectionDelay = v;
	  this.backoff && this.backoff.setMin(v);
	  return this;
	};
	
	Manager.prototype.randomizationFactor = function (v) {
	  if (!arguments.length) return this._randomizationFactor;
	  this._randomizationFactor = v;
	  this.backoff && this.backoff.setJitter(v);
	  return this;
	};
	
	/**
	 * Sets the maximum delay between reconnections.
	 *
	 * @param {Number} delay
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnectionDelayMax = function (v) {
	  if (!arguments.length) return this._reconnectionDelayMax;
	  this._reconnectionDelayMax = v;
	  this.backoff && this.backoff.setMax(v);
	  return this;
	};
	
	/**
	 * Sets the connection timeout. `false` to disable
	 *
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.timeout = function (v) {
	  if (!arguments.length) return this._timeout;
	  this._timeout = v;
	  return this;
	};
	
	/**
	 * Starts trying to reconnect if reconnection is enabled and we have not
	 * started reconnecting yet
	 *
	 * @api private
	 */
	
	Manager.prototype.maybeReconnectOnOpen = function () {
	  // Only try to reconnect if it's the first time we're connecting
	  if (!this.reconnecting && this._reconnection && this.backoff.attempts === 0) {
	    // keeps reconnection from firing twice for the same reconnection loop
	    this.reconnect();
	  }
	};
	
	/**
	 * Sets the current transport `socket`.
	 *
	 * @param {Function} optional, callback
	 * @return {Manager} self
	 * @api public
	 */
	
	Manager.prototype.open =
	Manager.prototype.connect = function (fn, opts) {
	  debug('readyState %s', this.readyState);
	  if (~this.readyState.indexOf('open')) return this;
	
	  debug('opening %s', this.uri);
	  this.engine = eio(this.uri, this.opts);
	  var socket = this.engine;
	  var self = this;
	  this.readyState = 'opening';
	  this.skipReconnect = false;
	
	  // emit `open`
	  var openSub = on(socket, 'open', function () {
	    self.onopen();
	    fn && fn();
	  });
	
	  // emit `connect_error`
	  var errorSub = on(socket, 'error', function (data) {
	    debug('connect_error');
	    self.cleanup();
	    self.readyState = 'closed';
	    self.emitAll('connect_error', data);
	    if (fn) {
	      var err = new Error('Connection error');
	      err.data = data;
	      fn(err);
	    } else {
	      // Only do this if there is no fn to handle the error
	      self.maybeReconnectOnOpen();
	    }
	  });
	
	  // emit `connect_timeout`
	  if (false !== this._timeout) {
	    var timeout = this._timeout;
	    debug('connect attempt will timeout after %d', timeout);
	
	    // set timer
	    var timer = setTimeout(function () {
	      debug('connect attempt timed out after %d', timeout);
	      openSub.destroy();
	      socket.close();
	      socket.emit('error', 'timeout');
	      self.emitAll('connect_timeout', timeout);
	    }, timeout);
	
	    this.subs.push({
	      destroy: function () {
	        clearTimeout(timer);
	      }
	    });
	  }
	
	  this.subs.push(openSub);
	  this.subs.push(errorSub);
	
	  return this;
	};
	
	/**
	 * Called upon transport open.
	 *
	 * @api private
	 */
	
	Manager.prototype.onopen = function () {
	  debug('open');
	
	  // clear old subs
	  this.cleanup();
	
	  // mark as open
	  this.readyState = 'open';
	  this.emit('open');
	
	  // add new subs
	  var socket = this.engine;
	  this.subs.push(on(socket, 'data', bind(this, 'ondata')));
	  this.subs.push(on(socket, 'ping', bind(this, 'onping')));
	  this.subs.push(on(socket, 'pong', bind(this, 'onpong')));
	  this.subs.push(on(socket, 'error', bind(this, 'onerror')));
	  this.subs.push(on(socket, 'close', bind(this, 'onclose')));
	  this.subs.push(on(this.decoder, 'decoded', bind(this, 'ondecoded')));
	};
	
	/**
	 * Called upon a ping.
	 *
	 * @api private
	 */
	
	Manager.prototype.onping = function () {
	  this.lastPing = new Date();
	  this.emitAll('ping');
	};
	
	/**
	 * Called upon a packet.
	 *
	 * @api private
	 */
	
	Manager.prototype.onpong = function () {
	  this.emitAll('pong', new Date() - this.lastPing);
	};
	
	/**
	 * Called with data.
	 *
	 * @api private
	 */
	
	Manager.prototype.ondata = function (data) {
	  this.decoder.add(data);
	};
	
	/**
	 * Called when parser fully decodes a packet.
	 *
	 * @api private
	 */
	
	Manager.prototype.ondecoded = function (packet) {
	  this.emit('packet', packet);
	};
	
	/**
	 * Called upon socket error.
	 *
	 * @api private
	 */
	
	Manager.prototype.onerror = function (err) {
	  debug('error', err);
	  this.emitAll('error', err);
	};
	
	/**
	 * Creates a new socket for the given `nsp`.
	 *
	 * @return {Socket}
	 * @api public
	 */
	
	Manager.prototype.socket = function (nsp, opts) {
	  var socket = this.nsps[nsp];
	  if (!socket) {
	    socket = new Socket(this, nsp, opts);
	    this.nsps[nsp] = socket;
	    var self = this;
	    socket.on('connecting', onConnecting);
	    socket.on('connect', function () {
	      socket.id = self.engine.id;
	    });
	
	    if (this.autoConnect) {
	      // manually call here since connecting evnet is fired before listening
	      onConnecting();
	    }
	  }
	
	  function onConnecting () {
	    if (!~indexOf(self.connecting, socket)) {
	      self.connecting.push(socket);
	    }
	  }
	
	  return socket;
	};
	
	/**
	 * Called upon a socket close.
	 *
	 * @param {Socket} socket
	 */
	
	Manager.prototype.destroy = function (socket) {
	  var index = indexOf(this.connecting, socket);
	  if (~index) this.connecting.splice(index, 1);
	  if (this.connecting.length) return;
	
	  this.close();
	};
	
	/**
	 * Writes a packet.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Manager.prototype.packet = function (packet) {
	  debug('writing packet %j', packet);
	  var self = this;
	  if (packet.query && packet.type === 0) packet.nsp += '?' + packet.query;
	
	  if (!self.encoding) {
	    // encode, then write to engine with result
	    self.encoding = true;
	    this.encoder.encode(packet, function (encodedPackets) {
	      for (var i = 0; i < encodedPackets.length; i++) {
	        self.engine.write(encodedPackets[i], packet.options);
	      }
	      self.encoding = false;
	      self.processPacketQueue();
	    });
	  } else { // add packet to the queue
	    self.packetBuffer.push(packet);
	  }
	};
	
	/**
	 * If packet buffer is non-empty, begins encoding the
	 * next packet in line.
	 *
	 * @api private
	 */
	
	Manager.prototype.processPacketQueue = function () {
	  if (this.packetBuffer.length > 0 && !this.encoding) {
	    var pack = this.packetBuffer.shift();
	    this.packet(pack);
	  }
	};
	
	/**
	 * Clean up transport subscriptions and packet buffer.
	 *
	 * @api private
	 */
	
	Manager.prototype.cleanup = function () {
	  debug('cleanup');
	
	  var subsLength = this.subs.length;
	  for (var i = 0; i < subsLength; i++) {
	    var sub = this.subs.shift();
	    sub.destroy();
	  }
	
	  this.packetBuffer = [];
	  this.encoding = false;
	  this.lastPing = null;
	
	  this.decoder.destroy();
	};
	
	/**
	 * Close the current socket.
	 *
	 * @api private
	 */
	
	Manager.prototype.close =
	Manager.prototype.disconnect = function () {
	  debug('disconnect');
	  this.skipReconnect = true;
	  this.reconnecting = false;
	  if ('opening' === this.readyState) {
	    // `onclose` will not fire because
	    // an open event never happened
	    this.cleanup();
	  }
	  this.backoff.reset();
	  this.readyState = 'closed';
	  if (this.engine) this.engine.close();
	};
	
	/**
	 * Called upon engine close.
	 *
	 * @api private
	 */
	
	Manager.prototype.onclose = function (reason) {
	  debug('onclose');
	
	  this.cleanup();
	  this.backoff.reset();
	  this.readyState = 'closed';
	  this.emit('close', reason);
	
	  if (this._reconnection && !this.skipReconnect) {
	    this.reconnect();
	  }
	};
	
	/**
	 * Attempt a reconnection.
	 *
	 * @api private
	 */
	
	Manager.prototype.reconnect = function () {
	  if (this.reconnecting || this.skipReconnect) return this;
	
	  var self = this;
	
	  if (this.backoff.attempts >= this._reconnectionAttempts) {
	    debug('reconnect failed');
	    this.backoff.reset();
	    this.emitAll('reconnect_failed');
	    this.reconnecting = false;
	  } else {
	    var delay = this.backoff.duration();
	    debug('will wait %dms before reconnect attempt', delay);
	
	    this.reconnecting = true;
	    var timer = setTimeout(function () {
	      if (self.skipReconnect) return;
	
	      debug('attempting reconnect');
	      self.emitAll('reconnect_attempt', self.backoff.attempts);
	      self.emitAll('reconnecting', self.backoff.attempts);
	
	      // check again for the case socket closed in above events
	      if (self.skipReconnect) return;
	
	      self.open(function (err) {
	        if (err) {
	          debug('reconnect attempt error');
	          self.reconnecting = false;
	          self.reconnect();
	          self.emitAll('reconnect_error', err.data);
	        } else {
	          debug('reconnect success');
	          self.onreconnect();
	        }
	      });
	    }, delay);
	
	    this.subs.push({
	      destroy: function () {
	        clearTimeout(timer);
	      }
	    });
	  }
	};
	
	/**
	 * Called upon successful reconnect.
	 *
	 * @api private
	 */
	
	Manager.prototype.onreconnect = function () {
	  var attempt = this.backoff.attempts;
	  this.reconnecting = false;
	  this.backoff.reset();
	  this.updateSocketIds();
	  this.emitAll('reconnect', attempt);
	};


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	
	module.exports = __webpack_require__(612);


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	
	module.exports = __webpack_require__(613);
	
	/**
	 * Exports parser
	 *
	 * @api public
	 *
	 */
	module.exports.parser = __webpack_require__(620);


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module dependencies.
	 */
	
	var transports = __webpack_require__(614);
	var Emitter = __webpack_require__(628);
	var debug = __webpack_require__(632)('engine.io-client:socket');
	var index = __webpack_require__(638);
	var parser = __webpack_require__(620);
	var parseuri = __webpack_require__(595);
	var parsejson = __webpack_require__(639);
	var parseqs = __webpack_require__(629);
	
	/**
	 * Module exports.
	 */
	
	module.exports = Socket;
	
	/**
	 * Socket constructor.
	 *
	 * @param {String|Object} uri or options
	 * @param {Object} options
	 * @api public
	 */
	
	function Socket (uri, opts) {
	  if (!(this instanceof Socket)) return new Socket(uri, opts);
	
	  opts = opts || {};
	
	  if (uri && 'object' === typeof uri) {
	    opts = uri;
	    uri = null;
	  }
	
	  if (uri) {
	    uri = parseuri(uri);
	    opts.hostname = uri.host;
	    opts.secure = uri.protocol === 'https' || uri.protocol === 'wss';
	    opts.port = uri.port;
	    if (uri.query) opts.query = uri.query;
	  } else if (opts.host) {
	    opts.hostname = parseuri(opts.host).host;
	  }
	
	  this.secure = null != opts.secure ? opts.secure
	    : (global.location && 'https:' === location.protocol);
	
	  if (opts.hostname && !opts.port) {
	    // if no port is specified manually, use the protocol default
	    opts.port = this.secure ? '443' : '80';
	  }
	
	  this.agent = opts.agent || false;
	  this.hostname = opts.hostname ||
	    (global.location ? location.hostname : 'localhost');
	  this.port = opts.port || (global.location && location.port
	      ? location.port
	      : (this.secure ? 443 : 80));
	  this.query = opts.query || {};
	  if ('string' === typeof this.query) this.query = parseqs.decode(this.query);
	  this.upgrade = false !== opts.upgrade;
	  this.path = (opts.path || '/engine.io').replace(/\/$/, '') + '/';
	  this.forceJSONP = !!opts.forceJSONP;
	  this.jsonp = false !== opts.jsonp;
	  this.forceBase64 = !!opts.forceBase64;
	  this.enablesXDR = !!opts.enablesXDR;
	  this.timestampParam = opts.timestampParam || 't';
	  this.timestampRequests = opts.timestampRequests;
	  this.transports = opts.transports || ['polling', 'websocket'];
	  this.readyState = '';
	  this.writeBuffer = [];
	  this.prevBufferLen = 0;
	  this.policyPort = opts.policyPort || 843;
	  this.rememberUpgrade = opts.rememberUpgrade || false;
	  this.binaryType = null;
	  this.onlyBinaryUpgrades = opts.onlyBinaryUpgrades;
	  this.perMessageDeflate = false !== opts.perMessageDeflate ? (opts.perMessageDeflate || {}) : false;
	
	  if (true === this.perMessageDeflate) this.perMessageDeflate = {};
	  if (this.perMessageDeflate && null == this.perMessageDeflate.threshold) {
	    this.perMessageDeflate.threshold = 1024;
	  }
	
	  // SSL options for Node.js client
	  this.pfx = opts.pfx || null;
	  this.key = opts.key || null;
	  this.passphrase = opts.passphrase || null;
	  this.cert = opts.cert || null;
	  this.ca = opts.ca || null;
	  this.ciphers = opts.ciphers || null;
	  this.rejectUnauthorized = opts.rejectUnauthorized === undefined ? null : opts.rejectUnauthorized;
	  this.forceNode = !!opts.forceNode;
	
	  // other options for Node.js client
	  var freeGlobal = typeof global === 'object' && global;
	  if (freeGlobal.global === freeGlobal) {
	    if (opts.extraHeaders && Object.keys(opts.extraHeaders).length > 0) {
	      this.extraHeaders = opts.extraHeaders;
	    }
	
	    if (opts.localAddress) {
	      this.localAddress = opts.localAddress;
	    }
	  }
	
	  // set on handshake
	  this.id = null;
	  this.upgrades = null;
	  this.pingInterval = null;
	  this.pingTimeout = null;
	
	  // set on heartbeat
	  this.pingIntervalTimer = null;
	  this.pingTimeoutTimer = null;
	
	  this.open();
	}
	
	Socket.priorWebsocketSuccess = false;
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Socket.prototype);
	
	/**
	 * Protocol version.
	 *
	 * @api public
	 */
	
	Socket.protocol = parser.protocol; // this is an int
	
	/**
	 * Expose deps for legacy compatibility
	 * and standalone browser access.
	 */
	
	Socket.Socket = Socket;
	Socket.Transport = __webpack_require__(619);
	Socket.transports = __webpack_require__(614);
	Socket.parser = __webpack_require__(620);
	
	/**
	 * Creates transport of the given type.
	 *
	 * @param {String} transport name
	 * @return {Transport}
	 * @api private
	 */
	
	Socket.prototype.createTransport = function (name) {
	  debug('creating transport "%s"', name);
	  var query = clone(this.query);
	
	  // append engine.io protocol identifier
	  query.EIO = parser.protocol;
	
	  // transport name
	  query.transport = name;
	
	  // session id if we already have one
	  if (this.id) query.sid = this.id;
	
	  var transport = new transports[name]({
	    agent: this.agent,
	    hostname: this.hostname,
	    port: this.port,
	    secure: this.secure,
	    path: this.path,
	    query: query,
	    forceJSONP: this.forceJSONP,
	    jsonp: this.jsonp,
	    forceBase64: this.forceBase64,
	    enablesXDR: this.enablesXDR,
	    timestampRequests: this.timestampRequests,
	    timestampParam: this.timestampParam,
	    policyPort: this.policyPort,
	    socket: this,
	    pfx: this.pfx,
	    key: this.key,
	    passphrase: this.passphrase,
	    cert: this.cert,
	    ca: this.ca,
	    ciphers: this.ciphers,
	    rejectUnauthorized: this.rejectUnauthorized,
	    perMessageDeflate: this.perMessageDeflate,
	    extraHeaders: this.extraHeaders,
	    forceNode: this.forceNode,
	    localAddress: this.localAddress
	  });
	
	  return transport;
	};
	
	function clone (obj) {
	  var o = {};
	  for (var i in obj) {
	    if (obj.hasOwnProperty(i)) {
	      o[i] = obj[i];
	    }
	  }
	  return o;
	}
	
	/**
	 * Initializes transport to use and starts probe.
	 *
	 * @api private
	 */
	Socket.prototype.open = function () {
	  var transport;
	  if (this.rememberUpgrade && Socket.priorWebsocketSuccess && this.transports.indexOf('websocket') !== -1) {
	    transport = 'websocket';
	  } else if (0 === this.transports.length) {
	    // Emit error on next tick so it can be listened to
	    var self = this;
	    setTimeout(function () {
	      self.emit('error', 'No transports available');
	    }, 0);
	    return;
	  } else {
	    transport = this.transports[0];
	  }
	  this.readyState = 'opening';
	
	  // Retry with the next transport if the transport is disabled (jsonp: false)
	  try {
	    transport = this.createTransport(transport);
	  } catch (e) {
	    this.transports.shift();
	    this.open();
	    return;
	  }
	
	  transport.open();
	  this.setTransport(transport);
	};
	
	/**
	 * Sets the current transport. Disables the existing one (if any).
	 *
	 * @api private
	 */
	
	Socket.prototype.setTransport = function (transport) {
	  debug('setting transport %s', transport.name);
	  var self = this;
	
	  if (this.transport) {
	    debug('clearing existing transport %s', this.transport.name);
	    this.transport.removeAllListeners();
	  }
	
	  // set up transport
	  this.transport = transport;
	
	  // set up transport listeners
	  transport
	  .on('drain', function () {
	    self.onDrain();
	  })
	  .on('packet', function (packet) {
	    self.onPacket(packet);
	  })
	  .on('error', function (e) {
	    self.onError(e);
	  })
	  .on('close', function () {
	    self.onClose('transport close');
	  });
	};
	
	/**
	 * Probes a transport.
	 *
	 * @param {String} transport name
	 * @api private
	 */
	
	Socket.prototype.probe = function (name) {
	  debug('probing transport "%s"', name);
	  var transport = this.createTransport(name, { probe: 1 });
	  var failed = false;
	  var self = this;
	
	  Socket.priorWebsocketSuccess = false;
	
	  function onTransportOpen () {
	    if (self.onlyBinaryUpgrades) {
	      var upgradeLosesBinary = !this.supportsBinary && self.transport.supportsBinary;
	      failed = failed || upgradeLosesBinary;
	    }
	    if (failed) return;
	
	    debug('probe transport "%s" opened', name);
	    transport.send([{ type: 'ping', data: 'probe' }]);
	    transport.once('packet', function (msg) {
	      if (failed) return;
	      if ('pong' === msg.type && 'probe' === msg.data) {
	        debug('probe transport "%s" pong', name);
	        self.upgrading = true;
	        self.emit('upgrading', transport);
	        if (!transport) return;
	        Socket.priorWebsocketSuccess = 'websocket' === transport.name;
	
	        debug('pausing current transport "%s"', self.transport.name);
	        self.transport.pause(function () {
	          if (failed) return;
	          if ('closed' === self.readyState) return;
	          debug('changing transport and sending upgrade packet');
	
	          cleanup();
	
	          self.setTransport(transport);
	          transport.send([{ type: 'upgrade' }]);
	          self.emit('upgrade', transport);
	          transport = null;
	          self.upgrading = false;
	          self.flush();
	        });
	      } else {
	        debug('probe transport "%s" failed', name);
	        var err = new Error('probe error');
	        err.transport = transport.name;
	        self.emit('upgradeError', err);
	      }
	    });
	  }
	
	  function freezeTransport () {
	    if (failed) return;
	
	    // Any callback called by transport should be ignored since now
	    failed = true;
	
	    cleanup();
	
	    transport.close();
	    transport = null;
	  }
	
	  // Handle any error that happens while probing
	  function onerror (err) {
	    var error = new Error('probe error: ' + err);
	    error.transport = transport.name;
	
	    freezeTransport();
	
	    debug('probe transport "%s" failed because of error: %s', name, err);
	
	    self.emit('upgradeError', error);
	  }
	
	  function onTransportClose () {
	    onerror('transport closed');
	  }
	
	  // When the socket is closed while we're probing
	  function onclose () {
	    onerror('socket closed');
	  }
	
	  // When the socket is upgraded while we're probing
	  function onupgrade (to) {
	    if (transport && to.name !== transport.name) {
	      debug('"%s" works - aborting "%s"', to.name, transport.name);
	      freezeTransport();
	    }
	  }
	
	  // Remove all listeners on the transport and on self
	  function cleanup () {
	    transport.removeListener('open', onTransportOpen);
	    transport.removeListener('error', onerror);
	    transport.removeListener('close', onTransportClose);
	    self.removeListener('close', onclose);
	    self.removeListener('upgrading', onupgrade);
	  }
	
	  transport.once('open', onTransportOpen);
	  transport.once('error', onerror);
	  transport.once('close', onTransportClose);
	
	  this.once('close', onclose);
	  this.once('upgrading', onupgrade);
	
	  transport.open();
	};
	
	/**
	 * Called when connection is deemed open.
	 *
	 * @api public
	 */
	
	Socket.prototype.onOpen = function () {
	  debug('socket open');
	  this.readyState = 'open';
	  Socket.priorWebsocketSuccess = 'websocket' === this.transport.name;
	  this.emit('open');
	  this.flush();
	
	  // we check for `readyState` in case an `open`
	  // listener already closed the socket
	  if ('open' === this.readyState && this.upgrade && this.transport.pause) {
	    debug('starting upgrade probes');
	    for (var i = 0, l = this.upgrades.length; i < l; i++) {
	      this.probe(this.upgrades[i]);
	    }
	  }
	};
	
	/**
	 * Handles a packet.
	 *
	 * @api private
	 */
	
	Socket.prototype.onPacket = function (packet) {
	  if ('opening' === this.readyState || 'open' === this.readyState ||
	      'closing' === this.readyState) {
	    debug('socket receive: type "%s", data "%s"', packet.type, packet.data);
	
	    this.emit('packet', packet);
	
	    // Socket is live - any packet counts
	    this.emit('heartbeat');
	
	    switch (packet.type) {
	      case 'open':
	        this.onHandshake(parsejson(packet.data));
	        break;
	
	      case 'pong':
	        this.setPing();
	        this.emit('pong');
	        break;
	
	      case 'error':
	        var err = new Error('server error');
	        err.code = packet.data;
	        this.onError(err);
	        break;
	
	      case 'message':
	        this.emit('data', packet.data);
	        this.emit('message', packet.data);
	        break;
	    }
	  } else {
	    debug('packet received with socket readyState "%s"', this.readyState);
	  }
	};
	
	/**
	 * Called upon handshake completion.
	 *
	 * @param {Object} handshake obj
	 * @api private
	 */
	
	Socket.prototype.onHandshake = function (data) {
	  this.emit('handshake', data);
	  this.id = data.sid;
	  this.transport.query.sid = data.sid;
	  this.upgrades = this.filterUpgrades(data.upgrades);
	  this.pingInterval = data.pingInterval;
	  this.pingTimeout = data.pingTimeout;
	  this.onOpen();
	  // In case open handler closes socket
	  if ('closed' === this.readyState) return;
	  this.setPing();
	
	  // Prolong liveness of socket on heartbeat
	  this.removeListener('heartbeat', this.onHeartbeat);
	  this.on('heartbeat', this.onHeartbeat);
	};
	
	/**
	 * Resets ping timeout.
	 *
	 * @api private
	 */
	
	Socket.prototype.onHeartbeat = function (timeout) {
	  clearTimeout(this.pingTimeoutTimer);
	  var self = this;
	  self.pingTimeoutTimer = setTimeout(function () {
	    if ('closed' === self.readyState) return;
	    self.onClose('ping timeout');
	  }, timeout || (self.pingInterval + self.pingTimeout));
	};
	
	/**
	 * Pings server every `this.pingInterval` and expects response
	 * within `this.pingTimeout` or closes connection.
	 *
	 * @api private
	 */
	
	Socket.prototype.setPing = function () {
	  var self = this;
	  clearTimeout(self.pingIntervalTimer);
	  self.pingIntervalTimer = setTimeout(function () {
	    debug('writing ping packet - expecting pong within %sms', self.pingTimeout);
	    self.ping();
	    self.onHeartbeat(self.pingTimeout);
	  }, self.pingInterval);
	};
	
	/**
	* Sends a ping packet.
	*
	* @api private
	*/
	
	Socket.prototype.ping = function () {
	  var self = this;
	  this.sendPacket('ping', function () {
	    self.emit('ping');
	  });
	};
	
	/**
	 * Called on `drain` event
	 *
	 * @api private
	 */
	
	Socket.prototype.onDrain = function () {
	  this.writeBuffer.splice(0, this.prevBufferLen);
	
	  // setting prevBufferLen = 0 is very important
	  // for example, when upgrading, upgrade packet is sent over,
	  // and a nonzero prevBufferLen could cause problems on `drain`
	  this.prevBufferLen = 0;
	
	  if (0 === this.writeBuffer.length) {
	    this.emit('drain');
	  } else {
	    this.flush();
	  }
	};
	
	/**
	 * Flush write buffers.
	 *
	 * @api private
	 */
	
	Socket.prototype.flush = function () {
	  if ('closed' !== this.readyState && this.transport.writable &&
	    !this.upgrading && this.writeBuffer.length) {
	    debug('flushing %d packets in socket', this.writeBuffer.length);
	    this.transport.send(this.writeBuffer);
	    // keep track of current length of writeBuffer
	    // splice writeBuffer and callbackBuffer on `drain`
	    this.prevBufferLen = this.writeBuffer.length;
	    this.emit('flush');
	  }
	};
	
	/**
	 * Sends a message.
	 *
	 * @param {String} message.
	 * @param {Function} callback function.
	 * @param {Object} options.
	 * @return {Socket} for chaining.
	 * @api public
	 */
	
	Socket.prototype.write =
	Socket.prototype.send = function (msg, options, fn) {
	  this.sendPacket('message', msg, options, fn);
	  return this;
	};
	
	/**
	 * Sends a packet.
	 *
	 * @param {String} packet type.
	 * @param {String} data.
	 * @param {Object} options.
	 * @param {Function} callback function.
	 * @api private
	 */
	
	Socket.prototype.sendPacket = function (type, data, options, fn) {
	  if ('function' === typeof data) {
	    fn = data;
	    data = undefined;
	  }
	
	  if ('function' === typeof options) {
	    fn = options;
	    options = null;
	  }
	
	  if ('closing' === this.readyState || 'closed' === this.readyState) {
	    return;
	  }
	
	  options = options || {};
	  options.compress = false !== options.compress;
	
	  var packet = {
	    type: type,
	    data: data,
	    options: options
	  };
	  this.emit('packetCreate', packet);
	  this.writeBuffer.push(packet);
	  if (fn) this.once('flush', fn);
	  this.flush();
	};
	
	/**
	 * Closes the connection.
	 *
	 * @api private
	 */
	
	Socket.prototype.close = function () {
	  if ('opening' === this.readyState || 'open' === this.readyState) {
	    this.readyState = 'closing';
	
	    var self = this;
	
	    if (this.writeBuffer.length) {
	      this.once('drain', function () {
	        if (this.upgrading) {
	          waitForUpgrade();
	        } else {
	          close();
	        }
	      });
	    } else if (this.upgrading) {
	      waitForUpgrade();
	    } else {
	      close();
	    }
	  }
	
	  function close () {
	    self.onClose('forced close');
	    debug('socket closing - telling transport to close');
	    self.transport.close();
	  }
	
	  function cleanupAndClose () {
	    self.removeListener('upgrade', cleanupAndClose);
	    self.removeListener('upgradeError', cleanupAndClose);
	    close();
	  }
	
	  function waitForUpgrade () {
	    // wait for upgrade to finish since we can't send packets while pausing a transport
	    self.once('upgrade', cleanupAndClose);
	    self.once('upgradeError', cleanupAndClose);
	  }
	
	  return this;
	};
	
	/**
	 * Called upon transport error
	 *
	 * @api private
	 */
	
	Socket.prototype.onError = function (err) {
	  debug('socket error %j', err);
	  Socket.priorWebsocketSuccess = false;
	  this.emit('error', err);
	  this.onClose('transport error', err);
	};
	
	/**
	 * Called upon transport close.
	 *
	 * @api private
	 */
	
	Socket.prototype.onClose = function (reason, desc) {
	  if ('opening' === this.readyState || 'open' === this.readyState || 'closing' === this.readyState) {
	    debug('socket close with reason: "%s"', reason);
	    var self = this;
	
	    // clear timers
	    clearTimeout(this.pingIntervalTimer);
	    clearTimeout(this.pingTimeoutTimer);
	
	    // stop event from firing again for transport
	    this.transport.removeAllListeners('close');
	
	    // ensure transport won't stay open
	    this.transport.close();
	
	    // ignore further transport communication
	    this.transport.removeAllListeners();
	
	    // set ready state
	    this.readyState = 'closed';
	
	    // clear session id
	    this.id = null;
	
	    // emit close event
	    this.emit('close', reason, desc);
	
	    // clean buffers after, so users can still
	    // grab the buffers on `close` event
	    self.writeBuffer = [];
	    self.prevBufferLen = 0;
	  }
	};
	
	/**
	 * Filters upgrades, returning only those matching client transports.
	 *
	 * @param {Array} server upgrades
	 * @api private
	 *
	 */
	
	Socket.prototype.filterUpgrades = function (upgrades) {
	  var filteredUpgrades = [];
	  for (var i = 0, j = upgrades.length; i < j; i++) {
	    if (~index(this.transports, upgrades[i])) filteredUpgrades.push(upgrades[i]);
	  }
	  return filteredUpgrades;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module dependencies
	 */
	
	var XMLHttpRequest = __webpack_require__(615);
	var XHR = __webpack_require__(617);
	var JSONP = __webpack_require__(635);
	var websocket = __webpack_require__(636);
	
	/**
	 * Export transports.
	 */
	
	exports.polling = polling;
	exports.websocket = websocket;
	
	/**
	 * Polling transport polymorphic constructor.
	 * Decides on xhr vs jsonp based on feature detection.
	 *
	 * @api private
	 */
	
	function polling (opts) {
	  var xhr;
	  var xd = false;
	  var xs = false;
	  var jsonp = false !== opts.jsonp;
	
	  if (global.location) {
	    var isSSL = 'https:' === location.protocol;
	    var port = location.port;
	
	    // some user agents have empty `location.port`
	    if (!port) {
	      port = isSSL ? 443 : 80;
	    }
	
	    xd = opts.hostname !== location.hostname || port !== opts.port;
	    xs = opts.secure !== isSSL;
	  }
	
	  opts.xdomain = xd;
	  opts.xscheme = xs;
	  xhr = new XMLHttpRequest(opts);
	
	  if ('open' in xhr && !opts.forceJSONP) {
	    return new XHR(opts);
	  } else {
	    if (!jsonp) throw new Error('JSONP disabled');
	    return new JSONP(opts);
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// browser shim for xmlhttprequest module
	
	var hasCORS = __webpack_require__(616);
	
	module.exports = function (opts) {
	  var xdomain = opts.xdomain;
	
	  // scheme must be same when usign XDomainRequest
	  // http://blogs.msdn.com/b/ieinternals/archive/2010/05/13/xdomainrequest-restrictions-limitations-and-workarounds.aspx
	  var xscheme = opts.xscheme;
	
	  // XDomainRequest has a flow of not sending cookie, therefore it should be disabled as a default.
	  // https://github.com/Automattic/engine.io-client/pull/217
	  var enablesXDR = opts.enablesXDR;
	
	  // XMLHttpRequest can be disabled on IE
	  try {
	    if ('undefined' !== typeof XMLHttpRequest && (!xdomain || hasCORS)) {
	      return new XMLHttpRequest();
	    }
	  } catch (e) { }
	
	  // Use XDomainRequest for IE8 if enablesXDR is true
	  // because loading bar keeps flashing when using jsonp-polling
	  // https://github.com/yujiosaka/socke.io-ie8-loading-example
	  try {
	    if ('undefined' !== typeof XDomainRequest && !xscheme && enablesXDR) {
	      return new XDomainRequest();
	    }
	  } catch (e) { }
	
	  if (!xdomain) {
	    try {
	      return new global[['Active'].concat('Object').join('X')]('Microsoft.XMLHTTP');
	    } catch (e) { }
	  }
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 616 */
/***/ (function(module, exports) {

	
	/**
	 * Module exports.
	 *
	 * Logic borrowed from Modernizr:
	 *
	 *   - https://github.com/Modernizr/Modernizr/blob/master/feature-detects/cors.js
	 */
	
	try {
	  module.exports = typeof XMLHttpRequest !== 'undefined' &&
	    'withCredentials' in new XMLHttpRequest();
	} catch (err) {
	  // if XMLHttp support is disabled in IE then it will throw
	  // when trying to create
	  module.exports = false;
	}


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module requirements.
	 */
	
	var XMLHttpRequest = __webpack_require__(615);
	var Polling = __webpack_require__(618);
	var Emitter = __webpack_require__(628);
	var inherit = __webpack_require__(630);
	var debug = __webpack_require__(632)('engine.io-client:polling-xhr');
	
	/**
	 * Module exports.
	 */
	
	module.exports = XHR;
	module.exports.Request = Request;
	
	/**
	 * Empty function
	 */
	
	function empty () {}
	
	/**
	 * XHR Polling constructor.
	 *
	 * @param {Object} opts
	 * @api public
	 */
	
	function XHR (opts) {
	  Polling.call(this, opts);
	  this.requestTimeout = opts.requestTimeout;
	
	  if (global.location) {
	    var isSSL = 'https:' === location.protocol;
	    var port = location.port;
	
	    // some user agents have empty `location.port`
	    if (!port) {
	      port = isSSL ? 443 : 80;
	    }
	
	    this.xd = opts.hostname !== global.location.hostname ||
	      port !== opts.port;
	    this.xs = opts.secure !== isSSL;
	  } else {
	    this.extraHeaders = opts.extraHeaders;
	  }
	}
	
	/**
	 * Inherits from Polling.
	 */
	
	inherit(XHR, Polling);
	
	/**
	 * XHR supports binary
	 */
	
	XHR.prototype.supportsBinary = true;
	
	/**
	 * Creates a request.
	 *
	 * @param {String} method
	 * @api private
	 */
	
	XHR.prototype.request = function (opts) {
	  opts = opts || {};
	  opts.uri = this.uri();
	  opts.xd = this.xd;
	  opts.xs = this.xs;
	  opts.agent = this.agent || false;
	  opts.supportsBinary = this.supportsBinary;
	  opts.enablesXDR = this.enablesXDR;
	
	  // SSL options for Node.js client
	  opts.pfx = this.pfx;
	  opts.key = this.key;
	  opts.passphrase = this.passphrase;
	  opts.cert = this.cert;
	  opts.ca = this.ca;
	  opts.ciphers = this.ciphers;
	  opts.rejectUnauthorized = this.rejectUnauthorized;
	  opts.requestTimeout = this.requestTimeout;
	
	  // other options for Node.js client
	  opts.extraHeaders = this.extraHeaders;
	
	  return new Request(opts);
	};
	
	/**
	 * Sends data.
	 *
	 * @param {String} data to send.
	 * @param {Function} called upon flush.
	 * @api private
	 */
	
	XHR.prototype.doWrite = function (data, fn) {
	  var isBinary = typeof data !== 'string' && data !== undefined;
	  var req = this.request({ method: 'POST', data: data, isBinary: isBinary });
	  var self = this;
	  req.on('success', fn);
	  req.on('error', function (err) {
	    self.onError('xhr post error', err);
	  });
	  this.sendXhr = req;
	};
	
	/**
	 * Starts a poll cycle.
	 *
	 * @api private
	 */
	
	XHR.prototype.doPoll = function () {
	  debug('xhr poll');
	  var req = this.request();
	  var self = this;
	  req.on('data', function (data) {
	    self.onData(data);
	  });
	  req.on('error', function (err) {
	    self.onError('xhr poll error', err);
	  });
	  this.pollXhr = req;
	};
	
	/**
	 * Request constructor
	 *
	 * @param {Object} options
	 * @api public
	 */
	
	function Request (opts) {
	  this.method = opts.method || 'GET';
	  this.uri = opts.uri;
	  this.xd = !!opts.xd;
	  this.xs = !!opts.xs;
	  this.async = false !== opts.async;
	  this.data = undefined !== opts.data ? opts.data : null;
	  this.agent = opts.agent;
	  this.isBinary = opts.isBinary;
	  this.supportsBinary = opts.supportsBinary;
	  this.enablesXDR = opts.enablesXDR;
	  this.requestTimeout = opts.requestTimeout;
	
	  // SSL options for Node.js client
	  this.pfx = opts.pfx;
	  this.key = opts.key;
	  this.passphrase = opts.passphrase;
	  this.cert = opts.cert;
	  this.ca = opts.ca;
	  this.ciphers = opts.ciphers;
	  this.rejectUnauthorized = opts.rejectUnauthorized;
	
	  // other options for Node.js client
	  this.extraHeaders = opts.extraHeaders;
	
	  this.create();
	}
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Request.prototype);
	
	/**
	 * Creates the XHR object and sends the request.
	 *
	 * @api private
	 */
	
	Request.prototype.create = function () {
	  var opts = { agent: this.agent, xdomain: this.xd, xscheme: this.xs, enablesXDR: this.enablesXDR };
	
	  // SSL options for Node.js client
	  opts.pfx = this.pfx;
	  opts.key = this.key;
	  opts.passphrase = this.passphrase;
	  opts.cert = this.cert;
	  opts.ca = this.ca;
	  opts.ciphers = this.ciphers;
	  opts.rejectUnauthorized = this.rejectUnauthorized;
	
	  var xhr = this.xhr = new XMLHttpRequest(opts);
	  var self = this;
	
	  try {
	    debug('xhr open %s: %s', this.method, this.uri);
	    xhr.open(this.method, this.uri, this.async);
	    try {
	      if (this.extraHeaders) {
	        xhr.setDisableHeaderCheck(true);
	        for (var i in this.extraHeaders) {
	          if (this.extraHeaders.hasOwnProperty(i)) {
	            xhr.setRequestHeader(i, this.extraHeaders[i]);
	          }
	        }
	      }
	    } catch (e) {}
	    if (this.supportsBinary) {
	      // This has to be done after open because Firefox is stupid
	      // http://stackoverflow.com/questions/13216903/get-binary-data-with-xmlhttprequest-in-a-firefox-extension
	      xhr.responseType = 'arraybuffer';
	    }
	
	    if ('POST' === this.method) {
	      try {
	        if (this.isBinary) {
	          xhr.setRequestHeader('Content-type', 'application/octet-stream');
	        } else {
	          xhr.setRequestHeader('Content-type', 'text/plain;charset=UTF-8');
	        }
	      } catch (e) {}
	    }
	
	    try {
	      xhr.setRequestHeader('Accept', '*/*');
	    } catch (e) {}
	
	    // ie6 check
	    if ('withCredentials' in xhr) {
	      xhr.withCredentials = true;
	    }
	
	    if (this.requestTimeout) {
	      xhr.timeout = this.requestTimeout;
	    }
	
	    if (this.hasXDR()) {
	      xhr.onload = function () {
	        self.onLoad();
	      };
	      xhr.onerror = function () {
	        self.onError(xhr.responseText);
	      };
	    } else {
	      xhr.onreadystatechange = function () {
	        if (4 !== xhr.readyState) return;
	        if (200 === xhr.status || 1223 === xhr.status) {
	          self.onLoad();
	        } else {
	          // make sure the `error` event handler that's user-set
	          // does not throw in the same tick and gets caught here
	          setTimeout(function () {
	            self.onError(xhr.status);
	          }, 0);
	        }
	      };
	    }
	
	    debug('xhr data %s', this.data);
	    xhr.send(this.data);
	  } catch (e) {
	    // Need to defer since .create() is called directly fhrom the constructor
	    // and thus the 'error' event can only be only bound *after* this exception
	    // occurs.  Therefore, also, we cannot throw here at all.
	    setTimeout(function () {
	      self.onError(e);
	    }, 0);
	    return;
	  }
	
	  if (global.document) {
	    this.index = Request.requestsCount++;
	    Request.requests[this.index] = this;
	  }
	};
	
	/**
	 * Called upon successful response.
	 *
	 * @api private
	 */
	
	Request.prototype.onSuccess = function () {
	  this.emit('success');
	  this.cleanup();
	};
	
	/**
	 * Called if we have data.
	 *
	 * @api private
	 */
	
	Request.prototype.onData = function (data) {
	  this.emit('data', data);
	  this.onSuccess();
	};
	
	/**
	 * Called upon error.
	 *
	 * @api private
	 */
	
	Request.prototype.onError = function (err) {
	  this.emit('error', err);
	  this.cleanup(true);
	};
	
	/**
	 * Cleans up house.
	 *
	 * @api private
	 */
	
	Request.prototype.cleanup = function (fromError) {
	  if ('undefined' === typeof this.xhr || null === this.xhr) {
	    return;
	  }
	  // xmlhttprequest
	  if (this.hasXDR()) {
	    this.xhr.onload = this.xhr.onerror = empty;
	  } else {
	    this.xhr.onreadystatechange = empty;
	  }
	
	  if (fromError) {
	    try {
	      this.xhr.abort();
	    } catch (e) {}
	  }
	
	  if (global.document) {
	    delete Request.requests[this.index];
	  }
	
	  this.xhr = null;
	};
	
	/**
	 * Called upon load.
	 *
	 * @api private
	 */
	
	Request.prototype.onLoad = function () {
	  var data;
	  try {
	    var contentType;
	    try {
	      contentType = this.xhr.getResponseHeader('Content-Type').split(';')[0];
	    } catch (e) {}
	    if (contentType === 'application/octet-stream') {
	      data = this.xhr.response || this.xhr.responseText;
	    } else {
	      if (!this.supportsBinary) {
	        data = this.xhr.responseText;
	      } else {
	        try {
	          data = String.fromCharCode.apply(null, new Uint8Array(this.xhr.response));
	        } catch (e) {
	          var ui8Arr = new Uint8Array(this.xhr.response);
	          var dataArray = [];
	          for (var idx = 0, length = ui8Arr.length; idx < length; idx++) {
	            dataArray.push(ui8Arr[idx]);
	          }
	
	          data = String.fromCharCode.apply(null, dataArray);
	        }
	      }
	    }
	  } catch (e) {
	    this.onError(e);
	  }
	  if (null != data) {
	    this.onData(data);
	  }
	};
	
	/**
	 * Check if it has XDomainRequest.
	 *
	 * @api private
	 */
	
	Request.prototype.hasXDR = function () {
	  return 'undefined' !== typeof global.XDomainRequest && !this.xs && this.enablesXDR;
	};
	
	/**
	 * Aborts the request.
	 *
	 * @api public
	 */
	
	Request.prototype.abort = function () {
	  this.cleanup();
	};
	
	/**
	 * Aborts pending requests when unloading the window. This is needed to prevent
	 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
	 * emitted.
	 */
	
	Request.requestsCount = 0;
	Request.requests = {};
	
	if (global.document) {
	  if (global.attachEvent) {
	    global.attachEvent('onunload', unloadHandler);
	  } else if (global.addEventListener) {
	    global.addEventListener('beforeunload', unloadHandler, false);
	  }
	}
	
	function unloadHandler () {
	  for (var i in Request.requests) {
	    if (Request.requests.hasOwnProperty(i)) {
	      Request.requests[i].abort();
	    }
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	var Transport = __webpack_require__(619);
	var parseqs = __webpack_require__(629);
	var parser = __webpack_require__(620);
	var inherit = __webpack_require__(630);
	var yeast = __webpack_require__(631);
	var debug = __webpack_require__(632)('engine.io-client:polling');
	
	/**
	 * Module exports.
	 */
	
	module.exports = Polling;
	
	/**
	 * Is XHR2 supported?
	 */
	
	var hasXHR2 = (function () {
	  var XMLHttpRequest = __webpack_require__(615);
	  var xhr = new XMLHttpRequest({ xdomain: false });
	  return null != xhr.responseType;
	})();
	
	/**
	 * Polling interface.
	 *
	 * @param {Object} opts
	 * @api private
	 */
	
	function Polling (opts) {
	  var forceBase64 = (opts && opts.forceBase64);
	  if (!hasXHR2 || forceBase64) {
	    this.supportsBinary = false;
	  }
	  Transport.call(this, opts);
	}
	
	/**
	 * Inherits from Transport.
	 */
	
	inherit(Polling, Transport);
	
	/**
	 * Transport name.
	 */
	
	Polling.prototype.name = 'polling';
	
	/**
	 * Opens the socket (triggers polling). We write a PING message to determine
	 * when the transport is open.
	 *
	 * @api private
	 */
	
	Polling.prototype.doOpen = function () {
	  this.poll();
	};
	
	/**
	 * Pauses polling.
	 *
	 * @param {Function} callback upon buffers are flushed and transport is paused
	 * @api private
	 */
	
	Polling.prototype.pause = function (onPause) {
	  var self = this;
	
	  this.readyState = 'pausing';
	
	  function pause () {
	    debug('paused');
	    self.readyState = 'paused';
	    onPause();
	  }
	
	  if (this.polling || !this.writable) {
	    var total = 0;
	
	    if (this.polling) {
	      debug('we are currently polling - waiting to pause');
	      total++;
	      this.once('pollComplete', function () {
	        debug('pre-pause polling complete');
	        --total || pause();
	      });
	    }
	
	    if (!this.writable) {
	      debug('we are currently writing - waiting to pause');
	      total++;
	      this.once('drain', function () {
	        debug('pre-pause writing complete');
	        --total || pause();
	      });
	    }
	  } else {
	    pause();
	  }
	};
	
	/**
	 * Starts polling cycle.
	 *
	 * @api public
	 */
	
	Polling.prototype.poll = function () {
	  debug('polling');
	  this.polling = true;
	  this.doPoll();
	  this.emit('poll');
	};
	
	/**
	 * Overloads onData to detect payloads.
	 *
	 * @api private
	 */
	
	Polling.prototype.onData = function (data) {
	  var self = this;
	  debug('polling got data %s', data);
	  var callback = function (packet, index, total) {
	    // if its the first message we consider the transport open
	    if ('opening' === self.readyState) {
	      self.onOpen();
	    }
	
	    // if its a close packet, we close the ongoing requests
	    if ('close' === packet.type) {
	      self.onClose();
	      return false;
	    }
	
	    // otherwise bypass onData and handle the message
	    self.onPacket(packet);
	  };
	
	  // decode payload
	  parser.decodePayload(data, this.socket.binaryType, callback);
	
	  // if an event did not trigger closing
	  if ('closed' !== this.readyState) {
	    // if we got data we're not polling
	    this.polling = false;
	    this.emit('pollComplete');
	
	    if ('open' === this.readyState) {
	      this.poll();
	    } else {
	      debug('ignoring poll - transport state "%s"', this.readyState);
	    }
	  }
	};
	
	/**
	 * For polling, send a close packet.
	 *
	 * @api private
	 */
	
	Polling.prototype.doClose = function () {
	  var self = this;
	
	  function close () {
	    debug('writing close packet');
	    self.write([{ type: 'close' }]);
	  }
	
	  if ('open' === this.readyState) {
	    debug('transport open - closing');
	    close();
	  } else {
	    // in case we're trying to close while
	    // handshaking is in progress (GH-164)
	    debug('transport not open - deferring close');
	    this.once('open', close);
	  }
	};
	
	/**
	 * Writes a packets payload.
	 *
	 * @param {Array} data packets
	 * @param {Function} drain callback
	 * @api private
	 */
	
	Polling.prototype.write = function (packets) {
	  var self = this;
	  this.writable = false;
	  var callbackfn = function () {
	    self.writable = true;
	    self.emit('drain');
	  };
	
	  parser.encodePayload(packets, this.supportsBinary, function (data) {
	    self.doWrite(data, callbackfn);
	  });
	};
	
	/**
	 * Generates uri for connection.
	 *
	 * @api private
	 */
	
	Polling.prototype.uri = function () {
	  var query = this.query || {};
	  var schema = this.secure ? 'https' : 'http';
	  var port = '';
	
	  // cache busting is forced
	  if (false !== this.timestampRequests) {
	    query[this.timestampParam] = yeast();
	  }
	
	  if (!this.supportsBinary && !query.sid) {
	    query.b64 = 1;
	  }
	
	  query = parseqs.encode(query);
	
	  // avoid port if default for schema
	  if (this.port && (('https' === schema && Number(this.port) !== 443) ||
	     ('http' === schema && Number(this.port) !== 80))) {
	    port = ':' + this.port;
	  }
	
	  // prepend ? to query
	  if (query.length) {
	    query = '?' + query;
	  }
	
	  var ipv6 = this.hostname.indexOf(':') !== -1;
	  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
	};


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	var parser = __webpack_require__(620);
	var Emitter = __webpack_require__(628);
	
	/**
	 * Module exports.
	 */
	
	module.exports = Transport;
	
	/**
	 * Transport abstract constructor.
	 *
	 * @param {Object} options.
	 * @api private
	 */
	
	function Transport (opts) {
	  this.path = opts.path;
	  this.hostname = opts.hostname;
	  this.port = opts.port;
	  this.secure = opts.secure;
	  this.query = opts.query;
	  this.timestampParam = opts.timestampParam;
	  this.timestampRequests = opts.timestampRequests;
	  this.readyState = '';
	  this.agent = opts.agent || false;
	  this.socket = opts.socket;
	  this.enablesXDR = opts.enablesXDR;
	
	  // SSL options for Node.js client
	  this.pfx = opts.pfx;
	  this.key = opts.key;
	  this.passphrase = opts.passphrase;
	  this.cert = opts.cert;
	  this.ca = opts.ca;
	  this.ciphers = opts.ciphers;
	  this.rejectUnauthorized = opts.rejectUnauthorized;
	  this.forceNode = opts.forceNode;
	
	  // other options for Node.js client
	  this.extraHeaders = opts.extraHeaders;
	  this.localAddress = opts.localAddress;
	}
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Transport.prototype);
	
	/**
	 * Emits an error.
	 *
	 * @param {String} str
	 * @return {Transport} for chaining
	 * @api public
	 */
	
	Transport.prototype.onError = function (msg, desc) {
	  var err = new Error(msg);
	  err.type = 'TransportError';
	  err.description = desc;
	  this.emit('error', err);
	  return this;
	};
	
	/**
	 * Opens the transport.
	 *
	 * @api public
	 */
	
	Transport.prototype.open = function () {
	  if ('closed' === this.readyState || '' === this.readyState) {
	    this.readyState = 'opening';
	    this.doOpen();
	  }
	
	  return this;
	};
	
	/**
	 * Closes the transport.
	 *
	 * @api private
	 */
	
	Transport.prototype.close = function () {
	  if ('opening' === this.readyState || 'open' === this.readyState) {
	    this.doClose();
	    this.onClose();
	  }
	
	  return this;
	};
	
	/**
	 * Sends multiple packets.
	 *
	 * @param {Array} packets
	 * @api private
	 */
	
	Transport.prototype.send = function (packets) {
	  if ('open' === this.readyState) {
	    this.write(packets);
	  } else {
	    throw new Error('Transport not open');
	  }
	};
	
	/**
	 * Called upon open
	 *
	 * @api private
	 */
	
	Transport.prototype.onOpen = function () {
	  this.readyState = 'open';
	  this.writable = true;
	  this.emit('open');
	};
	
	/**
	 * Called with data.
	 *
	 * @param {String} data
	 * @api private
	 */
	
	Transport.prototype.onData = function (data) {
	  var packet = parser.decodePacket(data, this.socket.binaryType);
	  this.onPacket(packet);
	};
	
	/**
	 * Called with a decoded packet.
	 */
	
	Transport.prototype.onPacket = function (packet) {
	  this.emit('packet', packet);
	};
	
	/**
	 * Called upon close.
	 *
	 * @api private
	 */
	
	Transport.prototype.onClose = function () {
	  this.readyState = 'closed';
	  this.emit('close');
	};


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module dependencies.
	 */
	
	var keys = __webpack_require__(621);
	var hasBinary = __webpack_require__(622);
	var sliceBuffer = __webpack_require__(623);
	var after = __webpack_require__(624);
	var utf8 = __webpack_require__(625);
	
	var base64encoder;
	if (global && global.ArrayBuffer) {
	  base64encoder = __webpack_require__(626);
	}
	
	/**
	 * Check if we are running an android browser. That requires us to use
	 * ArrayBuffer with polling transports...
	 *
	 * http://ghinda.net/jpeg-blob-ajax-android/
	 */
	
	var isAndroid = typeof navigator !== 'undefined' && /Android/i.test(navigator.userAgent);
	
	/**
	 * Check if we are running in PhantomJS.
	 * Uploading a Blob with PhantomJS does not work correctly, as reported here:
	 * https://github.com/ariya/phantomjs/issues/11395
	 * @type boolean
	 */
	var isPhantomJS = typeof navigator !== 'undefined' && /PhantomJS/i.test(navigator.userAgent);
	
	/**
	 * When true, avoids using Blobs to encode payloads.
	 * @type boolean
	 */
	var dontSendBlobs = isAndroid || isPhantomJS;
	
	/**
	 * Current protocol version.
	 */
	
	exports.protocol = 3;
	
	/**
	 * Packet types.
	 */
	
	var packets = exports.packets = {
	    open:     0    // non-ws
	  , close:    1    // non-ws
	  , ping:     2
	  , pong:     3
	  , message:  4
	  , upgrade:  5
	  , noop:     6
	};
	
	var packetslist = keys(packets);
	
	/**
	 * Premade error packet.
	 */
	
	var err = { type: 'error', data: 'parser error' };
	
	/**
	 * Create a blob api even for blob builder when vendor prefixes exist
	 */
	
	var Blob = __webpack_require__(627);
	
	/**
	 * Encodes a packet.
	 *
	 *     <packet type id> [ <data> ]
	 *
	 * Example:
	 *
	 *     5hello world
	 *     3
	 *     4
	 *
	 * Binary is encoded in an identical principle
	 *
	 * @api private
	 */
	
	exports.encodePacket = function (packet, supportsBinary, utf8encode, callback) {
	  if ('function' == typeof supportsBinary) {
	    callback = supportsBinary;
	    supportsBinary = false;
	  }
	
	  if ('function' == typeof utf8encode) {
	    callback = utf8encode;
	    utf8encode = null;
	  }
	
	  var data = (packet.data === undefined)
	    ? undefined
	    : packet.data.buffer || packet.data;
	
	  if (global.ArrayBuffer && data instanceof ArrayBuffer) {
	    return encodeArrayBuffer(packet, supportsBinary, callback);
	  } else if (Blob && data instanceof global.Blob) {
	    return encodeBlob(packet, supportsBinary, callback);
	  }
	
	  // might be an object with { base64: true, data: dataAsBase64String }
	  if (data && data.base64) {
	    return encodeBase64Object(packet, callback);
	  }
	
	  // Sending data as a utf-8 string
	  var encoded = packets[packet.type];
	
	  // data fragment is optional
	  if (undefined !== packet.data) {
	    encoded += utf8encode ? utf8.encode(String(packet.data)) : String(packet.data);
	  }
	
	  return callback('' + encoded);
	
	};
	
	function encodeBase64Object(packet, callback) {
	  // packet data is an object { base64: true, data: dataAsBase64String }
	  var message = 'b' + exports.packets[packet.type] + packet.data.data;
	  return callback(message);
	}
	
	/**
	 * Encode packet helpers for binary types
	 */
	
	function encodeArrayBuffer(packet, supportsBinary, callback) {
	  if (!supportsBinary) {
	    return exports.encodeBase64Packet(packet, callback);
	  }
	
	  var data = packet.data;
	  var contentArray = new Uint8Array(data);
	  var resultBuffer = new Uint8Array(1 + data.byteLength);
	
	  resultBuffer[0] = packets[packet.type];
	  for (var i = 0; i < contentArray.length; i++) {
	    resultBuffer[i+1] = contentArray[i];
	  }
	
	  return callback(resultBuffer.buffer);
	}
	
	function encodeBlobAsArrayBuffer(packet, supportsBinary, callback) {
	  if (!supportsBinary) {
	    return exports.encodeBase64Packet(packet, callback);
	  }
	
	  var fr = new FileReader();
	  fr.onload = function() {
	    packet.data = fr.result;
	    exports.encodePacket(packet, supportsBinary, true, callback);
	  };
	  return fr.readAsArrayBuffer(packet.data);
	}
	
	function encodeBlob(packet, supportsBinary, callback) {
	  if (!supportsBinary) {
	    return exports.encodeBase64Packet(packet, callback);
	  }
	
	  if (dontSendBlobs) {
	    return encodeBlobAsArrayBuffer(packet, supportsBinary, callback);
	  }
	
	  var length = new Uint8Array(1);
	  length[0] = packets[packet.type];
	  var blob = new Blob([length.buffer, packet.data]);
	
	  return callback(blob);
	}
	
	/**
	 * Encodes a packet with binary data in a base64 string
	 *
	 * @param {Object} packet, has `type` and `data`
	 * @return {String} base64 encoded message
	 */
	
	exports.encodeBase64Packet = function(packet, callback) {
	  var message = 'b' + exports.packets[packet.type];
	  if (Blob && packet.data instanceof global.Blob) {
	    var fr = new FileReader();
	    fr.onload = function() {
	      var b64 = fr.result.split(',')[1];
	      callback(message + b64);
	    };
	    return fr.readAsDataURL(packet.data);
	  }
	
	  var b64data;
	  try {
	    b64data = String.fromCharCode.apply(null, new Uint8Array(packet.data));
	  } catch (e) {
	    // iPhone Safari doesn't let you apply with typed arrays
	    var typed = new Uint8Array(packet.data);
	    var basic = new Array(typed.length);
	    for (var i = 0; i < typed.length; i++) {
	      basic[i] = typed[i];
	    }
	    b64data = String.fromCharCode.apply(null, basic);
	  }
	  message += global.btoa(b64data);
	  return callback(message);
	};
	
	/**
	 * Decodes a packet. Changes format to Blob if requested.
	 *
	 * @return {Object} with `type` and `data` (if any)
	 * @api private
	 */
	
	exports.decodePacket = function (data, binaryType, utf8decode) {
	  if (data === undefined) {
	    return err;
	  }
	  // String data
	  if (typeof data == 'string') {
	    if (data.charAt(0) == 'b') {
	      return exports.decodeBase64Packet(data.substr(1), binaryType);
	    }
	
	    if (utf8decode) {
	      data = tryDecode(data);
	      if (data === false) {
	        return err;
	      }
	    }
	    var type = data.charAt(0);
	
	    if (Number(type) != type || !packetslist[type]) {
	      return err;
	    }
	
	    if (data.length > 1) {
	      return { type: packetslist[type], data: data.substring(1) };
	    } else {
	      return { type: packetslist[type] };
	    }
	  }
	
	  var asArray = new Uint8Array(data);
	  var type = asArray[0];
	  var rest = sliceBuffer(data, 1);
	  if (Blob && binaryType === 'blob') {
	    rest = new Blob([rest]);
	  }
	  return { type: packetslist[type], data: rest };
	};
	
	function tryDecode(data) {
	  try {
	    data = utf8.decode(data);
	  } catch (e) {
	    return false;
	  }
	  return data;
	}
	
	/**
	 * Decodes a packet encoded in a base64 string
	 *
	 * @param {String} base64 encoded message
	 * @return {Object} with `type` and `data` (if any)
	 */
	
	exports.decodeBase64Packet = function(msg, binaryType) {
	  var type = packetslist[msg.charAt(0)];
	  if (!base64encoder) {
	    return { type: type, data: { base64: true, data: msg.substr(1) } };
	  }
	
	  var data = base64encoder.decode(msg.substr(1));
	
	  if (binaryType === 'blob' && Blob) {
	    data = new Blob([data]);
	  }
	
	  return { type: type, data: data };
	};
	
	/**
	 * Encodes multiple messages (payload).
	 *
	 *     <length>:data
	 *
	 * Example:
	 *
	 *     11:hello world2:hi
	 *
	 * If any contents are binary, they will be encoded as base64 strings. Base64
	 * encoded strings are marked with a b before the length specifier
	 *
	 * @param {Array} packets
	 * @api private
	 */
	
	exports.encodePayload = function (packets, supportsBinary, callback) {
	  if (typeof supportsBinary == 'function') {
	    callback = supportsBinary;
	    supportsBinary = null;
	  }
	
	  var isBinary = hasBinary(packets);
	
	  if (supportsBinary && isBinary) {
	    if (Blob && !dontSendBlobs) {
	      return exports.encodePayloadAsBlob(packets, callback);
	    }
	
	    return exports.encodePayloadAsArrayBuffer(packets, callback);
	  }
	
	  if (!packets.length) {
	    return callback('0:');
	  }
	
	  function setLengthHeader(message) {
	    return message.length + ':' + message;
	  }
	
	  function encodeOne(packet, doneCallback) {
	    exports.encodePacket(packet, !isBinary ? false : supportsBinary, true, function(message) {
	      doneCallback(null, setLengthHeader(message));
	    });
	  }
	
	  map(packets, encodeOne, function(err, results) {
	    return callback(results.join(''));
	  });
	};
	
	/**
	 * Async array map using after
	 */
	
	function map(ary, each, done) {
	  var result = new Array(ary.length);
	  var next = after(ary.length, done);
	
	  var eachWithIndex = function(i, el, cb) {
	    each(el, function(error, msg) {
	      result[i] = msg;
	      cb(error, result);
	    });
	  };
	
	  for (var i = 0; i < ary.length; i++) {
	    eachWithIndex(i, ary[i], next);
	  }
	}
	
	/*
	 * Decodes data when a payload is maybe expected. Possible binary contents are
	 * decoded from their base64 representation
	 *
	 * @param {String} data, callback method
	 * @api public
	 */
	
	exports.decodePayload = function (data, binaryType, callback) {
	  if (typeof data != 'string') {
	    return exports.decodePayloadAsBinary(data, binaryType, callback);
	  }
	
	  if (typeof binaryType === 'function') {
	    callback = binaryType;
	    binaryType = null;
	  }
	
	  var packet;
	  if (data == '') {
	    // parser error - ignoring payload
	    return callback(err, 0, 1);
	  }
	
	  var length = ''
	    , n, msg;
	
	  for (var i = 0, l = data.length; i < l; i++) {
	    var chr = data.charAt(i);
	
	    if (':' != chr) {
	      length += chr;
	    } else {
	      if ('' == length || (length != (n = Number(length)))) {
	        // parser error - ignoring payload
	        return callback(err, 0, 1);
	      }
	
	      msg = data.substr(i + 1, n);
	
	      if (length != msg.length) {
	        // parser error - ignoring payload
	        return callback(err, 0, 1);
	      }
	
	      if (msg.length) {
	        packet = exports.decodePacket(msg, binaryType, true);
	
	        if (err.type == packet.type && err.data == packet.data) {
	          // parser error in individual packet - ignoring payload
	          return callback(err, 0, 1);
	        }
	
	        var ret = callback(packet, i + n, l);
	        if (false === ret) return;
	      }
	
	      // advance cursor
	      i += n;
	      length = '';
	    }
	  }
	
	  if (length != '') {
	    // parser error - ignoring payload
	    return callback(err, 0, 1);
	  }
	
	};
	
	/**
	 * Encodes multiple messages (payload) as binary.
	 *
	 * <1 = binary, 0 = string><number from 0-9><number from 0-9>[...]<number
	 * 255><data>
	 *
	 * Example:
	 * 1 3 255 1 2 3, if the binary contents are interpreted as 8 bit integers
	 *
	 * @param {Array} packets
	 * @return {ArrayBuffer} encoded payload
	 * @api private
	 */
	
	exports.encodePayloadAsArrayBuffer = function(packets, callback) {
	  if (!packets.length) {
	    return callback(new ArrayBuffer(0));
	  }
	
	  function encodeOne(packet, doneCallback) {
	    exports.encodePacket(packet, true, true, function(data) {
	      return doneCallback(null, data);
	    });
	  }
	
	  map(packets, encodeOne, function(err, encodedPackets) {
	    var totalLength = encodedPackets.reduce(function(acc, p) {
	      var len;
	      if (typeof p === 'string'){
	        len = p.length;
	      } else {
	        len = p.byteLength;
	      }
	      return acc + len.toString().length + len + 2; // string/binary identifier + separator = 2
	    }, 0);
	
	    var resultArray = new Uint8Array(totalLength);
	
	    var bufferIndex = 0;
	    encodedPackets.forEach(function(p) {
	      var isString = typeof p === 'string';
	      var ab = p;
	      if (isString) {
	        var view = new Uint8Array(p.length);
	        for (var i = 0; i < p.length; i++) {
	          view[i] = p.charCodeAt(i);
	        }
	        ab = view.buffer;
	      }
	
	      if (isString) { // not true binary
	        resultArray[bufferIndex++] = 0;
	      } else { // true binary
	        resultArray[bufferIndex++] = 1;
	      }
	
	      var lenStr = ab.byteLength.toString();
	      for (var i = 0; i < lenStr.length; i++) {
	        resultArray[bufferIndex++] = parseInt(lenStr[i]);
	      }
	      resultArray[bufferIndex++] = 255;
	
	      var view = new Uint8Array(ab);
	      for (var i = 0; i < view.length; i++) {
	        resultArray[bufferIndex++] = view[i];
	      }
	    });
	
	    return callback(resultArray.buffer);
	  });
	};
	
	/**
	 * Encode as Blob
	 */
	
	exports.encodePayloadAsBlob = function(packets, callback) {
	  function encodeOne(packet, doneCallback) {
	    exports.encodePacket(packet, true, true, function(encoded) {
	      var binaryIdentifier = new Uint8Array(1);
	      binaryIdentifier[0] = 1;
	      if (typeof encoded === 'string') {
	        var view = new Uint8Array(encoded.length);
	        for (var i = 0; i < encoded.length; i++) {
	          view[i] = encoded.charCodeAt(i);
	        }
	        encoded = view.buffer;
	        binaryIdentifier[0] = 0;
	      }
	
	      var len = (encoded instanceof ArrayBuffer)
	        ? encoded.byteLength
	        : encoded.size;
	
	      var lenStr = len.toString();
	      var lengthAry = new Uint8Array(lenStr.length + 1);
	      for (var i = 0; i < lenStr.length; i++) {
	        lengthAry[i] = parseInt(lenStr[i]);
	      }
	      lengthAry[lenStr.length] = 255;
	
	      if (Blob) {
	        var blob = new Blob([binaryIdentifier.buffer, lengthAry.buffer, encoded]);
	        doneCallback(null, blob);
	      }
	    });
	  }
	
	  map(packets, encodeOne, function(err, results) {
	    return callback(new Blob(results));
	  });
	};
	
	/*
	 * Decodes data when a payload is maybe expected. Strings are decoded by
	 * interpreting each byte as a key code for entries marked to start with 0. See
	 * description of encodePayloadAsBinary
	 *
	 * @param {ArrayBuffer} data, callback method
	 * @api public
	 */
	
	exports.decodePayloadAsBinary = function (data, binaryType, callback) {
	  if (typeof binaryType === 'function') {
	    callback = binaryType;
	    binaryType = null;
	  }
	
	  var bufferTail = data;
	  var buffers = [];
	
	  var numberTooLong = false;
	  while (bufferTail.byteLength > 0) {
	    var tailArray = new Uint8Array(bufferTail);
	    var isString = tailArray[0] === 0;
	    var msgLength = '';
	
	    for (var i = 1; ; i++) {
	      if (tailArray[i] == 255) break;
	
	      if (msgLength.length > 310) {
	        numberTooLong = true;
	        break;
	      }
	
	      msgLength += tailArray[i];
	    }
	
	    if(numberTooLong) return callback(err, 0, 1);
	
	    bufferTail = sliceBuffer(bufferTail, 2 + msgLength.length);
	    msgLength = parseInt(msgLength);
	
	    var msg = sliceBuffer(bufferTail, 0, msgLength);
	    if (isString) {
	      try {
	        msg = String.fromCharCode.apply(null, new Uint8Array(msg));
	      } catch (e) {
	        // iPhone Safari doesn't let you apply to typed arrays
	        var typed = new Uint8Array(msg);
	        msg = '';
	        for (var i = 0; i < typed.length; i++) {
	          msg += String.fromCharCode(typed[i]);
	        }
	      }
	    }
	
	    buffers.push(msg);
	    bufferTail = sliceBuffer(bufferTail, msgLength);
	  }
	
	  var total = buffers.length;
	  buffers.forEach(function(buffer, i) {
	    callback(exports.decodePacket(buffer, binaryType, true), i, total);
	  });
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 621 */
/***/ (function(module, exports) {

	
	/**
	 * Gets the keys for an object.
	 *
	 * @return {Array} keys
	 * @api private
	 */
	
	module.exports = Object.keys || function keys (obj){
	  var arr = [];
	  var has = Object.prototype.hasOwnProperty;
	
	  for (var i in obj) {
	    if (has.call(obj, i)) {
	      arr.push(i);
	    }
	  }
	  return arr;
	};


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/*
	 * Module requirements.
	 */
	
	var isArray = __webpack_require__(608);
	
	/**
	 * Module exports.
	 */
	
	module.exports = hasBinary;
	
	/**
	 * Checks for binary data.
	 *
	 * Right now only Buffer and ArrayBuffer are supported..
	 *
	 * @param {Object} anything
	 * @api public
	 */
	
	function hasBinary(data) {
	
	  function _hasBinary(obj) {
	    if (!obj) return false;
	
	    if ( (global.Buffer && global.Buffer.isBuffer && global.Buffer.isBuffer(obj)) ||
	         (global.ArrayBuffer && obj instanceof ArrayBuffer) ||
	         (global.Blob && obj instanceof Blob) ||
	         (global.File && obj instanceof File)
	        ) {
	      return true;
	    }
	
	    if (isArray(obj)) {
	      for (var i = 0; i < obj.length; i++) {
	          if (_hasBinary(obj[i])) {
	              return true;
	          }
	      }
	    } else if (obj && 'object' == typeof obj) {
	      // see: https://github.com/Automattic/has-binary/pull/4
	      if (obj.toJSON && 'function' == typeof obj.toJSON) {
	        obj = obj.toJSON();
	      }
	
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key) && _hasBinary(obj[key])) {
	          return true;
	        }
	      }
	    }
	
	    return false;
	  }
	
	  return _hasBinary(data);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 623 */
/***/ (function(module, exports) {

	/**
	 * An abstraction for slicing an arraybuffer even when
	 * ArrayBuffer.prototype.slice is not supported
	 *
	 * @api public
	 */
	
	module.exports = function(arraybuffer, start, end) {
	  var bytes = arraybuffer.byteLength;
	  start = start || 0;
	  end = end || bytes;
	
	  if (arraybuffer.slice) { return arraybuffer.slice(start, end); }
	
	  if (start < 0) { start += bytes; }
	  if (end < 0) { end += bytes; }
	  if (end > bytes) { end = bytes; }
	
	  if (start >= bytes || start >= end || bytes === 0) {
	    return new ArrayBuffer(0);
	  }
	
	  var abv = new Uint8Array(arraybuffer);
	  var result = new Uint8Array(end - start);
	  for (var i = start, ii = 0; i < end; i++, ii++) {
	    result[ii] = abv[i];
	  }
	  return result.buffer;
	};


/***/ }),
/* 624 */
/***/ (function(module, exports) {

	module.exports = after
	
	function after(count, callback, err_cb) {
	    var bail = false
	    err_cb = err_cb || noop
	    proxy.count = count
	
	    return (count === 0) ? callback() : proxy
	
	    function proxy(err, result) {
	        if (proxy.count <= 0) {
	            throw new Error('after called too many times')
	        }
	        --proxy.count
	
	        // after first error, rest are passed to err_cb
	        if (err) {
	            bail = true
	            callback(err)
	            // future error callbacks will go to error handler
	            callback = err_cb
	        } else if (proxy.count === 0 && !bail) {
	            callback(null, result)
	        }
	    }
	}
	
	function noop() {}


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! https://mths.be/wtf8 v1.0.0 by @mathias */
	;(function(root) {
	
		// Detect free variables `exports`
		var freeExports = typeof exports == 'object' && exports;
	
		// Detect free variable `module`
		var freeModule = typeof module == 'object' && module &&
			module.exports == freeExports && module;
	
		// Detect free variable `global`, from Node.js or Browserified code,
		// and use it as `root`
		var freeGlobal = typeof global == 'object' && global;
		if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
			root = freeGlobal;
		}
	
		/*--------------------------------------------------------------------------*/
	
		var stringFromCharCode = String.fromCharCode;
	
		// Taken from https://mths.be/punycode
		function ucs2decode(string) {
			var output = [];
			var counter = 0;
			var length = string.length;
			var value;
			var extra;
			while (counter < length) {
				value = string.charCodeAt(counter++);
				if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
					// high surrogate, and there is a next character
					extra = string.charCodeAt(counter++);
					if ((extra & 0xFC00) == 0xDC00) { // low surrogate
						output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
					} else {
						// unmatched surrogate; only append this code unit, in case the next
						// code unit is the high surrogate of a surrogate pair
						output.push(value);
						counter--;
					}
				} else {
					output.push(value);
				}
			}
			return output;
		}
	
		// Taken from https://mths.be/punycode
		function ucs2encode(array) {
			var length = array.length;
			var index = -1;
			var value;
			var output = '';
			while (++index < length) {
				value = array[index];
				if (value > 0xFFFF) {
					value -= 0x10000;
					output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
					value = 0xDC00 | value & 0x3FF;
				}
				output += stringFromCharCode(value);
			}
			return output;
		}
	
		/*--------------------------------------------------------------------------*/
	
		function createByte(codePoint, shift) {
			return stringFromCharCode(((codePoint >> shift) & 0x3F) | 0x80);
		}
	
		function encodeCodePoint(codePoint) {
			if ((codePoint & 0xFFFFFF80) == 0) { // 1-byte sequence
				return stringFromCharCode(codePoint);
			}
			var symbol = '';
			if ((codePoint & 0xFFFFF800) == 0) { // 2-byte sequence
				symbol = stringFromCharCode(((codePoint >> 6) & 0x1F) | 0xC0);
			}
			else if ((codePoint & 0xFFFF0000) == 0) { // 3-byte sequence
				symbol = stringFromCharCode(((codePoint >> 12) & 0x0F) | 0xE0);
				symbol += createByte(codePoint, 6);
			}
			else if ((codePoint & 0xFFE00000) == 0) { // 4-byte sequence
				symbol = stringFromCharCode(((codePoint >> 18) & 0x07) | 0xF0);
				symbol += createByte(codePoint, 12);
				symbol += createByte(codePoint, 6);
			}
			symbol += stringFromCharCode((codePoint & 0x3F) | 0x80);
			return symbol;
		}
	
		function wtf8encode(string) {
			var codePoints = ucs2decode(string);
			var length = codePoints.length;
			var index = -1;
			var codePoint;
			var byteString = '';
			while (++index < length) {
				codePoint = codePoints[index];
				byteString += encodeCodePoint(codePoint);
			}
			return byteString;
		}
	
		/*--------------------------------------------------------------------------*/
	
		function readContinuationByte() {
			if (byteIndex >= byteCount) {
				throw Error('Invalid byte index');
			}
	
			var continuationByte = byteArray[byteIndex] & 0xFF;
			byteIndex++;
	
			if ((continuationByte & 0xC0) == 0x80) {
				return continuationByte & 0x3F;
			}
	
			// If we end up here, it’s not a continuation byte.
			throw Error('Invalid continuation byte');
		}
	
		function decodeSymbol() {
			var byte1;
			var byte2;
			var byte3;
			var byte4;
			var codePoint;
	
			if (byteIndex > byteCount) {
				throw Error('Invalid byte index');
			}
	
			if (byteIndex == byteCount) {
				return false;
			}
	
			// Read the first byte.
			byte1 = byteArray[byteIndex] & 0xFF;
			byteIndex++;
	
			// 1-byte sequence (no continuation bytes)
			if ((byte1 & 0x80) == 0) {
				return byte1;
			}
	
			// 2-byte sequence
			if ((byte1 & 0xE0) == 0xC0) {
				var byte2 = readContinuationByte();
				codePoint = ((byte1 & 0x1F) << 6) | byte2;
				if (codePoint >= 0x80) {
					return codePoint;
				} else {
					throw Error('Invalid continuation byte');
				}
			}
	
			// 3-byte sequence (may include unpaired surrogates)
			if ((byte1 & 0xF0) == 0xE0) {
				byte2 = readContinuationByte();
				byte3 = readContinuationByte();
				codePoint = ((byte1 & 0x0F) << 12) | (byte2 << 6) | byte3;
				if (codePoint >= 0x0800) {
					return codePoint;
				} else {
					throw Error('Invalid continuation byte');
				}
			}
	
			// 4-byte sequence
			if ((byte1 & 0xF8) == 0xF0) {
				byte2 = readContinuationByte();
				byte3 = readContinuationByte();
				byte4 = readContinuationByte();
				codePoint = ((byte1 & 0x0F) << 0x12) | (byte2 << 0x0C) |
					(byte3 << 0x06) | byte4;
				if (codePoint >= 0x010000 && codePoint <= 0x10FFFF) {
					return codePoint;
				}
			}
	
			throw Error('Invalid WTF-8 detected');
		}
	
		var byteArray;
		var byteCount;
		var byteIndex;
		function wtf8decode(byteString) {
			byteArray = ucs2decode(byteString);
			byteCount = byteArray.length;
			byteIndex = 0;
			var codePoints = [];
			var tmp;
			while ((tmp = decodeSymbol()) !== false) {
				codePoints.push(tmp);
			}
			return ucs2encode(codePoints);
		}
	
		/*--------------------------------------------------------------------------*/
	
		var wtf8 = {
			'version': '1.0.0',
			'encode': wtf8encode,
			'decode': wtf8decode
		};
	
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return wtf8;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}	else if (freeExports && !freeExports.nodeType) {
			if (freeModule) { // in Node.js or RingoJS v0.8.0+
				freeModule.exports = wtf8;
			} else { // in Narwhal or RingoJS v0.7.0-
				var object = {};
				var hasOwnProperty = object.hasOwnProperty;
				for (var key in wtf8) {
					hasOwnProperty.call(wtf8, key) && (freeExports[key] = wtf8[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.wtf8 = wtf8;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(40)(module), (function() { return this; }())))

/***/ }),
/* 626 */
/***/ (function(module, exports) {

	/*
	 * base64-arraybuffer
	 * https://github.com/niklasvh/base64-arraybuffer
	 *
	 * Copyright (c) 2012 Niklas von Hertzen
	 * Licensed under the MIT license.
	 */
	(function(){
	  "use strict";
	
	  var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
	
	  // Use a lookup table to find the index.
	  var lookup = new Uint8Array(256);
	  for (var i = 0; i < chars.length; i++) {
	    lookup[chars.charCodeAt(i)] = i;
	  }
	
	  exports.encode = function(arraybuffer) {
	    var bytes = new Uint8Array(arraybuffer),
	    i, len = bytes.length, base64 = "";
	
	    for (i = 0; i < len; i+=3) {
	      base64 += chars[bytes[i] >> 2];
	      base64 += chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];
	      base64 += chars[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];
	      base64 += chars[bytes[i + 2] & 63];
	    }
	
	    if ((len % 3) === 2) {
	      base64 = base64.substring(0, base64.length - 1) + "=";
	    } else if (len % 3 === 1) {
	      base64 = base64.substring(0, base64.length - 2) + "==";
	    }
	
	    return base64;
	  };
	
	  exports.decode =  function(base64) {
	    var bufferLength = base64.length * 0.75,
	    len = base64.length, i, p = 0,
	    encoded1, encoded2, encoded3, encoded4;
	
	    if (base64[base64.length - 1] === "=") {
	      bufferLength--;
	      if (base64[base64.length - 2] === "=") {
	        bufferLength--;
	      }
	    }
	
	    var arraybuffer = new ArrayBuffer(bufferLength),
	    bytes = new Uint8Array(arraybuffer);
	
	    for (i = 0; i < len; i+=4) {
	      encoded1 = lookup[base64.charCodeAt(i)];
	      encoded2 = lookup[base64.charCodeAt(i+1)];
	      encoded3 = lookup[base64.charCodeAt(i+2)];
	      encoded4 = lookup[base64.charCodeAt(i+3)];
	
	      bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
	      bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
	      bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
	    }
	
	    return arraybuffer;
	  };
	})();


/***/ }),
/* 627 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Create a blob builder even when vendor prefixes exist
	 */
	
	var BlobBuilder = global.BlobBuilder
	  || global.WebKitBlobBuilder
	  || global.MSBlobBuilder
	  || global.MozBlobBuilder;
	
	/**
	 * Check if Blob constructor is supported
	 */
	
	var blobSupported = (function() {
	  try {
	    var a = new Blob(['hi']);
	    return a.size === 2;
	  } catch(e) {
	    return false;
	  }
	})();
	
	/**
	 * Check if Blob constructor supports ArrayBufferViews
	 * Fails in Safari 6, so we need to map to ArrayBuffers there.
	 */
	
	var blobSupportsArrayBufferView = blobSupported && (function() {
	  try {
	    var b = new Blob([new Uint8Array([1,2])]);
	    return b.size === 2;
	  } catch(e) {
	    return false;
	  }
	})();
	
	/**
	 * Check if BlobBuilder is supported
	 */
	
	var blobBuilderSupported = BlobBuilder
	  && BlobBuilder.prototype.append
	  && BlobBuilder.prototype.getBlob;
	
	/**
	 * Helper function that maps ArrayBufferViews to ArrayBuffers
	 * Used by BlobBuilder constructor and old browsers that didn't
	 * support it in the Blob constructor.
	 */
	
	function mapArrayBufferViews(ary) {
	  for (var i = 0; i < ary.length; i++) {
	    var chunk = ary[i];
	    if (chunk.buffer instanceof ArrayBuffer) {
	      var buf = chunk.buffer;
	
	      // if this is a subarray, make a copy so we only
	      // include the subarray region from the underlying buffer
	      if (chunk.byteLength !== buf.byteLength) {
	        var copy = new Uint8Array(chunk.byteLength);
	        copy.set(new Uint8Array(buf, chunk.byteOffset, chunk.byteLength));
	        buf = copy.buffer;
	      }
	
	      ary[i] = buf;
	    }
	  }
	}
	
	function BlobBuilderConstructor(ary, options) {
	  options = options || {};
	
	  var bb = new BlobBuilder();
	  mapArrayBufferViews(ary);
	
	  for (var i = 0; i < ary.length; i++) {
	    bb.append(ary[i]);
	  }
	
	  return (options.type) ? bb.getBlob(options.type) : bb.getBlob();
	};
	
	function BlobConstructor(ary, options) {
	  mapArrayBufferViews(ary);
	  return new Blob(ary, options || {});
	};
	
	module.exports = (function() {
	  if (blobSupported) {
	    return blobSupportsArrayBufferView ? global.Blob : BlobConstructor;
	  } else if (blobBuilderSupported) {
	    return BlobBuilderConstructor;
	  } else {
	    return undefined;
	  }
	})();
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Expose `Emitter`.
	 */
	
	if (true) {
	  module.exports = Emitter;
	}
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  function on() {
	    this.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks['$' + event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks['$' + event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	  var args = [].slice.call(arguments, 1)
	    , callbacks = this._callbacks['$' + event];
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks['$' + event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ }),
/* 629 */
/***/ (function(module, exports) {

	/**
	 * Compiles a querystring
	 * Returns string representation of the object
	 *
	 * @param {Object}
	 * @api private
	 */
	
	exports.encode = function (obj) {
	  var str = '';
	
	  for (var i in obj) {
	    if (obj.hasOwnProperty(i)) {
	      if (str.length) str += '&';
	      str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
	    }
	  }
	
	  return str;
	};
	
	/**
	 * Parses a simple querystring into an object
	 *
	 * @param {String} qs
	 * @api private
	 */
	
	exports.decode = function(qs){
	  var qry = {};
	  var pairs = qs.split('&');
	  for (var i = 0, l = pairs.length; i < l; i++) {
	    var pair = pairs[i].split('=');
	    qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
	  }
	  return qry;
	};


/***/ }),
/* 630 */
/***/ (function(module, exports) {

	
	module.exports = function(a, b){
	  var fn = function(){};
	  fn.prototype = b.prototype;
	  a.prototype = new fn;
	  a.prototype.constructor = a;
	};

/***/ }),
/* 631 */
/***/ (function(module, exports) {

	'use strict';
	
	var alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_'.split('')
	  , length = 64
	  , map = {}
	  , seed = 0
	  , i = 0
	  , prev;
	
	/**
	 * Return a string representing the specified number.
	 *
	 * @param {Number} num The number to convert.
	 * @returns {String} The string representation of the number.
	 * @api public
	 */
	function encode(num) {
	  var encoded = '';
	
	  do {
	    encoded = alphabet[num % length] + encoded;
	    num = Math.floor(num / length);
	  } while (num > 0);
	
	  return encoded;
	}
	
	/**
	 * Return the integer value specified by the given string.
	 *
	 * @param {String} str The string to convert.
	 * @returns {Number} The integer value represented by the string.
	 * @api public
	 */
	function decode(str) {
	  var decoded = 0;
	
	  for (i = 0; i < str.length; i++) {
	    decoded = decoded * length + map[str.charAt(i)];
	  }
	
	  return decoded;
	}
	
	/**
	 * Yeast: A tiny growing id generator.
	 *
	 * @returns {String} A unique id.
	 * @api public
	 */
	function yeast() {
	  var now = encode(+new Date());
	
	  if (now !== prev) return seed = 0, prev = now;
	  return now +'.'+ encode(seed++);
	}
	
	//
	// Map each character to its index.
	//
	for (; i < length; i++) map[alphabet[i]] = i;
	
	//
	// Expose the `yeast`, `encode` and `decode` functions.
	//
	yeast.encode = encode;
	yeast.decode = decode;
	module.exports = yeast;


/***/ }),
/* 632 */
[1356, 633],
/* 633 */
[1357, 634],
/* 634 */
599,
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module requirements.
	 */
	
	var Polling = __webpack_require__(618);
	var inherit = __webpack_require__(630);
	
	/**
	 * Module exports.
	 */
	
	module.exports = JSONPPolling;
	
	/**
	 * Cached regular expressions.
	 */
	
	var rNewline = /\n/g;
	var rEscapedNewline = /\\n/g;
	
	/**
	 * Global JSONP callbacks.
	 */
	
	var callbacks;
	
	/**
	 * Noop.
	 */
	
	function empty () { }
	
	/**
	 * JSONP Polling constructor.
	 *
	 * @param {Object} opts.
	 * @api public
	 */
	
	function JSONPPolling (opts) {
	  Polling.call(this, opts);
	
	  this.query = this.query || {};
	
	  // define global callbacks array if not present
	  // we do this here (lazily) to avoid unneeded global pollution
	  if (!callbacks) {
	    // we need to consider multiple engines in the same page
	    if (!global.___eio) global.___eio = [];
	    callbacks = global.___eio;
	  }
	
	  // callback identifier
	  this.index = callbacks.length;
	
	  // add callback to jsonp global
	  var self = this;
	  callbacks.push(function (msg) {
	    self.onData(msg);
	  });
	
	  // append to query string
	  this.query.j = this.index;
	
	  // prevent spurious errors from being emitted when the window is unloaded
	  if (global.document && global.addEventListener) {
	    global.addEventListener('beforeunload', function () {
	      if (self.script) self.script.onerror = empty;
	    }, false);
	  }
	}
	
	/**
	 * Inherits from Polling.
	 */
	
	inherit(JSONPPolling, Polling);
	
	/*
	 * JSONP only supports binary as base64 encoded strings
	 */
	
	JSONPPolling.prototype.supportsBinary = false;
	
	/**
	 * Closes the socket.
	 *
	 * @api private
	 */
	
	JSONPPolling.prototype.doClose = function () {
	  if (this.script) {
	    this.script.parentNode.removeChild(this.script);
	    this.script = null;
	  }
	
	  if (this.form) {
	    this.form.parentNode.removeChild(this.form);
	    this.form = null;
	    this.iframe = null;
	  }
	
	  Polling.prototype.doClose.call(this);
	};
	
	/**
	 * Starts a poll cycle.
	 *
	 * @api private
	 */
	
	JSONPPolling.prototype.doPoll = function () {
	  var self = this;
	  var script = document.createElement('script');
	
	  if (this.script) {
	    this.script.parentNode.removeChild(this.script);
	    this.script = null;
	  }
	
	  script.async = true;
	  script.src = this.uri();
	  script.onerror = function (e) {
	    self.onError('jsonp poll error', e);
	  };
	
	  var insertAt = document.getElementsByTagName('script')[0];
	  if (insertAt) {
	    insertAt.parentNode.insertBefore(script, insertAt);
	  } else {
	    (document.head || document.body).appendChild(script);
	  }
	  this.script = script;
	
	  var isUAgecko = 'undefined' !== typeof navigator && /gecko/i.test(navigator.userAgent);
	
	  if (isUAgecko) {
	    setTimeout(function () {
	      var iframe = document.createElement('iframe');
	      document.body.appendChild(iframe);
	      document.body.removeChild(iframe);
	    }, 100);
	  }
	};
	
	/**
	 * Writes with a hidden iframe.
	 *
	 * @param {String} data to send
	 * @param {Function} called upon flush.
	 * @api private
	 */
	
	JSONPPolling.prototype.doWrite = function (data, fn) {
	  var self = this;
	
	  if (!this.form) {
	    var form = document.createElement('form');
	    var area = document.createElement('textarea');
	    var id = this.iframeId = 'eio_iframe_' + this.index;
	    var iframe;
	
	    form.className = 'socketio';
	    form.style.position = 'absolute';
	    form.style.top = '-1000px';
	    form.style.left = '-1000px';
	    form.target = id;
	    form.method = 'POST';
	    form.setAttribute('accept-charset', 'utf-8');
	    area.name = 'd';
	    form.appendChild(area);
	    document.body.appendChild(form);
	
	    this.form = form;
	    this.area = area;
	  }
	
	  this.form.action = this.uri();
	
	  function complete () {
	    initIframe();
	    fn();
	  }
	
	  function initIframe () {
	    if (self.iframe) {
	      try {
	        self.form.removeChild(self.iframe);
	      } catch (e) {
	        self.onError('jsonp polling iframe removal error', e);
	      }
	    }
	
	    try {
	      // ie6 dynamic iframes with target="" support (thanks Chris Lambacher)
	      var html = '<iframe src="javascript:0" name="' + self.iframeId + '">';
	      iframe = document.createElement(html);
	    } catch (e) {
	      iframe = document.createElement('iframe');
	      iframe.name = self.iframeId;
	      iframe.src = 'javascript:0';
	    }
	
	    iframe.id = self.iframeId;
	
	    self.form.appendChild(iframe);
	    self.iframe = iframe;
	  }
	
	  initIframe();
	
	  // escape \n to prevent it from being converted into \r\n by some UAs
	  // double escaping is required for escaped new lines because unescaping of new lines can be done safely on server-side
	  data = data.replace(rEscapedNewline, '\\\n');
	  this.area.value = data.replace(rNewline, '\\n');
	
	  try {
	    this.form.submit();
	  } catch (e) {}
	
	  if (this.iframe.attachEvent) {
	    this.iframe.onreadystatechange = function () {
	      if (self.iframe.readyState === 'complete') {
	        complete();
	      }
	    };
	  } else {
	    this.iframe.onload = complete;
	  }
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module dependencies.
	 */
	
	var Transport = __webpack_require__(619);
	var parser = __webpack_require__(620);
	var parseqs = __webpack_require__(629);
	var inherit = __webpack_require__(630);
	var yeast = __webpack_require__(631);
	var debug = __webpack_require__(632)('engine.io-client:websocket');
	var BrowserWebSocket = global.WebSocket || global.MozWebSocket;
	var NodeWebSocket;
	if (typeof window === 'undefined') {
	  try {
	    NodeWebSocket = __webpack_require__(637);
	  } catch (e) { }
	}
	
	/**
	 * Get either the `WebSocket` or `MozWebSocket` globals
	 * in the browser or try to resolve WebSocket-compatible
	 * interface exposed by `ws` for Node-like environment.
	 */
	
	var WebSocket = BrowserWebSocket;
	if (!WebSocket && typeof window === 'undefined') {
	  WebSocket = NodeWebSocket;
	}
	
	/**
	 * Module exports.
	 */
	
	module.exports = WS;
	
	/**
	 * WebSocket transport constructor.
	 *
	 * @api {Object} connection options
	 * @api public
	 */
	
	function WS (opts) {
	  var forceBase64 = (opts && opts.forceBase64);
	  if (forceBase64) {
	    this.supportsBinary = false;
	  }
	  this.perMessageDeflate = opts.perMessageDeflate;
	  this.usingBrowserWebSocket = BrowserWebSocket && !opts.forceNode;
	  if (!this.usingBrowserWebSocket) {
	    WebSocket = NodeWebSocket;
	  }
	  Transport.call(this, opts);
	}
	
	/**
	 * Inherits from Transport.
	 */
	
	inherit(WS, Transport);
	
	/**
	 * Transport name.
	 *
	 * @api public
	 */
	
	WS.prototype.name = 'websocket';
	
	/*
	 * WebSockets support binary
	 */
	
	WS.prototype.supportsBinary = true;
	
	/**
	 * Opens socket.
	 *
	 * @api private
	 */
	
	WS.prototype.doOpen = function () {
	  if (!this.check()) {
	    // let probe timeout
	    return;
	  }
	
	  var uri = this.uri();
	  var protocols = void (0);
	  var opts = {
	    agent: this.agent,
	    perMessageDeflate: this.perMessageDeflate
	  };
	
	  // SSL options for Node.js client
	  opts.pfx = this.pfx;
	  opts.key = this.key;
	  opts.passphrase = this.passphrase;
	  opts.cert = this.cert;
	  opts.ca = this.ca;
	  opts.ciphers = this.ciphers;
	  opts.rejectUnauthorized = this.rejectUnauthorized;
	  if (this.extraHeaders) {
	    opts.headers = this.extraHeaders;
	  }
	  if (this.localAddress) {
	    opts.localAddress = this.localAddress;
	  }
	
	  try {
	    this.ws = this.usingBrowserWebSocket ? new WebSocket(uri) : new WebSocket(uri, protocols, opts);
	  } catch (err) {
	    return this.emit('error', err);
	  }
	
	  if (this.ws.binaryType === undefined) {
	    this.supportsBinary = false;
	  }
	
	  if (this.ws.supports && this.ws.supports.binary) {
	    this.supportsBinary = true;
	    this.ws.binaryType = 'nodebuffer';
	  } else {
	    this.ws.binaryType = 'arraybuffer';
	  }
	
	  this.addEventListeners();
	};
	
	/**
	 * Adds event listeners to the socket
	 *
	 * @api private
	 */
	
	WS.prototype.addEventListeners = function () {
	  var self = this;
	
	  this.ws.onopen = function () {
	    self.onOpen();
	  };
	  this.ws.onclose = function () {
	    self.onClose();
	  };
	  this.ws.onmessage = function (ev) {
	    self.onData(ev.data);
	  };
	  this.ws.onerror = function (e) {
	    self.onError('websocket error', e);
	  };
	};
	
	/**
	 * Writes data to socket.
	 *
	 * @param {Array} array of packets.
	 * @api private
	 */
	
	WS.prototype.write = function (packets) {
	  var self = this;
	  this.writable = false;
	
	  // encodePacket efficient as it uses WS framing
	  // no need for encodePayload
	  var total = packets.length;
	  for (var i = 0, l = total; i < l; i++) {
	    (function (packet) {
	      parser.encodePacket(packet, self.supportsBinary, function (data) {
	        if (!self.usingBrowserWebSocket) {
	          // always create a new object (GH-437)
	          var opts = {};
	          if (packet.options) {
	            opts.compress = packet.options.compress;
	          }
	
	          if (self.perMessageDeflate) {
	            var len = 'string' === typeof data ? global.Buffer.byteLength(data) : data.length;
	            if (len < self.perMessageDeflate.threshold) {
	              opts.compress = false;
	            }
	          }
	        }
	
	        // Sometimes the websocket has already been closed but the browser didn't
	        // have a chance of informing us about it yet, in that case send will
	        // throw an error
	        try {
	          if (self.usingBrowserWebSocket) {
	            // TypeError is thrown when passing the second argument on Safari
	            self.ws.send(data);
	          } else {
	            self.ws.send(data, opts);
	          }
	        } catch (e) {
	          debug('websocket closed before onclose event');
	        }
	
	        --total || done();
	      });
	    })(packets[i]);
	  }
	
	  function done () {
	    self.emit('flush');
	
	    // fake drain
	    // defer to next tick to allow Socket to clear writeBuffer
	    setTimeout(function () {
	      self.writable = true;
	      self.emit('drain');
	    }, 0);
	  }
	};
	
	/**
	 * Called upon close
	 *
	 * @api private
	 */
	
	WS.prototype.onClose = function () {
	  Transport.prototype.onClose.call(this);
	};
	
	/**
	 * Closes socket.
	 *
	 * @api private
	 */
	
	WS.prototype.doClose = function () {
	  if (typeof this.ws !== 'undefined') {
	    this.ws.close();
	  }
	};
	
	/**
	 * Generates uri for connection.
	 *
	 * @api private
	 */
	
	WS.prototype.uri = function () {
	  var query = this.query || {};
	  var schema = this.secure ? 'wss' : 'ws';
	  var port = '';
	
	  // avoid port if default for schema
	  if (this.port && (('wss' === schema && Number(this.port) !== 443) ||
	    ('ws' === schema && Number(this.port) !== 80))) {
	    port = ':' + this.port;
	  }
	
	  // append timestamp to URI
	  if (this.timestampRequests) {
	    query[this.timestampParam] = yeast();
	  }
	
	  // communicate binary support capabilities
	  if (!this.supportsBinary) {
	    query.b64 = 1;
	  }
	
	  query = parseqs.encode(query);
	
	  // prepend ? to query
	  if (query.length) {
	    query = '?' + query;
	  }
	
	  var ipv6 = this.hostname.indexOf(':') !== -1;
	  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
	};
	
	/**
	 * Feature detection for WebSocket.
	 *
	 * @return {Boolean} whether this transport is available.
	 * @api public
	 */
	
	WS.prototype.check = function () {
	  return !!WebSocket && !('__initialize' in WebSocket && this.name === WS.prototype.name);
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 637 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 638 */
/***/ (function(module, exports) {

	
	var indexOf = [].indexOf;
	
	module.exports = function(arr, obj){
	  if (indexOf) return arr.indexOf(obj);
	  for (var i = 0; i < arr.length; ++i) {
	    if (arr[i] === obj) return i;
	  }
	  return -1;
	};

/***/ }),
/* 639 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * JSON parse.
	 *
	 * @see Based on jQuery#parseJSON (MIT) and JSON2
	 * @api private
	 */
	
	var rvalidchars = /^[\],:{}\s]*$/;
	var rvalidescape = /\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g;
	var rvalidtokens = /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
	var rvalidbraces = /(?:^|:|,)(?:\s*\[)+/g;
	var rtrimLeft = /^\s+/;
	var rtrimRight = /\s+$/;
	
	module.exports = function parsejson(data) {
	  if ('string' != typeof data || !data) {
	    return null;
	  }
	
	  data = data.replace(rtrimLeft, '').replace(rtrimRight, '');
	
	  // Attempt to parse using the native JSON parser first
	  if (global.JSON && JSON.parse) {
	    return JSON.parse(data);
	  }
	
	  if (rvalidchars.test(data.replace(rvalidescape, '@')
	      .replace(rvalidtokens, ']')
	      .replace(rvalidbraces, ''))) {
	    return (new Function('return ' + data))();
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var parser = __webpack_require__(600);
	var Emitter = __webpack_require__(628);
	var toArray = __webpack_require__(641);
	var on = __webpack_require__(642);
	var bind = __webpack_require__(643);
	var debug = __webpack_require__(596)('socket.io-client:socket');
	var hasBin = __webpack_require__(622);
	
	/**
	 * Module exports.
	 */
	
	module.exports = exports = Socket;
	
	/**
	 * Internal events (blacklisted).
	 * These events can't be emitted by the user.
	 *
	 * @api private
	 */
	
	var events = {
	  connect: 1,
	  connect_error: 1,
	  connect_timeout: 1,
	  connecting: 1,
	  disconnect: 1,
	  error: 1,
	  reconnect: 1,
	  reconnect_attempt: 1,
	  reconnect_failed: 1,
	  reconnect_error: 1,
	  reconnecting: 1,
	  ping: 1,
	  pong: 1
	};
	
	/**
	 * Shortcut to `Emitter#emit`.
	 */
	
	var emit = Emitter.prototype.emit;
	
	/**
	 * `Socket` constructor.
	 *
	 * @api public
	 */
	
	function Socket (io, nsp, opts) {
	  this.io = io;
	  this.nsp = nsp;
	  this.json = this; // compat
	  this.ids = 0;
	  this.acks = {};
	  this.receiveBuffer = [];
	  this.sendBuffer = [];
	  this.connected = false;
	  this.disconnected = true;
	  if (opts && opts.query) {
	    this.query = opts.query;
	  }
	  if (this.io.autoConnect) this.open();
	}
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Socket.prototype);
	
	/**
	 * Subscribe to open, close and packet events
	 *
	 * @api private
	 */
	
	Socket.prototype.subEvents = function () {
	  if (this.subs) return;
	
	  var io = this.io;
	  this.subs = [
	    on(io, 'open', bind(this, 'onopen')),
	    on(io, 'packet', bind(this, 'onpacket')),
	    on(io, 'close', bind(this, 'onclose'))
	  ];
	};
	
	/**
	 * "Opens" the socket.
	 *
	 * @api public
	 */
	
	Socket.prototype.open =
	Socket.prototype.connect = function () {
	  if (this.connected) return this;
	
	  this.subEvents();
	  this.io.open(); // ensure open
	  if ('open' === this.io.readyState) this.onopen();
	  this.emit('connecting');
	  return this;
	};
	
	/**
	 * Sends a `message` event.
	 *
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.send = function () {
	  var args = toArray(arguments);
	  args.unshift('message');
	  this.emit.apply(this, args);
	  return this;
	};
	
	/**
	 * Override `emit`.
	 * If the event is in `events`, it's emitted normally.
	 *
	 * @param {String} event name
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.emit = function (ev) {
	  if (events.hasOwnProperty(ev)) {
	    emit.apply(this, arguments);
	    return this;
	  }
	
	  var args = toArray(arguments);
	  var parserType = parser.EVENT; // default
	  if (hasBin(args)) { parserType = parser.BINARY_EVENT; } // binary
	  var packet = { type: parserType, data: args };
	
	  packet.options = {};
	  packet.options.compress = !this.flags || false !== this.flags.compress;
	
	  // event ack callback
	  if ('function' === typeof args[args.length - 1]) {
	    debug('emitting packet with ack id %d', this.ids);
	    this.acks[this.ids] = args.pop();
	    packet.id = this.ids++;
	  }
	
	  if (this.connected) {
	    this.packet(packet);
	  } else {
	    this.sendBuffer.push(packet);
	  }
	
	  delete this.flags;
	
	  return this;
	};
	
	/**
	 * Sends a packet.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.packet = function (packet) {
	  packet.nsp = this.nsp;
	  this.io.packet(packet);
	};
	
	/**
	 * Called upon engine `open`.
	 *
	 * @api private
	 */
	
	Socket.prototype.onopen = function () {
	  debug('transport is open - connecting');
	
	  // write connect packet if necessary
	  if ('/' !== this.nsp) {
	    if (this.query) {
	      this.packet({type: parser.CONNECT, query: this.query});
	    } else {
	      this.packet({type: parser.CONNECT});
	    }
	  }
	};
	
	/**
	 * Called upon engine `close`.
	 *
	 * @param {String} reason
	 * @api private
	 */
	
	Socket.prototype.onclose = function (reason) {
	  debug('close (%s)', reason);
	  this.connected = false;
	  this.disconnected = true;
	  delete this.id;
	  this.emit('disconnect', reason);
	};
	
	/**
	 * Called with socket packet.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.onpacket = function (packet) {
	  if (packet.nsp !== this.nsp) return;
	
	  switch (packet.type) {
	    case parser.CONNECT:
	      this.onconnect();
	      break;
	
	    case parser.EVENT:
	      this.onevent(packet);
	      break;
	
	    case parser.BINARY_EVENT:
	      this.onevent(packet);
	      break;
	
	    case parser.ACK:
	      this.onack(packet);
	      break;
	
	    case parser.BINARY_ACK:
	      this.onack(packet);
	      break;
	
	    case parser.DISCONNECT:
	      this.ondisconnect();
	      break;
	
	    case parser.ERROR:
	      this.emit('error', packet.data);
	      break;
	  }
	};
	
	/**
	 * Called upon a server event.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.onevent = function (packet) {
	  var args = packet.data || [];
	  debug('emitting event %j', args);
	
	  if (null != packet.id) {
	    debug('attaching ack callback to event');
	    args.push(this.ack(packet.id));
	  }
	
	  if (this.connected) {
	    emit.apply(this, args);
	  } else {
	    this.receiveBuffer.push(args);
	  }
	};
	
	/**
	 * Produces an ack callback to emit with an event.
	 *
	 * @api private
	 */
	
	Socket.prototype.ack = function (id) {
	  var self = this;
	  var sent = false;
	  return function () {
	    // prevent double callbacks
	    if (sent) return;
	    sent = true;
	    var args = toArray(arguments);
	    debug('sending ack %j', args);
	
	    var type = hasBin(args) ? parser.BINARY_ACK : parser.ACK;
	    self.packet({
	      type: type,
	      id: id,
	      data: args
	    });
	  };
	};
	
	/**
	 * Called upon a server acknowlegement.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.onack = function (packet) {
	  var ack = this.acks[packet.id];
	  if ('function' === typeof ack) {
	    debug('calling ack %s with %j', packet.id, packet.data);
	    ack.apply(this, packet.data);
	    delete this.acks[packet.id];
	  } else {
	    debug('bad ack %s', packet.id);
	  }
	};
	
	/**
	 * Called upon server connect.
	 *
	 * @api private
	 */
	
	Socket.prototype.onconnect = function () {
	  this.connected = true;
	  this.disconnected = false;
	  this.emit('connect');
	  this.emitBuffered();
	};
	
	/**
	 * Emit buffered events (received and emitted).
	 *
	 * @api private
	 */
	
	Socket.prototype.emitBuffered = function () {
	  var i;
	  for (i = 0; i < this.receiveBuffer.length; i++) {
	    emit.apply(this, this.receiveBuffer[i]);
	  }
	  this.receiveBuffer = [];
	
	  for (i = 0; i < this.sendBuffer.length; i++) {
	    this.packet(this.sendBuffer[i]);
	  }
	  this.sendBuffer = [];
	};
	
	/**
	 * Called upon server disconnect.
	 *
	 * @api private
	 */
	
	Socket.prototype.ondisconnect = function () {
	  debug('server disconnect (%s)', this.nsp);
	  this.destroy();
	  this.onclose('io server disconnect');
	};
	
	/**
	 * Called upon forced client/server side disconnections,
	 * this method ensures the manager stops tracking us and
	 * that reconnections don't get triggered for this.
	 *
	 * @api private.
	 */
	
	Socket.prototype.destroy = function () {
	  if (this.subs) {
	    // clean subscriptions to avoid reconnections
	    for (var i = 0; i < this.subs.length; i++) {
	      this.subs[i].destroy();
	    }
	    this.subs = null;
	  }
	
	  this.io.destroy(this);
	};
	
	/**
	 * Disconnects the socket manually.
	 *
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.close =
	Socket.prototype.disconnect = function () {
	  if (this.connected) {
	    debug('performing disconnect (%s)', this.nsp);
	    this.packet({ type: parser.DISCONNECT });
	  }
	
	  // remove socket from pool
	  this.destroy();
	
	  if (this.connected) {
	    // fire events
	    this.onclose('io client disconnect');
	  }
	  return this;
	};
	
	/**
	 * Sets the compress flag.
	 *
	 * @param {Boolean} if `true`, compresses the sending data
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.compress = function (compress) {
	  this.flags = this.flags || {};
	  this.flags.compress = compress;
	  return this;
	};


/***/ }),
/* 641 */
/***/ (function(module, exports) {

	module.exports = toArray
	
	function toArray(list, index) {
	    var array = []
	
	    index = index || 0
	
	    for (var i = index || 0; i < list.length; i++) {
	        array[i - index] = list[i]
	    }
	
	    return array
	}


/***/ }),
/* 642 */
/***/ (function(module, exports) {

	
	/**
	 * Module exports.
	 */
	
	module.exports = on;
	
	/**
	 * Helper for subscriptions.
	 *
	 * @param {Object|EventEmitter} obj with `Emitter` mixin or `EventEmitter`
	 * @param {String} event name
	 * @param {Function} callback
	 * @api public
	 */
	
	function on (obj, ev, fn) {
	  obj.on(ev, fn);
	  return {
	    destroy: function () {
	      obj.removeListener(ev, fn);
	    }
	  };
	}


/***/ }),
/* 643 */
/***/ (function(module, exports) {

	/**
	 * Slice reference.
	 */
	
	var slice = [].slice;
	
	/**
	 * Bind `obj` to `fn`.
	 *
	 * @param {Object} obj
	 * @param {Function|String} fn or string
	 * @return {Function}
	 * @api public
	 */
	
	module.exports = function(obj, fn){
	  if ('string' == typeof fn) fn = obj[fn];
	  if ('function' != typeof fn) throw new Error('bind() requires a function');
	  var args = slice.call(arguments, 2);
	  return function(){
	    return fn.apply(obj, args.concat(slice.call(arguments)));
	  }
	};


/***/ }),
/* 644 */
/***/ (function(module, exports) {

	
	/**
	 * Expose `Backoff`.
	 */
	
	module.exports = Backoff;
	
	/**
	 * Initialize backoff timer with `opts`.
	 *
	 * - `min` initial timeout in milliseconds [100]
	 * - `max` max timeout [10000]
	 * - `jitter` [0]
	 * - `factor` [2]
	 *
	 * @param {Object} opts
	 * @api public
	 */
	
	function Backoff(opts) {
	  opts = opts || {};
	  this.ms = opts.min || 100;
	  this.max = opts.max || 10000;
	  this.factor = opts.factor || 2;
	  this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
	  this.attempts = 0;
	}
	
	/**
	 * Return the backoff duration.
	 *
	 * @return {Number}
	 * @api public
	 */
	
	Backoff.prototype.duration = function(){
	  var ms = this.ms * Math.pow(this.factor, this.attempts++);
	  if (this.jitter) {
	    var rand =  Math.random();
	    var deviation = Math.floor(rand * this.jitter * ms);
	    ms = (Math.floor(rand * 10) & 1) == 0  ? ms - deviation : ms + deviation;
	  }
	  return Math.min(ms, this.max) | 0;
	};
	
	/**
	 * Reset the number of attempts.
	 *
	 * @api public
	 */
	
	Backoff.prototype.reset = function(){
	  this.attempts = 0;
	};
	
	/**
	 * Set the minimum duration
	 *
	 * @api public
	 */
	
	Backoff.prototype.setMin = function(min){
	  this.ms = min;
	};
	
	/**
	 * Set the maximum duration
	 *
	 * @api public
	 */
	
	Backoff.prototype.setMax = function(max){
	  this.max = max;
	};
	
	/**
	 * Set the jitter
	 *
	 * @api public
	 */
	
	Backoff.prototype.setJitter = function(jitter){
	  this.jitter = jitter;
	};
	


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var moment = __webpack_require__(435);
	var DateTimeZonePipe = (function () {
	    function DateTimeZonePipe() {
	    }
	    DateTimeZonePipe.prototype.transform = function (value, pattern, offset) {
	        if (moment(value).isValid())
	            return moment(value).utcOffset(offset).format(pattern);
	        else
	            return "";
	    };
	    DateTimeZonePipe = __decorate([
	        core_1.Pipe({
	            name: 'dateTimeZone'
	        }),
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [])
	    ], DateTimeZonePipe);
	    return DateTimeZonePipe;
	}());
	exports.DateTimeZonePipe = DateTimeZonePipe;


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div id=\"right-sidebar-wrapper\" class=\"\" *ngIf=\"loginService.isLoggedIn()\">\n    <div class=\"navRightResUser col-xs-12\" onClick={this.ocultarBarra.bind(this)}>\n        <div class=\"col-xs-4\">\n            <div class=\"previewFotoPerfil\">\n                <img id=\"logoEmpresa\" [src]=\"urlLogo\" class=\"\"/>\n            </div>\n        </div>\n        <div class=\"col-xs-8 name-usuario\">\n            <h4>{{usuario.nombre + \" \" + usuario.apellido}}</h4>\n            <p class=\"text-muted\" style=\"margin-bottom: 0px; color:black\">\n                {{usuario.rol}}\n            </p>\n            <p class=\"text-muted\" style=\"margin-bottom: 0px; color:black\">\n                {{usuario.puesto}}\n            </p>\n        </div>\n    </div>\n    <div class=\"navRightResOptions col-xs-12\">\n        <ul class=\"nav nav-tabs\">\n            <li id=\"configuracionLink\" class=\"col-xs-4 active\">\n                <a data-toggle=\"tab\" href=\"#configuracion\">\n                    <img src=\"" + __webpack_require__(585) + "\" style=\"width: 20px\"/>\n                </a>\n            </li>\n            <li id=\"notificacionesLink\" class=\"col-xs-4\">\n                <a data-toggle=\"tab\" href=\"#notificaciones\">\n                    <img src=\"" + __webpack_require__(647) + "\" style=\"width: 20px\"/>\n                    <span *ngIf=\"regAlarmas.length>0\"\n                          class=\"badge\">{{regAlarmas.length}}</span>\n                </a>\n            </li>\n            <li id=\"notificacionesRangoLink\"\n                class=\"col-xs-4\">\n                <a data-toggle=\"tab\" href=\"#notificacionesRango\">\n                    <img src=\"" + __webpack_require__(648) + "\" style=\"width: 20px\"/>\n                    <span *ngIf=\"regAlarmasRango.length>0\" class=\"badge\">{{regAlarmasRango.length}}</span>\n                </a>\n            </li>\n        </ul>\n    </div>\n    <div class=\"tab-content col-xs-12 navRightResTabs\" style=\"margin-bottom:100px\">\n        <div id=\"configuracion\" class=\"tab-pane fade in active\">\n            <h5>Configuración</h5>\n            <ul class=\"\">\n                <li routerLinkActive=\"active\">\n                    <a routerLink=\"miCuenta\" (click)=\"toogleBar()\">\n                        <span class=\"glyphicon glyphicon-user\"></span> Mi cuenta\n                    </a>\n                </li>\n                <li routerLinkActive=\"active\">\n                    <a routerLink=\"cambiarPassword\" (click)=\"toogleBar()\">\n                        <span class=\"glyphicon glyphicon-lock\"></span> Cambiar contraseña\n                    </a>\n                </li>\n                <li routerLinkActive=\"active\">\n                    <a target=\"_blank\" href=\"https://wa.me/5493416932144\" (click)=\"toogleBar()\" style=\"display: flex; align-items: baseline\">\n                        <img src=\"" + __webpack_require__(649) + "\" style=\"width: 15px; margin-left: 5px; margin-right: 10px\"/> Servicio Técnico\n                    </a>\n                </li>\n                <li class=\"divider\"></li>\n                <li style=\"text-align:center; cursor: pointer\" (click)=\"logout()\">Cerrar Sesión</li>\n            </ul>\n        </div>\n        <div id=\"notificaciones\" class=\"tab-pane fade\">\n            <h5>Alarmas Activas</h5>\n            <div class=\"itemNotificacion\" *ngFor=\"let alarma of regAlarmas; let i = index\"\n                 [hidden]=\"((alarma.sensor_id!=null && alarma.sensor_id.posicionString == 9 && usuario.rol != 'Administrador' && usuario.rol != 'Tecnico'))\">\n                <b>\n                    {{alarma.tipoEspecial == null ? \"Alarma por rango\" : (alarma.tipoEspecial == \"SINACTIVIDAD\" ? \"Sin Actividad\" : alarma.tipoEspecial == \"SENSORNULL\" ? \"Sensor sin información\" : (alarma.tipoEspecial == \"CALIBRACION\" ? \"Próxima calibración\" : \"Bateria Baja\"))}}\n                </b>\n                <p *ngIf=\"alarma.nodo_id\">\n                    {{ \"Sucursal: \" + (alarma.nodo_id.ubicacion_id.sucursal_id ? alarma.nodo_id.ubicacion_id.sucursal_id.descripcion : \"\") + \" - \" + (alarma.nodo_id.ubicacion_id.sucursal_id ? alarma.nodo_id.ubicacion_id.sucursal_id.empresa.descripcion : \"\")}}\n                </p>\n                <p *ngIf=\"alarma.sucursal_id\">\n                    {{ \"Sucursal: \" + (alarma.sucursal_id ? alarma.sucursal_id.descripcion : \"\") + \" - \" + (alarma.sucursal_id ? alarma.sucursal_id.empresa.descripcion : \"\")}}\n                </p>\n                <p *ngIf=\"alarma.nodo_id\">\n                    {{\"Ubicación: \" + alarma.nodo_id.ubicacion_id.descripcion}}\n                </p>\n                <p *ngIf=\"alarma.sensor_id!=null\">\n                    Canal de Monitorización:\n                </p>\n                <b *ngIf=\"alarma.sensor_id!=null\">\n                    {{alarma.sensor_id.etiqueta}}\n                </b>\n                <p *ngIf=\"alarma.nodo_id\">\n                    {{\"Nodo: \" + alarma.nodo_id.etiqueta}}\n                </p>\n                <p *ngIf=\"alarma.sensor_id!=null && alarma.valorMedido!=undefined\">\n                    {{\"Valor Detectado: \" + alarma.valorMedido}}\n                </p>\n                <p style=\"display: flex\">\n                    <label *ngFor=\"let c of alarma.color\"\n                           [ngClass]=\"{'label': true, 'label-warning': c=='Amarillo' || c=='Duración estimada' || c=='En 60 días', 'label-danger': c=='Rojo' || c=='Voltaje bajo' || c=='En 30 días'}\"\n                           style=\"margin-right: 5px\">\n                        {{c}}\n                    </label>\n                </p>\n                <p [hidden]=\"!alarma.tipoEspecial\" style=\"margin-top: 5px; margin-bottom: 5px\">\n                    <label [ngClass]=\"{'label': true, 'label-info': alarma.tipoEspecial=='SINACTIVIDAD', 'label-primary': alarma.tipoEspecial=='SENSORNULL' || alarma.tipoEspecial=='CALIBRACION', 'label-success': alarma.tipoEspecial=='BATERIABAJA'}\"\n                           style=\"margin-right: 5px\">\n                        {{alarma.tipoEspecial == \"SINACTIVIDAD\" ? \"Sin Actividad\" : alarma.tipoEspecial == \"SENSORNULL\" ? \"Sensor sin información\" : (alarma.tipoEspecial == \"CALIBRACION\" ? \"Próxima calibración\" : \"Bateria Baja\")}}\n                    </label>\n                </p>\n                <p *ngIf=\"alarma.nodo_id\">\n                    {{\"Activación: \" + (alarma.fechaActivado | dateTimeZone: 'DD/MM/yyyy HH:mm' : (alarma.nodo_id.ubicacion_id.sucursal_id.husoHorario_id ? alarma.nodo_id.ubicacion_id.sucursal_id.husoHorario_id.offset : \"-03:00\"))}}\n                </p>\n                <p *ngIf=\"alarma.sucursal_id\">\n                    {{\"Activación: \" + (alarma.fechaActivado | dateTimeZone: 'DD/MM/yyyy HH:mm' : (alarma.sucursal_id.husoHorario_id ? alarma.sucursal_id.husoHorario_id.offset : \"-03:00\"))}}\n                </p>\n            </div>\n            <b *ngIf=\"regAlarmas==undefined || regAlarmas.length==0\">No hay alarmas activas.</b>\n        </div>\n        <div id=\"notificacionesRango\" class=\"tab-pane fade\">\n            <h5>Alarmas Activas</h5>\n            <div class=\"itemNotificacion\" *ngFor=\"let alarma of regAlarmasRango; let i = index\"\n                 [hidden]=\"((alarma.sensor_id!=null && alarma.sensor_id.posicionString == 9  && usuario.rol != 'Administrador' && usuario.rol != 'Tecnico'))\">\n                <b>\n                    {{alarma.tipoEspecial == null ? \"Alarma por rango\" : (alarma.tipoEspecial == \"SINACTIVIDAD\" ? \"Sin Actividad\" : alarma.tipoEspecial == \"SENSORNULL\" ? \"Sensor sin información\" : \"Bateria Baja\")}}\n                </b>\n                <p>\n                    {{ \"Sucursal: \" + (alarma.nodo_id.ubicacion_id.sucursal_id ? alarma.nodo_id.ubicacion_id.sucursal_id.descripcion : \"\") + \" - \" + (alarma.nodo_id.ubicacion_id.sucursal_id ? alarma.nodo_id.ubicacion_id.sucursal_id.empresa.descripcion : \"\")}}\n                </p>\n                <p>\n                    {{\"Ubicación: \" + alarma.nodo_id.ubicacion_id.descripcion}}\n                </p>\n                <p *ngIf=\"alarma.sensor_id!=null\">\n                    Canal de Monitorización:\n                </p>\n                <b *ngIf=\"alarma.sensor_id!=null\">\n                    {{alarma.sensor_id.etiqueta}}\n                </b>\n                <p>\n                    {{\"Nodo: \" + alarma.nodo_id.etiqueta}}\n                </p>\n                <p *ngIf=\"alarma.sensor_id!=null && alarma.valorMedido!=undefined\">\n                    {{\"Valor Detectado: \" + alarma.valorMedido}}\n                </p>\n                <p style=\"display: flex\">\n                    <label *ngFor=\"let c of alarma.color\"\n                           [ngClass]=\"{'label': true, 'label-warning': c=='Amarillo', 'label-danger': c=='Rojo'}\"\n                           style=\"margin-right: 5px\">\n                        {{c}}\n                    </label>\n                </p>\n                <p [hidden]=\"!alarma.tipoEspecial\" style=\"margin-top: 5px; margin-bottom: 5px\">\n                    <label [ngClass]=\"{'label': true, 'label-info': alarma.tipoEspecial=='SINACTIVIDAD', 'label-primary': alarma.tipoEspecial=='SENSORNULL', 'label-success': alarma.tipoEspecial=='BATERIABAJA'}\"\n                           style=\"margin-right: 5px\">\n                        {{alarma.tipoEspecial == \"SINACTIVIDAD\" ? \"Sin Actividad\" : alarma.tipoEspecial == \"SENSORNULL\" ? \"Sensor sin información\" : \"Bateria Baja\"}}\n                    </label>\n                </p>\n                <p *ngIf=\"alarma.nodo_id\">\n                    {{\"Activación: \" + (alarma.fechaActivado | dateTimeZone: 'DD/MM/yyyy HH:mm' : (alarma.nodo_id.ubicacion_id.sucursal_id.husoHorario_id ? alarma.nodo_id.ubicacion_id.sucursal_id.husoHorario_id.offset : \"-03:00\"))}}\n                </p>\n                <p *ngIf=\"alarma.sucursal_id\">\n                    {{\"Activación: \" + (alarma.fechaActivado | dateTimeZone: 'DD/MM/yyyy HH:mm' : (alarma.sucursal_id.husoHorario_id ? alarma.sucursal_id.husoHorario_id.offset : \"-03:00\"))}}\n                </p>\n            </div>\n            <b *ngIf=\"regAlarmasRango==undefined || regAlarmasRango.length==0\">No hay alarmas activas por rango.</b>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/alarmas.96ce2b27a5b9d6bad9da7a5440d179ee.svg";

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/warning.22332f3d7042c039c4ea239da036e8c4.svg";

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/whatsapp.8e9789b83617bc02f0cf971f4644470d.svg";

/***/ }),
/* 650 */
/***/ (function(module, exports) {

	module.exports = "/*NavRightRes*/\n\n.navRightResUser {\n    padding: 5px;\n    background-color:  #E76049 ;\n    position: relative;\n    color: white;\n    font-family: \"Raleway\";\n    cursor: pointer;\n    height: 110px;\n}\n\n.navRightResUser img {\n    width: 65px;\n    height: 65px;\n    color: #555;\n}\n\n.navRightResOptions {\n    background-color: #273135;\n    padding-right: 15px;\n    padding-top: 15px;\n}\n\n.navRightResOptions li {\n    list-style-type: none;\n    padding: 0px;\n    text-align: center;\n}\n\n.nav-tabs a {\n    fill: red;\n    color: #dddbdb;\n    border:none;\n\n}\n\n.nav-tabs svg {\n    margin: 0px;\n}\n\n.nav-tabs > li.active > a,\n.nav-tabs > li.active > a:hover,\n.nav-tabs > li.active > a:focus > path {\n    color: #1ebcb7 !important;\n    background-color: transparent !important;\n    border: none !important;\n}\n\n.nav-tabs > li > a:hover{\n    background-color: transparent;\n    border:none;\n    border-bottom: solid 3px #E76049;\n}\n\n.nav-tabs > li.active{\n    background-color: transparent;\n    border:none;\n    border-bottom: solid 3px #E76049;\n}\n\n.navRightResOptions a {\n    padding-bottom: 15px;\n}\n\n.navRightResOptions ul {\n    border-bottom: none;\n}\n\n.navRightResTabs {\n    color: #dddbdb;\n    font-family: \"Raleway\";\n}\n\n.navRightResTabs h5 {\n    border-bottom: 1px solid rgba(176, 176, 178, .5);\n    padding: 10px;\n    font-size: 16px;\n}\n\n.navRightResTabs ul {\n    padding: 0px;\n}\n\n.navRightResTabs li {\n    list-style-type: none;\n    padding: 10px;\n    cursor: pointer;\n}\n\n.navRightResTabs a {\n    color: #dddbdb;\n    font-family: \"Raleway\";\n}\n\n.navRightResTabs span {\n    border-radius: 50%;\n    color: #d6d6d6;\n    height: 26px;\n    width: 26px;\n    text-align: center;\n    padding: 0px;\n    padding-top: 5px;\n    /*margin-right: 5px;*/\n}\n\n.tab-pane input,\n.tab-pane textarea {\n    background-color: transparent !important;\n    color: #dddbdb !important;\n    border: 1px solid #646262 !important;\n}\n\n.imgPerfil{\n    background: url(../../img/carrefour.png) no-repeat center center;\n    background-size: contain;\n    height: 100%;\n    max-height: 60px;\n    padding: 5px;\n    cursor: pointer;\n}\n\n.itemNotificacion{\n    border-bottom: 1px solid rgba(224, 219, 219,.5);\n    padding: 10px 7px;\n}\n\n.itemNotificacion p {\n    padding:0px;\n    margin:0px;\n}\n\n.itemNotificacion b {\n    padding:0px;\n    margin:0px;\n    font-size: 15px;\n    font-family: \"Raleway Bold\";\n}\n\n.previewFotoPerfil {\n    width: auto;\n    height: 100%;\n    position: relative;\n}\n\n.previewFotoPerfil img{\n    width: auto;\n    height: auto;\n    max-width: 100%;\n    max-height: 100%;\n    position: absolute;\n    margin: auto;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n}\n\n.badge{\n    position: absolute;\n    bottom: 4px;\n}\n\n.name-usuario{\n    padding: 10px;\n}\n\n.name-usuario p{\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    max-width: 160px;\n    overflow: hidden;\n}\n.name-usuario h4{\n    display: -webkit-box;\n    line-clamp: 2;\n    box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    line-height: initial;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    max-width: 160px;\n    margin-top: 0px;\n    margin-bottom: 2px;\n}"

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var error_notifier_1 = __webpack_require__(652);
	var login_service_1 = __webpack_require__(381);
	var myGlobals = __webpack_require__(414);
	var io = __webpack_require__(593);
	var ErrorComponent = (function () {
	    function ErrorComponent(errorNotifierService, loginService) {
	        var _this = this;
	        this.errorNotifierService = errorNotifierService;
	        this.loginService = loginService;
	        this.error = [];
	        this.message = "";
	        this.segundoModal = false;
	        //$("#modalErrores").modal("show");
	        //Conectar al socket con configuración específica
	        this.socket = io.connect(myGlobals.default.URL_MQTT, {
	            path: myGlobals.default.PATH_MQTT,
	            transports: ['websocket', 'polling'],
	            upgrade: true,
	            rememberUpgrade: true
	        });
	        // Debug de conexiones
	        this.socket.on('connect', function () {
	            console.log('Socket error conectado via:', _this.socket.io.engine.transport.name);
	            $('#online').css("display", "none");
	            _this.socket.io.engine.on('upgrade', function () {
	                console.log('Socket error actualizado a:', _this.socket.io.engine.transport.name);
	            });
	        });
	        this.socket.on('connect_error', function () {
	            $('#online').css("display", "block");
	        });
	    }
	    ErrorComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        //Suscribir al error notifier
	        this.errorNotifierService.onError(function (value) {
	            _this.error = "";
	            _this.message = "";
	            if (value.status == 401) {
	                _this.loginService.logout();
	            }
	            else {
	                _this.error = $.map(JSON.parse(value._body).errors, function (el) {
	                    return el;
	                });
	                if (JSON.parse(value._body).name != "ValidationError")
	                    _this.message = JSON.parse(value._body).message;
	                $("#modalErrores").modal("show");
	            }
	        });
	        this.errorNotifierService.onOk(function () {
	            $("#modalOk").modal("show");
	        });
	        //Corregir dos modales uno encima del otro
	        $(document).on('show.bs.modal', '.modal', function () {
	            var zIndex = 1040 + (10 * $('.modal:visible').length);
	            $(this).css('z-index', zIndex);
	            setTimeout(function () {
	                $('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack');
	            }, 0);
	        });
	    };
	    ErrorComponent.prototype.closeModal = function () {
	        $("#modalErrores").modal("hide");
	        //Corregir scroll cuando hay dos modales uno encima del otro
	        $(document).on('hidden.bs.modal', '.modal', function () {
	            $('.modal:visible').length && $(document.body).addClass('modal-open');
	        });
	    };
	    ErrorComponent.prototype.ngOnDestroy = function () {
	        this.socket.disconnect();
	    };
	    ErrorComponent = __decorate([
	        core_1.Component({
	            selector: 'Error',
	            template: __webpack_require__(866),
	            styles: [__webpack_require__(867)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof error_notifier_1.ErrorNotifierService !== 'undefined' && error_notifier_1.ErrorNotifierService) === 'function' && _a) || Object, (typeof (_b = typeof login_service_1.LoginService !== 'undefined' && login_service_1.LoginService) === 'function' && _b) || Object])
	    ], ErrorComponent);
	    return ErrorComponent;
	    var _a, _b;
	}());
	exports.ErrorComponent = ErrorComponent;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(419)))

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Rx_1 = __webpack_require__(653);
	var ErrorNotifierService = (function () {
	    function ErrorNotifierService() {
	        var _this = this;
	        this.errorObservable = Rx_1.Observable.create(function (observer) {
	            _this.errorObserver = observer;
	        }).share();
	        this.okObservable = Rx_1.Observable.create(function (observer) {
	            _this.okObserver = observer;
	        }).share();
	    }
	    ErrorNotifierService.prototype.notifyError = function (error) {
	        this.errorObserver.next(error);
	    };
	    ErrorNotifierService.prototype.onError = function (callback) {
	        this.errorObservable.subscribe(callback);
	    };
	    ErrorNotifierService.prototype.notifyOk = function () {
	        this.okObserver.next(true);
	    };
	    ErrorNotifierService.prototype.onOk = function (callback) {
	        this.okObservable.subscribe(callback);
	    };
	    return ErrorNotifierService;
	}());
	exports.ErrorNotifierService = ErrorNotifierService;


/***/ }),
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */
/***/ (function(module, exports) {

	module.exports = "<!-- Modal -->\n<div class=\"modal fade\" id=\"modalErrores\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\" style=\"z-index: 9999999\">\n    <div class=\"modal-dialog\" role=\"document\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n                <h4 class=\"modal-title\" id=\"myModalLabel\">Error</h4>\n            </div>\n            <div class=\"modal-body\">\n                <p style=\"text-align:center\">{{message}}</p>\n                <ul>\n                    <li *ngFor=\"let err of error\">{{err.message}}</li>\n                </ul>\n                <p class=\"text-warning\"><small>Intentelo nuevamente. Si el problema persiste contacte al administrador.</small></p>\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-danger\" (click)=\"closeModal()\">Aceptar</button>\n            </div>\n        </div>\n    </div>\n</div>\n<!-- Modal -->\n<div class=\"modal fade\" id=\"modalOk\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\" style=\"z-index: 9999999\">\n    <div class=\"modal-dialog\" role=\"document\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n                <h4 class=\"modal-title\" id=\"myModalLabel\">Confirmación</h4>\n            </div>\n            <div class=\"modal-body\">\n                La operación se ha realizado correctamente.\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-success\" data-dismiss=\"modal\">Aceptar</button>\n            </div>\n        </div>\n    </div>\n</div>\n<div id=\"online\" class=\"alert alert-danger fade in\" style=\"display: none; position: fixed; right:10px; bottom:0px;z-index:10\">\n    <strong>Cuidado!</strong> Se perdió la conexión con el servidor. Recupere la conexión y luego guarde sus cambios.\n</div>\n";

/***/ }),
/* 867 */
/***/ (function(module, exports) {

	module.exports = ""

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var router_1 = __webpack_require__(329);
	var email_service_1 = __webpack_require__(869);
	var email_1 = __webpack_require__(870);
	var LandingPageComponent = (function () {
	    function LandingPageComponent(emailService) {
	        this.emailService = emailService;
	        // Internet Explorer 6-11
	        this.isIE = false || !!document['documentMode'];
	        // Edge 20+
	        this.isEdge = !this.isIE && !!window['StyleMedia'];
	    }
	    LandingPageComponent.prototype.ngOnInit = function () {
	        window.scrollTo(0, 0);
	        //Inicializar
	        this.active = true;
	        this.email1 = new email_1.Email();
	        this.guardando = false;
	        this.ok = false;
	        this.error = null;
	        // var json = require("../../app/landingPage/assets/particles.json");
	        // console.log(json);
	        try {
	            setTimeout(function () {
	                return particlesJS.load('particles-js', "../../img/particles.json", function () {
	                    console.log('callback - particles.js config loaded');
	                    $(".particles-js-canvas-el").css("position", "absolute");
	                    $(".particles-js-canvas-el").css("top", "0px");
	                });
	            }, 1000);
	        }
	        catch (e) {
	        }
	        $(document).scroll(function () {
	            if ($(window).scrollTop() > 10) {
	                $("#divP").addClass("is-scroll");
	            }
	            if ($(window).scrollTop() == 0) {
	                $("#divP").removeClass("is-scroll");
	            }
	            if ($("#funcionamiento").offset() && $(window).scrollTop() > $("#funcionamiento").offset().top - 750) {
	                console.log("activo");
	                $("#fabrica").addClass("animacion");
	                $("#linea").addClass("linea");
	                $("#circulo").addClass("circulo");
	                $("#linea2").addClass("linea2");
	                $("#circulo2").addClass("circulo2");
	                $("#linea3").addClass("linea3");
	                $("#circulo3").addClass("circulo3");
	            }
	        });
	    };
	    LandingPageComponent.prototype.animarA = function (nombre) {
	        console.log(nombre);
	        $('html,body').animate({
	            scrollTop: $("#" + nombre).offset().top
	        }, 1000);
	    };
	    LandingPageComponent.prototype.isElementInView = function (element, fullyInView) {
	        var pageTop = $(window).scrollTop();
	        var pageBottom = pageTop + $(window).height();
	        var elementTop = $(element).offset().top;
	        var elementBottom = elementTop + $(element).height();
	        if (fullyInView === true) {
	            return ((pageTop < elementTop) && (pageBottom > elementBottom));
	        }
	        else {
	            return ((elementTop <= pageBottom) && (elementBottom >= pageTop));
	        }
	    };
	    LandingPageComponent.prototype.animarMenuCelular = function () {
	        if ($("#m-nav").attr('class').indexOf("animacionFondoMenuFin") == -1) {
	            $("#m-nav").toggleClass("animacionFondoMenuDFin");
	            $("#ul-nav").toggleClass("animacionMenuDFin");
	            setTimeout(function () {
	                $("#m-nav").toggleClass("animacionFondoMenuFin");
	                $("#ul-nav").toggleClass("animacionMenuFin");
	            }, 200);
	        }
	        else {
	            $("#m-nav").toggleClass("animacionFondoMenuFin");
	            $("#ul-nav").toggleClass("animacionMenuFin");
	            setTimeout(function () {
	                $("#m-nav").toggleClass("animacionFondoMenuDFin");
	                $("#ul-nav").toggleClass("animacionMenuDFin");
	            }, 600);
	        }
	    };
	    LandingPageComponent.prototype.enviarMail = function () {
	        var _this = this;
	        console.log(this.email1);
	        this.guardando = true;
	        this.emailService
	            .enviar(this.email1)
	            .subscribe(function (data) {
	            _this.ok = true;
	            _this.guardando = false;
	            _this.email1 = new email_1.Email();
	            //Reseteo form1 para eliminar errores
	            _this.active = false;
	            setTimeout(function () { return _this.active = true; }, 0);
	        }, function (err) {
	            _this.error = err;
	            _this.guardando = false;
	        });
	    };
	    LandingPageComponent = __decorate([
	        core_1.Component({
	            selector: 'landing',
	            template: __webpack_require__(871),
	            styles: [__webpack_require__(891)],
	            directives: [router_1.ROUTER_DIRECTIVES],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof email_service_1.EmailService !== 'undefined' && email_service_1.EmailService) === 'function' && _a) || Object])
	    ], LandingPageComponent);
	    return LandingPageComponent;
	    var _a;
	}());
	exports.LandingPageComponent = LandingPageComponent;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(419)))

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var http_1 = __webpack_require__(382);
	__webpack_require__(374);
	var myGlobals = __webpack_require__(414);
	var EmailService = (function () {
	    function EmailService(http) {
	        this.http = http;
	        this.emailUrl = myGlobals.default.BASE_URL + '/email/'; // URL to web api
	    }
	    // Agregar nuevo usuario
	    EmailService.prototype.enviar = function (email) {
	        var headers = new http_1.Headers({
	            'Content-Type': 'application/json;charset=UTF-8' });
	        headers.append('dataType', 'json');
	        var usuarioStr = JSON.stringify(email);
	        return this.http
	            .post(this.emailUrl, usuarioStr, { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    EmailService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
	    ], EmailService);
	    return EmailService;
	    var _a;
	}());
	exports.EmailService = EmailService;


/***/ }),
/* 870 */
/***/ (function(module, exports) {

	"use strict";
	var Email = (function () {
	    function Email() {
	    }
	    return Email;
	}());
	exports.Email = Email;


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div id=\"divP\" class=\"site\">\n    <nav id=\"m-nav\" class=\"m-nav animacionFondoMenuInicio animacionFondoMenuDInicio\">\n        <div class=\"m-nav-tb\">\n            <div  class=\"m-nav-tb-cell\">\n                <!-- mobile menu will clone inside here by js script -->\n                <div class=\"m-primary-menu\">\n                    <ul id=\"ul-nav\" class=\"nav m-primary-menu-list animacionMenuInicio animacionMenuDInicio\">\n                        <li class=\"m-primary-menu-item\" [ngClass]=\"{'active':isElementInView('#funcionamiento',true) || isElementInView('#funcionamiento2',true)}\">\n                            <a (click)=\"animarA('funcionamiento');animarMenuCelular()\"><span>Cómo Funciona</span></a>\n                        </li>\n                        <li class=\"m-primary-menu-item\" [ngClass]=\"{'active':isElementInView('#software',true)}\">\n                            <a (click)=\"animarA('software');animarMenuCelular()\"><span>Software</span></a>\n                        </li>\n                        <li class=\"m-primary-menu-item\" [ngClass]=\"{'active':isElementInView('#hardware',true)}\">\n                            <a (click)=\"animarA('hardware');animarMenuCelular()\"><span>Hardware</span></a>\n                        </li>\n                        <li class=\"m-primary-menu-item\" [ngClass]=\"{'active':isElementInView('#variables',true)}\">\n                            <a (click)=\"animarA('variables');animarMenuCelular()\"><span>Variables</span></a>\n                        </li>\n                        <li class=\"m-primary-menu-item\" [ngClass]=\"{'active':isElementInView('#empresa',true)}\">\n                            <a (click)=\"animarA('empresa');animarMenuCelular()\"><span>Empresa</span></a>\n                        </li>\n                        <li class=\"m-primary-menu-item\" [ngClass]=\"{'active':isElementInView('#contact',true)}\">\n                            <a (click)=\"animarA('contact');animarMenuCelular()\"><span>Contacto</span></a>\n                        </li>\n                        <li class=\"m-primary-menu-item\">\n                            <a routerLink=\"login\" (click)=\"animarMenuCelular()\"><span>Iniciar Sesión</span></a>\n                        </li>\n                    </ul>\n                </div></div>\n        </div>\n    </nav> <!-- m-nav -->\n\n    <header class=\"site-header text-light\">\n        <div class=\"site-header-container container\">\n            <div class=\"site-header-brand\">\n                <img class=\"site-header-brand-img\" src=\"" + __webpack_require__(872) + "\" alt=\"\">\n            </div> <!-- .site-header-brand -->\n\n            <nav class=\"site-header-nav\">\n                <div class=\"primary-menu\">\n                    <ul class=\"primary-menu-list nav\">\n                        <li class=\"primary-menu-item\" [ngClass]=\"{'active':isElementInView('#funcionamiento',true) || isElementInView('#funcionamiento2',true)}\">\n                            <a (click)=\"animarA('funcionamiento')\"><span>Cómo Funciona</span></a>\n                        </li>\n                        <li class=\"primary-menu-item\" [ngClass]=\"{'active':isElementInView('#software',true)}\">\n                            <a (click)=\"animarA('software')\"><span>Software</span></a>\n                        </li>\n                        <li class=\"primary-menu-item\" [ngClass]=\"{'active':isElementInView('#hardware',true)}\">\n                            <a (click)=\"animarA('hardware')\"><span>Hardware</span></a>\n                        </li>\n                        <li class=\"primary-menu-item\" [ngClass]=\"{'active':isElementInView('#variables',true)}\">\n                            <a (click)=\"animarA('variables')\"><span>Variables</span></a>\n                        </li>\n                        <li class=\"primary-menu-item\" [ngClass]=\"{'active':isElementInView('#empresa',true)}\">\n                            <a (click)=\"animarA('empresa')\"><span>Empresa</span></a>\n                        </li>\n                        <li class=\"primary-menu-item\" [ngClass]=\"{'active':isElementInView('#contact',true)}\">\n                            <a (click)=\"animarA('contact')\"><span>Contacto</span></a>\n                        </li>\n                        <li class=\"primary-menu-item\">\n                            <a routerLink=\"login\"><span>Iniciar Sesión</span></a>\n                        </li>\n                    </ul>\n\n                </div> <!-- .primary-menu -->\n\n\n                    <button type=\"button\" data-target=\"#m-nav\" data-toggle=\"velocity-animating\" class=\"navbar-toggle\" (click)=\"animarMenuCelular()\">\n                        <span class=\"sr-only\">Toggle navigation</span>\n                        <span class=\"icon-bar\"></span>\n                        <span class=\"icon-bar\"></span>\n                        <span class=\"icon-bar\"></span>\n                    </button>\n               <!-- .icon-menu -->\n\n            </nav> <!-- .site-header-nav -->\n        </div>\n    </header> <!-- .site-header -->\n\n    <main class=\"site-content\">\n        <div id=\"home\" class=\"section text-light\"\n             style=\"background-image: url('../../img/landingPage/deposito.jpg'); background-size: cover; background-color: black\">\n            <div id=\"particles-js\">\n                <div class=\"site-bg\">\n                    <div class=\"site-bg-img\"></div>\n                    <div class=\"site-bg-video\"></div>\n                    <div class=\"site-bg-overlay\"></div>\n                    <div class=\"site-bg-effect\"></div>\n                    <canvas class=\"site-bg-canvas\"></canvas>\n                </div> <!-- .site bg -->\n\n                <div class=\"section-table\">\n                    <div class=\"section-cell\">\n                        <div class=\"container\">\n                            <div class=\"row\">\n                                <div class=\"col-xs-12 col-md-7 col-lg-6\" data-equal-height=\"1\">\n                                    <div class=\"equal-height-cell\">\n                                        <h1 class=\"section-title\">Sistema de<span class=\"color\"> monitoreo</span></h1>\n                                        <div class=\"m-t-space\" style=\"color: white\">\n\n\n                                            <p> Ideal para monitoreo:\n                                            </p>\n                                            <ul>\n                                                <li class=\"wow fadeIn\" data-wow-delay=\"0.2s\">\n                                                    Procesos industriales.\n                                                </li>\n                                                <li class=\"wow fadeIn\" data-wow-delay=\"0.6s\">\n                                                    Frigoríficos.\n                                                </li>\n                                                <li class=\"wow fadeIn\" data-wow-delay=\"1s\">\n                                                    Laboratorios.\n                                                </li>\n                                                <li class=\"wow fadeIn\" data-wow-delay=\"1.4s\">\n                                                    Ámbitos hospitalarios.\n                                                </li>\n                                                <li class=\"wow fadeIn\" data-wow-delay=\"1.8s\">\n                                                    Líneas de producción.\n                                                </li>\n                                            </ul>\n                                        </div>\n                                    </div>\n                                </div>\n                                <div class=\"col-xs-12 col-md-5 col-lg-offset-1\" data-equal-height=\"1\">\n                                    <div class=\"equal-height-cell\">\n                                        <div class=\"double-device _right\">\n                                            <img src=\"" + __webpack_require__(873) + "\" class=\"double-device-front\">\n                                            <img src=\"" + __webpack_require__(874) + "\"\n                                                 class=\"double-device-back wow animated fadeInLeftScale90\">\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div> <!-- #home -->\n\n\n\n        <div id=\"funcionamiento\" class=\"section\">\n            <div class=\"container\">\n                <div class=\"row\">\n                    <div class=\"col-xs-12 col-md-6 col-md-offset-1 float-right-md-min\">\n                        <div class=\"equal-height-cell\">\n                            <h3 class=\"section-subtitle\">Como funciona?</h3>\n                            <h2 class=\"section-title\">Controle las variables del proceso <span\n                                    class=\"color\">en todo momento.</span></h2>\n                            <p class=\"m-t-space\">El sistema se compone de un conjunto de dispositivos inalámbricos que\n                                sensan variables analógicas tales como temperatura, humedad, presión, variables\n                                eléctricas. Estos dispositivos envían de forma remota las mediciones a un concentrador\n                                (Gateway) encargado de procesar y reenviar la información a un servidor web.</p>\n                        </div>\n                        <div style=\"text-align: center; padding-top: 60px;\">\n                            <button type=\"button\" (click)=\"animarA('contact');animarMenuCelular()\" class=\"btn _theme _icon\">\n                                <span>Consulta aquí</span>\n                                <i class=\"ion-forward\"></i>\n                            </button>\n                        </div>\n                    </div>\n                    <div class=\"col-xs-12 col-md-5\" *ngIf=\"!isIE && !isEdge\">\n                        <div class=\"row\" style=\"text-align: center\">\n                            <img src=\"" + __webpack_require__(875) + "\" class=\"wow bounceIn\" data-wow-delay=\"12s\"\n                                 data-wow-duration=\"4s\" data-wow-offset=\"10\" data-wow-iteration=\"infinite\"\n                                 style=\"width: 200px; padding-top: 9px;\"/>\n                        </div>\n                        <div class=\"row contenedorInstrumentos\">\n                            <div class=\"col-xs-4\">\n                                <div class=\"feature-icon wow fadeIn\" data-wow-delay=\"9s\" style=\"position: relative\">\n                                    <i>\n                                        <img src=\"" + __webpack_require__(876) + "\" style=\"width: 28px; padding-top: 7px;\"/>\n                                    </i>\n                                </div>\n                            </div>\n                            <div class=\"col-xs-4 humedad\">\n                                <div class=\"feature-icon wow fadeIn\" data-wow-delay=\"10s\" style=\"position: relative\">\n                                    <i>\n                                        <img src=\"" + __webpack_require__(877) + "\" style=\"width: 43px; padding-top: 9px;\"/>\n                                    </i>\n                                </div>\n                            </div>\n                            <div class=\"col-xs-4 barometro\">\n                                <div class=\"feature-icon wow fadeIn\" data-wow-delay=\"11s\" style=\"position: relative\">\n                                    <i>\n                                        <img src=\"" + __webpack_require__(878) + "\" style=\"width: 43px; padding-top: 9px;\"/>\n                                    </i>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"row\">\n                            <div class=\"containerCircuito\" id=\"containerFabrica\">\n                                <div class=\"\" id=\"circulo\"></div>\n                                <div class=\"\" id=\"linea\"></div>\n                                <div class=\"\" id=\"circulo2\"></div>\n                                <div class=\"\" id=\"linea2\"></div>\n                                <div class=\"\" id=\"circulo3\"></div>\n                                <div class=\"\" id=\"linea3\"></div>\n                                <svg class=\"circuito\" version=\"1.1\" id=\"fabrica\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t viewBox=\"0 0 505 160\" style=\"enable-background:new 0 0 505 160;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0 {\n        fill: #FFFFFF;\n    }\n\n    .st1 {\n        fill: #2B8897;\n    }\n\n    .st2 {\n        fill: #7AACBB;\n    }\n</style>\n<g id=\"CbchFu.tif\">\n\t<g>\n\t\t<g>\n\n\t\t\t<path class=\"st0\" d=\"M418,161c-101,0-202,0-303,0c1.5-3,1.8-6.2,1.8-9.5c-0.1-24.3,0-48.7,0-73c0-1.8,0-3.6,0-5.7\n\t\t\t\tc2.1-0.1,3.7-0.3,5.3-0.3c9.3,0,18.7,0,28,0c11.6,0,9.5,0.8,9.7-9.4c0-2.9,0-5.9,0-9.2c3.4,0,6.2-0.2,9,0\n\t\t\t\tc3.6,0.3,5.8-0.6,7.1-4.4c1.9-5.5,5.6-10.5,11-12.4c8.1-2.8,12.9-6.8,9.9-16.1c3.2-0.5,5.6-0.6,8.3,0c0,2.9,0.2,5.6,0,8.2\n\t\t\t\tc-0.2,2.9,0.5,4.4,3.7,5.2c5.2,1.5,10.2,4.3,12.7,9.2c3.8,7.6,8.4,12.8,18.2,9.7c0,3.8,0,6.6,0,9.3c0,8.9,0,8.9,8.7,10.4\n\t\t\t\tc0,1.7,0,3.5,0,5.3c0,15.2,0.1,30.3-0.1,45.5c0,3.3,0.8,4.8,4.5,4.8c12.7-0.2,25.3-0.2,38,0c3.9,0.1,4.9-1.5,4.8-5\n\t\t\t\tc-0.2-5.2,0-10.4,0-16.4c6.4,3,11.9,5.3,17.2,8c8,4.2,8.9,3,8.2-5.3c-0.1-0.6,0.2-1.3,0.3-2.6c6.9,3.2,13.5,6.2,20,9.4\n\t\t\t\tc3.3,1.6,5.1,1.1,4.9-2.9c-0.1-1.9,0-3.9,0-6.7c7.1,3.3,13.5,6.4,20,9.3c4.5,2.1,5.2,1.6,5.3-3.2c0-1.8,0-3.6,0-5.2\n\t\t\t\tc1.2-0.6,2-0.2,2.7,0.2c5.9,2.8,11.7,5.5,17.6,8.3c4.3,2,5.1,1.4,5.3-3.5c0.1-1.7-0.6-3.6,0.8-5.5c5.4,2.5,10.8,5.2,16.3,7.5\n\t\t\t\tc3,1.2,4.2,2.8,4.1,6.3C417.8,134.7,418,147.8,418,161z M331.5,149.4c18.7,0,37.3,0,56,0c3.8,0,7.7,0,11.5,0\n\t\t\t\tc1.4,0,2.8-0.4,2.7-2.2c-0.1-1.3-1.2-1.9-2.5-1.9c-1,0-2,0-3,0c-42.8,0-85.6,0-128.5,0c-1,0-2,0-3,0c-1.5,0.1-2.7,0.5-2.6,2.3\n\t\t\t\tc0.1,1.5,1.3,1.8,2.5,1.8c1.2,0,2.3,0,3.5,0C289.2,149.4,310.3,149.4,331.5,149.4z M331.5,155c21.3,0,42.6,0,64,0\n\t\t\t\tc1.2,0,2.3,0,3.5,0c1.5,0,2.8-0.6,2.7-2.2c-0.1-1.4-1.2-1.8-2.5-1.8c-1,0-2,0-3,0c-42.8,0-85.6,0-128.4,0c-1.2,0-2.3,0-3.5,0\n\t\t\t\tc-1.1,0-2,0.4-2.2,1.6c-0.2,1.4,0.7,2.2,2,2.3c1.3,0.1,2.7,0.1,4,0.1C289.2,155,310.3,155,331.5,155z M198.3,131.8\n\t\t\t\tC198.3,131.9,198.3,131.9,198.3,131.8c1.8,0.1,3.6,0.1,5.5,0.1c2.4-0.1,4.2-1.2,4.6-3.7c0.7-3.8,1.4-7.9,0-11.3\n\t\t\t\tc-2.5-6-8.4-2.7-12.7-3.3c-2.8-0.4-5.9-0.4-6.7,3.4c-0.8,3.8-0.8,7.6-0.2,11.4c0.3,2.4,2.1,3.3,4.2,3.5\n\t\t\t\tC194.7,132,196.5,131.8,198.3,131.8z M229.1,131.8C229.1,131.9,229.1,131.9,229.1,131.8c1,0.1,2,0.1,3,0.1c6.3,0,7.3-1.1,7.6-7.5\n\t\t\t\tc0.1-1.8,0.1-3.6,0.1-5.5c0-4.1-2.6-5.9-6.1-5.2c-4.8,0.9-11.6-3.8-13.9,4.2c-0.9,3.1-0.4,6.6-0.2,9.9c0.1,2.5,1.8,3.9,4.2,4\n\t\t\t\tC225.5,131.9,227.3,131.8,229.1,131.8z M229.6,86.7c-1.2,0-2.3,0-3.5,0c-3-0.2-6.1,0-6.4,3.8c-0.3,4.6-2.2,9.5,1.7,13.6\n\t\t\t\tc0.2,0.2,0.6,0.3,0.9,0.5c11,4.3,18.2-0.7,17.6-12.1c-0.2-4.2-2.2-5.9-6.3-5.8C232.2,86.7,230.9,86.7,229.6,86.7z M229.6,157.1\n\t\t\t\tc9.9,0,10.2-0.3,10.2-10.3c0-0.7,0-1.3,0-2c-0.1-2.8-0.7-5.9-4.1-5.6c-5.2,0.5-12.1-3.4-15.5,2.6\n\t\t\t\tC215.3,150.5,219.9,157.1,229.6,157.1z M198.2,139c-2.6,0.6-6.5-1.6-8.4,1.6c-2.5,4.3-2.2,9.4-0.7,14c1.2,4,5.3,2.5,8.3,2.5\n\t\t\t\tc9.9,0.1,11.7,2.4,11.5-11.9c0-4.4-1.8-6.5-6.3-6.2C201.3,139.1,199.9,139,198.2,139z M198.6,86.7c-9.8,0-10.2,0.4-10.2,10.3\n\t\t\t\tc0,0.7,0,1.3,0,2c0.1,3.1,0.9,6.2,4.5,5.7c5.2-0.7,12.1,3.6,15.2-3.1C212.4,92.5,208.3,86.7,198.6,86.7z M135.2,131.9\n\t\t\t\tC135.2,131.9,135.2,131.9,135.2,131.9c1,0,2,0,3,0c5.9-0.1,6.8-1,7-7c0-1.2,0-2.3,0-3.5c0-7.2-0.7-7.8-8.1-7.9\n\t\t\t\tc-12.2-0.1-13,0.8-12.2,13c0.2,3.5,1.8,5.2,5.2,5.3C131.9,131.9,133.5,131.9,135.2,131.9z M167.2,113.7\n\t\t\t\tc-10.3-0.1-10.3-0.1-10.3,10.1c0,1.3,0.1,2.7,0.1,4c0,2.2,1.3,3.3,3.2,3.9c12.1,3.8,17.7-0.7,16.9-13c-0.2-3.3-1.7-4.9-4.9-5\n\t\t\t\tC170.5,113.7,168.8,113.7,167.2,113.7z M166.7,104.9c10.2,0,10.2,0,10.3-10.2c0-1-0.1-2-0.1-3c0.1-3.4-1.7-4.9-4.9-4.9\n\t\t\t\tc-15.5,0.2-15.5-2.4-15.3,13.1c0,3.3,1.7,4.9,4.9,5C163.4,104.9,165.1,104.9,166.7,104.9z M135.5,104.9c2.6-0.5,6.5,1.5,8.4-1.6\n\t\t\t\tc2.7-4.3,1.9-9.5,0.8-14.1c-0.9-3.7-5-2.4-7.8-2.5C125,86.7,124,87.9,125,99.9c0.3,3.3,1.8,4.9,5,5\n\t\t\t\tC131.7,105,133.4,104.9,135.5,104.9z M135.6,157.1c2.6-0.5,6.6,1.5,8.4-1.7c2.5-4.3,1.9-9.5,0.6-14.1c-1-3.6-5.1-2.3-7.9-2.3\n\t\t\t\tc-10.6-0.1-11.8-2.3-11.7,12.3c0,4,1.7,5.9,5.7,5.8C132.2,157.1,133.7,157.1,135.6,157.1z M166.9,139c-1.2,0-2.3,0.1-3.5,0\n\t\t\t\tc-4.9-0.5-6.7,2-6.5,6.5c0,1,0,2,0,3c-0.1,8.4,0.2,8.7,8.7,8.7c11.8,0,12-0.4,11.6-12.5c-0.1-4-1.8-5.8-5.7-5.7\n\t\t\t\tC169.9,139.1,168.4,139,166.9,139z\"/>\n\t\t\t<path class=\"st1\" d=\"M418,161c0-13.2-0.2-26.3,0-39.5c0.1-3.5-1.1-5-4.1-6.3c-5.5-2.3-10.8-4.9-16.3-7.5\n\t\t\t\tc-1.4,1.9-0.7,3.8-0.8,5.5c-0.2,4.9-0.9,5.5-5.3,3.5c-5.9-2.7-11.8-5.5-17.6-8.3c-0.7-0.3-1.5-0.8-2.7-0.2c0,1.6,0,3.4,0,5.2\n\t\t\t\tc0,4.8-0.8,5.3-5.3,3.2c-6.4-3-12.9-6-20-9.3c0,2.8-0.1,4.7,0,6.7c0.2,4.1-1.6,4.6-4.9,2.9c-6.5-3.2-13.2-6.2-20-9.4\n\t\t\t\tc-0.2,1.3-0.4,1.9-0.3,2.6c0.7,8.3-0.2,9.5-8.2,5.3c-5.3-2.7-10.8-5.1-17.2-8c0,6-0.1,11.2,0,16.4c0.1,3.5-0.9,5.1-4.8,5\n\t\t\t\tc-12.7-0.2-25.3-0.2-38,0c-3.6,0-4.5-1.4-4.5-4.8c0.1-15.2,0.1-30.3,0.1-45.5c0-1.8,0-3.6,0-5.3c-8.7-1.5-8.7-1.5-8.7-10.4\n\t\t\t\tc0-2.8,0-5.6,0-9.3c-9.8,3.1-14.4-2.1-18.2-9.7c-2.4-4.8-7.4-7.7-12.7-9.2c-3.2-0.9-3.9-2.4-3.7-5.2c0.2-2.6,0-5.3,0-8.2\n\t\t\t\tc-2.7-0.7-5-0.5-8.3,0c3,9.3-1.8,13.2-9.9,16.1c-5.4,1.9-9.1,6.9-11,12.4c-1.3,3.8-3.5,4.7-7.1,4.4c-2.8-0.3-5.6,0-9,0\n\t\t\t\tc0,3.4,0,6.3,0,9.2c-0.2,10.3,1.9,9.4-9.7,9.4c-9.3,0-18.7,0-28,0c-1.6,0-3.2,0.2-5.3,0.3c0,2.1,0,3.9,0,5.7c0,24.3,0,48.7,0,73\n\t\t\t\tc0,3.4-0.3,6.5-1.8,9.5c-38,0-76,0-114,0c0-1.3,0-2.7,0-4c5.7,1,8.9-1.7,11-6.8c1.6-3.8,3.8-7.4,5.6-11.1\n\t\t\t\tC36.7,97,38.2,52.6,35.1,7.5c-0.1-2-3.8-3.1-1.2-5.6c21.3,0,42.6,0,63.9,0c1.7,0,3.7,0.7,5.2-0.9c0.3,0,0.7,0,1,0\n\t\t\t\tc1.9,3.1-1.9,4.4-2.1,6.9c-2.5,32.5-0.4,64.5,9.1,95.9c0.1,0.4,0.5,0.7,1.3,1.7c0-10.3,0-20,0-29.6c0-7.7,0.1-7.7,7.6-7.7\n\t\t\t\tc11.6,0,23.3,0,35.5,0c0-4.9,0.2-9.3-0.1-13.7c-0.2-3.6,1.1-5.4,4.9-5c0.7,0.1,1.3-0.1,2,0c5.8,0.9,9.8-0.6,12.6-6.5\n\t\t\t\tc2.8-5.8,8.2-9.7,14.3-11.8c3.1-1.1,3.9-2.6,3.8-5.7c-0.1-10.1-1.4-9.2,8.8-9.2c7.4,0,7.7,0,7.2,7.3c-0.3,4.8,1.1,7.4,5.7,9.3\n\t\t\t\tc5.7,2.3,10,6.8,12.6,12.4c1.7,3.7,3.8,4.6,7.6,4.5c10.3-0.3,8.8-0.4,8.9,8.7c0,3.1,0,6.3,0,9.3c8.7,1.4,8.7,1.4,8.7,9.9\n\t\t\t\tc0,15.3,0,30.6,0,46.4c12.7,0,25.3,0,38.7,0c0-5.7,0.1-11.6,0-17.5c-0.1-4.1,1.3-5.1,5.1-3.3c6.4,3.1,12.9,6.1,19.3,9\n\t\t\t\tc1.4-1.3,0.9-2.7,0.9-3.9c0.1-6.9,0.6-7.2,6.6-4.4c6.1,2.8,12.3,5.7,19,8.7c0-2.6,0.1-4.6,0-6.5c-0.2-4,1.4-4.7,4.9-3\n\t\t\t\tc6.5,3.2,13.2,6.2,20.4,9.5c0-2.6,0.1-4.6,0-6.5c-0.2-4.1,1.6-4.6,4.9-3c6.6,3.1,13.2,6.2,19.9,9.3c0.2-1,0.4-1.5,0.4-2\n\t\t\t\tc0.4-9.4,0.4-9.4,8.8-5.5c5.7,2.7,11.4,5.5,17.2,8c2.9,1.2,3.9,2.8,3.8,6c-0.2,12.5-0.1,25-0.1,37.9c7.2,0,14.2,0,21.6,0\n\t\t\t\tc0.8-14.6,1.6-29,2.4-43.4c0.1-1.8,0.1-3.7,0.2-5.5c0.3-6.3,3.2-8.2,9.4-6.4c2.7,0.8,2.3,2.9,2.4,4.8c0.9,15.6,1.8,31.3,2.7,46.9\n\t\t\t\tc0.1,1.1,0.2,2.3,0.3,3.7c3.5,0,7,0,11,0c0.6-10.7,1.3-21.5,1.9-32.2c0.3-5.8,0.9-11.6,0.9-17.5c0-3.9,0.6-6,5.5-6\n\t\t\t\tc4.8,0,6.3,1.6,6.5,6.2c0.5,14.6,1.4,29.3,2.2,43.9c0.1,1.8,0.3,3.6,0.4,5.8c3.2,0,6.2,0.1,9.1,0c3.3-0.2,4.2,1.2,3.4,4.2\n\t\t\t\tC474,161,446,161,418,161z M39.1,5.9c4.1,52.6,1.2,103.6-26,151.2c32.7,0,64.1,0,95.6,0c2.9,0,3.7-1,3.7-3.8\n\t\t\t\tc-0.1-10.2-0.1-20.3,0-30.5c0-1.7-0.4-3.3-1-4.9c-9.6-25.5-14.1-51.9-14.5-79.1C96.7,28,97,17,97.8,5.9C78.2,5.9,59,5.9,39.1,5.9\n\t\t\t\tz M485.1,156.6c-0.4-8.7-0.8-17.1-1.3-25.5c-0.4-7.5-0.8-15-1.4-22.4c-0.1-1.3,0.5-3.5-1.9-3.3c-2.3,0.2-1.4,2.3-1.5,3.6\n\t\t\t\tc-0.3,3.1-0.4,6.3-0.6,9.5c-0.7,12.7-1.4,25.4-2.1,38.3C479.4,156.6,482,156.6,485.1,156.6z M456.6,156.5\n\t\t\t\tc-0.9-16.2-1.7-32.2-2.6-48.3c-0.1-1.2,0.3-3-1.8-2.9c-2,0.1-1.5,1.9-1.6,3.1c-0.6,9.8-1.3,19.6-1.6,29.4\n\t\t\t\tc-0.2,6.2-1.5,12.5-0.7,18.8C451.2,156.9,453.8,157.1,456.6,156.5z M112.8,107.1c-0.1-0.3-0.2-0.5-0.3-0.8\n\t\t\t\tc-0.1,0.1-0.3,0.2-0.3,0.3c0.1,0.3,0.2,0.5,0.3,0.8C112.6,107.3,112.7,107.2,112.8,107.1z\"/>\n\t\t\t<path class=\"st2\" d=\"M33.9,1.9C34,1.6,34,1.3,34,1c23,0,46,0,69,0c-1.5,1.6-3.4,0.9-5.2,0.9C76.5,2,55.2,1.9,33.9,1.9z\"/>\n\t\t\t<path class=\"st1\" d=\"M331.5,149.4c-21.2,0-42.3,0-63.5,0c-1.2,0-2.3,0-3.5,0c-1.2,0-2.4-0.3-2.5-1.8c-0.1-1.7,1.2-2.2,2.6-2.3\n\t\t\t\tc1-0.1,2,0,3,0c42.8,0,85.6,0,128.5,0c1,0,2,0,3,0c1.3,0,2.4,0.6,2.5,1.9c0.2,1.8-1.2,2.2-2.7,2.2c-3.8,0-7.7,0-11.5,0\n\t\t\t\tC368.8,149.4,350.2,149.4,331.5,149.4z\"/>\n\t\t\t<path class=\"st1\" d=\"M331.5,155c-21.2,0-42.3,0-63.5,0c-1.3,0-2.7,0-4-0.1c-1.3-0.1-2.2-0.9-2-2.3c0.1-1.2,1.1-1.6,2.2-1.6\n\t\t\t\tc1.2,0,2.3,0,3.5,0c42.8,0,85.6,0,128.4,0c1,0,2,0,3,0c1.3,0,2.4,0.4,2.5,1.8c0.1,1.7-1.2,2.2-2.7,2.2c-1.2,0-2.3,0-3.5,0\n\t\t\t\tC374.1,155,352.8,155,331.5,155z\"/>\n\t\t\t<path class=\"st1\" d=\"M198.3,131.8c-1.8,0-3.7,0.1-5.5,0c-2.1-0.2-3.9-1.1-4.2-3.5c-0.5-3.8-0.5-7.6,0.2-11.4\n\t\t\t\tc0.8-3.8,3.9-3.8,6.7-3.4c4.4,0.6,10.2-2.7,12.7,3.3c1.4,3.4,0.7,7.5,0,11.3c-0.4,2.4-2.2,3.6-4.6,3.7\n\t\t\t\tC202,131.9,200.2,131.9,198.3,131.8C198.3,131.9,198.3,131.9,198.3,131.8z M204.3,118.4c-5.4-0.8-7.7-0.8-11.4,0.4\n\t\t\t\tc-0.2,2.9-0.6,5.8,0.3,8.6C205.1,128.7,205.1,128.7,204.3,118.4z\"/>\n\t\t\t<path class=\"st1\" d=\"M229.1,131.8c-1.8,0-3.6,0.1-5.5,0c-2.4-0.2-4.1-1.5-4.2-4c-0.1-3.3-0.6-6.8,0.2-9.9c2.3-8,9.1-3.3,13.9-4.2\n\t\t\t\tc3.5-0.7,6.1,1.1,6.1,5.2c0,1.8,0,3.6-0.1,5.5c-0.2,6.5-1.3,7.5-7.6,7.5C231.1,131.9,230.1,131.9,229.1,131.8\n\t\t\t\tC229.1,131.9,229.1,131.9,229.1,131.8z M234.9,127.5c1.4-2.9,0.1-6,0.3-9.2c-3.9-0.6-7.6-0.7-11.3,0c-0.5,3.2-1,6.1,0.3,9.2\n\t\t\t\tC227.6,127.5,230.8,127.5,234.9,127.5z\"/>\n\t\t\t<path class=\"st1\" d=\"M229.6,86.7c1.3,0,2.7,0,4,0c4-0.2,6,1.5,6.3,5.8c0.6,11.5-6.5,16.5-17.6,12.1c-0.3-0.1-0.7-0.2-0.9-0.5\n\t\t\t\tc-3.9-4.1-2-9.1-1.7-13.6c0.3-3.8,3.4-3.9,6.4-3.8C227.2,86.7,228.4,86.7,229.6,86.7z M234.8,100.6c1.4-3.2,0.3-6.2,0.3-9.4\n\t\t\t\tc-3.8-0.4-7.4-0.5-11.3,0.1c-0.2,3.2-1,6.3,0.6,9.3C227.9,100.6,231.3,100.6,234.8,100.6z\"/>\n\t\t\t<path class=\"st1\" d=\"M229.6,157.1c-9.7,0-14.2-6.7-9.4-15.3c3.4-6.1,10.2-2.1,15.5-2.6c3.4-0.3,4,2.8,4.1,5.6c0,0.7,0,1.3,0,2\n\t\t\t\tC239.8,156.8,239.4,157.1,229.6,157.1z M223.9,143.3c-0.3,3.5-1.1,6.5,0.3,9.5c3.7,0,7.1,0,10.9,0c0.5-3.2,0.3-6.3-0.2-9.5\n\t\t\t\tC231.3,143.3,227.9,143.3,223.9,143.3z\"/>\n\t\t\t<path class=\"st1\" d=\"M198.2,139c1.7,0,3.1,0.1,4.4,0c4.5-0.3,6.3,1.8,6.3,6.2c0.2,14.3-1.6,12-11.5,11.9c-2.9,0-7,1.5-8.3-2.5\n\t\t\t\tc-1.4-4.6-1.7-9.7,0.7-14C191.7,137.4,195.6,139.6,198.2,139z M193.1,152.9c14.1,0.4,11.6,1.2,11-9.1c-4.1-1-7-1-11.2,0.1\n\t\t\t\tC192.6,146.7,192.4,149.7,193.1,152.9z\"/>\n\t\t\t<path class=\"st1\" d=\"M198.6,86.7c9.8,0,13.9,5.7,9.6,14.9c-3.1,6.7-10.1,2.4-15.2,3.1c-3.6,0.5-4.5-2.6-4.5-5.7c0-0.7,0-1.3,0-2\n\t\t\t\tC188.4,87.1,188.7,86.7,198.6,86.7z M193.2,100.4c12,1.2,12.7,0.6,10.7-9.3c-3.5,0-7.1,0-10.9,0\n\t\t\t\tC192.6,94.4,192.4,97.3,193.2,100.4z\"/>\n\t\t\t<path class=\"st1\" d=\"M135.2,131.9c-1.7,0-3.3,0-5,0c-3.4-0.1-5-1.9-5.2-5.3c-0.8-12.3,0-13.1,12.2-13c7.4,0.1,8.1,0.7,8.1,7.9\n\t\t\t\tc0,1.2,0,2.3,0,3.5c-0.2,6-1.1,7-7,7C137.2,131.9,136.2,131.9,135.2,131.9C135.2,131.9,135.2,131.9,135.2,131.9z M140.9,117.9\n\t\t\t\tc-3.3,0-6.1,0-8.9,0c-0.8,0-1.6,0.2-2.3,0.3c-1.6,10-0.5,10.9,11.1,8.9C140.9,124.3,140.9,121.4,140.9,117.9z\"/>\n\t\t\t<path class=\"st1\" d=\"M167.2,113.7c1.7,0,3.3,0,5,0c3.2,0.1,4.7,1.6,4.9,5c0.9,12.3-4.8,16.8-16.9,13c-1.9-0.6-3.2-1.7-3.2-3.9\n\t\t\t\tc0-1.3-0.1-2.7-0.1-4C156.9,113.6,156.9,113.6,167.2,113.7z M172.7,127.1c0.5-3.1,0.3-6-0.2-9.1c-4-0.2-7.8-0.8-11.5,0.4\n\t\t\t\tc0,3-0.6,5.8,0.4,8.8C165.2,127.9,168.9,128.1,172.7,127.1z\"/>\n\t\t\t<path class=\"st1\" d=\"M166.7,104.9c-1.7,0-3.3,0-5,0c-3.2-0.1-4.8-1.7-4.9-5c-0.2-15.5-0.2-13,15.3-13.1c3.2,0,5,1.5,4.9,4.9\n\t\t\t\tc0,1,0.1,2,0.1,3C176.9,104.9,176.9,104.9,166.7,104.9z M161.1,100.2c13.4,1.2,12.6,1.5,11.1-9.4c-1.7,0-3.5-0.1-5.3,0\n\t\t\t\tc-1.9,0.1-3.9-0.6-5.8,0.8C161.1,94.4,161.1,97.2,161.1,100.2z\"/>\n\t\t\t<path class=\"st1\" d=\"M135.5,104.9c-2.1,0-3.8,0-5.5,0c-3.2-0.1-4.7-1.7-5-5c-1-12,0-13.3,11.9-13.1c2.8,0,6.9-1.3,7.8,2.5\n\t\t\t\tc1.1,4.6,1.9,9.8-0.8,14.1C142,106.4,138,104.4,135.5,104.9z M129.7,91.1c-1,9.8-2.7,10.8,11.3,9.1c0.1-3,0.5-6-0.4-9.1\n\t\t\t\tC136.9,91.1,133.4,91.1,129.7,91.1z\"/>\n\t\t\t<path class=\"st1\" d=\"M135.6,157.1c-1.9,0-3.4,0-4.9,0c-4,0.2-5.6-1.8-5.7-5.8c-0.2-14.6,1.1-12.4,11.7-12.3\n\t\t\t\tc2.9,0,6.9-1.2,7.9,2.3c1.3,4.5,1.9,9.7-0.6,14.1C142.2,158.7,138.2,156.6,135.6,157.1z M129.7,143.3\n\t\t\t\tc-0.9,10.1-2.6,10.7,11.3,9.1c0.4-3,0.6-6.1-0.4-9.1C136.8,143.3,133.4,143.3,129.7,143.3z\"/>\n\t\t\t<path class=\"st1\" d=\"M166.9,139c1.5,0,3,0.1,4.5,0c4-0.2,5.6,1.7,5.7,5.7c0.4,12.1,0.2,12.5-11.6,12.5c-8.5,0-8.8-0.3-8.7-8.7\n\t\t\t\tc0-1,0-2,0-3c-0.2-4.5,1.6-7,6.5-6.5C164.5,139.1,165.7,139,166.9,139z M160.9,143.3c0.2,3.5-0.5,6.4,0.5,9.2\n\t\t\t\tc13.4,1.2,12.2,1.3,10.8-9.2C168.7,143.3,165.2,143.3,160.9,143.3z\"/>\n\t\t\t<path class=\"st0\" d=\"M39.1,5.9c19.9,0,39.1,0,58.7,0C97,17,96.7,28,96.9,38.9c0.4,27.2,4.9,53.6,14.5,79.1c0.6,1.6,1,3.2,1,4.9\n\t\t\t\tc0,10.2-0.1,20.3,0,30.5c0,2.8-0.8,3.8-3.7,3.8c-31.5-0.1-62.9,0-95.6,0C40.3,109.5,43.2,58.5,39.1,5.9z\"/>\n\t\t\t<path class=\"st0\" d=\"M485.1,156.6c-3,0-5.6,0-8.7,0c0.7-12.8,1.4-25.5,2.1-38.3c0.2-3.2,0.3-6.3,0.6-9.5c0.1-1.3-0.8-3.4,1.5-3.6\n\t\t\t\tc2.3-0.2,1.8,2,1.9,3.3c0.5,7.5,1,14.9,1.4,22.4C484.2,139.5,484.6,147.9,485.1,156.6z\"/>\n\t\t\t<path class=\"st0\" d=\"M456.6,156.5c-2.8,0.6-5.4,0.4-8.3,0.1c-0.7-6.4,0.5-12.6,0.7-18.8c0.4-9.8,1-19.6,1.6-29.4\n\t\t\t\tc0.1-1.2-0.4-3,1.6-3.1c2.1-0.1,1.7,1.6,1.8,2.9C454.9,124.2,455.7,140.3,456.6,156.5z\"/>\n\t\t\t<path class=\"st2\" d=\"M112.8,107.1c-0.1,0.1-0.2,0.2-0.4,0.3c-0.1-0.3-0.3-0.5-0.3-0.8c0-0.1,0.2-0.2,0.3-0.3\n\t\t\t\tC112.6,106.6,112.7,106.8,112.8,107.1z\"/>\n\t\t\t<path class=\"st0\" d=\"M204.3,118.4c0.8,10.3,0.8,10.3-11.1,8.9c-1-2.8-0.5-5.7-0.3-8.6C196.6,117.6,198.9,117.5,204.3,118.4z\"/>\n\t\t\t<path class=\"st0\" d=\"M234.9,127.5c-4.1,0-7.3,0-10.6,0c-1.3-3.1-0.9-6-0.3-9.2c3.7-0.7,7.4-0.6,11.3,0\n\t\t\t\tC235,121.5,236.3,124.5,234.9,127.5z\"/>\n\t\t\t<path class=\"st0\" d=\"M234.8,100.6c-3.5,0-7,0-10.5,0c-1.6-3.1-0.7-6.2-0.6-9.3c3.9-0.6,7.5-0.5,11.3-0.1\n\t\t\t\tC235.1,94.4,236.2,97.4,234.8,100.6z\"/>\n\t\t\t<path class=\"st0\" d=\"M223.9,143.3c4,0,7.4,0,11,0c0.6,3.3,0.7,6.3,0.2,9.5c-3.8,0-7.2,0-10.9,0\n\t\t\t\tC222.9,149.8,223.6,146.8,223.9,143.3z\"/>\n\t\t\t<path class=\"st0\" d=\"M193.1,152.9c-0.7-3.2-0.5-6.1-0.1-9c4.2-1,7.1-1,11.2-0.1C204.7,154,207.2,153.2,193.1,152.9z\"/>\n\t\t\t<path class=\"st0\" d=\"M193.2,100.4c-0.8-3.2-0.6-6.1-0.2-9.3c3.8,0,7.4,0,10.9,0C205.9,101,205.3,101.6,193.2,100.4z\"/>\n\t\t\t<path class=\"st0\" d=\"M140.9,117.9c0,3.6,0,6.4,0,9.3c-11.6,2-12.8,1.1-11.1-8.9c0.7-0.1,1.5-0.3,2.3-0.3\n\t\t\t\tC134.8,117.8,137.6,117.9,140.9,117.9z\"/>\n\t\t\t<path class=\"st0\" d=\"M172.7,127.1c-3.8,0.9-7.5,0.8-11.2,0.1c-1-3-0.4-5.8-0.4-8.8c3.7-1.1,7.5-0.6,11.5-0.4\n\t\t\t\tC173,121.1,173.2,124,172.7,127.1z\"/>\n\t\t\t<path class=\"st0\" d=\"M161.1,100.2c0-3,0-5.8,0-8.5c1.9-1.4,3.9-0.7,5.8-0.8c1.8-0.1,3.6,0,5.3,0\n\t\t\t\tC173.7,101.8,174.5,101.5,161.1,100.2z\"/>\n\t\t\t<path class=\"st0\" d=\"M129.7,91.1c3.7,0,7.2,0,10.9,0c0.9,3.1,0.5,6.1,0.4,9.1C127,101.9,128.7,100.9,129.7,91.1z\"/>\n\t\t\t<path class=\"st0\" d=\"M129.7,143.3c3.7,0,7.2,0,10.9,0c0.9,3,0.7,6.1,0.4,9.1C127.1,154,128.7,153.4,129.7,143.3z\"/>\n\t\t\t<path class=\"st0\" d=\"M160.9,143.3c4.2,0,7.8,0,11.3,0c1.4,10.5,2.6,10.4-10.8,9.2C160.4,149.7,161.1,146.8,160.9,143.3z\"/>\n\t\t</g>\n\t</g>\n</g>\n</svg>\n                            </div>\n\n                        </div>\n                    </div>\n                    <div *ngIf=\"(isIE || isEdge)\">\n                        <img src=\"" + __webpack_require__(879) + "\" style=\"width: 100%;max-width: 450px;\">\n                    </div>\n                </div>\n            </div>\n        </div> <!-- #funcionamiento-->\n\n        <div id=\"funcionamiento2\" class=\"section\" >\n            <div class=\"container\">\n                <div class=\"row\">\n                    <div class=\"col-xs-12 col-md-6\">\n                        <div class=\"equal-height-cell\">\n                            <h3 class=\"section-subtitle\">Como funciona?</h3>\n                            <h2 class=\"section-title\">Visualice la información <span\n                                    class=\"color\">en tiempo real.</span>\n                            </h2>\n                            <p class=\"m-t-space\"></p>\n                            <p class=\"m-t-space\">Este servidor web almacena los datos y los muestra de forma clara y sencilla. El acceso\n                                al sistema de monitoreo se puede realizar a través de múltiples dispositivos de acceso a\n                                internet, brindando información en tiempo real, análisis histório, la posibilidad de\n                                programar alertas y el envío de avisos por sms y correo electrónico.</p>\n                        </div>\n                        <div style=\"text-align: center; padding-top: 60px;\">\n                            <button type=\"button\" (click)=\"animarA('contact');animarMenuCelular()\" class=\"btn _theme _icon\">\n                                <span>Obtenelo ahora</span>\n                                <i class=\"ion-forward\"></i>\n                            </button>\n                        </div>\n                    </div>\n                    <div class=\"hidden-xs col-md-5 col-md-offset-1\">\n                        <img src=\"" + __webpack_require__(880) + "\"\n                             class=\"double-device-front wow animated fadeInLeftScale90\" style=\"position: relative;top: 100px; margin: auto\n\"/>\n                    </div>\n                </div>\n            </div>\n        </div> <!-- #app-brief-2 -->\n        <div id=\"software\" class=\"section\">\n            <div class=\"container\">\n                <div class=\"row\">\n                    <div class=\"col-xs-12\">\n                        <div class=\"text-center max-width-640\">\n                            <h3 class=\"section-subtitle\">Software</h3>\n                            <h2 class=\"section-title\">Características de la <span class=\"color\">aplicación.</span></h2>\n                            <p class=\"m-t-10\">La aplicación web puede accederse a través de un navegador desde cualquier dispositivo. </p>\n                        </div>\n                        <ul class=\"feature feature-list row m-t-space\">\n                            <li class=\"feature-item col-xs-12 col-md-6 col-md-4\">\n                                <div class=\"feature-box\">\n                                    <div class=\"feature-icon\">\n                                        <i>\n                                            <img src=\"" + __webpack_require__(881) + "\"\n                                                 style=\"width: 43px; padding-top: 11px;\"/>\n                                        </i>\n                                    </div>\n                                    <h3 class=\"feature-title\">Adaptable a múltiples dispositivos</h3>\n                                    <p class=\"feature-content\">Visualización en distintas resoluciones.</p>\n                                </div>\n                            </li>\n                            <li class=\"feature-item col-xs-12 col-md-6 col-md-4\">\n                                <div class=\"feature-box\">\n                                    <div class=\"feature-icon\">\n                                        <i>\n                                            <img src=\"" + __webpack_require__(882) + "\" style=\"width: 43px; padding-top: 11px;\"/>\n                                        </i>\n                                    </div>\n                                    <h3 class=\"feature-title\">Fácil de usar</h3>\n                                    <p class=\"feature-content\">Interfaz amigable e intuitiva.</p>\n                                </div>\n                            </li>\n                            <li class=\"feature-item col-xs-12 col-md-6 col-md-4\">\n                                <div class=\"feature-box\">\n                                    <div class=\"feature-icon\">\n                                        <i>\n                                            <img src=\"" + __webpack_require__(883) + "\" style=\"width: 50px; padding-top: 17px;\"/>\n                                        </i>\n                                    </div>\n                                    <h3 class=\"feature-title\">Gráficas en tiempo real</h3>\n                                    <p class=\"feature-content\">Visualización de datos en tiempo real. Controle las mediciones minuto a minuto.</p>\n                                </div>\n                            </li>\n                            <li class=\"feature-item col-xs-12 col-md-6 col-md-4\">\n                                <div class=\"feature-box\">\n                                    <div class=\"feature-icon\">\n                                        <i>\n                                            <img src=\"" + __webpack_require__(884) + "\" style=\"width: 43px; padding-top: 8px;\"/>\n                                        </i>\n                                    </div>\n                                    <h3 class=\"feature-title\">Gráficas de históricos</h3>\n                                    <p class=\"feature-content\">Visualización de mediciones históricas.\n                                        Controle minuciosamente la evolución de variables a través del tiempo.</p>\n                                </div>\n                            </li>\n                            <li class=\"feature-item col-xs-12 col-md-6 col-md-4\">\n                                <div class=\"feature-box\">\n                                    <div class=\"feature-icon\">\n                                        <i>\n                                            <img src=\"" + __webpack_require__(885) + "\" style=\"width: 43px; padding-top: 7px;\"/>\n                                        </i>\n                                    </div>\n                                    <h3 class=\"feature-title\">Avisos de alarmas vía email y sms</h3>\n                                    <p class=\"feature-content\">Notificaciones sobre situaciones de funcionamiento\n                                        anormal.</p>\n                                </div>\n                            </li>\n                            <li class=\"feature-item col-xs-12 col-md-6 col-md-4\">\n                                <div class=\"feature-box\">\n                                    <div class=\"feature-icon\">\n                                        <i>\n                                            <img src=\"" + __webpack_require__(886) + "\" style=\"width: 43px; padding-top: 19px;\"/>\n                                        </i>\n                                    </div>\n                                    <h3 class=\"feature-title\">Panel de resumen de estados</h3>\n                                    <p class=\"feature-content\">Vista resumen de estados con colores que indican\n                                        condición.</p>\n                                </div>\n                            </li>\n                        </ul>\n                    </div>\n                </div>\n            </div>\n        </div> <!-- #feature -->\n\n        <div id=\"hardware\" class=\"section text-light\" data-stellar-background-ratio=\".5\">\n            <div class=\"section-overlay\"></div>\n            <div class=\"container\">\n                <div class=\"row relative\">\n                    <div class=\"col-md-6 float-right-md-min\">\n                        <h3 class=\"section-subtitle\">Hardware</h3>\n                        <h2 class=\"section-title\">Especificaciones <span\n                                class=\"color\">técnicas</span>\n                        </h2>\n                        <p class=\"m-t-space\">Conectividad inalámbrica. Pequeños dispositivos a bateria.</p>\n                        <div class=\"selling-point\">\n                            <ul class=\"selling-point-list\">\n                                <li class=\"selling-point-item\"><i class=\"glyphicon glyphicon-ok-sign\"></i>Alimentación a batería.</li>\n                                <li class=\"selling-point-item\"><i class=\"glyphicon glyphicon-ok-sign\"></i>Dimensiones: 75x55x30mm</li>\n                                <li class=\"selling-point-item\"><i class=\"glyphicon glyphicon-ok-sign\"></i>Rango típico de alcancce inalámbrico: hasta 50m</li>\n                                <li class=\"selling-point-item\"><i class=\"glyphicon glyphicon-ok-sign\"></i>Frecuencia de muestreo mayor a un minuto.</li>\n                                <li class=\"selling-point-item\"><i class=\"glyphicon glyphicon-ok-sign\"></i>Seguridad inalámbrica.</li>\n                                <li class=\"selling-point-item\"><i class=\"glyphicon glyphicon-ok-sign\"></i>Respaldo de datos ante falla de comunicación: 1 millon de datos.</li>\n                                <li class=\"selling-point-item\"><i class=\"glyphicon glyphicon-ok-sign\"></i>Autonomía ante corte de energía: 60 minutos.</li>\n                            </ul>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div> <!-- #download -->\n\n        <div id=\"variables\" class=\"section\">\n            <div class=\"container\">\n                <div class=\"row\">\n                    <div class=\"col-xs-12\">\n                        <div class=\"text-center max-width-640\">\n                            <h3 class=\"section-subtitle\">Tipos variables</h3>\n                            <h2 class=\"section-title\">Variables a<span class=\"color\"> sensar.</span></h2>\n                            <p class=\"m-t-10\" style=\"font-size: 16px\">Se dispone de distintos modelos de dispositivos, permiten la medición de diferentes tipos de variables. </p>\n                        </div>\n                        <ul class=\"feature feature-list row m-t-space\">\n                            <li class=\"feature-item col-xs-12 col-md-6 col-md-4\">\n                                <div class=\"feature-box\">\n                                    <div class=\"feature-icon\">\n                                        <i>\n                                            <img src=\"" + __webpack_require__(876) + "\"\n                                                 style=\"width: 28px; padding-top: 8px;\"/>\n                                        </i>\n                                    </div>\n                                    <h3 class=\"feature-title\">Temperatura</h3>\n                                </div>\n                            </li>\n                            <li class=\"feature-item col-xs-12 col-md-6 col-md-4\">\n                                <div class=\"feature-box\">\n                                    <div class=\"feature-icon\">\n                                        <i>\n                                            <img src=\"" + __webpack_require__(877) + "\" style=\"width: 43px; padding-top: 11px;\"/>\n                                        </i>\n                                    </div>\n                                    <h3 class=\"feature-title\">Humedad</h3>\n                                </div>\n                            </li>\n                            <li class=\"feature-item col-xs-12 col-md-6 col-md-4\">\n                                <div class=\"feature-box\">\n                                    <div class=\"feature-icon\">\n                                        <i>\n                                            <img src=\"" + __webpack_require__(878) + "\" style=\"width: 50px; padding-top: 7px;\"/>\n                                        </i>\n                                    </div>\n                                    <h3 class=\"feature-title\">Presión</h3>\n                                </div>\n                            </li>\n                            <li class=\"feature-item col-xs-12 col-md-6 col-md-4\">\n                                <div class=\"feature-box\">\n                                    <div class=\"feature-icon\">\n                                        <i>\n                                            <img src=\"" + __webpack_require__(887) + "\" style=\"width: 21px; padding-top: 9px;\"/>\n                                        </i>\n                                    </div>\n                                    <h3 class=\"feature-title\">Tensión continua</h3>\n                                </div>\n                            </li>\n                            <li class=\"feature-item col-xs-12 col-md-6 col-md-4\">\n                                <div class=\"feature-box\">\n                                    <div class=\"feature-icon\">\n                                        <i>\n                                            <img src=\"" + __webpack_require__(888) + "\" style=\"width: 33px; padding-top: 9px;\"/>\n                                        </i>\n                                    </div>\n                                    <h3 class=\"feature-title\">Corriente continua</h3>\n                                </div>\n                            </li>\n                            <li class=\"feature-item col-xs-12 col-md-6 col-md-4\">\n                                <div class=\"feature-box\">\n                                    <div class=\"feature-icon\">\n                                        <i>\n                                            <img src=\"" + __webpack_require__(889) + "\" style=\"width: 31px; padding-top: 9px;\"/>\n                                        </i>\n                                    </div>\n                                    <h3 class=\"feature-title\">Otras variables</h3>\n                                    <p class=\"feature-content\">Posibilidad de sensar otras variables mediante transductor.</p>\n                                </div>\n                            </li>\n                        </ul>\n                    </div>\n                </div>\n            </div>\n        </div> <!-- #feature -->\n\n        <div id=\"empresa\" class=\"section\">\n            <div class=\"container\">\n                <div class=\"row\">\n                    <div class=\"col-xs-12 col-md-6\">\n                        <div class=\"equal-height-cell\">\n                            <h3 class=\"section-subtitle\">Empresa</h3>\n                            <h2 class=\"section-title\">Desarrollado por\n                                <img src=\"" + __webpack_require__(890) + "\"  style=\"position: relative;\"/>\n\n                            </h2>\n\n\n                            <p class=\"m-t-space\"></p>\n                            <p>Empresa con más de 30 años de trayectoria, dedicada a ofrecer al mercado productos de alta tecnología\n                                provenientes del exterior junto con desarrollos propios,\n                                que involucrándolos le brinda a sus clientes soluciones integrales adaptadas a sus necesidades.</p>\n                            <div class=\"selling-point\">\n                                <ul class=\"selling-point-list\" style=\"font-size: 17px\">\n                                    <li class=\"selling-point-item\" style=\"color: black; margin-bottom: 5px\"><i class=\"glyphicon glyphicon-map-marker\"></i>Lamadrid 470 - Zona i - Nave 2 - PB Of. 2 (S2001EBJ)<br/>Rosario, Santa Fe (Argentina)</li>\n                                    <li class=\"selling-point-item\" style=\"color: black; margin-bottom: 5px\"><i class=\"glyphicon glyphicon-phone\"></i>+54 341 5277920</li>\n                                    <li class=\"selling-point-item\" style=\"color: black; margin-bottom: 5px\"><i class=\"glyphicon glyphicon-envelope\"></i>tbm@tbm.com.ar</li>\n                                    <li class=\"selling-point-item\" style=\"color: black; margin-bottom: 5px\"><i class=\"glyphicon glyphicon-globe\"></i><a target=\"_blank\" href=\"http://www.tbm.com.ar\">www.tbm.com.ar</a> </li>\n                                </ul>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"col-xs-12 col-md-6\">\n                        <div id=\"map\" style=\"height: 100%; max-height: 500px;max-width: 500px; border-radius: 100%; margin: auto\"></div>\n                    </div>\n                </div>\n            </div>\n        </div> <!-- #app-brief-2 -->\n\n        <div id=\"contact\" class=\"section\">\n            <div class=\"container\">\n                <div class=\"row\">\n                    <div class=\"col-xs-12\">\n                        <div class=\"text-center max-width-640\">\n                            <h3 class=\"section-subtitle\">Alguna consulta?</h3>\n                            <h2 class=\"section-title\">Contacto<span class=\"color\">.</span></h2>\n                            <p class=\"m-t-10\"></p>\n                        </div>\n\n                        <form #contactoForm=\"ngForm\" *ngIf=\"active\">\n                            <div class=\"row\">\n                                <div class=\"col-sm-12\">\n                                    <div class=\"form-group required\">\n                                        <label class=\"form-label\" for=\"consulta\">Tipo Consulta</label>\n                                        <select required class=\"form-control\" id=\"consulta\" type=\"text\" name=\"consulta\" [(ngModel)]=\"email1.tipoConsulta\" #tipoConsulta=\"ngModel\">\n                                            <option value=\"\"></option>\n                                            <option value=\"tecnica\">Técnica</option>\n                                            <option value=\"comercial\">Comercial</option>\n                                        </select>\n                                        <div [hidden]=\"tipoConsulta.valid || tipoConsulta.pristine\" class=\"alert alert-danger\">\n                                            Tipo consulta es requerido\n                                        </div>\n                                    </div>\n                                </div>\n                                <div class=\"col-sm-6\">\n                                    <div class=\"form-group required\">\n                                        <label class=\"form-label\" for=\"nombre\">Nombre</label>\n                                        <input required class=\"form-control\" id=\"nombre\" type=\"text\" name=\"nombre\" [(ngModel)]=\"email1.nombre\" #nombre=\"ngModel\">\n                                        <div [hidden]=\"nombre.valid || nombre.pristine\" class=\"alert alert-danger\">\n                                            Nombre es requerido\n                                        </div>\n                                    </div>\n                                </div>\n                                <div class=\"col-sm-6\">\n                                    <div class=\"form-group required\">\n                                        <label class=\"form-label\" for=\"email\">Email</label>\n                                        <input required class=\"form-control\" id=\"email\" type=\"email\" name=\"email\"\n                                               pattern=\"^[_a-z0-9-]+(\\.[_a-z0-9-]+)*@[a-z0-9-]+(\\.[a-z0-9-]+)*(\\.[a-z]{2,3})$\" [(ngModel)]=\"email1.email\" #email=\"ngModel\">\n                                        <div [hidden]=\"email.valid || email.pristine\" class=\"alert alert-danger\">\n                                            Email es requerido y debe tener un formato válido.\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"form-group required\">\n                                <label class=\"form-label\" for=\"mensaje\">Mensaje</label>\n                                <textarea required class=\"form-control\" id=\"mensaje\" rows=\"5\" name=\"mensaje\" [(ngModel)]=\"email1.mensaje\" #mensaje=\"ngModel\"></textarea>\n                                <div [hidden]=\"mensaje.valid || mensaje.pristine\" class=\"alert alert-danger\">\n                                    Mensaje es requerido\n                                </div>\n                            </div>\n                            <button type=\"button\" (click)=\"enviarMail()\" class=\"btn _theme _icon\" [disabled]=\"!contactoForm.form.valid || guardando\">\n                                <span *ngIf=\"!guardando\">Enviar mensaje</span>\n                                <span *ngIf=\"guardando\">Enviando</span>\n                                <i class=\"ion-forward\"></i>\n                            </button>\n                            <div class=\"form-notify\">\n                                <p *ngIf=\"!guardando && error==null && ok\" style=\"color: green;\">Mensaje enviado correctamente</p>\n                                <p *ngIf=\"!guardando && error!=null && !ok\" style=\"color: red;\">Error en el envío de mail. Vuelva a intentarlo.</p>\n                            </div>\n                        </form> <!-- #contactForm -->\n                    </div>\n                </div>\n            </div>\n        </div> <!-- #contact -->\n    </main> <!-- .site-content -->\n\n    <footer class=\"site-footer text-light text-center\">\n        <div class=\"container\">\n            <div class=\"row\">\n                <div class=\"col-xs-12\">\n                    <div class=\"col-md-6\">\n                        <p class=\"copy\">\n                            © 2017 Bemakoha, Todos los derechos reservados.\n                        </p>\n                    </div>\n                    <div class=\"col-md-6\">\n                        <a class=\"desa\" target=\"_blank\" href=\"http://www.exadec.com\" style=\"text-align: right; display:block;\">\n                            <span><div class=\"exadec\"></div></span>\n                            <p style=\"color:grey;font-size: 9px; margin: 0;\">Diseñado por</p>\n\n                        </a>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </footer> <!-- .site-footer -->\n</div> <!-- .site -->\n\n<!-- script -->\n\n\n";

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/ojo_bemakoha_letras.4695a20d76828cf75fda1668fe2b2701.png";

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/phone-02.deb423da11ef0551b203d4f020f2e158.png";

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/phone-011.27e4f7108dbabc90ed2dc702d877bd5e.png";

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/nube.68369b289f85d39f7523e04c5c4fff54.svg";

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/temperaturaB.2fede32c46f41b125f47c6fc0c1121b9.png";

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/humedad.faf5dde2fdcb6366ead6b3415aca8471.png";

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/barometro.7930f9933c86173e2a521b7c340b26c2.png";

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/fabricaSinAnimacion.d7377b18401020006fc6f24e12c66637.png";

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/responsiveWebDesign.afe961f5ace07b373340c85ab9de7849.png";

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/responsive.09fa58cd134b881a639bbf693c4f5b1e.png";

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/facil.d71bd931a6ac87d0e1129634b6ce3673.png";

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/graficos.9d094adc32efc989d426d4fed5cd4a75.png";

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/historico.f54df762bebb89487f0849493afd9781.png";

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/alarmas.bbf37c97a766448f5672261de1a51011.png";

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/ojoBlanco.7b734dcc33a63de5b34ce3a9c3a6ab16.png";

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/voltaje.3c22947d3e74552662b1cf7f5876be29.png";

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/corriente.f2550b072ba9597d5ec40d584e09eb07.png";

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/pregunta.41771275bd8b21f62f78f996a51bafed.png";

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/logo_tbm.c7b5907f9e5f31cba2622d1ad3fbe03c.png";

/***/ }),
/* 891 */
/***/ (function(module, exports) {

	module.exports = ".seccion {\n    width: 100vw;\n    height: 100vh;\n    min-height: 807px;\n    background-image: url(\"../../img/fabrica.jpeg\");\n    background-size: cover;\n    font-size: 15px;\n\n}\n\n.containerCircuito h2 {\n    font-size: 18px;\n    margin: 0\n}\n\n.containerCircuito ._28WmEDDQ-XFTb-tTU8PLat {\n    position: absolute;\n    bottom: 70px;\n    width: 100%;\n    opacity: 0;\n    z-index: 1;\n    font-size: 13px;\n    -webkit-animation: _3hQ2jb6feIHlJ_zIdyVHPk;\n    animation: _3hQ2jb6feIHlJ_zIdyVHPk;\n    -webkit-animation-delay: 1s;\n    animation-delay: 1s;\n    -webkit-animation-duration: .3s;\n    animation-duration: .3s;\n    -webkit-animation-timing-function: ease-in;\n    animation-timing-function: ease-in;\n    -webkit-animation-fill-mode: forwards;\n    animation-fill-mode: forwards\n}\n\n.containerCircuito .circuito {\n    width: 100%;\n    min-height: 100%;\n    /*position: absolute;\n    top: 0;\n    left: 0*/\n}\n\n.containerCircuito .circuito path {\n    fill: none;\n    stroke: #008094;\n    stroke-width: 3px;\n    stroke-dasharray: 5500px;\n    stroke-miterlimit: 10;\n    stroke-dashoffset: -5500px;\n    stroke-width: 2;\n    stroke-linecap: round;\n    stroke-linejoin: round;\n    stroke-miterlimit: 10;\n\n}\n\n.containerCircuito .circuitoVisible {\n    width: 100%;\n    min-height: 100%;\n}\n\n.containerCircuito .circuitoVisible path {\n    stroke: #008094;\n    stroke-dasharray: 5500px;\n    stroke-miterlimit: 10;\n    stroke-width: 2;\n    stroke-linecap: round;\n    stroke-linejoin: round;\n    stroke-dashoffset: 0;\n\n}\n\n.animacion path {\n    -webkit-animation-name: animacionCircuito;\n    animation-name: animacionCircuito;\n    -webkit-animation-duration: 7s;\n    animation-duration: 7s;\n    -webkit-animation-direction: alternate;\n    animation-direction: alternate;\n    -webkit-animation-iteration-count: 1;\n    animation-iteration-count: 1;\n    -webkit-animation-fill-mode: forwards;\n    animation-fill-mode: forwards;\n    -webkit-animation-timing-function: linear;\n    animation-timing-function: linear;\n    animation-delay: 0s;\n}\n\n@-webkit-keyframes _3hQ2jb6feIHlJ_zIdyVHPk {\n    0% {\n        opacity: 0\n    }\n    to {\n        opacity: 1\n    }\n}\n\n@keyframes _3hQ2jb6feIHlJ_zIdyVHPk {\n    0% {\n        opacity: 0\n    }\n    to {\n        opacity: 1\n    }\n}\n\n@-webkit-keyframes animacionCircuito {\n    to {\n        stroke-dashoffset: 0\n    }\n}\n\n@keyframes animacionCircuito {\n    to {\n        stroke-dashoffset: 0\n    }\n}\n\n.circulo {\n    width: 17px;\n    height: 17px;\n    border-radius: 100%;\n    background-color: rgba(230, 49, 49, .4);\n    position: absolute;\n    margin-left: 123px;\n    margin-top: 110px;\n    -webkit-animation: sonarWave 2s linear infinite;\n    animation: sonarWave 2s linear infinite;\n    animation-delay: 8s;\n    opacity: 0;\n}\n\n.circulo2 {\n    width: 17px;\n    height: 17px;\n    border-radius: 100%;\n    background-color: rgba(230, 49, 49, .4);\n    position: absolute;\n    margin-left: 212px;\n    margin-top: 110px;\n    -webkit-animation: sonarWave 2s linear infinite;\n    animation: sonarWave 2s linear infinite;\n    animation-delay: 8s;\n    opacity: 0;\n}\n\n.circulo3 {\n    width: 17px;\n    height: 17px;\n    border-radius: 100%;\n    background-color: rgba(230, 49, 49, .4);\n    position: absolute;\n    margin-left: 301px;\n    margin-top: 110px;\n    -webkit-animation: sonarWave 2s linear infinite;\n    animation: sonarWave 2s linear infinite;\n    animation-delay: 8s;\n    opacity: 0;\n}\n\n@-webkit-keyframes sonarWave {\n    from {\n        opacity: 1;\n        -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\";\n    }\n    to {\n        -webkit-transform: scale(2);\n        transform: scale(2);\n        opacity: 0;\n        -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";\n    }\n}\n\n@keyframes sonarWave {\n    from {\n        opacity: 1;\n        -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\";\n    }\n    to {\n        -webkit-transform: scale(2);\n        transform: scale(2);\n        opacity: 0;\n        -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";\n    }\n}\n\n.linea {\n    height: 100px;\n    border: 1px dashed rgba(230, 49, 49, .4);\n    position: absolute;\n    margin-left: 130px;\n    margin-top: -27px;\n    -webkit-animation: sonarWave 2s linear infinite;\n    animation: sonarWave 2s linear infinite;\n    animation-delay: 9s;\n    opacity: 0;\n}\n\n.linea2 {\n    height: 100px;\n    border: 1px dashed rgba(230, 49, 49, .4);\n    position: absolute;\n    margin-left: 221px;\n    margin-top: -27px;\n    -webkit-animation: sonarWave 2s linear infinite;\n    animation: sonarWave 2s linear infinite;\n    animation-delay: 9s;\n    opacity: 0;\n}\n\n.linea3 {\n    height: 100px;\n    border: 1px dashed rgba(230, 49, 49, .4);\n    position: absolute;\n    margin-left: 312px;\n    margin-top: -27px;\n    -webkit-animation: sonarWave 2s linear infinite;\n    animation: sonarWave 2s linear infinite;\n    animation-delay: 9s;\n    opacity: 0;\n}\n\nnav {\n    background-color: transparent;\n}\n\n.celulares {\n    text-align: center;\n    margin-top: 15%;\n}\n\n.celulares img {\n    width: 70%;\n}\n\n.icon-bar {\n    background-color: white;\n}\n\n.animacionMenuI.seccion {\n    width: 100vw;\n    height: 100vh;\n    min-height: 807px;\n    background-image: url(\"../../img/fabrica.jpeg\");\n    background-size: cover;\n    font-size: 15px;\n\n}\n\n.containerCircuito h2 {\n    font-size: 18px;\n    margin: 0\n}\n\n.containerCircuito ._28WmEDDQ-XFTb-tTU8PLat {\n    position: absolute;\n    bottom: 70px;\n    width: 100%;\n    opacity: 0;\n    z-index: 1;\n    font-size: 13px;\n    -webkit-animation: _3hQ2jb6feIHlJ_zIdyVHPk;\n    animation: _3hQ2jb6feIHlJ_zIdyVHPk;\n    -webkit-animation-delay: 1s;\n    animation-delay: 1s;\n    -webkit-animation-duration: .3s;\n    animation-duration: .3s;\n    -webkit-animation-timing-function: ease-in;\n    animation-timing-function: ease-in;\n    -webkit-animation-fill-mode: forwards;\n    animation-fill-mode: forwards\n}\n\n.containerCircuito .circuito {\n    width: 100%;\n    min-height: 100%;\n    /*position: absolute;\n    top: 0;\n    left: 0*/\n}\n\n.containerCircuito .circuito path {\n    fill: none;\n    stroke: #008094;\n    stroke-width: 3px;\n    stroke-dasharray: 5500px;\n    stroke-miterlimit: 10;\n    stroke-dashoffset: -5500px;\n    stroke-width: 2;\n    stroke-linecap: round;\n    stroke-linejoin: round;\n    stroke-miterlimit: 10;\n\n}\n\n.animacion path {\n    -webkit-animation-name: animacionCircuito;\n    animation-name: animacionCircuito;\n    -webkit-animation-duration: 7s;\n    animation-duration: 7s;\n    -webkit-animation-direction: alternate;\n    animation-direction: alternate;\n    -webkit-animation-iteration-count: 1;\n    animation-iteration-count: 1;\n    -webkit-animation-fill-mode: forwards;\n    animation-fill-mode: forwards;\n    -webkit-animation-timing-function: linear;\n    animation-timing-function: linear;\n    animation-delay: 0s;\n}\n\n@-webkit-keyframes _3hQ2jb6feIHlJ_zIdyVHPk {\n    0% {\n        opacity: 0\n    }\n    to {\n        opacity: 1\n    }\n}\n\n@keyframes _3hQ2jb6feIHlJ_zIdyVHPk {\n    0% {\n        opacity: 0\n    }\n    to {\n        opacity: 1\n    }\n}\n\n@-webkit-keyframes animacionCircuito {\n    to {\n        stroke-dashoffset: 0\n    }\n}\n\n@keyframes animacionCircuito {\n    to {\n        stroke-dashoffset: 0\n    }\n}\n\n.circulo {\n    width: 17px;\n    height: 17px;\n    border-radius: 100%;\n    background-color: rgba(230, 49, 49, .4);\n    position: absolute;\n    margin-left: 123px;\n    margin-top: 110px;\n    -webkit-animation: sonarWave 2s linear infinite;\n    animation: sonarWave 2s linear infinite;\n    animation-delay: 8s;\n    opacity: 0;\n}\n\n.circulo2 {\n    width: 17px;\n    height: 17px;\n    border-radius: 100%;\n    background-color: rgba(230, 49, 49, .4);\n    position: absolute;\n    margin-left: 212px;\n    margin-top: 110px;\n    -webkit-animation: sonarWave 2s linear infinite;\n    animation: sonarWave 2s linear infinite;\n    animation-delay: 8s;\n    opacity: 0;\n}\n\n.circulo3 {\n    width: 17px;\n    height: 17px;\n    border-radius: 100%;\n    background-color: rgba(230, 49, 49, .4);\n    position: absolute;\n    margin-left: 301px;\n    margin-top: 110px;\n    -webkit-animation: sonarWave 2s linear infinite;\n    animation: sonarWave 2s linear infinite;\n    animation-delay: 8s;\n    opacity: 0;\n}\n\n@media (max-width: 767px) {\n    .circulo {\n        margin-top: 95px;\n    }\n\n    .circulo2 {\n        margin-top: 95px;\n    }\n\n    .circulo3 {\n        margin-top: 95px;\n    }\n}\n\n@media (max-width: 320px) {\n    .circulo2 {\n        margin-left: 198px;\n    }\n\n    .linea2 {\n        margin-left: 206px !important;\n    }\n\n    .circulo3 {\n        margin-left: 274px;\n    }\n\n    .linea3 {\n        margin-left: 281px !important;\n    }\n}\n\n@media (min-width: 1024px) and (max-width: 1199px) {\n    .humedad {\n        padding-left: 26px !important;\n    }\n\n    .barometro {\n        padding-left: 54px !important;\n    }\n\n    .site-header-brand-img {\n        height: 34px;\n    }\n}\n\n@media (min-width: 768px) and (max-width: 991px) {\n    .circulo2 {\n        margin-left: 300px;\n    }\n\n    .linea2 {\n        margin-left: 311px !important;\n    }\n\n    .circulo3 {\n        margin-left: 483px;\n    }\n\n    .linea3 {\n        margin-left: 490px !important;\n    }\n\n    .selling-point {\n        font-size: 20px;\n    }\n\n    .m-t-space {\n        font-size: 20px;\n    }\n}\n\n@media (max-width: 991px) {\n    .double-device-front {\n        margin-top: 60px !important;\n    }\n}\n\n@-webkit-keyframes sonarWave {\n    from {\n        opacity: 1;\n        -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\";\n    }\n    to {\n        -webkit-transform: scale(2);\n        transform: scale(2);\n        opacity: 0;\n        -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";\n    }\n}\n\n@keyframes sonarWave {\n    from {\n        opacity: 1;\n        -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\";\n    }\n    to {\n        -webkit-transform: scale(2);\n        transform: scale(2);\n        opacity: 0;\n        -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";\n    }\n}\n\n.linea {\n    height: 100px;\n    border: 1px dashed rgba(230, 49, 49, .4);\n    position: absolute;\n    margin-left: 130px;\n    margin-top: -27px;\n    -webkit-animation: sonarWave 2s linear infinite;\n    animation: sonarWave 2s linear infinite;\n    animation-delay: 9s;\n    opacity: 0;\n}\n\n.linea2 {\n    height: 100px;\n    border: 1px dashed rgba(230, 49, 49, .4);\n    position: absolute;\n    margin-left: 221px;\n    margin-top: -27px;\n    -webkit-animation: sonarWave 2s linear infinite;\n    animation: sonarWave 2s linear infinite;\n    animation-delay: 9s;\n    opacity: 0;\n}\n\n.linea3 {\n    height: 100px;\n    border: 1px dashed rgba(230, 49, 49, .4);\n    position: absolute;\n    margin-left: 312px;\n    margin-top: -27px;\n    -webkit-animation: sonarWave 2s linear infinite;\n    animation: sonarWave 2s linear infinite;\n    animation-delay: 9s;\n    opacity: 0;\n}\n\n.contenedorInstrumentos {\n    margin: 60px;\n}\n\n@media (min-width: 767px) {\n    .barometro {\n        padding-left: 0px;\n        margin-left: -21px;\n    }\n\n    .humedad {\n        padding-left: 0px;\n    }\n}\n\n@media (max-width: 767px) {\n    .contenedorInstrumentos {\n        margin-right: 0px;\n    }\n}\n\nnav {\n    background-color: transparent;\n}\n\n.celulares {\n    text-align: center;\n    margin-top: 15%;\n}\n\n.celulares img {\n    width: 70%;\n}\n\n.icon-bar {\n    background-color: white;\n}\n\n.animacionMenuInicio {\n\n    opacity: 0;\n    transform: translateY(-100px) rotateX(-35deg);\n    transition: transform 1s, opacity 1s;\n    /*animation: letras 1s ease-out 2s 1 ;*/\n    /*transition: transform 2s, opacity 1s;*/\n}\n\n.animacionMenuDInicio {\n    display: none !important;\n}\n\n.animacionMenuFin {\n    /*animation: letras 1s ease-out 2s 1 ;*/\n    transform: translateY(10%);\n    opacity: 1;\n    transition: transform 1s, opacity 0s;\n}\n\n.animacionMenuDFin {\n    display: block !important;\n}\n\n.animacionFondoMenuInicio {\n\n    opacity: 0;\n    transition: opacity 3s;\n    /*animation: letras 1s ease-out 2s 1 ;*/\n    /*transition: transform 2s, opacity 1s;*/\n}\n\n.animacionFondoMenuDInicio {\n    display: none !important;\n}\n\n.animacionFondoMenuFin {\n    /*animation: letras 1s ease-out 2s 1 ;*/\n    opacity: 1;\n    transition: opacity 1s;\n}\n\n.animacionFondoMenuDFin {\n    display: block !important;\n}\n\n.desa:hover .exadec {\n    background-image: url(../../img/exadec2.png);\n}\n\n.exadec {\n    background-image: url(\"../../img/exadec.png\");\n    background-repeat: no-repeat;\n    background-size: 84%;\n    width: 100px;\n    height: 30px;\n    right: 0;\n    top: 15px;\n    position: absolute;\n    -webkit-transition: .5s ease-in-out;\n    -moz-transition: .5s ease-in-out;\n    -o-transition: .5s ease-in-out;\n    -ms-transition: .5s ease-in-out;\n    transition: .5s ease-in-out;\n    transition-property: initial;\n    transition-duration: 0.5s;\n    transition-timing-function: ease-in-out;\n    transition-delay: initial;\n}\n\n@charset \"UTF-8\";\n\n/*!\n * jquery.mb.components\n * file: jquery.mb.YTPlayer.src.js\n * last modified: 01/07/15 19.35\n * Open Lab s.r.l., Florence - Italy\n * email: matteo@open-lab.com\n * site: http://pupunzi.com\n * http://open-lab.com\n * blog: http://pupunzi.open-lab.com\n * Q&A:  http://jquery.pupunzi.com\n * Licences: MIT, GPL\n * http://www.opensource.org/licenses/mit-license.php\n * http://www.gnu.org/licenses/gpl.html\n * Copyright (c) 2001-2015. Matteo Bicocchi (Pupunzi);\n * --------------------------------------------------\n */\n\n.mb_YTPBar, .mb_YTPBar span.mb_YTPUrl a {\n    color: #fff\n}\n\n@font-face {\n    font-family: ytpregular;\n    src: url(../fonts/ytp-regular.eot)\n}\n\n@font-face {\n    font-family: ytpregular;\n    src: url(\"data:application/x-font-woff;charset=utf-8;base64,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)format('woff'\"), url(\"../fonts/ytp-regular.ttf)format('truetype'\")\n}\n\n.mb_YTPlayer:focus {\n    outline: 0\n}\n\n.mbYTP_wrapper {\n    display: block;\n    transform: translateZ(0) translate3d(0, 0, 0);\n    transform-style: preserve-3d;\n    perspective: 1000;\n    -webkit-backface-visibility: hidden;\n    backface-visibility: hidden;\n    box-sizing: border-box\n}\n\n.mb_YTPlayer .loading {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    font-size: 12px;\n    color: #fff;\n    background: rgba(0, 0, 0, .51);\n    text-align: center;\n    padding: 2px 4px;\n    border-radius: 5px;\n    font-family: Droid Sans, sans-serif;\n    -webkit-animation: fade .1s infinite alternate;\n    animation: fade .1s infinite alternate\n}\n\n@-webkit-keyframes fade {\n    0% {\n        opacity: .5\n    }\n    100% {\n        opacity: 1\n    }\n}\n\n@keyframes fade {\n    0% {\n        opacity: .5\n    }\n    100% {\n        opacity: 1\n    }\n}\n\n.fullscreen {\n    display: block !important;\n    position: fixed !important;\n    width: 100% !important;\n    height: 100% !important;\n    top: 0 !important;\n    left: 0 !important;\n    margin: 0 !important;\n    border: none !important;\n    opacity: 1 !important\n}\n\n.mbYTP_wrapper iframe {\n    max-width: 4000px !important\n}\n\n.inline_YTPlayer {\n    margin-bottom: 20px;\n    vertical-align: top;\n    position: relative;\n    left: 0;\n    overflow: hidden;\n    border-radius: 4px;\n    box-shadow: 0 0 5px rgba(0, 0, 0, .7);\n    background: rgba(0, 0, 0, .5)\n}\n\n.inline_YTPlayer img {\n    border: none !important;\n    margin: 0 !important;\n    padding: 0 !important;\n    transform: none !important\n}\n\n.mb_YTPBar, .mb_YTPBar .buttonBar {\n    box-sizing: border-box;\n    left: 0;\n    padding: 5px;\n    width: 100%\n}\n\n.mb_YTPBar .ytpicon {\n    font-size: 20px;\n    font-family: ytpregular\n}\n\n.mb_YTPBar .mb_YTPUrl.ytpicon {\n    font-size: 30px\n}\n\n.mb_YTPBar {\n    transition: opacity .5s;\n    display: block;\n    height: 10px;\n    background: #333;\n    position: fixed;\n    bottom: 0;\n    text-align: left;\n    z-index: 1000;\n    font: 14px/16px sans-serif;\n    opacity: .1\n}\n\n.mb_YTPBar.visible, .mb_YTPBar:hover {\n    opacity: 1\n}\n\n.mb_YTPBar .buttonBar {\n    transition: all .5s;\n    background: 0 0;\n    font: 12px/14px Calibri;\n    position: absolute;\n    top: -30px\n}\n\n.mb_YTPBar:hover .buttonBar {\n    background: rgba(0, 0, 0, .4)\n}\n\n.mb_YTPBar span {\n    display: inline-block;\n    font: 16px/20px Calibri, sans-serif;\n    position: relative;\n    width: 30px;\n    height: 25px;\n    vertical-align: middle\n}\n\n.mb_YTPBar span.mb_YTPTime {\n    width: 130px\n}\n\n.mb_YTPBar span.mb_OnlyYT, .mb_YTPBar span.mb_YTPUrl {\n    position: absolute;\n    width: auto;\n    display: block;\n    top: 6px;\n    right: 10px;\n    cursor: pointer\n}\n\n.mb_YTPBar span.mb_YTPUrl img {\n    width: 60px\n}\n\n.mb_YTPBar span.mb_OnlyYT {\n    left: 300px;\n    right: auto\n}\n\n.mb_YTPBar span.mb_OnlyYT img {\n    width: 25px\n}\n\n.mb_YTPBar .mb_YTPMuteUnmute, .mb_YTPBar .mb_YTPPlaypause, .mb_YTPlayer .mb_YTPBar .mb_YTPPlaypause img {\n    cursor: pointer\n}\n\n.mb_YTPBar .mb_YTPProgress {\n    height: 10px;\n    width: 100%;\n    background: #222;\n    bottom: 0;\n    left: 0\n}\n\n.mb_YTPBar .mb_YTPLoaded {\n    height: 10px;\n    width: 0;\n    background: #444;\n    left: 0\n}\n\n.mb_YTPBar .mb_YTPseekbar {\n    height: 10px;\n    width: 0;\n    background: #000;\n    bottom: 0;\n    left: 0;\n    box-shadow: rgba(82, 82, 82, .47) 1px 1px 3px\n}\n\n.mb_YTPBar .YTPOverlay {\n    backface-visibility: hidden;\n    -webkit-backface-visibility: hidden;\n    -webkit-transform-style: \"flat\";\n    box-sizing: border-box\n}\n\n.YTPOverlay.raster {\n    background: url(images/raster.png)\n}\n\n.YTPOverlay.raster.retina {\n    background: url(images/raster@2x.png)\n}\n\n.YTPOverlay.raster-dot {\n    background: url(images/raster_dot.png)\n}\n\n.YTPOverlay.raster-dot.retina {\n    background: url(images/raster_dot@2x.png)\n}\n\n.mb_YTPBar .simpleSlider {\n    position: relative;\n    width: 100px;\n    height: 10px;\n    border: 1px solid #fff;\n    overflow: hidden;\n    box-sizing: border-box;\n    margin-right: 10px;\n    cursor: pointer !important;\n    border-radius: 3px\n}\n\n.mb_YTPBar.compact .simpleSlider {\n    width: 40px\n}\n\n.mb_YTPBar .simpleSlider.muted {\n    opacity: .3\n}\n\n.mb_YTPBar .level {\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    background-color: #fff;\n    box-sizing: border-box\n}\n\n.mb_YTPBar .level.horizontal {\n    height: 100%;\n    width: 0\n}\n\n.mb_YTPBar .level.vertical {\n    height: auto;\n    width: 100%\n}\n\n/**\n * kenburnsy - Easy to use JQuery plugin to make slideshows with Ken Burns effect\n * @version v0.0.5\n * @link https://github.com/ZeroOneStudio/kenburnsy\n * @license MIT\n * --------------------------------------------------\n */\n\n.kenburnsy {\n    position: relative;\n    overflow: hidden;\n    width: 100%\n}\n\n.kenburnsy.fullscreen {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: -1\n}\n\n.kenburnsy img {\n    display: none\n}\n\n.kenburnsy .slide {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background-position: center center;\n    -webkit-background-size: cover;\n    background-size: cover;\n    background-repeat: no-repeat;\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n    -webkit-transform-origin: center;\n    -ms-transform-origin: center;\n    transform-origin: center\n}\n\n.ss {\n    position: relative;\n    overflow: hidden;\n    width: 100%\n}\n\n.ss.fullscreen {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: -1\n}\n\n.ss img {\n    display: none\n}\n\n.ss .slide {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background-position: center center;\n    -webkit-background-size: cover;\n    background-size: cover;\n    background-repeat: no-repeat;\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n    -webkit-transform-origin: center;\n    -ms-transform-origin: center;\n    transform-origin: center\n}\n\n/*!\n * Animate.css - http://daneden.me/animate\n * Licensed under the MIT license - http://opensource.org/licenses/MIT\n * Copyright (c) 2015 Daniel Eden\n * --------------------------------------------------\n */\n\n.animated {\n    -webkit-animation-duration: 1s;\n    animation-duration: 1s;\n    -webkit-animation-fill-mode: both;\n    animation-fill-mode: both\n}\n\n.animated.infinite {\n    -webkit-animation-iteration-count: infinite;\n    animation-iteration-count: infinite\n}\n\n.animated.hinge {\n    -webkit-animation-duration: 2s;\n    animation-duration: 2s\n}\n\n.animated.bounceIn, .animated.bounceOut {\n    -webkit-animation-duration: .75s;\n    animation-duration: .75s\n}\n\n.animated.flipOutX, .animated.flipOutY {\n    -webkit-animation-duration: .75s;\n    animation-duration: .75s\n}\n\n@-webkit-keyframes bounce {\n    from, 20%, 53%, 80%, 100% {\n        -webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1.000);\n        animation-timing-function: cubic-bezier(.215, .61, .355, 1.000);\n        -webkit-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0)\n    }\n    40%, 43% {\n        -webkit-animation-timing-function: cubic-bezier(.755, .05, .855, .06);\n        animation-timing-function: cubic-bezier(.755, .05, .855, .06);\n        -webkit-transform: translate3d(0, -30px, 0);\n        transform: translate3d(0, -30px, 0)\n    }\n    70% {\n        -webkit-animation-timing-function: cubic-bezier(.755, .05, .855, .06);\n        animation-timing-function: cubic-bezier(.755, .05, .855, .06);\n        -webkit-transform: translate3d(0, -15px, 0);\n        transform: translate3d(0, -15px, 0)\n    }\n    90% {\n        -webkit-transform: translate3d(0, -4px, 0);\n        transform: translate3d(0, -4px, 0)\n    }\n}\n\n@keyframes bounce {\n    from, 20%, 53%, 80%, 100% {\n        -webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1.000);\n        animation-timing-function: cubic-bezier(.215, .61, .355, 1.000);\n        -webkit-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0)\n    }\n    40%, 43% {\n        -webkit-animation-timing-function: cubic-bezier(.755, .05, .855, .06);\n        animation-timing-function: cubic-bezier(.755, .05, .855, .06);\n        -webkit-transform: translate3d(0, -30px, 0);\n        transform: translate3d(0, -30px, 0)\n    }\n    70% {\n        -webkit-animation-timing-function: cubic-bezier(.755, .05, .855, .06);\n        animation-timing-function: cubic-bezier(.755, .05, .855, .06);\n        -webkit-transform: translate3d(0, -15px, 0);\n        transform: translate3d(0, -15px, 0)\n    }\n    90% {\n        -webkit-transform: translate3d(0, -4px, 0);\n        transform: translate3d(0, -4px, 0)\n    }\n}\n\n.bounce {\n    -webkit-animation-name: bounce;\n    animation-name: bounce;\n    -webkit-transform-origin: center bottom;\n    transform-origin: center bottom\n}\n\n@-webkit-keyframes flash {\n    from, 50%, 100% {\n        opacity: 1\n    }\n    25%, 75% {\n        opacity: 0\n    }\n}\n\n@keyframes flash {\n    from, 50%, 100% {\n        opacity: 1\n    }\n    25%, 75% {\n        opacity: 0\n    }\n}\n\n.flash {\n    -webkit-animation-name: flash;\n    animation-name: flash\n}\n\n@-webkit-keyframes pulse {\n    from {\n        -webkit-transform: scale3d(1, 1, 1);\n        transform: scale3d(1, 1, 1)\n    }\n    50% {\n        -webkit-transform: scale3d(1.05, 1.05, 1.05);\n        transform: scale3d(1.05, 1.05, 1.05)\n    }\n    100% {\n        -webkit-transform: scale3d(1, 1, 1);\n        transform: scale3d(1, 1, 1)\n    }\n}\n\n@keyframes pulse {\n    from {\n        -webkit-transform: scale3d(1, 1, 1);\n        transform: scale3d(1, 1, 1)\n    }\n    50% {\n        -webkit-transform: scale3d(1.05, 1.05, 1.05);\n        transform: scale3d(1.05, 1.05, 1.05)\n    }\n    100% {\n        -webkit-transform: scale3d(1, 1, 1);\n        transform: scale3d(1, 1, 1)\n    }\n}\n\n.pulse {\n    -webkit-animation-name: pulse;\n    animation-name: pulse\n}\n\n@-webkit-keyframes rubberBand {\n    from {\n        -webkit-transform: scale3d(1, 1, 1);\n        transform: scale3d(1, 1, 1)\n    }\n    30% {\n        -webkit-transform: scale3d(1.25, .75, 1);\n        transform: scale3d(1.25, .75, 1)\n    }\n    40% {\n        -webkit-transform: scale3d(.75, 1.25, 1);\n        transform: scale3d(.75, 1.25, 1)\n    }\n    50% {\n        -webkit-transform: scale3d(1.15, .85, 1);\n        transform: scale3d(1.15, .85, 1)\n    }\n    65% {\n        -webkit-transform: scale3d(.95, 1.05, 1);\n        transform: scale3d(.95, 1.05, 1)\n    }\n    75% {\n        -webkit-transform: scale3d(1.05, .95, 1);\n        transform: scale3d(1.05, .95, 1)\n    }\n    100% {\n        -webkit-transform: scale3d(1, 1, 1);\n        transform: scale3d(1, 1, 1)\n    }\n}\n\n@keyframes rubberBand {\n    from {\n        -webkit-transform: scale3d(1, 1, 1);\n        transform: scale3d(1, 1, 1)\n    }\n    30% {\n        -webkit-transform: scale3d(1.25, .75, 1);\n        transform: scale3d(1.25, .75, 1)\n    }\n    40% {\n        -webkit-transform: scale3d(.75, 1.25, 1);\n        transform: scale3d(.75, 1.25, 1)\n    }\n    50% {\n        -webkit-transform: scale3d(1.15, .85, 1);\n        transform: scale3d(1.15, .85, 1)\n    }\n    65% {\n        -webkit-transform: scale3d(.95, 1.05, 1);\n        transform: scale3d(.95, 1.05, 1)\n    }\n    75% {\n        -webkit-transform: scale3d(1.05, .95, 1);\n        transform: scale3d(1.05, .95, 1)\n    }\n    100% {\n        -webkit-transform: scale3d(1, 1, 1);\n        transform: scale3d(1, 1, 1)\n    }\n}\n\n.rubberBand {\n    -webkit-animation-name: rubberBand;\n    animation-name: rubberBand\n}\n\n@-webkit-keyframes shake {\n    from, 100% {\n        -webkit-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0)\n    }\n    10%, 30%, 50%, 70%, 90% {\n        -webkit-transform: translate3d(-10px, 0, 0);\n        transform: translate3d(-10px, 0, 0)\n    }\n    20%, 40%, 60%, 80% {\n        -webkit-transform: translate3d(10px, 0, 0);\n        transform: translate3d(10px, 0, 0)\n    }\n}\n\n@keyframes shake {\n    from, 100% {\n        -webkit-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0)\n    }\n    10%, 30%, 50%, 70%, 90% {\n        -webkit-transform: translate3d(-10px, 0, 0);\n        transform: translate3d(-10px, 0, 0)\n    }\n    20%, 40%, 60%, 80% {\n        -webkit-transform: translate3d(10px, 0, 0);\n        transform: translate3d(10px, 0, 0)\n    }\n}\n\n.shake {\n    -webkit-animation-name: shake;\n    animation-name: shake\n}\n\n@-webkit-keyframes swing {\n    20% {\n        -webkit-transform: rotate3d(0, 0, 1, 15deg);\n        transform: rotate3d(0, 0, 1, 15deg)\n    }\n    40% {\n        -webkit-transform: rotate3d(0, 0, 1, -10deg);\n        transform: rotate3d(0, 0, 1, -10deg)\n    }\n    60% {\n        -webkit-transform: rotate3d(0, 0, 1, 5deg);\n        transform: rotate3d(0, 0, 1, 5deg)\n    }\n    80% {\n        -webkit-transform: rotate3d(0, 0, 1, -5deg);\n        transform: rotate3d(0, 0, 1, -5deg)\n    }\n    100% {\n        -webkit-transform: rotate3d(0, 0, 1, 0deg);\n        transform: rotate3d(0, 0, 1, 0deg)\n    }\n}\n\n@keyframes swing {\n    20% {\n        -webkit-transform: rotate3d(0, 0, 1, 15deg);\n        transform: rotate3d(0, 0, 1, 15deg)\n    }\n    40% {\n        -webkit-transform: rotate3d(0, 0, 1, -10deg);\n        transform: rotate3d(0, 0, 1, -10deg)\n    }\n    60% {\n        -webkit-transform: rotate3d(0, 0, 1, 5deg);\n        transform: rotate3d(0, 0, 1, 5deg)\n    }\n    80% {\n        -webkit-transform: rotate3d(0, 0, 1, -5deg);\n        transform: rotate3d(0, 0, 1, -5deg)\n    }\n    100% {\n        -webkit-transform: rotate3d(0, 0, 1, 0deg);\n        transform: rotate3d(0, 0, 1, 0deg)\n    }\n}\n\n.swing {\n    -webkit-transform-origin: top center;\n    transform-origin: top center;\n    -webkit-animation-name: swing;\n    animation-name: swing\n}\n\n@-webkit-keyframes tada {\n    from {\n        -webkit-transform: scale3d(1, 1, 1);\n        transform: scale3d(1, 1, 1)\n    }\n    10%, 20% {\n        -webkit-transform: scale3d(.9, .9, .9) rotate3d(0, 0, 1, -3deg);\n        transform: scale3d(.9, .9, .9) rotate3d(0, 0, 1, -3deg)\n    }\n    30%, 50%, 70%, 90% {\n        -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);\n        transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg)\n    }\n    40%, 60%, 80% {\n        -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);\n        transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg)\n    }\n    100% {\n        -webkit-transform: scale3d(1, 1, 1);\n        transform: scale3d(1, 1, 1)\n    }\n}\n\n@keyframes tada {\n    from {\n        -webkit-transform: scale3d(1, 1, 1);\n        transform: scale3d(1, 1, 1)\n    }\n    10%, 20% {\n        -webkit-transform: scale3d(.9, .9, .9) rotate3d(0, 0, 1, -3deg);\n        transform: scale3d(.9, .9, .9) rotate3d(0, 0, 1, -3deg)\n    }\n    30%, 50%, 70%, 90% {\n        -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);\n        transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg)\n    }\n    40%, 60%, 80% {\n        -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);\n        transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg)\n    }\n    100% {\n        -webkit-transform: scale3d(1, 1, 1);\n        transform: scale3d(1, 1, 1)\n    }\n}\n\n.tada {\n    -webkit-animation-name: tada;\n    animation-name: tada\n}\n\n@-webkit-keyframes wobble {\n    from {\n        -webkit-transform: none;\n        transform: none\n    }\n    15% {\n        -webkit-transform: translate3d(-25%, 0, 0) rotate3d(0, 0, 1, -5deg);\n        transform: translate3d(-25%, 0, 0) rotate3d(0, 0, 1, -5deg)\n    }\n    30% {\n        -webkit-transform: translate3d(20%, 0, 0) rotate3d(0, 0, 1, 3deg);\n        transform: translate3d(20%, 0, 0) rotate3d(0, 0, 1, 3deg)\n    }\n    45% {\n        -webkit-transform: translate3d(-15%, 0, 0) rotate3d(0, 0, 1, -3deg);\n        transform: translate3d(-15%, 0, 0) rotate3d(0, 0, 1, -3deg)\n    }\n    60% {\n        -webkit-transform: translate3d(10%, 0, 0) rotate3d(0, 0, 1, 2deg);\n        transform: translate3d(10%, 0, 0) rotate3d(0, 0, 1, 2deg)\n    }\n    75% {\n        -webkit-transform: translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -1deg);\n        transform: translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -1deg)\n    }\n    100% {\n        -webkit-transform: none;\n        transform: none\n    }\n}\n\n@keyframes wobble {\n    from {\n        -webkit-transform: none;\n        transform: none\n    }\n    15% {\n        -webkit-transform: translate3d(-25%, 0, 0) rotate3d(0, 0, 1, -5deg);\n        transform: translate3d(-25%, 0, 0) rotate3d(0, 0, 1, -5deg)\n    }\n    30% {\n        -webkit-transform: translate3d(20%, 0, 0) rotate3d(0, 0, 1, 3deg);\n        transform: translate3d(20%, 0, 0) rotate3d(0, 0, 1, 3deg)\n    }\n    45% {\n        -webkit-transform: translate3d(-15%, 0, 0) rotate3d(0, 0, 1, -3deg);\n        transform: translate3d(-15%, 0, 0) rotate3d(0, 0, 1, -3deg)\n    }\n    60% {\n        -webkit-transform: translate3d(10%, 0, 0) rotate3d(0, 0, 1, 2deg);\n        transform: translate3d(10%, 0, 0) rotate3d(0, 0, 1, 2deg)\n    }\n    75% {\n        -webkit-transform: translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -1deg);\n        transform: translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -1deg)\n    }\n    100% {\n        -webkit-transform: none;\n        transform: none\n    }\n}\n\n.wobble {\n    -webkit-animation-name: wobble;\n    animation-name: wobble\n}\n\n@-webkit-keyframes jello {\n    from, 11.1%, 100% {\n        -webkit-transform: none;\n        transform: none\n    }\n    22.2% {\n        -webkit-transform: skewX(-12.5deg) skewY(-12.5deg);\n        transform: skewX(-12.5deg) skewY(-12.5deg)\n    }\n    33.3% {\n        -webkit-transform: skewX(6.25deg) skewY(6.25deg);\n        transform: skewX(6.25deg) skewY(6.25deg)\n    }\n    44.4% {\n        -webkit-transform: skewX(-3.125deg) skewY(-3.125deg);\n        transform: skewX(-3.125deg) skewY(-3.125deg)\n    }\n    55.5% {\n        -webkit-transform: skewX(1.5625deg) skewY(1.5625deg);\n        transform: skewX(1.5625deg) skewY(1.5625deg)\n    }\n    66.6% {\n        -webkit-transform: skewX(-.78125deg) skewY(-.78125deg);\n        transform: skewX(-.78125deg) skewY(-.78125deg)\n    }\n    77.7% {\n        -webkit-transform: skewX(.390625deg) skewY(.390625deg);\n        transform: skewX(.390625deg) skewY(.390625deg)\n    }\n    88.8% {\n        -webkit-transform: skewX(-.1953125deg) skewY(-.1953125deg);\n        transform: skewX(-.1953125deg) skewY(-.1953125deg)\n    }\n}\n\n@keyframes jello {\n    from, 11.1%, 100% {\n        -webkit-transform: none;\n        transform: none\n    }\n    22.2% {\n        -webkit-transform: skewX(-12.5deg) skewY(-12.5deg);\n        transform: skewX(-12.5deg) skewY(-12.5deg)\n    }\n    33.3% {\n        -webkit-transform: skewX(6.25deg) skewY(6.25deg);\n        transform: skewX(6.25deg) skewY(6.25deg)\n    }\n    44.4% {\n        -webkit-transform: skewX(-3.125deg) skewY(-3.125deg);\n        transform: skewX(-3.125deg) skewY(-3.125deg)\n    }\n    55.5% {\n        -webkit-transform: skewX(1.5625deg) skewY(1.5625deg);\n        transform: skewX(1.5625deg) skewY(1.5625deg)\n    }\n    66.6% {\n        -webkit-transform: skewX(-.78125deg) skewY(-.78125deg);\n        transform: skewX(-.78125deg) skewY(-.78125deg)\n    }\n    77.7% {\n        -webkit-transform: skewX(.390625deg) skewY(.390625deg);\n        transform: skewX(.390625deg) skewY(.390625deg)\n    }\n    88.8% {\n        -webkit-transform: skewX(-.1953125deg) skewY(-.1953125deg);\n        transform: skewX(-.1953125deg) skewY(-.1953125deg)\n    }\n}\n\n.jello {\n    -webkit-animation-name: jello;\n    animation-name: jello;\n    -webkit-transform-origin: center;\n    transform-origin: center\n}\n\n@-webkit-keyframes bounceIn {\n    from, 20%, 40%, 60%, 80%, 100% {\n        -webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1.000);\n        animation-timing-function: cubic-bezier(.215, .61, .355, 1.000)\n    }\n    0% {\n        opacity: 0;\n        -webkit-transform: scale3d(.3, .3, .3);\n        transform: scale3d(.3, .3, .3)\n    }\n    20% {\n        -webkit-transform: scale3d(1.1, 1.1, 1.1);\n        transform: scale3d(1.1, 1.1, 1.1)\n    }\n    40% {\n        -webkit-transform: scale3d(.9, .9, .9);\n        transform: scale3d(.9, .9, .9)\n    }\n    60% {\n        opacity: 1;\n        -webkit-transform: scale3d(1.03, 1.03, 1.03);\n        transform: scale3d(1.03, 1.03, 1.03)\n    }\n    80% {\n        -webkit-transform: scale3d(.97, .97, .97);\n        transform: scale3d(.97, .97, .97)\n    }\n    100% {\n        opacity: 1;\n        -webkit-transform: scale3d(1, 1, 1);\n        transform: scale3d(1, 1, 1)\n    }\n}\n\n@keyframes bounceIn {\n    from, 20%, 40%, 60%, 80%, 100% {\n        -webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1.000);\n        animation-timing-function: cubic-bezier(.215, .61, .355, 1.000)\n    }\n    0% {\n        opacity: 0;\n        -webkit-transform: scale3d(.3, .3, .3);\n        transform: scale3d(.3, .3, .3)\n    }\n    20% {\n        -webkit-transform: scale3d(1.1, 1.1, 1.1);\n        transform: scale3d(1.1, 1.1, 1.1)\n    }\n    40% {\n        -webkit-transform: scale3d(.9, .9, .9);\n        transform: scale3d(.9, .9, .9)\n    }\n    60% {\n        opacity: 1;\n        -webkit-transform: scale3d(1.03, 1.03, 1.03);\n        transform: scale3d(1.03, 1.03, 1.03)\n    }\n    80% {\n        -webkit-transform: scale3d(.97, .97, .97);\n        transform: scale3d(.97, .97, .97)\n    }\n    100% {\n        opacity: 1;\n        -webkit-transform: scale3d(1, 1, 1);\n        transform: scale3d(1, 1, 1)\n    }\n}\n\n.bounceIn {\n    -webkit-animation-name: bounceIn;\n    animation-name: bounceIn\n}\n\n@-webkit-keyframes bounceInDown {\n    from, 60%, 75%, 90%, 100% {\n        -webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1.000);\n        animation-timing-function: cubic-bezier(.215, .61, .355, 1.000)\n    }\n    0% {\n        opacity: 0;\n        -webkit-transform: translate3d(0, -3000px, 0);\n        transform: translate3d(0, -3000px, 0)\n    }\n    60% {\n        opacity: 1;\n        -webkit-transform: translate3d(0, 25px, 0);\n        transform: translate3d(0, 25px, 0)\n    }\n    75% {\n        -webkit-transform: translate3d(0, -10px, 0);\n        transform: translate3d(0, -10px, 0)\n    }\n    90% {\n        -webkit-transform: translate3d(0, 5px, 0);\n        transform: translate3d(0, 5px, 0)\n    }\n    100% {\n        -webkit-transform: none;\n        transform: none\n    }\n}\n\n@keyframes bounceInDown {\n    from, 60%, 75%, 90%, 100% {\n        -webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1.000);\n        animation-timing-function: cubic-bezier(.215, .61, .355, 1.000)\n    }\n    0% {\n        opacity: 0;\n        -webkit-transform: translate3d(0, -3000px, 0);\n        transform: translate3d(0, -3000px, 0)\n    }\n    60% {\n        opacity: 1;\n        -webkit-transform: translate3d(0, 25px, 0);\n        transform: translate3d(0, 25px, 0)\n    }\n    75% {\n        -webkit-transform: translate3d(0, -10px, 0);\n        transform: translate3d(0, -10px, 0)\n    }\n    90% {\n        -webkit-transform: translate3d(0, 5px, 0);\n        transform: translate3d(0, 5px, 0)\n    }\n    100% {\n        -webkit-transform: none;\n        transform: none\n    }\n}\n\n.bounceInDown {\n    -webkit-animation-name: bounceInDown;\n    animation-name: bounceInDown\n}\n\n@-webkit-keyframes bounceInLeft {\n    from, 60%, 75%, 90%, 100% {\n        -webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1.000);\n        animation-timing-function: cubic-bezier(.215, .61, .355, 1.000)\n    }\n    0% {\n        opacity: 0;\n        -webkit-transform: translate3d(-3000px, 0, 0);\n        transform: translate3d(-3000px, 0, 0)\n    }\n    60% {\n        opacity: 1;\n        -webkit-transform: translate3d(25px, 0, 0);\n        transform: translate3d(25px, 0, 0)\n    }\n    75% {\n        -webkit-transform: translate3d(-10px, 0, 0);\n        transform: translate3d(-10px, 0, 0)\n    }\n    90% {\n        -webkit-transform: translate3d(5px, 0, 0);\n        transform: translate3d(5px, 0, 0)\n    }\n    100% {\n        -webkit-transform: none;\n        transform: none\n    }\n}\n\n@keyframes bounceInLeft {\n    from, 60%, 75%, 90%, 100% {\n        -webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1.000);\n        animation-timing-function: cubic-bezier(.215, .61, .355, 1.000)\n    }\n    0% {\n        opacity: 0;\n        -webkit-transform: translate3d(-3000px, 0, 0);\n        transform: translate3d(-3000px, 0, 0)\n    }\n    60% {\n        opacity: 1;\n        -webkit-transform: translate3d(25px, 0, 0);\n        transform: translate3d(25px, 0, 0)\n    }\n    75% {\n        -webkit-transform: translate3d(-10px, 0, 0);\n        transform: translate3d(-10px, 0, 0)\n    }\n    90% {\n        -webkit-transform: translate3d(5px, 0, 0);\n        transform: translate3d(5px, 0, 0)\n    }\n    100% {\n        -webkit-transform: none;\n        transform: none\n    }\n}\n\n.bounceInLeft {\n    -webkit-animation-name: bounceInLeft;\n    animation-name: bounceInLeft\n}\n\n@-webkit-keyframes bounceInRight {\n    from, 60%, 75%, 90%, 100% {\n        -webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1.000);\n        animation-timing-function: cubic-bezier(.215, .61, .355, 1.000)\n    }\n    from {\n        opacity: 0;\n        -webkit-transform: translate3d(3000px, 0, 0);\n        transform: translate3d(3000px, 0, 0)\n    }\n    60% {\n        opacity: 1;\n        -webkit-transform: translate3d(-25px, 0, 0);\n        transform: translate3d(-25px, 0, 0)\n    }\n    75% {\n        -webkit-transform: translate3d(10px, 0, 0);\n        transform: translate3d(10px, 0, 0)\n    }\n    90% {\n        -webkit-transform: translate3d(-5px, 0, 0);\n        transform: translate3d(-5px, 0, 0)\n    }\n    100% {\n        -webkit-transform: none;\n        transform: none\n    }\n}\n\n@keyframes bounceInRight {\n    from, 60%, 75%, 90%, 100% {\n        -webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1.000);\n        animation-timing-function: cubic-bezier(.215, .61, .355, 1.000)\n    }\n    from {\n        opacity: 0;\n        -webkit-transform: translate3d(3000px, 0, 0);\n        transform: translate3d(3000px, 0, 0)\n    }\n    60% {\n        opacity: 1;\n        -webkit-transform: translate3d(-25px, 0, 0);\n        transform: translate3d(-25px, 0, 0)\n    }\n    75% {\n        -webkit-transform: translate3d(10px, 0, 0);\n        transform: translate3d(10px, 0, 0)\n    }\n    90% {\n        -webkit-transform: translate3d(-5px, 0, 0);\n        transform: translate3d(-5px, 0, 0)\n    }\n    100% {\n        -webkit-transform: none;\n        transform: none\n    }\n}\n\n.bounceInRight {\n    -webkit-animation-name: bounceInRight;\n    animation-name: bounceInRight\n}\n\n@-webkit-keyframes bounceInUp {\n    from, 60%, 75%, 90%, 100% {\n        -webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1.000);\n        animation-timing-function: cubic-bezier(.215, .61, .355, 1.000)\n    }\n    from {\n        opacity: 0;\n        -webkit-transform: translate3d(0, 3000px, 0);\n        transform: translate3d(0, 3000px, 0)\n    }\n    60% {\n        opacity: 1;\n        -webkit-transform: translate3d(0, -20px, 0);\n        transform: translate3d(0, -20px, 0)\n    }\n    75% {\n        -webkit-transform: translate3d(0, 10px, 0);\n        transform: translate3d(0, 10px, 0)\n    }\n    90% {\n        -webkit-transform: translate3d(0, -5px, 0);\n        transform: translate3d(0, -5px, 0)\n    }\n    100% {\n        -webkit-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0)\n    }\n}\n\n@keyframes bounceInUp {\n    from, 60%, 75%, 90%, 100% {\n        -webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1.000);\n        animation-timing-function: cubic-bezier(.215, .61, .355, 1.000)\n    }\n    from {\n        opacity: 0;\n        -webkit-transform: translate3d(0, 3000px, 0);\n        transform: translate3d(0, 3000px, 0)\n    }\n    60% {\n        opacity: 1;\n        -webkit-transform: translate3d(0, -20px, 0);\n        transform: translate3d(0, -20px, 0)\n    }\n    75% {\n        -webkit-transform: translate3d(0, 10px, 0);\n        transform: translate3d(0, 10px, 0)\n    }\n    90% {\n        -webkit-transform: translate3d(0, -5px, 0);\n        transform: translate3d(0, -5px, 0)\n    }\n    100% {\n        -webkit-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0)\n    }\n}\n\n.bounceInUp {\n    -webkit-animation-name: bounceInUp;\n    animation-name: bounceInUp\n}\n\n@-webkit-keyframes bounceOut {\n    20% {\n        -webkit-transform: scale3d(.9, .9, .9);\n        transform: scale3d(.9, .9, .9)\n    }\n    50%, 55% {\n        opacity: 1;\n        -webkit-transform: scale3d(1.1, 1.1, 1.1);\n        transform: scale3d(1.1, 1.1, 1.1)\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: scale3d(.3, .3, .3);\n        transform: scale3d(.3, .3, .3)\n    }\n}\n\n@keyframes bounceOut {\n    20% {\n        -webkit-transform: scale3d(.9, .9, .9);\n        transform: scale3d(.9, .9, .9)\n    }\n    50%, 55% {\n        opacity: 1;\n        -webkit-transform: scale3d(1.1, 1.1, 1.1);\n        transform: scale3d(1.1, 1.1, 1.1)\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: scale3d(.3, .3, .3);\n        transform: scale3d(.3, .3, .3)\n    }\n}\n\n.bounceOut {\n    -webkit-animation-name: bounceOut;\n    animation-name: bounceOut\n}\n\n@-webkit-keyframes bounceOutDown {\n    20% {\n        -webkit-transform: translate3d(0, 10px, 0);\n        transform: translate3d(0, 10px, 0)\n    }\n    40%, 45% {\n        opacity: 1;\n        -webkit-transform: translate3d(0, -20px, 0);\n        transform: translate3d(0, -20px, 0)\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translate3d(0, 2000px, 0);\n        transform: translate3d(0, 2000px, 0)\n    }\n}\n\n@keyframes bounceOutDown {\n    20% {\n        -webkit-transform: translate3d(0, 10px, 0);\n        transform: translate3d(0, 10px, 0)\n    }\n    40%, 45% {\n        opacity: 1;\n        -webkit-transform: translate3d(0, -20px, 0);\n        transform: translate3d(0, -20px, 0)\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translate3d(0, 2000px, 0);\n        transform: translate3d(0, 2000px, 0)\n    }\n}\n\n.bounceOutDown {\n    -webkit-animation-name: bounceOutDown;\n    animation-name: bounceOutDown\n}\n\n@-webkit-keyframes bounceOutLeft {\n    20% {\n        opacity: 1;\n        -webkit-transform: translate3d(20px, 0, 0);\n        transform: translate3d(20px, 0, 0)\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translate3d(-2000px, 0, 0);\n        transform: translate3d(-2000px, 0, 0)\n    }\n}\n\n@keyframes bounceOutLeft {\n    20% {\n        opacity: 1;\n        -webkit-transform: translate3d(20px, 0, 0);\n        transform: translate3d(20px, 0, 0)\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translate3d(-2000px, 0, 0);\n        transform: translate3d(-2000px, 0, 0)\n    }\n}\n\n.bounceOutLeft {\n    -webkit-animation-name: bounceOutLeft;\n    animation-name: bounceOutLeft\n}\n\n@-webkit-keyframes bounceOutRight {\n    20% {\n        opacity: 1;\n        -webkit-transform: translate3d(-20px, 0, 0);\n        transform: translate3d(-20px, 0, 0)\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translate3d(2000px, 0, 0);\n        transform: translate3d(2000px, 0, 0)\n    }\n}\n\n@keyframes bounceOutRight {\n    20% {\n        opacity: 1;\n        -webkit-transform: translate3d(-20px, 0, 0);\n        transform: translate3d(-20px, 0, 0)\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translate3d(2000px, 0, 0);\n        transform: translate3d(2000px, 0, 0)\n    }\n}\n\n.bounceOutRight {\n    -webkit-animation-name: bounceOutRight;\n    animation-name: bounceOutRight\n}\n\n@-webkit-keyframes bounceOutUp {\n    20% {\n        -webkit-transform: translate3d(0, -10px, 0);\n        transform: translate3d(0, -10px, 0)\n    }\n    40%, 45% {\n        opacity: 1;\n        -webkit-transform: translate3d(0, 20px, 0);\n        transform: translate3d(0, 20px, 0)\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translate3d(0, -2000px, 0);\n        transform: translate3d(0, -2000px, 0)\n    }\n}\n\n@keyframes bounceOutUp {\n    20% {\n        -webkit-transform: translate3d(0, -10px, 0);\n        transform: translate3d(0, -10px, 0)\n    }\n    40%, 45% {\n        opacity: 1;\n        -webkit-transform: translate3d(0, 20px, 0);\n        transform: translate3d(0, 20px, 0)\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translate3d(0, -2000px, 0);\n        transform: translate3d(0, -2000px, 0)\n    }\n}\n\n.bounceOutUp {\n    -webkit-animation-name: bounceOutUp;\n    animation-name: bounceOutUp\n}\n\n@-webkit-keyframes fadeIn {\n    from {\n        opacity: 0\n    }\n    100% {\n        opacity: 1\n    }\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0\n    }\n    100% {\n        opacity: 1\n    }\n}\n\n.fadeIn {\n    -webkit-animation-name: fadeIn;\n    animation-name: fadeIn\n}\n\n@-webkit-keyframes fadeInDown {\n    from {\n        opacity: 0;\n        -webkit-transform: translate3d(0, -100%, 0);\n        transform: translate3d(0, -100%, 0)\n    }\n    100% {\n        opacity: 1;\n        -webkit-transform: none;\n        transform: none\n    }\n}\n\n@keyframes fadeInDown {\n    from {\n        opacity: 0;\n        -webkit-transform: translate3d(0, -100%, 0);\n        transform: translate3d(0, -100%, 0)\n    }\n    100% {\n        opacity: 1;\n        -webkit-transform: none;\n        transform: none\n    }\n}\n\n.fadeInDown {\n    -webkit-animation-name: fadeInDown;\n    animation-name: fadeInDown\n}\n\n@-webkit-keyframes fadeInDownBig {\n    from {\n        opacity: 0;\n        -webkit-transform: translate3d(0, -2000px, 0);\n        transform: translate3d(0, -2000px, 0)\n    }\n    100% {\n        opacity: 1;\n        -webkit-transform: none;\n        transform: none\n    }\n}\n\n@keyframes fadeInDownBig {\n    from {\n        opacity: 0;\n        -webkit-transform: translate3d(0, -2000px, 0);\n        transform: translate3d(0, -2000px, 0)\n    }\n    100% {\n        opacity: 1;\n        -webkit-transform: none;\n        transform: none\n    }\n}\n\n.fadeInDownBig {\n    -webkit-animation-name: fadeInDownBig;\n    animation-name: fadeInDownBig\n}\n\n@-webkit-keyframes fadeInLeft {\n    from {\n        opacity: 0;\n        -webkit-transform: translate3d(-100%, 0, 0);\n        transform: translate3d(-100%, 0, 0)\n    }\n    100% {\n        opacity: 1;\n        -webkit-transform: none;\n        transform: none\n    }\n}\n\n@keyframes fadeInLeft {\n    from {\n        opacity: 0;\n        -webkit-transform: translate3d(-100%, 0, 0);\n        transform: translate3d(-100%, 0, 0)\n    }\n    100% {\n        opacity: 1;\n        -webkit-transform: none;\n        transform: none\n    }\n}\n\n.fadeInLeft {\n    -webkit-animation-name: fadeInLeft;\n    animation-name: fadeInLeft\n}\n\n@-webkit-keyframes fadeInLeftBig {\n    from {\n        opacity: 0;\n        -webkit-transform: translate3d(-2000px, 0, 0);\n        transform: translate3d(-2000px, 0, 0)\n    }\n    100% {\n        opacity: 1;\n        -webkit-transform: none;\n        transform: none\n    }\n}\n\n@keyframes fadeInLeftBig {\n    from {\n        opacity: 0;\n        -webkit-transform: translate3d(-2000px, 0, 0);\n        transform: translate3d(-2000px, 0, 0)\n    }\n    100% {\n        opacity: 1;\n        -webkit-transform: none;\n        transform: none\n    }\n}\n\n.fadeInLeftBig {\n    -webkit-animation-name: fadeInLeftBig;\n    animation-name: fadeInLeftBig\n}\n\n@-webkit-keyframes fadeInRight {\n    from {\n        opacity: 0;\n        -webkit-transform: translate3d(100%, 0, 0);\n        transform: translate3d(100%, 0, 0)\n    }\n    100% {\n        opacity: 1;\n        -webkit-transform: none;\n        transform: none\n    }\n}\n\n@keyframes fadeInRight {\n    from {\n        opacity: 0;\n        -webkit-transform: translate3d(100%, 0, 0);\n        transform: translate3d(100%, 0, 0)\n    }\n    100% {\n        opacity: 1;\n        -webkit-transform: none;\n        transform: none\n    }\n}\n\n.fadeInRight {\n    -webkit-animation-name: fadeInRight;\n    animation-name: fadeInRight\n}\n\n@-webkit-keyframes fadeInRightBig {\n    from {\n        opacity: 0;\n        -webkit-transform: translate3d(2000px, 0, 0);\n        transform: translate3d(2000px, 0, 0)\n    }\n    100% {\n        opacity: 1;\n        -webkit-transform: none;\n        transform: none\n    }\n}\n\n@keyframes fadeInRightBig {\n    from {\n        opacity: 0;\n        -webkit-transform: translate3d(2000px, 0, 0);\n        transform: translate3d(2000px, 0, 0)\n    }\n    100% {\n        opacity: 1;\n        -webkit-transform: none;\n        transform: none\n    }\n}\n\n.fadeInRightBig {\n    -webkit-animation-name: fadeInRightBig;\n    animation-name: fadeInRightBig\n}\n\n@-webkit-keyframes fadeInUp {\n    from {\n        opacity: 0;\n        -webkit-transform: translate3d(0, 100%, 0);\n        transform: translate3d(0, 100%, 0)\n    }\n    100% {\n        opacity: 1;\n        -webkit-transform: none;\n        transform: none\n    }\n}\n\n@keyframes fadeInUp {\n    from {\n        opacity: 0;\n        -webkit-transform: translate3d(0, 100%, 0);\n        transform: translate3d(0, 100%, 0)\n    }\n    100% {\n        opacity: 1;\n        -webkit-transform: none;\n        transform: none\n    }\n}\n\n.fadeInUp {\n    -webkit-animation-name: fadeInUp;\n    animation-name: fadeInUp\n}\n\n@-webkit-keyframes fadeInUpBig {\n    from {\n        opacity: 0;\n        -webkit-transform: translate3d(0, 2000px, 0);\n        transform: translate3d(0, 2000px, 0)\n    }\n    100% {\n        opacity: 1;\n        -webkit-transform: none;\n        transform: none\n    }\n}\n\n@keyframes fadeInUpBig {\n    from {\n        opacity: 0;\n        -webkit-transform: translate3d(0, 2000px, 0);\n        transform: translate3d(0, 2000px, 0)\n    }\n    100% {\n        opacity: 1;\n        -webkit-transform: none;\n        transform: none\n    }\n}\n\n.fadeInUpBig {\n    -webkit-animation-name: fadeInUpBig;\n    animation-name: fadeInUpBig\n}\n\n@-webkit-keyframes fadeOut {\n    from {\n        opacity: 1\n    }\n    100% {\n        opacity: 0\n    }\n}\n\n@keyframes fadeOut {\n    from {\n        opacity: 1\n    }\n    100% {\n        opacity: 0\n    }\n}\n\n.fadeOut {\n    -webkit-animation-name: fadeOut;\n    animation-name: fadeOut\n}\n\n@-webkit-keyframes fadeOutDown {\n    from {\n        opacity: 1\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translate3d(0, 100%, 0);\n        transform: translate3d(0, 100%, 0)\n    }\n}\n\n@keyframes fadeOutDown {\n    from {\n        opacity: 1\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translate3d(0, 100%, 0);\n        transform: translate3d(0, 100%, 0)\n    }\n}\n\n.fadeOutDown {\n    -webkit-animation-name: fadeOutDown;\n    animation-name: fadeOutDown\n}\n\n@-webkit-keyframes fadeOutDownBig {\n    from {\n        opacity: 1\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translate3d(0, 2000px, 0);\n        transform: translate3d(0, 2000px, 0)\n    }\n}\n\n@keyframes fadeOutDownBig {\n    from {\n        opacity: 1\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translate3d(0, 2000px, 0);\n        transform: translate3d(0, 2000px, 0)\n    }\n}\n\n.fadeOutDownBig {\n    -webkit-animation-name: fadeOutDownBig;\n    animation-name: fadeOutDownBig\n}\n\n@-webkit-keyframes fadeOutLeft {\n    from {\n        opacity: 1\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translate3d(-100%, 0, 0);\n        transform: translate3d(-100%, 0, 0)\n    }\n}\n\n@keyframes fadeOutLeft {\n    from {\n        opacity: 1\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translate3d(-100%, 0, 0);\n        transform: translate3d(-100%, 0, 0)\n    }\n}\n\n.fadeOutLeft {\n    -webkit-animation-name: fadeOutLeft;\n    animation-name: fadeOutLeft\n}\n\n@-webkit-keyframes fadeOutLeftBig {\n    from {\n        opacity: 1\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translate3d(-2000px, 0, 0);\n        transform: translate3d(-2000px, 0, 0)\n    }\n}\n\n@keyframes fadeOutLeftBig {\n    from {\n        opacity: 1\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translate3d(-2000px, 0, 0);\n        transform: translate3d(-2000px, 0, 0)\n    }\n}\n\n.fadeOutLeftBig {\n    -webkit-animation-name: fadeOutLeftBig;\n    animation-name: fadeOutLeftBig\n}\n\n@-webkit-keyframes fadeOutRight {\n    from {\n        opacity: 1\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translate3d(100%, 0, 0);\n        transform: translate3d(100%, 0, 0)\n    }\n}\n\n@keyframes fadeOutRight {\n    from {\n        opacity: 1\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translate3d(100%, 0, 0);\n        transform: translate3d(100%, 0, 0)\n    }\n}\n\n.fadeOutRight {\n    -webkit-animation-name: fadeOutRight;\n    animation-name: fadeOutRight\n}\n\n@-webkit-keyframes fadeOutRightBig {\n    from {\n        opacity: 1\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translate3d(2000px, 0, 0);\n        transform: translate3d(2000px, 0, 0)\n    }\n}\n\n@keyframes fadeOutRightBig {\n    from {\n        opacity: 1\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translate3d(2000px, 0, 0);\n        transform: translate3d(2000px, 0, 0)\n    }\n}\n\n.fadeOutRightBig {\n    -webkit-animation-name: fadeOutRightBig;\n    animation-name: fadeOutRightBig\n}\n\n@-webkit-keyframes fadeOutUp {\n    from {\n        opacity: 1\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translate3d(0, -100%, 0);\n        transform: translate3d(0, -100%, 0)\n    }\n}\n\n@keyframes fadeOutUp {\n    from {\n        opacity: 1\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translate3d(0, -100%, 0);\n        transform: translate3d(0, -100%, 0)\n    }\n}\n\n.fadeOutUp {\n    -webkit-animation-name: fadeOutUp;\n    animation-name: fadeOutUp\n}\n\n@-webkit-keyframes fadeOutUpBig {\n    from {\n        opacity: 1\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translate3d(0, -2000px, 0);\n        transform: translate3d(0, -2000px, 0)\n    }\n}\n\n@keyframes fadeOutUpBig {\n    from {\n        opacity: 1\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translate3d(0, -2000px, 0);\n        transform: translate3d(0, -2000px, 0)\n    }\n}\n\n.fadeOutUpBig {\n    -webkit-animation-name: fadeOutUpBig;\n    animation-name: fadeOutUpBig\n}\n\n@-webkit-keyframes flip {\n    from {\n        -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -360deg);\n        transform: perspective(400px) rotate3d(0, 1, 0, -360deg);\n        -webkit-animation-timing-function: ease-out;\n        animation-timing-function: ease-out\n    }\n    40% {\n        -webkit-transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -190deg);\n        transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -190deg);\n        -webkit-animation-timing-function: ease-out;\n        animation-timing-function: ease-out\n    }\n    50% {\n        -webkit-transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -170deg);\n        transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -170deg);\n        -webkit-animation-timing-function: ease-in;\n        animation-timing-function: ease-in\n    }\n    80% {\n        -webkit-transform: perspective(400px) scale3d(.95, .95, .95);\n        transform: perspective(400px) scale3d(.95, .95, .95);\n        -webkit-animation-timing-function: ease-in;\n        animation-timing-function: ease-in\n    }\n    100% {\n        -webkit-transform: perspective(400px);\n        transform: perspective(400px);\n        -webkit-animation-timing-function: ease-in;\n        animation-timing-function: ease-in\n    }\n}\n\n@keyframes flip {\n    from {\n        -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -360deg);\n        transform: perspective(400px) rotate3d(0, 1, 0, -360deg);\n        -webkit-animation-timing-function: ease-out;\n        animation-timing-function: ease-out\n    }\n    40% {\n        -webkit-transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -190deg);\n        transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -190deg);\n        -webkit-animation-timing-function: ease-out;\n        animation-timing-function: ease-out\n    }\n    50% {\n        -webkit-transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -170deg);\n        transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -170deg);\n        -webkit-animation-timing-function: ease-in;\n        animation-timing-function: ease-in\n    }\n    80% {\n        -webkit-transform: perspective(400px) scale3d(.95, .95, .95);\n        transform: perspective(400px) scale3d(.95, .95, .95);\n        -webkit-animation-timing-function: ease-in;\n        animation-timing-function: ease-in\n    }\n    100% {\n        -webkit-transform: perspective(400px);\n        transform: perspective(400px);\n        -webkit-animation-timing-function: ease-in;\n        animation-timing-function: ease-in\n    }\n}\n\n.animated.flip {\n    -webkit-backface-visibility: visible;\n    backface-visibility: visible;\n    -webkit-animation-name: flip;\n    animation-name: flip\n}\n\n@-webkit-keyframes flipInX {\n    from {\n        -webkit-transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n        transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n        -webkit-animation-timing-function: ease-in;\n        animation-timing-function: ease-in;\n        opacity: 0\n    }\n    40% {\n        -webkit-transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n        transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n        -webkit-animation-timing-function: ease-in;\n        animation-timing-function: ease-in\n    }\n    60% {\n        -webkit-transform: perspective(400px) rotate3d(1, 0, 0, 10deg);\n        transform: perspective(400px) rotate3d(1, 0, 0, 10deg);\n        opacity: 1\n    }\n    80% {\n        -webkit-transform: perspective(400px) rotate3d(1, 0, 0, -5deg);\n        transform: perspective(400px) rotate3d(1, 0, 0, -5deg)\n    }\n    100% {\n        -webkit-transform: perspective(400px);\n        transform: perspective(400px)\n    }\n}\n\n@keyframes flipInX {\n    from {\n        -webkit-transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n        transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n        -webkit-animation-timing-function: ease-in;\n        animation-timing-function: ease-in;\n        opacity: 0\n    }\n    40% {\n        -webkit-transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n        transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n        -webkit-animation-timing-function: ease-in;\n        animation-timing-function: ease-in\n    }\n    60% {\n        -webkit-transform: perspective(400px) rotate3d(1, 0, 0, 10deg);\n        transform: perspective(400px) rotate3d(1, 0, 0, 10deg);\n        opacity: 1\n    }\n    80% {\n        -webkit-transform: perspective(400px) rotate3d(1, 0, 0, -5deg);\n        transform: perspective(400px) rotate3d(1, 0, 0, -5deg)\n    }\n    100% {\n        -webkit-transform: perspective(400px);\n        transform: perspective(400px)\n    }\n}\n\n.flipInX {\n    -webkit-backface-visibility: visible !important;\n    backface-visibility: visible !important;\n    -webkit-animation-name: flipInX;\n    animation-name: flipInX\n}\n\n@-webkit-keyframes flipInY {\n    from {\n        -webkit-transform: perspective(400px) rotate3d(0, 1, 0, 90deg);\n        transform: perspective(400px) rotate3d(0, 1, 0, 90deg);\n        -webkit-animation-timing-function: ease-in;\n        animation-timing-function: ease-in;\n        opacity: 0\n    }\n    40% {\n        -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -20deg);\n        transform: perspective(400px) rotate3d(0, 1, 0, -20deg);\n        -webkit-animation-timing-function: ease-in;\n        animation-timing-function: ease-in\n    }\n    60% {\n        -webkit-transform: perspective(400px) rotate3d(0, 1, 0, 10deg);\n        transform: perspective(400px) rotate3d(0, 1, 0, 10deg);\n        opacity: 1\n    }\n    80% {\n        -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -5deg);\n        transform: perspective(400px) rotate3d(0, 1, 0, -5deg)\n    }\n    100% {\n        -webkit-transform: perspective(400px);\n        transform: perspective(400px)\n    }\n}\n\n@keyframes flipInY {\n    from {\n        -webkit-transform: perspective(400px) rotate3d(0, 1, 0, 90deg);\n        transform: perspective(400px) rotate3d(0, 1, 0, 90deg);\n        -webkit-animation-timing-function: ease-in;\n        animation-timing-function: ease-in;\n        opacity: 0\n    }\n    40% {\n        -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -20deg);\n        transform: perspective(400px) rotate3d(0, 1, 0, -20deg);\n        -webkit-animation-timing-function: ease-in;\n        animation-timing-function: ease-in\n    }\n    60% {\n        -webkit-transform: perspective(400px) rotate3d(0, 1, 0, 10deg);\n        transform: perspective(400px) rotate3d(0, 1, 0, 10deg);\n        opacity: 1\n    }\n    80% {\n        -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -5deg);\n        transform: perspective(400px) rotate3d(0, 1, 0, -5deg)\n    }\n    100% {\n        -webkit-transform: perspective(400px);\n        transform: perspective(400px)\n    }\n}\n\n.flipInY {\n    -webkit-backface-visibility: visible !important;\n    backface-visibility: visible !important;\n    -webkit-animation-name: flipInY;\n    animation-name: flipInY\n}\n\n@-webkit-keyframes flipOutX {\n    from {\n        -webkit-transform: perspective(400px);\n        transform: perspective(400px)\n    }\n    30% {\n        -webkit-transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n        transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n        opacity: 1\n    }\n    100% {\n        -webkit-transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n        transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n        opacity: 0\n    }\n}\n\n@keyframes flipOutX {\n    from {\n        -webkit-transform: perspective(400px);\n        transform: perspective(400px)\n    }\n    30% {\n        -webkit-transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n        transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n        opacity: 1\n    }\n    100% {\n        -webkit-transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n        transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n        opacity: 0\n    }\n}\n\n.flipOutX {\n    -webkit-animation-name: flipOutX;\n    animation-name: flipOutX;\n    -webkit-backface-visibility: visible !important;\n    backface-visibility: visible !important\n}\n\n@-webkit-keyframes flipOutY {\n    from {\n        -webkit-transform: perspective(400px);\n        transform: perspective(400px)\n    }\n    30% {\n        -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -15deg);\n        transform: perspective(400px) rotate3d(0, 1, 0, -15deg);\n        opacity: 1\n    }\n    100% {\n        -webkit-transform: perspective(400px) rotate3d(0, 1, 0, 90deg);\n        transform: perspective(400px) rotate3d(0, 1, 0, 90deg);\n        opacity: 0\n    }\n}\n\n@keyframes flipOutY {\n    from {\n        -webkit-transform: perspective(400px);\n        transform: perspective(400px)\n    }\n    30% {\n        -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -15deg);\n        transform: perspective(400px) rotate3d(0, 1, 0, -15deg);\n        opacity: 1\n    }\n    100% {\n        -webkit-transform: perspective(400px) rotate3d(0, 1, 0, 90deg);\n        transform: perspective(400px) rotate3d(0, 1, 0, 90deg);\n        opacity: 0\n    }\n}\n\n.flipOutY {\n    -webkit-backface-visibility: visible !important;\n    backface-visibility: visible !important;\n    -webkit-animation-name: flipOutY;\n    animation-name: flipOutY\n}\n\n@-webkit-keyframes lightSpeedIn {\n    from {\n        -webkit-transform: translate3d(100%, 0, 0) skewX(-30deg);\n        transform: translate3d(100%, 0, 0) skewX(-30deg);\n        opacity: 0\n    }\n    60% {\n        -webkit-transform: skewX(20deg);\n        transform: skewX(20deg);\n        opacity: 1\n    }\n    80% {\n        -webkit-transform: skewX(-5deg);\n        transform: skewX(-5deg);\n        opacity: 1\n    }\n    100% {\n        -webkit-transform: none;\n        transform: none;\n        opacity: 1\n    }\n}\n\n@keyframes lightSpeedIn {\n    from {\n        -webkit-transform: translate3d(100%, 0, 0) skewX(-30deg);\n        transform: translate3d(100%, 0, 0) skewX(-30deg);\n        opacity: 0\n    }\n    60% {\n        -webkit-transform: skewX(20deg);\n        transform: skewX(20deg);\n        opacity: 1\n    }\n    80% {\n        -webkit-transform: skewX(-5deg);\n        transform: skewX(-5deg);\n        opacity: 1\n    }\n    100% {\n        -webkit-transform: none;\n        transform: none;\n        opacity: 1\n    }\n}\n\n.lightSpeedIn {\n    -webkit-animation-name: lightSpeedIn;\n    animation-name: lightSpeedIn;\n    -webkit-animation-timing-function: ease-out;\n    animation-timing-function: ease-out\n}\n\n@-webkit-keyframes lightSpeedOut {\n    from {\n        opacity: 1\n    }\n    100% {\n        -webkit-transform: translate3d(100%, 0, 0) skewX(30deg);\n        transform: translate3d(100%, 0, 0) skewX(30deg);\n        opacity: 0\n    }\n}\n\n@keyframes lightSpeedOut {\n    from {\n        opacity: 1\n    }\n    100% {\n        -webkit-transform: translate3d(100%, 0, 0) skewX(30deg);\n        transform: translate3d(100%, 0, 0) skewX(30deg);\n        opacity: 0\n    }\n}\n\n.lightSpeedOut {\n    -webkit-animation-name: lightSpeedOut;\n    animation-name: lightSpeedOut;\n    -webkit-animation-timing-function: ease-in;\n    animation-timing-function: ease-in\n}\n\n@-webkit-keyframes rotateIn {\n    from {\n        -webkit-transform-origin: center;\n        transform-origin: center;\n        -webkit-transform: rotate3d(0, 0, 1, -200deg);\n        transform: rotate3d(0, 0, 1, -200deg);\n        opacity: 0\n    }\n    100% {\n        -webkit-transform-origin: center;\n        transform-origin: center;\n        -webkit-transform: none;\n        transform: none;\n        opacity: 1\n    }\n}\n\n@keyframes rotateIn {\n    from {\n        -webkit-transform-origin: center;\n        transform-origin: center;\n        -webkit-transform: rotate3d(0, 0, 1, -200deg);\n        transform: rotate3d(0, 0, 1, -200deg);\n        opacity: 0\n    }\n    100% {\n        -webkit-transform-origin: center;\n        transform-origin: center;\n        -webkit-transform: none;\n        transform: none;\n        opacity: 1\n    }\n}\n\n.rotateIn {\n    -webkit-animation-name: rotateIn;\n    animation-name: rotateIn\n}\n\n@-webkit-keyframes rotateInDownLeft {\n    from {\n        -webkit-transform-origin: left bottom;\n        transform-origin: left bottom;\n        -webkit-transform: rotate3d(0, 0, 1, -45deg);\n        transform: rotate3d(0, 0, 1, -45deg);\n        opacity: 0\n    }\n    100% {\n        -webkit-transform-origin: left bottom;\n        transform-origin: left bottom;\n        -webkit-transform: none;\n        transform: none;\n        opacity: 1\n    }\n}\n\n@keyframes rotateInDownLeft {\n    from {\n        -webkit-transform-origin: left bottom;\n        transform-origin: left bottom;\n        -webkit-transform: rotate3d(0, 0, 1, -45deg);\n        transform: rotate3d(0, 0, 1, -45deg);\n        opacity: 0\n    }\n    100% {\n        -webkit-transform-origin: left bottom;\n        transform-origin: left bottom;\n        -webkit-transform: none;\n        transform: none;\n        opacity: 1\n    }\n}\n\n.rotateInDownLeft {\n    -webkit-animation-name: rotateInDownLeft;\n    animation-name: rotateInDownLeft\n}\n\n@-webkit-keyframes rotateInDownRight {\n    from {\n        -webkit-transform-origin: right bottom;\n        transform-origin: right bottom;\n        -webkit-transform: rotate3d(0, 0, 1, 45deg);\n        transform: rotate3d(0, 0, 1, 45deg);\n        opacity: 0\n    }\n    100% {\n        -webkit-transform-origin: right bottom;\n        transform-origin: right bottom;\n        -webkit-transform: none;\n        transform: none;\n        opacity: 1\n    }\n}\n\n@keyframes rotateInDownRight {\n    from {\n        -webkit-transform-origin: right bottom;\n        transform-origin: right bottom;\n        -webkit-transform: rotate3d(0, 0, 1, 45deg);\n        transform: rotate3d(0, 0, 1, 45deg);\n        opacity: 0\n    }\n    100% {\n        -webkit-transform-origin: right bottom;\n        transform-origin: right bottom;\n        -webkit-transform: none;\n        transform: none;\n        opacity: 1\n    }\n}\n\n.rotateInDownRight {\n    -webkit-animation-name: rotateInDownRight;\n    animation-name: rotateInDownRight\n}\n\n@-webkit-keyframes rotateInUpLeft {\n    from {\n        -webkit-transform-origin: left bottom;\n        transform-origin: left bottom;\n        -webkit-transform: rotate3d(0, 0, 1, 45deg);\n        transform: rotate3d(0, 0, 1, 45deg);\n        opacity: 0\n    }\n    100% {\n        -webkit-transform-origin: left bottom;\n        transform-origin: left bottom;\n        -webkit-transform: none;\n        transform: none;\n        opacity: 1\n    }\n}\n\n@keyframes rotateInUpLeft {\n    from {\n        -webkit-transform-origin: left bottom;\n        transform-origin: left bottom;\n        -webkit-transform: rotate3d(0, 0, 1, 45deg);\n        transform: rotate3d(0, 0, 1, 45deg);\n        opacity: 0\n    }\n    100% {\n        -webkit-transform-origin: left bottom;\n        transform-origin: left bottom;\n        -webkit-transform: none;\n        transform: none;\n        opacity: 1\n    }\n}\n\n.rotateInUpLeft {\n    -webkit-animation-name: rotateInUpLeft;\n    animation-name: rotateInUpLeft\n}\n\n@-webkit-keyframes rotateInUpRight {\n    from {\n        -webkit-transform-origin: right bottom;\n        transform-origin: right bottom;\n        -webkit-transform: rotate3d(0, 0, 1, -90deg);\n        transform: rotate3d(0, 0, 1, -90deg);\n        opacity: 0\n    }\n    100% {\n        -webkit-transform-origin: right bottom;\n        transform-origin: right bottom;\n        -webkit-transform: none;\n        transform: none;\n        opacity: 1\n    }\n}\n\n@keyframes rotateInUpRight {\n    from {\n        -webkit-transform-origin: right bottom;\n        transform-origin: right bottom;\n        -webkit-transform: rotate3d(0, 0, 1, -90deg);\n        transform: rotate3d(0, 0, 1, -90deg);\n        opacity: 0\n    }\n    100% {\n        -webkit-transform-origin: right bottom;\n        transform-origin: right bottom;\n        -webkit-transform: none;\n        transform: none;\n        opacity: 1\n    }\n}\n\n.rotateInUpRight {\n    -webkit-animation-name: rotateInUpRight;\n    animation-name: rotateInUpRight\n}\n\n@-webkit-keyframes rotateOut {\n    from {\n        -webkit-transform-origin: center;\n        transform-origin: center;\n        opacity: 1\n    }\n    100% {\n        -webkit-transform-origin: center;\n        transform-origin: center;\n        -webkit-transform: rotate3d(0, 0, 1, 200deg);\n        transform: rotate3d(0, 0, 1, 200deg);\n        opacity: 0\n    }\n}\n\n@keyframes rotateOut {\n    from {\n        -webkit-transform-origin: center;\n        transform-origin: center;\n        opacity: 1\n    }\n    100% {\n        -webkit-transform-origin: center;\n        transform-origin: center;\n        -webkit-transform: rotate3d(0, 0, 1, 200deg);\n        transform: rotate3d(0, 0, 1, 200deg);\n        opacity: 0\n    }\n}\n\n.rotateOut {\n    -webkit-animation-name: rotateOut;\n    animation-name: rotateOut\n}\n\n@-webkit-keyframes rotateOutDownLeft {\n    from {\n        -webkit-transform-origin: left bottom;\n        transform-origin: left bottom;\n        opacity: 1\n    }\n    100% {\n        -webkit-transform-origin: left bottom;\n        transform-origin: left bottom;\n        -webkit-transform: rotate3d(0, 0, 1, 45deg);\n        transform: rotate3d(0, 0, 1, 45deg);\n        opacity: 0\n    }\n}\n\n@keyframes rotateOutDownLeft {\n    from {\n        -webkit-transform-origin: left bottom;\n        transform-origin: left bottom;\n        opacity: 1\n    }\n    100% {\n        -webkit-transform-origin: left bottom;\n        transform-origin: left bottom;\n        -webkit-transform: rotate3d(0, 0, 1, 45deg);\n        transform: rotate3d(0, 0, 1, 45deg);\n        opacity: 0\n    }\n}\n\n.rotateOutDownLeft {\n    -webkit-animation-name: rotateOutDownLeft;\n    animation-name: rotateOutDownLeft\n}\n\n@-webkit-keyframes rotateOutDownRight {\n    from {\n        -webkit-transform-origin: right bottom;\n        transform-origin: right bottom;\n        opacity: 1\n    }\n    100% {\n        -webkit-transform-origin: right bottom;\n        transform-origin: right bottom;\n        -webkit-transform: rotate3d(0, 0, 1, -45deg);\n        transform: rotate3d(0, 0, 1, -45deg);\n        opacity: 0\n    }\n}\n\n@keyframes rotateOutDownRight {\n    from {\n        -webkit-transform-origin: right bottom;\n        transform-origin: right bottom;\n        opacity: 1\n    }\n    100% {\n        -webkit-transform-origin: right bottom;\n        transform-origin: right bottom;\n        -webkit-transform: rotate3d(0, 0, 1, -45deg);\n        transform: rotate3d(0, 0, 1, -45deg);\n        opacity: 0\n    }\n}\n\n.rotateOutDownRight {\n    -webkit-animation-name: rotateOutDownRight;\n    animation-name: rotateOutDownRight\n}\n\n@-webkit-keyframes rotateOutUpLeft {\n    from {\n        -webkit-transform-origin: left bottom;\n        transform-origin: left bottom;\n        opacity: 1\n    }\n    100% {\n        -webkit-transform-origin: left bottom;\n        transform-origin: left bottom;\n        -webkit-transform: rotate3d(0, 0, 1, -45deg);\n        transform: rotate3d(0, 0, 1, -45deg);\n        opacity: 0\n    }\n}\n\n@keyframes rotateOutUpLeft {\n    from {\n        -webkit-transform-origin: left bottom;\n        transform-origin: left bottom;\n        opacity: 1\n    }\n    100% {\n        -webkit-transform-origin: left bottom;\n        transform-origin: left bottom;\n        -webkit-transform: rotate3d(0, 0, 1, -45deg);\n        transform: rotate3d(0, 0, 1, -45deg);\n        opacity: 0\n    }\n}\n\n.rotateOutUpLeft {\n    -webkit-animation-name: rotateOutUpLeft;\n    animation-name: rotateOutUpLeft\n}\n\n@-webkit-keyframes rotateOutUpRight {\n    from {\n        -webkit-transform-origin: right bottom;\n        transform-origin: right bottom;\n        opacity: 1\n    }\n    100% {\n        -webkit-transform-origin: right bottom;\n        transform-origin: right bottom;\n        -webkit-transform: rotate3d(0, 0, 1, 90deg);\n        transform: rotate3d(0, 0, 1, 90deg);\n        opacity: 0\n    }\n}\n\n@keyframes rotateOutUpRight {\n    from {\n        -webkit-transform-origin: right bottom;\n        transform-origin: right bottom;\n        opacity: 1\n    }\n    100% {\n        -webkit-transform-origin: right bottom;\n        transform-origin: right bottom;\n        -webkit-transform: rotate3d(0, 0, 1, 90deg);\n        transform: rotate3d(0, 0, 1, 90deg);\n        opacity: 0\n    }\n}\n\n.rotateOutUpRight {\n    -webkit-animation-name: rotateOutUpRight;\n    animation-name: rotateOutUpRight\n}\n\n@-webkit-keyframes hinge {\n    0% {\n        -webkit-transform-origin: top left;\n        transform-origin: top left;\n        -webkit-animation-timing-function: ease-in-out;\n        animation-timing-function: ease-in-out\n    }\n    20%, 60% {\n        -webkit-transform: rotate3d(0, 0, 1, 80deg);\n        transform: rotate3d(0, 0, 1, 80deg);\n        -webkit-transform-origin: top left;\n        transform-origin: top left;\n        -webkit-animation-timing-function: ease-in-out;\n        animation-timing-function: ease-in-out\n    }\n    40%, 80% {\n        -webkit-transform: rotate3d(0, 0, 1, 60deg);\n        transform: rotate3d(0, 0, 1, 60deg);\n        -webkit-transform-origin: top left;\n        transform-origin: top left;\n        -webkit-animation-timing-function: ease-in-out;\n        animation-timing-function: ease-in-out;\n        opacity: 1\n    }\n    100% {\n        -webkit-transform: translate3d(0, 700px, 0);\n        transform: translate3d(0, 700px, 0);\n        opacity: 0\n    }\n}\n\n@keyframes hinge {\n    0% {\n        -webkit-transform-origin: top left;\n        transform-origin: top left;\n        -webkit-animation-timing-function: ease-in-out;\n        animation-timing-function: ease-in-out\n    }\n    20%, 60% {\n        -webkit-transform: rotate3d(0, 0, 1, 80deg);\n        transform: rotate3d(0, 0, 1, 80deg);\n        -webkit-transform-origin: top left;\n        transform-origin: top left;\n        -webkit-animation-timing-function: ease-in-out;\n        animation-timing-function: ease-in-out\n    }\n    40%, 80% {\n        -webkit-transform: rotate3d(0, 0, 1, 60deg);\n        transform: rotate3d(0, 0, 1, 60deg);\n        -webkit-transform-origin: top left;\n        transform-origin: top left;\n        -webkit-animation-timing-function: ease-in-out;\n        animation-timing-function: ease-in-out;\n        opacity: 1\n    }\n    100% {\n        -webkit-transform: translate3d(0, 700px, 0);\n        transform: translate3d(0, 700px, 0);\n        opacity: 0\n    }\n}\n\n.hinge {\n    -webkit-animation-name: hinge;\n    animation-name: hinge\n}\n\n@-webkit-keyframes rollIn {\n    from {\n        opacity: 0;\n        -webkit-transform: translate3d(-100%, 0, 0) rotate3d(0, 0, 1, -120deg);\n        transform: translate3d(-100%, 0, 0) rotate3d(0, 0, 1, -120deg)\n    }\n    100% {\n        opacity: 1;\n        -webkit-transform: none;\n        transform: none\n    }\n}\n\n@keyframes rollIn {\n    from {\n        opacity: 0;\n        -webkit-transform: translate3d(-100%, 0, 0) rotate3d(0, 0, 1, -120deg);\n        transform: translate3d(-100%, 0, 0) rotate3d(0, 0, 1, -120deg)\n    }\n    100% {\n        opacity: 1;\n        -webkit-transform: none;\n        transform: none\n    }\n}\n\n.rollIn {\n    -webkit-animation-name: rollIn;\n    animation-name: rollIn\n}\n\n@-webkit-keyframes rollOut {\n    from {\n        opacity: 1\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translate3d(100%, 0, 0) rotate3d(0, 0, 1, 120deg);\n        transform: translate3d(100%, 0, 0) rotate3d(0, 0, 1, 120deg)\n    }\n}\n\n@keyframes rollOut {\n    from {\n        opacity: 1\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translate3d(100%, 0, 0) rotate3d(0, 0, 1, 120deg);\n        transform: translate3d(100%, 0, 0) rotate3d(0, 0, 1, 120deg)\n    }\n}\n\n.rollOut {\n    -webkit-animation-name: rollOut;\n    animation-name: rollOut\n}\n\n@-webkit-keyframes zoomIn {\n    from {\n        opacity: 0;\n        -webkit-transform: scale3d(.3, .3, .3);\n        transform: scale3d(.3, .3, .3)\n    }\n    50% {\n        opacity: 1\n    }\n}\n\n@keyframes zoomIn {\n    from {\n        opacity: 0;\n        -webkit-transform: scale3d(.3, .3, .3);\n        transform: scale3d(.3, .3, .3)\n    }\n    50% {\n        opacity: 1\n    }\n}\n\n.zoomIn {\n    -webkit-animation-name: zoomIn;\n    animation-name: zoomIn\n}\n\n@-webkit-keyframes zoomInDown {\n    from {\n        opacity: 0;\n        -webkit-transform: scale3d(.1, .1, .1) translate3d(0, -1000px, 0);\n        transform: scale3d(.1, .1, .1) translate3d(0, -1000px, 0);\n        -webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);\n        animation-timing-function: cubic-bezier(.55, .055, .675, .19)\n    }\n    60% {\n        opacity: 1;\n        -webkit-transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);\n        transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);\n        -webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);\n        animation-timing-function: cubic-bezier(.175, .885, .32, 1)\n    }\n}\n\n@keyframes zoomInDown {\n    from {\n        opacity: 0;\n        -webkit-transform: scale3d(.1, .1, .1) translate3d(0, -1000px, 0);\n        transform: scale3d(.1, .1, .1) translate3d(0, -1000px, 0);\n        -webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);\n        animation-timing-function: cubic-bezier(.55, .055, .675, .19)\n    }\n    60% {\n        opacity: 1;\n        -webkit-transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);\n        transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);\n        -webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);\n        animation-timing-function: cubic-bezier(.175, .885, .32, 1)\n    }\n}\n\n.zoomInDown {\n    -webkit-animation-name: zoomInDown;\n    animation-name: zoomInDown\n}\n\n@-webkit-keyframes zoomInLeft {\n    from {\n        opacity: 0;\n        -webkit-transform: scale3d(.1, .1, .1) translate3d(-1000px, 0, 0);\n        transform: scale3d(.1, .1, .1) translate3d(-1000px, 0, 0);\n        -webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);\n        animation-timing-function: cubic-bezier(.55, .055, .675, .19)\n    }\n    60% {\n        opacity: 1;\n        -webkit-transform: scale3d(.475, .475, .475) translate3d(10px, 0, 0);\n        transform: scale3d(.475, .475, .475) translate3d(10px, 0, 0);\n        -webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);\n        animation-timing-function: cubic-bezier(.175, .885, .32, 1)\n    }\n}\n\n@keyframes zoomInLeft {\n    from {\n        opacity: 0;\n        -webkit-transform: scale3d(.1, .1, .1) translate3d(-1000px, 0, 0);\n        transform: scale3d(.1, .1, .1) translate3d(-1000px, 0, 0);\n        -webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);\n        animation-timing-function: cubic-bezier(.55, .055, .675, .19)\n    }\n    60% {\n        opacity: 1;\n        -webkit-transform: scale3d(.475, .475, .475) translate3d(10px, 0, 0);\n        transform: scale3d(.475, .475, .475) translate3d(10px, 0, 0);\n        -webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);\n        animation-timing-function: cubic-bezier(.175, .885, .32, 1)\n    }\n}\n\n.zoomInLeft {\n    -webkit-animation-name: zoomInLeft;\n    animation-name: zoomInLeft\n}\n\n@-webkit-keyframes zoomInRight {\n    from {\n        opacity: 0;\n        -webkit-transform: scale3d(.1, .1, .1) translate3d(1000px, 0, 0);\n        transform: scale3d(.1, .1, .1) translate3d(1000px, 0, 0);\n        -webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);\n        animation-timing-function: cubic-bezier(.55, .055, .675, .19)\n    }\n    60% {\n        opacity: 1;\n        -webkit-transform: scale3d(.475, .475, .475) translate3d(-10px, 0, 0);\n        transform: scale3d(.475, .475, .475) translate3d(-10px, 0, 0);\n        -webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);\n        animation-timing-function: cubic-bezier(.175, .885, .32, 1)\n    }\n}\n\n@keyframes zoomInRight {\n    from {\n        opacity: 0;\n        -webkit-transform: scale3d(.1, .1, .1) translate3d(1000px, 0, 0);\n        transform: scale3d(.1, .1, .1) translate3d(1000px, 0, 0);\n        -webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);\n        animation-timing-function: cubic-bezier(.55, .055, .675, .19)\n    }\n    60% {\n        opacity: 1;\n        -webkit-transform: scale3d(.475, .475, .475) translate3d(-10px, 0, 0);\n        transform: scale3d(.475, .475, .475) translate3d(-10px, 0, 0);\n        -webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);\n        animation-timing-function: cubic-bezier(.175, .885, .32, 1)\n    }\n}\n\n.zoomInRight {\n    -webkit-animation-name: zoomInRight;\n    animation-name: zoomInRight\n}\n\n@-webkit-keyframes zoomInUp {\n    from {\n        opacity: 0;\n        -webkit-transform: scale3d(.1, .1, .1) translate3d(0, 1000px, 0);\n        transform: scale3d(.1, .1, .1) translate3d(0, 1000px, 0);\n        -webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);\n        animation-timing-function: cubic-bezier(.55, .055, .675, .19)\n    }\n    60% {\n        opacity: 1;\n        -webkit-transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);\n        transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);\n        -webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);\n        animation-timing-function: cubic-bezier(.175, .885, .32, 1)\n    }\n}\n\n@keyframes zoomInUp {\n    from {\n        opacity: 0;\n        -webkit-transform: scale3d(.1, .1, .1) translate3d(0, 1000px, 0);\n        transform: scale3d(.1, .1, .1) translate3d(0, 1000px, 0);\n        -webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);\n        animation-timing-function: cubic-bezier(.55, .055, .675, .19)\n    }\n    60% {\n        opacity: 1;\n        -webkit-transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);\n        transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);\n        -webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);\n        animation-timing-function: cubic-bezier(.175, .885, .32, 1)\n    }\n}\n\n.zoomInUp {\n    -webkit-animation-name: zoomInUp;\n    animation-name: zoomInUp\n}\n\n@-webkit-keyframes zoomOut {\n    from {\n        opacity: 1\n    }\n    50% {\n        opacity: 0;\n        -webkit-transform: scale3d(.3, .3, .3);\n        transform: scale3d(.3, .3, .3)\n    }\n    100% {\n        opacity: 0\n    }\n}\n\n@keyframes zoomOut {\n    from {\n        opacity: 1\n    }\n    50% {\n        opacity: 0;\n        -webkit-transform: scale3d(.3, .3, .3);\n        transform: scale3d(.3, .3, .3)\n    }\n    100% {\n        opacity: 0\n    }\n}\n\n.zoomOut {\n    -webkit-animation-name: zoomOut;\n    animation-name: zoomOut\n}\n\n@-webkit-keyframes zoomOutDown {\n    40% {\n        opacity: 1;\n        -webkit-transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);\n        transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);\n        -webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);\n        animation-timing-function: cubic-bezier(.55, .055, .675, .19)\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: scale3d(.1, .1, .1) translate3d(0, 2000px, 0);\n        transform: scale3d(.1, .1, .1) translate3d(0, 2000px, 0);\n        -webkit-transform-origin: center bottom;\n        transform-origin: center bottom;\n        -webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);\n        animation-timing-function: cubic-bezier(.175, .885, .32, 1)\n    }\n}\n\n@keyframes zoomOutDown {\n    40% {\n        opacity: 1;\n        -webkit-transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);\n        transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);\n        -webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);\n        animation-timing-function: cubic-bezier(.55, .055, .675, .19)\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: scale3d(.1, .1, .1) translate3d(0, 2000px, 0);\n        transform: scale3d(.1, .1, .1) translate3d(0, 2000px, 0);\n        -webkit-transform-origin: center bottom;\n        transform-origin: center bottom;\n        -webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);\n        animation-timing-function: cubic-bezier(.175, .885, .32, 1)\n    }\n}\n\n.zoomOutDown {\n    -webkit-animation-name: zoomOutDown;\n    animation-name: zoomOutDown\n}\n\n@-webkit-keyframes zoomOutLeft {\n    40% {\n        opacity: 1;\n        -webkit-transform: scale3d(.475, .475, .475) translate3d(42px, 0, 0);\n        transform: scale3d(.475, .475, .475) translate3d(42px, 0, 0)\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: scale(.1) translate3d(-2000px, 0, 0);\n        transform: scale(.1) translate3d(-2000px, 0, 0);\n        -webkit-transform-origin: left center;\n        transform-origin: left center\n    }\n}\n\n@keyframes zoomOutLeft {\n    40% {\n        opacity: 1;\n        -webkit-transform: scale3d(.475, .475, .475) translate3d(42px, 0, 0);\n        transform: scale3d(.475, .475, .475) translate3d(42px, 0, 0)\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: scale(.1) translate3d(-2000px, 0, 0);\n        transform: scale(.1) translate3d(-2000px, 0, 0);\n        -webkit-transform-origin: left center;\n        transform-origin: left center\n    }\n}\n\n.zoomOutLeft {\n    -webkit-animation-name: zoomOutLeft;\n    animation-name: zoomOutLeft\n}\n\n@-webkit-keyframes zoomOutRight {\n    40% {\n        opacity: 1;\n        -webkit-transform: scale3d(.475, .475, .475) translate3d(-42px, 0, 0);\n        transform: scale3d(.475, .475, .475) translate3d(-42px, 0, 0)\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: scale(.1) translate3d(2000px, 0, 0);\n        transform: scale(.1) translate3d(2000px, 0, 0);\n        -webkit-transform-origin: right center;\n        transform-origin: right center\n    }\n}\n\n@keyframes zoomOutRight {\n    40% {\n        opacity: 1;\n        -webkit-transform: scale3d(.475, .475, .475) translate3d(-42px, 0, 0);\n        transform: scale3d(.475, .475, .475) translate3d(-42px, 0, 0)\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: scale(.1) translate3d(2000px, 0, 0);\n        transform: scale(.1) translate3d(2000px, 0, 0);\n        -webkit-transform-origin: right center;\n        transform-origin: right center\n    }\n}\n\n.zoomOutRight {\n    -webkit-animation-name: zoomOutRight;\n    animation-name: zoomOutRight\n}\n\n@-webkit-keyframes zoomOutUp {\n    40% {\n        opacity: 1;\n        -webkit-transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);\n        transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);\n        -webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);\n        animation-timing-function: cubic-bezier(.55, .055, .675, .19)\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: scale3d(.1, .1, .1) translate3d(0, -2000px, 0);\n        transform: scale3d(.1, .1, .1) translate3d(0, -2000px, 0);\n        -webkit-transform-origin: center bottom;\n        transform-origin: center bottom;\n        -webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);\n        animation-timing-function: cubic-bezier(.175, .885, .32, 1)\n    }\n}\n\n@keyframes zoomOutUp {\n    40% {\n        opacity: 1;\n        -webkit-transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);\n        transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);\n        -webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);\n        animation-timing-function: cubic-bezier(.55, .055, .675, .19)\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: scale3d(.1, .1, .1) translate3d(0, -2000px, 0);\n        transform: scale3d(.1, .1, .1) translate3d(0, -2000px, 0);\n        -webkit-transform-origin: center bottom;\n        transform-origin: center bottom;\n        -webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);\n        animation-timing-function: cubic-bezier(.175, .885, .32, 1)\n    }\n}\n\n.zoomOutUp {\n    -webkit-animation-name: zoomOutUp;\n    animation-name: zoomOutUp\n}\n\n@-webkit-keyframes slideInDown {\n    from {\n        -webkit-transform: translate3d(0, -100%, 0);\n        transform: translate3d(0, -100%, 0);\n        visibility: visible\n    }\n    100% {\n        -webkit-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0)\n    }\n}\n\n@keyframes slideInDown {\n    from {\n        -webkit-transform: translate3d(0, -100%, 0);\n        transform: translate3d(0, -100%, 0);\n        visibility: visible\n    }\n    100% {\n        -webkit-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0)\n    }\n}\n\n.slideInDown {\n    -webkit-animation-name: slideInDown;\n    animation-name: slideInDown\n}\n\n@-webkit-keyframes slideInLeft {\n    from {\n        -webkit-transform: translate3d(-100%, 0, 0);\n        transform: translate3d(-100%, 0, 0);\n        visibility: visible\n    }\n    100% {\n        -webkit-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0)\n    }\n}\n\n@keyframes slideInLeft {\n    from {\n        -webkit-transform: translate3d(-100%, 0, 0);\n        transform: translate3d(-100%, 0, 0);\n        visibility: visible\n    }\n    100% {\n        -webkit-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0)\n    }\n}\n\n.slideInLeft {\n    -webkit-animation-name: slideInLeft;\n    animation-name: slideInLeft\n}\n\n@-webkit-keyframes slideInRight {\n    from {\n        -webkit-transform: translate3d(100%, 0, 0);\n        transform: translate3d(100%, 0, 0);\n        visibility: visible\n    }\n    100% {\n        -webkit-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0)\n    }\n}\n\n@keyframes slideInRight {\n    from {\n        -webkit-transform: translate3d(100%, 0, 0);\n        transform: translate3d(100%, 0, 0);\n        visibility: visible\n    }\n    100% {\n        -webkit-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0)\n    }\n}\n\n.slideInRight {\n    -webkit-animation-name: slideInRight;\n    animation-name: slideInRight\n}\n\n@-webkit-keyframes slideInUp {\n    from {\n        -webkit-transform: translate3d(0, 100%, 0);\n        transform: translate3d(0, 100%, 0);\n        visibility: visible\n    }\n    100% {\n        -webkit-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0)\n    }\n}\n\n@keyframes slideInUp {\n    from {\n        -webkit-transform: translate3d(0, 100%, 0);\n        transform: translate3d(0, 100%, 0);\n        visibility: visible\n    }\n    100% {\n        -webkit-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0)\n    }\n}\n\n.slideInUp {\n    -webkit-animation-name: slideInUp;\n    animation-name: slideInUp\n}\n\n@-webkit-keyframes slideOutDown {\n    from {\n        -webkit-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0)\n    }\n    100% {\n        visibility: hidden;\n        -webkit-transform: translate3d(0, 100%, 0);\n        transform: translate3d(0, 100%, 0)\n    }\n}\n\n@keyframes slideOutDown {\n    from {\n        -webkit-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0)\n    }\n    100% {\n        visibility: hidden;\n        -webkit-transform: translate3d(0, 100%, 0);\n        transform: translate3d(0, 100%, 0)\n    }\n}\n\n.slideOutDown {\n    -webkit-animation-name: slideOutDown;\n    animation-name: slideOutDown\n}\n\n@-webkit-keyframes slideOutLeft {\n    from {\n        -webkit-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0)\n    }\n    100% {\n        visibility: hidden;\n        -webkit-transform: translate3d(-100%, 0, 0);\n        transform: translate3d(-100%, 0, 0)\n    }\n}\n\n@keyframes slideOutLeft {\n    from {\n        -webkit-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0)\n    }\n    100% {\n        visibility: hidden;\n        -webkit-transform: translate3d(-100%, 0, 0);\n        transform: translate3d(-100%, 0, 0)\n    }\n}\n\n.slideOutLeft {\n    -webkit-animation-name: slideOutLeft;\n    animation-name: slideOutLeft\n}\n\n@-webkit-keyframes slideOutRight {\n    from {\n        -webkit-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0)\n    }\n    100% {\n        visibility: hidden;\n        -webkit-transform: translate3d(100%, 0, 0);\n        transform: translate3d(100%, 0, 0)\n    }\n}\n\n@keyframes slideOutRight {\n    from {\n        -webkit-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0)\n    }\n    100% {\n        visibility: hidden;\n        -webkit-transform: translate3d(100%, 0, 0);\n        transform: translate3d(100%, 0, 0)\n    }\n}\n\n.slideOutRight {\n    -webkit-animation-name: slideOutRight;\n    animation-name: slideOutRight\n}\n\n@-webkit-keyframes slideOutUp {\n    from {\n        -webkit-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0)\n    }\n    100% {\n        visibility: hidden;\n        -webkit-transform: translate3d(0, -100%, 0);\n        transform: translate3d(0, -100%, 0)\n    }\n}\n\n@keyframes slideOutUp {\n    from {\n        -webkit-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0)\n    }\n    100% {\n        visibility: hidden;\n        -webkit-transform: translate3d(0, -100%, 0);\n        transform: translate3d(0, -100%, 0)\n    }\n}\n\n.slideOutUp {\n    -webkit-animation-name: slideOutUp;\n    animation-name: slideOutUp\n}\n\n/*!\n  Ionicons, v2.0.0\n  Created by Ben Sperry for the Ionic Framework, http://ionicons.com/\n  https://twitter.com/benjsperry  https://twitter.com/ionicframework\n  MIT License: https://github.com/driftyco/ionicons\n\n  Android-style icons originally built by Google’s\n  Material Design Icons: https://github.com/google/material-design-icons\n  used under CC BY http://creativecommons.org/licenses/by/4.0/\n  Modified icons to fit ionicon’s grid from original.\n\n * --------------------------------------------------\n */\n\n/*@font-face{font-family:Ionicons;src:url(./assets/fonts/ionicons.eot?v=2.0.01);src:url(./assets/fonts/ionicons.eot?v=2.0.0#iefix) format(\"embedded-opentype\"),url(./assets/fonts/ionicons.ttf?v=2.0.0) format(\"truetype\"),url(./assets/fonts/ionicons.woff?v=2.0.0) format(\"woff\"),url(./assets/fonts/ionicons.svg?v=2.0.0#Ionicons) format(\"svg\")}.ion,.ionicons,.ion-alert:before,.ion-alert-circled:before,.ion-android-add:before,.ion-android-add-circle:before,.ion-android-alarm-clock:before,.ion-android-alert:before,.ion-android-apps:before,.ion-android-archive:before,.ion-android-arrow-back:before,.ion-android-arrow-down:before,.ion-android-arrow-dropdown:before,.ion-android-arrow-dropdown-circle:before,.ion-android-arrow-dropleft:before,.ion-android-arrow-dropleft-circle:before,.ion-android-arrow-dropright:before,.ion-android-arrow-dropright-circle:before,.ion-android-arrow-dropup:before,.ion-android-arrow-dropup-circle:before,.ion-android-arrow-forward:before,.ion-android-arrow-up:before,.ion-android-attach:before,.ion-android-bar:before,.ion-android-bicycle:before,.ion-android-boat:before,.ion-android-bookmark:before,.ion-android-bulb:before,.ion-android-bus:before,.ion-android-calendar:before,.ion-android-call:before,.ion-android-camera:before,.ion-android-cancel:before,.ion-android-car:before,.ion-android-cart:before,.ion-android-chat:before,.ion-android-checkbox:before,.ion-android-checkbox-blank:before,.ion-android-checkbox-outline:before,.ion-android-checkbox-outline-blank:before,.ion-android-checkmark-circle:before,.ion-android-clipboard:before,.ion-android-close:before,.ion-android-cloud:before,.ion-android-cloud-circle:before,.ion-android-cloud-done:before,.ion-android-cloud-outline:before,.ion-android-color-palette:before,.ion-android-compass:before,.ion-android-contact:before,.ion-android-contacts:before,.ion-android-contract:before,.ion-android-create:before,.ion-android-delete:before,.ion-android-desktop:before,.ion-android-document:before,.ion-android-done:before,.ion-android-done-all:before,.ion-android-download:before,.ion-android-drafts:before,.ion-android-exit:before,.ion-android-expand:before,.ion-android-favorite:before,.ion-android-favorite-outline:before,.ion-android-film:before,.ion-android-folder:before,.ion-android-folder-open:before,.ion-android-funnel:before,.ion-android-globe:before,.ion-android-hand:before,.ion-android-hangout:before,.ion-android-happy:before,.ion-android-home:before,.ion-android-image:before,.ion-android-laptop:before,.ion-android-list:before,.ion-android-locate:before,.ion-android-lock:before,.ion-android-mail:before,.ion-android-map:before,.ion-android-menu:before,.ion-android-microphone:before,.ion-android-microphone-off:before,.ion-android-more-horizontal:before,.ion-android-more-vertical:before,.ion-android-navigate:before,.ion-android-notifications:before,.ion-android-notifications-none:before,.ion-android-notifications-off:before,.ion-android-open:before,.ion-android-options:before,.ion-android-people:before,.ion-android-person:before,.ion-android-person-add:before,.ion-android-phone-landscape:before,.ion-android-phone-portrait:before,.ion-android-pin:before,.ion-android-plane:before,.ion-android-playstore:before,.ion-android-print:before,.ion-android-radio-button-off:before,.ion-android-radio-button-on:before,.ion-android-refresh:before,.ion-android-remove:before,.ion-android-remove-circle:before,.ion-android-restaurant:before,.ion-android-sad:before,.ion-android-search:before,.ion-android-send:before,.ion-android-settings:before,.ion-android-share:before,.ion-android-share-alt:before,.ion-android-star:before,.ion-android-star-half:before,.ion-android-star-outline:before,.ion-android-stopwatch:before,.ion-android-subway:before,.ion-android-sunny:before,.ion-android-sync:before,.ion-android-textsms:before,.ion-android-time:before,.ion-android-train:before,.ion-android-unlock:before,.ion-android-upload:before,.ion-android-volume-down:before,.ion-android-volume-mute:before,.ion-android-volume-off:before,.ion-android-volume-up:before,.ion-android-walk:before,.ion-android-warning:before,.ion-android-watch:before,.ion-android-wifi:before,.ion-aperture:before,.ion-archive:before,.ion-arrow-down-a:before,.ion-arrow-down-b:before,.ion-arrow-down-c:before,.ion-arrow-expand:before,.ion-arrow-graph-down-left:before,.ion-arrow-graph-down-right:before,.ion-arrow-graph-up-left:before,.ion-arrow-graph-up-right:before,.ion-arrow-left-a:before,.ion-arrow-left-b:before,.ion-arrow-left-c:before,.ion-arrow-move:before,.ion-arrow-resize:before,.ion-arrow-return-left:before,.ion-arrow-return-right:before,.ion-arrow-right-a:before,.ion-arrow-right-b:before,.ion-arrow-right-c:before,.ion-arrow-shrink:before,.ion-arrow-swap:before,.ion-arrow-up-a:before,.ion-arrow-up-b:before,.ion-arrow-up-c:before,.ion-asterisk:before,.ion-at:before,.ion-backspace:before,.ion-backspace-outline:before,.ion-bag:before,.ion-battery-charging:before,.ion-battery-empty:before,.ion-battery-full:before,.ion-battery-half:before,.ion-battery-low:before,.ion-beaker:before,.ion-beer:before,.ion-bluetooth:before,.ion-bonfire:before,.ion-bookmark:before,.ion-bowtie:before,.ion-briefcase:before,.ion-bug:before,.ion-calculator:before,.ion-calendar:before,.ion-camera:before,.ion-card:before,.ion-cash:before,.ion-chatbox:before,.ion-chatbox-working:before,.ion-chatboxes:before,.ion-chatbubble:before,.ion-chatbubble-working:before,.ion-chatbubbles:before,.ion-checkmark:before,.ion-checkmark-circled:before,.ion-checkmark-round:before,.ion-chevron-down:before,.ion-chevron-left:before,.ion-chevron-right:before,.ion-chevron-up:before,.ion-clipboard:before,.ion-clock:before,.ion-close:before,.ion-close-circled:before,.ion-close-round:before,.ion-closed-captioning:before,.ion-cloud:before,.ion-code:before,.ion-code-download:before,.ion-code-working:before,.ion-coffee:before,.ion-compass:before,.ion-compose:before,.ion-connection-bars:before,.ion-contrast:before,.ion-crop:before,.ion-cube:before,.ion-disc:before,.ion-document:before,.ion-document-text:before,.ion-drag:before,.ion-earth:before,.ion-easel:before,.ion-edit:before,.ion-egg:before,.ion-eject:before,.ion-email:before,.ion-email-unread:before,.ion-erlenmeyer-flask:before,.ion-erlenmeyer-flask-bubbles:before,.ion-eye:before,.ion-eye-disabled:before,.ion-female:before,.ion-filing:before,.ion-film-marker:before,.ion-fireball:before,.ion-flag:before,.ion-flame:before,.ion-flash:before,.ion-flash-off:before,.ion-folder:before,.ion-fork:before,.ion-fork-repo:before,.ion-forward:before,.ion-funnel:before,.ion-gear-a:before,.ion-gear-b:before,.ion-grid:before,.ion-hammer:before,.ion-happy:before,.ion-happy-outline:before,.ion-headphone:before,.ion-heart:before,.ion-heart-broken:before,.ion-help:before,.ion-help-buoy:before,.ion-help-circled:before,.ion-home:before,.ion-icecream:before,.ion-image:before,.ion-images:before,.ion-information:before,.ion-information-circled:before,.ion-ionic:before,.ion-ios-alarm:before,.ion-ios-alarm-outline:before,.ion-ios-albums:before,.ion-ios-albums-outline:before,.ion-ios-americanfootball:before,.ion-ios-americanfootball-outline:before,.ion-ios-analytics:before,.ion-ios-analytics-outline:before,.ion-ios-arrow-back:before,.ion-ios-arrow-down:before,.ion-ios-arrow-forward:before,.ion-ios-arrow-left:before,.ion-ios-arrow-right:before,.ion-ios-arrow-thin-down:before,.ion-ios-arrow-thin-left:before,.ion-ios-arrow-thin-right:before,.ion-ios-arrow-thin-up:before,.ion-ios-arrow-up:before,.ion-ios-at:before,.ion-ios-at-outline:before,.ion-ios-barcode:before,.ion-ios-barcode-outline:before,.ion-ios-baseball:before,.ion-ios-baseball-outline:before,.ion-ios-basketball:before,.ion-ios-basketball-outline:before,.ion-ios-bell:before,.ion-ios-bell-outline:before,.ion-ios-body:before,.ion-ios-body-outline:before,.ion-ios-bolt:before,.ion-ios-bolt-outline:before,.ion-ios-book:before,.ion-ios-book-outline:before,.ion-ios-bookmarks:before,.ion-ios-bookmarks-outline:before,.ion-ios-box:before,.ion-ios-box-outline:before,.ion-ios-briefcase:before,.ion-ios-briefcase-outline:before,.ion-ios-browsers:before,.ion-ios-browsers-outline:before,.ion-ios-calculator:before,.ion-ios-calculator-outline:before,.ion-ios-calendar:before,.ion-ios-calendar-outline:before,.ion-ios-camera:before,.ion-ios-camera-outline:before,.ion-ios-cart:before,.ion-ios-cart-outline:before,.ion-ios-chatboxes:before,.ion-ios-chatboxes-outline:before,.ion-ios-chatbubble:before,.ion-ios-chatbubble-outline:before,.ion-ios-checkmark:before,.ion-ios-checkmark-empty:before,.ion-ios-checkmark-outline:before,.ion-ios-circle-filled:before,.ion-ios-circle-outline:before,.ion-ios-clock:before,.ion-ios-clock-outline:before,.ion-ios-close:before,.ion-ios-close-empty:before,.ion-ios-close-outline:before,.ion-ios-cloud:before,.ion-ios-cloud-download:before,.ion-ios-cloud-download-outline:before,.ion-ios-cloud-outline:before,.ion-ios-cloud-upload:before,.ion-ios-cloud-upload-outline:before,.ion-ios-cloudy:before,.ion-ios-cloudy-night:before,.ion-ios-cloudy-night-outline:before,.ion-ios-cloudy-outline:before,.ion-ios-cog:before,.ion-ios-cog-outline:before,.ion-ios-color-filter:before,.ion-ios-color-filter-outline:before,.ion-ios-color-wand:before,.ion-ios-color-wand-outline:before,.ion-ios-compose:before,.ion-ios-compose-outline:before,.ion-ios-contact:before,.ion-ios-contact-outline:before,.ion-ios-copy:before,.ion-ios-copy-outline:before,.ion-ios-crop:before,.ion-ios-crop-strong:before,.ion-ios-download:before,.ion-ios-download-outline:before,.ion-ios-drag:before,.ion-ios-email:before,.ion-ios-email-outline:before,.ion-ios-eye:before,.ion-ios-eye-outline:before,.ion-ios-fastforward:before,.ion-ios-fastforward-outline:before,.ion-ios-filing:before,.ion-ios-filing-outline:before,.ion-ios-film:before,.ion-ios-film-outline:before,.ion-ios-flag:before,.ion-ios-flag-outline:before,.ion-ios-flame:before,.ion-ios-flame-outline:before,.ion-ios-flask:before,.ion-ios-flask-outline:before,.ion-ios-flower:before,.ion-ios-flower-outline:before,.ion-ios-folder:before,.ion-ios-folder-outline:before,.ion-ios-football:before,.ion-ios-football-outline:before,.ion-ios-game-controller-a:before,.ion-ios-game-controller-a-outline:before,.ion-ios-game-controller-b:before,.ion-ios-game-controller-b-outline:before,.ion-ios-gear:before,.ion-ios-gear-outline:before,.ion-ios-glasses:before,.ion-ios-glasses-outline:before,.ion-ios-grid-view:before,.ion-ios-grid-view-outline:before,.ion-ios-heart:before,.ion-ios-heart-outline:before,.ion-ios-help:before,.ion-ios-help-empty:before,.ion-ios-help-outline:before,.ion-ios-home:before,.ion-ios-home-outline:before,.ion-ios-infinite:before,.ion-ios-infinite-outline:before,.ion-ios-information:before,.ion-ios-information-empty:before,.ion-ios-information-outline:before,.ion-ios-ionic-outline:before,.ion-ios-keypad:before,.ion-ios-keypad-outline:before,.ion-ios-lightbulb:before,.ion-ios-lightbulb-outline:before,.ion-ios-list:before,.ion-ios-list-outline:before,.ion-ios-location:before,.ion-ios-location-outline:before,.ion-ios-locked:before,.ion-ios-locked-outline:before,.ion-ios-loop:before,.ion-ios-loop-strong:before,.ion-ios-medical:before,.ion-ios-medical-outline:before,.ion-ios-medkit:before,.ion-ios-medkit-outline:before,.ion-ios-mic:before,.ion-ios-mic-off:before,.ion-ios-mic-outline:before,.ion-ios-minus:before,.ion-ios-minus-empty:before,.ion-ios-minus-outline:before,.ion-ios-monitor:before,.ion-ios-monitor-outline:before,.ion-ios-moon:before,.ion-ios-moon-outline:before,.ion-ios-more:before,.ion-ios-more-outline:before,.ion-ios-musical-note:before,.ion-ios-musical-notes:before,.ion-ios-navigate:before,.ion-ios-navigate-outline:before,.ion-ios-nutrition:before,.ion-ios-nutrition-outline:before,.ion-ios-paper:before,.ion-ios-paper-outline:before,.ion-ios-paperplane:before,.ion-ios-paperplane-outline:before,.ion-ios-partlysunny:before,.ion-ios-partlysunny-outline:before,.ion-ios-pause:before,.ion-ios-pause-outline:before,.ion-ios-paw:before,.ion-ios-paw-outline:before,.ion-ios-people:before,.ion-ios-people-outline:before,.ion-ios-person:before,.ion-ios-person-outline:before,.ion-ios-personadd:before,.ion-ios-personadd-outline:before,.ion-ios-photos:before,.ion-ios-photos-outline:before,.ion-ios-pie:before,.ion-ios-pie-outline:before,.ion-ios-pint:before,.ion-ios-pint-outline:before,.ion-ios-play:before,.ion-ios-play-outline:before,.ion-ios-plus:before,.ion-ios-plus-empty:before,.ion-ios-plus-outline:before,.ion-ios-pricetag:before,.ion-ios-pricetag-outline:before,.ion-ios-pricetags:before,.ion-ios-pricetags-outline:before,.ion-ios-printer:before,.ion-ios-printer-outline:before,.ion-ios-pulse:before,.ion-ios-pulse-strong:before,.ion-ios-rainy:before,.ion-ios-rainy-outline:before,.ion-ios-recording:before,.ion-ios-recording-outline:before,.ion-ios-redo:before,.ion-ios-redo-outline:before,.ion-ios-refresh:before,.ion-ios-refresh-empty:before,.ion-ios-refresh-outline:before,.ion-ios-reload:before,.ion-ios-reverse-camera:before,.ion-ios-reverse-camera-outline:before,.ion-ios-rewind:before,.ion-ios-rewind-outline:before,.ion-ios-rose:before,.ion-ios-rose-outline:before,.ion-ios-search:before,.ion-ios-search-strong:before,.ion-ios-settings:before,.ion-ios-settings-strong:before,.ion-ios-shuffle:before,.ion-ios-shuffle-strong:before,.ion-ios-skipbackward:before,.ion-ios-skipbackward-outline:before,.ion-ios-skipforward:before,.ion-ios-skipforward-outline:before,.ion-ios-snowy:before,.ion-ios-speedometer:before,.ion-ios-speedometer-outline:before,.ion-ios-star:before,.ion-ios-star-half:before,.ion-ios-star-outline:before,.ion-ios-stopwatch:before,.ion-ios-stopwatch-outline:before,.ion-ios-sunny:before,.ion-ios-sunny-outline:before,.ion-ios-telephone:before,.ion-ios-telephone-outline:before,.ion-ios-tennisball:before,.ion-ios-tennisball-outline:before,.ion-ios-thunderstorm:before,.ion-ios-thunderstorm-outline:before,.ion-ios-time:before,.ion-ios-time-outline:before,.ion-ios-timer:before,.ion-ios-timer-outline:before,.ion-ios-toggle:before,.ion-ios-toggle-outline:before,.ion-ios-trash:before,.ion-ios-trash-outline:before,.ion-ios-undo:before,.ion-ios-undo-outline:before,.ion-ios-unlocked:before,.ion-ios-unlocked-outline:before,.ion-ios-upload:before,.ion-ios-upload-outline:before,.ion-ios-videocam:before,.ion-ios-videocam-outline:before,.ion-ios-volume-high:before,.ion-ios-volume-low:before,.ion-ios-wineglass:before,.ion-ios-wineglass-outline:before,.ion-ios-world:before,.ion-ios-world-outline:before,.ion-ipad:before,.ion-iphone:before,.ion-ipod:before,.ion-jet:before,.ion-key:before,.ion-knife:before,.ion-laptop:before,.ion-leaf:before,.ion-levels:before,.ion-lightbulb:before,.ion-link:before,.ion-load-a:before,.ion-load-b:before,.ion-load-c:before,.ion-load-d:before,.ion-location:before,.ion-lock-combination:before,.ion-locked:before,.ion-log-in:before,.ion-log-out:before,.ion-loop:before,.ion-magnet:before,.ion-male:before,.ion-man:before,.ion-map:before,.ion-medkit:before,.ion-merge:before,.ion-mic-a:before,.ion-mic-b:before,.ion-mic-c:before,.ion-minus:before,.ion-minus-circled:before,.ion-minus-round:before,.ion-model-s:before,.ion-monitor:before,.ion-more:before,.ion-mouse:before,.ion-music-note:before,.ion-navicon:before,.ion-navicon-round:before,.ion-navigate:before,.ion-network:before,.ion-no-smoking:before,.ion-nuclear:before,.ion-outlet:before,.ion-paintbrush:before,.ion-paintbucket:before,.ion-paper-airplane:before,.ion-paperclip:before,.ion-pause:before,.ion-person:before,.ion-person-add:before,.ion-person-stalker:before,.ion-pie-graph:before,.ion-pin:before,.ion-pinpoint:before,.ion-pizza:before,.ion-plane:before,.ion-planet:before,.ion-play:before,.ion-playstation:before,.ion-plus:before,.ion-plus-circled:before,.ion-plus-round:before,.ion-podium:before,.ion-pound:before,.ion-power:before,.ion-pricetag:before,.ion-pricetags:before,.ion-printer:before,.ion-pull-request:before,.ion-qr-scanner:before,.ion-quote:before,.ion-radio-waves:before,.ion-record:before,.ion-refresh:before,.ion-reply:before,.ion-reply-all:before,.ion-ribbon-a:before,.ion-ribbon-b:before,.ion-sad:before,.ion-sad-outline:before,.ion-scissors:before,.ion-search:before,.ion-settings:before,.ion-share:before,.ion-shuffle:before,.ion-skip-backward:before,.ion-skip-forward:before,.ion-social-android:before,.ion-social-android-outline:before,.ion-social-angular:before,.ion-social-angular-outline:before,.ion-social-apple:before,.ion-social-apple-outline:before,.ion-social-bitcoin:before,.ion-social-bitcoin-outline:before,.ion-social-buffer:before,.ion-social-buffer-outline:before,.ion-social-chrome:before,.ion-social-chrome-outline:before,.ion-social-codepen:before,.ion-social-codepen-outline:before,.ion-social-css3:before,.ion-social-css3-outline:before,.ion-social-designernews:before,.ion-social-designernews-outline:before,.ion-social-dribbble:before,.ion-social-dribbble-outline:before,.ion-social-dropbox:before,.ion-social-dropbox-outline:before,.ion-social-euro:before,.ion-social-euro-outline:before,.ion-social-facebook:before,.ion-social-facebook-outline:before,.ion-social-foursquare:before,.ion-social-foursquare-outline:before,.ion-social-freebsd-devil:before,.ion-social-github:before,.ion-social-github-outline:before,.ion-social-google:before,.ion-social-google-outline:before,.ion-social-googleplus:before,.ion-social-googleplus-outline:before,.ion-social-hackernews:before,.ion-social-hackernews-outline:before,.ion-social-html5:before,.ion-social-html5-outline:before,.ion-social-instagram:before,.ion-social-instagram-outline:before,.ion-social-javascript:before,.ion-social-javascript-outline:before,.ion-social-linkedin:before,.ion-social-linkedin-outline:before,.ion-social-markdown:before,.ion-social-nodejs:before,.ion-social-octocat:before,.ion-social-pinterest:before,.ion-social-pinterest-outline:before,.ion-social-python:before,.ion-social-reddit:before,.ion-social-reddit-outline:before,.ion-social-rss:before,.ion-social-rss-outline:before,.ion-social-sass:before,.ion-social-skype:before,.ion-social-skype-outline:before,.ion-social-snapchat:before,.ion-social-snapchat-outline:before,.ion-social-tumblr:before,.ion-social-tumblr-outline:before,.ion-social-tux:before,.ion-social-twitch:before,.ion-social-twitch-outline:before,.ion-social-twitter:before,.ion-social-twitter-outline:before,.ion-social-usd:before,.ion-social-usd-outline:before,.ion-social-vimeo:before,.ion-social-vimeo-outline:before,.ion-social-whatsapp:before,.ion-social-whatsapp-outline:before,.ion-social-windows:before,.ion-social-windows-outline:before,.ion-social-wordpress:before,.ion-social-wordpress-outline:before,.ion-social-yahoo:before,.ion-social-yahoo-outline:before,.ion-social-yen:before,.ion-social-yen-outline:before,.ion-social-youtube:before,.ion-social-youtube-outline:before,.ion-soup-can:before,.ion-soup-can-outline:before,.ion-speakerphone:before,.ion-speedometer:before,.ion-spoon:before,.ion-star:before,.ion-stats-bars:before,.ion-steam:before,.ion-stop:before,.ion-thermometer:before,.ion-thumbsdown:before,.ion-thumbsup:before,.ion-toggle:before,.ion-toggle-filled:before,.ion-transgender:before,.ion-trash-a:before,.ion-trash-b:before,.ion-trophy:before,.ion-tshirt:before,.ion-tshirt-outline:before,.ion-umbrella:before,.ion-university:before,.ion-unlocked:before,.ion-upload:before,.ion-usb:before,.ion-videocamera:before,.ion-volume-high:before,.ion-volume-low:before,.ion-volume-medium:before,.ion-volume-mute:before,.ion-wand:before,.ion-waterdrop:before,.ion-wifi:before,.ion-wineglass:before,.ion-woman:before,.ion-wrench:before,.ion-xbox:before{display:inline-block;font-family:Ionicons;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;text-rendering:auto;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.ion-alert:before{content:\"\\f101\"}.ion-alert-circled:before{content:\"\\f100\"}.ion-android-add:before{content:\"\\f2c7\"}.ion-android-add-circle:before{content:\"\\f359\"}.ion-android-alarm-clock:before{content:\"\\f35a\"}.ion-android-alert:before{content:\"\\f35b\"}.ion-android-apps:before{content:\"\\f35c\"}.ion-android-archive:before{content:\"\\f2c9\"}.ion-android-arrow-back:before{content:\"\\f2ca\"}.ion-android-arrow-down:before{content:\"\\f35d\"}.ion-android-arrow-dropdown:before{content:\"\\f35f\"}.ion-android-arrow-dropdown-circle:before{content:\"\\f35e\"}.ion-android-arrow-dropleft:before{content:\"\\f361\"}.ion-android-arrow-dropleft-circle:before{content:\"\\f360\"}.ion-android-arrow-dropright:before{content:\"\\f363\"}.ion-android-arrow-dropright-circle:before{content:\"\\f362\"}.ion-android-arrow-dropup:before{content:\"\\f365\"}.ion-android-arrow-dropup-circle:before{content:\"\\f364\"}.ion-android-arrow-forward:before{content:\"\\f30f\"}.ion-android-arrow-up:before{content:\"\\f366\"}.ion-android-attach:before{content:\"\\f367\"}.ion-android-bar:before{content:\"\\f368\"}.ion-android-bicycle:before{content:\"\\f369\"}.ion-android-boat:before{content:\"\\f36a\"}.ion-android-bookmark:before{content:\"\\f36b\"}.ion-android-bulb:before{content:\"\\f36c\"}.ion-android-bus:before{content:\"\\f36d\"}.ion-android-calendar:before{content:\"\\f2d1\"}.ion-android-call:before{content:\"\\f2d2\"}.ion-android-camera:before{content:\"\\f2d3\"}.ion-android-cancel:before{content:\"\\f36e\"}.ion-android-car:before{content:\"\\f36f\"}.ion-android-cart:before{content:\"\\f370\"}.ion-android-chat:before{content:\"\\f2d4\"}.ion-android-checkbox:before{content:\"\\f374\"}.ion-android-checkbox-blank:before{content:\"\\f371\"}.ion-android-checkbox-outline:before{content:\"\\f373\"}.ion-android-checkbox-outline-blank:before{content:\"\\f372\"}.ion-android-checkmark-circle:before{content:\"\\f375\"}.ion-android-clipboard:before{content:\"\\f376\"}.ion-android-close:before{content:\"\\f2d7\"}.ion-android-cloud:before{content:\"\\f37a\"}.ion-android-cloud-circle:before{content:\"\\f377\"}.ion-android-cloud-done:before{content:\"\\f378\"}.ion-android-cloud-outline:before{content:\"\\f379\"}.ion-android-color-palette:before{content:\"\\f37b\"}.ion-android-compass:before{content:\"\\f37c\"}.ion-android-contact:before{content:\"\\f2d8\"}.ion-android-contacts:before{content:\"\\f2d9\"}.ion-android-contract:before{content:\"\\f37d\"}.ion-android-create:before{content:\"\\f37e\"}.ion-android-delete:before{content:\"\\f37f\"}.ion-android-desktop:before{content:\"\\f380\"}.ion-android-document:before{content:\"\\f381\"}.ion-android-done:before{content:\"\\f383\"}.ion-android-done-all:before{content:\"\\f382\"}.ion-android-download:before{content:\"\\f2dd\"}.ion-android-drafts:before{content:\"\\f384\"}.ion-android-exit:before{content:\"\\f385\"}.ion-android-expand:before{content:\"\\f386\"}.ion-android-favorite:before{content:\"\\f388\"}.ion-android-favorite-outline:before{content:\"\\f387\"}.ion-android-film:before{content:\"\\f389\"}.ion-android-folder:before{content:\"\\f2e0\"}.ion-android-folder-open:before{content:\"\\f38a\"}.ion-android-funnel:before{content:\"\\f38b\"}.ion-android-globe:before{content:\"\\f38c\"}.ion-android-hand:before{content:\"\\f2e3\"}.ion-android-hangout:before{content:\"\\f38d\"}.ion-android-happy:before{content:\"\\f38e\"}.ion-android-home:before{content:\"\\f38f\"}.ion-android-image:before{content:\"\\f2e4\"}.ion-android-laptop:before{content:\"\\f390\"}.ion-android-list:before{content:\"\\f391\"}.ion-android-locate:before{content:\"\\f2e9\"}.ion-android-lock:before{content:\"\\f392\"}.ion-android-mail:before{content:\"\\f2eb\"}.ion-android-map:before{content:\"\\f393\"}.ion-android-menu:before{content:\"\\f394\"}.ion-android-microphone:before{content:\"\\f2ec\"}.ion-android-microphone-off:before{content:\"\\f395\"}.ion-android-more-horizontal:before{content:\"\\f396\"}.ion-android-more-vertical:before{content:\"\\f397\"}.ion-android-navigate:before{content:\"\\f398\"}.ion-android-notifications:before{content:\"\\f39b\"}.ion-android-notifications-none:before{content:\"\\f399\"}.ion-android-notifications-off:before{content:\"\\f39a\"}.ion-android-open:before{content:\"\\f39c\"}.ion-android-options:before{content:\"\\f39d\"}.ion-android-people:before{content:\"\\f39e\"}.ion-android-person:before{content:\"\\f3a0\"}.ion-android-person-add:before{content:\"\\f39f\"}.ion-android-phone-landscape:before{content:\"\\f3a1\"}.ion-android-phone-portrait:before{content:\"\\f3a2\"}.ion-android-pin:before{content:\"\\f3a3\"}.ion-android-plane:before{content:\"\\f3a4\"}.ion-android-playstore:before{content:\"\\f2f0\"}.ion-android-print:before{content:\"\\f3a5\"}.ion-android-radio-button-off:before{content:\"\\f3a6\"}.ion-android-radio-button-on:before{content:\"\\f3a7\"}.ion-android-refresh:before{content:\"\\f3a8\"}.ion-android-remove:before{content:\"\\f2f4\"}.ion-android-remove-circle:before{content:\"\\f3a9\"}.ion-android-restaurant:before{content:\"\\f3aa\"}.ion-android-sad:before{content:\"\\f3ab\"}.ion-android-search:before{content:\"\\f2f5\"}.ion-android-send:before{content:\"\\f2f6\"}.ion-android-settings:before{content:\"\\f2f7\"}.ion-android-share:before{content:\"\\f2f8\"}.ion-android-share-alt:before{content:\"\\f3ac\"}.ion-android-star:before{content:\"\\f2fc\"}.ion-android-star-half:before{content:\"\\f3ad\"}.ion-android-star-outline:before{content:\"\\f3ae\"}.ion-android-stopwatch:before{content:\"\\f2fd\"}.ion-android-subway:before{content:\"\\f3af\"}.ion-android-sunny:before{content:\"\\f3b0\"}.ion-android-sync:before{content:\"\\f3b1\"}.ion-android-textsms:before{content:\"\\f3b2\"}.ion-android-time:before{content:\"\\f3b3\"}.ion-android-train:before{content:\"\\f3b4\"}.ion-android-unlock:before{content:\"\\f3b5\"}.ion-android-upload:before{content:\"\\f3b6\"}.ion-android-volume-down:before{content:\"\\f3b7\"}.ion-android-volume-mute:before{content:\"\\f3b8\"}.ion-android-volume-off:before{content:\"\\f3b9\"}.ion-android-volume-up:before{content:\"\\f3ba\"}.ion-android-walk:before{content:\"\\f3bb\"}.ion-android-warning:before{content:\"\\f3bc\"}.ion-android-watch:before{content:\"\\f3bd\"}.ion-android-wifi:before{content:\"\\f305\"}.ion-aperture:before{content:\"\\f313\"}.ion-archive:before{content:\"\\f102\"}.ion-arrow-down-a:before{content:\"\\f103\"}.ion-arrow-down-b:before{content:\"\\f104\"}.ion-arrow-down-c:before{content:\"\\f105\"}.ion-arrow-expand:before{content:\"\\f25e\"}.ion-arrow-graph-down-left:before{content:\"\\f25f\"}.ion-arrow-graph-down-right:before{content:\"\\f260\"}.ion-arrow-graph-up-left:before{content:\"\\f261\"}.ion-arrow-graph-up-right:before{content:\"\\f262\"}.ion-arrow-left-a:before{content:\"\\f106\"}.ion-arrow-left-b:before{content:\"\\f107\"}.ion-arrow-left-c:before{content:\"\\f108\"}.ion-arrow-move:before{content:\"\\f263\"}.ion-arrow-resize:before{content:\"\\f264\"}.ion-arrow-return-left:before{content:\"\\f265\"}.ion-arrow-return-right:before{content:\"\\f266\"}.ion-arrow-right-a:before{content:\"\\f109\"}.ion-arrow-right-b:before{content:\"\\f10a\"}.ion-arrow-right-c:before{content:\"\\f10b\"}.ion-arrow-shrink:before{content:\"\\f267\"}.ion-arrow-swap:before{content:\"\\f268\"}.ion-arrow-up-a:before{content:\"\\f10c\"}.ion-arrow-up-b:before{content:\"\\f10d\"}.ion-arrow-up-c:before{content:\"\\f10e\"}.ion-asterisk:before{content:\"\\f314\"}.ion-at:before{content:\"\\f10f\"}.ion-backspace:before{content:\"\\f3bf\"}.ion-backspace-outline:before{content:\"\\f3be\"}.ion-bag:before{content:\"\\f110\"}.ion-battery-charging:before{content:\"\\f111\"}.ion-battery-empty:before{content:\"\\f112\"}.ion-battery-full:before{content:\"\\f113\"}.ion-battery-half:before{content:\"\\f114\"}.ion-battery-low:before{content:\"\\f115\"}.ion-beaker:before{content:\"\\f269\"}.ion-beer:before{content:\"\\f26a\"}.ion-bluetooth:before{content:\"\\f116\"}.ion-bonfire:before{content:\"\\f315\"}.ion-bookmark:before{content:\"\\f26b\"}.ion-bowtie:before{content:\"\\f3c0\"}.ion-briefcase:before{content:\"\\f26c\"}.ion-bug:before{content:\"\\f2be\"}.ion-calculator:before{content:\"\\f26d\"}.ion-calendar:before{content:\"\\f117\"}.ion-camera:before{content:\"\\f118\"}.ion-card:before{content:\"\\f119\"}.ion-cash:before{content:\"\\f316\"}.ion-chatbox:before{content:\"\\f11b\"}.ion-chatbox-working:before{content:\"\\f11a\"}.ion-chatboxes:before{content:\"\\f11c\"}.ion-chatbubble:before{content:\"\\f11e\"}.ion-chatbubble-working:before{content:\"\\f11d\"}.ion-chatbubbles:before{content:\"\\f11f\"}.ion-checkmark:before{content:\"\\f122\"}.ion-checkmark-circled:before{content:\"\\f120\"}.ion-checkmark-round:before{content:\"\\f121\"}.ion-chevron-down:before{content:\"\\f123\"}.ion-chevron-left:before{content:\"\\f124\"}.ion-chevron-right:before{content:\"\\f125\"}.ion-chevron-up:before{content:\"\\f126\"}.ion-clipboard:before{content:\"\\f127\"}.ion-clock:before{content:\"\\f26e\"}.ion-close:before{content:\"\\f12a\"}.ion-close-circled:before{content:\"\\f128\"}.ion-close-round:before{content:\"\\f129\"}.ion-closed-captioning:before{content:\"\\f317\"}.ion-cloud:before{content:\"\\f12b\"}.ion-code:before{content:\"\\f271\"}.ion-code-download:before{content:\"\\f26f\"}.ion-code-working:before{content:\"\\f270\"}.ion-coffee:before{content:\"\\f272\"}.ion-compass:before{content:\"\\f273\"}.ion-compose:before{content:\"\\f12c\"}.ion-connection-bars:before{content:\"\\f274\"}.ion-contrast:before{content:\"\\f275\"}.ion-crop:before{content:\"\\f3c1\"}.ion-cube:before{content:\"\\f318\"}.ion-disc:before{content:\"\\f12d\"}.ion-document:before{content:\"\\f12f\"}.ion-document-text:before{content:\"\\f12e\"}.ion-drag:before{content:\"\\f130\"}.ion-earth:before{content:\"\\f276\"}.ion-easel:before{content:\"\\f3c2\"}.ion-edit:before{content:\"\\f2bf\"}.ion-egg:before{content:\"\\f277\"}.ion-eject:before{content:\"\\f131\"}.ion-email:before{content:\"\\f132\"}.ion-email-unread:before{content:\"\\f3c3\"}.ion-erlenmeyer-flask:before{content:\"\\f3c5\"}.ion-erlenmeyer-flask-bubbles:before{content:\"\\f3c4\"}.ion-eye:before{content:\"\\f133\"}.ion-eye-disabled:before{content:\"\\f306\"}.ion-female:before{content:\"\\f278\"}.ion-filing:before{content:\"\\f134\"}.ion-film-marker:before{content:\"\\f135\"}.ion-fireball:before{content:\"\\f319\"}.ion-flag:before{content:\"\\f279\"}.ion-flame:before{content:\"\\f31a\"}.ion-flash:before{content:\"\\f137\"}.ion-flash-off:before{content:\"\\f136\"}.ion-folder:before{content:\"\\f139\"}.ion-fork:before{content:\"\\f27a\"}.ion-fork-repo:before{content:\"\\f2c0\"}.ion-forward:before{content:\"\\f13a\"}.ion-funnel:before{content:\"\\f31b\"}.ion-gear-a:before{content:\"\\f13d\"}.ion-gear-b:before{content:\"\\f13e\"}.ion-grid:before{content:\"\\f13f\"}.ion-hammer:before{content:\"\\f27b\"}.ion-happy:before{content:\"\\f31c\"}.ion-happy-outline:before{content:\"\\f3c6\"}.ion-headphone:before{content:\"\\f140\"}.ion-heart:before{content:\"\\f141\"}.ion-heart-broken:before{content:\"\\f31d\"}.ion-help:before{content:\"\\f143\"}.ion-help-buoy:before{content:\"\\f27c\"}.ion-help-circled:before{content:\"\\f142\"}.ion-home:before{content:\"\\f144\"}.ion-icecream:before{content:\"\\f27d\"}.ion-image:before{content:\"\\f147\"}.ion-images:before{content:\"\\f148\"}.ion-information:before{content:\"\\f14a\"}.ion-information-circled:before{content:\"\\f149\"}.ion-ionic:before{content:\"\\f14b\"}.ion-ios-alarm:before{content:\"\\f3c8\"}.ion-ios-alarm-outline:before{content:\"\\f3c7\"}.ion-ios-albums:before{content:\"\\f3ca\"}.ion-ios-albums-outline:before{content:\"\\f3c9\"}.ion-ios-americanfootball:before{content:\"\\f3cc\"}.ion-ios-americanfootball-outline:before{content:\"\\f3cb\"}.ion-ios-analytics:before{content:\"\\f3ce\"}.ion-ios-analytics-outline:before{content:\"\\f3cd\"}.ion-ios-arrow-back:before{content:\"\\f3cf\"}.ion-ios-arrow-down:before{content:\"\\f3d0\"}.ion-ios-arrow-forward:before{content:\"\\f3d1\"}.ion-ios-arrow-left:before{content:\"\\f3d2\"}.ion-ios-arrow-right:before{content:\"\\f3d3\"}.ion-ios-arrow-thin-down:before{content:\"\\f3d4\"}.ion-ios-arrow-thin-left:before{content:\"\\f3d5\"}.ion-ios-arrow-thin-right:before{content:\"\\f3d6\"}.ion-ios-arrow-thin-up:before{content:\"\\f3d7\"}.ion-ios-arrow-up:before{content:\"\\f3d8\"}.ion-ios-at:before{content:\"\\f3da\"}.ion-ios-at-outline:before{content:\"\\f3d9\"}.ion-ios-barcode:before{content:\"\\f3dc\"}.ion-ios-barcode-outline:before{content:\"\\f3db\"}.ion-ios-baseball:before{content:\"\\f3de\"}.ion-ios-baseball-outline:before{content:\"\\f3dd\"}.ion-ios-basketball:before{content:\"\\f3e0\"}.ion-ios-basketball-outline:before{content:\"\\f3df\"}.ion-ios-bell:before{content:\"\\f3e2\"}.ion-ios-bell-outline:before{content:\"\\f3e1\"}.ion-ios-body:before{content:\"\\f3e4\"}.ion-ios-body-outline:before{content:\"\\f3e3\"}.ion-ios-bolt:before{content:\"\\f3e6\"}.ion-ios-bolt-outline:before{content:\"\\f3e5\"}.ion-ios-book:before{content:\"\\f3e8\"}.ion-ios-book-outline:before{content:\"\\f3e7\"}.ion-ios-bookmarks:before{content:\"\\f3ea\"}.ion-ios-bookmarks-outline:before{content:\"\\f3e9\"}.ion-ios-box:before{content:\"\\f3ec\"}.ion-ios-box-outline:before{content:\"\\f3eb\"}.ion-ios-briefcase:before{content:\"\\f3ee\"}.ion-ios-briefcase-outline:before{content:\"\\f3ed\"}.ion-ios-browsers:before{content:\"\\f3f0\"}.ion-ios-browsers-outline:before{content:\"\\f3ef\"}.ion-ios-calculator:before{content:\"\\f3f2\"}.ion-ios-calculator-outline:before{content:\"\\f3f1\"}.ion-ios-calendar:before{content:\"\\f3f4\"}.ion-ios-calendar-outline:before{content:\"\\f3f3\"}.ion-ios-camera:before{content:\"\\f3f6\"}.ion-ios-camera-outline:before{content:\"\\f3f5\"}.ion-ios-cart:before{content:\"\\f3f8\"}.ion-ios-cart-outline:before{content:\"\\f3f7\"}.ion-ios-chatboxes:before{content:\"\\f3fa\"}.ion-ios-chatboxes-outline:before{content:\"\\f3f9\"}.ion-ios-chatbubble:before{content:\"\\f3fc\"}.ion-ios-chatbubble-outline:before{content:\"\\f3fb\"}.ion-ios-checkmark:before{content:\"\\f3ff\"}.ion-ios-checkmark-empty:before{content:\"\\f3fd\"}.ion-ios-checkmark-outline:before{content:\"\\f3fe\"}.ion-ios-circle-filled:before{content:\"\\f400\"}.ion-ios-circle-outline:before{content:\"\\f401\"}.ion-ios-clock:before{content:\"\\f403\"}.ion-ios-clock-outline:before{content:\"\\f402\"}.ion-ios-close:before{content:\"\\f406\"}.ion-ios-close-empty:before{content:\"\\f404\"}.ion-ios-close-outline:before{content:\"\\f405\"}.ion-ios-cloud:before{content:\"\\f40c\"}.ion-ios-cloud-download:before{content:\"\\f408\"}.ion-ios-cloud-download-outline:before{content:\"\\f407\"}.ion-ios-cloud-outline:before{content:\"\\f409\"}.ion-ios-cloud-upload:before{content:\"\\f40b\"}.ion-ios-cloud-upload-outline:before{content:\"\\f40a\"}.ion-ios-cloudy:before{content:\"\\f410\"}.ion-ios-cloudy-night:before{content:\"\\f40e\"}.ion-ios-cloudy-night-outline:before{content:\"\\f40d\"}.ion-ios-cloudy-outline:before{content:\"\\f40f\"}.ion-ios-cog:before{content:\"\\f412\"}.ion-ios-cog-outline:before{content:\"\\f411\"}.ion-ios-color-filter:before{content:\"\\f414\"}.ion-ios-color-filter-outline:before{content:\"\\f413\"}.ion-ios-color-wand:before{content:\"\\f416\"}.ion-ios-color-wand-outline:before{content:\"\\f415\"}.ion-ios-compose:before{content:\"\\f418\"}.ion-ios-compose-outline:before{content:\"\\f417\"}.ion-ios-contact:before{content:\"\\f41a\"}.ion-ios-contact-outline:before{content:\"\\f419\"}.ion-ios-copy:before{content:\"\\f41c\"}.ion-ios-copy-outline:before{content:\"\\f41b\"}.ion-ios-crop:before{content:\"\\f41e\"}.ion-ios-crop-strong:before{content:\"\\f41d\"}.ion-ios-download:before{content:\"\\f420\"}.ion-ios-download-outline:before{content:\"\\f41f\"}.ion-ios-drag:before{content:\"\\f421\"}.ion-ios-email:before{content:\"\\f423\"}.ion-ios-email-outline:before{content:\"\\f422\"}.ion-ios-eye:before{content:\"\\f425\"}.ion-ios-eye-outline:before{content:\"\\f424\"}.ion-ios-fastforward:before{content:\"\\f427\"}.ion-ios-fastforward-outline:before{content:\"\\f426\"}.ion-ios-filing:before{content:\"\\f429\"}.ion-ios-filing-outline:before{content:\"\\f428\"}.ion-ios-film:before{content:\"\\f42b\"}.ion-ios-film-outline:before{content:\"\\f42a\"}.ion-ios-flag:before{content:\"\\f42d\"}.ion-ios-flag-outline:before{content:\"\\f42c\"}.ion-ios-flame:before{content:\"\\f42f\"}.ion-ios-flame-outline:before{content:\"\\f42e\"}.ion-ios-flask:before{content:\"\\f431\"}.ion-ios-flask-outline:before{content:\"\\f430\"}.ion-ios-flower:before{content:\"\\f433\"}.ion-ios-flower-outline:before{content:\"\\f432\"}.ion-ios-folder:before{content:\"\\f435\"}.ion-ios-folder-outline:before{content:\"\\f434\"}.ion-ios-football:before{content:\"\\f437\"}.ion-ios-football-outline:before{content:\"\\f436\"}.ion-ios-game-controller-a:before{content:\"\\f439\"}.ion-ios-game-controller-a-outline:before{content:\"\\f438\"}.ion-ios-game-controller-b:before{content:\"\\f43b\"}.ion-ios-game-controller-b-outline:before{content:\"\\f43a\"}.ion-ios-gear:before{content:\"\\f43d\"}.ion-ios-gear-outline:before{content:\"\\f43c\"}.ion-ios-glasses:before{content:\"\\f43f\"}.ion-ios-glasses-outline:before{content:\"\\f43e\"}.ion-ios-grid-view:before{content:\"\\f441\"}.ion-ios-grid-view-outline:before{content:\"\\f440\"}.ion-ios-heart:before{content:\"\\f443\"}.ion-ios-heart-outline:before{content:\"\\f442\"}.ion-ios-help:before{content:\"\\f446\"}.ion-ios-help-empty:before{content:\"\\f444\"}.ion-ios-help-outline:before{content:\"\\f445\"}.ion-ios-home:before{content:\"\\f448\"}.ion-ios-home-outline:before{content:\"\\f447\"}.ion-ios-infinite:before{content:\"\\f44a\"}.ion-ios-infinite-outline:before{content:\"\\f449\"}.ion-ios-information:before{content:\"\\f44d\"}.ion-ios-information-empty:before{content:\"\\f44b\"}.ion-ios-information-outline:before{content:\"\\f44c\"}.ion-ios-ionic-outline:before{content:\"\\f44e\"}.ion-ios-keypad:before{content:\"\\f450\"}.ion-ios-keypad-outline:before{content:\"\\f44f\"}.ion-ios-lightbulb:before{content:\"\\f452\"}.ion-ios-lightbulb-outline:before{content:\"\\f451\"}.ion-ios-list:before{content:\"\\f454\"}.ion-ios-list-outline:before{content:\"\\f453\"}.ion-ios-location:before{content:\"\\f456\"}.ion-ios-location-outline:before{content:\"\\f455\"}.ion-ios-locked:before{content:\"\\f458\"}.ion-ios-locked-outline:before{content:\"\\f457\"}.ion-ios-loop:before{content:\"\\f45a\"}.ion-ios-loop-strong:before{content:\"\\f459\"}.ion-ios-medical:before{content:\"\\f45c\"}.ion-ios-medical-outline:before{content:\"\\f45b\"}.ion-ios-medkit:before{content:\"\\f45e\"}.ion-ios-medkit-outline:before{content:\"\\f45d\"}.ion-ios-mic:before{content:\"\\f461\"}.ion-ios-mic-off:before{content:\"\\f45f\"}.ion-ios-mic-outline:before{content:\"\\f460\"}.ion-ios-minus:before{content:\"\\f464\"}.ion-ios-minus-empty:before{content:\"\\f462\"}.ion-ios-minus-outline:before{content:\"\\f463\"}.ion-ios-monitor:before{content:\"\\f466\"}.ion-ios-monitor-outline:before{content:\"\\f465\"}.ion-ios-moon:before{content:\"\\f468\"}.ion-ios-moon-outline:before{content:\"\\f467\"}.ion-ios-more:before{content:\"\\f46a\"}.ion-ios-more-outline:before{content:\"\\f469\"}.ion-ios-musical-note:before{content:\"\\f46b\"}.ion-ios-musical-notes:before{content:\"\\f46c\"}.ion-ios-navigate:before{content:\"\\f46e\"}.ion-ios-navigate-outline:before{content:\"\\f46d\"}.ion-ios-nutrition:before{content:\"\\f470\"}.ion-ios-nutrition-outline:before{content:\"\\f46f\"}.ion-ios-paper:before{content:\"\\f472\"}.ion-ios-paper-outline:before{content:\"\\f471\"}.ion-ios-paperplane:before{content:\"\\f474\"}.ion-ios-paperplane-outline:before{content:\"\\f473\"}.ion-ios-partlysunny:before{content:\"\\f476\"}.ion-ios-partlysunny-outline:before{content:\"\\f475\"}.ion-ios-pause:before{content:\"\\f478\"}.ion-ios-pause-outline:before{content:\"\\f477\"}.ion-ios-paw:before{content:\"\\f47a\"}.ion-ios-paw-outline:before{content:\"\\f479\"}.ion-ios-people:before{content:\"\\f47c\"}.ion-ios-people-outline:before{content:\"\\f47b\"}.ion-ios-person:before{content:\"\\f47e\"}.ion-ios-person-outline:before{content:\"\\f47d\"}.ion-ios-personadd:before{content:\"\\f480\"}.ion-ios-personadd-outline:before{content:\"\\f47f\"}.ion-ios-photos:before{content:\"\\f482\"}.ion-ios-photos-outline:before{content:\"\\f481\"}.ion-ios-pie:before{content:\"\\f484\"}.ion-ios-pie-outline:before{content:\"\\f483\"}.ion-ios-pint:before{content:\"\\f486\"}.ion-ios-pint-outline:before{content:\"\\f485\"}.ion-ios-play:before{content:\"\\f488\"}.ion-ios-play-outline:before{content:\"\\f487\"}.ion-ios-plus:before{content:\"\\f48b\"}.ion-ios-plus-empty:before{content:\"\\f489\"}.ion-ios-plus-outline:before{content:\"\\f48a\"}.ion-ios-pricetag:before{content:\"\\f48d\"}.ion-ios-pricetag-outline:before{content:\"\\f48c\"}.ion-ios-pricetags:before{content:\"\\f48f\"}.ion-ios-pricetags-outline:before{content:\"\\f48e\"}.ion-ios-printer:before{content:\"\\f491\"}.ion-ios-printer-outline:before{content:\"\\f490\"}.ion-ios-pulse:before{content:\"\\f493\"}.ion-ios-pulse-strong:before{content:\"\\f492\"}.ion-ios-rainy:before{content:\"\\f495\"}.ion-ios-rainy-outline:before{content:\"\\f494\"}.ion-ios-recording:before{content:\"\\f497\"}.ion-ios-recording-outline:before{content:\"\\f496\"}.ion-ios-redo:before{content:\"\\f499\"}.ion-ios-redo-outline:before{content:\"\\f498\"}.ion-ios-refresh:before{content:\"\\f49c\"}.ion-ios-refresh-empty:before{content:\"\\f49a\"}.ion-ios-refresh-outline:before{content:\"\\f49b\"}.ion-ios-reload:before{content:\"\\f49d\"}.ion-ios-reverse-camera:before{content:\"\\f49f\"}.ion-ios-reverse-camera-outline:before{content:\"\\f49e\"}.ion-ios-rewind:before{content:\"\\f4a1\"}.ion-ios-rewind-outline:before{content:\"\\f4a0\"}.ion-ios-rose:before{content:\"\\f4a3\"}.ion-ios-rose-outline:before{content:\"\\f4a2\"}.ion-ios-search:before{content:\"\\f4a5\"}.ion-ios-search-strong:before{content:\"\\f4a4\"}.ion-ios-settings:before{content:\"\\f4a7\"}.ion-ios-settings-strong:before{content:\"\\f4a6\"}.ion-ios-shuffle:before{content:\"\\f4a9\"}.ion-ios-shuffle-strong:before{content:\"\\f4a8\"}.ion-ios-skipbackward:before{content:\"\\f4ab\"}.ion-ios-skipbackward-outline:before{content:\"\\f4aa\"}.ion-ios-skipforward:before{content:\"\\f4ad\"}.ion-ios-skipforward-outline:before{content:\"\\f4ac\"}.ion-ios-snowy:before{content:\"\\f4ae\"}.ion-ios-speedometer:before{content:\"\\f4b0\"}.ion-ios-speedometer-outline:before{content:\"\\f4af\"}.ion-ios-star:before{content:\"\\f4b3\"}.ion-ios-star-half:before{content:\"\\f4b1\"}.ion-ios-star-outline:before{content:\"\\f4b2\"}.ion-ios-stopwatch:before{content:\"\\f4b5\"}.ion-ios-stopwatch-outline:before{content:\"\\f4b4\"}.ion-ios-sunny:before{content:\"\\f4b7\"}.ion-ios-sunny-outline:before{content:\"\\f4b6\"}.ion-ios-telephone:before{content:\"\\f4b9\"}.ion-ios-telephone-outline:before{content:\"\\f4b8\"}.ion-ios-tennisball:before{content:\"\\f4bb\"}.ion-ios-tennisball-outline:before{content:\"\\f4ba\"}.ion-ios-thunderstorm:before{content:\"\\f4bd\"}.ion-ios-thunderstorm-outline:before{content:\"\\f4bc\"}.ion-ios-time:before{content:\"\\f4bf\"}.ion-ios-time-outline:before{content:\"\\f4be\"}.ion-ios-timer:before{content:\"\\f4c1\"}.ion-ios-timer-outline:before{content:\"\\f4c0\"}.ion-ios-toggle:before{content:\"\\f4c3\"}.ion-ios-toggle-outline:before{content:\"\\f4c2\"}.ion-ios-trash:before{content:\"\\f4c5\"}.ion-ios-trash-outline:before{content:\"\\f4c4\"}.ion-ios-undo:before{content:\"\\f4c7\"}.ion-ios-undo-outline:before{content:\"\\f4c6\"}.ion-ios-unlocked:before{content:\"\\f4c9\"}.ion-ios-unlocked-outline:before{content:\"\\f4c8\"}.ion-ios-upload:before{content:\"\\f4cb\"}.ion-ios-upload-outline:before{content:\"\\f4ca\"}.ion-ios-videocam:before{content:\"\\f4cd\"}.ion-ios-videocam-outline:before{content:\"\\f4cc\"}.ion-ios-volume-high:before{content:\"\\f4ce\"}.ion-ios-volume-low:before{content:\"\\f4cf\"}.ion-ios-wineglass:before{content:\"\\f4d1\"}.ion-ios-wineglass-outline:before{content:\"\\f4d0\"}.ion-ios-world:before{content:\"\\f4d3\"}.ion-ios-world-outline:before{content:\"\\f4d2\"}.ion-ipad:before{content:\"\\f1f9\"}.ion-iphone:before{content:\"\\f1fa\"}.ion-ipod:before{content:\"\\f1fb\"}.ion-jet:before{content:\"\\f295\"}.ion-key:before{content:\"\\f296\"}.ion-knife:before{content:\"\\f297\"}.ion-laptop:before{content:\"\\f1fc\"}.ion-leaf:before{content:\"\\f1fd\"}.ion-levels:before{content:\"\\f298\"}.ion-lightbulb:before{content:\"\\f299\"}.ion-link:before{content:\"\\f1fe\"}.ion-load-a:before{content:\"\\f29a\"}.ion-load-b:before{content:\"\\f29b\"}.ion-load-c:before{content:\"\\f29c\"}.ion-load-d:before{content:\"\\f29d\"}.ion-location:before{content:\"\\f1ff\"}.ion-lock-combination:before{content:\"\\f4d4\"}.ion-locked:before{content:\"\\f200\"}.ion-log-in:before{content:\"\\f29e\"}.ion-log-out:before{content:\"\\f29f\"}.ion-loop:before{content:\"\\f201\"}.ion-magnet:before{content:\"\\f2a0\"}.ion-male:before{content:\"\\f2a1\"}.ion-man:before{content:\"\\f202\"}.ion-map:before{content:\"\\f203\"}.ion-medkit:before{content:\"\\f2a2\"}.ion-merge:before{content:\"\\f33f\"}.ion-mic-a:before{content:\"\\f204\"}.ion-mic-b:before{content:\"\\f205\"}.ion-mic-c:before{content:\"\\f206\"}.ion-minus:before{content:\"\\f209\"}.ion-minus-circled:before{content:\"\\f207\"}.ion-minus-round:before{content:\"\\f208\"}.ion-model-s:before{content:\"\\f2c1\"}.ion-monitor:before{content:\"\\f20a\"}.ion-more:before{content:\"\\f20b\"}.ion-mouse:before{content:\"\\f340\"}.ion-music-note:before{content:\"\\f20c\"}.ion-navicon:before{content:\"\\f20e\"}.ion-navicon-round:before{content:\"\\f20d\"}.ion-navigate:before{content:\"\\f2a3\"}.ion-network:before{content:\"\\f341\"}.ion-no-smoking:before{content:\"\\f2c2\"}.ion-nuclear:before{content:\"\\f2a4\"}.ion-outlet:before{content:\"\\f342\"}.ion-paintbrush:before{content:\"\\f4d5\"}.ion-paintbucket:before{content:\"\\f4d6\"}.ion-paper-airplane:before{content:\"\\f2c3\"}.ion-paperclip:before{content:\"\\f20f\"}.ion-pause:before{content:\"\\f210\"}.ion-person:before{content:\"\\f213\"}.ion-person-add:before{content:\"\\f211\"}.ion-person-stalker:before{content:\"\\f212\"}.ion-pie-graph:before{content:\"\\f2a5\"}.ion-pin:before{content:\"\\f2a6\"}.ion-pinpoint:before{content:\"\\f2a7\"}.ion-pizza:before{content:\"\\f2a8\"}.ion-plane:before{content:\"\\f214\"}.ion-planet:before{content:\"\\f343\"}.ion-play:before{content:\"\\f215\"}.ion-playstation:before{content:\"\\f30a\"}.ion-plus:before{content:\"\\f218\"}.ion-plus-circled:before{content:\"\\f216\"}.ion-plus-round:before{content:\"\\f217\"}.ion-podium:before{content:\"\\f344\"}.ion-pound:before{content:\"\\f219\"}.ion-power:before{content:\"\\f2a9\"}.ion-pricetag:before{content:\"\\f2aa\"}.ion-pricetags:before{content:\"\\f2ab\"}.ion-printer:before{content:\"\\f21a\"}.ion-pull-request:before{content:\"\\f345\"}.ion-qr-scanner:before{content:\"\\f346\"}.ion-quote:before{content:\"\\f347\"}.ion-radio-waves:before{content:\"\\f2ac\"}.ion-record:before{content:\"\\f21b\"}.ion-refresh:before{content:\"\\f21c\"}.ion-reply:before{content:\"\\f21e\"}.ion-reply-all:before{content:\"\\f21d\"}.ion-ribbon-a:before{content:\"\\f348\"}.ion-ribbon-b:before{content:\"\\f349\"}.ion-sad:before{content:\"\\f34a\"}.ion-sad-outline:before{content:\"\\f4d7\"}.ion-scissors:before{content:\"\\f34b\"}.ion-search:before{content:\"\\f21f\"}.ion-settings:before{content:\"\\f2ad\"}.ion-share:before{content:\"\\f220\"}.ion-shuffle:before{content:\"\\f221\"}.ion-skip-backward:before{content:\"\\f222\"}.ion-skip-forward:before{content:\"\\f223\"}.ion-social-android:before{content:\"\\f225\"}.ion-social-android-outline:before{content:\"\\f224\"}.ion-social-angular:before{content:\"\\f4d9\"}.ion-social-angular-outline:before{content:\"\\f4d8\"}.ion-social-apple:before{content:\"\\f227\"}.ion-social-apple-outline:before{content:\"\\f226\"}.ion-social-bitcoin:before{content:\"\\f2af\"}.ion-social-bitcoin-outline:before{content:\"\\f2ae\"}.ion-social-buffer:before{content:\"\\f229\"}.ion-social-buffer-outline:before{content:\"\\f228\"}.ion-social-chrome:before{content:\"\\f4db\"}.ion-social-chrome-outline:before{content:\"\\f4da\"}.ion-social-codepen:before{content:\"\\f4dd\"}.ion-social-codepen-outline:before{content:\"\\f4dc\"}.ion-social-css3:before{content:\"\\f4df\"}.ion-social-css3-outline:before{content:\"\\f4de\"}.ion-social-designernews:before{content:\"\\f22b\"}.ion-social-designernews-outline:before{content:\"\\f22a\"}.ion-social-dribbble:before{content:\"\\f22d\"}.ion-social-dribbble-outline:before{content:\"\\f22c\"}.ion-social-dropbox:before{content:\"\\f22f\"}.ion-social-dropbox-outline:before{content:\"\\f22e\"}.ion-social-euro:before{content:\"\\f4e1\"}.ion-social-euro-outline:before{content:\"\\f4e0\"}.ion-social-facebook:before{content:\"\\f231\"}.ion-social-facebook-outline:before{content:\"\\f230\"}.ion-social-foursquare:before{content:\"\\f34d\"}.ion-social-foursquare-outline:before{content:\"\\f34c\"}.ion-social-freebsd-devil:before{content:\"\\f2c4\"}.ion-social-github:before{content:\"\\f233\"}.ion-social-github-outline:before{content:\"\\f232\"}.ion-social-google:before{content:\"\\f34f\"}.ion-social-google-outline:before{content:\"\\f34e\"}.ion-social-googleplus:before{content:\"\\f235\"}.ion-social-googleplus-outline:before{content:\"\\f234\"}.ion-social-hackernews:before{content:\"\\f237\"}.ion-social-hackernews-outline:before{content:\"\\f236\"}.ion-social-html5:before{content:\"\\f4e3\"}.ion-social-html5-outline:before{content:\"\\f4e2\"}.ion-social-instagram:before{content:\"\\f351\"}.ion-social-instagram-outline:before{content:\"\\f350\"}.ion-social-javascript:before{content:\"\\f4e5\"}.ion-social-javascript-outline:before{content:\"\\f4e4\"}.ion-social-linkedin:before{content:\"\\f239\"}.ion-social-linkedin-outline:before{content:\"\\f238\"}.ion-social-markdown:before{content:\"\\f4e6\"}.ion-social-nodejs:before{content:\"\\f4e7\"}.ion-social-octocat:before{content:\"\\f4e8\"}.ion-social-pinterest:before{content:\"\\f2b1\"}.ion-social-pinterest-outline:before{content:\"\\f2b0\"}.ion-social-python:before{content:\"\\f4e9\"}.ion-social-reddit:before{content:\"\\f23b\"}.ion-social-reddit-outline:before{content:\"\\f23a\"}.ion-social-rss:before{content:\"\\f23d\"}.ion-social-rss-outline:before{content:\"\\f23c\"}.ion-social-sass:before{content:\"\\f4ea\"}.ion-social-skype:before{content:\"\\f23f\"}.ion-social-skype-outline:before{content:\"\\f23e\"}.ion-social-snapchat:before{content:\"\\f4ec\"}.ion-social-snapchat-outline:before{content:\"\\f4eb\"}.ion-social-tumblr:before{content:\"\\f241\"}.ion-social-tumblr-outline:before{content:\"\\f240\"}.ion-social-tux:before{content:\"\\f2c5\"}.ion-social-twitch:before{content:\"\\f4ee\"}.ion-social-twitch-outline:before{content:\"\\f4ed\"}.ion-social-twitter:before{content:\"\\f243\"}.ion-social-twitter-outline:before{content:\"\\f242\"}.ion-social-usd:before{content:\"\\f353\"}.ion-social-usd-outline:before{content:\"\\f352\"}.ion-social-vimeo:before{content:\"\\f245\"}.ion-social-vimeo-outline:before{content:\"\\f244\"}.ion-social-whatsapp:before{content:\"\\f4f0\"}.ion-social-whatsapp-outline:before{content:\"\\f4ef\"}.ion-social-windows:before{content:\"\\f247\"}.ion-social-windows-outline:before{content:\"\\f246\"}.ion-social-wordpress:before{content:\"\\f249\"}.ion-social-wordpress-outline:before{content:\"\\f248\"}.ion-social-yahoo:before{content:\"\\f24b\"}.ion-social-yahoo-outline:before{content:\"\\f24a\"}.ion-social-yen:before{content:\"\\f4f2\"}.ion-social-yen-outline:before{content:\"\\f4f1\"}.ion-social-youtube:before{content:\"\\f24d\"}.ion-social-youtube-outline:before{content:\"\\f24c\"}.ion-soup-can:before{content:\"\\f4f4\"}.ion-soup-can-outline:before{content:\"\\f4f3\"}.ion-speakerphone:before{content:\"\\f2b2\"}.ion-speedometer:before{content:\"\\f2b3\"}.ion-spoon:before{content:\"\\f2b4\"}.ion-star:before{content:\"\\f24e\"}.ion-stats-bars:before{content:\"\\f2b5\"}.ion-steam:before{content:\"\\f30b\"}.ion-stop:before{content:\"\\f24f\"}.ion-thermometer:before{content:\"\\f2b6\"}.ion-thumbsdown:before{content:\"\\f250\"}.ion-thumbsup:before{content:\"\\f251\"}.ion-toggle:before{content:\"\\f355\"}.ion-toggle-filled:before{content:\"\\f354\"}.ion-transgender:before{content:\"\\f4f5\"}.ion-trash-a:before{content:\"\\f252\"}.ion-trash-b:before{content:\"\\f253\"}.ion-trophy:before{content:\"\\f356\"}.ion-tshirt:before{content:\"\\f4f7\"}.ion-tshirt-outline:before{content:\"\\f4f6\"}.ion-umbrella:before{content:\"\\f2b7\"}.ion-university:before{content:\"\\f357\"}.ion-unlocked:before{content:\"\\f254\"}.ion-upload:before{content:\"\\f255\"}.ion-usb:before{content:\"\\f2b8\"}.ion-videocamera:before{content:\"\\f256\"}.ion-volume-high:before{content:\"\\f257\"}.ion-volume-low:before{content:\"\\f258\"}.ion-volume-medium:before{content:\"\\f259\"}.ion-volume-mute:before{content:\"\\f25a\"}.ion-wand:before{content:\"\\f358\"}.ion-waterdrop:before{content:\"\\f25b\"}.ion-wifi:before{content:\"\\f25c\"}.ion-wineglass:before{content:\"\\f2b9\"}.ion-woman:before{content:\"\\f25d\"}.ion-wrench:before{content:\"\\f2ba\"}.ion-xbox:before{content:\"\\f30c\"}*/\n\n/*!\n* Template Name: Flora- Easy To Use App Landing Page Template\n* Author: bonefishcode\n*/\n/*\n * table of contents\n * --------------------------------------------------\n * import\n * reset\n * helper class\n * base\n * element\n * site loader\n * site header (nav)\n * site background\n * site common\n * home section\n * feature section\n * why us section\n * what we do section\n * contact section\n * footer\n * custom animation\n */\n/*\n * color code, [search and replace] with text editor\n * --------------------------------------------------\n *\n * loader, nav background\n * #1e1f25\n *\n * home overlay\n * rgba(30, 31, 37, 0.65)\n *\n * download overlay\n * rgba(30, 31, 37, 0.65)\n *\n * theme color\n * #50d2c2\n * #34cab8 [hover]\n *\n */\n/**\n * import\n * --------------------------------------------------\n */\n@import url(\"http://fonts.googleapis.com/css?family=Lora:400,700,400italic,700italic\");\n@import url(\"http://fonts.googleapis.com/css?family=Source+Sans+Pro:200,300,400,600,700,900,200italic,300italic,400italic,600italic,700italic,900italic\");\n/**\n * reset\n * --------------------------------------------------\n */\nli > ol,\nli > ul {\n    margin-bottom: 0;\n}\n\nimg {\n    vertical-align: middle;\n    max-width: 100%;\n    font-style: italic;\n}\n\n.gm-style img,\nimg[width],\nimg[height] {\n    max-width: none;\n}\n\n.page-header {\n    margin: 0;\n    border-bottom: 0;\n    padding-bottom: 0;\n}\n\n/**\n * helper class\n * --------------------------------------------------\n */\n/* float */\n.clearfix:before,\n.primary-menu-list:before,\n.icon-menu-list:before,\n.double-device:before,\n.clearfix:after, .primary-menu-list:after, .icon-menu-list:after, .double-device:after {\n    content: \" \";\n    display: table;\n}\n\n.clearfix:after, .primary-menu-list:after, .icon-menu-list:after, .double-device:after {\n    clear: both;\n}\n\n@media (max-width: 767px) {\n    .float-right-xs-max {\n        float: right !important;\n    }\n\n    .float-left-xs-max {\n        float: left !important;\n    }\n}\n\n@media (max-width: 991px) {\n    .float-right-sm-max {\n        float: right !important;\n    }\n\n    .float-left-sm-max {\n        float: left !important;\n    }\n}\n\n@media (max-width: 1199px) {\n    .float-right-md-max {\n        float: right !important;\n    }\n\n    .float-left-md-max {\n        float: left !important;\n    }\n}\n\n@media (min-width: 480px) {\n    .float-right-xs-min {\n        float: right !important;\n    }\n\n    .float-left-xs-min {\n        float: left !important;\n    }\n}\n\n@media (min-width: 768px) {\n    .float-right-sm-min {\n        float: right !important;\n    }\n\n    .float-left-sm-min {\n        float: left !important;\n    }\n}\n\n@media (min-width: 992px) {\n    .float-right-md-min {\n        float: right !important;\n    }\n\n    .float-left-md-min {\n        float: left !important;\n    }\n}\n\n.float-right {\n    float: right !important;\n}\n\n.float-left {\n    float: left !important;\n}\n\n/* transition */\n.transition-base, a, .btn, .site-header, .site-header-brand, .site-header-nav, .feature-icon, .feature-icon:before {\n    -webkit-transition: 0.3s ease-in-out;\n    -o-transition: 0.3s ease-in-out;\n    transition: 0.3s ease-in-out;\n}\n\n/* hardware acceleration */\n.ha-3d, [data-animation-in], .site-loader._multi-circle-line, .site-loader._multi-circle-line .site-loader-spinner, .site-header, .site-header-brand, .site-header-nav, .site-bg, #videoPlayer, .site-bg-effect, .feature-icon, .feature-icon:before {\n    -webkit-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0);\n    -webkit-backface-visibility: hidden;\n    backface-visibility: hidden;\n    -webkit-perspective: 1000;\n    perspective: 1000;\n}\n\n.ha-z {\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n    -webkit-backface-visibility: hidden;\n    backface-visibility: hidden;\n    -webkit-perspective: 1000;\n    perspective: 1000;\n}\n\n/* position */\n.relative {\n    position: relative;\n}\n\n.layer, .site-loader._multi-circle-line, .site-overlay, .m-nav, .site-bg, .site-bg-img,\n.site-bg-video,\n.site-bg-overlay,\n.site-bg-effect,\n.site-bg-canvas, .cloud, .section-overlay {\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n}\n\n/* display */\n.hide {\n    display: none;\n}\n\n.tb, .m-nav-tb {\n    display: table;\n    table-layout: fixed;\n    width: 100%;\n    height: 100%;\n}\n\n.tb-cell, .m-nav-tb-cell {\n    display: table-cell;\n    vertical-align: middle;\n}\n\n.overflow-hidden {\n    overflow: hidden;\n}\n\n.scroll-block {\n    -ms-overflow-style: scrollbar;\n    overflow-x: hidden;\n    overflow-y: auto;\n}\n\n/* margin and padding */\n.m-t-5 {\n    margin-top: 5px;\n}\n\n.m-r-5 {\n    margin-right: 5px;\n}\n\n.m-b-5 {\n    margin-bottom: 5px;\n}\n\n.m-l-5 {\n    margin-left: 5px;\n}\n\n.p-t-5 {\n    padding-top: 5px;\n}\n\n.p-r-5 {\n    padding-right: 5px;\n}\n\n.p-b-5 {\n    padding-bottom: 5px;\n}\n\n.p-l-5 {\n    padding-left: 5px;\n}\n\n.m-t-10 {\n    margin-top: 10px;\n}\n\n.m-r-10 {\n    margin-right: 10px;\n}\n\n.m-b-10 {\n    margin-bottom: 10px;\n}\n\n.m-l-10 {\n    margin-left: 10px;\n}\n\n.p-t-10 {\n    padding-top: 10px;\n}\n\n.p-r-10 {\n    padding-right: 10px;\n}\n\n.p-b-10 {\n    padding-bottom: 10px;\n}\n\n.p-l-10 {\n    padding-left: 10px;\n}\n\n.m-t-15 {\n    margin-top: 15px;\n}\n\n.m-r-15 {\n    margin-right: 15px;\n}\n\n.m-b-15 {\n    margin-bottom: 15px;\n}\n\n.m-l-15 {\n    margin-left: 15px;\n}\n\n.p-t-15 {\n    padding-top: 15px;\n}\n\n.p-r-15 {\n    padding-right: 15px;\n}\n\n.p-b-15 {\n    padding-bottom: 15px;\n}\n\n.p-l-15 {\n    padding-left: 15px;\n}\n\n.m-t-20 {\n    margin-top: 20px;\n}\n\n.m-r-20 {\n    margin-right: 20px;\n}\n\n.m-b-20 {\n    margin-bottom: 20px;\n}\n\n.m-l-20 {\n    margin-left: 20px;\n}\n\n.p-t-20 {\n    padding-top: 20px;\n}\n\n.p-r-20 {\n    padding-right: 20px;\n}\n\n.p-b-20 {\n    padding-bottom: 20px;\n}\n\n.p-l-20 {\n    padding-left: 20px;\n}\n\n.m-t-25 {\n    margin-top: 25px;\n}\n\n.m-r-25 {\n    margin-right: 25px;\n}\n\n.m-b-25 {\n    margin-bottom: 25px;\n}\n\n.m-l-25 {\n    margin-left: 25px;\n}\n\n.p-t-25 {\n    padding-top: 25px;\n}\n\n.p-r-25 {\n    padding-right: 25px;\n}\n\n.p-b-25 {\n    padding-bottom: 25px;\n}\n\n.p-l-25 {\n    padding-left: 25px;\n}\n\n.m-t-30 {\n    margin-top: 30px;\n}\n\n.m-r-30 {\n    margin-right: 30px;\n}\n\n.m-b-30 {\n    margin-bottom: 30px;\n}\n\n.m-l-30 {\n    margin-left: 30px;\n}\n\n.p-t-30 {\n    padding-top: 30px;\n}\n\n.p-r-30 {\n    padding-right: 30px;\n}\n\n.p-b-30 {\n    padding-bottom: 30px;\n}\n\n.p-l-30 {\n    padding-left: 30px;\n}\n\n.m-t-35 {\n    margin-top: 35px;\n}\n\n.m-r-35 {\n    margin-right: 35px;\n}\n\n.m-b-35 {\n    margin-bottom: 35px;\n}\n\n.m-l-35 {\n    margin-left: 35px;\n}\n\n.p-t-35 {\n    padding-top: 35px;\n}\n\n.p-r-35 {\n    padding-right: 35px;\n}\n\n.p-b-35 {\n    padding-bottom: 35px;\n}\n\n.p-l-35 {\n    padding-left: 35px;\n}\n\n.m-t-40 {\n    margin-top: 40px;\n}\n\n.m-r-40 {\n    margin-right: 40px;\n}\n\n.m-b-40 {\n    margin-bottom: 40px;\n}\n\n.m-l-40 {\n    margin-left: 40px;\n}\n\n.p-t-40 {\n    padding-top: 40px;\n}\n\n.p-r-40 {\n    padding-right: 40px;\n}\n\n.p-b-40 {\n    padding-bottom: 40px;\n}\n\n.p-l-40 {\n    padding-left: 40px;\n}\n\n.m-t-space {\n    margin-top: 50px;\n}\n\n.m-t-space p {\n    margin-top: 50px;\n    font-size: 24px;\n    margin-bottom: 20px;\n}\n\n.m-t-space ul {\n    font-size: 20px;\n    line-height: 50px;\n    padding-left: 60px;\n\n}\n\n.m-r-space {\n    margin-right: 20px;\n}\n\n.m-b-space {\n    margin-bottom: 20px;\n}\n\n.m-l-space {\n    margin-left: 20px;\n}\n\n.p-t-space {\n    padding-top: 20px;\n}\n\n.p-r-space {\n    padding-right: 20px;\n}\n\n.p-b-space {\n    padding-bottom: 20px;\n}\n\n.p-l-space {\n    padding-left: 20px;\n}\n\n@media (min-width: 992px) {\n    .m-t-space {\n        margin-top: 30px !important;\n    }\n\n    .m-r-space {\n        margin-right: 30px !important;\n    }\n\n    .m-b-space {\n        margin-bottom: 30px !important;\n    }\n\n    .m-l-space {\n        margin-left: 30px !important;\n    }\n\n    .p-t-space {\n        padding-top: 30px !important;\n    }\n\n    .p-r-space {\n        padding-right: 30px !important;\n    }\n\n    .p-b-space {\n        padding-bottom: 30px !important;\n    }\n\n    .p-l-space {\n        padding-left: 30px !important;\n    }\n}\n\n.section-title {\n    font-size: 52px;\n    font-family: \"Raleway Bold\";\n}\n\n@media (max-width: 769px) {\n    .section-title {\n        font-size: 40px;\n    }\n}\n\n/* border */\n.border-radius-base, .btn, .form-theme .form-control {\n    -webkit-border-top-left-radius: 4px;\n    border-top-left-radius: 4px;\n    -webkit-border-top-right-radius: 4px;\n    border-top-right-radius: 4px;\n    -webkit-border-bottom-left-radius: 4px;\n    border-bottom-left-radius: 4px;\n    -webkit-border-bottom-right-radius: 4px;\n    border-bottom-right-radius: 4px;\n}\n\n/* align */\n.text-align-right {\n    text-align: right;\n}\n\n.text-align-left {\n    text-align: left;\n}\n\n.text-align-center {\n    text-align: center;\n}\n\n/* list */\n.list-reset, .primary-menu-list, .icon-menu-list, .m-primary-menu-list, .feature-list, .selling-point-list, .service-list, .contact-info-list, .social-list {\n    margin-bottom: 0;\n    padding-left: 0;\n    list-style: none;\n    color: white;\n}\n\n/* color */\n.color {\n    color: #008094;\n}\n\n.text-light h1, .text-light h2, .text-light h3, .text-light h4, .text-light h5, .text-light h6, .text-light p {\n    color: #fff;\n}\n\n/**\n * base\n * --------------------------------------------------\n */\nbody, .section-subtitle {\n    /*font-family: \"Lora\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;*/\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6, .btn, .primary-menu-item > a, .m-primary-menu-item > a {\n    /*font-family: \"Source Sans Pro\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;*/\n}\n\nbody {\n    line-height: 1.9;\n    font-weight: 400;\n    text-transform: none;\n    letter-spacing: 0;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n    line-height: 1.2;\n    font-weight: 700;\n    /*text-transform: capitalize;*/\n    letter-spacing: 0;\n}\n\nhtml {\n    -webkit-tap-highlight-color: transparent;\n}\n\nbody {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    position: relative;\n    overflow-x: hidden;\n    background-color: #fff;\n    font-size: 18px;\n    color: #333;\n}\n\n@media (min-width: 992px) {\n    body {\n        font-size: 18px;\n    }\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n    margin: 0;\n    color: #333;\n}\n\nh1 {\n    font-size: 36px;\n}\n\n@media (min-width: 768px) {\n    h1 {\n        line-height: 1.1;\n        font-size: 50px;\n    }\n}\n\n@media (min-width: 992px) {\n    h1 {\n        line-height: 1.05;\n        font-size: 64px;\n    }\n}\n\nh2 {\n    font-size: 36px;\n}\n\n@media (min-width: 992px) {\n    h2 {\n        font-size: 40px;\n    }\n}\n\nh3 {\n    font-size: 22px;\n}\n\n@media (min-width: 992px) {\n    h3 {\n        font-size: 24px;\n    }\n}\n\nh4 {\n    font-size: 20px;\n}\n\n@media (min-width: 768px) {\n    h4 {\n        font-size: 22px;\n    }\n}\n\nh5 {\n    font-size: 18px;\n}\n\n@media (min-width: 768px) {\n    h5 {\n        font-size: 18px;\n    }\n}\n\nh6,\n.small {\n    font-size: 12px;\n    letter-spacing: 1.5px;\n}\n\np,\nol,\nul,\nblockquote,\npre {\n    margin-bottom: 20px;\n}\n\np:last-child,\nol:last-child,\nul:last-child,\nblockquote:last-child,\npre:last-child {\n    margin-bottom: 0;\n}\n\n@media (min-width: 992px) {\n    p,\n    ol,\n    ul,\n    blockquote,\n    pre {\n        margin-bottom: 30px;\n    }\n}\n\na {\n    color: #50d2c2;\n}\n\na:focus {\n    outline: 0;\n}\n\na:focus,\na:hover {\n    text-decoration: none;\n    color: #34cab8;\n}\n\n.thin {\n    font-weight: 300;\n}\n\n.normal {\n    font-weight: 400;\n}\n\n.bold {\n    font-weight: 700;\n}\n\ni {\n    display: inline-block;\n    letter-spacing: 0;\n}\n\n/* animate */\n.velocity-animating {\n    -webkit-transition: none !important;\n    -o-transition: none !important;\n    transition: none !important;\n}\n\n/*\n * element\n * --------------------------------------------------\n */\n/*\n * button\n * -------------------------\n */\n.btn {\n    line-height: 1 !important;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 1.5px;\n}\n\n.btn[disabled] {\n    cursor: not-allowed;\n}\n\n.btn:hover[disabled] {\n    cursor: not-allowed;\n    background-color: #0080A3 !important;\n}\n\n.btn {\n    position: relative;\n    display: inline-block;\n    overflow: hidden;\n    vertical-align: middle;\n    height: auto !important;\n    border: 1px solid transparent;\n    padding: 20px 28.5px 20px 30px;\n    background-image: none;\n    font-size: 14px;\n    text-align: center;\n    white-space: nowrap;\n    -ms-touch-action: manipulation;\n    touch-action: manipulation;\n    cursor: pointer;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n}\n\n.btn:active {\n    -webkit-box-shadow: none;\n    box-shadow: none;\n}\n\n.btn:active:focus {\n    outline: 0;\n}\n\n.btn:focus {\n    outline: 0;\n}\n\n.btn span {\n    display: inline-block;\n}\n\n.btn span + i {\n    -webkit-transform: scale(1.5);\n    -ms-transform: scale(1.5);\n    -o-transform: scale(1.5);\n    transform: scale(1.5);\n    line-height: 0;\n    margin-left: 5px;\n}\n\n@media (min-width: 992px) {\n    .btn {\n        padding: 25px 38.5px 25px 40px;\n    }\n}\n\n.btn._base {\n    border-color: #333;\n    color: #333;\n}\n\n.btn._base:active,\n.btn._base:active:focus,\n.btn._base:focus,\n.btn._base:hover {\n    background-color: #333;\n    color: #fff;\n}\n\n.btn._theme {\n    border-color: #008094;\n    background-color: #008094;\n    color: #fff;\n}\n\n.btn._theme:active,\n.btn._theme:active:focus,\n.btn._theme:focus,\n.btn._theme:hover {\n    border-color: #34cab8;\n    background-color: #34cab8;\n    color: #fff;\n}\n\n.btn._circle {\n    -webkit-border-top-left-radius: 50px;\n    border-top-left-radius: 50px;\n    -webkit-border-top-right-radius: 50px;\n    border-top-right-radius: 50px;\n    -webkit-border-bottom-left-radius: 50px;\n    border-bottom-left-radius: 50px;\n    -webkit-border-bottom-right-radius: 50px;\n    border-bottom-right-radius: 50px;\n}\n\n.btn-container {\n    margin-top: 10px;\n}\n\n.btn-container .btn {\n    margin: 10px 5px 0;\n}\n\n@media (min-width: 992px) {\n    .btn-container {\n        margin-top: 20px;\n    }\n}\n\n/*\n * form\n * -------------------------\n */\n/* form notify */\n.form-notify {\n    margin-top: 20px;\n}\n\n/* form theme */\n.form-theme {\n    position: relative;\n}\n\n.form-theme .required:after {\n    position: absolute;\n    top: 10px;\n    right: 0;\n    content: \"*\";\n    line-height: 1;\n    /* font-family: Arial, sans-serif;*/\n    font-size: 20px;\n    font-weight: 700;\n    color: #ed485c;\n}\n\n.form-theme .form-group {\n    position: relative;\n    margin-bottom: 20px;\n}\n\n.form-theme .form-group.error .form-control {\n    border-color: #ed485c;\n}\n\n@media (min-width: 992px) {\n    .form-theme .form-group {\n        margin-bottom: 30px;\n    }\n}\n\n.form-theme .form-control {\n    height: 56px;\n    padding: 17px 20px;\n    border-color: transparent;\n    background-color: rgba(0, 0, 0, 0.05);\n    -webkit-box-shadow: none;\n    box-shadow: none;\n    font-size: 18px;\n}\n\n.form-theme textarea.form-control {\n    height: auto;\n}\n\n/**\n * site loader\n * --------------------------------------------------\n */\n/*\n\n*/\n.site-loader._multi-circle-line {\n    position: fixed;\n    z-index: 900;\n}\n\n.site-loader._multi-circle-line .site-loader-spinner {\n    -webkit-animation: spin 1.5s infinite linear;\n    -o-animation: spin 1.5s infinite linear;\n    animation: spin 1.5s infinite linear;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    z-index: 1;\n    width: 150px;\n    height: 150px;\n    margin-top: -75px;\n    margin-left: -75px;\n    border: 3px solid transparent;\n    border-top-color: rgba(80, 210, 194, 0.5);\n    -webkit-border-radius: 50%;\n    border-radius: 50%;\n}\n\n.site-loader._multi-circle-line .site-loader-spinner:before,\n.site-loader._multi-circle-line .site-loader-spinner:after {\n    position: absolute;\n    content: \"\";\n    -webkit-border-radius: 50%;\n    border-radius: 50%;\n}\n\n.site-loader._multi-circle-line .site-loader-spinner:before {\n    -webkit-animation: spin 2.5s infinite linear;\n    -o-animation: spin 2.5s infinite linear;\n    animation: spin 2.5s infinite linear;\n    top: 5px;\n    right: 5px;\n    bottom: 5px;\n    left: 5px;\n    border: 3px solid transparent;\n    border-top-color: rgba(80, 210, 194, 0.4);\n}\n\n.site-loader._multi-circle-line .site-loader-spinner:after {\n    -webkit-animation: spin 1.5s infinite linear;\n    -o-animation: spin 1.5s infinite linear;\n    animation: spin 1.5s infinite linear;\n    top: 15px;\n    right: 15px;\n    bottom: 15px;\n    left: 15px;\n    border: 3px solid transparent;\n    border-top-color: rgba(80, 210, 194, 0.3);\n}\n\n@-webkit-keyframes spin {\n    0% {\n        -webkit-transform: rotate(0);\n        transform: rotate(0);\n    }\n    100% {\n        -webkit-transform: rotate(360deg);\n        transform: rotate(360deg);\n    }\n}\n\n@-o-keyframes spin {\n    0% {\n        -o-transform: rotate(0);\n        transform: rotate(0);\n    }\n    100% {\n        -o-transform: rotate(360deg);\n        transform: rotate(360deg);\n    }\n}\n\n@keyframes spin {\n    0% {\n        -webkit-transform: rotate(0);\n        -o-transform: rotate(0);\n        transform: rotate(0);\n    }\n    100% {\n        -webkit-transform: rotate(360deg);\n        -o-transform: rotate(360deg);\n        transform: rotate(360deg);\n    }\n}\n\n.site-loader._multi-circle-line .site-loader-section {\n    position: fixed;\n    top: 0;\n    width: 51%;\n    height: 100%;\n    background-color: #1e1f25;\n}\n\n.site-loader._multi-circle-line .site-loader-section._left {\n    left: 0;\n}\n\n.site-loader._multi-circle-line .site-loader-section._right {\n    right: 0;\n}\n\n.is-loaded2 .site-loader-container {\n    -webkit-transition: all 0.3s 1s ease-out;\n    -o-transition: all 0.3s 1s ease-out;\n    transition: all 0.3s 1s ease-out;\n    visibility: hidden;\n}\n\n.is-loaded2 .site-loader-spinner {\n    -webkit-transition: all 0.3s ease-out;\n    -o-transition: all 0.3s ease-out;\n    transition: all 0.3s ease-out;\n    opacity: 0;\n}\n\n.is-loaded2 .site-loader-section._left {\n    -webkit-transition: all 0.7s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n    -o-transition: all 0.7s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n    transition: all 0.7s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n    -webkit-transform: translateX(-100%);\n    -ms-transform: translateX(-100%);\n    -o-transform: translateX(-100%);\n    transform: translateX(-100%);\n}\n\n.is-loaded2 .site-loader-section._right {\n    -webkit-transition: all 0.7s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n    -o-transition: all 0.7s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n    transition: all 0.7s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n    -webkit-transform: translateX(100%);\n    -ms-transform: translateX(100%);\n    -o-transform: translateX(100%);\n    transform: translateX(100%);\n}\n\n/**\n * header\n * --------------------------------------------------\n */\n.site-header {\n    -webkit-transition-property: background-color;\n    -o-transition-property: background-color;\n    transition-property: background-color;\n    position: fixed;\n    top: 0;\n    right: 0;\n    left: 0;\n    z-index: 800;\n}\n\n.is-scroll .site-header {\n    background-color: #1e1f25;\n}\n\n.site-header .nav > li > a {\n    padding: 0 !important;\n}\n\n.site-header .nav > li > a:focus,\n.site-header .nav > li > a:hover {\n    background-color: transparent;\n}\n\n.site-header-container {\n    position: relative;\n}\n\n.site-header-brand {\n    -webkit-transition-property: margin;\n    -o-transition-property: margin;\n    transition-property: margin;\n    float: left;\n    margin: 8px 0 8px;\n}\n\n@media (min-width: 992px) {\n    .site-header-brand {\n        margin: 22px 0 22px;\n    }\n\n    .is-scroll .site-header-brand {\n        margin: 12px 0 12px;\n    }\n}\n\n.site-header-brand-img {\n    height: 40px;\n}\n\n@media (min-width: 992px) {\n    .site-header-brand-img {\n        height: 56px;\n    }\n}\n\n.site-header-nav {\n    -webkit-transition-property: margin;\n    -o-transition-property: margin;\n    transition-property: margin;\n    float: right;\n    height: 40px;\n    line-height: 40px;\n    margin: 8px 0 8px;\n}\n\n@media (min-width: 992px) {\n    .site-header-nav {\n        height: 56px;\n        line-height: 56px;\n        margin: 22px 0 22px;\n    }\n\n    .is-scroll .site-header-nav {\n        margin: 12px 0 12px;\n    }\n}\n\n.primary-menu {\n    float: left;\n}\n\n/*@media (max-width: 991px) {*/\n/*.primary-menu {*/\n/*display: none;*/\n/*}*/\n/*}*/\n\n.primary-menu-item {\n    float: left;\n}\n\n.primary-menu-item:not(:first-child) {\n    margin-left: 30px;\n}\n\n.primary-menu-item > a {\n    -webkit-transition-property: color;\n    -o-transition-property: color;\n    transition-property: color;\n    display: block;\n    height: 40px;\n    line-height: 40px;\n    font-size: 13px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 1.5px;\n    color: #fff;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n}\n\n.primary-menu-item > a:hover {\n    color: #008094;\n    background-color: transparent !important;\n}\n\n.primary-menu-item > a > span {\n    display: inline-block;\n}\n\n@media (min-width: 992px) {\n    .primary-menu-item > a {\n        height: 56px;\n        line-height: 56px;\n    }\n}\n\n.primary-menu-item.active > a {\n    color: #008094;\n}\n\n.primary-menu-item.active > a:hover {\n    color: #34cab8;\n}\n\n.icon-menu {\n    float: left;\n}\n\n.icon-menu-item {\n    float: left;\n    margin-left: 30px;\n}\n\n.icon-menu-item > a {\n    display: block;\n    height: 40px;\n    line-height: 40px;\n    color: #fff;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n}\n\n.icon-menu-item > a:focus,\n.icon-menu-item > a:hover {\n    color: #fff;\n}\n\n.icon-menu-item > a > i {\n    font-size: 25px;\n}\n\n.icon-menu-item > a > i:before {\n    display: block;\n    line-height: inherit;\n}\n\n@media (min-width: 992px) {\n    .icon-menu-item > a {\n        height: 56px;\n        line-height: 56px;\n    }\n}\n\n.audio-toggle {\n    display: none;\n}\n\n.is-audio .audio-toggle,\n.is-mute .audio-toggle {\n    display: block;\n}\n\n.audio-toggle-link {\n    color: #fff;\n}\n\n.audio-toggle-link:hover {\n    color: #fff !important;\n}\n\n.is-mute .audio-toggle-link {\n    color: #999 !important;\n}\n\n.site-overlay {\n    position: fixed;\n    opacity: 0;\n    visibility: hidden;\n    background-color: rgba(30, 31, 37, 0.5);\n}\n\n/* mobile nav */\n.m-nav {\n    position: fixed;\n    z-index: 798;\n    display: none;\n    overflow-x: hidden;\n    overflow-y: scroll;\n    background-color: #1e1f25;\n    text-align: center;\n}\n\n.m-nav .nav > li > a {\n    font-size: 18px;\n    font-weight: 700;\n}\n\n.m-nav .nav > li > a:focus,\n.m-nav .nav > li > a:hover {\n    background-color: transparent;\n}\n\n@media (min-width: 992px) {\n    .m-nav {\n        display: none !important;\n    }\n}\n\n.m-primary-menu-item > a {\n    -webkit-transition-property: color;\n    -o-transition-property: color;\n    transition-property: color;\n    display: block;\n    font-size: 14px;\n    text-transform: uppercase;\n    letter-spacing: 1.5px;\n    color: #fff;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n}\n\n.m-primary-menu-item > a:hover {\n    color: #50d2c2;\n    background-color: transparent !important;\n}\n\n.m-primary-menu-item > a > span {\n    display: inline-block;\n}\n\n.m-primary-menu-item.active > a {\n    color: #50d2c2;\n}\n\n.m-primary-menu-item.active > a:hover {\n    color: #34cab8;\n}\n\n/**\n * site background\n * --------------------------------------------------\n */\n.site-bg {\n    position: absolute;\n    z-index: -1;\n    overflow: hidden;\n}\n\n.site-bg-img,\n.site-bg-video,\n.site-bg-overlay,\n.site-bg-effect,\n.site-bg-canvas {\n    position: absolute;\n}\n\n.site-bg-img {\n    background-repeat: no-repeat;\n    background-position: 50% 50%;\n    background-size: cover;\n}\n\n.is-site-bg-img .site-bg-img {\n    display: block;\n    background-image: url(../img/bg/site-bg-img.jpg);\n}\n\n.is-site-bg-slideshow .site-bg-img {\n    display: block;\n}\n\n.is-site-bg-video .site-bg-img {\n    display: block;\n    background-image: url(../img/bg/site-bg-video.jpg);\n}\n\n.is-site-bg-video-youtube .site-bg-img {\n    display: block;\n    background-image: url(../img/bg/site-bg-video-youtube.jpg);\n}\n\n.is-site-bg-video .site-bg-video,\n.is-site-bg-video-youtube .site-bg-video {\n    display: block;\n}\n\n#videoPlayer {\n    -webkit-transform: translate(-50%, -50%);\n    -ms-transform: translate(-50%, -50%);\n    -o-transform: translate(-50%, -50%);\n    transform: translate(-50%, -50%);\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    display: block;\n    min-width: 100%;\n    min-height: 100%;\n    width: auto;\n    height: auto;\n}\n\n.site-bg-overlay {\n    position: absolute;\n    background-color: rgba(30, 31, 37, 0.65);\n}\n\n.is-site-bg-cloud .site-bg-effect {\n    display: block;\n}\n\n.ie9 .site-bg-effect {\n    background-image: url(#);\n}\n\n.cloud {\n    position: absolute;\n    background-repeat: no-repeat;\n    background-position: center center;\n    background-size: 100%;\n}\n\n.site-bg-canvas {\n    display: none;\n}\n\n.is-site-bg-star .site-bg-canvas {\n    display: block;\n}\n\n/* cloud */\n.cloud-01 {\n    background-image: url(../img/bg/cloud-01.png);\n}\n\n.cloud-02 {\n    background-image: url(../img/bg/cloud-02.png);\n}\n\n.cloud-03 {\n    background-image: url(../img/bg/cloud-03.png);\n}\n\n/**\n * content common\n * --------------------------------------------------\n */\n.animated {\n    opacity: 0;\n    visibility: hidden;\n}\n\n.ie9 .animated,\n.is-mobile .animated {\n    opacity: 1;\n    visibility: visible;\n}\n\n#feature,\n#app-brief-1,\n#app-brief-2,\n#download,\n#funcionamiento,\n#funcionamiento2,\n#hardware,\n#software,\n#empresa,\n#contacto,\n#variables,\n#contact {\n    padding: 65px 0;\n    min-height: 100vh;\n}\n\n@media (min-width: 992px) {\n    #feature,\n    #app-brief-1,\n    #app-brief-2,\n    #funcionamiento,\n    #funcionamiento2,\n    #hardware,\n    #software,\n    #empresa,\n    #contacto,\n    #variables,\n    #download,\n    #contact {\n        padding: 130px 0;\n    }\n}\n\n.section {\n    position: relative;\n    z-index: 1;\n    overflow: hidden;\n}\n\n.section-overlay {\n    position: absolute;\n}\n\n@media (max-width: 991px) {\n    [data-equal-height] {\n        height: auto !important;\n    }\n}\n\n@media (min-width: 992px) {\n    [data-equal-height] {\n        display: table;\n    }\n}\n\n@media (min-width: 992px) {\n    .equal-height-cell {\n        display: table-cell;\n        vertical-align: middle;\n    }\n}\n\n.section-subtitle {\n    font-size: 13px;\n    font-style: italic;\n    text-transform: uppercase;\n    letter-spacing: 6px;\n    margin-bottom: 5px;\n}\n\n.double-device {\n    position: relative;\n    width: 100%;\n    max-width: 300px;\n    margin: 0 auto;\n}\n\n@media (max-width: 991px) {\n    .double-device {\n        margin-top: 65px;\n    }\n}\n\n@media (min-width: 768px) {\n    .double-device {\n        max-width: 350px;\n    }\n}\n\n@media (min-width: 992px) {\n    .double-device {\n        max-width: 440px;\n    }\n\n    .double-device._right {\n        float: right;\n    }\n\n    .double-device._left {\n        float: left;\n    }\n\n    .double-device._bottom {\n        position: absolute;\n        bottom: -250px;\n    }\n\n    .double-device._bottom._left {\n        left: 15px;\n    }\n}\n\n.double-device-front {\n    position: relative;\n    float: left;\n    z-index: 1;\n}\n\n.is-desktop .double-device-front {\n    -webkit-filter: drop-shadow(0 0 8px rgba(0, 0, 0, 0.1));\n    filter: drop-shadow(0 0 8px rgba(0, 0, 0, 0.1));\n}\n\n@media (max-width: 991px) {\n    .double-device-front {\n        width: 60%;\n    }\n}\n\n.double-device-back {\n    position: absolute;\n    top: 50%;\n    right: 0px;\n    height: 90%;\n}\n\n.is-desktop .double-device-back {\n    -webkit-filter: drop-shadow(0 0 8px rgba(0, 0, 0, 0.1));\n    filter: drop-shadow(0 0 8px rgba(0, 0, 0, 0.1));\n}\n\n.ie9 .double-device-back,\n.is-mobile .double-device-back {\n    -webkit-transform: translate(0, -50%);\n    -ms-transform: translate(0, -50%);\n    -o-transform: translate(0, -50%);\n    transform: translate(0, -50%);\n}\n\n@media (max-width: 991px) {\n    .double-device-back {\n        width: 60% !important;\n        height: 83% !important;\n    }\n}\n\n.max-width-640 {\n    max-width: 640px;\n    margin: auto;\n}\n\n.max-width-960 {\n    max-width: 960px;\n    margin: auto;\n}\n\n/**\n * home\n * --------------------------------------------------\n */\n#home {\n    position: relative;\n    padding: 108px 0 60px;\n}\n\n@media (min-width: 768px) {\n    #home {\n        padding: 138px 0 90px;\n    }\n}\n\n@media (min-width: 992px) {\n    #home {\n        padding: 198px 0 120px;\n    }\n}\n\n/**\n * feature\n * --------------------------------------------------\n */\n#variables, #software {\n    background-color: #fff;\n}\n\n.feature-box {\n    position: relative;\n    margin-top: 40px;\n    padding: 0 0 0 94px;\n}\n\n@media (min-width: 992px) {\n    .feature-box {\n        margin-top: 60px;\n    }\n}\n\n.feature-icon {\n    -webkit-border-top-left-radius: 50%;\n    border-top-left-radius: 50%;\n    -webkit-border-top-right-radius: 50%;\n    border-top-right-radius: 50%;\n    -webkit-border-bottom-left-radius: 50%;\n    border-bottom-left-radius: 50%;\n    -webkit-border-bottom-right-radius: 50%;\n    border-bottom-right-radius: 50%;\n    -webkit-transition-property: -webkit-transform;\n    -o-transition-property: -o-transform;\n    transition-property: transform;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 74px;\n    height: 74px;\n    border: 2px solid #008094;\n    padding: 3px;\n}\n\n.feature-icon:before {\n    -webkit-transition-property: -webkit-transform opacity;\n    -o-transition-property: -o-transform opacity;\n    transition-property: transform opacity;\n    position: absolute;\n    bottom: -30px;\n    left: 5%;\n    content: \"\";\n    height: 10px;\n    width: 90%;\n    background: -webkit-radial-gradient(center, ellipse, rgba(0, 0, 0, 0.35) 0%, transparent 80%);\n    background: -o-radial-gradient(center, ellipse, rgba(0, 0, 0, 0.35) 0%, transparent 80%);\n    background: radial-gradient(ellipse at center, rgba(0, 0, 0, 0.35) 0%, transparent 80%);\n    opacity: 0;\n}\n\n.feature-icon > i {\n    -webkit-border-top-left-radius: 50%;\n    border-top-left-radius: 50%;\n    -webkit-border-top-right-radius: 50%;\n    border-top-right-radius: 50%;\n    -webkit-border-bottom-left-radius: 50%;\n    border-bottom-left-radius: 50%;\n    -webkit-border-bottom-right-radius: 50%;\n    border-bottom-right-radius: 50%;\n    display: block;\n    width: 64px;\n    height: 64px;\n    line-height: 64px;\n    background-color: #008094;\n    /*background-image: url(./assets/img/item/svg-mask.svg);*/\n    background-size: 100% 100%;\n    font-size: 36px;\n    text-align: center;\n    color: #fff;\n}\n\n.feature-box:hover .feature-icon {\n    -webkit-transform: translateY(-5px);\n    -ms-transform: translateY(-5px);\n    -o-transform: translateY(-5px);\n    transform: translateY(-5px);\n}\n\n.feature-box:hover .feature-icon:before {\n    opacity: 1;\n    -webkit-transform: translateY(5px);\n    -ms-transform: translateY(5px);\n    -o-transform: translateY(5px);\n    transform: translateY(5px);\n}\n\n.feature-title {\n    font-family: \"Raleway Bold\";\n    font-size: 20px;\n    min-height: 50px;\n    margin-top: 6px !important;\n}\n\n.feature-content {\n    margin-top: 7px !important;\n    font-size: 16px !important;\n    color: black;\n}\n\n/**\n * app brief 1 (why us section)\n * --------------------------------------------------\n */\n#funcionamiento {\n    background-color: #f5f5f5;\n}\n\n.selling-point-item > i {\n    -webkit-transform: translateY(2px);\n    -ms-transform: translateY(2px);\n    -o-transform: translateY(2px);\n    transform: translateY(2px);\n    position: relative;\n    margin-right: 1em;\n    font-size: 24px;\n    color: #008094;\n}\n\n/**\n * app brief 2 (what we do section)\n * --------------------------------------------------\n */\n#funcionamiento2, #empresa {\n    background-color: #fafafa;\n}\n\n@media (min-width: 992px) {\n    .service {\n        margin-top: 50px;\n    }\n}\n\n.service-icon {\n    line-height: 44px;\n    font-size: 44px;\n    color: #50d2c2;\n}\n\n@media (max-width: 991px) {\n    .service-icon {\n        margin-top: 20px;\n    }\n}\n\n.service-title {\n    margin-top: 10px;\n    font-weight: 400;\n    color: #333;\n}\n\n/**\n * download\n * --------------------------------------------------\n */\n#hardware {\n    position: relative;\n    background-image: url(\"../../img/landingPage/circuito.jpg\");\n    background-repeat: no-repeat;\n    background-position: 50% 50%;\n    background-size: cover;\n}\n\n#hardware .section-overlay {\n    background-color: rgba(30, 31, 37, 0.65);\n}\n\n@media (max-width: 991px) {\n    #hardware {\n        padding-bottom: 0;\n    }\n\n    #hardware .double-device {\n        -webkit-transform: translateY(100px);\n        -ms-transform: translateY(100px);\n        -o-transform: translateY(100px);\n        transform: translateY(100px);\n        margin-top: -35px;\n    }\n}\n\n/**\n * contact\n * --------------------------------------------------\n */\n#contact {\n    background-color: #fff;\n}\n\n.contact-info {\n    margin-top: 20px !important;\n}\n\n.contact-info-item {\n    margin-top: 40px;\n}\n\n.contact-info-icon {\n    line-height: 40px;\n    font-size: 40px;\n}\n\n.contact-info-title {\n    margin: 15px 0 5px;\n}\n\n#contactForm {\n    margin-top: 40px;\n}\n\n@media (min-width: 992px) {\n    #contactForm {\n        margin-top: 60px;\n    }\n}\n\n/**\n * footer\n * --------------------------------------------------\n */\n.site-footer {\n    position: relative;\n    z-index: 1;\n    overflow: hidden;\n    padding: 65px 0;\n    background-color: #1e1f25;\n}\n\n@media (min-width: 992px) {\n    .site-footer {\n        padding: 60px 0 !important;\n    }\n}\n\n.site-footer-brand-img {\n    height: 40px;\n}\n\n@media (min-width: 992px) {\n    .site-footer-brand-img {\n        height: 56px;\n    }\n}\n\n.copyright {\n    color: #999 !important;\n}\n\n.social-item {\n    display: inline-block;\n}\n\n.social-item a {\n    color: #999;\n}\n\n.social-item a:focus,\n.social-item a:hover {\n    color: #50d2c2;\n}\n\n.social-item i {\n    font-size: 30px;\n    margin: 10px 15px;\n}\n\n/**\n * custom animating\n * --------------------------------------------------\n */\n.fadeInLeftScale90 {\n    -webkit-animation-name: fadeInLeftScale90;\n    -o-animation-name: fadeInLeftScale90;\n    animation-name: fadeInLeftScale90;\n}\n\n@-webkit-keyframes fadeInLeftScale90 {\n    0% {\n        opacity: 0;\n        -webkit-transform: translate(-30%, -50%);\n        transform: translate(-30%, -50%);\n    }\n    100% {\n        opacity: 1;\n        -webkit-transform: translate(0, -50%);\n        transform: translate(0, -50%);\n    }\n}\n\n@-o-keyframes fadeInLeftScale90 {\n    0% {\n        opacity: 0;\n        -o-transform: translate(-30%, -50%);\n        transform: translate(-30%, -50%);\n    }\n    100% {\n        opacity: 1;\n        -o-transform: translate(0, -50%);\n        transform: translate(0, -50%);\n    }\n}\n\n@keyframes fadeInLeftScale90 {\n    0% {\n        opacity: 0;\n        -webkit-transform: translate(-30%, -50%);\n        -o-transform: translate(-30%, -50%);\n        transform: translate(-30%, -50%);\n    }\n    100% {\n        opacity: 1;\n        -webkit-transform: translate(0, -50%);\n        -o-transform: translate(0, -50%);\n        transform: translate(0, -50%);\n    }\n}\n\n.is-desktop .fadeInUpScale90 {\n    -webkit-animation-name: fadeInUpScale90;\n    -o-animation-name: fadeInUpScale90;\n    animation-name: fadeInUpScale90;\n}\n\n@-webkit-keyframes fadeInUpScale90 {\n    0% {\n        opacity: 0;\n        -webkit-transform: translateY(100%);\n        transform: translateY(100%);\n    }\n    100% {\n        opacity: 1;\n        -webkit-transform: translateY(-40%);\n        transform: translateY(-40%);\n    }\n}\n\n@-o-keyframes fadeInUpScale90 {\n    0% {\n        opacity: 0;\n        -o-transform: translateY(100%);\n        transform: translateY(100%);\n    }\n    100% {\n        opacity: 1;\n        -o-transform: translateY(-40%);\n        transform: translateY(-40%);\n    }\n}\n\n@keyframes fadeInUpScale90 {\n    0% {\n        opacity: 0;\n        -webkit-transform: translateY(100%);\n        -o-transform: translateY(100%);\n        transform: translateY(100%);\n    }\n    100% {\n        opacity: 1;\n        -webkit-transform: translateY(-40%);\n        -o-transform: translateY(-40%);\n        transform: translateY(-40%);\n    }\n}\n\nnicio {\n\n    opacity: 0;\n    transform: translateY(-100px) rotateX(-35deg);\n    transition: transform 1s, opacity 1s;\n    /*animation: letras 1s ease-out 2s 1 ;*/\n    /*transition: transform 2s, opacity 1s;*/\n}\n\n.animacionMenuFin {\n    /*animation: letras 1s ease-out 2s 1 ;*/\n    transform: translateY(10%);\n    opacity: 1;\n    transition: transform 1s, opacity 0s;\n}\n\n.animacionFondoMenuInicio {\n\n    opacity: 0;\n    transition: opacity 3s;\n    /*animation: letras 1s ease-out 2s 1 ;*/\n    /*transition: transform 2s, opacity 1s;*/\n}\n\n.animacionFondoMenuFin {\n    /*animation: letras 1s ease-out 2s 1 ;*/\n    opacity: 1;\n    transition: opacity 1s;\n}\n\n@charset \"UTF-8\";\n\n/*!\n * jquery.mb.components\n * file: jquery.mb.YTPlayer.src.js\n * last modified: 01/07/15 19.35\n * Open Lab s.r.l., Florence - Italy\n * email: matteo@open-lab.com\n * site: http://pupunzi.com\n * http://open-lab.com\n * blog: http://pupunzi.open-lab.com\n * Q&A:  http://jquery.pupunzi.com\n * Licences: MIT, GPL\n * http://www.opensource.org/licenses/mit-license.php\n * http://www.gnu.org/licenses/gpl.html\n * Copyright (c) 2001-2015. Matteo Bicocchi (Pupunzi);\n * --------------------------------------------------\n */\n\n.mb_YTPBar, .mb_YTPBar span.mb_YTPUrl a {\n    color: #fff\n}\n\n@font-face {\n    font-family: ytpregular;\n    src: url(../fonts/ytp-regular.eot)\n}\n\n@font-face {\n    font-family: ytpregular;\n    src: url(\"data:application/x-font-woff;charset=utf-8;base64,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)format('woff'\"), url(\"../fonts/ytp-regular.ttf)format('truetype'\")\n}\n\n.mb_YTPlayer:focus {\n    outline: 0\n}\n\n.mbYTP_wrapper {\n    display: block;\n    transform: translateZ(0) translate3d(0, 0, 0);\n    transform-style: preserve-3d;\n    perspective: 1000;\n    -webkit-backface-visibility: hidden;\n    backface-visibility: hidden;\n    box-sizing: border-box\n}\n\n.mb_YTPlayer .loading {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    font-size: 12px;\n    color: #fff;\n    background: rgba(0, 0, 0, .51);\n    text-align: center;\n    padding: 2px 4px;\n    border-radius: 5px;\n    font-family: Droid Sans, sans-serif;\n    -webkit-animation: fade .1s infinite alternate;\n    animation: fade .1s infinite alternate\n}\n\n@-webkit-keyframes fade {\n    0% {\n        opacity: .5\n    }\n    100% {\n        opacity: 1\n    }\n}\n\n@keyframes fade {\n    0% {\n        opacity: .5\n    }\n    100% {\n        opacity: 1\n    }\n}\n\n.fullscreen {\n    display: block !important;\n    position: fixed !important;\n    width: 100% !important;\n    height: 100% !important;\n    top: 0 !important;\n    left: 0 !important;\n    margin: 0 !important;\n    border: none !important;\n    opacity: 1 !important\n}\n\n.mbYTP_wrapper iframe {\n    max-width: 4000px !important\n}\n\n.inline_YTPlayer {\n    margin-bottom: 20px;\n    vertical-align: top;\n    position: relative;\n    left: 0;\n    overflow: hidden;\n    border-radius: 4px;\n    box-shadow: 0 0 5px rgba(0, 0, 0, .7);\n    background: rgba(0, 0, 0, .5)\n}\n\n.inline_YTPlayer img {\n    border: none !important;\n    margin: 0 !important;\n    padding: 0 !important;\n    transform: none !important\n}\n\n.mb_YTPBar, .mb_YTPBar .buttonBar {\n    box-sizing: border-box;\n    left: 0;\n    padding: 5px;\n    width: 100%\n}\n\n.mb_YTPBar .ytpicon {\n    font-size: 20px;\n    font-family: ytpregular\n}\n\n.mb_YTPBar .mb_YTPUrl.ytpicon {\n    font-size: 30px\n}\n\n.mb_YTPBar {\n    transition: opacity .5s;\n    display: block;\n    height: 10px;\n    background: #333;\n    position: fixed;\n    bottom: 0;\n    text-align: left;\n    z-index: 1000;\n    font: 14px/16px sans-serif;\n    opacity: .1\n}\n\n.mb_YTPBar.visible, .mb_YTPBar:hover {\n    opacity: 1\n}\n\n.mb_YTPBar .buttonBar {\n    transition: all .5s;\n    background: 0 0;\n    font: 12px/14px Calibri;\n    position: absolute;\n    top: -30px\n}\n\n.mb_YTPBar:hover .buttonBar {\n    background: rgba(0, 0, 0, .4)\n}\n\n.mb_YTPBar span {\n    display: inline-block;\n    font: 16px/20px Calibri, sans-serif;\n    position: relative;\n    width: 30px;\n    height: 25px;\n    vertical-align: middle\n}\n\n.mb_YTPBar span.mb_YTPTime {\n    width: 130px\n}\n\n.mb_YTPBar span.mb_OnlyYT, .mb_YTPBar span.mb_YTPUrl {\n    position: absolute;\n    width: auto;\n    display: block;\n    top: 6px;\n    right: 10px;\n    cursor: pointer\n}\n\n.mb_YTPBar span.mb_YTPUrl img {\n    width: 60px\n}\n\n.mb_YTPBar span.mb_OnlyYT {\n    left: 300px;\n    right: auto\n}\n\n.mb_YTPBar span.mb_OnlyYT img {\n    width: 25px\n}\n\n.mb_YTPBar .mb_YTPMuteUnmute, .mb_YTPBar .mb_YTPPlaypause, .mb_YTPlayer .mb_YTPBar .mb_YTPPlaypause img {\n    cursor: pointer\n}\n\n.mb_YTPBar .mb_YTPProgress {\n    height: 10px;\n    width: 100%;\n    background: #222;\n    bottom: 0;\n    left: 0\n}\n\n.mb_YTPBar .mb_YTPLoaded {\n    height: 10px;\n    width: 0;\n    background: #444;\n    left: 0\n}\n\n.mb_YTPBar .mb_YTPseekbar {\n    height: 10px;\n    width: 0;\n    background: #000;\n    bottom: 0;\n    left: 0;\n    box-shadow: rgba(82, 82, 82, .47) 1px 1px 3px\n}\n\n.mb_YTPBar .YTPOverlay {\n    backface-visibility: hidden;\n    -webkit-backface-visibility: hidden;\n    -webkit-transform-style: \"flat\";\n    box-sizing: border-box\n}\n\n.YTPOverlay.raster {\n    background: url(images/raster.png)\n}\n\n.YTPOverlay.raster.retina {\n    background: url(images/raster@2x.png)\n}\n\n.YTPOverlay.raster-dot {\n    background: url(images/raster_dot.png)\n}\n\n.YTPOverlay.raster-dot.retina {\n    background: url(images/raster_dot@2x.png)\n}\n\n.mb_YTPBar .simpleSlider {\n    position: relative;\n    width: 100px;\n    height: 10px;\n    border: 1px solid #fff;\n    overflow: hidden;\n    box-sizing: border-box;\n    margin-right: 10px;\n    cursor: pointer !important;\n    border-radius: 3px\n}\n\n.mb_YTPBar.compact .simpleSlider {\n    width: 40px\n}\n\n.mb_YTPBar .simpleSlider.muted {\n    opacity: .3\n}\n\n.mb_YTPBar .level {\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    background-color: #fff;\n    box-sizing: border-box\n}\n\n.mb_YTPBar .level.horizontal {\n    height: 100%;\n    width: 0\n}\n\n.mb_YTPBar .level.vertical {\n    height: auto;\n    width: 100%\n}\n\n/**\n * kenburnsy - Easy to use JQuery plugin to make slideshows with Ken Burns effect\n * @version v0.0.5\n * @link https://github.com/ZeroOneStudio/kenburnsy\n * @license MIT\n * --------------------------------------------------\n */\n\n.kenburnsy {\n    position: relative;\n    overflow: hidden;\n    width: 100%\n}\n\n.kenburnsy.fullscreen {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: -1\n}\n\n.kenburnsy img {\n    display: none\n}\n\n.kenburnsy .slide {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background-position: center center;\n    -webkit-background-size: cover;\n    background-size: cover;\n    background-repeat: no-repeat;\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n    -webkit-transform-origin: center;\n    -ms-transform-origin: center;\n    transform-origin: center\n}\n\n.ss {\n    position: relative;\n    overflow: hidden;\n    width: 100%\n}\n\n.ss.fullscreen {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: -1\n}\n\n.ss img {\n    display: none\n}\n\n.ss .slide {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background-position: center center;\n    -webkit-background-size: cover;\n    background-size: cover;\n    background-repeat: no-repeat;\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n    -webkit-transform-origin: center;\n    -ms-transform-origin: center;\n    transform-origin: center\n}\n\n/*!\n * Animate.css - http://daneden.me/animate\n * Licensed under the MIT license - http://opensource.org/licenses/MIT\n * Copyright (c) 2015 Daniel Eden\n * --------------------------------------------------\n */\n\n.animated {\n    -webkit-animation-duration: 1s;\n    animation-duration: 1s;\n    -webkit-animation-fill-mode: both;\n    animation-fill-mode: both\n}\n\n.animated.infinite {\n    -webkit-animation-iteration-count: infinite;\n    animation-iteration-count: infinite\n}\n\n.animated.hinge {\n    -webkit-animation-duration: 2s;\n    animation-duration: 2s\n}\n\n.animated.bounceIn, .animated.bounceOut {\n    -webkit-animation-duration: .75s;\n    animation-duration: .75s\n}\n\n.animated.flipOutX, .animated.flipOutY {\n    -webkit-animation-duration: .75s;\n    animation-duration: .75s\n}\n\n@-webkit-keyframes bounce {\n    from, 20%, 53%, 80%, 100% {\n        -webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1.000);\n        animation-timing-function: cubic-bezier(.215, .61, .355, 1.000);\n        -webkit-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0)\n    }\n    40%, 43% {\n        -webkit-animation-timing-function: cubic-bezier(.755, .05, .855, .06);\n        animation-timing-function: cubic-bezier(.755, .05, .855, .06);\n        -webkit-transform: translate3d(0, -30px, 0);\n        transform: translate3d(0, -30px, 0)\n    }\n    70% {\n        -webkit-animation-timing-function: cubic-bezier(.755, .05, .855, .06);\n        animation-timing-function: cubic-bezier(.755, .05, .855, .06);\n        -webkit-transform: translate3d(0, -15px, 0);\n        transform: translate3d(0, -15px, 0)\n    }\n    90% {\n        -webkit-transform: translate3d(0, -4px, 0);\n        transform: translate3d(0, -4px, 0)\n    }\n}\n\n@keyframes bounce {\n    from, 20%, 53%, 80%, 100% {\n        -webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1.000);\n        animation-timing-function: cubic-bezier(.215, .61, .355, 1.000);\n        -webkit-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0)\n    }\n    40%, 43% {\n        -webkit-animation-timing-function: cubic-bezier(.755, .05, .855, .06);\n        animation-timing-function: cubic-bezier(.755, .05, .855, .06);\n        -webkit-transform: translate3d(0, -30px, 0);\n        transform: translate3d(0, -30px, 0)\n    }\n    70% {\n        -webkit-animation-timing-function: cubic-bezier(.755, .05, .855, .06);\n        animation-timing-function: cubic-bezier(.755, .05, .855, .06);\n        -webkit-transform: translate3d(0, -15px, 0);\n        transform: translate3d(0, -15px, 0)\n    }\n    90% {\n        -webkit-transform: translate3d(0, -4px, 0);\n        transform: translate3d(0, -4px, 0)\n    }\n}\n\n.bounce {\n    -webkit-animation-name: bounce;\n    animation-name: bounce;\n    -webkit-transform-origin: center bottom;\n    transform-origin: center bottom\n}\n\n@-webkit-keyframes flash {\n    from, 50%, 100% {\n        opacity: 1\n    }\n    25%, 75% {\n        opacity: 0\n    }\n}\n\n@keyframes flash {\n    from, 50%, 100% {\n        opacity: 1\n    }\n    25%, 75% {\n        opacity: 0\n    }\n}\n\n.flash {\n    -webkit-animation-name: flash;\n    animation-name: flash\n}\n\n@-webkit-keyframes pulse {\n    from {\n        -webkit-transform: scale3d(1, 1, 1);\n        transform: scale3d(1, 1, 1)\n    }\n    50% {\n        -webkit-transform: scale3d(1.05, 1.05, 1.05);\n        transform: scale3d(1.05, 1.05, 1.05)\n    }\n    100% {\n        -webkit-transform: scale3d(1, 1, 1);\n        transform: scale3d(1, 1, 1)\n    }\n}\n\n@keyframes pulse {\n    from {\n        -webkit-transform: scale3d(1, 1, 1);\n        transform: scale3d(1, 1, 1)\n    }\n    50% {\n        -webkit-transform: scale3d(1.05, 1.05, 1.05);\n        transform: scale3d(1.05, 1.05, 1.05)\n    }\n    100% {\n        -webkit-transform: scale3d(1, 1, 1);\n        transform: scale3d(1, 1, 1)\n    }\n}\n\n.pulse {\n    -webkit-animation-name: pulse;\n    animation-name: pulse\n}\n\n@-webkit-keyframes rubberBand {\n    from {\n        -webkit-transform: scale3d(1, 1, 1);\n        transform: scale3d(1, 1, 1)\n    }\n    30% {\n        -webkit-transform: scale3d(1.25, .75, 1);\n        transform: scale3d(1.25, .75, 1)\n    }\n    40% {\n        -webkit-transform: scale3d(.75, 1.25, 1);\n        transform: scale3d(.75, 1.25, 1)\n    }\n    50% {\n        -webkit-transform: scale3d(1.15, .85, 1);\n        transform: scale3d(1.15, .85, 1)\n    }\n    65% {\n        -webkit-transform: scale3d(.95, 1.05, 1);\n        transform: scale3d(.95, 1.05, 1)\n    }\n    75% {\n        -webkit-transform: scale3d(1.05, .95, 1);\n        transform: scale3d(1.05, .95, 1)\n    }\n    100% {\n        -webkit-transform: scale3d(1, 1, 1);\n        transform: scale3d(1, 1, 1)\n    }\n}\n\n@keyframes rubberBand {\n    from {\n        -webkit-transform: scale3d(1, 1, 1);\n        transform: scale3d(1, 1, 1)\n    }\n    30% {\n        -webkit-transform: scale3d(1.25, .75, 1);\n        transform: scale3d(1.25, .75, 1)\n    }\n    40% {\n        -webkit-transform: scale3d(.75, 1.25, 1);\n        transform: scale3d(.75, 1.25, 1)\n    }\n    50% {\n        -webkit-transform: scale3d(1.15, .85, 1);\n        transform: scale3d(1.15, .85, 1)\n    }\n    65% {\n        -webkit-transform: scale3d(.95, 1.05, 1);\n        transform: scale3d(.95, 1.05, 1)\n    }\n    75% {\n        -webkit-transform: scale3d(1.05, .95, 1);\n        transform: scale3d(1.05, .95, 1)\n    }\n    100% {\n        -webkit-transform: scale3d(1, 1, 1);\n        transform: scale3d(1, 1, 1)\n    }\n}\n\n.rubberBand {\n    -webkit-animation-name: rubberBand;\n    animation-name: rubberBand\n}\n\n@-webkit-keyframes shake {\n    from, 100% {\n        -webkit-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0)\n    }\n    10%, 30%, 50%, 70%, 90% {\n        -webkit-transform: translate3d(-10px, 0, 0);\n        transform: translate3d(-10px, 0, 0)\n    }\n    20%, 40%, 60%, 80% {\n        -webkit-transform: translate3d(10px, 0, 0);\n        transform: translate3d(10px, 0, 0)\n    }\n}\n\n@keyframes shake {\n    from, 100% {\n        -webkit-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0)\n    }\n    10%, 30%, 50%, 70%, 90% {\n        -webkit-transform: translate3d(-10px, 0, 0);\n        transform: translate3d(-10px, 0, 0)\n    }\n    20%, 40%, 60%, 80% {\n        -webkit-transform: translate3d(10px, 0, 0);\n        transform: translate3d(10px, 0, 0)\n    }\n}\n\n.shake {\n    -webkit-animation-name: shake;\n    animation-name: shake\n}\n\n@-webkit-keyframes swing {\n    20% {\n        -webkit-transform: rotate3d(0, 0, 1, 15deg);\n        transform: rotate3d(0, 0, 1, 15deg)\n    }\n    40% {\n        -webkit-transform: rotate3d(0, 0, 1, -10deg);\n        transform: rotate3d(0, 0, 1, -10deg)\n    }\n    60% {\n        -webkit-transform: rotate3d(0, 0, 1, 5deg);\n        transform: rotate3d(0, 0, 1, 5deg)\n    }\n    80% {\n        -webkit-transform: rotate3d(0, 0, 1, -5deg);\n        transform: rotate3d(0, 0, 1, -5deg)\n    }\n    100% {\n        -webkit-transform: rotate3d(0, 0, 1, 0deg);\n        transform: rotate3d(0, 0, 1, 0deg)\n    }\n}\n\n@keyframes swing {\n    20% {\n        -webkit-transform: rotate3d(0, 0, 1, 15deg);\n        transform: rotate3d(0, 0, 1, 15deg)\n    }\n    40% {\n        -webkit-transform: rotate3d(0, 0, 1, -10deg);\n        transform: rotate3d(0, 0, 1, -10deg)\n    }\n    60% {\n        -webkit-transform: rotate3d(0, 0, 1, 5deg);\n        transform: rotate3d(0, 0, 1, 5deg)\n    }\n    80% {\n        -webkit-transform: rotate3d(0, 0, 1, -5deg);\n        transform: rotate3d(0, 0, 1, -5deg)\n    }\n    100% {\n        -webkit-transform: rotate3d(0, 0, 1, 0deg);\n        transform: rotate3d(0, 0, 1, 0deg)\n    }\n}\n\n.swing {\n    -webkit-transform-origin: top center;\n    transform-origin: top center;\n    -webkit-animation-name: swing;\n    animation-name: swing\n}\n\n@-webkit-keyframes tada {\n    from {\n        -webkit-transform: scale3d(1, 1, 1);\n        transform: scale3d(1, 1, 1)\n    }\n    10%, 20% {\n        -webkit-transform: scale3d(.9, .9, .9) rotate3d(0, 0, 1, -3deg);\n        transform: scale3d(.9, .9, .9) rotate3d(0, 0, 1, -3deg)\n    }\n    30%, 50%, 70%, 90% {\n        -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);\n        transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg)\n    }\n    40%, 60%, 80% {\n        -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);\n        transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg)\n    }\n    100% {\n        -webkit-transform: scale3d(1, 1, 1);\n        transform: scale3d(1, 1, 1)\n    }\n}\n\n@keyframes tada {\n    from {\n        -webkit-transform: scale3d(1, 1, 1);\n        transform: scale3d(1, 1, 1)\n    }\n    10%, 20% {\n        -webkit-transform: scale3d(.9, .9, .9) rotate3d(0, 0, 1, -3deg);\n        transform: scale3d(.9, .9, .9) rotate3d(0, 0, 1, -3deg)\n    }\n    30%, 50%, 70%, 90% {\n        -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);\n        transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg)\n    }\n    40%, 60%, 80% {\n        -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);\n        transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg)\n    }\n    100% {\n        -webkit-transform: scale3d(1, 1, 1);\n        transform: scale3d(1, 1, 1)\n    }\n}\n\n.tada {\n    -webkit-animation-name: tada;\n    animation-name: tada\n}\n\n@-webkit-keyframes wobble {\n    from {\n        -webkit-transform: none;\n        transform: none\n    }\n    15% {\n        -webkit-transform: translate3d(-25%, 0, 0) rotate3d(0, 0, 1, -5deg);\n        transform: translate3d(-25%, 0, 0) rotate3d(0, 0, 1, -5deg)\n    }\n    30% {\n        -webkit-transform: translate3d(20%, 0, 0) rotate3d(0, 0, 1, 3deg);\n        transform: translate3d(20%, 0, 0) rotate3d(0, 0, 1, 3deg)\n    }\n    45% {\n        -webkit-transform: translate3d(-15%, 0, 0) rotate3d(0, 0, 1, -3deg);\n        transform: translate3d(-15%, 0, 0) rotate3d(0, 0, 1, -3deg)\n    }\n    60% {\n        -webkit-transform: translate3d(10%, 0, 0) rotate3d(0, 0, 1, 2deg);\n        transform: translate3d(10%, 0, 0) rotate3d(0, 0, 1, 2deg)\n    }\n    75% {\n        -webkit-transform: translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -1deg);\n        transform: translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -1deg)\n    }\n    100% {\n        -webkit-transform: none;\n        transform: none\n    }\n}\n\n@keyframes wobble {\n    from {\n        -webkit-transform: none;\n        transform: none\n    }\n    15% {\n        -webkit-transform: translate3d(-25%, 0, 0) rotate3d(0, 0, 1, -5deg);\n        transform: translate3d(-25%, 0, 0) rotate3d(0, 0, 1, -5deg)\n    }\n    30% {\n        -webkit-transform: translate3d(20%, 0, 0) rotate3d(0, 0, 1, 3deg);\n        transform: translate3d(20%, 0, 0) rotate3d(0, 0, 1, 3deg)\n    }\n    45% {\n        -webkit-transform: translate3d(-15%, 0, 0) rotate3d(0, 0, 1, -3deg);\n        transform: translate3d(-15%, 0, 0) rotate3d(0, 0, 1, -3deg)\n    }\n    60% {\n        -webkit-transform: translate3d(10%, 0, 0) rotate3d(0, 0, 1, 2deg);\n        transform: translate3d(10%, 0, 0) rotate3d(0, 0, 1, 2deg)\n    }\n    75% {\n        -webkit-transform: translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -1deg);\n        transform: translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -1deg)\n    }\n    100% {\n        -webkit-transform: none;\n        transform: none\n    }\n}\n\n.wobble {\n    -webkit-animation-name: wobble;\n    animation-name: wobble\n}\n\n@-webkit-keyframes jello {\n    from, 11.1%, 100% {\n        -webkit-transform: none;\n        transform: none\n    }\n    22.2% {\n        -webkit-transform: skewX(-12.5deg) skewY(-12.5deg);\n        transform: skewX(-12.5deg) skewY(-12.5deg)\n    }\n    33.3% {\n        -webkit-transform: skewX(6.25deg) skewY(6.25deg);\n        transform: skewX(6.25deg) skewY(6.25deg)\n    }\n    44.4% {\n        -webkit-transform: skewX(-3.125deg) skewY(-3.125deg);\n        transform: skewX(-3.125deg) skewY(-3.125deg)\n    }\n    55.5% {\n        -webkit-transform: skewX(1.5625deg) skewY(1.5625deg);\n        transform: skewX(1.5625deg) skewY(1.5625deg)\n    }\n    66.6% {\n        -webkit-transform: skewX(-.78125deg) skewY(-.78125deg);\n        transform: skewX(-.78125deg) skewY(-.78125deg)\n    }\n    77.7% {\n        -webkit-transform: skewX(.390625deg) skewY(.390625deg);\n        transform: skewX(.390625deg) skewY(.390625deg)\n    }\n    88.8% {\n        -webkit-transform: skewX(-.1953125deg) skewY(-.1953125deg);\n        transform: skewX(-.1953125deg) skewY(-.1953125deg)\n    }\n}\n\n@keyframes jello {\n    from, 11.1%, 100% {\n        -webkit-transform: none;\n        transform: none\n    }\n    22.2% {\n        -webkit-transform: skewX(-12.5deg) skewY(-12.5deg);\n        transform: skewX(-12.5deg) skewY(-12.5deg)\n    }\n    33.3% {\n        -webkit-transform: skewX(6.25deg) skewY(6.25deg);\n        transform: skewX(6.25deg) skewY(6.25deg)\n    }\n    44.4% {\n        -webkit-transform: skewX(-3.125deg) skewY(-3.125deg);\n        transform: skewX(-3.125deg) skewY(-3.125deg)\n    }\n    55.5% {\n        -webkit-transform: skewX(1.5625deg) skewY(1.5625deg);\n        transform: skewX(1.5625deg) skewY(1.5625deg)\n    }\n    66.6% {\n        -webkit-transform: skewX(-.78125deg) skewY(-.78125deg);\n        transform: skewX(-.78125deg) skewY(-.78125deg)\n    }\n    77.7% {\n        -webkit-transform: skewX(.390625deg) skewY(.390625deg);\n        transform: skewX(.390625deg) skewY(.390625deg)\n    }\n    88.8% {\n        -webkit-transform: skewX(-.1953125deg) skewY(-.1953125deg);\n        transform: skewX(-.1953125deg) skewY(-.1953125deg)\n    }\n}\n\n.jello {\n    -webkit-animation-name: jello;\n    animation-name: jello;\n    -webkit-transform-origin: center;\n    transform-origin: center\n}\n\n@-webkit-keyframes bounceIn {\n    from, 20%, 40%, 60%, 80%, 100% {\n        -webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1.000);\n        animation-timing-function: cubic-bezier(.215, .61, .355, 1.000)\n    }\n    0% {\n        opacity: 0;\n        -webkit-transform: scale3d(.3, .3, .3);\n        transform: scale3d(.3, .3, .3)\n    }\n    20% {\n        -webkit-transform: scale3d(1.1, 1.1, 1.1);\n        transform: scale3d(1.1, 1.1, 1.1)\n    }\n    40% {\n        -webkit-transform: scale3d(.9, .9, .9);\n        transform: scale3d(.9, .9, .9)\n    }\n    60% {\n        opacity: 1;\n        -webkit-transform: scale3d(1.03, 1.03, 1.03);\n        transform: scale3d(1.03, 1.03, 1.03)\n    }\n    80% {\n        -webkit-transform: scale3d(.97, .97, .97);\n        transform: scale3d(.97, .97, .97)\n    }\n    100% {\n        opacity: 1;\n        -webkit-transform: scale3d(1, 1, 1);\n        transform: scale3d(1, 1, 1)\n    }\n}\n\n@keyframes bounceIn {\n    from, 20%, 40%, 60%, 80%, 100% {\n        -webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1.000);\n        animation-timing-function: cubic-bezier(.215, .61, .355, 1.000)\n    }\n    0% {\n        opacity: 0;\n        -webkit-transform: scale3d(.3, .3, .3);\n        transform: scale3d(.3, .3, .3)\n    }\n    20% {\n        -webkit-transform: scale3d(1.1, 1.1, 1.1);\n        transform: scale3d(1.1, 1.1, 1.1)\n    }\n    40% {\n        -webkit-transform: scale3d(.9, .9, .9);\n        transform: scale3d(.9, .9, .9)\n    }\n    60% {\n        opacity: 1;\n        -webkit-transform: scale3d(1.03, 1.03, 1.03);\n        transform: scale3d(1.03, 1.03, 1.03)\n    }\n    80% {\n        -webkit-transform: scale3d(.97, .97, .97);\n        transform: scale3d(.97, .97, .97)\n    }\n    100% {\n        opacity: 1;\n        -webkit-transform: scale3d(1, 1, 1);\n        transform: scale3d(1, 1, 1)\n    }\n}\n\n.bounceIn {\n    -webkit-animation-name: bounceIn;\n    animation-name: bounceIn\n}\n\n@-webkit-keyframes bounceInDown {\n    from, 60%, 75%, 90%, 100% {\n        -webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1.000);\n        animation-timing-function: cubic-bezier(.215, .61, .355, 1.000)\n    }\n    0% {\n        opacity: 0;\n        -webkit-transform: translate3d(0, -3000px, 0);\n        transform: translate3d(0, -3000px, 0)\n    }\n    60% {\n        opacity: 1;\n        -webkit-transform: translate3d(0, 25px, 0);\n        transform: translate3d(0, 25px, 0)\n    }\n    75% {\n        -webkit-transform: translate3d(0, -10px, 0);\n        transform: translate3d(0, -10px, 0)\n    }\n    90% {\n        -webkit-transform: translate3d(0, 5px, 0);\n        transform: translate3d(0, 5px, 0)\n    }\n    100% {\n        -webkit-transform: none;\n        transform: none\n    }\n}\n\n@keyframes bounceInDown {\n    from, 60%, 75%, 90%, 100% {\n        -webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1.000);\n        animation-timing-function: cubic-bezier(.215, .61, .355, 1.000)\n    }\n    0% {\n        opacity: 0;\n        -webkit-transform: translate3d(0, -3000px, 0);\n        transform: translate3d(0, -3000px, 0)\n    }\n    60% {\n        opacity: 1;\n        -webkit-transform: translate3d(0, 25px, 0);\n        transform: translate3d(0, 25px, 0)\n    }\n    75% {\n        -webkit-transform: translate3d(0, -10px, 0);\n        transform: translate3d(0, -10px, 0)\n    }\n    90% {\n        -webkit-transform: translate3d(0, 5px, 0);\n        transform: translate3d(0, 5px, 0)\n    }\n    100% {\n        -webkit-transform: none;\n        transform: none\n    }\n}\n\n.bounceInDown {\n    -webkit-animation-name: bounceInDown;\n    animation-name: bounceInDown\n}\n\n@-webkit-keyframes bounceInLeft {\n    from, 60%, 75%, 90%, 100% {\n        -webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1.000);\n        animation-timing-function: cubic-bezier(.215, .61, .355, 1.000)\n    }\n    0% {\n        opacity: 0;\n        -webkit-transform: translate3d(-3000px, 0, 0);\n        transform: translate3d(-3000px, 0, 0)\n    }\n    60% {\n        opacity: 1;\n        -webkit-transform: translate3d(25px, 0, 0);\n        transform: translate3d(25px, 0, 0)\n    }\n    75% {\n        -webkit-transform: translate3d(-10px, 0, 0);\n        transform: translate3d(-10px, 0, 0)\n    }\n    90% {\n        -webkit-transform: translate3d(5px, 0, 0);\n        transform: translate3d(5px, 0, 0)\n    }\n    100% {\n        -webkit-transform: none;\n        transform: none\n    }\n}\n\n@keyframes bounceInLeft {\n    from, 60%, 75%, 90%, 100% {\n        -webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1.000);\n        animation-timing-function: cubic-bezier(.215, .61, .355, 1.000)\n    }\n    0% {\n        opacity: 0;\n        -webkit-transform: translate3d(-3000px, 0, 0);\n        transform: translate3d(-3000px, 0, 0)\n    }\n    60% {\n        opacity: 1;\n        -webkit-transform: translate3d(25px, 0, 0);\n        transform: translate3d(25px, 0, 0)\n    }\n    75% {\n        -webkit-transform: translate3d(-10px, 0, 0);\n        transform: translate3d(-10px, 0, 0)\n    }\n    90% {\n        -webkit-transform: translate3d(5px, 0, 0);\n        transform: translate3d(5px, 0, 0)\n    }\n    100% {\n        -webkit-transform: none;\n        transform: none\n    }\n}\n\n.bounceInLeft {\n    -webkit-animation-name: bounceInLeft;\n    animation-name: bounceInLeft\n}\n\n@-webkit-keyframes bounceInRight {\n    from, 60%, 75%, 90%, 100% {\n        -webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1.000);\n        animation-timing-function: cubic-bezier(.215, .61, .355, 1.000)\n    }\n    from {\n        opacity: 0;\n        -webkit-transform: translate3d(3000px, 0, 0);\n        transform: translate3d(3000px, 0, 0)\n    }\n    60% {\n        opacity: 1;\n        -webkit-transform: translate3d(-25px, 0, 0);\n        transform: translate3d(-25px, 0, 0)\n    }\n    75% {\n        -webkit-transform: translate3d(10px, 0, 0);\n        transform: translate3d(10px, 0, 0)\n    }\n    90% {\n        -webkit-transform: translate3d(-5px, 0, 0);\n        transform: translate3d(-5px, 0, 0)\n    }\n    100% {\n        -webkit-transform: none;\n        transform: none\n    }\n}\n\n@keyframes bounceInRight {\n    from, 60%, 75%, 90%, 100% {\n        -webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1.000);\n        animation-timing-function: cubic-bezier(.215, .61, .355, 1.000)\n    }\n    from {\n        opacity: 0;\n        -webkit-transform: translate3d(3000px, 0, 0);\n        transform: translate3d(3000px, 0, 0)\n    }\n    60% {\n        opacity: 1;\n        -webkit-transform: translate3d(-25px, 0, 0);\n        transform: translate3d(-25px, 0, 0)\n    }\n    75% {\n        -webkit-transform: translate3d(10px, 0, 0);\n        transform: translate3d(10px, 0, 0)\n    }\n    90% {\n        -webkit-transform: translate3d(-5px, 0, 0);\n        transform: translate3d(-5px, 0, 0)\n    }\n    100% {\n        -webkit-transform: none;\n        transform: none\n    }\n}\n\n.bounceInRight {\n    -webkit-animation-name: bounceInRight;\n    animation-name: bounceInRight\n}\n\n@-webkit-keyframes bounceInUp {\n    from, 60%, 75%, 90%, 100% {\n        -webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1.000);\n        animation-timing-function: cubic-bezier(.215, .61, .355, 1.000)\n    }\n    from {\n        opacity: 0;\n        -webkit-transform: translate3d(0, 3000px, 0);\n        transform: translate3d(0, 3000px, 0)\n    }\n    60% {\n        opacity: 1;\n        -webkit-transform: translate3d(0, -20px, 0);\n        transform: translate3d(0, -20px, 0)\n    }\n    75% {\n        -webkit-transform: translate3d(0, 10px, 0);\n        transform: translate3d(0, 10px, 0)\n    }\n    90% {\n        -webkit-transform: translate3d(0, -5px, 0);\n        transform: translate3d(0, -5px, 0)\n    }\n    100% {\n        -webkit-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0)\n    }\n}\n\n@keyframes bounceInUp {\n    from, 60%, 75%, 90%, 100% {\n        -webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1.000);\n        animation-timing-function: cubic-bezier(.215, .61, .355, 1.000)\n    }\n    from {\n        opacity: 0;\n        -webkit-transform: translate3d(0, 3000px, 0);\n        transform: translate3d(0, 3000px, 0)\n    }\n    60% {\n        opacity: 1;\n        -webkit-transform: translate3d(0, -20px, 0);\n        transform: translate3d(0, -20px, 0)\n    }\n    75% {\n        -webkit-transform: translate3d(0, 10px, 0);\n        transform: translate3d(0, 10px, 0)\n    }\n    90% {\n        -webkit-transform: translate3d(0, -5px, 0);\n        transform: translate3d(0, -5px, 0)\n    }\n    100% {\n        -webkit-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0)\n    }\n}\n\n.bounceInUp {\n    -webkit-animation-name: bounceInUp;\n    animation-name: bounceInUp\n}\n\n@-webkit-keyframes bounceOut {\n    20% {\n        -webkit-transform: scale3d(.9, .9, .9);\n        transform: scale3d(.9, .9, .9)\n    }\n    50%, 55% {\n        opacity: 1;\n        -webkit-transform: scale3d(1.1, 1.1, 1.1);\n        transform: scale3d(1.1, 1.1, 1.1)\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: scale3d(.3, .3, .3);\n        transform: scale3d(.3, .3, .3)\n    }\n}\n\n@keyframes bounceOut {\n    20% {\n        -webkit-transform: scale3d(.9, .9, .9);\n        transform: scale3d(.9, .9, .9)\n    }\n    50%, 55% {\n        opacity: 1;\n        -webkit-transform: scale3d(1.1, 1.1, 1.1);\n        transform: scale3d(1.1, 1.1, 1.1)\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: scale3d(.3, .3, .3);\n        transform: scale3d(.3, .3, .3)\n    }\n}\n\n.bounceOut {\n    -webkit-animation-name: bounceOut;\n    animation-name: bounceOut\n}\n\n@-webkit-keyframes bounceOutDown {\n    20% {\n        -webkit-transform: translate3d(0, 10px, 0);\n        transform: translate3d(0, 10px, 0)\n    }\n    40%, 45% {\n        opacity: 1;\n        -webkit-transform: translate3d(0, -20px, 0);\n        transform: translate3d(0, -20px, 0)\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translate3d(0, 2000px, 0);\n        transform: translate3d(0, 2000px, 0)\n    }\n}\n\n@keyframes bounceOutDown {\n    20% {\n        -webkit-transform: translate3d(0, 10px, 0);\n        transform: translate3d(0, 10px, 0)\n    }\n    40%, 45% {\n        opacity: 1;\n        -webkit-transform: translate3d(0, -20px, 0);\n        transform: translate3d(0, -20px, 0)\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translate3d(0, 2000px, 0);\n        transform: translate3d(0, 2000px, 0)\n    }\n}\n\n.bounceOutDown {\n    -webkit-animation-name: bounceOutDown;\n    animation-name: bounceOutDown\n}\n\n@-webkit-keyframes bounceOutLeft {\n    20% {\n        opacity: 1;\n        -webkit-transform: translate3d(20px, 0, 0);\n        transform: translate3d(20px, 0, 0)\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translate3d(-2000px, 0, 0);\n        transform: translate3d(-2000px, 0, 0)\n    }\n}\n\n@keyframes bounceOutLeft {\n    20% {\n        opacity: 1;\n        -webkit-transform: translate3d(20px, 0, 0);\n        transform: translate3d(20px, 0, 0)\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translate3d(-2000px, 0, 0);\n        transform: translate3d(-2000px, 0, 0)\n    }\n}\n\n.bounceOutLeft {\n    -webkit-animation-name: bounceOutLeft;\n    animation-name: bounceOutLeft\n}\n\n@-webkit-keyframes bounceOutRight {\n    20% {\n        opacity: 1;\n        -webkit-transform: translate3d(-20px, 0, 0);\n        transform: translate3d(-20px, 0, 0)\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translate3d(2000px, 0, 0);\n        transform: translate3d(2000px, 0, 0)\n    }\n}\n\n@keyframes bounceOutRight {\n    20% {\n        opacity: 1;\n        -webkit-transform: translate3d(-20px, 0, 0);\n        transform: translate3d(-20px, 0, 0)\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translate3d(2000px, 0, 0);\n        transform: translate3d(2000px, 0, 0)\n    }\n}\n\n.bounceOutRight {\n    -webkit-animation-name: bounceOutRight;\n    animation-name: bounceOutRight\n}\n\n@-webkit-keyframes bounceOutUp {\n    20% {\n        -webkit-transform: translate3d(0, -10px, 0);\n        transform: translate3d(0, -10px, 0)\n    }\n    40%, 45% {\n        opacity: 1;\n        -webkit-transform: translate3d(0, 20px, 0);\n        transform: translate3d(0, 20px, 0)\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translate3d(0, -2000px, 0);\n        transform: translate3d(0, -2000px, 0)\n    }\n}\n\n@keyframes bounceOutUp {\n    20% {\n        -webkit-transform: translate3d(0, -10px, 0);\n        transform: translate3d(0, -10px, 0)\n    }\n    40%, 45% {\n        opacity: 1;\n        -webkit-transform: translate3d(0, 20px, 0);\n        transform: translate3d(0, 20px, 0)\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translate3d(0, -2000px, 0);\n        transform: translate3d(0, -2000px, 0)\n    }\n}\n\n.bounceOutUp {\n    -webkit-animation-name: bounceOutUp;\n    animation-name: bounceOutUp\n}\n\n@-webkit-keyframes fadeIn {\n    from {\n        opacity: 0\n    }\n    100% {\n        opacity: 1\n    }\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0\n    }\n    100% {\n        opacity: 1\n    }\n}\n\n.fadeIn {\n    -webkit-animation-name: fadeIn;\n    animation-name: fadeIn\n}\n\n@-webkit-keyframes fadeInDown {\n    from {\n        opacity: 0;\n        -webkit-transform: translate3d(0, -100%, 0);\n        transform: translate3d(0, -100%, 0)\n    }\n    100% {\n        opacity: 1;\n        -webkit-transform: none;\n        transform: none\n    }\n}\n\n@keyframes fadeInDown {\n    from {\n        opacity: 0;\n        -webkit-transform: translate3d(0, -100%, 0);\n        transform: translate3d(0, -100%, 0)\n    }\n    100% {\n        opacity: 1;\n        -webkit-transform: none;\n        transform: none\n    }\n}\n\n.fadeInDown {\n    -webkit-animation-name: fadeInDown;\n    animation-name: fadeInDown\n}\n\n@-webkit-keyframes fadeInDownBig {\n    from {\n        opacity: 0;\n        -webkit-transform: translate3d(0, -2000px, 0);\n        transform: translate3d(0, -2000px, 0)\n    }\n    100% {\n        opacity: 1;\n        -webkit-transform: none;\n        transform: none\n    }\n}\n\n@keyframes fadeInDownBig {\n    from {\n        opacity: 0;\n        -webkit-transform: translate3d(0, -2000px, 0);\n        transform: translate3d(0, -2000px, 0)\n    }\n    100% {\n        opacity: 1;\n        -webkit-transform: none;\n        transform: none\n    }\n}\n\n.fadeInDownBig {\n    -webkit-animation-name: fadeInDownBig;\n    animation-name: fadeInDownBig\n}\n\n@-webkit-keyframes fadeInLeft {\n    from {\n        opacity: 0;\n        -webkit-transform: translate3d(-100%, 0, 0);\n        transform: translate3d(-100%, 0, 0)\n    }\n    100% {\n        opacity: 1;\n        -webkit-transform: none;\n        transform: none\n    }\n}\n\n@keyframes fadeInLeft {\n    from {\n        opacity: 0;\n        -webkit-transform: translate3d(-100%, 0, 0);\n        transform: translate3d(-100%, 0, 0)\n    }\n    100% {\n        opacity: 1;\n        -webkit-transform: none;\n        transform: none\n    }\n}\n\n.fadeInLeft {\n    -webkit-animation-name: fadeInLeft;\n    animation-name: fadeInLeft\n}\n\n@-webkit-keyframes fadeInLeftBig {\n    from {\n        opacity: 0;\n        -webkit-transform: translate3d(-2000px, 0, 0);\n        transform: translate3d(-2000px, 0, 0)\n    }\n    100% {\n        opacity: 1;\n        -webkit-transform: none;\n        transform: none\n    }\n}\n\n@keyframes fadeInLeftBig {\n    from {\n        opacity: 0;\n        -webkit-transform: translate3d(-2000px, 0, 0);\n        transform: translate3d(-2000px, 0, 0)\n    }\n    100% {\n        opacity: 1;\n        -webkit-transform: none;\n        transform: none\n    }\n}\n\n.fadeInLeftBig {\n    -webkit-animation-name: fadeInLeftBig;\n    animation-name: fadeInLeftBig\n}\n\n@-webkit-keyframes fadeInRight {\n    from {\n        opacity: 0;\n        -webkit-transform: translate3d(100%, 0, 0);\n        transform: translate3d(100%, 0, 0)\n    }\n    100% {\n        opacity: 1;\n        -webkit-transform: none;\n        transform: none\n    }\n}\n\n@keyframes fadeInRight {\n    from {\n        opacity: 0;\n        -webkit-transform: translate3d(100%, 0, 0);\n        transform: translate3d(100%, 0, 0)\n    }\n    100% {\n        opacity: 1;\n        -webkit-transform: none;\n        transform: none\n    }\n}\n\n.fadeInRight {\n    -webkit-animation-name: fadeInRight;\n    animation-name: fadeInRight\n}\n\n@-webkit-keyframes fadeInRightBig {\n    from {\n        opacity: 0;\n        -webkit-transform: translate3d(2000px, 0, 0);\n        transform: translate3d(2000px, 0, 0)\n    }\n    100% {\n        opacity: 1;\n        -webkit-transform: none;\n        transform: none\n    }\n}\n\n@keyframes fadeInRightBig {\n    from {\n        opacity: 0;\n        -webkit-transform: translate3d(2000px, 0, 0);\n        transform: translate3d(2000px, 0, 0)\n    }\n    100% {\n        opacity: 1;\n        -webkit-transform: none;\n        transform: none\n    }\n}\n\n.fadeInRightBig {\n    -webkit-animation-name: fadeInRightBig;\n    animation-name: fadeInRightBig\n}\n\n@-webkit-keyframes fadeInUp {\n    from {\n        opacity: 0;\n        -webkit-transform: translate3d(0, 100%, 0);\n        transform: translate3d(0, 100%, 0)\n    }\n    100% {\n        opacity: 1;\n        -webkit-transform: none;\n        transform: none\n    }\n}\n\n@keyframes fadeInUp {\n    from {\n        opacity: 0;\n        -webkit-transform: translate3d(0, 100%, 0);\n        transform: translate3d(0, 100%, 0)\n    }\n    100% {\n        opacity: 1;\n        -webkit-transform: none;\n        transform: none\n    }\n}\n\n.fadeInUp {\n    -webkit-animation-name: fadeInUp;\n    animation-name: fadeInUp\n}\n\n@-webkit-keyframes fadeInUpBig {\n    from {\n        opacity: 0;\n        -webkit-transform: translate3d(0, 2000px, 0);\n        transform: translate3d(0, 2000px, 0)\n    }\n    100% {\n        opacity: 1;\n        -webkit-transform: none;\n        transform: none\n    }\n}\n\n@keyframes fadeInUpBig {\n    from {\n        opacity: 0;\n        -webkit-transform: translate3d(0, 2000px, 0);\n        transform: translate3d(0, 2000px, 0)\n    }\n    100% {\n        opacity: 1;\n        -webkit-transform: none;\n        transform: none\n    }\n}\n\n.fadeInUpBig {\n    -webkit-animation-name: fadeInUpBig;\n    animation-name: fadeInUpBig\n}\n\n@-webkit-keyframes fadeOut {\n    from {\n        opacity: 1\n    }\n    100% {\n        opacity: 0\n    }\n}\n\n@keyframes fadeOut {\n    from {\n        opacity: 1\n    }\n    100% {\n        opacity: 0\n    }\n}\n\n.fadeOut {\n    -webkit-animation-name: fadeOut;\n    animation-name: fadeOut\n}\n\n@-webkit-keyframes fadeOutDown {\n    from {\n        opacity: 1\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translate3d(0, 100%, 0);\n        transform: translate3d(0, 100%, 0)\n    }\n}\n\n@keyframes fadeOutDown {\n    from {\n        opacity: 1\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translate3d(0, 100%, 0);\n        transform: translate3d(0, 100%, 0)\n    }\n}\n\n.fadeOutDown {\n    -webkit-animation-name: fadeOutDown;\n    animation-name: fadeOutDown\n}\n\n@-webkit-keyframes fadeOutDownBig {\n    from {\n        opacity: 1\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translate3d(0, 2000px, 0);\n        transform: translate3d(0, 2000px, 0)\n    }\n}\n\n@keyframes fadeOutDownBig {\n    from {\n        opacity: 1\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translate3d(0, 2000px, 0);\n        transform: translate3d(0, 2000px, 0)\n    }\n}\n\n.fadeOutDownBig {\n    -webkit-animation-name: fadeOutDownBig;\n    animation-name: fadeOutDownBig\n}\n\n@-webkit-keyframes fadeOutLeft {\n    from {\n        opacity: 1\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translate3d(-100%, 0, 0);\n        transform: translate3d(-100%, 0, 0)\n    }\n}\n\n@keyframes fadeOutLeft {\n    from {\n        opacity: 1\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translate3d(-100%, 0, 0);\n        transform: translate3d(-100%, 0, 0)\n    }\n}\n\n.fadeOutLeft {\n    -webkit-animation-name: fadeOutLeft;\n    animation-name: fadeOutLeft\n}\n\n@-webkit-keyframes fadeOutLeftBig {\n    from {\n        opacity: 1\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translate3d(-2000px, 0, 0);\n        transform: translate3d(-2000px, 0, 0)\n    }\n}\n\n@keyframes fadeOutLeftBig {\n    from {\n        opacity: 1\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translate3d(-2000px, 0, 0);\n        transform: translate3d(-2000px, 0, 0)\n    }\n}\n\n.fadeOutLeftBig {\n    -webkit-animation-name: fadeOutLeftBig;\n    animation-name: fadeOutLeftBig\n}\n\n@-webkit-keyframes fadeOutRight {\n    from {\n        opacity: 1\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translate3d(100%, 0, 0);\n        transform: translate3d(100%, 0, 0)\n    }\n}\n\n@keyframes fadeOutRight {\n    from {\n        opacity: 1\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translate3d(100%, 0, 0);\n        transform: translate3d(100%, 0, 0)\n    }\n}\n\n.fadeOutRight {\n    -webkit-animation-name: fadeOutRight;\n    animation-name: fadeOutRight\n}\n\n@-webkit-keyframes fadeOutRightBig {\n    from {\n        opacity: 1\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translate3d(2000px, 0, 0);\n        transform: translate3d(2000px, 0, 0)\n    }\n}\n\n@keyframes fadeOutRightBig {\n    from {\n        opacity: 1\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translate3d(2000px, 0, 0);\n        transform: translate3d(2000px, 0, 0)\n    }\n}\n\n.fadeOutRightBig {\n    -webkit-animation-name: fadeOutRightBig;\n    animation-name: fadeOutRightBig\n}\n\n@-webkit-keyframes fadeOutUp {\n    from {\n        opacity: 1\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translate3d(0, -100%, 0);\n        transform: translate3d(0, -100%, 0)\n    }\n}\n\n@keyframes fadeOutUp {\n    from {\n        opacity: 1\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translate3d(0, -100%, 0);\n        transform: translate3d(0, -100%, 0)\n    }\n}\n\n.fadeOutUp {\n    -webkit-animation-name: fadeOutUp;\n    animation-name: fadeOutUp\n}\n\n@-webkit-keyframes fadeOutUpBig {\n    from {\n        opacity: 1\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translate3d(0, -2000px, 0);\n        transform: translate3d(0, -2000px, 0)\n    }\n}\n\n@keyframes fadeOutUpBig {\n    from {\n        opacity: 1\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translate3d(0, -2000px, 0);\n        transform: translate3d(0, -2000px, 0)\n    }\n}\n\n.fadeOutUpBig {\n    -webkit-animation-name: fadeOutUpBig;\n    animation-name: fadeOutUpBig\n}\n\n@-webkit-keyframes flip {\n    from {\n        -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -360deg);\n        transform: perspective(400px) rotate3d(0, 1, 0, -360deg);\n        -webkit-animation-timing-function: ease-out;\n        animation-timing-function: ease-out\n    }\n    40% {\n        -webkit-transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -190deg);\n        transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -190deg);\n        -webkit-animation-timing-function: ease-out;\n        animation-timing-function: ease-out\n    }\n    50% {\n        -webkit-transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -170deg);\n        transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -170deg);\n        -webkit-animation-timing-function: ease-in;\n        animation-timing-function: ease-in\n    }\n    80% {\n        -webkit-transform: perspective(400px) scale3d(.95, .95, .95);\n        transform: perspective(400px) scale3d(.95, .95, .95);\n        -webkit-animation-timing-function: ease-in;\n        animation-timing-function: ease-in\n    }\n    100% {\n        -webkit-transform: perspective(400px);\n        transform: perspective(400px);\n        -webkit-animation-timing-function: ease-in;\n        animation-timing-function: ease-in\n    }\n}\n\n@keyframes flip {\n    from {\n        -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -360deg);\n        transform: perspective(400px) rotate3d(0, 1, 0, -360deg);\n        -webkit-animation-timing-function: ease-out;\n        animation-timing-function: ease-out\n    }\n    40% {\n        -webkit-transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -190deg);\n        transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -190deg);\n        -webkit-animation-timing-function: ease-out;\n        animation-timing-function: ease-out\n    }\n    50% {\n        -webkit-transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -170deg);\n        transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -170deg);\n        -webkit-animation-timing-function: ease-in;\n        animation-timing-function: ease-in\n    }\n    80% {\n        -webkit-transform: perspective(400px) scale3d(.95, .95, .95);\n        transform: perspective(400px) scale3d(.95, .95, .95);\n        -webkit-animation-timing-function: ease-in;\n        animation-timing-function: ease-in\n    }\n    100% {\n        -webkit-transform: perspective(400px);\n        transform: perspective(400px);\n        -webkit-animation-timing-function: ease-in;\n        animation-timing-function: ease-in\n    }\n}\n\n.animated.flip {\n    -webkit-backface-visibility: visible;\n    backface-visibility: visible;\n    -webkit-animation-name: flip;\n    animation-name: flip\n}\n\n@-webkit-keyframes flipInX {\n    from {\n        -webkit-transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n        transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n        -webkit-animation-timing-function: ease-in;\n        animation-timing-function: ease-in;\n        opacity: 0\n    }\n    40% {\n        -webkit-transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n        transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n        -webkit-animation-timing-function: ease-in;\n        animation-timing-function: ease-in\n    }\n    60% {\n        -webkit-transform: perspective(400px) rotate3d(1, 0, 0, 10deg);\n        transform: perspective(400px) rotate3d(1, 0, 0, 10deg);\n        opacity: 1\n    }\n    80% {\n        -webkit-transform: perspective(400px) rotate3d(1, 0, 0, -5deg);\n        transform: perspective(400px) rotate3d(1, 0, 0, -5deg)\n    }\n    100% {\n        -webkit-transform: perspective(400px);\n        transform: perspective(400px)\n    }\n}\n\n@keyframes flipInX {\n    from {\n        -webkit-transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n        transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n        -webkit-animation-timing-function: ease-in;\n        animation-timing-function: ease-in;\n        opacity: 0\n    }\n    40% {\n        -webkit-transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n        transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n        -webkit-animation-timing-function: ease-in;\n        animation-timing-function: ease-in\n    }\n    60% {\n        -webkit-transform: perspective(400px) rotate3d(1, 0, 0, 10deg);\n        transform: perspective(400px) rotate3d(1, 0, 0, 10deg);\n        opacity: 1\n    }\n    80% {\n        -webkit-transform: perspective(400px) rotate3d(1, 0, 0, -5deg);\n        transform: perspective(400px) rotate3d(1, 0, 0, -5deg)\n    }\n    100% {\n        -webkit-transform: perspective(400px);\n        transform: perspective(400px)\n    }\n}\n\n.flipInX {\n    -webkit-backface-visibility: visible !important;\n    backface-visibility: visible !important;\n    -webkit-animation-name: flipInX;\n    animation-name: flipInX\n}\n\n@-webkit-keyframes flipInY {\n    from {\n        -webkit-transform: perspective(400px) rotate3d(0, 1, 0, 90deg);\n        transform: perspective(400px) rotate3d(0, 1, 0, 90deg);\n        -webkit-animation-timing-function: ease-in;\n        animation-timing-function: ease-in;\n        opacity: 0\n    }\n    40% {\n        -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -20deg);\n        transform: perspective(400px) rotate3d(0, 1, 0, -20deg);\n        -webkit-animation-timing-function: ease-in;\n        animation-timing-function: ease-in\n    }\n    60% {\n        -webkit-transform: perspective(400px) rotate3d(0, 1, 0, 10deg);\n        transform: perspective(400px) rotate3d(0, 1, 0, 10deg);\n        opacity: 1\n    }\n    80% {\n        -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -5deg);\n        transform: perspective(400px) rotate3d(0, 1, 0, -5deg)\n    }\n    100% {\n        -webkit-transform: perspective(400px);\n        transform: perspective(400px)\n    }\n}\n\n@keyframes flipInY {\n    from {\n        -webkit-transform: perspective(400px) rotate3d(0, 1, 0, 90deg);\n        transform: perspective(400px) rotate3d(0, 1, 0, 90deg);\n        -webkit-animation-timing-function: ease-in;\n        animation-timing-function: ease-in;\n        opacity: 0\n    }\n    40% {\n        -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -20deg);\n        transform: perspective(400px) rotate3d(0, 1, 0, -20deg);\n        -webkit-animation-timing-function: ease-in;\n        animation-timing-function: ease-in\n    }\n    60% {\n        -webkit-transform: perspective(400px) rotate3d(0, 1, 0, 10deg);\n        transform: perspective(400px) rotate3d(0, 1, 0, 10deg);\n        opacity: 1\n    }\n    80% {\n        -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -5deg);\n        transform: perspective(400px) rotate3d(0, 1, 0, -5deg)\n    }\n    100% {\n        -webkit-transform: perspective(400px);\n        transform: perspective(400px)\n    }\n}\n\n.flipInY {\n    -webkit-backface-visibility: visible !important;\n    backface-visibility: visible !important;\n    -webkit-animation-name: flipInY;\n    animation-name: flipInY\n}\n\n@-webkit-keyframes flipOutX {\n    from {\n        -webkit-transform: perspective(400px);\n        transform: perspective(400px)\n    }\n    30% {\n        -webkit-transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n        transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n        opacity: 1\n    }\n    100% {\n        -webkit-transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n        transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n        opacity: 0\n    }\n}\n\n@keyframes flipOutX {\n    from {\n        -webkit-transform: perspective(400px);\n        transform: perspective(400px)\n    }\n    30% {\n        -webkit-transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n        transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n        opacity: 1\n    }\n    100% {\n        -webkit-transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n        transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n        opacity: 0\n    }\n}\n\n.flipOutX {\n    -webkit-animation-name: flipOutX;\n    animation-name: flipOutX;\n    -webkit-backface-visibility: visible !important;\n    backface-visibility: visible !important\n}\n\n@-webkit-keyframes flipOutY {\n    from {\n        -webkit-transform: perspective(400px);\n        transform: perspective(400px)\n    }\n    30% {\n        -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -15deg);\n        transform: perspective(400px) rotate3d(0, 1, 0, -15deg);\n        opacity: 1\n    }\n    100% {\n        -webkit-transform: perspective(400px) rotate3d(0, 1, 0, 90deg);\n        transform: perspective(400px) rotate3d(0, 1, 0, 90deg);\n        opacity: 0\n    }\n}\n\n@keyframes flipOutY {\n    from {\n        -webkit-transform: perspective(400px);\n        transform: perspective(400px)\n    }\n    30% {\n        -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -15deg);\n        transform: perspective(400px) rotate3d(0, 1, 0, -15deg);\n        opacity: 1\n    }\n    100% {\n        -webkit-transform: perspective(400px) rotate3d(0, 1, 0, 90deg);\n        transform: perspective(400px) rotate3d(0, 1, 0, 90deg);\n        opacity: 0\n    }\n}\n\n.flipOutY {\n    -webkit-backface-visibility: visible !important;\n    backface-visibility: visible !important;\n    -webkit-animation-name: flipOutY;\n    animation-name: flipOutY\n}\n\n@-webkit-keyframes lightSpeedIn {\n    from {\n        -webkit-transform: translate3d(100%, 0, 0) skewX(-30deg);\n        transform: translate3d(100%, 0, 0) skewX(-30deg);\n        opacity: 0\n    }\n    60% {\n        -webkit-transform: skewX(20deg);\n        transform: skewX(20deg);\n        opacity: 1\n    }\n    80% {\n        -webkit-transform: skewX(-5deg);\n        transform: skewX(-5deg);\n        opacity: 1\n    }\n    100% {\n        -webkit-transform: none;\n        transform: none;\n        opacity: 1\n    }\n}\n\n@keyframes lightSpeedIn {\n    from {\n        -webkit-transform: translate3d(100%, 0, 0) skewX(-30deg);\n        transform: translate3d(100%, 0, 0) skewX(-30deg);\n        opacity: 0\n    }\n    60% {\n        -webkit-transform: skewX(20deg);\n        transform: skewX(20deg);\n        opacity: 1\n    }\n    80% {\n        -webkit-transform: skewX(-5deg);\n        transform: skewX(-5deg);\n        opacity: 1\n    }\n    100% {\n        -webkit-transform: none;\n        transform: none;\n        opacity: 1\n    }\n}\n\n.lightSpeedIn {\n    -webkit-animation-name: lightSpeedIn;\n    animation-name: lightSpeedIn;\n    -webkit-animation-timing-function: ease-out;\n    animation-timing-function: ease-out\n}\n\n@-webkit-keyframes lightSpeedOut {\n    from {\n        opacity: 1\n    }\n    100% {\n        -webkit-transform: translate3d(100%, 0, 0) skewX(30deg);\n        transform: translate3d(100%, 0, 0) skewX(30deg);\n        opacity: 0\n    }\n}\n\n@keyframes lightSpeedOut {\n    from {\n        opacity: 1\n    }\n    100% {\n        -webkit-transform: translate3d(100%, 0, 0) skewX(30deg);\n        transform: translate3d(100%, 0, 0) skewX(30deg);\n        opacity: 0\n    }\n}\n\n.lightSpeedOut {\n    -webkit-animation-name: lightSpeedOut;\n    animation-name: lightSpeedOut;\n    -webkit-animation-timing-function: ease-in;\n    animation-timing-function: ease-in\n}\n\n@-webkit-keyframes rotateIn {\n    from {\n        -webkit-transform-origin: center;\n        transform-origin: center;\n        -webkit-transform: rotate3d(0, 0, 1, -200deg);\n        transform: rotate3d(0, 0, 1, -200deg);\n        opacity: 0\n    }\n    100% {\n        -webkit-transform-origin: center;\n        transform-origin: center;\n        -webkit-transform: none;\n        transform: none;\n        opacity: 1\n    }\n}\n\n@keyframes rotateIn {\n    from {\n        -webkit-transform-origin: center;\n        transform-origin: center;\n        -webkit-transform: rotate3d(0, 0, 1, -200deg);\n        transform: rotate3d(0, 0, 1, -200deg);\n        opacity: 0\n    }\n    100% {\n        -webkit-transform-origin: center;\n        transform-origin: center;\n        -webkit-transform: none;\n        transform: none;\n        opacity: 1\n    }\n}\n\n.rotateIn {\n    -webkit-animation-name: rotateIn;\n    animation-name: rotateIn\n}\n\n@-webkit-keyframes rotateInDownLeft {\n    from {\n        -webkit-transform-origin: left bottom;\n        transform-origin: left bottom;\n        -webkit-transform: rotate3d(0, 0, 1, -45deg);\n        transform: rotate3d(0, 0, 1, -45deg);\n        opacity: 0\n    }\n    100% {\n        -webkit-transform-origin: left bottom;\n        transform-origin: left bottom;\n        -webkit-transform: none;\n        transform: none;\n        opacity: 1\n    }\n}\n\n@keyframes rotateInDownLeft {\n    from {\n        -webkit-transform-origin: left bottom;\n        transform-origin: left bottom;\n        -webkit-transform: rotate3d(0, 0, 1, -45deg);\n        transform: rotate3d(0, 0, 1, -45deg);\n        opacity: 0\n    }\n    100% {\n        -webkit-transform-origin: left bottom;\n        transform-origin: left bottom;\n        -webkit-transform: none;\n        transform: none;\n        opacity: 1\n    }\n}\n\n.rotateInDownLeft {\n    -webkit-animation-name: rotateInDownLeft;\n    animation-name: rotateInDownLeft\n}\n\n@-webkit-keyframes rotateInDownRight {\n    from {\n        -webkit-transform-origin: right bottom;\n        transform-origin: right bottom;\n        -webkit-transform: rotate3d(0, 0, 1, 45deg);\n        transform: rotate3d(0, 0, 1, 45deg);\n        opacity: 0\n    }\n    100% {\n        -webkit-transform-origin: right bottom;\n        transform-origin: right bottom;\n        -webkit-transform: none;\n        transform: none;\n        opacity: 1\n    }\n}\n\n@keyframes rotateInDownRight {\n    from {\n        -webkit-transform-origin: right bottom;\n        transform-origin: right bottom;\n        -webkit-transform: rotate3d(0, 0, 1, 45deg);\n        transform: rotate3d(0, 0, 1, 45deg);\n        opacity: 0\n    }\n    100% {\n        -webkit-transform-origin: right bottom;\n        transform-origin: right bottom;\n        -webkit-transform: none;\n        transform: none;\n        opacity: 1\n    }\n}\n\n.rotateInDownRight {\n    -webkit-animation-name: rotateInDownRight;\n    animation-name: rotateInDownRight\n}\n\n@-webkit-keyframes rotateInUpLeft {\n    from {\n        -webkit-transform-origin: left bottom;\n        transform-origin: left bottom;\n        -webkit-transform: rotate3d(0, 0, 1, 45deg);\n        transform: rotate3d(0, 0, 1, 45deg);\n        opacity: 0\n    }\n    100% {\n        -webkit-transform-origin: left bottom;\n        transform-origin: left bottom;\n        -webkit-transform: none;\n        transform: none;\n        opacity: 1\n    }\n}\n\n@keyframes rotateInUpLeft {\n    from {\n        -webkit-transform-origin: left bottom;\n        transform-origin: left bottom;\n        -webkit-transform: rotate3d(0, 0, 1, 45deg);\n        transform: rotate3d(0, 0, 1, 45deg);\n        opacity: 0\n    }\n    100% {\n        -webkit-transform-origin: left bottom;\n        transform-origin: left bottom;\n        -webkit-transform: none;\n        transform: none;\n        opacity: 1\n    }\n}\n\n.rotateInUpLeft {\n    -webkit-animation-name: rotateInUpLeft;\n    animation-name: rotateInUpLeft\n}\n\n@-webkit-keyframes rotateInUpRight {\n    from {\n        -webkit-transform-origin: right bottom;\n        transform-origin: right bottom;\n        -webkit-transform: rotate3d(0, 0, 1, -90deg);\n        transform: rotate3d(0, 0, 1, -90deg);\n        opacity: 0\n    }\n    100% {\n        -webkit-transform-origin: right bottom;\n        transform-origin: right bottom;\n        -webkit-transform: none;\n        transform: none;\n        opacity: 1\n    }\n}\n\n@keyframes rotateInUpRight {\n    from {\n        -webkit-transform-origin: right bottom;\n        transform-origin: right bottom;\n        -webkit-transform: rotate3d(0, 0, 1, -90deg);\n        transform: rotate3d(0, 0, 1, -90deg);\n        opacity: 0\n    }\n    100% {\n        -webkit-transform-origin: right bottom;\n        transform-origin: right bottom;\n        -webkit-transform: none;\n        transform: none;\n        opacity: 1\n    }\n}\n\n.rotateInUpRight {\n    -webkit-animation-name: rotateInUpRight;\n    animation-name: rotateInUpRight\n}\n\n@-webkit-keyframes rotateOut {\n    from {\n        -webkit-transform-origin: center;\n        transform-origin: center;\n        opacity: 1\n    }\n    100% {\n        -webkit-transform-origin: center;\n        transform-origin: center;\n        -webkit-transform: rotate3d(0, 0, 1, 200deg);\n        transform: rotate3d(0, 0, 1, 200deg);\n        opacity: 0\n    }\n}\n\n@keyframes rotateOut {\n    from {\n        -webkit-transform-origin: center;\n        transform-origin: center;\n        opacity: 1\n    }\n    100% {\n        -webkit-transform-origin: center;\n        transform-origin: center;\n        -webkit-transform: rotate3d(0, 0, 1, 200deg);\n        transform: rotate3d(0, 0, 1, 200deg);\n        opacity: 0\n    }\n}\n\n.rotateOut {\n    -webkit-animation-name: rotateOut;\n    animation-name: rotateOut\n}\n\n@-webkit-keyframes rotateOutDownLeft {\n    from {\n        -webkit-transform-origin: left bottom;\n        transform-origin: left bottom;\n        opacity: 1\n    }\n    100% {\n        -webkit-transform-origin: left bottom;\n        transform-origin: left bottom;\n        -webkit-transform: rotate3d(0, 0, 1, 45deg);\n        transform: rotate3d(0, 0, 1, 45deg);\n        opacity: 0\n    }\n}\n\n@keyframes rotateOutDownLeft {\n    from {\n        -webkit-transform-origin: left bottom;\n        transform-origin: left bottom;\n        opacity: 1\n    }\n    100% {\n        -webkit-transform-origin: left bottom;\n        transform-origin: left bottom;\n        -webkit-transform: rotate3d(0, 0, 1, 45deg);\n        transform: rotate3d(0, 0, 1, 45deg);\n        opacity: 0\n    }\n}\n\n.rotateOutDownLeft {\n    -webkit-animation-name: rotateOutDownLeft;\n    animation-name: rotateOutDownLeft\n}\n\n@-webkit-keyframes rotateOutDownRight {\n    from {\n        -webkit-transform-origin: right bottom;\n        transform-origin: right bottom;\n        opacity: 1\n    }\n    100% {\n        -webkit-transform-origin: right bottom;\n        transform-origin: right bottom;\n        -webkit-transform: rotate3d(0, 0, 1, -45deg);\n        transform: rotate3d(0, 0, 1, -45deg);\n        opacity: 0\n    }\n}\n\n@keyframes rotateOutDownRight {\n    from {\n        -webkit-transform-origin: right bottom;\n        transform-origin: right bottom;\n        opacity: 1\n    }\n    100% {\n        -webkit-transform-origin: right bottom;\n        transform-origin: right bottom;\n        -webkit-transform: rotate3d(0, 0, 1, -45deg);\n        transform: rotate3d(0, 0, 1, -45deg);\n        opacity: 0\n    }\n}\n\n.rotateOutDownRight {\n    -webkit-animation-name: rotateOutDownRight;\n    animation-name: rotateOutDownRight\n}\n\n@-webkit-keyframes rotateOutUpLeft {\n    from {\n        -webkit-transform-origin: left bottom;\n        transform-origin: left bottom;\n        opacity: 1\n    }\n    100% {\n        -webkit-transform-origin: left bottom;\n        transform-origin: left bottom;\n        -webkit-transform: rotate3d(0, 0, 1, -45deg);\n        transform: rotate3d(0, 0, 1, -45deg);\n        opacity: 0\n    }\n}\n\n@keyframes rotateOutUpLeft {\n    from {\n        -webkit-transform-origin: left bottom;\n        transform-origin: left bottom;\n        opacity: 1\n    }\n    100% {\n        -webkit-transform-origin: left bottom;\n        transform-origin: left bottom;\n        -webkit-transform: rotate3d(0, 0, 1, -45deg);\n        transform: rotate3d(0, 0, 1, -45deg);\n        opacity: 0\n    }\n}\n\n.rotateOutUpLeft {\n    -webkit-animation-name: rotateOutUpLeft;\n    animation-name: rotateOutUpLeft\n}\n\n@-webkit-keyframes rotateOutUpRight {\n    from {\n        -webkit-transform-origin: right bottom;\n        transform-origin: right bottom;\n        opacity: 1\n    }\n    100% {\n        -webkit-transform-origin: right bottom;\n        transform-origin: right bottom;\n        -webkit-transform: rotate3d(0, 0, 1, 90deg);\n        transform: rotate3d(0, 0, 1, 90deg);\n        opacity: 0\n    }\n}\n\n@keyframes rotateOutUpRight {\n    from {\n        -webkit-transform-origin: right bottom;\n        transform-origin: right bottom;\n        opacity: 1\n    }\n    100% {\n        -webkit-transform-origin: right bottom;\n        transform-origin: right bottom;\n        -webkit-transform: rotate3d(0, 0, 1, 90deg);\n        transform: rotate3d(0, 0, 1, 90deg);\n        opacity: 0\n    }\n}\n\n.rotateOutUpRight {\n    -webkit-animation-name: rotateOutUpRight;\n    animation-name: rotateOutUpRight\n}\n\n@-webkit-keyframes hinge {\n    0% {\n        -webkit-transform-origin: top left;\n        transform-origin: top left;\n        -webkit-animation-timing-function: ease-in-out;\n        animation-timing-function: ease-in-out\n    }\n    20%, 60% {\n        -webkit-transform: rotate3d(0, 0, 1, 80deg);\n        transform: rotate3d(0, 0, 1, 80deg);\n        -webkit-transform-origin: top left;\n        transform-origin: top left;\n        -webkit-animation-timing-function: ease-in-out;\n        animation-timing-function: ease-in-out\n    }\n    40%, 80% {\n        -webkit-transform: rotate3d(0, 0, 1, 60deg);\n        transform: rotate3d(0, 0, 1, 60deg);\n        -webkit-transform-origin: top left;\n        transform-origin: top left;\n        -webkit-animation-timing-function: ease-in-out;\n        animation-timing-function: ease-in-out;\n        opacity: 1\n    }\n    100% {\n        -webkit-transform: translate3d(0, 700px, 0);\n        transform: translate3d(0, 700px, 0);\n        opacity: 0\n    }\n}\n\n@keyframes hinge {\n    0% {\n        -webkit-transform-origin: top left;\n        transform-origin: top left;\n        -webkit-animation-timing-function: ease-in-out;\n        animation-timing-function: ease-in-out\n    }\n    20%, 60% {\n        -webkit-transform: rotate3d(0, 0, 1, 80deg);\n        transform: rotate3d(0, 0, 1, 80deg);\n        -webkit-transform-origin: top left;\n        transform-origin: top left;\n        -webkit-animation-timing-function: ease-in-out;\n        animation-timing-function: ease-in-out\n    }\n    40%, 80% {\n        -webkit-transform: rotate3d(0, 0, 1, 60deg);\n        transform: rotate3d(0, 0, 1, 60deg);\n        -webkit-transform-origin: top left;\n        transform-origin: top left;\n        -webkit-animation-timing-function: ease-in-out;\n        animation-timing-function: ease-in-out;\n        opacity: 1\n    }\n    100% {\n        -webkit-transform: translate3d(0, 700px, 0);\n        transform: translate3d(0, 700px, 0);\n        opacity: 0\n    }\n}\n\n.hinge {\n    -webkit-animation-name: hinge;\n    animation-name: hinge\n}\n\n@-webkit-keyframes rollIn {\n    from {\n        opacity: 0;\n        -webkit-transform: translate3d(-100%, 0, 0) rotate3d(0, 0, 1, -120deg);\n        transform: translate3d(-100%, 0, 0) rotate3d(0, 0, 1, -120deg)\n    }\n    100% {\n        opacity: 1;\n        -webkit-transform: none;\n        transform: none\n    }\n}\n\n@keyframes rollIn {\n    from {\n        opacity: 0;\n        -webkit-transform: translate3d(-100%, 0, 0) rotate3d(0, 0, 1, -120deg);\n        transform: translate3d(-100%, 0, 0) rotate3d(0, 0, 1, -120deg)\n    }\n    100% {\n        opacity: 1;\n        -webkit-transform: none;\n        transform: none\n    }\n}\n\n.rollIn {\n    -webkit-animation-name: rollIn;\n    animation-name: rollIn\n}\n\n@-webkit-keyframes rollOut {\n    from {\n        opacity: 1\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translate3d(100%, 0, 0) rotate3d(0, 0, 1, 120deg);\n        transform: translate3d(100%, 0, 0) rotate3d(0, 0, 1, 120deg)\n    }\n}\n\n@keyframes rollOut {\n    from {\n        opacity: 1\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translate3d(100%, 0, 0) rotate3d(0, 0, 1, 120deg);\n        transform: translate3d(100%, 0, 0) rotate3d(0, 0, 1, 120deg)\n    }\n}\n\n.rollOut {\n    -webkit-animation-name: rollOut;\n    animation-name: rollOut\n}\n\n@-webkit-keyframes zoomIn {\n    from {\n        opacity: 0;\n        -webkit-transform: scale3d(.3, .3, .3);\n        transform: scale3d(.3, .3, .3)\n    }\n    50% {\n        opacity: 1\n    }\n}\n\n@keyframes zoomIn {\n    from {\n        opacity: 0;\n        -webkit-transform: scale3d(.3, .3, .3);\n        transform: scale3d(.3, .3, .3)\n    }\n    50% {\n        opacity: 1\n    }\n}\n\n.zoomIn {\n    -webkit-animation-name: zoomIn;\n    animation-name: zoomIn\n}\n\n@-webkit-keyframes zoomInDown {\n    from {\n        opacity: 0;\n        -webkit-transform: scale3d(.1, .1, .1) translate3d(0, -1000px, 0);\n        transform: scale3d(.1, .1, .1) translate3d(0, -1000px, 0);\n        -webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);\n        animation-timing-function: cubic-bezier(.55, .055, .675, .19)\n    }\n    60% {\n        opacity: 1;\n        -webkit-transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);\n        transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);\n        -webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);\n        animation-timing-function: cubic-bezier(.175, .885, .32, 1)\n    }\n}\n\n@keyframes zoomInDown {\n    from {\n        opacity: 0;\n        -webkit-transform: scale3d(.1, .1, .1) translate3d(0, -1000px, 0);\n        transform: scale3d(.1, .1, .1) translate3d(0, -1000px, 0);\n        -webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);\n        animation-timing-function: cubic-bezier(.55, .055, .675, .19)\n    }\n    60% {\n        opacity: 1;\n        -webkit-transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);\n        transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);\n        -webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);\n        animation-timing-function: cubic-bezier(.175, .885, .32, 1)\n    }\n}\n\n.zoomInDown {\n    -webkit-animation-name: zoomInDown;\n    animation-name: zoomInDown\n}\n\n@-webkit-keyframes zoomInLeft {\n    from {\n        opacity: 0;\n        -webkit-transform: scale3d(.1, .1, .1) translate3d(-1000px, 0, 0);\n        transform: scale3d(.1, .1, .1) translate3d(-1000px, 0, 0);\n        -webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);\n        animation-timing-function: cubic-bezier(.55, .055, .675, .19)\n    }\n    60% {\n        opacity: 1;\n        -webkit-transform: scale3d(.475, .475, .475) translate3d(10px, 0, 0);\n        transform: scale3d(.475, .475, .475) translate3d(10px, 0, 0);\n        -webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);\n        animation-timing-function: cubic-bezier(.175, .885, .32, 1)\n    }\n}\n\n@keyframes zoomInLeft {\n    from {\n        opacity: 0;\n        -webkit-transform: scale3d(.1, .1, .1) translate3d(-1000px, 0, 0);\n        transform: scale3d(.1, .1, .1) translate3d(-1000px, 0, 0);\n        -webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);\n        animation-timing-function: cubic-bezier(.55, .055, .675, .19)\n    }\n    60% {\n        opacity: 1;\n        -webkit-transform: scale3d(.475, .475, .475) translate3d(10px, 0, 0);\n        transform: scale3d(.475, .475, .475) translate3d(10px, 0, 0);\n        -webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);\n        animation-timing-function: cubic-bezier(.175, .885, .32, 1)\n    }\n}\n\n.zoomInLeft {\n    -webkit-animation-name: zoomInLeft;\n    animation-name: zoomInLeft\n}\n\n@-webkit-keyframes zoomInRight {\n    from {\n        opacity: 0;\n        -webkit-transform: scale3d(.1, .1, .1) translate3d(1000px, 0, 0);\n        transform: scale3d(.1, .1, .1) translate3d(1000px, 0, 0);\n        -webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);\n        animation-timing-function: cubic-bezier(.55, .055, .675, .19)\n    }\n    60% {\n        opacity: 1;\n        -webkit-transform: scale3d(.475, .475, .475) translate3d(-10px, 0, 0);\n        transform: scale3d(.475, .475, .475) translate3d(-10px, 0, 0);\n        -webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);\n        animation-timing-function: cubic-bezier(.175, .885, .32, 1)\n    }\n}\n\n@keyframes zoomInRight {\n    from {\n        opacity: 0;\n        -webkit-transform: scale3d(.1, .1, .1) translate3d(1000px, 0, 0);\n        transform: scale3d(.1, .1, .1) translate3d(1000px, 0, 0);\n        -webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);\n        animation-timing-function: cubic-bezier(.55, .055, .675, .19)\n    }\n    60% {\n        opacity: 1;\n        -webkit-transform: scale3d(.475, .475, .475) translate3d(-10px, 0, 0);\n        transform: scale3d(.475, .475, .475) translate3d(-10px, 0, 0);\n        -webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);\n        animation-timing-function: cubic-bezier(.175, .885, .32, 1)\n    }\n}\n\n.zoomInRight {\n    -webkit-animation-name: zoomInRight;\n    animation-name: zoomInRight\n}\n\n@-webkit-keyframes zoomInUp {\n    from {\n        opacity: 0;\n        -webkit-transform: scale3d(.1, .1, .1) translate3d(0, 1000px, 0);\n        transform: scale3d(.1, .1, .1) translate3d(0, 1000px, 0);\n        -webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);\n        animation-timing-function: cubic-bezier(.55, .055, .675, .19)\n    }\n    60% {\n        opacity: 1;\n        -webkit-transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);\n        transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);\n        -webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);\n        animation-timing-function: cubic-bezier(.175, .885, .32, 1)\n    }\n}\n\n@keyframes zoomInUp {\n    from {\n        opacity: 0;\n        -webkit-transform: scale3d(.1, .1, .1) translate3d(0, 1000px, 0);\n        transform: scale3d(.1, .1, .1) translate3d(0, 1000px, 0);\n        -webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);\n        animation-timing-function: cubic-bezier(.55, .055, .675, .19)\n    }\n    60% {\n        opacity: 1;\n        -webkit-transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);\n        transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);\n        -webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);\n        animation-timing-function: cubic-bezier(.175, .885, .32, 1)\n    }\n}\n\n.zoomInUp {\n    -webkit-animation-name: zoomInUp;\n    animation-name: zoomInUp\n}\n\n@-webkit-keyframes zoomOut {\n    from {\n        opacity: 1\n    }\n    50% {\n        opacity: 0;\n        -webkit-transform: scale3d(.3, .3, .3);\n        transform: scale3d(.3, .3, .3)\n    }\n    100% {\n        opacity: 0\n    }\n}\n\n@keyframes zoomOut {\n    from {\n        opacity: 1\n    }\n    50% {\n        opacity: 0;\n        -webkit-transform: scale3d(.3, .3, .3);\n        transform: scale3d(.3, .3, .3)\n    }\n    100% {\n        opacity: 0\n    }\n}\n\n.zoomOut {\n    -webkit-animation-name: zoomOut;\n    animation-name: zoomOut\n}\n\n@-webkit-keyframes zoomOutDown {\n    40% {\n        opacity: 1;\n        -webkit-transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);\n        transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);\n        -webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);\n        animation-timing-function: cubic-bezier(.55, .055, .675, .19)\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: scale3d(.1, .1, .1) translate3d(0, 2000px, 0);\n        transform: scale3d(.1, .1, .1) translate3d(0, 2000px, 0);\n        -webkit-transform-origin: center bottom;\n        transform-origin: center bottom;\n        -webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);\n        animation-timing-function: cubic-bezier(.175, .885, .32, 1)\n    }\n}\n\n@keyframes zoomOutDown {\n    40% {\n        opacity: 1;\n        -webkit-transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);\n        transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);\n        -webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);\n        animation-timing-function: cubic-bezier(.55, .055, .675, .19)\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: scale3d(.1, .1, .1) translate3d(0, 2000px, 0);\n        transform: scale3d(.1, .1, .1) translate3d(0, 2000px, 0);\n        -webkit-transform-origin: center bottom;\n        transform-origin: center bottom;\n        -webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);\n        animation-timing-function: cubic-bezier(.175, .885, .32, 1)\n    }\n}\n\n.zoomOutDown {\n    -webkit-animation-name: zoomOutDown;\n    animation-name: zoomOutDown\n}\n\n@-webkit-keyframes zoomOutLeft {\n    40% {\n        opacity: 1;\n        -webkit-transform: scale3d(.475, .475, .475) translate3d(42px, 0, 0);\n        transform: scale3d(.475, .475, .475) translate3d(42px, 0, 0)\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: scale(.1) translate3d(-2000px, 0, 0);\n        transform: scale(.1) translate3d(-2000px, 0, 0);\n        -webkit-transform-origin: left center;\n        transform-origin: left center\n    }\n}\n\n@keyframes zoomOutLeft {\n    40% {\n        opacity: 1;\n        -webkit-transform: scale3d(.475, .475, .475) translate3d(42px, 0, 0);\n        transform: scale3d(.475, .475, .475) translate3d(42px, 0, 0)\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: scale(.1) translate3d(-2000px, 0, 0);\n        transform: scale(.1) translate3d(-2000px, 0, 0);\n        -webkit-transform-origin: left center;\n        transform-origin: left center\n    }\n}\n\n.zoomOutLeft {\n    -webkit-animation-name: zoomOutLeft;\n    animation-name: zoomOutLeft\n}\n\n@-webkit-keyframes zoomOutRight {\n    40% {\n        opacity: 1;\n        -webkit-transform: scale3d(.475, .475, .475) translate3d(-42px, 0, 0);\n        transform: scale3d(.475, .475, .475) translate3d(-42px, 0, 0)\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: scale(.1) translate3d(2000px, 0, 0);\n        transform: scale(.1) translate3d(2000px, 0, 0);\n        -webkit-transform-origin: right center;\n        transform-origin: right center\n    }\n}\n\n@keyframes zoomOutRight {\n    40% {\n        opacity: 1;\n        -webkit-transform: scale3d(.475, .475, .475) translate3d(-42px, 0, 0);\n        transform: scale3d(.475, .475, .475) translate3d(-42px, 0, 0)\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: scale(.1) translate3d(2000px, 0, 0);\n        transform: scale(.1) translate3d(2000px, 0, 0);\n        -webkit-transform-origin: right center;\n        transform-origin: right center\n    }\n}\n\n.zoomOutRight {\n    -webkit-animation-name: zoomOutRight;\n    animation-name: zoomOutRight\n}\n\n@-webkit-keyframes zoomOutUp {\n    40% {\n        opacity: 1;\n        -webkit-transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);\n        transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);\n        -webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);\n        animation-timing-function: cubic-bezier(.55, .055, .675, .19)\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: scale3d(.1, .1, .1) translate3d(0, -2000px, 0);\n        transform: scale3d(.1, .1, .1) translate3d(0, -2000px, 0);\n        -webkit-transform-origin: center bottom;\n        transform-origin: center bottom;\n        -webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);\n        animation-timing-function: cubic-bezier(.175, .885, .32, 1)\n    }\n}\n\n@keyframes zoomOutUp {\n    40% {\n        opacity: 1;\n        -webkit-transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);\n        transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);\n        -webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);\n        animation-timing-function: cubic-bezier(.55, .055, .675, .19)\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: scale3d(.1, .1, .1) translate3d(0, -2000px, 0);\n        transform: scale3d(.1, .1, .1) translate3d(0, -2000px, 0);\n        -webkit-transform-origin: center bottom;\n        transform-origin: center bottom;\n        -webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);\n        animation-timing-function: cubic-bezier(.175, .885, .32, 1)\n    }\n}\n\n.zoomOutUp {\n    -webkit-animation-name: zoomOutUp;\n    animation-name: zoomOutUp\n}\n\n@-webkit-keyframes slideInDown {\n    from {\n        -webkit-transform: translate3d(0, -100%, 0);\n        transform: translate3d(0, -100%, 0);\n        visibility: visible\n    }\n    100% {\n        -webkit-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0)\n    }\n}\n\n@keyframes slideInDown {\n    from {\n        -webkit-transform: translate3d(0, -100%, 0);\n        transform: translate3d(0, -100%, 0);\n        visibility: visible\n    }\n    100% {\n        -webkit-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0)\n    }\n}\n\n.slideInDown {\n    -webkit-animation-name: slideInDown;\n    animation-name: slideInDown\n}\n\n@-webkit-keyframes slideInLeft {\n    from {\n        -webkit-transform: translate3d(-100%, 0, 0);\n        transform: translate3d(-100%, 0, 0);\n        visibility: visible\n    }\n    100% {\n        -webkit-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0)\n    }\n}\n\n@keyframes slideInLeft {\n    from {\n        -webkit-transform: translate3d(-100%, 0, 0);\n        transform: translate3d(-100%, 0, 0);\n        visibility: visible\n    }\n    100% {\n        -webkit-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0)\n    }\n}\n\n.slideInLeft {\n    -webkit-animation-name: slideInLeft;\n    animation-name: slideInLeft\n}\n\n@-webkit-keyframes slideInRight {\n    from {\n        -webkit-transform: translate3d(100%, 0, 0);\n        transform: translate3d(100%, 0, 0);\n        visibility: visible\n    }\n    100% {\n        -webkit-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0)\n    }\n}\n\n@keyframes slideInRight {\n    from {\n        -webkit-transform: translate3d(100%, 0, 0);\n        transform: translate3d(100%, 0, 0);\n        visibility: visible\n    }\n    100% {\n        -webkit-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0)\n    }\n}\n\n.slideInRight {\n    -webkit-animation-name: slideInRight;\n    animation-name: slideInRight\n}\n\n@-webkit-keyframes slideInUp {\n    from {\n        -webkit-transform: translate3d(0, 100%, 0);\n        transform: translate3d(0, 100%, 0);\n        visibility: visible\n    }\n    100% {\n        -webkit-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0)\n    }\n}\n\n@keyframes slideInUp {\n    from {\n        -webkit-transform: translate3d(0, 100%, 0);\n        transform: translate3d(0, 100%, 0);\n        visibility: visible\n    }\n    100% {\n        -webkit-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0)\n    }\n}\n\n.slideInUp {\n    -webkit-animation-name: slideInUp;\n    animation-name: slideInUp\n}\n\n@-webkit-keyframes slideOutDown {\n    from {\n        -webkit-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0)\n    }\n    100% {\n        visibility: hidden;\n        -webkit-transform: translate3d(0, 100%, 0);\n        transform: translate3d(0, 100%, 0)\n    }\n}\n\n@keyframes slideOutDown {\n    from {\n        -webkit-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0)\n    }\n    100% {\n        visibility: hidden;\n        -webkit-transform: translate3d(0, 100%, 0);\n        transform: translate3d(0, 100%, 0)\n    }\n}\n\n.slideOutDown {\n    -webkit-animation-name: slideOutDown;\n    animation-name: slideOutDown\n}\n\n@-webkit-keyframes slideOutLeft {\n    from {\n        -webkit-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0)\n    }\n    100% {\n        visibility: hidden;\n        -webkit-transform: translate3d(-100%, 0, 0);\n        transform: translate3d(-100%, 0, 0)\n    }\n}\n\n@keyframes slideOutLeft {\n    from {\n        -webkit-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0)\n    }\n    100% {\n        visibility: hidden;\n        -webkit-transform: translate3d(-100%, 0, 0);\n        transform: translate3d(-100%, 0, 0)\n    }\n}\n\n.slideOutLeft {\n    -webkit-animation-name: slideOutLeft;\n    animation-name: slideOutLeft\n}\n\n@-webkit-keyframes slideOutRight {\n    from {\n        -webkit-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0)\n    }\n    100% {\n        visibility: hidden;\n        -webkit-transform: translate3d(100%, 0, 0);\n        transform: translate3d(100%, 0, 0)\n    }\n}\n\n@keyframes slideOutRight {\n    from {\n        -webkit-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0)\n    }\n    100% {\n        visibility: hidden;\n        -webkit-transform: translate3d(100%, 0, 0);\n        transform: translate3d(100%, 0, 0)\n    }\n}\n\n.slideOutRight {\n    -webkit-animation-name: slideOutRight;\n    animation-name: slideOutRight\n}\n\n@-webkit-keyframes slideOutUp {\n    from {\n        -webkit-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0)\n    }\n    100% {\n        visibility: hidden;\n        -webkit-transform: translate3d(0, -100%, 0);\n        transform: translate3d(0, -100%, 0)\n    }\n}\n\n@keyframes slideOutUp {\n    from {\n        -webkit-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0)\n    }\n    100% {\n        visibility: hidden;\n        -webkit-transform: translate3d(0, -100%, 0);\n        transform: translate3d(0, -100%, 0)\n    }\n}\n\n.slideOutUp {\n    -webkit-animation-name: slideOutUp;\n    animation-name: slideOutUp\n}\n\n/*!\n  Ionicons, v2.0.0\n  Created by Ben Sperry for the Ionic Framework, http://ionicons.com/\n  https://twitter.com/benjsperry  https://twitter.com/ionicframework\n  MIT License: https://github.com/driftyco/ionicons\n\n  Android-style icons originally built by Google’s\n  Material Design Icons: https://github.com/google/material-design-icons\n  used under CC BY http://creativecommons.org/licenses/by/4.0/\n  Modified icons to fit ionicon’s grid from original.\n\n * --------------------------------------------------\n */\n\n/*@font-face{font-family:Ionicons;src:url(./assets/fonts/ionicons.eot?v=2.0.01);src:url(./assets/fonts/ionicons.eot?v=2.0.0#iefix) format(\"embedded-opentype\"),url(./assets/fonts/ionicons.ttf?v=2.0.0) format(\"truetype\"),url(./assets/fonts/ionicons.woff?v=2.0.0) format(\"woff\"),url(./assets/fonts/ionicons.svg?v=2.0.0#Ionicons) format(\"svg\")}.ion,.ionicons,.ion-alert:before,.ion-alert-circled:before,.ion-android-add:before,.ion-android-add-circle:before,.ion-android-alarm-clock:before,.ion-android-alert:before,.ion-android-apps:before,.ion-android-archive:before,.ion-android-arrow-back:before,.ion-android-arrow-down:before,.ion-android-arrow-dropdown:before,.ion-android-arrow-dropdown-circle:before,.ion-android-arrow-dropleft:before,.ion-android-arrow-dropleft-circle:before,.ion-android-arrow-dropright:before,.ion-android-arrow-dropright-circle:before,.ion-android-arrow-dropup:before,.ion-android-arrow-dropup-circle:before,.ion-android-arrow-forward:before,.ion-android-arrow-up:before,.ion-android-attach:before,.ion-android-bar:before,.ion-android-bicycle:before,.ion-android-boat:before,.ion-android-bookmark:before,.ion-android-bulb:before,.ion-android-bus:before,.ion-android-calendar:before,.ion-android-call:before,.ion-android-camera:before,.ion-android-cancel:before,.ion-android-car:before,.ion-android-cart:before,.ion-android-chat:before,.ion-android-checkbox:before,.ion-android-checkbox-blank:before,.ion-android-checkbox-outline:before,.ion-android-checkbox-outline-blank:before,.ion-android-checkmark-circle:before,.ion-android-clipboard:before,.ion-android-close:before,.ion-android-cloud:before,.ion-android-cloud-circle:before,.ion-android-cloud-done:before,.ion-android-cloud-outline:before,.ion-android-color-palette:before,.ion-android-compass:before,.ion-android-contact:before,.ion-android-contacts:before,.ion-android-contract:before,.ion-android-create:before,.ion-android-delete:before,.ion-android-desktop:before,.ion-android-document:before,.ion-android-done:before,.ion-android-done-all:before,.ion-android-download:before,.ion-android-drafts:before,.ion-android-exit:before,.ion-android-expand:before,.ion-android-favorite:before,.ion-android-favorite-outline:before,.ion-android-film:before,.ion-android-folder:before,.ion-android-folder-open:before,.ion-android-funnel:before,.ion-android-globe:before,.ion-android-hand:before,.ion-android-hangout:before,.ion-android-happy:before,.ion-android-home:before,.ion-android-image:before,.ion-android-laptop:before,.ion-android-list:before,.ion-android-locate:before,.ion-android-lock:before,.ion-android-mail:before,.ion-android-map:before,.ion-android-menu:before,.ion-android-microphone:before,.ion-android-microphone-off:before,.ion-android-more-horizontal:before,.ion-android-more-vertical:before,.ion-android-navigate:before,.ion-android-notifications:before,.ion-android-notifications-none:before,.ion-android-notifications-off:before,.ion-android-open:before,.ion-android-options:before,.ion-android-people:before,.ion-android-person:before,.ion-android-person-add:before,.ion-android-phone-landscape:before,.ion-android-phone-portrait:before,.ion-android-pin:before,.ion-android-plane:before,.ion-android-playstore:before,.ion-android-print:before,.ion-android-radio-button-off:before,.ion-android-radio-button-on:before,.ion-android-refresh:before,.ion-android-remove:before,.ion-android-remove-circle:before,.ion-android-restaurant:before,.ion-android-sad:before,.ion-android-search:before,.ion-android-send:before,.ion-android-settings:before,.ion-android-share:before,.ion-android-share-alt:before,.ion-android-star:before,.ion-android-star-half:before,.ion-android-star-outline:before,.ion-android-stopwatch:before,.ion-android-subway:before,.ion-android-sunny:before,.ion-android-sync:before,.ion-android-textsms:before,.ion-android-time:before,.ion-android-train:before,.ion-android-unlock:before,.ion-android-upload:before,.ion-android-volume-down:before,.ion-android-volume-mute:before,.ion-android-volume-off:before,.ion-android-volume-up:before,.ion-android-walk:before,.ion-android-warning:before,.ion-android-watch:before,.ion-android-wifi:before,.ion-aperture:before,.ion-archive:before,.ion-arrow-down-a:before,.ion-arrow-down-b:before,.ion-arrow-down-c:before,.ion-arrow-expand:before,.ion-arrow-graph-down-left:before,.ion-arrow-graph-down-right:before,.ion-arrow-graph-up-left:before,.ion-arrow-graph-up-right:before,.ion-arrow-left-a:before,.ion-arrow-left-b:before,.ion-arrow-left-c:before,.ion-arrow-move:before,.ion-arrow-resize:before,.ion-arrow-return-left:before,.ion-arrow-return-right:before,.ion-arrow-right-a:before,.ion-arrow-right-b:before,.ion-arrow-right-c:before,.ion-arrow-shrink:before,.ion-arrow-swap:before,.ion-arrow-up-a:before,.ion-arrow-up-b:before,.ion-arrow-up-c:before,.ion-asterisk:before,.ion-at:before,.ion-backspace:before,.ion-backspace-outline:before,.ion-bag:before,.ion-battery-charging:before,.ion-battery-empty:before,.ion-battery-full:before,.ion-battery-half:before,.ion-battery-low:before,.ion-beaker:before,.ion-beer:before,.ion-bluetooth:before,.ion-bonfire:before,.ion-bookmark:before,.ion-bowtie:before,.ion-briefcase:before,.ion-bug:before,.ion-calculator:before,.ion-calendar:before,.ion-camera:before,.ion-card:before,.ion-cash:before,.ion-chatbox:before,.ion-chatbox-working:before,.ion-chatboxes:before,.ion-chatbubble:before,.ion-chatbubble-working:before,.ion-chatbubbles:before,.ion-checkmark:before,.ion-checkmark-circled:before,.ion-checkmark-round:before,.ion-chevron-down:before,.ion-chevron-left:before,.ion-chevron-right:before,.ion-chevron-up:before,.ion-clipboard:before,.ion-clock:before,.ion-close:before,.ion-close-circled:before,.ion-close-round:before,.ion-closed-captioning:before,.ion-cloud:before,.ion-code:before,.ion-code-download:before,.ion-code-working:before,.ion-coffee:before,.ion-compass:before,.ion-compose:before,.ion-connection-bars:before,.ion-contrast:before,.ion-crop:before,.ion-cube:before,.ion-disc:before,.ion-document:before,.ion-document-text:before,.ion-drag:before,.ion-earth:before,.ion-easel:before,.ion-edit:before,.ion-egg:before,.ion-eject:before,.ion-email:before,.ion-email-unread:before,.ion-erlenmeyer-flask:before,.ion-erlenmeyer-flask-bubbles:before,.ion-eye:before,.ion-eye-disabled:before,.ion-female:before,.ion-filing:before,.ion-film-marker:before,.ion-fireball:before,.ion-flag:before,.ion-flame:before,.ion-flash:before,.ion-flash-off:before,.ion-folder:before,.ion-fork:before,.ion-fork-repo:before,.ion-forward:before,.ion-funnel:before,.ion-gear-a:before,.ion-gear-b:before,.ion-grid:before,.ion-hammer:before,.ion-happy:before,.ion-happy-outline:before,.ion-headphone:before,.ion-heart:before,.ion-heart-broken:before,.ion-help:before,.ion-help-buoy:before,.ion-help-circled:before,.ion-home:before,.ion-icecream:before,.ion-image:before,.ion-images:before,.ion-information:before,.ion-information-circled:before,.ion-ionic:before,.ion-ios-alarm:before,.ion-ios-alarm-outline:before,.ion-ios-albums:before,.ion-ios-albums-outline:before,.ion-ios-americanfootball:before,.ion-ios-americanfootball-outline:before,.ion-ios-analytics:before,.ion-ios-analytics-outline:before,.ion-ios-arrow-back:before,.ion-ios-arrow-down:before,.ion-ios-arrow-forward:before,.ion-ios-arrow-left:before,.ion-ios-arrow-right:before,.ion-ios-arrow-thin-down:before,.ion-ios-arrow-thin-left:before,.ion-ios-arrow-thin-right:before,.ion-ios-arrow-thin-up:before,.ion-ios-arrow-up:before,.ion-ios-at:before,.ion-ios-at-outline:before,.ion-ios-barcode:before,.ion-ios-barcode-outline:before,.ion-ios-baseball:before,.ion-ios-baseball-outline:before,.ion-ios-basketball:before,.ion-ios-basketball-outline:before,.ion-ios-bell:before,.ion-ios-bell-outline:before,.ion-ios-body:before,.ion-ios-body-outline:before,.ion-ios-bolt:before,.ion-ios-bolt-outline:before,.ion-ios-book:before,.ion-ios-book-outline:before,.ion-ios-bookmarks:before,.ion-ios-bookmarks-outline:before,.ion-ios-box:before,.ion-ios-box-outline:before,.ion-ios-briefcase:before,.ion-ios-briefcase-outline:before,.ion-ios-browsers:before,.ion-ios-browsers-outline:before,.ion-ios-calculator:before,.ion-ios-calculator-outline:before,.ion-ios-calendar:before,.ion-ios-calendar-outline:before,.ion-ios-camera:before,.ion-ios-camera-outline:before,.ion-ios-cart:before,.ion-ios-cart-outline:before,.ion-ios-chatboxes:before,.ion-ios-chatboxes-outline:before,.ion-ios-chatbubble:before,.ion-ios-chatbubble-outline:before,.ion-ios-checkmark:before,.ion-ios-checkmark-empty:before,.ion-ios-checkmark-outline:before,.ion-ios-circle-filled:before,.ion-ios-circle-outline:before,.ion-ios-clock:before,.ion-ios-clock-outline:before,.ion-ios-close:before,.ion-ios-close-empty:before,.ion-ios-close-outline:before,.ion-ios-cloud:before,.ion-ios-cloud-download:before,.ion-ios-cloud-download-outline:before,.ion-ios-cloud-outline:before,.ion-ios-cloud-upload:before,.ion-ios-cloud-upload-outline:before,.ion-ios-cloudy:before,.ion-ios-cloudy-night:before,.ion-ios-cloudy-night-outline:before,.ion-ios-cloudy-outline:before,.ion-ios-cog:before,.ion-ios-cog-outline:before,.ion-ios-color-filter:before,.ion-ios-color-filter-outline:before,.ion-ios-color-wand:before,.ion-ios-color-wand-outline:before,.ion-ios-compose:before,.ion-ios-compose-outline:before,.ion-ios-contact:before,.ion-ios-contact-outline:before,.ion-ios-copy:before,.ion-ios-copy-outline:before,.ion-ios-crop:before,.ion-ios-crop-strong:before,.ion-ios-download:before,.ion-ios-download-outline:before,.ion-ios-drag:before,.ion-ios-email:before,.ion-ios-email-outline:before,.ion-ios-eye:before,.ion-ios-eye-outline:before,.ion-ios-fastforward:before,.ion-ios-fastforward-outline:before,.ion-ios-filing:before,.ion-ios-filing-outline:before,.ion-ios-film:before,.ion-ios-film-outline:before,.ion-ios-flag:before,.ion-ios-flag-outline:before,.ion-ios-flame:before,.ion-ios-flame-outline:before,.ion-ios-flask:before,.ion-ios-flask-outline:before,.ion-ios-flower:before,.ion-ios-flower-outline:before,.ion-ios-folder:before,.ion-ios-folder-outline:before,.ion-ios-football:before,.ion-ios-football-outline:before,.ion-ios-game-controller-a:before,.ion-ios-game-controller-a-outline:before,.ion-ios-game-controller-b:before,.ion-ios-game-controller-b-outline:before,.ion-ios-gear:before,.ion-ios-gear-outline:before,.ion-ios-glasses:before,.ion-ios-glasses-outline:before,.ion-ios-grid-view:before,.ion-ios-grid-view-outline:before,.ion-ios-heart:before,.ion-ios-heart-outline:before,.ion-ios-help:before,.ion-ios-help-empty:before,.ion-ios-help-outline:before,.ion-ios-home:before,.ion-ios-home-outline:before,.ion-ios-infinite:before,.ion-ios-infinite-outline:before,.ion-ios-information:before,.ion-ios-information-empty:before,.ion-ios-information-outline:before,.ion-ios-ionic-outline:before,.ion-ios-keypad:before,.ion-ios-keypad-outline:before,.ion-ios-lightbulb:before,.ion-ios-lightbulb-outline:before,.ion-ios-list:before,.ion-ios-list-outline:before,.ion-ios-location:before,.ion-ios-location-outline:before,.ion-ios-locked:before,.ion-ios-locked-outline:before,.ion-ios-loop:before,.ion-ios-loop-strong:before,.ion-ios-medical:before,.ion-ios-medical-outline:before,.ion-ios-medkit:before,.ion-ios-medkit-outline:before,.ion-ios-mic:before,.ion-ios-mic-off:before,.ion-ios-mic-outline:before,.ion-ios-minus:before,.ion-ios-minus-empty:before,.ion-ios-minus-outline:before,.ion-ios-monitor:before,.ion-ios-monitor-outline:before,.ion-ios-moon:before,.ion-ios-moon-outline:before,.ion-ios-more:before,.ion-ios-more-outline:before,.ion-ios-musical-note:before,.ion-ios-musical-notes:before,.ion-ios-navigate:before,.ion-ios-navigate-outline:before,.ion-ios-nutrition:before,.ion-ios-nutrition-outline:before,.ion-ios-paper:before,.ion-ios-paper-outline:before,.ion-ios-paperplane:before,.ion-ios-paperplane-outline:before,.ion-ios-partlysunny:before,.ion-ios-partlysunny-outline:before,.ion-ios-pause:before,.ion-ios-pause-outline:before,.ion-ios-paw:before,.ion-ios-paw-outline:before,.ion-ios-people:before,.ion-ios-people-outline:before,.ion-ios-person:before,.ion-ios-person-outline:before,.ion-ios-personadd:before,.ion-ios-personadd-outline:before,.ion-ios-photos:before,.ion-ios-photos-outline:before,.ion-ios-pie:before,.ion-ios-pie-outline:before,.ion-ios-pint:before,.ion-ios-pint-outline:before,.ion-ios-play:before,.ion-ios-play-outline:before,.ion-ios-plus:before,.ion-ios-plus-empty:before,.ion-ios-plus-outline:before,.ion-ios-pricetag:before,.ion-ios-pricetag-outline:before,.ion-ios-pricetags:before,.ion-ios-pricetags-outline:before,.ion-ios-printer:before,.ion-ios-printer-outline:before,.ion-ios-pulse:before,.ion-ios-pulse-strong:before,.ion-ios-rainy:before,.ion-ios-rainy-outline:before,.ion-ios-recording:before,.ion-ios-recording-outline:before,.ion-ios-redo:before,.ion-ios-redo-outline:before,.ion-ios-refresh:before,.ion-ios-refresh-empty:before,.ion-ios-refresh-outline:before,.ion-ios-reload:before,.ion-ios-reverse-camera:before,.ion-ios-reverse-camera-outline:before,.ion-ios-rewind:before,.ion-ios-rewind-outline:before,.ion-ios-rose:before,.ion-ios-rose-outline:before,.ion-ios-search:before,.ion-ios-search-strong:before,.ion-ios-settings:before,.ion-ios-settings-strong:before,.ion-ios-shuffle:before,.ion-ios-shuffle-strong:before,.ion-ios-skipbackward:before,.ion-ios-skipbackward-outline:before,.ion-ios-skipforward:before,.ion-ios-skipforward-outline:before,.ion-ios-snowy:before,.ion-ios-speedometer:before,.ion-ios-speedometer-outline:before,.ion-ios-star:before,.ion-ios-star-half:before,.ion-ios-star-outline:before,.ion-ios-stopwatch:before,.ion-ios-stopwatch-outline:before,.ion-ios-sunny:before,.ion-ios-sunny-outline:before,.ion-ios-telephone:before,.ion-ios-telephone-outline:before,.ion-ios-tennisball:before,.ion-ios-tennisball-outline:before,.ion-ios-thunderstorm:before,.ion-ios-thunderstorm-outline:before,.ion-ios-time:before,.ion-ios-time-outline:before,.ion-ios-timer:before,.ion-ios-timer-outline:before,.ion-ios-toggle:before,.ion-ios-toggle-outline:before,.ion-ios-trash:before,.ion-ios-trash-outline:before,.ion-ios-undo:before,.ion-ios-undo-outline:before,.ion-ios-unlocked:before,.ion-ios-unlocked-outline:before,.ion-ios-upload:before,.ion-ios-upload-outline:before,.ion-ios-videocam:before,.ion-ios-videocam-outline:before,.ion-ios-volume-high:before,.ion-ios-volume-low:before,.ion-ios-wineglass:before,.ion-ios-wineglass-outline:before,.ion-ios-world:before,.ion-ios-world-outline:before,.ion-ipad:before,.ion-iphone:before,.ion-ipod:before,.ion-jet:before,.ion-key:before,.ion-knife:before,.ion-laptop:before,.ion-leaf:before,.ion-levels:before,.ion-lightbulb:before,.ion-link:before,.ion-load-a:before,.ion-load-b:before,.ion-load-c:before,.ion-load-d:before,.ion-location:before,.ion-lock-combination:before,.ion-locked:before,.ion-log-in:before,.ion-log-out:before,.ion-loop:before,.ion-magnet:before,.ion-male:before,.ion-man:before,.ion-map:before,.ion-medkit:before,.ion-merge:before,.ion-mic-a:before,.ion-mic-b:before,.ion-mic-c:before,.ion-minus:before,.ion-minus-circled:before,.ion-minus-round:before,.ion-model-s:before,.ion-monitor:before,.ion-more:before,.ion-mouse:before,.ion-music-note:before,.ion-navicon:before,.ion-navicon-round:before,.ion-navigate:before,.ion-network:before,.ion-no-smoking:before,.ion-nuclear:before,.ion-outlet:before,.ion-paintbrush:before,.ion-paintbucket:before,.ion-paper-airplane:before,.ion-paperclip:before,.ion-pause:before,.ion-person:before,.ion-person-add:before,.ion-person-stalker:before,.ion-pie-graph:before,.ion-pin:before,.ion-pinpoint:before,.ion-pizza:before,.ion-plane:before,.ion-planet:before,.ion-play:before,.ion-playstation:before,.ion-plus:before,.ion-plus-circled:before,.ion-plus-round:before,.ion-podium:before,.ion-pound:before,.ion-power:before,.ion-pricetag:before,.ion-pricetags:before,.ion-printer:before,.ion-pull-request:before,.ion-qr-scanner:before,.ion-quote:before,.ion-radio-waves:before,.ion-record:before,.ion-refresh:before,.ion-reply:before,.ion-reply-all:before,.ion-ribbon-a:before,.ion-ribbon-b:before,.ion-sad:before,.ion-sad-outline:before,.ion-scissors:before,.ion-search:before,.ion-settings:before,.ion-share:before,.ion-shuffle:before,.ion-skip-backward:before,.ion-skip-forward:before,.ion-social-android:before,.ion-social-android-outline:before,.ion-social-angular:before,.ion-social-angular-outline:before,.ion-social-apple:before,.ion-social-apple-outline:before,.ion-social-bitcoin:before,.ion-social-bitcoin-outline:before,.ion-social-buffer:before,.ion-social-buffer-outline:before,.ion-social-chrome:before,.ion-social-chrome-outline:before,.ion-social-codepen:before,.ion-social-codepen-outline:before,.ion-social-css3:before,.ion-social-css3-outline:before,.ion-social-designernews:before,.ion-social-designernews-outline:before,.ion-social-dribbble:before,.ion-social-dribbble-outline:before,.ion-social-dropbox:before,.ion-social-dropbox-outline:before,.ion-social-euro:before,.ion-social-euro-outline:before,.ion-social-facebook:before,.ion-social-facebook-outline:before,.ion-social-foursquare:before,.ion-social-foursquare-outline:before,.ion-social-freebsd-devil:before,.ion-social-github:before,.ion-social-github-outline:before,.ion-social-google:before,.ion-social-google-outline:before,.ion-social-googleplus:before,.ion-social-googleplus-outline:before,.ion-social-hackernews:before,.ion-social-hackernews-outline:before,.ion-social-html5:before,.ion-social-html5-outline:before,.ion-social-instagram:before,.ion-social-instagram-outline:before,.ion-social-javascript:before,.ion-social-javascript-outline:before,.ion-social-linkedin:before,.ion-social-linkedin-outline:before,.ion-social-markdown:before,.ion-social-nodejs:before,.ion-social-octocat:before,.ion-social-pinterest:before,.ion-social-pinterest-outline:before,.ion-social-python:before,.ion-social-reddit:before,.ion-social-reddit-outline:before,.ion-social-rss:before,.ion-social-rss-outline:before,.ion-social-sass:before,.ion-social-skype:before,.ion-social-skype-outline:before,.ion-social-snapchat:before,.ion-social-snapchat-outline:before,.ion-social-tumblr:before,.ion-social-tumblr-outline:before,.ion-social-tux:before,.ion-social-twitch:before,.ion-social-twitch-outline:before,.ion-social-twitter:before,.ion-social-twitter-outline:before,.ion-social-usd:before,.ion-social-usd-outline:before,.ion-social-vimeo:before,.ion-social-vimeo-outline:before,.ion-social-whatsapp:before,.ion-social-whatsapp-outline:before,.ion-social-windows:before,.ion-social-windows-outline:before,.ion-social-wordpress:before,.ion-social-wordpress-outline:before,.ion-social-yahoo:before,.ion-social-yahoo-outline:before,.ion-social-yen:before,.ion-social-yen-outline:before,.ion-social-youtube:before,.ion-social-youtube-outline:before,.ion-soup-can:before,.ion-soup-can-outline:before,.ion-speakerphone:before,.ion-speedometer:before,.ion-spoon:before,.ion-star:before,.ion-stats-bars:before,.ion-steam:before,.ion-stop:before,.ion-thermometer:before,.ion-thumbsdown:before,.ion-thumbsup:before,.ion-toggle:before,.ion-toggle-filled:before,.ion-transgender:before,.ion-trash-a:before,.ion-trash-b:before,.ion-trophy:before,.ion-tshirt:before,.ion-tshirt-outline:before,.ion-umbrella:before,.ion-university:before,.ion-unlocked:before,.ion-upload:before,.ion-usb:before,.ion-videocamera:before,.ion-volume-high:before,.ion-volume-low:before,.ion-volume-medium:before,.ion-volume-mute:before,.ion-wand:before,.ion-waterdrop:before,.ion-wifi:before,.ion-wineglass:before,.ion-woman:before,.ion-wrench:before,.ion-xbox:before{display:inline-block;font-family:Ionicons;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;text-rendering:auto;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.ion-alert:before{content:\"\\f101\"}.ion-alert-circled:before{content:\"\\f100\"}.ion-android-add:before{content:\"\\f2c7\"}.ion-android-add-circle:before{content:\"\\f359\"}.ion-android-alarm-clock:before{content:\"\\f35a\"}.ion-android-alert:before{content:\"\\f35b\"}.ion-android-apps:before{content:\"\\f35c\"}.ion-android-archive:before{content:\"\\f2c9\"}.ion-android-arrow-back:before{content:\"\\f2ca\"}.ion-android-arrow-down:before{content:\"\\f35d\"}.ion-android-arrow-dropdown:before{content:\"\\f35f\"}.ion-android-arrow-dropdown-circle:before{content:\"\\f35e\"}.ion-android-arrow-dropleft:before{content:\"\\f361\"}.ion-android-arrow-dropleft-circle:before{content:\"\\f360\"}.ion-android-arrow-dropright:before{content:\"\\f363\"}.ion-android-arrow-dropright-circle:before{content:\"\\f362\"}.ion-android-arrow-dropup:before{content:\"\\f365\"}.ion-android-arrow-dropup-circle:before{content:\"\\f364\"}.ion-android-arrow-forward:before{content:\"\\f30f\"}.ion-android-arrow-up:before{content:\"\\f366\"}.ion-android-attach:before{content:\"\\f367\"}.ion-android-bar:before{content:\"\\f368\"}.ion-android-bicycle:before{content:\"\\f369\"}.ion-android-boat:before{content:\"\\f36a\"}.ion-android-bookmark:before{content:\"\\f36b\"}.ion-android-bulb:before{content:\"\\f36c\"}.ion-android-bus:before{content:\"\\f36d\"}.ion-android-calendar:before{content:\"\\f2d1\"}.ion-android-call:before{content:\"\\f2d2\"}.ion-android-camera:before{content:\"\\f2d3\"}.ion-android-cancel:before{content:\"\\f36e\"}.ion-android-car:before{content:\"\\f36f\"}.ion-android-cart:before{content:\"\\f370\"}.ion-android-chat:before{content:\"\\f2d4\"}.ion-android-checkbox:before{content:\"\\f374\"}.ion-android-checkbox-blank:before{content:\"\\f371\"}.ion-android-checkbox-outline:before{content:\"\\f373\"}.ion-android-checkbox-outline-blank:before{content:\"\\f372\"}.ion-android-checkmark-circle:before{content:\"\\f375\"}.ion-android-clipboard:before{content:\"\\f376\"}.ion-android-close:before{content:\"\\f2d7\"}.ion-android-cloud:before{content:\"\\f37a\"}.ion-android-cloud-circle:before{content:\"\\f377\"}.ion-android-cloud-done:before{content:\"\\f378\"}.ion-android-cloud-outline:before{content:\"\\f379\"}.ion-android-color-palette:before{content:\"\\f37b\"}.ion-android-compass:before{content:\"\\f37c\"}.ion-android-contact:before{content:\"\\f2d8\"}.ion-android-contacts:before{content:\"\\f2d9\"}.ion-android-contract:before{content:\"\\f37d\"}.ion-android-create:before{content:\"\\f37e\"}.ion-android-delete:before{content:\"\\f37f\"}.ion-android-desktop:before{content:\"\\f380\"}.ion-android-document:before{content:\"\\f381\"}.ion-android-done:before{content:\"\\f383\"}.ion-android-done-all:before{content:\"\\f382\"}.ion-android-download:before{content:\"\\f2dd\"}.ion-android-drafts:before{content:\"\\f384\"}.ion-android-exit:before{content:\"\\f385\"}.ion-android-expand:before{content:\"\\f386\"}.ion-android-favorite:before{content:\"\\f388\"}.ion-android-favorite-outline:before{content:\"\\f387\"}.ion-android-film:before{content:\"\\f389\"}.ion-android-folder:before{content:\"\\f2e0\"}.ion-android-folder-open:before{content:\"\\f38a\"}.ion-android-funnel:before{content:\"\\f38b\"}.ion-android-globe:before{content:\"\\f38c\"}.ion-android-hand:before{content:\"\\f2e3\"}.ion-android-hangout:before{content:\"\\f38d\"}.ion-android-happy:before{content:\"\\f38e\"}.ion-android-home:before{content:\"\\f38f\"}.ion-android-image:before{content:\"\\f2e4\"}.ion-android-laptop:before{content:\"\\f390\"}.ion-android-list:before{content:\"\\f391\"}.ion-android-locate:before{content:\"\\f2e9\"}.ion-android-lock:before{content:\"\\f392\"}.ion-android-mail:before{content:\"\\f2eb\"}.ion-android-map:before{content:\"\\f393\"}.ion-android-menu:before{content:\"\\f394\"}.ion-android-microphone:before{content:\"\\f2ec\"}.ion-android-microphone-off:before{content:\"\\f395\"}.ion-android-more-horizontal:before{content:\"\\f396\"}.ion-android-more-vertical:before{content:\"\\f397\"}.ion-android-navigate:before{content:\"\\f398\"}.ion-android-notifications:before{content:\"\\f39b\"}.ion-android-notifications-none:before{content:\"\\f399\"}.ion-android-notifications-off:before{content:\"\\f39a\"}.ion-android-open:before{content:\"\\f39c\"}.ion-android-options:before{content:\"\\f39d\"}.ion-android-people:before{content:\"\\f39e\"}.ion-android-person:before{content:\"\\f3a0\"}.ion-android-person-add:before{content:\"\\f39f\"}.ion-android-phone-landscape:before{content:\"\\f3a1\"}.ion-android-phone-portrait:before{content:\"\\f3a2\"}.ion-android-pin:before{content:\"\\f3a3\"}.ion-android-plane:before{content:\"\\f3a4\"}.ion-android-playstore:before{content:\"\\f2f0\"}.ion-android-print:before{content:\"\\f3a5\"}.ion-android-radio-button-off:before{content:\"\\f3a6\"}.ion-android-radio-button-on:before{content:\"\\f3a7\"}.ion-android-refresh:before{content:\"\\f3a8\"}.ion-android-remove:before{content:\"\\f2f4\"}.ion-android-remove-circle:before{content:\"\\f3a9\"}.ion-android-restaurant:before{content:\"\\f3aa\"}.ion-android-sad:before{content:\"\\f3ab\"}.ion-android-search:before{content:\"\\f2f5\"}.ion-android-send:before{content:\"\\f2f6\"}.ion-android-settings:before{content:\"\\f2f7\"}.ion-android-share:before{content:\"\\f2f8\"}.ion-android-share-alt:before{content:\"\\f3ac\"}.ion-android-star:before{content:\"\\f2fc\"}.ion-android-star-half:before{content:\"\\f3ad\"}.ion-android-star-outline:before{content:\"\\f3ae\"}.ion-android-stopwatch:before{content:\"\\f2fd\"}.ion-android-subway:before{content:\"\\f3af\"}.ion-android-sunny:before{content:\"\\f3b0\"}.ion-android-sync:before{content:\"\\f3b1\"}.ion-android-textsms:before{content:\"\\f3b2\"}.ion-android-time:before{content:\"\\f3b3\"}.ion-android-train:before{content:\"\\f3b4\"}.ion-android-unlock:before{content:\"\\f3b5\"}.ion-android-upload:before{content:\"\\f3b6\"}.ion-android-volume-down:before{content:\"\\f3b7\"}.ion-android-volume-mute:before{content:\"\\f3b8\"}.ion-android-volume-off:before{content:\"\\f3b9\"}.ion-android-volume-up:before{content:\"\\f3ba\"}.ion-android-walk:before{content:\"\\f3bb\"}.ion-android-warning:before{content:\"\\f3bc\"}.ion-android-watch:before{content:\"\\f3bd\"}.ion-android-wifi:before{content:\"\\f305\"}.ion-aperture:before{content:\"\\f313\"}.ion-archive:before{content:\"\\f102\"}.ion-arrow-down-a:before{content:\"\\f103\"}.ion-arrow-down-b:before{content:\"\\f104\"}.ion-arrow-down-c:before{content:\"\\f105\"}.ion-arrow-expand:before{content:\"\\f25e\"}.ion-arrow-graph-down-left:before{content:\"\\f25f\"}.ion-arrow-graph-down-right:before{content:\"\\f260\"}.ion-arrow-graph-up-left:before{content:\"\\f261\"}.ion-arrow-graph-up-right:before{content:\"\\f262\"}.ion-arrow-left-a:before{content:\"\\f106\"}.ion-arrow-left-b:before{content:\"\\f107\"}.ion-arrow-left-c:before{content:\"\\f108\"}.ion-arrow-move:before{content:\"\\f263\"}.ion-arrow-resize:before{content:\"\\f264\"}.ion-arrow-return-left:before{content:\"\\f265\"}.ion-arrow-return-right:before{content:\"\\f266\"}.ion-arrow-right-a:before{content:\"\\f109\"}.ion-arrow-right-b:before{content:\"\\f10a\"}.ion-arrow-right-c:before{content:\"\\f10b\"}.ion-arrow-shrink:before{content:\"\\f267\"}.ion-arrow-swap:before{content:\"\\f268\"}.ion-arrow-up-a:before{content:\"\\f10c\"}.ion-arrow-up-b:before{content:\"\\f10d\"}.ion-arrow-up-c:before{content:\"\\f10e\"}.ion-asterisk:before{content:\"\\f314\"}.ion-at:before{content:\"\\f10f\"}.ion-backspace:before{content:\"\\f3bf\"}.ion-backspace-outline:before{content:\"\\f3be\"}.ion-bag:before{content:\"\\f110\"}.ion-battery-charging:before{content:\"\\f111\"}.ion-battery-empty:before{content:\"\\f112\"}.ion-battery-full:before{content:\"\\f113\"}.ion-battery-half:before{content:\"\\f114\"}.ion-battery-low:before{content:\"\\f115\"}.ion-beaker:before{content:\"\\f269\"}.ion-beer:before{content:\"\\f26a\"}.ion-bluetooth:before{content:\"\\f116\"}.ion-bonfire:before{content:\"\\f315\"}.ion-bookmark:before{content:\"\\f26b\"}.ion-bowtie:before{content:\"\\f3c0\"}.ion-briefcase:before{content:\"\\f26c\"}.ion-bug:before{content:\"\\f2be\"}.ion-calculator:before{content:\"\\f26d\"}.ion-calendar:before{content:\"\\f117\"}.ion-camera:before{content:\"\\f118\"}.ion-card:before{content:\"\\f119\"}.ion-cash:before{content:\"\\f316\"}.ion-chatbox:before{content:\"\\f11b\"}.ion-chatbox-working:before{content:\"\\f11a\"}.ion-chatboxes:before{content:\"\\f11c\"}.ion-chatbubble:before{content:\"\\f11e\"}.ion-chatbubble-working:before{content:\"\\f11d\"}.ion-chatbubbles:before{content:\"\\f11f\"}.ion-checkmark:before{content:\"\\f122\"}.ion-checkmark-circled:before{content:\"\\f120\"}.ion-checkmark-round:before{content:\"\\f121\"}.ion-chevron-down:before{content:\"\\f123\"}.ion-chevron-left:before{content:\"\\f124\"}.ion-chevron-right:before{content:\"\\f125\"}.ion-chevron-up:before{content:\"\\f126\"}.ion-clipboard:before{content:\"\\f127\"}.ion-clock:before{content:\"\\f26e\"}.ion-close:before{content:\"\\f12a\"}.ion-close-circled:before{content:\"\\f128\"}.ion-close-round:before{content:\"\\f129\"}.ion-closed-captioning:before{content:\"\\f317\"}.ion-cloud:before{content:\"\\f12b\"}.ion-code:before{content:\"\\f271\"}.ion-code-download:before{content:\"\\f26f\"}.ion-code-working:before{content:\"\\f270\"}.ion-coffee:before{content:\"\\f272\"}.ion-compass:before{content:\"\\f273\"}.ion-compose:before{content:\"\\f12c\"}.ion-connection-bars:before{content:\"\\f274\"}.ion-contrast:before{content:\"\\f275\"}.ion-crop:before{content:\"\\f3c1\"}.ion-cube:before{content:\"\\f318\"}.ion-disc:before{content:\"\\f12d\"}.ion-document:before{content:\"\\f12f\"}.ion-document-text:before{content:\"\\f12e\"}.ion-drag:before{content:\"\\f130\"}.ion-earth:before{content:\"\\f276\"}.ion-easel:before{content:\"\\f3c2\"}.ion-edit:before{content:\"\\f2bf\"}.ion-egg:before{content:\"\\f277\"}.ion-eject:before{content:\"\\f131\"}.ion-email:before{content:\"\\f132\"}.ion-email-unread:before{content:\"\\f3c3\"}.ion-erlenmeyer-flask:before{content:\"\\f3c5\"}.ion-erlenmeyer-flask-bubbles:before{content:\"\\f3c4\"}.ion-eye:before{content:\"\\f133\"}.ion-eye-disabled:before{content:\"\\f306\"}.ion-female:before{content:\"\\f278\"}.ion-filing:before{content:\"\\f134\"}.ion-film-marker:before{content:\"\\f135\"}.ion-fireball:before{content:\"\\f319\"}.ion-flag:before{content:\"\\f279\"}.ion-flame:before{content:\"\\f31a\"}.ion-flash:before{content:\"\\f137\"}.ion-flash-off:before{content:\"\\f136\"}.ion-folder:before{content:\"\\f139\"}.ion-fork:before{content:\"\\f27a\"}.ion-fork-repo:before{content:\"\\f2c0\"}.ion-forward:before{content:\"\\f13a\"}.ion-funnel:before{content:\"\\f31b\"}.ion-gear-a:before{content:\"\\f13d\"}.ion-gear-b:before{content:\"\\f13e\"}.ion-grid:before{content:\"\\f13f\"}.ion-hammer:before{content:\"\\f27b\"}.ion-happy:before{content:\"\\f31c\"}.ion-happy-outline:before{content:\"\\f3c6\"}.ion-headphone:before{content:\"\\f140\"}.ion-heart:before{content:\"\\f141\"}.ion-heart-broken:before{content:\"\\f31d\"}.ion-help:before{content:\"\\f143\"}.ion-help-buoy:before{content:\"\\f27c\"}.ion-help-circled:before{content:\"\\f142\"}.ion-home:before{content:\"\\f144\"}.ion-icecream:before{content:\"\\f27d\"}.ion-image:before{content:\"\\f147\"}.ion-images:before{content:\"\\f148\"}.ion-information:before{content:\"\\f14a\"}.ion-information-circled:before{content:\"\\f149\"}.ion-ionic:before{content:\"\\f14b\"}.ion-ios-alarm:before{content:\"\\f3c8\"}.ion-ios-alarm-outline:before{content:\"\\f3c7\"}.ion-ios-albums:before{content:\"\\f3ca\"}.ion-ios-albums-outline:before{content:\"\\f3c9\"}.ion-ios-americanfootball:before{content:\"\\f3cc\"}.ion-ios-americanfootball-outline:before{content:\"\\f3cb\"}.ion-ios-analytics:before{content:\"\\f3ce\"}.ion-ios-analytics-outline:before{content:\"\\f3cd\"}.ion-ios-arrow-back:before{content:\"\\f3cf\"}.ion-ios-arrow-down:before{content:\"\\f3d0\"}.ion-ios-arrow-forward:before{content:\"\\f3d1\"}.ion-ios-arrow-left:before{content:\"\\f3d2\"}.ion-ios-arrow-right:before{content:\"\\f3d3\"}.ion-ios-arrow-thin-down:before{content:\"\\f3d4\"}.ion-ios-arrow-thin-left:before{content:\"\\f3d5\"}.ion-ios-arrow-thin-right:before{content:\"\\f3d6\"}.ion-ios-arrow-thin-up:before{content:\"\\f3d7\"}.ion-ios-arrow-up:before{content:\"\\f3d8\"}.ion-ios-at:before{content:\"\\f3da\"}.ion-ios-at-outline:before{content:\"\\f3d9\"}.ion-ios-barcode:before{content:\"\\f3dc\"}.ion-ios-barcode-outline:before{content:\"\\f3db\"}.ion-ios-baseball:before{content:\"\\f3de\"}.ion-ios-baseball-outline:before{content:\"\\f3dd\"}.ion-ios-basketball:before{content:\"\\f3e0\"}.ion-ios-basketball-outline:before{content:\"\\f3df\"}.ion-ios-bell:before{content:\"\\f3e2\"}.ion-ios-bell-outline:before{content:\"\\f3e1\"}.ion-ios-body:before{content:\"\\f3e4\"}.ion-ios-body-outline:before{content:\"\\f3e3\"}.ion-ios-bolt:before{content:\"\\f3e6\"}.ion-ios-bolt-outline:before{content:\"\\f3e5\"}.ion-ios-book:before{content:\"\\f3e8\"}.ion-ios-book-outline:before{content:\"\\f3e7\"}.ion-ios-bookmarks:before{content:\"\\f3ea\"}.ion-ios-bookmarks-outline:before{content:\"\\f3e9\"}.ion-ios-box:before{content:\"\\f3ec\"}.ion-ios-box-outline:before{content:\"\\f3eb\"}.ion-ios-briefcase:before{content:\"\\f3ee\"}.ion-ios-briefcase-outline:before{content:\"\\f3ed\"}.ion-ios-browsers:before{content:\"\\f3f0\"}.ion-ios-browsers-outline:before{content:\"\\f3ef\"}.ion-ios-calculator:before{content:\"\\f3f2\"}.ion-ios-calculator-outline:before{content:\"\\f3f1\"}.ion-ios-calendar:before{content:\"\\f3f4\"}.ion-ios-calendar-outline:before{content:\"\\f3f3\"}.ion-ios-camera:before{content:\"\\f3f6\"}.ion-ios-camera-outline:before{content:\"\\f3f5\"}.ion-ios-cart:before{content:\"\\f3f8\"}.ion-ios-cart-outline:before{content:\"\\f3f7\"}.ion-ios-chatboxes:before{content:\"\\f3fa\"}.ion-ios-chatboxes-outline:before{content:\"\\f3f9\"}.ion-ios-chatbubble:before{content:\"\\f3fc\"}.ion-ios-chatbubble-outline:before{content:\"\\f3fb\"}.ion-ios-checkmark:before{content:\"\\f3ff\"}.ion-ios-checkmark-empty:before{content:\"\\f3fd\"}.ion-ios-checkmark-outline:before{content:\"\\f3fe\"}.ion-ios-circle-filled:before{content:\"\\f400\"}.ion-ios-circle-outline:before{content:\"\\f401\"}.ion-ios-clock:before{content:\"\\f403\"}.ion-ios-clock-outline:before{content:\"\\f402\"}.ion-ios-close:before{content:\"\\f406\"}.ion-ios-close-empty:before{content:\"\\f404\"}.ion-ios-close-outline:before{content:\"\\f405\"}.ion-ios-cloud:before{content:\"\\f40c\"}.ion-ios-cloud-download:before{content:\"\\f408\"}.ion-ios-cloud-download-outline:before{content:\"\\f407\"}.ion-ios-cloud-outline:before{content:\"\\f409\"}.ion-ios-cloud-upload:before{content:\"\\f40b\"}.ion-ios-cloud-upload-outline:before{content:\"\\f40a\"}.ion-ios-cloudy:before{content:\"\\f410\"}.ion-ios-cloudy-night:before{content:\"\\f40e\"}.ion-ios-cloudy-night-outline:before{content:\"\\f40d\"}.ion-ios-cloudy-outline:before{content:\"\\f40f\"}.ion-ios-cog:before{content:\"\\f412\"}.ion-ios-cog-outline:before{content:\"\\f411\"}.ion-ios-color-filter:before{content:\"\\f414\"}.ion-ios-color-filter-outline:before{content:\"\\f413\"}.ion-ios-color-wand:before{content:\"\\f416\"}.ion-ios-color-wand-outline:before{content:\"\\f415\"}.ion-ios-compose:before{content:\"\\f418\"}.ion-ios-compose-outline:before{content:\"\\f417\"}.ion-ios-contact:before{content:\"\\f41a\"}.ion-ios-contact-outline:before{content:\"\\f419\"}.ion-ios-copy:before{content:\"\\f41c\"}.ion-ios-copy-outline:before{content:\"\\f41b\"}.ion-ios-crop:before{content:\"\\f41e\"}.ion-ios-crop-strong:before{content:\"\\f41d\"}.ion-ios-download:before{content:\"\\f420\"}.ion-ios-download-outline:before{content:\"\\f41f\"}.ion-ios-drag:before{content:\"\\f421\"}.ion-ios-email:before{content:\"\\f423\"}.ion-ios-email-outline:before{content:\"\\f422\"}.ion-ios-eye:before{content:\"\\f425\"}.ion-ios-eye-outline:before{content:\"\\f424\"}.ion-ios-fastforward:before{content:\"\\f427\"}.ion-ios-fastforward-outline:before{content:\"\\f426\"}.ion-ios-filing:before{content:\"\\f429\"}.ion-ios-filing-outline:before{content:\"\\f428\"}.ion-ios-film:before{content:\"\\f42b\"}.ion-ios-film-outline:before{content:\"\\f42a\"}.ion-ios-flag:before{content:\"\\f42d\"}.ion-ios-flag-outline:before{content:\"\\f42c\"}.ion-ios-flame:before{content:\"\\f42f\"}.ion-ios-flame-outline:before{content:\"\\f42e\"}.ion-ios-flask:before{content:\"\\f431\"}.ion-ios-flask-outline:before{content:\"\\f430\"}.ion-ios-flower:before{content:\"\\f433\"}.ion-ios-flower-outline:before{content:\"\\f432\"}.ion-ios-folder:before{content:\"\\f435\"}.ion-ios-folder-outline:before{content:\"\\f434\"}.ion-ios-football:before{content:\"\\f437\"}.ion-ios-football-outline:before{content:\"\\f436\"}.ion-ios-game-controller-a:before{content:\"\\f439\"}.ion-ios-game-controller-a-outline:before{content:\"\\f438\"}.ion-ios-game-controller-b:before{content:\"\\f43b\"}.ion-ios-game-controller-b-outline:before{content:\"\\f43a\"}.ion-ios-gear:before{content:\"\\f43d\"}.ion-ios-gear-outline:before{content:\"\\f43c\"}.ion-ios-glasses:before{content:\"\\f43f\"}.ion-ios-glasses-outline:before{content:\"\\f43e\"}.ion-ios-grid-view:before{content:\"\\f441\"}.ion-ios-grid-view-outline:before{content:\"\\f440\"}.ion-ios-heart:before{content:\"\\f443\"}.ion-ios-heart-outline:before{content:\"\\f442\"}.ion-ios-help:before{content:\"\\f446\"}.ion-ios-help-empty:before{content:\"\\f444\"}.ion-ios-help-outline:before{content:\"\\f445\"}.ion-ios-home:before{content:\"\\f448\"}.ion-ios-home-outline:before{content:\"\\f447\"}.ion-ios-infinite:before{content:\"\\f44a\"}.ion-ios-infinite-outline:before{content:\"\\f449\"}.ion-ios-information:before{content:\"\\f44d\"}.ion-ios-information-empty:before{content:\"\\f44b\"}.ion-ios-information-outline:before{content:\"\\f44c\"}.ion-ios-ionic-outline:before{content:\"\\f44e\"}.ion-ios-keypad:before{content:\"\\f450\"}.ion-ios-keypad-outline:before{content:\"\\f44f\"}.ion-ios-lightbulb:before{content:\"\\f452\"}.ion-ios-lightbulb-outline:before{content:\"\\f451\"}.ion-ios-list:before{content:\"\\f454\"}.ion-ios-list-outline:before{content:\"\\f453\"}.ion-ios-location:before{content:\"\\f456\"}.ion-ios-location-outline:before{content:\"\\f455\"}.ion-ios-locked:before{content:\"\\f458\"}.ion-ios-locked-outline:before{content:\"\\f457\"}.ion-ios-loop:before{content:\"\\f45a\"}.ion-ios-loop-strong:before{content:\"\\f459\"}.ion-ios-medical:before{content:\"\\f45c\"}.ion-ios-medical-outline:before{content:\"\\f45b\"}.ion-ios-medkit:before{content:\"\\f45e\"}.ion-ios-medkit-outline:before{content:\"\\f45d\"}.ion-ios-mic:before{content:\"\\f461\"}.ion-ios-mic-off:before{content:\"\\f45f\"}.ion-ios-mic-outline:before{content:\"\\f460\"}.ion-ios-minus:before{content:\"\\f464\"}.ion-ios-minus-empty:before{content:\"\\f462\"}.ion-ios-minus-outline:before{content:\"\\f463\"}.ion-ios-monitor:before{content:\"\\f466\"}.ion-ios-monitor-outline:before{content:\"\\f465\"}.ion-ios-moon:before{content:\"\\f468\"}.ion-ios-moon-outline:before{content:\"\\f467\"}.ion-ios-more:before{content:\"\\f46a\"}.ion-ios-more-outline:before{content:\"\\f469\"}.ion-ios-musical-note:before{content:\"\\f46b\"}.ion-ios-musical-notes:before{content:\"\\f46c\"}.ion-ios-navigate:before{content:\"\\f46e\"}.ion-ios-navigate-outline:before{content:\"\\f46d\"}.ion-ios-nutrition:before{content:\"\\f470\"}.ion-ios-nutrition-outline:before{content:\"\\f46f\"}.ion-ios-paper:before{content:\"\\f472\"}.ion-ios-paper-outline:before{content:\"\\f471\"}.ion-ios-paperplane:before{content:\"\\f474\"}.ion-ios-paperplane-outline:before{content:\"\\f473\"}.ion-ios-partlysunny:before{content:\"\\f476\"}.ion-ios-partlysunny-outline:before{content:\"\\f475\"}.ion-ios-pause:before{content:\"\\f478\"}.ion-ios-pause-outline:before{content:\"\\f477\"}.ion-ios-paw:before{content:\"\\f47a\"}.ion-ios-paw-outline:before{content:\"\\f479\"}.ion-ios-people:before{content:\"\\f47c\"}.ion-ios-people-outline:before{content:\"\\f47b\"}.ion-ios-person:before{content:\"\\f47e\"}.ion-ios-person-outline:before{content:\"\\f47d\"}.ion-ios-personadd:before{content:\"\\f480\"}.ion-ios-personadd-outline:before{content:\"\\f47f\"}.ion-ios-photos:before{content:\"\\f482\"}.ion-ios-photos-outline:before{content:\"\\f481\"}.ion-ios-pie:before{content:\"\\f484\"}.ion-ios-pie-outline:before{content:\"\\f483\"}.ion-ios-pint:before{content:\"\\f486\"}.ion-ios-pint-outline:before{content:\"\\f485\"}.ion-ios-play:before{content:\"\\f488\"}.ion-ios-play-outline:before{content:\"\\f487\"}.ion-ios-plus:before{content:\"\\f48b\"}.ion-ios-plus-empty:before{content:\"\\f489\"}.ion-ios-plus-outline:before{content:\"\\f48a\"}.ion-ios-pricetag:before{content:\"\\f48d\"}.ion-ios-pricetag-outline:before{content:\"\\f48c\"}.ion-ios-pricetags:before{content:\"\\f48f\"}.ion-ios-pricetags-outline:before{content:\"\\f48e\"}.ion-ios-printer:before{content:\"\\f491\"}.ion-ios-printer-outline:before{content:\"\\f490\"}.ion-ios-pulse:before{content:\"\\f493\"}.ion-ios-pulse-strong:before{content:\"\\f492\"}.ion-ios-rainy:before{content:\"\\f495\"}.ion-ios-rainy-outline:before{content:\"\\f494\"}.ion-ios-recording:before{content:\"\\f497\"}.ion-ios-recording-outline:before{content:\"\\f496\"}.ion-ios-redo:before{content:\"\\f499\"}.ion-ios-redo-outline:before{content:\"\\f498\"}.ion-ios-refresh:before{content:\"\\f49c\"}.ion-ios-refresh-empty:before{content:\"\\f49a\"}.ion-ios-refresh-outline:before{content:\"\\f49b\"}.ion-ios-reload:before{content:\"\\f49d\"}.ion-ios-reverse-camera:before{content:\"\\f49f\"}.ion-ios-reverse-camera-outline:before{content:\"\\f49e\"}.ion-ios-rewind:before{content:\"\\f4a1\"}.ion-ios-rewind-outline:before{content:\"\\f4a0\"}.ion-ios-rose:before{content:\"\\f4a3\"}.ion-ios-rose-outline:before{content:\"\\f4a2\"}.ion-ios-search:before{content:\"\\f4a5\"}.ion-ios-search-strong:before{content:\"\\f4a4\"}.ion-ios-settings:before{content:\"\\f4a7\"}.ion-ios-settings-strong:before{content:\"\\f4a6\"}.ion-ios-shuffle:before{content:\"\\f4a9\"}.ion-ios-shuffle-strong:before{content:\"\\f4a8\"}.ion-ios-skipbackward:before{content:\"\\f4ab\"}.ion-ios-skipbackward-outline:before{content:\"\\f4aa\"}.ion-ios-skipforward:before{content:\"\\f4ad\"}.ion-ios-skipforward-outline:before{content:\"\\f4ac\"}.ion-ios-snowy:before{content:\"\\f4ae\"}.ion-ios-speedometer:before{content:\"\\f4b0\"}.ion-ios-speedometer-outline:before{content:\"\\f4af\"}.ion-ios-star:before{content:\"\\f4b3\"}.ion-ios-star-half:before{content:\"\\f4b1\"}.ion-ios-star-outline:before{content:\"\\f4b2\"}.ion-ios-stopwatch:before{content:\"\\f4b5\"}.ion-ios-stopwatch-outline:before{content:\"\\f4b4\"}.ion-ios-sunny:before{content:\"\\f4b7\"}.ion-ios-sunny-outline:before{content:\"\\f4b6\"}.ion-ios-telephone:before{content:\"\\f4b9\"}.ion-ios-telephone-outline:before{content:\"\\f4b8\"}.ion-ios-tennisball:before{content:\"\\f4bb\"}.ion-ios-tennisball-outline:before{content:\"\\f4ba\"}.ion-ios-thunderstorm:before{content:\"\\f4bd\"}.ion-ios-thunderstorm-outline:before{content:\"\\f4bc\"}.ion-ios-time:before{content:\"\\f4bf\"}.ion-ios-time-outline:before{content:\"\\f4be\"}.ion-ios-timer:before{content:\"\\f4c1\"}.ion-ios-timer-outline:before{content:\"\\f4c0\"}.ion-ios-toggle:before{content:\"\\f4c3\"}.ion-ios-toggle-outline:before{content:\"\\f4c2\"}.ion-ios-trash:before{content:\"\\f4c5\"}.ion-ios-trash-outline:before{content:\"\\f4c4\"}.ion-ios-undo:before{content:\"\\f4c7\"}.ion-ios-undo-outline:before{content:\"\\f4c6\"}.ion-ios-unlocked:before{content:\"\\f4c9\"}.ion-ios-unlocked-outline:before{content:\"\\f4c8\"}.ion-ios-upload:before{content:\"\\f4cb\"}.ion-ios-upload-outline:before{content:\"\\f4ca\"}.ion-ios-videocam:before{content:\"\\f4cd\"}.ion-ios-videocam-outline:before{content:\"\\f4cc\"}.ion-ios-volume-high:before{content:\"\\f4ce\"}.ion-ios-volume-low:before{content:\"\\f4cf\"}.ion-ios-wineglass:before{content:\"\\f4d1\"}.ion-ios-wineglass-outline:before{content:\"\\f4d0\"}.ion-ios-world:before{content:\"\\f4d3\"}.ion-ios-world-outline:before{content:\"\\f4d2\"}.ion-ipad:before{content:\"\\f1f9\"}.ion-iphone:before{content:\"\\f1fa\"}.ion-ipod:before{content:\"\\f1fb\"}.ion-jet:before{content:\"\\f295\"}.ion-key:before{content:\"\\f296\"}.ion-knife:before{content:\"\\f297\"}.ion-laptop:before{content:\"\\f1fc\"}.ion-leaf:before{content:\"\\f1fd\"}.ion-levels:before{content:\"\\f298\"}.ion-lightbulb:before{content:\"\\f299\"}.ion-link:before{content:\"\\f1fe\"}.ion-load-a:before{content:\"\\f29a\"}.ion-load-b:before{content:\"\\f29b\"}.ion-load-c:before{content:\"\\f29c\"}.ion-load-d:before{content:\"\\f29d\"}.ion-location:before{content:\"\\f1ff\"}.ion-lock-combination:before{content:\"\\f4d4\"}.ion-locked:before{content:\"\\f200\"}.ion-log-in:before{content:\"\\f29e\"}.ion-log-out:before{content:\"\\f29f\"}.ion-loop:before{content:\"\\f201\"}.ion-magnet:before{content:\"\\f2a0\"}.ion-male:before{content:\"\\f2a1\"}.ion-man:before{content:\"\\f202\"}.ion-map:before{content:\"\\f203\"}.ion-medkit:before{content:\"\\f2a2\"}.ion-merge:before{content:\"\\f33f\"}.ion-mic-a:before{content:\"\\f204\"}.ion-mic-b:before{content:\"\\f205\"}.ion-mic-c:before{content:\"\\f206\"}.ion-minus:before{content:\"\\f209\"}.ion-minus-circled:before{content:\"\\f207\"}.ion-minus-round:before{content:\"\\f208\"}.ion-model-s:before{content:\"\\f2c1\"}.ion-monitor:before{content:\"\\f20a\"}.ion-more:before{content:\"\\f20b\"}.ion-mouse:before{content:\"\\f340\"}.ion-music-note:before{content:\"\\f20c\"}.ion-navicon:before{content:\"\\f20e\"}.ion-navicon-round:before{content:\"\\f20d\"}.ion-navigate:before{content:\"\\f2a3\"}.ion-network:before{content:\"\\f341\"}.ion-no-smoking:before{content:\"\\f2c2\"}.ion-nuclear:before{content:\"\\f2a4\"}.ion-outlet:before{content:\"\\f342\"}.ion-paintbrush:before{content:\"\\f4d5\"}.ion-paintbucket:before{content:\"\\f4d6\"}.ion-paper-airplane:before{content:\"\\f2c3\"}.ion-paperclip:before{content:\"\\f20f\"}.ion-pause:before{content:\"\\f210\"}.ion-person:before{content:\"\\f213\"}.ion-person-add:before{content:\"\\f211\"}.ion-person-stalker:before{content:\"\\f212\"}.ion-pie-graph:before{content:\"\\f2a5\"}.ion-pin:before{content:\"\\f2a6\"}.ion-pinpoint:before{content:\"\\f2a7\"}.ion-pizza:before{content:\"\\f2a8\"}.ion-plane:before{content:\"\\f214\"}.ion-planet:before{content:\"\\f343\"}.ion-play:before{content:\"\\f215\"}.ion-playstation:before{content:\"\\f30a\"}.ion-plus:before{content:\"\\f218\"}.ion-plus-circled:before{content:\"\\f216\"}.ion-plus-round:before{content:\"\\f217\"}.ion-podium:before{content:\"\\f344\"}.ion-pound:before{content:\"\\f219\"}.ion-power:before{content:\"\\f2a9\"}.ion-pricetag:before{content:\"\\f2aa\"}.ion-pricetags:before{content:\"\\f2ab\"}.ion-printer:before{content:\"\\f21a\"}.ion-pull-request:before{content:\"\\f345\"}.ion-qr-scanner:before{content:\"\\f346\"}.ion-quote:before{content:\"\\f347\"}.ion-radio-waves:before{content:\"\\f2ac\"}.ion-record:before{content:\"\\f21b\"}.ion-refresh:before{content:\"\\f21c\"}.ion-reply:before{content:\"\\f21e\"}.ion-reply-all:before{content:\"\\f21d\"}.ion-ribbon-a:before{content:\"\\f348\"}.ion-ribbon-b:before{content:\"\\f349\"}.ion-sad:before{content:\"\\f34a\"}.ion-sad-outline:before{content:\"\\f4d7\"}.ion-scissors:before{content:\"\\f34b\"}.ion-search:before{content:\"\\f21f\"}.ion-settings:before{content:\"\\f2ad\"}.ion-share:before{content:\"\\f220\"}.ion-shuffle:before{content:\"\\f221\"}.ion-skip-backward:before{content:\"\\f222\"}.ion-skip-forward:before{content:\"\\f223\"}.ion-social-android:before{content:\"\\f225\"}.ion-social-android-outline:before{content:\"\\f224\"}.ion-social-angular:before{content:\"\\f4d9\"}.ion-social-angular-outline:before{content:\"\\f4d8\"}.ion-social-apple:before{content:\"\\f227\"}.ion-social-apple-outline:before{content:\"\\f226\"}.ion-social-bitcoin:before{content:\"\\f2af\"}.ion-social-bitcoin-outline:before{content:\"\\f2ae\"}.ion-social-buffer:before{content:\"\\f229\"}.ion-social-buffer-outline:before{content:\"\\f228\"}.ion-social-chrome:before{content:\"\\f4db\"}.ion-social-chrome-outline:before{content:\"\\f4da\"}.ion-social-codepen:before{content:\"\\f4dd\"}.ion-social-codepen-outline:before{content:\"\\f4dc\"}.ion-social-css3:before{content:\"\\f4df\"}.ion-social-css3-outline:before{content:\"\\f4de\"}.ion-social-designernews:before{content:\"\\f22b\"}.ion-social-designernews-outline:before{content:\"\\f22a\"}.ion-social-dribbble:before{content:\"\\f22d\"}.ion-social-dribbble-outline:before{content:\"\\f22c\"}.ion-social-dropbox:before{content:\"\\f22f\"}.ion-social-dropbox-outline:before{content:\"\\f22e\"}.ion-social-euro:before{content:\"\\f4e1\"}.ion-social-euro-outline:before{content:\"\\f4e0\"}.ion-social-facebook:before{content:\"\\f231\"}.ion-social-facebook-outline:before{content:\"\\f230\"}.ion-social-foursquare:before{content:\"\\f34d\"}.ion-social-foursquare-outline:before{content:\"\\f34c\"}.ion-social-freebsd-devil:before{content:\"\\f2c4\"}.ion-social-github:before{content:\"\\f233\"}.ion-social-github-outline:before{content:\"\\f232\"}.ion-social-google:before{content:\"\\f34f\"}.ion-social-google-outline:before{content:\"\\f34e\"}.ion-social-googleplus:before{content:\"\\f235\"}.ion-social-googleplus-outline:before{content:\"\\f234\"}.ion-social-hackernews:before{content:\"\\f237\"}.ion-social-hackernews-outline:before{content:\"\\f236\"}.ion-social-html5:before{content:\"\\f4e3\"}.ion-social-html5-outline:before{content:\"\\f4e2\"}.ion-social-instagram:before{content:\"\\f351\"}.ion-social-instagram-outline:before{content:\"\\f350\"}.ion-social-javascript:before{content:\"\\f4e5\"}.ion-social-javascript-outline:before{content:\"\\f4e4\"}.ion-social-linkedin:before{content:\"\\f239\"}.ion-social-linkedin-outline:before{content:\"\\f238\"}.ion-social-markdown:before{content:\"\\f4e6\"}.ion-social-nodejs:before{content:\"\\f4e7\"}.ion-social-octocat:before{content:\"\\f4e8\"}.ion-social-pinterest:before{content:\"\\f2b1\"}.ion-social-pinterest-outline:before{content:\"\\f2b0\"}.ion-social-python:before{content:\"\\f4e9\"}.ion-social-reddit:before{content:\"\\f23b\"}.ion-social-reddit-outline:before{content:\"\\f23a\"}.ion-social-rss:before{content:\"\\f23d\"}.ion-social-rss-outline:before{content:\"\\f23c\"}.ion-social-sass:before{content:\"\\f4ea\"}.ion-social-skype:before{content:\"\\f23f\"}.ion-social-skype-outline:before{content:\"\\f23e\"}.ion-social-snapchat:before{content:\"\\f4ec\"}.ion-social-snapchat-outline:before{content:\"\\f4eb\"}.ion-social-tumblr:before{content:\"\\f241\"}.ion-social-tumblr-outline:before{content:\"\\f240\"}.ion-social-tux:before{content:\"\\f2c5\"}.ion-social-twitch:before{content:\"\\f4ee\"}.ion-social-twitch-outline:before{content:\"\\f4ed\"}.ion-social-twitter:before{content:\"\\f243\"}.ion-social-twitter-outline:before{content:\"\\f242\"}.ion-social-usd:before{content:\"\\f353\"}.ion-social-usd-outline:before{content:\"\\f352\"}.ion-social-vimeo:before{content:\"\\f245\"}.ion-social-vimeo-outline:before{content:\"\\f244\"}.ion-social-whatsapp:before{content:\"\\f4f0\"}.ion-social-whatsapp-outline:before{content:\"\\f4ef\"}.ion-social-windows:before{content:\"\\f247\"}.ion-social-windows-outline:before{content:\"\\f246\"}.ion-social-wordpress:before{content:\"\\f249\"}.ion-social-wordpress-outline:before{content:\"\\f248\"}.ion-social-yahoo:before{content:\"\\f24b\"}.ion-social-yahoo-outline:before{content:\"\\f24a\"}.ion-social-yen:before{content:\"\\f4f2\"}.ion-social-yen-outline:before{content:\"\\f4f1\"}.ion-social-youtube:before{content:\"\\f24d\"}.ion-social-youtube-outline:before{content:\"\\f24c\"}.ion-soup-can:before{content:\"\\f4f4\"}.ion-soup-can-outline:before{content:\"\\f4f3\"}.ion-speakerphone:before{content:\"\\f2b2\"}.ion-speedometer:before{content:\"\\f2b3\"}.ion-spoon:before{content:\"\\f2b4\"}.ion-star:before{content:\"\\f24e\"}.ion-stats-bars:before{content:\"\\f2b5\"}.ion-steam:before{content:\"\\f30b\"}.ion-stop:before{content:\"\\f24f\"}.ion-thermometer:before{content:\"\\f2b6\"}.ion-thumbsdown:before{content:\"\\f250\"}.ion-thumbsup:before{content:\"\\f251\"}.ion-toggle:before{content:\"\\f355\"}.ion-toggle-filled:before{content:\"\\f354\"}.ion-transgender:before{content:\"\\f4f5\"}.ion-trash-a:before{content:\"\\f252\"}.ion-trash-b:before{content:\"\\f253\"}.ion-trophy:before{content:\"\\f356\"}.ion-tshirt:before{content:\"\\f4f7\"}.ion-tshirt-outline:before{content:\"\\f4f6\"}.ion-umbrella:before{content:\"\\f2b7\"}.ion-university:before{content:\"\\f357\"}.ion-unlocked:before{content:\"\\f254\"}.ion-upload:before{content:\"\\f255\"}.ion-usb:before{content:\"\\f2b8\"}.ion-videocamera:before{content:\"\\f256\"}.ion-volume-high:before{content:\"\\f257\"}.ion-volume-low:before{content:\"\\f258\"}.ion-volume-medium:before{content:\"\\f259\"}.ion-volume-mute:before{content:\"\\f25a\"}.ion-wand:before{content:\"\\f358\"}.ion-waterdrop:before{content:\"\\f25b\"}.ion-wifi:before{content:\"\\f25c\"}.ion-wineglass:before{content:\"\\f2b9\"}.ion-woman:before{content:\"\\f25d\"}.ion-wrench:before{content:\"\\f2ba\"}.ion-xbox:before{content:\"\\f30c\"}*/\n\n/*!\n* Template Name: Flora- Easy To Use App Landing Page Template\n* Author: bonefishcode\n*/\n/*\n * table of contents\n * --------------------------------------------------\n * import\n * reset\n * helper class\n * base\n * element\n * site loader\n * site header (nav)\n * site background\n * site common\n * home section\n * feature section\n * why us section\n * what we do section\n * contact section\n * footer\n * custom animation\n */\n/*\n * color code, [search and replace] with text editor\n * --------------------------------------------------\n *\n * loader, nav background\n * #1e1f25\n *\n * home overlay\n * rgba(30, 31, 37, 0.65)\n *\n * download overlay\n * rgba(30, 31, 37, 0.65)\n *\n * theme color\n * #50d2c2\n * #34cab8 [hover]\n *\n */\n/**\n * import\n * --------------------------------------------------\n */\n@import url(\"http://fonts.googleapis.com/css?family=Lora:400,700,400italic,700italic\");\n@import url(\"http://fonts.googleapis.com/css?family=Source+Sans+Pro:200,300,400,600,700,900,200italic,300italic,400italic,600italic,700italic,900italic\");\n/**\n * reset\n * --------------------------------------------------\n */\nli > ol,\nli > ul {\n    margin-bottom: 0;\n}\n\nimg {\n    vertical-align: middle;\n    max-width: 100%;\n    font-style: italic;\n}\n\n.gm-style img,\nimg[width],\nimg[height] {\n    max-width: none;\n}\n\n.page-header {\n    margin: 0;\n    border-bottom: 0;\n    padding-bottom: 0;\n}\n\n/**\n * helper class\n * --------------------------------------------------\n */\n/* float */\n.clearfix:before,\n.primary-menu-list:before,\n.icon-menu-list:before,\n.double-device:before,\n.clearfix:after, .primary-menu-list:after, .icon-menu-list:after, .double-device:after {\n    content: \" \";\n    display: table;\n}\n\n.clearfix:after, .primary-menu-list:after, .icon-menu-list:after, .double-device:after {\n    clear: both;\n}\n\n@media (max-width: 767px) {\n    .float-right-xs-max {\n        float: right !important;\n    }\n\n    .float-left-xs-max {\n        float: left !important;\n    }\n}\n\n@media (max-width: 991px) {\n    .float-right-sm-max {\n        float: right !important;\n    }\n\n    .float-left-sm-max {\n        float: left !important;\n    }\n}\n\n@media (max-width: 1199px) {\n    .float-right-md-max {\n        float: right !important;\n    }\n\n    .float-left-md-max {\n        float: left !important;\n    }\n}\n\n@media (min-width: 480px) {\n    .float-right-xs-min {\n        float: right !important;\n    }\n\n    .float-left-xs-min {\n        float: left !important;\n    }\n}\n\n@media (min-width: 768px) {\n    .float-right-sm-min {\n        float: right !important;\n    }\n\n    .float-left-sm-min {\n        float: left !important;\n    }\n}\n\n@media (min-width: 992px) {\n    .float-right-md-min {\n        float: right !important;\n    }\n\n    .float-left-md-min {\n        float: left !important;\n    }\n}\n\n.float-right {\n    float: right !important;\n}\n\n.float-left {\n    float: left !important;\n}\n\n/* transition */\n.transition-base, a, .btn, .site-header, .site-header-brand, .site-header-nav, .feature-icon, .feature-icon:before {\n    -webkit-transition: 0.3s ease-in-out;\n    -o-transition: 0.3s ease-in-out;\n    transition: 0.3s ease-in-out;\n}\n\n/* hardware acceleration */\n.ha-3d, [data-animation-in], .site-loader._multi-circle-line, .site-loader._multi-circle-line .site-loader-spinner, .site-header, .site-header-brand, .site-header-nav, .site-bg, #videoPlayer, .site-bg-effect, .feature-icon, .feature-icon:before {\n    -webkit-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0);\n    -webkit-backface-visibility: hidden;\n    backface-visibility: hidden;\n    -webkit-perspective: 1000;\n    perspective: 1000;\n}\n\n.ha-z {\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n    -webkit-backface-visibility: hidden;\n    backface-visibility: hidden;\n    -webkit-perspective: 1000;\n    perspective: 1000;\n}\n\n/* position */\n.relative {\n    position: relative;\n}\n\n.layer, .site-loader._multi-circle-line, .site-overlay, .m-nav, .site-bg, .site-bg-img,\n.site-bg-video,\n.site-bg-overlay,\n.site-bg-effect,\n.site-bg-canvas, .cloud, .section-overlay {\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n}\n\n/* display */\n.hide {\n    display: none;\n}\n\n.tb, .m-nav-tb {\n    display: table;\n    table-layout: fixed;\n    width: 100%;\n    height: 100%;\n}\n\n.tb-cell, .m-nav-tb-cell {\n    display: table-cell;\n    vertical-align: middle;\n}\n\n.overflow-hidden {\n    overflow: hidden;\n}\n\n.scroll-block {\n    -ms-overflow-style: scrollbar;\n    overflow-x: hidden;\n    overflow-y: auto;\n}\n\n/* margin and padding */\n.m-t-5 {\n    margin-top: 5px;\n}\n\n.m-r-5 {\n    margin-right: 5px;\n}\n\n.m-b-5 {\n    margin-bottom: 5px;\n}\n\n.m-l-5 {\n    margin-left: 5px;\n}\n\n.p-t-5 {\n    padding-top: 5px;\n}\n\n.p-r-5 {\n    padding-right: 5px;\n}\n\n.p-b-5 {\n    padding-bottom: 5px;\n}\n\n.p-l-5 {\n    padding-left: 5px;\n}\n\n.m-t-10 {\n    margin-top: 10px;\n}\n\n.m-r-10 {\n    margin-right: 10px;\n}\n\n.m-b-10 {\n    margin-bottom: 10px;\n}\n\n.m-l-10 {\n    margin-left: 10px;\n}\n\n.p-t-10 {\n    padding-top: 10px;\n}\n\n.p-r-10 {\n    padding-right: 10px;\n}\n\n.p-b-10 {\n    padding-bottom: 10px;\n}\n\n.p-l-10 {\n    padding-left: 10px;\n}\n\n.m-t-15 {\n    margin-top: 15px;\n}\n\n.m-r-15 {\n    margin-right: 15px;\n}\n\n.m-b-15 {\n    margin-bottom: 15px;\n}\n\n.m-l-15 {\n    margin-left: 15px;\n}\n\n.p-t-15 {\n    padding-top: 15px;\n}\n\n.p-r-15 {\n    padding-right: 15px;\n}\n\n.p-b-15 {\n    padding-bottom: 15px;\n}\n\n.p-l-15 {\n    padding-left: 15px;\n}\n\n.m-t-20 {\n    margin-top: 20px;\n}\n\n.m-r-20 {\n    margin-right: 20px;\n}\n\n.m-b-20 {\n    margin-bottom: 20px;\n}\n\n.m-l-20 {\n    margin-left: 20px;\n}\n\n.p-t-20 {\n    padding-top: 20px;\n}\n\n.p-r-20 {\n    padding-right: 20px;\n}\n\n.p-b-20 {\n    padding-bottom: 20px;\n}\n\n.p-l-20 {\n    padding-left: 20px;\n}\n\n.m-t-25 {\n    margin-top: 25px;\n}\n\n.m-r-25 {\n    margin-right: 25px;\n}\n\n.m-b-25 {\n    margin-bottom: 25px;\n}\n\n.m-l-25 {\n    margin-left: 25px;\n}\n\n.p-t-25 {\n    padding-top: 25px;\n}\n\n.p-r-25 {\n    padding-right: 25px;\n}\n\n.p-b-25 {\n    padding-bottom: 25px;\n}\n\n.p-l-25 {\n    padding-left: 25px;\n}\n\n.m-t-30 {\n    margin-top: 30px;\n}\n\n.m-r-30 {\n    margin-right: 30px;\n}\n\n.m-b-30 {\n    margin-bottom: 30px;\n}\n\n.m-l-30 {\n    margin-left: 30px;\n}\n\n.p-t-30 {\n    padding-top: 30px;\n}\n\n.p-r-30 {\n    padding-right: 30px;\n}\n\n.p-b-30 {\n    padding-bottom: 30px;\n}\n\n.p-l-30 {\n    padding-left: 30px;\n}\n\n.m-t-35 {\n    margin-top: 35px;\n}\n\n.m-r-35 {\n    margin-right: 35px;\n}\n\n.m-b-35 {\n    margin-bottom: 35px;\n}\n\n.m-l-35 {\n    margin-left: 35px;\n}\n\n.p-t-35 {\n    padding-top: 35px;\n}\n\n.p-r-35 {\n    padding-right: 35px;\n}\n\n.p-b-35 {\n    padding-bottom: 35px;\n}\n\n.p-l-35 {\n    padding-left: 35px;\n}\n\n.m-t-40 {\n    margin-top: 40px;\n}\n\n.m-r-40 {\n    margin-right: 40px;\n}\n\n.m-b-40 {\n    margin-bottom: 40px;\n}\n\n.m-l-40 {\n    margin-left: 40px;\n}\n\n.p-t-40 {\n    padding-top: 40px;\n}\n\n.p-r-40 {\n    padding-right: 40px;\n}\n\n.p-b-40 {\n    padding-bottom: 40px;\n}\n\n.p-l-40 {\n    padding-left: 40px;\n}\n\n.m-t-space {\n    margin-top: 50px;\n}\n\n.m-t-space p {\n    margin-top: 50px;\n    font-size: 24px;\n    margin-bottom: 20px;\n}\n\n.m-t-space ul {\n    font-size: 20px;\n    line-height: 50px;\n    padding-left: 60px;\n\n}\n\n.m-r-space {\n    margin-right: 20px;\n}\n\n.m-b-space {\n    margin-bottom: 20px;\n}\n\n.m-l-space {\n    margin-left: 20px;\n}\n\n.p-t-space {\n    padding-top: 20px;\n}\n\n.p-r-space {\n    padding-right: 20px;\n}\n\n.p-b-space {\n    padding-bottom: 20px;\n}\n\n.p-l-space {\n    padding-left: 20px;\n}\n\n@media (min-width: 992px) {\n    .m-t-space {\n        margin-top: 30px !important;\n    }\n\n    .m-r-space {\n        margin-right: 30px !important;\n    }\n\n    .m-b-space {\n        margin-bottom: 30px !important;\n    }\n\n    .m-l-space {\n        margin-left: 30px !important;\n    }\n\n    .p-t-space {\n        padding-top: 30px !important;\n    }\n\n    .p-r-space {\n        padding-right: 30px !important;\n    }\n\n    .p-b-space {\n        padding-bottom: 30px !important;\n    }\n\n    .p-l-space {\n        padding-left: 30px !important;\n    }\n}\n\n.section-title {\n    font-size: 52px;\n    font-family: \"Raleway Bold\";\n}\n\n@media (max-width: 769px) {\n    .section-title {\n        font-size: 40px;\n    }\n}\n\n/* border */\n.border-radius-base, .btn, .form-theme .form-control {\n    -webkit-border-top-left-radius: 4px;\n    border-top-left-radius: 4px;\n    -webkit-border-top-right-radius: 4px;\n    border-top-right-radius: 4px;\n    -webkit-border-bottom-left-radius: 4px;\n    border-bottom-left-radius: 4px;\n    -webkit-border-bottom-right-radius: 4px;\n    border-bottom-right-radius: 4px;\n}\n\n/* align */\n.text-align-right {\n    text-align: right;\n}\n\n.text-align-left {\n    text-align: left;\n}\n\n.text-align-center {\n    text-align: center;\n}\n\n/* list */\n.list-reset, .primary-menu-list, .icon-menu-list, .m-primary-menu-list, .feature-list, .selling-point-list, .service-list, .contact-info-list, .social-list {\n    margin-bottom: 30px !important;\n    padding-left: 0;\n    list-style: none;\n    color: white;\n}\n\n/* color */\n.color {\n    color: #008094;\n}\n\n.text-light h1, .text-light h2, .text-light h3, .text-light h4, .text-light h5, .text-light h6, .text-light p {\n    color: #fff;\n}\n\n/**\n * base\n * --------------------------------------------------\n */\nbody, .section-subtitle {\n    /*font-family: \"Lora\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;*/\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6, .btn, .primary-menu-item > a, .m-primary-menu-item > a {\n    /*font-family: \"Source Sans Pro\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;*/\n}\n\nbody {\n    line-height: 1.9;\n    font-weight: 400;\n    text-transform: none;\n    letter-spacing: 0;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n    line-height: 1.2;\n    font-weight: 700;\n    /*text-transform: capitalize;*/\n    letter-spacing: 0;\n}\n\nhtml {\n    -webkit-tap-highlight-color: transparent;\n}\n\nbody {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    position: relative;\n    overflow-x: hidden;\n    background-color: #fff;\n    font-size: 18px;\n    color: #333;\n}\n\n@media (min-width: 992px) {\n    body {\n        font-size: 18px;\n    }\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n    margin: 0;\n    color: #333;\n}\n\nh1 {\n    font-size: 36px;\n}\n\n@media (min-width: 768px) {\n    h1 {\n        line-height: 1.1;\n        font-size: 50px;\n    }\n}\n\n@media (min-width: 992px) {\n    h1 {\n        line-height: 1.05;\n        font-size: 64px;\n    }\n}\n\nh2 {\n    font-size: 36px;\n}\n\n@media (min-width: 992px) {\n    h2 {\n        font-size: 40px;\n    }\n}\n\nh3 {\n    font-size: 22px;\n}\n\n@media (min-width: 992px) {\n    h3 {\n        font-size: 24px;\n    }\n}\n\nh4 {\n    font-size: 20px;\n}\n\n@media (min-width: 768px) {\n    h4 {\n        font-size: 22px;\n    }\n}\n\nh5 {\n    font-size: 18px;\n}\n\n@media (min-width: 768px) {\n    h5 {\n        font-size: 18px;\n    }\n}\n\nh6,\n.small {\n    font-size: 12px;\n    letter-spacing: 1.5px;\n}\n\np,\nol,\nul,\nblockquote,\npre {\n    margin-bottom: 20px;\n}\n\np:last-child,\nol:last-child,\nul:last-child,\nblockquote:last-child,\npre:last-child {\n    margin-bottom: 0;\n}\n\n@media (min-width: 992px) {\n    p,\n    ol,\n    ul,\n    blockquote,\n    pre {\n        margin-bottom: 30px;\n    }\n}\n\na {\n    color: #008094;\n}\n\na:focus {\n    outline: 0;\n}\n\na:focus,\na:hover {\n    text-decoration: none;\n    color: #34cab8;\n}\n\n.thin {\n    font-weight: 300;\n}\n\n.normal {\n    font-weight: 400;\n}\n\n.bold {\n    font-weight: 700;\n}\n\ni {\n    display: inline-block;\n    letter-spacing: 0;\n}\n\n/* animate */\n.velocity-animating {\n    -webkit-transition: none !important;\n    -o-transition: none !important;\n    transition: none !important;\n}\n\n/*\n * element\n * --------------------------------------------------\n */\n/*\n * button\n * -------------------------\n */\n.btn {\n    line-height: 1 !important;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 1.5px;\n}\n\n.btn {\n    position: relative;\n    display: inline-block;\n    overflow: hidden;\n    vertical-align: middle;\n    height: auto !important;\n    border: 1px solid transparent;\n    padding: 20px 28.5px 20px 30px;\n    background-image: none;\n    font-size: 14px;\n    text-align: center;\n    white-space: nowrap;\n    -ms-touch-action: manipulation;\n    touch-action: manipulation;\n    cursor: pointer;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n}\n\n.btn:active {\n    -webkit-box-shadow: none;\n    box-shadow: none;\n}\n\n.btn:active:focus {\n    outline: 0;\n}\n\n.btn:focus {\n    outline: 0;\n}\n\n.btn span {\n    display: inline-block;\n}\n\n.btn span + i {\n    -webkit-transform: scale(1.5);\n    -ms-transform: scale(1.5);\n    -o-transform: scale(1.5);\n    transform: scale(1.5);\n    line-height: 0;\n    margin-left: 5px;\n}\n\n@media (min-width: 992px) {\n    .btn {\n        padding: 25px 38.5px 25px 40px;\n    }\n}\n\n.btn._base {\n    border-color: #333;\n    color: #333;\n}\n\n.btn._base:active,\n.btn._base:active:focus,\n.btn._base:focus,\n.btn._base:hover {\n    background-color: #333;\n    color: #fff;\n}\n\n.btn._theme {\n    border-color: #008094;\n    background-color: #008094;\n    color: #fff;\n}\n\n.btn._theme:active,\n.btn._theme:active:focus,\n.btn._theme:focus,\n.btn._theme:hover {\n    border-color: #34cab8;\n    background-color: #34cab8;\n    color: #fff;\n}\n\n.btn._circle {\n    -webkit-border-top-left-radius: 50px;\n    border-top-left-radius: 50px;\n    -webkit-border-top-right-radius: 50px;\n    border-top-right-radius: 50px;\n    -webkit-border-bottom-left-radius: 50px;\n    border-bottom-left-radius: 50px;\n    -webkit-border-bottom-right-radius: 50px;\n    border-bottom-right-radius: 50px;\n}\n\n.btn-container {\n    margin-top: 10px;\n}\n\n.btn-container .btn {\n    margin: 10px 5px 0;\n}\n\n@media (min-width: 992px) {\n    .btn-container {\n        margin-top: 20px;\n    }\n}\n\n/*\n * form\n * -------------------------\n */\n/* form notify */\n.form-notify {\n    margin-top: 20px;\n}\n\n/* form theme */\n.form-theme {\n    position: relative;\n}\n\n.form-theme .required:after {\n    position: absolute;\n    top: 10px;\n    right: 0;\n    content: \"*\";\n    line-height: 1;\n    /* font-family: Arial, sans-serif;*/\n    font-size: 20px;\n    font-weight: 700;\n    color: #ed485c;\n}\n\n.form-theme .form-group {\n    position: relative;\n    margin-bottom: 20px;\n}\n\n.form-theme .form-group.error .form-control {\n    border-color: #ed485c;\n}\n\n@media (min-width: 992px) {\n    .form-theme .form-group {\n        margin-bottom: 30px;\n    }\n}\n\n.form-theme .form-control {\n    height: 56px;\n    padding: 17px 20px;\n    border-color: transparent;\n    background-color: rgba(0, 0, 0, 0.05);\n    -webkit-box-shadow: none;\n    box-shadow: none;\n    font-size: 18px;\n}\n\n.form-theme textarea.form-control {\n    height: auto;\n}\n\n/**\n * site loader\n * --------------------------------------------------\n */\n/*\n\n*/\n.site-loader._multi-circle-line {\n    position: fixed;\n    z-index: 900;\n}\n\n.site-loader._multi-circle-line .site-loader-spinner {\n    -webkit-animation: spin 1.5s infinite linear;\n    -o-animation: spin 1.5s infinite linear;\n    animation: spin 1.5s infinite linear;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    z-index: 1;\n    width: 150px;\n    height: 150px;\n    margin-top: -75px;\n    margin-left: -75px;\n    border: 3px solid transparent;\n    border-top-color: rgba(80, 210, 194, 0.5);\n    -webkit-border-radius: 50%;\n    border-radius: 50%;\n}\n\n.site-loader._multi-circle-line .site-loader-spinner:before,\n.site-loader._multi-circle-line .site-loader-spinner:after {\n    position: absolute;\n    content: \"\";\n    -webkit-border-radius: 50%;\n    border-radius: 50%;\n}\n\n.site-loader._multi-circle-line .site-loader-spinner:before {\n    -webkit-animation: spin 2.5s infinite linear;\n    -o-animation: spin 2.5s infinite linear;\n    animation: spin 2.5s infinite linear;\n    top: 5px;\n    right: 5px;\n    bottom: 5px;\n    left: 5px;\n    border: 3px solid transparent;\n    border-top-color: rgba(80, 210, 194, 0.4);\n}\n\n.site-loader._multi-circle-line .site-loader-spinner:after {\n    -webkit-animation: spin 1.5s infinite linear;\n    -o-animation: spin 1.5s infinite linear;\n    animation: spin 1.5s infinite linear;\n    top: 15px;\n    right: 15px;\n    bottom: 15px;\n    left: 15px;\n    border: 3px solid transparent;\n    border-top-color: rgba(80, 210, 194, 0.3);\n}\n\n@-webkit-keyframes spin {\n    0% {\n        -webkit-transform: rotate(0);\n        transform: rotate(0);\n    }\n    100% {\n        -webkit-transform: rotate(360deg);\n        transform: rotate(360deg);\n    }\n}\n\n@-o-keyframes spin {\n    0% {\n        -o-transform: rotate(0);\n        transform: rotate(0);\n    }\n    100% {\n        -o-transform: rotate(360deg);\n        transform: rotate(360deg);\n    }\n}\n\n@keyframes spin {\n    0% {\n        -webkit-transform: rotate(0);\n        -o-transform: rotate(0);\n        transform: rotate(0);\n    }\n    100% {\n        -webkit-transform: rotate(360deg);\n        -o-transform: rotate(360deg);\n        transform: rotate(360deg);\n    }\n}\n\n.site-loader._multi-circle-line .site-loader-section {\n    position: fixed;\n    top: 0;\n    width: 51%;\n    height: 100%;\n    background-color: #1e1f25;\n}\n\n.site-loader._multi-circle-line .site-loader-section._left {\n    left: 0;\n}\n\n.site-loader._multi-circle-line .site-loader-section._right {\n    right: 0;\n}\n\n.is-loaded2 .site-loader-container {\n    -webkit-transition: all 0.3s 1s ease-out;\n    -o-transition: all 0.3s 1s ease-out;\n    transition: all 0.3s 1s ease-out;\n    visibility: hidden;\n}\n\n.is-loaded2 .site-loader-spinner {\n    -webkit-transition: all 0.3s ease-out;\n    -o-transition: all 0.3s ease-out;\n    transition: all 0.3s ease-out;\n    opacity: 0;\n}\n\n.is-loaded2 .site-loader-section._left {\n    -webkit-transition: all 0.7s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n    -o-transition: all 0.7s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n    transition: all 0.7s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n    -webkit-transform: translateX(-100%);\n    -ms-transform: translateX(-100%);\n    -o-transform: translateX(-100%);\n    transform: translateX(-100%);\n}\n\n.is-loaded2 .site-loader-section._right {\n    -webkit-transition: all 0.7s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n    -o-transition: all 0.7s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n    transition: all 0.7s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n    -webkit-transform: translateX(100%);\n    -ms-transform: translateX(100%);\n    -o-transform: translateX(100%);\n    transform: translateX(100%);\n}\n\n/**\n * header\n * --------------------------------------------------\n */\n.site-header {\n    -webkit-transition-property: background-color;\n    -o-transition-property: background-color;\n    transition-property: background-color;\n    position: fixed;\n    top: 0;\n    right: 0;\n    left: 0;\n    z-index: 800;\n}\n\n.is-scroll .site-header {\n    background-color: #1e1f25;\n}\n\n.site-header .nav > li > a {\n    padding: 0 !important;\n}\n\n.site-header .nav > li > a:focus,\n.site-header .nav > li > a:hover {\n    background-color: transparent;\n}\n\n.site-header-container {\n    position: relative;\n}\n\n.site-header-brand {\n    -webkit-transition-property: margin;\n    -o-transition-property: margin;\n    transition-property: margin;\n    float: left;\n    margin: 8px 0 8px;\n}\n\n@media (min-width: 992px) {\n    .site-header-brand {\n        margin: 22px 0 22px;\n    }\n\n    .is-scroll .site-header-brand {\n        margin: 12px 0 12px;\n    }\n}\n\n.site-header-brand-img {\n    height: 40px;\n}\n\n@media (min-width: 992px) {\n    .site-header-brand-img {\n        height: 56px;\n    }\n}\n\n.site-header-nav {\n    -webkit-transition-property: margin;\n    -o-transition-property: margin;\n    transition-property: margin;\n    float: right;\n    height: 40px;\n    line-height: 40px;\n    margin: 8px 0 8px;\n}\n\n@media (min-width: 992px) {\n    .site-header-nav {\n        height: 56px;\n        line-height: 56px;\n        margin: 22px 0 22px;\n    }\n\n    .is-scroll .site-header-nav {\n        margin: 12px 0 12px;\n    }\n}\n\n.primary-menu {\n    float: left;\n}\n\n@media (max-width: 991px) {\n    .primary-menu {\n        display: none;\n    }\n}\n\n@media (max-width: 991px) {\n    .navbar-toggle {\n        display: inline;\n    }\n}\n\n.primary-menu-item {\n    float: left;\n}\n\n.primary-menu-item:not(:first-child) {\n    margin-left: 30px;\n}\n\n.primary-menu-item > a {\n    -webkit-transition-property: color;\n    -o-transition-property: color;\n    transition-property: color;\n    display: block;\n    height: 40px;\n    line-height: 40px;\n    font-size: 13px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 1.5px;\n    color: #fff;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n}\n\n.primary-menu-item > a:hover {\n    color: #50d2c2;\n    background-color: transparent !important;\n}\n\n.primary-menu-item > a > span {\n    display: inline-block;\n}\n\n@media (min-width: 992px) {\n    .primary-menu-item > a {\n        height: 56px;\n        line-height: 56px;\n    }\n}\n\n.primary-menu-item.active > a {\n    color: #50d2c2;\n}\n\n.primary-menu-item.active > a:hover {\n    color: #34cab8;\n}\n\n.icon-menu {\n    float: left;\n}\n\n.icon-menu-item {\n    float: left;\n    margin-left: 30px;\n}\n\n.icon-menu-item > a {\n    display: block;\n    height: 40px;\n    line-height: 40px;\n    color: #fff;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n}\n\n.icon-menu-item > a:focus,\n.icon-menu-item > a:hover {\n    color: #fff;\n}\n\n.icon-menu-item > a > i {\n    font-size: 25px;\n}\n\n.icon-menu-item > a > i:before {\n    display: block;\n    line-height: inherit;\n}\n\n@media (min-width: 992px) {\n    .icon-menu-item > a {\n        height: 56px;\n        line-height: 56px;\n    }\n}\n\n.audio-toggle {\n    display: none;\n}\n\n.is-audio .audio-toggle,\n.is-mute .audio-toggle {\n    display: block;\n}\n\n.audio-toggle-link {\n    color: #fff;\n}\n\n.audio-toggle-link:hover {\n    color: #fff !important;\n}\n\n.is-mute .audio-toggle-link {\n    color: #999 !important;\n}\n\n.site-overlay {\n    position: fixed;\n    opacity: 0;\n    visibility: hidden;\n    background-color: rgba(30, 31, 37, 0.5);\n}\n\n/* mobile nav */\n.m-nav {\n    position: fixed;\n    z-index: 798;\n    display: none;\n    overflow-x: hidden;\n    overflow-y: scroll;\n    background-color: #1e1f25;\n    text-align: center;\n}\n\n.m-nav .nav > li > a {\n    font-size: 18px;\n    font-weight: 700;\n}\n\n.m-nav .nav > li > a:focus,\n.m-nav .nav > li > a:hover {\n    background-color: transparent;\n}\n\n@media (min-width: 992px) {\n    .m-nav {\n        display: none !important;\n    }\n}\n\n.m-primary-menu-item > a {\n    -webkit-transition-property: color;\n    -o-transition-property: color;\n    transition-property: color;\n    display: block;\n    font-size: 14px;\n    text-transform: uppercase;\n    letter-spacing: 1.5px;\n    color: #fff;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n}\n\n.m-primary-menu-item > a:hover {\n    color: #50d2c2;\n    background-color: transparent !important;\n}\n\n.m-primary-menu-item > a > span {\n    display: inline-block;\n}\n\n.m-primary-menu-item.active > a {\n    color: #50d2c2;\n}\n\n.m-primary-menu-item.active > a:hover {\n    color: #34cab8;\n}\n\n/**\n * site background\n * --------------------------------------------------\n */\n.site-bg {\n    position: absolute;\n    z-index: -1;\n    overflow: hidden;\n}\n\n.site-bg-img,\n.site-bg-video,\n.site-bg-overlay,\n.site-bg-effect,\n.site-bg-canvas {\n    position: absolute;\n}\n\n.site-bg-img {\n    background-repeat: no-repeat;\n    background-position: 50% 50%;\n    background-size: cover;\n}\n\n.is-site-bg-img .site-bg-img {\n    display: block;\n    background-image: url(../img/bg/site-bg-img.jpg);\n}\n\n.is-site-bg-slideshow .site-bg-img {\n    display: block;\n}\n\n.is-site-bg-video .site-bg-img {\n    display: block;\n    background-image: url(../img/bg/site-bg-video.jpg);\n}\n\n.is-site-bg-video-youtube .site-bg-img {\n    display: block;\n    background-image: url(../img/bg/site-bg-video-youtube.jpg);\n}\n\n.is-site-bg-video .site-bg-video,\n.is-site-bg-video-youtube .site-bg-video {\n    display: block;\n}\n\n#videoPlayer {\n    -webkit-transform: translate(-50%, -50%);\n    -ms-transform: translate(-50%, -50%);\n    -o-transform: translate(-50%, -50%);\n    transform: translate(-50%, -50%);\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    display: block;\n    min-width: 100%;\n    min-height: 100%;\n    width: auto;\n    height: auto;\n}\n\n.site-bg-overlay {\n    position: absolute;\n    background-color: rgba(30, 31, 37, 0.65);\n}\n\n.is-site-bg-cloud .site-bg-effect {\n    display: block;\n}\n\n.ie9 .site-bg-effect {\n    background-image: url(#);\n}\n\n.cloud {\n    position: absolute;\n    background-repeat: no-repeat;\n    background-position: center center;\n    background-size: 100%;\n}\n\n.site-bg-canvas {\n    display: none;\n}\n\n.is-site-bg-star .site-bg-canvas {\n    display: block;\n}\n\n/* cloud */\n.cloud-01 {\n    background-image: url(../img/bg/cloud-01.png);\n}\n\n.cloud-02 {\n    background-image: url(../img/bg/cloud-02.png);\n}\n\n.cloud-03 {\n    background-image: url(../img/bg/cloud-03.png);\n}\n\n/**\n * content common\n * --------------------------------------------------\n */\n.animated {\n    opacity: 0;\n    visibility: hidden;\n}\n\n.ie9 .animated,\n.is-mobile .animated {\n    opacity: 1;\n    visibility: visible;\n}\n\n#feature,\n#app-brief-1,\n#app-brief-2,\n#download,\n#funcionamiento,\n#funcionamiento2,\n#hardware,\n#software,\n#empresa,\n#contacto,\n#variables,\n#contact {\n    padding: 65px 0;\n    min-height: 100vh;\n}\n\n@media (min-width: 992px) {\n    #feature,\n    #app-brief-1,\n    #app-brief-2,\n    #funcionamiento,\n    #funcionamiento2,\n    #hardware,\n    #software,\n    #empresa,\n    #contacto,\n    #variables,\n    #download,\n    #contact {\n        padding: 130px 0;\n    }\n}\n\n.section {\n    position: relative;\n    z-index: 1;\n    overflow: hidden;\n}\n\n.section-overlay {\n    position: absolute;\n}\n\n@media (max-width: 991px) {\n    [data-equal-height] {\n        height: auto !important;\n    }\n}\n\n@media (min-width: 992px) {\n    [data-equal-height] {\n        display: table;\n    }\n}\n\n@media (min-width: 992px) {\n    .equal-height-cell {\n        display: table-cell;\n        vertical-align: middle;\n    }\n}\n\n.section-subtitle {\n    font-size: 13px;\n    font-style: italic;\n    text-transform: uppercase;\n    letter-spacing: 6px;\n    margin-bottom: 5px;\n}\n\n.double-device {\n    position: relative;\n    width: 100%;\n    max-width: 300px;\n    margin: 0 auto;\n}\n\n@media (max-width: 991px) {\n    .double-device {\n        margin-top: 65px;\n    }\n}\n\n@media (min-width: 768px) {\n    .double-device {\n        max-width: 350px;\n    }\n}\n\n@media (min-width: 992px) {\n    .double-device {\n        max-width: 440px;\n    }\n\n    .double-device._right {\n        float: right;\n    }\n\n    .double-device._left {\n        float: left;\n    }\n\n    .double-device._bottom {\n        position: absolute;\n        bottom: -250px;\n    }\n\n    .double-device._bottom._left {\n        left: 15px;\n    }\n}\n\n.double-device-front {\n    position: relative;\n    float: left;\n    z-index: 1;\n}\n\n.is-desktop .double-device-front {\n    -webkit-filter: drop-shadow(0 0 8px rgba(0, 0, 0, 0.1));\n    filter: drop-shadow(0 0 8px rgba(0, 0, 0, 0.1));\n}\n\n@media (max-width: 991px) {\n    .double-device-front {\n        width: 60%;\n    }\n}\n\n.double-device-back {\n    position: absolute;\n    top: 50%;\n    right: 0px;\n    height: 90%;\n}\n\n.is-desktop .double-device-back {\n    -webkit-filter: drop-shadow(0 0 8px rgba(0, 0, 0, 0.1));\n    filter: drop-shadow(0 0 8px rgba(0, 0, 0, 0.1));\n}\n\n.ie9 .double-device-back,\n.is-mobile .double-device-back {\n    -webkit-transform: translate(0, -50%);\n    -ms-transform: translate(0, -50%);\n    -o-transform: translate(0, -50%);\n    transform: translate(0, -50%);\n}\n\n@media (max-width: 991px) {\n    .double-device-back {\n        width: 250px;\n    }\n}\n\n.max-width-640 {\n    max-width: 640px;\n    margin: auto;\n}\n\n.max-width-960 {\n    max-width: 960px;\n    margin: auto;\n}\n\n/**\n * home\n * --------------------------------------------------\n */\n#home {\n    position: relative;\n    padding: 108px 0 60px;\n}\n\n@media (min-width: 768px) {\n    #home {\n        padding: 138px 0 90px;\n    }\n}\n\n@media (min-width: 992px) {\n    #home {\n        padding: 198px 0 120px;\n    }\n}\n\n/**\n * feature\n * --------------------------------------------------\n */\n#variables, #software {\n    background-color: #fff;\n}\n\n.feature-box {\n    position: relative;\n    margin-top: 40px;\n    padding: 0 0 0 94px;\n}\n\n@media (min-width: 992px) {\n    .feature-box {\n        margin-top: 60px;\n    }\n}\n\n.feature-icon {\n    -webkit-border-top-left-radius: 50%;\n    border-top-left-radius: 50%;\n    -webkit-border-top-right-radius: 50%;\n    border-top-right-radius: 50%;\n    -webkit-border-bottom-left-radius: 50%;\n    border-bottom-left-radius: 50%;\n    -webkit-border-bottom-right-radius: 50%;\n    border-bottom-right-radius: 50%;\n    -webkit-transition-property: -webkit-transform;\n    -o-transition-property: -o-transform;\n    transition-property: transform;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 74px;\n    height: 74px;\n    border: 2px solid #008094;\n    padding: 3px;\n}\n\n.feature-icon:before {\n    -webkit-transition-property: -webkit-transform opacity;\n    -o-transition-property: -o-transform opacity;\n    transition-property: transform opacity;\n    position: absolute;\n    bottom: -30px;\n    left: 5%;\n    content: \"\";\n    height: 10px;\n    width: 90%;\n    background: -webkit-radial-gradient(center, ellipse, rgba(0, 0, 0, 0.35) 0%, transparent 80%);\n    background: -o-radial-gradient(center, ellipse, rgba(0, 0, 0, 0.35) 0%, transparent 80%);\n    background: radial-gradient(ellipse at center, rgba(0, 0, 0, 0.35) 0%, transparent 80%);\n    opacity: 0;\n}\n\n.feature-icon > i {\n    -webkit-border-top-left-radius: 50%;\n    border-top-left-radius: 50%;\n    -webkit-border-top-right-radius: 50%;\n    border-top-right-radius: 50%;\n    -webkit-border-bottom-left-radius: 50%;\n    border-bottom-left-radius: 50%;\n    -webkit-border-bottom-right-radius: 50%;\n    border-bottom-right-radius: 50%;\n    display: block;\n    width: 64px;\n    height: 64px;\n    line-height: 64px;\n    background-color: #008094;\n    /*background-image: url(./assets/img/item/svg-mask.svg);*/\n    background-size: 100% 100%;\n    font-size: 36px;\n    text-align: center;\n    color: #fff;\n}\n\n.feature-box:hover .feature-icon {\n    -webkit-transform: translateY(-5px);\n    -ms-transform: translateY(-5px);\n    -o-transform: translateY(-5px);\n    transform: translateY(-5px);\n}\n\n.feature-box:hover .feature-icon:before {\n    opacity: 1;\n    -webkit-transform: translateY(5px);\n    -ms-transform: translateY(5px);\n    -o-transform: translateY(5px);\n    transform: translateY(5px);\n}\n\n.feature-title {\n    font-family: \"Raleway Bold\";\n    font-size: 20px;\n    min-height: 50px;\n    margin-top: 6px !important;\n}\n\n.feature-content {\n    margin-top: 7px !important;\n    font-size: 16px !important;\n    color: black;\n}\n\n/**\n * app brief 1 (why us section)\n * --------------------------------------------------\n */\n#funcionamiento {\n    background-color: #f5f5f5;\n}\n\n.selling-point-item > i {\n    -webkit-transform: translateY(2px);\n    -ms-transform: translateY(2px);\n    -o-transform: translateY(2px);\n    transform: translateY(2px);\n    position: relative;\n    margin-right: 1em;\n    font-size: 24px;\n    color: #008094;\n}\n\n/**\n * app brief 2 (what we do section)\n * --------------------------------------------------\n */\n#funcionamiento2, #empresa {\n    background-color: #fafafa;\n}\n\n@media (min-width: 992px) {\n    .service {\n        margin-top: 50px;\n    }\n}\n\n.service-icon {\n    line-height: 44px;\n    font-size: 44px;\n    color: #50d2c2;\n}\n\n@media (max-width: 991px) {\n    .service-icon {\n        margin-top: 20px;\n    }\n}\n\n.service-title {\n    margin-top: 10px;\n    font-weight: 400;\n    color: #333;\n}\n\n/**\n * download\n * --------------------------------------------------\n */\n#hardware {\n    position: relative;\n    background-image: url(\"../../img/landingPage/circuito.jpg\");\n    background-repeat: no-repeat;\n    background-position: 50% 50%;\n    background-size: cover;\n}\n\n#hardware .section-overlay {\n    background-color: rgba(30, 31, 37, 0.65);\n}\n\n@media (max-width: 991px) {\n    #hardware {\n        padding-bottom: 0;\n    }\n\n    #hardware .double-device {\n        -webkit-transform: translateY(100px);\n        -ms-transform: translateY(100px);\n        -o-transform: translateY(100px);\n        transform: translateY(100px);\n        margin-top: -35px;\n    }\n}\n\n/**\n * contact\n * --------------------------------------------------\n */\n#contact {\n    background-color: #fff;\n}\n\n.contact-info {\n    margin-top: 20px !important;\n}\n\n.contact-info-item {\n    margin-top: 40px;\n}\n\n.contact-info-icon {\n    line-height: 40px;\n    font-size: 40px;\n}\n\n.contact-info-title {\n    margin: 15px 0 5px;\n}\n\n#contactForm {\n    margin-top: 40px;\n}\n\n@media (min-width: 992px) {\n    #contactForm {\n        margin-top: 60px;\n    }\n}\n\n/**\n * footer\n * --------------------------------------------------\n */\n.site-footer {\n    position: relative;\n    z-index: 1;\n    overflow: hidden;\n    padding: 65px 0;\n    background-color: #1e1f25;\n}\n\n@media (min-width: 992px) {\n    .site-footer {\n        padding: 90px 0;\n    }\n}\n\n.site-footer-brand-img {\n    height: 40px;\n}\n\n@media (min-width: 992px) {\n    .site-footer-brand-img {\n        height: 56px;\n    }\n}\n\n.copyright {\n    color: #999 !important;\n}\n\n.social-item {\n    display: inline-block;\n}\n\n.social-item a {\n    color: #999;\n}\n\n.social-item a:focus,\n.social-item a:hover {\n    color: #50d2c2;\n}\n\n.social-item i {\n    font-size: 30px;\n    margin: 10px 15px;\n}\n\n/**\n * custom animating\n * --------------------------------------------------\n */\n.fadeInLeftScale90 {\n    -webkit-animation-name: fadeInLeftScale90;\n    -o-animation-name: fadeInLeftScale90;\n    animation-name: fadeInLeftScale90;\n}\n\n@media (min-width: 768px) {\n    @-webkit-keyframes fadeInLeftScale90 {\n        0% {\n            opacity: 0;\n            -webkit-transform: translate(-30%, -50%);\n            transform: translate(-30%, -50%);\n        }\n        100% {\n            opacity: 1;\n            -webkit-transform: translate(0, -50%);\n            transform: translate(0, -50%);\n        }\n    }\n\n    @-o-keyframes fadeInLeftScale90 {\n        0% {\n            opacity: 0;\n            -o-transform: translate(-30%, -50%);\n            transform: translate(-30%, -50%);\n        }\n        100% {\n            opacity: 1;\n            -o-transform: translate(0, -50%);\n            transform: translate(0, -50%);\n        }\n    }\n\n    @keyframes fadeInLeftScale90 {\n        0% {\n            opacity: 0;\n            -webkit-transform: translate(-30%, -50%);\n            -o-transform: translate(-30%, -50%);\n            transform: translate(-30%, -50%);\n        }\n        100% {\n            opacity: 1;\n            -webkit-transform: translate(0, -50%);\n            -o-transform: translate(0, -50%);\n            transform: translate(0, -50%);\n        }\n    }\n\n    .is-desktop .fadeInUpScale90 {\n        -webkit-animation-name: fadeInUpScale90;\n        -o-animation-name: fadeInUpScale90;\n        animation-name: fadeInUpScale90;\n    }\n\n    @-webkit-keyframes fadeInUpScale90 {\n        0% {\n            opacity: 0;\n            -webkit-transform: translateY(100%);\n            transform: translateY(100%);\n        }\n        100% {\n            opacity: 1;\n            -webkit-transform: translateY(-40%);\n            transform: translateY(-40%);\n        }\n    }\n\n    @-o-keyframes fadeInUpScale90 {\n        0% {\n            opacity: 0;\n            -o-transform: translateY(100%);\n            transform: translateY(100%);\n        }\n        100% {\n            opacity: 1;\n            -o-transform: translateY(-40%);\n            transform: translateY(-40%);\n        }\n    }\n\n    @keyframes fadeInUpScale90 {\n        0% {\n            opacity: 0;\n            -webkit-transform: translateY(100%);\n            -o-transform: translateY(100%);\n            transform: translateY(100%);\n        }\n        100% {\n            opacity: 1;\n            -webkit-transform: translateY(-40%);\n            -o-transform: translateY(-40%);\n            transform: translateY(-40%);\n        }\n    }\n}\n\n@media (max-width: 768px) {\n    @-webkit-keyframes fadeInLeftScale90 {\n        0% {\n            opacity: 0;\n            -webkit-transform: translate(-30%, -50%);\n            transform: translate(0, -50%);\n        }\n        100% {\n            opacity: 1;\n            -webkit-transform: translate(0, -50%);\n            transform: translate(0, -50%);\n        }\n    }\n\n    @-o-keyframes fadeInLeftScale90 {\n        0% {\n            opacity: 0;\n            -o-transform: translate(-30%, -50%);\n            transform: translate(0, -50%);\n        }\n        100% {\n            opacity: 1;\n            -o-transform: translate(0, -50%);\n            transform: translate(0, -50%);\n        }\n    }\n\n    @keyframes fadeInLeftScale90 {\n        0% {\n            opacity: 0;\n            -webkit-transform: translate(-30%, -50%);\n            -o-transform: translate(-30%, -50%);\n            transform: translate(0, -50%);\n        }\n        100% {\n            opacity: 1;\n            -webkit-transform: translate(0, -50%);\n            -o-transform: translate(0, -50%);\n            transform: translate(0, -50%);\n        }\n    }\n\n    .is-desktop .fadeInUpScale90 {\n        -webkit-animation-name: fadeInUpScale90;\n        -o-animation-name: fadeInUpScale90;\n        animation-name: fadeInUpScale90;\n    }\n\n    @-webkit-keyframes fadeInUpScale90 {\n        0% {\n            opacity: 0;\n            -webkit-transform: translateY(100%);\n            transform: translateY(100%);\n        }\n        100% {\n            opacity: 1;\n            -webkit-transform: translateY(-40%);\n            transform: translateY(-40%);\n        }\n    }\n\n    @-o-keyframes fadeInUpScale90 {\n        0% {\n            opacity: 0;\n            -o-transform: translateY(100%);\n            transform: translateY(100%);\n        }\n        100% {\n            opacity: 1;\n            -o-transform: translateY(-40%);\n            transform: translateY(-40%);\n        }\n    }\n\n    @keyframes fadeInUpScale90 {\n        0% {\n            opacity: 0;\n            -webkit-transform: translateY(100%);\n            -o-transform: translateY(100%);\n            transform: translateY(100%);\n        }\n        100% {\n            opacity: 1;\n            -webkit-transform: translateY(-40%);\n            -o-transform: translateY(-40%);\n            transform: translateY(-40%);\n        }\n    }\n}\n"

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var router_1 = __webpack_require__(329);
	var login_service_1 = __webpack_require__(381);
	var AuthGuard = (function () {
	    function AuthGuard(loginService, router) {
	        this.loginService = loginService;
	        this.router = router;
	    }
	    AuthGuard.prototype.canActivate = function (route, state) {
	        if (this.loginService.isLoggedIn() && !this.loginService.getDecodeToken().cambiarPassword) {
	            return true;
	        }
	        // Store the attempted URL for redirecting
	        this.loginService.redirectUrl = state.url;
	        if (!this.loginService.isLoggedIn())
	            // Navigate to the login page with extras
	            this.router.navigate(['/login']);
	        else
	            this.router.navigate(['/cambiarPassword']);
	        return false;
	    };
	    AuthGuard = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof login_service_1.LoginService !== 'undefined' && login_service_1.LoginService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object])
	    ], AuthGuard);
	    return AuthGuard;
	    var _a, _b;
	}());
	exports.AuthGuard = AuthGuard;


/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var http_1 = __webpack_require__(382);
	__webpack_require__(374);
	var myGlobals = __webpack_require__(414);
	var MiCuentaService = (function () {
	    function MiCuentaService(http) {
	        this.http = http;
	        this.usuarioUrl = myGlobals.default.BASE_URL + '/miCuenta/'; // URL to web api
	    }
	    MiCuentaService.prototype.save = function (usuario) {
	        if (usuario._id) {
	            return this.put(usuario);
	        }
	    };
	    // Actualizar usuario
	    MiCuentaService.prototype.put = function (usuario) {
	        var headers = new http_1.Headers();
	        headers.append('Content-Type', 'application/json');
	        var url = this.usuarioUrl + "/" + usuario._id;
	        return this.http
	            .put(url, JSON.stringify(usuario), { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    MiCuentaService.prototype.cambiarPassword = function (usuario) {
	        var headers = new http_1.Headers();
	        headers.append('Content-Type', 'application/json');
	        var url = this.usuarioUrl + "cambiarPassword/" + usuario._id;
	        return this.http
	            .put(url, JSON.stringify(usuario), { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    MiCuentaService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
	    ], MiCuentaService);
	    return MiCuentaService;
	    var _a;
	}());
	exports.MiCuentaService = MiCuentaService;


/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var http_1 = __webpack_require__(382);
	__webpack_require__(374);
	var myGlobals = __webpack_require__(414);
	var NotificacionService = (function () {
	    function NotificacionService(http) {
	        this.http = http;
	        this.alarmaUrl = myGlobals.default.BASE_URL + '/notificacion/'; // URL to web api
	    }
	    //Obtener un resumen de notificaciones por empresa
	    NotificacionService.prototype.getResumenNotificaciones = function (_id) {
	        return this.http.get(this.alarmaUrl + "resumen/" + _id)
	            .map(function (response) { return response.json(); });
	    };
	    NotificacionService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
	    ], NotificacionService);
	    return NotificacionService;
	    var _a;
	}());
	exports.NotificacionService = NotificacionService;


/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var http_1 = __webpack_require__(382);
	__webpack_require__(374);
	var myGlobals = __webpack_require__(414);
	var RecargaCreditoService = (function () {
	    function RecargaCreditoService(http) {
	        this.http = http;
	        this.recargaCreditoUrl = myGlobals.default.BASE_URL + '/recargaCredito/'; // URL to web api
	    }
	    //Obtener recargas para una empresa
	    RecargaCreditoService.prototype.getRecargasCreditoByEmpresa = function (_id) {
	        return this.http.get(this.recargaCreditoUrl + _id)
	            .map(function (response) { return response.json(); });
	    };
	    RecargaCreditoService.prototype.save = function (recargaCredito) {
	        //Seteo estado activo
	        recargaCredito.estado = true;
	        return this.post(recargaCredito);
	    };
	    //Desactivar recarga
	    RecargaCreditoService.prototype.delete = function (idRecargaCredito) {
	        var headers = new http_1.Headers();
	        headers.append('Content-Type', 'application/json');
	        var url = this.recargaCreditoUrl + "/" + idRecargaCredito;
	        return this.http
	            .delete(url, { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    // Agregar nueva recarga
	    RecargaCreditoService.prototype.post = function (recargaCredito) {
	        var headers = new http_1.Headers({
	            'Content-Type': 'application/json;charset=UTF-8'
	        });
	        headers.append('dataType', 'json');
	        var recargaCreditoStr = JSON.stringify(recargaCredito);
	        return this.http
	            .post(this.recargaCreditoUrl, recargaCreditoStr, { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    RecargaCreditoService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
	    ], RecargaCreditoService);
	    return RecargaCreditoService;
	    var _a;
	}());
	exports.RecargaCreditoService = RecargaCreditoService;


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var http_1 = __webpack_require__(382);
	__webpack_require__(374);
	var myGlobals = __webpack_require__(414);
	var InformeService = (function () {
	    function InformeService(http) {
	        this.http = http;
	        this.informeUrl = myGlobals.default.BASE_URL + '/informe/'; // URL to web api
	    }
	    // Informe mensual
	    InformeService.prototype.getInformeMantenimiento = function (idSucursal, reporte, filename) {
	        var headers = new http_1.Headers({
	            'Content-Type': 'application/json;charset=UTF-8',
	            'Accept': 'application/pdf'
	        });
	        headers.append('dataType', 'json');
	        var sucursalStr = JSON.stringify(reporte);
	        var requestOptions = { headers: headers, responseType: 'arraybuffer' };
	        return this.http
	            .post(this.informeUrl + idSucursal, sucursalStr, requestOptions)
	            .map(function (response) {
	            var linkSource = "data:application/pdf;base64," + response.text();
	            var downloadLink = document.createElement("a");
	            var fileName = "reporteMantenimientoBemakoha-" + filename + '-' + reporte.mes + reporte.anio + ".pdf";
	            downloadLink.href = linkSource;
	            downloadLink.download = fileName;
	            downloadLink.click();
	        });
	    };
	    // Informe resumen
	    InformeService.prototype.getInformeResumen = function (idSucursal, reporte) {
	        var headers = new http_1.Headers({
	            'Content-Type': 'application/json;charset=UTF-8',
	            'Accept': 'application/pdf'
	        });
	        headers.append('dataType', 'json');
	        var sucursalStr = JSON.stringify(reporte);
	        var requestOptions = { headers: headers, responseType: 'arraybuffer' };
	        return this.http
	            .post(this.informeUrl + "/informeResumen/" + idSucursal, sucursalStr, requestOptions)
	            .map(function (response) {
	            //let reporteBlob = new Blob(["data:application/pdf;base64, " +response.text()], {type: 'data:application/pdf'});
	            var linkSource = "data:application/pdf;base64," + response.text();
	            var downloadLink = document.createElement("a");
	            var fileName = "reporteResumenBemakoha" + ".pdf";
	            downloadLink.href = linkSource;
	            downloadLink.download = fileName;
	            downloadLink.click();
	        });
	    };
	    InformeService.prototype.getInformeGeneral = function (idSucursal, reporte) {
	        var headers = new http_1.Headers({
	            'Content-Type': 'application/json;charset=UTF-8',
	            'Accept': 'application/pdf'
	        });
	        headers.append('dataType', 'json');
	        var sucursalStr = JSON.stringify(reporte);
	        var requestOptions = { headers: headers, responseType: 'arraybuffer' };
	        return this.http
	            .post(this.informeUrl + "informeGeneral", sucursalStr, requestOptions)
	            .map(function (response) {
	            var linkSource = "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," + response.text();
	            var downloadLink = document.createElement("a");
	            var fileName = "reporteGeneralBemakoha" + ".xlsx";
	            downloadLink.href = linkSource;
	            downloadLink.download = fileName;
	            downloadLink.click();
	        });
	    };
	    InformeService.prototype.getConfiguracionSucursal = function (idSucursal) {
	        var headers = new http_1.Headers({
	            'Content-Type': 'application/json;charset=UTF-8',
	            'Accept': 'application/pdf'
	        });
	        headers.append('dataType', 'json');
	        var sucursalStr = { sucursal_id: idSucursal };
	        var requestOptions = { headers: headers, responseType: 'arraybuffer' };
	        return this.http
	            .post(this.informeUrl + "configuracionSucursal", sucursalStr, requestOptions)
	            .map(function (response) {
	            var linkSource = "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," + response.text();
	            var downloadLink = document.createElement("a");
	            var fileName = "configuracionSucursal" + ".xlsx";
	            downloadLink.href = linkSource;
	            downloadLink.download = fileName;
	            downloadLink.click();
	        });
	    };
	    InformeService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
	    ], InformeService);
	    return InformeService;
	    var _a;
	}());
	exports.InformeService = InformeService;


/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var http_1 = __webpack_require__(382);
	__webpack_require__(374);
	var myGlobals = __webpack_require__(414);
	var LogActividadService = (function () {
	    function LogActividadService(http) {
	        this.http = http;
	        this.informeUrl = myGlobals.default.BASE_URL + '/logActividad'; // URL to web api
	    }
	    // Informe resumen
	    LogActividadService.prototype.export = function (filtros) {
	        var headers = new http_1.Headers({
	            'Content-Type': 'application/json;charset=UTF-8',
	            'Accept': 'application/pdf'
	        });
	        headers.append('dataType', 'json');
	        var esc = encodeURIComponent;
	        var query = "";
	        if (filtros)
	            query = Object.keys(filtros)
	                .map(function (k) { return esc(k) + '=' + esc(filtros[k]); })
	                .join('&');
	        var requestOptions = { headers: headers, responseType: 'arraybuffer' };
	        return this.http
	            .get(this.informeUrl + "/export?" + query, requestOptions)
	            .map(function (response) {
	            var linkSource = "data:application/pdf;base64," + response.text();
	            var downloadLink = document.createElement("a");
	            var fileName = "reporteActividadesBemakoha" + ".pdf";
	            downloadLink.href = linkSource;
	            downloadLink.download = fileName;
	            downloadLink.click();
	        });
	    };
	    LogActividadService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
	    ], LogActividadService);
	    return LogActividadService;
	    var _a;
	}());
	exports.LogActividadService = LogActividadService;


/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var http_1 = __webpack_require__(382);
	__webpack_require__(374);
	var myGlobals = __webpack_require__(414);
	var HusoHorarioService = (function () {
	    function HusoHorarioService(http) {
	        this.http = http;
	        this.husoHorarioURL = myGlobals.default.BASE_URL + '/husoHorario/'; // URL to web api
	    }
	    //Obtener todas las husos horarios
	    HusoHorarioService.prototype.getHusosHorarios = function () {
	        return this.http.get(this.husoHorarioURL)
	            .map(function (response) { return response.json(); });
	    };
	    HusoHorarioService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
	    ], HusoHorarioService);
	    return HusoHorarioService;
	    var _a;
	}());
	exports.HusoHorarioService = HusoHorarioService;


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var http_1 = __webpack_require__(382);
	__webpack_require__(374);
	var myGlobals = __webpack_require__(414);
	var PlanService = (function () {
	    function PlanService(http) {
	        this.http = http;
	        this.planUrl = myGlobals.default.BASE_URL + "/plan/"; // URL to web api
	    }
	    //Obtener todos los planes habilitados para el usuario
	    PlanService.prototype.getPlanes = function () {
	        return this.http.get(this.planUrl).map(function (response) { return response.json(); });
	    };
	    //Obtener un plan
	    PlanService.prototype.getPlan = function (_id) {
	        return this.http
	            .get(this.planUrl + _id)
	            .map(function (response) { return response.json(); });
	    };
	    PlanService.prototype.save = function (plan) {
	        if (plan._id) {
	            return this.put(plan);
	        }
	        //Seteo estado activo
	        plan.estado = true;
	        return this.post(plan);
	    };
	    //Desactivar plan
	    PlanService.prototype.delete = function (plan) {
	        var headers = new http_1.Headers();
	        headers.append("Content-Type", "application/json");
	        var url = this.planUrl + "/" + plan._id;
	        return this.http
	            .delete(url, { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    // Agregar nuevo plan
	    PlanService.prototype.post = function (plan) {
	        var headers = new http_1.Headers({
	            "Content-Type": "application/json;charset=UTF-8",
	        });
	        headers.append("dataType", "json");
	        console.log(plan);
	        console.log(JSON.stringify(plan));
	        var planStr = JSON.stringify(plan);
	        return this.http
	            .post(this.planUrl, planStr, { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    // Actualizar plan
	    PlanService.prototype.put = function (plan) {
	        var headers = new http_1.Headers();
	        headers.append("Content-Type", "application/json");
	        var url = this.planUrl + "/" + plan._id;
	        return this.http
	            .put(url, JSON.stringify(plan), { headers: headers })
	            .map(function (response) { return response.json(); });
	    };
	    PlanService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
	    ], PlanService);
	    return PlanService;
	    var _a;
	}());
	exports.PlanService = PlanService;


/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var router_1 = __webpack_require__(329);
	var login_component_1 = __webpack_require__(418);
	var home_component_1 = __webpack_require__(901);
	var homeTecnico_component_1 = __webpack_require__(907);
	var graficos_component_1 = __webpack_require__(911);
	var alarmas_component_1 = __webpack_require__(922);
	var empresa_component_1 = __webpack_require__(925);
	var sucursal_component_1 = __webpack_require__(938);
	var ubicacion_component_1 = __webpack_require__(945);
	var gateway_component_1 = __webpack_require__(948);
	var nodo_component_1 = __webpack_require__(952);
	var sensor_component_1 = __webpack_require__(956);
	var tipoSensor_component_1 = __webpack_require__(960);
	var abmgeneral_component_1 = __webpack_require__(964);
	var usuario_component_1 = __webpack_require__(983);
	var tipoVariable_component_1 = __webpack_require__(987);
	var tipoBateria_component_1 = __webpack_require__(991);
	var historico_component_1 = __webpack_require__(995);
	var actividades_component_1 = __webpack_require__(1000);
	var auth_guard_service_1 = __webpack_require__(892);
	var login_service_1 = __webpack_require__(381);
	var reset_component_1 = __webpack_require__(1003);
	var miCuenta_component_1 = __webpack_require__(1007);
	var cambiarPassword_component_1 = __webpack_require__(1011);
	var recargaCredito_component_1 = __webpack_require__(928);
	var calibracion_component_1 = __webpack_require__(1014);
	var documento_component_1 = __webpack_require__(1017);
	var regalarmas_component_1 = __webpack_require__(1022);
	var authorization_guard_service_1 = __webpack_require__(1025);
	var menu_service_1 = __webpack_require__(428);
	var plan_component_1 = __webpack_require__(1026);
	exports.routes = [
	    { path: "", component: login_component_1.LoginComponent },
	    { path: "login", component: login_component_1.LoginComponent },
	    { path: "home", component: home_component_1.HomeComponent, canActivate: [auth_guard_service_1.AuthGuard] },
	    {
	        path: "homeTecnico",
	        component: homeTecnico_component_1.HomeTecnicoComponent,
	        canActivate: [auth_guard_service_1.AuthGuard, authorization_guard_service_1.AuthorizationGuard],
	    },
	    {
	        path: "graficos",
	        component: graficos_component_1.GraficosComponent,
	        canActivate: [auth_guard_service_1.AuthGuard, authorization_guard_service_1.AuthorizationGuard],
	    },
	    {
	        path: "alarmas",
	        component: alarmas_component_1.AlarmasComponent,
	        canActivate: [auth_guard_service_1.AuthGuard, authorization_guard_service_1.AuthorizationGuard],
	    },
	    {
	        path: "empresa",
	        component: empresa_component_1.EmpresaComponent,
	        canActivate: [auth_guard_service_1.AuthGuard, authorization_guard_service_1.AuthorizationGuard],
	    },
	    {
	        path: "sucursal",
	        component: sucursal_component_1.SucursalComponent,
	        canActivate: [auth_guard_service_1.AuthGuard, authorization_guard_service_1.AuthorizationGuard],
	    },
	    {
	        path: "ubicacion",
	        component: ubicacion_component_1.UbicacionComponent,
	        canActivate: [auth_guard_service_1.AuthGuard, authorization_guard_service_1.AuthorizationGuard],
	    },
	    {
	        path: "gateway",
	        component: gateway_component_1.GatewayComponent,
	        canActivate: [auth_guard_service_1.AuthGuard, authorization_guard_service_1.AuthorizationGuard],
	    },
	    {
	        path: "nodo",
	        component: nodo_component_1.NodoComponent,
	        canActivate: [auth_guard_service_1.AuthGuard, authorization_guard_service_1.AuthorizationGuard],
	    },
	    {
	        path: "sensor",
	        component: sensor_component_1.SensorComponent,
	        canActivate: [auth_guard_service_1.AuthGuard, authorization_guard_service_1.AuthorizationGuard],
	    },
	    {
	        path: "configuracion",
	        component: abmgeneral_component_1.ABMGeneralComponent,
	        canActivate: [auth_guard_service_1.AuthGuard, authorization_guard_service_1.AuthorizationGuard],
	    },
	    {
	        path: "usuarios",
	        component: usuario_component_1.UsuariosComponent,
	        canActivate: [auth_guard_service_1.AuthGuard, authorization_guard_service_1.AuthorizationGuard],
	    },
	    {
	        path: "tipoVariable",
	        component: tipoVariable_component_1.TipoVariableComponent,
	        canActivate: [auth_guard_service_1.AuthGuard, authorization_guard_service_1.AuthorizationGuard],
	    },
	    {
	        path: "tipoSensor",
	        component: tipoSensor_component_1.TipoSensorComponent,
	        canActivate: [auth_guard_service_1.AuthGuard, authorization_guard_service_1.AuthorizationGuard],
	    },
	    {
	        path: "tipoBateria",
	        component: tipoBateria_component_1.TipoBateriaComponent,
	        canActivate: [auth_guard_service_1.AuthGuard, authorization_guard_service_1.AuthorizationGuard],
	    },
	    {
	        path: "actividades",
	        component: actividades_component_1.ActividadesComponent,
	        canActivate: [auth_guard_service_1.AuthGuard, authorization_guard_service_1.AuthorizationGuard],
	    },
	    {
	        path: "historico",
	        component: historico_component_1.HistoricoComponent,
	        canActivate: [auth_guard_service_1.AuthGuard, authorization_guard_service_1.AuthorizationGuard],
	    },
	    { path: "miCuenta", component: miCuenta_component_1.MiCuentaComponent, canActivate: [auth_guard_service_1.AuthGuard] },
	    { path: "cambiarPassword", component: cambiarPassword_component_1.CambiarPasswordComponent },
	    { path: "reset/:token", component: reset_component_1.ResetComponent },
	    {
	        path: "recargaCredito",
	        component: recargaCredito_component_1.RecargaCreditoComponent,
	        canActivate: [auth_guard_service_1.AuthGuard, authorization_guard_service_1.AuthorizationGuard],
	    },
	    {
	        path: "presupuestoCalibracion/:id",
	        component: calibracion_component_1.CalibracionComponent,
	        canActivate: [auth_guard_service_1.AuthGuard],
	    },
	    {
	        path: "documentos",
	        component: documento_component_1.DocumentoComponent,
	        canActivate: [auth_guard_service_1.AuthGuard, authorization_guard_service_1.AuthorizationGuard],
	    },
	    {
	        path: "regAlarmas",
	        component: regalarmas_component_1.RegAlarmasComponent,
	        canActivate: [auth_guard_service_1.AuthGuard, authorization_guard_service_1.AuthorizationGuard],
	    },
	    {
	        path: "planes",
	        component: plan_component_1.PlanComponent,
	        canActivate: [auth_guard_service_1.AuthGuard, authorization_guard_service_1.AuthorizationGuard],
	    },
	    { path: "404", component: login_component_1.LoginComponent },
	    { path: "**/:*", redirectTo: "/404" },
	    { path: "**", redirectTo: "/404" },
	    {
	        path: "",
	        redirectTo: "/login",
	        pathMatch: "full",
	    },
	];
	exports.APP_ROUTER_PROVIDERS = [
	    router_1.provideRouter(exports.routes),
	    auth_guard_service_1.AuthGuard,
	    authorization_guard_service_1.AuthorizationGuard,
	    login_service_1.LoginService,
	    menu_service_1.MenuService,
	];


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var login_service_1 = __webpack_require__(381);
	var regAlarma_service_1 = __webpack_require__(572);
	var nodo_service_1 = __webpack_require__(433);
	var io = __webpack_require__(593);
	var myGlobals = __webpack_require__(414);
	var dateTimeZonePipe_1 = __webpack_require__(645);
	var Highcharts = __webpack_require__(902);
	// Load module after Highcharts is loaded
	__webpack_require__(903)(Highcharts);
	__webpack_require__(904)(Highcharts);
	var ChartGlobal = [];
	var HomeComponent = (function () {
	    function HomeComponent(regAlarmaService, nodoService, loginService) {
	        this.regAlarmaService = regAlarmaService;
	        this.nodoService = nodoService;
	        this.loginService = loginService;
	        this.usuario = '';
	    }
	    HomeComponent.prototype.ngOnDestroy = function () {
	        this.socket.disconnect();
	        this.socketSensor.disconnect();
	    };
	    HomeComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        window.scrollTo(0, 0);
	        this.usuarioConectado = this.loginService.getDecodeToken();
	        //Desactivar auto slide
	        $("#myCarousel").carousel({
	            interval: false
	        });
	        //Conectar al socket con configuración específica
	        this.socket = io.connect(myGlobals.default.URL_MQTT_ALARMAS, {
	            path: myGlobals.default.PATH_MQTT_ALARMAS,
	            transports: ['websocket', 'polling'],
	            upgrade: true,
	            rememberUpgrade: true
	        });
	        this.socketSensor = io.connect(myGlobals.default.URL_MQTT, {
	            path: myGlobals.default.PATH_MQTT,
	            transports: ['websocket', 'polling'],
	            upgrade: true,
	            rememberUpgrade: true
	        });
	        // Debug de conexiones
	        this.socket.on('connect', function () {
	            console.log('Socket alarmas conectado via:', _this.socket.io.engine.transport.name);
	            _this.socket.io.engine.on('upgrade', function () {
	                console.log('Socket alarmas actualizado a:', _this.socket.io.engine.transport.name);
	            });
	        });
	        this.socketSensor.on('connect', function () {
	            console.log('Socket sensor conectado via:', _this.socketSensor.io.engine.transport.name);
	            _this.socketSensor.io.engine.on('upgrade', function () {
	                console.log('Socket sensor actualizado a:', _this.socketSensor.io.engine.transport.name);
	            });
	        });
	        this.inicializarSocketAlarma();
	        //Cargar arbol
	        this.recargar();
	    };
	    HomeComponent.prototype.recargar = function () {
	        var _this = this;
	        //Arbol de sucursales->ubicaciones->nodos->sensores segun usuario logueado
	        this.nodoService.getNodosInfoBasica().subscribe(function (sucursalesConTodo) {
	            _this.sucursales = sucursalesConTodo;
	            for (var s = 0; s < _this.sucursales.length; s++) {
	                var sucursal = _this.sucursales[s];
	                if (!sucursal.estado) {
	                    _this.sucursales.splice(_this.sucursales.indexOf(sucursal), 1);
	                    s--;
	                    continue;
	                }
	                //sucursal.alarmaActiva = false;
	                for (var u = 0; u < sucursal.ubicaciones.length; u++) {
	                    var ubicacion = sucursal.ubicaciones[u];
	                    if (!ubicacion.estado) {
	                        sucursal.ubicaciones.splice(sucursal.ubicaciones.indexOf(ubicacion), 1);
	                        u--;
	                        continue;
	                    }
	                    //ubicacion.alarmaActiva=false;
	                    //Busco alarmas por nodo
	                    for (var n = 0; n < ubicacion.nodos.length; n++) {
	                        var nodo = ubicacion.nodos[n];
	                        if (!nodo.estado) {
	                            ubicacion.nodos.splice(ubicacion.nodos.indexOf(nodo), 1);
	                            n--;
	                            continue;
	                        }
	                        if (nodo.regAlarmas.length > 0) {
	                            nodo.alarmaActiva = true;
	                            ubicacion.alarmaActiva = true;
	                            sucursal.alarmaActiva = true;
	                            ubicacion.color = "Rojo";
	                            nodo.color = "Rojo";
	                            sucursal.color = "Rojo";
	                        }
	                        else
	                            nodo.alarmaActiva = false;
	                        var _loop_1 = function(s_1) {
	                            var sensor = nodo.sensores_id[s_1];
	                            //console.log("SENSOR " + sensor.etiqueta + " NODO " + nodo.etiqueta);
	                            sensor.alarmaActiva = false;
	                            //nodo.alarmaActiva = false;
	                            //ubicacion.alarmaActiva = false;
	                            //sucursal.alarmaActiva = false;
	                            //Busco alarmas por sensor
	                            if ((!sensor.estado) || (sensor.posicionString == 9 && _this.usuarioConectado.rol != "Administrador" && _this.usuarioConectado.rol != "Tecnico")) {
	                                nodo.sensores_id.splice(nodo.sensores_id.indexOf(sensor), 1);
	                                s_1--;
	                                return out_s_1_1 = s_1, "continue";
	                            }
	                            if (sensor.regAlarmas.length > 0) {
	                                var color_1 = "Amarillo";
	                                sensor.regAlarmas.map(function (regAlarmaSensor) {
	                                    if (regAlarmaSensor.color == "Rojo" || (regAlarmaSensor.tipoEspecial == "BATERIABAJA" && (regAlarmaSensor.color == "Rojo" || !regAlarmaSensor.color)))
	                                        color_1 = "Rojo";
	                                });
	                                sensor.alarmaActiva = true;
	                                sensor.color = color_1;
	                                if (nodo.regAlarmas.length > 0)
	                                    color_1 = "Rojo";
	                                nodo.alarmaActiva = true;
	                                if (!nodo.color || (nodo.color == 'Amarillo' && color_1 == "Rojo"))
	                                    nodo.color = color_1;
	                                ubicacion.alarmaActiva = true;
	                                if (!ubicacion.color || (ubicacion.color == 'Amarillo' && color_1 == "Rojo"))
	                                    ubicacion.color = color_1;
	                                sucursal.alarmaActiva = true;
	                                if (!sucursal.color || (sucursal.color == 'Amarillo' && color_1 == "Rojo"))
	                                    sucursal.color = color_1;
	                            }
	                            _this.inicializarSensor(sensor, nodo);
	                            out_s_1_1 = s_1;
	                        };
	                        var out_s_1_1;
	                        for (var s_1 = 0; s_1 < nodo.sensores_id.length; s_1++) {
	                            _loop_1(s_1);
	                            s_1 = out_s_1_1;
	                        }
	                    }
	                }
	            }
	            setTimeout(function () { return _this.checkSlideActiva(); }, 500);
	        });
	    };
	    HomeComponent.prototype.cambiarSlide = function (idSlide) {
	        var goTo = 0;
	        $('.carousel-inner .item').each(function (index) {
	            if ($(this).attr('id') == idSlide) {
	                goTo = index;
	                return false;
	            }
	        });
	        $('#carousel').carousel(goTo);
	        window.scrollTo(0, 0);
	    };
	    /*
	     Evitar que deje de existir una slide activa
	     */
	    HomeComponent.prototype.checkSlideActiva = function () {
	        var bandera = true;
	        $('.carousel-inner .item').each(function (index) {
	            if ($(this).hasClass("active")) {
	                bandera = false;
	            }
	        });
	        if (bandera) {
	            $('#principalSucursales').addClass("active");
	        }
	    };
	    HomeComponent.prototype.inicializarSensor = function (sensor, nodo) {
	        //Inicializar sensores
	        var chartActual;
	        setTimeout(function () {
	            chartActual = new Highcharts.chart(sensor._id, {
	                chart: {
	                    type: 'solidgauge',
	                    backgroundColor: 'rgba(0,0,0,0)',
	                    width: '120',
	                    height: '100',
	                },
	                exporting: {
	                    enabled: false
	                },
	                title: null,
	                pane: {
	                    center: ['50%', '85%'],
	                    size: '130%',
	                    startAngle: -90,
	                    endAngle: 90,
	                    background: {
	                        backgroundColor: '#717579',
	                        innerRadius: '98%',
	                        outerRadius: '100%',
	                        shape: 'arc',
	                        borderWidth: 0,
	                        borderColor: 'transparent'
	                    }
	                },
	                tooltip: {
	                    enabled: false
	                },
	                yAxis: {
	                    showFirstLabel: false,
	                    showLastLabel: false,
	                    min: sensor.tipo_id.rangoDesde,
	                    max: sensor.tipo_id.rangoHasta,
	                    stops: [
	                        [0, !sensor.alarmaActiva ? '#84B547' : ((!sensor.color || sensor.color == 'Rojo') ? '#CC3E4A' : '#fbd749')],
	                    ],
	                    lineWidth: 0,
	                    tickWidth: 0,
	                    minorTickInterval: null,
	                    tickAmount: 2,
	                },
	                plotOptions: {
	                    solidgauge: {
	                        innerRadius: '93%',
	                        dataLabels: {
	                            y: 5,
	                            borderWidth: 0,
	                            useHTML: true
	                        }
	                    }
	                },
	                credits: {
	                    enabled: false
	                },
	                series: [{
	                        name: sensor.etiqueta,
	                        data: [sensor.lastMediciones[sensor.lastMediciones.length - 1]],
	                        dataLabels: {
	                            format: '<div style="text-align:center"><span style="font-size:21px;font-family:Raleway 2;padding-bottom:10px;color: ' +
	                                ('#717579') + '">{y}' + " " + sensor.tipo_id.tipo + '</span>'
	                        },
	                    }]
	            });
	            ChartGlobal.push({ _id: sensor._id, chart: chartActual });
	        }, 1000);
	        sensor.fechaUltimaMedicion = nodo.lastMedicionDate;
	        //Establecer socket sensor
	        this.socketSensor.on(sensor._id, function (data) {
	            var point;
	            //Busco la serie que corresponda
	            //var chartRpm = $('#'+sensor._id).highcharts();
	            //var chartRpm = ChartGlobal.chart(sensor._id);
	            var chartRpm = null;
	            for (var _i = 0, ChartGlobal_1 = ChartGlobal; _i < ChartGlobal_1.length; _i++) {
	                var chart = ChartGlobal_1[_i];
	                if (chart._id == sensor._id) {
	                    chartRpm = chart;
	                    break;
	                }
	            }
	            if (chartRpm) {
	                point = chartRpm.chart.series[0].points[0];
	                point.update(data.valor);
	            }
	            if (this.sucursales != undefined && this.sucursales.length > 0)
	                for (var _a = 0, _b = this.sucursales; _a < _b.length; _a++) {
	                    var sucursal = _b[_a];
	                    for (var _c = 0, _d = sucursal.ubicaciones; _c < _d.length; _c++) {
	                        var ubicacion = _d[_c];
	                        for (var _e = 0, _f = ubicacion.nodos; _e < _f.length; _e++) {
	                            var nodo_1 = _f[_e];
	                            for (var _g = 0, _h = nodo_1.sensores_id; _g < _h.length; _g++) {
	                                var s = _h[_g];
	                                if (s._id == sensor._id) {
	                                    s.fechaUltimaMedicion = data.fecha;
	                                    break;
	                                }
	                            }
	                        }
	                    }
	                }
	        }.bind(this));
	    };
	    HomeComponent.prototype.inicializarSocketAlarma = function () {
	        //Inicilizo socket para alarmas
	        this.socket.on("alarma", function (alarma) {
	            this.recargar();
	        }.bind(this));
	    };
	    HomeComponent = __decorate([
	        core_1.Component({
	            selector: 'home',
	            template: __webpack_require__(905),
	            styles: [__webpack_require__(906)],
	            pipes: [dateTimeZonePipe_1.DateTimeZonePipe]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof regAlarma_service_1.RegAlarmaService !== 'undefined' && regAlarma_service_1.RegAlarmaService) === 'function' && _a) || Object, (typeof (_b = typeof nodo_service_1.NodoService !== 'undefined' && nodo_service_1.NodoService) === 'function' && _b) || Object, (typeof (_c = typeof login_service_1.LoginService !== 'undefined' && login_service_1.LoginService) === 'function' && _c) || Object])
	    ], HomeComponent);
	    return HomeComponent;
	    var _a, _b, _c;
	}());
	exports.HomeComponent = HomeComponent;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(419)))

/***/ }),
/* 902 */
/***/ (function(module, exports) {

	/**
	 * @license Highstock JS v5.0.14 (2017-07-28)
	 *
	 * (c) 2009-2016 Torstein Honsi
	 *
	 * License: www.highcharts.com/license
	 */
	'use strict';
	(function(root, factory) {
	    if (typeof module === 'object' && module.exports) {
	        module.exports = root.document ?
	            factory(root) :
	            factory;
	    } else {
	        root.Highcharts = factory(root);
	    }
	}(typeof window !== 'undefined' ? window : this, function(win) {
	    var Highcharts = (function() {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        /* global window */
	        var win = window,
	            doc = win.document;
	
	        var SVG_NS = 'http://www.w3.org/2000/svg',
	            userAgent = (win.navigator && win.navigator.userAgent) || '',
	            svg = doc && doc.createElementNS && !!doc.createElementNS(SVG_NS, 'svg').createSVGRect,
	            isMS = /(edge|msie|trident)/i.test(userAgent) && !window.opera,
	            vml = !svg,
	            isFirefox = /Firefox/.test(userAgent),
	            hasBidiBug = isFirefox && parseInt(userAgent.split('Firefox/')[1], 10) < 4; // issue #38
	
	        var Highcharts = win.Highcharts ? win.Highcharts.error(16, true) : {
	            product: 'Highstock',
	            version: '5.0.14',
	            deg2rad: Math.PI * 2 / 360,
	            doc: doc,
	            hasBidiBug: hasBidiBug,
	            hasTouch: doc && doc.documentElement.ontouchstart !== undefined,
	            isMS: isMS,
	            isWebKit: /AppleWebKit/.test(userAgent),
	            isFirefox: isFirefox,
	            isTouchDevice: /(Mobile|Android|Windows Phone)/.test(userAgent),
	            SVG_NS: SVG_NS,
	            chartCount: 0,
	            seriesTypes: {},
	            symbolSizes: {},
	            svg: svg,
	            vml: vml,
	            win: win,
	            marginNames: ['plotTop', 'marginRight', 'marginBottom', 'plotLeft'],
	            noop: function() {
	                return undefined;
	            },
	            /**
	             * An array containing the current chart objects in the page. A chart's
	             * position in the array is preserved throughout the page's lifetime. When
	             * a chart is destroyed, the array item becomes `undefined`.
	             * @type {Array.<Highcharts.Chart>}
	             * @memberOf Highcharts
	             */
	            charts: []
	        };
	        return Highcharts;
	    }());
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        /* eslint max-len: ["warn", 80, 4] */
	
	        /**
	         * The Highcharts object is the placeholder for all other members, and various
	         * utility functions. The most important member of the namespace would be the
	         * chart constructor.
	         *
	         * @example
	         * var chart = Highcharts.chart('container', { ... });
	         * 
	         * @namespace Highcharts
	         */
	
	        var timers = [];
	
	        var charts = H.charts,
	            doc = H.doc,
	            win = H.win;
	
	        /**
	         * Provide error messages for debugging, with links to online explanation. This
	         * function can be overridden to provide custom error handling.
	         *
	         * @function #error
	         * @memberOf Highcharts
	         * @param {Number|String} code - The error code. See [errors.xml]{@link 
	         *     https://github.com/highcharts/highcharts/blob/master/errors/errors.xml}
	         *     for available codes. If it is a string, the error message is printed
	         *     directly in the console.
	         * @param {Boolean} [stop=false] - Whether to throw an error or just log a 
	         *     warning in the console.
	         *
	         * @sample highcharts/chart/highcharts-error/ Custom error handler
	         */
	        H.error = function(code, stop) {
	            var msg = H.isNumber(code) ?
	                'Highcharts error #' + code + ': www.highcharts.com/errors/' + code :
	                code;
	            if (stop) {
	                throw new Error(msg);
	            }
	            // else ...
	            if (win.console) {
	                console.log(msg); // eslint-disable-line no-console
	            }
	        };
	
	        /**
	         * An animator object used internally. One instance applies to one property
	         * (attribute or style prop) on one element. Animation is always initiated
	         * through {@link SVGElement#animate}.
	         *
	         * @constructor Fx
	         * @memberOf Highcharts
	         * @param {HTMLDOMElement|SVGElement} elem - The element to animate.
	         * @param {AnimationOptions} options - Animation options.
	         * @param {string} prop - The single attribute or CSS property to animate.
	         * @private
	         *
	         * @example
	         * var rect = renderer.rect(0, 0, 10, 10).add();
	         * rect.animate({ width: 100 });
	         */
	        H.Fx = function(elem, options, prop) {
	            this.options = options;
	            this.elem = elem;
	            this.prop = prop;
	        };
	        H.Fx.prototype = {
	
	            /**
	             * Set the current step of a path definition on SVGElement.
	             *
	             * @function #dSetter
	             * @memberOf Highcharts.Fx
	             */
	            dSetter: function() {
	                var start = this.paths[0],
	                    end = this.paths[1],
	                    ret = [],
	                    now = this.now,
	                    i = start.length,
	                    startVal;
	
	                // Land on the final path without adjustment points appended in the ends
	                if (now === 1) {
	                    ret = this.toD;
	
	                } else if (i === end.length && now < 1) {
	                    while (i--) {
	                        startVal = parseFloat(start[i]);
	                        ret[i] =
	                            isNaN(startVal) ? // a letter instruction like M or L
	                            start[i] :
	                            now * (parseFloat(end[i] - startVal)) + startVal;
	
	                    }
	                    // If animation is finished or length not matching, land on right value
	                } else {
	                    ret = end;
	                }
	                this.elem.attr('d', ret, null, true);
	            },
	
	            /**
	             * Update the element with the current animation step.
	             *
	             * @function #update
	             * @memberOf Highcharts.Fx
	             */
	            update: function() {
	                var elem = this.elem,
	                    prop = this.prop, // if destroyed, it is null
	                    now = this.now,
	                    step = this.options.step;
	
	                // Animation setter defined from outside
	                if (this[prop + 'Setter']) {
	                    this[prop + 'Setter']();
	
	                    // Other animations on SVGElement
	                } else if (elem.attr) {
	                    if (elem.element) {
	                        elem.attr(prop, now, null, true);
	                    }
	
	                    // HTML styles, raw HTML content like container size
	                } else {
	                    elem.style[prop] = now + this.unit;
	                }
	
	                if (step) {
	                    step.call(elem, now, this);
	                }
	
	            },
	
	            /**
	             * Run an animation.
	             *
	             * @function #run
	             * @memberOf Highcharts.Fx
	             * @param {Number} from - The current value, value to start from.
	             * @param {Number} to - The end value, value to land on.
	             * @param {String} [unit] - The property unit, for example `px`.
	             * 
	             */
	            run: function(from, to, unit) {
	                var self = this,
	                    timer = function(gotoEnd) {
	                        return timer.stopped ? false : self.step(gotoEnd);
	                    },
	                    i;
	
	                this.startTime = +new Date();
	                this.start = from;
	                this.end = to;
	                this.unit = unit;
	                this.now = this.start;
	                this.pos = 0;
	
	                timer.elem = this.elem;
	                timer.prop = this.prop;
	
	                if (timer() && timers.push(timer) === 1) {
	                    timer.timerId = setInterval(function() {
	
	                        for (i = 0; i < timers.length; i++) {
	                            if (!timers[i]()) {
	                                timers.splice(i--, 1);
	                            }
	                        }
	
	                        if (!timers.length) {
	                            clearInterval(timer.timerId);
	                        }
	                    }, 13);
	                }
	            },
	
	            /**
	             * Run a single step in the animation.
	             *
	             * @function #step
	             * @memberOf Highcharts.Fx
	             * @param   {Boolean} [gotoEnd] - Whether to go to the endpoint of the
	             *     animation after abort.
	             * @returns {Boolean} Returns `true` if animation continues.
	             */
	            step: function(gotoEnd) {
	                var t = +new Date(),
	                    ret,
	                    done,
	                    options = this.options,
	                    elem = this.elem,
	                    complete = options.complete,
	                    duration = options.duration,
	                    curAnim = options.curAnim;
	
	                if (elem.attr && !elem.element) { // #2616, element is destroyed
	                    ret = false;
	
	                } else if (gotoEnd || t >= duration + this.startTime) {
	                    this.now = this.end;
	                    this.pos = 1;
	                    this.update();
	
	                    curAnim[this.prop] = true;
	
	                    done = true;
	
	                    H.objectEach(curAnim, function(val) {
	                        if (val !== true) {
	                            done = false;
	                        }
	                    });
	
	                    if (done && complete) {
	                        complete.call(elem);
	                    }
	                    ret = false;
	
	                } else {
	                    this.pos = options.easing((t - this.startTime) / duration);
	                    this.now = this.start + ((this.end - this.start) * this.pos);
	                    this.update();
	                    ret = true;
	                }
	                return ret;
	            },
	
	            /**
	             * Prepare start and end values so that the path can be animated one to one.
	             *
	             * @function #initPath
	             * @memberOf Highcharts.Fx
	             * @param {SVGElement} elem - The SVGElement item.
	             * @param {String} fromD - Starting path definition.
	             * @param {Array} toD - Ending path definition.
	             * @returns {Array} An array containing start and end paths in array form
	             * so that they can be animated in parallel.
	             */
	            initPath: function(elem, fromD, toD) {
	                fromD = fromD || '';
	                var shift,
	                    startX = elem.startX,
	                    endX = elem.endX,
	                    bezier = fromD.indexOf('C') > -1,
	                    numParams = bezier ? 7 : 3,
	                    fullLength,
	                    slice,
	                    i,
	                    start = fromD.split(' '),
	                    end = toD.slice(), // copy
	                    isArea = elem.isArea,
	                    positionFactor = isArea ? 2 : 1,
	                    reverse;
	
	                /**
	                 * In splines make moveTo and lineTo points have six parameters like
	                 * bezier curves, to allow animation one-to-one.
	                 */
	                function sixify(arr) {
	                    var isOperator,
	                        nextIsOperator;
	                    i = arr.length;
	                    while (i--) {
	
	                        // Fill in dummy coordinates only if the next operator comes
	                        // three places behind (#5788)
	                        isOperator = arr[i] === 'M' || arr[i] === 'L';
	                        nextIsOperator = /[a-zA-Z]/.test(arr[i + 3]);
	                        if (isOperator && nextIsOperator) {
	                            arr.splice(
	                                i + 1, 0,
	                                arr[i + 1], arr[i + 2],
	                                arr[i + 1], arr[i + 2]
	                            );
	                        }
	                    }
	                }
	
	                /**
	                 * Insert an array at the given position of another array
	                 */
	                function insertSlice(arr, subArr, index) {
	                    [].splice.apply(
	                        arr, [index, 0].concat(subArr)
	                    );
	                }
	
	                /**
	                 * If shifting points, prepend a dummy point to the end path. 
	                 */
	                function prepend(arr, other) {
	                    while (arr.length < fullLength) {
	
	                        // Move to, line to or curve to?
	                        arr[0] = other[fullLength - arr.length];
	
	                        // Prepend a copy of the first point
	                        insertSlice(arr, arr.slice(0, numParams), 0);
	
	                        // For areas, the bottom path goes back again to the left, so we
	                        // need to append a copy of the last point.
	                        if (isArea) {
	                            insertSlice(
	                                arr,
	                                arr.slice(arr.length - numParams), arr.length
	                            );
	                            i--;
	                        }
	                    }
	                    arr[0] = 'M';
	                }
	
	                /**
	                 * Copy and append last point until the length matches the end length
	                 */
	                function append(arr, other) {
	                    var i = (fullLength - arr.length) / numParams;
	                    while (i > 0 && i--) {
	
	                        // Pull out the slice that is going to be appended or inserted.
	                        // In a line graph, the positionFactor is 1, and the last point
	                        // is sliced out. In an area graph, the positionFactor is 2,
	                        // causing the middle two points to be sliced out, since an area
	                        // path starts at left, follows the upper path then turns and
	                        // follows the bottom back. 
	                        slice = arr.slice().splice(
	                            (arr.length / positionFactor) - numParams,
	                            numParams * positionFactor
	                        );
	
	                        // Move to, line to or curve to?
	                        slice[0] = other[fullLength - numParams - (i * numParams)];
	
	                        // Disable first control point
	                        if (bezier) {
	                            slice[numParams - 6] = slice[numParams - 2];
	                            slice[numParams - 5] = slice[numParams - 1];
	                        }
	
	                        // Now insert the slice, either in the middle (for areas) or at
	                        // the end (for lines)
	                        insertSlice(arr, slice, arr.length / positionFactor);
	
	                        if (isArea) {
	                            i--;
	                        }
	                    }
	                }
	
	                if (bezier) {
	                    sixify(start);
	                    sixify(end);
	                }
	
	                // For sideways animation, find out how much we need to shift to get the
	                // start path Xs to match the end path Xs.
	                if (startX && endX) {
	                    for (i = 0; i < startX.length; i++) {
	                        // Moving left, new points coming in on right
	                        if (startX[i] === endX[0]) {
	                            shift = i;
	                            break;
	                            // Moving right
	                        } else if (startX[0] ===
	                            endX[endX.length - startX.length + i]) {
	                            shift = i;
	                            reverse = true;
	                            break;
	                        }
	                    }
	                    if (shift === undefined) {
	                        start = [];
	                    }
	                }
	
	                if (start.length && H.isNumber(shift)) {
	
	                    // The common target length for the start and end array, where both 
	                    // arrays are padded in opposite ends
	                    fullLength = end.length + shift * positionFactor * numParams;
	
	                    if (!reverse) {
	                        prepend(end, start);
	                        append(start, end);
	                    } else {
	                        prepend(start, end);
	                        append(end, start);
	                    }
	                }
	
	                return [start, end];
	            }
	        }; // End of Fx prototype
	
	        /**
	         * Handle animation of the color attributes directly.
	         */
	        H.Fx.prototype.fillSetter =
	            H.Fx.prototype.strokeSetter = function() {
	                this.elem.attr(
	                    this.prop,
	                    H.color(this.start).tweenTo(H.color(this.end), this.pos),
	                    null,
	                    true
	                );
	            };
	
	
	        /**
	         * Utility function to extend an object with the members of another.
	         *
	         * @function #extend
	         * @memberOf Highcharts
	         * @param {Object} a - The object to be extended.
	         * @param {Object} b - The object to add to the first one.
	         * @returns {Object} Object a, the original object.
	         */
	        H.extend = function(a, b) {
	            var n;
	            if (!a) {
	                a = {};
	            }
	            for (n in b) {
	                a[n] = b[n];
	            }
	            return a;
	        };
	
	        /**
	         * Utility function to deep merge two or more objects and return a third object.
	         * If the first argument is true, the contents of the second object is copied
	         * into the first object. The merge function can also be used with a single 
	         * object argument to create a deep copy of an object.
	         *
	         * @function #merge
	         * @memberOf Highcharts
	         * @param {Boolean} [extend] - Whether to extend the left-side object (a) or
	                  return a whole new object.
	         * @param {Object} a - The first object to extend. When only this is given, the
	                  function returns a deep copy.
	         * @param {...Object} [n] - An object to merge into the previous one.
	         * @returns {Object} - The merged object. If the first argument is true, the 
	         * return is the same as the second argument.
	         */
	        H.merge = function() {
	            var i,
	                args = arguments,
	                len,
	                ret = {},
	                doCopy = function(copy, original) {
	                    // An object is replacing a primitive
	                    if (typeof copy !== 'object') {
	                        copy = {};
	                    }
	
	                    H.objectEach(original, function(value, key) {
	
	                        // Copy the contents of objects, but not arrays or DOM nodes
	                        if (
	                            H.isObject(value, true) &&
	                            !H.isClass(value) &&
	                            !H.isDOMElement(value)
	                        ) {
	                            copy[key] = doCopy(copy[key] || {}, value);
	
	                            // Primitives and arrays are copied over directly
	                        } else {
	                            copy[key] = original[key];
	                        }
	                    });
	                    return copy;
	                };
	
	            // If first argument is true, copy into the existing object. Used in
	            // setOptions.
	            if (args[0] === true) {
	                ret = args[1];
	                args = Array.prototype.slice.call(args, 2);
	            }
	
	            // For each argument, extend the return
	            len = args.length;
	            for (i = 0; i < len; i++) {
	                ret = doCopy(ret, args[i]);
	            }
	
	            return ret;
	        };
	
	        /**
	         * Shortcut for parseInt
	         * @ignore
	         * @param {Object} s
	         * @param {Number} mag Magnitude
	         */
	        H.pInt = function(s, mag) {
	            return parseInt(s, mag || 10);
	        };
	
	        /**
	         * Utility function to check for string type.
	         *
	         * @function #isString
	         * @memberOf Highcharts
	         * @param {Object} s - The item to check.
	         * @returns {Boolean} - True if the argument is a string.
	         */
	        H.isString = function(s) {
	            return typeof s === 'string';
	        };
	
	        /**
	         * Utility function to check if an item is an array.
	         *
	         * @function #isArray
	         * @memberOf Highcharts
	         * @param {Object} obj - The item to check.
	         * @returns {Boolean} - True if the argument is an array.
	         */
	        H.isArray = function(obj) {
	            var str = Object.prototype.toString.call(obj);
	            return str === '[object Array]' || str === '[object Array Iterator]';
	        };
	
	        /**
	         * Utility function to check if an item is of type object.
	         *
	         * @function #isObject
	         * @memberOf Highcharts
	         * @param {Object} obj - The item to check.
	         * @param {Boolean} [strict=false] - Also checks that the object is not an
	         *    array.
	         * @returns {Boolean} - True if the argument is an object.
	         */
	        H.isObject = function(obj, strict) {
	            return !!obj && typeof obj === 'object' && (!strict || !H.isArray(obj));
	        };
	
	        /**
	         * Utility function to check if an Object is a HTML Element.
	         *
	         * @function #isDOMElement
	         * @memberOf Highcharts
	         * @param {Object} obj - The item to check.
	         * @returns {Boolean} - True if the argument is a HTML Element.
	         */
	        H.isDOMElement = function(obj) {
	            return H.isObject(obj) && typeof obj.nodeType === 'number';
	        };
	
	        /**
	         * Utility function to check if an Object is an class.
	         *
	         * @function #isClass
	         * @memberOf Highcharts
	         * @param {Object} obj - The item to check.
	         * @returns {Boolean} - True if the argument is an class.
	         */
	        H.isClass = function(obj) {
	            var c = obj && obj.constructor;
	            return !!(
	                H.isObject(obj, true) &&
	                !H.isDOMElement(obj) &&
	                (c && c.name && c.name !== 'Object')
	            );
	        };
	
	        /**
	         * Utility function to check if an item is of type number.
	         *
	         * @function #isNumber
	         * @memberOf Highcharts
	         * @param {Object} n - The item to check.
	         * @returns {Boolean} - True if the item is a number and is not NaN.
	         */
	        H.isNumber = function(n) {
	            return typeof n === 'number' && !isNaN(n);
	        };
	
	        /**
	         * Remove the last occurence of an item from an array.
	         *
	         * @function #erase
	         * @memberOf Highcharts
	         * @param {Array} arr - The array.
	         * @param {*} item - The item to remove.
	         */
	        H.erase = function(arr, item) {
	            var i = arr.length;
	            while (i--) {
	                if (arr[i] === item) {
	                    arr.splice(i, 1);
	                    break;
	                }
	            }
	        };
	
	        /**
	         * Check if an object is null or undefined.
	         *
	         * @function #defined
	         * @memberOf Highcharts
	         * @param {Object} obj - The object to check.
	         * @returns {Boolean} - False if the object is null or undefined, otherwise
	         *        true.
	         */
	        H.defined = function(obj) {
	            return obj !== undefined && obj !== null;
	        };
	
	        /**
	         * Set or get an attribute or an object of attributes. To use as a setter, pass
	         * a key and a value, or let the second argument be a collection of keys and
	         * values. To use as a getter, pass only a string as the second argument.
	         *
	         * @function #attr
	         * @memberOf Highcharts
	         * @param {Object} elem - The DOM element to receive the attribute(s).
	         * @param {String|Object} [prop] - The property or an object of key-value pairs.
	         * @param {String} [value] - The value if a single property is set.
	         * @returns {*} When used as a getter, return the value.
	         */
	        H.attr = function(elem, prop, value) {
	            var ret;
	
	            // if the prop is a string
	            if (H.isString(prop)) {
	                // set the value
	                if (H.defined(value)) {
	                    elem.setAttribute(prop, value);
	
	                    // get the value
	                } else if (elem && elem.getAttribute) {
	                    ret = elem.getAttribute(prop);
	                }
	
	                // else if prop is defined, it is a hash of key/value pairs
	            } else if (H.defined(prop) && H.isObject(prop)) {
	                H.objectEach(prop, function(val, key) {
	                    elem.setAttribute(key, val);
	                });
	            }
	            return ret;
	        };
	
	        /**
	         * Check if an element is an array, and if not, make it into an array.
	         *
	         * @function #splat
	         * @memberOf Highcharts
	         * @param obj {*} - The object to splat.
	         * @returns {Array} The produced or original array.
	         */
	        H.splat = function(obj) {
	            return H.isArray(obj) ? obj : [obj];
	        };
	
	        /**
	         * Set a timeout if the delay is given, otherwise perform the function
	         * synchronously.
	         *
	         * @function #syncTimeout
	         * @memberOf Highcharts
	         * @param   {Function} fn - The function callback.
	         * @param   {Number}   delay - Delay in milliseconds.
	         * @param   {Object}   [context] - The context.
	         * @returns {Number} An identifier for the timeout that can later be cleared
	         * with clearTimeout.
	         */
	        H.syncTimeout = function(fn, delay, context) {
	            if (delay) {
	                return setTimeout(fn, delay, context);
	            }
	            fn.call(0, context);
	        };
	
	
	        /**
	         * Return the first value that is not null or undefined.
	         *
	         * @function #pick
	         * @memberOf Highcharts
	         * @param {...*} items - Variable number of arguments to inspect.
	         * @returns {*} The value of the first argument that is not null or undefined.
	         */
	        H.pick = function() {
	            var args = arguments,
	                i,
	                arg,
	                length = args.length;
	            for (i = 0; i < length; i++) {
	                arg = args[i];
	                if (arg !== undefined && arg !== null) {
	                    return arg;
	                }
	            }
	        };
	
	        /**
	         * @typedef {Object} CSSObject - A style object with camel case property names.
	         * The properties can be whatever styles are supported on the given SVG or HTML
	         * element.
	         * @example
	         * {
	         *    fontFamily: 'monospace',
	         *    fontSize: '1.2em'
	         * }
	         */
	        /**
	         * Set CSS on a given element.
	         *
	         * @function #css
	         * @memberOf Highcharts
	         * @param {HTMLDOMElement} el - A HTML DOM element.
	         * @param {CSSObject} styles - Style object with camel case property names.
	         * 
	         */
	        H.css = function(el, styles) {
	            if (H.isMS && !H.svg) { // #2686
	                if (styles && styles.opacity !== undefined) {
	                    styles.filter = 'alpha(opacity=' + (styles.opacity * 100) + ')';
	                }
	            }
	            H.extend(el.style, styles);
	        };
	
	        /**
	         * A HTML DOM element.
	         * @typedef {Object} HTMLDOMElement
	         */
	
	        /**
	         * Utility function to create an HTML element with attributes and styles.
	         *
	         * @function #createElement
	         * @memberOf Highcharts
	         * @param {String} tag - The HTML tag.
	         * @param {Object} [attribs] - Attributes as an object of key-value pairs.
	         * @param {CSSObject} [styles] - Styles as an object of key-value pairs.
	         * @param {Object} [parent] - The parent HTML object.
	         * @param {Boolean} [nopad=false] - If true, remove all padding, border and
	         *    margin.
	         * @returns {HTMLDOMElement} The created DOM element.
	         */
	        H.createElement = function(tag, attribs, styles, parent, nopad) {
	            var el = doc.createElement(tag),
	                css = H.css;
	            if (attribs) {
	                H.extend(el, attribs);
	            }
	            if (nopad) {
	                css(el, {
	                    padding: 0,
	                    border: 'none',
	                    margin: 0
	                });
	            }
	            if (styles) {
	                css(el, styles);
	            }
	            if (parent) {
	                parent.appendChild(el);
	            }
	            return el;
	        };
	
	        /**
	         * Extend a prototyped class by new members.
	         *
	         * @function #extendClass
	         * @memberOf Highcharts
	         * @param {Object} parent - The parent prototype to inherit.
	         * @param {Object} members - A collection of prototype members to add or
	         *        override compared to the parent prototype.
	         * @returns {Object} A new prototype.
	         */
	        H.extendClass = function(parent, members) {
	            var object = function() {};
	            object.prototype = new parent(); // eslint-disable-line new-cap
	            H.extend(object.prototype, members);
	            return object;
	        };
	
	        /**
	         * Left-pad a string to a given length by adding a character repetetively.
	         *
	         * @function #pad
	         * @memberOf Highcharts
	         * @param {Number} number - The input string or number.
	         * @param {Number} length - The desired string length.
	         * @param {String} [padder=0] - The character to pad with.
	         * @returns {String} The padded string.
	         */
	        H.pad = function(number, length, padder) {
	            return new Array((length || 2) + 1 -
	                String(number).length).join(padder || 0) + number;
	        };
	
	        /**
	         * @typedef {Number|String} RelativeSize - If a number is given, it defines the
	         *    pixel length. If a percentage string is given, like for example `'50%'`,
	         *    the setting defines a length relative to a base size, for example the size
	         *    of a container.
	         */
	        /**
	         * Return a length based on either the integer value, or a percentage of a base.
	         *
	         * @function #relativeLength
	         * @memberOf Highcharts
	         * @param  {RelativeSize} value
	         *         A percentage string or a number.
	         * @param  {number} base
	         *         The full length that represents 100%.
	         * @param  {number} [offset=0]
	         *         A pixel offset to apply for percentage values. Used internally in 
	         *         axis positioning.
	         * @return {number}
	         *         The computed length.
	         */
	        H.relativeLength = function(value, base, offset) {
	            return (/%$/).test(value) ?
	                (base * parseFloat(value) / 100) + (offset || 0) :
	                parseFloat(value);
	        };
	
	        /**
	         * Wrap a method with extended functionality, preserving the original function.
	         *
	         * @function #wrap
	         * @memberOf Highcharts
	         * @param {Object} obj - The context object that the method belongs to. In real
	         *        cases, this is often a prototype.
	         * @param {String} method - The name of the method to extend.
	         * @param {Function} func - A wrapper function callback. This function is called
	         *        with the same arguments as the original function, except that the
	         *        original function is unshifted and passed as the first argument.
	         * 
	         */
	        H.wrap = function(obj, method, func) {
	            var proceed = obj[method];
	            obj[method] = function() {
	                var args = Array.prototype.slice.call(arguments),
	                    outerArgs = arguments,
	                    ctx = this,
	                    ret;
	                ctx.proceed = function() {
	                    proceed.apply(ctx, arguments.length ? arguments : outerArgs);
	                };
	                args.unshift(proceed);
	                ret = func.apply(this, args);
	                ctx.proceed = null;
	                return ret;
	            };
	        };
	
	        /**
	         * Get the time zone offset based on the current timezone information as set in
	         * the global options.
	         *
	         * @function #getTZOffset
	         * @memberOf Highcharts
	         * @param  {Number} timestamp - The JavaScript timestamp to inspect.
	         * @return {Number} - The timezone offset in minutes compared to UTC.
	         */
	        H.getTZOffset = function(timestamp) {
	            var d = H.Date;
	            return ((d.hcGetTimezoneOffset && d.hcGetTimezoneOffset(timestamp)) ||
	                d.hcTimezoneOffset || 0) * 60000;
	        };
	
	        /**
	         * Formats a JavaScript date timestamp (milliseconds since Jan 1st 1970) into a
	         * human readable date string. The format is a subset of the formats for PHP's
	         * [strftime]{@link
	         * http://www.php.net/manual/en/function.strftime.php} function. Additional
	         * formats can be given in the {@link Highcharts.dateFormats} hook.
	         *
	         * @function #dateFormat
	         * @memberOf Highcharts
	         * @param {String} format - The desired format where various time
	         *        representations are prefixed with %.
	         * @param {Number} timestamp - The JavaScript timestamp.
	         * @param {Boolean} [capitalize=false] - Upper case first letter in the return.
	         * @returns {String} The formatted date.
	         */
	        H.dateFormat = function(format, timestamp, capitalize) {
	            if (!H.defined(timestamp) || isNaN(timestamp)) {
	                return H.defaultOptions.lang.invalidDate || '';
	            }
	            format = H.pick(format, '%Y-%m-%d %H:%M:%S');
	
	            var D = H.Date,
	                date = new D(timestamp - H.getTZOffset(timestamp)),
	                // get the basic time values
	                hours = date[D.hcGetHours](),
	                day = date[D.hcGetDay](),
	                dayOfMonth = date[D.hcGetDate](),
	                month = date[D.hcGetMonth](),
	                fullYear = date[D.hcGetFullYear](),
	                lang = H.defaultOptions.lang,
	                langWeekdays = lang.weekdays,
	                shortWeekdays = lang.shortWeekdays,
	                pad = H.pad,
	
	                // List all format keys. Custom formats can be added from the outside. 
	                replacements = H.extend({
	
	                        //-- Day
	                        // Short weekday, like 'Mon'
	                        'a': shortWeekdays ?
	                            shortWeekdays[day] : langWeekdays[day].substr(0, 3),
	                        // Long weekday, like 'Monday'
	                        'A': langWeekdays[day],
	                        // Two digit day of the month, 01 to 31
	                        'd': pad(dayOfMonth),
	                        // Day of the month, 1 through 31
	                        'e': pad(dayOfMonth, 2, ' '),
	                        'w': day,
	
	                        // Week (none implemented)
	                        //'W': weekNumber(),
	
	                        //-- Month
	                        // Short month, like 'Jan'
	                        'b': lang.shortMonths[month],
	                        // Long month, like 'January'
	                        'B': lang.months[month],
	                        // Two digit month number, 01 through 12
	                        'm': pad(month + 1),
	
	                        //-- Year
	                        // Two digits year, like 09 for 2009
	                        'y': fullYear.toString().substr(2, 2),
	                        // Four digits year, like 2009
	                        'Y': fullYear,
	
	                        //-- Time
	                        // Two digits hours in 24h format, 00 through 23
	                        'H': pad(hours),
	                        // Hours in 24h format, 0 through 23
	                        'k': hours,
	                        // Two digits hours in 12h format, 00 through 11
	                        'I': pad((hours % 12) || 12),
	                        // Hours in 12h format, 1 through 12
	                        'l': (hours % 12) || 12,
	                        // Two digits minutes, 00 through 59
	                        'M': pad(date[D.hcGetMinutes]()),
	                        // Upper case AM or PM
	                        'p': hours < 12 ? 'AM' : 'PM',
	                        // Lower case AM or PM
	                        'P': hours < 12 ? 'am' : 'pm',
	                        // Two digits seconds, 00 through  59
	                        'S': pad(date.getSeconds()),
	                        // Milliseconds (naming from Ruby)
	                        'L': pad(Math.round(timestamp % 1000), 3)
	                    },
	
	                    /**
	                     * A hook for defining additional date format specifiers. New
	                     * specifiers are defined as key-value pairs by using the specifier
	                     * as key, and a function which takes the timestamp as value. This
	                     * function returns the formatted portion of the date.
	                     *
	                     * @type {Object}
	                     * @name dateFormats
	                     * @memberOf Highcharts
	                     * @sample highcharts/global/dateformats/ Adding support for week
	                     * number
	                     */
	                    H.dateFormats
	                );
	
	
	            // Do the replaces
	            H.objectEach(replacements, function(val, key) {
	                // Regex would do it in one line, but this is faster
	                while (format.indexOf('%' + key) !== -1) {
	                    format = format.replace(
	                        '%' + key,
	                        typeof val === 'function' ? val(timestamp) : val
	                    );
	                }
	
	            });
	
	            // Optionally capitalize the string and return
	            return capitalize ?
	                format.substr(0, 1).toUpperCase() + format.substr(1) :
	                format;
	        };
	
	        /**
	         * Format a single variable. Similar to sprintf, without the % prefix.
	         *
	         * @example
	         * formatSingle('.2f', 5); // => '5.00'.
	         *
	         * @function #formatSingle
	         * @memberOf Highcharts
	         * @param {String} format The format string.
	         * @param {*} val The value.
	         * @returns {String} The formatted representation of the value.
	         */
	        H.formatSingle = function(format, val) {
	            var floatRegex = /f$/,
	                decRegex = /\.([0-9])/,
	                lang = H.defaultOptions.lang,
	                decimals;
	
	            if (floatRegex.test(format)) { // float
	                decimals = format.match(decRegex);
	                decimals = decimals ? decimals[1] : -1;
	                if (val !== null) {
	                    val = H.numberFormat(
	                        val,
	                        decimals,
	                        lang.decimalPoint,
	                        format.indexOf(',') > -1 ? lang.thousandsSep : ''
	                    );
	                }
	            } else {
	                val = H.dateFormat(format, val);
	            }
	            return val;
	        };
	
	        /**
	         * Format a string according to a subset of the rules of Python's String.format
	         * method.
	         *
	         * @function #format
	         * @memberOf Highcharts
	         * @param {String} str The string to format.
	         * @param {Object} ctx The context, a collection of key-value pairs where each
	         *        key is replaced by its value.
	         * @returns {String} The formatted string.
	         *
	         * @example
	         * var s = Highcharts.format(
	         *     'The {color} fox was {len:.2f} feet long',
	         *     { color: 'red', len: Math.PI }
	         * );
	         * // => The red fox was 3.14 feet long
	         */
	        H.format = function(str, ctx) {
	            var splitter = '{',
	                isInside = false,
	                segment,
	                valueAndFormat,
	                path,
	                i,
	                len,
	                ret = [],
	                val,
	                index;
	
	            while (str) {
	                index = str.indexOf(splitter);
	                if (index === -1) {
	                    break;
	                }
	
	                segment = str.slice(0, index);
	                if (isInside) { // we're on the closing bracket looking back
	
	                    valueAndFormat = segment.split(':');
	                    path = valueAndFormat.shift().split('.'); // get first and leave
	                    len = path.length;
	                    val = ctx;
	
	                    // Assign deeper paths
	                    for (i = 0; i < len; i++) {
	                        val = val[path[i]];
	                    }
	
	                    // Format the replacement
	                    if (valueAndFormat.length) {
	                        val = H.formatSingle(valueAndFormat.join(':'), val);
	                    }
	
	                    // Push the result and advance the cursor
	                    ret.push(val);
	
	                } else {
	                    ret.push(segment);
	
	                }
	                str = str.slice(index + 1); // the rest
	                isInside = !isInside; // toggle
	                splitter = isInside ? '}' : '{'; // now look for next matching bracket
	            }
	            ret.push(str);
	            return ret.join('');
	        };
	
	        /**
	         * Get the magnitude of a number.
	         *
	         * @function #getMagnitude
	         * @memberOf Highcharts
	         * @param {Number} number The number.
	         * @returns {Number} The magnitude, where 1-9 are magnitude 1, 10-99 magnitude 2
	         *        etc.
	         */
	        H.getMagnitude = function(num) {
	            return Math.pow(10, Math.floor(Math.log(num) / Math.LN10));
	        };
	
	        /**
	         * Take an interval and normalize it to multiples of round numbers.
	         *
	         * @todo  Move this function to the Axis prototype. It is here only for
	         *        historical reasons.
	         * @function #normalizeTickInterval
	         * @memberOf Highcharts
	         * @param {Number} interval - The raw, un-rounded interval.
	         * @param {Array} [multiples] - Allowed multiples.
	         * @param {Number} [magnitude] - The magnitude of the number.
	         * @param {Boolean} [allowDecimals] - Whether to allow decimals.
	         * @param {Boolean} [hasTickAmount] - If it has tickAmount, avoid landing
	         *        on tick intervals lower than original.
	         * @returns {Number} The normalized interval.
	         */
	        H.normalizeTickInterval = function(interval, multiples, magnitude,
	            allowDecimals, hasTickAmount) {
	            var normalized,
	                i,
	                retInterval = interval;
	
	            // round to a tenfold of 1, 2, 2.5 or 5
	            magnitude = H.pick(magnitude, 1);
	            normalized = interval / magnitude;
	
	            // multiples for a linear scale
	            if (!multiples) {
	                multiples = hasTickAmount ?
	                    // Finer grained ticks when the tick amount is hard set, including
	                    // when alignTicks is true on multiple axes (#4580).
	                    [1, 1.2, 1.5, 2, 2.5, 3, 4, 5, 6, 8, 10] :
	
	                    // Else, let ticks fall on rounder numbers
	                    [1, 2, 2.5, 5, 10];
	
	
	                // the allowDecimals option
	                if (allowDecimals === false) {
	                    if (magnitude === 1) {
	                        multiples = H.grep(multiples, function(num) {
	                            return num % 1 === 0;
	                        });
	                    } else if (magnitude <= 0.1) {
	                        multiples = [1 / magnitude];
	                    }
	                }
	            }
	
	            // normalize the interval to the nearest multiple
	            for (i = 0; i < multiples.length; i++) {
	                retInterval = multiples[i];
	                // only allow tick amounts smaller than natural
	                if ((hasTickAmount && retInterval * magnitude >= interval) ||
	                    (!hasTickAmount && (normalized <= (multiples[i] +
	                        (multiples[i + 1] || multiples[i])) / 2))) {
	                    break;
	                }
	            }
	
	            // Multiply back to the correct magnitude. Correct floats to appropriate 
	            // precision (#6085).
	            retInterval = H.correctFloat(
	                retInterval * magnitude, -Math.round(Math.log(0.001) / Math.LN10)
	            );
	
	            return retInterval;
	        };
	
	
	        /**
	         * Sort an object array and keep the order of equal items. The ECMAScript
	         * standard does not specify the behaviour when items are equal.
	         *
	         * @function #stableSort
	         * @memberOf Highcharts
	         * @param {Array} arr - The array to sort.
	         * @param {Function} sortFunction - The function to sort it with, like with 
	         *        regular Array.prototype.sort.
	         * 
	         */
	        H.stableSort = function(arr, sortFunction) {
	            var length = arr.length,
	                sortValue,
	                i;
	
	            // Add index to each item
	            for (i = 0; i < length; i++) {
	                arr[i].safeI = i; // stable sort index
	            }
	
	            arr.sort(function(a, b) {
	                sortValue = sortFunction(a, b);
	                return sortValue === 0 ? a.safeI - b.safeI : sortValue;
	            });
	
	            // Remove index from items
	            for (i = 0; i < length; i++) {
	                delete arr[i].safeI; // stable sort index
	            }
	        };
	
	        /**
	         * Non-recursive method to find the lowest member of an array. `Math.min` raises
	         * a maximum call stack size exceeded error in Chrome when trying to apply more
	         * than 150.000 points. This method is slightly slower, but safe.
	         *
	         * @function #arrayMin
	         * @memberOf  Highcharts
	         * @param {Array} data An array of numbers.
	         * @returns {Number} The lowest number.
	         */
	        H.arrayMin = function(data) {
	            var i = data.length,
	                min = data[0];
	
	            while (i--) {
	                if (data[i] < min) {
	                    min = data[i];
	                }
	            }
	            return min;
	        };
	
	        /**
	         * Non-recursive method to find the lowest member of an array. `Math.max` raises
	         * a maximum call stack size exceeded error in Chrome when trying to apply more
	         * than 150.000 points. This method is slightly slower, but safe.
	         *
	         * @function #arrayMax
	         * @memberOf  Highcharts
	         * @param {Array} data - An array of numbers.
	         * @returns {Number} The highest number.
	         */
	        H.arrayMax = function(data) {
	            var i = data.length,
	                max = data[0];
	
	            while (i--) {
	                if (data[i] > max) {
	                    max = data[i];
	                }
	            }
	            return max;
	        };
	
	        /**
	         * Utility method that destroys any SVGElement instances that are properties on
	         * the given object. It loops all properties and invokes destroy if there is a
	         * destroy method. The property is then delete.
	         *
	         * @function #destroyObjectProperties
	         * @memberOf Highcharts
	         * @param {Object} obj - The object to destroy properties on.
	         * @param {Object} [except] - Exception, do not destroy this property, only
	         *    delete it.
	         * 
	         */
	        H.destroyObjectProperties = function(obj, except) {
	            H.objectEach(obj, function(val, n) {
	                // If the object is non-null and destroy is defined
	                if (val && val !== except && val.destroy) {
	                    // Invoke the destroy
	                    val.destroy();
	                }
	
	                // Delete the property from the object.
	                delete obj[n];
	            });
	        };
	
	
	        /**
	         * Discard a HTML element by moving it to the bin and delete.
	         *
	         * @function #discardElement
	         * @memberOf Highcharts
	         * @param {HTMLDOMElement} element - The HTML node to discard.
	         * 
	         */
	        H.discardElement = function(element) {
	            var garbageBin = H.garbageBin;
	            // create a garbage bin element, not part of the DOM
	            if (!garbageBin) {
	                garbageBin = H.createElement('div');
	            }
	
	            // move the node and empty bin
	            if (element) {
	                garbageBin.appendChild(element);
	            }
	            garbageBin.innerHTML = '';
	        };
	
	        /**
	         * Fix JS round off float errors.
	         *
	         * @function #correctFloat
	         * @memberOf Highcharts
	         * @param {Number} num - A float number to fix.
	         * @param {Number} [prec=14] - The precision.
	         * @returns {Number} The corrected float number.
	         */
	        H.correctFloat = function(num, prec) {
	            return parseFloat(
	                num.toPrecision(prec || 14)
	            );
	        };
	
	        /**
	         * Set the global animation to either a given value, or fall back to the given
	         * chart's animation option.
	         *
	         * @function #setAnimation
	         * @memberOf Highcharts
	         * @param {Boolean|Animation} animation - The animation object.
	         * @param {Object} chart - The chart instance.
	         * 
	         * @todo This function always relates to a chart, and sets a property on the
	         *        renderer, so it should be moved to the SVGRenderer.
	         */
	        H.setAnimation = function(animation, chart) {
	            chart.renderer.globalAnimation = H.pick(
	                animation,
	                chart.options.chart.animation,
	                true
	            );
	        };
	
	        /**
	         * Get the animation in object form, where a disabled animation is always
	         * returned as `{ duration: 0 }`.
	         *
	         * @function #animObject
	         * @memberOf Highcharts
	         * @param {Boolean|AnimationOptions} animation - An animation setting. Can be an
	         *        object with duration, complete and easing properties, or a boolean to
	         *        enable or disable.
	         * @returns {AnimationOptions} An object with at least a duration property.
	         */
	        H.animObject = function(animation) {
	            return H.isObject(animation) ?
	                H.merge(animation) : {
	                    duration: animation ? 500 : 0
	                };
	        };
	
	        /**
	         * The time unit lookup
	         */
	        H.timeUnits = {
	            millisecond: 1,
	            second: 1000,
	            minute: 60000,
	            hour: 3600000,
	            day: 24 * 3600000,
	            week: 7 * 24 * 3600000,
	            month: 28 * 24 * 3600000,
	            year: 364 * 24 * 3600000
	        };
	
	        /**
	         * Format a number and return a string based on input settings.
	         *
	         * @function #numberFormat
	         * @memberOf Highcharts
	         * @param {Number} number - The input number to format.
	         * @param {Number} decimals - The amount of decimals. A value of -1 preserves
	         *        the amount in the input number.
	         * @param {String} [decimalPoint] - The decimal point, defaults to the one given
	         *        in the lang options, or a dot.
	         * @param {String} [thousandsSep] - The thousands separator, defaults to the one
	         *        given in the lang options, or a space character.
	         * @returns {String} The formatted number.
	         *
	         * @sample members/highcharts-numberformat/ Custom number format
	         */
	        H.numberFormat = function(number, decimals, decimalPoint, thousandsSep) {
	            number = +number || 0;
	            decimals = +decimals;
	
	            var lang = H.defaultOptions.lang,
	                origDec = (number.toString().split('.')[1] || '').split('e')[0].length,
	                strinteger,
	                thousands,
	                ret,
	                roundedNumber,
	                exponent = number.toString().split('e');
	
	            if (decimals === -1) {
	                // Preserve decimals. Not huge numbers (#3793).
	                decimals = Math.min(origDec, 20);
	            } else if (!H.isNumber(decimals)) {
	                decimals = 2;
	            }
	
	            // Add another decimal to avoid rounding errors of float numbers. (#4573)
	            // Then use toFixed to handle rounding.
	            roundedNumber = (
	                Math.abs(exponent[1] ? exponent[0] : number) +
	                Math.pow(10, -Math.max(decimals, origDec) - 1)
	            ).toFixed(decimals);
	
	            // A string containing the positive integer component of the number
	            strinteger = String(H.pInt(roundedNumber));
	
	            // Leftover after grouping into thousands. Can be 0, 1 or 3.
	            thousands = strinteger.length > 3 ? strinteger.length % 3 : 0;
	
	            // Language
	            decimalPoint = H.pick(decimalPoint, lang.decimalPoint);
	            thousandsSep = H.pick(thousandsSep, lang.thousandsSep);
	
	            // Start building the return
	            ret = number < 0 ? '-' : '';
	
	            // Add the leftover after grouping into thousands. For example, in the
	            // number 42 000 000, this line adds 42.
	            ret += thousands ? strinteger.substr(0, thousands) + thousandsSep : '';
	
	            // Add the remaining thousands groups, joined by the thousands separator
	            ret += strinteger
	                .substr(thousands)
	                .replace(/(\d{3})(?=\d)/g, '$1' + thousandsSep);
	
	            // Add the decimal point and the decimal component
	            if (decimals) {
	                // Get the decimal component
	                ret += decimalPoint + roundedNumber.slice(-decimals);
	            }
	
	            if (exponent[1]) {
	                ret += 'e' + exponent[1];
	            }
	
	            return ret;
	        };
	
	        /**
	         * Easing definition
	         * @ignore
	         * @param   {Number} pos Current position, ranging from 0 to 1.
	         */
	        Math.easeInOutSine = function(pos) {
	            return -0.5 * (Math.cos(Math.PI * pos) - 1);
	        };
	
	        /**
	         * Get the computed CSS value for given element and property, only for numerical
	         * properties. For width and height, the dimension of the inner box (excluding
	         * padding) is returned. Used for fitting the chart within the container.
	         *
	         * @function #getStyle
	         * @memberOf Highcharts
	         * @param {HTMLDOMElement} el - A HTML element.
	         * @param {String} prop - The property name.
	         * @param {Boolean} [toInt=true] - Parse to integer.
	         * @returns {Number} - The numeric value.
	         */
	        H.getStyle = function(el, prop, toInt) {
	
	            var style;
	
	            // For width and height, return the actual inner pixel size (#4913)
	            if (prop === 'width') {
	                return Math.min(el.offsetWidth, el.scrollWidth) -
	                    H.getStyle(el, 'padding-left') -
	                    H.getStyle(el, 'padding-right');
	            } else if (prop === 'height') {
	                return Math.min(el.offsetHeight, el.scrollHeight) -
	                    H.getStyle(el, 'padding-top') -
	                    H.getStyle(el, 'padding-bottom');
	            }
	
	            // Otherwise, get the computed style
	            style = win.getComputedStyle(el, undefined);
	            if (style) {
	                style = style.getPropertyValue(prop);
	                if (H.pick(toInt, true)) {
	                    style = H.pInt(style);
	                }
	            }
	            return style;
	        };
	
	        /**
	         * Search for an item in an array.
	         *
	         * @function #inArray
	         * @memberOf Highcharts
	         * @param {*} item - The item to search for.
	         * @param {arr} arr - The array or node collection to search in.
	         * @returns {Number} - The index within the array, or -1 if not found.
	         */
	        H.inArray = function(item, arr) {
	            return arr.indexOf ? arr.indexOf(item) : [].indexOf.call(arr, item);
	        };
	
	        /**
	         * Filter an array by a callback.
	         *
	         * @function #grep
	         * @memberOf Highcharts
	         * @param {Array} arr - The array to filter.
	         * @param {Function} callback - The callback function. The function receives the
	         *        item as the first argument. Return `true` if the item is to be
	         *        preserved.
	         * @returns {Array} - A new, filtered array.
	         */
	        H.grep = function(arr, callback) {
	            return [].filter.call(arr, callback);
	        };
	
	        /**
	         * Return the value of the first element in the array that satisfies the 
	         * provided testing function.
	         *
	         * @function #find
	         * @memberOf Highcharts
	         * @param {Array} arr - The array to test.
	         * @param {Function} callback - The callback function. The function receives the
	         *        item as the first argument. Return `true` if this item satisfies the
	         *        condition.
	         * @returns {Mixed} - The value of the element.
	         */
	        H.find = function(arr, callback) {
	            return [].find.call(arr, callback);
	        };
	
	        /**
	         * Map an array by a callback.
	         *
	         * @function #map
	         * @memberOf Highcharts
	         * @param {Array} arr - The array to map.
	         * @param {Function} fn - The callback function. Return the new value for the 
	         *        new array.
	         * @returns {Array} - A new array item with modified items.
	         */
	        H.map = function(arr, fn) {
	            var results = [],
	                i = 0,
	                len = arr.length;
	
	            for (; i < len; i++) {
	                results[i] = fn.call(arr[i], arr[i], i, arr);
	            }
	
	            return results;
	        };
	
	        /**
	         * Get the element's offset position, corrected for `overflow: auto`.
	         *
	         * @function #offset
	         * @memberOf Highcharts
	         * @param {HTMLDOMElement} el - The HTML element.
	         * @returns {Object} An object containing `left` and `top` properties for the
	         * position in the page.
	         */
	        H.offset = function(el) {
	            var docElem = doc.documentElement,
	                box = el.getBoundingClientRect();
	
	            return {
	                top: box.top + (win.pageYOffset || docElem.scrollTop) -
	                    (docElem.clientTop || 0),
	                left: box.left + (win.pageXOffset || docElem.scrollLeft) -
	                    (docElem.clientLeft || 0)
	            };
	        };
	
	        /**
	         * Stop running animation.
	         *
	         * @todo A possible extension to this would be to stop a single property, when
	         * we want to continue animating others. Then assign the prop to the timer
	         * in the Fx.run method, and check for the prop here. This would be an
	         * improvement in all cases where we stop the animation from .attr. Instead of
	         * stopping everything, we can just stop the actual attributes we're setting.
	         *
	         * @function #stop
	         * @memberOf Highcharts
	         * @param {SVGElement} el - The SVGElement to stop animation on.
	         * @param {string} [prop] - The property to stop animating. If given, the stop
	         *    method will stop a single property from animating, while others continue.
	         * 
	         */
	        H.stop = function(el, prop) {
	
	            var i = timers.length;
	
	            // Remove timers related to this element (#4519)
	            while (i--) {
	                if (timers[i].elem === el && (!prop || prop === timers[i].prop)) {
	                    timers[i].stopped = true; // #4667
	                }
	            }
	        };
	
	        /**
	         * Iterate over an array.
	         *
	         * @function #each
	         * @memberOf Highcharts
	         * @param {Array} arr - The array to iterate over.
	         * @param {Function} fn - The iterator callback. It passes three arguments:
	         * * item - The array item.
	         * * index - The item's index in the array.
	         * * arr - The array that each is being applied to.
	         * @param {Object} [ctx] The context.
	         */
	        H.each = function(arr, fn, ctx) { // modern browsers
	            return Array.prototype.forEach.call(arr, fn, ctx);
	        };
	
	        /**
	         * Iterate over object key pairs in an object.
	         *
	         * @function #objectEach
	         * @memberOf Highcharts
	         * @param  {Object}   obj - The object to iterate over.
	         * @param  {Function} fn  - The iterator callback. It passes three arguments:
	         * * value - The property value.
	         * * key - The property key.
	         * * obj - The object that objectEach is being applied to.
	         * @param  {Object}   ctx The context
	         */
	        H.objectEach = function(obj, fn, ctx) {
	            for (var key in obj) {
	                if (obj.hasOwnProperty(key)) {
	                    fn.call(ctx, obj[key], key, obj);
	                }
	            }
	        };
	
	        /**
	         * Add an event listener.
	         *
	         * @function #addEvent
	         * @memberOf Highcharts
	         * @param {Object} el - The element or object to add a listener to. It can be a
	         *        {@link HTMLDOMElement}, an {@link SVGElement} or any other object.
	         * @param {String} type - The event type.
	         * @param {Function} fn - The function callback to execute when the event is 
	         *        fired.
	         * @returns {Function} A callback function to remove the added event.
	         */
	        H.addEvent = function(el, type, fn) {
	
	            var events = el.hcEvents = el.hcEvents || {};
	
	            function wrappedFn(e) {
	                e.target = e.srcElement || win; // #2820
	                fn.call(el, e);
	            }
	
	            // Handle DOM events in modern browsers
	            if (el.addEventListener) {
	                el.addEventListener(type, fn, false);
	
	                // Handle old IE implementation
	            } else if (el.attachEvent) {
	
	                if (!el.hcEventsIE) {
	                    el.hcEventsIE = {};
	                }
	
	                // unique function string (#6746)
	                if (!fn.hcGetKey) {
	                    fn.hcGetKey = H.uniqueKey();
	                }
	
	                // Link wrapped fn with original fn, so we can get this in removeEvent
	                el.hcEventsIE[fn.hcGetKey] = wrappedFn;
	
	                el.attachEvent('on' + type, wrappedFn);
	            }
	
	            if (!events[type]) {
	                events[type] = [];
	            }
	
	            events[type].push(fn);
	
	            // Return a function that can be called to remove this event.
	            return function() {
	                H.removeEvent(el, type, fn);
	            };
	        };
	
	        /**
	         * Remove an event that was added with {@link Highcharts#addEvent}.
	         *
	         * @function #removeEvent
	         * @memberOf Highcharts
	         * @param {Object} el - The element to remove events on.
	         * @param {String} [type] - The type of events to remove. If undefined, all
	         *        events are removed from the element.
	         * @param {Function} [fn] - The specific callback to remove. If undefined, all
	         *        events that match the element and optionally the type are removed.
	         * 
	         */
	        H.removeEvent = function(el, type, fn) {
	
	            var events,
	                hcEvents = el.hcEvents,
	                index;
	
	            function removeOneEvent(type, fn) {
	                if (el.removeEventListener) {
	                    el.removeEventListener(type, fn, false);
	                } else if (el.attachEvent) {
	                    fn = el.hcEventsIE[fn.hcGetKey];
	                    el.detachEvent('on' + type, fn);
	                }
	            }
	
	            function removeAllEvents() {
	                var types,
	                    len;
	
	                if (!el.nodeName) {
	                    return; // break on non-DOM events
	                }
	
	                if (type) {
	                    types = {};
	                    types[type] = true;
	                } else {
	                    types = hcEvents;
	                }
	
	                H.objectEach(types, function(val, n) {
	                    if (hcEvents[n]) {
	                        len = hcEvents[n].length;
	                        while (len--) {
	                            removeOneEvent(n, hcEvents[n][len]);
	                        }
	                    }
	                });
	            }
	
	            if (hcEvents) {
	                if (type) {
	                    events = hcEvents[type] || [];
	                    if (fn) {
	                        index = H.inArray(fn, events);
	                        if (index > -1) {
	                            events.splice(index, 1);
	                            hcEvents[type] = events;
	                        }
	                        removeOneEvent(type, fn);
	
	                    } else {
	                        removeAllEvents();
	                        hcEvents[type] = [];
	                    }
	                } else {
	                    removeAllEvents();
	                    el.hcEvents = {};
	                }
	            }
	        };
	
	        /**
	         * Fire an event that was registered with {@link Highcharts#addEvent}.
	         *
	         * @function #fireEvent
	         * @memberOf Highcharts
	         * @param {Object} el - The object to fire the event on. It can be a
	         *        {@link HTMLDOMElement}, an {@link SVGElement} or any other object.
	         * @param {String} type - The type of event.
	         * @param {Object} [eventArguments] - Custom event arguments that are passed on
	         *        as an argument to the event handler.
	         * @param {Function} [defaultFunction] - The default function to execute if the 
	         *        other listeners haven't returned false.
	         * 
	         */
	        H.fireEvent = function(el, type, eventArguments, defaultFunction) {
	            var e,
	                hcEvents = el.hcEvents,
	                events,
	                len,
	                i,
	                fn;
	
	            eventArguments = eventArguments || {};
	
	            if (doc.createEvent && (el.dispatchEvent || el.fireEvent)) {
	                e = doc.createEvent('Events');
	                e.initEvent(type, true, true);
	                //e.target = el;
	
	                H.extend(e, eventArguments);
	
	                if (el.dispatchEvent) {
	                    el.dispatchEvent(e);
	                } else {
	                    el.fireEvent(type, e);
	                }
	
	            } else if (hcEvents) {
	
	                events = hcEvents[type] || [];
	                len = events.length;
	
	                if (!eventArguments.target) { // We're running a custom event
	
	                    H.extend(eventArguments, {
	                        // Attach a simple preventDefault function to skip default
	                        // handler if called. The built-in defaultPrevented property is
	                        // not overwritable (#5112)
	                        preventDefault: function() {
	                            eventArguments.defaultPrevented = true;
	                        },
	                        // Setting target to native events fails with clicking the
	                        // zoom-out button in Chrome.
	                        target: el,
	                        // If the type is not set, we're running a custom event (#2297).
	                        // If it is set, we're running a browser event, and setting it
	                        // will cause en error in IE8 (#2465).		
	                        type: type
	                    });
	                }
	
	
	                for (i = 0; i < len; i++) {
	                    fn = events[i];
	
	                    // If the event handler return false, prevent the default handler
	                    // from executing
	                    if (fn && fn.call(el, eventArguments) === false) {
	                        eventArguments.preventDefault();
	                    }
	                }
	            }
	
	            // Run the default if not prevented
	            if (defaultFunction && !eventArguments.defaultPrevented) {
	                defaultFunction(eventArguments);
	            }
	        };
	
	        /**
	         * An animation configuration. Animation configurations can also be defined as
	         * booleans, where `false` turns off animation and `true` defaults to a duration
	         * of 500ms.
	         * @typedef {Object} AnimationOptions
	         * @property {Number} duration - The animation duration in milliseconds.
	         * @property {String} [easing] - The name of an easing function as defined on
	         *     the `Math` object.
	         * @property {Function} [complete] - A callback function to exectute when the
	         *     animation finishes.
	         * @property {Function} [step] - A callback function to execute on each step of
	         *     each attribute or CSS property that's being animated. The first argument
	         *     contains information about the animation and progress.
	         */
	
	
	        /**
	         * The global animate method, which uses Fx to create individual animators.
	         *
	         * @function #animate
	         * @memberOf Highcharts
	         * @param {HTMLDOMElement|SVGElement} el - The element to animate.
	         * @param {Object} params - An object containing key-value pairs of the
	         *        properties to animate. Supports numeric as pixel-based CSS properties
	         *        for HTML objects and attributes for SVGElements.
	         * @param {AnimationOptions} [opt] - Animation options.
	         */
	        H.animate = function(el, params, opt) {
	            var start,
	                unit = '',
	                end,
	                fx,
	                args;
	
	            if (!H.isObject(opt)) { // Number or undefined/null
	                args = arguments;
	                opt = {
	                    duration: args[2],
	                    easing: args[3],
	                    complete: args[4]
	                };
	            }
	            if (!H.isNumber(opt.duration)) {
	                opt.duration = 400;
	            }
	            opt.easing = typeof opt.easing === 'function' ?
	                opt.easing :
	                (Math[opt.easing] || Math.easeInOutSine);
	            opt.curAnim = H.merge(params);
	
	            H.objectEach(params, function(val, prop) {
	                // Stop current running animation of this property
	                H.stop(el, prop);
	
	                fx = new H.Fx(el, opt, prop);
	                end = null;
	
	                if (prop === 'd') {
	                    fx.paths = fx.initPath(
	                        el,
	                        el.d,
	                        params.d
	                    );
	                    fx.toD = params.d;
	                    start = 0;
	                    end = 1;
	                } else if (el.attr) {
	                    start = el.attr(prop);
	                } else {
	                    start = parseFloat(H.getStyle(el, prop)) || 0;
	                    if (prop !== 'opacity') {
	                        unit = 'px';
	                    }
	                }
	
	                if (!end) {
	                    end = val;
	                }
	                if (end && end.match && end.match('px')) {
	                    end = end.replace(/px/g, ''); // #4351
	                }
	                fx.run(start, end, unit);
	            });
	        };
	
	        /**
	         * Factory to create new series prototypes.
	         *
	         * @function #seriesType
	         * @memberOf Highcharts
	         *
	         * @param {String} type - The series type name.
	         * @param {String} parent - The parent series type name. Use `line` to inherit
	         *        from the basic {@link Series} object.
	         * @param {Object} options - The additional default options that is merged with
	         *        the parent's options.
	         * @param {Object} props - The properties (functions and primitives) to set on
	         *        the new prototype.
	         * @param {Object} [pointProps] - Members for a series-specific extension of the
	         *        {@link Point} prototype if needed.
	         * @returns {*} - The newly created prototype as extended from {@link Series}
	         * or its derivatives.
	         */
	        // docs: add to API + extending Highcharts
	        H.seriesType = function(type, parent, options, props, pointProps) {
	            var defaultOptions = H.getOptions(),
	                seriesTypes = H.seriesTypes;
	
	            // Merge the options
	            defaultOptions.plotOptions[type] = H.merge(
	                defaultOptions.plotOptions[parent],
	                options
	            );
	
	            // Create the class
	            seriesTypes[type] = H.extendClass(seriesTypes[parent] ||
	                function() {}, props);
	            seriesTypes[type].prototype.type = type;
	
	            // Create the point class if needed
	            if (pointProps) {
	                seriesTypes[type].prototype.pointClass =
	                    H.extendClass(H.Point, pointProps);
	            }
	
	            return seriesTypes[type];
	        };
	
	        /**
	         * Get a unique key for using in internal element id's and pointers. The key
	         * is composed of a random hash specific to this Highcharts instance, and a 
	         * counter.
	         * @function #uniqueKey
	         * @memberOf Highcharts
	         * @return {string} The key.
	         * @example
	         * var id = H.uniqueKey(); // => 'highcharts-x45f6hp-0'
	         */
	        H.uniqueKey = (function() {
	
	            var uniqueKeyHash = Math.random().toString(36).substring(2, 9),
	                idCounter = 0;
	
	            return function() {
	                return 'highcharts-' + uniqueKeyHash + '-' + idCounter++;
	            };
	        }());
	
	        /**
	         * Register Highcharts as a plugin in jQuery
	         */
	        if (win.jQuery) {
	            win.jQuery.fn.highcharts = function() {
	                var args = [].slice.call(arguments);
	
	                if (this[0]) { // this[0] is the renderTo div
	
	                    // Create the chart
	                    if (args[0]) {
	                        new H[ // eslint-disable-line no-new
	                            // Constructor defaults to Chart
	                            H.isString(args[0]) ? args.shift() : 'Chart'
	                        ](this[0], args[0], args[1]);
	                        return this;
	                    }
	
	                    // When called without parameters or with the return argument,
	                    // return an existing chart
	                    return charts[H.attr(this[0], 'data-highcharts-chart')];
	                }
	            };
	        }
	
	
	        /**
	         * Compatibility section to add support for legacy IE. This can be removed if
	         * old IE support is not needed.
	         */
	        if (doc && !doc.defaultView) {
	            H.getStyle = function(el, prop) {
	                var val,
	                    alias = {
	                        width: 'clientWidth',
	                        height: 'clientHeight'
	                    }[prop];
	
	                if (el.style[prop]) {
	                    return H.pInt(el.style[prop]);
	                }
	                if (prop === 'opacity') {
	                    prop = 'filter';
	                }
	
	                // Getting the rendered width and height
	                if (alias) {
	                    el.style.zoom = 1;
	                    return Math.max(el[alias] - 2 * H.getStyle(el, 'padding'), 0);
	                }
	
	                val = el.currentStyle[prop.replace(/\-(\w)/g, function(a, b) {
	                    return b.toUpperCase();
	                })];
	                if (prop === 'filter') {
	                    val = val.replace(
	                        /alpha\(opacity=([0-9]+)\)/,
	                        function(a, b) {
	                            return b / 100;
	                        }
	                    );
	                }
	
	                return val === '' ? 1 : H.pInt(val);
	            };
	        }
	
	        if (!Array.prototype.forEach) {
	            H.each = function(arr, fn, ctx) { // legacy
	                var i = 0,
	                    len = arr.length;
	                for (; i < len; i++) {
	                    if (fn.call(ctx, arr[i], i, arr) === false) {
	                        return i;
	                    }
	                }
	            };
	        }
	
	        if (!Array.prototype.indexOf) {
	            H.inArray = function(item, arr) {
	                var len,
	                    i = 0;
	
	                if (arr) {
	                    len = arr.length;
	
	                    for (; i < len; i++) {
	                        if (arr[i] === item) {
	                            return i;
	                        }
	                    }
	                }
	
	                return -1;
	            };
	        }
	
	        if (!Array.prototype.filter) {
	            H.grep = function(elements, fn) {
	                var ret = [],
	                    i = 0,
	                    length = elements.length;
	
	                for (; i < length; i++) {
	                    if (fn(elements[i], i)) {
	                        ret.push(elements[i]);
	                    }
	                }
	
	                return ret;
	            };
	        }
	
	        if (!Array.prototype.find) {
	            H.find = function(arr, fn) {
	                var i,
	                    length = arr.length;
	
	                for (i = 0; i < length; i++) {
	                    if (fn(arr[i], i)) {
	                        return arr[i];
	                    }
	                }
	            };
	        }
	
	        //--- End compatibility section ---
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var each = H.each,
	            isNumber = H.isNumber,
	            map = H.map,
	            merge = H.merge,
	            pInt = H.pInt;
	
	        /**
	         * @typedef {string} ColorString
	         * A valid color to be parsed and handled by Highcharts. Highcharts internally 
	         * supports hex colors like `#ffffff`, rgb colors like `rgb(255,255,255)` and
	         * rgba colors like `rgba(255,255,255,1)`. Other colors may be supported by the
	         * browsers and displayed correctly, but Highcharts is not able to process them
	         * and apply concepts like opacity and brightening.
	         */
	        /**
	         * Handle color operations. The object methods are chainable.
	         * @param {String} input The input color in either rbga or hex format
	         */
	        H.Color = function(input) {
	            // Backwards compatibility, allow instanciation without new
	            if (!(this instanceof H.Color)) {
	                return new H.Color(input);
	            }
	            // Initialize
	            this.init(input);
	        };
	        H.Color.prototype = {
	
	            // Collection of parsers. This can be extended from the outside by pushing parsers
	            // to Highcharts.Color.prototype.parsers.
	            parsers: [{
	                // RGBA color
	                regex: /rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]?(?:\.[0-9]+)?)\s*\)/,
	                parse: function(result) {
	                    return [pInt(result[1]), pInt(result[2]), pInt(result[3]), parseFloat(result[4], 10)];
	                }
	            }, {
	                // RGB color
	                regex: /rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/,
	                parse: function(result) {
	                    return [pInt(result[1]), pInt(result[2]), pInt(result[3]), 1];
	                }
	            }],
	
	            // Collection of named colors. Can be extended from the outside by adding
	            // colors to Highcharts.Color.prototype.names.
	            names: {
	                none: 'rgba(255,255,255,0)',
	                white: '#ffffff',
	                black: '#000000'
	            },
	
	            /**
	             * Parse the input color to rgba array
	             * @param {String} input
	             */
	            init: function(input) {
	                var result,
	                    rgba,
	                    i,
	                    parser,
	                    len;
	
	                this.input = input = this.names[
	                    input && input.toLowerCase ?
	                    input.toLowerCase() :
	                    ''
	                ] || input;
	
	                // Gradients
	                if (input && input.stops) {
	                    this.stops = map(input.stops, function(stop) {
	                        return new H.Color(stop[1]);
	                    });
	
	                    // Solid colors
	                } else {
	
	                    // Bitmasking as input[0] is not working for legacy IE.
	                    if (input && input.charAt() === '#') {
	
	                        len = input.length;
	                        input = parseInt(input.substr(1), 16);
	
	                        // Handle long-form, e.g. #AABBCC
	                        if (len === 7) {
	
	                            rgba = [
	                                (input & 0xFF0000) >> 16,
	                                (input & 0xFF00) >> 8,
	                                (input & 0xFF),
	                                1
	                            ];
	
	                            // Handle short-form, e.g. #ABC
	                            // In short form, the value is assumed to be the same 
	                            // for both nibbles for each component. e.g. #ABC = #AABBCC
	                        } else if (len === 4) {
	
	                            rgba = [
	                                ((input & 0xF00) >> 4) | (input & 0xF00) >> 8,
	                                ((input & 0xF0) >> 4) | (input & 0xF0),
	                                ((input & 0xF) << 4) | (input & 0xF),
	                                1
	                            ];
	                        }
	                    }
	
	                    // Otherwise, check regex parsers
	                    if (!rgba) {
	                        i = this.parsers.length;
	                        while (i-- && !rgba) {
	                            parser = this.parsers[i];
	                            result = parser.regex.exec(input);
	                            if (result) {
	                                rgba = parser.parse(result);
	                            }
	                        }
	                    }
	                }
	                this.rgba = rgba || [];
	            },
	
	            /**
	             * Return the color a specified format
	             * @param {String} format
	             */
	            get: function(format) {
	                var input = this.input,
	                    rgba = this.rgba,
	                    ret;
	
	                if (this.stops) {
	                    ret = merge(input);
	                    ret.stops = [].concat(ret.stops);
	                    each(this.stops, function(stop, i) {
	                        ret.stops[i] = [ret.stops[i][0], stop.get(format)];
	                    });
	
	                    // it's NaN if gradient colors on a column chart
	                } else if (rgba && isNumber(rgba[0])) {
	                    if (format === 'rgb' || (!format && rgba[3] === 1)) {
	                        ret = 'rgb(' + rgba[0] + ',' + rgba[1] + ',' + rgba[2] + ')';
	                    } else if (format === 'a') {
	                        ret = rgba[3];
	                    } else {
	                        ret = 'rgba(' + rgba.join(',') + ')';
	                    }
	                } else {
	                    ret = input;
	                }
	                return ret;
	            },
	
	            /**
	             * Brighten the color
	             * @param {Number} alpha
	             */
	            brighten: function(alpha) {
	                var i,
	                    rgba = this.rgba;
	
	                if (this.stops) {
	                    each(this.stops, function(stop) {
	                        stop.brighten(alpha);
	                    });
	
	                } else if (isNumber(alpha) && alpha !== 0) {
	                    for (i = 0; i < 3; i++) {
	                        rgba[i] += pInt(alpha * 255);
	
	                        if (rgba[i] < 0) {
	                            rgba[i] = 0;
	                        }
	                        if (rgba[i] > 255) {
	                            rgba[i] = 255;
	                        }
	                    }
	                }
	                return this;
	            },
	
	            /**
	             * Set the color's opacity to a given alpha value
	             * @param {Number} alpha
	             */
	            setOpacity: function(alpha) {
	                this.rgba[3] = alpha;
	                return this;
	            },
	
	            /*
	             * Return an intermediate color between two colors.
	             *
	             * @param  {Highcharts.Color} to
	             *         The color object to tween to.
	             * @param  {Number} pos
	             *         The intermediate position, where 0 is the from color (current
	             *         color item), and 1 is the `to` color.
	             *
	             * @return {String}
	             *         The intermediate color in rgba notation.
	             */
	            tweenTo: function(to, pos) {
	                // Check for has alpha, because rgba colors perform worse due to lack of
	                // support in WebKit.
	                var from = this,
	                    hasAlpha,
	                    ret;
	
	                // Unsupported color, return to-color (#3920)
	                if (!to.rgba.length) {
	                    ret = to.input || 'none';
	
	                    // Interpolate
	                } else {
	                    from = from.rgba;
	                    to = to.rgba;
	                    hasAlpha = (to[3] !== 1 || from[3] !== 1);
	                    ret = (hasAlpha ? 'rgba(' : 'rgb(') +
	                        Math.round(to[0] + (from[0] - to[0]) * (1 - pos)) + ',' +
	                        Math.round(to[1] + (from[1] - to[1]) * (1 - pos)) + ',' +
	                        Math.round(to[2] + (from[2] - to[2]) * (1 - pos)) +
	                        (hasAlpha ?
	                            (',' + (to[3] + (from[3] - to[3]) * (1 - pos))) :
	                            '') + ')';
	                }
	                return ret;
	            }
	        };
	        H.color = function(input) {
	            return new H.Color(input);
	        };
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var SVGElement,
	            SVGRenderer,
	
	            addEvent = H.addEvent,
	            animate = H.animate,
	            attr = H.attr,
	            charts = H.charts,
	            color = H.color,
	            css = H.css,
	            createElement = H.createElement,
	            defined = H.defined,
	            deg2rad = H.deg2rad,
	            destroyObjectProperties = H.destroyObjectProperties,
	            doc = H.doc,
	            each = H.each,
	            extend = H.extend,
	            erase = H.erase,
	            grep = H.grep,
	            hasTouch = H.hasTouch,
	            inArray = H.inArray,
	            isArray = H.isArray,
	            isFirefox = H.isFirefox,
	            isMS = H.isMS,
	            isObject = H.isObject,
	            isString = H.isString,
	            isWebKit = H.isWebKit,
	            merge = H.merge,
	            noop = H.noop,
	            objectEach = H.objectEach,
	            pick = H.pick,
	            pInt = H.pInt,
	            removeEvent = H.removeEvent,
	            splat = H.splat,
	            stop = H.stop,
	            svg = H.svg,
	            SVG_NS = H.SVG_NS,
	            symbolSizes = H.symbolSizes,
	            win = H.win;
	
	        /**
	         * @typedef {Object} SVGDOMElement - An SVG DOM element.
	         */
	        /**
	         * The SVGElement prototype is a JavaScript wrapper for SVG elements used in the
	         * rendering layer of Highcharts. Combined with the {@link
	         * Highcharts.SVGRenderer} object, these prototypes allow freeform annotation
	         * in the charts or even in HTML pages without instanciating a chart. The
	         * SVGElement can also wrap HTML labels, when `text` or `label` elements are
	         * created with the `useHTML` parameter.
	         *
	         * The SVGElement instances are created through factory functions on the 
	         * {@link Highcharts.SVGRenderer} object, like
	         * [rect]{@link Highcharts.SVGRenderer#rect}, [path]{@link
	         * Highcharts.SVGRenderer#path}, [text]{@link Highcharts.SVGRenderer#text},
	         * [label]{@link Highcharts.SVGRenderer#label}, [g]{@link
	         * Highcharts.SVGRenderer#g} and more.
	         *
	         * @class Highcharts.SVGElement
	         */
	        SVGElement = H.SVGElement = function() {
	            return this;
	        };
	        extend(SVGElement.prototype, /** @lends Highcharts.SVGElement.prototype */ {
	
	            // Default base for animation
	            opacity: 1,
	            SVG_NS: SVG_NS,
	
	            /**
	             * For labels, these CSS properties are applied to the `text` node directly.
	             *
	             * @private
	             * @type {Array.<string>}
	             */
	            textProps: ['direction', 'fontSize', 'fontWeight', 'fontFamily',
	                'fontStyle', 'color', 'lineHeight', 'width', 'textAlign',
	                'textDecoration', 'textOverflow', 'textOutline'
	            ],
	
	            /**
	             * Initialize the SVG renderer. This function only exists to make the
	             * initiation process overridable. It should not be called directly.
	             *
	             * @param  {SVGRenderer} renderer
	             *         The SVGRenderer instance to initialize to.
	             * @param  {String} nodeName
	             *         The SVG node name.
	             * 
	             */
	            init: function(renderer, nodeName) {
	
	                /** 
	                 * The primary DOM node. Each `SVGElement` instance wraps a main DOM
	                 * node, but may also represent more nodes.
	                 *
	                 * @name  element
	                 * @memberOf SVGElement
	                 * @type {SVGDOMNode|HTMLDOMNode}
	                 */
	                this.element = nodeName === 'span' ?
	                    createElement(nodeName) :
	                    doc.createElementNS(this.SVG_NS, nodeName);
	
	                /**
	                 * The renderer that the SVGElement belongs to.
	                 *
	                 * @name renderer
	                 * @memberOf SVGElement
	                 * @type {SVGRenderer}
	                 */
	                this.renderer = renderer;
	            },
	
	            /**
	             * Animate to given attributes or CSS properties.
	             * 
	             * @param {SVGAttributes} params SVG attributes or CSS to animate.
	             * @param {AnimationOptions} [options] Animation options.
	             * @param {Function} [complete] Function to perform at the end of animation.
	             *
	             * @sample highcharts/members/element-on/
	             *         Setting some attributes by animation
	             * 
	             * @returns {SVGElement} Returns the SVGElement for chaining.
	             */
	            animate: function(params, options, complete) {
	                var animOptions = H.animObject(
	                    pick(options, this.renderer.globalAnimation, true)
	                );
	                if (animOptions.duration !== 0) {
	                    // allows using a callback with the global animation without
	                    // overwriting it
	                    if (complete) {
	                        animOptions.complete = complete;
	                    }
	                    animate(this, params, animOptions);
	                } else {
	                    this.attr(params, null, complete);
	                    if (animOptions.step) {
	                        animOptions.step.call(this);
	                    }
	                }
	                return this;
	            },
	
	            /**
	             * @typedef {Object} GradientOptions
	             * @property {Object} linearGradient Holds an object that defines the start
	             *    position and the end position relative to the shape.
	             * @property {Number} linearGradient.x1 Start horizontal position of the
	             *    gradient. Ranges 0-1.
	             * @property {Number} linearGradient.x2 End horizontal position of the
	             *    gradient. Ranges 0-1.
	             * @property {Number} linearGradient.y1 Start vertical position of the
	             *    gradient. Ranges 0-1.
	             * @property {Number} linearGradient.y2 End vertical position of the
	             *    gradient. Ranges 0-1.
	             * @property {Object} radialGradient Holds an object that defines the center
	             *    position and the radius.
	             * @property {Number} radialGradient.cx Center horizontal position relative
	             *    to the shape. Ranges 0-1.
	             * @property {Number} radialGradient.cy Center vertical position relative
	             *    to the shape. Ranges 0-1.
	             * @property {Number} radialGradient.r Radius relative to the shape. Ranges
	             *    0-1.
	             * @property {Array.<Array>} stops The first item in each tuple is the
	             *    position in the gradient, where 0 is the start of the gradient and 1
	             *    is the end of the gradient. Multiple stops can be applied. The second
	             *    item is the color for each stop. This color can also be given in the
	             *    rgba format.
	             *
	             * @example
	             * // Linear gradient used as a color option
	             * color: {
	             *     linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
	             *         stops: [
	             *             [0, '#003399'], // start
	             *             [0.5, '#ffffff'], // middle
	             *             [1, '#3366AA'] // end
	             *         ]
	             *     }
	             * }
	             */
	            /**
	             * Build and apply an SVG gradient out of a common JavaScript configuration
	             * object. This function is called from the attribute setters.
	             *
	             * @private
	             * @param {GradientOptions} color The gradient options structure.
	             * @param {string} prop The property to apply, can either be `fill` or
	             * `stroke`. 
	             * @param {SVGDOMElement} elem SVG DOM element to apply the gradient on.
	             */
	            colorGradient: function(color, prop, elem) {
	                var renderer = this.renderer,
	                    colorObject,
	                    gradName,
	                    gradAttr,
	                    radAttr,
	                    gradients,
	                    gradientObject,
	                    stops,
	                    stopColor,
	                    stopOpacity,
	                    radialReference,
	                    id,
	                    key = [],
	                    value;
	
	                // Apply linear or radial gradients
	                if (color.radialGradient) {
	                    gradName = 'radialGradient';
	                } else if (color.linearGradient) {
	                    gradName = 'linearGradient';
	                }
	
	                if (gradName) {
	                    gradAttr = color[gradName];
	                    gradients = renderer.gradients;
	                    stops = color.stops;
	                    radialReference = elem.radialReference;
	
	                    // Keep < 2.2 kompatibility
	                    if (isArray(gradAttr)) {
	                        color[gradName] = gradAttr = {
	                            x1: gradAttr[0],
	                            y1: gradAttr[1],
	                            x2: gradAttr[2],
	                            y2: gradAttr[3],
	                            gradientUnits: 'userSpaceOnUse'
	                        };
	                    }
	
	                    // Correct the radial gradient for the radial reference system
	                    if (
	                        gradName === 'radialGradient' &&
	                        radialReference &&
	                        !defined(gradAttr.gradientUnits)
	                    ) {
	                        radAttr = gradAttr; // Save the radial attributes for updating
	                        gradAttr = merge(
	                            gradAttr,
	                            renderer.getRadialAttr(radialReference, radAttr), {
	                                gradientUnits: 'userSpaceOnUse'
	                            }
	                        );
	                    }
	
	                    // Build the unique key to detect whether we need to create a new
	                    // element (#1282)
	                    objectEach(gradAttr, function(val, n) {
	                        if (n !== 'id') {
	                            key.push(n, val);
	                        }
	                    });
	                    objectEach(stops, function(val) {
	                        key.push(val);
	                    });
	                    key = key.join(',');
	
	                    // Check if a gradient object with the same config object is created
	                    // within this renderer
	                    if (gradients[key]) {
	                        id = gradients[key].attr('id');
	
	                    } else {
	
	                        // Set the id and create the element
	                        gradAttr.id = id = H.uniqueKey();
	                        gradients[key] = gradientObject =
	                            renderer.createElement(gradName)
	                            .attr(gradAttr)
	                            .add(renderer.defs);
	
	                        gradientObject.radAttr = radAttr;
	
	                        // The gradient needs to keep a list of stops to be able to
	                        // destroy them
	                        gradientObject.stops = [];
	                        each(stops, function(stop) {
	                            var stopObject;
	                            if (stop[1].indexOf('rgba') === 0) {
	                                colorObject = H.color(stop[1]);
	                                stopColor = colorObject.get('rgb');
	                                stopOpacity = colorObject.get('a');
	                            } else {
	                                stopColor = stop[1];
	                                stopOpacity = 1;
	                            }
	                            stopObject = renderer.createElement('stop').attr({
	                                offset: stop[0],
	                                'stop-color': stopColor,
	                                'stop-opacity': stopOpacity
	                            }).add(gradientObject);
	
	                            // Add the stop element to the gradient
	                            gradientObject.stops.push(stopObject);
	                        });
	                    }
	
	                    // Set the reference to the gradient object
	                    value = 'url(' + renderer.url + '#' + id + ')';
	                    elem.setAttribute(prop, value);
	                    elem.gradient = key;
	
	                    // Allow the color to be concatenated into tooltips formatters etc.
	                    // (#2995)
	                    color.toString = function() {
	                        return value;
	                    };
	                }
	            },
	
	            /**
	             * Apply a text outline through a custom CSS property, by copying the text
	             * element and apply stroke to the copy. Used internally. Contrast checks
	             * at http://jsfiddle.net/highcharts/43soe9m1/2/ .
	             *
	             * @private
	             * @param {String} textOutline A custom CSS `text-outline` setting, defined
	             *    by `width color`. 
	             * @example
	             * // Specific color
	             * text.css({
	             *    textOutline: '1px black'
	             * });
	             * // Automatic contrast
	             * text.css({
	             *    color: '#000000', // black text
	             *    textOutline: '1px contrast' // => white outline
	             * });
	             */
	            applyTextOutline: function(textOutline) {
	                var elem = this.element,
	                    tspans,
	                    tspan,
	                    hasContrast = textOutline.indexOf('contrast') !== -1,
	                    styles = {},
	                    color,
	                    strokeWidth,
	                    firstRealChild,
	                    i;
	
	                // When the text shadow is set to contrast, use dark stroke for light
	                // text and vice versa.
	                if (hasContrast) {
	                    styles.textOutline = textOutline = textOutline.replace(
	                        /contrast/g,
	                        this.renderer.getContrast(elem.style.fill)
	                    );
	                }
	
	                // Extract the stroke width and color
	                textOutline = textOutline.split(' ');
	                color = textOutline[textOutline.length - 1];
	                strokeWidth = textOutline[0];
	
	                if (strokeWidth && strokeWidth !== 'none' && H.svg) {
	
	                    this.fakeTS = true; // Fake text shadow
	
	                    tspans = [].slice.call(elem.getElementsByTagName('tspan'));
	
	                    // In order to get the right y position of the clone,
	                    // copy over the y setter
	                    this.ySetter = this.xSetter;
	
	                    // Since the stroke is applied on center of the actual outline, we
	                    // need to double it to get the correct stroke-width outside the 
	                    // glyphs.
	                    strokeWidth = strokeWidth.replace(
	                        /(^[\d\.]+)(.*?)$/g,
	                        function(match, digit, unit) {
	                            return (2 * digit) + unit;
	                        }
	                    );
	
	                    // Remove shadows from previous runs. Iterate from the end to
	                    // support removing items inside the cycle (#6472).
	                    i = tspans.length;
	                    while (i--) {
	                        tspan = tspans[i];
	                        if (tspan.getAttribute('class') === 'highcharts-text-outline') {
	                            // Remove then erase
	                            erase(tspans, elem.removeChild(tspan));
	                        }
	                    }
	
	                    // For each of the tspans, create a stroked copy behind it.
	                    firstRealChild = elem.firstChild;
	                    each(tspans, function(tspan, y) {
	                        var clone;
	
	                        // Let the first line start at the correct X position
	                        if (y === 0) {
	                            tspan.setAttribute('x', elem.getAttribute('x'));
	                            y = elem.getAttribute('y');
	                            tspan.setAttribute('y', y || 0);
	                            if (y === null) {
	                                elem.setAttribute('y', 0);
	                            }
	                        }
	
	                        // Create the clone and apply outline properties
	                        clone = tspan.cloneNode(1);
	                        attr(clone, {
	                            'class': 'highcharts-text-outline',
	                            'fill': color,
	                            'stroke': color,
	                            'stroke-width': strokeWidth,
	                            'stroke-linejoin': 'round'
	                        });
	                        elem.insertBefore(clone, firstRealChild);
	                    });
	                }
	            },
	
	            /**
	             *
	             * @typedef {Object} SVGAttributes An object of key-value pairs for SVG
	             *   attributes. Attributes in Highcharts elements for the most parts
	             *   correspond to SVG, but some are specific to Highcharts, like `zIndex`,
	             *   `rotation`, `translateX`, `translateY`, `scaleX` and `scaleY`. SVG
	             *   attributes containing a hyphen are _not_ camel-cased, they should be
	             *   quoted to preserve the hyphen.
	             * @example
	             * {
	             *     'stroke': '#ff0000', // basic
	             *     'stroke-width': 2, // hyphenated
	             *     'rotation': 45 // custom
	             *     'd': ['M', 10, 10, 'L', 30, 30, 'z'] // path definition, note format
	             * }
	             */
	            /**
	             * Apply native and custom attributes to the SVG elements.
	             * 
	             * In order to set the rotation center for rotation, set x and y to 0 and
	             * use `translateX` and `translateY` attributes to position the element
	             * instead.
	             *
	             * Attributes frequently used in Highcharts are `fill`, `stroke`,
	             * `stroke-width`.
	             *
	             * @param {SVGAttributes|String} hash - The native and custom SVG
	             *    attributes. 
	             * @param {string} [val] - If the type of the first argument is `string`, 
	             *    the second can be a value, which will serve as a single attribute
	             *    setter. If the first argument is a string and the second is undefined,
	             *    the function serves as a getter and the current value of the property
	             *    is returned.
	             * @param {Function} [complete] - A callback function to execute after
	             *    setting the attributes. This makes the function compliant and
	             *    interchangeable with the {@link SVGElement#animate} function.
	             * @param {boolean} [continueAnimation=true] Used internally when `.attr` is
	             *    called as part of an animation step. Otherwise, calling `.attr` for an
	             *    attribute will stop animation for that attribute.
	             *    
	             * @returns {SVGElement|string|number} If used as a setter, it returns the 
	             *    current {@link SVGElement} so the calls can be chained. If used as a 
	             *    getter, the current value of the attribute is returned.
	             *
	             * @sample highcharts/members/renderer-rect/
	             *         Setting some attributes
	             * 
	             * @example
	             * // Set multiple attributes
	             * element.attr({
	             *     stroke: 'red',
	             *     fill: 'blue',
	             *     x: 10,
	             *     y: 10
	             * });
	             *
	             * // Set a single attribute
	             * element.attr('stroke', 'red');
	             *
	             * // Get an attribute
	             * element.attr('stroke'); // => 'red'
	             * 
	             */
	            attr: function(hash, val, complete, continueAnimation) {
	                var key,
	                    element = this.element,
	                    hasSetSymbolSize,
	                    ret = this,
	                    skipAttr,
	                    setter;
	
	                // single key-value pair
	                if (typeof hash === 'string' && val !== undefined) {
	                    key = hash;
	                    hash = {};
	                    hash[key] = val;
	                }
	
	                // used as a getter: first argument is a string, second is undefined
	                if (typeof hash === 'string') {
	                    ret = (this[hash + 'Getter'] || this._defaultGetter).call(
	                        this,
	                        hash,
	                        element
	                    );
	
	                    // setter
	                } else {
	
	                    objectEach(hash, function(val, key) {
	                        skipAttr = false;
	
	                        // Unless .attr is from the animator update, stop current
	                        // running animation of this property
	                        if (!continueAnimation) {
	                            stop(this, key);
	                        }
	
	                        // Special handling of symbol attributes
	                        if (
	                            this.symbolName &&
	                            /^(x|y|width|height|r|start|end|innerR|anchorX|anchorY)$/
	                            .test(key)
	                        ) {
	                            if (!hasSetSymbolSize) {
	                                this.symbolAttr(hash);
	                                hasSetSymbolSize = true;
	                            }
	                            skipAttr = true;
	                        }
	
	                        if (this.rotation && (key === 'x' || key === 'y')) {
	                            this.doTransform = true;
	                        }
	
	                        if (!skipAttr) {
	                            setter = this[key + 'Setter'] || this._defaultSetter;
	                            setter.call(this, val, key, element);
	
	
	                            // Let the shadow follow the main element
	                            if (
	                                this.shadows &&
	                                /^(width|height|visibility|x|y|d|transform|cx|cy|r)$/
	                                .test(key)
	                            ) {
	                                this.updateShadows(key, val, setter);
	                            }
	
	                        }
	                    }, this);
	
	                    this.afterSetters();
	                }
	
	                // In accordance with animate, run a complete callback
	                if (complete) {
	                    complete();
	                }
	
	                return ret;
	            },
	
	            /**
	             * This method is executed in the end of `attr()`, after setting all
	             * attributes in the hash. In can be used to efficiently consolidate
	             * multiple attributes in one SVG property -- e.g., translate, rotate and
	             * scale are merged in one "transform" attribute in the SVG node.
	             *
	             * @private
	             */
	            afterSetters: function() {
	                // Update transform. Do this outside the loop to prevent redundant
	                // updating for batch setting of attributes.
	                if (this.doTransform) {
	                    this.updateTransform();
	                    this.doTransform = false;
	                }
	            },
	
	
	            /**
	             * Update the shadow elements with new attributes.
	             *
	             * @private
	             * @param {String} key - The attribute name.
	             * @param {String|Number} value - The value of the attribute.
	             * @param {Function} setter - The setter function, inherited from the
	             *   parent wrapper
	             * 
	             */
	            updateShadows: function(key, value, setter) {
	                var shadows = this.shadows,
	                    i = shadows.length;
	
	                while (i--) {
	                    setter.call(
	                        shadows[i],
	                        key === 'height' ?
	                        Math.max(value - (shadows[i].cutHeight || 0), 0) :
	                        key === 'd' ? this.d : value,
	                        key,
	                        shadows[i]
	                    );
	                }
	            },
	
	
	            /**
	             * Add a class name to an element.
	             *
	             * @param {string} className - The new class name to add.
	             * @param {boolean} [replace=false] - When true, the existing class name(s)
	             *    will be overwritten with the new one. When false, the new one is
	             *    added.
	             * @returns {SVGElement} Return the SVG element for chainability.
	             */
	            addClass: function(className, replace) {
	                var currentClassName = this.attr('class') || '';
	                if (currentClassName.indexOf(className) === -1) {
	                    if (!replace) {
	                        className =
	                            (currentClassName + (currentClassName ? ' ' : '') +
	                                className).replace('  ', ' ');
	                    }
	                    this.attr('class', className);
	                }
	
	                return this;
	            },
	
	            /**
	             * Check if an element has the given class name.
	             * @param  {string} className
	             *         The class name to check for.
	             * @return {Boolean}
	             *         Whether the class name is found.
	             */
	            hasClass: function(className) {
	                return inArray(
	                    className,
	                    (this.attr('class') || '').split(' ')
	                ) !== -1;
	            },
	
	            /**
	             * Remove a class name from the element.
	             * @param  {string} className The class name to remove.
	             * @return {SVGElement} Returns the SVG element for chainability.
	             */
	            removeClass: function(className) {
	                return this.attr(
	                    'class',
	                    (this.attr('class') || '').replace(className, '')
	                );
	            },
	
	            /**
	             * If one of the symbol size affecting parameters are changed,
	             * check all the others only once for each call to an element's
	             * .attr() method
	             * @param {Object} hash - The attributes to set.
	             * @private
	             */
	            symbolAttr: function(hash) {
	                var wrapper = this;
	
	                each([
	                    'x',
	                    'y',
	                    'r',
	                    'start',
	                    'end',
	                    'width',
	                    'height',
	                    'innerR',
	                    'anchorX',
	                    'anchorY'
	                ], function(key) {
	                    wrapper[key] = pick(hash[key], wrapper[key]);
	                });
	
	                wrapper.attr({
	                    d: wrapper.renderer.symbols[wrapper.symbolName](
	                        wrapper.x,
	                        wrapper.y,
	                        wrapper.width,
	                        wrapper.height,
	                        wrapper
	                    )
	                });
	            },
	
	            /**
	             * Apply a clipping rectangle to this element.
	             * 
	             * @param {ClipRect} [clipRect] - The clipping rectangle. If skipped, the
	             *    current clip is removed.
	             * @returns {SVGElement} Returns the SVG element to allow chaining.
	             */
	            clip: function(clipRect) {
	                return this.attr(
	                    'clip-path',
	                    clipRect ?
	                    'url(' + this.renderer.url + '#' + clipRect.id + ')' :
	                    'none'
	                );
	            },
	
	            /**
	             * Calculate the coordinates needed for drawing a rectangle crisply and
	             * return the calculated attributes.
	             * 
	             * @param {Object} rect - A rectangle.
	             * @param {number} rect.x - The x position.
	             * @param {number} rect.y - The y position.
	             * @param {number} rect.width - The width.
	             * @param {number} rect.height - The height.
	             * @param {number} [strokeWidth] - The stroke width to consider when
	             *    computing crisp positioning. It can also be set directly on the rect
	             *    parameter.
	             *
	             * @returns {{x: Number, y: Number, width: Number, height: Number}} The
	             *    modified rectangle arguments.
	             */
	            crisp: function(rect, strokeWidth) {
	
	                var wrapper = this,
	                    attribs = {},
	                    normalizer;
	
	                strokeWidth = strokeWidth || rect.strokeWidth || 0;
	                // Math.round because strokeWidth can sometimes have roundoff errors
	                normalizer = Math.round(strokeWidth) % 2 / 2;
	
	                // normalize for crisp edges
	                rect.x = Math.floor(rect.x || wrapper.x || 0) + normalizer;
	                rect.y = Math.floor(rect.y || wrapper.y || 0) + normalizer;
	                rect.width = Math.floor(
	                    (rect.width || wrapper.width || 0) - 2 * normalizer
	                );
	                rect.height = Math.floor(
	                    (rect.height || wrapper.height || 0) - 2 * normalizer
	                );
	                if (defined(rect.strokeWidth)) {
	                    rect.strokeWidth = strokeWidth;
	                }
	
	                objectEach(rect, function(val, key) {
	                    if (wrapper[key] !== val) { // only set attribute if changed
	                        wrapper[key] = attribs[key] = val;
	                    }
	                });
	
	                return attribs;
	            },
	
	            /**
	             * Set styles for the element. In addition to CSS styles supported by 
	             * native SVG and HTML elements, there are also some custom made for 
	             * Highcharts, like `width`, `ellipsis` and `textOverflow` for SVG text
	             * elements.
	             * @param {CSSObject} styles The new CSS styles.
	             * @returns {SVGElement} Return the SVG element for chaining.
	             *
	             * @sample highcharts/members/renderer-text-on-chart/
	             *         Styled text
	             */
	            css: function(styles) {
	                var oldStyles = this.styles,
	                    newStyles = {},
	                    elem = this.element,
	                    textWidth,
	                    serializedCss = '',
	                    hyphenate,
	                    hasNew = !oldStyles,
	                    // These CSS properties are interpreted internally by the SVG
	                    // renderer, but are not supported by SVG and should not be added to
	                    // the DOM. In styled mode, no CSS should find its way to the DOM
	                    // whatsoever (#6173, #6474).
	                    svgPseudoProps = ['textOutline', 'textOverflow', 'width'];
	
	                // convert legacy
	                if (styles && styles.color) {
	                    styles.fill = styles.color;
	                }
	
	                // Filter out existing styles to increase performance (#2640)
	                if (oldStyles) {
	                    objectEach(styles, function(style, n) {
	                        if (style !== oldStyles[n]) {
	                            newStyles[n] = style;
	                            hasNew = true;
	                        }
	                    });
	                }
	                if (hasNew) {
	
	                    // Merge the new styles with the old ones
	                    if (oldStyles) {
	                        styles = extend(
	                            oldStyles,
	                            newStyles
	                        );
	                    }
	
	                    // Get the text width from style
	                    textWidth = this.textWidth = (
	                        styles &&
	                        styles.width &&
	                        styles.width !== 'auto' &&
	                        elem.nodeName.toLowerCase() === 'text' &&
	                        pInt(styles.width)
	                    );
	
	                    // store object
	                    this.styles = styles;
	
	                    if (textWidth && (!svg && this.renderer.forExport)) {
	                        delete styles.width;
	                    }
	
	                    // serialize and set style attribute
	                    if (isMS && !svg) {
	                        css(this.element, styles);
	                    } else {
	                        hyphenate = function(a, b) {
	                            return '-' + b.toLowerCase();
	                        };
	                        objectEach(styles, function(style, n) {
	                            if (inArray(n, svgPseudoProps) === -1) {
	                                serializedCss +=
	                                    n.replace(/([A-Z])/g, hyphenate) + ':' +
	                                    style + ';';
	                            }
	                        });
	                        if (serializedCss) {
	                            attr(elem, 'style', serializedCss); // #1881
	                        }
	                    }
	
	
	                    if (this.added) {
	
	                        // Rebuild text after added. Cache mechanisms in the buildText
	                        // will prevent building if there are no significant changes.
	                        if (this.element.nodeName === 'text') {
	                            this.renderer.buildText(this);
	                        }
	
	                        // Apply text outline after added
	                        if (styles && styles.textOutline) {
	                            this.applyTextOutline(styles.textOutline);
	                        }
	                    }
	                }
	
	                return this;
	            },
	
	
	            /**
	             * Get the current stroke width. In classic mode, the setter registers it 
	             * directly on the element.
	             * @returns {number} The stroke width in pixels.
	             * @ignore
	             */
	            strokeWidth: function() {
	                return this['stroke-width'] || 0;
	            },
	
	
	            /**
	             * Add an event listener. This is a simple setter that replaces all other
	             * events of the same type, opposed to the {@link Highcharts#addEvent}
	             * function.
	             * @param {string} eventType - The event type. If the type is `click`, 
	             *    Highcharts will internally translate it to a `touchstart` event on 
	             *    touch devices, to prevent the browser from waiting for a click event
	             *    from firing.
	             * @param {Function} handler - The handler callback.
	             * @returns {SVGElement} The SVGElement for chaining.
	             *
	             * @sample highcharts/members/element-on/
	             *         A clickable rectangle
	             */
	            on: function(eventType, handler) {
	                var svgElement = this,
	                    element = svgElement.element;
	
	                // touch
	                if (hasTouch && eventType === 'click') {
	                    element.ontouchstart = function(e) {
	                        svgElement.touchEventFired = Date.now(); // #2269
	                        e.preventDefault();
	                        handler.call(element, e);
	                    };
	                    element.onclick = function(e) {
	                        if (win.navigator.userAgent.indexOf('Android') === -1 ||
	                            Date.now() - (svgElement.touchEventFired || 0) > 1100) {
	                            handler.call(element, e);
	                        }
	                    };
	                } else {
	                    // simplest possible event model for internal use
	                    element['on' + eventType] = handler;
	                }
	                return this;
	            },
	
	            /**
	             * Set the coordinates needed to draw a consistent radial gradient across
	             * a shape regardless of positioning inside the chart. Used on pie slices
	             * to make all the slices have the same radial reference point.
	             *
	             * @param {Array} coordinates The center reference. The format is
	             *    `[centerX, centerY, diameter]` in pixels.
	             * @returns {SVGElement} Returns the SVGElement for chaining.
	             */
	            setRadialReference: function(coordinates) {
	                var existingGradient = this.renderer.gradients[this.element.gradient];
	
	                this.element.radialReference = coordinates;
	
	                // On redrawing objects with an existing gradient, the gradient needs
	                // to be repositioned (#3801)
	                if (existingGradient && existingGradient.radAttr) {
	                    existingGradient.animate(
	                        this.renderer.getRadialAttr(
	                            coordinates,
	                            existingGradient.radAttr
	                        )
	                    );
	                }
	
	                return this;
	            },
	
	            /**
	             * Move an object and its children by x and y values.
	             * 
	             * @param {number} x - The x value.
	             * @param {number} y - The y value.
	             */
	            translate: function(x, y) {
	                return this.attr({
	                    translateX: x,
	                    translateY: y
	                });
	            },
	
	            /**
	             * Invert a group, rotate and flip. This is used internally on inverted 
	             * charts, where the points and graphs are drawn as if not inverted, then
	             * the series group elements are inverted.
	             *
	             * @param  {boolean} inverted
	             *         Whether to invert or not. An inverted shape can be un-inverted by
	             *         setting it to false.
	             * @return {SVGElement}
	             *         Return the SVGElement for chaining.
	             */
	            invert: function(inverted) {
	                var wrapper = this;
	                wrapper.inverted = inverted;
	                wrapper.updateTransform();
	                return wrapper;
	            },
	
	            /**
	             * Update the transform attribute based on internal properties. Deals with
	             * the custom `translateX`, `translateY`, `rotation`, `scaleX` and `scaleY`
	             * attributes and updates the SVG `transform` attribute.
	             * @private
	             * 
	             */
	            updateTransform: function() {
	                var wrapper = this,
	                    translateX = wrapper.translateX || 0,
	                    translateY = wrapper.translateY || 0,
	                    scaleX = wrapper.scaleX,
	                    scaleY = wrapper.scaleY,
	                    inverted = wrapper.inverted,
	                    rotation = wrapper.rotation,
	                    element = wrapper.element,
	                    transform;
	
	                // Flipping affects translate as adjustment for flipping around the
	                // group's axis
	                if (inverted) {
	                    translateX += wrapper.width;
	                    translateY += wrapper.height;
	                }
	
	                // Apply translate. Nearly all transformed elements have translation,
	                // so instead of checking for translate = 0, do it always (#1767,
	                // #1846).
	                transform = ['translate(' + translateX + ',' + translateY + ')'];
	
	                // apply rotation
	                if (inverted) {
	                    transform.push('rotate(90) scale(-1,1)');
	                } else if (rotation) { // text rotation
	                    transform.push(
	                        'rotate(' + rotation + ' ' + (element.getAttribute('x') || 0) +
	                        ' ' + (element.getAttribute('y') || 0) + ')'
	                    );
	                }
	
	                // apply scale
	                if (defined(scaleX) || defined(scaleY)) {
	                    transform.push(
	                        'scale(' + pick(scaleX, 1) + ' ' + pick(scaleY, 1) + ')'
	                    );
	                }
	
	                if (transform.length) {
	                    element.setAttribute('transform', transform.join(' '));
	                }
	            },
	
	            /**
	             * Bring the element to the front. Alternatively, a new zIndex can be set.
	             *
	             * @returns {SVGElement} Returns the SVGElement for chaining.
	             *
	             * @sample highcharts/members/element-tofront/
	             *         Click an element to bring it to front
	             */
	            toFront: function() {
	                var element = this.element;
	                element.parentNode.appendChild(element);
	                return this;
	            },
	
	
	            /**
	             * Align the element relative to the chart or another box.
	             * 
	             * @param {Object} [alignOptions] The alignment options. The function can be
	             *   called without this parameter in order to re-align an element after the
	             *   box has been updated.
	             * @param {string} [alignOptions.align=left] Horizontal alignment. Can be
	             *   one of `left`, `center` and `right`.
	             * @param {string} [alignOptions.verticalAlign=top] Vertical alignment. Can
	             *   be one of `top`, `middle` and `bottom`.
	             * @param {number} [alignOptions.x=0] Horizontal pixel offset from
	             *   alignment.
	             * @param {number} [alignOptions.y=0] Vertical pixel offset from alignment.
	             * @param {Boolean} [alignByTranslate=false] Use the `transform` attribute
	             *   with translateX and translateY custom attributes to align this elements
	             *   rather than `x` and `y` attributes.
	             * @param {String|Object} box The box to align to, needs a width and height.
	             *   When the box is a string, it refers to an object in the Renderer. For
	             *   example, when box is `spacingBox`, it refers to `Renderer.spacingBox`
	             *   which holds `width`, `height`, `x` and `y` properties.
	             * @returns {SVGElement} Returns the SVGElement for chaining.
	             */
	            align: function(alignOptions, alignByTranslate, box) {
	                var align,
	                    vAlign,
	                    x,
	                    y,
	                    attribs = {},
	                    alignTo,
	                    renderer = this.renderer,
	                    alignedObjects = renderer.alignedObjects,
	                    alignFactor,
	                    vAlignFactor;
	
	                // First call on instanciate
	                if (alignOptions) {
	                    this.alignOptions = alignOptions;
	                    this.alignByTranslate = alignByTranslate;
	                    if (!box || isString(box)) { // boxes other than renderer handle this internally
	                        this.alignTo = alignTo = box || 'renderer';
	                        erase(alignedObjects, this); // prevent duplicates, like legendGroup after resize
	                        alignedObjects.push(this);
	                        box = null; // reassign it below
	                    }
	
	                    // When called on resize, no arguments are supplied
	                } else {
	                    alignOptions = this.alignOptions;
	                    alignByTranslate = this.alignByTranslate;
	                    alignTo = this.alignTo;
	                }
	
	                box = pick(box, renderer[alignTo], renderer);
	
	                // Assign variables
	                align = alignOptions.align;
	                vAlign = alignOptions.verticalAlign;
	                x = (box.x || 0) + (alignOptions.x || 0); // default: left align
	                y = (box.y || 0) + (alignOptions.y || 0); // default: top align
	
	                // Align
	                if (align === 'right') {
	                    alignFactor = 1;
	                } else if (align === 'center') {
	                    alignFactor = 2;
	                }
	                if (alignFactor) {
	                    x += (box.width - (alignOptions.width || 0)) / alignFactor;
	                }
	                attribs[alignByTranslate ? 'translateX' : 'x'] = Math.round(x);
	
	
	                // Vertical align
	                if (vAlign === 'bottom') {
	                    vAlignFactor = 1;
	                } else if (vAlign === 'middle') {
	                    vAlignFactor = 2;
	                }
	                if (vAlignFactor) {
	                    y += (box.height - (alignOptions.height || 0)) / vAlignFactor;
	                }
	                attribs[alignByTranslate ? 'translateY' : 'y'] = Math.round(y);
	
	                // Animate only if already placed
	                this[this.placed ? 'animate' : 'attr'](attribs);
	                this.placed = true;
	                this.alignAttr = attribs;
	
	                return this;
	            },
	
	            /**
	             * Get the bounding box (width, height, x and y) for the element. Generally
	             * used to get rendered text size. Since this is called a lot in charts,
	             * the results are cached based on text properties, in order to save DOM
	             * traffic. The returned bounding box includes the rotation, so for example
	             * a single text line of rotation 90 will report a greater height, and a
	             * width corresponding to the line-height.
	             *
	             * @param {boolean} [reload] Skip the cache and get the updated DOM bouding
	             *   box.
	             * @param {number} [rot] Override the element's rotation. This is internally
	             *   used on axis labels with a value of 0 to find out what the bounding box
	             *   would be have been if it were not rotated.
	             * @returns {Object} The bounding box with `x`, `y`, `width` and `height`
	             * properties.
	             *
	             * @sample highcharts/members/renderer-on-chart/
	             *         Draw a rectangle based on a text's bounding box
	             */
	            getBBox: function(reload, rot) {
	                var wrapper = this,
	                    bBox, // = wrapper.bBox,
	                    renderer = wrapper.renderer,
	                    width,
	                    height,
	                    rotation,
	                    rad,
	                    element = wrapper.element,
	                    styles = wrapper.styles,
	                    fontSize,
	                    textStr = wrapper.textStr,
	                    toggleTextShadowShim,
	                    cache = renderer.cache,
	                    cacheKeys = renderer.cacheKeys,
	                    cacheKey;
	
	                rotation = pick(rot, wrapper.rotation);
	                rad = rotation * deg2rad;
	
	
	                fontSize = styles && styles.fontSize;
	
	
	                if (textStr !== undefined) {
	
	                    cacheKey = textStr.toString();
	
	                    // Since numbers are monospaced, and numerical labels appear a lot
	                    // in a chart, we assume that a label of n characters has the same
	                    // bounding box as others of the same length. Unless there is inner
	                    // HTML in the label. In that case, leave the numbers as is (#5899).
	                    if (cacheKey.indexOf('<') === -1) {
	                        cacheKey = cacheKey.replace(/[0-9]/g, '0');
	                    }
	
	                    // Properties that affect bounding box
	                    cacheKey += [
	                            '',
	                            rotation || 0,
	                            fontSize,
	                            styles && styles.width,
	                            styles && styles.textOverflow // #5968
	                        ]
	                        .join(',');
	
	                }
	
	                if (cacheKey && !reload) {
	                    bBox = cache[cacheKey];
	                }
	
	                // No cache found
	                if (!bBox) {
	
	                    // SVG elements
	                    if (element.namespaceURI === wrapper.SVG_NS || renderer.forExport) {
	                        try { // Fails in Firefox if the container has display: none.
	
	                            // When the text shadow shim is used, we need to hide the fake shadows
	                            // to get the correct bounding box (#3872)
	                            toggleTextShadowShim = this.fakeTS && function(display) {
	                                each(element.querySelectorAll('.highcharts-text-outline'), function(tspan) {
	                                    tspan.style.display = display;
	                                });
	                            };
	
	                            // Workaround for #3842, Firefox reporting wrong bounding box for shadows
	                            if (toggleTextShadowShim) {
	                                toggleTextShadowShim('none');
	                            }
	
	                            bBox = element.getBBox ?
	                                // SVG: use extend because IE9 is not allowed to change width and height in case
	                                // of rotation (below)
	                                extend({}, element.getBBox()) : {
	
	                                    // Legacy IE in export mode
	                                    width: element.offsetWidth,
	                                    height: element.offsetHeight
	                                };
	
	                            // #3842
	                            if (toggleTextShadowShim) {
	                                toggleTextShadowShim('');
	                            }
	                        } catch (e) {}
	
	                        // If the bBox is not set, the try-catch block above failed. The other condition
	                        // is for Opera that returns a width of -Infinity on hidden elements.
	                        if (!bBox || bBox.width < 0) {
	                            bBox = {
	                                width: 0,
	                                height: 0
	                            };
	                        }
	
	
	                        // VML Renderer or useHTML within SVG
	                    } else {
	
	                        bBox = wrapper.htmlGetBBox();
	
	                    }
	
	                    // True SVG elements as well as HTML elements in modern browsers using the .useHTML option
	                    // need to compensated for rotation
	                    if (renderer.isSVG) {
	                        width = bBox.width;
	                        height = bBox.height;
	
	                        // Workaround for wrong bounding box in IE, Edge and Chrome on
	                        // Windows. With Highcharts' default font, IE and Edge report
	                        // a box height of 16.899 and Chrome rounds it to 17. If this 
	                        // stands uncorrected, it results in more padding added below
	                        // the text than above when adding a label border or background.
	                        // Also vertical positioning is affected.
	                        // http://jsfiddle.net/highcharts/em37nvuj/
	                        // (#1101, #1505, #1669, #2568, #6213).
	                        if (
	                            styles &&
	                            styles.fontSize === '11px' &&
	                            Math.round(height) === 17
	                        ) {
	                            bBox.height = height = 14;
	                        }
	
	                        // Adjust for rotated text
	                        if (rotation) {
	                            bBox.width = Math.abs(height * Math.sin(rad)) + Math.abs(width * Math.cos(rad));
	                            bBox.height = Math.abs(height * Math.cos(rad)) + Math.abs(width * Math.sin(rad));
	                        }
	                    }
	
	                    // Cache it. When loading a chart in a hidden iframe in Firefox and IE/Edge, the
	                    // bounding box height is 0, so don't cache it (#5620).
	                    if (cacheKey && bBox.height > 0) {
	
	                        // Rotate (#4681)
	                        while (cacheKeys.length > 250) {
	                            delete cache[cacheKeys.shift()];
	                        }
	
	                        if (!cache[cacheKey]) {
	                            cacheKeys.push(cacheKey);
	                        }
	                        cache[cacheKey] = bBox;
	                    }
	                }
	                return bBox;
	            },
	
	            /**
	             * Show the element after it has been hidden. 
	             *
	             * @param {boolean} [inherit=false] Set the visibility attribute to
	             * `inherit` rather than `visible`. The difference is that an element with
	             * `visibility="visible"` will be visible even if the parent is hidden.
	             *
	             * @returns {SVGElement} Returns the SVGElement for chaining.
	             */
	            show: function(inherit) {
	                return this.attr({
	                    visibility: inherit ? 'inherit' : 'visible'
	                });
	            },
	
	            /**
	             * Hide the element, equivalent to setting the `visibility` attribute to
	             * `hidden`.
	             *
	             * @returns {SVGElement} Returns the SVGElement for chaining.
	             */
	            hide: function() {
	                return this.attr({
	                    visibility: 'hidden'
	                });
	            },
	
	            /**
	             * Fade out an element by animating its opacity down to 0, and hide it on
	             * complete. Used internally for the tooltip.
	             * 
	             * @param {number} [duration=150] The fade duration in milliseconds.
	             */
	            fadeOut: function(duration) {
	                var elemWrapper = this;
	                elemWrapper.animate({
	                    opacity: 0
	                }, {
	                    duration: duration || 150,
	                    complete: function() {
	                        // #3088, assuming we're only using this for tooltips
	                        elemWrapper.attr({
	                            y: -9999
	                        });
	                    }
	                });
	            },
	
	            /**
	             * Add the element to the DOM. All elements must be added this way.
	             * 
	             * @param {SVGElement|SVGDOMElement} [parent] The parent item to add it to.
	             *   If undefined, the element is added to the {@link
	             *   Highcharts.SVGRenderer.box}.
	             *
	             * @returns {SVGElement} Returns the SVGElement for chaining.
	             *
	             * @sample highcharts/members/renderer-g - Elements added to a group
	             */
	            add: function(parent) {
	
	                var renderer = this.renderer,
	                    element = this.element,
	                    inserted;
	
	                if (parent) {
	                    this.parentGroup = parent;
	                }
	
	                // mark as inverted
	                this.parentInverted = parent && parent.inverted;
	
	                // build formatted text
	                if (this.textStr !== undefined) {
	                    renderer.buildText(this);
	                }
	
	                // Mark as added
	                this.added = true;
	
	                // If we're adding to renderer root, or other elements in the group
	                // have a z index, we need to handle it
	                if (!parent || parent.handleZ || this.zIndex) {
	                    inserted = this.zIndexSetter();
	                }
	
	                // If zIndex is not handled, append at the end
	                if (!inserted) {
	                    (parent ? parent.element : renderer.box).appendChild(element);
	                }
	
	                // fire an event for internal hooks
	                if (this.onAdd) {
	                    this.onAdd();
	                }
	
	                return this;
	            },
	
	            /**
	             * Removes an element from the DOM.
	             *
	             * @private
	             * @param {SVGDOMElement|HTMLDOMElement} element The DOM node to remove.
	             */
	            safeRemoveChild: function(element) {
	                var parentNode = element.parentNode;
	                if (parentNode) {
	                    parentNode.removeChild(element);
	                }
	            },
	
	            /**
	             * Destroy the element and element wrapper and clear up the DOM and event
	             * hooks.
	             *
	             * 
	             */
	            destroy: function() {
	                var wrapper = this,
	                    element = wrapper.element || {},
	                    parentToClean =
	                    wrapper.renderer.isSVG &&
	                    element.nodeName === 'SPAN' &&
	                    wrapper.parentGroup,
	                    grandParent,
	                    ownerSVGElement = element.ownerSVGElement,
	                    i;
	
	                // remove events
	                element.onclick = element.onmouseout = element.onmouseover =
	                    element.onmousemove = element.point = null;
	                stop(wrapper); // stop running animations
	
	                if (wrapper.clipPath && ownerSVGElement) {
	                    // Look for existing references to this clipPath and remove them
	                    // before destroying the element (#6196).
	                    each(
	                        ownerSVGElement.querySelectorAll('[clip-path]'),
	                        function(el) {
	                            // Include the closing paranthesis in the test to rule out
	                            // id's from 10 and above (#6550)
	                            if (el.getAttribute('clip-path')
	                                .indexOf(wrapper.clipPath.element.id + ')') > -1) {
	                                el.removeAttribute('clip-path');
	                            }
	                        }
	                    );
	                    wrapper.clipPath = wrapper.clipPath.destroy();
	                }
	
	                // Destroy stops in case this is a gradient object
	                if (wrapper.stops) {
	                    for (i = 0; i < wrapper.stops.length; i++) {
	                        wrapper.stops[i] = wrapper.stops[i].destroy();
	                    }
	                    wrapper.stops = null;
	                }
	
	                // remove element
	                wrapper.safeRemoveChild(element);
	
	
	                wrapper.destroyShadows();
	
	
	                // In case of useHTML, clean up empty containers emulating SVG groups
	                // (#1960, #2393, #2697).
	                while (
	                    parentToClean &&
	                    parentToClean.div &&
	                    parentToClean.div.childNodes.length === 0
	                ) {
	                    grandParent = parentToClean.parentGroup;
	                    wrapper.safeRemoveChild(parentToClean.div);
	                    delete parentToClean.div;
	                    parentToClean = grandParent;
	                }
	
	                // remove from alignObjects
	                if (wrapper.alignTo) {
	                    erase(wrapper.renderer.alignedObjects, wrapper);
	                }
	
	                objectEach(wrapper, function(val, key) {
	                    delete wrapper[key];
	                });
	
	                return null;
	            },
	
	
	            /**
	             * @typedef {Object} ShadowOptions
	             * @property {string} [color=#000000] The shadow color.
	             * @property {number} [offsetX=1] The horizontal offset from the element.
	             * @property {number} [offsetY=1] The vertical offset from the element.
	             * @property {number} [opacity=0.15] The shadow opacity.
	             * @property {number} [width=3] The shadow width or distance from the
	             *    element.
	             */
	            /**
	             * Add a shadow to the element. Must be called after the element is added to
	             * the DOM. In styled mode, this method is not used, instead use `defs` and
	             * filters.
	             * 
	             * @param {boolean|ShadowOptions} shadowOptions The shadow options. If
	             *    `true`, the default options are applied. If `false`, the current
	             *    shadow will be removed.
	             * @param {SVGElement} [group] The SVG group element where the shadows will 
	             *    be applied. The default is to add it to the same parent as the current
	             *    element. Internally, this is ised for pie slices, where all the
	             *    shadows are added to an element behind all the slices.
	             * @param {boolean} [cutOff] Used internally for column shadows.
	             *
	             * @returns {SVGElement} Returns the SVGElement for chaining.
	             *
	             * @example
	             * renderer.rect(10, 100, 100, 100)
	             *     .attr({ fill: 'red' })
	             *     .shadow(true);
	             */
	            shadow: function(shadowOptions, group, cutOff) {
	                var shadows = [],
	                    i,
	                    shadow,
	                    element = this.element,
	                    strokeWidth,
	                    shadowWidth,
	                    shadowElementOpacity,
	
	                    // compensate for inverted plot area
	                    transform;
	
	                if (!shadowOptions) {
	                    this.destroyShadows();
	
	                } else if (!this.shadows) {
	                    shadowWidth = pick(shadowOptions.width, 3);
	                    shadowElementOpacity = (shadowOptions.opacity || 0.15) /
	                        shadowWidth;
	                    transform = this.parentInverted ?
	                        '(-1,-1)' :
	                        '(' + pick(shadowOptions.offsetX, 1) + ', ' +
	                        pick(shadowOptions.offsetY, 1) + ')';
	                    for (i = 1; i <= shadowWidth; i++) {
	                        shadow = element.cloneNode(0);
	                        strokeWidth = (shadowWidth * 2) + 1 - (2 * i);
	                        attr(shadow, {
	                            'isShadow': 'true',
	                            'stroke': shadowOptions.color || '#000000',
	                            'stroke-opacity': shadowElementOpacity * i,
	                            'stroke-width': strokeWidth,
	                            'transform': 'translate' + transform,
	                            'fill': 'none'
	                        });
	                        if (cutOff) {
	                            attr(
	                                shadow,
	                                'height',
	                                Math.max(attr(shadow, 'height') - strokeWidth, 0)
	                            );
	                            shadow.cutHeight = strokeWidth;
	                        }
	
	                        if (group) {
	                            group.element.appendChild(shadow);
	                        } else {
	                            element.parentNode.insertBefore(shadow, element);
	                        }
	
	                        shadows.push(shadow);
	                    }
	
	                    this.shadows = shadows;
	                }
	                return this;
	
	            },
	
	            /**
	             * Destroy shadows on the element.
	             * @private
	             */
	            destroyShadows: function() {
	                each(this.shadows || [], function(shadow) {
	                    this.safeRemoveChild(shadow);
	                }, this);
	                this.shadows = undefined;
	            },
	
	
	
	            xGetter: function(key) {
	                if (this.element.nodeName === 'circle') {
	                    if (key === 'x') {
	                        key = 'cx';
	                    } else if (key === 'y') {
	                        key = 'cy';
	                    }
	                }
	                return this._defaultGetter(key);
	            },
	
	            /**
	             * Get the current value of an attribute or pseudo attribute, used mainly
	             * for animation. Called internally from the {@link
	             * Highcharts.SVGRenderer#attr}
	             * function.
	             *
	             * @private
	             */
	            _defaultGetter: function(key) {
	                var ret = pick(
	                    this[key],
	                    this.element ? this.element.getAttribute(key) : null,
	                    0
	                );
	
	                if (/^[\-0-9\.]+$/.test(ret)) { // is numerical
	                    ret = parseFloat(ret);
	                }
	                return ret;
	            },
	
	
	            dSetter: function(value, key, element) {
	                if (value && value.join) { // join path
	                    value = value.join(' ');
	                }
	                if (/(NaN| {2}|^$)/.test(value)) {
	                    value = 'M 0 0';
	                }
	
	                // Check for cache before resetting. Resetting causes disturbance in the
	                // DOM, causing flickering in some cases in Edge/IE (#6747). Also
	                // possible performance gain.
	                if (this[key] !== value) {
	                    element.setAttribute(key, value);
	                    this[key] = value;
	                }
	
	            },
	
	            dashstyleSetter: function(value) {
	                var i,
	                    strokeWidth = this['stroke-width'];
	
	                // If "inherit", like maps in IE, assume 1 (#4981). With HC5 and the new
	                // strokeWidth function, we should be able to use that instead.
	                if (strokeWidth === 'inherit') {
	                    strokeWidth = 1;
	                }
	                value = value && value.toLowerCase();
	                if (value) {
	                    value = value
	                        .replace('shortdashdotdot', '3,1,1,1,1,1,')
	                        .replace('shortdashdot', '3,1,1,1')
	                        .replace('shortdot', '1,1,')
	                        .replace('shortdash', '3,1,')
	                        .replace('longdash', '8,3,')
	                        .replace(/dot/g, '1,3,')
	                        .replace('dash', '4,3,')
	                        .replace(/,$/, '')
	                        .split(','); // ending comma
	
	                    i = value.length;
	                    while (i--) {
	                        value[i] = pInt(value[i]) * strokeWidth;
	                    }
	                    value = value.join(',')
	                        .replace(/NaN/g, 'none'); // #3226
	                    this.element.setAttribute('stroke-dasharray', value);
	                }
	            },
	
	            alignSetter: function(value) {
	                var convert = {
	                    left: 'start',
	                    center: 'middle',
	                    right: 'end'
	                };
	                this.element.setAttribute('text-anchor', convert[value]);
	            },
	            opacitySetter: function(value, key, element) {
	                this[key] = value;
	                element.setAttribute(key, value);
	            },
	            titleSetter: function(value) {
	                var titleNode = this.element.getElementsByTagName('title')[0];
	                if (!titleNode) {
	                    titleNode = doc.createElementNS(this.SVG_NS, 'title');
	                    this.element.appendChild(titleNode);
	                }
	
	                // Remove text content if it exists
	                if (titleNode.firstChild) {
	                    titleNode.removeChild(titleNode.firstChild);
	                }
	
	                titleNode.appendChild(
	                    doc.createTextNode(
	                        (String(pick(value), '')).replace(/<[^>]*>/g, '') // #3276, #3895
	                    )
	                );
	            },
	            textSetter: function(value) {
	                if (value !== this.textStr) {
	                    // Delete bBox memo when the text changes
	                    delete this.bBox;
	
	                    this.textStr = value;
	                    if (this.added) {
	                        this.renderer.buildText(this);
	                    }
	                }
	            },
	            fillSetter: function(value, key, element) {
	                if (typeof value === 'string') {
	                    element.setAttribute(key, value);
	                } else if (value) {
	                    this.colorGradient(value, key, element);
	                }
	            },
	            visibilitySetter: function(value, key, element) {
	                // IE9-11 doesn't handle visibilty:inherit well, so we remove the attribute instead (#2881, #3909)
	                if (value === 'inherit') {
	                    element.removeAttribute(key);
	                } else if (this[key] !== value) { // #6747
	                    element.setAttribute(key, value);
	                }
	                this[key] = value;
	            },
	            zIndexSetter: function(value, key) {
	                var renderer = this.renderer,
	                    parentGroup = this.parentGroup,
	                    parentWrapper = parentGroup || renderer,
	                    parentNode = parentWrapper.element || renderer.box,
	                    childNodes,
	                    otherElement,
	                    otherZIndex,
	                    element = this.element,
	                    inserted,
	                    run = this.added,
	                    i;
	
	                if (defined(value)) {
	                    element.zIndex = value; // So we can read it for other elements in the group
	                    value = +value;
	                    if (this[key] === value) { // Only update when needed (#3865)
	                        run = false;
	                    }
	                    this[key] = value;
	                }
	
	                // Insert according to this and other elements' zIndex. Before .add() is called,
	                // nothing is done. Then on add, or by later calls to zIndexSetter, the node
	                // is placed on the right place in the DOM.
	                if (run) {
	                    value = this.zIndex;
	
	                    if (value && parentGroup) {
	                        parentGroup.handleZ = true;
	                    }
	
	                    childNodes = parentNode.childNodes;
	                    for (i = 0; i < childNodes.length && !inserted; i++) {
	                        otherElement = childNodes[i];
	                        otherZIndex = otherElement.zIndex;
	                        if (otherElement !== element && (
	                                // Insert before the first element with a higher zIndex
	                                pInt(otherZIndex) > value ||
	                                // If no zIndex given, insert before the first element with a zIndex
	                                (!defined(value) && defined(otherZIndex)) ||
	                                // Negative zIndex versus no zIndex:
	                                // On all levels except the highest. If the parent is <svg>,
	                                // then we don't want to put items before <desc> or <defs>
	                                (value < 0 && !defined(otherZIndex) && parentNode !== renderer.box)
	
	                            )) {
	                            parentNode.insertBefore(element, otherElement);
	                            inserted = true;
	                        }
	                    }
	                    if (!inserted) {
	                        parentNode.appendChild(element);
	                    }
	                }
	                return inserted;
	            },
	            _defaultSetter: function(value, key, element) {
	                element.setAttribute(key, value);
	            }
	        });
	
	        // Some shared setters and getters
	        SVGElement.prototype.yGetter = SVGElement.prototype.xGetter;
	        SVGElement.prototype.translateXSetter = SVGElement.prototype.translateYSetter =
	            SVGElement.prototype.rotationSetter = SVGElement.prototype.verticalAlignSetter =
	            SVGElement.prototype.scaleXSetter = SVGElement.prototype.scaleYSetter = function(value, key) {
	                this[key] = value;
	                this.doTransform = true;
	            };
	
	
	        // WebKit and Batik have problems with a stroke-width of zero, so in this case we remove the 
	        // stroke attribute altogether. #1270, #1369, #3065, #3072.
	        SVGElement.prototype['stroke-widthSetter'] = SVGElement.prototype.strokeSetter = function(value, key, element) {
	            this[key] = value;
	            // Only apply the stroke attribute if the stroke width is defined and larger than 0
	            if (this.stroke && this['stroke-width']) {
	                SVGElement.prototype.fillSetter.call(this, this.stroke, 'stroke', element); // use prototype as instance may be overridden
	                element.setAttribute('stroke-width', this['stroke-width']);
	                this.hasStroke = true;
	            } else if (key === 'stroke-width' && value === 0 && this.hasStroke) {
	                element.removeAttribute('stroke');
	                this.hasStroke = false;
	            }
	        };
	
	
	        /**
	         * Allows direct access to the Highcharts rendering layer in order to draw
	         * primitive shapes like circles, rectangles, paths or text directly on a chart,
	         * or independent from any chart. The SVGRenderer represents a wrapper object
	         * for SVGin modern browsers and through the VMLRenderer, for VML in IE < 8.
	         *
	         * An existing chart's renderer can be accessed through {@link Chart.renderer}.
	         * The renderer can also be used completely decoupled from a chart.
	         *
	         * @param {HTMLDOMElement} container - Where to put the SVG in the web page.
	         * @param {number} width - The width of the SVG.
	         * @param {number} height - The height of the SVG.
	         * @param {boolean} [forExport=false] - Whether the rendered content is intended
	         *   for export.
	         * @param {boolean} [allowHTML=true] - Whether the renderer is allowed to
	         *   include HTML text, which will be projected on top of the SVG.
	         *
	         * @example
	         * // Use directly without a chart object.
	         * var renderer = new Highcharts.Renderer(parentNode, 600, 400);
	         *
	         * @sample highcharts/members/renderer-on-chart - Annotating a chart programmatically.
	         * @sample highcharts/members/renderer-basic - Independent SVG drawing.
	         *
	         * @class Highcharts.SVGRenderer
	         */
	        SVGRenderer = H.SVGRenderer = function() {
	            this.init.apply(this, arguments);
	        };
	        extend(SVGRenderer.prototype, /** @lends Highcharts.SVGRenderer.prototype */ {
	            /**
	             * A pointer to the renderer's associated Element class. The VMLRenderer
	             * will have a pointer to VMLElement here.
	             * @type {SVGElement}
	             */
	            Element: SVGElement,
	            SVG_NS: SVG_NS,
	            /**
	             * Initialize the SVGRenderer. Overridable initiator function that takes
	             * the same parameters as the constructor.
	             */
	            init: function(container, width, height, style, forExport, allowHTML) {
	                var renderer = this,
	                    boxWrapper,
	                    element,
	                    desc;
	
	                boxWrapper = renderer.createElement('svg')
	                    .attr({
	                        'version': '1.1',
	                        'class': 'highcharts-root'
	                    })
	
	                    .css(this.getStyle(style));
	                element = boxWrapper.element;
	                container.appendChild(element);
	
	                // For browsers other than IE, add the namespace attribute (#1978)
	                if (container.innerHTML.indexOf('xmlns') === -1) {
	                    attr(element, 'xmlns', this.SVG_NS);
	                }
	
	                // object properties
	                renderer.isSVG = true;
	
	                /** 
	                 * The root `svg` node of the renderer.
	                 * @name box
	                 * @memberOf SVGRenderer
	                 * @type {SVGDOMElement}
	                 */
	                this.box = element;
	                /** 
	                 * The wrapper for the root `svg` node of the renderer.
	                 *
	                 * @name boxWrapper
	                 * @memberOf SVGRenderer
	                 * @type {SVGElement}
	                 */
	                this.boxWrapper = boxWrapper;
	                renderer.alignedObjects = [];
	
	                /**
	                 * Page url used for internal references.
	                 * @type {string}
	                 */
	                // #24, #672, #1070
	                this.url = (isFirefox || isWebKit) && doc.getElementsByTagName('base').length ?
	                    win.location.href
	                    .replace(/#.*?$/, '') // remove the hash
	                    .replace(/<[^>]*>/g, '') // wing cut HTML
	                    .replace(/([\('\)])/g, '\\$1') // escape parantheses and quotes
	                    .replace(/ /g, '%20') : // replace spaces (needed for Safari only)
	                    '';
	
	                // Add description
	                desc = this.createElement('desc').add();
	                desc.element.appendChild(doc.createTextNode('Created with Highstock 5.0.14'));
	
	                /**
	                 * A pointer to the `defs` node of the root SVG.
	                 * @type {SVGElement}
	                 * @name defs
	                 * @memberOf SVGRenderer
	                 */
	                renderer.defs = this.createElement('defs').add();
	                renderer.allowHTML = allowHTML;
	                renderer.forExport = forExport;
	                renderer.gradients = {}; // Object where gradient SvgElements are stored
	                renderer.cache = {}; // Cache for numerical bounding boxes
	                renderer.cacheKeys = [];
	                renderer.imgCount = 0;
	
	                renderer.setSize(width, height, false);
	
	
	
	                // Issue 110 workaround:
	                // In Firefox, if a div is positioned by percentage, its pixel position may land
	                // between pixels. The container itself doesn't display this, but an SVG element
	                // inside this container will be drawn at subpixel precision. In order to draw
	                // sharp lines, this must be compensated for. This doesn't seem to work inside
	                // iframes though (like in jsFiddle).
	                var subPixelFix, rect;
	                if (isFirefox && container.getBoundingClientRect) {
	                    subPixelFix = function() {
	                        css(container, {
	                            left: 0,
	                            top: 0
	                        });
	                        rect = container.getBoundingClientRect();
	                        css(container, {
	                            left: (Math.ceil(rect.left) - rect.left) + 'px',
	                            top: (Math.ceil(rect.top) - rect.top) + 'px'
	                        });
	                    };
	
	                    // run the fix now
	                    subPixelFix();
	
	                    // run it on resize
	                    renderer.unSubPixelFix = addEvent(win, 'resize', subPixelFix);
	                }
	            },
	
	
	
	            /**
	             * Get the global style setting for the renderer.
	             * @private
	             * @param  {CSSObject} style - Style settings.
	             * @return {CSSObject} The style settings mixed with defaults.
	             */
	            getStyle: function(style) {
	                this.style = extend({
	
	                    fontFamily: '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif', // default font
	                    fontSize: '12px'
	
	                }, style);
	                return this.style;
	            },
	            /**
	             * Apply the global style on the renderer, mixed with the default styles.
	             * 
	             * @param {CSSObject} style - CSS to apply.
	             */
	            setStyle: function(style) {
	                this.boxWrapper.css(this.getStyle(style));
	            },
	
	
	            /**
	             * Detect whether the renderer is hidden. This happens when one of the
	             * parent elements has `display: none`. Used internally to detect when we
	             * needto render preliminarily in another div to get the text bounding boxes 
	             * right.
	             *
	             * @returns {boolean} True if it is hidden.
	             */
	            isHidden: function() { // #608
	                return !this.boxWrapper.getBBox().width;
	            },
	
	            /**
	             * Destroys the renderer and its allocated members.
	             */
	            destroy: function() {
	                var renderer = this,
	                    rendererDefs = renderer.defs;
	                renderer.box = null;
	                renderer.boxWrapper = renderer.boxWrapper.destroy();
	
	                // Call destroy on all gradient elements
	                destroyObjectProperties(renderer.gradients || {});
	                renderer.gradients = null;
	
	                // Defs are null in VMLRenderer
	                // Otherwise, destroy them here.
	                if (rendererDefs) {
	                    renderer.defs = rendererDefs.destroy();
	                }
	
	                // Remove sub pixel fix handler (#982)
	                if (renderer.unSubPixelFix) {
	                    renderer.unSubPixelFix();
	                }
	
	                renderer.alignedObjects = null;
	
	                return null;
	            },
	
	            /**
	             * Create a wrapper for an SVG element. Serves as a factory for 
	             * {@link SVGElement}, but this function is itself mostly called from 
	             * primitive factories like {@link SVGRenderer#path}, {@link
	             * SVGRenderer#rect} or {@link SVGRenderer#text}.
	             * 
	             * @param {string} nodeName - The node name, for example `rect`, `g` etc.
	             * @returns {SVGElement} The generated SVGElement.
	             */
	            createElement: function(nodeName) {
	                var wrapper = new this.Element();
	                wrapper.init(this, nodeName);
	                return wrapper;
	            },
	
	            /**
	             * Dummy function for plugins, called every time the renderer is updated.
	             * Prior to Highcharts 5, this was used for the canvg renderer.
	             * @function
	             */
	            draw: noop,
	
	            /**
	             * Get converted radial gradient attributes according to the radial
	             * reference. Used internally from the {@link SVGElement#colorGradient}
	             * function.
	             *
	             * @private
	             */
	            getRadialAttr: function(radialReference, gradAttr) {
	                return {
	                    cx: (radialReference[0] - radialReference[2] / 2) + gradAttr.cx * radialReference[2],
	                    cy: (radialReference[1] - radialReference[2] / 2) + gradAttr.cy * radialReference[2],
	                    r: gradAttr.r * radialReference[2]
	                };
	            },
	
	            getSpanWidth: function(wrapper, tspan) {
	                var renderer = this,
	                    bBox = wrapper.getBBox(true),
	                    actualWidth = bBox.width;
	
	                // Old IE cannot measure the actualWidth for SVG elements (#2314)
	                if (!svg && renderer.forExport) {
	                    actualWidth = renderer.measureSpanWidth(tspan.firstChild.data, wrapper.styles);
	                }
	                return actualWidth;
	            },
	
	            applyEllipsis: function(wrapper, tspan, text, width) {
	                var renderer = this,
	                    rotation = wrapper.rotation,
	                    str = text,
	                    currentIndex,
	                    minIndex = 0,
	                    maxIndex = text.length,
	                    updateTSpan = function(s) {
	                        tspan.removeChild(tspan.firstChild);
	                        if (s) {
	                            tspan.appendChild(doc.createTextNode(s));
	                        }
	                    },
	                    actualWidth,
	                    wasTooLong;
	                wrapper.rotation = 0; // discard rotation when computing box
	                actualWidth = renderer.getSpanWidth(wrapper, tspan);
	                wasTooLong = actualWidth > width;
	                if (wasTooLong) {
	                    while (minIndex <= maxIndex) {
	                        currentIndex = Math.ceil((minIndex + maxIndex) / 2);
	                        str = text.substring(0, currentIndex) + '\u2026';
	                        updateTSpan(str);
	                        actualWidth = renderer.getSpanWidth(wrapper, tspan);
	                        if (minIndex === maxIndex) {
	                            // Complete
	                            minIndex = maxIndex + 1;
	                        } else if (actualWidth > width) {
	                            // Too large. Set max index to current.
	                            maxIndex = currentIndex - 1;
	                        } else {
	                            // Within width. Set min index to current.
	                            minIndex = currentIndex;
	                        }
	                    }
	                    // If max index was 0 it means just ellipsis was also to large.
	                    if (maxIndex === 0) {
	                        // Remove ellipses.
	                        updateTSpan('');
	                    }
	                }
	                wrapper.rotation = rotation; // Apply rotation again.
	                return wasTooLong;
	            },
	
	            /**
	             * Parse a simple HTML string into SVG tspans. Called internally when text
	             *   is set on an SVGElement. The function supports a subset of HTML tags,
	             *   CSS text features like `width`, `text-overflow`, `white-space`, and
	             *   also attributes like `href` and `style`.
	             * @private
	             * @param {SVGElement} wrapper The parent SVGElement.
	             */
	            buildText: function(wrapper) {
	                var textNode = wrapper.element,
	                    renderer = this,
	                    forExport = renderer.forExport,
	                    textStr = pick(wrapper.textStr, '').toString(),
	                    hasMarkup = textStr.indexOf('<') !== -1,
	                    lines,
	                    childNodes = textNode.childNodes,
	                    clsRegex,
	                    styleRegex,
	                    hrefRegex,
	                    wasTooLong,
	                    parentX = attr(textNode, 'x'),
	                    textStyles = wrapper.styles,
	                    width = wrapper.textWidth,
	                    textLineHeight = textStyles && textStyles.lineHeight,
	                    textOutline = textStyles && textStyles.textOutline,
	                    ellipsis = textStyles && textStyles.textOverflow === 'ellipsis',
	                    noWrap = textStyles && textStyles.whiteSpace === 'nowrap',
	                    fontSize = textStyles && textStyles.fontSize,
	                    textCache,
	                    isSubsequentLine,
	                    i = childNodes.length,
	                    tempParent = width && !wrapper.added && this.box,
	                    getLineHeight = function(tspan) {
	                        var fontSizeStyle;
	
	                        fontSizeStyle = /(px|em)$/.test(tspan && tspan.style.fontSize) ?
	                            tspan.style.fontSize :
	                            (fontSize || renderer.style.fontSize || 12);
	
	
	                        return textLineHeight ?
	                            pInt(textLineHeight) :
	                            renderer.fontMetrics(
	                                fontSizeStyle,
	                                // Get the computed size from parent if not explicit
	                                tspan.getAttribute('style') ? tspan : textNode
	                            ).h;
	                    },
	                    unescapeAngleBrackets = function(inputStr) {
	                        return inputStr.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
	                    };
	
	                // The buildText code is quite heavy, so if we're not changing something
	                // that affects the text, skip it (#6113).
	                textCache = [
	                    textStr,
	                    ellipsis,
	                    noWrap,
	                    textLineHeight,
	                    textOutline,
	                    fontSize,
	                    width
	                ].join(',');
	                if (textCache === wrapper.textCache) {
	                    return;
	                }
	                wrapper.textCache = textCache;
	
	                /// remove old text
	                while (i--) {
	                    textNode.removeChild(childNodes[i]);
	                }
	
	                // Skip tspans, add text directly to text node. The forceTSpan is a hook
	                // used in text outline hack.
	                if (!hasMarkup && !textOutline && !ellipsis && !width && textStr.indexOf(' ') === -1) {
	                    textNode.appendChild(doc.createTextNode(unescapeAngleBrackets(textStr)));
	
	                    // Complex strings, add more logic
	                } else {
	
	                    clsRegex = /<.*class="([^"]+)".*>/;
	                    styleRegex = /<.*style="([^"]+)".*>/;
	                    hrefRegex = /<.*href="([^"]+)".*>/;
	
	                    if (tempParent) {
	                        tempParent.appendChild(textNode); // attach it to the DOM to read offset width
	                    }
	
	                    if (hasMarkup) {
	                        lines = textStr
	
	                            .replace(/<(b|strong)>/g, '<span style="font-weight:bold">')
	                            .replace(/<(i|em)>/g, '<span style="font-style:italic">')
	
	                            .replace(/<a/g, '<span')
	                            .replace(/<\/(b|strong|i|em|a)>/g, '</span>')
	                            .split(/<br.*?>/g);
	
	                    } else {
	                        lines = [textStr];
	                    }
	
	
	                    // Trim empty lines (#5261)
	                    lines = grep(lines, function(line) {
	                        return line !== '';
	                    });
	
	
	                    // build the lines
	                    each(lines, function buildTextLines(line, lineNo) {
	                        var spans,
	                            spanNo = 0;
	                        line = line
	                            .replace(/^\s+|\s+$/g, '') // Trim to prevent useless/costly process on the spaces (#5258)
	                            .replace(/<span/g, '|||<span')
	                            .replace(/<\/span>/g, '</span>|||');
	                        spans = line.split('|||');
	
	                        each(spans, function buildTextSpans(span) {
	                            if (span !== '' || spans.length === 1) {
	                                var attributes = {},
	                                    tspan = doc.createElementNS(renderer.SVG_NS, 'tspan'),
	                                    spanCls,
	                                    spanStyle; // #390
	                                if (clsRegex.test(span)) {
	                                    spanCls = span.match(clsRegex)[1];
	                                    attr(tspan, 'class', spanCls);
	                                }
	                                if (styleRegex.test(span)) {
	                                    spanStyle = span.match(styleRegex)[1].replace(/(;| |^)color([ :])/, '$1fill$2');
	                                    attr(tspan, 'style', spanStyle);
	                                }
	                                if (hrefRegex.test(span) && !forExport) { // Not for export - #1529
	                                    attr(tspan, 'onclick', 'location.href=\"' + span.match(hrefRegex)[1] + '\"');
	                                    css(tspan, {
	                                        cursor: 'pointer'
	                                    });
	                                }
	
	                                span = unescapeAngleBrackets(span.replace(/<(.|\n)*?>/g, '') || ' ');
	
	                                // Nested tags aren't supported, and cause crash in Safari (#1596)
	                                if (span !== ' ') {
	
	                                    // add the text node
	                                    tspan.appendChild(doc.createTextNode(span));
	
	                                    if (!spanNo) { // first span in a line, align it to the left
	                                        if (lineNo && parentX !== null) {
	                                            attributes.x = parentX;
	                                        }
	                                    } else {
	                                        attributes.dx = 0; // #16
	                                    }
	
	                                    // add attributes
	                                    attr(tspan, attributes);
	
	                                    // Append it
	                                    textNode.appendChild(tspan);
	
	                                    // first span on subsequent line, add the line height
	                                    if (!spanNo && isSubsequentLine) {
	
	                                        // allow getting the right offset height in exporting in IE
	                                        if (!svg && forExport) {
	                                            css(tspan, {
	                                                display: 'block'
	                                            });
	                                        }
	
	                                        // Set the line height based on the font size of either
	                                        // the text element or the tspan element
	                                        attr(
	                                            tspan,
	                                            'dy',
	                                            getLineHeight(tspan)
	                                        );
	                                    }
	
	                                    /*if (width) {
	                                    	renderer.breakText(wrapper, width);
	                                    }*/
	
	                                    // Check width and apply soft breaks or ellipsis
	                                    if (width) {
	                                        var words = span.replace(/([^\^])-/g, '$1- ').split(' '), // #1273
	                                            hasWhiteSpace = spans.length > 1 || lineNo || (words.length > 1 && !noWrap),
	                                            tooLong,
	                                            rest = [],
	                                            actualWidth,
	                                            dy = getLineHeight(tspan),
	                                            rotation = wrapper.rotation;
	
	                                        if (ellipsis) {
	                                            wasTooLong = renderer.applyEllipsis(wrapper, tspan, span, width);
	                                        }
	
	                                        while (!ellipsis && hasWhiteSpace && (words.length || rest.length)) {
	                                            wrapper.rotation = 0; // discard rotation when computing box
	                                            actualWidth = renderer.getSpanWidth(wrapper, tspan);
	                                            tooLong = actualWidth > width;
	
	                                            // For ellipsis, do a binary search for the correct string length
	                                            if (wasTooLong === undefined) {
	                                                wasTooLong = tooLong; // First time
	                                            }
	
	                                            // Looping down, this is the first word sequence that is not too long,
	                                            // so we can move on to build the next line.
	                                            if (!tooLong || words.length === 1) {
	                                                words = rest;
	                                                rest = [];
	
	                                                if (words.length && !noWrap) {
	                                                    tspan = doc.createElementNS(SVG_NS, 'tspan');
	                                                    attr(tspan, {
	                                                        dy: dy,
	                                                        x: parentX
	                                                    });
	                                                    if (spanStyle) { // #390
	                                                        attr(tspan, 'style', spanStyle);
	                                                    }
	                                                    textNode.appendChild(tspan);
	                                                }
	                                                if (actualWidth > width) { // a single word is pressing it out
	                                                    width = actualWidth;
	                                                }
	                                            } else { // append to existing line tspan
	                                                tspan.removeChild(tspan.firstChild);
	                                                rest.unshift(words.pop());
	                                            }
	                                            if (words.length) {
	                                                tspan.appendChild(doc.createTextNode(words.join(' ').replace(/- /g, '-')));
	                                            }
	                                        }
	                                        wrapper.rotation = rotation;
	                                    }
	
	                                    spanNo++;
	                                }
	                            }
	                        });
	                        // To avoid beginning lines that doesn't add to the textNode (#6144)
	                        isSubsequentLine = isSubsequentLine || textNode.childNodes.length;
	                    });
	
	                    if (wasTooLong) {
	                        wrapper.attr('title', wrapper.textStr);
	                    }
	                    if (tempParent) {
	                        tempParent.removeChild(textNode); // attach it to the DOM to read offset width
	                    }
	
	                    // Apply the text outline
	                    if (textOutline && wrapper.applyTextOutline) {
	                        wrapper.applyTextOutline(textOutline);
	                    }
	                }
	            },
	
	
	
	            /*
	            breakText: function (wrapper, width) {
	            	var bBox = wrapper.getBBox(),
	            		node = wrapper.element,
	            		textLength = node.textContent.length,
	            		pos = Math.round(width * textLength / bBox.width), // try this position first, based on average character width
	            		increment = 0,
	            		finalPos;
	
	            	if (bBox.width > width) {
	            		while (finalPos === undefined) {
	            			textLength = node.getSubStringLength(0, pos);
	
	            			if (textLength <= width) {
	            				if (increment === -1) {
	            					finalPos = pos;
	            				} else {
	            					increment = 1;
	            				}
	            			} else {
	            				if (increment === 1) {
	            					finalPos = pos - 1;
	            				} else {
	            					increment = -1;
	            				}
	            			}
	            			pos += increment;
	            		}
	            	}
	            	console.log('width', width, 'stringWidth', node.getSubStringLength(0, finalPos))
	            },
	            */
	
	            /**
	             * Returns white for dark colors and black for bright colors.
	             *
	             * @param {ColorString} rgba - The color to get the contrast for.
	             * @returns {string} The contrast color, either `#000000` or `#FFFFFF`.
	             */
	            getContrast: function(rgba) {
	                rgba = color(rgba).rgba;
	
	                // The threshold may be discussed. Here's a proposal for adding
	                // different weight to the color channels (#6216)
	                /*
	        rgba[0] *= 1; // red
	        rgba[1] *= 1.2; // green
	        rgba[2] *= 0.7; // blue
	        */
	
	                return rgba[0] + rgba[1] + rgba[2] > 2 * 255 ? '#000000' : '#FFFFFF';
	            },
	
	            /**
	             * Create a button with preset states.
	             * @param {string} text - The text or HTML to draw.
	             * @param {number} x - The x position of the button's left side.
	             * @param {number} y - The y position of the button's top side.
	             * @param {Function} callback - The function to execute on button click or 
	             *    touch.
	             * @param {SVGAttributes} [normalState] - SVG attributes for the normal
	             *    state.
	             * @param {SVGAttributes} [hoverState] - SVG attributes for the hover state.
	             * @param {SVGAttributes} [pressedState] - SVG attributes for the pressed
	             *    state.
	             * @param {SVGAttributes} [disabledState] - SVG attributes for the disabled
	             *    state.
	             * @param {Symbol} [shape=rect] - The shape type.
	             * @returns {SVGRenderer} The button element.
	             */
	            button: function(text, x, y, callback, normalState, hoverState, pressedState, disabledState, shape) {
	                var label = this.label(text, x, y, shape, null, null, null, null, 'button'),
	                    curState = 0;
	
	                // Default, non-stylable attributes
	                label.attr(merge({
	                    'padding': 8,
	                    'r': 2
	                }, normalState));
	
	
	                // Presentational
	                var normalStyle,
	                    hoverStyle,
	                    pressedStyle,
	                    disabledStyle;
	
	                // Normal state - prepare the attributes
	                normalState = merge({
	                    fill: '#f7f7f7',
	                    stroke: '#cccccc',
	                    'stroke-width': 1,
	                    style: {
	                        color: '#333333',
	                        cursor: 'pointer',
	                        fontWeight: 'normal'
	                    }
	                }, normalState);
	                normalStyle = normalState.style;
	                delete normalState.style;
	
	                // Hover state
	                hoverState = merge(normalState, {
	                    fill: '#e6e6e6'
	                }, hoverState);
	                hoverStyle = hoverState.style;
	                delete hoverState.style;
	
	                // Pressed state
	                pressedState = merge(normalState, {
	                    fill: '#e6ebf5',
	                    style: {
	                        color: '#000000',
	                        fontWeight: 'bold'
	                    }
	                }, pressedState);
	                pressedStyle = pressedState.style;
	                delete pressedState.style;
	
	                // Disabled state
	                disabledState = merge(normalState, {
	                    style: {
	                        color: '#cccccc'
	                    }
	                }, disabledState);
	                disabledStyle = disabledState.style;
	                delete disabledState.style;
	
	
	                // Add the events. IE9 and IE10 need mouseover and mouseout to funciton (#667).
	                addEvent(label.element, isMS ? 'mouseover' : 'mouseenter', function() {
	                    if (curState !== 3) {
	                        label.setState(1);
	                    }
	                });
	                addEvent(label.element, isMS ? 'mouseout' : 'mouseleave', function() {
	                    if (curState !== 3) {
	                        label.setState(curState);
	                    }
	                });
	
	                label.setState = function(state) {
	                    // Hover state is temporary, don't record it
	                    if (state !== 1) {
	                        label.state = curState = state;
	                    }
	                    // Update visuals
	                    label.removeClass(/highcharts-button-(normal|hover|pressed|disabled)/)
	                        .addClass('highcharts-button-' + ['normal', 'hover', 'pressed', 'disabled'][state || 0]);
	
	
	                    label.attr([normalState, hoverState, pressedState, disabledState][state || 0])
	                        .css([normalStyle, hoverStyle, pressedStyle, disabledStyle][state || 0]);
	
	                };
	
	
	
	                // Presentational attributes
	                label
	                    .attr(normalState)
	                    .css(extend({
	                        cursor: 'default'
	                    }, normalStyle));
	
	
	                return label
	                    .on('click', function(e) {
	                        if (curState !== 3) {
	                            callback.call(label, e);
	                        }
	                    });
	            },
	
	            /**
	             * Make a straight line crisper by not spilling out to neighbour pixels.
	             * 
	             * @param {Array} points - The original points on the format `['M', 0, 0,
	             *    'L', 100, 0]`.
	             * @param {number} width - The width of the line.
	             * @returns {Array} The original points array, but modified to render
	             * crisply.
	             */
	            crispLine: function(points, width) {
	                // normalize to a crisp line
	                if (points[1] === points[4]) {
	                    // Substract due to #1129. Now bottom and left axis gridlines behave the same.
	                    points[1] = points[4] = Math.round(points[1]) - (width % 2 / 2);
	                }
	                if (points[2] === points[5]) {
	                    points[2] = points[5] = Math.round(points[2]) + (width % 2 / 2);
	                }
	                return points;
	            },
	
	
	            /**
	             * Draw a path, wraps the SVG `path` element.
	             * 
	             * @param {Array} [path] An SVG path definition in array form.
	             * 
	             * @example
	             * var path = renderer.path(['M', 10, 10, 'L', 30, 30, 'z'])
	             *     .attr({ stroke: '#ff00ff' })
	             *     .add();
	             * @returns {SVGElement} The generated wrapper element.
	             *
	             * @sample highcharts/members/renderer-path-on-chart/
	             *         Draw a path in a chart
	             * @sample highcharts/members/renderer-path/
	             *         Draw a path independent from a chart
	             *
	             */
	            /**
	             * Draw a path, wraps the SVG `path` element.
	             * 
	             * @param {SVGAttributes} [attribs] The initial attributes.
	             * @returns {SVGElement} The generated wrapper element.
	             */
	            path: function(path) {
	                var attribs = {
	
	                    fill: 'none'
	
	                };
	                if (isArray(path)) {
	                    attribs.d = path;
	                } else if (isObject(path)) { // attributes
	                    extend(attribs, path);
	                }
	                return this.createElement('path').attr(attribs);
	            },
	
	            /**
	             * Draw a circle, wraps the SVG `circle` element.
	             * 
	             * @param {number} [x] The center x position.
	             * @param {number} [y] The center y position.
	             * @param {number} [r] The radius.
	             * @returns {SVGElement} The generated wrapper element.
	             *
	             * @sample highcharts/members/renderer-circle/ Drawing a circle
	             */
	            /**
	             * Draw a circle, wraps the SVG `circle` element.
	             * 
	             * @param {SVGAttributes} [attribs] The initial attributes.
	             * @returns {SVGElement} The generated wrapper element.
	             */
	            circle: function(x, y, r) {
	                var attribs = isObject(x) ? x : {
	                        x: x,
	                        y: y,
	                        r: r
	                    },
	                    wrapper = this.createElement('circle');
	
	                // Setting x or y translates to cx and cy
	                wrapper.xSetter = wrapper.ySetter = function(value, key, element) {
	                    element.setAttribute('c' + key, value);
	                };
	
	                return wrapper.attr(attribs);
	            },
	
	            /**
	             * Draw and return an arc.
	             * @param {number} [x=0] Center X position.
	             * @param {number} [y=0] Center Y position.
	             * @param {number} [r=0] The outer radius of the arc.
	             * @param {number} [innerR=0] Inner radius like used in donut charts.
	             * @param {number} [start=0] The starting angle of the arc in radians, where
	             *    0 is to the right and `-Math.PI/2` is up.
	             * @param {number} [end=0] The ending angle of the arc in radians, where 0
	             *    is to the right and `-Math.PI/2` is up.
	             * @returns {SVGElement} The generated wrapper element.
	             *
	             * @sample highcharts/members/renderer-arc/
	             *         Drawing an arc
	             */
	            /**
	             * Draw and return an arc. Overloaded function that takes arguments object.
	             * @param {SVGAttributes} attribs Initial SVG attributes.
	             * @returns {SVGElement} The generated wrapper element.
	             */
	            arc: function(x, y, r, innerR, start, end) {
	                var arc,
	                    options;
	
	                if (isObject(x)) {
	                    options = x;
	                    y = options.y;
	                    r = options.r;
	                    innerR = options.innerR;
	                    start = options.start;
	                    end = options.end;
	                    x = options.x;
	                } else {
	                    options = {
	                        innerR: innerR,
	                        start: start,
	                        end: end
	                    };
	                }
	
	                // Arcs are defined as symbols for the ability to set
	                // attributes in attr and animate
	                arc = this.symbol('arc', x, y, r, r, options);
	                arc.r = r; // #959
	                return arc;
	            },
	
	            /**
	             * Draw and return a rectangle.
	             * @param {number} [x] Left position.
	             * @param {number} [y] Top position.
	             * @param {number} [width] Width of the rectangle.
	             * @param {number} [height] Height of the rectangle.
	             * @param {number} [r] Border corner radius.
	             * @param {number} [strokeWidth] A stroke width can be supplied to allow
	             *    crisp drawing.
	             * @returns {SVGElement} The generated wrapper element.
	             */
	            /**
	             * Draw and return a rectangle.
	             * @param  {SVGAttributes} [attributes]
	             *         General SVG attributes for the rectangle.
	             * @return {SVGElement}
	             *         The generated wrapper element.
	             *
	             * @sample highcharts/members/renderer-rect-on-chart/
	             *         Draw a rectangle in a chart
	             * @sample highcharts/members/renderer-rect/
	             *         Draw a rectangle independent from a chart
	             */
	            rect: function(x, y, width, height, r, strokeWidth) {
	
	                r = isObject(x) ? x.r : r;
	
	                var wrapper = this.createElement('rect'),
	                    attribs = isObject(x) ? x : x === undefined ? {} : {
	                        x: x,
	                        y: y,
	                        width: Math.max(width, 0),
	                        height: Math.max(height, 0)
	                    };
	
	
	                if (strokeWidth !== undefined) {
	                    attribs.strokeWidth = strokeWidth;
	                    attribs = wrapper.crisp(attribs);
	                }
	                attribs.fill = 'none';
	
	
	                if (r) {
	                    attribs.r = r;
	                }
	
	                wrapper.rSetter = function(value, key, element) {
	                    attr(element, {
	                        rx: value,
	                        ry: value
	                    });
	                };
	
	                return wrapper.attr(attribs);
	            },
	
	            /**
	             * Resize the {@link SVGRenderer#box} and re-align all aligned child
	             * elements.
	             * @param  {number} width
	             *         The new pixel width.
	             * @param  {number} height
	             *         The new pixel height.
	             * @param  {Boolean|AnimationOptions} [animate=true]
	             *         Whether and how to animate.
	             */
	            setSize: function(width, height, animate) {
	                var renderer = this,
	                    alignedObjects = renderer.alignedObjects,
	                    i = alignedObjects.length;
	
	                renderer.width = width;
	                renderer.height = height;
	
	                renderer.boxWrapper.animate({
	                    width: width,
	                    height: height
	                }, {
	                    step: function() {
	                        this.attr({
	                            viewBox: '0 0 ' + this.attr('width') + ' ' + this.attr('height')
	                        });
	                    },
	                    duration: pick(animate, true) ? undefined : 0
	                });
	
	                while (i--) {
	                    alignedObjects[i].align();
	                }
	            },
	
	            /**
	             * Create and return an svg group element. Child {@link Highcharts.SVGElement}
	             * objects are added to the group by using the group as the first parameter
	             * in {@link Highcharts.SVGElement#add|add()}.
	             * 
	             * @param {string} [name] The group will be given a class name of
	             * `highcharts-{name}`. This can be used for styling and scripting.
	             * @returns {SVGElement} The generated wrapper element.
	             *
	             * @sample highcharts/members/renderer-g/
	             *         Show and hide grouped objects
	             */
	            g: function(name) {
	                var elem = this.createElement('g');
	                return name ? elem.attr({
	                    'class': 'highcharts-' + name
	                }) : elem;
	            },
	
	            /**
	             * Display an image.
	             * @param {string} src The image source.
	             * @param {number} [x] The X position.
	             * @param {number} [y] The Y position.
	             * @param {number} [width] The image width. If omitted, it defaults to the 
	             *    image file width.
	             * @param {number} [height] The image height. If omitted it defaults to the
	             *    image file height.
	             * @returns {SVGElement} The generated wrapper element.
	             *
	             * @sample highcharts/members/renderer-image-on-chart/
	             *         Add an image in a chart
	             * @sample highcharts/members/renderer-image/
	             *         Add an image independent of a chart
	             */
	            image: function(src, x, y, width, height) {
	                var attribs = {
	                        preserveAspectRatio: 'none'
	                    },
	                    elemWrapper;
	
	                // optional properties
	                if (arguments.length > 1) {
	                    extend(attribs, {
	                        x: x,
	                        y: y,
	                        width: width,
	                        height: height
	                    });
	                }
	
	                elemWrapper = this.createElement('image').attr(attribs);
	
	                // set the href in the xlink namespace
	                if (elemWrapper.element.setAttributeNS) {
	                    elemWrapper.element.setAttributeNS('http://www.w3.org/1999/xlink',
	                        'href', src);
	                } else {
	                    // could be exporting in IE
	                    // using href throws "not supported" in ie7 and under, requries regex shim to fix later
	                    elemWrapper.element.setAttribute('hc-svg-href', src);
	                }
	                return elemWrapper;
	            },
	
	            /**
	             * Draw a symbol out of pre-defined shape paths from {@link SVGRenderer#symbols}.
	             * It is used in Highcharts for point makers, which cake a `symbol` option,
	             * and label and button backgrounds like in the tooltip and stock flags.
	             *
	             * @param {Symbol} symbol - The symbol name.
	             * @param {number} x - The X coordinate for the top left position.
	             * @param {number} y - The Y coordinate for the top left position.
	             * @param {number} width - The pixel width.
	             * @param {number} height - The pixel height.
	             * @param {Object} [options] - Additional options, depending on the actual
	             *    symbol drawn. 
	             * @param {number} [options.anchorX] - The anchor X position for the
	             *    `callout` symbol. This is where the chevron points to.
	             * @param {number} [options.anchorY] - The anchor Y position for the
	             *    `callout` symbol. This is where the chevron points to.
	             * @param {number} [options.end] - The end angle of an `arc` symbol.
	             * @param {boolean} [options.open] - Whether to draw `arc` symbol open or
	             *    closed.
	             * @param {number} [options.r] - The radius of an `arc` symbol, or the
	             *    border radius for the `callout` symbol.
	             * @param {number} [options.start] - The start angle of an `arc` symbol.
	             */
	            symbol: function(symbol, x, y, width, height, options) {
	
	                var ren = this,
	                    obj,
	                    imageRegex = /^url\((.*?)\)$/,
	                    isImage = imageRegex.test(symbol),
	                    sym = !isImage && (this.symbols[symbol] ? symbol : 'circle'),
	
	
	                    // get the symbol definition function
	                    symbolFn = sym && this.symbols[sym],
	
	                    // check if there's a path defined for this symbol
	                    path = defined(x) && symbolFn && symbolFn.call(
	                        this.symbols,
	                        Math.round(x),
	                        Math.round(y),
	                        width,
	                        height,
	                        options
	                    ),
	                    imageSrc,
	                    centerImage;
	
	                if (symbolFn) {
	                    obj = this.path(path);
	
	
	                    obj.attr('fill', 'none');
	
	
	                    // expando properties for use in animate and attr
	                    extend(obj, {
	                        symbolName: sym,
	                        x: x,
	                        y: y,
	                        width: width,
	                        height: height
	                    });
	                    if (options) {
	                        extend(obj, options);
	                    }
	
	
	                    // Image symbols
	                } else if (isImage) {
	
	
	                    imageSrc = symbol.match(imageRegex)[1];
	
	                    // Create the image synchronously, add attribs async
	                    obj = this.image(imageSrc);
	
	                    // The image width is not always the same as the symbol width. The
	                    // image may be centered within the symbol, as is the case when
	                    // image shapes are used as label backgrounds, for example in flags.
	                    obj.imgwidth = pick(
	                        symbolSizes[imageSrc] && symbolSizes[imageSrc].width,
	                        options && options.width
	                    );
	                    obj.imgheight = pick(
	                        symbolSizes[imageSrc] && symbolSizes[imageSrc].height,
	                        options && options.height
	                    );
	                    /**
	                     * Set the size and position
	                     */
	                    centerImage = function() {
	                        obj.attr({
	                            width: obj.width,
	                            height: obj.height
	                        });
	                    };
	
	                    /**
	                     * Width and height setters that take both the image's physical size
	                     * and the label size into consideration, and translates the image
	                     * to center within the label.
	                     */
	                    each(['width', 'height'], function(key) {
	                        obj[key + 'Setter'] = function(value, key) {
	                            var attribs = {},
	                                imgSize = this['img' + key],
	                                trans = key === 'width' ? 'translateX' : 'translateY';
	                            this[key] = value;
	                            if (defined(imgSize)) {
	                                if (this.element) {
	                                    this.element.setAttribute(key, imgSize);
	                                }
	                                if (!this.alignByTranslate) {
	                                    attribs[trans] = ((this[key] || 0) - imgSize) / 2;
	                                    this.attr(attribs);
	                                }
	                            }
	                        };
	                    });
	
	
	                    if (defined(x)) {
	                        obj.attr({
	                            x: x,
	                            y: y
	                        });
	                    }
	                    obj.isImg = true;
	
	                    if (defined(obj.imgwidth) && defined(obj.imgheight)) {
	                        centerImage();
	                    } else {
	                        // Initialize image to be 0 size so export will still function if there's no cached sizes.
	                        obj.attr({
	                            width: 0,
	                            height: 0
	                        });
	
	                        // Create a dummy JavaScript image to get the width and height. Due to a bug in IE < 8,
	                        // the created element must be assigned to a variable in order to load (#292).
	                        createElement('img', {
	                            onload: function() {
	
	                                var chart = charts[ren.chartIndex];
	
	                                // Special case for SVGs on IE11, the width is not accessible until the image is
	                                // part of the DOM (#2854).
	                                if (this.width === 0) {
	                                    css(this, {
	                                        position: 'absolute',
	                                        top: '-999em'
	                                    });
	                                    doc.body.appendChild(this);
	                                }
	
	                                // Center the image
	                                symbolSizes[imageSrc] = { // Cache for next	
	                                    width: this.width,
	                                    height: this.height
	                                };
	                                obj.imgwidth = this.width;
	                                obj.imgheight = this.height;
	
	                                if (obj.element) {
	                                    centerImage();
	                                }
	
	                                // Clean up after #2854 workaround.
	                                if (this.parentNode) {
	                                    this.parentNode.removeChild(this);
	                                }
	
	                                // Fire the load event when all external images are loaded
	                                ren.imgCount--;
	                                if (!ren.imgCount && chart && chart.onload) {
	                                    chart.onload();
	                                }
	                            },
	                            src: imageSrc
	                        });
	                        this.imgCount++;
	                    }
	                }
	
	                return obj;
	            },
	
	            /**
	             * @typedef {string} Symbol
	             * 
	             * Can be one of `arc`, `callout`, `circle`, `diamond`, `square`,
	             * `triangle`, `triangle-down`. Symbols are used internally for point
	             * markers, button and label borders and backgrounds, or custom shapes.
	             * Extendable by adding to {@link SVGRenderer#symbols}.
	             */
	            /**
	             * An extendable collection of functions for defining symbol paths.
	             */
	            symbols: {
	                'circle': function(x, y, w, h) {
	                    // Return a full arc
	                    return this.arc(x + w / 2, y + h / 2, w / 2, h / 2, {
	                        start: 0,
	                        end: Math.PI * 2,
	                        open: false
	                    });
	                },
	
	                'square': function(x, y, w, h) {
	                    return [
	                        'M', x, y,
	                        'L', x + w, y,
	                        x + w, y + h,
	                        x, y + h,
	                        'Z'
	                    ];
	                },
	
	                'triangle': function(x, y, w, h) {
	                    return [
	                        'M', x + w / 2, y,
	                        'L', x + w, y + h,
	                        x, y + h,
	                        'Z'
	                    ];
	                },
	
	                'triangle-down': function(x, y, w, h) {
	                    return [
	                        'M', x, y,
	                        'L', x + w, y,
	                        x + w / 2, y + h,
	                        'Z'
	                    ];
	                },
	                'diamond': function(x, y, w, h) {
	                    return [
	                        'M', x + w / 2, y,
	                        'L', x + w, y + h / 2,
	                        x + w / 2, y + h,
	                        x, y + h / 2,
	                        'Z'
	                    ];
	                },
	                'arc': function(x, y, w, h, options) {
	                    var start = options.start,
	                        rx = options.r || w,
	                        ry = options.r || h || w,
	                        proximity = 0.001,
	                        fullCircle =
	                        Math.abs(options.end - options.start - 2 * Math.PI) <
	                        proximity,
	                        // Substract a small number to prevent cos and sin of start and
	                        // end from becoming equal on 360 arcs (related: #1561)
	                        end = options.end - proximity,
	                        innerRadius = options.innerR,
	                        open = pick(options.open, fullCircle),
	                        cosStart = Math.cos(start),
	                        sinStart = Math.sin(start),
	                        cosEnd = Math.cos(end),
	                        sinEnd = Math.sin(end),
	                        // Proximity takes care of rounding errors around PI (#6971)
	                        longArc = options.end - start - Math.PI < proximity ? 0 : 1,
	                        arc;
	
	                    arc = [
	                        'M',
	                        x + rx * cosStart,
	                        y + ry * sinStart,
	                        'A', // arcTo
	                        rx, // x radius
	                        ry, // y radius
	                        0, // slanting
	                        longArc, // long or short arc
	                        1, // clockwise
	                        x + rx * cosEnd,
	                        y + ry * sinEnd
	                    ];
	
	                    if (defined(innerRadius)) {
	                        arc.push(
	                            open ? 'M' : 'L',
	                            x + innerRadius * cosEnd,
	                            y + innerRadius * sinEnd,
	                            'A', // arcTo
	                            innerRadius, // x radius
	                            innerRadius, // y radius
	                            0, // slanting
	                            longArc, // long or short arc
	                            0, // clockwise
	                            x + innerRadius * cosStart,
	                            y + innerRadius * sinStart
	                        );
	                    }
	
	                    arc.push(open ? '' : 'Z'); // close
	                    return arc;
	                },
	
	                /**
	                 * Callout shape used for default tooltips, also used for rounded rectangles in VML
	                 */
	                callout: function(x, y, w, h, options) {
	                    var arrowLength = 6,
	                        halfDistance = 6,
	                        r = Math.min((options && options.r) || 0, w, h),
	                        safeDistance = r + halfDistance,
	                        anchorX = options && options.anchorX,
	                        anchorY = options && options.anchorY,
	                        path;
	
	                    path = [
	                        'M', x + r, y,
	                        'L', x + w - r, y, // top side
	                        'C', x + w, y, x + w, y, x + w, y + r, // top-right corner
	                        'L', x + w, y + h - r, // right side
	                        'C', x + w, y + h, x + w, y + h, x + w - r, y + h, // bottom-right corner
	                        'L', x + r, y + h, // bottom side
	                        'C', x, y + h, x, y + h, x, y + h - r, // bottom-left corner
	                        'L', x, y + r, // left side
	                        'C', x, y, x, y, x + r, y // top-left corner
	                    ];
	
	                    // Anchor on right side
	                    if (anchorX && anchorX > w) {
	
	                        // Chevron
	                        if (anchorY > y + safeDistance && anchorY < y + h - safeDistance) {
	                            path.splice(13, 3,
	                                'L', x + w, anchorY - halfDistance,
	                                x + w + arrowLength, anchorY,
	                                x + w, anchorY + halfDistance,
	                                x + w, y + h - r
	                            );
	
	                            // Simple connector
	                        } else {
	                            path.splice(13, 3,
	                                'L', x + w, h / 2,
	                                anchorX, anchorY,
	                                x + w, h / 2,
	                                x + w, y + h - r
	                            );
	                        }
	
	                        // Anchor on left side
	                    } else if (anchorX && anchorX < 0) {
	
	                        // Chevron
	                        if (anchorY > y + safeDistance && anchorY < y + h - safeDistance) {
	                            path.splice(33, 3,
	                                'L', x, anchorY + halfDistance,
	                                x - arrowLength, anchorY,
	                                x, anchorY - halfDistance,
	                                x, y + r
	                            );
	
	                            // Simple connector
	                        } else {
	                            path.splice(33, 3,
	                                'L', x, h / 2,
	                                anchorX, anchorY,
	                                x, h / 2,
	                                x, y + r
	                            );
	                        }
	
	                    } else if (anchorY && anchorY > h && anchorX > x + safeDistance && anchorX < x + w - safeDistance) { // replace bottom
	                        path.splice(23, 3,
	                            'L', anchorX + halfDistance, y + h,
	                            anchorX, y + h + arrowLength,
	                            anchorX - halfDistance, y + h,
	                            x + r, y + h
	                        );
	                    } else if (anchorY && anchorY < 0 && anchorX > x + safeDistance && anchorX < x + w - safeDistance) { // replace top
	                        path.splice(3, 3,
	                            'L', anchorX - halfDistance, y,
	                            anchorX, y - arrowLength,
	                            anchorX + halfDistance, y,
	                            w - r, y
	                        );
	                    }
	
	                    return path;
	                }
	            },
	
	            /**
	             * @typedef {SVGElement} ClipRect - A clipping rectangle that can be applied
	             * to one or more {@link SVGElement} instances. It is instanciated with the
	             * {@link SVGRenderer#clipRect} function and applied with the {@link 
	             * SVGElement#clip} function.
	             *
	             * @example
	             * var circle = renderer.circle(100, 100, 100)
	             *     .attr({ fill: 'red' })
	             *     .add();
	             * var clipRect = renderer.clipRect(100, 100, 100, 100);
	             *
	             * // Leave only the lower right quarter visible
	             * circle.clip(clipRect);
	             */
	            /**
	             * Define a clipping rectangle. The clipping rectangle is later applied
	             * to {@link SVGElement} objects through the {@link SVGElement#clip}
	             * function.
	             * 
	             * @param {String} id
	             * @param {number} x
	             * @param {number} y
	             * @param {number} width
	             * @param {number} height
	             * @returns {ClipRect} A clipping rectangle.
	             *
	             * @example
	             * var circle = renderer.circle(100, 100, 100)
	             *     .attr({ fill: 'red' })
	             *     .add();
	             * var clipRect = renderer.clipRect(100, 100, 100, 100);
	             *
	             * // Leave only the lower right quarter visible
	             * circle.clip(clipRect);
	             */
	            clipRect: function(x, y, width, height) {
	                var wrapper,
	                    id = H.uniqueKey(),
	
	                    clipPath = this.createElement('clipPath').attr({
	                        id: id
	                    }).add(this.defs);
	
	                wrapper = this.rect(x, y, width, height, 0).add(clipPath);
	                wrapper.id = id;
	                wrapper.clipPath = clipPath;
	                wrapper.count = 0;
	
	                return wrapper;
	            },
	
	
	
	
	
	            /**
	             * Draw text. The text can contain a subset of HTML, like spans and anchors
	             * and some basic text styling of these. For more advanced features like
	             * border and background, use {@link Highcharts.SVGRenderer#label} instead.
	             * To update the text after render, run `text.attr({ text: 'New text' })`.
	             * @param  {String} str
	             *         The text of (subset) HTML to draw.
	             * @param  {number} x
	             *         The x position of the text's lower left corner.
	             * @param  {number} y
	             *         The y position of the text's lower left corner.
	             * @param  {Boolean} [useHTML=false]
	             *         Use HTML to render the text.
	             *
	             * @return {SVGElement} The text object.
	             *
	             * @sample highcharts/members/renderer-text-on-chart/
	             *         Annotate the chart freely
	             * @sample highcharts/members/renderer-on-chart/
	             *         Annotate with a border and in response to the data
	             * @sample highcharts/members/renderer-text/
	             *         Formatted text
	             */
	            text: function(str, x, y, useHTML) {
	
	                // declare variables
	                var renderer = this,
	                    fakeSVG = !svg && renderer.forExport,
	                    wrapper,
	                    attribs = {};
	
	                if (useHTML && (renderer.allowHTML || !renderer.forExport)) {
	                    return renderer.html(str, x, y);
	                }
	
	                attribs.x = Math.round(x || 0); // X is always needed for line-wrap logic
	                if (y) {
	                    attribs.y = Math.round(y);
	                }
	                if (str || str === 0) {
	                    attribs.text = str;
	                }
	
	                wrapper = renderer.createElement('text')
	                    .attr(attribs);
	
	                // Prevent wrapping from creating false offsetWidths in export in legacy IE (#1079, #1063)
	                if (fakeSVG) {
	                    wrapper.css({
	                        position: 'absolute'
	                    });
	                }
	
	                if (!useHTML) {
	                    wrapper.xSetter = function(value, key, element) {
	                        var tspans = element.getElementsByTagName('tspan'),
	                            tspan,
	                            parentVal = element.getAttribute(key),
	                            i;
	                        for (i = 0; i < tspans.length; i++) {
	                            tspan = tspans[i];
	                            // If the x values are equal, the tspan represents a linebreak
	                            if (tspan.getAttribute(key) === parentVal) {
	                                tspan.setAttribute(key, value);
	                            }
	                        }
	                        element.setAttribute(key, value);
	                    };
	                }
	
	                return wrapper;
	            },
	
	            /**
	             * Utility to return the baseline offset and total line height from the font
	             * size.
	             *
	             * @param {?string} fontSize The current font size to inspect. If not given,
	             *   the font size will be found from the DOM element.
	             * @param {SVGElement|SVGDOMElement} [elem] The element to inspect for a
	             *   current font size.
	             * @returns {Object} An object containing `h`: the line height, `b`: the
	             * baseline relative to the top of the box, and `f`: the font size.
	             */
	            fontMetrics: function(fontSize, elem) {
	                var lineHeight,
	                    baseline;
	
	
	                fontSize = fontSize ||
	                    // When the elem is a DOM element (#5932)
	                    (elem && elem.style && elem.style.fontSize) ||
	                    // Fall back on the renderer style default
	                    (this.style && this.style.fontSize);
	
	
	
	                // Handle different units
	                if (/px/.test(fontSize)) {
	                    fontSize = pInt(fontSize);
	                } else if (/em/.test(fontSize)) {
	                    // The em unit depends on parent items
	                    fontSize = parseFloat(fontSize) *
	                        (elem ? this.fontMetrics(null, elem.parentNode).f : 16);
	                } else {
	                    fontSize = 12;
	                }
	
	                // Empirical values found by comparing font size and bounding box
	                // height. Applies to the default font family.
	                // http://jsfiddle.net/highcharts/7xvn7/
	                lineHeight = fontSize < 24 ? fontSize + 3 : Math.round(fontSize * 1.2);
	                baseline = Math.round(lineHeight * 0.8);
	
	                return {
	                    h: lineHeight,
	                    b: baseline,
	                    f: fontSize
	                };
	            },
	
	            /**
	             * Correct X and Y positioning of a label for rotation (#1764).
	             *
	             * @private
	             */
	            rotCorr: function(baseline, rotation, alterY) {
	                var y = baseline;
	                if (rotation && alterY) {
	                    y = Math.max(y * Math.cos(rotation * deg2rad), 4);
	                }
	                return {
	                    x: (-baseline / 3) * Math.sin(rotation * deg2rad),
	                    y: y
	                };
	            },
	
	            /**
	             * Draw a label, which is an extended text element with support for border
	             * and background. Highcharts creates a `g` element with a text and a `path`
	             * or `rect` inside, to make it behave somewhat like a HTML div. Border and
	             * background are set through `stroke`, `stroke-width` and `fill` attributes
	             * using the {@link Highcharts.SVGElement#attr|attr} method. To update the
	             * text after render, run `label.attr({ text: 'New text' })`.
	             * 
	             * @param  {string} str
	             *         The initial text string or (subset) HTML to render.
	             * @param  {number} x
	             *         The x position of the label's left side.
	             * @param  {number} y
	             *         The y position of the label's top side or baseline, depending on
	             *         the `baseline` parameter.
	             * @param  {String} shape
	             *         The shape of the label's border/background, if any. Defaults to
	             *         `rect`. Other possible values are `callout` or other shapes
	             *         defined in {@link Highcharts.SVGRenderer#symbols}.
	             * @param  {number} anchorX
	             *         In case the `shape` has a pointer, like a flag, this is the
	             *         coordinates it should be pinned to.
	             * @param  {number} anchorY
	             *         In case the `shape` has a pointer, like a flag, this is the
	             *         coordinates it should be pinned to.
	             * @param  {Boolean} baseline
	             *         Whether to position the label relative to the text baseline,
	             *	       like {@link Highcharts.SVGRenderer#text|renderer.text}, or to the
	             *	       upper border of the rectangle.
	             * @param  {String} className
	             *         Class name for the group.
	             *
	             * @return {SVGElement}
	             *         The generated label.
	             *
	             * @sample highcharts/members/renderer-label-on-chart/
	             *         A label on the chart
	             */
	            label: function(str, x, y, shape, anchorX, anchorY, useHTML, baseline, className) {
	
	                var renderer = this,
	                    wrapper = renderer.g(className !== 'button' && 'label'),
	                    text = wrapper.text = renderer.text('', 0, 0, useHTML)
	                    .attr({
	                        zIndex: 1
	                    }),
	                    box,
	                    bBox,
	                    alignFactor = 0,
	                    padding = 3,
	                    paddingLeft = 0,
	                    width,
	                    height,
	                    wrapperX,
	                    wrapperY,
	                    textAlign,
	                    deferredAttr = {},
	                    strokeWidth,
	                    baselineOffset,
	                    hasBGImage = /^url\((.*?)\)$/.test(shape),
	                    needsBox = hasBGImage,
	                    getCrispAdjust,
	                    updateBoxSize,
	                    updateTextPadding,
	                    boxAttr;
	
	                if (className) {
	                    wrapper.addClass('highcharts-' + className);
	                }
	
	
	                needsBox = hasBGImage;
	                getCrispAdjust = function() {
	                    return (strokeWidth || 0) % 2 / 2;
	                };
	
	
	
	                /**
	                 * This function runs after the label is added to the DOM (when the bounding box is
	                 * available), and after the text of the label is updated to detect the new bounding
	                 * box and reflect it in the border box.
	                 */
	                updateBoxSize = function() {
	                    var style = text.element.style,
	                        crispAdjust,
	                        attribs = {};
	
	                    bBox = (width === undefined || height === undefined || textAlign) && defined(text.textStr) &&
	                        text.getBBox(); //#3295 && 3514 box failure when string equals 0
	                    wrapper.width = (width || bBox.width || 0) + 2 * padding + paddingLeft;
	                    wrapper.height = (height || bBox.height || 0) + 2 * padding;
	
	                    // Update the label-scoped y offset
	                    baselineOffset = padding + renderer.fontMetrics(style && style.fontSize, text).b;
	
	
	                    if (needsBox) {
	
	                        // Create the border box if it is not already present
	                        if (!box) {
	                            wrapper.box = box = renderer.symbols[shape] || hasBGImage ? // Symbol definition exists (#5324)
	                                renderer.symbol(shape) :
	                                renderer.rect();
	
	                            box.addClass(
	                                (className === 'button' ? '' : 'highcharts-label-box') + // Don't use label className for buttons
	                                (className ? ' highcharts-' + className + '-box' : '')
	                            );
	
	                            box.add(wrapper);
	
	                            crispAdjust = getCrispAdjust();
	                            attribs.x = crispAdjust;
	                            attribs.y = (baseline ? -baselineOffset : 0) + crispAdjust;
	                        }
	
	                        // Apply the box attributes
	                        attribs.width = Math.round(wrapper.width);
	                        attribs.height = Math.round(wrapper.height);
	
	                        box.attr(extend(attribs, deferredAttr));
	                        deferredAttr = {};
	                    }
	                };
	
	                /**
	                 * This function runs after setting text or padding, but only if padding is changed
	                 */
	                updateTextPadding = function() {
	                    var textX = paddingLeft + padding,
	                        textY;
	
	                    // determin y based on the baseline
	                    textY = baseline ? 0 : baselineOffset;
	
	                    // compensate for alignment
	                    if (defined(width) && bBox && (textAlign === 'center' || textAlign === 'right')) {
	                        textX += {
	                            center: 0.5,
	                            right: 1
	                        }[textAlign] * (width - bBox.width);
	                    }
	
	                    // update if anything changed
	                    if (textX !== text.x || textY !== text.y) {
	                        text.attr('x', textX);
	                        if (textY !== undefined) {
	                            text.attr('y', textY);
	                        }
	                    }
	
	                    // record current values
	                    text.x = textX;
	                    text.y = textY;
	                };
	
	                /**
	                 * Set a box attribute, or defer it if the box is not yet created
	                 * @param {Object} key
	                 * @param {Object} value
	                 */
	                boxAttr = function(key, value) {
	                    if (box) {
	                        box.attr(key, value);
	                    } else {
	                        deferredAttr[key] = value;
	                    }
	                };
	
	                /**
	                 * After the text element is added, get the desired size of the border box
	                 * and add it before the text in the DOM.
	                 */
	                wrapper.onAdd = function() {
	                    text.add(wrapper);
	                    wrapper.attr({
	                        text: (str || str === 0) ? str : '', // alignment is available now // #3295: 0 not rendered if given as a value
	                        x: x,
	                        y: y
	                    });
	
	                    if (box && defined(anchorX)) {
	                        wrapper.attr({
	                            anchorX: anchorX,
	                            anchorY: anchorY
	                        });
	                    }
	                };
	
	                /*
	                 * Add specific attribute setters.
	                 */
	
	                // only change local variables
	                wrapper.widthSetter = function(value) {
	                    width = H.isNumber(value) ? value : null; // width:auto => null
	                };
	                wrapper.heightSetter = function(value) {
	                    height = value;
	                };
	                wrapper['text-alignSetter'] = function(value) {
	                    textAlign = value;
	                };
	                wrapper.paddingSetter = function(value) {
	                    if (defined(value) && value !== padding) {
	                        padding = wrapper.padding = value;
	                        updateTextPadding();
	                    }
	                };
	                wrapper.paddingLeftSetter = function(value) {
	                    if (defined(value) && value !== paddingLeft) {
	                        paddingLeft = value;
	                        updateTextPadding();
	                    }
	                };
	
	
	                // change local variable and prevent setting attribute on the group
	                wrapper.alignSetter = function(value) {
	                    value = {
	                        left: 0,
	                        center: 0.5,
	                        right: 1
	                    }[value];
	                    if (value !== alignFactor) {
	                        alignFactor = value;
	                        if (bBox) { // Bounding box exists, means we're dynamically changing
	                            wrapper.attr({
	                                x: wrapperX
	                            }); // #5134
	                        }
	                    }
	                };
	
	                // apply these to the box and the text alike
	                wrapper.textSetter = function(value) {
	                    if (value !== undefined) {
	                        text.textSetter(value);
	                    }
	                    updateBoxSize();
	                    updateTextPadding();
	                };
	
	                // apply these to the box but not to the text
	                wrapper['stroke-widthSetter'] = function(value, key) {
	                    if (value) {
	                        needsBox = true;
	                    }
	                    strokeWidth = this['stroke-width'] = value;
	                    boxAttr(key, value);
	                };
	
	                wrapper.strokeSetter = wrapper.fillSetter = wrapper.rSetter = function(value, key) {
	                    if (key !== 'r') {
	                        if (key === 'fill' && value) {
	                            needsBox = true;
	                        }
	                        // for animation getter (#6776)
	                        wrapper[key] = value;
	                    }
	                    boxAttr(key, value);
	                };
	
	                wrapper.anchorXSetter = function(value, key) {
	                    anchorX = wrapper.anchorX = value;
	                    boxAttr(key, Math.round(value) - getCrispAdjust() - wrapperX);
	                };
	                wrapper.anchorYSetter = function(value, key) {
	                    anchorY = wrapper.anchorY = value;
	                    boxAttr(key, value - wrapperY);
	                };
	
	                // rename attributes
	                wrapper.xSetter = function(value) {
	                    wrapper.x = value; // for animation getter
	                    if (alignFactor) {
	                        value -= alignFactor * ((width || bBox.width) + 2 * padding);
	                    }
	                    wrapperX = Math.round(value);
	                    wrapper.attr('translateX', wrapperX);
	                };
	                wrapper.ySetter = function(value) {
	                    wrapperY = wrapper.y = Math.round(value);
	                    wrapper.attr('translateY', wrapperY);
	                };
	
	                // Redirect certain methods to either the box or the text
	                var baseCss = wrapper.css;
	                return extend(wrapper, {
	                    /**
	                     * Pick up some properties and apply them to the text instead of the
	                     * wrapper.
	                     * @ignore
	                     */
	                    css: function(styles) {
	                        if (styles) {
	                            var textStyles = {};
	                            styles = merge(styles); // create a copy to avoid altering the original object (#537)
	                            each(wrapper.textProps, function(prop) {
	                                if (styles[prop] !== undefined) {
	                                    textStyles[prop] = styles[prop];
	                                    delete styles[prop];
	                                }
	                            });
	                            text.css(textStyles);
	                        }
	                        return baseCss.call(wrapper, styles);
	                    },
	                    /**
	                     * Return the bounding box of the box, not the group.
	                     * @ignore
	                     */
	                    getBBox: function() {
	                        return {
	                            width: bBox.width + 2 * padding,
	                            height: bBox.height + 2 * padding,
	                            x: bBox.x - padding,
	                            y: bBox.y - padding
	                        };
	                    },
	
	                    /**
	                     * Apply the shadow to the box.
	                     * @ignore
	                     */
	                    shadow: function(b) {
	                        if (b) {
	                            updateBoxSize();
	                            if (box) {
	                                box.shadow(b);
	                            }
	                        }
	                        return wrapper;
	                    },
	
	                    /**
	                     * Destroy and release memory.
	                     * @ignore
	                     */
	                    destroy: function() {
	
	                        // Added by button implementation
	                        removeEvent(wrapper.element, 'mouseenter');
	                        removeEvent(wrapper.element, 'mouseleave');
	
	                        if (text) {
	                            text = text.destroy();
	                        }
	                        if (box) {
	                            box = box.destroy();
	                        }
	                        // Call base implementation to destroy the rest
	                        SVGElement.prototype.destroy.call(wrapper);
	
	                        // Release local pointers (#1298)
	                        wrapper = renderer = updateBoxSize = updateTextPadding = boxAttr = null;
	                    }
	                });
	            }
	        }); // end SVGRenderer
	
	
	        // general renderer
	        H.Renderer = SVGRenderer;
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        /* eslint max-len: ["warn", 80, 4] */
	        var attr = H.attr,
	            createElement = H.createElement,
	            css = H.css,
	            defined = H.defined,
	            each = H.each,
	            extend = H.extend,
	            isFirefox = H.isFirefox,
	            isMS = H.isMS,
	            isWebKit = H.isWebKit,
	            pInt = H.pInt,
	            SVGElement = H.SVGElement,
	            SVGRenderer = H.SVGRenderer,
	            win = H.win,
	            wrap = H.wrap;
	
	        // Extend SvgElement for useHTML option
	        extend(SVGElement.prototype, /** @lends SVGElement.prototype */ {
	            /**
	             * Apply CSS to HTML elements. This is used in text within SVG rendering and
	             * by the VML renderer
	             */
	            htmlCss: function(styles) {
	                var wrapper = this,
	                    element = wrapper.element,
	                    textWidth = styles && element.tagName === 'SPAN' && styles.width;
	
	                if (textWidth) {
	                    delete styles.width;
	                    wrapper.textWidth = textWidth;
	                    wrapper.updateTransform();
	                }
	                if (styles && styles.textOverflow === 'ellipsis') {
	                    styles.whiteSpace = 'nowrap';
	                    styles.overflow = 'hidden';
	                }
	                wrapper.styles = extend(wrapper.styles, styles);
	                css(wrapper.element, styles);
	
	                return wrapper;
	            },
	
	            /**
	             * VML and useHTML method for calculating the bounding box based on offsets
	             * @param {Boolean} refresh Whether to force a fresh value from the DOM or
	             * to use the cached value.
	             *
	             * @return {Object} A hash containing values for x, y, width and height
	             */
	
	            htmlGetBBox: function() {
	                var wrapper = this,
	                    element = wrapper.element;
	
	                // faking getBBox in exported SVG in legacy IE (is this a duplicate of
	                // the fix for #1079?)
	                if (element.nodeName === 'text') {
	                    element.style.position = 'absolute';
	                }
	
	                return {
	                    x: element.offsetLeft,
	                    y: element.offsetTop,
	                    width: element.offsetWidth,
	                    height: element.offsetHeight
	                };
	            },
	
	            /**
	             * VML override private method to update elements based on internal
	             * properties based on SVG transform
	             */
	            htmlUpdateTransform: function() {
	                // aligning non added elements is expensive
	                if (!this.added) {
	                    this.alignOnAdd = true;
	                    return;
	                }
	
	                var wrapper = this,
	                    renderer = wrapper.renderer,
	                    elem = wrapper.element,
	                    translateX = wrapper.translateX || 0,
	                    translateY = wrapper.translateY || 0,
	                    x = wrapper.x || 0,
	                    y = wrapper.y || 0,
	                    align = wrapper.textAlign || 'left',
	                    alignCorrection = {
	                        left: 0,
	                        center: 0.5,
	                        right: 1
	                    }[align],
	                    styles = wrapper.styles;
	
	                // apply translate
	                css(elem, {
	                    marginLeft: translateX,
	                    marginTop: translateY
	                });
	
	
	                if (wrapper.shadows) { // used in labels/tooltip
	                    each(wrapper.shadows, function(shadow) {
	                        css(shadow, {
	                            marginLeft: translateX + 1,
	                            marginTop: translateY + 1
	                        });
	                    });
	                }
	
	
	                // apply inversion
	                if (wrapper.inverted) { // wrapper is a group
	                    each(elem.childNodes, function(child) {
	                        renderer.invertChild(child, elem);
	                    });
	                }
	
	                if (elem.tagName === 'SPAN') {
	
	                    var rotation = wrapper.rotation,
	                        baseline,
	                        textWidth = pInt(wrapper.textWidth),
	                        whiteSpace = styles && styles.whiteSpace,
	                        currentTextTransform = [
	                            rotation,
	                            align,
	                            elem.innerHTML,
	                            wrapper.textWidth,
	                            wrapper.textAlign
	                        ].join(',');
	
	                    // Do the calculations and DOM access only if properties changed
	                    if (currentTextTransform !== wrapper.cTT) {
	
	
	                        baseline = renderer.fontMetrics(elem.style.fontSize).b;
	
	                        // Renderer specific handling of span rotation
	                        if (defined(rotation)) {
	                            wrapper.setSpanRotation(
	                                rotation,
	                                alignCorrection,
	                                baseline
	                            );
	                        }
	
	                        // Reset multiline/ellipsis in order to read width (#4928,
	                        // #5417)
	                        css(elem, {
	                            width: '',
	                            whiteSpace: whiteSpace || 'nowrap'
	                        });
	
	                        // Update textWidth
	                        if (
	                            elem.offsetWidth > textWidth &&
	                            /[ \-]/.test(elem.textContent || elem.innerText)
	                        ) { // #983, #1254
	                            css(elem, {
	                                width: textWidth + 'px',
	                                display: 'block',
	                                whiteSpace: whiteSpace || 'normal' // #3331
	                            });
	                        }
	
	
	                        wrapper.getSpanCorrection(
	                            elem.offsetWidth,
	                            baseline,
	                            alignCorrection,
	                            rotation,
	                            align
	                        );
	                    }
	
	                    // apply position with correction
	                    css(elem, {
	                        left: (x + (wrapper.xCorr || 0)) + 'px',
	                        top: (y + (wrapper.yCorr || 0)) + 'px'
	                    });
	
	                    // Force reflow in webkit to apply the left and top on useHTML
	                    // element (#1249)
	                    if (isWebKit) {
	                        // Assigned to baseline for lint purpose
	                        baseline = elem.offsetHeight;
	                    }
	
	                    // record current text transform
	                    wrapper.cTT = currentTextTransform;
	                }
	            },
	
	            /**
	             * Set the rotation of an individual HTML span
	             */
	            setSpanRotation: function(rotation, alignCorrection, baseline) {
	                var rotationStyle = {},
	                    cssTransformKey =
	                    isMS ?
	                    '-ms-transform' :
	                    isWebKit ?
	                    '-webkit-transform' :
	                    isFirefox ?
	                    'MozTransform' :
	                    win.opera ?
	                    '-o-transform' :
	                    '';
	
	                rotationStyle[cssTransformKey] = rotationStyle.transform =
	                    'rotate(' + rotation + 'deg)';
	                rotationStyle[cssTransformKey + (isFirefox ? 'Origin' : '-origin')] =
	                    rotationStyle.transformOrigin =
	                    (alignCorrection * 100) + '% ' + baseline + 'px';
	                css(this.element, rotationStyle);
	            },
	
	            /**
	             * Get the correction in X and Y positioning as the element is rotated.
	             */
	            getSpanCorrection: function(width, baseline, alignCorrection) {
	                this.xCorr = -width * alignCorrection;
	                this.yCorr = -baseline;
	            }
	        });
	
	        // Extend SvgRenderer for useHTML option.
	        extend(SVGRenderer.prototype, /** @lends SVGRenderer.prototype */ {
	            /**
	             * Create HTML text node. This is used by the VML renderer as well as the
	             * SVG renderer through the useHTML option.
	             *
	             * @param {String} str
	             * @param {Number} x
	             * @param {Number} y
	             */
	            html: function(str, x, y) {
	                var wrapper = this.createElement('span'),
	                    element = wrapper.element,
	                    renderer = wrapper.renderer,
	                    isSVG = renderer.isSVG,
	                    addSetters = function(element, style) {
	                        // These properties are set as attributes on the SVG group, and
	                        // as identical CSS properties on the div. (#3542)
	                        each(['opacity', 'visibility'], function(prop) {
	                            wrap(element, prop + 'Setter', function(
	                                proceed,
	                                value,
	                                key,
	                                elem
	                            ) {
	                                proceed.call(this, value, key, elem);
	                                style[key] = value;
	                            });
	                        });
	                    };
	
	                // Text setter
	                wrapper.textSetter = function(value) {
	                    if (value !== element.innerHTML) {
	                        delete this.bBox;
	                    }
	                    element.innerHTML = this.textStr = value;
	                    wrapper.htmlUpdateTransform();
	                };
	
	                // Add setters for the element itself (#4938)
	                if (isSVG) { // #4938, only for HTML within SVG
	                    addSetters(wrapper, wrapper.element.style);
	                }
	
	                // Various setters which rely on update transform
	                wrapper.xSetter =
	                    wrapper.ySetter =
	                    wrapper.alignSetter =
	                    wrapper.rotationSetter =
	                    function(value, key) {
	                        if (key === 'align') {
	                            // Do not overwrite the SVGElement.align method. Same as VML.
	                            key = 'textAlign';
	                        }
	                        wrapper[key] = value;
	                        wrapper.htmlUpdateTransform();
	                    };
	
	                // Set the default attributes
	                wrapper
	                    .attr({
	                        text: str,
	                        x: Math.round(x),
	                        y: Math.round(y)
	                    })
	                    .css({
	
	                        fontFamily: this.style.fontFamily,
	                        fontSize: this.style.fontSize,
	
	                        position: 'absolute'
	                    });
	
	                // Keep the whiteSpace style outside the wrapper.styles collection
	                element.style.whiteSpace = 'nowrap';
	
	                // Use the HTML specific .css method
	                wrapper.css = wrapper.htmlCss;
	
	                // This is specific for HTML within SVG
	                if (isSVG) {
	                    wrapper.add = function(svgGroupWrapper) {
	
	                        var htmlGroup,
	                            container = renderer.box.parentNode,
	                            parentGroup,
	                            parents = [];
	
	                        this.parentGroup = svgGroupWrapper;
	
	                        // Create a mock group to hold the HTML elements
	                        if (svgGroupWrapper) {
	                            htmlGroup = svgGroupWrapper.div;
	                            if (!htmlGroup) {
	
	                                // Read the parent chain into an array and read from top
	                                // down
	                                parentGroup = svgGroupWrapper;
	                                while (parentGroup) {
	
	                                    parents.push(parentGroup);
	
	                                    // Move up to the next parent group
	                                    parentGroup = parentGroup.parentGroup;
	                                }
	
	                                // Ensure dynamically updating position when any parent
	                                // is translated
	                                each(parents.reverse(), function(parentGroup) {
	                                    var htmlGroupStyle,
	                                        cls = attr(parentGroup.element, 'class');
	
	                                    if (cls) {
	                                        cls = {
	                                            className: cls
	                                        };
	                                    } // else null
	
	                                    // Create a HTML div and append it to the parent div
	                                    // to emulate the SVG group structure
	                                    htmlGroup =
	                                        parentGroup.div =
	                                        parentGroup.div || createElement('div', cls, {
	                                            position: 'absolute',
	                                            left: (parentGroup.translateX || 0) + 'px',
	                                            top: (parentGroup.translateY || 0) + 'px',
	                                            display: parentGroup.display,
	                                            opacity: parentGroup.opacity, // #5075
	                                            pointerEvents: (
	                                                parentGroup.styles &&
	                                                parentGroup.styles.pointerEvents
	                                            ) // #5595
	
	                                            // the top group is appended to container
	                                        }, htmlGroup || container);
	
	                                    // Shortcut
	                                    htmlGroupStyle = htmlGroup.style;
	
	                                    // Set listeners to update the HTML div's position
	                                    // whenever the SVG group position is changed.
	                                    extend(parentGroup, {
	                                        classSetter: function(value) {
	                                            this.element.setAttribute('class', value);
	                                            htmlGroup.className = value;
	                                        },
	                                        on: function() {
	                                            if (parents[0].div) { // #6418
	                                                wrapper.on.apply({
	                                                        element: parents[0].div
	                                                    },
	                                                    arguments
	                                                );
	                                            }
	                                            return parentGroup;
	                                        },
	                                        translateXSetter: function(value, key) {
	                                            htmlGroupStyle.left = value + 'px';
	                                            parentGroup[key] = value;
	                                            parentGroup.doTransform = true;
	                                        },
	                                        translateYSetter: function(value, key) {
	                                            htmlGroupStyle.top = value + 'px';
	                                            parentGroup[key] = value;
	                                            parentGroup.doTransform = true;
	                                        }
	                                    });
	                                    addSetters(parentGroup, htmlGroupStyle);
	                                });
	
	                            }
	                        } else {
	                            htmlGroup = container;
	                        }
	
	                        htmlGroup.appendChild(element);
	
	                        // Shared with VML:
	                        wrapper.added = true;
	                        if (wrapper.alignOnAdd) {
	                            wrapper.htmlUpdateTransform();
	                        }
	
	                        return wrapper;
	                    };
	                }
	                return wrapper;
	            }
	        });
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	
	        var VMLRenderer,
	            VMLRendererExtension,
	            VMLElement,
	
	            createElement = H.createElement,
	            css = H.css,
	            defined = H.defined,
	            deg2rad = H.deg2rad,
	            discardElement = H.discardElement,
	            doc = H.doc,
	            each = H.each,
	            erase = H.erase,
	            extend = H.extend,
	            extendClass = H.extendClass,
	            isArray = H.isArray,
	            isNumber = H.isNumber,
	            isObject = H.isObject,
	            merge = H.merge,
	            noop = H.noop,
	            pick = H.pick,
	            pInt = H.pInt,
	            svg = H.svg,
	            SVGElement = H.SVGElement,
	            SVGRenderer = H.SVGRenderer,
	            win = H.win;
	
	        /* ****************************************************************************
	         *                                                                            *
	         * START OF INTERNET EXPLORER <= 8 SPECIFIC CODE                              *
	         *                                                                            *
	         * For applications and websites that don't need IE support, like platform    *
	         * targeted mobile apps and web apps, this code can be removed.               *
	         *                                                                            *
	         *****************************************************************************/
	
	        /**
	         * @constructor
	         */
	        if (!svg) {
	
	            /**
	             * The VML element wrapper.
	             */
	            VMLElement = {
	
	                docMode8: doc && doc.documentMode === 8,
	
	                /**
	                 * Initialize a new VML element wrapper. It builds the markup as a string
	                 * to minimize DOM traffic.
	                 * @param {Object} renderer
	                 * @param {Object} nodeName
	                 */
	                init: function(renderer, nodeName) {
	                    var wrapper = this,
	                        markup = ['<', nodeName, ' filled="f" stroked="f"'],
	                        style = ['position: ', 'absolute', ';'],
	                        isDiv = nodeName === 'div';
	
	                    // divs and shapes need size
	                    if (nodeName === 'shape' || isDiv) {
	                        style.push('left:0;top:0;width:1px;height:1px;');
	                    }
	                    style.push('visibility: ', isDiv ? 'hidden' : 'visible');
	
	                    markup.push(' style="', style.join(''), '"/>');
	
	                    // create element with default attributes and style
	                    if (nodeName) {
	                        markup = isDiv || nodeName === 'span' || nodeName === 'img' ?
	                            markup.join('') :
	                            renderer.prepVML(markup);
	                        wrapper.element = createElement(markup);
	                    }
	
	                    wrapper.renderer = renderer;
	                },
	
	                /**
	                 * Add the node to the given parent
	                 * @param {Object} parent
	                 */
	                add: function(parent) {
	                    var wrapper = this,
	                        renderer = wrapper.renderer,
	                        element = wrapper.element,
	                        box = renderer.box,
	                        inverted = parent && parent.inverted,
	
	                        // get the parent node
	                        parentNode = parent ?
	                        parent.element || parent :
	                        box;
	
	                    if (parent) {
	                        this.parentGroup = parent;
	                    }
	
	                    // if the parent group is inverted, apply inversion on all children
	                    if (inverted) { // only on groups
	                        renderer.invertChild(element, parentNode);
	                    }
	
	                    // append it
	                    parentNode.appendChild(element);
	
	                    // align text after adding to be able to read offset
	                    wrapper.added = true;
	                    if (wrapper.alignOnAdd && !wrapper.deferUpdateTransform) {
	                        wrapper.updateTransform();
	                    }
	
	                    // fire an event for internal hooks
	                    if (wrapper.onAdd) {
	                        wrapper.onAdd();
	                    }
	
	                    // IE8 Standards can't set the class name before the element is appended
	                    if (this.className) {
	                        this.attr('class', this.className);
	                    }
	
	                    return wrapper;
	                },
	
	                /**
	                 * VML always uses htmlUpdateTransform
	                 */
	                updateTransform: SVGElement.prototype.htmlUpdateTransform,
	
	                /**
	                 * Set the rotation of a span with oldIE's filter
	                 */
	                setSpanRotation: function() {
	                    // Adjust for alignment and rotation. Rotation of useHTML content is not yet implemented
	                    // but it can probably be implemented for Firefox 3.5+ on user request. FF3.5+
	                    // has support for CSS3 transform. The getBBox method also needs to be updated
	                    // to compensate for the rotation, like it currently does for SVG.
	                    // Test case: http://jsfiddle.net/highcharts/Ybt44/
	
	                    var rotation = this.rotation,
	                        costheta = Math.cos(rotation * deg2rad),
	                        sintheta = Math.sin(rotation * deg2rad);
	
	                    css(this.element, {
	                        filter: rotation ? ['progid:DXImageTransform.Microsoft.Matrix(M11=', costheta,
	                            ', M12=', -sintheta, ', M21=', sintheta, ', M22=', costheta,
	                            ', sizingMethod=\'auto expand\')'
	                        ].join('') : 'none'
	                    });
	                },
	
	                /**
	                 * Get the positioning correction for the span after rotating.
	                 */
	                getSpanCorrection: function(width, baseline, alignCorrection, rotation, align) {
	
	                    var costheta = rotation ? Math.cos(rotation * deg2rad) : 1,
	                        sintheta = rotation ? Math.sin(rotation * deg2rad) : 0,
	                        height = pick(this.elemHeight, this.element.offsetHeight),
	                        quad,
	                        nonLeft = align && align !== 'left';
	
	                    // correct x and y
	                    this.xCorr = costheta < 0 && -width;
	                    this.yCorr = sintheta < 0 && -height;
	
	                    // correct for baseline and corners spilling out after rotation
	                    quad = costheta * sintheta < 0;
	                    this.xCorr += sintheta * baseline * (quad ? 1 - alignCorrection : alignCorrection);
	                    this.yCorr -= costheta * baseline * (rotation ? (quad ? alignCorrection : 1 - alignCorrection) : 1);
	                    // correct for the length/height of the text
	                    if (nonLeft) {
	                        this.xCorr -= width * alignCorrection * (costheta < 0 ? -1 : 1);
	                        if (rotation) {
	                            this.yCorr -= height * alignCorrection * (sintheta < 0 ? -1 : 1);
	                        }
	                        css(this.element, {
	                            textAlign: align
	                        });
	                    }
	                },
	
	                /**
	                 * Converts a subset of an SVG path definition to its VML counterpart. Takes an array
	                 * as the parameter and returns a string.
	                 */
	                pathToVML: function(value) {
	                    // convert paths
	                    var i = value.length,
	                        path = [];
	
	                    while (i--) {
	
	                        // Multiply by 10 to allow subpixel precision.
	                        // Substracting half a pixel seems to make the coordinates
	                        // align with SVG, but this hasn't been tested thoroughly
	                        if (isNumber(value[i])) {
	                            path[i] = Math.round(value[i] * 10) - 5;
	                        } else if (value[i] === 'Z') { // close the path
	                            path[i] = 'x';
	                        } else {
	                            path[i] = value[i];
	
	                            // When the start X and end X coordinates of an arc are too close,
	                            // they are rounded to the same value above. In this case, substract or
	                            // add 1 from the end X and Y positions. #186, #760, #1371, #1410.
	                            if (value.isArc && (value[i] === 'wa' || value[i] === 'at')) {
	                                // Start and end X
	                                if (path[i + 5] === path[i + 7]) {
	                                    path[i + 7] += value[i + 7] > value[i + 5] ? 1 : -1;
	                                }
	                                // Start and end Y
	                                if (path[i + 6] === path[i + 8]) {
	                                    path[i + 8] += value[i + 8] > value[i + 6] ? 1 : -1;
	                                }
	                            }
	                        }
	                    }
	
	
	                    // Loop up again to handle path shortcuts (#2132)
	                    /*while (i++ < path.length) {
	                    	if (path[i] === 'H') { // horizontal line to
	                    		path[i] = 'L';
	                    		path.splice(i + 2, 0, path[i - 1]);
	                    	} else if (path[i] === 'V') { // vertical line to
	                    		path[i] = 'L';
	                    		path.splice(i + 1, 0, path[i - 2]);
	                    	}
	                    }*/
	                    return path.join(' ') || 'x';
	                },
	
	                /**
	                 * Set the element's clipping to a predefined rectangle
	                 *
	                 * @param {String} id The id of the clip rectangle
	                 */
	                clip: function(clipRect) {
	                    var wrapper = this,
	                        clipMembers,
	                        cssRet;
	
	                    if (clipRect) {
	                        clipMembers = clipRect.members;
	                        erase(clipMembers, wrapper); // Ensure unique list of elements (#1258)
	                        clipMembers.push(wrapper);
	                        wrapper.destroyClip = function() {
	                            erase(clipMembers, wrapper);
	                        };
	                        cssRet = clipRect.getCSS(wrapper);
	
	                    } else {
	                        if (wrapper.destroyClip) {
	                            wrapper.destroyClip();
	                        }
	                        cssRet = {
	                            clip: wrapper.docMode8 ? 'inherit' : 'rect(auto)'
	                        }; // #1214
	                    }
	
	                    return wrapper.css(cssRet);
	
	                },
	
	                /**
	                 * Set styles for the element
	                 * @param {Object} styles
	                 */
	                css: SVGElement.prototype.htmlCss,
	
	                /**
	                 * Removes a child either by removeChild or move to garbageBin.
	                 * Issue 490; in VML removeChild results in Orphaned nodes according to sIEve, discardElement does not.
	                 */
	                safeRemoveChild: function(element) {
	                    // discardElement will detach the node from its parent before attaching it
	                    // to the garbage bin. Therefore it is important that the node is attached and have parent.
	                    if (element.parentNode) {
	                        discardElement(element);
	                    }
	                },
	
	                /**
	                 * Extend element.destroy by removing it from the clip members array
	                 */
	                destroy: function() {
	                    if (this.destroyClip) {
	                        this.destroyClip();
	                    }
	
	                    return SVGElement.prototype.destroy.apply(this);
	                },
	
	                /**
	                 * Add an event listener. VML override for normalizing event parameters.
	                 * @param {String} eventType
	                 * @param {Function} handler
	                 */
	                on: function(eventType, handler) {
	                    // simplest possible event model for internal use
	                    this.element['on' + eventType] = function() {
	                        var evt = win.event;
	                        evt.target = evt.srcElement;
	                        handler(evt);
	                    };
	                    return this;
	                },
	
	                /**
	                 * In stacked columns, cut off the shadows so that they don't overlap
	                 */
	                cutOffPath: function(path, length) {
	
	                    var len;
	
	                    path = path.split(/[ ,]/); // The extra comma tricks the trailing comma remover in "gulp scripts" task
	                    len = path.length;
	
	                    if (len === 9 || len === 11) {
	                        path[len - 4] = path[len - 2] = pInt(path[len - 2]) - 10 * length;
	                    }
	                    return path.join(' ');
	                },
	
	                /**
	                 * Apply a drop shadow by copying elements and giving them different strokes
	                 * @param {Boolean|Object} shadowOptions
	                 */
	                shadow: function(shadowOptions, group, cutOff) {
	                    var shadows = [],
	                        i,
	                        element = this.element,
	                        renderer = this.renderer,
	                        shadow,
	                        elemStyle = element.style,
	                        markup,
	                        path = element.path,
	                        strokeWidth,
	                        modifiedPath,
	                        shadowWidth,
	                        shadowElementOpacity;
	
	                    // some times empty paths are not strings
	                    if (path && typeof path.value !== 'string') {
	                        path = 'x';
	                    }
	                    modifiedPath = path;
	
	                    if (shadowOptions) {
	                        shadowWidth = pick(shadowOptions.width, 3);
	                        shadowElementOpacity = (shadowOptions.opacity || 0.15) / shadowWidth;
	                        for (i = 1; i <= 3; i++) {
	
	                            strokeWidth = (shadowWidth * 2) + 1 - (2 * i);
	
	                            // Cut off shadows for stacked column items
	                            if (cutOff) {
	                                modifiedPath = this.cutOffPath(path.value, strokeWidth + 0.5);
	                            }
	
	                            markup = ['<shape isShadow="true" strokeweight="', strokeWidth,
	                                '" filled="false" path="', modifiedPath,
	                                '" coordsize="10 10" style="', element.style.cssText, '" />'
	                            ];
	
	                            shadow = createElement(renderer.prepVML(markup),
	                                null, {
	                                    left: pInt(elemStyle.left) + pick(shadowOptions.offsetX, 1),
	                                    top: pInt(elemStyle.top) + pick(shadowOptions.offsetY, 1)
	                                }
	                            );
	                            if (cutOff) {
	                                shadow.cutOff = strokeWidth + 1;
	                            }
	
	                            // apply the opacity
	                            markup = [
	                                '<stroke color="',
	                                shadowOptions.color || '#000000',
	                                '" opacity="', shadowElementOpacity * i, '"/>'
	                            ];
	                            createElement(renderer.prepVML(markup), null, null, shadow);
	
	
	                            // insert it
	                            if (group) {
	                                group.element.appendChild(shadow);
	                            } else {
	                                element.parentNode.insertBefore(shadow, element);
	                            }
	
	                            // record it
	                            shadows.push(shadow);
	
	                        }
	
	                        this.shadows = shadows;
	                    }
	                    return this;
	                },
	                updateShadows: noop, // Used in SVG only
	
	                setAttr: function(key, value) {
	                    if (this.docMode8) { // IE8 setAttribute bug
	                        this.element[key] = value;
	                    } else {
	                        this.element.setAttribute(key, value);
	                    }
	                },
	                classSetter: function(value) {
	                    // IE8 Standards mode has problems retrieving the className unless set like this.
	                    // IE8 Standards can't set the class name before the element is appended.
	                    (this.added ? this.element : this).className = value;
	                },
	                dashstyleSetter: function(value, key, element) {
	                    var strokeElem = element.getElementsByTagName('stroke')[0] ||
	                        createElement(this.renderer.prepVML(['<stroke/>']), null, null, element);
	                    strokeElem[key] = value || 'solid';
	                    this[key] = value;
	                    /* because changing stroke-width will change the dash length
					and cause an epileptic effect */
	                },
	                dSetter: function(value, key, element) {
	                    var i,
	                        shadows = this.shadows;
	                    value = value || [];
	                    this.d = value.join && value.join(' '); // used in getter for animation
	
	                    element.path = value = this.pathToVML(value);
	
	                    // update shadows
	                    if (shadows) {
	                        i = shadows.length;
	                        while (i--) {
	                            shadows[i].path = shadows[i].cutOff ? this.cutOffPath(value, shadows[i].cutOff) : value;
	                        }
	                    }
	                    this.setAttr(key, value);
	                },
	                fillSetter: function(value, key, element) {
	                    var nodeName = element.nodeName;
	                    if (nodeName === 'SPAN') { // text color
	                        element.style.color = value;
	                    } else if (nodeName !== 'IMG') { // #1336
	                        element.filled = value !== 'none';
	                        this.setAttr('fillcolor', this.renderer.color(value, element, key, this));
	                    }
	                },
	                'fill-opacitySetter': function(value, key, element) {
	                    createElement(
	                        this.renderer.prepVML(['<', key.split('-')[0], ' opacity="', value, '"/>']),
	                        null,
	                        null,
	                        element
	                    );
	                },
	                opacitySetter: noop, // Don't bother - animation is too slow and filters introduce artifacts
	                rotationSetter: function(value, key, element) {
	                    var style = element.style;
	                    this[key] = style[key] = value; // style is for #1873
	
	                    // Correction for the 1x1 size of the shape container. Used in gauge needles.
	                    style.left = -Math.round(Math.sin(value * deg2rad) + 1) + 'px';
	                    style.top = Math.round(Math.cos(value * deg2rad)) + 'px';
	                },
	                strokeSetter: function(value, key, element) {
	                    this.setAttr('strokecolor', this.renderer.color(value, element, key, this));
	                },
	                'stroke-widthSetter': function(value, key, element) {
	                    element.stroked = !!value; // VML "stroked" attribute
	                    this[key] = value; // used in getter, issue #113
	                    if (isNumber(value)) {
	                        value += 'px';
	                    }
	                    this.setAttr('strokeweight', value);
	                },
	                titleSetter: function(value, key) {
	                    this.setAttr(key, value);
	                },
	                visibilitySetter: function(value, key, element) {
	
	                    // Handle inherited visibility
	                    if (value === 'inherit') {
	                        value = 'visible';
	                    }
	
	                    // Let the shadow follow the main element
	                    if (this.shadows) {
	                        each(this.shadows, function(shadow) {
	                            shadow.style[key] = value;
	                        });
	                    }
	
	                    // Instead of toggling the visibility CSS property, move the div out of the viewport.
	                    // This works around #61 and #586
	                    if (element.nodeName === 'DIV') {
	                        value = value === 'hidden' ? '-999em' : 0;
	
	                        // In order to redraw, IE7 needs the div to be visible when tucked away
	                        // outside the viewport. So the visibility is actually opposite of
	                        // the expected value. This applies to the tooltip only.
	                        if (!this.docMode8) {
	                            element.style[key] = value ? 'visible' : 'hidden';
	                        }
	                        key = 'top';
	                    }
	                    element.style[key] = value;
	                },
	                xSetter: function(value, key, element) {
	                    this[key] = value; // used in getter
	
	                    if (key === 'x') {
	                        key = 'left';
	                    } else if (key === 'y') {
	                        key = 'top';
	                    }
	                    /* else {
	                    				value = Math.max(0, value); // don't set width or height below zero (#311)
	                    			}*/
	
	                    // clipping rectangle special
	                    if (this.updateClipping) {
	                        this[key] = value; // the key is now 'left' or 'top' for 'x' and 'y'
	                        this.updateClipping();
	                    } else {
	                        // normal
	                        element.style[key] = value;
	                    }
	                },
	                zIndexSetter: function(value, key, element) {
	                    element.style[key] = value;
	                }
	            };
	            VMLElement['stroke-opacitySetter'] = VMLElement['fill-opacitySetter'];
	            H.VMLElement = VMLElement = extendClass(SVGElement, VMLElement);
	
	            // Some shared setters
	            VMLElement.prototype.ySetter =
	                VMLElement.prototype.widthSetter =
	                VMLElement.prototype.heightSetter =
	                VMLElement.prototype.xSetter;
	
	
	            /**
	             * The VML renderer
	             */
	            VMLRendererExtension = { // inherit SVGRenderer
	
	                Element: VMLElement,
	                isIE8: win.navigator.userAgent.indexOf('MSIE 8.0') > -1,
	
	
	                /**
	                 * Initialize the VMLRenderer
	                 * @param {Object} container
	                 * @param {Number} width
	                 * @param {Number} height
	                 */
	                init: function(container, width, height) {
	                    var renderer = this,
	                        boxWrapper,
	                        box,
	                        css;
	
	                    renderer.alignedObjects = [];
	
	                    boxWrapper = renderer.createElement('div')
	                        .css({
	                            position: 'relative'
	                        });
	                    box = boxWrapper.element;
	                    container.appendChild(boxWrapper.element);
	
	
	                    // generate the containing box
	                    renderer.isVML = true;
	                    renderer.box = box;
	                    renderer.boxWrapper = boxWrapper;
	                    renderer.gradients = {};
	                    renderer.cache = {}; // Cache for numerical bounding boxes
	                    renderer.cacheKeys = [];
	                    renderer.imgCount = 0;
	
	
	                    renderer.setSize(width, height, false);
	
	                    // The only way to make IE6 and IE7 print is to use a global namespace. However,
	                    // with IE8 the only way to make the dynamic shapes visible in screen and print mode
	                    // seems to be to add the xmlns attribute and the behaviour style inline.
	                    if (!doc.namespaces.hcv) {
	
	                        doc.namespaces.add('hcv', 'urn:schemas-microsoft-com:vml');
	
	                        // Setup default CSS (#2153, #2368, #2384)
	                        css = 'hcv\\:fill, hcv\\:path, hcv\\:shape, hcv\\:stroke' +
	                            '{ behavior:url(#default#VML); display: inline-block; } ';
	                        try {
	                            doc.createStyleSheet().cssText = css;
	                        } catch (e) {
	                            doc.styleSheets[0].cssText += css;
	                        }
	
	                    }
	                },
	
	
	                /**
	                 * Detect whether the renderer is hidden. This happens when one of the parent elements
	                 * has display: none
	                 */
	                isHidden: function() {
	                    return !this.box.offsetWidth;
	                },
	
	                /**
	                 * Define a clipping rectangle. In VML it is accomplished by storing the values
	                 * for setting the CSS style to all associated members.
	                 *
	                 * @param {Number} x
	                 * @param {Number} y
	                 * @param {Number} width
	                 * @param {Number} height
	                 */
	                clipRect: function(x, y, width, height) {
	
	                    // create a dummy element
	                    var clipRect = this.createElement(),
	                        isObj = isObject(x);
	
	                    // mimic a rectangle with its style object for automatic updating in attr
	                    return extend(clipRect, {
	                        members: [],
	                        count: 0,
	                        left: (isObj ? x.x : x) + 1,
	                        top: (isObj ? x.y : y) + 1,
	                        width: (isObj ? x.width : width) - 1,
	                        height: (isObj ? x.height : height) - 1,
	                        getCSS: function(wrapper) {
	                            var element = wrapper.element,
	                                nodeName = element.nodeName,
	                                isShape = nodeName === 'shape',
	                                inverted = wrapper.inverted,
	                                rect = this,
	                                top = rect.top - (isShape ? element.offsetTop : 0),
	                                left = rect.left,
	                                right = left + rect.width,
	                                bottom = top + rect.height,
	                                ret = {
	                                    clip: 'rect(' +
	                                        Math.round(inverted ? left : top) + 'px,' +
	                                        Math.round(inverted ? bottom : right) + 'px,' +
	                                        Math.round(inverted ? right : bottom) + 'px,' +
	                                        Math.round(inverted ? top : left) + 'px)'
	                                };
	
	                            // issue 74 workaround
	                            if (!inverted && wrapper.docMode8 && nodeName === 'DIV') {
	                                extend(ret, {
	                                    width: right + 'px',
	                                    height: bottom + 'px'
	                                });
	                            }
	                            return ret;
	                        },
	
	                        // used in attr and animation to update the clipping of all members
	                        updateClipping: function() {
	                            each(clipRect.members, function(member) {
	                                // Member.element is falsy on deleted series, like in
	                                // stock/members/series-remove demo. Should be removed
	                                // from members, but this will do.
	                                if (member.element) {
	                                    member.css(clipRect.getCSS(member));
	                                }
	                            });
	                        }
	                    });
	
	                },
	
	
	                /**
	                 * Take a color and return it if it's a string, make it a gradient if it's a
	                 * gradient configuration object, and apply opacity.
	                 *
	                 * @param {Object} color The color or config object
	                 */
	                color: function(color, elem, prop, wrapper) {
	                    var renderer = this,
	                        colorObject,
	                        regexRgba = /^rgba/,
	                        markup,
	                        fillType,
	                        ret = 'none';
	
	                    // Check for linear or radial gradient
	                    if (color && color.linearGradient) {
	                        fillType = 'gradient';
	                    } else if (color && color.radialGradient) {
	                        fillType = 'pattern';
	                    }
	
	
	                    if (fillType) {
	
	                        var stopColor,
	                            stopOpacity,
	                            gradient = color.linearGradient || color.radialGradient,
	                            x1,
	                            y1,
	                            x2,
	                            y2,
	                            opacity1,
	                            opacity2,
	                            color1,
	                            color2,
	                            fillAttr = '',
	                            stops = color.stops,
	                            firstStop,
	                            lastStop,
	                            colors = [],
	                            addFillNode = function() {
	                                // Add the fill subnode. When colors attribute is used, the meanings of opacity and o:opacity2
	                                // are reversed.
	                                markup = ['<fill colors="' + colors.join(',') +
	                                    '" opacity="', opacity2, '" o:opacity2="',
	                                    opacity1, '" type="', fillType, '" ', fillAttr,
	                                    'focus="100%" method="any" />'
	                                ];
	                                createElement(renderer.prepVML(markup), null, null, elem);
	                            };
	
	                        // Extend from 0 to 1
	                        firstStop = stops[0];
	                        lastStop = stops[stops.length - 1];
	                        if (firstStop[0] > 0) {
	                            stops.unshift([
	                                0,
	                                firstStop[1]
	                            ]);
	                        }
	                        if (lastStop[0] < 1) {
	                            stops.push([
	                                1,
	                                lastStop[1]
	                            ]);
	                        }
	
	                        // Compute the stops
	                        each(stops, function(stop, i) {
	                            if (regexRgba.test(stop[1])) {
	                                colorObject = H.color(stop[1]);
	                                stopColor = colorObject.get('rgb');
	                                stopOpacity = colorObject.get('a');
	                            } else {
	                                stopColor = stop[1];
	                                stopOpacity = 1;
	                            }
	
	                            // Build the color attribute
	                            colors.push((stop[0] * 100) + '% ' + stopColor);
	
	                            // Only start and end opacities are allowed, so we use the first and the last
	                            if (!i) {
	                                opacity1 = stopOpacity;
	                                color2 = stopColor;
	                            } else {
	                                opacity2 = stopOpacity;
	                                color1 = stopColor;
	                            }
	                        });
	
	                        // Apply the gradient to fills only.
	                        if (prop === 'fill') {
	
	                            // Handle linear gradient angle
	                            if (fillType === 'gradient') {
	                                x1 = gradient.x1 || gradient[0] || 0;
	                                y1 = gradient.y1 || gradient[1] || 0;
	                                x2 = gradient.x2 || gradient[2] || 0;
	                                y2 = gradient.y2 || gradient[3] || 0;
	                                fillAttr = 'angle="' + (90 - Math.atan(
	                                    (y2 - y1) / // y vector
	                                    (x2 - x1) // x vector
	                                ) * 180 / Math.PI) + '"';
	
	                                addFillNode();
	
	                                // Radial (circular) gradient
	                            } else {
	
	                                var r = gradient.r,
	                                    sizex = r * 2,
	                                    sizey = r * 2,
	                                    cx = gradient.cx,
	                                    cy = gradient.cy,
	                                    radialReference = elem.radialReference,
	                                    bBox,
	                                    applyRadialGradient = function() {
	                                        if (radialReference) {
	                                            bBox = wrapper.getBBox();
	                                            cx += (radialReference[0] - bBox.x) / bBox.width - 0.5;
	                                            cy += (radialReference[1] - bBox.y) / bBox.height - 0.5;
	                                            sizex *= radialReference[2] / bBox.width;
	                                            sizey *= radialReference[2] / bBox.height;
	                                        }
	                                        fillAttr = 'src="' + H.getOptions().global.VMLRadialGradientURL + '" ' +
	                                            'size="' + sizex + ',' + sizey + '" ' +
	                                            'origin="0.5,0.5" ' +
	                                            'position="' + cx + ',' + cy + '" ' +
	                                            'color2="' + color2 + '" ';
	
	                                        addFillNode();
	                                    };
	
	                                // Apply radial gradient
	                                if (wrapper.added) {
	                                    applyRadialGradient();
	                                } else {
	                                    // We need to know the bounding box to get the size and position right
	                                    wrapper.onAdd = applyRadialGradient;
	                                }
	
	                                // The fill element's color attribute is broken in IE8 standards mode, so we
	                                // need to set the parent shape's fillcolor attribute instead.
	                                ret = color1;
	                            }
	
	                            // Gradients are not supported for VML stroke, return the first color. #722.
	                        } else {
	                            ret = stopColor;
	                        }
	
	                        // If the color is an rgba color, split it and add a fill node
	                        // to hold the opacity component
	                    } else if (regexRgba.test(color) && elem.tagName !== 'IMG') {
	
	                        colorObject = H.color(color);
	
	                        wrapper[prop + '-opacitySetter'](colorObject.get('a'), prop, elem);
	
	                        ret = colorObject.get('rgb');
	
	
	                    } else {
	                        var propNodes = elem.getElementsByTagName(prop); // 'stroke' or 'fill' node
	                        if (propNodes.length) {
	                            propNodes[0].opacity = 1;
	                            propNodes[0].type = 'solid';
	                        }
	                        ret = color;
	                    }
	
	                    return ret;
	                },
	
	                /**
	                 * Take a VML string and prepare it for either IE8 or IE6/IE7.
	                 * @param {Array} markup A string array of the VML markup to prepare
	                 */
	                prepVML: function(markup) {
	                    var vmlStyle = 'display:inline-block;behavior:url(#default#VML);',
	                        isIE8 = this.isIE8;
	
	                    markup = markup.join('');
	
	                    if (isIE8) { // add xmlns and style inline
	                        markup = markup.replace('/>', ' xmlns="urn:schemas-microsoft-com:vml" />');
	                        if (markup.indexOf('style="') === -1) {
	                            markup = markup.replace('/>', ' style="' + vmlStyle + '" />');
	                        } else {
	                            markup = markup.replace('style="', 'style="' + vmlStyle);
	                        }
	
	                    } else { // add namespace
	                        markup = markup.replace('<', '<hcv:');
	                    }
	
	                    return markup;
	                },
	
	                /**
	                 * Create rotated and aligned text
	                 * @param {String} str
	                 * @param {Number} x
	                 * @param {Number} y
	                 */
	                text: SVGRenderer.prototype.html,
	
	                /**
	                 * Create and return a path element
	                 * @param {Array} path
	                 */
	                path: function(path) {
	                    var attr = {
	                        // subpixel precision down to 0.1 (width and height = 1px)
	                        coordsize: '10 10'
	                    };
	                    if (isArray(path)) {
	                        attr.d = path;
	                    } else if (isObject(path)) { // attributes
	                        extend(attr, path);
	                    }
	                    // create the shape
	                    return this.createElement('shape').attr(attr);
	                },
	
	                /**
	                 * Create and return a circle element. In VML circles are implemented as
	                 * shapes, which is faster than v:oval
	                 * @param {Number} x
	                 * @param {Number} y
	                 * @param {Number} r
	                 */
	                circle: function(x, y, r) {
	                    var circle = this.symbol('circle');
	                    if (isObject(x)) {
	                        r = x.r;
	                        y = x.y;
	                        x = x.x;
	                    }
	                    circle.isCircle = true; // Causes x and y to mean center (#1682)
	                    circle.r = r;
	                    return circle.attr({
	                        x: x,
	                        y: y
	                    });
	                },
	
	                /**
	                 * Create a group using an outer div and an inner v:group to allow rotating
	                 * and flipping. A simple v:group would have problems with positioning
	                 * child HTML elements and CSS clip.
	                 *
	                 * @param {String} name The name of the group
	                 */
	                g: function(name) {
	                    var wrapper,
	                        attribs;
	
	                    // set the class name
	                    if (name) {
	                        attribs = {
	                            'className': 'highcharts-' + name,
	                            'class': 'highcharts-' + name
	                        };
	                    }
	
	                    // the div to hold HTML and clipping
	                    wrapper = this.createElement('div').attr(attribs);
	
	                    return wrapper;
	                },
	
	                /**
	                 * VML override to create a regular HTML image
	                 * @param {String} src
	                 * @param {Number} x
	                 * @param {Number} y
	                 * @param {Number} width
	                 * @param {Number} height
	                 */
	                image: function(src, x, y, width, height) {
	                    var obj = this.createElement('img')
	                        .attr({
	                            src: src
	                        });
	
	                    if (arguments.length > 1) {
	                        obj.attr({
	                            x: x,
	                            y: y,
	                            width: width,
	                            height: height
	                        });
	                    }
	                    return obj;
	                },
	
	                /**
	                 * For rectangles, VML uses a shape for rect to overcome bugs and rotation problems
	                 */
	                createElement: function(nodeName) {
	                    return nodeName === 'rect' ?
	                        this.symbol(nodeName) :
	                        SVGRenderer.prototype.createElement.call(this, nodeName);
	                },
	
	                /**
	                 * In the VML renderer, each child of an inverted div (group) is inverted
	                 * @param {Object} element
	                 * @param {Object} parentNode
	                 */
	                invertChild: function(element, parentNode) {
	                    var ren = this,
	                        parentStyle = parentNode.style,
	                        imgStyle = element.tagName === 'IMG' && element.style; // #1111
	
	                    css(element, {
	                        flip: 'x',
	                        left: pInt(parentStyle.width) - (imgStyle ? pInt(imgStyle.top) : 1),
	                        top: pInt(parentStyle.height) - (imgStyle ? pInt(imgStyle.left) : 1),
	                        rotation: -90
	                    });
	
	                    // Recursively invert child elements, needed for nested composite
	                    // shapes like box plots and error bars. #1680, #1806.
	                    each(element.childNodes, function(child) {
	                        ren.invertChild(child, element);
	                    });
	                },
	
	                /**
	                 * Symbol definitions that override the parent SVG renderer's symbols
	                 *
	                 */
	                symbols: {
	                    // VML specific arc function
	                    arc: function(x, y, w, h, options) {
	                        var start = options.start,
	                            end = options.end,
	                            radius = options.r || w || h,
	                            innerRadius = options.innerR,
	                            cosStart = Math.cos(start),
	                            sinStart = Math.sin(start),
	                            cosEnd = Math.cos(end),
	                            sinEnd = Math.sin(end),
	                            ret;
	
	                        if (end - start === 0) { // no angle, don't show it.
	                            return ['x'];
	                        }
	
	                        ret = [
	                            'wa', // clockwise arc to
	                            x - radius, // left
	                            y - radius, // top
	                            x + radius, // right
	                            y + radius, // bottom
	                            x + radius * cosStart, // start x
	                            y + radius * sinStart, // start y
	                            x + radius * cosEnd, // end x
	                            y + radius * sinEnd // end y
	                        ];
	
	                        if (options.open && !innerRadius) {
	                            ret.push(
	                                'e',
	                                'M',
	                                x, // - innerRadius,
	                                y // - innerRadius
	                            );
	                        }
	
	                        ret.push(
	                            'at', // anti clockwise arc to
	                            x - innerRadius, // left
	                            y - innerRadius, // top
	                            x + innerRadius, // right
	                            y + innerRadius, // bottom
	                            x + innerRadius * cosEnd, // start x
	                            y + innerRadius * sinEnd, // start y
	                            x + innerRadius * cosStart, // end x
	                            y + innerRadius * sinStart, // end y
	                            'x', // finish path
	                            'e' // close
	                        );
	
	                        ret.isArc = true;
	                        return ret;
	
	                    },
	                    // Add circle symbol path. This performs significantly faster than v:oval.
	                    circle: function(x, y, w, h, wrapper) {
	
	                        if (wrapper && defined(wrapper.r)) {
	                            w = h = 2 * wrapper.r;
	                        }
	
	                        // Center correction, #1682
	                        if (wrapper && wrapper.isCircle) {
	                            x -= w / 2;
	                            y -= h / 2;
	                        }
	
	                        // Return the path
	                        return [
	                            'wa', // clockwisearcto
	                            x, // left
	                            y, // top
	                            x + w, // right
	                            y + h, // bottom
	                            x + w, // start x
	                            y + h / 2, // start y
	                            x + w, // end x
	                            y + h / 2, // end y
	                            //'x', // finish path
	                            'e' // close
	                        ];
	                    },
	                    /**
	                     * Add rectangle symbol path which eases rotation and omits arcsize problems
	                     * compared to the built-in VML roundrect shape. When borders are not rounded,
	                     * use the simpler square path, else use the callout path without the arrow.
	                     */
	                    rect: function(x, y, w, h, options) {
	                        return SVGRenderer.prototype.symbols[!defined(options) || !options.r ? 'square' : 'callout'].call(0, x, y, w, h, options);
	                    }
	                }
	            };
	            H.VMLRenderer = VMLRenderer = function() {
	                this.init.apply(this, arguments);
	            };
	            VMLRenderer.prototype = merge(SVGRenderer.prototype, VMLRendererExtension);
	
	            // general renderer
	            H.Renderer = VMLRenderer;
	        }
	
	        // This method is used with exporting in old IE, when emulating SVG (see #2314)
	        SVGRenderer.prototype.measureSpanWidth = function(text, styles) {
	            var measuringSpan = doc.createElement('span'),
	                offsetWidth,
	                textNode = doc.createTextNode(text);
	
	            measuringSpan.appendChild(textNode);
	            css(measuringSpan, styles);
	            this.box.appendChild(measuringSpan);
	            offsetWidth = measuringSpan.offsetWidth;
	            discardElement(measuringSpan); // #2463
	            return offsetWidth;
	        };
	
	
	        /* ****************************************************************************
	         *                                                                            *
	         * END OF INTERNET EXPLORER <= 8 SPECIFIC CODE                                *
	         *                                                                            *
	         *****************************************************************************/
	
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var color = H.color,
	            each = H.each,
	            getTZOffset = H.getTZOffset,
	            isTouchDevice = H.isTouchDevice,
	            merge = H.merge,
	            pick = H.pick,
	            svg = H.svg,
	            win = H.win;
	
	        /* ****************************************************************************
	         * Handle the options                                                         *
	         *****************************************************************************/
	        /** 	 
	         * @optionparent
	         */
	        H.defaultOptions = {
	
	
	            /**
	             * An array containing the default colors for the chart's series. When
	             * all colors are used, new colors are pulled from the start again.
	             * 
	             * Default colors can also be set on a series or series.type basis,
	             * see [column.colors](#plotOptions.column.colors), [pie.colors](#plotOptions.
	             * pie.colors).
	             * 
	             * In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	             * style/style-by-css), the colors option doesn't exist. Instead, colors
	             * are defined in CSS and applied either through series or point class
	             * names, or through the [chart.colorCount](#chart.colorCount) option.
	             * 
	             * 
	             * ### Legacy
	             * 
	             * In Highcharts 3.x, the default colors were:
	             * 
	             * <pre>colors: ['#2f7ed8', '#0d233a', '#8bbc21', '#910000', '#1aadce',
	             * 
	             * '#492970', '#f28f43', '#77a1e5', '#c42525', '#a6c96a']</pre>
	             * 
	             * In Highcharts 2.x, the default colors were:
	             * 
	             * <pre>colors: ['#4572A7', '#AA4643', '#89A54E', '#80699B', '#3D96AE',
	             * 
	             *    '#DB843D', '#92A8CD', '#A47D7C', '#B5CA92']</pre>
	             * 
	             * @type {Array<Color>}
	             * @sample {highcharts} highcharts/chart/colors/ Assign a global color theme
	             * @default [ "#7cb5ec" , "#434348" , "#90ed7d" , "#f7a35c" , "#8085e9" ,
	             *          "#f15c80" , "#e4d354" , "#2b908f" , "#f45b5b" , "#91e8e1"]
	             * @product highcharts highstock highmaps
	             */
	            colors: '#7cb5ec #434348 #90ed7d #f7a35c #8085e9 #f15c80 #e4d354 #2b908f #f45b5b #91e8e1'.split(' '),
	
	
	            /**
	             */
	            symbols: ['circle', 'diamond', 'square', 'triangle', 'triangle-down'],
	            lang: {
	
	                /**
	                 * The loading text that appears when the chart is set into the loading
	                 * state following a call to `chart.showLoading`.
	                 * 
	                 * @type {String}
	                 * @default Loading...
	                 * @product highcharts highstock highmaps
	                 */
	                loading: 'Loading...',
	
	                /**
	                 * An array containing the months names. Corresponds to the `%B` format
	                 * in `Highcharts.dateFormat()`.
	                 * 
	                 * @type {Array<String>}
	                 * @default [ "January" , "February" , "March" , "April" , "May" ,
	                 *          "June" , "July" , "August" , "September" , "October" ,
	                 *          "November" , "December"]
	                 * @product highcharts highstock highmaps
	                 */
	                months: [
	                    'January', 'February', 'March', 'April', 'May', 'June', 'July',
	                    'August', 'September', 'October', 'November', 'December'
	                ],
	
	                /**
	                 * An array containing the months names in abbreviated form. Corresponds
	                 * to the `%b` format in `Highcharts.dateFormat()`.
	                 * 
	                 * @type {Array<String>}
	                 * @default [ "Jan" , "Feb" , "Mar" , "Apr" , "May" , "Jun" ,
	                 *          "Jul" , "Aug" , "Sep" , "Oct" , "Nov" , "Dec"]
	                 */
	                shortMonths: [
	                    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul',
	                    'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
	                ],
	
	                /**
	                 * An array containing the weekday names.
	                 * 
	                 * @type {Array<String>}
	                 * @default ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday",
	                 *          "Friday", "Saturday"]
	                 * @product highcharts highstock highmaps
	                 */
	                weekdays: [
	                    'Sunday', 'Monday', 'Tuesday', 'Wednesday',
	                    'Thursday', 'Friday', 'Saturday'
	                ],
	                // invalidDate: '',
	
	                /**
	                 * The default decimal point used in the `Highcharts.numberFormat`
	                 * method unless otherwise specified in the function arguments.
	                 * 
	                 * @type {String}
	                 * @default .
	                 * @since 1.2.2
	                 * @product highcharts highstock highmaps
	                 */
	                decimalPoint: '.',
	
	                /**
	                 * [Metric prefixes](http://en.wikipedia.org/wiki/Metric_prefix) used
	                 * to shorten high numbers in axis labels. Replacing any of the positions
	                 * with `null` causes the full number to be written. Setting `numericSymbols`
	                 * to `null` disables shortening altogether.
	                 * 
	                 * @type {Array<String>}
	                 * @sample {highcharts} highcharts/lang/numericsymbols/ Replacing the symbols with text
	                 * @sample {highstock} highcharts/lang/numericsymbols/ Replacing the symbols with text
	                 * @default [ "k" , "M" , "G" , "T" , "P" , "E"]
	                 * @since 2.3.0
	                 * @product highcharts highstock highmaps
	                 */
	                numericSymbols: ['k', 'M', 'G', 'T', 'P', 'E'], // SI prefixes used in axis labels
	
	                /**
	                 * The text for the label appearing when a chart is zoomed.
	                 * 
	                 * @type {String}
	                 * @default Reset zoom
	                 * @since 1.2.4
	                 * @product highcharts highstock highmaps
	                 */
	                resetZoom: 'Reset zoom',
	
	                /**
	                 * The tooltip title for the label appearing when a chart is zoomed.
	                 * 
	                 * @type {String}
	                 * @default Reset zoom level 1:1
	                 * @since 1.2.4
	                 * @product highcharts highstock highmaps
	                 */
	                resetZoomTitle: 'Reset zoom level 1:1',
	
	                /**
	                 * The default thousands separator used in the `Highcharts.numberFormat`
	                 * method unless otherwise specified in the function arguments. Since
	                 * Highcharts 4.1 it defaults to a single space character, which is
	                 * compatible with ISO and works across Anglo-American and continental
	                 * European languages.
	                 * 
	                 * The default is a single space.
	                 * 
	                 * @type {String}
	                 * @default  
	                 * @since 1.2.2
	                 * @product highcharts highstock highmaps
	                 */
	                thousandsSep: ' '
	            },
	
	            /**
	             * Global options that don't apply to each chart. These options, like
	             * the `lang` options, must be set using the `Highcharts.setOptions`
	             * method.
	             * 
	             * <pre>Highcharts.setOptions({
	             * global: {
	             * useUTC: false
	             * }
	             * });</pre>
	             * 
	             * @product highcharts highstock highmaps
	             */
	            global: {
	
	                /**
	                 * Whether to use UTC time for axis scaling, tickmark placement and
	                 * time display in `Highcharts.dateFormat`. Advantages of using UTC
	                 * is that the time displays equally regardless of the user agent's
	                 * time zone settings. Local time can be used when the data is loaded
	                 * in real time or when correct Daylight Saving Time transitions are
	                 * required.
	                 * 
	                 * @type {Boolean}
	                 * @sample {highcharts} highcharts/global/useutc-true/ True by default
	                 * @sample {highcharts} highcharts/global/useutc-false/ False
	                 * @default true
	                 * @product highcharts highstock highmaps
	                 */
	                useUTC: true,
	                //timezoneOffset: 0,
	
	
	                /**
	                 * Path to the pattern image required by VML browsers in order to
	                 * draw radial gradients.
	                 * 
	                 * @type {String}
	                 * @default {highcharts} http://code.highcharts.com/{version}/gfx/vml-radial-gradient.png
	                 * @default {highstock} http://code.highcharts.com/highstock/{version}/gfx/vml-radial-gradient.png
	                 * @default {highmaps} http://code.highcharts.com/{version}/gfx/vml-radial-gradient.png
	                 * @since 2.3.0
	                 * @product highcharts highstock highmaps
	                 */
	                VMLRadialGradientURL: 'http://code.highcharts.com/5.0.14/gfx/vml-radial-gradient.png'
	
	            },
	            chart: {
	
	                /**
	                 * When using multiple axis, the ticks of two or more opposite axes
	                 * will automatically be aligned by adding ticks to the axis or axes
	                 * with the least ticks, as if `tickAmount` were specified.
	                 * 
	                 * This can be prevented by setting `alignTicks` to false. If the grid
	                 * lines look messy, it's a good idea to hide them for the secondary
	                 * axis by setting `gridLineWidth` to 0.
	                 * 
	                 * @type {Boolean}
	                 * @sample {highcharts} highcharts/chart/alignticks-true/ True by default
	                 * @sample {highcharts} highcharts/chart/alignticks-false/ False
	                 * @sample {highstock} stock/chart/alignticks-true/
	                 *         True by default
	                 * @sample {highstock} stock/chart/alignticks-false/
	                 *         False
	                 * @default true
	                 * @product highcharts highstock
	                 * @apioption chart.alignTicks
	                 */
	
	
	                /**
	                 * Set the overall animation for all chart updating. Animation can be
	                 * disabled throughout the chart by setting it to false here. It can
	                 * be overridden for each individual API method as a function parameter.
	                 * The only animation not affected by this option is the initial series
	                 * animation, see [plotOptions.series.animation](#plotOptions.series.
	                 * animation).
	                 * 
	                 * The animation can either be set as a boolean or a configuration
	                 * object. If `true`, it will use the 'swing' jQuery easing and a
	                 * duration of 500 ms. If used as a configuration object, the following
	                 * properties are supported:
	                 * 
	                 * <dl>
	                 * 
	                 * <dt>duration</dt>
	                 * 
	                 * <dd>The duration of the animation in milliseconds.</dd>
	                 * 
	                 * <dt>easing</dt>
	                 * 
	                 * <dd>A string reference to an easing function set on the `Math` object.
	                 * See [the easing demo](http://jsfiddle.net/gh/get/library/pure/
	                 * highcharts/highcharts/tree/master/samples/highcharts/plotoptions/
	                 * series-animation-easing/).</dd>
	                 * 
	                 * </dl>
	                 * 
	                 * @type {Boolean|Object}
	                 * @sample {highcharts} highcharts/chart/animation-none/
	                 *         Updating with no animation
	                 * @sample {highcharts} highcharts/chart/animation-duration/
	                 *         With a longer duration
	                 * @sample {highcharts} highcharts/chart/animation-easing/
	                 *         With a jQuery UI easing
	                 * @sample {highmaps} maps/chart/animation-none/
	                 *         Updating with no animation
	                 * @sample {highmaps} maps/chart/animation-duration/
	                 *         With a longer duration
	                 * @default true
	                 * @apioption chart.animation
	                 */
	
	                /**
	                 * A CSS class name to apply to the charts container `div`, allowing
	                 * unique CSS styling for each chart.
	                 * 
	                 * @type {String}
	                 * @apioption chart.className
	                 */
	
	                /**
	                 * Event listeners for the chart.
	                 * 
	                 * @apioption chart.events
	                 */
	
	                /**
	                 * Fires when a series is added to the chart after load time, using
	                 * the `addSeries` method. One parameter, `event`, is passed to the
	                 * function, containing common event information.
	                 * Through `event.options` you can access the series options that was
	                 * passed to the `addSeries` method. Returning false prevents the series
	                 * from being added.
	                 * 
	                 * @type {Function}
	                 * @context Chart
	                 * @sample {highcharts} highcharts/chart/events-addseries/ Alert on add series
	                 * @sample {highstock} stock/chart/events-addseries/ Alert on add series
	                 * @since 1.2.0
	                 * @apioption chart.events.addSeries
	                 */
	
	                /**
	                 * Fires when clicking on the plot background. One parameter, `event`,
	                 * is passed to the function, containing common event information.
	                 * 
	                 * Information on the clicked spot can be found through `event.xAxis`
	                 * and `event.yAxis`, which are arrays containing the axes of each dimension
	                 * and each axis' value at the clicked spot. The primary axes are `event.
	                 * xAxis[0]` and `event.yAxis[0]`. Remember the unit of a datetime axis
	                 * is milliseconds since 1970-01-01 00:00:00.
	                 * 
	                 * <pre>click: function(e) {
	                 * console.log(
	                 * Highcharts.dateFormat('%Y-%m-%d %H:%M:%S', e.xAxis[0].value),
	                 * e.yAxis[0].value
	                 * )
	                 * }</pre>
	                 * 
	                 * @type {Function}
	                 * @context Chart
	                 * @sample {highcharts} highcharts/chart/events-click/
	                 *         Alert coordinates on click
	                 * @sample {highcharts} highcharts/chart/events-container/
	                 *         Alternatively, attach event to container
	                 * @sample {highstock} stock/chart/events-click/
	                 *         Alert coordinates on click
	                 * @sample {highstock} highcharts/chart/events-container/
	                 *         Alternatively, attach event to container
	                 * @sample {highmaps} maps/chart/events-click/
	                 *         Record coordinates on click
	                 * @sample {highmaps} highcharts/chart/events-container/
	                 *         Alternatively, attach event to container
	                 * @since 1.2.0
	                 * @apioption chart.events.click
	                 */
	
	
	                /**
	                 * Fires when the chart is finished loading. Since v4.2.2, it also waits
	                 * for images to be loaded, for example from point markers. One parameter,
	                 * `event`, is passed to the function, containing common event information.
	                 * 
	                 * There is also a second parameter to the chart constructor where a
	                 * callback function can be passed to be executed on chart.load.
	                 * 
	                 * @type {Function}
	                 * @context Chart
	                 * @sample {highcharts} highcharts/chart/events-load/
	                 *         Alert on chart load
	                 * @sample {highstock} stock/chart/events-load/
	                 *         Alert on chart load
	                 * @sample {highmaps} maps/chart/events-load/
	                 *         Add series on chart load
	                 * @apioption chart.events.load
	                 */
	
	                /**
	                 * Fires when the chart is redrawn, either after a call to chart.redraw()
	                 * or after an axis, series or point is modified with the `redraw` option
	                 * set to true. One parameter, `event`, is passed to the function, containing common event information.
	                 * 
	                 * @type {Function}
	                 * @context Chart
	                 * @sample {highcharts} highcharts/chart/events-redraw/
	                 *         Alert on chart redraw
	                 * @sample {highstock} stock/chart/events-redraw/
	                 *         Alert on chart redraw when adding a series or moving the
	                 *         zoomed range
	                 * @sample {highmaps} maps/chart/events-redraw/
	                 *         Set subtitle on chart redraw
	                 * @since 1.2.0
	                 * @apioption chart.events.redraw
	                 */
	
	                /**
	                 * Fires after initial load of the chart (directly after the `load`
	                 * event), and after each redraw (directly after the `redraw` event).
	                 * 
	                 * @type {Function}
	                 * @context Chart
	                 * @since 5.0.7
	                 * @apioption chart.events.render
	                 */
	
	                /**
	                 * Fires when an area of the chart has been selected. Selection is enabled
	                 * by setting the chart's zoomType. One parameter, `event`, is passed
	                 * to the function, containing common event information. The default action for the selection event is to
	                 * zoom the chart to the selected area. It can be prevented by calling
	                 * `event.preventDefault()`.
	                 * 
	                 * Information on the selected area can be found through `event.xAxis`
	                 * and `event.yAxis`, which are arrays containing the axes of each dimension
	                 * and each axis' min and max values. The primary axes are `event.xAxis[0]`
	                 * and `event.yAxis[0]`. Remember the unit of a datetime axis is milliseconds
	                 * since 1970-01-01 00:00:00.
	                 * 
	                 * <pre>selection: function(event) {
	                 * // log the min and max of the primary, datetime x-axis
	                 * console.log(
	                 * Highcharts.dateFormat('%Y-%m-%d %H:%M:%S', event.xAxis[0].min),
	                 * 
	                 * Highcharts.dateFormat('%Y-%m-%d %H:%M:%S', event.xAxis[0].max)
	                 * );
	                 * // log the min and max of the y axis
	                 * console.log(event.yAxis[0].min, event.yAxis[0].max);
	                 * }</pre>
	                 * 
	                 * @type {Function}
	                 * @sample {highcharts} highcharts/chart/events-selection/
	                 *         Report on selection and reset
	                 * @sample {highcharts} highcharts/chart/events-selection-points/
	                 *         Select a range of points through a drag selection
	                 * @sample {highstock} stock/chart/events-selection/
	                 *         Report on selection and reset
	                 * @sample {highstock} highcharts/chart/events-selection-points/
	                 *         Select a range of points through a drag selection (Highcharts)
	                 * @apioption chart.events.selection
	                 */
	
	                /**
	                 * The margin between the outer edge of the chart and the plot area.
	                 * The numbers in the array designate top, right, bottom and left
	                 * respectively. Use the options `marginTop`, `marginRight`,
	                 * `marginBottom` and `marginLeft` for shorthand setting of one option.
	                 * 
	                 * By default there is no margin. The actual space is dynamically calculated
	                 * from the offset of axis labels, axis title, title, subtitle and legend
	                 * in addition to the `spacingTop`, `spacingRight`, `spacingBottom`
	                 * and `spacingLeft` options.
	                 * 
	                 * @type {Array}
	                 * @sample {highcharts} highcharts/chart/margins-zero/
	                 *         Zero margins
	                 * @sample {highstock} stock/chart/margin-zero/
	                 *         Zero margins
	                 *
	                 * @defaults {all} null
	                 * @apioption chart.margin
	                 */
	
	                /**
	                 * The margin between the bottom outer edge of the chart and the plot
	                 * area. Use this to set a fixed pixel value for the margin as opposed
	                 * to the default dynamic margin. See also `spacingBottom`.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/chart/marginbottom/
	                 *         100px bottom margin
	                 * @sample {highstock} stock/chart/marginbottom/
	                 *         100px bottom margin
	                 * @sample {highmaps} maps/chart/margin/
	                 *         100px margins
	                 * @since 2.0
	                 * @apioption chart.marginBottom
	                 */
	
	                /**
	                 * The margin between the left outer edge of the chart and the plot
	                 * area. Use this to set a fixed pixel value for the margin as opposed
	                 * to the default dynamic margin. See also `spacingLeft`.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/chart/marginleft/
	                 *         150px left margin
	                 * @sample {highstock} stock/chart/marginleft/
	                 *         150px left margin
	                 * @sample {highmaps} maps/chart/margin/
	                 *         100px margins
	                 * @default null
	                 * @since 2.0
	                 * @apioption chart.marginLeft
	                 */
	
	                /**
	                 * The margin between the right outer edge of the chart and the plot
	                 * area. Use this to set a fixed pixel value for the margin as opposed
	                 * to the default dynamic margin. See also `spacingRight`.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/chart/marginright/
	                 *         100px right margin
	                 * @sample {highstock} stock/chart/marginright/
	                 *         100px right margin
	                 * @sample {highmaps} maps/chart/margin/
	                 *         100px margins
	                 * @default null
	                 * @since 2.0
	                 * @apioption chart.marginRight
	                 */
	
	                /**
	                 * The margin between the top outer edge of the chart and the plot area.
	                 * Use this to set a fixed pixel value for the margin as opposed to
	                 * the default dynamic margin. See also `spacingTop`.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/chart/margintop/ 100px top margin
	                 * @sample {highstock} stock/chart/margintop/
	                 *         100px top margin
	                 * @sample {highmaps} maps/chart/margin/
	                 *         100px margins
	                 * @default null
	                 * @since 2.0
	                 * @apioption chart.marginTop
	                 */
	
	                /**
	                 * Allows setting a key to switch between zooming and panning. Can be
	                 * one of `alt`, `ctrl`, `meta` (the command key on Mac and Windows
	                 * key on Windows) or `shift`. The keys are mapped directly to the key
	                 * properties of the click event argument (`event.altKey`, `event.ctrlKey`,
	                 * `event.metaKey` and `event.shiftKey`).
	                 * 
	                 * @validvalue [null, "alt", "ctrl", "meta", "shift"]
	                 * @type {String}
	                 * @since 4.0.3
	                 * @product highcharts
	                 * @apioption chart.panKey
	                 */
	
	                /**
	                 * Allow panning in a chart. Best used with [panKey](#chart.panKey)
	                 * to combine zooming and panning.
	                 * 
	                 * On touch devices, when the [tooltip.followTouchMove](#tooltip.followTouchMove)
	                 * option is `true` (default), panning requires two fingers. To allow
	                 * panning with one finger, set `followTouchMove` to `false`.
	                 * 
	                 * @type {Boolean}
	                 * @sample {highcharts} highcharts/chart/pankey/ Zooming and panning
	                 * @default {highcharts} false
	                 * @default {highstock} true
	                 * @since 4.0.3
	                 * @product highcharts highstock
	                 * @apioption chart.panning
	                 */
	
	
	                /**
	                 * Equivalent to [zoomType](#chart.zoomType), but for multitouch gestures
	                 * only. By default, the `pinchType` is the same as the `zoomType` setting.
	                 * However, pinching can be enabled separately in some cases, for example
	                 * in stock charts where a mouse drag pans the chart, while pinching
	                 * is enabled. When [tooltip.followTouchMove](#tooltip.followTouchMove)
	                 * is true, pinchType only applies to two-finger touches.
	                 * 
	                 * @validvalue ["x", "y", "xy"]
	                 * @type {String}
	                 * @default {highcharts} null
	                 * @default {highstock} x
	                 * @since 3.0
	                 * @product highcharts highstock
	                 * @apioption chart.pinchType
	                 */
	
	                /**
	                 * The corner radius of the outer chart border.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/chart/borderradius/ 20px radius
	                 * @sample {highstock} stock/chart/border/ 10px radius
	                 * @sample {highmaps} maps/chart/border/ Border options
	                 * @default 0
	                 * @product highcharts highstock highmaps
	                 */
	                borderRadius: 0,
	
	
	                /**
	                 * Alias of `type`.
	                 * 
	                 * @validvalue ["line", "spline", "column", "area", "areaspline", "pie"]
	                 * @type {String}
	                 * @deprecated
	                 * @sample {highcharts} highcharts/chart/defaultseriestype/ Bar
	                 * @default line
	                 * @product highcharts
	                 */
	                defaultSeriesType: 'line',
	
	                /**
	                 * If true, the axes will scale to the remaining visible series once
	                 * one series is hidden. If false, hiding and showing a series will
	                 * not affect the axes or the other series. For stacks, once one series
	                 * within the stack is hidden, the rest of the stack will close in
	                 * around it even if the axis is not affected.
	                 * 
	                 * @type {Boolean}
	                 * @sample {highcharts} highcharts/chart/ignorehiddenseries-true/
	                 *         True by default
	                 * @sample {highcharts} highcharts/chart/ignorehiddenseries-false/
	                 *         False
	                 * @sample {highcharts} highcharts/chart/ignorehiddenseries-true-stacked/
	                 *         True with stack
	                 * @sample {highstock} stock/chart/ignorehiddenseries-true/
	                 *         True by default
	                 * @sample {highstock} stock/chart/ignorehiddenseries-false/
	                 *         False
	                 * @default true
	                 * @since 1.2.0
	                 * @product highcharts highstock
	                 */
	                ignoreHiddenSeries: true,
	
	
	                /**
	                 * Whether to invert the axes so that the x axis is vertical and y axis
	                 * is horizontal. When `true`, the x axis is [reversed](#xAxis.reversed)
	                 * by default.
	                 *
	                 * @productdesc {highcharts}
	                 * If a bar series is present in the chart, it will be inverted
	                 * automatically. Inverting the chart doesn't have an effect if there
	                 * are no cartesian series in the chart, or if the chart is
	                 * [polar](#chart.polar).
	                 * 
	                 * @type {Boolean}
	                 * @sample {highcharts} highcharts/chart/inverted/
	                 *         Inverted line
	                 * @sample {highstock} stock/navigator/inverted/
	                 *         Inverted stock chart
	                 * @default false
	                 * @product highcharts highstock
	                 * @apioption chart.inverted
	                 */
	
	                /**
	                 * The distance between the outer edge of the chart and the content,
	                 * like title or legend, or axis title and labels if present. The
	                 * numbers in the array designate top, right, bottom and left respectively.
	                 * Use the options spacingTop, spacingRight, spacingBottom and spacingLeft
	                 * options for shorthand setting of one option.
	                 * 
	                 * @type {Array<Number>}
	                 * @see [chart.margin](#chart.margin)
	                 * @default [10, 10, 15, 10]
	                 * @since 3.0.6
	                 * @product highcharts highstock highmaps
	                 */
	                spacing: [10, 10, 15, 10],
	
	                /**
	                 * The button that appears after a selection zoom, allowing the user
	                 * to reset zoom.
	                 * 
	                 * @product highcharts highstock highmaps
	                 */
	                resetZoomButton: {
	
	                    /**
	                     * A collection of attributes for the button. The object takes SVG
	                     * attributes like `fill`, `stroke`, `stroke-width` or `r`, the border
	                     * radius. The theme also supports `style`, a collection of CSS properties
	                     * for the text. Equivalent attributes for the hover state are given
	                     * in `theme.states.hover`.
	                     * 
	                     * @type {Object}
	                     * @sample {highcharts} highcharts/chart/resetzoombutton-theme/ Theming the button
	                     * @sample {highstock} highcharts/chart/resetzoombutton-theme/ Theming the button
	                     * @since 2.2
	                     * @product highcharts highstock highmaps
	                     */
	                    theme: {
	
	                        /**
	                         */
	                        zIndex: 20
	                    },
	
	                    /**
	                     * The position of the button.
	                     * 
	                     * @type {Object}
	                     * @sample {highcharts} highcharts/chart/resetzoombutton-position/
	                     *         Above the plot area
	                     * @sample {highstock} highcharts/chart/resetzoombutton-position/
	                     *         Above the plot area
	                     * @sample {highmaps} highcharts/chart/resetzoombutton-position/
	                     *         Above the plot area
	                     * @since 2.2
	                     * @product highcharts highstock highmaps
	                     */
	                    position: {
	
	                        /**
	                         * The horizontal alignment of the button.
	                         * 
	                         * @type {String}
	                         */
	                        align: 'right',
	
	                        /**
	                         * The horizontal offset of the button.
	                         * 
	                         * @type {Number}
	                         */
	                        x: -10,
	
	                        /**
	                         * The vertical alignment of the button.
	                         * 
	                         * @validvalue ["top", "middle", "bottom"]
	                         * @type {String}
	                         * @default top
	                         * @apioption chart.resetZoomButton.position.verticalAlign
	                         */
	
	                        /**
	                         * The vertical offset of the button.
	                         * 
	                         * @type {Number}
	                         */
	                        y: 10
	                    }
	
	                    /**
	                     * What frame the button should be placed related to. Can be either
	                     * `plot` or `chart`
	                     * 
	                     * @validvalue ["plot", "chart"]
	                     * @type {String}
	                     * @sample {highcharts} highcharts/chart/resetzoombutton-relativeto/
	                     *         Relative to the chart
	                     * @sample {highstock} highcharts/chart/resetzoombutton-relativeto/
	                     *         Relative to the chart
	                     * @default plot
	                     * @since 2.2
	                     * @apioption chart.resetZoomButton.relativeTo
	                     */
	                },
	
	                /**
	                 * An explicit width for the chart. By default (when `null`) the width
	                 * is calculated from the offset width of the containing element.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/chart/width/ 800px wide
	                 * @sample {highstock} stock/chart/width/ 800px wide
	                 * @sample {highmaps} maps/chart/size/ Chart with explicit size
	                 * @default null
	                 * @product highcharts highstock highmaps
	                 */
	                width: null,
	
	                /**
	                 * An explicit height for the chart. If a _number_, the height is
	                 * given in pixels. If given a _percentage string_ (for example `'56%'`),
	                 * the height is given as the percentage of the actual chart width.
	                 * This allows for preserving the aspect ratio across responsive
	                 * sizes.
	                 * 
	                 * By default (when `null`) the height is calculated from the offset
	                 * height of the containing element, or 400 pixels if the containing
	                 * element's height is 0.
	                 * 
	                 * @type {Number|String}
	                 * @sample {highcharts} highcharts/chart/height/
	                 *         500px height
	                 * @sample {highstock} stock/chart/height/
	                 *         300px height
	                 * @sample {highmaps} maps/chart/size/
	                 *         Chart with explicit size
	                 * @sample highcharts/chart/height-percent/
	                 *         Highcharts with percentage height
	                 * @default null
	                 * @product highcharts highstock highmaps
	                 */
	                height: null,
	
	
	
	                /**
	                 * The color of the outer chart border.
	                 * 
	                 * @type {Color}
	                 * @see In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), the stroke is set with the `.highcharts-background`
	                 * class.
	                 * @sample {highcharts} highcharts/chart/bordercolor/ Brown border
	                 * @sample {highstock} stock/chart/border/ Brown border
	                 * @sample {highmaps} maps/chart/border/ Border options
	                 * @default #335cad
	                 * @product highcharts highstock highmaps
	                 */
	                borderColor: '#335cad',
	
	                /**
	                 * The pixel width of the outer chart border.
	                 * 
	                 * @type {Number}
	                 * @see In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), the stroke is set with the `.highcharts-background`
	                 * class.
	                 * @sample {highcharts} highcharts/chart/borderwidth/ 5px border
	                 * @sample {highstock} stock/chart/border/
	                 *         2px border
	                 * @sample {highmaps} maps/chart/border/
	                 *         Border options
	                 * @default 0
	                 * @apioption chart.borderWidth
	                 */
	
	                //style: {
	                //	fontFamily: '"Lucida Grande", "Lucida Sans Unicode", Verdana, Arial, Helvetica, sans-serif', // default font
	                //	fontSize: '12px'
	                //},
	
	                /**
	                 * The background color or gradient for the outer chart area.
	                 * 
	                 * @type {Color}
	                 * @see In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), the background is set with the `.highcharts-
	                 * background` class.
	                 * @sample {highcharts} highcharts/chart/backgroundcolor-color/ Color
	                 * @sample {highcharts} highcharts/chart/backgroundcolor-gradient/ Gradient
	                 * @sample {highstock} stock/chart/backgroundcolor-color/
	                 *         Color
	                 * @sample {highstock} stock/chart/backgroundcolor-gradient/
	                 *         Gradient
	                 * @sample {highmaps} maps/chart/backgroundcolor-color/
	                 *         Color
	                 * @sample {highmaps} maps/chart/backgroundcolor-gradient/
	                 *         Gradient
	                 * @default #FFFFFF
	                 * @product highcharts highstock highmaps
	                 */
	                backgroundColor: '#ffffff',
	
	                /**
	                 * The background color or gradient for the plot area.
	                 * 
	                 * @type {Color}
	                 * @see In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), the plot background is set with the `.highcharts-
	                 * plot-background` class.
	                 * @sample {highcharts} highcharts/chart/plotbackgroundcolor-color/
	                 *         Color
	                 * @sample {highcharts} highcharts/chart/plotbackgroundcolor-gradient/
	                 *         Gradient
	                 * @sample {highstock} stock/chart/plotbackgroundcolor-color/
	                 *         Color
	                 * @sample {highstock} stock/chart/plotbackgroundcolor-gradient/
	                 *         Gradient
	                 * @sample {highmaps} maps/chart/plotbackgroundcolor-color/
	                 *         Color
	                 * @sample {highmaps} maps/chart/plotbackgroundcolor-gradient/
	                 *         Gradient
	                 * @default null
	                 * @apioption chart.plotBackgroundColor
	                 */
	
	
	                /**
	                 * The URL for an image to use as the plot background. To set an image
	                 * as the background for the entire chart, set a CSS background image
	                 * to the container element. Note that for the image to be applied to
	                 * exported charts, its URL needs to be accessible by the export server.
	                 * 
	                 * @type {String}
	                 * @see In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), a plot background image can be set with the
	                 * `.highcharts-plot-background` class and a [custom pattern](http://www.
	                 * highcharts.com/docs/chart-design-and-style/gradients-shadows-and-
	                 * patterns).
	                 * @sample {highcharts} highcharts/chart/plotbackgroundimage/ Skies
	                 * @sample {highstock} stock/chart/plotbackgroundimage/ Skies
	                 * @default null
	                 * @apioption chart.plotBackgroundImage
	                 */
	
	                /**
	                 * The color of the inner chart or plot area border.
	                 * 
	                 * @type {Color}
	                 * @see In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), a plot border stroke can be set with the `.
	                 * highcharts-plot-border` class.
	                 * @sample {highcharts} highcharts/chart/plotbordercolor/ Blue border
	                 * @sample {highstock} stock/chart/plotborder/ Blue border
	                 * @sample {highmaps} maps/chart/plotborder/ Plot border options
	                 * @default #cccccc
	                 * @product highcharts highstock highmaps
	                 */
	                plotBorderColor: '#cccccc'
	
	
	                /**
	                 * The pixel width of the plot area border.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/chart/plotborderwidth/ 1px border
	                 * @sample {highstock} stock/chart/plotborder/
	                 *         2px border
	                 * @sample {highmaps} maps/chart/plotborder/
	                 *         Plot border options
	                 * @default 0
	                 * @apioption chart.plotBorderWidth
	                 */
	
	                /**
	                 * Whether to apply a drop shadow to the plot area. Requires that
	                 * plotBackgroundColor be set. The shadow can be an object configuration
	                 * containing `color`, `offsetX`, `offsetY`, `opacity` and `width`.
	                 * 
	                 * @type {Boolean|Object}
	                 * @sample {highcharts} highcharts/chart/plotshadow/ Plot shadow
	                 * @sample {highstock} stock/chart/plotshadow/
	                 *         Plot shadow
	                 * @sample {highmaps} maps/chart/plotborder/
	                 *         Plot border options
	                 * @default false
	                 * @apioption chart.plotShadow
	                 */
	
	                /**
	                 * When true, cartesian charts like line, spline, area and column are
	                 * transformed into the polar coordinate system. Requires `highcharts-
	                 * more.js`.
	                 * 
	                 * @type {Boolean}
	                 * @default false
	                 * @since 2.3.0
	                 * @product highcharts
	                 * @apioption chart.polar
	                 */
	
	                /**
	                 * Whether to reflow the chart to fit the width of the container div
	                 * on resizing the window.
	                 * 
	                 * @type {Boolean}
	                 * @sample {highcharts} highcharts/chart/reflow-true/ True by default
	                 * @sample {highcharts} highcharts/chart/reflow-false/ False
	                 * @sample {highstock} stock/chart/reflow-true/
	                 *         True by default
	                 * @sample {highstock} stock/chart/reflow-false/
	                 *         False
	                 * @sample {highmaps} maps/chart/reflow-true/
	                 *         True by default
	                 * @sample {highmaps} maps/chart/reflow-false/
	                 *         False
	                 * @default true
	                 * @since 2.1
	                 * @apioption chart.reflow
	                 */
	
	
	
	
	                /**
	                 * The HTML element where the chart will be rendered. If it is a string,
	                 * the element by that id is used. The HTML element can also be passed
	                 * by direct reference, or as the first argument of the chart constructor,
	                 *  in which case the option is not needed.
	                 * 
	                 * @type {String|Object}
	                 * @sample {highcharts} highcharts/chart/reflow-true/
	                 *         String
	                 * @sample {highcharts} highcharts/chart/renderto-object/
	                 *         Object reference
	                 * @sample {highcharts} highcharts/chart/renderto-jquery/
	                 *         Object reference through jQuery
	                 * @sample {highstock} stock/chart/renderto-string/
	                 *         String
	                 * @sample {highstock} stock/chart/renderto-object/
	                 *         Object reference
	                 * @sample {highstock} stock/chart/renderto-jquery/
	                 *         Object reference through jQuery
	                 * @apioption chart.renderTo
	                 */
	
	                /**
	                 * The background color of the marker square when selecting (zooming
	                 * in on) an area of the chart.
	                 * 
	                 * @type {Color}
	                 * @see In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), the selection marker fill is set with the
	                 * `.highcharts-selection-marker` class.
	                 * @default rgba(51,92,173,0.25)
	                 * @since 2.1.7
	                 * @apioption chart.selectionMarkerFill
	                 */
	
	                /**
	                 * Whether to apply a drop shadow to the outer chart area. Requires
	                 * that backgroundColor be set. The shadow can be an object configuration
	                 * containing `color`, `offsetX`, `offsetY`, `opacity` and `width`.
	                 * 
	                 * @type {Boolean|Object}
	                 * @sample {highcharts} highcharts/chart/shadow/ Shadow
	                 * @sample {highstock} stock/chart/shadow/
	                 *         Shadow
	                 * @sample {highmaps} maps/chart/border/
	                 *         Chart border and shadow
	                 * @default false
	                 * @apioption chart.shadow
	                 */
	
	                /**
	                 * Whether to show the axes initially. This only applies to empty charts
	                 * where series are added dynamically, as axes are automatically added
	                 * to cartesian series.
	                 * 
	                 * @type {Boolean}
	                 * @sample {highcharts} highcharts/chart/showaxes-false/ False by default
	                 * @sample {highcharts} highcharts/chart/showaxes-true/ True
	                 * @since 1.2.5
	                 * @product highcharts
	                 * @apioption chart.showAxes
	                 */
	
	                /**
	                 * The space between the bottom edge of the chart and the content (plot
	                 * area, axis title and labels, title, subtitle or legend in top position).
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/chart/spacingbottom/
	                 *         Spacing bottom set to 100
	                 * @sample {highstock} stock/chart/spacingbottom/
	                 *         Spacing bottom set to 100
	                 * @sample {highmaps} maps/chart/spacing/
	                 *         Spacing 100 all around
	                 * @default 15
	                 * @since 2.1
	                 * @apioption chart.spacingBottom
	                 */
	
	                /**
	                 * The space between the left edge of the chart and the content (plot
	                 * area, axis title and labels, title, subtitle or legend in top position).
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/chart/spacingleft/
	                 *         Spacing left set to 100
	                 * @sample {highstock} stock/chart/spacingleft/
	                 *         Spacing left set to 100
	                 * @sample {highmaps} maps/chart/spacing/
	                 *         Spacing 100 all around
	                 * @default 10
	                 * @since 2.1
	                 * @apioption chart.spacingLeft
	                 */
	
	                /**
	                 * The space between the right edge of the chart and the content (plot
	                 * area, axis title and labels, title, subtitle or legend in top
	                 * position).
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/chart/spacingright-100/
	                 *         Spacing set to 100
	                 * @sample {highcharts} highcharts/chart/spacingright-legend/
	                 *         Legend in right position with default spacing
	                 * @sample {highstock} stock/chart/spacingright/
	                 *         Spacing set to 100
	                 * @sample {highmaps} maps/chart/spacing/
	                 *         Spacing 100 all around
	                 * @default 10
	                 * @since 2.1
	                 * @apioption chart.spacingRight
	                 */
	
	                /**
	                 * The space between the top edge of the chart and the content (plot
	                 * area, axis title and labels, title, subtitle or legend in top
	                 * position).
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/chart/spacingtop-100/
	                 * A top spacing of 100
	                 * @sample {highcharts} highcharts/chart/spacingtop-10/
	                 *         Floating chart title makes the plot area align to the default
	                 *         spacingTop of 10.
	                 * @sample {highstock} stock/chart/spacingtop/
	                 *         A top spacing of 100
	                 * @sample {highmaps} maps/chart/spacing/
	                 *         Spacing 100 all around
	                 * @default 10
	                 * @since 2.1
	                 * @apioption chart.spacingTop
	                 */
	
	                /**
	                 * Additional CSS styles to apply inline to the container `div`. Note
	                 * that since the default font styles are applied in the renderer, it
	                 * is ignorant of the individual chart options and must be set globally.
	                 * 
	                 * @type {CSSObject}
	                 * @see In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), general chart styles can be set with the `.highcharts-
	                 * root` class.
	                 * @sample {highcharts} highcharts/chart/style-serif-font/
	                 *         Using a serif type font
	                 * @sample {highcharts} highcharts/css/em/
	                 *         Styled mode with relative font sizes
	                 * @sample {highstock} stock/chart/style/
	                 *         Using a serif type font
	                 * @sample {highmaps} maps/chart/style-serif-font/
	                 *         Using a serif type font
	                 * @default {"fontFamily":"\"Lucida Grande\", \"Lucida Sans Unicode\", Verdana, Arial, Helvetica, sans-serif","fontSize":"12px"}
	                 * @apioption chart.style
	                 */
	
	                /**
	                 * The default series type for the chart. Can be any of the chart types
	                 * listed under [plotOptions](#plotOptions).
	                 * 
	                 * @validvalue ["line", "spline", "column", "bar", "area", "areaspline", "pie", "arearange", "areasplinerange", "boxplot", "bubble", "columnrange", "errorbar", "funnel", "gauge", "heatmap", "polygon", "pyramid", "scatter", "solidgauge", "treemap", "waterfall"]
	                 * @type {String}
	                 * @sample {highcharts} highcharts/chart/type-bar/ Bar
	                 * @sample {highstock} stock/chart/type/
	                 *         Areaspline
	                 * @sample {highmaps} maps/chart/type-mapline/
	                 *         Mapline
	                 * @default {highcharts} line
	                 * @default {highstock} line
	                 * @default {highmaps} map
	                 * @since 2.1.0
	                 * @apioption chart.type
	                 */
	
	                /**
	                 * Decides in what dimensions the user can zoom by dragging the mouse.
	                 * Can be one of `x`, `y` or `xy`.
	                 * 
	                 * @validvalue [null, "x", "y", "xy"]
	                 * @type {String}
	                 * @see [panKey](#chart.panKey)
	                 * @sample {highcharts} highcharts/chart/zoomtype-none/ None by default
	                 * @sample {highcharts} highcharts/chart/zoomtype-x/ X
	                 * @sample {highcharts} highcharts/chart/zoomtype-y/ Y
	                 * @sample {highcharts} highcharts/chart/zoomtype-xy/ Xy
	                 * @sample {highstock} stock/demo/basic-line/ None by default
	                 * @sample {highstock} stock/chart/zoomtype-x/ X
	                 * @sample {highstock} stock/chart/zoomtype-y/ Y
	                 * @sample {highstock} stock/chart/zoomtype-xy/ Xy
	                 * @product highcharts highstock
	                 * @apioption chart.zoomType
	                 */
	            },
	
	            /**
	             * The chart's main title.
	             * 
	             * @sample {highmaps} maps/title/title/ Title options demonstrated
	             * @product highcharts highstock highmaps
	             */
	            title: {
	
	                /**
	                 * The title of the chart. To disable the title, set the `text` to
	                 * `null`.
	                 * 
	                 * @type {String}
	                 * @sample {highcharts} highcharts/title/text/ Custom title
	                 * @sample {highstock} stock/chart/title-text/ Custom title
	                 * @default {highcharts} Chart title
	                 * @default {highstock} null
	                 * @default {highmaps} Chart title
	                 * @product highcharts highstock highmaps
	                 */
	                text: 'Chart title',
	
	                /**
	                 * The horizontal alignment of the title. Can be one of "left", "center"
	                 * and "right".
	                 * 
	                 * @validvalue ["left", "center", "right"]
	                 * @type {String}
	                 * @sample {highcharts} highcharts/title/align/ Aligned to the plot area (x = 70px     = margin left - spacing left)
	                 * @sample {highstock} stock/chart/title-align/ Aligned to the plot area (x = 50px     = margin left - spacing left)
	                 * @default center
	                 * @since 2.0
	                 * @product highcharts highstock highmaps
	                 */
	                align: 'center',
	                // floating: false,
	
	                /**
	                 * The margin between the title and the plot area, or if a subtitle
	                 * is present, the margin between the subtitle and the plot area.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/title/margin-50/ A chart title margin of 50
	                 * @sample {highcharts} highcharts/title/margin-subtitle/ The same margin applied with a subtitle
	                 * @sample {highstock} stock/chart/title-margin/ A chart title margin of 50
	                 * @default 15
	                 * @since 2.1
	                 * @product highcharts highstock highmaps
	                 */
	                margin: 15,
	                // x: 0,
	                // verticalAlign: 'top',
	                // y: null,
	                // style: {}, // defined inline
	
	                /**
	                 * Adjustment made to the title width, normally to reserve space for
	                 * the exporting burger menu.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/title/widthadjust/ Wider menu, greater padding
	                 * @sample {highstock} highcharts/title/widthadjust/ Wider menu, greater padding
	                 * @sample {highmaps} highcharts/title/widthadjust/ Wider menu, greater padding
	                 * @default -44
	                 * @since 4.2.5
	                 * @product highcharts highstock highmaps
	                 */
	                widthAdjust: -44
	
	            },
	
	            /**
	             * The chart's subtitle. This can be used both to display a subtitle below
	             * the main title, and to display random text anywhere in the chart. The
	             * subtitle can be updated after chart initialization through the 
	             * `Chart.setTitle` method.
	             * 
	             * @sample {highmaps} maps/title/subtitle/ Subtitle options demonstrated
	             * @product highcharts highstock highmaps
	             */
	            subtitle: {
	
	                /**
	                 * The subtitle of the chart.
	                 * 
	                 * @type {String}
	                 * @sample {highcharts} highcharts/subtitle/text/ Custom subtitle
	                 * @sample {highcharts} highcharts/subtitle/text-formatted/ Formatted and linked text.
	                 * @sample {highstock} stock/chart/subtitle-text Custom subtitle
	                 * @sample {highstock} stock/chart/subtitle-text-formatted Formatted and linked text.
	                 * @product highcharts highstock highmaps
	                 */
	                text: '',
	
	                /**
	                 * The horizontal alignment of the subtitle. Can be one of "left",
	                 *  "center" and "right".
	                 * 
	                 * @validvalue ["left", "center", "right"]
	                 * @type {String}
	                 * @sample {highcharts} highcharts/subtitle/align/ Footnote at right of plot area
	                 * @sample {highstock} stock/chart/subtitle-footnote Footnote at bottom right of plot area
	                 * @default center
	                 * @since 2.0
	                 * @product highcharts highstock highmaps
	                 */
	                align: 'center',
	                // floating: false
	                // x: 0,
	                // verticalAlign: 'top',
	                // y: null,
	                // style: {}, // defined inline
	
	                /**
	                 * Adjustment made to the subtitle width, normally to reserve space
	                 * for the exporting burger menu.
	                 * 
	                 * @type {Number}
	                 * @see [title.widthAdjust](#title.widthAdjust)
	                 * @sample {highcharts} highcharts/title/widthadjust/ Wider menu, greater padding
	                 * @sample {highstock} highcharts/title/widthadjust/ Wider menu, greater padding
	                 * @sample {highmaps} highcharts/title/widthadjust/ Wider menu, greater padding
	                 * @default -44
	                 * @since 4.2.5
	                 * @product highcharts highstock highmaps
	                 */
	                widthAdjust: -44
	            },
	
	            /**
	             * The plotOptions is a wrapper object for config objects for each series
	             * type. The config objects for each series can also be overridden for
	             * each series item as given in the series array.
	             * 
	             * Configuration options for the series are given in three levels. Options
	             * for all series in a chart are given in the [plotOptions.series](#plotOptions.
	             * series) object. Then options for all series of a specific type are
	             * given in the plotOptions of that type, for example plotOptions.line.
	             * Next, options for one single series are given in [the series array](#series).
	             * 
	             * @product highcharts highstock highmaps
	             */
	            plotOptions: {},
	
	            /**
	             * HTML labels that can be positioned anywhere in the chart area.
	             * 
	             * @product highcharts highstock highmaps
	             */
	            labels: {
	                //items: [],
	
	                /**
	                 * Shared CSS styles for all labels.
	                 * 
	                 * @type {CSSObject}
	                 * @default { "color": "#333333" }
	                 * @product highcharts highstock highmaps
	                 */
	                style: {
	                    //font: defaultFont,
	
	                    /**
	                     */
	                    position: 'absolute',
	
	                    /**
	                     */
	                    color: '#333333'
	                }
	            },
	
	            /**
	             * The legend is a box containing a symbol and name for each series
	             * item or point item in the chart. Each series (or points in case
	             * of pie charts) is represented by a symbol and its name in the legend.
	             *  
	             * It is possible to override the symbol creator function and
	             * create [custom legend symbols](http://jsfiddle.net/gh/get/library/pure/highcharts/highcharts/tree/master/samples/highcharts/studies/legend-
	             * custom-symbol/).
	             * 
	             * @productdesc {highmaps}
	             * A Highmaps legend by default contains one legend item per series, but if
	             * a `colorAxis` is defined, the axis will be displayed in the legend.
	             * Either as a gradient, or as multiple legend items for `dataClasses`.
	             */
	            legend: {
	
	                /**
	                 * Enable or disable the legend.
	                 * 
	                 * @type {Boolean}
	                 * @sample {highcharts} highcharts/legend/enabled-false/ Legend disabled
	                 * @sample {highstock} stock/legend/align/ Various legend options
	                 * @sample {highmaps} maps/legend/enabled-false/ Legend disabled
	                 * @default {highstock} false
	                 * @default {highmaps} true
	                 * @product highcharts highstock highmaps
	                 */
	                enabled: true,
	
	                /**
	                 * The horizontal alignment of the legend box within the chart area.
	                 * Valid values are `left`, `center` and `right`.
	                 * 
	                 * In the case that the legend is aligned in a corner position, the
	                 * `layout` option will determine whether to place it above/below
	                 * or on the side of the plot area.
	                 * 
	                 * @validvalue ["left", "center", "right"]
	                 * @type {String}
	                 * @sample {highcharts} highcharts/legend/align/ Legend at the right of the chart
	                 * @sample {highstock} stock/legend/align/ Various legend options
	                 * @sample {highmaps} maps/legend/alignment/ Legend alignment
	                 * @default center
	                 * @since 2.0
	                 * @product highcharts highstock highmaps
	                 */
	                align: 'center',
	                //floating: false,
	
	                /**
	                 * The layout of the legend items. Can be one of "horizontal" or "vertical".
	                 * 
	                 * @validvalue ["horizontal", "vertical"]
	                 * @type {String}
	                 * @sample {highcharts} highcharts/legend/layout-horizontal/ Horizontal by default
	                 * @sample {highcharts} highcharts/legend/layout-vertical/ Vertical
	                 * @sample {highstock} stock/legend/layout-horizontal/ Horizontal by default
	                 * @sample {highmaps} maps/legend/padding-itemmargin/ Vertical with data classes
	                 * @sample {highmaps} maps/legend/layout-vertical/ Vertical with color axis gradient
	                 * @default horizontal
	                 * @product highcharts highstock highmaps
	                 */
	                layout: 'horizontal',
	
	                /**
	                 * Callback function to format each of the series' labels. The `this`
	                 * keyword refers to the series object, or the point object in case
	                 * of pie charts. By default the series or point name is printed.
	                 *
	                 * @productdesc {highmaps}
	                 *              In Highmaps the context can also be a data class in case
	                 *              of a `colorAxis`.
	                 * 
	                 * @type {Function}
	                 * @sample {highcharts} highcharts/legend/labelformatter/ Add text
	                 * @sample {highmaps} maps/legend/labelformatter/ Data classes with label formatter
	                 * @context {Series|Point}
	                 */
	                labelFormatter: function() {
	                    return this.name;
	                },
	                //borderWidth: 0,
	
	                /**
	                 * The color of the drawn border around the legend.
	                 * 
	                 * @type {Color}
	                 * @see In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), the legend border stroke can be applied with
	                 * the `.highcharts-legend-box` class.
	                 * @sample {highcharts} highcharts/legend/bordercolor/ Brown border
	                 * @sample {highstock} stock/legend/align/ Various legend options
	                 * @sample {highmaps} maps/legend/border-background/ Border and background options
	                 * @default #999999
	                 * @product highcharts highstock highmaps
	                 */
	                borderColor: '#999999',
	
	                /**
	                 * The border corner radius of the legend.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/legend/borderradius-default/ Square by default
	                 * @sample {highcharts} highcharts/legend/borderradius-round/ 5px rounded
	                 * @sample {highmaps} maps/legend/border-background/ Border and background options
	                 * @default 0
	                 * @product highcharts highstock highmaps
	                 */
	                borderRadius: 0,
	
	                /**
	                 * Options for the paging or navigation appearing when the legend
	                 * is overflown. Navigation works well on screen, but not in static
	                 * exported images. One way of working around that is to [increase
	                 * the chart height in export](http://jsfiddle.net/gh/get/library/pure/highcharts/highcharts/tree/master/samples/highcharts/legend/navigation-
	                 * enabled-false/).
	                 * 
	                 * @product highcharts highstock highmaps
	                 */
	                navigation: {
	
	
	                    /**
	                     * The color for the active up or down arrow in the legend page navigation.
	                     * 
	                     * @type {Color}
	                     * @see In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                     * style/style-by-css), the active arrow be styled with the `.highcharts-
	                     * legend-nav-active` class.
	                     * @sample {highcharts} highcharts/legend/navigation/ Legend page navigation demonstrated
	                     * @sample {highstock} highcharts/legend/navigation/ Legend page navigation demonstrated
	                     * @default #003399
	                     * @since 2.2.4
	                     * @product highcharts highstock highmaps
	                     */
	                    activeColor: '#003399',
	
	                    /**
	                     * The color of the inactive up or down arrow in the legend page
	                     * navigation. .
	                     * 
	                     * @type {Color}
	                     * @see In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                     * style/style-by-css), the inactive arrow be styled with the `.highcharts-
	                     * legend-nav-inactive` class.
	                     * @sample {highcharts} highcharts/legend/navigation/ Legend page navigation demonstrated
	                     * @sample {highstock} highcharts/legend/navigation/ Legend page navigation demonstrated
	                     * @default {highcharts} #cccccc
	                     * @default {highstock} #cccccc
	                     * @default {highmaps} ##cccccc
	                     * @since 2.2.4
	                     * @product highcharts highstock highmaps
	                     */
	                    inactiveColor: '#cccccc'
	
	                    // animation: true,
	                    // arrowSize: 12
	                    // style: {} // text styles
	                },
	                // margin: 20,
	                // reversed: false,
	                // backgroundColor: null,
	                /*style: {
	                	padding: '5px'
	                },*/
	
	
	                /**
	                 * CSS styles for each legend item. Only a subset of CSS is supported,
	                 * notably those options related to text. The default `textOverflow`
	                 * property makes long texts truncate. Set it to `null` to wrap text
	                 * instead. A `width` property can be added to control the text width.
	                 * 
	                 * @type {CSSObject}
	                 * @see In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), the legend items can be styled with the `.
	                 * highcharts-legend-item` class.
	                 * @sample {highcharts} highcharts/legend/itemstyle/ Bold black text
	                 * @sample {highmaps} maps/legend/itemstyle/ Item text styles
	                 * @default { "color": "#333333", "cursor": "pointer", "fontSize": "12px", "fontWeight": "bold", "textOverflow": "ellipsis" }
	                 * @product highcharts highstock highmaps
	                 */
	                itemStyle: {
	
	                    /**
	                     */
	                    color: '#333333',
	
	                    /**
	                     */
	                    fontSize: '12px',
	
	                    /**
	                     */
	                    fontWeight: 'bold',
	
	                    /**
	                     */
	                    textOverflow: 'ellipsis'
	                },
	
	                /**
	                 * CSS styles for each legend item in hover mode. Only a subset of
	                 * CSS is supported, notably those options related to text. Properties
	                 * are inherited from `style` unless overridden here.
	                 * 
	                 * @type {CSSObject}
	                 * @see In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), the hovered legend items can be styled with
	                 * the `.highcharts-legend-item:hover` pesudo-class.
	                 * @sample {highcharts} highcharts/legend/itemhoverstyle/ Red on hover
	                 * @sample {highmaps} maps/legend/itemstyle/ Item text styles
	                 * @default { "color": "#000000" }
	                 * @product highcharts highstock highmaps
	                 */
	                itemHoverStyle: {
	                    //cursor: 'pointer', removed as of #601
	
	                    /**
	                     */
	                    color: '#000000'
	                },
	
	                /**
	                 * CSS styles for each legend item when the corresponding series or
	                 * point is hidden. Only a subset of CSS is supported, notably those
	                 * options related to text. Properties are inherited from `style`
	                 * unless overridden here.
	                 * 
	                 * @type {CSSObject}
	                 * @see In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), the hidden legend items can be styled with
	                 * the `.highcharts-legend-item-hidden` class.
	                 * @sample {highcharts} highcharts/legend/itemhiddenstyle/ Darker gray color
	                 * @default { "color": "#cccccc" }
	                 * @product highcharts highstock highmaps
	                 */
	                itemHiddenStyle: {
	
	                    /**
	                     */
	                    color: '#cccccc'
	                },
	
	                /**
	                 * Whether to apply a drop shadow to the legend. A `backgroundColor`
	                 * also needs to be applied for this to take effect. The shadow can be
	                 * an object configuration containing `color`, `offsetX`, `offsetY`,
	                 * `opacity` and `width`.
	                 * 
	                 * @type {Boolean|Object}
	                 * @sample {highcharts} highcharts/legend/shadow/
	                 *         White background and drop shadow
	                 * @sample {highstock} stock/legend/align/
	                 *         Various legend options
	                 * @sample {highmaps} maps/legend/border-background/
	                 *         Border and background options
	                 * @default false
	                 * @product highcharts highstock highmaps
	                 */
	                shadow: false,
	
	
	                /**
	                 */
	                itemCheckboxStyle: {
	
	                    /**
	                     */
	                    position: 'absolute',
	
	                    /**
	                     */
	                    width: '13px', // for IE precision
	
	                    /**
	                     */
	                    height: '13px'
	                },
	                // itemWidth: undefined,
	
	                /**
	                 * When this is true, the legend symbol width will be the same as
	                 * the symbol height, which in turn defaults to the font size of the
	                 * legend items.
	                 * 
	                 * @type {Boolean}
	                 * @default true
	                 * @since 5.0.0
	                 * @product highcharts highstock highmaps
	                 */
	                squareSymbol: true,
	
	                /**
	                 * The pixel height of the symbol for series types that use a rectangle
	                 * in the legend. Defaults to the font size of legend items.
	                 *
	                 * @productdesc {highmaps}
	                 * In Highmaps, when the symbol is the gradient of a vertical color
	                 * axis, the height defaults to 200.
	                 * 
	                 * @type {Number}
	                 * @sample {highmaps} maps/legend/layout-vertical-sized/
	                 *         Sized vertical gradient
	                 * @sample {highmaps} maps/legend/padding-itemmargin/
	                 *         No distance between data classes
	                 * @since 3.0.8
	                 * @apioption legend.symbolHeight
	                 */
	
	                /**
	                 * The border radius of the symbol for series types that use a rectangle
	                 * in the legend. Defaults to half the `symbolHeight`.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/legend/symbolradius/ Round symbols
	                 * @sample {highstock} highcharts/legend/symbolradius/ Round symbols
	                 * @sample {highmaps} highcharts/legend/symbolradius/ Round symbols
	                 * @since 3.0.8
	                 * @apioption legend.symbolRadius
	                 */
	
	                /**
	                 * The pixel width of the legend item symbol. When the `squareSymbol`
	                 * option is set, this defaults to the `symbolHeight`, otherwise 16.
	                 * 
	                 * @productdesc {highmaps}
	                 * In Highmaps, when the symbol is the gradient of a horizontal color
	                 * axis, the width defaults to 200.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/legend/symbolwidth/
	                 *         Greater symbol width and padding
	                 * @sample {highmaps} maps/legend/padding-itemmargin/
	                 *         Padding and item margins demonstrated
	                 * @sample {highmaps} maps/legend/layout-vertical-sized/
	                 *         Sized vertical gradient
	                 * @apioption legend.symbolWidth
	                 */
	
	                /**
	                 * Whether to [use HTML](http://www.highcharts.com/docs/chart-concepts/labels-
	                 * and-string-formatting#html) to render the legend item texts. Prior
	                 * to 4.1.7, when using HTML, [legend.navigation](#legend.navigation)
	                 * was disabled.
	                 * 
	                 * @type {Boolean}
	                 * @default false
	                 * @apioption legend.useHTML
	                 */
	
	                /**
	                 * The width of the legend box.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/legend/width/ Aligned to the plot area
	                 * @default null
	                 * @since 2.0
	                 * @apioption legend.width
	                 */
	
	                /**
	                 * The pixel padding between the legend item symbol and the legend
	                 * item text.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/legend/symbolpadding/ Greater symbol width and padding
	                 * @default 5
	                 * @product highcharts highstock highmaps
	                 */
	                symbolPadding: 5,
	
	                /**
	                 * The vertical alignment of the legend box. Can be one of `top`,
	                 * `middle` or `bottom`. Vertical position can be further determined
	                 * by the `y` option.
	                 * 
	                 * In the case that the legend is aligned in a corner position, the
	                 * `layout` option will determine whether to place it above/below
	                 * or on the side of the plot area.
	                 * 
	                 * @validvalue ["top", "middle", "bottom"]
	                 * @type {String}
	                 * @sample {highcharts} highcharts/legend/verticalalign/ Legend 100px from the top of the chart
	                 * @sample {highstock} stock/legend/align/ Various legend options
	                 * @sample {highmaps} maps/legend/alignment/ Legend alignment
	                 * @default bottom
	                 * @since 2.0
	                 * @product highcharts highstock highmaps
	                 */
	                verticalAlign: 'bottom',
	                // width: undefined,
	
	                /**
	                 * The x offset of the legend relative to its horizontal alignment
	                 * `align` within chart.spacingLeft and chart.spacingRight. Negative
	                 * x moves it to the left, positive x moves it to the right.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/legend/width/ Aligned to the plot area
	                 * @default 0
	                 * @since 2.0
	                 * @product highcharts highstock highmaps
	                 */
	                x: 0,
	
	                /**
	                 * The vertical offset of the legend relative to it's vertical alignment
	                 * `verticalAlign` within chart.spacingTop and chart.spacingBottom.
	                 *  Negative y moves it up, positive y moves it down.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/legend/verticalalign/ Legend 100px from the top of the chart
	                 * @sample {highstock} stock/legend/align/ Various legend options
	                 * @sample {highmaps} maps/legend/alignment/ Legend alignment
	                 * @default 0
	                 * @since 2.0
	                 * @product highcharts highstock highmaps
	                 */
	                y: 0,
	
	                /**
	                 * A title to be added on top of the legend.
	                 * 
	                 * @sample {highcharts} highcharts/legend/title/ Legend title
	                 * @sample {highmaps} maps/legend/alignment/ Legend with title
	                 * @since 3.0
	                 * @product highcharts highstock highmaps
	                 */
	                title: {
	                    //text: null,
	
	
	                    /**
	                     * Generic CSS styles for the legend title.
	                     * 
	                     * @type {CSSObject}
	                     * @see In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                     * style/style-by-css), the legend title is styled with the `.highcharts-
	                     * legend-title` class.
	                     * @default {"fontWeight":"bold"}
	                     * @since 3.0
	                     * @product highcharts highstock highmaps
	                     */
	                    style: {
	
	                        /**
	                         */
	                        fontWeight: 'bold'
	                    }
	
	                }
	            },
	
	
	            /**
	             * The loading options control the appearance of the loading screen
	             * that covers the plot area on chart operations. This screen only
	             * appears after an explicit call to `chart.showLoading()`. It is a
	             * utility for developers to communicate to the end user that something
	             * is going on, for example while retrieving new data via an XHR connection.
	             * The "Loading..." text itself is not part of this configuration
	             * object, but part of the `lang` object.
	             * 
	             * @product highcharts highstock highmaps
	             */
	            loading: {
	
	                /**
	                 * The duration in milliseconds of the fade out effect.
	                 * 
	                 * @type {Number}
	                 * @sample highcharts/loading/hideduration/ Fade in and out over a second
	                 * @default 100
	                 * @since 1.2.0
	                 * @apioption loading.hideDuration
	                 */
	
	                /**
	                 * The duration in milliseconds of the fade in effect.
	                 * 
	                 * @type {Number}
	                 * @sample highcharts/loading/hideduration/ Fade in and out over a second
	                 * @default 100
	                 * @since 1.2.0
	                 * @apioption loading.showDuration
	                 */
	
	
	                /**
	                 * CSS styles for the loading label `span`.
	                 * 
	                 * @type {CSSObject}
	                 * @see In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), the loading label is styled with the
	                 * `.highcharts-legend-loading-inner` class.
	                 * @sample {highcharts|highmaps} highcharts/loading/labelstyle/ Vertically centered
	                 * @sample {highstock} stock/loading/general/ Label styles
	                 * @default { "fontWeight": "bold", "position": "relative", "top": "45%" }
	                 * @since 1.2.0
	                 * @product highcharts highstock highmaps
	                 */
	                labelStyle: {
	                    fontWeight: 'bold',
	                    position: 'relative',
	                    top: '45%'
	                },
	
	                /**
	                 * CSS styles for the loading screen that covers the plot area.
	                 * 
	                 * @type {CSSObject}
	                 * @see In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), the loading label is styled with the `.highcharts-
	                 * legend-loading` class.
	                 * @sample {highcharts|highmaps} highcharts/loading/style/ Gray plot area, white text
	                 * @sample {highstock} stock/loading/general/ Gray plot area, white text
	                 * @default { "position": "absolute", "backgroundColor": "#ffffff", "opacity": 0.5, "textAlign": "center" }
	                 * @since 1.2.0
	                 */
	                style: {
	                    position: 'absolute',
	                    backgroundColor: '#ffffff',
	                    opacity: 0.5,
	                    textAlign: 'center'
	                }
	
	            },
	
	
	            /**
	             * Options for the tooltip that appears when the user hovers over a
	             * series or point.
	             * 
	             * @product highcharts highstock highmaps
	             */
	            tooltip: {
	
	                /**
	                 * Enable or disable the tooltip.
	                 * 
	                 * @type {Boolean}
	                 * @sample {highcharts} highcharts/tooltip/enabled/ Disabled
	                 * @sample {highcharts} highcharts/plotoptions/series-point-events-mouseover/ Disable tooltip and show values on chart instead
	                 * @default true
	                 * @product highcharts highstock highmaps
	                 */
	                enabled: true,
	
	                /**
	                 * Enable or disable animation of the tooltip. In slow legacy IE browsers
	                 * the animation is disabled by default.
	                 * 
	                 * @type {Boolean}
	                 * @default true
	                 * @since 2.3.0
	                 * @product highcharts highstock highmaps
	                 */
	                animation: svg,
	                //crosshairs: null,
	
	                /**
	                 * The radius of the rounded border corners.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/tooltip/bordercolor-default/ 5px by default
	                 * @sample {highcharts} highcharts/tooltip/borderradius-0/ Square borders
	                 * @sample {highmaps} maps/tooltip/background-border/ Background and border demo
	                 * @default 3
	                 * @product highcharts highstock highmaps
	                 */
	                borderRadius: 3,
	
	                /**
	                 * For series on a datetime axes, the date format in the tooltip's
	                 * header will by default be guessed based on the closest data points.
	                 * This member gives the default string representations used for
	                 * each unit. For an overview of the replacement codes, see [dateFormat](#Highcharts.
	                 * dateFormat).
	                 * 
	                 * Defaults to:
	                 * 
	                 * <pre>{
	                 * millisecond:"%A, %b %e, %H:%M:%S.%L",
	                 * second:"%A, %b %e, %H:%M:%S",
	                 * minute:"%A, %b %e, %H:%M",
	                 * hour:"%A, %b %e, %H:%M",
	                 * day:"%A, %b %e, %Y",
	                 * week:"Week from %A, %b %e, %Y",
	                 * month:"%B %Y",
	                 * year:"%Y"
	                 * }</pre>
	                 * 
	                 * @type {Object}
	                 * @see [xAxis.dateTimeLabelFormats](#xAxis.dateTimeLabelFormats)
	                 * @product highcharts highstock
	                 */
	                dateTimeLabelFormats: {
	
	                    /**
	                     */
	                    millisecond: '%A, %b %e, %H:%M:%S.%L',
	
	                    /**
	                     */
	                    second: '%A, %b %e, %H:%M:%S',
	
	                    /**
	                     */
	                    minute: '%A, %b %e, %H:%M',
	
	                    /**
	                     */
	                    hour: '%A, %b %e, %H:%M',
	
	                    /**
	                     */
	                    day: '%A, %b %e, %Y',
	
	                    /**
	                     */
	                    week: 'Week from %A, %b %e, %Y',
	
	                    /**
	                     */
	                    month: '%B %Y',
	
	                    /**
	                     */
	                    year: '%Y'
	                },
	
	                /**
	                 * A string to append to the tooltip format.
	                 * 
	                 * @type {String}
	                 * @sample {highcharts} highcharts/tooltip/footerformat/ A table for value alignment
	                 * @sample {highmaps} maps/tooltip/format/ Format demo
	                 * @default false
	                 * @since 2.2
	                 * @product highcharts highmaps
	                 */
	                footerFormat: '',
	                //formatter: defaultFormatter,
	                /* todo: em font-size when finished comparing against HC4
	                headerFormat: '<span style="font-size: 0.85em">{point.key}</span><br/>',
	                */
	
	                /**
	                 * Padding inside the tooltip, in pixels.
	                 * 
	                 * @type {Number}
	                 * @default 8
	                 * @since 5.0.0
	                 * @product highcharts highstock highmaps
	                 */
	                padding: 8,
	
	                //shape: 'callout',
	                //shared: false,
	
	                /**
	                 * Proximity snap for graphs or single points. It defaults to 10 for
	                 * mouse-powered devices and 25 for touch devices.
	                 * 
	                 * Note that in most cases the whole plot area captures the mouse
	                 * movement, and in these cases `tooltip.snap` doesn't make sense.
	                 * This applies when [stickyTracking](#plotOptions.series.stickyTracking)
	                 * is `true` (default) and when the tooltip is [shared](#tooltip.shared)
	                 * or [split](#tooltip.split).
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/tooltip/bordercolor-default/ 10 px by default
	                 * @sample {highcharts} highcharts/tooltip/snap-50/ 50 px on graph
	                 * @default 10/25
	                 * @since 1.2.0
	                 * @product highcharts highstock
	                 */
	                snap: isTouchDevice ? 25 : 10,
	
	
	                /**
	                 * The background color or gradient for the tooltip.
	                 * 
	                 * In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), the stroke width is set in the `.highcharts-
	                 * tooltip-box` class.
	                 * 
	                 * @type {Color}
	                 * @sample {highcharts} highcharts/tooltip/backgroundcolor-solid/ Yellowish background
	                 * @sample {highcharts} highcharts/tooltip/backgroundcolor-gradient/ Gradient
	                 * @sample {highcharts} highcharts/css/tooltip-border-background/ Tooltip in styled mode
	                 * @sample {highstock} stock/tooltip/general/ Custom tooltip
	                 * @sample {highstock} highcharts/css/tooltip-border-background/ Tooltip in styled mode
	                 * @sample {highmaps} maps/tooltip/background-border/ Background and border demo
	                 * @sample {highmaps} highcharts/css/tooltip-border-background/ Tooltip in styled mode
	                 * @default rgba(247,247,247,0.85)
	                 * @product highcharts highstock highmaps
	                 */
	                backgroundColor: color('#f7f7f7').setOpacity(0.85).get(),
	
	                /**
	                 * The pixel width of the tooltip border.
	                 * 
	                 * In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), the stroke width is set in the `.highcharts-
	                 * tooltip-box` class.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/tooltip/bordercolor-default/ 2px by default
	                 * @sample {highcharts} highcharts/tooltip/borderwidth/ No border (shadow only)
	                 * @sample {highcharts} highcharts/css/tooltip-border-background/ Tooltip in styled mode
	                 * @sample {highstock} stock/tooltip/general/ Custom tooltip
	                 * @sample {highstock} highcharts/css/tooltip-border-background/ Tooltip in styled mode
	                 * @sample {highmaps} maps/tooltip/background-border/ Background and border demo
	                 * @sample {highmaps} highcharts/css/tooltip-border-background/ Tooltip in styled mode
	                 * @default 1
	                 * @product highcharts highstock highmaps
	                 */
	                borderWidth: 1,
	
	                /**
	                 * The HTML of the tooltip header line. Variables are enclosed by
	                 * curly brackets. Available variables are `point.key`, `series.name`,
	                 * `series.color` and other members from the `point` and `series`
	                 * objects. The `point.key` variable contains the category name, x
	                 * value or datetime string depending on the type of axis. For datetime
	                 * axes, the `point.key` date format can be set using tooltip.xDateFormat.
	                 * 
	                 * 
	                 * Defaults to `<span style="font-size: 10px">{point.key}</span><br/>`
	                 * 
	                 * @type {String}
	                 * @sample {highcharts} highcharts/tooltip/footerformat/ A HTML table in the tooltip
	                 * @sample {highstock} highcharts/tooltip/footerformat/ A HTML table in the tooltip
	                 * @sample {highmaps} maps/tooltip/format/ Format demo
	                 * @product highcharts highstock highmaps
	                 */
	                headerFormat: '<span style="font-size: 10px">{point.key}</span><br/>',
	
	                /**
	                 * The HTML of the point's line in the tooltip. Variables are enclosed
	                 * by curly brackets. Available variables are point.x, point.y, series.
	                 * name and series.color and other properties on the same form. Furthermore,
	                 * point.y can be extended by the `tooltip.valuePrefix` and `tooltip.
	                 * valueSuffix` variables. This can also be overridden for each series,
	                 * which makes it a good hook for displaying units.
	                 * 
	                 * In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), the dot is colored by a class name rather
	                 * than the point color.
	                 * 
	                 * @type {String}
	                 * @sample {highcharts} highcharts/tooltip/pointformat/ A different point format with value suffix
	                 * @sample {highmaps} maps/tooltip/format/ Format demo
	                 * @default <span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y}</b><br/>
	                 * @since 2.2
	                 * @product highcharts highstock highmaps
	                 */
	                pointFormat: '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y}</b><br/>',
	
	                /**
	                 * Whether to apply a drop shadow to the tooltip.
	                 * 
	                 * @type {Boolean}
	                 * @sample {highcharts} highcharts/tooltip/bordercolor-default/ True by default
	                 * @sample {highcharts} highcharts/tooltip/shadow/ False
	                 * @sample {highmaps} maps/tooltip/positioner/ Fixed tooltip position, border and shadow disabled
	                 * @default true
	                 * @product highcharts highstock highmaps
	                 */
	                shadow: true,
	
	                /**
	                 * CSS styles for the tooltip. The tooltip can also be styled through
	                 * the CSS class `.highcharts-tooltip`.
	                 * 
	                 * @type {CSSObject}
	                 * @sample {highcharts} highcharts/tooltip/style/ Greater padding, bold text
	                 * @default { "color": "#333333", "cursor": "default", "fontSize": "12px", "pointerEvents": "none", "whiteSpace": "nowrap" }
	                 * @product highcharts highstock highmaps
	                 */
	                style: {
	
	                    /**
	                     */
	                    color: '#333333',
	
	                    /**
	                     */
	                    cursor: 'default',
	
	                    /**
	                     */
	                    fontSize: '12px',
	
	                    /**
	                     */
	                    pointerEvents: 'none', // #1686 http://caniuse.com/#feat=pointer-events
	
	                    /**
	                     */
	                    whiteSpace: 'nowrap'
	                }
	
	                //xDateFormat: '%A, %b %e, %Y',
	                //valueDecimals: null,
	                //valuePrefix: '',
	                //valueSuffix: ''
	            },
	
	
	            /**
	             * Highchart by default puts a credits label in the lower right corner
	             * of the chart. This can be changed using these options.
	             * 
	             * @product highcharts highstock highmaps
	             */
	            credits: {
	
	                /**
	                 * Whether to show the credits text.
	                 * 
	                 * @type {Boolean}
	                 * @sample {highcharts} highcharts/credits/enabled-false/ Credits disabled
	                 * @sample {highstock} stock/credits/enabled/ Credits disabled
	                 * @sample {highmaps} maps/credits/enabled-false/ Credits disabled
	                 * @default true
	                 * @product highcharts highstock highmaps
	                 */
	                enabled: true,
	
	                /**
	                 * The URL for the credits label.
	                 * 
	                 * @type {String}
	                 * @sample {highcharts} highcharts/credits/href/ Custom URL and text
	                 * @sample {highmaps} maps/credits/customized/ Custom URL and text
	                 * @default {highcharts} http://www.highcharts.com
	                 * @default {highstock} "http://www.highcharts.com"
	                 * @default {highmaps} http://www.highcharts.com
	                 * @product highcharts highstock highmaps
	                 */
	                href: 'http://www.highcharts.com',
	
	                /**
	                 * Position configuration for the credits label.
	                 * 
	                 * @type {Object}
	                 * @sample {highcharts} highcharts/credits/position-left/ Left aligned
	                 * @sample {highcharts} highcharts/credits/position-left/ Left aligned
	                 * @sample {highmaps} maps/credits/customized/ Left aligned
	                 * @sample {highmaps} maps/credits/customized/ Left aligned
	                 * @since 2.1
	                 * @product highcharts highstock highmaps
	                 */
	                position: {
	
	                    /**
	                     * Horizontal alignment of the credits.
	                     * 
	                     * @validvalue ["left", "center", "right"]
	                     * @type {String}
	                     * @default right
	                     * @product highcharts highstock highmaps
	                     */
	                    align: 'right',
	
	                    /**
	                     * Horizontal pixel offset of the credits.
	                     * 
	                     * @type {Number}
	                     * @default -10
	                     * @product highcharts highstock highmaps
	                     */
	                    x: -10,
	
	                    /**
	                     * Vertical alignment of the credits.
	                     * 
	                     * @validvalue ["top", "middle", "bottom"]
	                     * @type {String}
	                     * @default bottom
	                     * @product highcharts highstock highmaps
	                     */
	                    verticalAlign: 'bottom',
	
	                    /**
	                     * Vertical pixel offset of the credits.
	                     * 
	                     * @type {Number}
	                     * @default -5
	                     * @product highcharts highstock highmaps
	                     */
	                    y: -5
	                },
	
	
	                /**
	                 * CSS styles for the credits label.
	                 * 
	                 * @type {CSSObject}
	                 * @see In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), credits styles can be set with the `.highcharts-
	                 * credits` class.
	                 * @default { "cursor": "pointer", "color": "#999999", "fontSize": "10px" }
	                 * @product highcharts highstock highmaps
	                 */
	                style: {
	
	                    /**
	                     */
	                    cursor: 'pointer',
	
	                    /**
	                     */
	                    color: '#999999',
	
	                    /**
	                     */
	                    fontSize: '9px'
	                },
	
	
	                /**
	                 * The text for the credits label.
	                 *
	                 * @productdesc {highmaps}
	                 * If a map is loaded as GeoJSON, the text defaults to `Highcharts @
	                 * {map-credits}`. Otherwise, it defaults to `Highcharts.com`.
	                 * 
	                 * @type {String}
	                 * @sample {highcharts} highcharts/credits/href/ Custom URL and text
	                 * @sample {highmaps} maps/credits/customized/ Custom URL and text
	                 * @default {highcharts|highstock} Highcharts.com
	                 */
	                text: 'Highcharts.com'
	            }
	        };
	
	
	
	        /**
	         * Sets the getTimezoneOffset function. If the timezone option is set, a default
	         * getTimezoneOffset function with that timezone is returned. If not, the
	         * specified getTimezoneOffset function is returned. If neither are specified,
	         * undefined is returned.
	         * @return {function} a getTimezoneOffset function or undefined
	         */
	        function getTimezoneOffsetOption() {
	            var globalOptions = H.defaultOptions.global,
	                moment = win.moment;
	
	            if (globalOptions.timezone) {
	                if (!moment) {
	                    // getTimezoneOffset-function stays undefined because it depends on
	                    // Moment.js
	                    H.error(25);
	
	                } else {
	                    return function(timestamp) {
	                        return -moment.tz(
	                            timestamp,
	                            globalOptions.timezone
	                        ).utcOffset();
	                    };
	                }
	            }
	
	            // If not timezone is set, look for the getTimezoneOffset callback
	            return globalOptions.useUTC && globalOptions.getTimezoneOffset;
	        }
	
	        /**
	         * Set the time methods globally based on the useUTC option. Time method can be
	         *   either local time or UTC (default). It is called internally on initiating
	         *   Highcharts and after running `Highcharts.setOptions`.
	         *
	         * @private
	         */
	        function setTimeMethods() {
	            var globalOptions = H.defaultOptions.global,
	                Date,
	                useUTC = globalOptions.useUTC,
	                GET = useUTC ? 'getUTC' : 'get',
	                SET = useUTC ? 'setUTC' : 'set';
	
	            H.Date = Date = globalOptions.Date || win.Date; // Allow using a different Date class
	            Date.hcTimezoneOffset = useUTC && globalOptions.timezoneOffset;
	            Date.hcGetTimezoneOffset = getTimezoneOffsetOption();
	            Date.hcMakeTime = function(year, month, date, hours, minutes, seconds) {
	                var d;
	                if (useUTC) {
	                    d = Date.UTC.apply(0, arguments);
	                    d += getTZOffset(d);
	                } else {
	                    d = new Date(
	                        year,
	                        month,
	                        pick(date, 1),
	                        pick(hours, 0),
	                        pick(minutes, 0),
	                        pick(seconds, 0)
	                    ).getTime();
	                }
	                return d;
	            };
	            each(['Minutes', 'Hours', 'Day', 'Date', 'Month', 'FullYear'], function(s) {
	                Date['hcGet' + s] = GET + s;
	            });
	            each(['Milliseconds', 'Seconds', 'Minutes', 'Hours', 'Date', 'Month', 'FullYear'], function(s) {
	                Date['hcSet' + s] = SET + s;
	            });
	        }
	
	        /**
	         * Merge the default options with custom options and return the new options
	         * structure. Commonly used for defining reusable templates.
	         *
	         * @function #setOptions
	         * @memberOf  Highcharts
	         * @sample highcharts/global/useutc-false Setting a global option
	         * @sample highcharts/members/setoptions Applying a global theme
	         * @param {Object} options The new custom chart options.
	         * @returns {Object} Updated options.
	         */
	        H.setOptions = function(options) {
	
	            // Copy in the default options
	            H.defaultOptions = merge(true, H.defaultOptions, options);
	
	            // Apply UTC
	            setTimeMethods();
	
	            return H.defaultOptions;
	        };
	
	        /**
	         * Get the updated default options. Until 3.0.7, merely exposing defaultOptions for outside modules
	         * wasn't enough because the setOptions method created a new object.
	         */
	        H.getOptions = function() {
	            return H.defaultOptions;
	        };
	
	
	        // Series defaults
	        H.defaultPlotOptions = H.defaultOptions.plotOptions;
	
	        // set the default time methods
	        setTimeMethods();
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var correctFloat = H.correctFloat,
	            defined = H.defined,
	            destroyObjectProperties = H.destroyObjectProperties,
	            isNumber = H.isNumber,
	            merge = H.merge,
	            pick = H.pick,
	            deg2rad = H.deg2rad;
	
	        /**
	         * The Tick class
	         */
	        H.Tick = function(axis, pos, type, noLabel) {
	            this.axis = axis;
	            this.pos = pos;
	            this.type = type || '';
	            this.isNew = true;
	            this.isNewLabel = true;
	
	            if (!type && !noLabel) {
	                this.addLabel();
	            }
	        };
	
	        H.Tick.prototype = {
	            /**
	             * Write the tick label
	             */
	            addLabel: function() {
	                var tick = this,
	                    axis = tick.axis,
	                    options = axis.options,
	                    chart = axis.chart,
	                    categories = axis.categories,
	                    names = axis.names,
	                    pos = tick.pos,
	                    labelOptions = options.labels,
	                    str,
	                    tickPositions = axis.tickPositions,
	                    isFirst = pos === tickPositions[0],
	                    isLast = pos === tickPositions[tickPositions.length - 1],
	                    value = categories ?
	                    pick(categories[pos], names[pos], pos) :
	                    pos,
	                    label = tick.label,
	                    tickPositionInfo = tickPositions.info,
	                    dateTimeLabelFormat;
	
	                // Set the datetime label format. If a higher rank is set for this position, use that. If not,
	                // use the general format.
	                if (axis.isDatetimeAxis && tickPositionInfo) {
	                    dateTimeLabelFormat =
	                        options.dateTimeLabelFormats[
	                            tickPositionInfo.higherRanks[pos] || tickPositionInfo.unitName
	                        ];
	                }
	                // set properties for access in render method
	                tick.isFirst = isFirst;
	                tick.isLast = isLast;
	
	                // get the string
	                str = axis.labelFormatter.call({
	                    axis: axis,
	                    chart: chart,
	                    isFirst: isFirst,
	                    isLast: isLast,
	                    dateTimeLabelFormat: dateTimeLabelFormat,
	                    value: axis.isLog ? correctFloat(axis.lin2log(value)) : value,
	                    pos: pos
	                });
	
	                // prepare CSS
	                //css = width && { width: Math.max(1, Math.round(width - 2 * (labelOptions.padding || 10))) + 'px' };
	
	                // first call
	                if (!defined(label)) {
	
	                    tick.label = label =
	                        defined(str) && labelOptions.enabled ?
	                        chart.renderer.text(
	                            str,
	                            0,
	                            0,
	                            labelOptions.useHTML
	                        )
	
	                        // without position absolute, IE export sometimes is wrong
	                        .css(merge(labelOptions.style))
	
	                        .add(axis.labelGroup) :
	                        null;
	                    tick.labelLength = label && label.getBBox().width; // Un-rotated length
	                    tick.rotation = 0; // Base value to detect change for new calls to getBBox
	
	                    // update
	                } else if (label) {
	                    label.attr({
	                        text: str
	                    });
	                }
	            },
	
	            /**
	             * Get the offset height or width of the label
	             */
	            getLabelSize: function() {
	                return this.label ?
	                    this.label.getBBox()[this.axis.horiz ? 'height' : 'width'] :
	                    0;
	            },
	
	            /**
	             * Handle the label overflow by adjusting the labels to the left and right edge, or
	             * hide them if they collide into the neighbour label.
	             */
	            handleOverflow: function(xy) {
	                var axis = this.axis,
	                    pxPos = xy.x,
	                    chartWidth = axis.chart.chartWidth,
	                    spacing = axis.chart.spacing,
	                    leftBound = pick(axis.labelLeft, Math.min(axis.pos, spacing[3])),
	                    rightBound = pick(axis.labelRight, Math.max(axis.pos + axis.len, chartWidth - spacing[1])),
	                    label = this.label,
	                    rotation = this.rotation,
	                    factor = {
	                        left: 0,
	                        center: 0.5,
	                        right: 1
	                    }[axis.labelAlign],
	                    labelWidth = label.getBBox().width,
	                    slotWidth = axis.getSlotWidth(),
	                    modifiedSlotWidth = slotWidth,
	                    xCorrection = factor,
	                    goRight = 1,
	                    leftPos,
	                    rightPos,
	                    textWidth,
	                    css = {};
	
	                // Check if the label overshoots the chart spacing box. If it does, move it.
	                // If it now overshoots the slotWidth, add ellipsis.
	                if (!rotation) {
	                    leftPos = pxPos - factor * labelWidth;
	                    rightPos = pxPos + (1 - factor) * labelWidth;
	
	                    if (leftPos < leftBound) {
	                        modifiedSlotWidth = xy.x + modifiedSlotWidth * (1 - factor) - leftBound;
	                    } else if (rightPos > rightBound) {
	                        modifiedSlotWidth = rightBound - xy.x + modifiedSlotWidth * factor;
	                        goRight = -1;
	                    }
	
	                    modifiedSlotWidth = Math.min(slotWidth, modifiedSlotWidth); // #4177
	                    if (modifiedSlotWidth < slotWidth && axis.labelAlign === 'center') {
	                        xy.x += goRight * (slotWidth - modifiedSlotWidth - xCorrection *
	                            (slotWidth - Math.min(labelWidth, modifiedSlotWidth)));
	                    }
	                    // If the label width exceeds the available space, set a text width to be
	                    // picked up below. Also, if a width has been set before, we need to set a new
	                    // one because the reported labelWidth will be limited by the box (#3938).
	                    if (labelWidth > modifiedSlotWidth || (axis.autoRotation && (label.styles || {}).width)) {
	                        textWidth = modifiedSlotWidth;
	                    }
	
	                    // Add ellipsis to prevent rotated labels to be clipped against the edge of the chart
	                } else if (rotation < 0 && pxPos - factor * labelWidth < leftBound) {
	                    textWidth = Math.round(pxPos / Math.cos(rotation * deg2rad) - leftBound);
	                } else if (rotation > 0 && pxPos + factor * labelWidth > rightBound) {
	                    textWidth = Math.round((chartWidth - pxPos) / Math.cos(rotation * deg2rad));
	                }
	
	                if (textWidth) {
	                    css.width = textWidth;
	                    if (!(axis.options.labels.style || {}).textOverflow) {
	                        css.textOverflow = 'ellipsis';
	                    }
	                    label.css(css);
	                }
	            },
	
	            /**
	             * Get the x and y position for ticks and labels
	             */
	            getPosition: function(horiz, pos, tickmarkOffset, old) {
	                var axis = this.axis,
	                    chart = axis.chart,
	                    cHeight = (old && chart.oldChartHeight) || chart.chartHeight;
	
	                return {
	                    x: horiz ?
	                        axis.translate(pos + tickmarkOffset, null, null, old) + axis.transB : axis.left + axis.offset +
	                        (axis.opposite ?
	                            ((old && chart.oldChartWidth) || chart.chartWidth) - axis.right - axis.left :
	                            0
	                        ),
	
	                    y: horiz ?
	                        cHeight - axis.bottom + axis.offset - (axis.opposite ? axis.height : 0) : cHeight - axis.translate(pos + tickmarkOffset, null, null, old) - axis.transB
	                };
	
	            },
	
	            /**
	             * Get the x, y position of the tick label
	             */
	            getLabelPosition: function(x, y, label, horiz, labelOptions, tickmarkOffset, index, step) {
	                var axis = this.axis,
	                    transA = axis.transA,
	                    reversed = axis.reversed,
	                    staggerLines = axis.staggerLines,
	                    rotCorr = axis.tickRotCorr || {
	                        x: 0,
	                        y: 0
	                    },
	                    yOffset = labelOptions.y,
	                    line;
	
	                if (!defined(yOffset)) {
	                    if (axis.side === 0) {
	                        yOffset = label.rotation ? -8 : -label.getBBox().height;
	                    } else if (axis.side === 2) {
	                        yOffset = rotCorr.y + 8;
	                    } else {
	                        // #3140, #3140
	                        yOffset = Math.cos(label.rotation * deg2rad) * (rotCorr.y - label.getBBox(false, 0).height / 2);
	                    }
	                }
	
	                x = x + labelOptions.x + rotCorr.x - (tickmarkOffset && horiz ?
	                    tickmarkOffset * transA * (reversed ? -1 : 1) : 0);
	                y = y + yOffset - (tickmarkOffset && !horiz ?
	                    tickmarkOffset * transA * (reversed ? 1 : -1) : 0);
	
	                // Correct for staggered labels
	                if (staggerLines) {
	                    line = (index / (step || 1) % staggerLines);
	                    if (axis.opposite) {
	                        line = staggerLines - line - 1;
	                    }
	                    y += line * (axis.labelOffset / staggerLines);
	                }
	
	                return {
	                    x: x,
	                    y: Math.round(y)
	                };
	            },
	
	            /**
	             * Extendible method to return the path of the marker
	             */
	            getMarkPath: function(x, y, tickLength, tickWidth, horiz, renderer) {
	                return renderer.crispLine([
	                    'M',
	                    x,
	                    y,
	                    'L',
	                    x + (horiz ? 0 : -tickLength),
	                    y + (horiz ? tickLength : 0)
	                ], tickWidth);
	            },
	
	            /**
	             * Renders the gridLine.
	             * @param  {Boolean} old         Whether or not the tick is old
	             * @param  {number} opacity      The opacity of the grid line
	             * @param  {number} reverseCrisp Modifier for avoiding overlapping 1 or -1
	             * @return {undefined}
	             */
	            renderGridLine: function(old, opacity, reverseCrisp) {
	                var tick = this,
	                    axis = tick.axis,
	                    options = axis.options,
	                    gridLine = tick.gridLine,
	                    gridLinePath,
	                    attribs = {},
	                    pos = tick.pos,
	                    type = tick.type,
	                    tickmarkOffset = axis.tickmarkOffset,
	                    renderer = axis.chart.renderer;
	
	
	                var gridPrefix = type ? type + 'Grid' : 'grid',
	                    gridLineWidth = options[gridPrefix + 'LineWidth'],
	                    gridLineColor = options[gridPrefix + 'LineColor'],
	                    dashStyle = options[gridPrefix + 'LineDashStyle'];
	
	
	                if (!gridLine) {
	
	                    attribs.stroke = gridLineColor;
	                    attribs['stroke-width'] = gridLineWidth;
	                    if (dashStyle) {
	                        attribs.dashstyle = dashStyle;
	                    }
	
	                    if (!type) {
	                        attribs.zIndex = 1;
	                    }
	                    if (old) {
	                        attribs.opacity = 0;
	                    }
	                    tick.gridLine = gridLine = renderer.path()
	                        .attr(attribs)
	                        .addClass(
	                            'highcharts-' + (type ? type + '-' : '') + 'grid-line'
	                        )
	                        .add(axis.gridGroup);
	                }
	
	                // If the parameter 'old' is set, the current call will be followed
	                // by another call, therefore do not do any animations this time
	                if (!old && gridLine) {
	                    gridLinePath = axis.getPlotLinePath(
	                        pos + tickmarkOffset,
	                        gridLine.strokeWidth() * reverseCrisp,
	                        old, true
	                    );
	                    if (gridLinePath) {
	                        gridLine[tick.isNew ? 'attr' : 'animate']({
	                            d: gridLinePath,
	                            opacity: opacity
	                        });
	                    }
	                }
	            },
	
	            /**
	             * Renders the tick mark.
	             * @param  {Object} xy           The position vector of the mark
	             * @param  {number} xy.x         The x position of the mark
	             * @param  {number} xy.y         The y position of the mark
	             * @param  {number} opacity      The opacity of the mark
	             * @param  {number} reverseCrisp Modifier for avoiding overlapping 1 or -1
	             * @return {undefined}
	             */
	            renderMark: function(xy, opacity, reverseCrisp) {
	                var tick = this,
	                    axis = tick.axis,
	                    options = axis.options,
	                    renderer = axis.chart.renderer,
	                    type = tick.type,
	                    tickPrefix = type ? type + 'Tick' : 'tick',
	                    tickSize = axis.tickSize(tickPrefix),
	                    mark = tick.mark,
	                    isNewMark = !mark,
	                    x = xy.x,
	                    y = xy.y;
	
	
	                var tickWidth = pick(
	                        options[tickPrefix + 'Width'], !type && axis.isXAxis ? 1 : 0
	                    ), // X axis defaults to 1
	                    tickColor = options[tickPrefix + 'Color'];
	
	
	                if (tickSize) {
	
	                    // negate the length
	                    if (axis.opposite) {
	                        tickSize[0] = -tickSize[0];
	                    }
	
	                    // First time, create it
	                    if (isNewMark) {
	                        tick.mark = mark = renderer.path()
	                            .addClass('highcharts-' + (type ? type + '-' : '') + 'tick')
	                            .add(axis.axisGroup);
	
	
	                        mark.attr({
	                            stroke: tickColor,
	                            'stroke-width': tickWidth
	                        });
	
	                    }
	                    mark[isNewMark ? 'attr' : 'animate']({
	                        d: tick.getMarkPath(
	                            x,
	                            y,
	                            tickSize[0],
	                            mark.strokeWidth() * reverseCrisp,
	                            axis.horiz,
	                            renderer),
	                        opacity: opacity
	                    });
	
	                }
	            },
	
	            /**
	             * Renders the tick label.
	             * Note: The label should already be created in init(), so it should only
	             * have to be moved into place.
	             * @param  {Object} xy      The position vector of the label
	             * @param  {number} xy.x    The x position of the label
	             * @param  {number} xy.y    The y position of the label
	             * @param  {Boolean} old    Whether or not the tick is old
	             * @param  {number} opacity The opacity of the label
	             * @param  {number} index   The index of the tick
	             * @return {undefined}
	             */
	            renderLabel: function(xy, old, opacity, index) {
	                var tick = this,
	                    axis = tick.axis,
	                    horiz = axis.horiz,
	                    options = axis.options,
	                    label = tick.label,
	                    labelOptions = options.labels,
	                    step = labelOptions.step,
	                    tickmarkOffset = axis.tickmarkOffset,
	                    show = true,
	                    x = xy.x,
	                    y = xy.y;
	                if (label && isNumber(x)) {
	                    label.xy = xy = tick.getLabelPosition(
	                        x,
	                        y,
	                        label,
	                        horiz,
	                        labelOptions,
	                        tickmarkOffset,
	                        index,
	                        step
	                    );
	
	                    // Apply show first and show last. If the tick is both first and
	                    // last, it is a single centered tick, in which case we show the
	                    // label anyway (#2100).
	                    if (
	                        (
	                            tick.isFirst &&
	                            !tick.isLast &&
	                            !pick(options.showFirstLabel, 1)
	                        ) ||
	                        (
	                            tick.isLast &&
	                            !tick.isFirst &&
	                            !pick(options.showLastLabel, 1)
	                        )
	                    ) {
	                        show = false;
	
	                        // Handle label overflow and show or hide accordingly
	                    } else if (horiz && !axis.isRadial && !labelOptions.step &&
	                        !labelOptions.rotation && !old && opacity !== 0) {
	                        tick.handleOverflow(xy);
	                    }
	
	                    // apply step
	                    if (step && index % step) {
	                        // show those indices dividable by step
	                        show = false;
	                    }
	
	                    // Set the new position, and show or hide
	                    if (show && isNumber(xy.y)) {
	                        xy.opacity = opacity;
	                        label[tick.isNewLabel ? 'attr' : 'animate'](xy);
	                        tick.isNewLabel = false;
	                    } else {
	                        label.attr('y', -9999); // #1338
	                        tick.isNewLabel = true;
	                    }
	                    tick.isNew = false;
	                }
	            },
	
	            /**
	             * Put everything in place
	             *
	             * @param index {Number}
	             * @param old {Boolean} Use old coordinates to prepare an animation into new
	             *                      position
	             */
	            render: function(index, old, opacity) {
	                var tick = this,
	                    axis = tick.axis,
	                    horiz = axis.horiz,
	                    pos = tick.pos,
	                    tickmarkOffset = axis.tickmarkOffset,
	                    xy = tick.getPosition(horiz, pos, tickmarkOffset, old),
	                    x = xy.x,
	                    y = xy.y,
	                    reverseCrisp = ((horiz && x === axis.pos + axis.len) ||
	                        (!horiz && y === axis.pos)) ? -1 : 1; // #1480, #1687
	
	                opacity = pick(opacity, 1);
	                this.isActive = true;
	
	                // Create the grid line
	                this.renderGridLine(old, opacity, reverseCrisp);
	
	                // create the tick mark
	                this.renderMark(xy, opacity, reverseCrisp);
	
	                // the label is created on init - now move it into place
	                this.renderLabel(xy, old, opacity, index);
	            },
	
	            /**
	             * Destructor for the tick prototype
	             */
	            destroy: function() {
	                destroyObjectProperties(this, this.axis);
	            }
	        };
	
	    }(Highcharts));
	    var Axis = (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	
	        var addEvent = H.addEvent,
	            animObject = H.animObject,
	            arrayMax = H.arrayMax,
	            arrayMin = H.arrayMin,
	            color = H.color,
	            correctFloat = H.correctFloat,
	            defaultOptions = H.defaultOptions,
	            defined = H.defined,
	            deg2rad = H.deg2rad,
	            destroyObjectProperties = H.destroyObjectProperties,
	            each = H.each,
	            extend = H.extend,
	            fireEvent = H.fireEvent,
	            format = H.format,
	            getMagnitude = H.getMagnitude,
	            grep = H.grep,
	            inArray = H.inArray,
	            isArray = H.isArray,
	            isNumber = H.isNumber,
	            isString = H.isString,
	            merge = H.merge,
	            normalizeTickInterval = H.normalizeTickInterval,
	            objectEach = H.objectEach,
	            pick = H.pick,
	            removeEvent = H.removeEvent,
	            splat = H.splat,
	            syncTimeout = H.syncTimeout,
	            Tick = H.Tick;
	
	        /**
	         * Create a new axis object. Called internally when instanciating a new chart or
	         * adding axes by {@link Highcharts.Chart#addAxis}.
	         *
	         * A chart can have from 0 axes (pie chart) to multiples. In a normal, single
	         * series cartesian chart, there is one X axis and one Y axis.
	         * 
	         * The X axis or axes are referenced by {@link Highcharts.Chart.xAxis}, which is
	         * an array of Axis objects. If there is only one axis, it can be referenced
	         * through `chart.xAxis[0]`, and multiple axes have increasing indices. The same
	         * pattern goes for Y axes.
	         * 
	         * If you need to get the axes from a series object, use the `series.xAxis` and
	         * `series.yAxis` properties. These are not arrays, as one series can only be
	         * associated to one X and one Y axis.
	         * 
	         * A third way to reference the axis programmatically is by `id`. Add an `id` in
	         * the axis configuration options, and get the axis by
	         * {@link Highcharts.Chart#get}.
	         * 
	         * Configuration options for the axes are given in options.xAxis and
	         * options.yAxis.
	         * 
	         * @class Highcharts.Axis
	         * @memberOf Highcharts
	         * @param {Highcharts.Chart} chart - The Chart instance to apply the axis on.
	         * @param {Object} options - Axis options
	         */
	        var Axis = function() {
	            this.init.apply(this, arguments);
	        };
	
	        H.extend(Axis.prototype, /** @lends Highcharts.Axis.prototype */ {
	
	            /**
	             * The X axis or category axis. Normally this is the horizontal axis,
	             * though if the chart is inverted this is the vertical axis. In case of
	             * multiple axes, the xAxis node is an array of configuration objects.
	             * 
	             * See [../class-reference/Highcharts.Axis](the Axis object) for
	             * programmatic access to the axis.
	             *
	             * @productdesc {highmaps}
	             * In Highmaps, the axis is hidden, but it is used behind the scenes to
	             * control features like zooming and panning. Zooming is in effect the same
	             * as setting the extremes of one of the exes.
	             * 
	             * @optionparent xAxis
	             */
	            defaultOptions: {
	                // allowDecimals: null,
	                // alternateGridColor: null,
	                // categories: [],
	
	                /**
	                 * For a datetime axis, the scale will automatically adjust to the
	                 * appropriate unit. This member gives the default string representations
	                 * used for each unit. For intermediate values, different units may
	                 * be used, for example the `day` unit can be used on midnight and
	                 * `hour` unit be used for intermediate values on the same axis. For
	                 * an overview of the replacement codes, see [dateFormat](#Highcharts.
	                 * dateFormat). Defaults to:
	                 * 
	                 * <pre>{
	                 * millisecond: '%H:%M:%S.%L',
	                 * second: '%H:%M:%S',
	                 * minute: '%H:%M',
	                 * hour: '%H:%M',
	                 * day: '%e. %b',
	                 * week: '%e. %b',
	                 * month: '%b \'%y',
	                 * year: '%Y'
	                 * }</pre>
	                 * 
	                 * @type {Object}
	                 * @sample {highcharts} highcharts/xaxis/datetimelabelformats/ Different day format on X axis
	                 * @sample {highstock} stock/xaxis/datetimelabelformats/ More information in x axis labels
	                 * @product highcharts highstock
	                 */
	                dateTimeLabelFormats: {
	
	                    /**
	                     */
	                    millisecond: '%H:%M:%S.%L',
	
	                    /**
	                     */
	                    second: '%H:%M:%S',
	
	                    /**
	                     */
	                    minute: '%H:%M',
	
	                    /**
	                     */
	                    hour: '%H:%M',
	
	                    /**
	                     */
	                    day: '%e. %b',
	
	                    /**
	                     */
	                    week: '%e. %b',
	
	                    /**
	                     */
	                    month: '%b \'%y',
	
	                    /**
	                     */
	                    year: '%Y'
	                },
	
	                /**
	                 * Whether to force the axis to end on a tick. Use this option with
	                 * the `maxPadding` option to control the axis end.
	                 * 
	                 * @type {Boolean}
	                 * @sample {highcharts} highcharts/chart/reflow-true/ True by default
	                 * @sample {highcharts} highcharts/yaxis/endontick/ False
	                 * @sample {highstock} stock/demo/basic-line/ True by default
	                 * @sample {highstock} stock/xaxis/endontick/ False
	                 * @default false
	                 * @since 1.2.0
	                 * @product highcharts highstock highmaps
	                 */
	                endOnTick: false,
	                // reversed: false,
	
	
	                /**
	                 * The axis labels show the number or category for each tick.
	                 *
	                 * @productdesc {highmaps}
	                 * X and Y axis labels are by default disabled in Highmaps, but the
	                 * functionality is inherited from Highcharts and used on `colorAxis`,
	                 * and can be enabled on X and Y axes too.
	                 */
	                labels: {
	
	                    /**
	                     * Enable or disable the axis labels.
	                     * 
	                     * @type {Boolean}
	                     * @sample {highcharts} highcharts/xaxis/labels-enabled/ X axis labels disabled
	                     * @sample {highstock} stock/xaxis/labels-enabled/ X axis labels disabled
	                     * @default {highstock} true
	                     * @default {highmaps} false
	                     * @product highcharts highstock highmaps
	                     */
	                    enabled: true,
	                    // rotation: 0,
	                    // align: 'center',
	                    // step: null,
	
	
	                    /**
	                     * CSS styles for the label. Use `whiteSpace: 'nowrap'` to prevent
	                     * wrapping of category labels. Use `textOverflow: 'none'` to prevent
	                     * ellipsis (dots).
	                     * 
	                     * In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                     * style/style-by-css), the labels are styled with the `.highcharts-
	                     * axis-labels` class.
	                     * 
	                     * @type {CSSObject}
	                     * @sample {highcharts} highcharts/xaxis/labels-style/ Red X axis labels
	                     * @default { "color": "#666666", "cursor": "default", "fontSize": "11px" }
	                     * @product highcharts highstock highmaps
	                     */
	                    style: {
	
	                        /**
	                         */
	                        color: '#666666',
	
	                        /**
	                         */
	                        cursor: 'default',
	
	                        /**
	                         */
	                        fontSize: '11px'
	                    },
	
	
	                    /**
	                     * The x position offset of the label relative to the tick position
	                     * on the axis.
	                     * 
	                     * @type {Number}
	                     * @sample {highcharts} highcharts/xaxis/labels-x/ Y axis labels placed on grid lines
	                     * @default 0
	                     * @product highcharts highstock highmaps
	                     */
	                    x: 0
	                    //y: undefined
	                    /*formatter: function () {
	                    	return this.value;
	                    },*/
	                },
	                //linkedTo: null,
	                //max: undefined,
	                //min: undefined,
	
	                /**
	                 * Padding of the min value relative to the length of the axis. A
	                 * padding of 0.05 will make a 100px axis 5px longer. This is useful
	                 * when you don't want the lowest data value to appear on the edge
	                 * of the plot area. When the axis' `min` option is set or a min extreme
	                 * is set using `axis.setExtremes()`, the minPadding will be ignored.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/yaxis/minpadding/ Min padding of 0.2
	                 * @sample {highstock} stock/xaxis/minpadding-maxpadding/ Greater min- and maxPadding
	                 * @sample {highmaps} maps/chart/plotbackgroundcolor-gradient/ Add some padding
	                 * @default {highcharts} 0.01
	                 * @default {highstock} 0
	                 * @default {highmaps} 0
	                 * @since 1.2.0
	                 * @product highcharts highstock highmaps
	                 */
	                minPadding: 0.01,
	
	                /**
	                 * Padding of the max value relative to the length of the axis. A
	                 * padding of 0.05 will make a 100px axis 5px longer. This is useful
	                 * when you don't want the highest data value to appear on the edge
	                 * of the plot area. When the axis' `max` option is set or a max extreme
	                 * is set using `axis.setExtremes()`, the maxPadding will be ignored.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/yaxis/maxpadding/ Max padding of 0.25 on y axis
	                 * @sample {highstock} stock/xaxis/minpadding-maxpadding/ Greater min- and maxPadding
	                 * @sample {highmaps} maps/chart/plotbackgroundcolor-gradient/ Add some padding
	                 * @default {highcharts} 0.01
	                 * @default {highstock} 0
	                 * @default {highmaps} 0
	                 * @since 1.2.0
	                 * @product highcharts highstock highmaps
	                 */
	                maxPadding: 0.01,
	                //minRange: null,
	                //minorTickInterval: null,
	
	                /**
	                 * The pixel length of the minor tick marks.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/yaxis/minorticklength/ 10px on Y axis
	                 * @sample {highstock} stock/xaxis/minorticks/ 10px on Y axis
	                 * @default 2
	                 * @product highcharts highstock highmaps
	                 */
	                minorTickLength: 2,
	
	                /**
	                 * The position of the minor tick marks relative to the axis line.
	                 *  Can be one of `inside` and `outside`.
	                 * 
	                 * @validvalue ["inside", "outside"]
	                 * @type {String}
	                 * @sample {highcharts} highcharts/yaxis/minortickposition-outside/ Outside by default
	                 * @sample {highcharts} highcharts/yaxis/minortickposition-inside/ Inside
	                 * @sample {highstock} stock/xaxis/minorticks/ Inside
	                 * @default outside
	                 * @product highcharts highstock highmaps
	                 */
	                minorTickPosition: 'outside', // inside or outside
	                //opposite: false,
	                //offset: 0,
	                //plotBands: [{
	                //	events: {},
	                //	zIndex: 1,
	                //	labels: { align, x, verticalAlign, y, style, rotation, textAlign }
	                //}],
	                //plotLines: [{
	                //	events: {}
	                //  dashStyle: {}
	                //	zIndex:
	                //	labels: { align, x, verticalAlign, y, style, rotation, textAlign }
	                //}],
	                //reversed: false,
	                // showFirstLabel: true,
	                // showLastLabel: true,
	
	                /**
	                 * For datetime axes, this decides where to put the tick between weeks.
	                 *  0 = Sunday, 1 = Monday.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/xaxis/startofweek-monday/ Monday by default
	                 * @sample {highcharts} highcharts/xaxis/startofweek-sunday/ Sunday
	                 * @sample {highstock} stock/xaxis/startofweek-1 Monday by default
	                 * @sample {highstock} stock/xaxis/startofweek-0 Sunday
	                 * @default 1
	                 * @product highcharts highstock
	                 */
	                startOfWeek: 1,
	
	                /**
	                 * Whether to force the axis to start on a tick. Use this option with
	                 * the `minPadding` option to control the axis start.
	                 *
	                 * @productdesc {highstock}
	                 * In Highstock, `startOnTick` is always false when the navigator is
	                 * enabled, to prevent jumpy scrolling.
	                 * 
	                 * @type {Boolean}
	                 * @sample {highcharts} highcharts/xaxis/startontick-false/ False by default
	                 * @sample {highcharts} highcharts/xaxis/startontick-true/ True
	                 * @sample {highstock} stock/xaxis/endontick/ False for Y axis
	                 * @default false
	                 * @since 1.2.0
	                 */
	                startOnTick: false,
	                //tickInterval: null,
	
	                /**
	                 * The pixel length of the main tick marks.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/xaxis/ticklength/ 20 px tick length on the X axis
	                 * @sample {highstock} stock/xaxis/ticks/ Formatted ticks on X axis
	                 * @default 10
	                 * @product highcharts highstock highmaps
	                 */
	                tickLength: 10,
	
	                /**
	                 * For categorized axes only. If `on` the tick mark is placed in the
	                 * center of the category, if `between` the tick mark is placed between
	                 * categories. The default is `between` if the `tickInterval` is 1,
	                 *  else `on`.
	                 * 
	                 * @validvalue [null, "on", "between"]
	                 * @type {String}
	                 * @sample {highcharts} highcharts/xaxis/tickmarkplacement-between/ "between" by default
	                 * @sample {highcharts} highcharts/xaxis/tickmarkplacement-on/ "on"
	                 * @default null
	                 * @product highcharts
	                 */
	                tickmarkPlacement: 'between', // on or between
	
	                /**
	                 * If tickInterval is `null` this option sets the approximate pixel
	                 * interval of the tick marks. Not applicable to categorized axis.
	                 * 
	                 * 
	                 * The tick interval is also influenced by the [minTickInterval](#xAxis.
	                 * minTickInterval) option, that, by default prevents ticks from being
	                 * denser than the data points.
	                 * 
	                 * Defaults to `72` for the Y axis and `100` for the X axis.
	                 * 
	                 * @type {Number}
	                 * @see [tickInterval](#xAxis.tickInterval), [tickPositioner](#xAxis.tickPositioner),
	                 *  [tickPositions](#xAxis.tickPositions)-
	                 * @sample {highcharts} highcharts/xaxis/tickpixelinterval-50/ 50 px on X axis
	                 * @sample {highstock} stock/xaxis/tickpixelinterval/ 200 px on X axis
	                 * @product highcharts highstock highmaps
	                 */
	                tickPixelInterval: 100,
	
	                /**
	                 * The position of the major tick marks relative to the axis line.
	                 *  Can be one of `inside` and `outside`.
	                 * 
	                 * @validvalue ["inside", "outside"]
	                 * @type {String}
	                 * @sample {highcharts} highcharts/xaxis/tickposition-outside/ "outside" by default
	                 * @sample {highcharts} highcharts/xaxis/tickposition-inside/ "inside"
	                 * @sample {highstock} stock/xaxis/ticks/ Formatted ticks on X axis
	                 * @default {highcharts} outside
	                 * @default {highstock} "outside"
	                 * @default {highmaps} outside
	                 * @product highcharts highstock highmaps
	                 */
	                tickPosition: 'outside',
	
	                /**
	                 * The axis title, showing next to the axis line.
	                 *
	                 * @productdesc {highmaps}
	                 * In Highmaps, the axis is hidden by default, but adding an axis title
	                 * is still possible. X axis and Y axis titles will appear at the bottom
	                 * and left by default.
	                 */
	                title: {
	                    //text: null,
	
	                    /**
	                     * Alignment of the title relative to the axis values. Possible values
	                     * are "low", "middle" or "high".
	                     * 
	                     * @validvalue ["low", "middle", "high"]
	                     * @type {String}
	                     * @sample {highcharts} highcharts/xaxis/title-align-low/ "low"
	                     * @sample {highcharts} highcharts/xaxis/title-align-center/ "middle" by default
	                     * @sample {highcharts} highcharts/xaxis/title-align-high/ "high"
	                     * @sample {highcharts} highcharts/yaxis/title-offset/ Place the Y axis title on top of the axis
	                     * @sample {highstock} stock/xaxis/title-align/ Aligned to "high" value
	                     * @default {highcharts} middle
	                     * @default {highstock} "middle"
	                     * @default {highmaps} middle
	                     * @product highcharts highstock highmaps
	                     */
	                    align: 'middle', // low, middle or high
	                    //margin: 0 for horizontal, 10 for vertical axes,
	                    // reserveSpace: true,
	                    //rotation: 0,
	                    //side: 'outside',
	
	
	                    /**
	                     * CSS styles for the title. If the title text is longer than the
	                     * axis length, it will wrap to multiple lines by default. This can
	                     * be customized by setting `textOverflow: 'ellipsis'`, by 
	                     * setting a specific `width` or by setting `wordSpace: 'nowrap'`.
	                     * 
	                     * 
	                     * In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                     * style/style-by-css), the stroke width is given in the
	                     * `.highcharts-axis-title` class.
	                     * 
	                     * @type {CSSObject}
	                     * @sample {highcharts} highcharts/xaxis/title-style/ Red
	                     * @sample {highcharts} highcharts/css/axis/ Styled mode
	                     * @default { "color": "#666666" }
	                     * @product highcharts highstock highmaps
	                     */
	                    style: {
	
	                        /**
	                         */
	                        color: '#666666'
	                    }
	
	                    //x: 0,
	                    //y: 0
	                },
	
	                /**
	                 * The type of axis. Can be one of `linear`, `logarithmic`, `datetime`
	                 * or `category`. In a datetime axis, the numbers are given in milliseconds,
	                 * and tick marks are placed on appropriate values like full hours
	                 * or days. In a category axis, the [point names](#series<line>.data.
	                 * name) of the chart's series are used for categories, if not a [categories](#xAxis.
	                 * categories) array is defined.
	                 * 
	                 * @validvalue ["linear", "logarithmic", "datetime", "category"]
	                 * @type {String}
	                 * @sample {highcharts} highcharts/xaxis/type-linear/ Linear
	                 * @sample {highcharts} highcharts/yaxis/type-log/ Logarithmic
	                 * @sample {highcharts} highcharts/yaxis/type-log-minorgrid/ Logarithmic with minor grid lines
	                 * @sample {highcharts} highcharts/xaxis/type-log-both/ Logarithmic on two axes
	                 * @sample {highcharts} highcharts/yaxis/type-log-negative/ Logarithmic with extension to emulate negative values
	                 * @default linear
	                 * @product highcharts
	                 */
	                type: 'linear', // linear, logarithmic or datetime
	                //visible: true
	
	
	                /**
	                 * Color of the minor, secondary grid lines.
	                 * 
	                 * In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), the stroke width is given in the `.highcharts-
	                 * minor-grid-line` class.
	                 * 
	                 * @type {Color}
	                 * @sample {highcharts} highcharts/yaxis/minorgridlinecolor/ Bright grey lines from Y axis
	                 * @sample {highcharts} highcharts/css/axis-grid/ Styled mode
	                 * @sample {highstock} stock/xaxis/minorgridlinecolor/ Bright grey lines from Y axis
	                 * @sample {highstock} highcharts/css/axis-grid/ Styled mode
	                 * @default #f2f2f2
	                 * @product highcharts highstock highmaps
	                 */
	                minorGridLineColor: '#f2f2f2',
	                // minorGridLineDashStyle: null,
	
	                /**
	                 * Width of the minor, secondary grid lines.
	                 * 
	                 * In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), the stroke width is given in the `.highcharts-
	                 * grid-line` class.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/yaxis/minorgridlinewidth/ 2px lines from Y axis
	                 * @sample {highcharts} highcharts/css/axis-grid/ Styled mode
	                 * @sample {highstock} stock/xaxis/minorgridlinewidth/ 2px lines from Y axis
	                 * @sample {highstock} highcharts/css/axis-grid/ Styled mode
	                 * @default 1
	                 * @product highcharts highstock highmaps
	                 */
	                minorGridLineWidth: 1,
	
	                /**
	                 * Color for the minor tick marks.
	                 * 
	                 * @type {Color}
	                 * @sample {highcharts} highcharts/yaxis/minortickcolor/ Black tick marks on Y axis
	                 * @sample {highstock} stock/xaxis/minorticks/ Black tick marks on Y axis
	                 * @default #999999
	                 * @product highcharts highstock highmaps
	                 */
	                minorTickColor: '#999999',
	                //minorTickWidth: 0,
	
	                /**
	                 * The color of the line marking the axis itself.
	                 * 
	                 * In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), the line stroke is given in the `.highcharts-
	                 * axis-line` or `.highcharts-xaxis-line` class.
	                 * 
	                 * @productdesc {highmaps}
	                 * In Highmaps, the axis line is hidden by default.
	                 * 
	                 * @type {Color}
	                 * @sample {highcharts} highcharts/yaxis/linecolor/ A red line on Y axis
	                 * @sample {highcharts} highcharts/css/axis/ Axes in styled mode
	                 * @sample {highstock} stock/xaxis/linecolor/ A red line on X axis
	                 * @sample {highstock} highcharts/css/axis/ Axes in styled mode
	                 * @default #ccd6eb
	                 * @product highcharts highstock highmaps
	                 */
	                lineColor: '#ccd6eb',
	
	                /**
	                 * The width of the line marking the axis itself.
	                 * 
	                 * In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), the stroke width is given in the `.highcharts-
	                 * axis-line` or `.highcharts-xaxis-line` class.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/yaxis/linecolor/ A 1px line on Y axis
	                 * @sample {highcharts} highcharts/css/axis/ Axes in styled mode
	                 * @sample {highstock} stock/xaxis/linewidth/ A 2px line on X axis
	                 * @sample {highstock} highcharts/css/axis/ Axes in styled mode
	                 * @default {highcharts} 1
	                 * @default {highstock} 1
	                 * @default {highmaps} 0
	                 * @product highcharts highstock highmaps
	                 */
	                lineWidth: 1,
	
	                /**
	                 * Color of the grid lines extending the ticks across the plot area.
	                 * 
	                 * In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), the stroke is given in the `.highcharts-grid-
	                 * line` class.
	                 *
	                 * @productdesc {highmaps}
	                 * In Highmaps, the grid lines are hidden by default.
	                 * 
	                 * @type {Color}
	                 * @sample {highcharts} highcharts/yaxis/gridlinecolor/ Green lines
	                 * @sample {highcharts} highcharts/css/axis-grid/ Styled mode
	                 * @sample {highstock} stock/xaxis/gridlinecolor/ Green lines
	                 * @sample {highstock} highcharts/css/axis-grid/ Styled mode
	                 * @default #e6e6e6
	                 * @product highcharts highstock highmaps
	                 */
	                gridLineColor: '#e6e6e6',
	                // gridLineDashStyle: 'solid',
	                // gridLineWidth: 0,
	
	                /**
	                 * Color for the main tick marks.
	                 * 
	                 * In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), the stroke is given in the `.highcharts-tick`
	                 * class.
	                 * 
	                 * @type {Color}
	                 * @sample {highcharts} highcharts/xaxis/tickcolor/ Red ticks on X axis
	                 * @sample {highcharts} highcharts/css/axis-grid/ Styled mode
	                 * @sample {highstock} stock/xaxis/ticks/ Formatted ticks on X axis
	                 * @sample {highstock} highcharts/css/axis-grid/ Styled mode
	                 * @default #ccd6eb
	                 * @product highcharts highstock highmaps
	                 */
	                tickColor: '#ccd6eb'
	                // tickWidth: 1
	
	            },
	
	            /**
	             * This option set extends the defaultOptions for Y axes.
	             * @extends xAxis
	             * @optionparent yAxis
	             */
	            defaultYAxisOptions: {
	
	                /**
	                 * Whether to force the axis to end on a tick. Use this option with
	                 * the `maxPadding` option to control the axis end.
	                 *
	                 * @productdesc {highstock}
	                 * In Highstock, `endOnTick` is always false when the navigator is
	                 * enabled, to prevent jumpy scrolling.
	                 * 
	                 * @type {Boolean}
	                 * @sample {highcharts} highcharts/chart/reflow-true/ True by default
	                 * @sample {highcharts} highcharts/yaxis/endontick-false/ False
	                 * @sample {highcharts} highcharts/yaxis/endontick-log-false/ False
	                 * @sample {highstock} stock/demo/basic-line/ True by default
	                 * @sample {highstock} stock/xaxis/endontick/ False
	                 * @default true
	                 * @since 1.2.0
	                 * @product highcharts highstock
	                 */
	                endOnTick: true,
	
	                /**
	                 */
	                tickPixelInterval: 72,
	
	                /**
	                 * Whether to show the last tick label. Defaults to `true` on cartesian
	                 * charts, and `false` on polar charts.
	                 * 
	                 * @type {Boolean}
	                 * @sample {highcharts} highcharts/xaxis/showlastlabel-true/ Set to true on X axis
	                 * @sample {highstock} stock/xaxis/showfirstlabel/ Labels below plot lines on Y axis
	                 * @default false
	                 * @product highcharts highstock
	                 */
	                showLastLabel: true,
	
	                /**
	                 * @extends xAxis.labels
	                 * @product highcharts highstock highmaps
	                 */
	                labels: {
	
	                    /**
	                     * The x position offset of the label relative to the tick position
	                     * on the axis. Defaults to -15 for left axis, 15 for right axis.
	                     * 
	                     * @type {Number}
	                     * @sample {highcharts} highcharts/xaxis/labels-x/ Y axis labels placed on grid lines
	                     * @default 0
	                     * @product highcharts highstock highmaps
	                     */
	                    x: -8
	                },
	
	                /**
	                 * Padding of the max value relative to the length of the axis. A
	                 * padding of 0.05 will make a 100px axis 5px longer. This is useful
	                 * when you don't want the highest data value to appear on the edge
	                 * of the plot area. When the axis' `max` option is set or a max extreme
	                 * is set using `axis.setExtremes()`, the maxPadding will be ignored.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/yaxis/maxpadding-02/ Max padding of 0.2
	                 * @sample {highstock} stock/xaxis/minpadding-maxpadding/ Greater min- and maxPadding
	                 * @default 0.05
	                 * @since 1.2.0
	                 * @product highcharts highstock
	                 */
	                maxPadding: 0.05,
	
	                /**
	                 * Padding of the min value relative to the length of the axis. A
	                 * padding of 0.05 will make a 100px axis 5px longer. This is useful
	                 * when you don't want the lowest data value to appear on the edge
	                 * of the plot area. When the axis' `min` option is set or a max extreme
	                 * is set using `axis.setExtremes()`, the maxPadding will be ignored.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/yaxis/minpadding/ Min padding of 0.2
	                 * @sample {highstock} stock/xaxis/minpadding-maxpadding/ Greater min- and maxPadding
	                 * @default 0.05
	                 * @since 1.2.0
	                 * @product highcharts highstock
	                 */
	                minPadding: 0.05,
	
	                /**
	                 * Whether to force the axis to start on a tick. Use this option with
	                 * the `maxPadding` option to control the axis start.
	                 * 
	                 * @type {Boolean}
	                 * @sample {highcharts} highcharts/xaxis/startontick-false/ False by default
	                 * @sample {highcharts} highcharts/xaxis/startontick-true/ True
	                 * @sample {highstock} stock/xaxis/endontick/ False for Y axis
	                 * @default true
	                 * @since 1.2.0
	                 * @product highcharts highstock
	                 */
	                startOnTick: true,
	
	                /**
	                 * @extends xAxis.title
	                 * @product highcharts highstock highmaps
	                 */
	                title: {
	
	                    /**
	                     * The rotation of the text in degrees. 0 is horizontal, 270 is vertical
	                     * reading from bottom to top.
	                     * 
	                     * @type {Number}
	                     * @sample {highcharts} highcharts/yaxis/title-offset/ Horizontal
	                     * @default 270
	                     * @product highcharts highstock highmaps
	                     */
	                    rotation: 270,
	
	                    /**
	                     * The actual text of the axis title. Horizontal texts can contain
	                     * HTML, but rotated texts are painted using vector techniques and
	                     * must be clean text. The Y axis title is disabled by setting the
	                     * `text` option to `null`.
	                     * 
	                     * @type {String}
	                     * @sample {highcharts} highcharts/xaxis/title-text/ Custom HTML
	                     * @default Values
	                     * @product highcharts
	                     */
	                    text: 'Values'
	                },
	
	                /**
	                 * The stack labels show the total value for each bar in a stacked
	                 * column or bar chart. The label will be placed on top of positive
	                 * columns and below negative columns. In case of an inverted column
	                 * chart or a bar chart the label is placed to the right of positive
	                 * bars and to the left of negative bars.
	                 * 
	                 * @product highcharts
	                 */
	                stackLabels: {
	
	                    /**
	                     * Allow the stack labels to overlap.
	                     * 
	                     * @type {Boolean}
	                     * @sample {highcharts} highcharts/yaxis/stacklabels-allowoverlap-false/
	                     *         Default false
	                     * @since 5.0.13
	                     * @product highcharts
	                     */
	                    allowOverlap: false,
	
	                    /**
	                     * Enable or disable the stack total labels.
	                     * 
	                     * @type {Boolean}
	                     * @sample {highcharts} highcharts/yaxis/stacklabels-enabled/ Enabled stack total labels
	                     * @since 2.1.5
	                     * @product highcharts
	                     */
	                    enabled: false,
	                    //align: dynamic,
	                    //y: dynamic,
	                    //x: dynamic,
	                    //verticalAlign: dynamic,
	                    //textAlign: dynamic,
	                    //rotation: 0,
	
	                    /**
	                     * Callback JavaScript function to format the label. The value is
	                     * given by `this.total`. Defaults to:
	                     * 
	                     * <pre>function() {
	                     * return this.total;
	                     * }</pre>
	                     * 
	                     * @type {Function}
	                     * @sample {highcharts} highcharts/yaxis/stacklabels-formatter/ Added units to stack total value
	                     * @since 2.1.5
	                     * @product highcharts
	                     */
	                    formatter: function() {
	                        return H.numberFormat(this.total, -1);
	                    },
	
	
	                    /**
	                     * CSS styles for the label.
	                     * 
	                     * In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                     * style/style-by-css), the styles are set in the `.highcharts-stack-
	                     * label` class.
	                     * 
	                     * @type {CSSObject}
	                     * @sample {highcharts} highcharts/yaxis/stacklabels-style/ Red stack total labels
	                     * @default { "color": "#000000", "fontSize": "11px", "fontWeight": "bold", "textShadow": "1px 1px contrast, -1px -1px contrast, -1px 1px contrast, 1px -1px contrast" }
	                     * @since 2.1.5
	                     * @product highcharts
	                     */
	                    style: {
	
	                        /**
	                         */
	                        fontSize: '11px',
	
	                        /**
	                         */
	                        fontWeight: 'bold',
	
	                        /**
	                         */
	                        color: '#000000',
	
	                        /**
	                         */
	                        textOutline: '1px contrast'
	                    }
	
	                },
	
	
	                /**
	                 * The width of the grid lines extending the ticks across the plot
	                 * area.
	                 * 
	                 * @productdesc {highmaps}
	                 * In Highmaps, the grid lines are hidden by default.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/yaxis/gridlinewidth/ 2px lines
	                 * @sample {highstock} stock/xaxis/gridlinewidth/ 2px lines
	                 * @default 1
	                 * @product highcharts highstock
	                 */
	                gridLineWidth: 1,
	
	                /**
	                 * The width of the line marking the axis itself.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/yaxis/linecolor/ A 1px line on Y axis
	                 * @sample {highstock} stock/xaxis/linewidth/ A 2px line on X axis
	                 * @default 0
	                 * @product highcharts highstock
	                 */
	                lineWidth: 0
	                // tickWidth: 0
	
	            },
	
	            /**
	             * These options extend the defaultOptions for left axes.
	             * 
	             * @private
	             * @type {Object}
	             */
	            defaultLeftAxisOptions: {
	                labels: {
	                    x: -15
	                },
	                title: {
	                    rotation: 270
	                }
	            },
	
	            /**
	             * These options extend the defaultOptions for right axes.
	             *
	             * @private
	             * @type {Object}
	             */
	            defaultRightAxisOptions: {
	                labels: {
	                    x: 15
	                },
	                title: {
	                    rotation: 90
	                }
	            },
	
	            /**
	             * These options extend the defaultOptions for bottom axes.
	             *
	             * @private
	             * @type {Object}
	             */
	            defaultBottomAxisOptions: {
	                labels: {
	                    autoRotation: [-45],
	                    x: 0
	                    // overflow: undefined,
	                    // staggerLines: null
	                },
	                title: {
	                    rotation: 0
	                }
	            },
	            /**
	             * These options extend the defaultOptions for top axes.
	             *
	             * @private
	             * @type {Object}
	             */
	            defaultTopAxisOptions: {
	                labels: {
	                    autoRotation: [-45],
	                    x: 0
	                    // overflow: undefined
	                    // staggerLines: null
	                },
	                title: {
	                    rotation: 0
	                }
	            },
	
	            /**
	             * Overrideable function to initialize the axis. 
	             *
	             * @see {@link Axis}
	             */
	            init: function(chart, userOptions) {
	
	
	                var isXAxis = userOptions.isX,
	                    axis = this;
	
	
	                /**
	                 * The Chart that the axis belongs to.
	                 *
	                 * @name chart
	                 * @memberOf Axis
	                 * @type {Chart}
	                 */
	                axis.chart = chart;
	
	                /**
	                 * Whether the axis is horizontal.
	                 *
	                 * @name horiz
	                 * @memberOf Axis
	                 * @type {Boolean}
	                 */
	                axis.horiz = chart.inverted && !axis.isZAxis ? !isXAxis : isXAxis;
	
	                // Flag, isXAxis
	                axis.isXAxis = isXAxis;
	
	                /**
	                 * The collection where the axis belongs, for example `xAxis`, `yAxis`
	                 * or `colorAxis`. Corresponds to properties on Chart, for example
	                 * {@link Chart.xAxis}.
	                 *
	                 * @name coll
	                 * @memberOf Axis
	                 * @type {String}
	                 */
	                axis.coll = axis.coll || (isXAxis ? 'xAxis' : 'yAxis');
	
	
	                axis.opposite = userOptions.opposite; // needed in setOptions
	
	                /**
	                 * The side on which the axis is rendered. 0 is top, 1 is right, 2 is
	                 * bottom and 3 is left.
	                 *
	                 * @name side
	                 * @memberOf Axis
	                 * @type {Number}
	                 */
	                axis.side = userOptions.side || (axis.horiz ?
	                    (axis.opposite ? 0 : 2) : // top : bottom
	                    (axis.opposite ? 1 : 3)); // right : left
	
	                axis.setOptions(userOptions);
	
	
	                var options = this.options,
	                    type = options.type,
	                    isDatetimeAxis = type === 'datetime';
	
	                axis.labelFormatter = options.labels.formatter ||
	                    axis.defaultLabelFormatter; // can be overwritten by dynamic format
	
	
	                // Flag, stagger lines or not
	                axis.userOptions = userOptions;
	
	                //axis.axisTitleMargin = undefined,// = options.title.margin,
	                axis.minPixelPadding = 0;
	
	
	                /**
	                 * Whether the axis is reversed. Based on the `axis.reversed`,
	                 * option, but inverted charts have reversed xAxis by default.
	                 *
	                 * @name reversed
	                 * @memberOf Axis
	                 * @type {Boolean}
	                 */
	                axis.reversed = options.reversed;
	                axis.visible = options.visible !== false;
	                axis.zoomEnabled = options.zoomEnabled !== false;
	
	                // Initial categories
	                axis.hasNames = type === 'category' || options.categories === true;
	                axis.categories = options.categories || axis.hasNames;
	                axis.names = axis.names || []; // Preserve on update (#3830)
	
	                // Elements
	                //axis.axisGroup = undefined;
	                //axis.gridGroup = undefined;
	                //axis.axisTitle = undefined;
	                //axis.axisLine = undefined;
	
	                // Placeholder for plotlines and plotbands groups
	                axis.plotLinesAndBandsGroups = {};
	
	                // Shorthand types
	                axis.isLog = type === 'logarithmic';
	                axis.isDatetimeAxis = isDatetimeAxis;
	                axis.positiveValuesOnly = axis.isLog && !axis.allowNegativeLog;
	
	                // Flag, if axis is linked to another axis
	                axis.isLinked = defined(options.linkedTo);
	                // Linked axis.
	                //axis.linkedParent = undefined;
	
	                // Major ticks
	                axis.ticks = {};
	                axis.labelEdge = [];
	                // Minor ticks
	                axis.minorTicks = {};
	
	                // List of plotLines/Bands
	                axis.plotLinesAndBands = [];
	
	                // Alternate bands
	                axis.alternateBands = {};
	
	                // Axis metrics
	                //axis.left = undefined;
	                //axis.top = undefined;
	                //axis.width = undefined;
	                //axis.height = undefined;
	                //axis.bottom = undefined;
	                //axis.right = undefined;
	                //axis.transA = undefined;
	                //axis.transB = undefined;
	                //axis.oldTransA = undefined;
	                axis.len = 0;
	                //axis.oldMin = undefined;
	                //axis.oldMax = undefined;
	                //axis.oldUserMin = undefined;
	                //axis.oldUserMax = undefined;
	                //axis.oldAxisLength = undefined;
	                axis.minRange = axis.userMinRange = options.minRange || options.maxZoom;
	                axis.range = options.range;
	                axis.offset = options.offset || 0;
	
	
	                // Dictionary for stacks
	                axis.stacks = {};
	                axis.oldStacks = {};
	                axis.stacksTouched = 0;
	
	                // Min and max in the data
	                //axis.dataMin = undefined,
	                //axis.dataMax = undefined,
	
	                /**
	                 * The maximum value of the axis. In a logarithmic axis, this is the
	                 * logarithm of the real value, and the real value can be obtained from
	                 * {@link Axis#getExtremes}.
	                 *
	                 * @name max
	                 * @memberOf Axis
	                 * @type {Number}
	                 */
	                axis.max = null;
	                /**
	                 * The minimum value of the axis. In a logarithmic axis, this is the
	                 * logarithm of the real value, and the real value can be obtained from
	                 * {@link Axis#getExtremes}.
	                 *
	                 * @name min
	                 * @memberOf Axis
	                 * @type {Number}
	                 */
	                axis.min = null;
	
	                // User set min and max
	                //axis.userMin = undefined,
	                //axis.userMax = undefined,
	
	                /**
	                 * The processed crosshair options.
	                 *
	                 * @name crosshair
	                 * @memberOf Axis
	                 * @type {AxisCrosshairOptions}
	                 */
	                axis.crosshair = pick(
	                    options.crosshair,
	                    splat(chart.options.tooltip.crosshairs)[isXAxis ? 0 : 1],
	                    false
	                );
	
	                var events = axis.options.events;
	
	                // Register. Don't add it again on Axis.update().
	                if (inArray(axis, chart.axes) === -1) { // 
	                    if (isXAxis) { // #2713
	                        chart.axes.splice(chart.xAxis.length, 0, axis);
	                    } else {
	                        chart.axes.push(axis);
	                    }
	
	                    chart[axis.coll].push(axis);
	                }
	
	                /**
	                 * All series associated to the axis.
	                 *
	                 * @name series
	                 * @memberOf Axis
	                 * @type {Array.<Series>}
	                 */
	                axis.series = axis.series || []; // populated by Series
	
	                // Reversed axis
	                if (
	                    chart.inverted &&
	                    !axis.isZAxis &&
	                    isXAxis &&
	                    axis.reversed === undefined
	                ) {
	                    axis.reversed = true;
	                }
	
	                // register event listeners
	                objectEach(events, function(event, eventType) {
	                    addEvent(axis, eventType, event);
	                });
	
	                // extend logarithmic axis
	                axis.lin2log = options.linearToLogConverter || axis.lin2log;
	                if (axis.isLog) {
	                    axis.val2lin = axis.log2lin;
	                    axis.lin2val = axis.lin2log;
	                }
	            },
	
	            /**
	             * Merge and set options.
	             *
	             * @private
	             */
	            setOptions: function(userOptions) {
	                this.options = merge(
	                    this.defaultOptions,
	                    this.coll === 'yAxis' && this.defaultYAxisOptions, [
	                        this.defaultTopAxisOptions,
	                        this.defaultRightAxisOptions,
	                        this.defaultBottomAxisOptions,
	                        this.defaultLeftAxisOptions
	                    ][this.side],
	                    merge(
	                        defaultOptions[this.coll], // if set in setOptions (#1053)
	                        userOptions
	                    )
	                );
	            },
	
	            /**
	             * The default label formatter. The context is a special config object for
	             * the label. In apps, use the {@link
	             * https://api.highcharts.com/highcharts/xAxis.labels.formatter|
	             * labels.formatter} instead except when a modification is needed.
	             *
	             * @private
	             */
	            defaultLabelFormatter: function() {
	                var axis = this.axis,
	                    value = this.value,
	                    categories = axis.categories,
	                    dateTimeLabelFormat = this.dateTimeLabelFormat,
	                    lang = defaultOptions.lang,
	                    numericSymbols = lang.numericSymbols,
	                    numSymMagnitude = lang.numericSymbolMagnitude || 1000,
	                    i = numericSymbols && numericSymbols.length,
	                    multi,
	                    ret,
	                    formatOption = axis.options.labels.format,
	
	                    // make sure the same symbol is added for all labels on a linear
	                    // axis
	                    numericSymbolDetector = axis.isLog ?
	                    Math.abs(value) :
	                    axis.tickInterval;
	
	                if (formatOption) {
	                    ret = format(formatOption, this);
	
	                } else if (categories) {
	                    ret = value;
	
	                } else if (dateTimeLabelFormat) { // datetime axis
	                    ret = H.dateFormat(dateTimeLabelFormat, value);
	
	                } else if (i && numericSymbolDetector >= 1000) {
	                    // Decide whether we should add a numeric symbol like k (thousands)
	                    // or M (millions). If we are to enable this in tooltip or other
	                    // places as well, we can move this logic to the numberFormatter and
	                    // enable it by a parameter.
	                    while (i-- && ret === undefined) {
	                        multi = Math.pow(numSymMagnitude, i + 1);
	                        if (
	                            numericSymbolDetector >= multi &&
	                            (value * 10) % multi === 0 &&
	                            numericSymbols[i] !== null &&
	                            value !== 0
	                        ) { // #5480
	                            ret = H.numberFormat(value / multi, -1) + numericSymbols[i];
	                        }
	                    }
	                }
	
	                if (ret === undefined) {
	                    if (Math.abs(value) >= 10000) { // add thousands separators
	                        ret = H.numberFormat(value, -1);
	                    } else { // small numbers
	                        ret = H.numberFormat(value, -1, undefined, ''); // #2466
	                    }
	                }
	
	                return ret;
	            },
	
	            /**
	             * Get the minimum and maximum for the series of each axis. The function
	             * analyzes the axis series and updates `this.dataMin` and `this.dataMax`.
	             *
	             * @private
	             */
	            getSeriesExtremes: function() {
	                var axis = this,
	                    chart = axis.chart;
	                axis.hasVisibleSeries = false;
	
	                // Reset properties in case we're redrawing (#3353)
	                axis.dataMin = axis.dataMax = axis.threshold = null;
	                axis.softThreshold = !axis.isXAxis;
	
	                if (axis.buildStacks) {
	                    axis.buildStacks();
	                }
	
	                // loop through this axis' series
	                each(axis.series, function(series) {
	
	                    if (series.visible || !chart.options.chart.ignoreHiddenSeries) {
	
	                        var seriesOptions = series.options,
	                            xData,
	                            threshold = seriesOptions.threshold,
	                            seriesDataMin,
	                            seriesDataMax;
	
	                        axis.hasVisibleSeries = true;
	
	                        // Validate threshold in logarithmic axes
	                        if (axis.positiveValuesOnly && threshold <= 0) {
	                            threshold = null;
	                        }
	
	                        // Get dataMin and dataMax for X axes
	                        if (axis.isXAxis) {
	                            xData = series.xData;
	                            if (xData.length) {
	                                // If xData contains values which is not numbers, then
	                                // filter them out. To prevent performance hit, we only
	                                // do this after we have already found seriesDataMin
	                                // because in most cases all data is valid. #5234.
	                                seriesDataMin = arrayMin(xData);
	                                if (!isNumber(seriesDataMin) &&
	                                    !(seriesDataMin instanceof Date) // #5010
	                                ) {
	                                    xData = grep(xData, function(x) {
	                                        return isNumber(x);
	                                    });
	                                    seriesDataMin = arrayMin(xData); // Do it again with valid data
	                                }
	
	                                axis.dataMin = Math.min(
	                                    pick(axis.dataMin, xData[0]),
	                                    seriesDataMin
	                                );
	                                axis.dataMax = Math.max(
	                                    pick(axis.dataMax, xData[0]),
	                                    arrayMax(xData)
	                                );
	
	                            }
	
	                            // Get dataMin and dataMax for Y axes, as well as handle
	                            // stacking and processed data
	                        } else {
	
	                            // Get this particular series extremes
	                            series.getExtremes();
	                            seriesDataMax = series.dataMax;
	                            seriesDataMin = series.dataMin;
	
	                            // Get the dataMin and dataMax so far. If percentage is
	                            // used, the min and max are always 0 and 100. If
	                            // seriesDataMin and seriesDataMax is null, then series
	                            // doesn't have active y data, we continue with nulls
	                            if (defined(seriesDataMin) && defined(seriesDataMax)) {
	                                axis.dataMin = Math.min(
	                                    pick(axis.dataMin, seriesDataMin),
	                                    seriesDataMin
	                                );
	                                axis.dataMax = Math.max(
	                                    pick(axis.dataMax, seriesDataMax),
	                                    seriesDataMax
	                                );
	                            }
	
	                            // Adjust to threshold
	                            if (defined(threshold)) {
	                                axis.threshold = threshold;
	                            }
	                            // If any series has a hard threshold, it takes precedence
	                            if (!seriesOptions.softThreshold ||
	                                axis.positiveValuesOnly
	                            ) {
	                                axis.softThreshold = false;
	                            }
	                        }
	                    }
	                });
	            },
	
	            /**
	             * Translate from axis value to pixel position on the chart, or back. Use
	             * the `toPixels` and `toValue` functions in applications.
	             *
	             * @private
	             */
	            translate: function(val, backwards, cvsCoord, old, handleLog, pointPlacement) {
	                var axis = this.linkedParent || this, // #1417
	                    sign = 1,
	                    cvsOffset = 0,
	                    localA = old ? axis.oldTransA : axis.transA,
	                    localMin = old ? axis.oldMin : axis.min,
	                    returnValue,
	                    minPixelPadding = axis.minPixelPadding,
	                    doPostTranslate = (axis.isOrdinal || axis.isBroken || (axis.isLog && handleLog)) && axis.lin2val;
	
	                if (!localA) {
	                    localA = axis.transA;
	                }
	
	                // In vertical axes, the canvas coordinates start from 0 at the top like in
	                // SVG.
	                if (cvsCoord) {
	                    sign *= -1; // canvas coordinates inverts the value
	                    cvsOffset = axis.len;
	                }
	
	                // Handle reversed axis
	                if (axis.reversed) {
	                    sign *= -1;
	                    cvsOffset -= sign * (axis.sector || axis.len);
	                }
	
	                // From pixels to value
	                if (backwards) { // reverse translation
	
	                    val = val * sign + cvsOffset;
	                    val -= minPixelPadding;
	                    returnValue = val / localA + localMin; // from chart pixel to value
	                    if (doPostTranslate) { // log and ordinal axes
	                        returnValue = axis.lin2val(returnValue);
	                    }
	
	                    // From value to pixels
	                } else {
	                    if (doPostTranslate) { // log and ordinal axes
	                        val = axis.val2lin(val);
	                    }
	                    returnValue = sign * (val - localMin) * localA + cvsOffset +
	                        (sign * minPixelPadding) +
	                        (isNumber(pointPlacement) ? localA * pointPlacement : 0);
	                }
	
	                return returnValue;
	            },
	
	            /**
	             * Translate a value in terms of axis units into pixels within the chart.
	             * 
	             * @param  {Number} value
	             *         A value in terms of axis units.
	             * @param  {Boolean} paneCoordinates
	             *         Whether to return the pixel coordinate relative to the chart or
	             *         just the axis/pane itself.
	             * @return {Number} Pixel position of the value on the chart or axis.
	             */
	            toPixels: function(value, paneCoordinates) {
	                return this.translate(value, false, !this.horiz, null, true) +
	                    (paneCoordinates ? 0 : this.pos);
	            },
	
	            /**
	             * Translate a pixel position along the axis to a value in terms of axis
	             * units.
	             * @param  {Number} pixel
	             *         The pixel value coordinate.
	             * @param  {Boolean} paneCoordiantes
	             *         Whether the input pixel is relative to the chart or just the
	             *         axis/pane itself.
	             * @return {Number} The axis value.
	             */
	            toValue: function(pixel, paneCoordinates) {
	                return this.translate(
	                    pixel - (paneCoordinates ? 0 : this.pos),
	                    true, !this.horiz,
	                    null,
	                    true
	                );
	            },
	
	            /**
	             * Create the path for a plot line that goes from the given value on
	             * this axis, across the plot to the opposite side. Also used internally for
	             * grid lines and crosshairs.
	             * 
	             * @param  {Number} value
	             *         Axis value.
	             * @param  {Number} [lineWidth=1]
	             *         Used for calculation crisp line coordinates.
	             * @param  {Boolean} [old=false]
	             *         Use old coordinates (for resizing and rescaling).
	             * @param  {Boolean} [force=false]
	             *         If `false`, the function will return null when it falls outside
	             *         the axis bounds.
	             * @param  {Number} [translatedValue]
	             *         If given, return the plot line path of a pixel position on the
	             *         axis.
	             *
	             * @return {Array.<String|Number>}
	             *         The SVG path definition for the plot line.
	             */
	            getPlotLinePath: function(value, lineWidth, old, force, translatedValue) {
	                var axis = this,
	                    chart = axis.chart,
	                    axisLeft = axis.left,
	                    axisTop = axis.top,
	                    x1,
	                    y1,
	                    x2,
	                    y2,
	                    cHeight = (old && chart.oldChartHeight) || chart.chartHeight,
	                    cWidth = (old && chart.oldChartWidth) || chart.chartWidth,
	                    skip,
	                    transB = axis.transB,
	                    /**
	                     * Check if x is between a and b. If not, either move to a/b or skip,
	                     * depending on the force parameter.
	                     */
	                    between = function(x, a, b) {
	                        if (x < a || x > b) {
	                            if (force) {
	                                x = Math.min(Math.max(a, x), b);
	                            } else {
	                                skip = true;
	                            }
	                        }
	                        return x;
	                    };
	
	                translatedValue = pick(translatedValue, axis.translate(value, null, null, old));
	                x1 = x2 = Math.round(translatedValue + transB);
	                y1 = y2 = Math.round(cHeight - translatedValue - transB);
	                if (!isNumber(translatedValue)) { // no min or max
	                    skip = true;
	
	                } else if (axis.horiz) {
	                    y1 = axisTop;
	                    y2 = cHeight - axis.bottom;
	                    x1 = x2 = between(x1, axisLeft, axisLeft + axis.width);
	                } else {
	                    x1 = axisLeft;
	                    x2 = cWidth - axis.right;
	                    y1 = y2 = between(y1, axisTop, axisTop + axis.height);
	                }
	                return skip && !force ?
	                    null :
	                    chart.renderer.crispLine(['M', x1, y1, 'L', x2, y2], lineWidth || 1);
	            },
	
	            /**
	             * Internal function to et the tick positions of a linear axis to round
	             * values like whole tens or every five.
	             *
	             * @param  {Number} tickInterval
	             *         The normalized tick interval
	             * @param  {Number} min
	             *         Axis minimum.
	             * @param  {Number} max
	             *         Axis maximum.
	             *
	             * @return {Array.<Number>}
	             *         An array of axis values where ticks should be placed.
	             */
	            getLinearTickPositions: function(tickInterval, min, max) {
	                var pos,
	                    lastPos,
	                    roundedMin = correctFloat(Math.floor(min / tickInterval) * tickInterval),
	                    roundedMax = correctFloat(Math.ceil(max / tickInterval) * tickInterval),
	                    tickPositions = [];
	
	                // For single points, add a tick regardless of the relative position
	                // (#2662, #6274)
	                if (this.single) {
	                    return [min];
	                }
	
	                // Populate the intermediate values
	                pos = roundedMin;
	                while (pos <= roundedMax) {
	
	                    // Place the tick on the rounded value
	                    tickPositions.push(pos);
	
	                    // Always add the raw tickInterval, not the corrected one.
	                    pos = correctFloat(pos + tickInterval);
	
	                    // If the interval is not big enough in the current min - max range to actually increase
	                    // the loop variable, we need to break out to prevent endless loop. Issue #619
	                    if (pos === lastPos) {
	                        break;
	                    }
	
	                    // Record the last value
	                    lastPos = pos;
	                }
	                return tickPositions;
	            },
	
	            /**
	             * Internal function to return the minor tick positions. For logarithmic
	             * axes, the same logic as for major ticks is reused.
	             *
	             * @return {Array.<Number>}
	             *         An array of axis values where ticks should be placed.
	             */
	            getMinorTickPositions: function() {
	                var axis = this,
	                    options = axis.options,
	                    tickPositions = axis.tickPositions,
	                    minorTickInterval = axis.minorTickInterval,
	                    minorTickPositions = [],
	                    pos,
	                    pointRangePadding = axis.pointRangePadding || 0,
	                    min = axis.min - pointRangePadding, // #1498
	                    max = axis.max + pointRangePadding, // #1498
	                    range = max - min;
	
	                // If minor ticks get too dense, they are hard to read, and may cause long running script. So we don't draw them.
	                if (range && range / minorTickInterval < axis.len / 3) { // #3875
	
	                    if (axis.isLog) {
	                        // For each interval in the major ticks, compute the minor ticks
	                        // separately.
	                        each(this.paddedTicks, function(pos, i, paddedTicks) {
	                            if (i) {
	                                minorTickPositions.push.apply(
	                                    minorTickPositions,
	                                    axis.getLogTickPositions(
	                                        minorTickInterval,
	                                        paddedTicks[i - 1],
	                                        paddedTicks[i],
	                                        true
	                                    )
	                                );
	                            }
	                        });
	
	                    } else if (axis.isDatetimeAxis && options.minorTickInterval === 'auto') { // #1314
	                        minorTickPositions = minorTickPositions.concat(
	                            axis.getTimeTicks(
	                                axis.normalizeTimeTickInterval(minorTickInterval),
	                                min,
	                                max,
	                                options.startOfWeek
	                            )
	                        );
	                    } else {
	                        for (
	                            pos = min + (tickPositions[0] - min) % minorTickInterval; pos <= max; pos += minorTickInterval
	                        ) {
	                            // Very, very, tight grid lines (#5771)
	                            if (pos === minorTickPositions[0]) {
	                                break;
	                            }
	                            minorTickPositions.push(pos);
	                        }
	                    }
	                }
	
	                if (minorTickPositions.length !== 0) {
	                    axis.trimTicks(minorTickPositions); // #3652 #3743 #1498 #6330
	                }
	                return minorTickPositions;
	            },
	
	            /**
	             * Adjust the min and max for the minimum range. Keep in mind that the series data is
	             * not yet processed, so we don't have information on data cropping and grouping, or
	             * updated axis.pointRange or series.pointRange. The data can't be processed until
	             * we have finally established min and max.
	             *
	             * @private
	             */
	            adjustForMinRange: function() {
	                var axis = this,
	                    options = axis.options,
	                    min = axis.min,
	                    max = axis.max,
	                    zoomOffset,
	                    spaceAvailable,
	                    closestDataRange,
	                    i,
	                    distance,
	                    xData,
	                    loopLength,
	                    minArgs,
	                    maxArgs,
	                    minRange;
	
	                // Set the automatic minimum range based on the closest point distance
	                if (axis.isXAxis && axis.minRange === undefined && !axis.isLog) {
	
	                    if (defined(options.min) || defined(options.max)) {
	                        axis.minRange = null; // don't do this again
	
	                    } else {
	
	                        // Find the closest distance between raw data points, as opposed to
	                        // closestPointRange that applies to processed points (cropped and grouped)
	                        each(axis.series, function(series) {
	                            xData = series.xData;
	                            loopLength = series.xIncrement ? 1 : xData.length - 1;
	                            for (i = loopLength; i > 0; i--) {
	                                distance = xData[i] - xData[i - 1];
	                                if (closestDataRange === undefined || distance < closestDataRange) {
	                                    closestDataRange = distance;
	                                }
	                            }
	                        });
	                        axis.minRange = Math.min(closestDataRange * 5, axis.dataMax - axis.dataMin);
	                    }
	                }
	
	                // if minRange is exceeded, adjust
	                if (max - min < axis.minRange) {
	
	                    spaceAvailable = axis.dataMax - axis.dataMin >= axis.minRange;
	                    minRange = axis.minRange;
	                    zoomOffset = (minRange - max + min) / 2;
	
	                    // if min and max options have been set, don't go beyond it
	                    minArgs = [min - zoomOffset, pick(options.min, min - zoomOffset)];
	                    if (spaceAvailable) { // if space is available, stay within the data range
	                        minArgs[2] = axis.isLog ? axis.log2lin(axis.dataMin) : axis.dataMin;
	                    }
	                    min = arrayMax(minArgs);
	
	                    maxArgs = [min + minRange, pick(options.max, min + minRange)];
	                    if (spaceAvailable) { // if space is availabe, stay within the data range
	                        maxArgs[2] = axis.isLog ? axis.log2lin(axis.dataMax) : axis.dataMax;
	                    }
	
	                    max = arrayMin(maxArgs);
	
	                    // now if the max is adjusted, adjust the min back
	                    if (max - min < minRange) {
	                        minArgs[0] = max - minRange;
	                        minArgs[1] = pick(options.min, max - minRange);
	                        min = arrayMax(minArgs);
	                    }
	                }
	
	                // Record modified extremes
	                axis.min = min;
	                axis.max = max;
	            },
	
	            /**
	             * Find the closestPointRange across all series.
	             *
	             * @private
	             */
	            getClosest: function() {
	                var ret;
	
	                if (this.categories) {
	                    ret = 1;
	                } else {
	                    each(this.series, function(series) {
	                        var seriesClosest = series.closestPointRange,
	                            visible = series.visible ||
	                            !series.chart.options.chart.ignoreHiddenSeries;
	
	                        if (!series.noSharedTooltip &&
	                            defined(seriesClosest) &&
	                            visible
	                        ) {
	                            ret = defined(ret) ?
	                                Math.min(ret, seriesClosest) :
	                                seriesClosest;
	                        }
	                    });
	                }
	                return ret;
	            },
	
	            /**
	             * When a point name is given and no x, search for the name in the existing
	             * categories, or if categories aren't provided, search names or create a
	             * new category (#2522).
	             *
	             * @private
	             *
	             * @param  {Point}
	             *         The point to inspect.
	             *
	             * @return {Number}
	             *         The X value that the point is given.
	             */
	            nameToX: function(point) {
	                var explicitCategories = isArray(this.categories),
	                    names = explicitCategories ? this.categories : this.names,
	                    nameX = point.options.x,
	                    x;
	
	                point.series.requireSorting = false;
	
	                if (!defined(nameX)) {
	                    nameX = this.options.uniqueNames === false ?
	                        point.series.autoIncrement() :
	                        inArray(point.name, names);
	                }
	                if (nameX === -1) { // The name is not found in currenct categories
	                    if (!explicitCategories) {
	                        x = names.length;
	                    }
	                } else {
	                    x = nameX;
	                }
	
	                // Write the last point's name to the names array
	                if (x !== undefined) {
	                    this.names[x] = point.name;
	                }
	
	                return x;
	            },
	
	            /**
	             * When changes have been done to series data, update the axis.names.
	             *
	             * @private
	             */
	            updateNames: function() {
	                var axis = this;
	
	                if (this.names.length > 0) {
	                    this.names.length = 0;
	                    this.minRange = this.userMinRange; // Reset
	                    each(this.series || [], function(series) {
	
	                        // Reset incrementer (#5928)
	                        series.xIncrement = null;
	
	                        // When adding a series, points are not yet generated
	                        if (!series.points || series.isDirtyData) {
	                            series.processData();
	                            series.generatePoints();
	                        }
	
	                        each(series.points, function(point, i) {
	                            var x;
	                            if (point.options) {
	                                x = axis.nameToX(point);
	                                if (x !== undefined && x !== point.x) {
	                                    point.x = x;
	                                    series.xData[i] = x;
	                                }
	                            }
	                        });
	                    });
	                }
	            },
	
	            /**
	             * Update translation information.
	             *
	             * @private
	             */
	            setAxisTranslation: function(saveOld) {
	                var axis = this,
	                    range = axis.max - axis.min,
	                    pointRange = axis.axisPointRange || 0,
	                    closestPointRange,
	                    minPointOffset = 0,
	                    pointRangePadding = 0,
	                    linkedParent = axis.linkedParent,
	                    ordinalCorrection,
	                    hasCategories = !!axis.categories,
	                    transA = axis.transA,
	                    isXAxis = axis.isXAxis;
	
	                // Adjust translation for padding. Y axis with categories need to go through the same (#1784).
	                if (isXAxis || hasCategories || pointRange) {
	
	                    // Get the closest points
	                    closestPointRange = axis.getClosest();
	
	                    if (linkedParent) {
	                        minPointOffset = linkedParent.minPointOffset;
	                        pointRangePadding = linkedParent.pointRangePadding;
	                    } else {
	                        each(axis.series, function(series) {
	                            var seriesPointRange = hasCategories ?
	                                1 :
	                                (isXAxis ?
	                                    pick(series.options.pointRange, closestPointRange, 0) :
	                                    (axis.axisPointRange || 0)), // #2806
	                                pointPlacement = series.options.pointPlacement;
	
	                            pointRange = Math.max(pointRange, seriesPointRange);
	
	                            if (!axis.single) {
	                                // minPointOffset is the value padding to the left of the axis in order to make
	                                // room for points with a pointRange, typically columns. When the pointPlacement option
	                                // is 'between' or 'on', this padding does not apply.
	                                minPointOffset = Math.max(
	                                    minPointOffset,
	                                    isString(pointPlacement) ? 0 : seriesPointRange / 2
	                                );
	
	                                // Determine the total padding needed to the length of the axis to make room for the
	                                // pointRange. If the series' pointPlacement is 'on', no padding is added.
	                                pointRangePadding = Math.max(
	                                    pointRangePadding,
	                                    pointPlacement === 'on' ? 0 : seriesPointRange
	                                );
	                            }
	                        });
	                    }
	
	                    // Record minPointOffset and pointRangePadding
	                    ordinalCorrection = axis.ordinalSlope && closestPointRange ? axis.ordinalSlope / closestPointRange : 1; // #988, #1853
	                    axis.minPointOffset = minPointOffset = minPointOffset * ordinalCorrection;
	                    axis.pointRangePadding = pointRangePadding = pointRangePadding * ordinalCorrection;
	
	                    // pointRange means the width reserved for each point, like in a column chart
	                    axis.pointRange = Math.min(pointRange, range);
	
	                    // closestPointRange means the closest distance between points. In columns
	                    // it is mostly equal to pointRange, but in lines pointRange is 0 while closestPointRange
	                    // is some other value
	                    if (isXAxis) {
	                        axis.closestPointRange = closestPointRange;
	                    }
	                }
	
	                // Secondary values
	                if (saveOld) {
	                    axis.oldTransA = transA;
	                }
	                axis.translationSlope = axis.transA = transA =
	                    axis.options.staticScale ||
	                    axis.len / ((range + pointRangePadding) || 1);
	                axis.transB = axis.horiz ? axis.left : axis.bottom; // translation addend
	                axis.minPixelPadding = transA * minPointOffset;
	            },
	
	            minFromRange: function() {
	                return this.max - this.range;
	            },
	
	            /**
	             * Set the tick positions to round values and optionally extend the extremes
	             * to the nearest tick.
	             *
	             * @private
	             */
	            setTickInterval: function(secondPass) {
	                var axis = this,
	                    chart = axis.chart,
	                    options = axis.options,
	                    isLog = axis.isLog,
	                    log2lin = axis.log2lin,
	                    isDatetimeAxis = axis.isDatetimeAxis,
	                    isXAxis = axis.isXAxis,
	                    isLinked = axis.isLinked,
	                    maxPadding = options.maxPadding,
	                    minPadding = options.minPadding,
	                    length,
	                    linkedParentExtremes,
	                    tickIntervalOption = options.tickInterval,
	                    minTickInterval,
	                    tickPixelIntervalOption = options.tickPixelInterval,
	                    categories = axis.categories,
	                    threshold = axis.threshold,
	                    softThreshold = axis.softThreshold,
	                    thresholdMin,
	                    thresholdMax,
	                    hardMin,
	                    hardMax;
	
	                if (!isDatetimeAxis && !categories && !isLinked) {
	                    this.getTickAmount();
	                }
	
	                // Min or max set either by zooming/setExtremes or initial options
	                hardMin = pick(axis.userMin, options.min);
	                hardMax = pick(axis.userMax, options.max);
	
	                // Linked axis gets the extremes from the parent axis
	                if (isLinked) {
	                    axis.linkedParent = chart[axis.coll][options.linkedTo];
	                    linkedParentExtremes = axis.linkedParent.getExtremes();
	                    axis.min = pick(linkedParentExtremes.min, linkedParentExtremes.dataMin);
	                    axis.max = pick(linkedParentExtremes.max, linkedParentExtremes.dataMax);
	                    if (options.type !== axis.linkedParent.options.type) {
	                        H.error(11, 1); // Can't link axes of different type
	                    }
	
	                    // Initial min and max from the extreme data values
	                } else {
	
	                    // Adjust to hard threshold
	                    if (!softThreshold && defined(threshold)) {
	                        if (axis.dataMin >= threshold) {
	                            thresholdMin = threshold;
	                            minPadding = 0;
	                        } else if (axis.dataMax <= threshold) {
	                            thresholdMax = threshold;
	                            maxPadding = 0;
	                        }
	                    }
	
	                    axis.min = pick(hardMin, thresholdMin, axis.dataMin);
	                    axis.max = pick(hardMax, thresholdMax, axis.dataMax);
	
	                }
	
	                if (isLog) {
	                    if (
	                        axis.positiveValuesOnly &&
	                        !secondPass &&
	                        Math.min(axis.min, pick(axis.dataMin, axis.min)) <= 0
	                    ) { // #978
	                        H.error(10, 1); // Can't plot negative values on log axis
	                    }
	                    // The correctFloat cures #934, float errors on full tens. But it
	                    // was too aggressive for #4360 because of conversion back to lin,
	                    // therefore use precision 15.
	                    axis.min = correctFloat(log2lin(axis.min), 15);
	                    axis.max = correctFloat(log2lin(axis.max), 15);
	                }
	
	                // handle zoomed range
	                if (axis.range && defined(axis.max)) {
	                    axis.userMin = axis.min = hardMin = Math.max(axis.dataMin, axis.minFromRange()); // #618, #6773
	                    axis.userMax = hardMax = axis.max;
	
	                    axis.range = null; // don't use it when running setExtremes
	                }
	
	                // Hook for Highstock Scroller. Consider combining with beforePadding.
	                fireEvent(axis, 'foundExtremes');
	
	                // Hook for adjusting this.min and this.max. Used by bubble series.
	                if (axis.beforePadding) {
	                    axis.beforePadding();
	                }
	
	                // adjust min and max for the minimum range
	                axis.adjustForMinRange();
	
	                // Pad the values to get clear of the chart's edges. To avoid tickInterval taking the padding
	                // into account, we do this after computing tick interval (#1337).
	                if (!categories && !axis.axisPointRange && !axis.usePercentage && !isLinked && defined(axis.min) && defined(axis.max)) {
	                    length = axis.max - axis.min;
	                    if (length) {
	                        if (!defined(hardMin) && minPadding) {
	                            axis.min -= length * minPadding;
	                        }
	                        if (!defined(hardMax) && maxPadding) {
	                            axis.max += length * maxPadding;
	                        }
	                    }
	                }
	
	                // Handle options for floor, ceiling, softMin and softMax (#6359)
	                if (isNumber(options.softMin)) {
	                    axis.min = Math.min(axis.min, options.softMin);
	                }
	                if (isNumber(options.softMax)) {
	                    axis.max = Math.max(axis.max, options.softMax);
	                }
	                if (isNumber(options.floor)) {
	                    axis.min = Math.max(axis.min, options.floor);
	                }
	                if (isNumber(options.ceiling)) {
	                    axis.max = Math.min(axis.max, options.ceiling);
	                }
	
	
	                // When the threshold is soft, adjust the extreme value only if
	                // the data extreme and the padded extreme land on either side of the threshold. For example,
	                // a series of [0, 1, 2, 3] would make the yAxis add a tick for -1 because of the
	                // default minPadding and startOnTick options. This is prevented by the softThreshold
	                // option.
	                if (softThreshold && defined(axis.dataMin)) {
	                    threshold = threshold || 0;
	                    if (!defined(hardMin) && axis.min < threshold && axis.dataMin >= threshold) {
	                        axis.min = threshold;
	                    } else if (!defined(hardMax) && axis.max > threshold && axis.dataMax <= threshold) {
	                        axis.max = threshold;
	                    }
	                }
	
	
	                // get tickInterval
	                if (axis.min === axis.max || axis.min === undefined || axis.max === undefined) {
	                    axis.tickInterval = 1;
	                } else if (isLinked && !tickIntervalOption &&
	                    tickPixelIntervalOption === axis.linkedParent.options.tickPixelInterval) {
	                    axis.tickInterval = tickIntervalOption = axis.linkedParent.tickInterval;
	                } else {
	                    axis.tickInterval = pick(
	                        tickIntervalOption,
	                        this.tickAmount ? ((axis.max - axis.min) / Math.max(this.tickAmount - 1, 1)) : undefined,
	                        categories ? // for categoried axis, 1 is default, for linear axis use tickPix
	                        1 :
	                        // don't let it be more than the data range
	                        (axis.max - axis.min) * tickPixelIntervalOption / Math.max(axis.len, tickPixelIntervalOption)
	                    );
	                }
	
	                // Now we're finished detecting min and max, crop and group series data. This
	                // is in turn needed in order to find tick positions in ordinal axes.
	                if (isXAxis && !secondPass) {
	                    each(axis.series, function(series) {
	                        series.processData(axis.min !== axis.oldMin || axis.max !== axis.oldMax);
	                    });
	                }
	
	                // set the translation factor used in translate function
	                axis.setAxisTranslation(true);
	
	                // hook for ordinal axes and radial axes
	                if (axis.beforeSetTickPositions) {
	                    axis.beforeSetTickPositions();
	                }
	
	                // hook for extensions, used in Highstock ordinal axes
	                if (axis.postProcessTickInterval) {
	                    axis.tickInterval = axis.postProcessTickInterval(axis.tickInterval);
	                }
	
	                // In column-like charts, don't cramp in more ticks than there are points (#1943, #4184)
	                if (axis.pointRange && !tickIntervalOption) {
	                    axis.tickInterval = Math.max(axis.pointRange, axis.tickInterval);
	                }
	
	                // Before normalizing the tick interval, handle minimum tick interval. This applies only if tickInterval is not defined.
	                minTickInterval = pick(options.minTickInterval, axis.isDatetimeAxis && axis.closestPointRange);
	                if (!tickIntervalOption && axis.tickInterval < minTickInterval) {
	                    axis.tickInterval = minTickInterval;
	                }
	
	                // for linear axes, get magnitude and normalize the interval
	                if (!isDatetimeAxis && !isLog && !tickIntervalOption) {
	                    axis.tickInterval = normalizeTickInterval(
	                        axis.tickInterval,
	                        null,
	                        getMagnitude(axis.tickInterval),
	                        // If the tick interval is between 0.5 and 5 and the axis max is in the order of
	                        // thousands, chances are we are dealing with years. Don't allow decimals. #3363.
	                        pick(options.allowDecimals, !(axis.tickInterval > 0.5 && axis.tickInterval < 5 && axis.max > 1000 && axis.max < 9999)), !!this.tickAmount
	                    );
	                }
	
	                // Prevent ticks from getting so close that we can't draw the labels
	                if (!this.tickAmount) {
	                    axis.tickInterval = axis.unsquish();
	                }
	
	                this.setTickPositions();
	            },
	
	            /**
	             * Now we have computed the normalized tickInterval, get the tick positions
	             */
	            setTickPositions: function() {
	
	                var options = this.options,
	                    tickPositions,
	                    tickPositionsOption = options.tickPositions,
	                    tickPositioner = options.tickPositioner,
	                    startOnTick = options.startOnTick,
	                    endOnTick = options.endOnTick;
	
	                // Set the tickmarkOffset
	                this.tickmarkOffset = (this.categories && options.tickmarkPlacement === 'between' &&
	                    this.tickInterval === 1) ? 0.5 : 0; // #3202
	
	
	                // get minorTickInterval
	                this.minorTickInterval = options.minorTickInterval === 'auto' && this.tickInterval ?
	                    this.tickInterval / 5 : options.minorTickInterval;
	
	                // When there is only one point, or all points have the same value on
	                // this axis, then min and max are equal and tickPositions.length is 0
	                // or 1. In this case, add some padding in order to center the point,
	                // but leave it with one tick. #1337.
	                this.single =
	                    this.min === this.max &&
	                    defined(this.min) &&
	                    !this.tickAmount &&
	                    (
	                        // Data is on integer (#6563)
	                        parseInt(this.min, 10) === this.min ||
	
	                        // Between integers and decimals are not allowed (#6274)
	                        options.allowDecimals !== false
	                    );
	
	                // Find the tick positions
	                this.tickPositions = tickPositions = tickPositionsOption && tickPositionsOption.slice(); // Work on a copy (#1565)
	                if (!tickPositions) {
	
	                    if (this.isDatetimeAxis) {
	                        tickPositions = this.getTimeTicks(
	                            this.normalizeTimeTickInterval(
	                                this.tickInterval,
	                                options.units
	                            ),
	                            this.min,
	                            this.max,
	                            options.startOfWeek,
	                            this.ordinalPositions,
	                            this.closestPointRange,
	                            true
	                        );
	                    } else if (this.isLog) {
	                        tickPositions = this.getLogTickPositions(
	                            this.tickInterval,
	                            this.min,
	                            this.max
	                        );
	                    } else {
	                        tickPositions = this.getLinearTickPositions(
	                            this.tickInterval,
	                            this.min,
	                            this.max
	                        );
	                    }
	
	                    // Too dense ticks, keep only the first and last (#4477)
	                    if (tickPositions.length > this.len) {
	                        tickPositions = [tickPositions[0], tickPositions.pop()];
	                    }
	
	                    this.tickPositions = tickPositions;
	
	                    // Run the tick positioner callback, that allows modifying auto tick positions.
	                    if (tickPositioner) {
	                        tickPositioner = tickPositioner.apply(this, [this.min, this.max]);
	                        if (tickPositioner) {
	                            this.tickPositions = tickPositions = tickPositioner;
	                        }
	                    }
	
	                }
	
	                // Reset min/max or remove extremes based on start/end on tick
	                this.paddedTicks = tickPositions.slice(0); // Used for logarithmic minor
	                this.trimTicks(tickPositions, startOnTick, endOnTick);
	                if (!this.isLinked) {
	
	                    // Substract half a unit (#2619, #2846, #2515, #3390),
	                    // but not in case of multiple ticks (#6897)
	                    if (this.single && tickPositions.length < 2) {
	                        this.min -= 0.5;
	                        this.max += 0.5;
	                    }
	                    if (!tickPositionsOption && !tickPositioner) {
	                        this.adjustTickAmount();
	                    }
	                }
	            },
	
	            /**
	             * Handle startOnTick and endOnTick by either adapting to padding min/max or
	             * rounded min/max. Also handle single data points.
	             *
	             * @private
	             */
	            trimTicks: function(tickPositions, startOnTick, endOnTick) {
	                var roundedMin = tickPositions[0],
	                    roundedMax = tickPositions[tickPositions.length - 1],
	                    minPointOffset = this.minPointOffset || 0;
	
	                if (!this.isLinked) {
	                    if (startOnTick && roundedMin !== -Infinity) { // #6502
	                        this.min = roundedMin;
	                    } else {
	                        while (this.min - minPointOffset > tickPositions[0]) {
	                            tickPositions.shift();
	                        }
	                    }
	
	                    if (endOnTick) {
	                        this.max = roundedMax;
	                    } else {
	                        while (this.max + minPointOffset < tickPositions[tickPositions.length - 1]) {
	                            tickPositions.pop();
	                        }
	                    }
	
	                    // If no tick are left, set one tick in the middle (#3195)
	                    if (tickPositions.length === 0 && defined(roundedMin)) {
	                        tickPositions.push((roundedMax + roundedMin) / 2);
	                    }
	                }
	            },
	
	            /**
	             * Check if there are multiple axes in the same pane.
	             *
	             * @private
	             * @return {Boolean}
	             *         True if there are other axes.
	             */
	            alignToOthers: function() {
	                var others = {}, // Whether there is another axis to pair with this one
	                    hasOther,
	                    options = this.options;
	
	                if (
	                    // Only if alignTicks is true
	                    this.chart.options.chart.alignTicks !== false &&
	                    options.alignTicks !== false &&
	
	                    // Don't try to align ticks on a log axis, they are not evenly
	                    // spaced (#6021)
	                    !this.isLog
	                ) {
	                    each(this.chart[this.coll], function(axis) {
	                        var otherOptions = axis.options,
	                            horiz = axis.horiz,
	                            key = [
	                                horiz ? otherOptions.left : otherOptions.top,
	                                otherOptions.width,
	                                otherOptions.height,
	                                otherOptions.pane
	                            ].join(',');
	
	
	                        if (axis.series.length) { // #4442
	                            if (others[key]) {
	                                hasOther = true; // #4201
	                            } else {
	                                others[key] = 1;
	                            }
	                        }
	                    });
	                }
	                return hasOther;
	            },
	
	            /**
	             * Find the max ticks of either the x and y axis collection, and record it
	             * in `this.tickAmount`.
	             *
	             * @private
	             */
	            getTickAmount: function() {
	                var options = this.options,
	                    tickAmount = options.tickAmount,
	                    tickPixelInterval = options.tickPixelInterval;
	
	                if (!defined(options.tickInterval) && this.len < tickPixelInterval && !this.isRadial &&
	                    !this.isLog && options.startOnTick && options.endOnTick) {
	                    tickAmount = 2;
	                }
	
	                if (!tickAmount && this.alignToOthers()) {
	                    // Add 1 because 4 tick intervals require 5 ticks (including first and last)
	                    tickAmount = Math.ceil(this.len / tickPixelInterval) + 1;
	                }
	
	                // For tick amounts of 2 and 3, compute five ticks and remove the intermediate ones. This
	                // prevents the axis from adding ticks that are too far away from the data extremes.
	                if (tickAmount < 4) {
	                    this.finalTickAmt = tickAmount;
	                    tickAmount = 5;
	                }
	
	                this.tickAmount = tickAmount;
	            },
	
	            /**
	             * When using multiple axes, adjust the number of ticks to match the highest
	             * number of ticks in that group.
	             *
	             * @private
	             */
	            adjustTickAmount: function() {
	                var tickInterval = this.tickInterval,
	                    tickPositions = this.tickPositions,
	                    tickAmount = this.tickAmount,
	                    finalTickAmt = this.finalTickAmt,
	                    currentTickAmount = tickPositions && tickPositions.length,
	                    i,
	                    len;
	
	                if (currentTickAmount < tickAmount) {
	                    while (tickPositions.length < tickAmount) {
	                        tickPositions.push(correctFloat(
	                            tickPositions[tickPositions.length - 1] + tickInterval
	                        ));
	                    }
	                    this.transA *= (currentTickAmount - 1) / (tickAmount - 1);
	                    this.max = tickPositions[tickPositions.length - 1];
	
	                    // We have too many ticks, run second pass to try to reduce ticks
	                } else if (currentTickAmount > tickAmount) {
	                    this.tickInterval *= 2;
	                    this.setTickPositions();
	                }
	
	                // The finalTickAmt property is set in getTickAmount
	                if (defined(finalTickAmt)) {
	                    i = len = tickPositions.length;
	                    while (i--) {
	                        if (
	                            (finalTickAmt === 3 && i % 2 === 1) || // Remove every other tick
	                            (finalTickAmt <= 2 && i > 0 && i < len - 1) // Remove all but first and last
	                        ) {
	                            tickPositions.splice(i, 1);
	                        }
	                    }
	                    this.finalTickAmt = undefined;
	                }
	            },
	
	            /**
	             * Set the scale based on data min and max, user set min and max or options.
	             * 
	             * @private
	             */
	            setScale: function() {
	                var axis = this,
	                    isDirtyData,
	                    isDirtyAxisLength;
	
	                axis.oldMin = axis.min;
	                axis.oldMax = axis.max;
	                axis.oldAxisLength = axis.len;
	
	                // set the new axisLength
	                axis.setAxisSize();
	                //axisLength = horiz ? axisWidth : axisHeight;
	                isDirtyAxisLength = axis.len !== axis.oldAxisLength;
	
	                // is there new data?
	                each(axis.series, function(series) {
	                    if (series.isDirtyData || series.isDirty ||
	                        series.xAxis.isDirty) { // when x axis is dirty, we need new data extremes for y as well
	                        isDirtyData = true;
	                    }
	                });
	
	                // do we really need to go through all this?
	                if (isDirtyAxisLength || isDirtyData || axis.isLinked || axis.forceRedraw ||
	                    axis.userMin !== axis.oldUserMin || axis.userMax !== axis.oldUserMax || axis.alignToOthers()) {
	
	                    if (axis.resetStacks) {
	                        axis.resetStacks();
	                    }
	
	                    axis.forceRedraw = false;
	
	                    // get data extremes if needed
	                    axis.getSeriesExtremes();
	
	                    // get fixed positions based on tickInterval
	                    axis.setTickInterval();
	
	                    // record old values to decide whether a rescale is necessary later on (#540)
	                    axis.oldUserMin = axis.userMin;
	                    axis.oldUserMax = axis.userMax;
	
	                    // Mark as dirty if it is not already set to dirty and extremes have changed. #595.
	                    if (!axis.isDirty) {
	                        axis.isDirty = isDirtyAxisLength || axis.min !== axis.oldMin || axis.max !== axis.oldMax;
	                    }
	                } else if (axis.cleanStacks) {
	                    axis.cleanStacks();
	                }
	            },
	
	            /**
	             * Set the minimum and maximum of the axes after render time. If the
	             * `startOnTick` and `endOnTick` options are true, the minimum and maximum
	             * values are rounded off to the nearest tick. To prevent this, these
	             * options can be set to false before calling setExtremes. Also, setExtremes
	             * will not allow a range lower than the `minRange` option, which by default
	             * is the range of five points.
	             * 
	             * @param  {Number} [newMin]
	             *         The new minimum value.
	             * @param  {Number} [newMax]
	             *         The new maximum value.
	             * @param  {Boolean} [redraw=true]
	             *         Whether to redraw the chart or wait for an explicit call to 
	             *         {@link Highcharts.Chart#redraw}
	             * @param  {AnimationOptions} [animation=true]
	             *         Enable or modify animations.
	             * @param  {Object} [eventArguments]
	             *         Arguments to be accessed in event handler.
	             *
	             * @sample highcharts/members/axis-setextremes/
	             *         Set extremes from a button
	             * @sample highcharts/members/axis-setextremes-datetime/
	             *         Set extremes on a datetime axis
	             * @sample highcharts/members/axis-setextremes-off-ticks/
	             *         Set extremes off ticks
	             * @sample stock/members/axis-setextremes/
	             *         Set extremes in Highstock
	             * @sample maps/members/axis-setextremes/
	             *         Set extremes in Highmaps
	             */
	            setExtremes: function(newMin, newMax, redraw, animation, eventArguments) {
	                var axis = this,
	                    chart = axis.chart;
	
	                redraw = pick(redraw, true); // defaults to true
	
	                each(axis.series, function(serie) {
	                    delete serie.kdTree;
	                });
	
	                // Extend the arguments with min and max
	                eventArguments = extend(eventArguments, {
	                    min: newMin,
	                    max: newMax
	                });
	
	                // Fire the event
	                fireEvent(axis, 'setExtremes', eventArguments, function() { // the default event handler
	
	                    axis.userMin = newMin;
	                    axis.userMax = newMax;
	                    axis.eventArgs = eventArguments;
	
	                    if (redraw) {
	                        chart.redraw(animation);
	                    }
	                });
	            },
	
	            /**
	             * Overridable method for zooming chart. Pulled out in a separate method to
	             * allow overriding in stock charts.
	             *
	             * @private
	             */
	            zoom: function(newMin, newMax) {
	                var dataMin = this.dataMin,
	                    dataMax = this.dataMax,
	                    options = this.options,
	                    min = Math.min(dataMin, pick(options.min, dataMin)),
	                    max = Math.max(dataMax, pick(options.max, dataMax));
	
	                if (newMin !== this.min || newMax !== this.max) { // #5790
	
	                    // Prevent pinch zooming out of range. Check for defined is for #1946. #1734.
	                    if (!this.allowZoomOutside) {
	                        // #6014, sometimes newMax will be smaller than min (or newMin will be larger than max).
	                        if (defined(dataMin)) {
	                            if (newMin < min) {
	                                newMin = min;
	                            }
	                            if (newMin > max) {
	                                newMin = max;
	                            }
	                        }
	                        if (defined(dataMax)) {
	                            if (newMax < min) {
	                                newMax = min;
	                            }
	                            if (newMax > max) {
	                                newMax = max;
	                            }
	                        }
	                    }
	
	                    // In full view, displaying the reset zoom button is not required
	                    this.displayBtn = newMin !== undefined || newMax !== undefined;
	
	                    // Do it
	                    this.setExtremes(
	                        newMin,
	                        newMax,
	                        false,
	                        undefined, {
	                            trigger: 'zoom'
	                        }
	                    );
	                }
	
	                return true;
	            },
	
	            /**
	             * Update the axis metrics.
	             *
	             * @private
	             */
	            setAxisSize: function() {
	                var chart = this.chart,
	                    options = this.options,
	                    offsets = options.offsets || [0, 0, 0, 0], // top / right / bottom / left
	                    horiz = this.horiz,
	
	                    // Check for percentage based input values. Rounding fixes problems
	                    // with column overflow and plot line filtering (#4898, #4899)
	                    width = this.width = Math.round(H.relativeLength(
	                        pick(
	                            options.width,
	                            chart.plotWidth - offsets[3] + offsets[1]
	                        ),
	                        chart.plotWidth
	                    )),
	                    height = this.height = Math.round(H.relativeLength(
	                        pick(
	                            options.height,
	                            chart.plotHeight - offsets[0] + offsets[2]
	                        ),
	                        chart.plotHeight
	                    )),
	                    top = this.top = Math.round(H.relativeLength(
	                        pick(options.top, chart.plotTop + offsets[0]),
	                        chart.plotHeight,
	                        chart.plotTop
	                    )),
	                    left = this.left = Math.round(H.relativeLength(
	                        pick(options.left, chart.plotLeft + offsets[3]),
	                        chart.plotWidth,
	                        chart.plotLeft
	                    ));
	
	                // Expose basic values to use in Series object and navigator
	                this.bottom = chart.chartHeight - height - top;
	                this.right = chart.chartWidth - width - left;
	
	                // Direction agnostic properties
	                this.len = Math.max(horiz ? width : height, 0); // Math.max fixes #905
	                this.pos = horiz ? left : top; // distance from SVG origin
	            },
	
	            /**
	             * The returned object literal from the {@link Highcharts.Axis#getExtremes}
	             * function. 
	             * @typedef {Object} Extremes
	             * @property {Number} dataMax
	             *         The maximum value of the axis' associated series.
	             * @property {Number} dataMin
	             *         The minimum value of the axis' associated series.
	             * @property {Number} max
	             *         The maximum axis value, either automatic or set manually. If the
	             *         `max` option is not set, `maxPadding` is 0 and `endOnTick` is
	             *         false, this value will be the same as `dataMax`.
	             * @property {Number} min
	             *         The minimum axis value, either automatic or set manually. If the
	             *         `min` option is not set, `minPadding` is 0 and `startOnTick` is
	             *         false, this value will be the same as `dataMin`.
	             */
	            /**
	             * Get the current extremes for the axis.
	             *
	             * @returns {Extremes}
	             * An object containing extremes information.
	             * 
	             * @sample  members/axis-getextremes/
	             *          Report extremes by click on a button
	             * @sample  maps/members/axis-getextremes/
	             *          Get extremes in Highmaps
	             */
	            getExtremes: function() {
	                var axis = this,
	                    isLog = axis.isLog,
	                    lin2log = axis.lin2log;
	
	                return {
	                    min: isLog ? correctFloat(lin2log(axis.min)) : axis.min,
	                    max: isLog ? correctFloat(lin2log(axis.max)) : axis.max,
	                    dataMin: axis.dataMin,
	                    dataMax: axis.dataMax,
	                    userMin: axis.userMin,
	                    userMax: axis.userMax
	                };
	            },
	
	            /**
	             * Get the zero plane either based on zero or on the min or max value.
	             * Used in bar and area plots.
	             *
	             * @param  {Number} threshold
	             *         The threshold in axis values.
	             *
	             * @return {Number}
	             *         The translated threshold position in terms of pixels, and
	             *         corrected to stay within the axis bounds.
	             */
	            getThreshold: function(threshold) {
	                var axis = this,
	                    isLog = axis.isLog,
	                    lin2log = axis.lin2log,
	                    realMin = isLog ? lin2log(axis.min) : axis.min,
	                    realMax = isLog ? lin2log(axis.max) : axis.max;
	
	                if (threshold === null) {
	                    threshold = realMin;
	                } else if (realMin > threshold) {
	                    threshold = realMin;
	                } else if (realMax < threshold) {
	                    threshold = realMax;
	                }
	
	                return axis.translate(threshold, 0, 1, 0, 1);
	            },
	
	            /**
	             * Compute auto alignment for the axis label based on which side the axis is
	             * on and the given rotation for the label.
	             *
	             * @param  {Number} rotation
	             *         The rotation in degrees as set by either the `rotation` or 
	             *         `autoRotation` options.
	             * @private
	             */
	            autoLabelAlign: function(rotation) {
	                var ret,
	                    angle = (pick(rotation, 0) - (this.side * 90) + 720) % 360;
	
	                if (angle > 15 && angle < 165) {
	                    ret = 'right';
	                } else if (angle > 195 && angle < 345) {
	                    ret = 'left';
	                } else {
	                    ret = 'center';
	                }
	                return ret;
	            },
	
	            /**
	             * Get the tick length and width for the axis based on axis options.
	             *
	             * @private
	             * 
	             * @param  {String} prefix
	             *         'tick' or 'minorTick'
	             * @return {Array.<Number>}
	             *         An array of tickLength and tickWidth
	             */
	            tickSize: function(prefix) {
	                var options = this.options,
	                    tickLength = options[prefix + 'Length'],
	                    tickWidth = pick(options[prefix + 'Width'], prefix === 'tick' && this.isXAxis ? 1 : 0); // X axis defaults to 1
	
	                if (tickWidth && tickLength) {
	                    // Negate the length
	                    if (options[prefix + 'Position'] === 'inside') {
	                        tickLength = -tickLength;
	                    }
	                    return [tickLength, tickWidth];
	                }
	
	            },
	
	            /**
	             * Return the size of the labels.
	             *
	             * @private
	             */
	            labelMetrics: function() {
	                var index = this.tickPositions && this.tickPositions[0] || 0;
	                return this.chart.renderer.fontMetrics(
	                    this.options.labels.style && this.options.labels.style.fontSize,
	                    this.ticks[index] && this.ticks[index].label
	                );
	            },
	
	            /**
	             * Prevent the ticks from getting so close we can't draw the labels. On a
	             * horizontal axis, this is handled by rotating the labels, removing ticks
	             * and adding ellipsis. On a vertical axis remove ticks and add ellipsis.
	             *
	             * @private
	             */
	            unsquish: function() {
	                var labelOptions = this.options.labels,
	                    horiz = this.horiz,
	                    tickInterval = this.tickInterval,
	                    newTickInterval = tickInterval,
	                    slotSize = this.len / (((this.categories ? 1 : 0) + this.max - this.min) / tickInterval),
	                    rotation,
	                    rotationOption = labelOptions.rotation,
	                    labelMetrics = this.labelMetrics(),
	                    step,
	                    bestScore = Number.MAX_VALUE,
	                    autoRotation,
	                    // Return the multiple of tickInterval that is needed to avoid collision
	                    getStep = function(spaceNeeded) {
	                        var step = spaceNeeded / (slotSize || 1);
	                        step = step > 1 ? Math.ceil(step) : 1;
	                        return step * tickInterval;
	                    };
	
	                if (horiz) {
	                    autoRotation = !labelOptions.staggerLines && !labelOptions.step && ( // #3971
	                        defined(rotationOption) ? [rotationOption] :
	                        slotSize < pick(labelOptions.autoRotationLimit, 80) && labelOptions.autoRotation
	                    );
	
	                    if (autoRotation) {
	
	                        // Loop over the given autoRotation options, and determine which gives the best score. The
	                        // best score is that with the lowest number of steps and a rotation closest to horizontal.
	                        each(autoRotation, function(rot) {
	                            var score;
	
	                            if (rot === rotationOption || (rot && rot >= -90 && rot <= 90)) { // #3891
	
	                                step = getStep(Math.abs(labelMetrics.h / Math.sin(deg2rad * rot)));
	
	                                score = step + Math.abs(rot / 360);
	
	                                if (score < bestScore) {
	                                    bestScore = score;
	                                    rotation = rot;
	                                    newTickInterval = step;
	                                }
	                            }
	                        });
	                    }
	
	                } else if (!labelOptions.step) { // #4411
	                    newTickInterval = getStep(labelMetrics.h);
	                }
	
	                this.autoRotation = autoRotation;
	                this.labelRotation = pick(rotation, rotationOption);
	
	                return newTickInterval;
	            },
	
	            /**
	             * Get the general slot width for labels/categories on this axis. This may
	             * change between the pre-render (from Axis.getOffset) and the final tick
	             * rendering and placement.
	             *
	             * @private
	             * @return {Number}
	             *         The pixel width allocated to each axis label.
	             */
	            getSlotWidth: function() {
	                // #5086, #1580, #1931
	                var chart = this.chart,
	                    horiz = this.horiz,
	                    labelOptions = this.options.labels,
	                    slotCount = Math.max(this.tickPositions.length - (this.categories ? 0 : 1), 1),
	                    marginLeft = chart.margin[3];
	
	                return (
	                    horiz &&
	                    (labelOptions.step || 0) < 2 &&
	                    !labelOptions.rotation && // #4415
	                    ((this.staggerLines || 1) * this.len) / slotCount
	                ) || (!horiz && (
	                    (marginLeft && (marginLeft - chart.spacing[3])) ||
	                    chart.chartWidth * 0.33
	                ));
	
	            },
	
	            /**
	             * Render the axis labels and determine whether ellipsis or rotation need
	             * to be applied.
	             *
	             * @private
	             */
	            renderUnsquish: function() {
	                var chart = this.chart,
	                    renderer = chart.renderer,
	                    tickPositions = this.tickPositions,
	                    ticks = this.ticks,
	                    labelOptions = this.options.labels,
	                    horiz = this.horiz,
	                    slotWidth = this.getSlotWidth(),
	                    innerWidth = Math.max(1, Math.round(slotWidth - 2 * (labelOptions.padding || 5))),
	                    attr = {},
	                    labelMetrics = this.labelMetrics(),
	                    textOverflowOption = labelOptions.style && labelOptions.style.textOverflow,
	                    css,
	                    maxLabelLength = 0,
	                    label,
	                    i,
	                    pos;
	
	                // Set rotation option unless it is "auto", like in gauges
	                if (!isString(labelOptions.rotation)) {
	                    attr.rotation = labelOptions.rotation || 0; // #4443
	                }
	
	                // Get the longest label length
	                each(tickPositions, function(tick) {
	                    tick = ticks[tick];
	                    if (tick && tick.labelLength > maxLabelLength) {
	                        maxLabelLength = tick.labelLength;
	                    }
	                });
	                this.maxLabelLength = maxLabelLength;
	
	
	                // Handle auto rotation on horizontal axis
	                if (this.autoRotation) {
	
	                    // Apply rotation only if the label is too wide for the slot, and
	                    // the label is wider than its height.
	                    if (maxLabelLength > innerWidth && maxLabelLength > labelMetrics.h) {
	                        attr.rotation = this.labelRotation;
	                    } else {
	                        this.labelRotation = 0;
	                    }
	
	                    // Handle word-wrap or ellipsis on vertical axis
	                } else if (slotWidth) {
	                    // For word-wrap or ellipsis
	                    css = {
	                        width: innerWidth + 'px'
	                    };
	
	                    if (!textOverflowOption) {
	                        css.textOverflow = 'clip';
	
	                        // On vertical axis, only allow word wrap if there is room for more lines.
	                        i = tickPositions.length;
	                        while (!horiz && i--) {
	                            pos = tickPositions[i];
	                            label = ticks[pos].label;
	                            if (label) {
	                                // Reset ellipsis in order to get the correct bounding box (#4070)
	                                if (label.styles && label.styles.textOverflow === 'ellipsis') {
	                                    label.css({
	                                        textOverflow: 'clip'
	                                    });
	
	                                    // Set the correct width in order to read the bounding box height (#4678, #5034)
	                                } else if (ticks[pos].labelLength > slotWidth) {
	                                    label.css({
	                                        width: slotWidth + 'px'
	                                    });
	                                }
	
	                                if (label.getBBox().height > this.len / tickPositions.length - (labelMetrics.h - labelMetrics.f)) {
	                                    label.specCss = {
	                                        textOverflow: 'ellipsis'
	                                    };
	                                }
	                            }
	                        }
	                    }
	                }
	
	
	                // Add ellipsis if the label length is significantly longer than ideal
	                if (attr.rotation) {
	                    css = {
	                        width: (maxLabelLength > chart.chartHeight * 0.5 ? chart.chartHeight * 0.33 : chart.chartHeight) + 'px'
	                    };
	                    if (!textOverflowOption) {
	                        css.textOverflow = 'ellipsis';
	                    }
	                }
	
	                // Set the explicit or automatic label alignment
	                this.labelAlign = labelOptions.align || this.autoLabelAlign(this.labelRotation);
	                if (this.labelAlign) {
	                    attr.align = this.labelAlign;
	                }
	
	                // Apply general and specific CSS
	                each(tickPositions, function(pos) {
	                    var tick = ticks[pos],
	                        label = tick && tick.label;
	                    if (label) {
	                        label.attr(attr); // This needs to go before the CSS in old IE (#4502)
	                        if (css) {
	                            label.css(merge(css, label.specCss));
	                        }
	                        delete label.specCss;
	                        tick.rotation = attr.rotation;
	                    }
	                });
	
	                // Note: Why is this not part of getLabelPosition?
	                this.tickRotCorr = renderer.rotCorr(labelMetrics.b, this.labelRotation || 0, this.side !== 0);
	            },
	
	            /**
	             * Return true if the axis has associated data.
	             *
	             * @return {Boolean}
	             *         True if the axis has associated visible series and those series
	             *         have either valid data points or explicit `min` and `max`
	             *         settings.
	             */
	            hasData: function() {
	                return (
	                    this.hasVisibleSeries ||
	                    (defined(this.min) && defined(this.max) && !!this.tickPositions)
	                );
	            },
	
	            /**
	             * Adds the title defined in axis.options.title.
	             * @param {Boolean} display - whether or not to display the title
	             */
	            addTitle: function(display) {
	                var axis = this,
	                    renderer = axis.chart.renderer,
	                    horiz = axis.horiz,
	                    opposite = axis.opposite,
	                    options = axis.options,
	                    axisTitleOptions = options.title,
	                    textAlign;
	
	                if (!axis.axisTitle) {
	                    textAlign = axisTitleOptions.textAlign;
	                    if (!textAlign) {
	                        textAlign = (horiz ? {
	                            low: 'left',
	                            middle: 'center',
	                            high: 'right'
	                        } : {
	                            low: opposite ? 'right' : 'left',
	                            middle: 'center',
	                            high: opposite ? 'left' : 'right'
	                        })[axisTitleOptions.align];
	                    }
	                    axis.axisTitle = renderer.text(
	                            axisTitleOptions.text,
	                            0,
	                            0,
	                            axisTitleOptions.useHTML
	                        )
	                        .attr({
	                            zIndex: 7,
	                            rotation: axisTitleOptions.rotation || 0,
	                            align: textAlign
	                        })
	                        .addClass('highcharts-axis-title')
	
	                        .css(axisTitleOptions.style)
	
	                        .add(axis.axisGroup);
	                    axis.axisTitle.isNew = true;
	                }
	
	                // Max width defaults to the length of the axis
	
	                if (!axisTitleOptions.style.width && !axis.isRadial) {
	
	                    axis.axisTitle.css({
	                        width: axis.len
	                    });
	
	                }
	
	
	
	                // hide or show the title depending on whether showEmpty is set
	                axis.axisTitle[display ? 'show' : 'hide'](true);
	            },
	
	            /**
	             * Generates a tick for initial positioning.
	             *
	             * @private
	             * @param  {number} pos
	             *         The tick position in axis values.
	             * @param  {number} i
	             *         The index of the tick in {@link Axis.tickPositions}.
	             */
	            generateTick: function(pos) {
	                var ticks = this.ticks;
	
	                if (!ticks[pos]) {
	                    ticks[pos] = new Tick(this, pos);
	                } else {
	                    ticks[pos].addLabel(); // update labels depending on tick interval
	                }
	            },
	
	            /**
	             * Render the tick labels to a preliminary position to get their sizes.
	             *
	             * @private
	             */
	            getOffset: function() {
	                var axis = this,
	                    chart = axis.chart,
	                    renderer = chart.renderer,
	                    options = axis.options,
	                    tickPositions = axis.tickPositions,
	                    ticks = axis.ticks,
	                    horiz = axis.horiz,
	                    side = axis.side,
	                    invertedSide = chart.inverted && !axis.isZAxis ? [1, 0, 3, 2][side] : side,
	                    hasData,
	                    showAxis,
	                    titleOffset = 0,
	                    titleOffsetOption,
	                    titleMargin = 0,
	                    axisTitleOptions = options.title,
	                    labelOptions = options.labels,
	                    labelOffset = 0, // reset
	                    labelOffsetPadded,
	                    axisOffset = chart.axisOffset,
	                    clipOffset = chart.clipOffset,
	                    clip,
	                    directionFactor = [-1, 1, 1, -1][side],
	                    className = options.className,
	                    axisParent = axis.axisParent, // Used in color axis
	                    lineHeightCorrection,
	                    tickSize = this.tickSize('tick');
	
	                // For reuse in Axis.render
	                hasData = axis.hasData();
	                axis.showAxis = showAxis = hasData || pick(options.showEmpty, true);
	
	                // Set/reset staggerLines
	                axis.staggerLines = axis.horiz && labelOptions.staggerLines;
	
	                // Create the axisGroup and gridGroup elements on first iteration
	                if (!axis.axisGroup) {
	                    axis.gridGroup = renderer.g('grid')
	                        .attr({
	                            zIndex: options.gridZIndex || 1
	                        })
	                        .addClass('highcharts-' + this.coll.toLowerCase() + '-grid ' + (className || ''))
	                        .add(axisParent);
	                    axis.axisGroup = renderer.g('axis')
	                        .attr({
	                            zIndex: options.zIndex || 2
	                        })
	                        .addClass('highcharts-' + this.coll.toLowerCase() + ' ' + (className || ''))
	                        .add(axisParent);
	                    axis.labelGroup = renderer.g('axis-labels')
	                        .attr({
	                            zIndex: labelOptions.zIndex || 7
	                        })
	                        .addClass('highcharts-' + axis.coll.toLowerCase() + '-labels ' + (className || ''))
	                        .add(axisParent);
	                }
	
	                if (hasData || axis.isLinked) {
	
	                    // Generate ticks
	                    each(tickPositions, function(pos, i) {
	                        // i is not used here, but may be used in overrides
	                        axis.generateTick(pos, i);
	                    });
	
	                    axis.renderUnsquish();
	
	
	                    // Left side must be align: right and right side must have align: left for labels
	                    if (labelOptions.reserveSpace !== false && (side === 0 || side === 2 || {
	                            1: 'left',
	                            3: 'right'
	                        }[side] === axis.labelAlign || axis.labelAlign === 'center')) {
	                        each(tickPositions, function(pos) {
	
	                            // get the highest offset
	                            labelOffset = Math.max(
	                                ticks[pos].getLabelSize(),
	                                labelOffset
	                            );
	                        });
	                    }
	
	                    if (axis.staggerLines) {
	                        labelOffset *= axis.staggerLines;
	                        axis.labelOffset = labelOffset * (axis.opposite ? -1 : 1);
	                    }
	
	
	                } else { // doesn't have data
	                    objectEach(ticks, function(tick, n) {
	                        tick.destroy();
	                        delete ticks[n];
	                    });
	                }
	
	                if (axisTitleOptions && axisTitleOptions.text && axisTitleOptions.enabled !== false) {
	                    axis.addTitle(showAxis);
	
	                    if (showAxis && axisTitleOptions.reserveSpace !== false) {
	                        axis.titleOffset = titleOffset =
	                            axis.axisTitle.getBBox()[horiz ? 'height' : 'width'];
	                        titleOffsetOption = axisTitleOptions.offset;
	                        titleMargin = defined(titleOffsetOption) ? 0 : pick(axisTitleOptions.margin, horiz ? 5 : 10);
	                    }
	                }
	
	                // Render the axis line
	                axis.renderLine();
	
	                // handle automatic or user set offset
	                axis.offset = directionFactor * pick(options.offset, axisOffset[side]);
	
	                axis.tickRotCorr = axis.tickRotCorr || {
	                    x: 0,
	                    y: 0
	                }; // polar
	                if (side === 0) {
	                    lineHeightCorrection = -axis.labelMetrics().h;
	                } else if (side === 2) {
	                    lineHeightCorrection = axis.tickRotCorr.y;
	                } else {
	                    lineHeightCorrection = 0;
	                }
	
	                // Find the padded label offset
	                labelOffsetPadded = Math.abs(labelOffset) + titleMargin;
	                if (labelOffset) {
	                    labelOffsetPadded -= lineHeightCorrection;
	                    labelOffsetPadded += directionFactor * (horiz ? pick(labelOptions.y, axis.tickRotCorr.y + directionFactor * 8) : labelOptions.x);
	                }
	                axis.axisTitleMargin = pick(titleOffsetOption, labelOffsetPadded);
	
	                axisOffset[side] = Math.max(
	                    axisOffset[side],
	                    axis.axisTitleMargin + titleOffset + directionFactor * axis.offset,
	                    labelOffsetPadded, // #3027
	                    hasData && tickPositions.length && tickSize ?
	                    tickSize[0] + directionFactor * axis.offset :
	                    0 // #4866
	                );
	
	                // Decide the clipping needed to keep the graph inside the plot area and
	                // axis lines
	                clip = Math.floor(axis.axisLine.strokeWidth() / 2) * 2; // #4308, #4371
	                if (options.offset > 0) {
	                    clip -= options.offset * 2;
	                }
	                clipOffset[invertedSide] = Math.max(
	                    clipOffset[invertedSide] || clip,
	                    clip
	                );
	            },
	
	            /**
	             * Internal function to get the path for the axis line. Extended for polar
	             * charts.
	             *
	             * @param  {Number} lineWidth
	             *         The line width in pixels.
	             * @return {Array}
	             *         The SVG path definition in array form.
	             */
	            getLinePath: function(lineWidth) {
	                var chart = this.chart,
	                    opposite = this.opposite,
	                    offset = this.offset,
	                    horiz = this.horiz,
	                    lineLeft = this.left + (opposite ? this.width : 0) + offset,
	                    lineTop = chart.chartHeight - this.bottom -
	                    (opposite ? this.height : 0) + offset;
	
	                if (opposite) {
	                    lineWidth *= -1; // crispify the other way - #1480, #1687
	                }
	
	                return chart.renderer
	                    .crispLine([
	                        'M',
	                        horiz ?
	                        this.left :
	                        lineLeft,
	                        horiz ?
	                        lineTop :
	                        this.top,
	                        'L',
	                        horiz ?
	                        chart.chartWidth - this.right :
	                        lineLeft,
	                        horiz ?
	                        lineTop :
	                        chart.chartHeight - this.bottom
	                    ], lineWidth);
	            },
	
	            /**
	             * Render the axis line. Called internally when rendering and redrawing the
	             * axis.
	             */
	            renderLine: function() {
	                if (!this.axisLine) {
	                    this.axisLine = this.chart.renderer.path()
	                        .addClass('highcharts-axis-line')
	                        .add(this.axisGroup);
	
	
	                    this.axisLine.attr({
	                        stroke: this.options.lineColor,
	                        'stroke-width': this.options.lineWidth,
	                        zIndex: 7
	                    });
	
	                }
	            },
	
	            /**
	             * Position the axis title.
	             *
	             * @private
	             *
	             * @return {Object}
	             *         X and Y positions for the title.
	             */
	            getTitlePosition: function() {
	                // compute anchor points for each of the title align options
	                var horiz = this.horiz,
	                    axisLeft = this.left,
	                    axisTop = this.top,
	                    axisLength = this.len,
	                    axisTitleOptions = this.options.title,
	                    margin = horiz ? axisLeft : axisTop,
	                    opposite = this.opposite,
	                    offset = this.offset,
	                    xOption = axisTitleOptions.x || 0,
	                    yOption = axisTitleOptions.y || 0,
	                    axisTitle = this.axisTitle,
	                    fontMetrics = this.chart.renderer.fontMetrics(
	                        axisTitleOptions.style && axisTitleOptions.style.fontSize,
	                        axisTitle
	                    ),
	                    // The part of a multiline text that is below the baseline of the
	                    // first line. Subtract 1 to preserve pixel-perfectness from the 
	                    // old behaviour (v5.0.12), where only one line was allowed.
	                    textHeightOvershoot = Math.max(
	                        axisTitle.getBBox(null, 0).height - fontMetrics.h - 1,
	                        0
	                    ),
	
	                    // the position in the length direction of the axis
	                    alongAxis = {
	                        low: margin + (horiz ? 0 : axisLength),
	                        middle: margin + axisLength / 2,
	                        high: margin + (horiz ? axisLength : 0)
	                    }[axisTitleOptions.align],
	
	                    // the position in the perpendicular direction of the axis
	                    offAxis = (horiz ? axisTop + this.height : axisLeft) +
	                    (horiz ? 1 : -1) * // horizontal axis reverses the margin
	                    (opposite ? -1 : 1) * // so does opposite axes
	                    this.axisTitleMargin + [-textHeightOvershoot, // top
	                        textHeightOvershoot, // right
	                        fontMetrics.f, // bottom
	                        -textHeightOvershoot // left
	                    ][this.side];
	
	
	                return {
	                    x: horiz ?
	                        alongAxis + xOption : offAxis + (opposite ? this.width : 0) + offset + xOption,
	                    y: horiz ?
	                        offAxis + yOption - (opposite ? this.height : 0) + offset : alongAxis + yOption
	                };
	            },
	
	            /**
	             * Render a minor tick into the given position. If a minor tick already 
	             * exists in this position, move it.
	             * 
	             * @param  {number} pos
	             *         The position in axis values.
	             */
	            renderMinorTick: function(pos) {
	                var slideInTicks = this.chart.hasRendered && isNumber(this.oldMin),
	                    minorTicks = this.minorTicks;
	
	                if (!minorTicks[pos]) {
	                    minorTicks[pos] = new Tick(this, pos, 'minor');
	                }
	
	                // Render new ticks in old position
	                if (slideInTicks && minorTicks[pos].isNew) {
	                    minorTicks[pos].render(null, true);
	                }
	
	                minorTicks[pos].render(null, false, 1);
	            },
	
	            /**
	             * Render a major tick into the given position. If a tick already exists
	             * in this position, move it.
	             * 
	             * @param  {number} pos
	             *         The position in axis values.
	             * @param  {number} i
	             *         The tick index.
	             */
	            renderTick: function(pos, i) {
	                var isLinked = this.isLinked,
	                    ticks = this.ticks,
	                    slideInTicks = this.chart.hasRendered && isNumber(this.oldMin);
	
	                // Linked axes need an extra check to find out if
	                if (!isLinked || (pos >= this.min && pos <= this.max)) {
	
	                    if (!ticks[pos]) {
	                        ticks[pos] = new Tick(this, pos);
	                    }
	
	                    // render new ticks in old position
	                    if (slideInTicks && ticks[pos].isNew) {
	                        ticks[pos].render(i, true, 0.1);
	                    }
	
	                    ticks[pos].render(i);
	                }
	            },
	
	            /**
	             * Render the axis.
	             *
	             * @private
	             */
	            render: function() {
	                var axis = this,
	                    chart = axis.chart,
	                    renderer = chart.renderer,
	                    options = axis.options,
	                    isLog = axis.isLog,
	                    lin2log = axis.lin2log,
	                    isLinked = axis.isLinked,
	                    tickPositions = axis.tickPositions,
	                    axisTitle = axis.axisTitle,
	                    ticks = axis.ticks,
	                    minorTicks = axis.minorTicks,
	                    alternateBands = axis.alternateBands,
	                    stackLabelOptions = options.stackLabels,
	                    alternateGridColor = options.alternateGridColor,
	                    tickmarkOffset = axis.tickmarkOffset,
	                    axisLine = axis.axisLine,
	                    showAxis = axis.showAxis,
	                    animation = animObject(renderer.globalAnimation),
	                    from,
	                    to;
	
	                // Reset
	                axis.labelEdge.length = 0;
	                //axis.justifyToPlot = overflow === 'justify';
	                axis.overlap = false;
	
	                // Mark all elements inActive before we go over and mark the active ones
	                each([ticks, minorTicks, alternateBands], function(coll) {
	                    objectEach(coll, function(tick) {
	                        tick.isActive = false;
	                    });
	                });
	
	                // If the series has data draw the ticks. Else only the line and title
	                if (axis.hasData() || isLinked) {
	
	                    // minor ticks
	                    if (axis.minorTickInterval && !axis.categories) {
	                        each(axis.getMinorTickPositions(), function(pos) {
	                            axis.renderMinorTick(pos);
	                        });
	                    }
	
	                    // Major ticks. Pull out the first item and render it last so that
	                    // we can get the position of the neighbour label. #808.
	                    if (tickPositions.length) { // #1300
	                        each(tickPositions, function(pos, i) {
	                            axis.renderTick(pos, i);
	                        });
	                        // In a categorized axis, the tick marks are displayed between labels. So
	                        // we need to add a tick mark and grid line at the left edge of the X axis.
	                        if (tickmarkOffset && (axis.min === 0 || axis.single)) {
	                            if (!ticks[-1]) {
	                                ticks[-1] = new Tick(axis, -1, null, true);
	                            }
	                            ticks[-1].render(-1);
	                        }
	
	                    }
	
	                    // alternate grid color
	                    if (alternateGridColor) {
	                        each(tickPositions, function(pos, i) {
	                            to = tickPositions[i + 1] !== undefined ? tickPositions[i + 1] + tickmarkOffset : axis.max - tickmarkOffset;
	                            if (i % 2 === 0 && pos < axis.max && to <= axis.max + (chart.polar ? -tickmarkOffset : tickmarkOffset)) { // #2248, #4660
	                                if (!alternateBands[pos]) {
	                                    alternateBands[pos] = new H.PlotLineOrBand(axis);
	                                }
	                                from = pos + tickmarkOffset; // #949
	                                alternateBands[pos].options = {
	                                    from: isLog ? lin2log(from) : from,
	                                    to: isLog ? lin2log(to) : to,
	                                    color: alternateGridColor
	                                };
	                                alternateBands[pos].render();
	                                alternateBands[pos].isActive = true;
	                            }
	                        });
	                    }
	
	                    // custom plot lines and bands
	                    if (!axis._addedPlotLB) { // only first time
	                        each((options.plotLines || []).concat(options.plotBands || []), function(plotLineOptions) {
	                            axis.addPlotBandOrLine(plotLineOptions);
	                        });
	                        axis._addedPlotLB = true;
	                    }
	
	                } // end if hasData
	
	                // Remove inactive ticks
	                each([ticks, minorTicks, alternateBands], function(coll) {
	                    var i,
	                        forDestruction = [],
	                        delay = animation.duration,
	                        destroyInactiveItems = function() {
	                            i = forDestruction.length;
	                            while (i--) {
	                                // When resizing rapidly, the same items may be destroyed in different timeouts,
	                                // or the may be reactivated
	                                if (coll[forDestruction[i]] && !coll[forDestruction[i]].isActive) {
	                                    coll[forDestruction[i]].destroy();
	                                    delete coll[forDestruction[i]];
	                                }
	                            }
	
	                        };
	
	                    objectEach(coll, function(tick, pos) {
	                        if (!tick.isActive) {
	                            // Render to zero opacity
	                            tick.render(pos, false, 0);
	                            tick.isActive = false;
	                            forDestruction.push(pos);
	                        }
	                    });
	
	                    // When the objects are finished fading out, destroy them
	                    syncTimeout(
	                        destroyInactiveItems,
	                        coll === alternateBands || !chart.hasRendered || !delay ? 0 : delay
	                    );
	                });
	
	                // Set the axis line path
	                if (axisLine) {
	                    axisLine[axisLine.isPlaced ? 'animate' : 'attr']({
	                        d: this.getLinePath(axisLine.strokeWidth())
	                    });
	                    axisLine.isPlaced = true;
	
	                    // Show or hide the line depending on options.showEmpty
	                    axisLine[showAxis ? 'show' : 'hide'](true);
	                }
	
	                if (axisTitle && showAxis) {
	                    var titleXy = axis.getTitlePosition();
	                    if (isNumber(titleXy.y)) {
	                        axisTitle[axisTitle.isNew ? 'attr' : 'animate'](titleXy);
	                        axisTitle.isNew = false;
	                    } else {
	                        axisTitle.attr('y', -9999);
	                        axisTitle.isNew = true;
	                    }
	                }
	
	                // Stacked totals:
	                if (stackLabelOptions && stackLabelOptions.enabled) {
	                    axis.renderStackTotals();
	                }
	                // End stacked totals
	
	                axis.isDirty = false;
	            },
	
	            /**
	             * Redraw the axis to reflect changes in the data or axis extremes. Called
	             * internally from {@link Chart#redraw}.
	             *
	             * @private
	             */
	            redraw: function() {
	
	                if (this.visible) {
	                    // render the axis
	                    this.render();
	
	                    // move plot lines and bands
	                    each(this.plotLinesAndBands, function(plotLine) {
	                        plotLine.render();
	                    });
	                }
	
	                // mark associated series as dirty and ready for redraw
	                each(this.series, function(series) {
	                    series.isDirty = true;
	                });
	
	            },
	
	            // Properties to survive after destroy, needed for Axis.update (#4317,
	            // #5773, #5881).
	            keepProps: ['extKey', 'hcEvents', 'names', 'series', 'userMax', 'userMin'],
	
	            /**
	             * Destroys an Axis instance. See {@link Axis#remove} for the API endpoint
	             * to fully remove the axis.
	             *
	             * @private
	             * @param  {Boolean} keepEvents
	             *         Whether to preserve events, used internally in Axis.update.
	             */
	            destroy: function(keepEvents) {
	                var axis = this,
	                    stacks = axis.stacks,
	                    plotLinesAndBands = axis.plotLinesAndBands,
	                    plotGroup,
	                    i;
	
	                // Remove the events
	                if (!keepEvents) {
	                    removeEvent(axis);
	                }
	
	                // Destroy each stack total
	                objectEach(stacks, function(stack, stackKey) {
	                    destroyObjectProperties(stack);
	
	                    stacks[stackKey] = null;
	                });
	
	                // Destroy collections
	                each([axis.ticks, axis.minorTicks, axis.alternateBands], function(coll) {
	                    destroyObjectProperties(coll);
	                });
	                if (plotLinesAndBands) {
	                    i = plotLinesAndBands.length;
	                    while (i--) { // #1975
	                        plotLinesAndBands[i].destroy();
	                    }
	                }
	
	                // Destroy local variables
	                each(['stackTotalGroup', 'axisLine', 'axisTitle', 'axisGroup', 'gridGroup', 'labelGroup', 'cross'], function(prop) {
	                    if (axis[prop]) {
	                        axis[prop] = axis[prop].destroy();
	                    }
	                });
	
	                // Destroy each generated group for plotlines and plotbands
	                for (plotGroup in axis.plotLinesAndBandsGroups) {
	                    axis.plotLinesAndBandsGroups[plotGroup] = axis.plotLinesAndBandsGroups[plotGroup].destroy();
	                }
	
	                // Delete all properties and fall back to the prototype.
	                objectEach(axis, function(val, key) {
	                    if (inArray(key, axis.keepProps) === -1) {
	                        delete axis[key];
	                    }
	                });
	            },
	
	            /**
	             * Internal function to draw a crosshair.
	             *
	             * @param  {PointerEvent} [e]
	             *         The event arguments from the modified pointer event, extended 
	             *         with `chartX` and `chartY`
	             * @param  {Point} [point]
	             *         The Point object if the crosshair snaps to points.
	             */
	            drawCrosshair: function(e, point) {
	
	                var path,
	                    options = this.crosshair,
	                    snap = pick(options.snap, true),
	                    pos,
	                    categorized,
	                    graphic = this.cross;
	
	                // Use last available event when updating non-snapped crosshairs without
	                // mouse interaction (#5287)
	                if (!e) {
	                    e = this.cross && this.cross.e;
	                }
	
	                if (
	                    // Disabled in options
	                    !this.crosshair ||
	                    // Snap
	                    ((defined(point) || !snap) === false)
	                ) {
	                    this.hideCrosshair();
	                } else {
	
	                    // Get the path
	                    if (!snap) {
	                        pos = e && (this.horiz ? e.chartX - this.pos : this.len - e.chartY + this.pos);
	                    } else if (defined(point)) {
	                        pos = this.isXAxis ? point.plotX : this.len - point.plotY; // #3834
	                    }
	
	                    if (defined(pos)) {
	                        path = this.getPlotLinePath(
	                            // First argument, value, only used on radial
	                            point && (this.isXAxis ? point.x : pick(point.stackY, point.y)),
	                            null,
	                            null,
	                            null,
	                            pos // Translated position
	                        ) || null; // #3189
	                    }
	
	                    if (!defined(path)) {
	                        this.hideCrosshair();
	                        return;
	                    }
	
	                    categorized = this.categories && !this.isRadial;
	
	                    // Draw the cross
	                    if (!graphic) {
	                        this.cross = graphic = this.chart.renderer
	                            .path()
	                            .addClass('highcharts-crosshair highcharts-crosshair-' +
	                                (categorized ? 'category ' : 'thin ') + options.className)
	                            .attr({
	                                zIndex: pick(options.zIndex, 2)
	                            })
	                            .add();
	
	
	                        // Presentational attributes
	                        graphic.attr({
	                            'stroke': options.color || (categorized ? color('#ccd6eb').setOpacity(0.25).get() : '#cccccc'),
	                            'stroke-width': pick(options.width, 1)
	                        });
	                        if (options.dashStyle) {
	                            graphic.attr({
	                                dashstyle: options.dashStyle
	                            });
	                        }
	
	
	                    }
	
	                    graphic.show().attr({
	                        d: path
	                    });
	
	                    if (categorized && !options.width) {
	                        graphic.attr({
	                            'stroke-width': this.transA
	                        });
	                    }
	                    this.cross.e = e;
	                }
	            },
	
	            /**
	             *	Hide the crosshair if visible.
	             */
	            hideCrosshair: function() {
	                if (this.cross) {
	                    this.cross.hide();
	                }
	            }
	        }); // end Axis
	
	        H.Axis = Axis;
	        return Axis;
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var Axis = H.Axis,
	            Date = H.Date,
	            dateFormat = H.dateFormat,
	            defaultOptions = H.defaultOptions,
	            defined = H.defined,
	            each = H.each,
	            extend = H.extend,
	            getMagnitude = H.getMagnitude,
	            getTZOffset = H.getTZOffset,
	            normalizeTickInterval = H.normalizeTickInterval,
	            pick = H.pick,
	            timeUnits = H.timeUnits;
	        /**
	         * Set the tick positions to a time unit that makes sense, for example
	         * on the first of each month or on every Monday. Return an array
	         * with the time positions. Used in datetime axes as well as for grouping
	         * data on a datetime axis.
	         *
	         * @param {Object} normalizedInterval The interval in axis values (ms) and the count
	         * @param {Number} min The minimum in axis values
	         * @param {Number} max The maximum in axis values
	         * @param {Number} startOfWeek
	         */
	        Axis.prototype.getTimeTicks = function(normalizedInterval, min, max, startOfWeek) {
	            var tickPositions = [],
	                i,
	                higherRanks = {},
	                useUTC = defaultOptions.global.useUTC,
	                minYear, // used in months and years as a basis for Date.UTC()
	                // When crossing DST, use the max. Resolves #6278.
	                minDate = new Date(min - Math.max(getTZOffset(min), getTZOffset(max))),
	                makeTime = Date.hcMakeTime,
	                interval = normalizedInterval.unitRange,
	                count = normalizedInterval.count,
	                baseOffset, // #6797
	                variableDayLength;
	
	            if (defined(min)) { // #1300
	                minDate[Date.hcSetMilliseconds](interval >= timeUnits.second ? 0 : // #3935
	                    count * Math.floor(minDate.getMilliseconds() / count)); // #3652, #3654
	
	                if (interval >= timeUnits.second) { // second
	                    minDate[Date.hcSetSeconds](interval >= timeUnits.minute ? 0 : // #3935
	                        count * Math.floor(minDate.getSeconds() / count));
	                }
	
	                if (interval >= timeUnits.minute) { // minute
	                    minDate[Date.hcSetMinutes](interval >= timeUnits.hour ? 0 :
	                        count * Math.floor(minDate[Date.hcGetMinutes]() / count));
	                }
	
	                if (interval >= timeUnits.hour) { // hour
	                    minDate[Date.hcSetHours](interval >= timeUnits.day ? 0 :
	                        count * Math.floor(minDate[Date.hcGetHours]() / count));
	                }
	
	                if (interval >= timeUnits.day) { // day
	                    minDate[Date.hcSetDate](interval >= timeUnits.month ? 1 :
	                        count * Math.floor(minDate[Date.hcGetDate]() / count));
	                }
	
	                if (interval >= timeUnits.month) { // month
	                    minDate[Date.hcSetMonth](interval >= timeUnits.year ? 0 :
	                        count * Math.floor(minDate[Date.hcGetMonth]() / count));
	                    minYear = minDate[Date.hcGetFullYear]();
	                }
	
	                if (interval >= timeUnits.year) { // year
	                    minYear -= minYear % count;
	                    minDate[Date.hcSetFullYear](minYear);
	                }
	
	                // week is a special case that runs outside the hierarchy
	                if (interval === timeUnits.week) {
	                    // get start of current week, independent of count
	                    minDate[Date.hcSetDate](minDate[Date.hcGetDate]() - minDate[Date.hcGetDay]() +
	                        pick(startOfWeek, 1));
	                }
	
	
	                // Get basics for variable time spans
	                minYear = minDate[Date.hcGetFullYear]();
	                var minMonth = minDate[Date.hcGetMonth](),
	                    minDateDate = minDate[Date.hcGetDate](),
	                    minHours = minDate[Date.hcGetHours]();
	
	
	                // Handle local timezone offset
	                if (Date.hcTimezoneOffset || Date.hcGetTimezoneOffset) {
	
	                    // Detect whether we need to take the DST crossover into
	                    // consideration. If we're crossing over DST, the day length may be
	                    // 23h or 25h and we need to compute the exact clock time for each
	                    // tick instead of just adding hours. This comes at a cost, so first
	                    // we found out if it is needed. #4951.
	                    variableDayLength =
	                        (!useUTC || !!Date.hcGetTimezoneOffset) &&
	                        (
	                            // Long range, assume we're crossing over.
	                            max - min > 4 * timeUnits.month ||
	                            // Short range, check if min and max are in different time 
	                            // zones.
	                            getTZOffset(min) !== getTZOffset(max)
	                        );
	
	                    // Adjust minDate to the offset date
	                    minDate = minDate.getTime();
	                    baseOffset = getTZOffset(minDate);
	                    minDate = new Date(minDate + baseOffset);
	                }
	
	
	                // Iterate and add tick positions at appropriate values
	                var time = minDate.getTime();
	                i = 1;
	                while (time < max) {
	                    tickPositions.push(time);
	
	                    // if the interval is years, use Date.UTC to increase years
	                    if (interval === timeUnits.year) {
	                        time = makeTime(minYear + i * count, 0);
	
	                        // if the interval is months, use Date.UTC to increase months
	                    } else if (interval === timeUnits.month) {
	                        time = makeTime(minYear, minMonth + i * count);
	
	                        // if we're using global time, the interval is not fixed as it jumps
	                        // one hour at the DST crossover
	                    } else if (
	                        variableDayLength &&
	                        (interval === timeUnits.day || interval === timeUnits.week)
	                    ) {
	                        time = makeTime(minYear, minMonth, minDateDate +
	                            i * count * (interval === timeUnits.day ? 1 : 7));
	
	                    } else if (variableDayLength && interval === timeUnits.hour) {
	                        // corrected by the start date time zone offset (baseOffset)
	                        // to hide duplicated label (#6797)
	                        time = makeTime(minYear, minMonth, minDateDate, minHours +
	                            i * count, 0, 0, baseOffset) - baseOffset;
	
	                        // else, the interval is fixed and we use simple addition
	                    } else {
	                        time += interval * count;
	                    }
	
	                    i++;
	                }
	
	                // push the last time
	                tickPositions.push(time);
	
	
	                // Handle higher ranks. Mark new days if the time is on midnight
	                // (#950, #1649, #1760, #3349). Use a reasonable dropout threshold to 
	                // prevent looping over dense data grouping (#6156).
	                if (interval <= timeUnits.hour && tickPositions.length < 10000) {
	                    each(tickPositions, function(time) {
	                        if (
	                            // Speed optimization, no need to run dateFormat unless
	                            // we're on a full or half hour
	                            time % 1800000 === 0 &&
	                            // Check for local or global midnight
	                            dateFormat('%H%M%S%L', time) === '000000000'
	                        ) {
	                            higherRanks[time] = 'day';
	                        }
	                    });
	                }
	            }
	
	
	            // record information on the chosen unit - for dynamic label formatter
	            tickPositions.info = extend(normalizedInterval, {
	                higherRanks: higherRanks,
	                totalRange: interval * count
	            });
	
	            return tickPositions;
	        };
	
	        /**
	         * Get a normalized tick interval for dates. Returns a configuration object with
	         * unit range (interval), count and name. Used to prepare data for getTimeTicks.
	         * Previously this logic was part of getTimeTicks, but as getTimeTicks now runs
	         * of segments in stock charts, the normalizing logic was extracted in order to
	         * prevent it for running over again for each segment having the same interval.
	         * #662, #697.
	         */
	        Axis.prototype.normalizeTimeTickInterval = function(tickInterval, unitsOption) {
	            var units = unitsOption || [
	                    [
	                        'millisecond', // unit name
	                        [1, 2, 5, 10, 20, 25, 50, 100, 200, 500] // allowed multiples
	                    ],
	                    [
	                        'second', [1, 2, 5, 10, 15, 30]
	                    ],
	                    [
	                        'minute', [1, 2, 5, 10, 15, 30]
	                    ],
	                    [
	                        'hour', [1, 2, 3, 4, 6, 8, 12]
	                    ],
	                    [
	                        'day', [1, 2]
	                    ],
	                    [
	                        'week', [1, 2]
	                    ],
	                    [
	                        'month', [1, 2, 3, 4, 6]
	                    ],
	                    [
	                        'year',
	                        null
	                    ]
	                ],
	                unit = units[units.length - 1], // default unit is years
	                interval = timeUnits[unit[0]],
	                multiples = unit[1],
	                count,
	                i;
	
	            // loop through the units to find the one that best fits the tickInterval
	            for (i = 0; i < units.length; i++) {
	                unit = units[i];
	                interval = timeUnits[unit[0]];
	                multiples = unit[1];
	
	
	                if (units[i + 1]) {
	                    // lessThan is in the middle between the highest multiple and the next unit.
	                    var lessThan = (interval * multiples[multiples.length - 1] +
	                        timeUnits[units[i + 1][0]]) / 2;
	
	                    // break and keep the current unit
	                    if (tickInterval <= lessThan) {
	                        break;
	                    }
	                }
	            }
	
	            // prevent 2.5 years intervals, though 25, 250 etc. are allowed
	            if (interval === timeUnits.year && tickInterval < 5 * interval) {
	                multiples = [1, 2, 5];
	            }
	
	            // get the count
	            count = normalizeTickInterval(
	                tickInterval / interval,
	                multiples,
	                unit[0] === 'year' ? Math.max(getMagnitude(tickInterval / interval), 1) : 1 // #1913, #2360
	            );
	
	            return {
	                unitRange: interval,
	                count: count,
	                unitName: unit[0]
	            };
	        };
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var Axis = H.Axis,
	            getMagnitude = H.getMagnitude,
	            map = H.map,
	            normalizeTickInterval = H.normalizeTickInterval,
	            pick = H.pick;
	        /**
	         * Methods defined on the Axis prototype
	         */
	
	        /**
	         * Set the tick positions of a logarithmic axis
	         */
	        Axis.prototype.getLogTickPositions = function(interval, min, max, minor) {
	            var axis = this,
	                options = axis.options,
	                axisLength = axis.len,
	                lin2log = axis.lin2log,
	                log2lin = axis.log2lin,
	                // Since we use this method for both major and minor ticks,
	                // use a local variable and return the result
	                positions = [];
	
	            // Reset
	            if (!minor) {
	                axis._minorAutoInterval = null;
	            }
	
	            // First case: All ticks fall on whole logarithms: 1, 10, 100 etc.
	            if (interval >= 0.5) {
	                interval = Math.round(interval);
	                positions = axis.getLinearTickPositions(interval, min, max);
	
	                // Second case: We need intermediary ticks. For example
	                // 1, 2, 4, 6, 8, 10, 20, 40 etc.
	            } else if (interval >= 0.08) {
	                var roundedMin = Math.floor(min),
	                    intermediate,
	                    i,
	                    j,
	                    len,
	                    pos,
	                    lastPos,
	                    break2;
	
	                if (interval > 0.3) {
	                    intermediate = [1, 2, 4];
	                } else if (interval > 0.15) { // 0.2 equals five minor ticks per 1, 10, 100 etc
	                    intermediate = [1, 2, 4, 6, 8];
	                } else { // 0.1 equals ten minor ticks per 1, 10, 100 etc
	                    intermediate = [1, 2, 3, 4, 5, 6, 7, 8, 9];
	                }
	
	                for (i = roundedMin; i < max + 1 && !break2; i++) {
	                    len = intermediate.length;
	                    for (j = 0; j < len && !break2; j++) {
	                        pos = log2lin(lin2log(i) * intermediate[j]);
	                        if (pos > min && (!minor || lastPos <= max) && lastPos !== undefined) { // #1670, lastPos is #3113
	                            positions.push(lastPos);
	                        }
	
	                        if (lastPos > max) {
	                            break2 = true;
	                        }
	                        lastPos = pos;
	                    }
	                }
	
	                // Third case: We are so deep in between whole logarithmic values that
	                // we might as well handle the tick positions like a linear axis. For
	                // example 1.01, 1.02, 1.03, 1.04.
	            } else {
	                var realMin = lin2log(min),
	                    realMax = lin2log(max),
	                    tickIntervalOption = options[minor ? 'minorTickInterval' : 'tickInterval'],
	                    filteredTickIntervalOption = tickIntervalOption === 'auto' ? null : tickIntervalOption,
	                    tickPixelIntervalOption = options.tickPixelInterval / (minor ? 5 : 1),
	                    totalPixelLength = minor ? axisLength / axis.tickPositions.length : axisLength;
	
	                interval = pick(
	                    filteredTickIntervalOption,
	                    axis._minorAutoInterval,
	                    (realMax - realMin) * tickPixelIntervalOption / (totalPixelLength || 1)
	                );
	
	                interval = normalizeTickInterval(
	                    interval,
	                    null,
	                    getMagnitude(interval)
	                );
	
	                positions = map(axis.getLinearTickPositions(
	                    interval,
	                    realMin,
	                    realMax
	                ), log2lin);
	
	                if (!minor) {
	                    axis._minorAutoInterval = interval / 5;
	                }
	            }
	
	            // Set the axis-level tickInterval variable
	            if (!minor) {
	                axis.tickInterval = interval;
	            }
	            return positions;
	        };
	
	        Axis.prototype.log2lin = function(num) {
	            return Math.log(num) / Math.LN10;
	        };
	
	        Axis.prototype.lin2log = function(num) {
	            return Math.pow(10, num);
	        };
	
	    }(Highcharts));
	    (function(H, Axis) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var arrayMax = H.arrayMax,
	            arrayMin = H.arrayMin,
	            defined = H.defined,
	            destroyObjectProperties = H.destroyObjectProperties,
	            each = H.each,
	            erase = H.erase,
	            merge = H.merge,
	            pick = H.pick;
	        /*
	         * The object wrapper for plot lines and plot bands
	         * @param {Object} options
	         */
	        H.PlotLineOrBand = function(axis, options) {
	            this.axis = axis;
	
	            if (options) {
	                this.options = options;
	                this.id = options.id;
	            }
	        };
	
	        H.PlotLineOrBand.prototype = {
	
	            /**
	             * Render the plot line or plot band. If it is already existing,
	             * move it.
	             */
	            render: function() {
	                var plotLine = this,
	                    axis = plotLine.axis,
	                    horiz = axis.horiz,
	                    options = plotLine.options,
	                    optionsLabel = options.label,
	                    label = plotLine.label,
	                    to = options.to,
	                    from = options.from,
	                    value = options.value,
	                    isBand = defined(from) && defined(to),
	                    isLine = defined(value),
	                    svgElem = plotLine.svgElem,
	                    isNew = !svgElem,
	                    path = [],
	                    color = options.color,
	                    zIndex = pick(options.zIndex, 0),
	                    events = options.events,
	                    attribs = {
	                        'class': 'highcharts-plot-' + (isBand ? 'band ' : 'line ') + (options.className || '')
	                    },
	                    groupAttribs = {},
	                    renderer = axis.chart.renderer,
	                    groupName = isBand ? 'bands' : 'lines',
	                    group,
	                    log2lin = axis.log2lin;
	
	                // logarithmic conversion
	                if (axis.isLog) {
	                    from = log2lin(from);
	                    to = log2lin(to);
	                    value = log2lin(value);
	                }
	
	
	                // Set the presentational attributes
	                if (isLine) {
	                    attribs = {
	                        stroke: color,
	                        'stroke-width': options.width
	                    };
	                    if (options.dashStyle) {
	                        attribs.dashstyle = options.dashStyle;
	                    }
	
	                } else if (isBand) { // plot band
	                    if (color) {
	                        attribs.fill = color;
	                    }
	                    if (options.borderWidth) {
	                        attribs.stroke = options.borderColor;
	                        attribs['stroke-width'] = options.borderWidth;
	                    }
	                }
	
	
	                // Grouping and zIndex
	                groupAttribs.zIndex = zIndex;
	                groupName += '-' + zIndex;
	
	                group = axis.plotLinesAndBandsGroups[groupName];
	                if (!group) {
	                    axis.plotLinesAndBandsGroups[groupName] = group = renderer.g('plot-' + groupName)
	                        .attr(groupAttribs).add();
	                }
	
	                // Create the path
	                if (isNew) {
	                    plotLine.svgElem = svgElem =
	                        renderer
	                        .path()
	                        .attr(attribs).add(group);
	                }
	
	
	                // Set the path or return
	                if (isLine) {
	                    path = axis.getPlotLinePath(value, svgElem.strokeWidth());
	                } else if (isBand) { // plot band
	                    path = axis.getPlotBandPath(from, to, options);
	                } else {
	                    return;
	                }
	
	
	                // common for lines and bands
	                if (isNew && path && path.length) {
	                    svgElem.attr({
	                        d: path
	                    });
	
	                    // events
	                    if (events) {
	                        H.objectEach(events, function(event, eventType) {
	                            svgElem.on(eventType, function(e) {
	                                events[eventType].apply(plotLine, [e]);
	                            });
	                        });
	                    }
	                } else if (svgElem) {
	                    if (path) {
	                        svgElem.show();
	                        svgElem.animate({
	                            d: path
	                        });
	                    } else {
	                        svgElem.hide();
	                        if (label) {
	                            plotLine.label = label = label.destroy();
	                        }
	                    }
	                }
	
	                // the plot band/line label
	                if (optionsLabel && defined(optionsLabel.text) && path && path.length &&
	                    axis.width > 0 && axis.height > 0 && !path.flat) {
	                    // apply defaults
	                    optionsLabel = merge({
	                        align: horiz && isBand && 'center',
	                        x: horiz ? !isBand && 4 : 10,
	                        verticalAlign: !horiz && isBand && 'middle',
	                        y: horiz ? isBand ? 16 : 10 : isBand ? 6 : -4,
	                        rotation: horiz && !isBand && 90
	                    }, optionsLabel);
	
	                    this.renderLabel(optionsLabel, path, isBand, zIndex);
	
	                } else if (label) { // move out of sight
	                    label.hide();
	                }
	
	                // chainable
	                return plotLine;
	            },
	
	            /**
	             * Render and align label for plot line or band.
	             */
	            renderLabel: function(optionsLabel, path, isBand, zIndex) {
	                var plotLine = this,
	                    label = plotLine.label,
	                    renderer = plotLine.axis.chart.renderer,
	                    attribs,
	                    xs,
	                    ys,
	                    x,
	                    y;
	
	                // add the SVG element
	                if (!label) {
	                    attribs = {
	                        align: optionsLabel.textAlign || optionsLabel.align,
	                        rotation: optionsLabel.rotation,
	                        'class': 'highcharts-plot-' + (isBand ? 'band' : 'line') + '-label ' + (optionsLabel.className || '')
	                    };
	
	                    attribs.zIndex = zIndex;
	
	                    plotLine.label = label = renderer.text(
	                            optionsLabel.text,
	                            0,
	                            0,
	                            optionsLabel.useHTML
	                        )
	                        .attr(attribs)
	                        .add();
	
	
	                    label.css(optionsLabel.style);
	
	                }
	
	                // get the bounding box and align the label
	                // #3000 changed to better handle choice between plotband or plotline
	                xs = [path[1], path[4], (isBand ? path[6] : path[1])];
	                ys = [path[2], path[5], (isBand ? path[7] : path[2])];
	                x = arrayMin(xs);
	                y = arrayMin(ys);
	
	                label.align(optionsLabel, false, {
	                    x: x,
	                    y: y,
	                    width: arrayMax(xs) - x,
	                    height: arrayMax(ys) - y
	                });
	                label.show();
	            },
	
	            /**
	             * Remove the plot line or band
	             */
	            destroy: function() {
	                // remove it from the lookup
	                erase(this.axis.plotLinesAndBands, this);
	
	                delete this.axis;
	                destroyObjectProperties(this);
	            }
	        };
	
	        /**
	         * Object with members for extending the Axis prototype
	         * @todo Extend directly instead of adding object to Highcharts first
	         */
	
	        H.extend(Axis.prototype, /** @lends Highcharts.Axis.prototype */ {
	
	            /**
	             * Internal function to create the SVG path definition for a plot band.
	             *
	             * @param  {Number} from
	             *         The axis value to start from.
	             * @param  {Number} to
	             *         The axis value to end on.
	             *
	             * @return {Array.<String|Number>}
	             *         The SVG path definition in array form.
	             */
	            getPlotBandPath: function(from, to) {
	                var toPath = this.getPlotLinePath(to, null, null, true),
	                    path = this.getPlotLinePath(from, null, null, true),
	                    // #4964 check if chart is inverted or plotband is on yAxis 
	                    horiz = this.horiz,
	                    plus = 1,
	                    outside =
	                    (from < this.min && to < this.min) ||
	                    (from > this.max && to > this.max);
	
	                if (path && toPath) {
	
	                    // Flat paths don't need labels (#3836)
	                    if (outside) {
	                        path.flat = path.toString() === toPath.toString();
	                        plus = 0;
	                    }
	
	                    // Add 1 pixel, when coordinates are the same
	                    path.push(
	                        horiz && toPath[4] === path[4] ? toPath[4] + plus : toPath[4], !horiz && toPath[5] === path[5] ? toPath[5] + plus : toPath[5],
	                        horiz && toPath[1] === path[1] ? toPath[1] + plus : toPath[1], !horiz && toPath[2] === path[2] ? toPath[2] + plus : toPath[2]
	                    );
	                } else { // outside the axis area
	                    path = null;
	                }
	
	                return path;
	            },
	
	            /**
	             * Add a plot band after render time.
	             *
	             * @param  {AxisPlotBandsOptions} options
	             *         A configuration object for the plot band, as defined in {@link
	             *         https://api.highcharts.com/highcharts/xAxis.plotBands|
	             *         xAxis.plotBands}.
	             * @return {Object}
	             *         The added plot band.
	             * @sample highcharts/members/axis-addplotband/
	             *         Toggle the plot band from a button
	             */
	            addPlotBand: function(options) {
	                return this.addPlotBandOrLine(options, 'plotBands');
	            },
	
	            /**
	             * Add a plot line after render time.
	             * 
	             * @param  {AxisPlotLinesOptions} options
	             *         A configuration object for the plot line, as defined in {@link
	             *         https://api.highcharts.com/highcharts/xAxis.plotLines|
	             *         xAxis.plotLines}.
	             * @return {Object}
	             *         The added plot line.
	             * @sample highcharts/members/axis-addplotline/
	             *         Toggle the plot line from a button
	             */
	            addPlotLine: function(options) {
	                return this.addPlotBandOrLine(options, 'plotLines');
	            },
	
	            /**
	             * Add a plot band or plot line after render time. Called from addPlotBand
	             * and addPlotLine internally.
	             *
	             * @private
	             * @param  options {AxisPlotLinesOptions|AxisPlotBandsOptions}
	             *         The plotBand or plotLine configuration object.
	             */
	            addPlotBandOrLine: function(options, coll) {
	                var obj = new H.PlotLineOrBand(this, options).render(),
	                    userOptions = this.userOptions;
	
	                if (obj) { // #2189
	                    // Add it to the user options for exporting and Axis.update
	                    if (coll) {
	                        userOptions[coll] = userOptions[coll] || [];
	                        userOptions[coll].push(options);
	                    }
	                    this.plotLinesAndBands.push(obj);
	                }
	
	                return obj;
	            },
	
	            /**
	             * Remove a plot band or plot line from the chart by id. Called internally
	             * from `removePlotBand` and `removePlotLine`.
	             *
	             * @private
	             * @param {String} id
	             */
	            removePlotBandOrLine: function(id) {
	                var plotLinesAndBands = this.plotLinesAndBands,
	                    options = this.options,
	                    userOptions = this.userOptions,
	                    i = plotLinesAndBands.length;
	                while (i--) {
	                    if (plotLinesAndBands[i].id === id) {
	                        plotLinesAndBands[i].destroy();
	                    }
	                }
	                each([
	                    options.plotLines || [],
	                    userOptions.plotLines || [],
	                    options.plotBands || [],
	                    userOptions.plotBands || []
	                ], function(arr) {
	                    i = arr.length;
	                    while (i--) {
	                        if (arr[i].id === id) {
	                            erase(arr, arr[i]);
	                        }
	                    }
	                });
	            },
	
	            /**
	             * Remove a plot band by its id.
	             * 
	             * @param  {String} id
	             *         The plot band's `id` as given in the original configuration
	             *         object or in the `addPlotBand` option.
	             * @sample highcharts/members/axis-removeplotband/
	             *         Remove plot band by id
	             * @sample highcharts/members/axis-addplotband/
	             *         Toggle the plot band from a button
	             */
	            removePlotBand: function(id) {
	                this.removePlotBandOrLine(id);
	            },
	
	            /**
	             * Remove a plot line by its id.
	             * @param  {String} id
	             *         The plot line's `id` as given in the original configuration
	             *         object or in the `addPlotLine` option.
	             * @sample highcharts/xaxis/plotlines-id/
	             *         Remove plot line by id
	             * @sample highcharts/members/axis-addplotline/
	             *         Toggle the plot line from a button
	             */
	            removePlotLine: function(id) {
	                this.removePlotBandOrLine(id);
	            }
	        });
	
	    }(Highcharts, Axis));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var dateFormat = H.dateFormat,
	            each = H.each,
	            extend = H.extend,
	            format = H.format,
	            isNumber = H.isNumber,
	            map = H.map,
	            merge = H.merge,
	            pick = H.pick,
	            splat = H.splat,
	            syncTimeout = H.syncTimeout,
	            timeUnits = H.timeUnits;
	        /**
	         * The tooltip object
	         * @param {Object} chart The chart instance
	         * @param {Object} options Tooltip options
	         */
	        H.Tooltip = function() {
	            this.init.apply(this, arguments);
	        };
	
	        H.Tooltip.prototype = {
	
	            init: function(chart, options) {
	
	                // Save the chart and options
	                this.chart = chart;
	                this.options = options;
	
	                // Keep track of the current series
	                //this.currentSeries = undefined;
	
	                // List of crosshairs
	                this.crosshairs = [];
	
	                // Current values of x and y when animating
	                this.now = {
	                    x: 0,
	                    y: 0
	                };
	
	                // The tooltip is initially hidden
	                this.isHidden = true;
	
	
	
	                // Public property for getting the shared state.
	                this.split = options.split && !chart.inverted;
	                this.shared = options.shared || this.split;
	
	            },
	
	            /**
	             * Destroy the single tooltips in a split tooltip.
	             * If the tooltip is active then it is not destroyed, unless forced to.
	             * @param  {boolean} force Force destroy all tooltips.
	             * @return {undefined}
	             */
	            cleanSplit: function(force) {
	                each(this.chart.series, function(series) {
	                    var tt = series && series.tt;
	                    if (tt) {
	                        if (!tt.isActive || force) {
	                            series.tt = tt.destroy();
	                        } else {
	                            tt.isActive = false;
	                        }
	                    }
	                });
	            },
	
	
	
	
	            /**
	             * Create the Tooltip label element if it doesn't exist, then return the
	             * label.
	             */
	            getLabel: function() {
	
	                var renderer = this.chart.renderer,
	                    options = this.options;
	
	                if (!this.label) {
	                    // Create the label
	                    if (this.split) {
	                        this.label = renderer.g('tooltip');
	                    } else {
	                        this.label = renderer.label(
	                                '',
	                                0,
	                                0,
	                                options.shape || 'callout',
	                                null,
	                                null,
	                                options.useHTML,
	                                null,
	                                'tooltip'
	                            )
	                            .attr({
	                                padding: options.padding,
	                                r: options.borderRadius
	                            });
	
	
	                        this.label
	                            .attr({
	                                'fill': options.backgroundColor,
	                                'stroke-width': options.borderWidth
	                            })
	                            // #2301, #2657
	                            .css(options.style)
	                            .shadow(options.shadow);
	
	                    }
	
	
	
	                    this.label
	                        .attr({
	                            zIndex: 8
	                        })
	                        .add();
	                }
	                return this.label;
	            },
	
	            update: function(options) {
	                this.destroy();
	                // Update user options (#6218)
	                merge(true, this.chart.options.tooltip.userOptions, options);
	                this.init(this.chart, merge(true, this.options, options));
	            },
	
	            /**
	             * Destroy the tooltip and its elements.
	             */
	            destroy: function() {
	                // Destroy and clear local variables
	                if (this.label) {
	                    this.label = this.label.destroy();
	                }
	                if (this.split && this.tt) {
	                    this.cleanSplit(this.chart, true);
	                    this.tt = this.tt.destroy();
	                }
	                clearTimeout(this.hideTimer);
	                clearTimeout(this.tooltipTimeout);
	            },
	
	            /**
	             * Provide a soft movement for the tooltip
	             *
	             * @param {Number} x
	             * @param {Number} y
	             * @private
	             */
	            move: function(x, y, anchorX, anchorY) {
	                var tooltip = this,
	                    now = tooltip.now,
	                    animate = tooltip.options.animation !== false && !tooltip.isHidden &&
	                    // When we get close to the target position, abort animation and land on the right place (#3056)
	                    (Math.abs(x - now.x) > 1 || Math.abs(y - now.y) > 1),
	                    skipAnchor = tooltip.followPointer || tooltip.len > 1;
	
	                // Get intermediate values for animation
	                extend(now, {
	                    x: animate ? (2 * now.x + x) / 3 : x,
	                    y: animate ? (now.y + y) / 2 : y,
	                    anchorX: skipAnchor ? undefined : animate ? (2 * now.anchorX + anchorX) / 3 : anchorX,
	                    anchorY: skipAnchor ? undefined : animate ? (now.anchorY + anchorY) / 2 : anchorY
	                });
	
	                // Move to the intermediate value
	                tooltip.getLabel().attr(now);
	
	
	                // Run on next tick of the mouse tracker
	                if (animate) {
	
	                    // Never allow two timeouts
	                    clearTimeout(this.tooltipTimeout);
	
	                    // Set the fixed interval ticking for the smooth tooltip
	                    this.tooltipTimeout = setTimeout(function() {
	                        // The interval function may still be running during destroy,
	                        // so check that the chart is really there before calling.
	                        if (tooltip) {
	                            tooltip.move(x, y, anchorX, anchorY);
	                        }
	                    }, 32);
	
	                }
	            },
	
	            /**
	             * Hide the tooltip
	             */
	            hide: function(delay) {
	                var tooltip = this;
	                clearTimeout(this.hideTimer); // disallow duplicate timers (#1728, #1766)
	                delay = pick(delay, this.options.hideDelay, 500);
	                if (!this.isHidden) {
	                    this.hideTimer = syncTimeout(function() {
	                        tooltip.getLabel()[delay ? 'fadeOut' : 'hide']();
	                        tooltip.isHidden = true;
	                    }, delay);
	                }
	            },
	
	            /**
	             * Extendable method to get the anchor position of the tooltip
	             * from a point or set of points
	             */
	            getAnchor: function(points, mouseEvent) {
	                var ret,
	                    chart = this.chart,
	                    inverted = chart.inverted,
	                    plotTop = chart.plotTop,
	                    plotLeft = chart.plotLeft,
	                    plotX = 0,
	                    plotY = 0,
	                    yAxis,
	                    xAxis;
	
	                points = splat(points);
	
	                // Pie uses a special tooltipPos
	                ret = points[0].tooltipPos;
	
	                // When tooltip follows mouse, relate the position to the mouse
	                if (this.followPointer && mouseEvent) {
	                    if (mouseEvent.chartX === undefined) {
	                        mouseEvent = chart.pointer.normalize(mouseEvent);
	                    }
	                    ret = [
	                        mouseEvent.chartX - chart.plotLeft,
	                        mouseEvent.chartY - plotTop
	                    ];
	                }
	                // When shared, use the average position
	                if (!ret) {
	                    each(points, function(point) {
	                        yAxis = point.series.yAxis;
	                        xAxis = point.series.xAxis;
	                        plotX += point.plotX + (!inverted && xAxis ? xAxis.left - plotLeft : 0);
	                        plotY += (point.plotLow ? (point.plotLow + point.plotHigh) / 2 : point.plotY) +
	                            (!inverted && yAxis ? yAxis.top - plotTop : 0); // #1151
	                    });
	
	                    plotX /= points.length;
	                    plotY /= points.length;
	
	                    ret = [
	                        inverted ? chart.plotWidth - plotY : plotX,
	                        this.shared && !inverted && points.length > 1 && mouseEvent ?
	                        mouseEvent.chartY - plotTop : // place shared tooltip next to the mouse (#424)
	                        inverted ? chart.plotHeight - plotX : plotY
	                    ];
	                }
	
	                return map(ret, Math.round);
	            },
	
	            /**
	             * Place the tooltip in a chart without spilling over
	             * and not covering the point it self.
	             */
	            getPosition: function(boxWidth, boxHeight, point) {
	
	                var chart = this.chart,
	                    distance = this.distance,
	                    ret = {},
	                    h = point.h || 0, // #4117
	                    swapped,
	                    first = ['y', chart.chartHeight, boxHeight,
	                        point.plotY + chart.plotTop, chart.plotTop,
	                        chart.plotTop + chart.plotHeight
	                    ],
	                    second = ['x', chart.chartWidth, boxWidth,
	                        point.plotX + chart.plotLeft, chart.plotLeft,
	                        chart.plotLeft + chart.plotWidth
	                    ],
	                    // The far side is right or bottom
	                    preferFarSide = !this.followPointer && pick(point.ttBelow, !chart.inverted === !!point.negative), // #4984
	                    /**
	                     * Handle the preferred dimension. When the preferred dimension is tooltip
	                     * on top or bottom of the point, it will look for space there.
	                     */
	                    firstDimension = function(dim, outerSize, innerSize, point, min, max) {
	                        var roomLeft = innerSize < point - distance,
	                            roomRight = point + distance + innerSize < outerSize,
	                            alignedLeft = point - distance - innerSize,
	                            alignedRight = point + distance;
	
	                        if (preferFarSide && roomRight) {
	                            ret[dim] = alignedRight;
	                        } else if (!preferFarSide && roomLeft) {
	                            ret[dim] = alignedLeft;
	                        } else if (roomLeft) {
	                            ret[dim] = Math.min(max - innerSize, alignedLeft - h < 0 ? alignedLeft : alignedLeft - h);
	                        } else if (roomRight) {
	                            ret[dim] = Math.max(
	                                min,
	                                alignedRight + h + innerSize > outerSize ?
	                                alignedRight :
	                                alignedRight + h
	                            );
	                        } else {
	                            return false;
	                        }
	                    },
	                    /**
	                     * Handle the secondary dimension. If the preferred dimension is tooltip
	                     * on top or bottom of the point, the second dimension is to align the tooltip
	                     * above the point, trying to align center but allowing left or right
	                     * align within the chart box.
	                     */
	                    secondDimension = function(dim, outerSize, innerSize, point) {
	                        var retVal;
	
	                        // Too close to the edge, return false and swap dimensions
	                        if (point < distance || point > outerSize - distance) {
	                            retVal = false;
	                            // Align left/top
	                        } else if (point < innerSize / 2) {
	                            ret[dim] = 1;
	                            // Align right/bottom
	                        } else if (point > outerSize - innerSize / 2) {
	                            ret[dim] = outerSize - innerSize - 2;
	                            // Align center
	                        } else {
	                            ret[dim] = point - innerSize / 2;
	                        }
	                        return retVal;
	                    },
	                    /**
	                     * Swap the dimensions
	                     */
	                    swap = function(count) {
	                        var temp = first;
	                        first = second;
	                        second = temp;
	                        swapped = count;
	                    },
	                    run = function() {
	                        if (firstDimension.apply(0, first) !== false) {
	                            if (secondDimension.apply(0, second) === false && !swapped) {
	                                swap(true);
	                                run();
	                            }
	                        } else if (!swapped) {
	                            swap(true);
	                            run();
	                        } else {
	                            ret.x = ret.y = 0;
	                        }
	                    };
	
	                // Under these conditions, prefer the tooltip on the side of the point
	                if (chart.inverted || this.len > 1) {
	                    swap();
	                }
	                run();
	
	                return ret;
	
	            },
	
	            /**
	             * In case no user defined formatter is given, this will be used. Note that the context
	             * here is an object holding point, series, x, y etc.
	             *
	             * @returns {String|Array<String>}
	             */
	            defaultFormatter: function(tooltip) {
	                var items = this.points || splat(this),
	                    s;
	
	                // Build the header
	                s = [tooltip.tooltipFooterHeaderFormatter(items[0])];
	
	                // build the values
	                s = s.concat(tooltip.bodyFormatter(items));
	
	                // footer
	                s.push(tooltip.tooltipFooterHeaderFormatter(items[0], true));
	
	                return s;
	            },
	
	            /**
	             * Refresh the tooltip's text and position.
	             * @param {Object|Array} pointOrPoints Rither a point or an array of points
	             */
	            refresh: function(pointOrPoints, mouseEvent) {
	                var tooltip = this,
	                    label,
	                    options = tooltip.options,
	                    x,
	                    y,
	                    point = pointOrPoints,
	                    anchor,
	                    textConfig = {},
	                    text,
	                    pointConfig = [],
	                    formatter = options.formatter || tooltip.defaultFormatter,
	                    shared = tooltip.shared,
	                    currentSeries;
	
	                if (!options.enabled) {
	                    return;
	                }
	
	                clearTimeout(this.hideTimer);
	
	                // get the reference point coordinates (pie charts use tooltipPos)
	                tooltip.followPointer = splat(point)[0].series.tooltipOptions.followPointer;
	                anchor = tooltip.getAnchor(point, mouseEvent);
	                x = anchor[0];
	                y = anchor[1];
	
	                // shared tooltip, array is sent over
	                if (shared && !(point.series && point.series.noSharedTooltip)) {
	                    each(point, function(item) {
	                        item.setState('hover');
	
	                        pointConfig.push(item.getLabelConfig());
	                    });
	
	                    textConfig = {
	                        x: point[0].category,
	                        y: point[0].y
	                    };
	                    textConfig.points = pointConfig;
	                    point = point[0];
	
	                    // single point tooltip
	                } else {
	                    textConfig = point.getLabelConfig();
	                }
	                this.len = pointConfig.length; // #6128
	                text = formatter.call(textConfig, tooltip);
	
	                // register the current series
	                currentSeries = point.series;
	                this.distance = pick(currentSeries.tooltipOptions.distance, 16);
	
	                // update the inner HTML
	                if (text === false) {
	                    this.hide();
	                } else {
	
	                    label = tooltip.getLabel();
	
	                    // show it
	                    if (tooltip.isHidden) {
	                        label.attr({
	                            opacity: 1
	                        }).show();
	                    }
	
	                    // update text
	                    if (tooltip.split) {
	                        this.renderSplit(text, pointOrPoints);
	                    } else {
	
	                        // Prevent the tooltip from flowing over the chart box (#6659)
	
	                        if (!options.style.width) {
	
	                            label.css({
	                                width: this.chart.spacingBox.width
	                            });
	
	                        }
	
	
	                        label.attr({
	                            text: text && text.join ? text.join('') : text
	                        });
	
	                        // Set the stroke color of the box to reflect the point
	                        label.removeClass(/highcharts-color-[\d]+/g)
	                            .addClass('highcharts-color-' + pick(point.colorIndex, currentSeries.colorIndex));
	
	
	                        label.attr({
	                            stroke: options.borderColor || point.color || currentSeries.color || '#666666'
	                        });
	
	
	                        tooltip.updatePosition({
	                            plotX: x,
	                            plotY: y,
	                            negative: point.negative,
	                            ttBelow: point.ttBelow,
	                            h: anchor[2] || 0
	                        });
	                    }
	
	                    this.isHidden = false;
	                }
	            },
	
	            /**
	             * Render the split tooltip. Loops over each point's text and adds
	             * a label next to the point, then uses the distribute function to 
	             * find best non-overlapping positions.
	             */
	            renderSplit: function(labels, points) {
	                var tooltip = this,
	                    boxes = [],
	                    chart = this.chart,
	                    ren = chart.renderer,
	                    rightAligned = true,
	                    options = this.options,
	                    headerHeight = 0,
	                    tooltipLabel = this.getLabel();
	
	                // Create the individual labels for header and points, ignore footer
	                each(labels.slice(0, points.length + 1), function(str, i) {
	                    if (str !== false) {
	                        var point = points[i - 1] ||
	                            // Item 0 is the header. Instead of this, we could also
	                            // use the crosshair label
	                            {
	                                isHeader: true,
	                                plotX: points[0].plotX
	                            },
	                            owner = point.series || tooltip,
	                            tt = owner.tt,
	                            series = point.series || {},
	                            colorClass = 'highcharts-color-' + pick(
	                                point.colorIndex,
	                                series.colorIndex,
	                                'none'
	                            ),
	                            target,
	                            x,
	                            bBox,
	                            boxWidth;
	
	                        // Store the tooltip referance on the series
	                        if (!tt) {
	                            owner.tt = tt = ren.label(null, null, null, 'callout')
	                                .addClass('highcharts-tooltip-box ' + colorClass)
	                                .attr({
	                                    'padding': options.padding,
	                                    'r': options.borderRadius,
	
	                                    'fill': options.backgroundColor,
	                                    'stroke': (
	                                        options.borderColor ||
	                                        point.color ||
	                                        series.color ||
	                                        '#333333'
	                                    ),
	                                    'stroke-width': options.borderWidth
	
	                                })
	                                .add(tooltipLabel);
	                        }
	
	                        tt.isActive = true;
	                        tt.attr({
	                            text: str
	                        });
	
	                        tt.css(options.style)
	                            .shadow(options.shadow);
	
	
	                        // Get X position now, so we can move all to the other side in
	                        // case of overflow
	                        bBox = tt.getBBox();
	                        boxWidth = bBox.width + tt.strokeWidth();
	                        if (point.isHeader) {
	                            headerHeight = bBox.height;
	                            x = Math.max(
	                                0, // No left overflow
	                                Math.min(
	                                    point.plotX + chart.plotLeft - boxWidth / 2,
	                                    // No right overflow (#5794)
	                                    chart.chartWidth - boxWidth
	                                )
	                            );
	                        } else {
	                            x = point.plotX + chart.plotLeft -
	                                pick(options.distance, 16) - boxWidth;
	                        }
	
	
	                        // If overflow left, we don't use this x in the next loop
	                        if (x < 0) {
	                            rightAligned = false;
	                        }
	
	                        // Prepare for distribution
	                        target = (point.series && point.series.yAxis &&
	                            point.series.yAxis.pos) + (point.plotY || 0);
	                        target -= chart.plotTop;
	                        boxes.push({
	                            target: point.isHeader ?
	                                chart.plotHeight + headerHeight : target,
	                            rank: point.isHeader ? 1 : 0,
	                            size: owner.tt.getBBox().height + 1,
	                            point: point,
	                            x: x,
	                            tt: tt
	                        });
	                    }
	                });
	
	                // Clean previous run (for missing points)
	                this.cleanSplit();
	
	                // Distribute and put in place
	                H.distribute(boxes, chart.plotHeight + headerHeight);
	                each(boxes, function(box) {
	                    var point = box.point,
	                        series = point.series;
	
	                    // Put the label in place
	                    box.tt.attr({
	                        visibility: box.pos === undefined ? 'hidden' : 'inherit',
	                        x: (rightAligned || point.isHeader ?
	                            box.x :
	                            point.plotX + chart.plotLeft + pick(options.distance, 16)),
	                        y: box.pos + chart.plotTop,
	                        anchorX: point.isHeader ?
	                            point.plotX + chart.plotLeft : point.plotX + series.xAxis.pos,
	                        anchorY: point.isHeader ?
	                            box.pos + chart.plotTop - 15 : point.plotY + series.yAxis.pos
	                    });
	                });
	            },
	
	            /**
	             * Find the new position and perform the move
	             */
	            updatePosition: function(point) {
	                var chart = this.chart,
	                    label = this.getLabel(),
	                    pos = (this.options.positioner || this.getPosition).call(
	                        this,
	                        label.width,
	                        label.height,
	                        point
	                    );
	
	                // do the move
	                this.move(
	                    Math.round(pos.x),
	                    Math.round(pos.y || 0), // can be undefined (#3977) 
	                    point.plotX + chart.plotLeft,
	                    point.plotY + chart.plotTop
	                );
	            },
	
	            /**
	             * Get the optimal date format for a point, based on a range.
	             * @param  {number} range - The time range
	             * @param  {number|Date} date - The date of the point in question
	             * @param  {number} startOfWeek - An integer representing the first day of
	             * the week, where 0 is Sunday
	             * @param  {Object} dateTimeLabelFormats - A map of time units to formats
	             * @return {string} - the optimal date format for a point
	             */
	            getDateFormat: function(range, date, startOfWeek, dateTimeLabelFormats) {
	                var dateStr = dateFormat('%m-%d %H:%M:%S.%L', date),
	                    format,
	                    n,
	                    blank = '01-01 00:00:00.000',
	                    strpos = {
	                        millisecond: 15,
	                        second: 12,
	                        minute: 9,
	                        hour: 6,
	                        day: 3
	                    },
	                    lastN = 'millisecond'; // for sub-millisecond data, #4223
	                for (n in timeUnits) {
	
	                    // If the range is exactly one week and we're looking at a Sunday/Monday, go for the week format
	                    if (range === timeUnits.week && +dateFormat('%w', date) === startOfWeek &&
	                        dateStr.substr(6) === blank.substr(6)) {
	                        n = 'week';
	                        break;
	                    }
	
	                    // The first format that is too great for the range
	                    if (timeUnits[n] > range) {
	                        n = lastN;
	                        break;
	                    }
	
	                    // If the point is placed every day at 23:59, we need to show
	                    // the minutes as well. #2637.
	                    if (strpos[n] && dateStr.substr(strpos[n]) !== blank.substr(strpos[n])) {
	                        break;
	                    }
	
	                    // Weeks are outside the hierarchy, only apply them on Mondays/Sundays like in the first condition
	                    if (n !== 'week') {
	                        lastN = n;
	                    }
	                }
	
	                if (n) {
	                    format = dateTimeLabelFormats[n];
	                }
	
	                return format;
	            },
	
	            /**
	             * Get the best X date format based on the closest point range on the axis.
	             */
	            getXDateFormat: function(point, options, xAxis) {
	                var xDateFormat,
	                    dateTimeLabelFormats = options.dateTimeLabelFormats,
	                    closestPointRange = xAxis && xAxis.closestPointRange;
	
	                if (closestPointRange) {
	                    xDateFormat = this.getDateFormat(
	                        closestPointRange,
	                        point.x,
	                        xAxis.options.startOfWeek,
	                        dateTimeLabelFormats
	                    );
	                } else {
	                    xDateFormat = dateTimeLabelFormats.day;
	                }
	
	                return xDateFormat || dateTimeLabelFormats.year; // #2546, 2581
	            },
	
	            /**
	             * Format the footer/header of the tooltip
	             * #3397: abstraction to enable formatting of footer and header
	             */
	            tooltipFooterHeaderFormatter: function(labelConfig, isFooter) {
	                var footOrHead = isFooter ? 'footer' : 'header',
	                    series = labelConfig.series,
	                    tooltipOptions = series.tooltipOptions,
	                    xDateFormat = tooltipOptions.xDateFormat,
	                    xAxis = series.xAxis,
	                    isDateTime = xAxis && xAxis.options.type === 'datetime' && isNumber(labelConfig.key),
	                    formatString = tooltipOptions[footOrHead + 'Format'];
	
	                // Guess the best date format based on the closest point distance (#568, #3418)
	                if (isDateTime && !xDateFormat) {
	                    xDateFormat = this.getXDateFormat(labelConfig, tooltipOptions, xAxis);
	                }
	
	                // Insert the footer date format if any
	                if (isDateTime && xDateFormat) {
	                    formatString = formatString.replace('{point.key}', '{point.key:' + xDateFormat + '}');
	                }
	
	                return format(formatString, {
	                    point: labelConfig,
	                    series: series
	                });
	            },
	
	            /**
	             * Build the body (lines) of the tooltip by iterating over the items and returning one entry for each item,
	             * abstracting this functionality allows to easily overwrite and extend it.
	             */
	            bodyFormatter: function(items) {
	                return map(items, function(item) {
	                    var tooltipOptions = item.series.tooltipOptions;
	                    return (tooltipOptions.pointFormatter || item.point.tooltipFormatter)
	                        .call(item.point, tooltipOptions.pointFormat);
	                });
	            }
	
	        };
	
	    }(Highcharts));
	    (function(Highcharts) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var H = Highcharts,
	            addEvent = H.addEvent,
	            attr = H.attr,
	            charts = H.charts,
	            color = H.color,
	            css = H.css,
	            defined = H.defined,
	            each = H.each,
	            extend = H.extend,
	            find = H.find,
	            fireEvent = H.fireEvent,
	            isObject = H.isObject,
	            offset = H.offset,
	            pick = H.pick,
	            removeEvent = H.removeEvent,
	            splat = H.splat,
	            Tooltip = H.Tooltip,
	            win = H.win;
	
	        /**
	         * The mouse and touch tracker object. Each {@link Chart} item has one
	         * assosiated Pointer item that can be accessed from the  {@link Chart.pointer}
	         * property.
	         *
	         * @class
	         * @param  {Chart} chart
	         *         The Chart instance.
	         * @param  {Options} options
	         *         The root options object. The pointer uses options from the chart and
	         *         tooltip structures.
	         */
	        Highcharts.Pointer = function(chart, options) {
	            this.init(chart, options);
	        };
	
	        Highcharts.Pointer.prototype = {
	            /**
	             * Initialize the Pointer.
	             *
	             * @private
	             */
	            init: function(chart, options) {
	
	                // Store references
	                this.options = options;
	                this.chart = chart;
	
	                // Do we need to handle click on a touch device?
	                this.runChartClick = options.chart.events && !!options.chart.events.click;
	
	                this.pinchDown = [];
	                this.lastValidTouch = {};
	
	                if (Tooltip) {
	                    chart.tooltip = new Tooltip(chart, options.tooltip);
	                    this.followTouchMove = pick(options.tooltip.followTouchMove, true);
	                }
	
	                this.setDOMEvents();
	            },
	
	            /**
	             * Resolve the zoomType option, this is reset on all touch start and mouse
	             * down events.
	             *
	             * @private
	             */
	            zoomOption: function(e) {
	                var chart = this.chart,
	                    options = chart.options.chart,
	                    zoomType = options.zoomType || '',
	                    inverted = chart.inverted,
	                    zoomX,
	                    zoomY;
	
	                // Look for the pinchType option
	                if (/touch/.test(e.type)) {
	                    zoomType = pick(options.pinchType, zoomType);
	                }
	
	                this.zoomX = zoomX = /x/.test(zoomType);
	                this.zoomY = zoomY = /y/.test(zoomType);
	                this.zoomHor = (zoomX && !inverted) || (zoomY && inverted);
	                this.zoomVert = (zoomY && !inverted) || (zoomX && inverted);
	                this.hasZoom = zoomX || zoomY;
	            },
	
	            /**
	             * @typedef  {Object} PointerEvent
	             *           A native browser mouse or touch event, extended with position
	             *           information relative to the {@link Chart.container}.
	             * @property {Number} chartX
	             *           The X coordinate of the pointer interaction relative to the
	             *           chart.
	             * @property {Number} chartY
	             *           The Y coordinate of the pointer interaction relative to the 
	             *           chart.
	             * 
	             */
	            /**
	             * Takes a browser event object and extends it with custom Highcharts
	             * properties `chartX` and `chartY` in order to work on the internal 
	             * coordinate system.
	             * 
	             * @param  {Object} e
	             *         The event object in standard browsers.
	             *
	             * @return {PointerEvent}
	             *         A browser event with extended properties `chartX` and `chartY`.
	             */
	            normalize: function(e, chartPosition) {
	                var chartX,
	                    chartY,
	                    ePos;
	
	                // IE normalizing
	                e = e || win.event;
	                if (!e.target) {
	                    e.target = e.srcElement;
	                }
	
	                // iOS (#2757)
	                ePos = e.touches ? (e.touches.length ? e.touches.item(0) : e.changedTouches[0]) : e;
	
	                // Get mouse position
	                if (!chartPosition) {
	                    this.chartPosition = chartPosition = offset(this.chart.container);
	                }
	
	                // chartX and chartY
	                if (ePos.pageX === undefined) { // IE < 9. #886.
	                    chartX = Math.max(e.x, e.clientX - chartPosition.left); // #2005, #2129: the second case is 
	                    // for IE10 quirks mode within framesets
	                    chartY = e.y;
	                } else {
	                    chartX = ePos.pageX - chartPosition.left;
	                    chartY = ePos.pageY - chartPosition.top;
	                }
	
	                return extend(e, {
	                    chartX: Math.round(chartX),
	                    chartY: Math.round(chartY)
	                });
	            },
	
	            /**
	             * Get the click position in terms of axis values.
	             *
	             * @param  {PointerEvent} e
	             *         A pointer event, extended with `chartX` and `chartY`
	             *         properties.
	             */
	            getCoordinates: function(e) {
	                var coordinates = {
	                    xAxis: [],
	                    yAxis: []
	                };
	
	                each(this.chart.axes, function(axis) {
	                    coordinates[axis.isXAxis ? 'xAxis' : 'yAxis'].push({
	                        axis: axis,
	                        value: axis.toValue(e[axis.horiz ? 'chartX' : 'chartY'])
	                    });
	                });
	                return coordinates;
	            },
	            /**
	             * Finds the closest point to a set of coordinates, using the k-d-tree
	             * algorithm.
	             *
	             * @param  {Array.<Series>} series
	             *         All the series to search in.
	             * @param  {boolean} shared
	             *         Whether it is a shared tooltip or not.
	             * @param  {object} coordinates
	             *         Chart coordinates of the pointer.
	             * @param  {number} coordinates.chartX
	             * @param  {number} coordinates.chartY
	             *
	             * @return {Point|undefined} The point closest to given coordinates.
	             */
	            findNearestKDPoint: function(series, shared, coordinates) {
	                var closest,
	                    sort = function(p1, p2) {
	                        var isCloserX = p1.distX - p2.distX,
	                            isCloser = p1.dist - p2.dist,
	                            isAbove =
	                            (p2.series.group && p2.series.group.zIndex) -
	                            (p1.series.group && p1.series.group.zIndex),
	                            result;
	
	                        // We have two points which are not in the same place on xAxis
	                        // and shared tooltip:
	                        if (isCloserX !== 0 && shared) { // #5721
	                            result = isCloserX;
	                            // Points are not exactly in the same place on x/yAxis:
	                        } else if (isCloser !== 0) {
	                            result = isCloser;
	                            // The same xAxis and yAxis position, sort by z-index:
	                        } else if (isAbove !== 0) {
	                            result = isAbove;
	                            // The same zIndex, sort by array index:
	                        } else {
	                            result = p1.series.index > p2.series.index ? -1 : 1;
	                        }
	                        return result;
	                    };
	                each(series, function(s) {
	                    var noSharedTooltip = s.noSharedTooltip && shared,
	                        compareX = (!noSharedTooltip &&
	                            s.options.findNearestPointBy.indexOf('y') < 0
	                        ),
	                        point = s.searchPoint(
	                            coordinates,
	                            compareX
	                        );
	                    if (
	                        // Check that we actually found a point on the series.
	                        isObject(point, true) &&
	                        // Use the new point if it is closer.
	                        (!isObject(closest, true) || (sort(closest, point) > 0))
	                    ) {
	                        closest = point;
	                    }
	                });
	                return closest;
	            },
	            getPointFromEvent: function(e) {
	                var target = e.target,
	                    point;
	
	                while (target && !point) {
	                    point = target.point;
	                    target = target.parentNode;
	                }
	                return point;
	            },
	
	            getChartCoordinatesFromPoint: function(point, inverted) {
	                var series = point.series,
	                    xAxis = series.xAxis,
	                    yAxis = series.yAxis;
	
	                if (xAxis && yAxis) {
	                    return inverted ? {
	                        chartX: xAxis.len + xAxis.pos - point.clientX,
	                        chartY: yAxis.len + yAxis.pos - point.plotY
	                    } : {
	                        chartX: point.clientX + xAxis.pos,
	                        chartY: point.plotY + yAxis.pos
	                    };
	                }
	            },
	
	            /**
	             * Calculates what is the current hovered point/points and series.
	             *
	             * @private
	             *
	             * @param  {undefined|Point} existingHoverPoint
	             *         The point currrently beeing hovered.
	             * @param  {undefined|Series} existingHoverSeries
	             *         The series currently beeing hovered.
	             * @param  {Array.<Series>} series
	             *         All the series in the chart.
	             * @param  {boolean} isDirectTouch
	             *         Is the pointer directly hovering the point.
	             * @param  {boolean} shared
	             *         Whether it is a shared tooltip or not.
	             * @param  {object} coordinates
	             *         Chart coordinates of the pointer.
	             * @param  {number} coordinates.chartX
	             * @param  {number} coordinates.chartY
	             * 
	             * @return {object}
	             *         Object containing resulting hover data.
	             */
	            getHoverData: function(
	                existingHoverPoint,
	                existingHoverSeries,
	                series,
	                isDirectTouch,
	                shared,
	                coordinates
	            ) {
	                var hoverPoint,
	                    hoverPoints = [],
	                    hoverSeries = existingHoverSeries,
	                    useExisting = !!(isDirectTouch && existingHoverPoint),
	                    notSticky = hoverSeries && !hoverSeries.stickyTracking,
	                    filter = function(s) {
	                        return (
	                            s.visible &&
	                            !(!shared && s.directTouch) && // #3821
	                            pick(s.options.enableMouseTracking, true)
	                        );
	                    },
	                    // Which series to look in for the hover point
	                    searchSeries = notSticky ?
	                    // Only search on hovered series if it has stickyTracking false
	                    [hoverSeries] :
	                    // Filter what series to look in.
	                    H.grep(series, function(s) {
	                        return filter(s) && s.stickyTracking;
	                    });
	
	                // Use existing hovered point or find the one closest to coordinates.
	                hoverPoint = useExisting ?
	                    existingHoverPoint :
	                    this.findNearestKDPoint(searchSeries, shared, coordinates);
	
	                // Assign hover series
	                hoverSeries = hoverPoint && hoverPoint.series;
	
	                // If we have a hoverPoint, assign hoverPoints.
	                if (hoverPoint) {
	                    // When tooltip is shared, it displays more than one point
	                    if (shared && !hoverSeries.noSharedTooltip) {
	                        searchSeries = H.grep(series, function(s) {
	                            return filter(s) && !s.noSharedTooltip;
	                        });
	
	                        // Get all points with the same x value as the hoverPoint
	                        each(searchSeries, function(s) {
	                            var point = find(s.points, function(p) {
	                                return p.x === hoverPoint.x;
	                            });
	                            if (isObject(point) && !point.isNull) {
	                                hoverPoints.push(point);
	                            }
	                        });
	                    } else {
	                        hoverPoints.push(hoverPoint);
	                    }
	                }
	
	                return {
	                    hoverPoint: hoverPoint,
	                    hoverSeries: hoverSeries,
	                    hoverPoints: hoverPoints
	                };
	            },
	            /**
	             * With line type charts with a single tracker, get the point closest to the
	             * mouse. Run Point.onMouseOver and display tooltip for the point or points.
	             *
	             * @private
	             */
	            runPointActions: function(e, p) {
	                var pointer = this,
	                    chart = pointer.chart,
	                    series = chart.series,
	                    tooltip = chart.tooltip,
	                    shared = tooltip ? tooltip.shared : false,
	                    hoverPoint = p || chart.hoverPoint,
	                    hoverSeries = hoverPoint && hoverPoint.series || chart.hoverSeries,
	                    // onMouseOver or already hovering a series with directTouch
	                    isDirectTouch = !!p || (
	                        (hoverSeries && hoverSeries.directTouch) &&
	                        pointer.isDirectTouch
	                    ),
	                    hoverData = this.getHoverData(
	                        hoverPoint,
	                        hoverSeries,
	                        series,
	                        isDirectTouch,
	                        shared,
	                        e
	                    ),
	                    useSharedTooltip,
	                    followPointer,
	                    anchor,
	                    points;
	                // Update variables from hoverData.
	                hoverPoint = hoverData.hoverPoint;
	                points = hoverData.hoverPoints;
	                hoverSeries = hoverData.hoverSeries;
	                followPointer = hoverSeries && hoverSeries.tooltipOptions.followPointer;
	                useSharedTooltip = shared && hoverSeries && !hoverSeries.noSharedTooltip;
	
	                // Refresh tooltip for kdpoint if new hover point or tooltip was hidden
	                // #3926, #4200
	                if (
	                    hoverPoint &&
	                    // !(hoverSeries && hoverSeries.directTouch) &&
	                    (hoverPoint !== chart.hoverPoint || (tooltip && tooltip.isHidden))
	                ) {
	                    each(chart.hoverPoints || [], function(p) {
	                        if (H.inArray(p, points) === -1) {
	                            p.setState();
	                        }
	                    });
	                    // Do mouseover on all points (#3919, #3985, #4410, #5622)
	                    each(points || [], function(p) {
	                        p.setState('hover');
	                    });
	                    // set normal state to previous series
	                    if (chart.hoverSeries !== hoverSeries) {
	                        hoverSeries.onMouseOver();
	                    }
	
	                    // If tracking is on series in stead of on each point, 
	                    // fire mouseOver on hover point. // #4448
	                    if (chart.hoverPoint) {
	                        chart.hoverPoint.firePointEvent('mouseOut');
	                    }
	                    hoverPoint.firePointEvent('mouseOver');
	                    chart.hoverPoints = points;
	                    chart.hoverPoint = hoverPoint;
	                    // Draw tooltip if necessary
	                    if (tooltip) {
	                        tooltip.refresh(useSharedTooltip ? points : hoverPoint, e);
	                    }
	                    // Update positions (regardless of kdpoint or hoverPoint)
	                } else if (followPointer && tooltip && !tooltip.isHidden) {
	                    anchor = tooltip.getAnchor([{}], e);
	                    tooltip.updatePosition({
	                        plotX: anchor[0],
	                        plotY: anchor[1]
	                    });
	                }
	
	                // Start the event listener to pick up the tooltip and crosshairs
	                if (!pointer.unDocMouseMove) {
	                    pointer.unDocMouseMove = addEvent(
	                        chart.container.ownerDocument,
	                        'mousemove',
	                        function(e) {
	                            var chart = charts[H.hoverChartIndex];
	                            if (chart) {
	                                chart.pointer.onDocumentMouseMove(e);
	                            }
	                        }
	                    );
	                }
	
	                // Issues related to crosshair #4927, #5269 #5066, #5658
	                each(chart.axes, function drawAxisCrosshair(axis) {
	                    var snap = pick(axis.crosshair.snap, true),
	                        point = !snap ?
	                        undefined :
	                        H.find(points, function(p) {
	                            return p.series[axis.coll] === axis;
	                        });
	
	                    // Axis has snapping crosshairs, and one of the hover points belongs
	                    // to axis. Always call drawCrosshair when it is not snap.
	                    if (point || !snap) {
	                        axis.drawCrosshair(e, point);
	                        // Axis has snapping crosshairs, but no hover point belongs to axis
	                    } else {
	                        axis.hideCrosshair();
	                    }
	                });
	            },
	
	            /**
	             * Reset the tracking by hiding the tooltip, the hover series state and the
	             * hover point
	             *
	             * @param allowMove {Boolean}
	             *        Instead of destroying the tooltip altogether, allow moving it if
	             *        possible.
	             */
	            reset: function(allowMove, delay) {
	                var pointer = this,
	                    chart = pointer.chart,
	                    hoverSeries = chart.hoverSeries,
	                    hoverPoint = chart.hoverPoint,
	                    hoverPoints = chart.hoverPoints,
	                    tooltip = chart.tooltip,
	                    tooltipPoints = tooltip && tooltip.shared ? hoverPoints : hoverPoint;
	
	                // Check if the points have moved outside the plot area (#1003, #4736, #5101)
	                if (allowMove && tooltipPoints) {
	                    each(splat(tooltipPoints), function(point) {
	                        if (point.series.isCartesian && point.plotX === undefined) {
	                            allowMove = false;
	                        }
	                    });
	                }
	
	                // Just move the tooltip, #349
	                if (allowMove) {
	                    if (tooltip && tooltipPoints) {
	                        tooltip.refresh(tooltipPoints);
	                        if (hoverPoint) { // #2500
	                            hoverPoint.setState(hoverPoint.state, true);
	                            each(chart.axes, function(axis) {
	                                if (axis.crosshair) {
	                                    axis.drawCrosshair(null, hoverPoint);
	                                }
	                            });
	                        }
	                    }
	
	                    // Full reset
	                } else {
	
	                    if (hoverPoint) {
	                        hoverPoint.onMouseOut();
	                    }
	
	                    if (hoverPoints) {
	                        each(hoverPoints, function(point) {
	                            point.setState();
	                        });
	                    }
	
	                    if (hoverSeries) {
	                        hoverSeries.onMouseOut();
	                    }
	
	                    if (tooltip) {
	                        tooltip.hide(delay);
	                    }
	
	                    if (pointer.unDocMouseMove) {
	                        pointer.unDocMouseMove = pointer.unDocMouseMove();
	                    }
	
	                    // Remove crosshairs
	                    each(chart.axes, function(axis) {
	                        axis.hideCrosshair();
	                    });
	
	                    pointer.hoverX = chart.hoverPoints = chart.hoverPoint = null;
	                }
	            },
	
	            /**
	             * Scale series groups to a certain scale and translation.
	             *
	             * @private
	             */
	            scaleGroups: function(attribs, clip) {
	
	                var chart = this.chart,
	                    seriesAttribs;
	
	                // Scale each series
	                each(chart.series, function(series) {
	                    seriesAttribs = attribs || series.getPlotBox(); // #1701
	                    if (series.xAxis && series.xAxis.zoomEnabled && series.group) {
	                        series.group.attr(seriesAttribs);
	                        if (series.markerGroup) {
	                            series.markerGroup.attr(seriesAttribs);
	                            series.markerGroup.clip(clip ? chart.clipRect : null);
	                        }
	                        if (series.dataLabelsGroup) {
	                            series.dataLabelsGroup.attr(seriesAttribs);
	                        }
	                    }
	                });
	
	                // Clip
	                chart.clipRect.attr(clip || chart.clipBox);
	            },
	
	            /**
	             * Start a drag operation.
	             *
	             * @private
	             */
	            dragStart: function(e) {
	                var chart = this.chart;
	
	                // Record the start position
	                chart.mouseIsDown = e.type;
	                chart.cancelClick = false;
	                chart.mouseDownX = this.mouseDownX = e.chartX;
	                chart.mouseDownY = this.mouseDownY = e.chartY;
	            },
	
	            /**
	             * Perform a drag operation in response to a mousemove event while the mouse
	             * is down.
	             *
	             * @private
	             */
	            drag: function(e) {
	
	                var chart = this.chart,
	                    chartOptions = chart.options.chart,
	                    chartX = e.chartX,
	                    chartY = e.chartY,
	                    zoomHor = this.zoomHor,
	                    zoomVert = this.zoomVert,
	                    plotLeft = chart.plotLeft,
	                    plotTop = chart.plotTop,
	                    plotWidth = chart.plotWidth,
	                    plotHeight = chart.plotHeight,
	                    clickedInside,
	                    size,
	                    selectionMarker = this.selectionMarker,
	                    mouseDownX = this.mouseDownX,
	                    mouseDownY = this.mouseDownY,
	                    panKey = chartOptions.panKey && e[chartOptions.panKey + 'Key'];
	
	                // If the device supports both touch and mouse (like IE11), and we are touch-dragging
	                // inside the plot area, don't handle the mouse event. #4339.
	                if (selectionMarker && selectionMarker.touch) {
	                    return;
	                }
	
	                // If the mouse is outside the plot area, adjust to cooordinates
	                // inside to prevent the selection marker from going outside
	                if (chartX < plotLeft) {
	                    chartX = plotLeft;
	                } else if (chartX > plotLeft + plotWidth) {
	                    chartX = plotLeft + plotWidth;
	                }
	
	                if (chartY < plotTop) {
	                    chartY = plotTop;
	                } else if (chartY > plotTop + plotHeight) {
	                    chartY = plotTop + plotHeight;
	                }
	
	                // determine if the mouse has moved more than 10px
	                this.hasDragged = Math.sqrt(
	                    Math.pow(mouseDownX - chartX, 2) +
	                    Math.pow(mouseDownY - chartY, 2)
	                );
	
	                if (this.hasDragged > 10) {
	                    clickedInside = chart.isInsidePlot(mouseDownX - plotLeft, mouseDownY - plotTop);
	
	                    // make a selection
	                    if (chart.hasCartesianSeries && (this.zoomX || this.zoomY) && clickedInside && !panKey) {
	                        if (!selectionMarker) {
	                            this.selectionMarker = selectionMarker = chart.renderer.rect(
	                                    plotLeft,
	                                    plotTop,
	                                    zoomHor ? 1 : plotWidth,
	                                    zoomVert ? 1 : plotHeight,
	                                    0
	                                )
	                                .attr({
	
	                                    fill: chartOptions.selectionMarkerFill || color('#335cad').setOpacity(0.25).get(),
	
	                                    'class': 'highcharts-selection-marker',
	                                    'zIndex': 7
	                                })
	                                .add();
	                        }
	                    }
	
	                    // adjust the width of the selection marker
	                    if (selectionMarker && zoomHor) {
	                        size = chartX - mouseDownX;
	                        selectionMarker.attr({
	                            width: Math.abs(size),
	                            x: (size > 0 ? 0 : size) + mouseDownX
	                        });
	                    }
	                    // adjust the height of the selection marker
	                    if (selectionMarker && zoomVert) {
	                        size = chartY - mouseDownY;
	                        selectionMarker.attr({
	                            height: Math.abs(size),
	                            y: (size > 0 ? 0 : size) + mouseDownY
	                        });
	                    }
	
	                    // panning
	                    if (clickedInside && !selectionMarker && chartOptions.panning) {
	                        chart.pan(e, chartOptions.panning);
	                    }
	                }
	            },
	
	            /**
	             * On mouse up or touch end across the entire document, drop the selection.
	             *
	             * @private
	             */
	            drop: function(e) {
	                var pointer = this,
	                    chart = this.chart,
	                    hasPinched = this.hasPinched;
	
	                if (this.selectionMarker) {
	                    var selectionData = {
	                            originalEvent: e, // #4890
	                            xAxis: [],
	                            yAxis: []
	                        },
	                        selectionBox = this.selectionMarker,
	                        selectionLeft = selectionBox.attr ? selectionBox.attr('x') : selectionBox.x,
	                        selectionTop = selectionBox.attr ? selectionBox.attr('y') : selectionBox.y,
	                        selectionWidth = selectionBox.attr ? selectionBox.attr('width') : selectionBox.width,
	                        selectionHeight = selectionBox.attr ? selectionBox.attr('height') : selectionBox.height,
	                        runZoom;
	
	                    // a selection has been made
	                    if (this.hasDragged || hasPinched) {
	
	                        // record each axis' min and max
	                        each(chart.axes, function(axis) {
	                            if (axis.zoomEnabled && defined(axis.min) && (hasPinched || pointer[{
	                                    xAxis: 'zoomX',
	                                    yAxis: 'zoomY'
	                                }[axis.coll]])) { // #859, #3569
	                                var horiz = axis.horiz,
	                                    minPixelPadding = e.type === 'touchend' ? axis.minPixelPadding : 0, // #1207, #3075
	                                    selectionMin = axis.toValue((horiz ? selectionLeft : selectionTop) + minPixelPadding),
	                                    selectionMax = axis.toValue((horiz ? selectionLeft + selectionWidth : selectionTop + selectionHeight) - minPixelPadding);
	
	                                selectionData[axis.coll].push({
	                                    axis: axis,
	                                    min: Math.min(selectionMin, selectionMax), // for reversed axes
	                                    max: Math.max(selectionMin, selectionMax)
	                                });
	                                runZoom = true;
	                            }
	                        });
	                        if (runZoom) {
	                            fireEvent(chart, 'selection', selectionData, function(args) {
	                                chart.zoom(extend(args, hasPinched ? {
	                                    animation: false
	                                } : null));
	                            });
	                        }
	
	                    }
	                    this.selectionMarker = this.selectionMarker.destroy();
	
	                    // Reset scaling preview
	                    if (hasPinched) {
	                        this.scaleGroups();
	                    }
	                }
	
	                // Reset all
	                if (chart) { // it may be destroyed on mouse up - #877
	                    css(chart.container, {
	                        cursor: chart._cursor
	                    });
	                    chart.cancelClick = this.hasDragged > 10; // #370
	                    chart.mouseIsDown = this.hasDragged = this.hasPinched = false;
	                    this.pinchDown = [];
	                }
	            },
	
	            onContainerMouseDown: function(e) {
	
	                e = this.normalize(e);
	
	                this.zoomOption(e);
	
	                // issue #295, dragging not always working in Firefox
	                if (e.preventDefault) {
	                    e.preventDefault();
	                }
	
	                this.dragStart(e);
	            },
	
	
	
	            onDocumentMouseUp: function(e) {
	                if (charts[H.hoverChartIndex]) {
	                    charts[H.hoverChartIndex].pointer.drop(e);
	                }
	            },
	
	            /**
	             * Special handler for mouse move that will hide the tooltip when the mouse
	             * leaves the plotarea. Issue #149 workaround. The mouseleave event does not
	             * always fire.
	             *
	             * @private
	             */
	            onDocumentMouseMove: function(e) {
	                var chart = this.chart,
	                    chartPosition = this.chartPosition;
	
	                e = this.normalize(e, chartPosition);
	
	                // If we're outside, hide the tooltip
	                if (chartPosition && !this.inClass(e.target, 'highcharts-tracker') &&
	                    !chart.isInsidePlot(e.chartX - chart.plotLeft, e.chartY - chart.plotTop)) {
	                    this.reset();
	                }
	            },
	
	            /**
	             * When mouse leaves the container, hide the tooltip.
	             *
	             * @private
	             */
	            onContainerMouseLeave: function(e) {
	                var chart = charts[H.hoverChartIndex];
	                if (chart && (e.relatedTarget || e.toElement)) { // #4886, MS Touch end fires mouseleave but with no related target
	                    chart.pointer.reset();
	                    chart.pointer.chartPosition = null; // also reset the chart position, used in #149 fix
	                }
	            },
	
	            // The mousemove, touchmove and touchstart event handler
	            onContainerMouseMove: function(e) {
	
	                var chart = this.chart;
	
	                if (!defined(H.hoverChartIndex) || !charts[H.hoverChartIndex] || !charts[H.hoverChartIndex].mouseIsDown) {
	                    H.hoverChartIndex = chart.index;
	                }
	
	                e = this.normalize(e);
	                e.returnValue = false; // #2251, #3224
	
	                if (chart.mouseIsDown === 'mousedown') {
	                    this.drag(e);
	                }
	
	                // Show the tooltip and run mouse over events (#977)
	                if ((this.inClass(e.target, 'highcharts-tracker') ||
	                        chart.isInsidePlot(e.chartX - chart.plotLeft, e.chartY - chart.plotTop)) && !chart.openMenu) {
	                    this.runPointActions(e);
	                }
	            },
	
	            /**
	             * Utility to detect whether an element has, or has a parent with, a specific
	             * class name. Used on detection of tracker objects and on deciding whether
	             * hovering the tooltip should cause the active series to mouse out.
	             *
	             * @param  {SVGDOMElement|HTMLDOMElement} element
	             *         The element to investigate.
	             * @param  {String} className
	             *         The class name to look for.
	             *
	             * @return {Boolean}
	             *         True if either the element or one of its parents has the given
	             *         class name.
	             */
	            inClass: function(element, className) {
	                var elemClassName;
	                while (element) {
	                    elemClassName = attr(element, 'class');
	                    if (elemClassName) {
	                        if (elemClassName.indexOf(className) !== -1) {
	                            return true;
	                        }
	                        if (elemClassName.indexOf('highcharts-container') !== -1) {
	                            return false;
	                        }
	                    }
	                    element = element.parentNode;
	                }
	            },
	
	            onTrackerMouseOut: function(e) {
	                var series = this.chart.hoverSeries,
	                    relatedTarget = e.relatedTarget || e.toElement;
	                this.isDirectTouch = false;
	                if (series && relatedTarget && !series.stickyTracking &&
	                    !this.inClass(relatedTarget, 'highcharts-tooltip') &&
	                    (!this.inClass(relatedTarget, 'highcharts-series-' + series.index) || // #2499, #4465
	                        !this.inClass(relatedTarget, 'highcharts-tracker') // #5553
	                    )
	                ) {
	                    series.onMouseOut();
	                }
	            },
	
	            onContainerClick: function(e) {
	                var chart = this.chart,
	                    hoverPoint = chart.hoverPoint,
	                    plotLeft = chart.plotLeft,
	                    plotTop = chart.plotTop;
	
	                e = this.normalize(e);
	
	                if (!chart.cancelClick) {
	
	                    // On tracker click, fire the series and point events. #783, #1583
	                    if (hoverPoint && this.inClass(e.target, 'highcharts-tracker')) {
	
	                        // the series click event
	                        fireEvent(hoverPoint.series, 'click', extend(e, {
	                            point: hoverPoint
	                        }));
	
	                        // the point click event
	                        if (chart.hoverPoint) { // it may be destroyed (#1844)
	                            hoverPoint.firePointEvent('click', e);
	                        }
	
	                        // When clicking outside a tracker, fire a chart event
	                    } else {
	                        extend(e, this.getCoordinates(e));
	
	                        // fire a click event in the chart
	                        if (chart.isInsidePlot(e.chartX - plotLeft, e.chartY - plotTop)) {
	                            fireEvent(chart, 'click', e);
	                        }
	                    }
	
	
	                }
	            },
	
	            /**
	             * Set the JS DOM events on the container and document. This method should contain
	             * a one-to-one assignment between methods and their handlers. Any advanced logic should
	             * be moved to the handler reflecting the event's name.
	             *
	             * @private
	             */
	            setDOMEvents: function() {
	
	                var pointer = this,
	                    container = pointer.chart.container,
	                    ownerDoc = container.ownerDocument;
	
	                container.onmousedown = function(e) {
	                    pointer.onContainerMouseDown(e);
	                };
	                container.onmousemove = function(e) {
	                    pointer.onContainerMouseMove(e);
	                };
	                container.onclick = function(e) {
	                    pointer.onContainerClick(e);
	                };
	                addEvent(container, 'mouseleave', pointer.onContainerMouseLeave);
	                if (H.chartCount === 1) {
	                    addEvent(
	                        ownerDoc,
	                        'mouseup',
	                        pointer.onDocumentMouseUp
	                    );
	                }
	                if (H.hasTouch) {
	                    container.ontouchstart = function(e) {
	                        pointer.onContainerTouchStart(e);
	                    };
	                    container.ontouchmove = function(e) {
	                        pointer.onContainerTouchMove(e);
	                    };
	                    if (H.chartCount === 1) {
	                        addEvent(
	                            ownerDoc,
	                            'touchend',
	                            pointer.onDocumentTouchEnd
	                        );
	                    }
	                }
	
	            },
	
	            /**
	             * Destroys the Pointer object and disconnects DOM events.
	             */
	            destroy: function() {
	                var pointer = this,
	                    ownerDoc = this.chart.container.ownerDocument;
	
	                if (pointer.unDocMouseMove) {
	                    pointer.unDocMouseMove();
	                }
	
	                removeEvent(
	                    pointer.chart.container,
	                    'mouseleave',
	                    pointer.onContainerMouseLeave
	                );
	                if (!H.chartCount) {
	                    removeEvent(ownerDoc, 'mouseup', pointer.onDocumentMouseUp);
	                    if (H.hasTouch) {
	                        removeEvent(ownerDoc, 'touchend', pointer.onDocumentTouchEnd);
	                    }
	                }
	
	                // memory and CPU leak
	                clearInterval(pointer.tooltipTimeout);
	
	                H.objectEach(pointer, function(val, prop) {
	                    pointer[prop] = null;
	                });
	            }
	        };
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var charts = H.charts,
	            each = H.each,
	            extend = H.extend,
	            map = H.map,
	            noop = H.noop,
	            pick = H.pick,
	            Pointer = H.Pointer;
	
	        /* Support for touch devices */
	        extend(Pointer.prototype, /** @lends Pointer.prototype */ {
	
	            /**
	             * Run translation operations
	             */
	            pinchTranslate: function(pinchDown, touches, transform, selectionMarker, clip, lastValidTouch) {
	                if (this.zoomHor) {
	                    this.pinchTranslateDirection(true, pinchDown, touches, transform, selectionMarker, clip, lastValidTouch);
	                }
	                if (this.zoomVert) {
	                    this.pinchTranslateDirection(false, pinchDown, touches, transform, selectionMarker, clip, lastValidTouch);
	                }
	            },
	
	            /**
	             * Run translation operations for each direction (horizontal and vertical) independently
	             */
	            pinchTranslateDirection: function(horiz, pinchDown, touches, transform,
	                selectionMarker, clip, lastValidTouch, forcedScale) {
	                var chart = this.chart,
	                    xy = horiz ? 'x' : 'y',
	                    XY = horiz ? 'X' : 'Y',
	                    sChartXY = 'chart' + XY,
	                    wh = horiz ? 'width' : 'height',
	                    plotLeftTop = chart['plot' + (horiz ? 'Left' : 'Top')],
	                    selectionWH,
	                    selectionXY,
	                    clipXY,
	                    scale = forcedScale || 1,
	                    inverted = chart.inverted,
	                    bounds = chart.bounds[horiz ? 'h' : 'v'],
	                    singleTouch = pinchDown.length === 1,
	                    touch0Start = pinchDown[0][sChartXY],
	                    touch0Now = touches[0][sChartXY],
	                    touch1Start = !singleTouch && pinchDown[1][sChartXY],
	                    touch1Now = !singleTouch && touches[1][sChartXY],
	                    outOfBounds,
	                    transformScale,
	                    scaleKey,
	                    setScale = function() {
	                        // Don't zoom if fingers are too close on this axis
	                        if (!singleTouch && Math.abs(touch0Start - touch1Start) > 20) {
	                            scale = forcedScale || Math.abs(touch0Now - touch1Now) / Math.abs(touch0Start - touch1Start);
	                        }
	
	                        clipXY = ((plotLeftTop - touch0Now) / scale) + touch0Start;
	                        selectionWH = chart['plot' + (horiz ? 'Width' : 'Height')] / scale;
	                    };
	
	                // Set the scale, first pass
	                setScale();
	
	                selectionXY = clipXY; // the clip position (x or y) is altered if out of bounds, the selection position is not
	
	                // Out of bounds
	                if (selectionXY < bounds.min) {
	                    selectionXY = bounds.min;
	                    outOfBounds = true;
	                } else if (selectionXY + selectionWH > bounds.max) {
	                    selectionXY = bounds.max - selectionWH;
	                    outOfBounds = true;
	                }
	
	                // Is the chart dragged off its bounds, determined by dataMin and dataMax?
	                if (outOfBounds) {
	
	                    // Modify the touchNow position in order to create an elastic drag movement. This indicates
	                    // to the user that the chart is responsive but can't be dragged further.
	                    touch0Now -= 0.8 * (touch0Now - lastValidTouch[xy][0]);
	                    if (!singleTouch) {
	                        touch1Now -= 0.8 * (touch1Now - lastValidTouch[xy][1]);
	                    }
	
	                    // Set the scale, second pass to adapt to the modified touchNow positions
	                    setScale();
	
	                } else {
	                    lastValidTouch[xy] = [touch0Now, touch1Now];
	                }
	
	                // Set geometry for clipping, selection and transformation
	                if (!inverted) {
	                    clip[xy] = clipXY - plotLeftTop;
	                    clip[wh] = selectionWH;
	                }
	                scaleKey = inverted ? (horiz ? 'scaleY' : 'scaleX') : 'scale' + XY;
	                transformScale = inverted ? 1 / scale : scale;
	
	                selectionMarker[wh] = selectionWH;
	                selectionMarker[xy] = selectionXY;
	                transform[scaleKey] = scale;
	                transform['translate' + XY] = (transformScale * plotLeftTop) + (touch0Now - (transformScale * touch0Start));
	            },
	
	            /**
	             * Handle touch events with two touches
	             */
	            pinch: function(e) {
	
	                var self = this,
	                    chart = self.chart,
	                    pinchDown = self.pinchDown,
	                    touches = e.touches,
	                    touchesLength = touches.length,
	                    lastValidTouch = self.lastValidTouch,
	                    hasZoom = self.hasZoom,
	                    selectionMarker = self.selectionMarker,
	                    transform = {},
	                    fireClickEvent = touchesLength === 1 && ((self.inClass(e.target, 'highcharts-tracker') &&
	                        chart.runTrackerClick) || self.runChartClick),
	                    clip = {};
	
	                // Don't initiate panning until the user has pinched. This prevents us from
	                // blocking page scrolling as users scroll down a long page (#4210).
	                if (touchesLength > 1) {
	                    self.initiated = true;
	                }
	
	                // On touch devices, only proceed to trigger click if a handler is defined
	                if (hasZoom && self.initiated && !fireClickEvent) {
	                    e.preventDefault();
	                }
	
	                // Normalize each touch
	                map(touches, function(e) {
	                    return self.normalize(e);
	                });
	
	                // Register the touch start position
	                if (e.type === 'touchstart') {
	                    each(touches, function(e, i) {
	                        pinchDown[i] = {
	                            chartX: e.chartX,
	                            chartY: e.chartY
	                        };
	                    });
	                    lastValidTouch.x = [pinchDown[0].chartX, pinchDown[1] && pinchDown[1].chartX];
	                    lastValidTouch.y = [pinchDown[0].chartY, pinchDown[1] && pinchDown[1].chartY];
	
	                    // Identify the data bounds in pixels
	                    each(chart.axes, function(axis) {
	                        if (axis.zoomEnabled) {
	                            var bounds = chart.bounds[axis.horiz ? 'h' : 'v'],
	                                minPixelPadding = axis.minPixelPadding,
	                                min = axis.toPixels(pick(axis.options.min, axis.dataMin)),
	                                max = axis.toPixels(pick(axis.options.max, axis.dataMax)),
	                                absMin = Math.min(min, max),
	                                absMax = Math.max(min, max);
	
	                            // Store the bounds for use in the touchmove handler
	                            bounds.min = Math.min(axis.pos, absMin - minPixelPadding);
	                            bounds.max = Math.max(axis.pos + axis.len, absMax + minPixelPadding);
	                        }
	                    });
	                    self.res = true; // reset on next move
	
	                    // Optionally move the tooltip on touchmove
	                } else if (self.followTouchMove && touchesLength === 1) {
	                    this.runPointActions(self.normalize(e));
	
	                    // Event type is touchmove, handle panning and pinching
	                } else if (pinchDown.length) { // can be 0 when releasing, if touchend fires first
	
	
	                    // Set the marker
	                    if (!selectionMarker) {
	                        self.selectionMarker = selectionMarker = extend({
	                            destroy: noop,
	                            touch: true
	                        }, chart.plotBox);
	                    }
	
	                    self.pinchTranslate(pinchDown, touches, transform, selectionMarker, clip, lastValidTouch);
	
	                    self.hasPinched = hasZoom;
	
	                    // Scale and translate the groups to provide visual feedback during pinching
	                    self.scaleGroups(transform, clip);
	
	                    if (self.res) {
	                        self.res = false;
	                        this.reset(false, 0);
	                    }
	                }
	            },
	
	            /**
	             * General touch handler shared by touchstart and touchmove.
	             */
	            touch: function(e, start) {
	                var chart = this.chart,
	                    hasMoved,
	                    pinchDown,
	                    isInside;
	
	                if (chart.index !== H.hoverChartIndex) {
	                    this.onContainerMouseLeave({
	                        relatedTarget: true
	                    });
	                }
	                H.hoverChartIndex = chart.index;
	
	                if (e.touches.length === 1) {
	
	                    e = this.normalize(e);
	
	                    isInside = chart.isInsidePlot(
	                        e.chartX - chart.plotLeft,
	                        e.chartY - chart.plotTop
	                    );
	                    if (isInside && !chart.openMenu) {
	
	                        // Run mouse events and display tooltip etc
	                        if (start) {
	                            this.runPointActions(e);
	                        }
	
	                        // Android fires touchmove events after the touchstart even if the
	                        // finger hasn't moved, or moved only a pixel or two. In iOS however,
	                        // the touchmove doesn't fire unless the finger moves more than ~4px.
	                        // So we emulate this behaviour in Android by checking how much it
	                        // moved, and cancelling on small distances. #3450.
	                        if (e.type === 'touchmove') {
	                            pinchDown = this.pinchDown;
	                            hasMoved = pinchDown[0] ? Math.sqrt( // #5266
	                                Math.pow(pinchDown[0].chartX - e.chartX, 2) +
	                                Math.pow(pinchDown[0].chartY - e.chartY, 2)
	                            ) >= 4 : false;
	                        }
	
	                        if (pick(hasMoved, true)) {
	                            this.pinch(e);
	                        }
	
	                    } else if (start) {
	                        // Hide the tooltip on touching outside the plot area (#1203)
	                        this.reset();
	                    }
	
	                } else if (e.touches.length === 2) {
	                    this.pinch(e);
	                }
	            },
	
	            onContainerTouchStart: function(e) {
	                this.zoomOption(e);
	                this.touch(e, true);
	            },
	
	            onContainerTouchMove: function(e) {
	                this.touch(e);
	            },
	
	            onDocumentTouchEnd: function(e) {
	                if (charts[H.hoverChartIndex]) {
	                    charts[H.hoverChartIndex].pointer.drop(e);
	                }
	            }
	
	        });
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var addEvent = H.addEvent,
	            charts = H.charts,
	            css = H.css,
	            doc = H.doc,
	            extend = H.extend,
	            hasTouch = H.hasTouch,
	            noop = H.noop,
	            Pointer = H.Pointer,
	            removeEvent = H.removeEvent,
	            win = H.win,
	            wrap = H.wrap;
	
	        if (!hasTouch && (win.PointerEvent || win.MSPointerEvent)) {
	
	            // The touches object keeps track of the points being touched at all times
	            var touches = {},
	                hasPointerEvent = !!win.PointerEvent,
	                getWebkitTouches = function() {
	                    var fake = [];
	                    fake.item = function(i) {
	                        return this[i];
	                    };
	                    H.objectEach(touches, function(touch) {
	                        fake.push({
	                            pageX: touch.pageX,
	                            pageY: touch.pageY,
	                            target: touch.target
	                        });
	                    });
	                    return fake;
	                },
	                translateMSPointer = function(e, method, wktype, func) {
	                    var p;
	                    if ((e.pointerType === 'touch' || e.pointerType === e.MSPOINTER_TYPE_TOUCH) && charts[H.hoverChartIndex]) {
	                        func(e);
	                        p = charts[H.hoverChartIndex].pointer;
	                        p[method]({
	                            type: wktype,
	                            target: e.currentTarget,
	                            preventDefault: noop,
	                            touches: getWebkitTouches()
	                        });
	                    }
	                };
	
	            /**
	             * Extend the Pointer prototype with methods for each event handler and more
	             */
	            extend(Pointer.prototype, /** @lends Pointer.prototype */ {
	                onContainerPointerDown: function(e) {
	                    translateMSPointer(e, 'onContainerTouchStart', 'touchstart', function(e) {
	                        touches[e.pointerId] = {
	                            pageX: e.pageX,
	                            pageY: e.pageY,
	                            target: e.currentTarget
	                        };
	                    });
	                },
	                onContainerPointerMove: function(e) {
	                    translateMSPointer(e, 'onContainerTouchMove', 'touchmove', function(e) {
	                        touches[e.pointerId] = {
	                            pageX: e.pageX,
	                            pageY: e.pageY
	                        };
	                        if (!touches[e.pointerId].target) {
	                            touches[e.pointerId].target = e.currentTarget;
	                        }
	                    });
	                },
	                onDocumentPointerUp: function(e) {
	                    translateMSPointer(e, 'onDocumentTouchEnd', 'touchend', function(e) {
	                        delete touches[e.pointerId];
	                    });
	                },
	
	                /**
	                 * Add or remove the MS Pointer specific events
	                 */
	                batchMSEvents: function(fn) {
	                    fn(this.chart.container, hasPointerEvent ? 'pointerdown' : 'MSPointerDown', this.onContainerPointerDown);
	                    fn(this.chart.container, hasPointerEvent ? 'pointermove' : 'MSPointerMove', this.onContainerPointerMove);
	                    fn(doc, hasPointerEvent ? 'pointerup' : 'MSPointerUp', this.onDocumentPointerUp);
	                }
	            });
	
	            // Disable default IE actions for pinch and such on chart element
	            wrap(Pointer.prototype, 'init', function(proceed, chart, options) {
	                proceed.call(this, chart, options);
	                if (this.hasZoom) { // #4014
	                    css(chart.container, {
	                        '-ms-touch-action': 'none',
	                        'touch-action': 'none'
	                    });
	                }
	            });
	
	            // Add IE specific touch events to chart
	            wrap(Pointer.prototype, 'setDOMEvents', function(proceed) {
	                proceed.apply(this);
	                if (this.hasZoom || this.followTouchMove) {
	                    this.batchMSEvents(addEvent);
	                }
	            });
	            // Destroy MS events also
	            wrap(Pointer.prototype, 'destroy', function(proceed) {
	                this.batchMSEvents(removeEvent);
	                proceed.call(this);
	            });
	        }
	
	    }(Highcharts));
	    (function(Highcharts) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var H = Highcharts,
	
	            addEvent = H.addEvent,
	            css = H.css,
	            discardElement = H.discardElement,
	            defined = H.defined,
	            each = H.each,
	            isFirefox = H.isFirefox,
	            marginNames = H.marginNames,
	            merge = H.merge,
	            pick = H.pick,
	            setAnimation = H.setAnimation,
	            stableSort = H.stableSort,
	            win = H.win,
	            wrap = H.wrap;
	
	        /**
	         * The overview of the chart's series. The legend object is instanciated
	         * internally in the chart constructor, and available from `chart.legend`. Each
	         * chart has only one legend.
	         * 
	         * @class
	         */
	        Highcharts.Legend = function(chart, options) {
	            this.init(chart, options);
	        };
	
	        Highcharts.Legend.prototype = {
	
	            /**
	             * Initialize the legend.
	             *
	             * @private
	             */
	            init: function(chart, options) {
	
	                this.chart = chart;
	
	                this.setOptions(options);
	
	                if (options.enabled) {
	
	                    // Render it
	                    this.render();
	
	                    // move checkboxes
	                    addEvent(this.chart, 'endResize', function() {
	                        this.legend.positionCheckboxes();
	                    });
	                }
	            },
	
	            setOptions: function(options) {
	
	                var padding = pick(options.padding, 8);
	
	                this.options = options;
	
	
	                this.itemStyle = options.itemStyle;
	                this.itemHiddenStyle = merge(this.itemStyle, options.itemHiddenStyle);
	
	                this.itemMarginTop = options.itemMarginTop || 0;
	                this.padding = padding;
	                this.initialItemY = padding - 5; // 5 is pixels above the text
	                this.maxItemWidth = 0;
	                this.itemHeight = 0;
	                this.symbolWidth = pick(options.symbolWidth, 16);
	                this.pages = [];
	
	            },
	
	            /**
	             * Update the legend with new options. Equivalent to running `chart.update`
	             * with a legend configuration option.
	             * @param  {LegendOptions} options
	             *         Legend options.
	             * @param  {Boolean} [redraw=true]
	             *         Whether to redraw the chart.
	             *
	             * @sample highcharts/legend/legend-update/
	             *         Legend update
	             */
	            update: function(options, redraw) {
	                var chart = this.chart;
	
	                this.setOptions(merge(true, this.options, options));
	                this.destroy();
	                chart.isDirtyLegend = chart.isDirtyBox = true;
	                if (pick(redraw, true)) {
	                    chart.redraw();
	                }
	            },
	
	            /**
	             * Set the colors for the legend item.
	             *
	             * @private
	             * @param  {Series|Point} item
	             *         A Series or Point instance
	             * @param  {Boolean} visible
	             *         Dimmed or colored
	             */
	            colorizeItem: function(item, visible) {
	                item.legendGroup[visible ? 'removeClass' : 'addClass'](
	                    'highcharts-legend-item-hidden'
	                );
	
	
	                var legend = this,
	                    options = legend.options,
	                    legendItem = item.legendItem,
	                    legendLine = item.legendLine,
	                    legendSymbol = item.legendSymbol,
	                    hiddenColor = legend.itemHiddenStyle.color,
	                    textColor = visible ? options.itemStyle.color : hiddenColor,
	                    symbolColor = visible ? (item.color || hiddenColor) : hiddenColor,
	                    markerOptions = item.options && item.options.marker,
	                    symbolAttr = {
	                        fill: symbolColor
	                    };
	
	                if (legendItem) {
	                    legendItem.css({
	                        fill: textColor,
	                        color: textColor // #1553, oldIE
	                    });
	                }
	                if (legendLine) {
	                    legendLine.attr({
	                        stroke: symbolColor
	                    });
	                }
	
	                if (legendSymbol) {
	
	                    // Apply marker options
	                    if (markerOptions && legendSymbol.isMarker) { // #585
	                        symbolAttr = item.pointAttribs();
	                        if (!visible) {
	                            symbolAttr.stroke = symbolAttr.fill = hiddenColor; // #6769
	                        }
	                    }
	
	                    legendSymbol.attr(symbolAttr);
	                }
	
	            },
	
	            /**
	             * Position the legend item.
	             *
	             * @private
	             * @param {Series|Point} item
	             *        The item to position
	             */
	            positionItem: function(item) {
	                var legend = this,
	                    options = legend.options,
	                    symbolPadding = options.symbolPadding,
	                    ltr = !options.rtl,
	                    legendItemPos = item._legendItemPos,
	                    itemX = legendItemPos[0],
	                    itemY = legendItemPos[1],
	                    checkbox = item.checkbox,
	                    legendGroup = item.legendGroup;
	
	                if (legendGroup && legendGroup.element) {
	                    legendGroup.translate(
	                        ltr ?
	                        itemX :
	                        legend.legendWidth - itemX - 2 * symbolPadding - 4,
	                        itemY
	                    );
	                }
	
	                if (checkbox) {
	                    checkbox.x = itemX;
	                    checkbox.y = itemY;
	                }
	            },
	
	            /**
	             * Destroy a single legend item, used internally on removing series items.
	             * 
	             * @param {Series|Point} item
	             *        The item to remove
	             */
	            destroyItem: function(item) {
	                var checkbox = item.checkbox;
	
	                // destroy SVG elements
	                each(
	                    ['legendItem', 'legendLine', 'legendSymbol', 'legendGroup'],
	                    function(key) {
	                        if (item[key]) {
	                            item[key] = item[key].destroy();
	                        }
	                    }
	                );
	
	                if (checkbox) {
	                    discardElement(item.checkbox);
	                }
	            },
	
	            /**
	             * Destroy the legend. Used internally. To reflow objects, `chart.redraw`
	             * must be called after destruction.
	             */
	            destroy: function() {
	                function destroyItems(key) {
	                    if (this[key]) {
	                        this[key] = this[key].destroy();
	                    }
	                }
	
	                // Destroy items
	                each(this.getAllItems(), function(item) {
	                    each(['legendItem', 'legendGroup'], destroyItems, item);
	                });
	
	                // Destroy legend elements
	                each([
	                    'clipRect',
	                    'up',
	                    'down',
	                    'pager',
	                    'nav',
	                    'box',
	                    'title',
	                    'group'
	                ], destroyItems, this);
	                this.display = null; // Reset in .render on update.
	            },
	
	            /**
	             * Position the checkboxes after the width is determined.
	             *
	             * @private
	             */
	            positionCheckboxes: function(scrollOffset) {
	                var alignAttr = this.group && this.group.alignAttr,
	                    translateY,
	                    clipHeight = this.clipHeight || this.legendHeight,
	                    titleHeight = this.titleHeight;
	
	                if (alignAttr) {
	                    translateY = alignAttr.translateY;
	                    each(this.allItems, function(item) {
	                        var checkbox = item.checkbox,
	                            top;
	
	                        if (checkbox) {
	                            top = translateY + titleHeight + checkbox.y +
	                                (scrollOffset || 0) + 3;
	                            css(checkbox, {
	                                left: (alignAttr.translateX + item.checkboxOffset +
	                                    checkbox.x - 20) + 'px',
	                                top: top + 'px',
	                                display: top > translateY - 6 && top < translateY +
	                                    clipHeight - 6 ? '' : 'none'
	                            });
	                        }
	                    });
	                }
	            },
	
	            /**
	             * Render the legend title on top of the legend.
	             *
	             * @private
	             */
	            renderTitle: function() {
	                var options = this.options,
	                    padding = this.padding,
	                    titleOptions = options.title,
	                    titleHeight = 0,
	                    bBox;
	
	                if (titleOptions.text) {
	                    if (!this.title) {
	                        this.title = this.chart.renderer.label(
	                                titleOptions.text,
	                                padding - 3,
	                                padding - 4,
	                                null,
	                                null,
	                                null,
	                                options.useHTML,
	                                null,
	                                'legend-title'
	                            )
	                            .attr({
	                                zIndex: 1
	                            })
	
	                            .css(titleOptions.style)
	
	                            .add(this.group);
	                    }
	                    bBox = this.title.getBBox();
	                    titleHeight = bBox.height;
	                    this.offsetWidth = bBox.width; // #1717
	                    this.contentGroup.attr({
	                        translateY: titleHeight
	                    });
	                }
	                this.titleHeight = titleHeight;
	            },
	
	            /**
	             * Set the legend item text.
	             *
	             * @param  {Series|Point} item
	             *         The item for which to update the text in the legend.
	             */
	            setText: function(item) {
	                var options = this.options;
	                item.legendItem.attr({
	                    text: options.labelFormat ?
	                        H.format(options.labelFormat, item) : options.labelFormatter.call(item)
	                });
	            },
	
	            /**
	             * Render a single specific legend item. Called internally from the `render`
	             * function.
	             *
	             * @private
	             * @param {Series|Point} item
	             *        The item to render.
	             */
	            renderItem: function(item) {
	                var legend = this,
	                    chart = legend.chart,
	                    renderer = chart.renderer,
	                    options = legend.options,
	                    horizontal = options.layout === 'horizontal',
	                    symbolWidth = legend.symbolWidth,
	                    symbolPadding = options.symbolPadding,
	
	                    itemStyle = legend.itemStyle,
	                    itemHiddenStyle = legend.itemHiddenStyle,
	
	                    padding = legend.padding,
	                    itemDistance = horizontal ? pick(options.itemDistance, 20) : 0,
	                    ltr = !options.rtl,
	                    itemHeight,
	                    widthOption = options.width,
	                    itemMarginBottom = options.itemMarginBottom || 0,
	                    itemMarginTop = legend.itemMarginTop,
	                    bBox,
	                    itemWidth,
	                    li = item.legendItem,
	                    isSeries = !item.series,
	                    series = !isSeries && item.series.drawLegendSymbol ?
	                    item.series :
	                    item,
	                    seriesOptions = series.options,
	                    showCheckbox = legend.createCheckboxForItem &&
	                    seriesOptions &&
	                    seriesOptions.showCheckbox,
	                    // full width minus text width
	                    itemExtraWidth = symbolWidth + symbolPadding + itemDistance +
	                    (showCheckbox ? 20 : 0),
	                    useHTML = options.useHTML,
	                    fontSize = 12,
	                    itemClassName = item.options.className;
	
	                if (!li) { // generate it once, later move it
	
	                    // Generate the group box, a group to hold the symbol and text. Text
	                    // is to be appended in Legend class.
	                    item.legendGroup = renderer.g('legend-item')
	                        .addClass(
	                            'highcharts-' + series.type + '-series ' +
	                            'highcharts-color-' + item.colorIndex +
	                            (itemClassName ? ' ' + itemClassName : '') +
	                            (isSeries ? ' highcharts-series-' + item.index : '')
	                        )
	                        .attr({
	                            zIndex: 1
	                        })
	                        .add(legend.scrollGroup);
	
	                    // Generate the list item text and add it to the group
	                    item.legendItem = li = renderer.text(
	                            '',
	                            ltr ? symbolWidth + symbolPadding : -symbolPadding,
	                            legend.baseline || 0,
	                            useHTML
	                        )
	
	                        // merge to prevent modifying original (#1021)
	                        .css(merge(item.visible ? itemStyle : itemHiddenStyle))
	
	                        .attr({
	                            align: ltr ? 'left' : 'right',
	                            zIndex: 2
	                        })
	                        .add(item.legendGroup);
	
	                    // Get the baseline for the first item - the font size is equal for
	                    // all
	                    if (!legend.baseline) {
	
	                        fontSize = itemStyle.fontSize;
	
	                        legend.fontMetrics = renderer.fontMetrics(
	                            fontSize,
	                            li
	                        );
	                        legend.baseline = legend.fontMetrics.f + 3 + itemMarginTop;
	                        li.attr('y', legend.baseline);
	                    }
	
	                    // Draw the legend symbol inside the group box
	                    legend.symbolHeight = options.symbolHeight || legend.fontMetrics.f;
	                    series.drawLegendSymbol(legend, item);
	
	                    if (legend.setItemEvents) {
	                        legend.setItemEvents(item, li, useHTML);
	                    }
	
	                    // add the HTML checkbox on top
	                    if (showCheckbox) {
	                        legend.createCheckboxForItem(item);
	                    }
	                }
	
	                // Colorize the items
	                legend.colorizeItem(item, item.visible);
	
	                // Take care of max width and text overflow (#6659)
	
	                if (!itemStyle.width) {
	
	                    li.css({
	                        width: (
	                            options.itemWidth ||
	                            options.width ||
	                            chart.spacingBox.width
	                        ) - itemExtraWidth
	                    });
	
	                }
	
	
	                // Always update the text
	                legend.setText(item);
	
	                // calculate the positions for the next line
	                bBox = li.getBBox();
	
	                itemWidth = item.checkboxOffset =
	                    options.itemWidth ||
	                    item.legendItemWidth ||
	                    bBox.width + itemExtraWidth;
	                legend.itemHeight = itemHeight = Math.round(
	                    item.legendItemHeight || bBox.height || legend.symbolHeight
	                );
	
	                // If the item exceeds the width, start a new line
	                if (
	                    horizontal &&
	                    legend.itemX - padding + itemWidth > (
	                        widthOption || (
	                            chart.spacingBox.width - 2 * padding - options.x
	                        )
	                    )
	                ) {
	                    legend.itemX = padding;
	                    legend.itemY += itemMarginTop + legend.lastLineHeight +
	                        itemMarginBottom;
	                    legend.lastLineHeight = 0; // reset for next line (#915, #3976)
	                }
	
	                // If the item exceeds the height, start a new column
	                /*if (!horizontal && legend.itemY + options.y +
	                		itemHeight > chart.chartHeight - spacingTop - spacingBottom) {
	                	legend.itemY = legend.initialItemY;
	                	legend.itemX += legend.maxItemWidth;
	                	legend.maxItemWidth = 0;
	                }*/
	
	                // Set the edge positions
	                legend.maxItemWidth = Math.max(legend.maxItemWidth, itemWidth);
	                legend.lastItemY = itemMarginTop + legend.itemY + itemMarginBottom;
	                legend.lastLineHeight = Math.max( // #915
	                    itemHeight,
	                    legend.lastLineHeight
	                );
	
	                // cache the position of the newly generated or reordered items
	                item._legendItemPos = [legend.itemX, legend.itemY];
	
	                // advance
	                if (horizontal) {
	                    legend.itemX += itemWidth;
	
	                } else {
	                    legend.itemY += itemMarginTop + itemHeight + itemMarginBottom;
	                    legend.lastLineHeight = itemHeight;
	                }
	
	                // the width of the widest item
	                legend.offsetWidth = widthOption || Math.max(
	                    (
	                        horizontal ? legend.itemX - padding - (item.checkbox ?
	                            // decrease by itemDistance only when no checkbox #4853
	                            0 :
	                            itemDistance
	                        ) : itemWidth
	                    ) + padding,
	                    legend.offsetWidth
	                );
	            },
	
	            /**
	             * Get all items, which is one item per series for most series and one
	             * item per point for pie series and its derivatives.
	             *
	             * @return {Array.<Series|Point>}
	             *         The current items in the legend.
	             */
	            getAllItems: function() {
	                var allItems = [];
	                each(this.chart.series, function(series) {
	                    var seriesOptions = series && series.options;
	
	                    // Handle showInLegend. If the series is linked to another series,
	                    // defaults to false.
	                    if (series && pick(
	                            seriesOptions.showInLegend, !defined(seriesOptions.linkedTo) ? undefined : false, true
	                        )) {
	
	                        // Use points or series for the legend item depending on
	                        // legendType
	                        allItems = allItems.concat(
	                            series.legendItems ||
	                            (
	                                seriesOptions.legendType === 'point' ?
	                                series.data :
	                                series
	                            )
	                        );
	                    }
	                });
	                return allItems;
	            },
	
	            /**
	             * Adjust the chart margins by reserving space for the legend on only one
	             * side of the chart. If the position is set to a corner, top or bottom is
	             * reserved for horizontal legends and left or right for vertical ones.
	             *
	             * @private
	             */
	            adjustMargins: function(margin, spacing) {
	                var chart = this.chart,
	                    options = this.options,
	                    // Use the first letter of each alignment option in order to detect
	                    // the side. (#4189 - use charAt(x) notation instead of [x] for IE7)
	                    alignment = options.align.charAt(0) +
	                    options.verticalAlign.charAt(0) +
	                    options.layout.charAt(0);
	
	                if (!options.floating) {
	
	                    each([
	                        /(lth|ct|rth)/,
	                        /(rtv|rm|rbv)/,
	                        /(rbh|cb|lbh)/,
	                        /(lbv|lm|ltv)/
	                    ], function(alignments, side) {
	                        if (alignments.test(alignment) && !defined(margin[side])) {
	                            // Now we have detected on which side of the chart we should
	                            // reserve space for the legend
	                            chart[marginNames[side]] = Math.max(
	                                chart[marginNames[side]],
	                                (
	                                    chart.legend[
	                                        (side + 1) % 2 ? 'legendHeight' : 'legendWidth'
	                                    ] + [1, -1, -1, 1][side] * options[
	                                        (side % 2) ? 'x' : 'y'
	                                    ] +
	                                    pick(options.margin, 12) +
	                                    spacing[side]
	                                )
	                            );
	                        }
	                    });
	                }
	            },
	
	            /**
	             * Render the legend. This method can be called both before and after
	             * `chart.render`. If called after, it will only rearrange items instead
	             * of creating new ones. Called internally on initial render and after
	             * redraws.
	             */
	            render: function() {
	                var legend = this,
	                    chart = legend.chart,
	                    renderer = chart.renderer,
	                    legendGroup = legend.group,
	                    allItems,
	                    display,
	                    legendWidth,
	                    legendHeight,
	                    box = legend.box,
	                    options = legend.options,
	                    padding = legend.padding;
	
	                legend.itemX = padding;
	                legend.itemY = legend.initialItemY;
	                legend.offsetWidth = 0;
	                legend.lastItemY = 0;
	
	                if (!legendGroup) {
	                    legend.group = legendGroup = renderer.g('legend')
	                        .attr({
	                            zIndex: 7
	                        })
	                        .add();
	                    legend.contentGroup = renderer.g()
	                        .attr({
	                            zIndex: 1
	                        }) // above background
	                        .add(legendGroup);
	                    legend.scrollGroup = renderer.g()
	                        .add(legend.contentGroup);
	                }
	
	                legend.renderTitle();
	
	                // add each series or point
	                allItems = legend.getAllItems();
	
	                // sort by legendIndex
	                stableSort(allItems, function(a, b) {
	                    return ((a.options && a.options.legendIndex) || 0) -
	                        ((b.options && b.options.legendIndex) || 0);
	                });
	
	                // reversed legend
	                if (options.reversed) {
	                    allItems.reverse();
	                }
	
	                legend.allItems = allItems;
	                legend.display = display = !!allItems.length;
	
	                // render the items
	                legend.lastLineHeight = 0;
	                each(allItems, function(item) {
	                    legend.renderItem(item);
	                });
	
	                // Get the box
	                legendWidth = (options.width || legend.offsetWidth) + padding;
	                legendHeight = legend.lastItemY + legend.lastLineHeight +
	                    legend.titleHeight;
	                legendHeight = legend.handleOverflow(legendHeight);
	                legendHeight += padding;
	
	                // Draw the border and/or background
	                if (!box) {
	                    legend.box = box = renderer.rect()
	                        .addClass('highcharts-legend-box')
	                        .attr({
	                            r: options.borderRadius
	                        })
	                        .add(legendGroup);
	                    box.isNew = true;
	                }
	
	
	                // Presentational
	                box
	                    .attr({
	                        stroke: options.borderColor,
	                        'stroke-width': options.borderWidth || 0,
	                        fill: options.backgroundColor || 'none'
	                    })
	                    .shadow(options.shadow);
	
	
	                if (legendWidth > 0 && legendHeight > 0) {
	                    box[box.isNew ? 'attr' : 'animate'](
	                        box.crisp({
	                            x: 0,
	                            y: 0,
	                            width: legendWidth,
	                            height: legendHeight
	                        }, box.strokeWidth())
	                    );
	                    box.isNew = false;
	                }
	
	                // hide the border if no items
	                box[display ? 'show' : 'hide']();
	
	
	
	                legend.legendWidth = legendWidth;
	                legend.legendHeight = legendHeight;
	
	                // Now that the legend width and height are established, put the items
	                // in the final position
	                each(allItems, function(item) {
	                    legend.positionItem(item);
	                });
	
	                // 1.x compatibility: positioning based on style
	                /*var props = ['left', 'right', 'top', 'bottom'],
	                	prop,
	                	i = 4;
	                while (i--) {
	                	prop = props[i];
	                	if (options.style[prop] && options.style[prop] !== 'auto') {
	                		options[i < 2 ? 'align' : 'verticalAlign'] = prop;
	                		options[i < 2 ? 'x' : 'y'] = 
	                			pInt(options.style[prop]) * (i % 2 ? -1 : 1);
	                	}
	                }*/
	
	                if (display) {
	                    legendGroup.align(merge(options, {
	                        width: legendWidth,
	                        height: legendHeight
	                    }), true, 'spacingBox');
	                }
	
	                if (!chart.isResizing) {
	                    this.positionCheckboxes();
	                }
	            },
	
	            /**
	             * Set up the overflow handling by adding navigation with up and down arrows
	             * below the legend.
	             *
	             * @private
	             */
	            handleOverflow: function(legendHeight) {
	                var legend = this,
	                    chart = this.chart,
	                    renderer = chart.renderer,
	                    options = this.options,
	                    optionsY = options.y,
	                    alignTop = options.verticalAlign === 'top',
	                    padding = this.padding,
	                    spaceHeight = chart.spacingBox.height +
	                    (alignTop ? -optionsY : optionsY) - padding,
	                    maxHeight = options.maxHeight,
	                    clipHeight,
	                    clipRect = this.clipRect,
	                    navOptions = options.navigation,
	                    animation = pick(navOptions.animation, true),
	                    arrowSize = navOptions.arrowSize || 12,
	                    nav = this.nav,
	                    pages = this.pages,
	                    lastY,
	                    allItems = this.allItems,
	                    clipToHeight = function(height) {
	                        if (typeof height === 'number') {
	                            clipRect.attr({
	                                height: height
	                            });
	                        } else if (clipRect) { // Reset (#5912)
	                            legend.clipRect = clipRect.destroy();
	                            legend.contentGroup.clip();
	                        }
	
	                        // useHTML
	                        if (legend.contentGroup.div) {
	                            legend.contentGroup.div.style.clip = height ?
	                                'rect(' + padding + 'px,9999px,' +
	                                (padding + height) + 'px,0)' :
	                                'auto';
	                        }
	                    };
	
	
	                // Adjust the height
	                if (
	                    options.layout === 'horizontal' &&
	                    options.verticalAlign !== 'middle' &&
	                    !options.floating
	                ) {
	                    spaceHeight /= 2;
	                }
	                if (maxHeight) {
	                    spaceHeight = Math.min(spaceHeight, maxHeight);
	                }
	
	                // Reset the legend height and adjust the clipping rectangle
	                pages.length = 0;
	                if (legendHeight > spaceHeight && navOptions.enabled !== false) {
	
	                    this.clipHeight = clipHeight =
	                        Math.max(spaceHeight - 20 - this.titleHeight - padding, 0);
	                    this.currentPage = pick(this.currentPage, 1);
	                    this.fullHeight = legendHeight;
	
	                    // Fill pages with Y positions so that the top of each a legend item
	                    // defines the scroll top for each page (#2098)
	                    each(allItems, function(item, i) {
	                        var y = item._legendItemPos[1],
	                            h = Math.round(item.legendItem.getBBox().height),
	                            len = pages.length;
	
	                        if (!len || (y - pages[len - 1] > clipHeight &&
	                                (lastY || y) !== pages[len - 1])) {
	                            pages.push(lastY || y);
	                            len++;
	                        }
	
	                        if (i === allItems.length - 1 &&
	                            y + h - pages[len - 1] > clipHeight) {
	                            pages.push(y);
	                        }
	                        if (y !== lastY) {
	                            lastY = y;
	                        }
	                    });
	
	                    // Only apply clipping if needed. Clipping causes blurred legend in
	                    // PDF export (#1787)
	                    if (!clipRect) {
	                        clipRect = legend.clipRect =
	                            renderer.clipRect(0, padding, 9999, 0);
	                        legend.contentGroup.clip(clipRect);
	                    }
	
	                    clipToHeight(clipHeight);
	
	                    // Add navigation elements
	                    if (!nav) {
	                        this.nav = nav = renderer.g()
	                            .attr({
	                                zIndex: 1
	                            })
	                            .add(this.group);
	
	                        this.up = renderer
	                            .symbol(
	                                'triangle',
	                                0,
	                                0,
	                                arrowSize,
	                                arrowSize
	                            )
	                            .on('click', function() {
	                                legend.scroll(-1, animation);
	                            })
	                            .add(nav);
	
	                        this.pager = renderer.text('', 15, 10)
	                            .addClass('highcharts-legend-navigation')
	
	                            .css(navOptions.style)
	
	                            .add(nav);
	
	                        this.down = renderer
	                            .symbol(
	                                'triangle-down',
	                                0,
	                                0,
	                                arrowSize,
	                                arrowSize
	                            )
	                            .on('click', function() {
	                                legend.scroll(1, animation);
	                            })
	                            .add(nav);
	                    }
	
	                    // Set initial position
	                    legend.scroll(0);
	
	                    legendHeight = spaceHeight;
	
	                    // Reset
	                } else if (nav) {
	                    clipToHeight();
	                    this.nav = nav.destroy(); // #6322
	                    this.scrollGroup.attr({
	                        translateY: 1
	                    });
	                    this.clipHeight = 0; // #1379
	                }
	
	                return legendHeight;
	            },
	
	            /**
	             * Scroll the legend by a number of pages.
	             * @param  {Number} scrollBy
	             *         The number of pages to scroll.
	             * @param  {AnimationOptions} animation
	             *         Whether and how to apply animation.
	             */
	            scroll: function(scrollBy, animation) {
	                var pages = this.pages,
	                    pageCount = pages.length,
	                    currentPage = this.currentPage + scrollBy,
	                    clipHeight = this.clipHeight,
	                    navOptions = this.options.navigation,
	                    pager = this.pager,
	                    padding = this.padding,
	                    scrollOffset;
	
	                // When resizing while looking at the last page
	                if (currentPage > pageCount) {
	                    currentPage = pageCount;
	                }
	
	                if (currentPage > 0) {
	
	                    if (animation !== undefined) {
	                        setAnimation(animation, this.chart);
	                    }
	
	                    this.nav.attr({
	                        translateX: padding,
	                        translateY: clipHeight + this.padding + 7 + this.titleHeight,
	                        visibility: 'visible'
	                    });
	                    this.up.attr({
	                        'class': currentPage === 1 ?
	                            'highcharts-legend-nav-inactive' : 'highcharts-legend-nav-active'
	                    });
	                    pager.attr({
	                        text: currentPage + '/' + pageCount
	                    });
	                    this.down.attr({
	                        'x': 18 + this.pager.getBBox().width, // adjust to text width
	                        'class': currentPage === pageCount ?
	                            'highcharts-legend-nav-inactive' : 'highcharts-legend-nav-active'
	                    });
	
	
	                    this.up
	                        .attr({
	                            fill: currentPage === 1 ?
	                                navOptions.inactiveColor : navOptions.activeColor
	                        })
	                        .css({
	                            cursor: currentPage === 1 ? 'default' : 'pointer'
	                        });
	                    this.down
	                        .attr({
	                            fill: currentPage === pageCount ?
	                                navOptions.inactiveColor : navOptions.activeColor
	                        })
	                        .css({
	                            cursor: currentPage === pageCount ? 'default' : 'pointer'
	                        });
	
	
	                    scrollOffset = -pages[currentPage - 1] + this.initialItemY;
	
	                    this.scrollGroup.animate({
	                        translateY: scrollOffset
	                    });
	
	                    this.currentPage = currentPage;
	                    this.positionCheckboxes(scrollOffset);
	                }
	
	            }
	
	        };
	
	        /*
	         * LegendSymbolMixin
	         */
	
	        H.LegendSymbolMixin = {
	
	            /**
	             * Get the series' symbol in the legend
	             *
	             * @param {Object} legend The legend object
	             * @param {Object} item The series (this) or point
	             */
	            drawRectangle: function(legend, item) {
	                var options = legend.options,
	                    symbolHeight = legend.symbolHeight,
	                    square = options.squareSymbol,
	                    symbolWidth = square ? symbolHeight : legend.symbolWidth;
	
	                item.legendSymbol = this.chart.renderer.rect(
	                        square ? (legend.symbolWidth - symbolHeight) / 2 : 0,
	                        legend.baseline - symbolHeight + 1, // #3988
	                        symbolWidth,
	                        symbolHeight,
	                        pick(legend.options.symbolRadius, symbolHeight / 2)
	                    )
	                    .addClass('highcharts-point')
	                    .attr({
	                        zIndex: 3
	                    }).add(item.legendGroup);
	
	            },
	
	            /**
	             * Get the series' symbol in the legend. This method should be overridable
	             * to create custom symbols through
	             * Highcharts.seriesTypes[type].prototype.drawLegendSymbols.
	             *
	             * @param {Object} legend The legend object
	             */
	            drawLineMarker: function(legend) {
	
	                var options = this.options,
	                    markerOptions = options.marker,
	                    radius,
	                    legendSymbol,
	                    symbolWidth = legend.symbolWidth,
	                    symbolHeight = legend.symbolHeight,
	                    generalRadius = symbolHeight / 2,
	                    renderer = this.chart.renderer,
	                    legendItemGroup = this.legendGroup,
	                    verticalCenter = legend.baseline -
	                    Math.round(legend.fontMetrics.b * 0.3),
	                    attr = {};
	
	                // Draw the line
	
	                attr = {
	                    'stroke-width': options.lineWidth || 0
	                };
	                if (options.dashStyle) {
	                    attr.dashstyle = options.dashStyle;
	                }
	
	
	                this.legendLine = renderer.path([
	                        'M',
	                        0,
	                        verticalCenter,
	                        'L',
	                        symbolWidth,
	                        verticalCenter
	                    ])
	                    .addClass('highcharts-graph')
	                    .attr(attr)
	                    .add(legendItemGroup);
	
	                // Draw the marker
	                if (markerOptions && markerOptions.enabled !== false) {
	
	                    // Do not allow the marker to be larger than the symbolHeight
	                    radius = Math.min(
	                        pick(markerOptions.radius, generalRadius),
	                        generalRadius
	                    );
	
	                    // Restrict symbol markers size
	                    if (this.symbol.indexOf('url') === 0) {
	                        markerOptions = merge(markerOptions, {
	                            width: symbolHeight,
	                            height: symbolHeight
	                        });
	                        radius = 0;
	                    }
	
	                    this.legendSymbol = legendSymbol = renderer.symbol(
	                            this.symbol,
	                            (symbolWidth / 2) - radius,
	                            verticalCenter - radius,
	                            2 * radius,
	                            2 * radius,
	                            markerOptions
	                        )
	                        .addClass('highcharts-point')
	                        .add(legendItemGroup);
	                    legendSymbol.isMarker = true;
	                }
	            }
	        };
	
	        // Workaround for #2030, horizontal legend items not displaying in IE11 Preview,
	        // and for #2580, a similar drawing flaw in Firefox 26.
	        // Explore if there's a general cause for this. The problem may be related
	        // to nested group elements, as the legend item texts are within 4 group
	        // elements.
	        if (/Trident\/7\.0/.test(win.navigator.userAgent) || isFirefox) {
	            wrap(Highcharts.Legend.prototype, 'positionItem', function(proceed, item) {
	                var legend = this,
	                    // If chart destroyed in sync, this is undefined (#2030)
	                    runPositionItem = function() {
	                        if (item._legendItemPos) {
	                            proceed.call(legend, item);
	                        }
	                    };
	
	                // Do it now, for export and to get checkbox placement
	                runPositionItem();
	
	                // Do it after to work around the core issue
	                setTimeout(runPositionItem);
	            });
	        }
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var addEvent = H.addEvent,
	            animate = H.animate,
	            animObject = H.animObject,
	            attr = H.attr,
	            doc = H.doc,
	            Axis = H.Axis, // @todo add as requirement
	            createElement = H.createElement,
	            defaultOptions = H.defaultOptions,
	            discardElement = H.discardElement,
	            charts = H.charts,
	            css = H.css,
	            defined = H.defined,
	            each = H.each,
	            extend = H.extend,
	            find = H.find,
	            fireEvent = H.fireEvent,
	            getStyle = H.getStyle,
	            grep = H.grep,
	            isNumber = H.isNumber,
	            isObject = H.isObject,
	            isString = H.isString,
	            Legend = H.Legend, // @todo add as requirement
	            marginNames = H.marginNames,
	            merge = H.merge,
	            objectEach = H.objectEach,
	            Pointer = H.Pointer, // @todo add as requirement
	            pick = H.pick,
	            pInt = H.pInt,
	            removeEvent = H.removeEvent,
	            seriesTypes = H.seriesTypes,
	            splat = H.splat,
	            svg = H.svg,
	            syncTimeout = H.syncTimeout,
	            win = H.win,
	            Renderer = H.Renderer;
	        /**
	         * The Chart class. The recommended constructor is {@link Highcharts#chart}.
	         * @class Highcharts.Chart
	         * @param  {String|HTMLDOMElement} renderTo
	         *         The DOM element to render to, or its id.
	         * @param  {Options} options
	         *         The chart options structure.
	         * @param  {Function} [callback]
	         *         Function to run when the chart has loaded and and all external images
	         *         are loaded. Defining a {@link
	         *         https://api.highcharts.com/highcharts/chart.events.load|chart.event.load}
	         *         handler is equivalent.
	         *
	         * @example
	         * var chart = Highcharts.chart('container', {
	         * 	   title: {
	         * 	   	   text: 'My chart'
	         * 	   },
	         * 	   series: [{
	         * 	       data: [1, 3, 2, 4]
	         * 	   }]
	         * })
	         */
	        var Chart = H.Chart = function() {
	            this.getArgs.apply(this, arguments);
	        };
	
	        /**
	         * Factory function for basic charts. 
	         *
	         * @function #chart
	         * @memberOf Highcharts
	         * @param  {String|HTMLDOMElement} renderTo - The DOM element to render to, or
	         * its id.
	         * @param  {Options} options - The chart options structure.
	         * @param  {Function} [callback] - Function to run when the chart has loaded and
	         * and all external images are loaded. Defining a {@link
	         * https://api.highcharts.com/highcharts/chart.events.load|chart.event.load}
	         * handler is equivalent.
	         * @return {Highcharts.Chart} - Returns the Chart object.
	         *
	         * @example
	         * // Render a chart in to div#container
	         * var chart = Highcharts.chart('container', {
	         *     title: {
	         *         text: 'My chart'
	         *     },
	         *     series: [{
	         *         data: [1, 3, 2, 4]
	         *     }]
	         * });
	         */
	        H.chart = function(a, b, c) {
	            return new Chart(a, b, c);
	        };
	
	        extend(Chart.prototype, /** @lends Highcharts.Chart.prototype */ {
	
	            // Hook for adding callbacks in modules
	            callbacks: [],
	
	            /**
	             * Handle the arguments passed to the constructor.
	             *
	             * @private
	             * @returns {Array} Arguments without renderTo
	             */
	            getArgs: function() {
	                var args = [].slice.call(arguments);
	
	                // Remove the optional first argument, renderTo, and
	                // set it on this.
	                if (isString(args[0]) || args[0].nodeName) {
	                    this.renderTo = args.shift();
	                }
	                this.init(args[0], args[1]);
	            },
	
	            /**
	             * Overridable function that initializes the chart. The constructor's
	             * arguments are passed on directly.
	             */
	            init: function(userOptions, callback) {
	
	                // Handle regular options
	                var options,
	                    type,
	                    seriesOptions = userOptions.series, // skip merging data points to increase performance
	                    userPlotOptions = userOptions.plotOptions || {};
	
	                userOptions.series = null;
	                options = merge(defaultOptions, userOptions); // do the merge
	
	                // Override (by copy of user options) or clear tooltip options
	                // in chart.options.plotOptions (#6218)
	                for (type in options.plotOptions) {
	                    options.plotOptions[type].tooltip = (
	                        userPlotOptions[type] &&
	                        merge(userPlotOptions[type].tooltip) // override by copy
	                    ) || undefined; // or clear
	                }
	                // User options have higher priority than default options (#6218).
	                // In case of exporting: path is changed
	                options.tooltip.userOptions = (userOptions.chart &&
	                        userOptions.chart.forExport && userOptions.tooltip.userOptions) ||
	                    userOptions.tooltip;
	
	                options.series = userOptions.series = seriesOptions; // set back the series data
	                this.userOptions = userOptions;
	
	                var optionsChart = options.chart;
	
	                var chartEvents = optionsChart.events;
	
	                this.margin = [];
	                this.spacing = [];
	
	                //this.runChartClick = chartEvents && !!chartEvents.click;
	                this.bounds = {
	                    h: {},
	                    v: {}
	                }; // Pixel data bounds for touch zoom
	
	                this.callback = callback;
	                this.isResizing = 0;
	
	                /**
	                 * The options structure for the chart. It contains members for the sub
	                 * elements like series, legend, tooltip etc.
	                 *
	                 * @memberof Highcharts.Chart
	                 * @name options
	                 * @type {Options}
	                 */
	                this.options = options;
	                /**
	                 * All the axes in the chart.
	                 *
	                 * @memberof Highcharts.Chart
	                 * @name axes
	                 * @see  Highcharts.Chart.xAxis
	                 * @see  Highcharts.Chart.yAxis
	                 * @type {Array.<Highcharts.Axis>}
	                 */
	                this.axes = [];
	
	                /**
	                 * All the current series in the chart.
	                 *
	                 * @memberof Highcharts.Chart
	                 * @name series
	                 * @type {Array.<Highcharts.Series>}
	                 */
	                this.series = [];
	
	                /**
	                 * The chart title. The title has an `update` method that allows
	                 * modifying the options directly or indirectly via `chart.update`.
	                 *
	                 * @memberof Highcharts.Chart
	                 * @name title
	                 * @type Object
	                 *
	                 * @sample highcharts/members/title-update/
	                 *         Updating titles
	                 */
	
	                /**
	                 * The chart subtitle. The subtitle has an `update` method that allows
	                 * modifying the options directly or indirectly via `chart.update`.
	                 *
	                 * @memberof Highcharts.Chart
	                 * @name subtitle
	                 * @type Object
	                 */
	
	
	
	                this.hasCartesianSeries = optionsChart.showAxes;
	                //this.axisOffset = undefined;
	                //this.inverted = undefined;
	                //this.loadingShown = undefined;
	                //this.container = undefined;
	                //this.chartWidth = undefined;
	                //this.chartHeight = undefined;
	                //this.marginRight = undefined;
	                //this.marginBottom = undefined;
	                //this.containerWidth = undefined;
	                //this.containerHeight = undefined;
	                //this.oldChartWidth = undefined;
	                //this.oldChartHeight = undefined;
	
	                //this.renderTo = undefined;
	
	                //this.spacingBox = undefined
	
	                //this.legend = undefined;
	
	                // Elements
	                //this.chartBackground = undefined;
	                //this.plotBackground = undefined;
	                //this.plotBGImage = undefined;
	                //this.plotBorder = undefined;
	                //this.loadingDiv = undefined;
	                //this.loadingSpan = undefined;
	
	                var chart = this;
	
	                // Add the chart to the global lookup
	                chart.index = charts.length;
	
	                charts.push(chart);
	                H.chartCount++;
	
	                // Chart event handlers
	                if (chartEvents) {
	                    objectEach(chartEvents, function(event, eventType) {
	                        addEvent(chart, eventType, event);
	                    });
	                }
	
	                /**
	                 * A collection of the X axes in the chart.
	                 * @type {Array.<Highcharts.Axis>}
	                 * @name xAxis
	                 * @memberOf Highcharts.Chart
	                 */
	                chart.xAxis = [];
	                /**
	                 * A collection of the Y axes in the chart.
	                 * @type {Array.<Highcharts.Axis>}
	                 * @name yAxis
	                 * @memberOf Highcharts.Chart
	                 */
	                chart.yAxis = [];
	
	                chart.pointCount = chart.colorCounter = chart.symbolCounter = 0;
	
	                chart.firstRender();
	            },
	
	            /**
	             * Internal function to unitialize an individual series.
	             *
	             * @private
	             */
	            initSeries: function(options) {
	                var chart = this,
	                    optionsChart = chart.options.chart,
	                    type = options.type || optionsChart.type || optionsChart.defaultSeriesType,
	                    series,
	                    Constr = seriesTypes[type];
	
	                // No such series type
	                if (!Constr) {
	                    H.error(17, true);
	                }
	
	                series = new Constr();
	                series.init(this, options);
	                return series;
	            },
	
	            /**
	             * Order all series above a given index. When series are added and ordered
	             * by configuration, only the last series is handled (#248, #1123, #2456,
	             * #6112). This function is called on series initialization and destroy.
	             *
	             * @private
	             *
	             * @param  {number} fromIndex
	             *         If this is given, only the series above this index are handled.
	             */
	            orderSeries: function(fromIndex) {
	                var series = this.series,
	                    i = fromIndex || 0;
	                for (; i < series.length; i++) {
	                    if (series[i]) {
	                        series[i].index = i;
	                        series[i].name = series[i].name ||
	                            'Series ' + (series[i].index + 1);
	                    }
	                }
	            },
	
	            /**
	             * Check whether a given point is within the plot area.
	             *
	             * @param  {Number} plotX
	             *         Pixel x relative to the plot area.
	             * @param  {Number} plotY
	             *         Pixel y relative to the plot area.
	             * @param  {Boolean} inverted
	             *         Whether the chart is inverted.
	             *
	             * @return {Boolean}
	             *         Returns true if the given point is inside the plot area.
	             */
	            isInsidePlot: function(plotX, plotY, inverted) {
	                var x = inverted ? plotY : plotX,
	                    y = inverted ? plotX : plotY;
	
	                return x >= 0 &&
	                    x <= this.plotWidth &&
	                    y >= 0 &&
	                    y <= this.plotHeight;
	            },
	
	            /**
	             * Redraw the chart after changes have been done to the data, axis extremes
	             * chart size or chart elements. All methods for updating axes, series or
	             * points have a parameter for redrawing the chart. This is `true` by
	             * default. But in many cases you want to do more than one operation on the
	             * chart before redrawing, for example add a number of points. In those
	             * cases it is a waste of resources to redraw the chart for each new point
	             * added. So you add the points and call `chart.redraw()` after.
	             *
	             * @param  {AnimationOptions} animation
	             *         If or how to apply animation to the redraw.
	             */
	            redraw: function(animation) {
	                var chart = this,
	                    axes = chart.axes,
	                    series = chart.series,
	                    pointer = chart.pointer,
	                    legend = chart.legend,
	                    redrawLegend = chart.isDirtyLegend,
	                    hasStackedSeries,
	                    hasDirtyStacks,
	                    hasCartesianSeries = chart.hasCartesianSeries,
	                    isDirtyBox = chart.isDirtyBox,
	                    i,
	                    serie,
	                    renderer = chart.renderer,
	                    isHiddenChart = renderer.isHidden(),
	                    afterRedraw = [];
	
	                // Handle responsive rules, not only on resize (#6130)
	                if (chart.setResponsive) {
	                    chart.setResponsive(false);
	                }
	
	                H.setAnimation(animation, chart);
	
	                if (isHiddenChart) {
	                    chart.temporaryDisplay();
	                }
	
	                // Adjust title layout (reflow multiline text)
	                chart.layOutTitles();
	
	                // link stacked series
	                i = series.length;
	                while (i--) {
	                    serie = series[i];
	
	                    if (serie.options.stacking) {
	                        hasStackedSeries = true;
	
	                        if (serie.isDirty) {
	                            hasDirtyStacks = true;
	                            break;
	                        }
	                    }
	                }
	                if (hasDirtyStacks) { // mark others as dirty
	                    i = series.length;
	                    while (i--) {
	                        serie = series[i];
	                        if (serie.options.stacking) {
	                            serie.isDirty = true;
	                        }
	                    }
	                }
	
	                // Handle updated data in the series
	                each(series, function(serie) {
	                    if (serie.isDirty) {
	                        if (serie.options.legendType === 'point') {
	                            if (serie.updateTotals) {
	                                serie.updateTotals();
	                            }
	                            redrawLegend = true;
	                        }
	                    }
	                    if (serie.isDirtyData) {
	                        fireEvent(serie, 'updatedData');
	                    }
	                });
	
	                // handle added or removed series
	                if (redrawLegend && legend.options.enabled) { // series or pie points are added or removed
	                    // draw legend graphics
	                    legend.render();
	
	                    chart.isDirtyLegend = false;
	                }
	
	                // reset stacks
	                if (hasStackedSeries) {
	                    chart.getStacks();
	                }
	
	
	                if (hasCartesianSeries) {
	                    // set axes scales
	                    each(axes, function(axis) {
	                        axis.updateNames();
	                        axis.setScale();
	                    });
	                }
	
	                chart.getMargins(); // #3098
	
	                if (hasCartesianSeries) {
	                    // If one axis is dirty, all axes must be redrawn (#792, #2169)
	                    each(axes, function(axis) {
	                        if (axis.isDirty) {
	                            isDirtyBox = true;
	                        }
	                    });
	
	                    // redraw axes
	                    each(axes, function(axis) {
	
	                        // Fire 'afterSetExtremes' only if extremes are set
	                        var key = axis.min + ',' + axis.max;
	                        if (axis.extKey !== key) { // #821, #4452
	                            axis.extKey = key;
	                            afterRedraw.push(function() { // prevent a recursive call to chart.redraw() (#1119)
	                                fireEvent(axis, 'afterSetExtremes', extend(axis.eventArgs, axis.getExtremes())); // #747, #751
	                                delete axis.eventArgs;
	                            });
	                        }
	                        if (isDirtyBox || hasStackedSeries) {
	                            axis.redraw();
	                        }
	                    });
	                }
	
	                // the plot areas size has changed
	                if (isDirtyBox) {
	                    chart.drawChartBox();
	                }
	
	                // Fire an event before redrawing series, used by the boost module to
	                // clear previous series renderings.
	                fireEvent(chart, 'predraw');
	
	                // redraw affected series
	                each(series, function(serie) {
	                    if ((isDirtyBox || serie.isDirty) && serie.visible) {
	                        serie.redraw();
	                    }
	                    // Set it here, otherwise we will have unlimited 'updatedData' calls
	                    // for a hidden series after setData(). Fixes #6012
	                    serie.isDirtyData = false;
	                });
	
	                // move tooltip or reset
	                if (pointer) {
	                    pointer.reset(true);
	                }
	
	                // redraw if canvas
	                renderer.draw();
	
	                // Fire the events
	                fireEvent(chart, 'redraw');
	                fireEvent(chart, 'render');
	
	                if (isHiddenChart) {
	                    chart.temporaryDisplay(true);
	                }
	
	                // Fire callbacks that are put on hold until after the redraw
	                each(afterRedraw, function(callback) {
	                    callback.call();
	                });
	            },
	
	            /**
	             * Get an axis, series or point object by `id` as given in the configuration
	             * options. Returns `undefined` if no item is found.
	             * @param id {String} The id as given in the configuration options.
	             * @return {Highcharts.Axis|Highcharts.Series|Highcharts.Point|undefined}
	             *         The retrieved item.
	             * @sample highcharts/plotoptions/series-id/
	             *         Get series by id
	             */
	            get: function(id) {
	
	                var ret,
	                    series = this.series,
	                    i;
	
	                function itemById(item) {
	                    return item.id === id || (item.options && item.options.id === id);
	                }
	
	                ret =
	                    // Search axes
	                    find(this.axes, itemById) ||
	
	                    // Search series
	                    find(this.series, itemById);
	
	                // Search points
	                for (i = 0; !ret && i < series.length; i++) {
	                    ret = find(series[i].points || [], itemById);
	                }
	
	                return ret;
	            },
	
	            /**
	             * Create the Axis instances based on the config options.
	             *
	             * @private
	             */
	            getAxes: function() {
	                var chart = this,
	                    options = this.options,
	                    xAxisOptions = options.xAxis = splat(options.xAxis || {}),
	                    yAxisOptions = options.yAxis = splat(options.yAxis || {}),
	                    optionsArray;
	
	                // make sure the options are arrays and add some members
	                each(xAxisOptions, function(axis, i) {
	                    axis.index = i;
	                    axis.isX = true;
	                });
	
	                each(yAxisOptions, function(axis, i) {
	                    axis.index = i;
	                });
	
	                // concatenate all axis options into one array
	                optionsArray = xAxisOptions.concat(yAxisOptions);
	
	                each(optionsArray, function(axisOptions) {
	                    new Axis(chart, axisOptions); // eslint-disable-line no-new
	                });
	            },
	
	
	            /**
	             * Returns an array of all currently selected points in the chart. Points
	             * can be selected by clicking or programmatically by the {@link
	             * Highcharts.Point#select} function.
	             *
	             * @return {Array.<Highcharts.Point>}
	             *         The currently selected points.
	             *
	             * @sample highcharts/plotoptions/series-allowpointselect-line/
	             *         Get selected points
	             */
	            getSelectedPoints: function() {
	                var points = [];
	                each(this.series, function(serie) {
	                    // series.data - for points outside of viewed range (#6445)
	                    points = points.concat(grep(serie.data || [], function(point) {
	                        return point.selected;
	                    }));
	                });
	                return points;
	            },
	
	            /**
	             * Returns an array of all currently selected series in the chart. Series
	             * can be selected either programmatically by the {@link
	             * Highcharts.Series#select} function or by checking the checkbox next to
	             * the legend item if {@link
	             * https://api.highcharts.com/highcharts/plotOptions.series.showCheckbox|
	             * series.showCheckBox} is true.
	             * 
	             * @return {Array.<Highcharts.Series>}
	             *         The currently selected series.
	             *
	             * @sample highcharts/members/chart-getselectedseries/
	             *         Get selected series
	             */
	            getSelectedSeries: function() {
	                return grep(this.series, function(serie) {
	                    return serie.selected;
	                });
	            },
	
	            /**
	             * Set a new title or subtitle for the chart.
	             *
	             * @param  titleOptions {TitleOptions}
	             *         New title options. The title text itself is set by the
	             *         `titleOptions.text` property.
	             * @param  subtitleOptions {SubtitleOptions}
	             *         New subtitle options. The subtitle text itself is set by the
	             *         `subtitleOptions.text` property.
	             * @param  redraw {Boolean}
	             *         Whether to redraw the chart or wait for a later call to 
	             *         `chart.redraw()`.
	             *
	             * @sample highcharts/members/chart-settitle/ Set title text and styles
	             *
	             */
	            setTitle: function(titleOptions, subtitleOptions, redraw) {
	                var chart = this,
	                    options = chart.options,
	                    chartTitleOptions,
	                    chartSubtitleOptions;
	
	                chartTitleOptions = options.title = merge(
	
	                    // Default styles
	                    {
	                        style: {
	                            color: '#333333',
	                            fontSize: options.isStock ? '16px' : '18px' // #2944
	                        }
	                    },
	
	                    options.title,
	                    titleOptions
	                );
	                chartSubtitleOptions = options.subtitle = merge(
	
	                    // Default styles
	                    {
	                        style: {
	                            color: '#666666'
	                        }
	                    },
	
	                    options.subtitle,
	                    subtitleOptions
	                );
	
	                // add title and subtitle
	                each([
	                    ['title', titleOptions, chartTitleOptions],
	                    ['subtitle', subtitleOptions, chartSubtitleOptions]
	                ], function(arr, i) {
	                    var name = arr[0],
	                        title = chart[name],
	                        titleOptions = arr[1],
	                        chartTitleOptions = arr[2];
	
	                    if (title && titleOptions) {
	                        chart[name] = title = title.destroy(); // remove old
	                    }
	
	                    if (chartTitleOptions && chartTitleOptions.text && !title) {
	                        chart[name] = chart.renderer.text(
	                                chartTitleOptions.text,
	                                0,
	                                0,
	                                chartTitleOptions.useHTML
	                            )
	                            .attr({
	                                align: chartTitleOptions.align,
	                                'class': 'highcharts-' + name,
	                                zIndex: chartTitleOptions.zIndex || 4
	                            })
	                            .add();
	
	                        // Update methods, shortcut to Chart.setTitle
	                        chart[name].update = function(o) {
	                            chart.setTitle(!i && o, i && o);
	                        };
	
	
	                        // Presentational
	                        chart[name].css(chartTitleOptions.style);
	
	
	                    }
	                });
	                chart.layOutTitles(redraw);
	            },
	
	            /**
	             * Internal function to lay out the chart titles and cache the full offset
	             * height for use in `getMargins`. The result is stored in 
	             * `this.titleOffset`.
	             *
	             * @private
	             */
	            layOutTitles: function(redraw) {
	                var titleOffset = 0,
	                    requiresDirtyBox,
	                    renderer = this.renderer,
	                    spacingBox = this.spacingBox;
	
	                // Lay out the title and the subtitle respectively
	                each(['title', 'subtitle'], function(key) {
	                    var title = this[key],
	                        titleOptions = this.options[key],
	                        offset = key === 'title' ? -3 :
	                        // Floating subtitle (#6574)
	                        titleOptions.verticalAlign ? 0 : titleOffset + 2,
	                        titleSize;
	
	                    if (title) {
	
	                        titleSize = titleOptions.style.fontSize;
	
	                        titleSize = renderer.fontMetrics(titleSize, title).b;
	
	                        title
	                            .css({
	                                width: (titleOptions.width ||
	                                    spacingBox.width + titleOptions.widthAdjust) + 'px'
	                            })
	                            .align(extend({
	                                y: offset + titleSize
	                            }, titleOptions), false, 'spacingBox');
	
	                        if (!titleOptions.floating && !titleOptions.verticalAlign) {
	                            titleOffset = Math.ceil(
	                                titleOffset +
	                                // Skip the cache for HTML (#3481)
	                                title.getBBox(titleOptions.useHTML).height
	                            );
	                        }
	                    }
	                }, this);
	
	                requiresDirtyBox = this.titleOffset !== titleOffset;
	                this.titleOffset = titleOffset; // used in getMargins
	
	                if (!this.isDirtyBox && requiresDirtyBox) {
	                    this.isDirtyBox = requiresDirtyBox;
	                    // Redraw if necessary (#2719, #2744)
	                    if (this.hasRendered && pick(redraw, true) && this.isDirtyBox) {
	                        this.redraw();
	                    }
	                }
	            },
	
	            /**
	             * Internal function to get the chart width and height according to options
	             * and container size. Sets {@link Chart.chartWidth} and {@link
	             * Chart.chartHeight}.
	             */
	            getChartSize: function() {
	                var chart = this,
	                    optionsChart = chart.options.chart,
	                    widthOption = optionsChart.width,
	                    heightOption = optionsChart.height,
	                    renderTo = chart.renderTo;
	
	                // Get inner width and height
	                if (!defined(widthOption)) {
	                    chart.containerWidth = getStyle(renderTo, 'width');
	                }
	                if (!defined(heightOption)) {
	                    chart.containerHeight = getStyle(renderTo, 'height');
	                }
	
	                /**
	                 * The current pixel width of the chart.
	                 *
	                 * @name chartWidth
	                 * @memberOf Chart
	                 * @type {Number}
	                 */
	                chart.chartWidth = Math.max( // #1393
	                    0,
	                    widthOption || chart.containerWidth || 600 // #1460
	                );
	                /**
	                 * The current pixel height of the chart.
	                 *
	                 * @name chartHeight
	                 * @memberOf Chart
	                 * @type {Number}
	                 */
	                chart.chartHeight = Math.max(
	                    0,
	                    H.relativeLength(
	                        heightOption,
	                        chart.chartWidth
	                    ) || chart.containerHeight || 400
	                );
	            },
	
	            /**
	             * If the renderTo element has no offsetWidth, most likely one or more of
	             * its parents are hidden. Loop up the DOM tree to temporarily display the
	             * parents, then save the original display properties, and when the true
	             * size is retrieved, reset them. Used on first render and on redraws.
	             *
	             * @private
	             * 
	             * @param  {Boolean} revert
	             *         Revert to the saved original styles.
	             */
	            temporaryDisplay: function(revert) {
	                var node = this.renderTo,
	                    tempStyle;
	                if (!revert) {
	                    while (node && node.style) {
	
	                        // When rendering to a detached node, it needs to be temporarily
	                        // attached in order to read styling and bounding boxes (#5783).
	                        if (!doc.body.contains(node)) {
	                            node.hcOrigDetached = true;
	                            doc.body.appendChild(node);
	                        }
	                        if (
	                            getStyle(node, 'display', false) === 'none' ||
	                            node.hcOricDetached
	                        ) {
	                            node.hcOrigStyle = {
	                                display: node.style.display,
	                                height: node.style.height,
	                                overflow: node.style.overflow
	                            };
	                            tempStyle = {
	                                display: 'block',
	                                overflow: 'hidden'
	                            };
	                            if (node !== this.renderTo) {
	                                tempStyle.height = 0;
	                            }
	
	                            H.css(node, tempStyle);
	
	                            // If it still doesn't have an offset width after setting
	                            // display to block, it probably has an !important priority
	                            // #2631, 6803
	                            if (!node.offsetWidth) {
	                                node.style.setProperty('display', 'block', 'important');
	                            }
	                        }
	                        node = node.parentNode;
	
	                        if (node === doc.body) {
	                            break;
	                        }
	                    }
	                } else {
	                    while (node && node.style) {
	                        if (node.hcOrigStyle) {
	                            H.css(node, node.hcOrigStyle);
	                            delete node.hcOrigStyle;
	                        }
	                        if (node.hcOrigDetached) {
	                            doc.body.removeChild(node);
	                            node.hcOrigDetached = false;
	                        }
	                        node = node.parentNode;
	                    }
	                }
	            },
	
	            /**
	             * Set the {@link Chart.container|chart container's} class name, in
	             * addition to `highcharts-container`. 
	             */
	            setClassName: function(className) {
	                this.container.className = 'highcharts-container ' + (className || '');
	            },
	
	            /**
	             * Get the containing element, determine the size and create the inner
	             * container div to hold the chart.
	             *
	             * @private
	             */
	            getContainer: function() {
	                var chart = this,
	                    container,
	                    options = chart.options,
	                    optionsChart = options.chart,
	                    chartWidth,
	                    chartHeight,
	                    renderTo = chart.renderTo,
	                    indexAttrName = 'data-highcharts-chart',
	                    oldChartIndex,
	                    Ren,
	                    containerId = H.uniqueKey(),
	                    containerStyle,
	                    key;
	
	                if (!renderTo) {
	                    chart.renderTo = renderTo = optionsChart.renderTo;
	                }
	
	                if (isString(renderTo)) {
	                    chart.renderTo = renderTo = doc.getElementById(renderTo);
	                }
	
	                // Display an error if the renderTo is wrong
	                if (!renderTo) {
	                    H.error(13, true);
	                }
	
	                // If the container already holds a chart, destroy it. The check for
	                // hasRendered is there because web pages that are saved to disk from
	                // the browser, will preserve the data-highcharts-chart attribute and
	                // the SVG contents, but not an interactive chart. So in this case,
	                // charts[oldChartIndex] will point to the wrong chart if any (#2609).
	                oldChartIndex = pInt(attr(renderTo, indexAttrName));
	                if (
	                    isNumber(oldChartIndex) &&
	                    charts[oldChartIndex] &&
	                    charts[oldChartIndex].hasRendered
	                ) {
	                    charts[oldChartIndex].destroy();
	                }
	
	                // Make a reference to the chart from the div
	                attr(renderTo, indexAttrName, chart.index);
	
	                // remove previous chart
	                renderTo.innerHTML = '';
	
	                // If the container doesn't have an offsetWidth, it has or is a child of
	                // a node that has display:none. We need to temporarily move it out to a
	                // visible state to determine the size, else the legend and tooltips
	                // won't render properly. The skipClone option is used in sparklines as
	                // a micro optimization, saving about 1-2 ms each chart.
	                if (!optionsChart.skipClone && !renderTo.offsetWidth) {
	                    chart.temporaryDisplay();
	                }
	
	                // get the width and height
	                chart.getChartSize();
	                chartWidth = chart.chartWidth;
	                chartHeight = chart.chartHeight;
	
	                // Create the inner container
	
	                containerStyle = extend({
	                    position: 'relative',
	                    overflow: 'hidden', // needed for context menu (avoid scrollbars)
	                    // and content overflow in IE
	                    width: chartWidth + 'px',
	                    height: chartHeight + 'px',
	                    textAlign: 'left',
	                    lineHeight: 'normal', // #427
	                    zIndex: 0, // #1072
	                    '-webkit-tap-highlight-color': 'rgba(0,0,0,0)'
	                }, optionsChart.style);
	
	
	                /**
	                 * The containing HTML element of the chart. The container is
	                 * dynamically inserted into the element given as the `renderTo`
	                 * parameterin the {@link Highcharts#chart} constructor.
	                 *
	                 * @memberOf Highcharts.Chart
	                 * @type {HTMLDOMElement}
	                 */
	                container = createElement(
	                    'div', {
	                        id: containerId
	                    },
	                    containerStyle,
	                    renderTo
	                );
	                chart.container = container;
	
	                // cache the cursor (#1650)
	                chart._cursor = container.style.cursor;
	
	                // Initialize the renderer
	                Ren = H[optionsChart.renderer] || Renderer;
	                /**
	                 * The renderer instance of the chart. Each chart instance has only one
	                 * associated renderer.
	                 * @type {SVGRenderer}
	                 * @name renderer
	                 * @memberOf Chart
	                 */
	                chart.renderer = new Ren(
	                    container,
	                    chartWidth,
	                    chartHeight,
	                    null,
	                    optionsChart.forExport,
	                    options.exporting && options.exporting.allowHTML
	                );
	
	
	                chart.setClassName(optionsChart.className);
	
	                chart.renderer.setStyle(optionsChart.style);
	
	
	                // Add a reference to the charts index
	                chart.renderer.chartIndex = chart.index;
	            },
	
	            /**
	             * Calculate margins by rendering axis labels in a preliminary position.
	             * Title, subtitle and legend have already been rendered at this stage, but
	             * will be moved into their final positions.
	             *
	             * @private
	             */
	            getMargins: function(skipAxes) {
	                var chart = this,
	                    spacing = chart.spacing,
	                    margin = chart.margin,
	                    titleOffset = chart.titleOffset;
	
	                chart.resetMargins();
	
	                // Adjust for title and subtitle
	                if (titleOffset && !defined(margin[0])) {
	                    chart.plotTop = Math.max(
	                        chart.plotTop,
	                        titleOffset + chart.options.title.margin + spacing[0]
	                    );
	                }
	
	                // Adjust for legend
	                if (chart.legend.display) {
	                    chart.legend.adjustMargins(margin, spacing);
	                }
	
	                // adjust for scroller
	                if (chart.extraMargin) {
	                    chart[chart.extraMargin.type] =
	                        (chart[chart.extraMargin.type] || 0) + chart.extraMargin.value;
	                }
	                if (chart.extraTopMargin) {
	                    chart.plotTop += chart.extraTopMargin;
	                }
	                if (!skipAxes) {
	                    this.getAxisMargins();
	                }
	            },
	
	            getAxisMargins: function() {
	
	                var chart = this,
	                    // [top, right, bottom, left]
	                    axisOffset = chart.axisOffset = [0, 0, 0, 0],
	                    margin = chart.margin;
	
	                // pre-render axes to get labels offset width
	                if (chart.hasCartesianSeries) {
	                    each(chart.axes, function(axis) {
	                        if (axis.visible) {
	                            axis.getOffset();
	                        }
	                    });
	                }
	
	                // Add the axis offsets
	                each(marginNames, function(m, side) {
	                    if (!defined(margin[side])) {
	                        chart[m] += axisOffset[side];
	                    }
	                });
	
	                chart.setChartSize();
	
	            },
	
	            /**
	             * Reflows the chart to its container. By default, the chart reflows
	             * automatically to its container following a `window.resize` event, as per
	             * the {@link https://api.highcharts/highcharts/chart.reflow|chart.reflow}
	             * option. However, there are no reliable events for div resize, so if the
	             * container is resized without a window resize event, this must be called
	             * explicitly.
	             *
	             * @param  {Object} e
	             *         Event arguments. Used primarily when the function is called
	             *         internally as a response to window resize.
	             *
	             * @sample highcharts/members/chart-reflow/
	             *         Resize div and reflow
	             * @sample highcharts/chart/events-container/
	             *         Pop up and reflow
	             */
	            reflow: function(e) {
	                var chart = this,
	                    optionsChart = chart.options.chart,
	                    renderTo = chart.renderTo,
	                    hasUserSize = (
	                        defined(optionsChart.width) &&
	                        defined(optionsChart.height)
	                    ),
	                    width = optionsChart.width || getStyle(renderTo, 'width'),
	                    height = optionsChart.height || getStyle(renderTo, 'height'),
	                    target = e ? e.target : win;
	
	                // Width and height checks for display:none. Target is doc in IE8 and
	                // Opera, win in Firefox, Chrome and IE9.
	                if (!hasUserSize &&
	                    !chart.isPrinting &&
	                    width &&
	                    height &&
	                    (target === win || target === doc)
	                ) {
	                    if (
	                        width !== chart.containerWidth ||
	                        height !== chart.containerHeight
	                    ) {
	                        clearTimeout(chart.reflowTimeout);
	                        // When called from window.resize, e is set, else it's called
	                        // directly (#2224)
	                        chart.reflowTimeout = syncTimeout(function() {
	                            // Set size, it may have been destroyed in the meantime
	                            // (#1257)
	                            if (chart.container) {
	                                chart.setSize(undefined, undefined, false);
	                            }
	                        }, e ? 100 : 0);
	                    }
	                    chart.containerWidth = width;
	                    chart.containerHeight = height;
	                }
	            },
	
	            /**
	             * Add the event handlers necessary for auto resizing, depending on the 
	             * `chart.events.reflow` option.
	             *
	             * @private
	             */
	            initReflow: function() {
	                var chart = this,
	                    unbind;
	
	                unbind = addEvent(win, 'resize', function(e) {
	                    chart.reflow(e);
	                });
	                addEvent(chart, 'destroy', unbind);
	
	                // The following will add listeners to re-fit the chart before and after
	                // printing (#2284). However it only works in WebKit. Should have worked
	                // in Firefox, but not supported in IE.
	                /*
	                if (win.matchMedia) {
	                	win.matchMedia('print').addListener(function reflow() {
	                		chart.reflow();
	                	});
	                }
	                */
	            },
	
	            /**
	             * Resize the chart to a given width and height. In order to set the width
	             * only, the height argument may be skipped. To set the height only, pass
	             * `undefined for the width.
	             * @param  {Number|undefined|null} [width]
	             *         The new pixel width of the chart. Since v4.2.6, the argument can
	             *         be `undefined` in order to preserve the current value (when
	             *         setting height only), or `null` to adapt to the width of the
	             *         containing element.
	             * @param  {Number|undefined|null} [height]
	             *         The new pixel height of the chart. Since v4.2.6, the argument can
	             *         be `undefined` in order to preserve the current value, or `null`
	             *         in order to adapt to the height of the containing element.
	             * @param  {AnimationOptions} [animation=true]
	             *         Whether and how to apply animation.
	             *
	             * @sample highcharts/members/chart-setsize-button/
	             *         Test resizing from buttons
	             * @sample highcharts/members/chart-setsize-jquery-resizable/
	             *         Add a jQuery UI resizable
	             * @sample stock/members/chart-setsize/
	             *         Highstock with UI resizable
	             */
	            setSize: function(width, height, animation) {
	                var chart = this,
	                    renderer = chart.renderer,
	                    globalAnimation;
	
	                // Handle the isResizing counter
	                chart.isResizing += 1;
	
	                // set the animation for the current process
	                H.setAnimation(animation, chart);
	
	                chart.oldChartHeight = chart.chartHeight;
	                chart.oldChartWidth = chart.chartWidth;
	                if (width !== undefined) {
	                    chart.options.chart.width = width;
	                }
	                if (height !== undefined) {
	                    chart.options.chart.height = height;
	                }
	                chart.getChartSize();
	
	                // Resize the container with the global animation applied if enabled
	                // (#2503)
	
	                globalAnimation = renderer.globalAnimation;
	                (globalAnimation ? animate : css)(chart.container, {
	                    width: chart.chartWidth + 'px',
	                    height: chart.chartHeight + 'px'
	                }, globalAnimation);
	
	
	                chart.setChartSize(true);
	                renderer.setSize(chart.chartWidth, chart.chartHeight, animation);
	
	                // handle axes
	                each(chart.axes, function(axis) {
	                    axis.isDirty = true;
	                    axis.setScale();
	                });
	
	                chart.isDirtyLegend = true; // force legend redraw
	                chart.isDirtyBox = true; // force redraw of plot and chart border
	
	                chart.layOutTitles(); // #2857
	                chart.getMargins();
	
	                chart.redraw(animation);
	
	
	                chart.oldChartHeight = null;
	                fireEvent(chart, 'resize');
	
	                // Fire endResize and set isResizing back. If animation is disabled,
	                // fire without delay
	                syncTimeout(function() {
	                    if (chart) {
	                        fireEvent(chart, 'endResize', null, function() {
	                            chart.isResizing -= 1;
	                        });
	                    }
	                }, animObject(globalAnimation).duration);
	            },
	
	            /**
	             * Set the public chart properties. This is done before and after the
	             * pre-render to determine margin sizes.
	             *
	             * @private
	             */
	            setChartSize: function(skipAxes) {
	                var chart = this,
	                    inverted = chart.inverted,
	                    renderer = chart.renderer,
	                    chartWidth = chart.chartWidth,
	                    chartHeight = chart.chartHeight,
	                    optionsChart = chart.options.chart,
	                    spacing = chart.spacing,
	                    clipOffset = chart.clipOffset,
	                    clipX,
	                    clipY,
	                    plotLeft,
	                    plotTop,
	                    plotWidth,
	                    plotHeight,
	                    plotBorderWidth;
	
	                function clipOffsetSide(side) {
	                    var offset = clipOffset[side] || 0;
	                    return Math.max(plotBorderWidth || offset, offset) / 2;
	                }
	
	                /**
	                 * The current left position of the plot area in pixels.
	                 *
	                 * @name plotLeft
	                 * @memberOf Chart
	                 * @type {Number}
	                 */
	                chart.plotLeft = plotLeft = Math.round(chart.plotLeft);
	
	                /**
	                 * The current top position of the plot area in pixels.
	                 *
	                 * @name plotTop
	                 * @memberOf Chart
	                 * @type {Number}
	                 */
	                chart.plotTop = plotTop = Math.round(chart.plotTop);
	
	                /**
	                 * The current width of the plot area in pixels.
	                 *
	                 * @name plotWidth
	                 * @memberOf Chart
	                 * @type {Number}
	                 */
	                chart.plotWidth = plotWidth = Math.max(
	                    0,
	                    Math.round(chartWidth - plotLeft - chart.marginRight)
	                );
	
	                /**
	                 * The current height of the plot area in pixels.
	                 *
	                 * @name plotHeight
	                 * @memberOf Chart
	                 * @type {Number}
	                 */
	                chart.plotHeight = plotHeight = Math.max(
	                    0,
	                    Math.round(chartHeight - plotTop - chart.marginBottom)
	                );
	
	                chart.plotSizeX = inverted ? plotHeight : plotWidth;
	                chart.plotSizeY = inverted ? plotWidth : plotHeight;
	
	                chart.plotBorderWidth = optionsChart.plotBorderWidth || 0;
	
	                // Set boxes used for alignment
	                chart.spacingBox = renderer.spacingBox = {
	                    x: spacing[3],
	                    y: spacing[0],
	                    width: chartWidth - spacing[3] - spacing[1],
	                    height: chartHeight - spacing[0] - spacing[2]
	                };
	                chart.plotBox = renderer.plotBox = {
	                    x: plotLeft,
	                    y: plotTop,
	                    width: plotWidth,
	                    height: plotHeight
	                };
	
	                plotBorderWidth = 2 * Math.floor(chart.plotBorderWidth / 2);
	                clipX = Math.ceil(clipOffsetSide(3));
	                clipY = Math.ceil(clipOffsetSide(0));
	                chart.clipBox = {
	                    x: clipX,
	                    y: clipY,
	                    width: Math.floor(
	                        chart.plotSizeX -
	                        clipOffsetSide(1) -
	                        clipX
	                    ),
	                    height: Math.max(
	                        0,
	                        Math.floor(
	                            chart.plotSizeY -
	                            clipOffsetSide(2) -
	                            clipY
	                        )
	                    )
	                };
	
	                if (!skipAxes) {
	                    each(chart.axes, function(axis) {
	                        axis.setAxisSize();
	                        axis.setAxisTranslation();
	                    });
	                }
	            },
	
	            /**
	             * Initial margins before auto size margins are applied.
	             *
	             * @private
	             */
	            resetMargins: function() {
	                var chart = this,
	                    chartOptions = chart.options.chart;
	
	                // Create margin and spacing array
	                each(['margin', 'spacing'], function splashArrays(target) {
	                    var value = chartOptions[target],
	                        values = isObject(value) ? value : [value, value, value, value];
	
	                    each(['Top', 'Right', 'Bottom', 'Left'], function(sideName, side) {
	                        chart[target][side] = pick(
	                            chartOptions[target + sideName],
	                            values[side]
	                        );
	                    });
	                });
	
	                // Set margin names like chart.plotTop, chart.plotLeft,
	                // chart.marginRight, chart.marginBottom.
	                each(marginNames, function(m, side) {
	                    chart[m] = pick(chart.margin[side], chart.spacing[side]);
	                });
	                chart.axisOffset = [0, 0, 0, 0]; // top, right, bottom, left
	                chart.clipOffset = [];
	            },
	
	            /**
	             * Internal function to draw or redraw the borders and backgrounds for chart
	             * and plot area.
	             *
	             * @private
	             */
	            drawChartBox: function() {
	                var chart = this,
	                    optionsChart = chart.options.chart,
	                    renderer = chart.renderer,
	                    chartWidth = chart.chartWidth,
	                    chartHeight = chart.chartHeight,
	                    chartBackground = chart.chartBackground,
	                    plotBackground = chart.plotBackground,
	                    plotBorder = chart.plotBorder,
	                    chartBorderWidth,
	
	                    plotBGImage = chart.plotBGImage,
	                    chartBackgroundColor = optionsChart.backgroundColor,
	                    plotBackgroundColor = optionsChart.plotBackgroundColor,
	                    plotBackgroundImage = optionsChart.plotBackgroundImage,
	
	                    mgn,
	                    bgAttr,
	                    plotLeft = chart.plotLeft,
	                    plotTop = chart.plotTop,
	                    plotWidth = chart.plotWidth,
	                    plotHeight = chart.plotHeight,
	                    plotBox = chart.plotBox,
	                    clipRect = chart.clipRect,
	                    clipBox = chart.clipBox,
	                    verb = 'animate';
	
	                // Chart area
	                if (!chartBackground) {
	                    chart.chartBackground = chartBackground = renderer.rect()
	                        .addClass('highcharts-background')
	                        .add();
	                    verb = 'attr';
	                }
	
	
	                // Presentational
	                chartBorderWidth = optionsChart.borderWidth || 0;
	                mgn = chartBorderWidth + (optionsChart.shadow ? 8 : 0);
	
	                bgAttr = {
	                    fill: chartBackgroundColor || 'none'
	                };
	
	                if (chartBorderWidth || chartBackground['stroke-width']) { // #980
	                    bgAttr.stroke = optionsChart.borderColor;
	                    bgAttr['stroke-width'] = chartBorderWidth;
	                }
	                chartBackground
	                    .attr(bgAttr)
	                    .shadow(optionsChart.shadow);
	
	                chartBackground[verb]({
	                    x: mgn / 2,
	                    y: mgn / 2,
	                    width: chartWidth - mgn - chartBorderWidth % 2,
	                    height: chartHeight - mgn - chartBorderWidth % 2,
	                    r: optionsChart.borderRadius
	                });
	
	                // Plot background
	                verb = 'animate';
	                if (!plotBackground) {
	                    verb = 'attr';
	                    chart.plotBackground = plotBackground = renderer.rect()
	                        .addClass('highcharts-plot-background')
	                        .add();
	                }
	                plotBackground[verb](plotBox);
	
	
	                // Presentational attributes for the background
	                plotBackground
	                    .attr({
	                        fill: plotBackgroundColor || 'none'
	                    })
	                    .shadow(optionsChart.plotShadow);
	
	                // Create the background image
	                if (plotBackgroundImage) {
	                    if (!plotBGImage) {
	                        chart.plotBGImage = renderer.image(
	                            plotBackgroundImage,
	                            plotLeft,
	                            plotTop,
	                            plotWidth,
	                            plotHeight
	                        ).add();
	                    } else {
	                        plotBGImage.animate(plotBox);
	                    }
	                }
	
	
	                // Plot clip
	                if (!clipRect) {
	                    chart.clipRect = renderer.clipRect(clipBox);
	                } else {
	                    clipRect.animate({
	                        width: clipBox.width,
	                        height: clipBox.height
	                    });
	                }
	
	                // Plot area border
	                verb = 'animate';
	                if (!plotBorder) {
	                    verb = 'attr';
	                    chart.plotBorder = plotBorder = renderer.rect()
	                        .addClass('highcharts-plot-border')
	                        .attr({
	                            zIndex: 1 // Above the grid
	                        })
	                        .add();
	                }
	
	
	                // Presentational
	                plotBorder.attr({
	                    stroke: optionsChart.plotBorderColor,
	                    'stroke-width': optionsChart.plotBorderWidth || 0,
	                    fill: 'none'
	                });
	
	
	                plotBorder[verb](plotBorder.crisp({
	                    x: plotLeft,
	                    y: plotTop,
	                    width: plotWidth,
	                    height: plotHeight
	                }, -plotBorder.strokeWidth())); //#3282 plotBorder should be negative;
	
	                // reset
	                chart.isDirtyBox = false;
	            },
	
	            /**
	             * Detect whether a certain chart property is needed based on inspecting its
	             * options and series. This mainly applies to the chart.inverted property,
	             * and in extensions to the chart.angular and chart.polar properties.
	             *
	             * @private
	             */
	            propFromSeries: function() {
	                var chart = this,
	                    optionsChart = chart.options.chart,
	                    klass,
	                    seriesOptions = chart.options.series,
	                    i,
	                    value;
	
	
	                each(['inverted', 'angular', 'polar'], function(key) {
	
	                    // The default series type's class
	                    klass = seriesTypes[optionsChart.type ||
	                        optionsChart.defaultSeriesType];
	
	                    // Get the value from available chart-wide properties
	                    value =
	                        optionsChart[key] || // It is set in the options
	                        (klass && klass.prototype[key]); // The default series class
	                    // requires it
	
	                    // 4. Check if any the chart's series require it
	                    i = seriesOptions && seriesOptions.length;
	                    while (!value && i--) {
	                        klass = seriesTypes[seriesOptions[i].type];
	                        if (klass && klass.prototype[key]) {
	                            value = true;
	                        }
	                    }
	
	                    // Set the chart property
	                    chart[key] = value;
	                });
	
	            },
	
	            /**
	             * Internal function to link two or more series together, based on the 
	             * `linkedTo` option. This is done from `Chart.render`, and after
	             * `Chart.addSeries` and `Series.remove`.
	             *
	             * @private
	             */
	            linkSeries: function() {
	                var chart = this,
	                    chartSeries = chart.series;
	
	                // Reset links
	                each(chartSeries, function(series) {
	                    series.linkedSeries.length = 0;
	                });
	
	                // Apply new links
	                each(chartSeries, function(series) {
	                    var linkedTo = series.options.linkedTo;
	                    if (isString(linkedTo)) {
	                        if (linkedTo === ':previous') {
	                            linkedTo = chart.series[series.index - 1];
	                        } else {
	                            linkedTo = chart.get(linkedTo);
	                        }
	                        // #3341 avoid mutual linking
	                        if (linkedTo && linkedTo.linkedParent !== series) {
	                            linkedTo.linkedSeries.push(series);
	                            series.linkedParent = linkedTo;
	                            series.visible = pick(
	                                series.options.visible,
	                                linkedTo.options.visible,
	                                series.visible
	                            ); // #3879
	                        }
	                    }
	                });
	            },
	
	            /**
	             * Render series for the chart.
	             *
	             * @private
	             */
	            renderSeries: function() {
	                each(this.series, function(serie) {
	                    serie.translate();
	                    serie.render();
	                });
	            },
	
	            /**
	             * Render labels for the chart.
	             *
	             * @private
	             */
	            renderLabels: function() {
	                var chart = this,
	                    labels = chart.options.labels;
	                if (labels.items) {
	                    each(labels.items, function(label) {
	                        var style = extend(labels.style, label.style),
	                            x = pInt(style.left) + chart.plotLeft,
	                            y = pInt(style.top) + chart.plotTop + 12;
	
	                        // delete to prevent rewriting in IE
	                        delete style.left;
	                        delete style.top;
	
	                        chart.renderer.text(
	                                label.html,
	                                x,
	                                y
	                            )
	                            .attr({
	                                zIndex: 2
	                            })
	                            .css(style)
	                            .add();
	
	                    });
	                }
	            },
	
	            /**
	             * Render all graphics for the chart. Runs internally on initialization.
	             *
	             * @private
	             */
	            render: function() {
	                var chart = this,
	                    axes = chart.axes,
	                    renderer = chart.renderer,
	                    options = chart.options,
	                    tempWidth,
	                    tempHeight,
	                    redoHorizontal,
	                    redoVertical;
	
	                // Title
	                chart.setTitle();
	
	
	                // Legend
	                chart.legend = new Legend(chart, options.legend);
	
	                // Get stacks
	                if (chart.getStacks) {
	                    chart.getStacks();
	                }
	
	                // Get chart margins
	                chart.getMargins(true);
	                chart.setChartSize();
	
	                // Record preliminary dimensions for later comparison
	                tempWidth = chart.plotWidth;
	                tempHeight = chart.plotHeight = chart.plotHeight - 21; // 21 is the most common correction for X axis labels
	
	                // Get margins by pre-rendering axes
	                each(axes, function(axis) {
	                    axis.setScale();
	                });
	                chart.getAxisMargins();
	
	                // If the plot area size has changed significantly, calculate tick positions again
	                redoHorizontal = tempWidth / chart.plotWidth > 1.1;
	                redoVertical = tempHeight / chart.plotHeight > 1.05; // Height is more sensitive
	
	                if (redoHorizontal || redoVertical) {
	
	                    each(axes, function(axis) {
	                        if ((axis.horiz && redoHorizontal) || (!axis.horiz && redoVertical)) {
	                            axis.setTickInterval(true); // update to reflect the new margins
	                        }
	                    });
	                    chart.getMargins(); // second pass to check for new labels
	                }
	
	                // Draw the borders and backgrounds
	                chart.drawChartBox();
	
	
	                // Axes
	                if (chart.hasCartesianSeries) {
	                    each(axes, function(axis) {
	                        if (axis.visible) {
	                            axis.render();
	                        }
	                    });
	                }
	
	                // The series
	                if (!chart.seriesGroup) {
	                    chart.seriesGroup = renderer.g('series-group')
	                        .attr({
	                            zIndex: 3
	                        })
	                        .add();
	                }
	                chart.renderSeries();
	
	                // Labels
	                chart.renderLabels();
	
	                // Credits
	                chart.addCredits();
	
	                // Handle responsiveness
	                if (chart.setResponsive) {
	                    chart.setResponsive();
	                }
	
	                // Set flag
	                chart.hasRendered = true;
	
	            },
	
	            /**
	             * Set a new credits label for the chart.
	             *
	             * @param  {CreditOptions} options
	             *         A configuration object for the new credits.
	             * @sample highcharts/credits/credits-update/ Add and update credits
	             */
	            addCredits: function(credits) {
	                var chart = this;
	
	                credits = merge(true, this.options.credits, credits);
	                if (credits.enabled && !this.credits) {
	
	                    /**
	                     * The chart's credits label. The label has an `update` method that
	                     * allows setting new options as per the {@link
	                     * https://api.highcharts.com/highcharts/credits|
	                     * credits options set}.
	                     *
	                     * @memberof Highcharts.Chart
	                     * @name credits
	                     * @type {Highcharts.SVGElement}
	                     */
	                    this.credits = this.renderer.text(
	                            credits.text + (this.mapCredits || ''),
	                            0,
	                            0
	                        )
	                        .addClass('highcharts-credits')
	                        .on('click', function() {
	                            if (credits.href) {
	                                win.location.href = credits.href;
	                            }
	                        })
	                        .attr({
	                            align: credits.position.align,
	                            zIndex: 8
	                        })
	
	                        .css(credits.style)
	
	                        .add()
	                        .align(credits.position);
	
	                    // Dynamically update
	                    this.credits.update = function(options) {
	                        chart.credits = chart.credits.destroy();
	                        chart.addCredits(options);
	                    };
	                }
	            },
	
	            /**
	             * Remove the chart and purge memory. This method is called internally
	             * before adding a second chart into the same container, as well as on
	             * window unload to prevent leaks.
	             *
	             * @sample highcharts/members/chart-destroy/
	             *         Destroy the chart from a button
	             * @sample stock/members/chart-destroy/
	             *         Destroy with Highstock
	             */
	            destroy: function() {
	                var chart = this,
	                    axes = chart.axes,
	                    series = chart.series,
	                    container = chart.container,
	                    i,
	                    parentNode = container && container.parentNode;
	
	                // fire the chart.destoy event
	                fireEvent(chart, 'destroy');
	
	                // Delete the chart from charts lookup array
	                if (chart.renderer.forExport) {
	                    H.erase(charts, chart); // #6569
	                } else {
	                    charts[chart.index] = undefined;
	                }
	                H.chartCount--;
	                chart.renderTo.removeAttribute('data-highcharts-chart');
	
	                // remove events
	                removeEvent(chart);
	
	                // ==== Destroy collections:
	                // Destroy axes
	                i = axes.length;
	                while (i--) {
	                    axes[i] = axes[i].destroy();
	                }
	
	                // Destroy scroller & scroller series before destroying base series
	                if (this.scroller && this.scroller.destroy) {
	                    this.scroller.destroy();
	                }
	
	                // Destroy each series
	                i = series.length;
	                while (i--) {
	                    series[i] = series[i].destroy();
	                }
	
	                // ==== Destroy chart properties:
	                each([
	                    'title', 'subtitle', 'chartBackground', 'plotBackground',
	                    'plotBGImage', 'plotBorder', 'seriesGroup', 'clipRect', 'credits',
	                    'pointer', 'rangeSelector', 'legend', 'resetZoomButton', 'tooltip',
	                    'renderer'
	                ], function(name) {
	                    var prop = chart[name];
	
	                    if (prop && prop.destroy) {
	                        chart[name] = prop.destroy();
	                    }
	                });
	
	                // remove container and all SVG
	                if (container) { // can break in IE when destroyed before finished loading
	                    container.innerHTML = '';
	                    removeEvent(container);
	                    if (parentNode) {
	                        discardElement(container);
	                    }
	
	                }
	
	                // clean it all up
	                objectEach(chart, function(val, key) {
	                    delete chart[key];
	                });
	
	            },
	
	
	            /**
	             * VML namespaces can't be added until after complete. Listening
	             * for Perini's doScroll hack is not enough.
	             *
	             * @private
	             */
	            isReadyToRender: function() {
	                var chart = this;
	
	                // Note: win == win.top is required
	                if ((!svg && (win == win.top && doc.readyState !== 'complete'))) { // eslint-disable-line eqeqeq
	                    doc.attachEvent('onreadystatechange', function() {
	                        doc.detachEvent('onreadystatechange', chart.firstRender);
	                        if (doc.readyState === 'complete') {
	                            chart.firstRender();
	                        }
	                    });
	                    return false;
	                }
	                return true;
	            },
	
	            /**
	             * Prepare for first rendering after all data are loaded.
	             *
	             * @private
	             */
	            firstRender: function() {
	                var chart = this,
	                    options = chart.options;
	
	                // Check whether the chart is ready to render
	                if (!chart.isReadyToRender()) {
	                    return;
	                }
	
	                // Create the container
	                chart.getContainer();
	
	                // Run an early event after the container and renderer are established
	                fireEvent(chart, 'init');
	
	
	                chart.resetMargins();
	                chart.setChartSize();
	
	                // Set the common chart properties (mainly invert) from the given series
	                chart.propFromSeries();
	
	                // get axes
	                chart.getAxes();
	
	                // Initialize the series
	                each(options.series || [], function(serieOptions) {
	                    chart.initSeries(serieOptions);
	                });
	
	                chart.linkSeries();
	
	                // Run an event after axes and series are initialized, but before render. At this stage,
	                // the series data is indexed and cached in the xData and yData arrays, so we can access
	                // those before rendering. Used in Highstock.
	                fireEvent(chart, 'beforeRender');
	
	                // depends on inverted and on margins being set
	                if (Pointer) {
	
	                    /**
	                     * The Pointer that keeps track of mouse and touch interaction.
	                     *
	                     * @memberof Chart
	                     * @name pointer
	                     * @type Pointer
	                     */
	                    chart.pointer = new Pointer(chart, options);
	                }
	
	                chart.render();
	
	                // Fire the load event if there are no external images
	                if (!chart.renderer.imgCount && chart.onload) {
	                    chart.onload();
	                }
	
	                // If the chart was rendered outside the top container, put it back in (#3679)
	                chart.temporaryDisplay(true);
	
	            },
	
	            /** 
	             * Internal function that runs on chart load, async if any images are loaded
	             * in the chart. Runs the callbacks and triggers the `load` and `render`
	             * events.
	             *
	             * @private
	             */
	            onload: function() {
	
	                // Run callbacks
	                each([this.callback].concat(this.callbacks), function(fn) {
	                    if (fn && this.index !== undefined) { // Chart destroyed in its own callback (#3600)
	                        fn.apply(this, [this]);
	                    }
	                }, this);
	
	                fireEvent(this, 'load');
	                fireEvent(this, 'render');
	
	
	                // Set up auto resize, check for not destroyed (#6068)
	                if (defined(this.index) && this.options.chart.reflow !== false) {
	                    this.initReflow();
	                }
	
	                // Don't run again
	                this.onload = null;
	            }
	
	        }); // end Chart
	
	    }(Highcharts));
	    (function(Highcharts) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var Point,
	            H = Highcharts,
	
	            each = H.each,
	            extend = H.extend,
	            erase = H.erase,
	            fireEvent = H.fireEvent,
	            format = H.format,
	            isArray = H.isArray,
	            isNumber = H.isNumber,
	            pick = H.pick,
	            removeEvent = H.removeEvent;
	
	        /**
	         * The Point object. The point objects are generated from the `series.data` 
	         * configuration objects or raw numbers. They can be accessed from the
	         * `Series.points` array. Other ways to instaniate points are through {@link
	         * Highcharts.Series#addPoint} or {@link Highcharts.Series#setData}.
	         *
	         * @class
	         */
	
	        Highcharts.Point = Point = function() {};
	        Highcharts.Point.prototype = {
	
	            /**
	             * Initialize the point. Called internally based on the `series.data`
	             * option.
	             * @param  {Series} series
	             *         The series object containing this point.
	             * @param  {Number|Array|Object} options
	             *         The data in either number, array or object format.
	             * @param  {Number} x Optionally, the X value of the point.
	             * @return {Point} The Point instance.
	             */
	            init: function(series, options, x) {
	
	                var point = this,
	                    colors,
	                    colorCount = series.chart.options.chart.colorCount,
	                    colorIndex;
	
	                /**
	                 * The series object associated with the point.
	                 *
	                 * @name series
	                 * @memberof Highcharts.Point
	                 * @type Highcharts.Series
	                 */
	                point.series = series;
	
	
	                /**
	                 * The point's current color.
	                 * @name color
	                 * @memberof Highcharts.Point
	                 * @type {Color}
	                 */
	                point.color = series.color; // #3445
	
	                point.applyOptions(options, x);
	
	                if (series.options.colorByPoint) {
	
	                    colors = series.options.colors || series.chart.options.colors;
	                    point.color = point.color || colors[series.colorCounter];
	                    colorCount = colors.length;
	
	                    colorIndex = series.colorCounter;
	                    series.colorCounter++;
	                    // loop back to zero
	                    if (series.colorCounter === colorCount) {
	                        series.colorCounter = 0;
	                    }
	                } else {
	                    colorIndex = series.colorIndex;
	                }
	                point.colorIndex = pick(point.colorIndex, colorIndex);
	
	                series.chart.pointCount++;
	                return point;
	            },
	            /**
	             * Apply the options containing the x and y data and possible some extra
	             * properties. Called on point init or from point.update.
	             *
	             * @private
	             * @param {Object} options The point options as defined in series.data.
	             * @param {Number} x Optionally, the X value.
	             * @returns {Object} The Point instance.
	             */
	            applyOptions: function(options, x) {
	                var point = this,
	                    series = point.series,
	                    pointValKey = series.options.pointValKey || series.pointValKey;
	
	                options = Point.prototype.optionsToObject.call(this, options);
	
	                // copy options directly to point
	                extend(point, options);
	                point.options = point.options ? extend(point.options, options) : options;
	
	                // Since options are copied into the Point instance, some accidental options must be shielded (#5681)
	                if (options.group) {
	                    delete point.group;
	                }
	
	                // For higher dimension series types. For instance, for ranges, point.y is mapped to point.low.
	                if (pointValKey) {
	                    point.y = point[pointValKey];
	                }
	                point.isNull = pick(
	                    point.isValid && !point.isValid(),
	                    point.x === null || !isNumber(point.y, true)
	                ); // #3571, check for NaN
	
	                // The point is initially selected by options (#5777)
	                if (point.selected) {
	                    point.state = 'select';
	                }
	
	                // If no x is set by now, get auto incremented value. All points must have an
	                // x value, however the y value can be null to create a gap in the series
	                if ('name' in point && x === undefined && series.xAxis && series.xAxis.hasNames) {
	                    point.x = series.xAxis.nameToX(point);
	                }
	                if (point.x === undefined && series) {
	                    if (x === undefined) {
	                        point.x = series.autoIncrement(point);
	                    } else {
	                        point.x = x;
	                    }
	                }
	
	                return point;
	            },
	
	            /**
	             * Transform number or array configs into objects. Used internally to unify
	             * the different configuration formats for points. For example, a simple
	             * number `10` in a line series will be transformed to `{ y: 10 }`, and an
	             * array config like `[1, 10]` in a scatter series will be transformed to
	             * `{ x: 1, y: 10 }`.
	             *
	             * @param  {Number|Array|Object} options
	             *         The input options
	             * @return {Object} Transformed options.
	             */
	            optionsToObject: function(options) {
	                var ret = {},
	                    series = this.series,
	                    keys = series.options.keys,
	                    pointArrayMap = keys || series.pointArrayMap || ['y'],
	                    valueCount = pointArrayMap.length,
	                    firstItemType,
	                    i = 0,
	                    j = 0;
	
	                if (isNumber(options) || options === null) {
	                    ret[pointArrayMap[0]] = options;
	
	                } else if (isArray(options)) {
	                    // with leading x value
	                    if (!keys && options.length > valueCount) {
	                        firstItemType = typeof options[0];
	                        if (firstItemType === 'string') {
	                            ret.name = options[0];
	                        } else if (firstItemType === 'number') {
	                            ret.x = options[0];
	                        }
	                        i++;
	                    }
	                    while (j < valueCount) {
	                        if (!keys || options[i] !== undefined) { // Skip undefined positions for keys
	                            ret[pointArrayMap[j]] = options[i];
	                        }
	                        i++;
	                        j++;
	                    }
	                } else if (typeof options === 'object') {
	                    ret = options;
	
	                    // This is the fastest way to detect if there are individual point dataLabels that need
	                    // to be considered in drawDataLabels. These can only occur in object configs.
	                    if (options.dataLabels) {
	                        series._hasPointLabels = true;
	                    }
	
	                    // Same approach as above for markers
	                    if (options.marker) {
	                        series._hasPointMarkers = true;
	                    }
	                }
	                return ret;
	            },
	
	            /**
	             * Get the CSS class names for individual points. Used internally where the
	             * returned value is set on every point.
	             * 
	             * @returns {String} The class names.
	             */
	            getClassName: function() {
	                return 'highcharts-point' +
	                    (this.selected ? ' highcharts-point-select' : '') +
	                    (this.negative ? ' highcharts-negative' : '') +
	                    (this.isNull ? ' highcharts-null-point' : '') +
	                    (this.colorIndex !== undefined ? ' highcharts-color-' +
	                        this.colorIndex : '') +
	                    (this.options.className ? ' ' + this.options.className : '') +
	                    (this.zone && this.zone.className ? ' ' +
	                        this.zone.className.replace('highcharts-negative', '') : '');
	            },
	
	            /**
	             * In a series with `zones`, return the zone that the point belongs to.
	             *
	             * @return {Object}
	             *         The zone item.
	             */
	            getZone: function() {
	                var series = this.series,
	                    zones = series.zones,
	                    zoneAxis = series.zoneAxis || 'y',
	                    i = 0,
	                    zone;
	
	                zone = zones[i];
	                while (this[zoneAxis] >= zone.value) {
	                    zone = zones[++i];
	                }
	
	                if (zone && zone.color && !this.options.color) {
	                    this.color = zone.color;
	                }
	
	                return zone;
	            },
	
	            /**
	             * Destroy a point to clear memory. Its reference still stays in
	             * `series.data`.
	             *
	             * @private
	             */
	            destroy: function() {
	                var point = this,
	                    series = point.series,
	                    chart = series.chart,
	                    hoverPoints = chart.hoverPoints,
	                    prop;
	
	                chart.pointCount--;
	
	                if (hoverPoints) {
	                    point.setState();
	                    erase(hoverPoints, point);
	                    if (!hoverPoints.length) {
	                        chart.hoverPoints = null;
	                    }
	
	                }
	                if (point === chart.hoverPoint) {
	                    point.onMouseOut();
	                }
	
	                // remove all events
	                if (point.graphic || point.dataLabel) { // removeEvent and destroyElements are performance expensive
	                    removeEvent(point);
	                    point.destroyElements();
	                }
	
	                if (point.legendItem) { // pies have legend items
	                    chart.legend.destroyItem(point);
	                }
	
	                for (prop in point) {
	                    point[prop] = null;
	                }
	
	
	            },
	
	            /**
	             * Destroy SVG elements associated with the point.
	             *
	             * @private
	             */
	            destroyElements: function() {
	                var point = this,
	                    props = ['graphic', 'dataLabel', 'dataLabelUpper', 'connector', 'shadowGroup'],
	                    prop,
	                    i = 6;
	                while (i--) {
	                    prop = props[i];
	                    if (point[prop]) {
	                        point[prop] = point[prop].destroy();
	                    }
	                }
	            },
	
	            /**
	             * Return the configuration hash needed for the data label and tooltip
	             * formatters.
	             *
	             * @returns {Object}
	             *          Abstract object used in formatters and formats.
	             */
	            getLabelConfig: function() {
	                return {
	                    x: this.category,
	                    y: this.y,
	                    color: this.color,
	                    colorIndex: this.colorIndex,
	                    key: this.name || this.category,
	                    series: this.series,
	                    point: this,
	                    percentage: this.percentage,
	                    total: this.total || this.stackTotal
	                };
	            },
	
	            /**
	             * Extendable method for formatting each point's tooltip line.
	             *
	             * @param  {String} pointFormat
	             *         The point format.
	             * @return {String}
	             *         A string to be concatenated in to the common tooltip text.
	             */
	            tooltipFormatter: function(pointFormat) {
	
	                // Insert options for valueDecimals, valuePrefix, and valueSuffix
	                var series = this.series,
	                    seriesTooltipOptions = series.tooltipOptions,
	                    valueDecimals = pick(seriesTooltipOptions.valueDecimals, ''),
	                    valuePrefix = seriesTooltipOptions.valuePrefix || '',
	                    valueSuffix = seriesTooltipOptions.valueSuffix || '';
	
	                // Loop over the point array map and replace unformatted values with sprintf formatting markup
	                each(series.pointArrayMap || ['y'], function(key) {
	                    key = '{point.' + key; // without the closing bracket
	                    if (valuePrefix || valueSuffix) {
	                        pointFormat = pointFormat.replace(key + '}', valuePrefix + key + '}' + valueSuffix);
	                    }
	                    pointFormat = pointFormat.replace(key + '}', key + ':,.' + valueDecimals + 'f}');
	                });
	
	                return format(pointFormat, {
	                    point: this,
	                    series: this.series
	                });
	            },
	
	            /**
	             * Fire an event on the Point object.
	             *
	             * @private
	             * @param {String} eventType
	             * @param {Object} eventArgs Additional event arguments
	             * @param {Function} defaultFunction Default event handler
	             */
	            firePointEvent: function(eventType, eventArgs, defaultFunction) {
	                var point = this,
	                    series = this.series,
	                    seriesOptions = series.options;
	
	                // load event handlers on demand to save time on mouseover/out
	                if (seriesOptions.point.events[eventType] || (point.options && point.options.events && point.options.events[eventType])) {
	                    this.importEvents();
	                }
	
	                // add default handler if in selection mode
	                if (eventType === 'click' && seriesOptions.allowPointSelect) {
	                    defaultFunction = function(event) {
	                        // Control key is for Windows, meta (= Cmd key) for Mac, Shift for Opera
	                        if (point.select) { // Could be destroyed by prior event handlers (#2911)
	                            point.select(null, event.ctrlKey || event.metaKey || event.shiftKey);
	                        }
	                    };
	                }
	
	                fireEvent(this, eventType, eventArgs, defaultFunction);
	            },
	
	            /**
	             * For certain series types, like pie charts, where individual points can
	             * be shown or hidden. 
	             *
	             * @name visible
	             * @memberOf Highcharts.Point
	             * @type {Boolean}
	             */
	            visible: true
	        };
	
	        /**
	         * For categorized axes this property holds the category name for the 
	         * point. For other axes it holds the X value.
	         *
	         * @name category
	         * @memberOf Highcharts.Point
	         * @type {String|Number}
	         */
	
	        /**
	         * The percentage for points in a stacked series or pies.
	         *
	         * @name percentage
	         * @memberOf Highcharts.Point
	         * @type {Number}
	         */
	
	        /**
	         * The total of values in either a stack for stacked series, or a pie in a pie
	         * series.
	         *
	         * @name total
	         * @memberOf Highcharts.Point
	         * @type {Number}
	         */
	
	        /**
	         * The x value of the point.
	         *
	         * @name x
	         * @memberOf Highcharts.Point
	         * @type {Number}
	         */
	
	        /**
	         * The y value of the point.
	         *
	         * @name y
	         * @memberOf Highcharts.Point
	         * @type {Number}
	         */
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var addEvent = H.addEvent,
	            animObject = H.animObject,
	            arrayMax = H.arrayMax,
	            arrayMin = H.arrayMin,
	            correctFloat = H.correctFloat,
	            Date = H.Date,
	            defaultOptions = H.defaultOptions,
	            defaultPlotOptions = H.defaultPlotOptions,
	            defined = H.defined,
	            each = H.each,
	            erase = H.erase,
	            extend = H.extend,
	            fireEvent = H.fireEvent,
	            grep = H.grep,
	            isArray = H.isArray,
	            isNumber = H.isNumber,
	            isString = H.isString,
	            LegendSymbolMixin = H.LegendSymbolMixin, // @todo add as a requirement
	            merge = H.merge,
	            objectEach = H.objectEach,
	            pick = H.pick,
	            Point = H.Point, // @todo  add as a requirement
	            removeEvent = H.removeEvent,
	            splat = H.splat,
	            SVGElement = H.SVGElement,
	            syncTimeout = H.syncTimeout,
	            win = H.win;
	
	        /**
	         * This is the base series prototype that all other series types inherit from.
	         * A new series is initialized either through the {@link https://api.highcharts.com/highcharts/series|
	         * series} option structure, or after the chart is initialized, through {@link
	         * Highcharts.Chart#addSeries}.
	         *
	         * The object can be accessed in a number of ways. All series and point event
	         * handlers give a reference to the `series` object. The chart object has a
	         * {@link Highcharts.Chart.series|series} property that is a collection of all
	         * the chart's series. The point objects and axis objects also have the same
	         * reference.
	         *
	         * Another way to reference the series programmatically is by `id`. Add an id
	         * in the series configuration options, and get the series object by {@link
	         * Highcharts.Chart#get}.
	         *
	         * Configuration options for the series are given in three levels. Options for
	         * all series in a chart are given in the {@link https://api.highcharts.com/highcharts/plotOptions.series|
	         * plotOptions.series} object. Then options for all series of a specific type
	         * are given in the plotOptions of that type, for example `plotOptions.line`.
	         * Next, options for one single series are given in the series array, or as
	         * arguements to `chart.addSeries`.
	         *
	         * The data in the series is stored in various arrays.
	         *
	         * - First, `series.options.data` contains all the original config options for
	         * each point whether added by options or methods like `series.addPoint`.
	         * - Next, `series.data` contains those values converted to points, but in case
	         * the series data length exceeds the `cropThreshold`, or if the data is grouped,
	         * `series.data` doesn't contain all the points. It only contains the points that
	         * have been created on demand.
	         * - Then there's `series.points` that contains all currently visible point
	         * objects. In case of cropping, the cropped-away points are not part of this
	         * array. The `series.points` array starts at `series.cropStart` compared to
	         * `series.data` and `series.options.data`. If however the series data is grouped,
	         * these can't be correlated one to one.
	         * - `series.xData` and `series.processedXData` contain clean x values, equivalent
	         * to `series.data` and `series.points`.
	         * - `series.yData` and `series.processedYData` contain clean y values, equivalent
	         * to `series.data` and `series.points`.
	         *
	         * @class Highcharts.Series
	         * @param  {Highcharts.Chart} chart
	         *         The chart instance.
	         * @param  {Options.plotOptions.series} options
	         *         The series options.
	         *
	         */
	
	        /**
	         * General options for all series types.
	         * @optionparent plotOptions.series
	         */
	        H.Series = H.seriesType('line', null, { // base series options
	
	            //cursor: 'default',
	            //dashStyle: null,
	            //linecap: 'round',
	
	
	
	            /**
	             * Pixel with of the graph line.
	             * 
	             * @type {Number}
	             * @see In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	             * style/style-by-css), the line stroke-width can be set with the
	             * `.highcharts-graph` class name.
	             * @sample {highcharts} highcharts/plotoptions/series-linewidth-general/ On all series
	             * @sample {highcharts} highcharts/plotoptions/series-linewidth-specific/ On one single series
	             * @default 2
	             * @product highcharts highstock
	             */
	            lineWidth: 2,
	            //shadow: false,
	
	
	            /**
	             * For some series, there is a limit that shuts down initial animation
	             * by default when the total number of points in the chart is too high.
	             * For example, for a column chart and its derivatives, animation doesn't
	             * run if there is more than 250 points totally. To disable this cap, set
	             * `animationLimit` to `Infinity`.
	             * 
	             * @type {Number}
	             * @apioption plotOptions.series.animationLimit
	             */
	
	            /**
	             * Allow this series' points to be selected by clicking on the graphic 
	             * (columns, point markers, pie slices, map areas etc).
	             *
	             * @see [Chart#getSelectedPoints](../class-reference/Highcharts.Chart#getSelectedPoints).
	             * 
	             * @type {Boolean}
	             * @sample {highcharts} highcharts/plotoptions/series-allowpointselect-line/
	             *         Line
	             * @sample {highcharts} highcharts/plotoptions/series-allowpointselect-column/
	             *         Column
	             * @sample {highcharts} highcharts/plotoptions/series-allowpointselect-pie/
	             *         Pie
	             * @sample {highmaps} maps/plotoptions/series-allowpointselect/
	             *         Map area
	             * @sample {highmaps} maps/plotoptions/mapbubble-allowpointselect/
	             *         Map bubble
	             * @default false
	             * @since 1.2.0
	             * @product highcharts highstock highmaps
	             */
	            allowPointSelect: false,
	
	
	
	            /**
	             * If true, a checkbox is displayed next to the legend item to allow
	             * selecting the series. The state of the checkbox is determined by
	             * the `selected` option.
	             *
	             * @productdesc {highmaps}
	             * Note that if a `colorAxis` is defined, the color axis is represented in
	             * the legend, not the series.
	             * 
	             * @type {Boolean}
	             * @sample {highcharts} highcharts/plotoptions/series-showcheckbox-true/
	             *         Show select box
	             * @default false
	             * @since 1.2.0
	             */
	            showCheckbox: false,
	
	
	
	            /**
	             * Enable or disable the initial animation when a series is displayed.
	             * The animation can also be set as a configuration object. Please
	             * note that this option only applies to the initial animation of the
	             * series itself. For other animations, see [chart.animation](#chart.
	             * animation) and the animation parameter under the API methods. The
	             * following properties are supported:
	             * 
	             * <dl>
	             * 
	             * <dt>duration</dt>
	             * 
	             * <dd>The duration of the animation in milliseconds.</dd>
	             * 
	             * <dt>easing</dt>
	             * 
	             * <dd>A string reference to an easing function set on the `Math` object.
	             * See [the easing demo](http://jsfiddle.net/gh/get/library/pure/highcharts/highcharts/tree/master/samples/highcharts/plotoptions/series-
	             * animation-easing/).</dd>
	             * 
	             * </dl>
	             * 
	             * Due to poor performance, animation is disabled in old IE browsers
	             * for several chart types.
	             * 
	             * @type {Boolean}
	             * @sample {highcharts} highcharts/plotoptions/series-animation-disabled/
	             *         Animation disabled
	             * @sample {highcharts} highcharts/plotoptions/series-animation-slower/
	             *         Slower animation
	             * @sample {highcharts} highcharts/plotoptions/series-animation-easing/
	             *         Custom easing function
	             * @sample {highstock} stock/plotoptions/animation-slower/
	             *         Slower animation
	             * @sample {highstock} stock/plotoptions/animation-easing/
	             *         Custom easing function
	             * @sample {highmaps} maps/plotoptions/series-animation-true/
	             *         Animation enabled on map series
	             * @sample {highmaps} maps/plotoptions/mapbubble-animation-false/
	             *         Disabled on mapbubble series
	             * @default {highcharts} true
	             * @default {highstock} true
	             * @default {highmaps} false
	             */
	            animation: {
	
	
	                /**
	                 */
	                duration: 1000
	            },
	
	            /**
	             * A class name to apply to the series' graphical elements.
	             * 
	             * @type {String}
	             * @since 5.0.0
	             * @apioption plotOptions.series.className
	             */
	
	            /**
	             * The main color of the series. In line type series it applies to the
	             * line and the point markers unless otherwise specified. In bar type
	             * series it applies to the bars unless a color is specified per point.
	             * The default value is pulled from the `options.colors` array.
	             * 
	             * In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	             * style/style-by-css), the color can be defined by the [colorIndex](#plotOptions.
	             * series.colorIndex) option. Also, the series color can be set with
	             * the `.highcharts-series`, `.highcharts-color-{n}`, `.highcharts-{type}-
	             * series` or `.highcharts-series-{n}` class, or individual classes
	             * given by the `className` option.
	             *
	             * @productdesc {highmaps}
	             * In maps, the series color is rarely used, as most choropleth maps use the
	             * color to denote the value of each point. The series color can however be
	             * used in a map with multiple series holding categorized data.
	             * 
	             * @type {Color}
	             * @sample {highcharts} highcharts/plotoptions/series-color-general/
	             *         General plot option
	             * @sample {highcharts} highcharts/plotoptions/series-color-specific/
	             *         One specific series
	             * @sample {highcharts} highcharts/plotoptions/series-color-area/
	             *         Area color
	             * @sample {highmaps} maps/demo/category-map/
	             *         Category map by multiple series
	             * @apioption plotOptions.series.color
	             */
	
	            /**
	             * [Styled mode](http://www.highcharts.com/docs/chart-design-and-style/style-
	             * by-css) only. A specific color index to use for the series, so its
	             * graphic representations are given the class name `highcharts-color-
	             * {n}`.
	             * 
	             * @type {Number}
	             * @since 5.0.0
	             * @apioption plotOptions.series.colorIndex
	             */
	
	
	            /**
	             * Whether to connect a graph line across null points, or render a gap
	             * between the two points on either side of the null.
	             * 
	             * @type {Boolean}
	             * @sample {highcharts} highcharts/plotoptions/series-connectnulls-false/
	             *         False by default
	             * @sample {highcharts} highcharts/plotoptions/series-connectnulls-true/
	             *         True
	             * @product highcharts highstock
	             * @apioption plotOptions.series.connectNulls
	             */
	
	
	            /**
	             * You can set the cursor to "pointer" if you have click events attached
	             * to the series, to signal to the user that the points and lines can
	             * be clicked.
	             * 
	             * @validvalue [null, "default", "none", "help", "pointer", "crosshair"]
	             * @type {String}
	             * @see In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	             * style/style-by-css), the series cursor can be set with the same classes
	             * as listed under [series.color](#plotOptions.series.color).
	             * @sample {highcharts} highcharts/plotoptions/series-cursor-line/
	             *         On line graph
	             * @sample {highcharts} highcharts/plotoptions/series-cursor-column/
	             *         On columns
	             * @sample {highcharts} highcharts/plotoptions/series-cursor-scatter/
	             *         On scatter markers
	             * @sample {highstock} stock/plotoptions/cursor/
	             *         Pointer on a line graph
	             * @sample {highmaps} maps/plotoptions/series-allowpointselect/
	             *         Map area
	             * @sample {highmaps} maps/plotoptions/mapbubble-allowpointselect/
	             *         Map bubble
	             * @apioption plotOptions.series.cursor
	             */
	
	
	            /**
	             * A name for the dash style to use for the graph, or for some series types
	             * the outline of each shape. The value for the `dashStyle` include:
	             * 
	             * *   Solid
	             * *   ShortDash
	             * *   ShortDot
	             * *   ShortDashDot
	             * *   ShortDashDotDot
	             * *   Dot
	             * *   Dash
	             * *   LongDash
	             * *   DashDot
	             * *   LongDashDot
	             * *   LongDashDotDot
	             * 
	             * @validvalue ["Solid", "ShortDash", "ShortDot", "ShortDashDot",
	             *             "ShortDashDotDot", "Dot", "Dash" ,"LongDash", "DashDot",
	             *             "LongDashDot", "LongDashDotDot"]
	             * @type {String}
	             * @see In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	             * style/style-by-css), the [stroke dash-array](http://jsfiddle.net/gh/get/library/pure/highcharts/highcharts/tree/master/samples/highcharts/css/series-
	             * dashstyle/) can be set with the same classes as listed under [series.
	             * color](#plotOptions.series.color).
	             * @sample {highcharts} highcharts/plotoptions/series-dashstyle-all/
	             *         Possible values demonstrated
	             * @sample {highcharts} highcharts/plotoptions/series-dashstyle/
	             *         Chart suitable for printing in black and white
	             * @sample {highstock} highcharts/plotoptions/series-dashstyle-all/
	             *         Possible values demonstrated
	             * @sample {highmaps} highcharts/plotoptions/series-dashstyle-all/
	             *         Possible values demonstrated
	             * @sample {highmaps} maps/plotoptions/series-dashstyle/
	             *         Dotted borders on a map
	             * @default Solid
	             * @since 2.1
	             * @apioption plotOptions.series.dashStyle
	             */
	
	            /**
	             * Requires the Accessibility module.
	             * 
	             * A description of the series to add to the screen reader information
	             * about the series.
	             * 
	             * @type {String}
	             * @default undefined
	             * @since 5.0.0
	             * @apioption plotOptions.series.description
	             */
	
	
	
	
	
	            /**
	             * Enable or disable the mouse tracking for a specific series. This
	             * includes point tooltips and click events on graphs and points. For
	             * large datasets it improves performance.
	             * 
	             * @type {Boolean}
	             * @sample {highcharts} highcharts/plotoptions/series-enablemousetracking-false/ No mouse tracking
	             * @sample {highmaps} maps/plotoptions/series-enablemousetracking-false/ No mouse tracking
	             * @default true
	             * @apioption plotOptions.series.enableMouseTracking
	             */
	
	            /**
	             * By default, series are exposed to screen readers as regions. By enabling
	             * this option, the series element itself will be exposed in the same
	             * way as the data points. This is useful if the series is not used
	             * as a grouping entity in the chart, but you still want to attach a
	             * description to the series.
	             * 
	             * Requires the Accessibility module.
	             * 
	             * @type {Boolean}
	             * @sample {highcharts} highcharts/accessibility/art-grants/ Accessible data visualization
	             * @sample {highstock} highcharts/accessibility/art-grants/ Accessible data visualization
	             * @sample {highmaps} highcharts/accessibility/art-grants/ Accessible data visualization
	             * @default undefined
	             * @since 5.0.12
	             * @apioption plotOptions.series.exposeElementToA11y
	             */
	
	            /**
	             * Whether to use the Y extremes of the total chart width or only the
	             * zoomed area when zooming in on parts of the X axis. By default, the
	             * Y axis adjusts to the min and max of the visible data. Cartesian
	             * series only.
	             * 
	             * @type {Boolean}
	             * @default false
	             * @since 4.1.6
	             * @product highcharts highstock
	             * @apioption plotOptions.series.getExtremesFromAll
	             */
	
	            /**
	             * An array specifying which option maps to which key in the data point
	             * array. This makes it convenient to work with unstructured data arrays
	             * from different sources.
	             * 
	             * @type {Array<String>}
	             * @see [series.data](#series<line>.data)
	             * @sample {highcharts} highcharts/series/data-keys/ An extended data array with keys
	             * @sample {highstock} highcharts/series/data-keys/ An extended data array with keys
	             * @since 4.1.6
	             * @product highcharts highstock
	             * @apioption plotOptions.series.keys
	             */
	
	            /**
	             * The line cap used for line ends and line joins on the graph.
	             * 
	             * @validvalue ["round", "square"]
	             * @type {String}
	             * @default round
	             * @product highcharts highstock
	             * @apioption plotOptions.series.linecap
	             */
	
	            /**
	             * The [id](#series.id) of another series to link to. Additionally,
	             * the value can be ":previous" to link to the previous series. When
	             * two series are linked, only the first one appears in the legend.
	             * Toggling the visibility of this also toggles the linked series.
	             * 
	             * @type {String}
	             * @sample {highcharts} highcharts/demo/arearange-line/ Linked series
	             * @sample {highstock} highcharts/demo/arearange-line/ Linked series
	             * @since 3.0
	             * @product highcharts highstock
	             * @apioption plotOptions.series.linkedTo
	             */
	
	            /**
	             * The color for the parts of the graph or points that are below the
	             * [threshold](#plotOptions.series.threshold).
	             * 
	             * @type {Color}
	             * @see In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	             * style/style-by-css), a negative color is applied by setting this
	             * option to `true` combined with the `.highcharts-negative` class name
	             * ([view live demo](http://jsfiddle.net/gh/get/library/pure/highcharts/highcharts/tree/master/samples/highcharts/css/series-
	             * negative-color/)).
	             * @sample {highcharts} highcharts/plotoptions/series-negative-color/ Spline, area and column
	             * @sample {highcharts} highcharts/plotoptions/arearange-negativecolor/ Arearange
	             * @sample {highstock} highcharts/plotoptions/series-negative-color/ Spline, area and column
	             * @sample {highstock} highcharts/plotoptions/arearange-negativecolor/ Arearange
	             * @sample {highmaps} highcharts/plotoptions/series-negative-color/ Spline, area and column
	             * @sample {highmaps} highcharts/plotoptions/arearange-negativecolor/ Arearange
	             * @default null
	             * @since 3.0
	             * @apioption plotOptions.series.negativeColor
	             */
	
	            /**
	             * Same as [accessibility.pointDescriptionFormatter](#accessibility.
	             * pointDescriptionFormatter), but for an individual series. Overrides
	             * the chart wide configuration.
	             * 
	             * @type {Function}
	             * @since 5.0.12
	             * @apioption plotOptions.series.pointDescriptionFormatter
	             */
	
	            /**
	             * If no x values are given for the points in a series, `pointInterval`
	             * defines the interval of the x values. For example, if a series contains
	             * one value every decade starting from year 0, set `pointInterval` to
	             * 10. In true `datetime` axes, the `pointInterval` is set in milliseconds.
	             * 
	             * It can be also be combined with `pointIntervalUnit` to draw irregular
	             * time intervals.
	             * 
	             * @type {Number}
	             * @sample {highcharts} highcharts/plotoptions/series-pointstart-datetime/
	             *         Datetime X axis
	             * @sample {highstock} stock/plotoptions/pointinterval-pointstart/
	             *         Using pointStart and pointInterval
	             * @default 1
	             * @product highcharts highstock
	             * @apioption plotOptions.series.pointInterval
	             */
	
	            /**
	             * On datetime series, this allows for setting the [pointInterval](#plotOptions.
	             * series.pointInterval) to irregular time units, `day`, `month` and
	             * `year`. A day is usually the same as 24 hours, but pointIntervalUnit
	             * also takes the DST crossover into consideration when dealing with
	             * local time. Combine this option with `pointInterval` to draw weeks,
	             *  quarters, 6 months, 10 years etc.
	             * 
	             * @validvalue [null, "day", "month", "year"]
	             * @type {String}
	             * @sample {highcharts} highcharts/plotoptions/series-pointintervalunit/ One point a month
	             * @sample {highstock} highcharts/plotoptions/series-pointintervalunit/ One point a month
	             * @since 4.1.0
	             * @product highcharts highstock
	             * @apioption plotOptions.series.pointIntervalUnit
	             */
	
	            /**
	             * Possible values: `null`, `"on"`, `"between"`.
	             * 
	             * In a column chart, when pointPlacement is `"on"`, the point will
	             * not create any padding of the X axis. In a polar column chart this
	             * means that the first column points directly north. If the pointPlacement
	             * is `"between"`, the columns will be laid out between ticks. This
	             * is useful for example for visualising an amount between two points
	             * in time or in a certain sector of a polar chart.
	             * 
	             * Since Highcharts 3.0.2, the point placement can also be numeric,
	             * where 0 is on the axis value, -0.5 is between this value and the
	             * previous, and 0.5 is between this value and the next. Unlike the
	             * textual options, numeric point placement options won't affect axis
	             * padding.
	             * 
	             * Note that pointPlacement needs a [pointRange](#plotOptions.series.
	             * pointRange) to work. For column series this is computed, but for
	             * line-type series it needs to be set.
	             * 
	             * Defaults to `null` in cartesian charts, `"between"` in polar charts.
	             * 
	             * @validvalue [null, "on", "between"]
	             * @type {String|Number}
	             * @see [xAxis.tickmarkPlacement](#xAxis.tickmarkPlacement)
	             * @sample {highcharts} highcharts/plotoptions/series-pointplacement-between/ Between in a column chart
	             * @sample {highcharts} highcharts/plotoptions/series-pointplacement-numeric/ Numeric placement for custom layout
	             * @sample {highstock} highcharts/plotoptions/series-pointplacement-between/ Between in a column chart
	             * @sample {highstock} highcharts/plotoptions/series-pointplacement-numeric/ Numeric placement for custom layout
	             * @default null
	             * @since 2.3.0
	             * @product highcharts highstock
	             * @apioption plotOptions.series.pointPlacement
	             */
	
	            /**
	             * If no x values are given for the points in a series, pointStart defines
	             * on what value to start. For example, if a series contains one yearly
	             * value starting from 1945, set pointStart to 1945.
	             * 
	             * @type {Number}
	             * @sample {highcharts} highcharts/plotoptions/series-pointstart-linear/ Linear
	             * @sample {highcharts} highcharts/plotoptions/series-pointstart-datetime/ Datetime
	             * @sample {highstock} stock/plotoptions/pointinterval-pointstart/ Using pointStart and pointInterval
	             * @default 0
	             * @product highcharts highstock
	             * @apioption plotOptions.series.pointStart
	             */
	
	            /**
	             * Whether to select the series initially. If `showCheckbox` is true,
	             * the checkbox next to the series name in the legend will be checked for a
	             * selected series.
	             * 
	             * @type {Boolean}
	             * @sample {highcharts} highcharts/plotoptions/series-selected/
	             *         One out of two series selected
	             * @default false
	             * @since 1.2.0
	             * @apioption plotOptions.series.selected
	             */
	
	            /**
	             * Whether to apply a drop shadow to the graph line. Since 2.3 the shadow
	             * can be an object configuration containing `color`, `offsetX`, `offsetY`,
	             *  `opacity` and `width`.
	             * 
	             * @type {Boolean|Object}
	             * @sample {highcharts} highcharts/plotoptions/series-shadow/ Shadow enabled
	             * @default false
	             * @apioption plotOptions.series.shadow
	             */
	
	            /**
	             * Whether to display this particular series or series type in the legend.
	             * The default value is `true` for standalone series, `false` for linked
	             * series.
	             * 
	             * @type {Boolean}
	             * @sample {highcharts} highcharts/plotoptions/series-showinlegend/ One series in the legend, one hidden
	             * @default true
	             * @apioption plotOptions.series.showInLegend
	             */
	
	            /**
	             * If set to `True`, the accessibility module will skip past the points
	             * in this series for keyboard navigation.
	             * 
	             * @type {Boolean}
	             * @since 5.0.12
	             * @apioption plotOptions.series.skipKeyboardNavigation
	             */
	
	            /**
	             * Whether to stack the values of each series on top of each other.
	             * Possible values are null to disable, "normal" to stack by value or
	             * "percent". When stacking is enabled, data must be sorted in ascending
	             * X order.
	             * 
	             * @validvalue [null, "normal", "percent"]
	             * @type {String}
	             * @see [yAxis.reversedStacks](#yAxis.reversedStacks)
	             * @sample {highcharts} highcharts/plotoptions/series-stacking-line/ Line
	             * @sample {highcharts} highcharts/plotoptions/series-stacking-column/ Column
	             * @sample {highcharts} highcharts/plotoptions/series-stacking-bar/ Bar
	             * @sample {highcharts} highcharts/plotoptions/series-stacking-area/ Area
	             * @sample {highcharts} highcharts/plotoptions/series-stacking-percent-line/ Line
	             * @sample {highcharts} highcharts/plotoptions/series-stacking-percent-column/ Column
	             * @sample {highcharts} highcharts/plotoptions/series-stacking-percent-bar/ Bar
	             * @sample {highcharts} highcharts/plotoptions/series-stacking-percent-area/ Area
	             * @sample {highstock} stock/plotoptions/stacking/ Area
	             * @default null
	             * @product highcharts highstock
	             * @apioption plotOptions.series.stacking
	             */
	
	            /**
	             * Whether to apply steps to the line. Possible values are `left`, `center`
	             * and `right`.
	             * 
	             * @validvalue [null, "left", "center", "right"]
	             * @type {String}
	             * @sample {highcharts} highcharts/plotoptions/line-step/ Different step line options
	             * @sample {highcharts} highcharts/plotoptions/area-step/ Stepped, stacked area
	             * @sample {highstock} stock/plotoptions/line-step/ Step line
	             * @default {highcharts} null
	             * @default {highstock} false
	             * @since 1.2.5
	             * @product highcharts highstock
	             * @apioption plotOptions.series.step
	             */
	
	            /**
	             * The threshold, also called zero level or base level. For line type
	             * series this is only used in conjunction with [negativeColor](#plotOptions.
	             * series.negativeColor).
	             * 
	             * @type {Number}
	             * @see [softThreshold](#plotOptions.series.softThreshold).
	             * @default 0
	             * @since 3.0
	             * @product highcharts highstock
	             * @apioption plotOptions.series.threshold
	             */
	
	            /**
	             * Set the initial visibility of the series.
	             * 
	             * @type {Boolean}
	             * @sample {highcharts} highcharts/plotoptions/series-visible/ Two series, one hidden and one visible
	             * @sample {highstock} stock/plotoptions/series-visibility/ Hidden series
	             * @default true
	             * @apioption plotOptions.series.visible
	             */
	
	            /**
	             * Defines the Axis on which the zones are applied.
	             * 
	             * @type {String}
	             * @see [zones](#plotOption.series.zones)
	             * @sample {highcharts} highcharts/series/color-zones-zoneaxis-x/ Zones on the X-Axis
	             * @sample {highstock} highcharts/series/color-zones-zoneaxis-x/ Zones on the X-Axis
	             * @default y
	             * @since 4.1.0
	             * @product highcharts highstock
	             * @apioption plotOptions.series.zoneAxis
	             */
	
	            /**
	             * @product highcharts highstock highmaps
	             */
	            events: {},
	
	
	
	            /**
	             * Options for the point markers of line-like series. Properties like
	             * `fillColor`, `lineColor` and `lineWidth` define the visual appearance
	             * of the markers. Other series types, like column series, don't have
	             * markers, but have visual options on the series level instead.
	             * 
	             * In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	             * style/style-by-css), the markers can be styled with the `.highcharts-
	             * point`, `.highcharts-point-hover` and `.highcharts-point-select`
	             * class names.
	             * 
	             * @product highcharts highstock
	             */
	            marker: {
	
	
	
	                /**
	                 * The width of the point marker's outline.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/plotoptions/series-marker-fillcolor/ 2px blue marker
	                 * @default 0
	                 * @product highcharts highstock
	                 */
	                lineWidth: 0,
	
	
	                /**
	                 * The color of the point marker's outline. When `null`, the series'
	                 * or point's color is used.
	                 * 
	                 * @type {Color}
	                 * @sample {highcharts} highcharts/plotoptions/series-marker-fillcolor/ Inherit from series color (null)
	                 * @default #ffffff
	                 * @product highcharts highstock
	                 */
	                lineColor: '#ffffff',
	                //fillColor: null,
	
	                //enabled: true,
	                //symbol: null,
	
	
	                /**
	                 * The radius of the point marker.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/plotoptions/series-marker-radius/ Bigger markers
	                 * @default 4
	                 * @product highcharts highstock
	                 */
	                radius: 4,
	
	
	                /**
	                 * @product highcharts highstock
	                 */
	                states: { // states for a single point
	
	
	
	                    /**
	                     * @product highcharts highstock
	                     */
	                    hover: {
	
	
	
	                        /**
	                         */
	                        animation: {
	
	
	                            /**
	                             */
	                            duration: 50
	                        },
	
	
	
	                        /**
	                         * Enable or disable the point marker.
	                         * 
	                         * @type {Boolean}
	                         * @sample {highcharts} highcharts/plotoptions/series-marker-states-hover-enabled/ Disabled hover state
	                         * @default true
	                         * @product highcharts highstock
	                         */
	                        enabled: true,
	
	
	
	                        /**
	                         * The number of pixels to increase the radius of the hovered point.
	                         * 
	                         * @type {Number}
	                         * @sample {highcharts} highcharts/plotoptions/series-states-hover-linewidthplus/ 5 pixels greater radius on hover
	                         * @sample {highstock} highcharts/plotoptions/series-states-hover-linewidthplus/ 5 pixels greater radius on hover
	                         * @default 2
	                         * @since 4.0.3
	                         * @product highcharts highstock
	                         */
	                        radiusPlus: 2,
	
	
	
	
	                        /**
	                         * The additional line width for a hovered point.
	                         * 
	                         * @type {Number}
	                         * @sample {highcharts} highcharts/plotoptions/series-states-hover-linewidthplus/ 2 pixels wider on hover
	                         * @sample {highstock} highcharts/plotoptions/series-states-hover-linewidthplus/ 2 pixels wider on hover
	                         * @default 1
	                         * @since 4.0.3
	                         * @product highcharts highstock
	                         */
	                        lineWidthPlus: 1
	
	                    },
	
	
	
	
	                    /**
	                     * The appearance of the point marker when selected. In order to
	                     * allow a point to be selected, set the `series.allowPointSelect`
	                     * option to true.
	                     * 
	                     * @product highcharts highstock
	                     */
	                    select: {
	
	
	
	                        /**
	                         * The fill color of the point marker.
	                         * 
	                         * @type {Color}
	                         * @sample {highcharts} highcharts/plotoptions/series-marker-states-select-fillcolor/ Solid red discs for selected points
	                         * @default null
	                         * @product highcharts highstock
	                         */
	                        fillColor: '#cccccc',
	
	
	
	                        /**
	                         * The color of the point marker's outline. When `null`, the series'
	                         * or point's color is used.
	                         * 
	                         * @type {Color}
	                         * @sample {highcharts} highcharts/plotoptions/series-marker-states-select-linecolor/ Red line color for selected points
	                         * @default #000000
	                         * @product highcharts highstock
	                         */
	                        lineColor: '#000000',
	
	
	
	                        /**
	                         * The width of the point marker's outline.
	                         * 
	                         * @type {Number}
	                         * @sample {highcharts} highcharts/plotoptions/series-marker-states-select-linewidth/ 3px line width for selected points
	                         * @default 0
	                         * @product highcharts highstock
	                         */
	                        lineWidth: 2
	                    }
	
	                }
	            },
	
	
	
	            /**
	             * Properties for each single point
	             * 
	             * @product highcharts highstock highmaps
	             */
	            point: {
	
	
	                /**
	                 * Events for each single point
	                 * 
	                 * @product highcharts highstock highmaps
	                 */
	                events: {}
	            },
	
	
	
	            /**
	             * Options for the series data labels, appearing next to each data
	             * point.
	             * 
	             * In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	             * style/style-by-css), the data labels can be styled wtih the `.highcharts-
	             * data-label-box` and `.highcharts-data-label` class names ([see example](http://jsfiddle.
	             * net/gh/get/library/pure/highcharts/highcharts/tree/master/samples/highcharts/css/series-
	             * datalabels)).
	             */
	            dataLabels: {
	
	
	                /**
	                 * The alignment of the data label compared to the point. If `right`,
	                 * the right side of the label should be touching the point. For
	                 * points with an extent, like columns, the alignments also dictates
	                 * how to align it inside the box, as given with the [inside](#plotOptions.
	                 * column.dataLabels.inside) option. Can be one of "left", "center"
	                 * or "right".
	                 * 
	                 * @validvalue ["left", "center", "right"]
	                 * @type {String}
	                 * @sample {highcharts} highcharts/plotoptions/series-datalabels-align-left/ Left aligned
	                 * @default center
	                 */
	                align: 'center',
	
	
	                /**
	                 * Whether to allow data labels to overlap. To make the labels less
	                 * sensitive for overlapping, the [dataLabels.padding](#plotOptions.
	                 * series.dataLabels.padding) can be set to 0.
	                 * 
	                 * @type {Boolean}
	                 * @sample {highcharts} highcharts/plotoptions/series-datalabels-allowoverlap-false/ Don't allow overlap
	                 * @sample {highstock} highcharts/plotoptions/series-datalabels-allowoverlap-false/ Don't allow overlap
	                 * @sample {highmaps} highcharts/plotoptions/series-datalabels-allowoverlap-false/ Don't allow overlap
	                 * @default false
	                 * @since 4.1.0
	                 * @apioption plotOptions.series.dataLabels.allowOverlap
	                 */
	
	
	                /**
	                 * The border radius in pixels for the data label.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/plotoptions/series-datalabels-box/ Data labels box options
	                 * @sample {highstock} highcharts/plotoptions/series-datalabels-box/ Data labels box options
	                 * @sample {highmaps} maps/plotoptions/series-datalabels-box/ Data labels box options
	                 * @default 0
	                 * @since 2.2.1
	                 * @apioption plotOptions.series.dataLabels.borderRadius
	                 */
	
	
	                /**
	                 * The border width in pixels for the data label.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/plotoptions/series-datalabels-box/ Data labels box options
	                 * @sample {highstock} highcharts/plotoptions/series-datalabels-box/ Data labels box options
	                 * @default 0
	                 * @since 2.2.1
	                 * @apioption plotOptions.series.dataLabels.borderWidth
	                 */
	
	                /**
	                 * A class name for the data label. Particularly in [styled mode](http://www.
	                 * highcharts.com/docs/chart-design-and-style/style-by-css), this can
	                 * be used to give each series' or point's data label unique styling.
	                 * In addition to this option, a default color class name is added
	                 * so that we can give the labels a [contrast text shadow](http://jsfiddle.
	                 * net/gh/get/library/pure/highcharts/highcharts/tree/master/samples/highcharts/css/data-
	                 * label-contrast/).
	                 * 
	                 * @type {String}
	                 * @sample {highcharts} highcharts/css/series-datalabels/ Styling by CSS
	                 * @sample {highstock} highcharts/css/series-datalabels/ Styling by CSS
	                 * @sample {highmaps} highcharts/css/series-datalabels/ Styling by CSS
	                 * @since 5.0.0
	                 * @apioption plotOptions.series.dataLabels.className
	                 */
	
	                /**
	                 * The text color for the data labels. Defaults to `null`. For certain series
	                 * types, like column or map, the data labels can be drawn inside the points.
	                 * In this case the data label will be drawn with maximum contrast by default.
	                 * Additionally, it will be given a `text-outline` style with the opposite
	                 * color, to further increase the contrast. This can be overridden by setting
	                 * the `text-outline` style to `none` in the `dataLabels.style` option.
	                 * 
	                 * @type {Color}
	                 * @sample {highcharts} highcharts/plotoptions/series-datalabels-color/
	                 *         Red data labels
	                 * @sample {highmaps} maps/demo/color-axis/
	                 *         White data labels
	                 * @apioption plotOptions.series.dataLabels.color
	                 */
	
	                /**
	                 * Whether to hide data labels that are outside the plot area. By default,
	                 * the data label is moved inside the plot area according to the [overflow](#plotOptions.
	                 * series.dataLabels.overflow) option.
	                 * 
	                 * @type {Boolean}
	                 * @default true
	                 * @since 2.3.3
	                 * @apioption plotOptions.series.dataLabels.crop
	                 */
	
	                /**
	                 * Whether to defer displaying the data labels until the initial series
	                 * animation has finished.
	                 * 
	                 * @type {Boolean}
	                 * @default true
	                 * @since 4.0
	                 * @product highcharts highstock
	                 * @apioption plotOptions.series.dataLabels.defer
	                 */
	
	                /**
	                 * Enable or disable the data labels.
	                 * 
	                 * @type {Boolean}
	                 * @sample {highcharts} highcharts/plotoptions/series-datalabels-enabled/ Data labels enabled
	                 * @sample {highmaps} maps/demo/color-axis/ Data labels enabled
	                 * @default false
	                 * @apioption plotOptions.series.dataLabels.enabled
	                 */
	
	                /**
	                 * A [format string](http://www.highcharts.com/docs/chart-concepts/labels-
	                 * and-string-formatting) for the data label. Available variables are
	                 * the same as for `formatter`.
	                 * 
	                 * @type {String}
	                 * @sample {highcharts} highcharts/plotoptions/series-datalabels-format/ Add a unit
	                 * @sample {highstock} highcharts/plotoptions/series-datalabels-format/ Add a unit
	                 * @sample {highmaps} maps/plotoptions/series-datalabels-format/ Formatted value in the data label
	                 * @default {highcharts} {y}
	                 * @default {highstock} {y}
	                 * @default {highmaps} {point.value}
	                 * @since 3.0
	                 * @apioption plotOptions.series.dataLabels.format
	                 */
	
	                /**
	                 * Callback JavaScript function to format the data label. Note that
	                 * if a `format` is defined, the format takes precedence and the formatter
	                 * is ignored. Available data are:
	                 * 
	                 * <table>
	                 * 
	                 * <tbody>
	                 * 
	                 * <tr>
	                 * 
	                 * <td>`this.percentage`</td>
	                 * 
	                 * <td>Stacked series and pies only. The point's percentage of the
	                 * total.</td>
	                 * 
	                 * </tr>
	                 * 
	                 * <tr>
	                 * 
	                 * <td>`this.point`</td>
	                 * 
	                 * <td>The point object. The point name, if defined, is available
	                 * through `this.point.name`.</td>
	                 * 
	                 * </tr>
	                 * 
	                 * <tr>
	                 * 
	                 * <td>`this.series`:</td>
	                 * 
	                 * <td>The series object. The series name is available through `this.
	                 * series.name`.</td>
	                 * 
	                 * </tr>
	                 * 
	                 * <tr>
	                 * 
	                 * <td>`this.total`</td>
	                 * 
	                 * <td>Stacked series only. The total value at this point's x value.
	                 * </td>
	                 * 
	                 * </tr>
	                 * 
	                 * <tr>
	                 * 
	                 * <td>`this.x`:</td>
	                 * 
	                 * <td>The x value.</td>
	                 * 
	                 * </tr>
	                 * 
	                 * <tr>
	                 * 
	                 * <td>`this.y`:</td>
	                 * 
	                 * <td>The y value.</td>
	                 * 
	                 * </tr>
	                 * 
	                 * </tbody>
	                 * 
	                 * </table>
	                 * 
	                 * @type {Function}
	                 * @sample {highmaps} maps/plotoptions/series-datalabels-format/ Formatted value
	                 * @product highcharts highstock highmaps
	                 */
	                formatter: function() {
	                    return this.y === null ? '' : H.numberFormat(this.y, -1);
	                },
	
	
	
	                /**
	                 * Styles for the label. The default `color` setting is `"contrast"`,
	                 * which is a pseudo color that Highcharts picks up and applies the
	                 * maximum contrast to the underlying point item, for example the
	                 * bar in a bar chart. The `textOutline` is a pseudo property that
	                 * applies an outline of the given width with the given color, which
	                 * by default is the maximum contrast to the text. So a bright text
	                 * color will result in a black text outline for maximum readability
	                 * on a mixed background. In some cases, especially with grayscale
	                 * text, the text outline doesn't work well, in which cases it can
	                 * be disabled by setting it to `"none"`.
	                 * 
	                 * @type {CSSObject}
	                 * @sample {highcharts} highcharts/plotoptions/series-datalabels-style/
	                 *         Bold labels
	                 * @sample {highmaps} maps/demo/color-axis/ Bold labels
	                 * @default {"color": "contrast", "fontSize": "11px", "fontWeight": "bold", "textOutline": "1px contrast" }
	                 * @since 4.1.0
	                 */
	                style: {
	                    fontSize: '11px',
	                    fontWeight: 'bold',
	                    color: 'contrast',
	                    textOutline: '1px contrast'
	                },
	
	                /**
	                 * The background color or gradient for the data label. Defaults to
	                 * `undefined`.
	                 * 
	                 * @type {Color}
	                 * @sample {highcharts} highcharts/plotoptions/series-datalabels-box/ Data labels box options
	                 * @sample {highmaps} maps/plotoptions/series-datalabels-box/ Data labels box options
	                 * @since 2.2.1
	                 * @apioption plotOptions.series.dataLabels.backgroundColor
	                 */
	
	                /**
	                 * The border color for the data label. Defaults to `undefined`.
	                 * 
	                 * @type {Color}
	                 * @sample {highcharts} highcharts/plotoptions/series-datalabels-box/ Data labels box options
	                 * @sample {highstock} highcharts/plotoptions/series-datalabels-box/ Data labels box options
	                 * @default undefined
	                 * @since 2.2.1
	                 * @apioption plotOptions.series.dataLabels.borderColor
	                 */
	
	                /**
	                 * The shadow of the box. Works best with `borderWidth` or `backgroundColor`.
	                 * Since 2.3 the shadow can be an object configuration containing `color`,
	                 *  `offsetX`, `offsetY`, `opacity` and `width`.
	                 * 
	                 * @type {Boolean|Object}
	                 * @sample {highcharts} highcharts/plotoptions/series-datalabels-box/ Data labels box options
	                 * @sample {highstock} highcharts/plotoptions/series-datalabels-box/ Data labels box options
	                 * @default false
	                 * @since 2.2.1
	                 * @apioption plotOptions.series.dataLabels.shadow
	                 */
	
	
	                /**
	                 * For points with an extent, like columns or map areas, whether to align the data
	                 * label inside the box or to the actual value point. Defaults to `false`
	                 * in most cases, `true` in stacked columns.
	                 * 
	                 * @type {Boolean}
	                 * @since 3.0
	                 * @apioption plotOptions.series.dataLabels.inside
	                 */
	
	                /**
	                 * How to handle data labels that flow outside the plot area. The default
	                 * is `justify`, which aligns them inside the plot area. For columns
	                 * and bars, this means it will be moved inside the bar. To display
	                 * data labels outside the plot area, set `crop` to `false` and `overflow`
	                 * to `"none"`.
	                 * 
	                 * @validvalue ["justify", "none"]
	                 * @type {String}
	                 * @default justify
	                 * @since 3.0.6
	                 * @apioption plotOptions.series.dataLabels.overflow
	                 */
	
	                /**
	                 * Text rotation in degrees. Note that due to a more complex structure,
	                 * backgrounds, borders and padding will be lost on a rotated data
	                 * label.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/plotoptions/series-datalabels-rotation/ Vertical labels
	                 * @default 0
	                 * @apioption plotOptions.series.dataLabels.rotation
	                 */
	
	                /**
	                 * The vertical alignment of a data label. Can be one of `top`, `middle`
	                 * or `bottom`. The default value depends on the data, for instance
	                 * in a column chart, the label is above positive values and below
	                 * negative values.
	                 * 
	                 * @validvalue ["top", "middle", "bottom"]
	                 * @type {String}
	                 * @since 2.3.3
	                 * @product highcharts highstock highmaps
	                 */
	                verticalAlign: 'bottom', // above singular point
	
	
	                /**
	                 * The x position offset of the label relative to the point.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/plotoptions/series-datalabels-rotation/ Vertical and positioned
	                 * @default 0
	                 * @product highcharts highstock highmaps
	                 */
	                x: 0,
	
	
	                /**
	                 * The y position offset of the label relative to the point.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/plotoptions/series-datalabels-rotation/ Vertical and positioned
	                 * @default -6
	                 * @product highcharts highstock highmaps
	                 */
	                y: 0,
	
	
	                /**
	                 * When either the `borderWidth` or the `backgroundColor` is set,
	                 * this is the padding within the box.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/plotoptions/series-datalabels-box/ Data labels box options
	                 * @sample {highstock} highcharts/plotoptions/series-datalabels-box/ Data labels box options
	                 * @sample {highmaps} maps/plotoptions/series-datalabels-box/ Data labels box options
	                 * @default {highcharts} 5
	                 * @default {highstock} 5
	                 * @default {highmaps} 0
	                 * @since 2.2.1
	                 * @product highcharts highstock highmaps
	                 */
	                padding: 5
	
	                /**
	                 * The name of a symbol to use for the border around the label. Symbols
	                 * are predefined functions on the Renderer object.
	                 * 
	                 * @type {String}
	                 * @sample {highcharts} highcharts/plotoptions/series-datalabels-shape/ A callout for annotations
	                 * @sample {highstock} highcharts/plotoptions/series-datalabels-shape/ A callout for annotations
	                 * @sample {highmaps} highcharts/plotoptions/series-datalabels-shape/ A callout for annotations (Highcharts demo)
	                 * @default square
	                 * @since 4.1.2
	                 * @apioption plotOptions.series.dataLabels.shape
	                 */
	
	                /**
	                 * The Z index of the data labels. The default Z index puts it above
	                 * the series. Use a Z index of 2 to display it behind the series.
	                 * 
	                 * @type {Number}
	                 * @default 6
	                 * @since 2.3.5
	                 * @apioption plotOptions.series.dataLabels.zIndex
	                 */
	            },
	            // draw points outside the plot area when the number of points is less than
	            // this
	
	
	
	            /**
	             * When the series contains less points than the crop threshold, all
	             * points are drawn, even if the points fall outside the visible plot
	             * area at the current zoom. The advantage of drawing all points (including
	             * markers and columns), is that animation is performed on updates.
	             * On the other hand, when the series contains more points than the
	             * crop threshold, the series data is cropped to only contain points
	             * that fall within the plot area. The advantage of cropping away invisible
	             * points is to increase performance on large series.
	             * 
	             * @type {Number}
	             * @default 300
	             * @since 2.2
	             * @product highcharts highstock
	             */
	            cropThreshold: 300,
	
	
	
	            /**
	             * The width of each point on the x axis. For example in a column chart
	             * with one value each day, the pointRange would be 1 day (= 24 * 3600
	             * * 1000 milliseconds). This is normally computed automatically, but
	             * this option can be used to override the automatic value.
	             * 
	             * @type {Number}
	             * @default 0
	             * @product highstock
	             */
	            pointRange: 0,
	            //pointStart: 0,
	            //pointInterval: 1,
	            //showInLegend: null, // auto = false for linked series
	
	
	
	            /**
	             * When this is true, the series will not cause the Y axis to cross
	             * the zero plane (or [threshold](#plotOptions.series.threshold) option)
	             * unless the data actually crosses the plane.
	             * 
	             * For example, if `softThreshold` is `false`, a series of 0, 1, 2,
	             * 3 will make the Y axis show negative values according to the `minPadding`
	             * option. If `softThreshold` is `true`, the Y axis starts at 0.
	             * 
	             * @type {Boolean}
	             * @default true
	             * @since 4.1.9
	             * @product highcharts highstock
	             */
	            softThreshold: true,
	
	
	
	            /**
	             * A wrapper object for all the series options in specific states.
	             * 
	             * @type {plotOptions.series.states}
	             * @product highcharts highstock highmaps
	             */
	            states: { // states for the entire series
	
	
	                /**
	                 * Options for the hovered series
	                 * 
	                 * @product highcharts highstock highmaps
	                 */
	                hover: {
	                    //enabled: false,
	
	
	
	                    /**
	                     * Animation setting for hovering the graph in line-type series.
	                     * 
	                     * @type {Boolean|Object}
	                     * @default { "duration": 50 }
	                     * @since 5.0.8
	                     * @product highcharts
	                     */
	                    animation: {
	
	
	
	                        /**
	                         */
	                        duration: 50
	                    },
	
	
	
	                    /**
	                     * The additional line width for the graph of a hovered series.
	                     * 
	                     * @type {Number}
	                     * @sample {highcharts} highcharts/plotoptions/series-states-hover-linewidthplus/ 5 pixels wider
	                     * @sample {highstock} highcharts/plotoptions/series-states-hover-linewidthplus/ 5 pixels wider
	                     * @default 1
	                     * @since 4.0.3
	                     * @product highcharts highstock
	                     */
	                    lineWidthPlus: 1,
	
	
	
	                    /**
	                     * In Highcharts 1.0, the appearance of all markers belonging to
	                     * the hovered series. For settings on the hover state of the individual
	                     * point, see [marker.states.hover](#plotOptions.series.marker.states.
	                     * hover).
	                     * 
	                     * @extends plotOptions.series.marker
	                     * @deprecated
	                     * @product highcharts highstock
	                     */
	                    marker: {
	                        // lineWidth: base + 1,
	                        // radius: base + 1
	                    },
	
	
	
	                    /**
	                     * Options for the halo appearing around the hovered point in line-
	                     * type series as well as outside the hovered slice in pie charts.
	                     * By default the halo is filled by the current point or series
	                     * color with an opacity of 0.25\. The halo can be disabled by setting
	                     * the `halo` option to `false`.
	                     * 
	                     * In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                     * style/style-by-css), the halo is styled with the `.highcharts-
	                     * halo` class, with colors inherited from `.highcharts-color-{n}`.
	                     * 
	                     * @type {Object}
	                     * @sample {highcharts} highcharts/plotoptions/halo/ Halo options
	                     * @sample {highstock} highcharts/plotoptions/halo/ Halo options
	                     * @since 4.0
	                     * @product highcharts highstock
	                     */
	                    halo: {
	
	
	
	                        /**
	                         * The pixel size of the halo. For point markers this is the radius
	                         * of the halo. For pie slices it is the width of the halo outside
	                         * the slice. For bubbles it defaults to 5 and is the width of the
	                         * halo outside the bubble.
	                         * 
	                         * @type {Number}
	                         * @default 10
	                         * @since 4.0
	                         * @product highcharts highstock
	                         */
	                        size: 10,
	
	
	
	
	                        /**
	                         * Opacity for the halo unless a specific fill is overridden using
	                         * the `attributes` setting. Note that Highcharts is only able to
	                         * apply opacity to colors of hex or rgb(a) formats.
	                         * 
	                         * @type {Number}
	                         * @default 0.25
	                         * @since 4.0
	                         * @product highcharts highstock
	                         */
	                        opacity: 0.25
	
	                    }
	                },
	
	
	                /**
	                 * Specific options for point in selected states, after being selected
	                 * by [allowPointSelect](#plotOptions.series.allowPointSelect) or
	                 * programmatically.
	                 * 
	                 * @type {Object}
	                 * @extends plotOptions.series.states.hover
	                 * @excluding brightness
	                 * @sample {highmaps} maps/plotoptions/series-allowpointselect/ Allow point select demo
	                 * @product highmaps
	                 */
	                select: {
	
	
	
	                    /**
	                     */
	                    marker: {}
	                }
	            },
	
	
	
	            /**
	             * Sticky tracking of mouse events. When true, the `mouseOut` event
	             * on a series isn't triggered until the mouse moves over another series,
	             * or out of the plot area. When false, the `mouseOut` event on a
	             * series is triggered when the mouse leaves the area around the series'
	             * graph or markers. This also implies the tooltip when not shared. When
	             * `stickyTracking` is false and `tooltip.shared` is false, the tooltip will
	             * be hidden when moving the mouse between series. Defaults to true for line
	             * and area type series, but to false for columns, pies etc.
	             * 
	             * @type {Boolean}
	             * @sample {highcharts} highcharts/plotoptions/series-stickytracking-true/
	             *         True by default
	             * @sample {highcharts} highcharts/plotoptions/series-stickytracking-false/
	             *         False
	             * @default {highcharts} true
	             * @default {highstock} true
	             * @default {highmaps} false
	             * @since 2.0
	             * @product highcharts highstock highmaps
	             */
	            stickyTracking: true,
	            //tooltip: {
	            //pointFormat: '<span style="color:{point.color}">\u25CF</span>' +
	            // '{series.name}: <b>{point.y}</b>'
	            //valueDecimals: null,
	            //xDateFormat: '%A, %b %e, %Y',
	            //valuePrefix: '',
	            //ySuffix: ''
	            //}
	
	
	
	            /**
	             * When a series contains a data array that is longer than this, only
	             * one dimensional arrays of numbers, or two dimensional arrays with
	             * x and y values are allowed. Also, only the first point is tested,
	             * and the rest are assumed to be the same format. This saves expensive
	             * data checking and indexing in long series. Set it to `0` disable.
	             * 
	             * @type {Number}
	             * @default 1000
	             * @since 2.2
	             * @product highcharts highstock
	             */
	            turboThreshold: 1000,
	            // zIndex: null
	
	
	
	            /**
	             * Determines whether the series should look for the nearest point
	             * in both dimensions or just the x-dimension when hovering the series.
	             * Defaults to `'xy'` for scatter series and `'x'` for most other
	             * series. If the data has duplicate x-values, it is recommended to
	             * set this to `'xy'` to allow hovering over all points.
	             * 
	             * Applies only to series types using nearest neighbor search (not
	             * direct hover) for tooltip.
	             * 
	             * @validvalue ['x', 'xy']
	             * @type {String}
	             * @sample {highcharts} highcharts/series/findnearestpointby/ Different hover behaviors
	             * @sample {highstock} highcharts/series/findnearestpointby/ Different hover behaviors
	             * @sample {highmaps} highcharts/series/findnearestpointby/ Different hover behaviors
	             * @since 5.0.10
	             * @product highcharts highstock highmaps
	             */
	            findNearestPointBy: 'x'
	
	        }, /** @lends Highcharts.Series.prototype */ {
	            isCartesian: true,
	            pointClass: Point,
	            sorted: true, // requires the data to be sorted
	            requireSorting: true,
	            directTouch: false,
	            axisTypes: ['xAxis', 'yAxis'],
	            colorCounter: 0,
	            // each point's x and y values are stored in this.xData and this.yData
	            parallelArrays: ['x', 'y'],
	            coll: 'series',
	            init: function(chart, options) {
	                var series = this,
	                    events,
	                    chartSeries = chart.series,
	                    lastSeries;
	
	                /**
	                 * Read only. The chart that the series belongs to.
	                 *
	                 * @name chart
	                 * @memberOf Series
	                 * @type {Chart}
	                 */
	                series.chart = chart;
	
	                /**
	                 * Read only. The series' type, like "line", "area", "column" etc. The
	                 * type in the series options anc can be altered using {@link
	                 * Series#update}.
	                 *
	                 * @name type
	                 * @memberOf Series
	                 * @type String
	                 */
	
	                /**
	                 * Read only. The series' current options. To update, use {@link
	                 * Series#update}.
	                 *
	                 * @name options
	                 * @memberOf Series
	                 * @type SeriesOptions
	                 */
	                series.options = options = series.setOptions(options);
	                series.linkedSeries = [];
	
	                // bind the axes
	                series.bindAxes();
	
	                // set some variables
	                extend(series, {
	                    /**
	                     * The series name as given in the options. Defaults to
	                     * "Series {n}".
	                     *
	                     * @name name
	                     * @memberOf Series
	                     * @type {String}
	                     */
	                    name: options.name,
	                    state: '',
	                    /**
	                     * Read only. The series' visibility state as set by {@link
	                     * Series#show}, {@link Series#hide}, or in the initial
	                     * configuration.
	                     *
	                     * @name visible
	                     * @memberOf Series
	                     * @type {Boolean}
	                     */
	                    visible: options.visible !== false, // true by default
	                    /**
	                     * Read only. The series' selected state as set by {@link
	                     * Highcharts.Series#select}.
	                     *
	                     * @name selected
	                     * @memberOf Series
	                     * @type {Boolean}
	                     */
	                    selected: options.selected === true // false by default
	                });
	
	                // register event listeners
	                events = options.events;
	
	                objectEach(events, function(event, eventType) {
	                    addEvent(series, eventType, event);
	                });
	                if (
	                    (events && events.click) ||
	                    (
	                        options.point &&
	                        options.point.events &&
	                        options.point.events.click
	                    ) ||
	                    options.allowPointSelect
	                ) {
	                    chart.runTrackerClick = true;
	                }
	
	                series.getColor();
	                series.getSymbol();
	
	                // Set the data
	                each(series.parallelArrays, function(key) {
	                    series[key + 'Data'] = [];
	                });
	                series.setData(options.data, false);
	
	                // Mark cartesian
	                if (series.isCartesian) {
	                    chart.hasCartesianSeries = true;
	                }
	
	                // Get the index and register the series in the chart. The index is one
	                // more than the current latest series index (#5960).
	                if (chartSeries.length) {
	                    lastSeries = chartSeries[chartSeries.length - 1];
	                }
	                series._i = pick(lastSeries && lastSeries._i, -1) + 1;
	
	                // Insert the series and re-order all series above the insertion point.
	                chart.orderSeries(this.insert(chartSeries));
	            },
	
	            /**
	             * Insert the series in a collection with other series, either the chart
	             * series or yAxis series, in the correct order according to the index
	             * option. Used internally when adding series.
	             *
	             * @private
	             * @param   {Array.<Series>} collection
	             *          A collection of series, like `chart.series` or `xAxis.series`.
	             * @returns {Number} The index of the series in the collection.
	             */
	            insert: function(collection) {
	                var indexOption = this.options.index,
	                    i;
	
	                // Insert by index option
	                if (isNumber(indexOption)) {
	                    i = collection.length;
	                    while (i--) {
	                        // Loop down until the interted element has higher index
	                        if (indexOption >=
	                            pick(collection[i].options.index, collection[i]._i)) {
	                            collection.splice(i + 1, 0, this);
	                            break;
	                        }
	                    }
	                    if (i === -1) {
	                        collection.unshift(this);
	                    }
	                    i = i + 1;
	
	                    // Or just push it to the end
	                } else {
	                    collection.push(this);
	                }
	                return pick(i, collection.length - 1);
	            },
	
	            /**
	             * Set the xAxis and yAxis properties of cartesian series, and register the
	             * series in the `axis.series` array.
	             *
	             * @private
	             */
	            bindAxes: function() {
	                var series = this,
	                    seriesOptions = series.options,
	                    chart = series.chart,
	                    axisOptions;
	
	                // repeat for xAxis and yAxis
	                each(series.axisTypes || [], function(AXIS) {
	
	                    // loop through the chart's axis objects
	                    each(chart[AXIS], function(axis) {
	                        axisOptions = axis.options;
	
	                        // apply if the series xAxis or yAxis option mathches the number
	                        // of the axis, or if undefined, use the first axis
	                        if (
	                            seriesOptions[AXIS] === axisOptions.index ||
	                            (
	                                seriesOptions[AXIS] !== undefined &&
	                                seriesOptions[AXIS] === axisOptions.id
	                            ) ||
	                            (
	                                seriesOptions[AXIS] === undefined &&
	                                axisOptions.index === 0
	                            )
	                        ) {
	
	                            // register this series in the axis.series lookup
	                            series.insert(axis.series);
	
	                            // set this series.xAxis or series.yAxis reference
	                            /**
	                             * Read only. The unique xAxis object associated with the
	                             * series.
	                             *
	                             * @name xAxis
	                             * @memberOf Series
	                             * @type Axis
	                             */
	                            /**
	                             * Read only. The unique yAxis object associated with the
	                             * series.
	                             *
	                             * @name yAxis
	                             * @memberOf Series
	                             * @type Axis
	                             */
	                            series[AXIS] = axis;
	
	                            // mark dirty for redraw
	                            axis.isDirty = true;
	                        }
	                    });
	
	                    // The series needs an X and an Y axis
	                    if (!series[AXIS] && series.optionalAxis !== AXIS) {
	                        H.error(18, true);
	                    }
	
	                });
	            },
	
	            /**
	             * For simple series types like line and column, the data values are held in
	             * arrays like xData and yData for quick lookup to find extremes and more.
	             * For multidimensional series like bubble and map, this can be extended
	             * with arrays like zData and valueData by adding to the
	             * `series.parallelArrays` array.
	             *
	             * @private
	             */
	            updateParallelArrays: function(point, i) {
	                var series = point.series,
	                    args = arguments,
	                    fn = isNumber(i) ?
	                    // Insert the value in the given position
	                    function(key) {
	                        var val = key === 'y' && series.toYData ?
	                            series.toYData(point) :
	                            point[key];
	                        series[key + 'Data'][i] = val;
	                    } :
	                    // Apply the method specified in i with the following arguments
	                    // as arguments
	                    function(key) {
	                        Array.prototype[i].apply(
	                            series[key + 'Data'],
	                            Array.prototype.slice.call(args, 2)
	                        );
	                    };
	
	                each(series.parallelArrays, fn);
	            },
	
	            /**
	             * Return an auto incremented x value based on the pointStart and
	             * pointInterval options. This is only used if an x value is not given for
	             * the point that calls autoIncrement.
	             *
	             * @private
	             */
	            autoIncrement: function() {
	
	                var options = this.options,
	                    xIncrement = this.xIncrement,
	                    date,
	                    pointInterval,
	                    pointIntervalUnit = options.pointIntervalUnit;
	
	                xIncrement = pick(xIncrement, options.pointStart, 0);
	
	                this.pointInterval = pointInterval = pick(
	                    this.pointInterval,
	                    options.pointInterval,
	                    1
	                );
	
	                // Added code for pointInterval strings
	                if (pointIntervalUnit) {
	                    date = new Date(xIncrement);
	
	                    if (pointIntervalUnit === 'day') {
	                        date = +date[Date.hcSetDate](
	                            date[Date.hcGetDate]() + pointInterval
	                        );
	                    } else if (pointIntervalUnit === 'month') {
	                        date = +date[Date.hcSetMonth](
	                            date[Date.hcGetMonth]() + pointInterval
	                        );
	                    } else if (pointIntervalUnit === 'year') {
	                        date = +date[Date.hcSetFullYear](
	                            date[Date.hcGetFullYear]() + pointInterval
	                        );
	                    }
	                    pointInterval = date - xIncrement;
	
	                }
	
	                this.xIncrement = xIncrement + pointInterval;
	                return xIncrement;
	            },
	
	            /**
	             * Set the series options by merging from the options tree. Called
	             * internally on initiating and updating series. This function will not
	             * redraw the series. For API usage, use {@link Series#update}.
	             * 
	             * @param  {Options.plotOptions.series} itemOptions
	             *         The series options.
	             */
	            setOptions: function(itemOptions) {
	                var chart = this.chart,
	                    chartOptions = chart.options,
	                    plotOptions = chartOptions.plotOptions,
	                    userOptions = chart.userOptions || {},
	                    userPlotOptions = userOptions.plotOptions || {},
	                    typeOptions = plotOptions[this.type],
	                    options,
	                    zones;
	
	                this.userOptions = itemOptions;
	
	                // General series options take precedence over type options because
	                // otherwise, default type options like column.animation would be
	                // overwritten by the general option. But issues have been raised here
	                // (#3881), and the solution may be to distinguish between default
	                // option and userOptions like in the tooltip below.
	                options = merge(
	                    typeOptions,
	                    plotOptions.series,
	                    itemOptions
	                );
	
	                // The tooltip options are merged between global and series specific
	                // options. Importance order asscendingly:
	                // globals: (1)tooltip, (2)plotOptions.series, (3)plotOptions[this.type]
	                // init userOptions with possible later updates: 4-6 like 1-3 and
	                // (7)this series options
	                this.tooltipOptions = merge(
	                    defaultOptions.tooltip, // 1
	                    defaultOptions.plotOptions.series &&
	                    defaultOptions.plotOptions.series.tooltip, // 2
	                    defaultOptions.plotOptions[this.type].tooltip, // 3
	                    chartOptions.tooltip.userOptions, // 4
	                    plotOptions.series && plotOptions.series.tooltip, // 5
	                    plotOptions[this.type].tooltip, // 6
	                    itemOptions.tooltip // 7
	                );
	
	                // When shared tooltip, stickyTracking is true by default,
	                // unless user says otherwise.
	                this.stickyTracking = pick(
	                    itemOptions.stickyTracking,
	                    userPlotOptions[this.type] &&
	                    userPlotOptions[this.type].stickyTracking,
	                    userPlotOptions.series && userPlotOptions.series.stickyTracking,
	                    (
	                        this.tooltipOptions.shared && !this.noSharedTooltip ?
	                        true :
	                        options.stickyTracking
	                    )
	                );
	
	                // Delete marker object if not allowed (#1125)
	                if (typeOptions.marker === null) {
	                    delete options.marker;
	                }
	
	                // Handle color zones
	                this.zoneAxis = options.zoneAxis;
	                zones = this.zones = (options.zones || []).slice();
	                if (
	                    (options.negativeColor || options.negativeFillColor) &&
	                    !options.zones
	                ) {
	                    zones.push({
	                        value: options[this.zoneAxis + 'Threshold'] ||
	                            options.threshold ||
	                            0,
	                        className: 'highcharts-negative',
	
	                        color: options.negativeColor,
	                        fillColor: options.negativeFillColor
	
	                    });
	                }
	                if (zones.length) { // Push one extra zone for the rest
	                    if (defined(zones[zones.length - 1].value)) {
	                        zones.push({
	
	                            color: this.color,
	                            fillColor: this.fillColor
	
	                        });
	                    }
	                }
	                return options;
	            },
	
	            getCyclic: function(prop, value, defaults) {
	                var i,
	                    chart = this.chart,
	                    userOptions = this.userOptions,
	                    indexName = prop + 'Index',
	                    counterName = prop + 'Counter',
	                    len = defaults ? defaults.length : pick(
	                        chart.options.chart[prop + 'Count'],
	                        chart[prop + 'Count']
	                    ),
	                    setting;
	
	                if (!value) {
	                    // Pick up either the colorIndex option, or the _colorIndex after
	                    // Series.update()
	                    setting = pick(
	                        userOptions[indexName],
	                        userOptions['_' + indexName]
	                    );
	                    if (defined(setting)) { // after Series.update()
	                        i = setting;
	                    } else {
	                        // #6138
	                        if (!chart.series.length) {
	                            chart[counterName] = 0;
	                        }
	                        userOptions['_' + indexName] = i = chart[counterName] % len;
	                        chart[counterName] += 1;
	                    }
	                    if (defaults) {
	                        value = defaults[i];
	                    }
	                }
	                // Set the colorIndex
	                if (i !== undefined) {
	                    this[indexName] = i;
	                }
	                this[prop] = value;
	            },
	
	            /**
	             * Get the series' color based on either the options or pulled from global
	             * options.
	             *
	             * @return  {Color} The series color.
	             */
	
	            getColor: function() {
	                if (this.options.colorByPoint) {
	                    // #4359, selected slice got series.color even when colorByPoint was
	                    // set.
	                    this.options.color = null;
	                } else {
	                    this.getCyclic(
	                        'color',
	                        this.options.color || defaultPlotOptions[this.type].color,
	                        this.chart.options.colors
	                    );
	                }
	            },
	
	            /**
	             * Get the series' symbol based on either the options or pulled from global
	             * options.
	             */
	            getSymbol: function() {
	                var seriesMarkerOption = this.options.marker;
	
	                this.getCyclic(
	                    'symbol',
	                    seriesMarkerOption.symbol,
	                    this.chart.options.symbols
	                );
	            },
	
	            drawLegendSymbol: LegendSymbolMixin.drawLineMarker,
	
	            /**
	             * Apply a new set of data to the series and optionally redraw it. The new
	             * data array is passed by reference (except in case of `updatePoints`), and
	             * may later be mutated when updating the chart data.
	             *
	             * Note the difference in behaviour when setting the same amount of points,
	             * or a different amount of points, as handled by the `updatePoints`
	             * parameter.
	             *
	             * @param  {SeriesDataOptions} data
	             *         Takes an array of data in the same format as described under
	             *         `series<type>data` for the given series type.
	             * @param  {Boolean} [redraw=true]
	             *         Whether to redraw the chart after the series is altered. If doing
	             *         more operations on the chart, it is a good idea to set redraw to
	             *         false and call {@link Chart#redraw} after.
	             * @param  {AnimationOptions} [animation]
	             *         When the updated data is the same length as the existing data,
	             *         points will be updated by default, and animation visualizes how
	             *         the points are changed. Set false to disable animation, or a
	             *         configuration object to set duration or easing.
	             * @param  {Boolean} [updatePoints=true]
	             *         When the updated data is the same length as the existing data,
	             *         points will be updated instead of replaced. This allows updating
	             *         with animation and performs better. In this case, the original
	             *         array is not passed by reference. Set false to prevent.
	             *
	             * @sample highcharts/members/series-setdata/
	             *         Set new data from a button
	             * @sample highcharts/members/series-setdata-pie/
	             *         Set data in a pie
	             * @sample stock/members/series-setdata/
	             *         Set new data in Highstock
	             * @sample maps/members/series-setdata/
	             *         Set new data in Highmaps
	             */
	            setData: function(data, redraw, animation, updatePoints) {
	                var series = this,
	                    oldData = series.points,
	                    oldDataLength = (oldData && oldData.length) || 0,
	                    dataLength,
	                    options = series.options,
	                    chart = series.chart,
	                    firstPoint = null,
	                    xAxis = series.xAxis,
	                    i,
	                    turboThreshold = options.turboThreshold,
	                    pt,
	                    xData = this.xData,
	                    yData = this.yData,
	                    pointArrayMap = series.pointArrayMap,
	                    valueCount = pointArrayMap && pointArrayMap.length;
	
	                data = data || [];
	                dataLength = data.length;
	                redraw = pick(redraw, true);
	
	                // If the point count is the same as is was, just run Point.update which
	                // is cheaper, allows animation, and keeps references to points.
	                if (
	                    updatePoints !== false &&
	                    dataLength &&
	                    oldDataLength === dataLength &&
	                    !series.cropped &&
	                    !series.hasGroupedData &&
	                    series.visible
	                ) {
	                    each(data, function(point, i) {
	                        // .update doesn't exist on a linked, hidden series (#3709)
	                        if (oldData[i].update && point !== options.data[i]) {
	                            oldData[i].update(point, false, null, false);
	                        }
	                    });
	
	                } else {
	
	                    // Reset properties
	                    series.xIncrement = null;
	
	                    series.colorCounter = 0; // for series with colorByPoint (#1547)
	
	                    // Update parallel arrays
	                    each(this.parallelArrays, function(key) {
	                        series[key + 'Data'].length = 0;
	                    });
	
	                    // In turbo mode, only one- or twodimensional arrays of numbers are
	                    // allowed. The first value is tested, and we assume that all the
	                    // rest are defined the same way. Although the 'for' loops are
	                    // similar, they are repeated inside each if-else conditional for
	                    // max performance.
	                    if (turboThreshold && dataLength > turboThreshold) {
	
	                        // find the first non-null point
	                        i = 0;
	                        while (firstPoint === null && i < dataLength) {
	                            firstPoint = data[i];
	                            i++;
	                        }
	
	
	                        if (isNumber(firstPoint)) { // assume all points are numbers
	                            for (i = 0; i < dataLength; i++) {
	                                xData[i] = this.autoIncrement();
	                                yData[i] = data[i];
	                            }
	
	                            // Assume all points are arrays when first point is
	                        } else if (isArray(firstPoint)) {
	                            if (valueCount) { // [x, low, high] or [x, o, h, l, c]
	                                for (i = 0; i < dataLength; i++) {
	                                    pt = data[i];
	                                    xData[i] = pt[0];
	                                    yData[i] = pt.slice(1, valueCount + 1);
	                                }
	                            } else { // [x, y]
	                                for (i = 0; i < dataLength; i++) {
	                                    pt = data[i];
	                                    xData[i] = pt[0];
	                                    yData[i] = pt[1];
	                                }
	                            }
	                        } else {
	                            // Highcharts expects configs to be numbers or arrays in
	                            // turbo mode
	                            H.error(12);
	                        }
	                    } else {
	                        for (i = 0; i < dataLength; i++) {
	                            if (data[i] !== undefined) { // stray commas in oldIE
	                                pt = {
	                                    series: series
	                                };
	                                series.pointClass.prototype.applyOptions.apply(
	                                    pt, [data[i]]
	                                );
	                                series.updateParallelArrays(pt, i);
	                            }
	                        }
	                    }
	
	                    // Forgetting to cast strings to numbers is a common caveat when
	                    // handling CSV or JSON
	                    if (isString(yData[0])) {
	                        H.error(14, true);
	                    }
	
	                    series.data = [];
	                    series.options.data = series.userOptions.data = data;
	
	                    // destroy old points
	                    i = oldDataLength;
	                    while (i--) {
	                        if (oldData[i] && oldData[i].destroy) {
	                            oldData[i].destroy();
	                        }
	                    }
	
	                    // reset minRange (#878)
	                    if (xAxis) {
	                        xAxis.minRange = xAxis.userMinRange;
	                    }
	
	                    // redraw
	                    series.isDirty = chart.isDirtyBox = true;
	                    series.isDirtyData = !!oldData;
	                    animation = false;
	                }
	
	                // Typically for pie series, points need to be processed and generated
	                // prior to rendering the legend
	                if (options.legendType === 'point') {
	                    this.processData();
	                    this.generatePoints();
	                }
	
	                if (redraw) {
	                    chart.redraw(animation);
	                }
	            },
	
	            /**
	             * Internal function to process the data by cropping away unused data points
	             * if the series is longer than the crop threshold. This saves computing
	             * time for large series. In Highstock, this function is extended to
	             * provide data grouping.
	             *
	             * @private
	             * @param  {Boolean} force
	             *         Force data grouping.
	             */
	            processData: function(force) {
	                var series = this,
	                    processedXData = series.xData, // copied during slice operation
	                    processedYData = series.yData,
	                    dataLength = processedXData.length,
	                    croppedData,
	                    cropStart = 0,
	                    cropped,
	                    distance,
	                    closestPointRange,
	                    xAxis = series.xAxis,
	                    i, // loop variable
	                    options = series.options,
	                    cropThreshold = options.cropThreshold,
	                    getExtremesFromAll =
	                    series.getExtremesFromAll ||
	                    options.getExtremesFromAll, // #4599
	                    isCartesian = series.isCartesian,
	                    xExtremes,
	                    val2lin = xAxis && xAxis.val2lin,
	                    isLog = xAxis && xAxis.isLog,
	                    min,
	                    max;
	
	                // If the series data or axes haven't changed, don't go through this.
	                // Return false to pass the message on to override methods like in data
	                // grouping.
	                if (
	                    isCartesian &&
	                    !series.isDirty &&
	                    !xAxis.isDirty &&
	                    !series.yAxis.isDirty &&
	                    !force
	                ) {
	                    return false;
	                }
	
	                if (xAxis) {
	                    xExtremes = xAxis.getExtremes(); // corrected for log axis (#3053)
	                    min = xExtremes.min;
	                    max = xExtremes.max;
	                }
	
	                // optionally filter out points outside the plot area
	                if (
	                    isCartesian &&
	                    series.sorted &&
	                    !getExtremesFromAll &&
	                    (!cropThreshold || dataLength > cropThreshold || series.forceCrop)
	                ) {
	
	                    // it's outside current extremes
	                    if (
	                        processedXData[dataLength - 1] < min ||
	                        processedXData[0] > max
	                    ) {
	                        processedXData = [];
	                        processedYData = [];
	
	                        // only crop if it's actually spilling out
	                    } else if (
	                        processedXData[0] < min ||
	                        processedXData[dataLength - 1] > max
	                    ) {
	                        croppedData = this.cropData(
	                            series.xData,
	                            series.yData,
	                            min,
	                            max
	                        );
	                        processedXData = croppedData.xData;
	                        processedYData = croppedData.yData;
	                        cropStart = croppedData.start;
	                        cropped = true;
	                    }
	                }
	
	
	                // Find the closest distance between processed points
	                i = processedXData.length || 1;
	                while (--i) {
	                    distance = isLog ?
	                        val2lin(processedXData[i]) - val2lin(processedXData[i - 1]) :
	                        processedXData[i] - processedXData[i - 1];
	
	                    if (
	                        distance > 0 &&
	                        (
	                            closestPointRange === undefined ||
	                            distance < closestPointRange
	                        )
	                    ) {
	                        closestPointRange = distance;
	
	                        // Unsorted data is not supported by the line tooltip, as well as
	                        // data grouping and navigation in Stock charts (#725) and width
	                        // calculation of columns (#1900)
	                    } else if (distance < 0 && series.requireSorting) {
	                        H.error(15);
	                    }
	                }
	
	                // Record the properties
	                series.cropped = cropped; // undefined or true
	                series.cropStart = cropStart;
	                series.processedXData = processedXData;
	                series.processedYData = processedYData;
	
	                series.closestPointRange = closestPointRange;
	
	            },
	
	            /**
	             * Iterate over xData and crop values between min and max. Returns object
	             * containing crop start/end cropped xData with corresponding part of yData,
	             * dataMin and dataMax within the cropped range.
	             *
	             * @private
	             */
	            cropData: function(xData, yData, min, max) {
	                var dataLength = xData.length,
	                    cropStart = 0,
	                    cropEnd = dataLength,
	                    // line-type series need one point outside
	                    cropShoulder = pick(this.cropShoulder, 1),
	                    i,
	                    j;
	
	                // iterate up to find slice start
	                for (i = 0; i < dataLength; i++) {
	                    if (xData[i] >= min) {
	                        cropStart = Math.max(0, i - cropShoulder);
	                        break;
	                    }
	                }
	
	                // proceed to find slice end
	                for (j = i; j < dataLength; j++) {
	                    if (xData[j] > max) {
	                        cropEnd = j + cropShoulder;
	                        break;
	                    }
	                }
	
	                return {
	                    xData: xData.slice(cropStart, cropEnd),
	                    yData: yData.slice(cropStart, cropEnd),
	                    start: cropStart,
	                    end: cropEnd
	                };
	            },
	
	
	            /**
	             * Generate the data point after the data has been processed by cropping
	             * away unused points and optionally grouped in Highcharts Stock.
	             *
	             * @private
	             */
	            generatePoints: function() {
	                var series = this,
	                    options = series.options,
	                    dataOptions = options.data,
	                    data = series.data,
	                    dataLength,
	                    processedXData = series.processedXData,
	                    processedYData = series.processedYData,
	                    PointClass = series.pointClass,
	                    processedDataLength = processedXData.length,
	                    cropStart = series.cropStart || 0,
	                    cursor,
	                    hasGroupedData = series.hasGroupedData,
	                    keys = options.keys,
	                    point,
	                    points = [],
	                    i;
	
	                if (!data && !hasGroupedData) {
	                    var arr = [];
	                    arr.length = dataOptions.length;
	                    data = series.data = arr;
	                }
	
	                if (keys && hasGroupedData) {
	                    // grouped data has already applied keys (#6590)
	                    series.options.keys = false;
	                }
	
	                for (i = 0; i < processedDataLength; i++) {
	                    cursor = cropStart + i;
	                    if (!hasGroupedData) {
	                        point = data[cursor];
	                        if (!point && dataOptions[cursor] !== undefined) { // #970
	                            data[cursor] = point = (new PointClass()).init(
	                                series,
	                                dataOptions[cursor],
	                                processedXData[i]
	                            );
	                        }
	                    } else {
	                        // splat the y data in case of ohlc data array
	                        point = (new PointClass()).init(
	                            series, [processedXData[i]].concat(splat(processedYData[i]))
	                        );
	
	                        /**
	                         * Highstock only. If a point object is created by data
	                         * grouping, it doesn't reflect actual points in the raw data.
	                         * In this case, the `dataGroup` property holds information
	                         * that points back to the raw data.
	                         *
	                         * - `dataGroup.start` is the index of the first raw data point
	                         * in the group.
	                         * - `dataGroup.length` is the amount of points in the group.
	                         *
	                         * @name dataGroup
	                         * @memberOf Point
	                         * @type {Object}
	                         *
	                         */
	                        point.dataGroup = series.groupMap[i];
	                    }
	                    if (point) { // #6279
	                        point.index = cursor; // For faster access in Point.update
	                        points[i] = point;
	                    }
	                }
	
	                // restore keys options (#6590)
	                series.options.keys = keys;
	
	                // Hide cropped-away points - this only runs when the number of points
	                // is above cropThreshold, or when swithching view from non-grouped
	                // data to grouped data (#637)
	                if (
	                    data &&
	                    (
	                        processedDataLength !== (dataLength = data.length) ||
	                        hasGroupedData
	                    )
	                ) {
	                    for (i = 0; i < dataLength; i++) {
	                        // when has grouped data, clear all points
	                        if (i === cropStart && !hasGroupedData) {
	                            i += processedDataLength;
	                        }
	                        if (data[i]) {
	                            data[i].destroyElements();
	                            data[i].plotX = undefined; // #1003
	                        }
	                    }
	                }
	
	                /**
	                 * Read only. An array containing the series' data point objects. To
	                 * modify the data, use {@link Highcharts.Series#setData} or {@link
	                 * Highcharts.Point#update}.
	                 *
	                 * @name data
	                 * @memberOf Highcharts.Series
	                 * @type {Array.<Highcharts.Point>}
	                 */
	                series.data = data;
	
	                /**
	                 * An array containing all currently visible point objects. In case of
	                 * cropping, the cropped-away points are not part of this array. The
	                 * `series.points` array starts at `series.cropStart` compared to
	                 * `series.data` and `series.options.data`. If however the series data
	                 * is grouped, these can't be correlated one to one. To
	                 * modify the data, use {@link Highcharts.Series#setData} or {@link
	                 * Highcharts.Point#update}.
	                 * @name point
	                 * @memberof Series
	                 * @type {Array.<Point>}
	                 */
	                series.points = points;
	            },
	
	            /**
	             * Calculate Y extremes for the visible data. The result is set as 
	             * `dataMin` and `dataMax` on the Series item.
	             *
	             * @param  {Array.<Number>} [yData]
	             *         The data to inspect. Defaults to the current data within the
	             *         visible range.
	             * 
	             */
	            getExtremes: function(yData) {
	                var xAxis = this.xAxis,
	                    yAxis = this.yAxis,
	                    xData = this.processedXData,
	                    yDataLength,
	                    activeYData = [],
	                    activeCounter = 0,
	                    // #2117, need to compensate for log X axis
	                    xExtremes = xAxis.getExtremes(),
	                    xMin = xExtremes.min,
	                    xMax = xExtremes.max,
	                    validValue,
	                    withinRange,
	                    x,
	                    y,
	                    i,
	                    j;
	
	                yData = yData || this.stackedYData || this.processedYData || [];
	                yDataLength = yData.length;
	
	                for (i = 0; i < yDataLength; i++) {
	
	                    x = xData[i];
	                    y = yData[i];
	
	                    // For points within the visible range, including the first point
	                    // outside the visible range, consider y extremes
	                    validValue =
	                        (isNumber(y, true) || isArray(y)) &&
	                        (!yAxis.positiveValuesOnly || (y.length || y > 0));
	                    withinRange =
	                        this.getExtremesFromAll ||
	                        this.options.getExtremesFromAll ||
	                        this.cropped ||
	                        ((xData[i] || x) >= xMin && (xData[i] || x) <= xMax);
	
	                    if (validValue && withinRange) {
	
	                        j = y.length;
	                        if (j) { // array, like ohlc or range data
	                            while (j--) {
	                                if (y[j] !== null) {
	                                    activeYData[activeCounter++] = y[j];
	                                }
	                            }
	                        } else {
	                            activeYData[activeCounter++] = y;
	                        }
	                    }
	                }
	
	                this.dataMin = arrayMin(activeYData);
	                this.dataMax = arrayMax(activeYData);
	            },
	
	            /**
	             * Translate data points from raw data values to chart specific positioning
	             * data needed later in the `drawPoints` and `drawGraph` functions. This
	             * function can be overridden in plugins and custom series type
	             * implementations.
	             */
	            translate: function() {
	                if (!this.processedXData) { // hidden series
	                    this.processData();
	                }
	                this.generatePoints();
	                var series = this,
	                    options = series.options,
	                    stacking = options.stacking,
	                    xAxis = series.xAxis,
	                    categories = xAxis.categories,
	                    yAxis = series.yAxis,
	                    points = series.points,
	                    dataLength = points.length,
	                    hasModifyValue = !!series.modifyValue,
	                    i,
	                    pointPlacement = options.pointPlacement,
	                    dynamicallyPlaced =
	                    pointPlacement === 'between' ||
	                    isNumber(pointPlacement),
	                    threshold = options.threshold,
	                    stackThreshold = options.startFromThreshold ? threshold : 0,
	                    plotX,
	                    plotY,
	                    lastPlotX,
	                    stackIndicator,
	                    closestPointRangePx = Number.MAX_VALUE;
	
	                // Point placement is relative to each series pointRange (#5889)
	                if (pointPlacement === 'between') {
	                    pointPlacement = 0.5;
	                }
	                if (isNumber(pointPlacement)) {
	                    pointPlacement *= pick(options.pointRange || xAxis.pointRange);
	                }
	
	                // Translate each point
	                for (i = 0; i < dataLength; i++) {
	                    var point = points[i],
	                        xValue = point.x,
	                        yValue = point.y,
	                        yBottom = point.low,
	                        stack = stacking && yAxis.stacks[(
	                            series.negStacks &&
	                            yValue < (stackThreshold ? 0 : threshold) ? '-' : ''
	                        ) + series.stackKey],
	                        pointStack,
	                        stackValues;
	
	                    // Discard disallowed y values for log axes (#3434)
	                    if (yAxis.positiveValuesOnly && yValue !== null && yValue <= 0) {
	                        point.isNull = true;
	                    }
	
	                    // Get the plotX translation
	                    point.plotX = plotX = correctFloat( // #5236
	                        Math.min(Math.max(-1e5, xAxis.translate(
	                            xValue,
	                            0,
	                            0,
	                            0,
	                            1,
	                            pointPlacement,
	                            this.type === 'flags'
	                        )), 1e5) // #3923
	                    );
	
	                    // Calculate the bottom y value for stacked series
	                    if (
	                        stacking &&
	                        series.visible &&
	                        !point.isNull &&
	                        stack &&
	                        stack[xValue]
	                    ) {
	                        stackIndicator = series.getStackIndicator(
	                            stackIndicator,
	                            xValue,
	                            series.index
	                        );
	                        pointStack = stack[xValue];
	                        stackValues = pointStack.points[stackIndicator.key];
	                        yBottom = stackValues[0];
	                        yValue = stackValues[1];
	
	                        if (
	                            yBottom === stackThreshold &&
	                            stackIndicator.key === stack[xValue].base
	                        ) {
	                            yBottom = pick(threshold, yAxis.min);
	                        }
	                        if (yAxis.positiveValuesOnly && yBottom <= 0) { // #1200, #1232
	                            yBottom = null;
	                        }
	
	                        point.total = point.stackTotal = pointStack.total;
	                        point.percentage =
	                            pointStack.total &&
	                            (point.y / pointStack.total * 100);
	                        point.stackY = yValue;
	
	                        // Place the stack label
	                        pointStack.setOffset(
	                            series.pointXOffset || 0,
	                            series.barW || 0
	                        );
	
	                    }
	
	                    // Set translated yBottom or remove it
	                    point.yBottom = defined(yBottom) ?
	                        yAxis.translate(yBottom, 0, 1, 0, 1) :
	                        null;
	
	                    // general hook, used for Highstock compare mode
	                    if (hasModifyValue) {
	                        yValue = series.modifyValue(yValue, point);
	                    }
	
	                    // Set the the plotY value, reset it for redraws
	                    point.plotY = plotY =
	                        (typeof yValue === 'number' && yValue !== Infinity) ?
	                        Math.min(Math.max(-1e5,
	                            yAxis.translate(yValue, 0, 1, 0, 1)), 1e5) : // #3201
	                        undefined;
	
	                    point.isInside =
	                        plotY !== undefined &&
	                        plotY >= 0 &&
	                        plotY <= yAxis.len && // #3519
	                        plotX >= 0 &&
	                        plotX <= xAxis.len;
	
	
	                    // Set client related positions for mouse tracking
	                    point.clientX = dynamicallyPlaced ?
	                        correctFloat(
	                            xAxis.translate(xValue, 0, 0, 0, 1, pointPlacement)
	                        ) :
	                        plotX; // #1514, #5383, #5518
	
	                    point.negative = point.y < (threshold || 0);
	
	                    // some API data
	                    point.category = categories && categories[point.x] !== undefined ?
	                        categories[point.x] : point.x;
	
	                    // Determine auto enabling of markers (#3635, #5099)
	                    if (!point.isNull) {
	                        if (lastPlotX !== undefined) {
	                            closestPointRangePx = Math.min(
	                                closestPointRangePx,
	                                Math.abs(plotX - lastPlotX)
	                            );
	                        }
	                        lastPlotX = plotX;
	                    }
	
	                    // Find point zone
	                    point.zone = this.zones.length && point.getZone();
	                }
	                series.closestPointRangePx = closestPointRangePx;
	            },
	
	            /**
	             * Return the series points with null points filtered out.
	             *
	             * @param  {Array.<Point>} [points]
	             *         The points to inspect, defaults to {@link Series.points}.
	             * @param  {Boolean} [insideOnly=false]
	             *         Whether to inspect only the points that are inside the visible
	             *         view.
	             *
	             * @return {Array.<Point>}
	             *         The valid points.
	             */
	            getValidPoints: function(points, insideOnly) {
	                var chart = this.chart;
	                // #3916, #5029, #5085
	                return grep(points || this.points || [], function isValidPoint(point) {
	                    if (insideOnly && !chart.isInsidePlot(
	                            point.plotX,
	                            point.plotY,
	                            chart.inverted
	                        )) {
	                        return false;
	                    }
	                    return !point.isNull;
	                });
	            },
	
	            /**
	             * Set the clipping for the series. For animated series it is called twice,
	             * first to initiate animating the clip then the second time without the
	             * animation to set the final clip.
	             *
	             * @private
	             */
	            setClip: function(animation) {
	                var chart = this.chart,
	                    options = this.options,
	                    renderer = chart.renderer,
	                    inverted = chart.inverted,
	                    seriesClipBox = this.clipBox,
	                    clipBox = seriesClipBox || chart.clipBox,
	                    sharedClipKey =
	                    this.sharedClipKey || [
	                        '_sharedClip',
	                        animation && animation.duration,
	                        animation && animation.easing,
	                        clipBox.height,
	                        options.xAxis,
	                        options.yAxis
	                    ].join(','), // #4526
	                    clipRect = chart[sharedClipKey],
	                    markerClipRect = chart[sharedClipKey + 'm'];
	
	                // If a clipping rectangle with the same properties is currently present
	                // in the chart, use that.
	                if (!clipRect) {
	
	                    // When animation is set, prepare the initial positions
	                    if (animation) {
	                        clipBox.width = 0;
	
	                        chart[sharedClipKey + 'm'] = markerClipRect = renderer.clipRect(-99, // include the width of the first marker
	                            inverted ? -chart.plotLeft : -chart.plotTop,
	                            99,
	                            inverted ? chart.chartWidth : chart.chartHeight
	                        );
	                    }
	                    chart[sharedClipKey] = clipRect = renderer.clipRect(clipBox);
	                    // Create hashmap for series indexes
	                    clipRect.count = {
	                        length: 0
	                    };
	
	                }
	                if (animation) {
	                    if (!clipRect.count[this.index]) {
	                        clipRect.count[this.index] = true;
	                        clipRect.count.length += 1;
	                    }
	                }
	
	                if (options.clip !== false) {
	                    this.group.clip(animation || seriesClipBox ? clipRect : chart.clipRect);
	                    this.markerGroup.clip(markerClipRect);
	                    this.sharedClipKey = sharedClipKey;
	                }
	
	                // Remove the shared clipping rectangle when all series are shown
	                if (!animation) {
	                    if (clipRect.count[this.index]) {
	                        delete clipRect.count[this.index];
	                        clipRect.count.length -= 1;
	                    }
	
	                    if (clipRect.count.length === 0 && sharedClipKey && chart[sharedClipKey]) {
	                        if (!seriesClipBox) {
	                            chart[sharedClipKey] = chart[sharedClipKey].destroy();
	                        }
	                        if (chart[sharedClipKey + 'm']) {
	                            chart[sharedClipKey + 'm'] = chart[sharedClipKey + 'm'].destroy();
	                        }
	                    }
	                }
	            },
	
	            /**
	             * Animate in the series. Called internally twice. First with the `init`
	             * parameter set to true, which sets up the initial state of the animation.
	             * Then when ready, it is called with the `init` parameter undefined, in 
	             * order to perform the actual animation. After the second run, the function
	             * is removed.
	             *
	             * @param  {Boolean} init
	             *         Initialize the animation.
	             */
	            animate: function(init) {
	                var series = this,
	                    chart = series.chart,
	                    clipRect,
	                    animation = animObject(series.options.animation),
	                    sharedClipKey;
	
	                // Initialize the animation. Set up the clipping rectangle.
	                if (init) {
	
	                    series.setClip(animation);
	
	                    // Run the animation
	                } else {
	                    sharedClipKey = this.sharedClipKey;
	                    clipRect = chart[sharedClipKey];
	                    if (clipRect) {
	                        clipRect.animate({
	                            width: chart.plotSizeX
	                        }, animation);
	                    }
	                    if (chart[sharedClipKey + 'm']) {
	                        chart[sharedClipKey + 'm'].animate({
	                            width: chart.plotSizeX + 99
	                        }, animation);
	                    }
	
	                    // Delete this function to allow it only once
	                    series.animate = null;
	
	                }
	            },
	
	            /**
	             * This runs after animation to land on the final plot clipping.
	             *
	             * @private
	             */
	            afterAnimate: function() {
	                this.setClip();
	                fireEvent(this, 'afterAnimate');
	                this.finishedAnimating = true;
	            },
	
	            /**
	             * Draw the markers for line-like series types, and columns or other
	             * graphical representation for {@link Point} objects for other series
	             * types. The resulting element is typically stored as {@link
	             * Point.graphic}, and is created on the first call and updated and moved on
	             * subsequent calls.
	             */
	            drawPoints: function() {
	                var series = this,
	                    points = series.points,
	                    chart = series.chart,
	                    plotY,
	                    i,
	                    point,
	                    symbol,
	                    graphic,
	                    options = series.options,
	                    seriesMarkerOptions = options.marker,
	                    pointMarkerOptions,
	                    hasPointMarker,
	                    enabled,
	                    isInside,
	                    markerGroup = series[series.specialGroup] || series.markerGroup,
	                    xAxis = series.xAxis,
	                    markerAttribs,
	                    globallyEnabled = pick(
	                        seriesMarkerOptions.enabled,
	                        xAxis.isRadial ? true : null,
	                        // Use larger or equal as radius is null in bubbles (#6321)
	                        series.closestPointRangePx >= 2 * seriesMarkerOptions.radius
	                    );
	
	                if (seriesMarkerOptions.enabled !== false || series._hasPointMarkers) {
	
	                    for (i = 0; i < points.length; i++) {
	                        point = points[i];
	                        plotY = point.plotY;
	                        graphic = point.graphic;
	                        pointMarkerOptions = point.marker || {};
	                        hasPointMarker = !!point.marker;
	                        enabled = (globallyEnabled && pointMarkerOptions.enabled === undefined) || pointMarkerOptions.enabled;
	                        isInside = point.isInside;
	
	                        // only draw the point if y is defined
	                        if (enabled && isNumber(plotY) && point.y !== null) {
	
	                            // Shortcuts
	                            symbol = pick(pointMarkerOptions.symbol, series.symbol);
	                            point.hasImage = symbol.indexOf('url') === 0;
	
	                            markerAttribs = series.markerAttribs(
	                                point,
	                                point.selected && 'select'
	                            );
	
	                            if (graphic) { // update
	                                graphic[isInside ? 'show' : 'hide'](true) // Since the marker group isn't clipped, each individual marker must be toggled
	                                    .animate(markerAttribs);
	                            } else if (isInside && (markerAttribs.width > 0 || point.hasImage)) {
	
	                                /**
	                                 * The graphic representation of the point. Typically
	                                 * this is a simple shape, like a `rect` for column
	                                 * charts or `path` for line markers, but for some 
	                                 * complex series types like boxplot or 3D charts, the
	                                 * graphic may be a `g` element containing other shapes.
	                                 * The graphic is generated the first time {@link
	                                 * Series#drawPoints} runs, and updated and moved on
	                                 * subsequent runs.
	                                 *
	                                 * @memberof Point
	                                 * @name graphic
	                                 * @type {SVGElement}
	                                 */
	                                point.graphic = graphic = chart.renderer.symbol(
	                                        symbol,
	                                        markerAttribs.x,
	                                        markerAttribs.y,
	                                        markerAttribs.width,
	                                        markerAttribs.height,
	                                        hasPointMarker ? pointMarkerOptions : seriesMarkerOptions
	                                    )
	                                    .add(markerGroup);
	                            }
	
	
	                            // Presentational attributes
	                            if (graphic) {
	                                graphic.attr(series.pointAttribs(point, point.selected && 'select'));
	                            }
	
	
	                            if (graphic) {
	                                graphic.addClass(point.getClassName(), true);
	                            }
	
	                        } else if (graphic) {
	                            point.graphic = graphic.destroy(); // #1269
	                        }
	                    }
	                }
	
	            },
	
	            /**
	             * Get non-presentational attributes for a point. Used internally for both
	             * styled mode and classic. Can be overridden for different series types.
	             *
	             * @see    Series#pointAttribs
	             *
	             * @param  {Point} point
	             *         The Point to inspect.
	             * @param  {String} [state]
	             *         The state, can be either `hover`, `select` or undefined.
	             *
	             * @return {SVGAttributes}
	             *         A hash containing those attributes that are not settable from
	             *         CSS.
	             */
	            markerAttribs: function(point, state) {
	                var seriesMarkerOptions = this.options.marker,
	                    seriesStateOptions,
	                    pointMarkerOptions = point.marker || {},
	                    pointStateOptions,
	                    radius = pick(
	                        pointMarkerOptions.radius,
	                        seriesMarkerOptions.radius
	                    ),
	                    attribs;
	
	                // Handle hover and select states
	                if (state) {
	                    seriesStateOptions = seriesMarkerOptions.states[state];
	                    pointStateOptions = pointMarkerOptions.states &&
	                        pointMarkerOptions.states[state];
	
	                    radius = pick(
	                        pointStateOptions && pointStateOptions.radius,
	                        seriesStateOptions && seriesStateOptions.radius,
	                        radius + (seriesStateOptions && seriesStateOptions.radiusPlus || 0)
	                    );
	                }
	
	                if (point.hasImage) {
	                    radius = 0; // and subsequently width and height is not set
	                }
	
	                attribs = {
	                    x: Math.floor(point.plotX) - radius, // Math.floor for #1843
	                    y: point.plotY - radius
	                };
	
	                if (radius) {
	                    attribs.width = attribs.height = 2 * radius;
	                }
	
	                return attribs;
	
	            },
	
	
	            /**
	             * Internal function to get presentational attributes for each point. Unlike
	             * {@link Series#markerAttribs}, this function should return those
	             * attributes that can also be set in CSS. In styled mode, `pointAttribs`
	             * won't be called.
	             *
	             * @param  {Point} point
	             *         The point instance to inspect.
	             * @param  {String} [state]
	             *         The point state, can be either `hover`, `select` or undefined for
	             *         normal state.
	             *
	             * @return {SVGAttributes}
	             *         The presentational attributes to be set on the point.
	             */
	            pointAttribs: function(point, state) {
	                var seriesMarkerOptions = this.options.marker,
	                    seriesStateOptions,
	                    pointOptions = point && point.options,
	                    pointMarkerOptions = (pointOptions && pointOptions.marker) || {},
	                    pointStateOptions,
	                    color = this.color,
	                    pointColorOption = pointOptions && pointOptions.color,
	                    pointColor = point && point.color,
	                    strokeWidth = pick(
	                        pointMarkerOptions.lineWidth,
	                        seriesMarkerOptions.lineWidth
	                    ),
	                    zoneColor = point && point.zone && point.zone.color,
	                    fill,
	                    stroke;
	
	                color = pointColorOption || zoneColor || pointColor || color;
	                fill = pointMarkerOptions.fillColor || seriesMarkerOptions.fillColor || color;
	                stroke = pointMarkerOptions.lineColor || seriesMarkerOptions.lineColor || color;
	
	                // Handle hover and select states
	                if (state) {
	                    seriesStateOptions = seriesMarkerOptions.states[state];
	                    pointStateOptions = (pointMarkerOptions.states && pointMarkerOptions.states[state]) || {};
	                    strokeWidth = pick(
	                        pointStateOptions.lineWidth,
	                        seriesStateOptions.lineWidth,
	                        strokeWidth + pick(
	                            pointStateOptions.lineWidthPlus,
	                            seriesStateOptions.lineWidthPlus,
	                            0
	                        )
	                    );
	                    fill = pointStateOptions.fillColor || seriesStateOptions.fillColor || fill;
	                    stroke = pointStateOptions.lineColor || seriesStateOptions.lineColor || stroke;
	                }
	
	                return {
	                    'stroke': stroke,
	                    'stroke-width': strokeWidth,
	                    'fill': fill
	                };
	            },
	
	            /**
	             * Clear DOM objects and free up memory.
	             *
	             * @private
	             */
	            destroy: function() {
	                var series = this,
	                    chart = series.chart,
	                    issue134 = /AppleWebKit\/533/.test(win.navigator.userAgent),
	                    destroy,
	                    i,
	                    data = series.data || [],
	                    point,
	                    axis;
	
	                // add event hook
	                fireEvent(series, 'destroy');
	
	                // remove all events
	                removeEvent(series);
	
	                // erase from axes
	                each(series.axisTypes || [], function(AXIS) {
	                    axis = series[AXIS];
	                    if (axis && axis.series) {
	                        erase(axis.series, series);
	                        axis.isDirty = axis.forceRedraw = true;
	                    }
	                });
	
	                // remove legend items
	                if (series.legendItem) {
	                    series.chart.legend.destroyItem(series);
	                }
	
	                // destroy all points with their elements
	                i = data.length;
	                while (i--) {
	                    point = data[i];
	                    if (point && point.destroy) {
	                        point.destroy();
	                    }
	                }
	                series.points = null;
	
	                // Clear the animation timeout if we are destroying the series during initial animation
	                clearTimeout(series.animationTimeout);
	
	                // Destroy all SVGElements associated to the series
	                objectEach(series, function(val, prop) {
	                    if (val instanceof SVGElement && !val.survive) { // Survive provides a hook for not destroying
	
	                        // issue 134 workaround
	                        destroy = issue134 && prop === 'group' ?
	                            'hide' :
	                            'destroy';
	
	                        val[destroy]();
	                    }
	                });
	
	                // remove from hoverSeries
	                if (chart.hoverSeries === series) {
	                    chart.hoverSeries = null;
	                }
	                erase(chart.series, series);
	                chart.orderSeries();
	
	                // clear all members
	                objectEach(series, function(val, prop) {
	                    delete series[prop];
	                });
	            },
	
	            /**
	             * Get the graph path.
	             *
	             * @private
	             */
	            getGraphPath: function(points, nullsAsZeroes, connectCliffs) {
	                var series = this,
	                    options = series.options,
	                    step = options.step,
	                    reversed,
	                    graphPath = [],
	                    xMap = [],
	                    gap;
	
	                points = points || series.points;
	
	                // Bottom of a stack is reversed
	                reversed = points.reversed;
	                if (reversed) {
	                    points.reverse();
	                }
	                // Reverse the steps (#5004)
	                step = {
	                    right: 1,
	                    center: 2
	                }[step] || (step && 3);
	                if (step && reversed) {
	                    step = 4 - step;
	                }
	
	                // Remove invalid points, especially in spline (#5015)
	                if (options.connectNulls && !nullsAsZeroes && !connectCliffs) {
	                    points = this.getValidPoints(points);
	                }
	
	                // Build the line
	                each(points, function(point, i) {
	
	                    var plotX = point.plotX,
	                        plotY = point.plotY,
	                        lastPoint = points[i - 1],
	                        pathToPoint; // the path to this point from the previous
	
	                    if ((point.leftCliff || (lastPoint && lastPoint.rightCliff)) && !connectCliffs) {
	                        gap = true; // ... and continue
	                    }
	
	                    // Line series, nullsAsZeroes is not handled
	                    if (point.isNull && !defined(nullsAsZeroes) && i > 0) {
	                        gap = !options.connectNulls;
	
	                        // Area series, nullsAsZeroes is set
	                    } else if (point.isNull && !nullsAsZeroes) {
	                        gap = true;
	
	                    } else {
	
	                        if (i === 0 || gap) {
	                            pathToPoint = ['M', point.plotX, point.plotY];
	
	                        } else if (series.getPointSpline) { // generate the spline as defined in the SplineSeries object
	
	                            pathToPoint = series.getPointSpline(points, point, i);
	
	                        } else if (step) {
	
	                            if (step === 1) { // right
	                                pathToPoint = [
	                                    'L',
	                                    lastPoint.plotX,
	                                    plotY
	                                ];
	
	                            } else if (step === 2) { // center
	                                pathToPoint = [
	                                    'L',
	                                    (lastPoint.plotX + plotX) / 2,
	                                    lastPoint.plotY,
	                                    'L',
	                                    (lastPoint.plotX + plotX) / 2,
	                                    plotY
	                                ];
	
	                            } else {
	                                pathToPoint = [
	                                    'L',
	                                    plotX,
	                                    lastPoint.plotY
	                                ];
	                            }
	                            pathToPoint.push('L', plotX, plotY);
	
	                        } else {
	                            // normal line to next point
	                            pathToPoint = [
	                                'L',
	                                plotX,
	                                plotY
	                            ];
	                        }
	
	                        // Prepare for animation. When step is enabled, there are two path nodes for each x value.
	                        xMap.push(point.x);
	                        if (step) {
	                            xMap.push(point.x);
	                        }
	
	                        graphPath.push.apply(graphPath, pathToPoint);
	                        gap = false;
	                    }
	                });
	
	                graphPath.xMap = xMap;
	                series.graphPath = graphPath;
	
	                return graphPath;
	
	            },
	
	            /**
	             * Draw the graph. Called internally when rendering line-like series types.
	             * The first time it generates the `series.graph` item and optionally other
	             * series-wide items like `series.area` for area charts. On subsequent calls
	             * these items are updated with new positions and attributes.
	             */
	            drawGraph: function() {
	                var series = this,
	                    options = this.options,
	                    graphPath = (this.gappedPath || this.getGraphPath).call(this),
	                    props = [
	                        [
	                            'graph',
	                            'highcharts-graph',
	
	                            options.lineColor || this.color,
	                            options.dashStyle
	
	                        ]
	                    ];
	
	                // Add the zone properties if any
	                each(this.zones, function(zone, i) {
	                    props.push([
	                        'zone-graph-' + i,
	                        'highcharts-graph highcharts-zone-graph-' + i + ' ' + (zone.className || ''),
	
	                        zone.color || series.color,
	                        zone.dashStyle || options.dashStyle
	
	                    ]);
	                });
	
	                // Draw the graph
	                each(props, function(prop, i) {
	                    var graphKey = prop[0],
	                        graph = series[graphKey],
	                        attribs;
	
	                    if (graph) {
	                        graph.endX = graphPath.xMap;
	                        graph.animate({
	                            d: graphPath
	                        });
	
	                    } else if (graphPath.length) { // #1487
	
	                        series[graphKey] = series.chart.renderer.path(graphPath)
	                            .addClass(prop[1])
	                            .attr({
	                                zIndex: 1
	                            }) // #1069
	                            .add(series.group);
	
	
	                        attribs = {
	                            'stroke': prop[2],
	                            'stroke-width': options.lineWidth,
	                            'fill': (series.fillGraph && series.color) || 'none' // Polygon series use filled graph
	                        };
	
	                        if (prop[3]) {
	                            attribs.dashstyle = prop[3];
	                        } else if (options.linecap !== 'square') {
	                            attribs['stroke-linecap'] = attribs['stroke-linejoin'] = 'round';
	                        }
	
	                        graph = series[graphKey]
	                            .attr(attribs)
	                            .shadow((i < 2) && options.shadow); // add shadow to normal series (0) or to first zone (1) #3932
	
	                    }
	
	                    // Helpers for animation
	                    if (graph) {
	                        graph.startX = graphPath.xMap;
	                        //graph.shiftUnit = options.step ? 2 : 1;
	                        graph.isArea = graphPath.isArea; // For arearange animation
	                    }
	                });
	            },
	
	            /**
	             * Clip the graphs into zones for colors and styling.
	             *
	             * @private
	             */
	            applyZones: function() {
	                var series = this,
	                    chart = this.chart,
	                    renderer = chart.renderer,
	                    zones = this.zones,
	                    translatedFrom,
	                    translatedTo,
	                    clips = this.clips || [],
	                    clipAttr,
	                    graph = this.graph,
	                    area = this.area,
	                    chartSizeMax = Math.max(chart.chartWidth, chart.chartHeight),
	                    axis = this[(this.zoneAxis || 'y') + 'Axis'],
	                    extremes,
	                    reversed,
	                    inverted = chart.inverted,
	                    horiz,
	                    pxRange,
	                    pxPosMin,
	                    pxPosMax,
	                    ignoreZones = false;
	
	                if (zones.length && (graph || area) && axis && axis.min !== undefined) {
	                    reversed = axis.reversed;
	                    horiz = axis.horiz;
	                    // The use of the Color Threshold assumes there are no gaps
	                    // so it is safe to hide the original graph and area
	                    if (graph) {
	                        graph.hide();
	                    }
	                    if (area) {
	                        area.hide();
	                    }
	
	                    // Create the clips
	                    extremes = axis.getExtremes();
	                    each(zones, function(threshold, i) {
	
	                        translatedFrom = reversed ?
	                            (horiz ? chart.plotWidth : 0) :
	                            (horiz ? 0 : axis.toPixels(extremes.min));
	                        translatedFrom = Math.min(Math.max(pick(translatedTo, translatedFrom), 0), chartSizeMax);
	                        translatedTo = Math.min(Math.max(Math.round(axis.toPixels(pick(threshold.value, extremes.max), true)), 0), chartSizeMax);
	
	                        if (ignoreZones) {
	                            translatedFrom = translatedTo = axis.toPixels(extremes.max);
	                        }
	
	                        pxRange = Math.abs(translatedFrom - translatedTo);
	                        pxPosMin = Math.min(translatedFrom, translatedTo);
	                        pxPosMax = Math.max(translatedFrom, translatedTo);
	                        if (axis.isXAxis) {
	                            clipAttr = {
	                                x: inverted ? pxPosMax : pxPosMin,
	                                y: 0,
	                                width: pxRange,
	                                height: chartSizeMax
	                            };
	                            if (!horiz) {
	                                clipAttr.x = chart.plotHeight - clipAttr.x;
	                            }
	                        } else {
	                            clipAttr = {
	                                x: 0,
	                                y: inverted ? pxPosMax : pxPosMin,
	                                width: chartSizeMax,
	                                height: pxRange
	                            };
	                            if (horiz) {
	                                clipAttr.y = chart.plotWidth - clipAttr.y;
	                            }
	                        }
	
	
	                        /// VML SUPPPORT
	                        if (inverted && renderer.isVML) {
	                            if (axis.isXAxis) {
	                                clipAttr = {
	                                    x: 0,
	                                    y: reversed ? pxPosMin : pxPosMax,
	                                    height: clipAttr.width,
	                                    width: chart.chartWidth
	                                };
	                            } else {
	                                clipAttr = {
	                                    x: clipAttr.y - chart.plotLeft - chart.spacingBox.x,
	                                    y: 0,
	                                    width: clipAttr.height,
	                                    height: chart.chartHeight
	                                };
	                            }
	                        }
	                        /// END OF VML SUPPORT
	
	
	                        if (clips[i]) {
	                            clips[i].animate(clipAttr);
	                        } else {
	                            clips[i] = renderer.clipRect(clipAttr);
	
	                            if (graph) {
	                                series['zone-graph-' + i].clip(clips[i]);
	                            }
	
	                            if (area) {
	                                series['zone-area-' + i].clip(clips[i]);
	                            }
	                        }
	                        // if this zone extends out of the axis, ignore the others
	                        ignoreZones = threshold.value > extremes.max;
	                    });
	                    this.clips = clips;
	                }
	            },
	
	            /**
	             * Initialize and perform group inversion on series.group and
	             * series.markerGroup.
	             *
	             * @private
	             */
	            invertGroups: function(inverted) {
	                var series = this,
	                    chart = series.chart,
	                    remover;
	
	                function setInvert() {
	                    each(['group', 'markerGroup'], function(groupName) {
	                        if (series[groupName]) {
	
	                            // VML/HTML needs explicit attributes for flipping
	                            if (chart.renderer.isVML) {
	                                series[groupName].attr({
	                                    width: series.yAxis.len,
	                                    height: series.xAxis.len
	                                });
	                            }
	
	                            series[groupName].width = series.yAxis.len;
	                            series[groupName].height = series.xAxis.len;
	                            series[groupName].invert(inverted);
	                        }
	                    });
	                }
	
	                // Pie, go away (#1736)
	                if (!series.xAxis) {
	                    return;
	                }
	
	                // A fixed size is needed for inversion to work
	                remover = addEvent(chart, 'resize', setInvert);
	                addEvent(series, 'destroy', remover);
	
	                // Do it now
	                setInvert(inverted); // do it now
	
	                // On subsequent render and redraw, just do setInvert without setting up events again
	                series.invertGroups = setInvert;
	            },
	
	            /**
	             * General abstraction for creating plot groups like series.group,
	             * series.dataLabelsGroup and series.markerGroup. On subsequent calls, the
	             * group will only be adjusted to the updated plot size.
	             *
	             * @private
	             */
	            plotGroup: function(prop, name, visibility, zIndex, parent) {
	                var group = this[prop],
	                    isNew = !group;
	
	                // Generate it on first call
	                if (isNew) {
	                    this[prop] = group = this.chart.renderer.g()
	                        .attr({
	                            zIndex: zIndex || 0.1 // IE8 and pointer logic use this
	                        })
	                        .add(parent);
	
	                }
	
	                // Add the class names, and replace existing ones as response to
	                // Series.update (#6660)
	                group.addClass(
	                    (
	                        'highcharts-' + name +
	                        ' highcharts-series-' + this.index +
	                        ' highcharts-' + this.type + '-series ' +
	                        'highcharts-color-' + this.colorIndex + ' ' +
	                        (this.options.className || '')
	                    ),
	                    true
	                );
	
	                // Place it on first and subsequent (redraw) calls
	                group.attr({
	                    visibility: visibility
	                })[isNew ? 'attr' : 'animate'](
	                    this.getPlotBox()
	                );
	                return group;
	            },
	
	            /**
	             * Get the translation and scale for the plot area of this series.
	             */
	            getPlotBox: function() {
	                var chart = this.chart,
	                    xAxis = this.xAxis,
	                    yAxis = this.yAxis;
	
	                // Swap axes for inverted (#2339)
	                if (chart.inverted) {
	                    xAxis = yAxis;
	                    yAxis = this.xAxis;
	                }
	                return {
	                    translateX: xAxis ? xAxis.left : chart.plotLeft,
	                    translateY: yAxis ? yAxis.top : chart.plotTop,
	                    scaleX: 1, // #1623
	                    scaleY: 1
	                };
	            },
	
	            /**
	             * Render the graph and markers. Called internally when first rendering and
	             * later when redrawing the chart. This function can be extended in plugins,
	             * but normally shouldn't be called directly.
	             */
	            render: function() {
	                var series = this,
	                    chart = series.chart,
	                    group,
	                    options = series.options,
	                    // Animation doesn't work in IE8 quirks when the group div is
	                    // hidden, and looks bad in other oldIE
	                    animDuration = (!!series.animate &&
	                        chart.renderer.isSVG &&
	                        animObject(options.animation).duration
	                    ),
	                    visibility = series.visible ? 'inherit' : 'hidden', // #2597
	                    zIndex = options.zIndex,
	                    hasRendered = series.hasRendered,
	                    chartSeriesGroup = chart.seriesGroup,
	                    inverted = chart.inverted;
	
	                // the group
	                group = series.plotGroup(
	                    'group',
	                    'series',
	                    visibility,
	                    zIndex,
	                    chartSeriesGroup
	                );
	
	                series.markerGroup = series.plotGroup(
	                    'markerGroup',
	                    'markers',
	                    visibility,
	                    zIndex,
	                    chartSeriesGroup
	                );
	
	                // initiate the animation
	                if (animDuration) {
	                    series.animate(true);
	                }
	
	                // SVGRenderer needs to know this before drawing elements (#1089, #1795)
	                group.inverted = series.isCartesian ? inverted : false;
	
	                // draw the graph if any
	                if (series.drawGraph) {
	                    series.drawGraph();
	                    series.applyZones();
	                }
	
	                /*		each(series.points, function (point) {
	                			if (point.redraw) {
	                				point.redraw();
	                			}
	                		});*/
	
	                // draw the data labels (inn pies they go before the points)
	                if (series.drawDataLabels) {
	                    series.drawDataLabels();
	                }
	
	                // draw the points
	                if (series.visible) {
	                    series.drawPoints();
	                }
	
	
	                // draw the mouse tracking area
	                if (
	                    series.drawTracker &&
	                    series.options.enableMouseTracking !== false
	                ) {
	                    series.drawTracker();
	                }
	
	                // Handle inverted series and tracker groups
	                series.invertGroups(inverted);
	
	                // Initial clipping, must be defined after inverting groups for VML.
	                // Applies to columns etc. (#3839).
	                if (options.clip !== false && !series.sharedClipKey && !hasRendered) {
	                    group.clip(chart.clipRect);
	                }
	
	                // Run the animation
	                if (animDuration) {
	                    series.animate();
	                }
	
	                // Call the afterAnimate function on animation complete (but don't
	                // overwrite the animation.complete option which should be available to
	                // the user).
	                if (!hasRendered) {
	                    series.animationTimeout = syncTimeout(function() {
	                        series.afterAnimate();
	                    }, animDuration);
	                }
	
	                series.isDirty = false; // means data is in accordance with what you see
	                // (See #322) series.isDirty = series.isDirtyData = false; // means
	                // data is in accordance with what you see
	                series.hasRendered = true;
	            },
	
	            /**
	             * Redraw the series. This function is called internally from `chart.redraw`
	             * and normally shouldn't be called directly.
	             *
	             * @private
	             */
	            redraw: function() {
	                var series = this,
	                    chart = series.chart,
	                    // cache it here as it is set to false in render, but used after
	                    wasDirty = series.isDirty || series.isDirtyData,
	                    group = series.group,
	                    xAxis = series.xAxis,
	                    yAxis = series.yAxis;
	
	                // reposition on resize
	                if (group) {
	                    if (chart.inverted) {
	                        group.attr({
	                            width: chart.plotWidth,
	                            height: chart.plotHeight
	                        });
	                    }
	
	                    group.animate({
	                        translateX: pick(xAxis && xAxis.left, chart.plotLeft),
	                        translateY: pick(yAxis && yAxis.top, chart.plotTop)
	                    });
	                }
	
	                series.translate();
	                series.render();
	                if (wasDirty) { // #3868, #3945
	                    delete this.kdTree;
	                }
	            },
	
	            kdAxisArray: ['clientX', 'plotY'],
	
	            searchPoint: function(e, compareX) {
	                var series = this,
	                    xAxis = series.xAxis,
	                    yAxis = series.yAxis,
	                    inverted = series.chart.inverted;
	
	                return this.searchKDTree({
	                    clientX: inverted ?
	                        xAxis.len - e.chartY + xAxis.pos : e.chartX - xAxis.pos,
	                    plotY: inverted ?
	                        yAxis.len - e.chartX + yAxis.pos : e.chartY - yAxis.pos
	                }, compareX);
	            },
	
	            /**
	             * Build the k-d-tree that is used by mouse and touch interaction to get the
	             * closest point. Line-like series typically have a one-dimensional tree
	             * where points are searched along the X axis, while scatter-like series
	             * typically search in two dimensions, X and Y.
	             *
	             * @private
	             */
	            buildKDTree: function() {
	
	                // Prevent multiple k-d-trees from being built simultaneously (#6235)
	                this.buildingKdTree = true;
	
	                var series = this,
	                    dimensions = series.options.findNearestPointBy.indexOf('y') > -1 ?
	                    2 : 1;
	
	                // Internal function
	                function _kdtree(points, depth, dimensions) {
	                    var axis,
	                        median,
	                        length = points && points.length;
	
	                    if (length) {
	
	                        // alternate between the axis
	                        axis = series.kdAxisArray[depth % dimensions];
	
	                        // sort point array
	                        points.sort(function(a, b) {
	                            return a[axis] - b[axis];
	                        });
	
	                        median = Math.floor(length / 2);
	
	                        // build and return nod
	                        return {
	                            point: points[median],
	                            left: _kdtree(
	                                points.slice(0, median), depth + 1, dimensions
	                            ),
	                            right: _kdtree(
	                                points.slice(median + 1), depth + 1, dimensions
	                            )
	                        };
	
	                    }
	                }
	
	                // Start the recursive build process with a clone of the points array
	                // and null points filtered out (#3873)
	                function startRecursive() {
	                    series.kdTree = _kdtree(
	                        series.getValidPoints(
	                            null,
	                            // For line-type series restrict to plot area, but
	                            // column-type series not (#3916, #4511)
	                            !series.directTouch
	                        ),
	                        dimensions,
	                        dimensions
	                    );
	                    series.buildingKdTree = false;
	                }
	                delete series.kdTree;
	
	                // For testing tooltips, don't build async
	                syncTimeout(startRecursive, series.options.kdNow ? 0 : 1);
	            },
	
	            searchKDTree: function(point, compareX) {
	                var series = this,
	                    kdX = this.kdAxisArray[0],
	                    kdY = this.kdAxisArray[1],
	                    kdComparer = compareX ? 'distX' : 'dist',
	                    kdDimensions = series.options.findNearestPointBy.indexOf('y') > -1 ?
	                    2 : 1;
	
	                // Set the one and two dimensional distance on the point object
	                function setDistance(p1, p2) {
	                    var x = (defined(p1[kdX]) && defined(p2[kdX])) ?
	                        Math.pow(p1[kdX] - p2[kdX], 2) :
	                        null,
	                        y = (defined(p1[kdY]) && defined(p2[kdY])) ?
	                        Math.pow(p1[kdY] - p2[kdY], 2) :
	                        null,
	                        r = (x || 0) + (y || 0);
	
	                    p2.dist = defined(r) ? Math.sqrt(r) : Number.MAX_VALUE;
	                    p2.distX = defined(x) ? Math.sqrt(x) : Number.MAX_VALUE;
	                }
	
	                function _search(search, tree, depth, dimensions) {
	                    var point = tree.point,
	                        axis = series.kdAxisArray[depth % dimensions],
	                        tdist,
	                        sideA,
	                        sideB,
	                        ret = point,
	                        nPoint1,
	                        nPoint2;
	
	                    setDistance(search, point);
	
	                    // Pick side based on distance to splitting point
	                    tdist = search[axis] - point[axis];
	                    sideA = tdist < 0 ? 'left' : 'right';
	                    sideB = tdist < 0 ? 'right' : 'left';
	
	                    // End of tree
	                    if (tree[sideA]) {
	                        nPoint1 = _search(search, tree[sideA], depth + 1, dimensions);
	
	                        ret = (nPoint1[kdComparer] < ret[kdComparer] ? nPoint1 : point);
	                    }
	                    if (tree[sideB]) {
	                        // compare distance to current best to splitting point to decide
	                        // wether to check side B or not
	                        if (Math.sqrt(tdist * tdist) < ret[kdComparer]) {
	                            nPoint2 = _search(
	                                search,
	                                tree[sideB],
	                                depth + 1,
	                                dimensions
	                            );
	                            ret = nPoint2[kdComparer] < ret[kdComparer] ?
	                                nPoint2 :
	                                ret;
	                        }
	                    }
	
	                    return ret;
	                }
	
	                if (!this.kdTree && !this.buildingKdTree) {
	                    this.buildKDTree();
	                }
	
	                if (this.kdTree) {
	                    return _search(point, this.kdTree, kdDimensions, kdDimensions);
	                }
	            }
	
	        }); // end Series prototype
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var Axis = H.Axis,
	            Chart = H.Chart,
	            correctFloat = H.correctFloat,
	            defined = H.defined,
	            destroyObjectProperties = H.destroyObjectProperties,
	            each = H.each,
	            format = H.format,
	            objectEach = H.objectEach,
	            pick = H.pick,
	            Series = H.Series;
	
	        /**
	         * The class for stacks. Each stack, on a specific X value and either negative
	         * or positive, has its own stack item.
	         *
	         * @class
	         */
	        H.StackItem = function(axis, options, isNegative, x, stackOption) {
	
	            var inverted = axis.chart.inverted;
	
	            this.axis = axis;
	
	            // Tells if the stack is negative
	            this.isNegative = isNegative;
	
	            // Save the options to be able to style the label
	            this.options = options;
	
	            // Save the x value to be able to position the label later
	            this.x = x;
	
	            // Initialize total value
	            this.total = null;
	
	            // This will keep each points' extremes stored by series.index and point 
	            // index
	            this.points = {};
	
	            // Save the stack option on the series configuration object, and whether to 
	            // treat it as percent
	            this.stack = stackOption;
	            this.leftCliff = 0;
	            this.rightCliff = 0;
	
	            // The align options and text align varies on whether the stack is negative 
	            // and if the chart is inverted or not.
	            // First test the user supplied value, then use the dynamic.
	            this.alignOptions = {
	                align: options.align ||
	                    (inverted ? (isNegative ? 'left' : 'right') : 'center'),
	                verticalAlign: options.verticalAlign ||
	                    (inverted ? 'middle' : (isNegative ? 'bottom' : 'top')),
	                y: pick(options.y, inverted ? 4 : (isNegative ? 14 : -6)),
	                x: pick(options.x, inverted ? (isNegative ? -6 : 6) : 0)
	            };
	
	            this.textAlign = options.textAlign ||
	                (inverted ? (isNegative ? 'right' : 'left') : 'center');
	        };
	
	        H.StackItem.prototype = {
	            destroy: function() {
	                destroyObjectProperties(this, this.axis);
	            },
	
	            /**
	             * Renders the stack total label and adds it to the stack label group.
	             */
	            render: function(group) {
	                var options = this.options,
	                    formatOption = options.format,
	                    str = formatOption ?
	                    format(formatOption, this) :
	                    options.formatter.call(this); // format the text in the label
	
	                // Change the text to reflect the new total and set visibility to hidden
	                // in case the serie is hidden
	                if (this.label) {
	                    this.label.attr({
	                        text: str,
	                        visibility: 'hidden'
	                    });
	                    // Create new label
	                } else {
	                    this.label =
	                        this.axis.chart.renderer.text(str, null, null, options.useHTML)
	                        .css(options.style)
	                        .attr({
	                            align: this.textAlign,
	                            rotation: options.rotation,
	                            visibility: 'hidden' // hidden until setOffset is called
	                        })
	                        .add(group); // add to the labels-group
	                }
	            },
	
	            /**
	             * Sets the offset that the stack has from the x value and repositions the
	             * label.
	             */
	            setOffset: function(xOffset, xWidth) {
	                var stackItem = this,
	                    axis = stackItem.axis,
	                    chart = axis.chart,
	                    // stack value translated mapped to chart coordinates
	                    y = axis.translate(
	                        axis.usePercentage ? 100 : stackItem.total,
	                        0,
	                        0,
	                        0,
	                        1
	                    ),
	                    yZero = axis.translate(0), // stack origin
	                    h = Math.abs(y - yZero), // stack height
	                    x = chart.xAxis[0].translate(stackItem.x) + xOffset, // stack x position
	                    stackBox = stackItem.getStackBox(chart, stackItem, x, y, xWidth, h),
	                    label = stackItem.label,
	                    alignAttr;
	
	                if (label) {
	                    // Align the label to the box
	                    label.align(stackItem.alignOptions, null, stackBox);
	
	                    // Set visibility (#678)
	                    alignAttr = label.alignAttr;
	                    label[
	                        stackItem.options.crop === false || chart.isInsidePlot(
	                            alignAttr.x,
	                            alignAttr.y
	                        ) ? 'show' : 'hide'](true);
	                }
	            },
	            getStackBox: function(chart, stackItem, x, y, xWidth, h) {
	                var reversed = stackItem.axis.reversed,
	                    inverted = chart.inverted,
	                    plotHeight = chart.plotHeight,
	                    neg = (stackItem.isNegative && !reversed) ||
	                    (!stackItem.isNegative && reversed); // #4056
	
	                return { // this is the box for the complete stack
	                    x: inverted ? (neg ? y : y - h) : x,
	                    y: inverted ?
	                        plotHeight - x - xWidth :
	                        (neg ?
	                            (plotHeight - y - h) :
	                            plotHeight - y
	                        ),
	                    width: inverted ? h : xWidth,
	                    height: inverted ? xWidth : h
	                };
	            }
	        };
	
	        /**
	         * Generate stacks for each series and calculate stacks total values
	         */
	        Chart.prototype.getStacks = function() {
	            var chart = this;
	
	            // reset stacks for each yAxis
	            each(chart.yAxis, function(axis) {
	                if (axis.stacks && axis.hasVisibleSeries) {
	                    axis.oldStacks = axis.stacks;
	                }
	            });
	
	            each(chart.series, function(series) {
	                if (series.options.stacking && (series.visible === true ||
	                        chart.options.chart.ignoreHiddenSeries === false)) {
	                    series.stackKey = series.type + pick(series.options.stack, '');
	                }
	            });
	        };
	
	
	        // Stacking methods defined on the Axis prototype
	
	        /**
	         * Build the stacks from top down
	         */
	        Axis.prototype.buildStacks = function() {
	            var axisSeries = this.series,
	                reversedStacks = pick(this.options.reversedStacks, true),
	                len = axisSeries.length,
	                i;
	            if (!this.isXAxis) {
	                this.usePercentage = false;
	                i = len;
	                while (i--) {
	                    axisSeries[reversedStacks ? i : len - i - 1].setStackedPoints();
	                }
	
	                // Loop up again to compute percent stack
	                if (this.usePercentage) {
	                    for (i = 0; i < len; i++) {
	                        axisSeries[i].setPercentStacks();
	                    }
	                }
	            }
	        };
	
	        Axis.prototype.renderStackTotals = function() {
	            var axis = this,
	                chart = axis.chart,
	                renderer = chart.renderer,
	                stacks = axis.stacks,
	                stackTotalGroup = axis.stackTotalGroup;
	
	            // Create a separate group for the stack total labels
	            if (!stackTotalGroup) {
	                axis.stackTotalGroup = stackTotalGroup =
	                    renderer.g('stack-labels')
	                    .attr({
	                        visibility: 'visible',
	                        zIndex: 6
	                    })
	                    .add();
	            }
	
	            // plotLeft/Top will change when y axis gets wider so we need to translate
	            // the stackTotalGroup at every render call. See bug #506 and #516
	            stackTotalGroup.translate(chart.plotLeft, chart.plotTop);
	
	            // Render each stack total
	            objectEach(stacks, function(type) {
	                objectEach(type, function(stack) {
	                    stack.render(stackTotalGroup);
	                });
	            });
	        };
	
	        /**
	         * Set all the stacks to initial states and destroy unused ones.
	         */
	        Axis.prototype.resetStacks = function() {
	            var axis = this,
	                stacks = axis.stacks;
	            if (!axis.isXAxis) {
	                objectEach(stacks, function(type) {
	                    objectEach(type, function(stack, key) {
	                        // Clean up memory after point deletion (#1044, #4320)
	                        if (stack.touched < axis.stacksTouched) {
	                            stack.destroy();
	                            delete type[key];
	
	                            // Reset stacks
	                        } else {
	                            stack.total = null;
	                            stack.cum = null;
	                        }
	                    });
	                });
	            }
	        };
	
	        Axis.prototype.cleanStacks = function() {
	            var stacks;
	
	            if (!this.isXAxis) {
	                if (this.oldStacks) {
	                    stacks = this.stacks = this.oldStacks;
	                }
	
	                // reset stacks
	                objectEach(stacks, function(type) {
	                    objectEach(type, function(stack) {
	                        stack.cum = stack.total;
	                    });
	                });
	            }
	        };
	
	
	        // Stacking methods defnied for Series prototype
	
	        /**
	         * Adds series' points value to corresponding stack
	         */
	        Series.prototype.setStackedPoints = function() {
	            if (!this.options.stacking || (this.visible !== true &&
	                    this.chart.options.chart.ignoreHiddenSeries !== false)) {
	                return;
	            }
	
	            var series = this,
	                xData = series.processedXData,
	                yData = series.processedYData,
	                stackedYData = [],
	                yDataLength = yData.length,
	                seriesOptions = series.options,
	                threshold = seriesOptions.threshold,
	                stackThreshold = seriesOptions.startFromThreshold ? threshold : 0,
	                stackOption = seriesOptions.stack,
	                stacking = seriesOptions.stacking,
	                stackKey = series.stackKey,
	                negKey = '-' + stackKey,
	                negStacks = series.negStacks,
	                yAxis = series.yAxis,
	                stacks = yAxis.stacks,
	                oldStacks = yAxis.oldStacks,
	                stackIndicator,
	                isNegative,
	                stack,
	                other,
	                key,
	                pointKey,
	                i,
	                x,
	                y;
	
	
	            yAxis.stacksTouched += 1;
	
	            // loop over the non-null y values and read them into a local array
	            for (i = 0; i < yDataLength; i++) {
	                x = xData[i];
	                y = yData[i];
	                stackIndicator = series.getStackIndicator(
	                    stackIndicator,
	                    x,
	                    series.index
	                );
	                pointKey = stackIndicator.key;
	                // Read stacked values into a stack based on the x value,
	                // the sign of y and the stack key. Stacking is also handled for null
	                // values (#739)
	                isNegative = negStacks && y < (stackThreshold ? 0 : threshold);
	                key = isNegative ? negKey : stackKey;
	
	                // Create empty object for this stack if it doesn't exist yet
	                if (!stacks[key]) {
	                    stacks[key] = {};
	                }
	
	                // Initialize StackItem for this x
	                if (!stacks[key][x]) {
	                    if (oldStacks[key] && oldStacks[key][x]) {
	                        stacks[key][x] = oldStacks[key][x];
	                        stacks[key][x].total = null;
	                    } else {
	                        stacks[key][x] = new H.StackItem(
	                            yAxis,
	                            yAxis.options.stackLabels,
	                            isNegative,
	                            x,
	                            stackOption
	                        );
	                    }
	                }
	
	                // If the StackItem doesn't exist, create it first
	                stack = stacks[key][x];
	                if (y !== null) {
	                    stack.points[pointKey] = stack.points[series.index] = [pick(stack.cum, stackThreshold)];
	
	                    // Record the base of the stack
	                    if (!defined(stack.cum)) {
	                        stack.base = pointKey;
	                    }
	                    stack.touched = yAxis.stacksTouched;
	
	
	                    // In area charts, if there are multiple points on the same X value,
	                    // let the area fill the full span of those points
	                    if (stackIndicator.index > 0 && series.singleStacks === false) {
	                        stack.points[pointKey][0] =
	                            stack.points[series.index + ',' + x + ',0'][0];
	                    }
	                }
	
	                // Add value to the stack total
	                if (stacking === 'percent') {
	
	                    // Percent stacked column, totals are the same for the positive and
	                    // negative stacks
	                    other = isNegative ? stackKey : negKey;
	                    if (negStacks && stacks[other] && stacks[other][x]) {
	                        other = stacks[other][x];
	                        stack.total = other.total =
	                            Math.max(other.total, stack.total) + Math.abs(y) || 0;
	
	                        // Percent stacked areas
	                    } else {
	                        stack.total = correctFloat(stack.total + (Math.abs(y) || 0));
	                    }
	                } else {
	                    stack.total = correctFloat(stack.total + (y || 0));
	                }
	
	                stack.cum = pick(stack.cum, stackThreshold) + (y || 0);
	
	                if (y !== null) {
	                    stack.points[pointKey].push(stack.cum);
	                    stackedYData[i] = stack.cum;
	                }
	
	            }
	
	            if (stacking === 'percent') {
	                yAxis.usePercentage = true;
	            }
	
	            this.stackedYData = stackedYData; // To be used in getExtremes
	
	            // Reset old stacks
	            yAxis.oldStacks = {};
	        };
	
	        /**
	         * Iterate over all stacks and compute the absolute values to percent
	         */
	        Series.prototype.setPercentStacks = function() {
	            var series = this,
	                stackKey = series.stackKey,
	                stacks = series.yAxis.stacks,
	                processedXData = series.processedXData,
	                stackIndicator;
	
	            each([stackKey, '-' + stackKey], function(key) {
	                var i = processedXData.length,
	                    x,
	                    stack,
	                    pointExtremes,
	                    totalFactor;
	
	                while (i--) {
	                    x = processedXData[i];
	                    stackIndicator = series.getStackIndicator(
	                        stackIndicator,
	                        x,
	                        series.index,
	                        key
	                    );
	                    stack = stacks[key] && stacks[key][x];
	                    pointExtremes = stack && stack.points[stackIndicator.key];
	                    if (pointExtremes) {
	                        totalFactor = stack.total ? 100 / stack.total : 0;
	                        // Y bottom value
	                        pointExtremes[0] = correctFloat(pointExtremes[0] * totalFactor);
	                        // Y value
	                        pointExtremes[1] = correctFloat(pointExtremes[1] * totalFactor);
	                        series.stackedYData[i] = pointExtremes[1];
	                    }
	                }
	            });
	        };
	
	        /**
	         * Get stack indicator, according to it's x-value, to determine points with the
	         * same x-value
	         */
	        Series.prototype.getStackIndicator = function(stackIndicator, x, index, key) {
	            // Update stack indicator, when:
	            // first point in a stack || x changed || stack type (negative vs positive)
	            // changed:
	            if (!defined(stackIndicator) || stackIndicator.x !== x ||
	                (key && stackIndicator.key !== key)) {
	                stackIndicator = {
	                    x: x,
	                    index: 0,
	                    key: key
	                };
	            } else {
	                stackIndicator.index++;
	            }
	
	            stackIndicator.key = [index, x, stackIndicator.index].join(',');
	
	            return stackIndicator;
	        };
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var addEvent = H.addEvent,
	            animate = H.animate,
	            Axis = H.Axis,
	            Chart = H.Chart,
	            createElement = H.createElement,
	            css = H.css,
	            defined = H.defined,
	            each = H.each,
	            erase = H.erase,
	            extend = H.extend,
	            fireEvent = H.fireEvent,
	            inArray = H.inArray,
	            isNumber = H.isNumber,
	            isObject = H.isObject,
	            isArray = H.isArray,
	            merge = H.merge,
	            objectEach = H.objectEach,
	            pick = H.pick,
	            Point = H.Point,
	            Series = H.Series,
	            seriesTypes = H.seriesTypes,
	            setAnimation = H.setAnimation,
	            splat = H.splat;
	
	        // Extend the Chart prototype for dynamic methods
	        extend(Chart.prototype, /** @lends Highcharts.Chart.prototype */ {
	
	            /**
	             * Add a series to the chart after render time. Note that this method should
	             * never be used when adding data synchronously at chart render time, as it
	             * adds expense to the calculations and rendering. When adding data at the
	             * same time as the chart is initialized, add the series as a configuration
	             * option instead. With multiple axes, the `offset` is dynamically adjusted.
	             *
	             * @param  {SeriesOptions} options
	             *         The config options for the series.
	             * @param  {Boolean} [redraw=true]
	             *         Whether to redraw the chart after adding.
	             * @param  {AnimationOptions} animation
	             *         Whether to apply animation, and optionally animation
	             *         configuration.
	             *
	             * @return {Highcharts.Series}
	             *         The newly created series object.
	             *
	             * @sample highcharts/members/chart-addseries/
	             *         Add a series from a button
	             * @sample stock/members/chart-addseries/
	             *         Add a series in Highstock
	             */
	            addSeries: function(options, redraw, animation) {
	                var series,
	                    chart = this;
	
	                if (options) {
	                    redraw = pick(redraw, true); // defaults to true
	
	                    fireEvent(chart, 'addSeries', {
	                        options: options
	                    }, function() {
	                        series = chart.initSeries(options);
	
	                        chart.isDirtyLegend = true; // the series array is out of sync with the display
	                        chart.linkSeries();
	                        if (redraw) {
	                            chart.redraw(animation);
	                        }
	                    });
	                }
	
	                return series;
	            },
	
	            /**
	             * Add an axis to the chart after render time. Note that this method should
	             * never be used when adding data synchronously at chart render time, as it
	             * adds expense to the calculations and rendering. When adding data at the
	             * same time as the chart is initialized, add the axis as a configuration
	             * option instead.
	             * @param  {AxisOptions} options
	             *         The axis options.
	             * @param  {Boolean} [isX=false]
	             *         Whether it is an X axis or a value axis.
	             * @param  {Boolean} [redraw=true]
	             *         Whether to redraw the chart after adding.
	             * @param  {AnimationOptions} [animation=true]
	             *         Whether and how to apply animation in the redraw.
	             *
	             * @sample highcharts/members/chart-addaxis/ Add and remove axes
	             *
	             * @return {Axis}
	             *         The newly generated Axis object.
	             */
	            addAxis: function(options, isX, redraw, animation) {
	                var key = isX ? 'xAxis' : 'yAxis',
	                    chartOptions = this.options,
	                    userOptions = merge(options, {
	                        index: this[key].length,
	                        isX: isX
	                    }),
	                    axis;
	
	                axis = new Axis(this, userOptions);
	
	                // Push the new axis options to the chart options
	                chartOptions[key] = splat(chartOptions[key] || {});
	                chartOptions[key].push(userOptions);
	
	                if (pick(redraw, true)) {
	                    this.redraw(animation);
	                }
	
	                return axis;
	            },
	
	            /**
	             * Dim the chart and show a loading text or symbol. Options for the loading
	             * screen are defined in {@link
	             * https://api.highcharts.com/highcharts/loading|the loading options}.
	             * 
	             * @param  {String} str
	             *         An optional text to show in the loading label instead of the
	             *         default one. The default text is set in {@link
	             *         http://api.highcharts.com/highcharts/lang.loading|lang.loading}.
	             *
	             * @sample highcharts/members/chart-hideloading/
	             *         Show and hide loading from a button
	             * @sample highcharts/members/chart-showloading/
	             *         Apply different text labels
	             * @sample stock/members/chart-show-hide-loading/
	             *         Toggle loading in Highstock
	             */
	            showLoading: function(str) {
	                var chart = this,
	                    options = chart.options,
	                    loadingDiv = chart.loadingDiv,
	                    loadingOptions = options.loading,
	                    setLoadingSize = function() {
	                        if (loadingDiv) {
	                            css(loadingDiv, {
	                                left: chart.plotLeft + 'px',
	                                top: chart.plotTop + 'px',
	                                width: chart.plotWidth + 'px',
	                                height: chart.plotHeight + 'px'
	                            });
	                        }
	                    };
	
	                // create the layer at the first call
	                if (!loadingDiv) {
	                    chart.loadingDiv = loadingDiv = createElement('div', {
	                        className: 'highcharts-loading highcharts-loading-hidden'
	                    }, null, chart.container);
	
	                    chart.loadingSpan = createElement(
	                        'span', {
	                            className: 'highcharts-loading-inner'
	                        },
	                        null,
	                        loadingDiv
	                    );
	                    addEvent(chart, 'redraw', setLoadingSize); // #1080
	                }
	
	                loadingDiv.className = 'highcharts-loading';
	
	                // Update text
	                chart.loadingSpan.innerHTML = str || options.lang.loading;
	
	
	                // Update visuals
	                css(loadingDiv, extend(loadingOptions.style, {
	                    zIndex: 10
	                }));
	                css(chart.loadingSpan, loadingOptions.labelStyle);
	
	                // Show it
	                if (!chart.loadingShown) {
	                    css(loadingDiv, {
	                        opacity: 0,
	                        display: ''
	                    });
	                    animate(loadingDiv, {
	                        opacity: loadingOptions.style.opacity || 0.5
	                    }, {
	                        duration: loadingOptions.showDuration || 0
	                    });
	                }
	
	
	                chart.loadingShown = true;
	                setLoadingSize();
	            },
	
	            /**
	             * Hide the loading layer.
	             *
	             * @see    Highcharts.Chart#showLoading
	             * @sample highcharts/members/chart-hideloading/
	             *         Show and hide loading from a button
	             * @sample stock/members/chart-show-hide-loading/
	             *         Toggle loading in Highstock
	             */
	            hideLoading: function() {
	                var options = this.options,
	                    loadingDiv = this.loadingDiv;
	
	                if (loadingDiv) {
	                    loadingDiv.className = 'highcharts-loading highcharts-loading-hidden';
	
	                    animate(loadingDiv, {
	                        opacity: 0
	                    }, {
	                        duration: options.loading.hideDuration || 100,
	                        complete: function() {
	                            css(loadingDiv, {
	                                display: 'none'
	                            });
	                        }
	                    });
	
	                }
	                this.loadingShown = false;
	            },
	
	            /** 
	             * These properties cause isDirtyBox to be set to true when updating. Can be extended from plugins.
	             */
	            propsRequireDirtyBox: ['backgroundColor', 'borderColor', 'borderWidth', 'margin', 'marginTop', 'marginRight',
	                'marginBottom', 'marginLeft', 'spacing', 'spacingTop', 'spacingRight', 'spacingBottom', 'spacingLeft',
	                'borderRadius', 'plotBackgroundColor', 'plotBackgroundImage', 'plotBorderColor', 'plotBorderWidth',
	                'plotShadow', 'shadow'
	            ],
	
	            /** 
	             * These properties cause all series to be updated when updating. Can be
	             * extended from plugins.
	             */
	            propsRequireUpdateSeries: ['chart.inverted', 'chart.polar',
	                'chart.ignoreHiddenSeries', 'chart.type', 'colors', 'plotOptions',
	                'tooltip'
	            ],
	
	            /**
	             * A generic function to update any element of the chart. Elements can be
	             * enabled and disabled, moved, re-styled, re-formatted etc.
	             *
	             * A special case is configuration objects that take arrays, for example
	             * {@link https://api.highcharts.com/highcharts/xAxis|xAxis}, 
	             * {@link https://api.highcharts.com/highcharts/yAxis|yAxis} or 
	             * {@link https://api.highcharts.com/highcharts/series|series}. For these
	             * collections, an `id` option is used to map the new option set to an
	             * existing object. If an existing object of the same id is not found, the
	             * corresponding item is updated. So for example, running `chart.update`
	             * with a series item without an id, will cause the existing chart's series
	             * with the same index in the series array to be updated. When the
	             * `oneToOne` parameter is true, `chart.update` will also take care of
	             * adding and removing items from the collection. Read more under the
	             * parameter description below.
	             *
	             * See also the {@link https://api.highcharts.com/highcharts/responsive|
	             * responsive option set}. Switching between `responsive.rules` basically
	             * runs `chart.update` under the hood.
	             *
	             * @param  {Options} options
	             *         A configuration object for the new chart options.
	             * @param  {Boolean} [redraw=true]
	             *         Whether to redraw the chart.
	             * @param  {Boolean} [oneToOne=false]
	             *         When `true`, the `series`, `xAxis` and `yAxis` collections will
	             *         be updated one to one, and items will be either added or removed
	             *         to match the new updated options. For example, if the chart has
	             *         two series and we call `chart.update` with a configuration 
	             *         containing three series, one will be added. If we call
	             *         `chart.update` with one series, one will be removed. Setting an
	             *         empty `series` array will remove all series, but leaving out the
	             *         `series` property will leave all series untouched. If the series
	             *         have id's, the new series options will be matched by id, and the
	             *         remaining ones removed.
	             *
	             * @sample highcharts/members/chart-update/
	             *         Update chart geometry 
	             */
	            update: function(options, redraw, oneToOne) {
	                var chart = this,
	                    adders = {
	                        credits: 'addCredits',
	                        title: 'setTitle',
	                        subtitle: 'setSubtitle'
	                    },
	                    optionsChart = options.chart,
	                    updateAllAxes,
	                    updateAllSeries,
	                    newWidth,
	                    newHeight,
	                    itemsForRemoval = [];
	
	                // If the top-level chart option is present, some special updates are required		
	                if (optionsChart) {
	                    merge(true, chart.options.chart, optionsChart);
	
	                    // Setter function
	                    if ('className' in optionsChart) {
	                        chart.setClassName(optionsChart.className);
	                    }
	
	                    if ('inverted' in optionsChart || 'polar' in optionsChart) {
	                        // Parse options.chart.inverted and options.chart.polar together
	                        // with the available series.
	                        chart.propFromSeries();
	                        updateAllAxes = true;
	                    }
	
	                    if ('alignTicks' in optionsChart) { // #6452
	                        updateAllAxes = true;
	                    }
	
	                    objectEach(optionsChart, function(val, key) {
	                        if (inArray('chart.' + key, chart.propsRequireUpdateSeries) !== -1) {
	                            updateAllSeries = true;
	                        }
	                        // Only dirty box
	                        if (inArray(key, chart.propsRequireDirtyBox) !== -1) {
	                            chart.isDirtyBox = true;
	                        }
	                    });
	
	
	                    if ('style' in optionsChart) {
	                        chart.renderer.setStyle(optionsChart.style);
	                    }
	
	                }
	
	                // Moved up, because tooltip needs updated plotOptions (#6218)
	
	                if (options.colors) {
	                    this.options.colors = options.colors;
	                }
	
	
	                if (options.plotOptions) {
	                    merge(true, this.options.plotOptions, options.plotOptions);
	                }
	
	                // Some option stuctures correspond one-to-one to chart objects that
	                // have update methods, for example
	                // options.credits => chart.credits
	                // options.legend => chart.legend
	                // options.title => chart.title
	                // options.tooltip => chart.tooltip
	                // options.subtitle => chart.subtitle
	                // options.mapNavigation => chart.mapNavigation
	                // options.navigator => chart.navigator
	                // options.scrollbar => chart.scrollbar
	                objectEach(options, function(val, key) {
	                    if (chart[key] && typeof chart[key].update === 'function') {
	                        chart[key].update(val, false);
	
	                        // If a one-to-one object does not exist, look for an adder function
	                    } else if (typeof chart[adders[key]] === 'function') {
	                        chart[adders[key]](val);
	                    }
	
	                    if (
	                        key !== 'chart' &&
	                        inArray(key, chart.propsRequireUpdateSeries) !== -1
	                    ) {
	                        updateAllSeries = true;
	                    }
	                });
	
	                // Setters for collections. For axes and series, each item is referred
	                // by an id. If the id is not found, it defaults to the corresponding
	                // item in the collection, so setting one series without an id, will
	                // update the first series in the chart. Setting two series without
	                // an id will update the first and the second respectively (#6019)
	                // chart.update and responsive.
	                each([
	                    'xAxis',
	                    'yAxis',
	                    'zAxis',
	                    'series',
	                    'colorAxis',
	                    'pane'
	                ], function(coll) {
	                    if (options[coll]) {
	                        each(splat(options[coll]), function(newOptions, i) {
	                            var item = (
	                                defined(newOptions.id) &&
	                                chart.get(newOptions.id)
	                            ) || chart[coll][i];
	                            if (item && item.coll === coll) {
	                                item.update(newOptions, false);
	
	                                if (oneToOne) {
	                                    item.touched = true;
	                                }
	                            }
	
	                            // If oneToOne and no matching item is found, add one
	                            if (!item && oneToOne) {
	                                if (coll === 'series') {
	                                    chart.addSeries(newOptions, false)
	                                        .touched = true;
	                                } else if (coll === 'xAxis' || coll === 'yAxis') {
	                                    chart.addAxis(newOptions, coll === 'xAxis', false)
	                                        .touched = true;
	                                }
	                            }
	
	                        });
	
	                        // Add items for removal
	                        if (oneToOne) {
	                            each(chart[coll], function(item) {
	                                if (!item.touched) {
	                                    itemsForRemoval.push(item);
	                                } else {
	                                    delete item.touched;
	                                }
	                            });
	                        }
	
	
	                    }
	                });
	
	                each(itemsForRemoval, function(item) {
	                    item.remove(false);
	                });
	
	                if (updateAllAxes) {
	                    each(chart.axes, function(axis) {
	                        axis.update({}, false);
	                    });
	                }
	
	                // Certain options require the whole series structure to be thrown away
	                // and rebuilt
	                if (updateAllSeries) {
	                    each(chart.series, function(series) {
	                        series.update({}, false);
	                    });
	                }
	
	                // For loading, just update the options, do not redraw
	                if (options.loading) {
	                    merge(true, chart.options.loading, options.loading);
	                }
	
	                // Update size. Redraw is forced.
	                newWidth = optionsChart && optionsChart.width;
	                newHeight = optionsChart && optionsChart.height;
	                if ((isNumber(newWidth) && newWidth !== chart.chartWidth) ||
	                    (isNumber(newHeight) && newHeight !== chart.chartHeight)) {
	                    chart.setSize(newWidth, newHeight);
	                } else if (pick(redraw, true)) {
	                    chart.redraw();
	                }
	            },
	
	            /**
	             * Shortcut to set the subtitle options. This can also be done from {@link
	             * Chart#update} or {@link Chart#setTitle}.
	             *
	             * @param  {SubtitleOptions} options
	             *         New subtitle options. The subtitle text itself is set by the
	             *         `options.text` property.
	             */
	            setSubtitle: function(options) {
	                this.setTitle(undefined, options);
	            }
	
	
	        });
	
	        // extend the Point prototype for dynamic methods
	        extend(Point.prototype, /** @lends Highcharts.Point.prototype */ {
	            /**
	             * Update point with new options (typically x/y data) and optionally redraw
	             * the series.
	             *
	             * @param  {Object} options
	             *         The point options. Point options are handled as described under
	             *         the `series<type>.data` item for each series type. For example
	             *         for a line series, if options is a single number, the point will
	             *         be given that number as the main y value. If it is an array, it
	             *         will be interpreted as x and y values respectively. If it is an
	             *         object, advanced options are applied. 
	             * @param  {Boolean} [redraw=true]
	             *          Whether to redraw the chart after the point is updated. If doing
	             *          more operations on the chart, it is best practice to set
	             *          `redraw` to false and call `chart.redraw()` after.
	             * @param  {AnimationOptions} [animation=true]
	             *         Whether to apply animation, and optionally animation
	             *         configuration.
	             *
	             * @sample highcharts/members/point-update-column/
	             *         Update column value
	             * @sample highcharts/members/point-update-pie/
	             *         Update pie slice
	             * @sample maps/members/point-update/
	             *         Update map area value in Highmaps
	             */
	            update: function(options, redraw, animation, runEvent) {
	                var point = this,
	                    series = point.series,
	                    graphic = point.graphic,
	                    i,
	                    chart = series.chart,
	                    seriesOptions = series.options;
	
	                redraw = pick(redraw, true);
	
	                function update() {
	
	                    point.applyOptions(options);
	
	                    // Update visuals
	                    if (point.y === null && graphic) { // #4146
	                        point.graphic = graphic.destroy();
	                    }
	                    if (isObject(options, true)) {
	                        // Destroy so we can get new elements
	                        if (graphic && graphic.element) {
	                            // "null" is also a valid symbol
	                            if (options && options.marker && options.marker.symbol !== undefined) {
	                                point.graphic = graphic.destroy();
	                            }
	                        }
	                        if (options && options.dataLabels && point.dataLabel) { // #2468
	                            point.dataLabel = point.dataLabel.destroy();
	                        }
	                    }
	
	                    // record changes in the parallel arrays
	                    i = point.index;
	                    series.updateParallelArrays(point, i);
	
	                    // Record the options to options.data. If the old or the new config
	                    // is an object, use point options, otherwise use raw options
	                    // (#4701, #4916).
	                    seriesOptions.data[i] = (
	                            isObject(seriesOptions.data[i], true) ||
	                            isObject(options, true)
	                        ) ?
	                        point.options :
	                        options;
	
	                    // redraw
	                    series.isDirty = series.isDirtyData = true;
	                    if (!series.fixedBox && series.hasCartesianSeries) { // #1906, #2320
	                        chart.isDirtyBox = true;
	                    }
	
	                    if (seriesOptions.legendType === 'point') { // #1831, #1885
	                        chart.isDirtyLegend = true;
	                    }
	                    if (redraw) {
	                        chart.redraw(animation);
	                    }
	                }
	
	                // Fire the event with a default handler of doing the update
	                if (runEvent === false) { // When called from setData
	                    update();
	                } else {
	                    point.firePointEvent('update', {
	                        options: options
	                    }, update);
	                }
	            },
	
	            /**
	             * Remove a point and optionally redraw the series and if necessary the axes
	             * @param  {Boolean} redraw
	             *         Whether to redraw the chart or wait for an explicit call. When
	             *         doing more operations on the chart, for example running
	             *         `point.remove()` in a loop, it is best practice to set `redraw`
	             *         to false and call `chart.redraw()` after.         
	             * @param  {AnimationOptions} [animation=false]
	             *         Whether to apply animation, and optionally animation
	             *         configuration.
	             *
	             * @sample highcharts/plotoptions/series-point-events-remove/
	             *         Remove point and confirm
	             * @sample highcharts/members/point-remove/
	             *         Remove pie slice
	             * @sample maps/members/point-remove/
	             *         Remove selected points in Highmaps
	             */
	            remove: function(redraw, animation) {
	                this.series.removePoint(inArray(this, this.series.data), redraw, animation);
	            }
	        });
	
	        // Extend the series prototype for dynamic methods
	        extend(Series.prototype, /** @lends Series.prototype */ {
	            /**
	             * Add a point to the series after render time. The point can be added at
	             * the end, or by giving it an X value, to the start or in the middle of the
	             * series.
	             * 
	             * @param  {Number|Array|Object} options
	             *         The point options. If options is a single number, a point with
	             *         that y value is appended to the series.If it is an array, it will
	             *         be interpreted as x and y values respectively. If it is an
	             *         object, advanced options as outlined under `series.data` are
	             *         applied.
	             * @param  {Boolean} [redraw=true]
	             *         Whether to redraw the chart after the point is added. When adding
	             *         more than one point, it is highly recommended that the redraw
	             *         option be set to false, and instead {@link Chart#redraw}
	             *         is explicitly called after the adding of points is finished.
	             *         Otherwise, the chart will redraw after adding each point.
	             * @param  {Boolean} [shift=false]
	             *         If true, a point is shifted off the start of the series as one is
	             *         appended to the end.
	             * @param  {AnimationOptions} [animation]
	             *         Whether to apply animation, and optionally animation
	             *         configuration.
	             *
	             * @sample highcharts/members/series-addpoint-append/
	             *         Append point
	             * @sample highcharts/members/series-addpoint-append-and-shift/
	             *         Append and shift
	             * @sample highcharts/members/series-addpoint-x-and-y/
	             *         Both X and Y values given
	             * @sample highcharts/members/series-addpoint-pie/
	             *         Append pie slice
	             * @sample stock/members/series-addpoint/
	             *         Append 100 points in Highstock
	             * @sample stock/members/series-addpoint-shift/
	             *         Append and shift in Highstock
	             * @sample maps/members/series-addpoint/
	             *         Add a point in Highmaps
	             */
	            addPoint: function(options, redraw, shift, animation) {
	                var series = this,
	                    seriesOptions = series.options,
	                    data = series.data,
	                    chart = series.chart,
	                    xAxis = series.xAxis,
	                    names = xAxis && xAxis.hasNames && xAxis.names,
	                    dataOptions = seriesOptions.data,
	                    point,
	                    isInTheMiddle,
	                    xData = series.xData,
	                    i,
	                    x;
	
	                // Optional redraw, defaults to true
	                redraw = pick(redraw, true);
	
	                // Get options and push the point to xData, yData and series.options. In series.generatePoints
	                // the Point instance will be created on demand and pushed to the series.data array.
	                point = {
	                    series: series
	                };
	                series.pointClass.prototype.applyOptions.apply(point, [options]);
	                x = point.x;
	
	                // Get the insertion point
	                i = xData.length;
	                if (series.requireSorting && x < xData[i - 1]) {
	                    isInTheMiddle = true;
	                    while (i && xData[i - 1] > x) {
	                        i--;
	                    }
	                }
	
	                series.updateParallelArrays(point, 'splice', i, 0, 0); // insert undefined item
	                series.updateParallelArrays(point, i); // update it
	
	                if (names && point.name) {
	                    names[x] = point.name;
	                }
	                dataOptions.splice(i, 0, options);
	
	                if (isInTheMiddle) {
	                    series.data.splice(i, 0, null);
	                    series.processData();
	                }
	
	                // Generate points to be added to the legend (#1329)
	                if (seriesOptions.legendType === 'point') {
	                    series.generatePoints();
	                }
	
	                // Shift the first point off the parallel arrays
	                if (shift) {
	                    if (data[0] && data[0].remove) {
	                        data[0].remove(false);
	                    } else {
	                        data.shift();
	                        series.updateParallelArrays(point, 'shift');
	
	                        dataOptions.shift();
	                    }
	                }
	
	                // redraw
	                series.isDirty = true;
	                series.isDirtyData = true;
	
	                if (redraw) {
	                    chart.redraw(animation); // Animation is set anyway on redraw, #5665
	                }
	            },
	
	            /**
	             * Remove a point from the series. Unlike the {@link Highcharts.Point#remove}
	             * method, this can also be done on a point that is not instanciated because
	             * it is outside the view or subject to Highstock data grouping.
	             *
	             * @param  {Number} i
	             *         The index of the point in the {@link Highcharts.Series.data|data}
	             *         array.
	             * @param  {Boolean} [redraw=true]
	             *         Whether to redraw the chart after the point is added. When 
	             *         removing more than one point, it is highly recommended that the
	             *         `redraw` option be set to `false`, and instead {@link
	             *         Highcharts.Chart#redraw} is explicitly called after the adding of
	             *         points is finished.
	             * @param  {AnimationOptions} [animation]
	             *         Whether and optionally how the series should be animated.
	             *
	             * @sample highcharts/members/series-removepoint/
	             *         Remove cropped point
	             */
	            removePoint: function(i, redraw, animation) {
	
	                var series = this,
	                    data = series.data,
	                    point = data[i],
	                    points = series.points,
	                    chart = series.chart,
	                    remove = function() {
	
	                        if (points && points.length === data.length) { // #4935
	                            points.splice(i, 1);
	                        }
	                        data.splice(i, 1);
	                        series.options.data.splice(i, 1);
	                        series.updateParallelArrays(point || {
	                            series: series
	                        }, 'splice', i, 1);
	
	                        if (point) {
	                            point.destroy();
	                        }
	
	                        // redraw
	                        series.isDirty = true;
	                        series.isDirtyData = true;
	                        if (redraw) {
	                            chart.redraw();
	                        }
	                    };
	
	                setAnimation(animation, chart);
	                redraw = pick(redraw, true);
	
	                // Fire the event with a default handler of removing the point
	                if (point) {
	                    point.firePointEvent('remove', null, remove);
	                } else {
	                    remove();
	                }
	            },
	
	            /**
	             * Remove a series and optionally redraw the chart.
	             *
	             * @param  {Boolean} [redraw=true]
	             *         Whether to redraw the chart or wait for an explicit call to
	             *         {@link Highcharts.Chart#redraw}.
	             * @param  {AnimationOptions} [animation]
	             *         Whether to apply animation, and optionally animation
	             *         configuration
	             * @param  {Boolean} [withEvent=true]
	             *         Used internally, whether to fire the series `remove` event.
	             *
	             * @sample highcharts/members/series-remove/
	             *         Remove first series from a button
	             */
	            remove: function(redraw, animation, withEvent) {
	                var series = this,
	                    chart = series.chart;
	
	                function remove() {
	
	                    // Destroy elements
	                    series.destroy();
	
	                    // Redraw
	                    chart.isDirtyLegend = chart.isDirtyBox = true;
	                    chart.linkSeries();
	
	                    if (pick(redraw, true)) {
	                        chart.redraw(animation);
	                    }
	                }
	
	                // Fire the event with a default handler of removing the point
	                if (withEvent !== false) {
	                    fireEvent(series, 'remove', null, remove);
	                } else {
	                    remove();
	                }
	            },
	
	            /**
	             * Update the series with a new set of options. For a clean and precise
	             * handling of new options, all methods and elements from the series are
	             * removed, and it is initiated from scratch. Therefore, this method is more
	             * performance expensive than some other utility methods like {@link
	             * Series#setData} or {@link Series#setVisible}.
	             *
	             * @param  {SeriesOptions} options
	             *         New options that will be merged with the series' existing
	             *         options.
	             * @param  {Boolean} [redraw=true]
	             *         Whether to redraw the chart after the series is altered. If doing
	             *         more operations on the chart, it is a good idea to set redraw to
	             *         false and call {@link Chart#redraw} after.
	             *
	             * @sample highcharts/members/series-update/
	             *         Updating series options
	             * @sample maps/members/series-update/
	             *         Update series options in Highmaps
	             */
	            update: function(newOptions, redraw) {
	                var series = this,
	                    chart = series.chart,
	                    // must use user options when changing type because series.options
	                    // is merged in with type specific plotOptions
	                    oldOptions = series.userOptions,
	                    oldType = series.oldType || series.type,
	                    newType = newOptions.type || oldOptions.type || chart.options.chart.type,
	                    proto = seriesTypes[oldType].prototype,
	                    n,
	                    preserve = [
	                        'group',
	                        'markerGroup',
	                        'dataLabelsGroup',
	                        'navigatorSeries',
	                        'baseSeries'
	                    ],
	
	                    // Animation must be enabled when calling update before the initial
	                    // animation has first run. This happens when calling update
	                    // directly after chart initialization, or when applying responsive
	                    // rules (#6912).
	                    animation = series.finishedAnimating && {
	                        animation: false
	                    };
	
	                // Running Series.update to update the data only is an intuitive usage,
	                // so we want to make sure that when used like this, we run the
	                // cheaper setData function and allow animation instead of completely
	                // recreating the series instance.
	                if (Object.keys && Object.keys(newOptions).toString() === 'data') {
	                    return this.setData(newOptions.data, redraw);
	                }
	
	                // If we're changing type or zIndex, create new groups (#3380, #3404)
	                if ((newType && newType !== oldType) || newOptions.zIndex !== undefined) {
	                    preserve.length = 0;
	                }
	
	                // Make sure groups are not destroyed (#3094)
	                each(preserve, function(prop) {
	                    preserve[prop] = series[prop];
	                    delete series[prop];
	                });
	
	                // Do the merge, with some forced options
	                newOptions = merge(oldOptions, animation, {
	                    index: series.index,
	                    pointStart: series.xData[0] // when updating after addPoint
	                }, {
	                    data: series.options.data
	                }, newOptions);
	
	                // Destroy the series and delete all properties. Reinsert all methods
	                // and properties from the new type prototype (#2270, #3719)
	                series.remove(false, null, false);
	                for (n in proto) {
	                    series[n] = undefined;
	                }
	                extend(series, seriesTypes[newType || oldType].prototype);
	
	                // Re-register groups (#3094) and other preserved properties
	                each(preserve, function(prop) {
	                    series[prop] = preserve[prop];
	                });
	
	                series.init(chart, newOptions);
	                series.oldType = oldType;
	                chart.linkSeries(); // Links are lost in series.remove (#3028)
	                if (pick(redraw, true)) {
	                    chart.redraw(false);
	                }
	            }
	        });
	
	        // Extend the Axis.prototype for dynamic methods
	        extend(Axis.prototype, /** @lends Highcharts.Axis.prototype */ {
	
	            /**
	             * Update an axis object with a new set of options. The options are merged
	             * with the existing options, so only new or altered options need to be
	             * specified.
	             *
	             * @param  {Object} options
	             *         The new options that will be merged in with existing options on
	             *         the axis.
	             * @sample highcharts/members/axis-update/ Axis update demo
	             */
	            update: function(options, redraw) {
	                var chart = this.chart;
	
	                options = chart.options[this.coll][this.options.index] =
	                    merge(this.userOptions, options);
	
	                this.destroy(true);
	
	                this.init(chart, extend(options, {
	                    events: undefined
	                }));
	
	                chart.isDirtyBox = true;
	                if (pick(redraw, true)) {
	                    chart.redraw();
	                }
	            },
	
	            /**
	             * Remove the axis from the chart.
	             *
	             * @param {Boolean} [redraw=true] Whether to redraw the chart following the
	             * remove.
	             *
	             * @sample highcharts/members/chart-addaxis/ Add and remove axes
	             */
	            remove: function(redraw) {
	                var chart = this.chart,
	                    key = this.coll, // xAxis or yAxis
	                    axisSeries = this.series,
	                    i = axisSeries.length;
	
	                // Remove associated series (#2687)
	                while (i--) {
	                    if (axisSeries[i]) {
	                        axisSeries[i].remove(false);
	                    }
	                }
	
	                // Remove the axis
	                erase(chart.axes, this);
	                erase(chart[key], this);
	
	                if (isArray(chart.options[key])) {
	                    chart.options[key].splice(this.options.index, 1);
	                } else { // color axis, #6488
	                    delete chart.options[key];
	                }
	
	                each(chart[key], function(axis, i) { // Re-index, #1706
	                    axis.options.index = i;
	                });
	                this.destroy();
	                chart.isDirtyBox = true;
	
	                if (pick(redraw, true)) {
	                    chart.redraw();
	                }
	            },
	
	            /**
	             * Update the axis title by options after render time.
	             *
	             * @param  {TitleOptions} titleOptions
	             *         The additional title options.
	             * @param  {Boolean} [redraw=true]
	             *         Whether to redraw the chart after setting the title.
	             * @sample highcharts/members/axis-settitle/ Set a new Y axis title
	             */
	            setTitle: function(titleOptions, redraw) {
	                this.update({
	                    title: titleOptions
	                }, redraw);
	            },
	
	            /**
	             * Set new axis categories and optionally redraw.
	             * @param {Array.<String>} categories - The new categories.
	             * @param {Boolean} [redraw=true] - Whether to redraw the chart.
	             * @sample highcharts/members/axis-setcategories/ Set categories by click on
	             * a button
	             */
	            setCategories: function(categories, redraw) {
	                this.update({
	                    categories: categories
	                }, redraw);
	            }
	
	        });
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var color = H.color,
	            each = H.each,
	            LegendSymbolMixin = H.LegendSymbolMixin,
	            map = H.map,
	            pick = H.pick,
	            Series = H.Series,
	            seriesType = H.seriesType;
	
	        /**
	         * Area series type.
	         * @constructor seriesTypes.area
	         * @extends {Series}
	         */
	        /**
	         * @extends {plotOptions.line}
	         * @optionparent plotOptions.area
	         */
	        seriesType('area', 'line', {
	
	            /**
	             * When this is true, the series will not cause the Y axis to cross
	             * the zero plane (or [threshold](#plotOptions.series.threshold) option)
	             * unless the data actually crosses the plane.
	             * 
	             * For example, if `softThreshold` is `false`, a series of 0, 1, 2,
	             * 3 will make the Y axis show negative values according to the `minPadding`
	             * option. If `softThreshold` is `true`, the Y axis starts at 0.
	             * 
	             * @type {Boolean}
	             * @default false
	             * @since 4.1.9
	             * @product highcharts highstock
	             */
	            softThreshold: false,
	
	            /**
	             * The Y axis value to serve as the base for the area, for distinguishing
	             * between values above and below a threshold. If `null`, the area
	             * behaves like a line series with fill between the graph and the Y
	             * axis minimum.
	             * 
	             * @type {Number}
	             * @sample {highcharts} highcharts/plotoptions/area-threshold/ A threshold of 100
	             * @default 0
	             * @since 2.0
	             * @product highcharts highstock
	             */
	            threshold: 0
	            // trackByArea: false,
	            // lineColor: null, // overrides color, but lets fillColor be unaltered
	            // fillOpacity: 0.75,
	            // fillColor: null
	        }, /** @lends seriesTypes.area.prototype */ {
	            singleStacks: false,
	            /** 
	             * Return an array of stacked points, where null and missing points are replaced by 
	             * dummy points in order for gaps to be drawn correctly in stacks.
	             */
	            getStackPoints: function(points) {
	                var series = this,
	                    segment = [],
	                    keys = [],
	                    xAxis = this.xAxis,
	                    yAxis = this.yAxis,
	                    stack = yAxis.stacks[this.stackKey],
	                    pointMap = {},
	                    seriesIndex = series.index,
	                    yAxisSeries = yAxis.series,
	                    seriesLength = yAxisSeries.length,
	                    visibleSeries,
	                    upOrDown = pick(yAxis.options.reversedStacks, true) ? 1 : -1,
	                    i;
	
	
	                points = points || this.points;
	
	                if (this.options.stacking) {
	                    // Create a map where we can quickly look up the points by their X value.
	                    for (i = 0; i < points.length; i++) {
	                        pointMap[points[i].x] = points[i];
	                    }
	
	                    // Sort the keys (#1651)
	                    H.objectEach(stack, function(stackX, x) {
	                        if (stackX.total !== null) { // nulled after switching between grouping and not (#1651, #2336)
	                            keys.push(x);
	                        }
	                    });
	                    keys.sort(function(a, b) {
	                        return a - b;
	                    });
	
	                    visibleSeries = map(yAxisSeries, function() {
	                        return this.visible;
	                    });
	
	                    each(keys, function(x, idx) {
	                        var y = 0,
	                            stackPoint,
	                            stackedValues;
	
	                        if (pointMap[x] && !pointMap[x].isNull) {
	                            segment.push(pointMap[x]);
	
	                            // Find left and right cliff. -1 goes left, 1 goes right.
	                            each([-1, 1], function(direction) {
	                                var nullName = direction === 1 ? 'rightNull' : 'leftNull',
	                                    cliffName = direction === 1 ? 'rightCliff' : 'leftCliff',
	                                    cliff = 0,
	                                    otherStack = stack[keys[idx + direction]];
	
	                                // If there is a stack next to this one, to the left or to the right...
	                                if (otherStack) {
	                                    i = seriesIndex;
	                                    while (i >= 0 && i < seriesLength) { // Can go either up or down, depending on reversedStacks
	                                        stackPoint = otherStack.points[i];
	                                        if (!stackPoint) {
	                                            // If the next point in this series is missing, mark the point
	                                            // with point.leftNull or point.rightNull = true.
	                                            if (i === seriesIndex) {
	                                                pointMap[x][nullName] = true;
	
	                                                // If there are missing points in the next stack in any of the 
	                                                // series below this one, we need to substract the missing values
	                                                // and add a hiatus to the left or right.
	                                            } else if (visibleSeries[i]) {
	                                                stackedValues = stack[x].points[i];
	                                                if (stackedValues) {
	                                                    cliff -= stackedValues[1] - stackedValues[0];
	                                                }
	                                            }
	                                        }
	                                        // When reversedStacks is true, loop up, else loop down
	                                        i += upOrDown;
	                                    }
	                                }
	                                pointMap[x][cliffName] = cliff;
	                            });
	
	
	                            // There is no point for this X value in this series, so we 
	                            // insert a dummy point in order for the areas to be drawn
	                            // correctly.
	                        } else {
	
	                            // Loop down the stack to find the series below this one that has
	                            // a value (#1991)
	                            i = seriesIndex;
	                            while (i >= 0 && i < seriesLength) {
	                                stackPoint = stack[x].points[i];
	                                if (stackPoint) {
	                                    y = stackPoint[1];
	                                    break;
	                                }
	                                // When reversedStacks is true, loop up, else loop down
	                                i += upOrDown;
	                            }
	                            y = yAxis.translate(y, 0, 1, 0, 1); // #6272
	                            segment.push({
	                                isNull: true,
	                                plotX: xAxis.translate(x, 0, 0, 0, 1), // #6272
	                                x: x,
	                                plotY: y,
	                                yBottom: y
	                            });
	                        }
	                    });
	
	                }
	
	                return segment;
	            },
	
	            getGraphPath: function(points) {
	                var getGraphPath = Series.prototype.getGraphPath,
	                    graphPath,
	                    options = this.options,
	                    stacking = options.stacking,
	                    yAxis = this.yAxis,
	                    topPath,
	                    //topPoints = [],
	                    bottomPath,
	                    bottomPoints = [],
	                    graphPoints = [],
	                    seriesIndex = this.index,
	                    i,
	                    areaPath,
	                    plotX,
	                    stacks = yAxis.stacks[this.stackKey],
	                    threshold = options.threshold,
	                    translatedThreshold = yAxis.getThreshold(options.threshold),
	                    isNull,
	                    yBottom,
	                    connectNulls = options.connectNulls || stacking === 'percent',
	                    /**
	                     * To display null points in underlying stacked series, this series graph must be 
	                     * broken, and the area also fall down to fill the gap left by the null point. #2069
	                     */
	                    addDummyPoints = function(i, otherI, side) {
	                        var point = points[i],
	                            stackedValues = stacking && stacks[point.x].points[seriesIndex],
	                            nullVal = point[side + 'Null'] || 0,
	                            cliffVal = point[side + 'Cliff'] || 0,
	                            top,
	                            bottom,
	                            isNull = true;
	
	                        if (cliffVal || nullVal) {
	
	                            top = (nullVal ? stackedValues[0] : stackedValues[1]) + cliffVal;
	                            bottom = stackedValues[0] + cliffVal;
	                            isNull = !!nullVal;
	
	                        } else if (!stacking && points[otherI] && points[otherI].isNull) {
	                            top = bottom = threshold;
	                        }
	
	                        // Add to the top and bottom line of the area
	                        if (top !== undefined) {
	                            graphPoints.push({
	                                plotX: plotX,
	                                plotY: top === null ? translatedThreshold : yAxis.getThreshold(top),
	                                isNull: isNull,
	                                isCliff: true
	                            });
	                            bottomPoints.push({
	                                plotX: plotX,
	                                plotY: bottom === null ? translatedThreshold : yAxis.getThreshold(bottom),
	                                doCurve: false // #1041, gaps in areaspline areas
	                            });
	                        }
	                    };
	
	                // Find what points to use
	                points = points || this.points;
	
	                // Fill in missing points
	                if (stacking) {
	                    points = this.getStackPoints(points);
	                }
	
	                for (i = 0; i < points.length; i++) {
	                    isNull = points[i].isNull;
	                    plotX = pick(points[i].rectPlotX, points[i].plotX);
	                    yBottom = pick(points[i].yBottom, translatedThreshold);
	
	                    if (!isNull || connectNulls) {
	
	                        if (!connectNulls) {
	                            addDummyPoints(i, i - 1, 'left');
	                        }
	
	                        if (!(isNull && !stacking && connectNulls)) { // Skip null point when stacking is false and connectNulls true
	                            graphPoints.push(points[i]);
	                            bottomPoints.push({
	                                x: i,
	                                plotX: plotX,
	                                plotY: yBottom
	                            });
	                        }
	
	                        if (!connectNulls) {
	                            addDummyPoints(i, i + 1, 'right');
	                        }
	                    }
	                }
	
	                topPath = getGraphPath.call(this, graphPoints, true, true);
	
	                bottomPoints.reversed = true;
	                bottomPath = getGraphPath.call(this, bottomPoints, true, true);
	                if (bottomPath.length) {
	                    bottomPath[0] = 'L';
	                }
	
	                areaPath = topPath.concat(bottomPath);
	                graphPath = getGraphPath.call(this, graphPoints, false, connectNulls); // TODO: don't set leftCliff and rightCliff when connectNulls?
	
	                areaPath.xMap = topPath.xMap;
	                this.areaPath = areaPath;
	
	                return graphPath;
	            },
	
	            /**
	             * Draw the graph and the underlying area. This method calls the Series base
	             * function and adds the area. The areaPath is calculated in the getSegmentPath
	             * method called from Series.prototype.drawGraph.
	             */
	            drawGraph: function() {
	
	                // Define or reset areaPath
	                this.areaPath = [];
	
	                // Call the base method
	                Series.prototype.drawGraph.apply(this);
	
	                // Define local variables
	                var series = this,
	                    areaPath = this.areaPath,
	                    options = this.options,
	                    zones = this.zones,
	                    props = [
	                        [
	                            'area',
	                            'highcharts-area',
	
	                            this.color,
	                            options.fillColor
	
	                        ]
	                    ]; // area name, main color, fill color
	
	                each(zones, function(zone, i) {
	                    props.push([
	                        'zone-area-' + i,
	                        'highcharts-area highcharts-zone-area-' + i + ' ' + zone.className,
	
	                        zone.color || series.color,
	                        zone.fillColor || options.fillColor
	
	                    ]);
	                });
	
	                each(props, function(prop) {
	                    var areaKey = prop[0],
	                        area = series[areaKey];
	
	                    // Create or update the area
	                    if (area) { // update
	                        area.endX = areaPath.xMap;
	                        area.animate({
	                            d: areaPath
	                        });
	
	                    } else { // create
	                        area = series[areaKey] = series.chart.renderer.path(areaPath)
	                            .addClass(prop[1])
	                            .attr({
	
	                                fill: pick(
	                                    prop[3],
	                                    color(prop[2]).setOpacity(pick(options.fillOpacity, 0.75)).get()
	                                ),
	
	                                zIndex: 0 // #1069
	                            }).add(series.group);
	                        area.isArea = true;
	                    }
	                    area.startX = areaPath.xMap;
	                    area.shiftUnit = options.step ? 2 : 1;
	                });
	            },
	
	            drawLegendSymbol: LegendSymbolMixin.drawRectangle
	        });
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var pick = H.pick,
	            seriesType = H.seriesType;
	
	        /**
	         * Spline series type.
	         * @constructor seriesTypes.spline
	         * @extends {Series}
	         */
	        seriesType('spline', 'line', {}, /** @lends seriesTypes.spline.prototype */ {
	            /**
	             * Get the spline segment from a given point's previous neighbour to the given point
	             */
	            getPointSpline: function(points, point, i) {
	                var smoothing = 1.5, // 1 means control points midway between points, 2 means 1/3 from the point, 3 is 1/4 etc
	                    denom = smoothing + 1,
	                    plotX = point.plotX,
	                    plotY = point.plotY,
	                    lastPoint = points[i - 1],
	                    nextPoint = points[i + 1],
	                    leftContX,
	                    leftContY,
	                    rightContX,
	                    rightContY,
	                    ret;
	
	                function doCurve(otherPoint) {
	                    return otherPoint &&
	                        !otherPoint.isNull &&
	                        otherPoint.doCurve !== false &&
	                        !point.isCliff; // #6387, area splines next to null
	                }
	
	                // Find control points
	                if (doCurve(lastPoint) && doCurve(nextPoint)) {
	                    var lastX = lastPoint.plotX,
	                        lastY = lastPoint.plotY,
	                        nextX = nextPoint.plotX,
	                        nextY = nextPoint.plotY,
	                        correction = 0;
	
	                    leftContX = (smoothing * plotX + lastX) / denom;
	                    leftContY = (smoothing * plotY + lastY) / denom;
	                    rightContX = (smoothing * plotX + nextX) / denom;
	                    rightContY = (smoothing * plotY + nextY) / denom;
	
	                    // Have the two control points make a straight line through main point
	                    if (rightContX !== leftContX) { // #5016, division by zero
	                        correction = ((rightContY - leftContY) * (rightContX - plotX)) /
	                            (rightContX - leftContX) + plotY - rightContY;
	                    }
	
	                    leftContY += correction;
	                    rightContY += correction;
	
	                    // to prevent false extremes, check that control points are between
	                    // neighbouring points' y values
	                    if (leftContY > lastY && leftContY > plotY) {
	                        leftContY = Math.max(lastY, plotY);
	                        rightContY = 2 * plotY - leftContY; // mirror of left control point
	                    } else if (leftContY < lastY && leftContY < plotY) {
	                        leftContY = Math.min(lastY, plotY);
	                        rightContY = 2 * plotY - leftContY;
	                    }
	                    if (rightContY > nextY && rightContY > plotY) {
	                        rightContY = Math.max(nextY, plotY);
	                        leftContY = 2 * plotY - rightContY;
	                    } else if (rightContY < nextY && rightContY < plotY) {
	                        rightContY = Math.min(nextY, plotY);
	                        leftContY = 2 * plotY - rightContY;
	                    }
	
	                    // record for drawing in next point
	                    point.rightContX = rightContX;
	                    point.rightContY = rightContY;
	
	
	                }
	
	                // Visualize control points for debugging
	                /*
	                if (leftContX) {
	                	this.chart.renderer.circle(leftContX + this.chart.plotLeft, leftContY + this.chart.plotTop, 2)
	                		.attr({
	                			stroke: 'red',
	                			'stroke-width': 2,
	                			fill: 'none',
	                			zIndex: 9
	                		})
	                		.add();
	                	this.chart.renderer.path(['M', leftContX + this.chart.plotLeft, leftContY + this.chart.plotTop,
	                		'L', plotX + this.chart.plotLeft, plotY + this.chart.plotTop])
	                		.attr({
	                			stroke: 'red',
	                			'stroke-width': 2,
	                			zIndex: 9
	                		})
	                		.add();
	                }
	                if (rightContX) {
	                	this.chart.renderer.circle(rightContX + this.chart.plotLeft, rightContY + this.chart.plotTop, 2)
	                		.attr({
	                			stroke: 'green',
	                			'stroke-width': 2,
	                			fill: 'none',
	                			zIndex: 9
	                		})
	                		.add();
	                	this.chart.renderer.path(['M', rightContX + this.chart.plotLeft, rightContY + this.chart.plotTop,
	                		'L', plotX + this.chart.plotLeft, plotY + this.chart.plotTop])
	                		.attr({
	                			stroke: 'green',
	                			'stroke-width': 2,
	                			zIndex: 9
	                		})
	                		.add();
	                }
	                // */
	                ret = [
	                    'C',
	                    pick(lastPoint.rightContX, lastPoint.plotX),
	                    pick(lastPoint.rightContY, lastPoint.plotY),
	                    pick(leftContX, plotX),
	                    pick(leftContY, plotY),
	                    plotX,
	                    plotY
	                ];
	                lastPoint.rightContX = lastPoint.rightContY = null; // reset for updating series later
	                return ret;
	            }
	        });
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var areaProto = H.seriesTypes.area.prototype,
	            defaultPlotOptions = H.defaultPlotOptions,
	            LegendSymbolMixin = H.LegendSymbolMixin,
	            seriesType = H.seriesType;
	        /**
	         * AreaSplineSeries object
	         */
	        seriesType('areaspline', 'spline', defaultPlotOptions.area, {
	            getStackPoints: areaProto.getStackPoints,
	            getGraphPath: areaProto.getGraphPath,
	            drawGraph: areaProto.drawGraph,
	            drawLegendSymbol: LegendSymbolMixin.drawRectangle
	        });
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var animObject = H.animObject,
	            color = H.color,
	            each = H.each,
	            extend = H.extend,
	            isNumber = H.isNumber,
	            LegendSymbolMixin = H.LegendSymbolMixin,
	            merge = H.merge,
	            noop = H.noop,
	            pick = H.pick,
	            Series = H.Series,
	            seriesType = H.seriesType,
	            svg = H.svg;
	        /**
	         * The column series type.
	         *
	         * @constructor seriesTypes.column
	         * @augments Series
	         */
	
	        /**
	         * @extends {plotOptions.line}
	         * @optionparent plotOptions.column
	         * @excluding connectNulls,dashStyle,linecap,lineWidth,marker,connectEnds,step
	         */
	        seriesType('column', 'line', {
	
	            /**
	             * The corner radius of the border surrounding each column or bar.
	             * 
	             * @type {Number}
	             * @sample {highcharts} highcharts/plotoptions/column-borderradius/ Rounded columns
	             * @default 0
	             * @product highcharts highstock
	             */
	            borderRadius: 0,
	            //colorByPoint: undefined,
	
	            /**
	             * When true, each column edge is rounded to its nearest pixel in order
	             * to render sharp on screen. In some cases, when there are a lot of
	             * densely packed columns, this leads to visible difference in column
	             * widths or distance between columns. In these cases, setting `crisp`
	             * to `false` may look better, even though each column is rendered
	             * blurry.
	             * 
	             * @type {Boolean}
	             * @sample {highcharts} highcharts/plotoptions/column-crisp-false/ Crisp is false
	             * @default true
	             * @since 5.0.10
	             * @product highcharts highstock
	             */
	            crisp: true,
	
	            /**
	             * Padding between each value groups, in x axis units.
	             * 
	             * @type {Number}
	             * @sample {highcharts} highcharts/plotoptions/column-grouppadding-default/ 0.2 by default
	             * @sample {highcharts} highcharts/plotoptions/column-grouppadding-none/ No group padding - all     columns are evenly spaced
	             * @default 0.2
	             * @product highcharts highstock
	             */
	            groupPadding: 0.2,
	            //grouping: true,
	
	            /**
	             */
	            marker: null, // point options are specified in the base options
	
	            /**
	             * Padding between each column or bar, in x axis units.
	             * 
	             * @type {Number}
	             * @sample {highcharts} highcharts/plotoptions/column-pointpadding-default/ 0.1 by default
	             * @sample {highcharts} highcharts/plotoptions/column-pointpadding-025/ 0.25
	             * @sample {highcharts} highcharts/plotoptions/column-pointpadding-none/ 0 for tightly packed columns
	             * @default 0.1
	             * @product highcharts highstock
	             */
	            pointPadding: 0.1,
	            //pointWidth: null,
	
	            /**
	             * The minimal height for a column or width for a bar. By default,
	             * 0 values are not shown. To visualize a 0 (or close to zero) point,
	             * set the minimal point length to a pixel value like 3\. In stacked
	             * column charts, minPointLength might not be respected for tightly
	             * packed values.
	             * 
	             * @type {Number}
	             * @sample {highcharts} highcharts/plotoptions/column-minpointlength/ Zero base value
	             * @sample {highcharts} highcharts/plotoptions/column-minpointlength-pos-and-neg/ Positive and negative close to zero values
	             * @default 0
	             * @product highcharts highstock
	             */
	            minPointLength: 0,
	
	            /**
	             * When the series contains less points than the crop threshold, all
	             * points are drawn, event if the points fall outside the visible plot
	             * area at the current zoom. The advantage of drawing all points (including
	             * markers and columns), is that animation is performed on updates.
	             * On the other hand, when the series contains more points than the
	             * crop threshold, the series data is cropped to only contain points
	             * that fall within the plot area. The advantage of cropping away invisible
	             * points is to increase performance on large series. .
	             * 
	             * @type {Number}
	             * @default 50
	             * @product highcharts highstock
	             */
	            cropThreshold: 50,
	
	            /**
	             * The X axis range that each point is valid for. This determines the
	             * width of the column. On a categorized axis, the range will be 1
	             * by default (one category unit). On linear and datetime axes, the
	             * range will be computed as the distance between the two closest data
	             * points.
	             *
	             * The default `null` means it is computed automatically, but this option
	             * can be used to override the automatic value.
	             * 
	             * @type {Number}
	             * @sample {highcharts} highcharts/plotoptions/column-pointrange/
	             *         Set the point range to one day on a data set with one week
	             *         between the points
	             * @default null
	             * @since 2.3
	             * @product highcharts highstock
	             */
	            pointRange: null,
	
	            /**
	             */
	            states: {
	
	                /**
	                 * @extends plotOptions.series.states.hover
	                 * @excluding lineWidth,lineWidthPlus,marker
	                 * @product highcharts highstock
	                 */
	                hover: {
	
	                    /**
	                     */
	                    halo: false,
	
	
	                    /**
	                     * How much to brighten the point on interaction. Requires the main
	                     * color to be defined in hex or rgb(a) format.
	                     * 
	                     * In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                     * style/style-by-css), the hover brightening is by default replaced
	                     * with a fill-opacity set in the `.highcharts-point:hover` rule.
	                     * 
	                     * @type {Number}
	                     * @sample {highcharts} highcharts/plotoptions/column-states-hover-brightness/ Brighten by 0.5
	                     * @default 0.1
	                     * @product highcharts highstock
	                     */
	                    brightness: 0.1,
	
	                    /**
	                     */
	                    shadow: false
	
	                },
	
	
	                /**
	                 */
	                select: {
	
	                    /**
	                     */
	                    color: '#cccccc',
	
	                    /**
	                     */
	                    borderColor: '#000000',
	
	                    /**
	                     */
	                    shadow: false
	                }
	
	            },
	
	            /**
	             */
	            dataLabels: {
	
	                /**
	                 */
	                align: null, // auto
	
	                /**
	                 */
	                verticalAlign: null, // auto
	
	                /**
	                 */
	                y: null
	            },
	
	            /**
	             * When this is true, the series will not cause the Y axis to cross
	             * the zero plane (or [threshold](#plotOptions.series.threshold) option)
	             * unless the data actually crosses the plane.
	             * 
	             * For example, if `softThreshold` is `false`, a series of 0, 1, 2,
	             * 3 will make the Y axis show negative values according to the `minPadding`
	             * option. If `softThreshold` is `true`, the Y axis starts at 0.
	             * 
	             * @type {Boolean}
	             * @default {highcharts} true
	             * @default {highstock} false
	             * @since 4.1.9
	             * @product highcharts highstock
	             */
	            softThreshold: false,
	
	            /**
	             */
	            startFromThreshold: true, // false doesn't work well: http://jsfiddle.net/highcharts/hz8fopan/14/
	
	            /**
	             */
	            stickyTracking: false,
	
	            /**
	             */
	            tooltip: {
	
	                /**
	                 */
	                distance: 6
	            },
	
	            /**
	             * The Y axis value to serve as the base for the columns, for distinguishing
	             * between values above and below a threshold. If `null`, the columns
	             * extend from the padding Y axis minimum.
	             * 
	             * @type {Number}
	             * @default 0
	             * @since 2.0
	             * @product highcharts
	             */
	            threshold: 0,
	
	
	            /**
	             * The color of the border surrounding each column or bar.
	             * 
	             * In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	             * style/style-by-css), the border stroke can be set with the `.highcharts-
	             * point` rule.
	             * 
	             * @type {Color}
	             * @sample {highcharts} highcharts/plotoptions/column-bordercolor/ Dark gray border
	             * @default #ffffff
	             * @product highcharts highstock
	             */
	            borderColor: '#ffffff'
	            // borderWidth: 1
	
	
	        }, /** @lends seriesTypes.column.prototype */ {
	            cropShoulder: 0,
	            directTouch: true, // When tooltip is not shared, this series (and derivatives) requires direct touch/hover. KD-tree does not apply.
	            trackerGroups: ['group', 'dataLabelsGroup'],
	            negStacks: true, // use separate negative stacks, unlike area stacks where a negative
	            // point is substracted from previous (#1910)
	
	            /**
	             * Initialize the series. Extends the basic Series.init method by
	             * marking other series of the same type as dirty.
	             *
	             * @function #init
	             * @memberOf seriesTypes.column
	             * 
	             */
	            init: function() {
	                Series.prototype.init.apply(this, arguments);
	
	                var series = this,
	                    chart = series.chart;
	
	                // if the series is added dynamically, force redraw of other
	                // series affected by a new column
	                if (chart.hasRendered) {
	                    each(chart.series, function(otherSeries) {
	                        if (otherSeries.type === series.type) {
	                            otherSeries.isDirty = true;
	                        }
	                    });
	                }
	            },
	
	            /**
	             * Return the width and x offset of the columns adjusted for grouping, groupPadding, pointPadding,
	             * pointWidth etc.
	             */
	            getColumnMetrics: function() {
	
	                var series = this,
	                    options = series.options,
	                    xAxis = series.xAxis,
	                    yAxis = series.yAxis,
	                    reversedXAxis = xAxis.reversed,
	                    stackKey,
	                    stackGroups = {},
	                    columnCount = 0;
	
	                // Get the total number of column type series.
	                // This is called on every series. Consider moving this logic to a
	                // chart.orderStacks() function and call it on init, addSeries and removeSeries
	                if (options.grouping === false) {
	                    columnCount = 1;
	                } else {
	                    each(series.chart.series, function(otherSeries) {
	                        var otherOptions = otherSeries.options,
	                            otherYAxis = otherSeries.yAxis,
	                            columnIndex;
	                        if (
	                            otherSeries.type === series.type &&
	                            (
	                                otherSeries.visible ||
	                                !series.chart.options.chart.ignoreHiddenSeries
	                            ) &&
	                            yAxis.len === otherYAxis.len &&
	                            yAxis.pos === otherYAxis.pos
	                        ) { // #642, #2086
	                            if (otherOptions.stacking) {
	                                stackKey = otherSeries.stackKey;
	                                if (stackGroups[stackKey] === undefined) {
	                                    stackGroups[stackKey] = columnCount++;
	                                }
	                                columnIndex = stackGroups[stackKey];
	                            } else if (otherOptions.grouping !== false) { // #1162
	                                columnIndex = columnCount++;
	                            }
	                            otherSeries.columnIndex = columnIndex;
	                        }
	                    });
	                }
	
	                var categoryWidth = Math.min(
	                        Math.abs(xAxis.transA) * (xAxis.ordinalSlope || options.pointRange || xAxis.closestPointRange || xAxis.tickInterval || 1), // #2610
	                        xAxis.len // #1535
	                    ),
	                    groupPadding = categoryWidth * options.groupPadding,
	                    groupWidth = categoryWidth - 2 * groupPadding,
	                    pointOffsetWidth = groupWidth / (columnCount || 1),
	                    pointWidth = Math.min(
	                        options.maxPointWidth || xAxis.len,
	                        pick(options.pointWidth, pointOffsetWidth * (1 - 2 * options.pointPadding))
	                    ),
	                    pointPadding = (pointOffsetWidth - pointWidth) / 2,
	                    colIndex = (series.columnIndex || 0) + (reversedXAxis ? 1 : 0), // #1251, #3737
	                    pointXOffset = pointPadding + (groupPadding + colIndex *
	                        pointOffsetWidth - (categoryWidth / 2)) *
	                    (reversedXAxis ? -1 : 1);
	
	                // Save it for reading in linked series (Error bars particularly)
	                series.columnMetrics = {
	                    width: pointWidth,
	                    offset: pointXOffset
	                };
	                return series.columnMetrics;
	
	            },
	
	            /**
	             * Make the columns crisp. The edges are rounded to the nearest full pixel.
	             */
	            crispCol: function(x, y, w, h) {
	                var chart = this.chart,
	                    borderWidth = this.borderWidth,
	                    xCrisp = -(borderWidth % 2 ? 0.5 : 0),
	                    yCrisp = borderWidth % 2 ? 0.5 : 1,
	                    right,
	                    bottom,
	                    fromTop;
	
	                if (chart.inverted && chart.renderer.isVML) {
	                    yCrisp += 1;
	                }
	
	                // Horizontal. We need to first compute the exact right edge, then round it
	                // and compute the width from there.
	                if (this.options.crisp) {
	                    right = Math.round(x + w) + xCrisp;
	                    x = Math.round(x) + xCrisp;
	                    w = right - x;
	                }
	
	                // Vertical
	                bottom = Math.round(y + h) + yCrisp;
	                fromTop = Math.abs(y) <= 0.5 && bottom > 0.5; // #4504, #4656
	                y = Math.round(y) + yCrisp;
	                h = bottom - y;
	
	                // Top edges are exceptions
	                if (fromTop && h) { // #5146
	                    y -= 1;
	                    h += 1;
	                }
	
	                return {
	                    x: x,
	                    y: y,
	                    width: w,
	                    height: h
	                };
	            },
	
	            /**
	             * Translate each point to the plot area coordinate system and find shape positions
	             */
	            translate: function() {
	                var series = this,
	                    chart = series.chart,
	                    options = series.options,
	                    dense = series.dense = series.closestPointRange * series.xAxis.transA < 2,
	                    borderWidth = series.borderWidth = pick(
	                        options.borderWidth,
	                        dense ? 0 : 1 // #3635
	                    ),
	                    yAxis = series.yAxis,
	                    threshold = options.threshold,
	                    translatedThreshold = series.translatedThreshold = yAxis.getThreshold(threshold),
	                    minPointLength = pick(options.minPointLength, 5),
	                    metrics = series.getColumnMetrics(),
	                    pointWidth = metrics.width,
	                    seriesBarW = series.barW = Math.max(pointWidth, 1 + 2 * borderWidth), // postprocessed for border width
	                    pointXOffset = series.pointXOffset = metrics.offset;
	
	                if (chart.inverted) {
	                    translatedThreshold -= 0.5; // #3355
	                }
	
	                // When the pointPadding is 0, we want the columns to be packed tightly, so we allow individual
	                // columns to have individual sizes. When pointPadding is greater, we strive for equal-width
	                // columns (#2694).
	                if (options.pointPadding) {
	                    seriesBarW = Math.ceil(seriesBarW);
	                }
	
	                Series.prototype.translate.apply(series);
	
	                // Record the new values
	                each(series.points, function(point) {
	                    var yBottom = pick(point.yBottom, translatedThreshold),
	                        safeDistance = 999 + Math.abs(yBottom),
	                        plotY = Math.min(Math.max(-safeDistance, point.plotY), yAxis.len + safeDistance), // Don't draw too far outside plot area (#1303, #2241, #4264)
	                        barX = point.plotX + pointXOffset,
	                        barW = seriesBarW,
	                        barY = Math.min(plotY, yBottom),
	                        up,
	                        barH = Math.max(plotY, yBottom) - barY;
	
	                    // Handle options.minPointLength
	                    if (Math.abs(barH) < minPointLength) {
	                        if (minPointLength) {
	                            barH = minPointLength;
	                            up = (!yAxis.reversed && !point.negative) || (yAxis.reversed && point.negative);
	                            barY = Math.abs(barY - translatedThreshold) > minPointLength ? // stacked
	                                yBottom - minPointLength : // keep position
	                                translatedThreshold - (up ? minPointLength : 0); // #1485, #4051
	                        }
	                    }
	
	                    // Cache for access in polar
	                    point.barX = barX;
	                    point.pointWidth = pointWidth;
	
	                    // Fix the tooltip on center of grouped columns (#1216, #424, #3648)
	                    point.tooltipPos = chart.inverted ? [yAxis.len + yAxis.pos - chart.plotLeft - plotY, series.xAxis.len - barX - barW / 2, barH] : [barX + barW / 2, plotY + yAxis.pos - chart.plotTop, barH];
	
	                    // Register shape type and arguments to be used in drawPoints
	                    point.shapeType = 'rect';
	                    point.shapeArgs = series.crispCol.apply(
	                        series,
	                        point.isNull ?
	                        // #3169, drilldown from null must have a position to work from
	                        // #6585, dataLabel should be placed on xAxis, not floating in the middle of the chart
	                        [barX, translatedThreshold, barW, 0] : [barX, barY, barW, barH]
	                    );
	                });
	
	            },
	
	            getSymbol: noop,
	
	            /**
	             * Use a solid rectangle like the area series types
	             */
	            drawLegendSymbol: LegendSymbolMixin.drawRectangle,
	
	
	            /**
	             * Columns have no graph
	             */
	            drawGraph: function() {
	                this.group[this.dense ? 'addClass' : 'removeClass']('highcharts-dense-data');
	            },
	
	
	            /**
	             * Get presentational attributes
	             */
	            pointAttribs: function(point, state) {
	                var options = this.options,
	                    stateOptions,
	                    ret,
	                    p2o = this.pointAttrToOptions || {},
	                    strokeOption = p2o.stroke || 'borderColor',
	                    strokeWidthOption = p2o['stroke-width'] || 'borderWidth',
	                    fill = (point && point.color) || this.color,
	                    stroke = point[strokeOption] || options[strokeOption] ||
	                    this.color || fill, // set to fill when borderColor null
	                    strokeWidth = point[strokeWidthOption] ||
	                    options[strokeWidthOption] || this[strokeWidthOption] || 0,
	                    dashstyle = options.dashStyle,
	                    zone,
	                    brightness;
	
	                // Handle zone colors
	                if (point && this.zones.length) {
	                    zone = point.getZone();
	                    fill = point.options.color || (zone && zone.color) || this.color; // When zones are present, don't use point.color (#4267). Changed order (#6527)
	                }
	
	                // Select or hover states
	                if (state) {
	                    stateOptions = merge(
	                        options.states[state],
	                        point.options.states && point.options.states[state] || {} // #6401
	                    );
	                    brightness = stateOptions.brightness;
	                    fill = stateOptions.color ||
	                        (brightness !== undefined && color(fill).brighten(stateOptions.brightness).get()) ||
	                        fill;
	                    stroke = stateOptions[strokeOption] || stroke;
	                    strokeWidth = stateOptions[strokeWidthOption] || strokeWidth;
	                    dashstyle = stateOptions.dashStyle || dashstyle;
	                }
	
	                ret = {
	                    'fill': fill,
	                    'stroke': stroke,
	                    'stroke-width': strokeWidth
	                };
	
	                if (dashstyle) {
	                    ret.dashstyle = dashstyle;
	                }
	
	                return ret;
	            },
	
	
	            /**
	             * Draw the columns. For bars, the series.group is rotated, so the same coordinates
	             * apply for columns and bars. This method is inherited by scatter series.
	             *
	             */
	            drawPoints: function() {
	                var series = this,
	                    chart = this.chart,
	                    options = series.options,
	                    renderer = chart.renderer,
	                    animationLimit = options.animationLimit || 250,
	                    shapeArgs;
	
	                // draw the columns
	                each(series.points, function(point) {
	                    var plotY = point.plotY,
	                        graphic = point.graphic;
	
	                    if (isNumber(plotY) && point.y !== null) {
	                        shapeArgs = point.shapeArgs;
	
	                        if (graphic) { // update
	                            graphic[chart.pointCount < animationLimit ? 'animate' : 'attr'](
	                                merge(shapeArgs)
	                            );
	
	                        } else {
	                            point.graphic = graphic = renderer[point.shapeType](shapeArgs)
	                                .add(point.group || series.group);
	                        }
	
	                        // Border radius is not stylable (#6900)
	                        if (options.borderRadius) {
	                            graphic.attr({
	                                r: options.borderRadius
	                            });
	                        }
	
	
	                        // Presentational
	                        graphic
	                            .attr(series.pointAttribs(point, point.selected && 'select'))
	                            .shadow(options.shadow, null, options.stacking && !options.borderRadius);
	
	
	                        graphic.addClass(point.getClassName(), true);
	
	
	                    } else if (graphic) {
	                        point.graphic = graphic.destroy(); // #1269
	                    }
	                });
	            },
	
	            /**
	             * Animate the column heights one by one from zero
	             * @param {Boolean} init Whether to initialize the animation or run it
	             */
	            animate: function(init) {
	                var series = this,
	                    yAxis = this.yAxis,
	                    options = series.options,
	                    inverted = this.chart.inverted,
	                    attr = {},
	                    translatedThreshold;
	
	                if (svg) { // VML is too slow anyway
	                    if (init) {
	                        attr.scaleY = 0.001;
	                        translatedThreshold = Math.min(yAxis.pos + yAxis.len, Math.max(yAxis.pos, yAxis.toPixels(options.threshold)));
	                        if (inverted) {
	                            attr.translateX = translatedThreshold - yAxis.len;
	                        } else {
	                            attr.translateY = translatedThreshold;
	                        }
	                        series.group.attr(attr);
	
	                    } else { // run the animation
	
	                        attr[inverted ? 'translateX' : 'translateY'] = yAxis.pos;
	                        series.group.animate(attr, extend(animObject(series.options.animation), {
	                            // Do the scale synchronously to ensure smooth updating (#5030)
	                            step: function(val, fx) {
	                                series.group.attr({
	                                    scaleY: Math.max(0.001, fx.pos) // #5250
	                                });
	                            }
	                        }));
	
	                        // delete this function to allow it only once
	                        series.animate = null;
	                    }
	                }
	            },
	
	            /**
	             * Remove this series from the chart
	             */
	            remove: function() {
	                var series = this,
	                    chart = series.chart;
	
	                // column and bar series affects other series of the same type
	                // as they are either stacked or grouped
	                if (chart.hasRendered) {
	                    each(chart.series, function(otherSeries) {
	                        if (otherSeries.type === series.type) {
	                            otherSeries.isDirty = true;
	                        }
	                    });
	                }
	
	                Series.prototype.remove.apply(series, arguments);
	            }
	        });
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	
	        var seriesType = H.seriesType;
	
	        /**
	         * The Bar series class
	         */
	        seriesType('bar', 'column', null, {
	            /**
	             */
	            inverted: true
	        });
	        /**
	         * @extends {plotOptions.column}
	         * @optionparent plotOptions.bar
	         */
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var Series = H.Series,
	            seriesType = H.seriesType;
	        /**
	         * The scatter series type
	         */
	
	        /**
	         * @extends {plotOptions.line}
	         * @optionparent plotOptions.scatter
	         */
	        seriesType('scatter', 'line', {
	
	            /**
	             * The width of the line connecting the data points.
	             * 
	             * @type {Number}
	             * @sample {highcharts} highcharts/plotoptions/scatter-linewidth-none/ 0 by default
	             * @sample {highcharts} highcharts/plotoptions/scatter-linewidth-1/ 1px
	             * @default 0
	             * @product highcharts highstock
	             */
	            lineWidth: 0,
	
	            /**
	             */
	            findNearestPointBy: 'xy',
	
	            /**
	             */
	            marker: {
	
	                /**
	                 */
	                enabled: true // Overrides auto-enabling in line series (#3647)
	            },
	
	            /**
	             * A configuration object for the tooltip rendering of each single
	             * series. Properties are inherited from <a class="internal">#tooltip</a>.
	             * Overridable properties are `headerFormat`, `pointFormat`, `yDecimals`,
	             * `xDateFormat`, `yPrefix` and `ySuffix`. Unlike other series, in
	             * a scatter plot the series.name by default shows in the headerFormat
	             * and point.x and point.y in the pointFormat.
	             * 
	             * @product highcharts highstock
	             */
	            tooltip: {
	
	                headerFormat: '<span style="color:{point.color}">\u25CF</span> ' +
	                    '<span style="font-size: 0.85em"> {series.name}</span><br/>',
	
	
	                /**
	                 */
	                pointFormat: 'x: <b>{point.x}</b><br/>y: <b>{point.y}</b><br/>'
	            }
	
	            // Prototype members
	        }, {
	            sorted: false,
	            requireSorting: false,
	            noSharedTooltip: true,
	            trackerGroups: ['group', 'markerGroup', 'dataLabelsGroup'],
	            takeOrdinalPosition: false, // #2342
	            drawGraph: function() {
	                if (this.options.lineWidth) {
	                    Series.prototype.drawGraph.call(this);
	                }
	            }
	        });
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var pick = H.pick,
	            relativeLength = H.relativeLength;
	
	        H.CenteredSeriesMixin = {
	            /**
	             * Get the center of the pie based on the size and center options relative to the
	             * plot area. Borrowed by the polar and gauge series types.
	             */
	            getCenter: function() {
	
	                var options = this.options,
	                    chart = this.chart,
	                    slicingRoom = 2 * (options.slicedOffset || 0),
	                    handleSlicingRoom,
	                    plotWidth = chart.plotWidth - 2 * slicingRoom,
	                    plotHeight = chart.plotHeight - 2 * slicingRoom,
	                    centerOption = options.center,
	                    positions = [pick(centerOption[0], '50%'), pick(centerOption[1], '50%'), options.size || '100%', options.innerSize || 0],
	                    smallestSize = Math.min(plotWidth, plotHeight),
	                    i,
	                    value;
	
	                for (i = 0; i < 4; ++i) {
	                    value = positions[i];
	                    handleSlicingRoom = i < 2 || (i === 2 && /%$/.test(value));
	
	                    // i == 0: centerX, relative to width
	                    // i == 1: centerY, relative to height
	                    // i == 2: size, relative to smallestSize
	                    // i == 3: innerSize, relative to size
	                    positions[i] = relativeLength(value, [plotWidth, plotHeight, smallestSize, positions[2]][i]) +
	                        (handleSlicingRoom ? slicingRoom : 0);
	
	                }
	                // innerSize cannot be larger than size (#3632)
	                if (positions[3] > positions[2]) {
	                    positions[3] = positions[2];
	                }
	                return positions;
	            }
	        };
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var addEvent = H.addEvent,
	            CenteredSeriesMixin = H.CenteredSeriesMixin,
	            defined = H.defined,
	            each = H.each,
	            extend = H.extend,
	            inArray = H.inArray,
	            LegendSymbolMixin = H.LegendSymbolMixin,
	            noop = H.noop,
	            pick = H.pick,
	            Point = H.Point,
	            Series = H.Series,
	            seriesType = H.seriesType,
	            seriesTypes = H.seriesTypes,
	            setAnimation = H.setAnimation;
	
	        /**
	         * The pie series type.
	         *
	         * @constructor seriesTypes.pie
	         * @augments Series
	         */
	
	        /**
	         * @extends {plotOptions.line}
	         * @optionparent plotOptions.pie
	         */
	        seriesType('pie', 'line', {
	
	            /**
	             * The center of the pie chart relative to the plot area. Can be percentages
	             * or pixel values. The default behaviour (as of 3.0) is to center
	             * the pie so that all slices and data labels are within the plot area.
	             * As a consequence, the pie may actually jump around in a chart with
	             * dynamic values, as the data labels move. In that case, the center
	             * should be explicitly set, for example to `["50%", "50%"]`.
	             * 
	             * @type {Array<String|Number>}
	             * @sample {highcharts} highcharts/plotoptions/pie-center/ Centered at 100, 100
	             * @default [null, null]
	             * @product highcharts
	             */
	            center: [null, null],
	
	            /**
	             */
	            clip: false,
	
	            /**
	             */
	            colorByPoint: true, // always true for pies
	
	            /**
	             * @extends plotOptions.series.dataLabels
	             * @excluding align,allowOverlap,staggerLines,step
	             * @product highcharts
	             */
	            dataLabels: {
	                // align: null,
	                // connectorWidth: 1,
	                // connectorColor: point.color,
	                // connectorPadding: 5,
	
	                /**
	                 * The distance of the data label from the pie's edge. Negative numbers
	                 * put the data label on top of the pie slices. Connectors are only
	                 * shown for data labels outside the pie.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/plotoptions/pie-datalabels-distance/ Data labels on top of the pie
	                 * @default 30
	                 * @since 2.1
	                 * @product highcharts
	                 */
	                distance: 30,
	
	                /**
	                 * Enable or disable the data labels.
	                 * 
	                 * @type {Boolean}
	                 * @since 2.1
	                 * @product highcharts
	                 */
	                enabled: true,
	
	                /**
	                 */
	                formatter: function() { // #2945
	                    return this.point.isNull ? undefined : this.point.name;
	                },
	                // softConnector: true,
	
	                /**
	                 */
	                x: 0
	                // y: 0
	            },
	
	            /**
	             * Equivalent to [chart.ignoreHiddenSeries](#chart.ignoreHiddenSeries),
	             * this option tells whether the series shall be redrawn as if the
	             * hidden point were `null`.
	             * 
	             * The default value changed from `false` to `true` with Highcharts
	             * 3.0.
	             * 
	             * @type {Boolean}
	             * @sample {highcharts} highcharts/plotoptions/pie-ignorehiddenpoint/ True, the hiddden point is ignored
	             * @default true
	             * @since 2.3.0
	             * @product highcharts
	             */
	            ignoreHiddenPoint: true,
	            //innerSize: 0,
	
	            /**
	             */
	            legendType: 'point',
	
	            /**
	             */
	            marker: null, // point options are specified in the base options
	
	            /**
	             * The diameter of the pie relative to the plot area. Can be a percentage
	             * or pixel value. Pixel values are given as integers. The default
	             * behaviour (as of 3.0) is to scale to the plot area and give room
	             * for data labels within the plot area. As a consequence, the size
	             * of the pie may vary when points are updated and data labels more
	             * around. In that case it is best to set a fixed value, for example
	             * `"75%"`.
	             * 
	             * @type {String|Number}
	             * @sample {highcharts} highcharts/plotoptions/pie-size/ Smaller pie
	             * @default  
	             * @product highcharts
	             */
	            size: null,
	
	            /**
	             * Whether to display this particular series or series type in the
	             * legend. Since 2.1, pies are not shown in the legend by default.
	             * 
	             * @type {Boolean}
	             * @sample {highcharts} highcharts/plotoptions/series-showinlegend/ One series in the legend, one hidden
	             * @product highcharts
	             */
	            showInLegend: false,
	
	            /**
	             * If a point is sliced, moved out from the center, how many pixels
	             * should it be moved?.
	             * 
	             * @type {Number}
	             * @sample {highcharts} highcharts/plotoptions/pie-slicedoffset-20/ 20px offset
	             * @default 10
	             * @product highcharts
	             */
	            slicedOffset: 10,
	
	            /**
	             * Sticky tracking of mouse events. When true, the `mouseOut` event
	             * on a series isn't triggered until the mouse moves over another series,
	             * or out of the plot area. When false, the `mouseOut` event on a
	             * series is triggered when the mouse leaves the area around the series'
	             * graph or markers. This also implies the tooltip. When `stickyTracking`
	             * is false and `tooltip.shared` is false, the tooltip will be hidden
	             * when moving the mouse between series.
	             * 
	             * @type {Boolean}
	             * @default false
	             * @product highcharts
	             */
	            stickyTracking: false,
	
	            /**
	             */
	            tooltip: {
	
	                /**
	                 */
	                followPointer: true
	            },
	
	
	            /**
	             * The color of the border surrounding each slice. When `null`, the
	             * border takes the same color as the slice fill. This can be used
	             * together with a `borderWidth` to fill drawing gaps created by antialiazing
	             * artefacts in borderless pies.
	             * 
	             * In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	             * style/style-by-css), the border stroke is given in the `.highcharts-
	             * point` class.
	             * 
	             * @type {Color}
	             * @sample {highcharts} highcharts/plotoptions/pie-bordercolor-black/ Black border
	             * @default #ffffff
	             * @product highcharts
	             */
	            borderColor: '#ffffff',
	
	            /**
	             * The width of the border surrounding each slice.
	             * 
	             * When setting the border width to 0, there may be small gaps between
	             * the slices due to SVG antialiasing artefacts. To work around this,
	             * keep the border width at 0.5 or 1, but set the `borderColor` to
	             * `null` instead.
	             * 
	             * In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	             * style/style-by-css), the border stroke width is given in the `.highcharts-
	             * point` class.
	             * 
	             * @type {Number}
	             * @sample {highcharts} highcharts/plotoptions/pie-borderwidth/ 3px border
	             * @default 1
	             * @product highcharts
	             */
	            borderWidth: 1,
	
	            /**
	             */
	            states: {
	
	                /**
	                 * @extends plotOptions.series.states.hover
	                 * @product highcharts
	                 */
	                hover: {
	
	                    /**
	                     * How much to brighten the point on interaction. Requires the main
	                     * color to be defined in hex or rgb(a) format.
	                     * 
	                     * In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                     * style/style-by-css), the hover brightness is by default replaced
	                     * by a fill-opacity given in the `.highcharts-point-hover` class.
	                     * 
	                     * @type {Number}
	                     * @sample {highcharts} highcharts/plotoptions/pie-states-hover-brightness/ Brightened by 0.5
	                     * @default 0.1
	                     * @product highcharts
	                     */
	                    brightness: 0.1,
	
	                    /**
	                     */
	                    shadow: false
	                }
	            }
	
	
	        }, /** @lends seriesTypes.pie.prototype */ {
	            isCartesian: false,
	            requireSorting: false,
	            directTouch: true,
	            noSharedTooltip: true,
	            trackerGroups: ['group', 'dataLabelsGroup'],
	            axisTypes: [],
	            pointAttribs: seriesTypes.column.prototype.pointAttribs,
	            /**
	             * Animate the pies in
	             */
	            animate: function(init) {
	                var series = this,
	                    points = series.points,
	                    startAngleRad = series.startAngleRad;
	
	                if (!init) {
	                    each(points, function(point) {
	                        var graphic = point.graphic,
	                            args = point.shapeArgs;
	
	                        if (graphic) {
	                            // start values
	                            graphic.attr({
	                                r: point.startR || (series.center[3] / 2), // animate from inner radius (#779)
	                                start: startAngleRad,
	                                end: startAngleRad
	                            });
	
	                            // animate
	                            graphic.animate({
	                                r: args.r,
	                                start: args.start,
	                                end: args.end
	                            }, series.options.animation);
	                        }
	                    });
	
	                    // delete this function to allow it only once
	                    series.animate = null;
	                }
	            },
	
	            /**
	             * Recompute total chart sum and update percentages of points.
	             */
	            updateTotals: function() {
	                var i,
	                    total = 0,
	                    points = this.points,
	                    len = points.length,
	                    point,
	                    ignoreHiddenPoint = this.options.ignoreHiddenPoint;
	
	                // Get the total sum
	                for (i = 0; i < len; i++) {
	                    point = points[i];
	                    total += (ignoreHiddenPoint && !point.visible) ?
	                        0 :
	                        point.isNull ? 0 : point.y;
	                }
	                this.total = total;
	
	                // Set each point's properties
	                for (i = 0; i < len; i++) {
	                    point = points[i];
	                    point.percentage = (total > 0 && (point.visible || !ignoreHiddenPoint)) ? point.y / total * 100 : 0;
	                    point.total = total;
	                }
	            },
	
	            /**
	             * Extend the generatePoints method by adding total and percentage properties to each point
	             */
	            generatePoints: function() {
	                Series.prototype.generatePoints.call(this);
	                this.updateTotals();
	            },
	
	            /**
	             * Do translation for pie slices
	             */
	            translate: function(positions) {
	                this.generatePoints();
	
	                var series = this,
	                    cumulative = 0,
	                    precision = 1000, // issue #172
	                    options = series.options,
	                    slicedOffset = options.slicedOffset,
	                    connectorOffset = slicedOffset + (options.borderWidth || 0),
	                    finalConnectorOffset,
	                    start,
	                    end,
	                    angle,
	                    startAngle = options.startAngle || 0,
	                    startAngleRad = series.startAngleRad = Math.PI / 180 * (startAngle - 90),
	                    endAngleRad = series.endAngleRad = Math.PI / 180 * ((pick(options.endAngle, startAngle + 360)) - 90),
	                    circ = endAngleRad - startAngleRad, //2 * Math.PI,
	                    points = series.points,
	                    radiusX, // the x component of the radius vector for a given point
	                    radiusY,
	                    labelDistance = options.dataLabels.distance,
	                    ignoreHiddenPoint = options.ignoreHiddenPoint,
	                    i,
	                    len = points.length,
	                    point;
	
	                // Get positions - either an integer or a percentage string must be given.
	                // If positions are passed as a parameter, we're in a recursive loop for adjusting
	                // space for data labels.
	                if (!positions) {
	                    series.center = positions = series.getCenter();
	                }
	
	                // Utility for getting the x value from a given y, used for anticollision
	                // logic in data labels.
	                // Added point for using specific points' label distance.
	                series.getX = function(y, left, point) {
	                    angle = Math.asin(Math.min((y - positions[1]) / (positions[2] / 2 + point.labelDistance), 1));
	                    return positions[0] +
	                        (left ? -1 : 1) *
	                        (Math.cos(angle) * (positions[2] / 2 + point.labelDistance));
	                };
	
	                // Calculate the geometry for each point
	                for (i = 0; i < len; i++) {
	
	                    point = points[i];
	
	                    // Used for distance calculation for specific point.
	                    point.labelDistance = pick(
	                        point.options.dataLabels && point.options.dataLabels.distance,
	                        labelDistance
	                    );
	
	                    // Saved for later dataLabels distance calculation.
	                    series.maxLabelDistance = Math.max(series.maxLabelDistance || 0, point.labelDistance);
	
	                    // set start and end angle
	                    start = startAngleRad + (cumulative * circ);
	                    if (!ignoreHiddenPoint || point.visible) {
	                        cumulative += point.percentage / 100;
	                    }
	                    end = startAngleRad + (cumulative * circ);
	
	                    // set the shape
	                    point.shapeType = 'arc';
	                    point.shapeArgs = {
	                        x: positions[0],
	                        y: positions[1],
	                        r: positions[2] / 2,
	                        innerR: positions[3] / 2,
	                        start: Math.round(start * precision) / precision,
	                        end: Math.round(end * precision) / precision
	                    };
	
	                    // The angle must stay within -90 and 270 (#2645)
	                    angle = (end + start) / 2;
	                    if (angle > 1.5 * Math.PI) {
	                        angle -= 2 * Math.PI;
	                    } else if (angle < -Math.PI / 2) {
	                        angle += 2 * Math.PI;
	                    }
	
	                    // Center for the sliced out slice
	                    point.slicedTranslation = {
	                        translateX: Math.round(Math.cos(angle) * slicedOffset),
	                        translateY: Math.round(Math.sin(angle) * slicedOffset)
	                    };
	
	                    // set the anchor point for tooltips
	                    radiusX = Math.cos(angle) * positions[2] / 2;
	                    radiusY = Math.sin(angle) * positions[2] / 2;
	                    point.tooltipPos = [
	                        positions[0] + radiusX * 0.7,
	                        positions[1] + radiusY * 0.7
	                    ];
	
	                    point.half = angle < -Math.PI / 2 || angle > Math.PI / 2 ? 1 : 0;
	                    point.angle = angle;
	
	                    // Set the anchor point for data labels. Use point.labelDistance 
	                    // instead of labelDistance // #1174
	                    // finalConnectorOffset - not override connectorOffset value.
	                    finalConnectorOffset = Math.min(connectorOffset, point.labelDistance / 5); // #1678
	                    point.labelPos = [
	                        positions[0] + radiusX + Math.cos(angle) * point.labelDistance, // first break of connector
	                        positions[1] + radiusY + Math.sin(angle) * point.labelDistance, // a/a
	                        positions[0] + radiusX + Math.cos(angle) * finalConnectorOffset, // second break, right outside pie
	                        positions[1] + radiusY + Math.sin(angle) * finalConnectorOffset, // a/a
	                        positions[0] + radiusX, // landing point for connector
	                        positions[1] + radiusY, // a/a
	                        point.labelDistance < 0 ? // alignment
	                        'center' :
	                        point.half ? 'right' : 'left', // alignment
	                        angle // center angle
	                    ];
	
	                }
	            },
	
	            drawGraph: null,
	
	            /**
	             * Draw the data points
	             */
	            drawPoints: function() {
	                var series = this,
	                    chart = series.chart,
	                    renderer = chart.renderer,
	                    groupTranslation,
	                    //center,
	                    graphic,
	                    //group,
	                    pointAttr,
	                    shapeArgs;
	
	
	                var shadow = series.options.shadow;
	                if (shadow && !series.shadowGroup) {
	                    series.shadowGroup = renderer.g('shadow')
	                        .add(series.group);
	                }
	
	
	                // draw the slices
	                each(series.points, function(point) {
	                    if (!point.isNull) {
	                        graphic = point.graphic;
	                        shapeArgs = point.shapeArgs;
	
	
	                        // If the point is sliced, use special translation, else use
	                        // plot area traslation
	                        groupTranslation = point.getTranslate();
	
	
	                        // Put the shadow behind all points
	                        var shadowGroup = point.shadowGroup;
	                        if (shadow && !shadowGroup) {
	                            shadowGroup = point.shadowGroup = renderer.g('shadow')
	                                .add(series.shadowGroup);
	                        }
	
	                        if (shadowGroup) {
	                            shadowGroup.attr(groupTranslation);
	                        }
	                        pointAttr = series.pointAttribs(point, point.selected && 'select');
	
	
	                        // Draw the slice
	                        if (graphic) {
	                            graphic
	                                .setRadialReference(series.center)
	
	                                .attr(pointAttr)
	
	                                .animate(extend(shapeArgs, groupTranslation));
	                        } else {
	
	                            point.graphic = graphic = renderer[point.shapeType](shapeArgs)
	                                .setRadialReference(series.center)
	                                .attr(groupTranslation)
	                                .add(series.group);
	
	                            if (!point.visible) {
	                                graphic.attr({
	                                    visibility: 'hidden'
	                                });
	                            }
	
	
	                            graphic
	                                .attr(pointAttr)
	                                .attr({
	                                    'stroke-linejoin': 'round'
	                                })
	                                .shadow(shadow, shadowGroup);
	
	                        }
	
	                        graphic.addClass(point.getClassName());
	
	                    }
	                });
	
	            },
	
	
	            searchPoint: noop,
	
	            /**
	             * Utility for sorting data labels
	             */
	            sortByAngle: function(points, sign) {
	                points.sort(function(a, b) {
	                    return a.angle !== undefined && (b.angle - a.angle) * sign;
	                });
	            },
	
	            /**
	             * Use a simple symbol from LegendSymbolMixin
	             */
	            drawLegendSymbol: LegendSymbolMixin.drawRectangle,
	
	            /**
	             * Use the getCenter method from drawLegendSymbol
	             */
	            getCenter: CenteredSeriesMixin.getCenter,
	
	            /**
	             * Pies don't have point marker symbols
	             */
	            getSymbol: noop
	
	
	            /**
	             * @constructor seriesTypes.pie.prototype.pointClass
	             * @extends {Point}
	             */
	        }, /** @lends seriesTypes.pie.prototype.pointClass.prototype */ {
	            /**
	             * Initiate the pie slice
	             */
	            init: function() {
	
	                Point.prototype.init.apply(this, arguments);
	
	                var point = this,
	                    toggleSlice;
	
	                point.name = pick(point.name, 'Slice');
	
	                // add event listener for select
	                toggleSlice = function(e) {
	                    point.slice(e.type === 'select');
	                };
	                addEvent(point, 'select', toggleSlice);
	                addEvent(point, 'unselect', toggleSlice);
	
	                return point;
	            },
	
	            /**
	             * Negative points are not valid (#1530, #3623, #5322)
	             */
	            isValid: function() {
	                return H.isNumber(this.y, true) && this.y >= 0;
	            },
	
	            /**
	             * Toggle the visibility of the pie slice
	             * @param {Boolean} vis Whether to show the slice or not. If undefined, the
	             *    visibility is toggled
	             */
	            setVisible: function(vis, redraw) {
	                var point = this,
	                    series = point.series,
	                    chart = series.chart,
	                    ignoreHiddenPoint = series.options.ignoreHiddenPoint;
	
	                redraw = pick(redraw, ignoreHiddenPoint);
	
	                if (vis !== point.visible) {
	
	                    // If called without an argument, toggle visibility
	                    point.visible = point.options.visible = vis = vis === undefined ? !point.visible : vis;
	                    series.options.data[inArray(point, series.data)] = point.options; // update userOptions.data
	
	                    // Show and hide associated elements. This is performed regardless of redraw or not,
	                    // because chart.redraw only handles full series.
	                    each(['graphic', 'dataLabel', 'connector', 'shadowGroup'], function(key) {
	                        if (point[key]) {
	                            point[key][vis ? 'show' : 'hide'](true);
	                        }
	                    });
	
	                    if (point.legendItem) {
	                        chart.legend.colorizeItem(point, vis);
	                    }
	
	                    // #4170, hide halo after hiding point
	                    if (!vis && point.state === 'hover') {
	                        point.setState('');
	                    }
	
	                    // Handle ignore hidden slices
	                    if (ignoreHiddenPoint) {
	                        series.isDirty = true;
	                    }
	
	                    if (redraw) {
	                        chart.redraw();
	                    }
	                }
	            },
	
	            /**
	             * Set or toggle whether the slice is cut out from the pie
	             * @param {Boolean} sliced When undefined, the slice state is toggled
	             * @param {Boolean} redraw Whether to redraw the chart. True by default.
	             */
	            slice: function(sliced, redraw, animation) {
	                var point = this,
	                    series = point.series,
	                    chart = series.chart;
	
	                setAnimation(animation, chart);
	
	                // redraw is true by default
	                redraw = pick(redraw, true);
	
	                // if called without an argument, toggle
	                point.sliced = point.options.sliced = sliced = defined(sliced) ? sliced : !point.sliced;
	                series.options.data[inArray(point, series.data)] = point.options; // update userOptions.data
	
	                point.graphic.animate(this.getTranslate());
	
	
	                if (point.shadowGroup) {
	                    point.shadowGroup.animate(this.getTranslate());
	                }
	
	            },
	
	            getTranslate: function() {
	                return this.sliced ? this.slicedTranslation : {
	                    translateX: 0,
	                    translateY: 0
	                };
	            },
	
	            haloPath: function(size) {
	                var shapeArgs = this.shapeArgs;
	
	                return this.sliced || !this.visible ? [] :
	                    this.series.chart.renderer.symbols.arc(
	                        shapeArgs.x,
	                        shapeArgs.y,
	                        shapeArgs.r + size,
	                        shapeArgs.r + size, {
	                            innerR: this.shapeArgs.r,
	                            start: shapeArgs.start,
	                            end: shapeArgs.end
	                        }
	                    );
	            }
	        });
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var addEvent = H.addEvent,
	            arrayMax = H.arrayMax,
	            defined = H.defined,
	            each = H.each,
	            extend = H.extend,
	            format = H.format,
	            map = H.map,
	            merge = H.merge,
	            noop = H.noop,
	            pick = H.pick,
	            relativeLength = H.relativeLength,
	            Series = H.Series,
	            seriesTypes = H.seriesTypes,
	            stableSort = H.stableSort;
	
	
	        /**
	         * Generatl distribution algorithm for distributing labels of differing size along a
	         * confined length in two dimensions. The algorithm takes an array of objects containing
	         * a size, a target and a rank. It will place the labels as close as possible to their 
	         * targets, skipping the lowest ranked labels if necessary.
	         */
	        H.distribute = function(boxes, len) {
	
	            var i,
	                overlapping = true,
	                origBoxes = boxes, // Original array will be altered with added .pos
	                restBoxes = [], // The outranked overshoot
	                box,
	                target,
	                total = 0;
	
	            function sortByTarget(a, b) {
	                return a.target - b.target;
	            }
	
	            // If the total size exceeds the len, remove those boxes with the lowest rank
	            i = boxes.length;
	            while (i--) {
	                total += boxes[i].size;
	            }
	
	            // Sort by rank, then slice away overshoot
	            if (total > len) {
	                stableSort(boxes, function(a, b) {
	                    return (b.rank || 0) - (a.rank || 0);
	                });
	                i = 0;
	                total = 0;
	                while (total <= len) {
	                    total += boxes[i].size;
	                    i++;
	                }
	                restBoxes = boxes.splice(i - 1, boxes.length);
	            }
	
	            // Order by target
	            stableSort(boxes, sortByTarget);
	
	
	            // So far we have been mutating the original array. Now
	            // create a copy with target arrays
	            boxes = map(boxes, function(box) {
	                return {
	                    size: box.size,
	                    targets: [box.target]
	                };
	            });
	
	            while (overlapping) {
	                // Initial positions: target centered in box
	                i = boxes.length;
	                while (i--) {
	                    box = boxes[i];
	                    // Composite box, average of targets
	                    target = (Math.min.apply(0, box.targets) + Math.max.apply(0, box.targets)) / 2;
	                    box.pos = Math.min(Math.max(0, target - box.size / 2), len - box.size);
	                }
	
	                // Detect overlap and join boxes
	                i = boxes.length;
	                overlapping = false;
	                while (i--) {
	                    if (i > 0 && boxes[i - 1].pos + boxes[i - 1].size > boxes[i].pos) { // Overlap
	                        boxes[i - 1].size += boxes[i].size; // Add this size to the previous box
	                        boxes[i - 1].targets = boxes[i - 1].targets.concat(boxes[i].targets);
	
	                        // Overlapping right, push left
	                        if (boxes[i - 1].pos + boxes[i - 1].size > len) {
	                            boxes[i - 1].pos = len - boxes[i - 1].size;
	                        }
	                        boxes.splice(i, 1); // Remove this item
	                        overlapping = true;
	                    }
	                }
	            }
	
	            // Now the composite boxes are placed, we need to put the original boxes within them
	            i = 0;
	            each(boxes, function(box) {
	                var posInCompositeBox = 0;
	                each(box.targets, function() {
	                    origBoxes[i].pos = box.pos + posInCompositeBox;
	                    posInCompositeBox += origBoxes[i].size;
	                    i++;
	                });
	            });
	
	            // Add the rest (hidden) boxes and sort by target
	            origBoxes.push.apply(origBoxes, restBoxes);
	            stableSort(origBoxes, sortByTarget);
	        };
	
	
	        /**
	         * Draw the data labels
	         */
	        Series.prototype.drawDataLabels = function() {
	            var series = this,
	                seriesOptions = series.options,
	                options = seriesOptions.dataLabels,
	                points = series.points,
	                pointOptions,
	                generalOptions,
	                hasRendered = series.hasRendered || 0,
	                str,
	                dataLabelsGroup,
	                defer = pick(options.defer, !!seriesOptions.animation),
	                renderer = series.chart.renderer;
	
	            if (options.enabled || series._hasPointLabels) {
	
	                // Process default alignment of data labels for columns
	                if (series.dlProcessOptions) {
	                    series.dlProcessOptions(options);
	                }
	
	                // Create a separate group for the data labels to avoid rotation
	                dataLabelsGroup = series.plotGroup(
	                    'dataLabelsGroup',
	                    'data-labels',
	                    defer && !hasRendered ? 'hidden' : 'visible', // #5133
	                    options.zIndex || 6
	                );
	
	                if (defer) {
	                    dataLabelsGroup.attr({
	                        opacity: +hasRendered
	                    }); // #3300
	                    if (!hasRendered) {
	                        addEvent(series, 'afterAnimate', function() {
	                            if (series.visible) { // #2597, #3023, #3024
	                                dataLabelsGroup.show(true);
	                            }
	                            dataLabelsGroup[seriesOptions.animation ? 'animate' : 'attr']({
	                                opacity: 1
	                            }, {
	                                duration: 200
	                            });
	                        });
	                    }
	                }
	
	                // Make the labels for each point
	                generalOptions = options;
	                each(points, function(point) {
	                    var enabled,
	                        dataLabel = point.dataLabel,
	                        labelConfig,
	                        attr,
	                        rotation,
	                        connector = point.connector,
	                        isNew = !dataLabel,
	                        style;
	                    // Determine if each data label is enabled
	                    // @note dataLabelAttribs (like pointAttribs) would eradicate
	                    // the need for dlOptions, and simplify the section below.
	                    pointOptions = point.dlOptions || (point.options && point.options.dataLabels); // dlOptions is used in treemaps
	                    enabled = pick(pointOptions && pointOptions.enabled, generalOptions.enabled) && point.y !== null; // #2282, #4641
	                    if (enabled) {
	                        // Create individual options structure that can be extended without
	                        // affecting others
	                        options = merge(generalOptions, pointOptions);
	                        labelConfig = point.getLabelConfig();
	                        str = options.format ?
	                            format(options.format, labelConfig) :
	                            options.formatter.call(labelConfig, options);
	                        style = options.style;
	                        rotation = options.rotation;
	
	                        // Determine the color
	                        style.color = pick(options.color, style.color, series.color, '#000000');
	                        // Get automated contrast color
	                        if (style.color === 'contrast') {
	                            point.contrastColor = renderer.getContrast(point.color || series.color);
	                            style.color = options.inside || pick(point.labelDistance, options.distance) < 0 ||
	                                !!seriesOptions.stacking ? point.contrastColor : '#000000';
	                        }
	                        if (seriesOptions.cursor) {
	                            style.cursor = seriesOptions.cursor;
	                        }
	
	
	                        attr = {
	                            //align: align,
	
	                            fill: options.backgroundColor,
	                            stroke: options.borderColor,
	                            'stroke-width': options.borderWidth,
	
	                            r: options.borderRadius || 0,
	                            rotation: rotation,
	                            padding: options.padding,
	                            zIndex: 1
	                        };
	
	                        // Remove unused attributes (#947)
	                        H.objectEach(attr, function(val, name) {
	                            if (val === undefined) {
	                                delete attr[name];
	                            }
	                        });
	                    }
	                    // If the point is outside the plot area, destroy it. #678, #820
	                    if (dataLabel && (!enabled || !defined(str))) {
	                        point.dataLabel = dataLabel = dataLabel.destroy();
	                        if (connector) {
	                            point.connector = connector.destroy();
	                        }
	                        // Individual labels are disabled if the are explicitly disabled
	                        // in the point options, or if they fall outside the plot area.
	                    } else if (enabled && defined(str)) {
	                        // create new label
	                        if (!dataLabel) {
	                            dataLabel = point.dataLabel = renderer[rotation ? 'text' : 'label']( // labels don't support rotation
	                                str,
	                                0, -9999,
	                                options.shape,
	                                null,
	                                null,
	                                options.useHTML,
	                                null,
	                                'data-label'
	                            );
	                            dataLabel.addClass(
	                                'highcharts-data-label-color-' + point.colorIndex +
	                                ' ' + (options.className || '') +
	                                (options.useHTML ? 'highcharts-tracker' : '') // #3398
	                            );
	                        } else {
	                            attr.text = str;
	                        }
	                        dataLabel.attr(attr);
	
	                        // Styles must be applied before add in order to read text bounding box
	                        dataLabel.css(style).shadow(options.shadow);
	
	
	                        if (!dataLabel.added) {
	                            dataLabel.add(dataLabelsGroup);
	                        }
	                        // Now the data label is created and placed at 0,0, so we need to align it
	                        series.alignDataLabel(point, dataLabel, options, null, isNew);
	                    }
	                });
	            }
	        };
	
	        /**
	         * Align each individual data label
	         */
	        Series.prototype.alignDataLabel = function(point, dataLabel, options, alignTo, isNew) {
	            var chart = this.chart,
	                inverted = chart.inverted,
	                plotX = pick(point.plotX, -9999),
	                plotY = pick(point.plotY, -9999),
	                bBox = dataLabel.getBBox(),
	                fontSize,
	                baseline,
	                rotation = options.rotation,
	                normRotation,
	                negRotation,
	                align = options.align,
	                rotCorr, // rotation correction
	                // Math.round for rounding errors (#2683), alignTo to allow column labels (#2700)
	                visible =
	                this.visible &&
	                (
	                    point.series.forceDL ||
	                    chart.isInsidePlot(plotX, Math.round(plotY), inverted) ||
	                    (
	                        alignTo && chart.isInsidePlot(
	                            plotX,
	                            inverted ? alignTo.x + 1 : alignTo.y + alignTo.height - 1,
	                            inverted
	                        )
	                    )
	                ),
	                alignAttr, // the final position;
	                justify = pick(options.overflow, 'justify') === 'justify';
	
	            if (visible) {
	
	
	                fontSize = options.style.fontSize;
	
	
	                baseline = chart.renderer.fontMetrics(fontSize, dataLabel).b;
	
	                // The alignment box is a singular point
	                alignTo = extend({
	                    x: inverted ? this.yAxis.len - plotY : plotX,
	                    y: Math.round(inverted ? this.xAxis.len - plotX : plotY),
	                    width: 0,
	                    height: 0
	                }, alignTo);
	
	                // Add the text size for alignment calculation
	                extend(options, {
	                    width: bBox.width,
	                    height: bBox.height
	                });
	
	                // Allow a hook for changing alignment in the last moment, then do the alignment
	                if (rotation) {
	                    justify = false; // Not supported for rotated text
	                    rotCorr = chart.renderer.rotCorr(baseline, rotation); // #3723
	                    alignAttr = {
	                        x: alignTo.x + options.x + alignTo.width / 2 + rotCorr.x,
	                        y: alignTo.y + options.y + {
	                            top: 0,
	                            middle: 0.5,
	                            bottom: 1
	                        }[options.verticalAlign] * alignTo.height
	                    };
	                    dataLabel[isNew ? 'attr' : 'animate'](alignAttr)
	                        .attr({ // #3003
	                            align: align
	                        });
	
	                    // Compensate for the rotated label sticking out on the sides
	                    normRotation = (rotation + 720) % 360;
	                    negRotation = normRotation > 180 && normRotation < 360;
	
	                    if (align === 'left') {
	                        alignAttr.y -= negRotation ? bBox.height : 0;
	                    } else if (align === 'center') {
	                        alignAttr.x -= bBox.width / 2;
	                        alignAttr.y -= bBox.height / 2;
	                    } else if (align === 'right') {
	                        alignAttr.x -= bBox.width;
	                        alignAttr.y -= negRotation ? 0 : bBox.height;
	                    }
	
	
	                } else {
	                    dataLabel.align(options, null, alignTo);
	                    alignAttr = dataLabel.alignAttr;
	                }
	
	                // Handle justify or crop
	                if (justify) {
	                    point.isLabelJustified = this.justifyDataLabel(
	                        dataLabel,
	                        options,
	                        alignAttr,
	                        bBox,
	                        alignTo,
	                        isNew
	                    );
	
	                    // Now check that the data label is within the plot area
	                } else if (pick(options.crop, true)) {
	                    visible = chart.isInsidePlot(alignAttr.x, alignAttr.y) && chart.isInsidePlot(alignAttr.x + bBox.width, alignAttr.y + bBox.height);
	                }
	
	                // When we're using a shape, make it possible with a connector or an arrow pointing to thie point
	                if (options.shape && !rotation) {
	                    dataLabel[isNew ? 'attr' : 'animate']({
	                        anchorX: inverted ? chart.plotWidth - point.plotY : point.plotX,
	                        anchorY: inverted ? chart.plotHeight - point.plotX : point.plotY
	                    });
	                }
	            }
	
	            // Show or hide based on the final aligned position
	            if (!visible) {
	                dataLabel.attr({
	                    y: -9999
	                });
	                dataLabel.placed = false; // don't animate back in
	            }
	
	        };
	
	        /**
	         * If data labels fall partly outside the plot area, align them back in, in a way that
	         * doesn't hide the point.
	         */
	        Series.prototype.justifyDataLabel = function(dataLabel, options, alignAttr, bBox, alignTo, isNew) {
	            var chart = this.chart,
	                align = options.align,
	                verticalAlign = options.verticalAlign,
	                off,
	                justified,
	                padding = dataLabel.box ? 0 : (dataLabel.padding || 0);
	
	            // Off left
	            off = alignAttr.x + padding;
	            if (off < 0) {
	                if (align === 'right') {
	                    options.align = 'left';
	                } else {
	                    options.x = -off;
	                }
	                justified = true;
	            }
	
	            // Off right
	            off = alignAttr.x + bBox.width - padding;
	            if (off > chart.plotWidth) {
	                if (align === 'left') {
	                    options.align = 'right';
	                } else {
	                    options.x = chart.plotWidth - off;
	                }
	                justified = true;
	            }
	
	            // Off top
	            off = alignAttr.y + padding;
	            if (off < 0) {
	                if (verticalAlign === 'bottom') {
	                    options.verticalAlign = 'top';
	                } else {
	                    options.y = -off;
	                }
	                justified = true;
	            }
	
	            // Off bottom
	            off = alignAttr.y + bBox.height - padding;
	            if (off > chart.plotHeight) {
	                if (verticalAlign === 'top') {
	                    options.verticalAlign = 'bottom';
	                } else {
	                    options.y = chart.plotHeight - off;
	                }
	                justified = true;
	            }
	
	            if (justified) {
	                dataLabel.placed = !isNew;
	                dataLabel.align(options, null, alignTo);
	            }
	
	            return justified;
	        };
	
	        /**
	         * Override the base drawDataLabels method by pie specific functionality
	         */
	        if (seriesTypes.pie) {
	            seriesTypes.pie.prototype.drawDataLabels = function() {
	                var series = this,
	                    data = series.data,
	                    point,
	                    chart = series.chart,
	                    options = series.options.dataLabels,
	                    connectorPadding = pick(options.connectorPadding, 10),
	                    connectorWidth = pick(options.connectorWidth, 1),
	                    plotWidth = chart.plotWidth,
	                    plotHeight = chart.plotHeight,
	                    connector,
	                    seriesCenter = series.center,
	                    radius = seriesCenter[2] / 2,
	                    centerY = seriesCenter[1],
	                    dataLabel,
	                    dataLabelWidth,
	                    labelPos,
	                    labelHeight,
	                    halves = [ // divide the points into right and left halves for anti collision
	                        [], // right
	                        [] // left
	                    ],
	                    x,
	                    y,
	                    visibility,
	                    j,
	                    overflow = [0, 0, 0, 0]; // top, right, bottom, left
	
	                // get out if not enabled
	                if (!series.visible || (!options.enabled && !series._hasPointLabels)) {
	                    return;
	                }
	
	                // Reset all labels that have been shortened
	                each(data, function(point) {
	                    if (point.dataLabel && point.visible && point.dataLabel.shortened) {
	                        point.dataLabel
	                            .attr({
	                                width: 'auto'
	                            }).css({
	                                width: 'auto',
	                                textOverflow: 'clip'
	                            });
	                        point.dataLabel.shortened = false;
	                    }
	                });
	
	
	                // run parent method
	                Series.prototype.drawDataLabels.apply(series);
	
	                each(data, function(point) {
	                    if (point.dataLabel && point.visible) { // #407, #2510
	
	                        // Arrange points for detection collision
	                        halves[point.half].push(point);
	
	                        // Reset positions (#4905)
	                        point.dataLabel._pos = null;
	                    }
	                });
	
	                /* Loop over the points in each half, starting from the top and bottom
	                 * of the pie to detect overlapping labels.
	                 */
	                each(halves, function(points, i) {
	
	                    var top,
	                        bottom,
	                        length = points.length,
	                        positions = [],
	                        naturalY,
	                        sideOverflow,
	                        positionsIndex, // Point index in positions array.
	                        size;
	
	                    if (!length) {
	                        return;
	                    }
	
	                    // Sort by angle
	                    series.sortByAngle(points, i - 0.5);
	                    // Only do anti-collision when we have dataLabels outside the pie 
	                    // and have connectors. (#856)
	                    if (series.maxLabelDistance > 0) {
	                        top = Math.max(
	                            0,
	                            centerY - radius - series.maxLabelDistance
	                        );
	                        bottom = Math.min(
	                            centerY + radius + series.maxLabelDistance,
	                            chart.plotHeight
	                        );
	                        each(points, function(point) {
	                            // check if specific points' label is outside the pie
	                            if (point.labelDistance > 0 && point.dataLabel) {
	                                // point.top depends on point.labelDistance value
	                                // Used for calculation of y value in getX method 
	                                point.top = Math.max(
	                                    0,
	                                    centerY - radius - point.labelDistance
	                                );
	                                point.bottom = Math.min(
	                                    centerY + radius + point.labelDistance,
	                                    chart.plotHeight
	                                );
	                                size = point.dataLabel.getBBox().height || 21;
	
	                                // point.positionsIndex is needed for getting index of 
	                                // parameter related to specific point inside positions 
	                                // array - not every point is in positions array.
	                                point.positionsIndex = positions.push({
	                                    target: point.labelPos[1] - point.top + size / 2,
	                                    size: size,
	                                    rank: point.y
	                                }) - 1;
	                            }
	                        });
	                        H.distribute(positions, bottom + size - top);
	                    }
	
	                    // Now the used slots are sorted, fill them up sequentially
	                    for (j = 0; j < length; j++) {
	
	                        point = points[j];
	                        positionsIndex = point.positionsIndex;
	                        labelPos = point.labelPos;
	                        dataLabel = point.dataLabel;
	                        visibility = point.visible === false ? 'hidden' : 'inherit';
	                        naturalY = labelPos[1];
	
	                        if (positions && defined(positions[positionsIndex])) {
	                            if (positions[positionsIndex].pos === undefined) {
	                                visibility = 'hidden';
	                            } else {
	                                labelHeight = positions[positionsIndex].size;
	                                y = point.top + positions[positionsIndex].pos;
	                            }
	
	                        } else {
	                            y = naturalY;
	                        }
	
	                        // It is needed to delete point.positionIndex for 
	                        // dynamically added points etc.
	
	                        delete point.positionIndex;
	
	                        // get the x - use the natural x position for labels near the 
	                        // top and bottom, to prevent the top and botton slice connectors 
	                        // from touching each other on either side
	                        if (options.justify) {
	                            x = seriesCenter[0] + (i ? -1 : 1) * (radius + point.labelDistance);
	                        } else {
	                            x = series.getX(y < point.top + 2 || y > point.bottom - 2 ? naturalY : y, i, point);
	                        }
	
	
	                        // Record the placement and visibility
	                        dataLabel._attr = {
	                            visibility: visibility,
	                            align: labelPos[6]
	                        };
	                        dataLabel._pos = {
	                            x: x + options.x +
	                                ({
	                                    left: connectorPadding,
	                                    right: -connectorPadding
	                                }[labelPos[6]] || 0),
	                            y: y + options.y - 10 // 10 is for the baseline (label vs text)
	                        };
	                        labelPos.x = x;
	                        labelPos.y = y;
	
	
	                        // Detect overflowing data labels
	                        if (pick(options.crop, true)) {
	                            dataLabelWidth = dataLabel.getBBox().width;
	
	                            sideOverflow = null;
	                            // Overflow left
	                            if (x - dataLabelWidth < connectorPadding) {
	                                sideOverflow = Math.round(
	                                    dataLabelWidth - x + connectorPadding
	                                );
	                                overflow[3] = Math.max(sideOverflow, overflow[3]);
	
	                                // Overflow right
	                            } else if (
	                                x + dataLabelWidth >
	                                plotWidth - connectorPadding
	                            ) {
	                                sideOverflow = Math.round(
	                                    x + dataLabelWidth - plotWidth + connectorPadding
	                                );
	                                overflow[1] = Math.max(sideOverflow, overflow[1]);
	                            }
	
	                            // Overflow top
	                            if (y - labelHeight / 2 < 0) {
	                                overflow[0] = Math.max(
	                                    Math.round(-y + labelHeight / 2),
	                                    overflow[0]
	                                );
	
	                                // Overflow left
	                            } else if (y + labelHeight / 2 > plotHeight) {
	                                overflow[2] = Math.max(
	                                    Math.round(y + labelHeight / 2 - plotHeight),
	                                    overflow[2]
	                                );
	                            }
	                            dataLabel.sideOverflow = sideOverflow;
	                        }
	                    } // for each point
	                }); // for each half
	
	                // Do not apply the final placement and draw the connectors until we have verified
	                // that labels are not spilling over.
	                if (arrayMax(overflow) === 0 || this.verifyDataLabelOverflow(overflow)) {
	
	                    // Place the labels in the final position
	                    this.placeDataLabels();
	
	                    // Draw the connectors
	                    if (connectorWidth) {
	                        each(this.points, function(point) {
	                            var isNew;
	
	                            connector = point.connector;
	                            dataLabel = point.dataLabel;
	
	                            if (
	                                dataLabel &&
	                                dataLabel._pos &&
	                                point.visible &&
	                                point.labelDistance > 0
	                            ) {
	                                visibility = dataLabel._attr.visibility;
	
	                                isNew = !connector;
	
	                                if (isNew) {
	                                    point.connector = connector = chart.renderer.path()
	                                        .addClass('highcharts-data-label-connector highcharts-color-' + point.colorIndex)
	                                        .add(series.dataLabelsGroup);
	
	
	                                    connector.attr({
	                                        'stroke-width': connectorWidth,
	                                        'stroke': options.connectorColor || point.color || '#666666'
	                                    });
	
	                                }
	                                connector[isNew ? 'attr' : 'animate']({
	                                    d: series.connectorPath(point.labelPos)
	                                });
	                                connector.attr('visibility', visibility);
	
	                            } else if (connector) {
	                                point.connector = connector.destroy();
	                            }
	                        });
	                    }
	                }
	            };
	
	            /**
	             * Extendable method for getting the path of the connector between the data label
	             * and the pie slice.
	             */
	            seriesTypes.pie.prototype.connectorPath = function(labelPos) {
	                var x = labelPos.x,
	                    y = labelPos.y;
	                return pick(this.options.dataLabels.softConnector, true) ? [
	                    'M',
	                    x + (labelPos[6] === 'left' ? 5 : -5), y, // end of the string at the label
	                    'C',
	                    x, y, // first break, next to the label
	                    2 * labelPos[2] - labelPos[4], 2 * labelPos[3] - labelPos[5],
	                    labelPos[2], labelPos[3], // second break
	                    'L',
	                    labelPos[4], labelPos[5] // base
	                ] : [
	                    'M',
	                    x + (labelPos[6] === 'left' ? 5 : -5), y, // end of the string at the label
	                    'L',
	                    labelPos[2], labelPos[3], // second break
	                    'L',
	                    labelPos[4], labelPos[5] // base
	                ];
	            };
	
	            /**
	             * Perform the final placement of the data labels after we have verified that they
	             * fall within the plot area.
	             */
	            seriesTypes.pie.prototype.placeDataLabels = function() {
	                each(this.points, function(point) {
	                    var dataLabel = point.dataLabel,
	                        _pos;
	                    if (dataLabel && point.visible) {
	                        _pos = dataLabel._pos;
	                        if (_pos) {
	
	                            // Shorten data labels with ellipsis if they still overflow
	                            // after the pie has reached minSize (#223).
	                            if (dataLabel.sideOverflow) {
	                                dataLabel._attr.width =
	                                    dataLabel.getBBox().width - dataLabel.sideOverflow;
	                                dataLabel.css({
	                                    width: dataLabel._attr.width + 'px',
	                                    textOverflow: 'ellipsis'
	                                });
	                                dataLabel.shortened = true;
	                            }
	
	                            dataLabel.attr(dataLabel._attr);
	                            dataLabel[dataLabel.moved ? 'animate' : 'attr'](_pos);
	                            dataLabel.moved = true;
	                        } else if (dataLabel) {
	                            dataLabel.attr({
	                                y: -9999
	                            });
	                        }
	                    }
	                }, this);
	            };
	
	            seriesTypes.pie.prototype.alignDataLabel = noop;
	
	            /**
	             * Verify whether the data labels are allowed to draw, or we should run more translation and data
	             * label positioning to keep them inside the plot area. Returns true when data labels are ready
	             * to draw.
	             */
	            seriesTypes.pie.prototype.verifyDataLabelOverflow = function(overflow) {
	
	                var center = this.center,
	                    options = this.options,
	                    centerOption = options.center,
	                    minSize = options.minSize || 80,
	                    newSize = minSize,
	                    // If a size is set, return true and don't try to shrink the pie
	                    // to fit the labels.
	                    ret = options.size !== null;
	
	                if (!ret) {
	                    // Handle horizontal size and center
	                    if (centerOption[0] !== null) { // Fixed center
	                        newSize = Math.max(center[2] -
	                            Math.max(overflow[1], overflow[3]), minSize);
	
	                    } else { // Auto center
	                        newSize = Math.max(
	                            // horizontal overflow
	                            center[2] - overflow[1] - overflow[3],
	                            minSize
	                        );
	                        // horizontal center
	                        center[0] += (overflow[3] - overflow[1]) / 2;
	                    }
	
	                    // Handle vertical size and center
	                    if (centerOption[1] !== null) { // Fixed center
	                        newSize = Math.max(Math.min(newSize, center[2] -
	                            Math.max(overflow[0], overflow[2])), minSize);
	
	                    } else { // Auto center
	                        newSize = Math.max(
	                            Math.min(
	                                newSize,
	                                // vertical overflow
	                                center[2] - overflow[0] - overflow[2]
	                            ),
	                            minSize
	                        );
	                        // vertical center
	                        center[1] += (overflow[0] - overflow[2]) / 2;
	                    }
	
	                    // If the size must be decreased, we need to run translate and
	                    // drawDataLabels again
	                    if (newSize < center[2]) {
	                        center[2] = newSize;
	                        center[3] = Math.min( // #3632
	                            relativeLength(options.innerSize || 0, newSize),
	                            newSize
	                        );
	                        this.translate(center);
	
	                        if (this.drawDataLabels) {
	                            this.drawDataLabels();
	                        }
	                        // Else, return true to indicate that the pie and its labels is
	                        // within the plot area
	                    } else {
	                        ret = true;
	                    }
	                }
	                return ret;
	            };
	        }
	
	        if (seriesTypes.column) {
	
	            /**
	             * Override the basic data label alignment by adjusting for the position of the column
	             */
	            seriesTypes.column.prototype.alignDataLabel = function(point, dataLabel, options, alignTo, isNew) {
	                var inverted = this.chart.inverted,
	                    series = point.series,
	                    dlBox = point.dlBox || point.shapeArgs, // data label box for alignment
	                    below = pick(point.below, point.plotY > pick(this.translatedThreshold, series.yAxis.len)), // point.below is used in range series
	                    inside = pick(options.inside, !!this.options.stacking), // draw it inside the box?
	                    overshoot;
	
	                // Align to the column itself, or the top of it
	                if (dlBox) { // Area range uses this method but not alignTo
	                    alignTo = merge(dlBox);
	
	                    if (alignTo.y < 0) {
	                        alignTo.height += alignTo.y;
	                        alignTo.y = 0;
	                    }
	                    overshoot = alignTo.y + alignTo.height - series.yAxis.len;
	                    if (overshoot > 0) {
	                        alignTo.height -= overshoot;
	                    }
	
	                    if (inverted) {
	                        alignTo = {
	                            x: series.yAxis.len - alignTo.y - alignTo.height,
	                            y: series.xAxis.len - alignTo.x - alignTo.width,
	                            width: alignTo.height,
	                            height: alignTo.width
	                        };
	                    }
	
	                    // Compute the alignment box
	                    if (!inside) {
	                        if (inverted) {
	                            alignTo.x += below ? 0 : alignTo.width;
	                            alignTo.width = 0;
	                        } else {
	                            alignTo.y += below ? alignTo.height : 0;
	                            alignTo.height = 0;
	                        }
	                    }
	                }
	
	
	                // When alignment is undefined (typically columns and bars), display the individual
	                // point below or above the point depending on the threshold
	                options.align = pick(
	                    options.align, !inverted || inside ? 'center' : below ? 'right' : 'left'
	                );
	                options.verticalAlign = pick(
	                    options.verticalAlign,
	                    inverted || inside ? 'middle' : below ? 'top' : 'bottom'
	                );
	
	                // Call the parent method
	                Series.prototype.alignDataLabel.call(this, point, dataLabel, options, alignTo, isNew);
	
	                // If label was justified and we have contrast, set it:
	                if (point.isLabelJustified && point.contrastColor) {
	                    point.dataLabel.css({
	                        color: point.contrastColor
	                    });
	                }
	            };
	        }
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2009-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        /**
	         * Highcharts module to hide overlapping data labels. This module is included in
	         * Highcharts.
	         */
	        var Chart = H.Chart,
	            each = H.each,
	            objectEach = H.objectEach,
	            pick = H.pick,
	            addEvent = H.addEvent;
	
	        // Collect potensial overlapping data labels. Stack labels probably don't need
	        // to be considered because they are usually accompanied by data labels that lie
	        // inside the columns.
	        Chart.prototype.callbacks.push(function(chart) {
	            function collectAndHide() {
	                var labels = [];
	
	                each(chart.yAxis || [], function(yAxis) {
	                    if (
	                        yAxis.options.stackLabels &&
	                        !yAxis.options.stackLabels.allowOverlap
	                    ) {
	                        objectEach(yAxis.stacks, function(stack) {
	                            objectEach(stack, function(stackItem) {
	                                labels.push(stackItem.label);
	                            });
	                        });
	                    }
	                });
	
	                each(chart.series || [], function(series) {
	                    var dlOptions = series.options.dataLabels,
	                        // Range series have two collections
	                        collections = series.dataLabelCollections || ['dataLabel'];
	
	                    if (
	                        (dlOptions.enabled || series._hasPointLabels) &&
	                        !dlOptions.allowOverlap &&
	                        series.visible
	                    ) { // #3866
	                        each(collections, function(coll) {
	                            each(series.points, function(point) {
	                                if (point[coll]) {
	                                    point[coll].labelrank = pick(
	                                        point.labelrank,
	                                        point.shapeArgs && point.shapeArgs.height
	                                    ); // #4118
	                                    labels.push(point[coll]);
	                                }
	                            });
	                        });
	                    }
	                });
	                chart.hideOverlappingLabels(labels);
	            }
	
	            // Do it now ...
	            collectAndHide();
	
	            // ... and after each chart redraw
	            addEvent(chart, 'redraw', collectAndHide);
	
	        });
	
	        /**
	         * Hide overlapping labels. Labels are moved and faded in and out on zoom to
	         * provide a smooth visual imression.
	         */
	        Chart.prototype.hideOverlappingLabels = function(labels) {
	
	            var len = labels.length,
	                label,
	                i,
	                j,
	                label1,
	                label2,
	                isIntersecting,
	                pos1,
	                pos2,
	                parent1,
	                parent2,
	                padding,
	                bBox,
	                intersectRect = function(x1, y1, w1, h1, x2, y2, w2, h2) {
	                    return !(
	                        x2 > x1 + w1 ||
	                        x2 + w2 < x1 ||
	                        y2 > y1 + h1 ||
	                        y2 + h2 < y1
	                    );
	                };
	
	            for (i = 0; i < len; i++) {
	                label = labels[i];
	                if (label) {
	
	                    // Mark with initial opacity
	                    label.oldOpacity = label.opacity;
	                    label.newOpacity = 1;
	
	                    // Get width and height if pure text nodes (stack labels)
	                    if (!label.width) {
	                        bBox = label.getBBox();
	                        label.width = bBox.width;
	                        label.height = bBox.height;
	                    }
	                }
	            }
	
	            // Prevent a situation in a gradually rising slope, that each label will
	            // hide the previous one because the previous one always has lower rank.
	            labels.sort(function(a, b) {
	                return (b.labelrank || 0) - (a.labelrank || 0);
	            });
	
	            // Detect overlapping labels
	            for (i = 0; i < len; i++) {
	                label1 = labels[i];
	
	                for (j = i + 1; j < len; ++j) {
	                    label2 = labels[j];
	                    if (
	                        label1 && label2 &&
	                        label1 !== label2 && // #6465, polar chart with connectEnds
	                        label1.placed && label2.placed &&
	                        label1.newOpacity !== 0 && label2.newOpacity !== 0
	                    ) {
	                        pos1 = label1.alignAttr;
	                        pos2 = label2.alignAttr;
	                        // Different panes have different positions
	                        parent1 = label1.parentGroup;
	                        parent2 = label2.parentGroup;
	                        // Substract the padding if no background or border (#4333)
	                        padding = 2 * (label1.box ? 0 : (label1.padding || 0));
	                        isIntersecting = intersectRect(
	                            pos1.x + parent1.translateX,
	                            pos1.y + parent1.translateY,
	                            label1.width - padding,
	                            label1.height - padding,
	                            pos2.x + parent2.translateX,
	                            pos2.y + parent2.translateY,
	                            label2.width - padding,
	                            label2.height - padding
	                        );
	
	                        if (isIntersecting) {
	                            (label1.labelrank < label2.labelrank ? label1 : label2)
	                            .newOpacity = 0;
	                        }
	                    }
	                }
	            }
	
	            // Hide or show
	            each(labels, function(label) {
	                var complete,
	                    newOpacity;
	
	                if (label) {
	                    newOpacity = label.newOpacity;
	
	                    if (label.oldOpacity !== newOpacity && label.placed) {
	
	                        // Make sure the label is completely hidden to avoid catching
	                        // clicks (#4362)
	                        if (newOpacity) {
	                            label.show(true);
	                        } else {
	                            complete = function() {
	                                label.hide();
	                            };
	                        }
	
	                        // Animate or set the opacity					
	                        label.alignAttr.opacity = newOpacity;
	                        label[label.isOld ? 'animate' : 'attr'](
	                            label.alignAttr,
	                            null,
	                            complete
	                        );
	
	                    }
	                    label.isOld = true;
	                }
	            });
	        };
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var addEvent = H.addEvent,
	            Chart = H.Chart,
	            createElement = H.createElement,
	            css = H.css,
	            defaultOptions = H.defaultOptions,
	            defaultPlotOptions = H.defaultPlotOptions,
	            each = H.each,
	            extend = H.extend,
	            fireEvent = H.fireEvent,
	            hasTouch = H.hasTouch,
	            inArray = H.inArray,
	            isObject = H.isObject,
	            Legend = H.Legend,
	            merge = H.merge,
	            pick = H.pick,
	            Point = H.Point,
	            Series = H.Series,
	            seriesTypes = H.seriesTypes,
	            svg = H.svg,
	            TrackerMixin;
	
	        /**
	         * TrackerMixin for points and graphs.
	         */
	        TrackerMixin = H.TrackerMixin = {
	
	            /**
	             * Draw the tracker for a point.
	             */
	            drawTrackerPoint: function() {
	                var series = this,
	                    chart = series.chart,
	                    pointer = chart.pointer,
	                    onMouseOver = function(e) {
	                        var point = pointer.getPointFromEvent(e);
	                        // undefined on graph in scatterchart
	                        if (point !== undefined) {
	                            pointer.isDirectTouch = true;
	                            point.onMouseOver(e);
	                        }
	                    };
	
	                // Add reference to the point
	                each(series.points, function(point) {
	                    if (point.graphic) {
	                        point.graphic.element.point = point;
	                    }
	                    if (point.dataLabel) {
	                        if (point.dataLabel.div) {
	                            point.dataLabel.div.point = point;
	                        } else {
	                            point.dataLabel.element.point = point;
	                        }
	                    }
	                });
	
	                // Add the event listeners, we need to do this only once
	                if (!series._hasTracking) {
	                    each(series.trackerGroups, function(key) {
	                        if (series[key]) { // we don't always have dataLabelsGroup
	                            series[key]
	                                .addClass('highcharts-tracker')
	                                .on('mouseover', onMouseOver)
	                                .on('mouseout', function(e) {
	                                    pointer.onTrackerMouseOut(e);
	                                });
	                            if (hasTouch) {
	                                series[key].on('touchstart', onMouseOver);
	                            }
	
	
	                            if (series.options.cursor) {
	                                series[key]
	                                    .css(css)
	                                    .css({
	                                        cursor: series.options.cursor
	                                    });
	                            }
	
	                        }
	                    });
	                    series._hasTracking = true;
	                }
	            },
	
	            /**
	             * Draw the tracker object that sits above all data labels and markers to
	             * track mouse events on the graph or points. For the line type charts
	             * the tracker uses the same graphPath, but with a greater stroke width
	             * for better control.
	             */
	            drawTrackerGraph: function() {
	                var series = this,
	                    options = series.options,
	                    trackByArea = options.trackByArea,
	                    trackerPath = [].concat(trackByArea ? series.areaPath : series.graphPath),
	                    trackerPathLength = trackerPath.length,
	                    chart = series.chart,
	                    pointer = chart.pointer,
	                    renderer = chart.renderer,
	                    snap = chart.options.tooltip.snap,
	                    tracker = series.tracker,
	                    i,
	                    onMouseOver = function() {
	                        if (chart.hoverSeries !== series) {
	                            series.onMouseOver();
	                        }
	                    },
	                    /*
	                     * Empirical lowest possible opacities for TRACKER_FILL for an element to stay invisible but clickable
	                     * IE6: 0.002
	                     * IE7: 0.002
	                     * IE8: 0.002
	                     * IE9: 0.00000000001 (unlimited)
	                     * IE10: 0.0001 (exporting only)
	                     * FF: 0.00000000001 (unlimited)
	                     * Chrome: 0.000001
	                     * Safari: 0.000001
	                     * Opera: 0.00000000001 (unlimited)
	                     */
	                    TRACKER_FILL = 'rgba(192,192,192,' + (svg ? 0.0001 : 0.002) + ')';
	
	                // Extend end points. A better way would be to use round linecaps,
	                // but those are not clickable in VML.
	                if (trackerPathLength && !trackByArea) {
	                    i = trackerPathLength + 1;
	                    while (i--) {
	                        if (trackerPath[i] === 'M') { // extend left side
	                            trackerPath.splice(i + 1, 0, trackerPath[i + 1] - snap, trackerPath[i + 2], 'L');
	                        }
	                        if ((i && trackerPath[i] === 'M') || i === trackerPathLength) { // extend right side
	                            trackerPath.splice(i, 0, 'L', trackerPath[i - 2] + snap, trackerPath[i - 1]);
	                        }
	                    }
	                }
	
	                // handle single points
	                /*for (i = 0; i < singlePoints.length; i++) {
	                	singlePoint = singlePoints[i];
	                	trackerPath.push(M, singlePoint.plotX - snap, singlePoint.plotY,
	                	L, singlePoint.plotX + snap, singlePoint.plotY);
	                }*/
	
	                // draw the tracker
	                if (tracker) {
	                    tracker.attr({
	                        d: trackerPath
	                    });
	                } else if (series.graph) { // create
	
	                    series.tracker = renderer.path(trackerPath)
	                        .attr({
	                            'stroke-linejoin': 'round', // #1225
	                            visibility: series.visible ? 'visible' : 'hidden',
	                            stroke: TRACKER_FILL,
	                            fill: trackByArea ? TRACKER_FILL : 'none',
	                            'stroke-width': series.graph.strokeWidth() + (trackByArea ? 0 : 2 * snap),
	                            zIndex: 2
	                        })
	                        .add(series.group);
	
	                    // The tracker is added to the series group, which is clipped, but is covered
	                    // by the marker group. So the marker group also needs to capture events.
	                    each([series.tracker, series.markerGroup], function(tracker) {
	                        tracker.addClass('highcharts-tracker')
	                            .on('mouseover', onMouseOver)
	                            .on('mouseout', function(e) {
	                                pointer.onTrackerMouseOut(e);
	                            });
	
	
	                        if (options.cursor) {
	                            tracker.css({
	                                cursor: options.cursor
	                            });
	                        }
	
	
	                        if (hasTouch) {
	                            tracker.on('touchstart', onMouseOver);
	                        }
	                    });
	                }
	            }
	        };
	        /* End TrackerMixin */
	
	
	        /**
	         * Add tracking event listener to the series group, so the point graphics
	         * themselves act as trackers
	         */
	
	        if (seriesTypes.column) {
	            seriesTypes.column.prototype.drawTracker = TrackerMixin.drawTrackerPoint;
	        }
	
	        if (seriesTypes.pie) {
	            seriesTypes.pie.prototype.drawTracker = TrackerMixin.drawTrackerPoint;
	        }
	
	        if (seriesTypes.scatter) {
	            seriesTypes.scatter.prototype.drawTracker = TrackerMixin.drawTrackerPoint;
	        }
	
	        /*
	         * Extend Legend for item events
	         */
	        extend(Legend.prototype, {
	
	            setItemEvents: function(item, legendItem, useHTML) {
	                var legend = this,
	                    boxWrapper = legend.chart.renderer.boxWrapper,
	                    activeClass = 'highcharts-legend-' + (item.series ? 'point' : 'series') + '-active';
	
	                // Set the events on the item group, or in case of useHTML, the item itself (#1249)
	                (useHTML ? legendItem : item.legendGroup).on('mouseover', function() {
	                        item.setState('hover');
	
	                        // A CSS class to dim or hide other than the hovered series
	                        boxWrapper.addClass(activeClass);
	
	
	                        legendItem.css(legend.options.itemHoverStyle);
	
	                    })
	                    .on('mouseout', function() {
	
	                        legendItem.css(merge(item.visible ? legend.itemStyle : legend.itemHiddenStyle));
	
	
	                        // A CSS class to dim or hide other than the hovered series
	                        boxWrapper.removeClass(activeClass);
	
	                        item.setState();
	                    })
	                    .on('click', function(event) {
	                        var strLegendItemClick = 'legendItemClick',
	                            fnLegendItemClick = function() {
	                                if (item.setVisible) {
	                                    item.setVisible();
	                                }
	                            };
	
	                        // Pass over the click/touch event. #4.
	                        event = {
	                            browserEvent: event
	                        };
	
	                        // click the name or symbol
	                        if (item.firePointEvent) { // point
	                            item.firePointEvent(strLegendItemClick, event, fnLegendItemClick);
	                        } else {
	                            fireEvent(item, strLegendItemClick, event, fnLegendItemClick);
	                        }
	                    });
	            },
	
	            createCheckboxForItem: function(item) {
	                var legend = this;
	
	                item.checkbox = createElement('input', {
	                    type: 'checkbox',
	                    checked: item.selected,
	                    defaultChecked: item.selected // required by IE7
	                }, legend.options.itemCheckboxStyle, legend.chart.container);
	
	                addEvent(item.checkbox, 'click', function(event) {
	                    var target = event.target;
	                    fireEvent(
	                        item.series || item,
	                        'checkboxClick', { // #3712
	                            checked: target.checked,
	                            item: item
	                        },
	                        function() {
	                            item.select();
	                        }
	                    );
	                });
	            }
	        });
	
	
	
	        // Add pointer cursor to legend itemstyle in defaultOptions
	        defaultOptions.legend.itemStyle.cursor = 'pointer';
	
	
	
	        /*
	         * Extend the Chart object with interaction
	         */
	
	        extend(Chart.prototype, /** @lends Chart.prototype */ {
	            /**
	             * Display the zoom button.
	             *
	             * @private
	             */
	            showResetZoom: function() {
	                var chart = this,
	                    lang = defaultOptions.lang,
	                    btnOptions = chart.options.chart.resetZoomButton,
	                    theme = btnOptions.theme,
	                    states = theme.states,
	                    alignTo = btnOptions.relativeTo === 'chart' ? null : 'plotBox';
	
	                function zoomOut() {
	                    chart.zoomOut();
	                }
	
	                this.resetZoomButton = chart.renderer.button(lang.resetZoom, null, null, zoomOut, theme, states && states.hover)
	                    .attr({
	                        align: btnOptions.position.align,
	                        title: lang.resetZoomTitle
	                    })
	                    .addClass('highcharts-reset-zoom')
	                    .add()
	                    .align(btnOptions.position, false, alignTo);
	
	            },
	
	            /**
	             * Zoom out to 1:1.
	             *
	             * @private
	             */
	            zoomOut: function() {
	                var chart = this;
	                fireEvent(chart, 'selection', {
	                    resetSelection: true
	                }, function() {
	                    chart.zoom();
	                });
	            },
	
	            /**
	             * Zoom into a given portion of the chart given by axis coordinates.
	             * @param {Object} event
	             *
	             * @private
	             */
	            zoom: function(event) {
	                var chart = this,
	                    hasZoomed,
	                    pointer = chart.pointer,
	                    displayButton = false,
	                    resetZoomButton;
	
	                // If zoom is called with no arguments, reset the axes
	                if (!event || event.resetSelection) {
	                    each(chart.axes, function(axis) {
	                        hasZoomed = axis.zoom();
	                    });
	                    pointer.initiated = false; // #6804
	
	                } else { // else, zoom in on all axes
	                    each(event.xAxis.concat(event.yAxis), function(axisData) {
	                        var axis = axisData.axis,
	                            isXAxis = axis.isXAxis;
	
	                        // don't zoom more than minRange
	                        if (pointer[isXAxis ? 'zoomX' : 'zoomY']) {
	                            hasZoomed = axis.zoom(axisData.min, axisData.max);
	                            if (axis.displayBtn) {
	                                displayButton = true;
	                            }
	                        }
	                    });
	                }
	
	                // Show or hide the Reset zoom button
	                resetZoomButton = chart.resetZoomButton;
	                if (displayButton && !resetZoomButton) {
	                    chart.showResetZoom();
	                } else if (!displayButton && isObject(resetZoomButton)) {
	                    chart.resetZoomButton = resetZoomButton.destroy();
	                }
	
	
	                // Redraw
	                if (hasZoomed) {
	                    chart.redraw(
	                        pick(chart.options.chart.animation, event && event.animation, chart.pointCount < 100) // animation
	                    );
	                }
	            },
	
	            /**
	             * Pan the chart by dragging the mouse across the pane. This function is
	             * called on mouse move, and the distance to pan is computed from chartX
	             * compared to the first chartX position in the dragging operation.
	             *
	             * @private
	             */
	            pan: function(e, panning) {
	
	                var chart = this,
	                    hoverPoints = chart.hoverPoints,
	                    doRedraw;
	
	                // remove active points for shared tooltip
	                if (hoverPoints) {
	                    each(hoverPoints, function(point) {
	                        point.setState();
	                    });
	                }
	
	                each(panning === 'xy' ? [1, 0] : [1], function(isX) { // xy is used in maps
	                    var axis = chart[isX ? 'xAxis' : 'yAxis'][0],
	                        horiz = axis.horiz,
	                        mousePos = e[horiz ? 'chartX' : 'chartY'],
	                        mouseDown = horiz ? 'mouseDownX' : 'mouseDownY',
	                        startPos = chart[mouseDown],
	                        halfPointRange = (axis.pointRange || 0) / 2,
	                        extremes = axis.getExtremes(),
	                        panMin = axis.toValue(startPos - mousePos, true) +
	                        halfPointRange,
	                        panMax = axis.toValue(startPos + axis.len - mousePos, true) -
	                        halfPointRange,
	                        flipped = panMax < panMin,
	                        newMin = flipped ? panMax : panMin,
	                        newMax = flipped ? panMin : panMax,
	                        paddedMin = Math.min(
	                            extremes.dataMin,
	                            axis.toValue(
	                                axis.toPixels(extremes.min) - axis.minPixelPadding
	                            )
	                        ),
	                        paddedMax = Math.max(
	                            extremes.dataMax,
	                            axis.toValue(
	                                axis.toPixels(extremes.max) + axis.minPixelPadding
	                            )
	                        ),
	                        spill;
	
	                    // If the new range spills over, either to the min or max, adjust
	                    // the new range.
	                    spill = paddedMin - newMin;
	                    if (spill > 0) {
	                        newMax += spill;
	                        newMin = paddedMin;
	                    }
	                    spill = newMax - paddedMax;
	                    if (spill > 0) {
	                        newMax = paddedMax;
	                        newMin -= spill;
	                    }
	
	                    // Set new extremes if they are actually new
	                    if (axis.series.length && newMin !== extremes.min && newMax !== extremes.max) {
	                        axis.setExtremes(
	                            newMin,
	                            newMax,
	                            false,
	                            false, {
	                                trigger: 'pan'
	                            }
	                        );
	                        doRedraw = true;
	                    }
	
	                    chart[mouseDown] = mousePos; // set new reference for next run
	                });
	
	                if (doRedraw) {
	                    chart.redraw(false);
	                }
	                css(chart.container, {
	                    cursor: 'move'
	                });
	            }
	        });
	
	        /*
	         * Extend the Point object with interaction
	         */
	        extend(Point.prototype, /** @lends Highcharts.Point.prototype */ {
	            /**
	             * Toggle the selection status of a point.
	             * @param  {Boolean} [selected]
	             *         When `true`, the point is selected. When `false`, the point is
	             *         unselected. When `null` or `undefined`, the selection state is
	             *         toggled.
	             * @param  {Boolean} [accumulate=false]
	             *         When `true`, the selection is added to other selected points.
	             *         When `false`, other selected points are deselected. Internally in
	             *         Highcharts, when {@link http://api.highcharts.com/highcharts/plotOptions.series.allowPointSelect|allowPointSelect}
	             *         is `true`, selected points are accumulated on Control, Shift or
	             *         Cmd clicking the point.
	             *
	             * @see    Highcharts.Chart#getSelectedPoints
	             *
	             * @sample highcharts/members/point-select/
	             *         Select a point from a button
	             * @sample highcharts/chart/events-selection-points/
	             *         Select a range of points through a drag selection
	             * @sample maps/series/data-id/
	             *         Select a point in Highmaps
	             */
	            select: function(selected, accumulate) {
	                var point = this,
	                    series = point.series,
	                    chart = series.chart;
	
	                selected = pick(selected, !point.selected);
	
	                // fire the event with the default handler
	                point.firePointEvent(selected ? 'select' : 'unselect', {
	                    accumulate: accumulate
	                }, function() {
	
	                    /**
	                     * Whether the point is selected or not. 
	                     * @see Point#select
	                     * @see Chart#getSelectedPoints
	                     * @memberof Point
	                     * @name selected
	                     * @type {Boolean}
	                     */
	                    point.selected = point.options.selected = selected;
	                    series.options.data[inArray(point, series.data)] = point.options;
	
	                    point.setState(selected && 'select');
	
	                    // unselect all other points unless Ctrl or Cmd + click
	                    if (!accumulate) {
	                        each(chart.getSelectedPoints(), function(loopPoint) {
	                            if (loopPoint.selected && loopPoint !== point) {
	                                loopPoint.selected = loopPoint.options.selected = false;
	                                series.options.data[inArray(loopPoint, series.data)] = loopPoint.options;
	                                loopPoint.setState('');
	                                loopPoint.firePointEvent('unselect');
	                            }
	                        });
	                    }
	                });
	            },
	
	            /**
	             * Runs on mouse over the point. Called internally from mouse and touch
	             * events.
	             * 
	             * @param {Object} e The event arguments
	             */
	            onMouseOver: function(e) {
	                var point = this,
	                    series = point.series,
	                    chart = series.chart,
	                    pointer = chart.pointer;
	                e = e ?
	                    pointer.normalize(e) :
	                    // In cases where onMouseOver is called directly without an event
	                    pointer.getChartCoordinatesFromPoint(point, chart.inverted);
	                pointer.runPointActions(e, point);
	            },
	
	            /**
	             * Runs on mouse out from the point. Called internally from mouse and touch
	             * events.
	             */
	            onMouseOut: function() {
	                var point = this,
	                    chart = point.series.chart;
	                point.firePointEvent('mouseOut');
	                each(chart.hoverPoints || [], function(p) {
	                    p.setState();
	                });
	                chart.hoverPoints = chart.hoverPoint = null;
	            },
	
	            /**
	             * Import events from the series' and point's options. Only do it on
	             * demand, to save processing time on hovering.
	             *
	             * @private
	             */
	            importEvents: function() {
	                if (!this.hasImportedEvents) {
	                    var point = this,
	                        options = merge(point.series.options.point, point.options),
	                        events = options.events;
	
	                    point.events = events;
	
	                    H.objectEach(events, function(event, eventType) {
	                        addEvent(point, eventType, event);
	                    });
	                    this.hasImportedEvents = true;
	
	                }
	            },
	
	            /**
	             * Set the point's state.
	             * @param  {String} [state]
	             *         The new state, can be one of `''` (an empty string), `hover` or
	             *         `select`.
	             */
	            setState: function(state, move) {
	                var point = this,
	                    plotX = Math.floor(point.plotX), // #4586
	                    plotY = point.plotY,
	                    series = point.series,
	                    stateOptions = series.options.states[state] || {},
	                    markerOptions = defaultPlotOptions[series.type].marker &&
	                    series.options.marker,
	                    normalDisabled = markerOptions && markerOptions.enabled === false,
	                    markerStateOptions = (markerOptions && markerOptions.states &&
	                        markerOptions.states[state]) || {},
	                    stateDisabled = markerStateOptions.enabled === false,
	                    stateMarkerGraphic = series.stateMarkerGraphic,
	                    pointMarker = point.marker || {},
	                    chart = series.chart,
	                    halo = series.halo,
	                    haloOptions,
	                    markerAttribs,
	                    hasMarkers = markerOptions && series.markerAttribs,
	                    newSymbol;
	
	                state = state || ''; // empty string
	
	                if (
	                    // already has this state
	                    (state === point.state && !move) ||
	
	                    // selected points don't respond to hover
	                    (point.selected && state !== 'select') ||
	
	                    // series' state options is disabled
	                    (stateOptions.enabled === false) ||
	
	                    // general point marker's state options is disabled
	                    (state && (
	                        stateDisabled ||
	                        (normalDisabled && markerStateOptions.enabled === false)
	                    )) ||
	
	                    // individual point marker's state options is disabled
	                    (
	                        state &&
	                        pointMarker.states &&
	                        pointMarker.states[state] &&
	                        pointMarker.states[state].enabled === false
	                    ) // #1610
	
	                ) {
	                    return;
	                }
	
	                if (hasMarkers) {
	                    markerAttribs = series.markerAttribs(point, state);
	                }
	
	                // Apply hover styles to the existing point
	                if (point.graphic) {
	
	                    if (point.state) {
	                        point.graphic.removeClass('highcharts-point-' + point.state);
	                    }
	                    if (state) {
	                        point.graphic.addClass('highcharts-point-' + state);
	                    }
	
	                    /*attribs = radius ? { // new symbol attributes (#507, #612)
	                    	x: plotX - radius,
	                    	y: plotY - radius,
	                    	width: 2 * radius,
	                    	height: 2 * radius
	                    } : {};*/
	
	
	                    //attribs = merge(series.pointAttribs(point, state), attribs);
	                    point.graphic.animate(
	                        series.pointAttribs(point, state),
	                        pick(
	                            chart.options.chart.animation,
	                            stateOptions.animation
	                        )
	                    );
	
	
	                    if (markerAttribs) {
	                        point.graphic.animate(
	                            markerAttribs,
	                            pick(
	                                chart.options.chart.animation, // Turn off globally
	                                markerStateOptions.animation,
	                                markerOptions.animation
	                            )
	                        );
	                    }
	
	                    // Zooming in from a range with no markers to a range with markers
	                    if (stateMarkerGraphic) {
	                        stateMarkerGraphic.hide();
	                    }
	                } else {
	                    // if a graphic is not applied to each point in the normal state, create a shared
	                    // graphic for the hover state
	                    if (state && markerStateOptions) {
	                        newSymbol = pointMarker.symbol || series.symbol;
	
	                        // If the point has another symbol than the previous one, throw away the
	                        // state marker graphic and force a new one (#1459)
	                        if (stateMarkerGraphic && stateMarkerGraphic.currentSymbol !== newSymbol) {
	                            stateMarkerGraphic = stateMarkerGraphic.destroy();
	                        }
	
	                        // Add a new state marker graphic
	                        if (!stateMarkerGraphic) {
	                            if (newSymbol) {
	                                series.stateMarkerGraphic = stateMarkerGraphic = chart.renderer.symbol(
	                                        newSymbol,
	                                        markerAttribs.x,
	                                        markerAttribs.y,
	                                        markerAttribs.width,
	                                        markerAttribs.height
	                                    )
	                                    .add(series.markerGroup);
	                                stateMarkerGraphic.currentSymbol = newSymbol;
	                            }
	
	                            // Move the existing graphic
	                        } else {
	                            stateMarkerGraphic[move ? 'animate' : 'attr']({ // #1054
	                                x: markerAttribs.x,
	                                y: markerAttribs.y
	                            });
	                        }
	
	                        if (stateMarkerGraphic) {
	                            stateMarkerGraphic.attr(series.pointAttribs(point, state));
	                        }
	
	                    }
	
	                    if (stateMarkerGraphic) {
	                        stateMarkerGraphic[state && chart.isInsidePlot(plotX, plotY, chart.inverted) ? 'show' : 'hide'](); // #2450
	                        stateMarkerGraphic.element.point = point; // #4310
	                    }
	                }
	
	                // Show me your halo
	                haloOptions = stateOptions.halo;
	                if (haloOptions && haloOptions.size) {
	                    if (!halo) {
	                        series.halo = halo = chart.renderer.path()
	                            // #5818, #5903, #6705
	                            .add((point.graphic || stateMarkerGraphic).parentGroup);
	                    }
	                    halo[move ? 'animate' : 'attr']({
	                        d: point.haloPath(haloOptions.size)
	                    });
	                    halo.attr({
	                        'class': 'highcharts-halo highcharts-color-' +
	                            pick(point.colorIndex, series.colorIndex)
	                    });
	                    halo.point = point; // #6055
	
	
	                    halo.attr(extend({
	                        'fill': point.color || series.color,
	                        'fill-opacity': haloOptions.opacity,
	                        'zIndex': -1 // #4929, IE8 added halo above everything
	                    }, haloOptions.attributes));
	
	
	                } else if (halo && halo.point && halo.point.haloPath) {
	                    // Animate back to 0 on the current halo point (#6055)
	                    halo.animate({
	                        d: halo.point.haloPath(0)
	                    });
	                }
	
	                point.state = state;
	            },
	
	            /**
	             * Get the path definition for the halo, which is usually a shadow-like
	             * circle around the currently hovered point.
	             * @param  {Number} size
	             *         The radius of the circular halo.
	             * @return {Array} The path definition
	             */
	            haloPath: function(size) {
	                var series = this.series,
	                    chart = series.chart;
	
	                return chart.renderer.symbols.circle(
	                    Math.floor(this.plotX) - size,
	                    this.plotY - size,
	                    size * 2,
	                    size * 2
	                );
	            }
	        });
	
	        /*
	         * Extend the Series object with interaction
	         */
	
	        extend(Series.prototype, /** @lends Highcharts.Series.prototype */ {
	            /**
	             * Runs on mouse over the series graphical items.
	             */
	            onMouseOver: function() {
	                var series = this,
	                    chart = series.chart,
	                    hoverSeries = chart.hoverSeries;
	
	                // set normal state to previous series
	                if (hoverSeries && hoverSeries !== series) {
	                    hoverSeries.onMouseOut();
	                }
	
	                // trigger the event, but to save processing time,
	                // only if defined
	                if (series.options.events.mouseOver) {
	                    fireEvent(series, 'mouseOver');
	                }
	
	                // hover this
	                series.setState('hover');
	                chart.hoverSeries = series;
	            },
	
	            /**
	             * Runs on mouse out of the series graphical items.
	             */
	            onMouseOut: function() {
	                // trigger the event only if listeners exist
	                var series = this,
	                    options = series.options,
	                    chart = series.chart,
	                    tooltip = chart.tooltip,
	                    hoverPoint = chart.hoverPoint;
	
	                chart.hoverSeries = null; // #182, set to null before the mouseOut event fires
	
	                // trigger mouse out on the point, which must be in this series
	                if (hoverPoint) {
	                    hoverPoint.onMouseOut();
	                }
	
	                // fire the mouse out event
	                if (series && options.events.mouseOut) {
	                    fireEvent(series, 'mouseOut');
	                }
	
	
	                // hide the tooltip
	                if (tooltip && !series.stickyTracking && (!tooltip.shared || series.noSharedTooltip)) {
	                    tooltip.hide();
	                }
	
	                // set normal state
	                series.setState();
	            },
	
	            /**
	             * Set the state of the series. Called internally on mouse interaction and
	             * select operations, but it can also be called directly to visually
	             * highlight a series.
	             *
	             * @param  {String} [state]
	             *         Can be either `hover`, `select` or undefined to set to normal
	             *         state.
	             */
	            setState: function(state) {
	                var series = this,
	                    options = series.options,
	                    graph = series.graph,
	                    stateOptions = options.states,
	                    lineWidth = options.lineWidth,
	                    attribs,
	                    i = 0;
	
	                state = state || '';
	
	                if (series.state !== state) {
	
	                    // Toggle class names
	                    each([
	                        series.group,
	                        series.markerGroup,
	                        series.dataLabelsGroup
	                    ], function(group) {
	                        if (group) {
	                            // Old state
	                            if (series.state) {
	                                group.removeClass('highcharts-series-' + series.state);
	                            }
	                            // New state
	                            if (state) {
	                                group.addClass('highcharts-series-' + state);
	                            }
	                        }
	                    });
	
	                    series.state = state;
	
	
	
	                    if (stateOptions[state] && stateOptions[state].enabled === false) {
	                        return;
	                    }
	
	                    if (state) {
	                        lineWidth = stateOptions[state].lineWidth || lineWidth + (stateOptions[state].lineWidthPlus || 0); // #4035
	                    }
	
	                    if (graph && !graph.dashstyle) { // hover is turned off for dashed lines in VML
	                        attribs = {
	                            'stroke-width': lineWidth
	                        };
	
	                        // Animate the graph stroke-width. By default a quick animation
	                        // to hover, slower to un-hover.
	                        graph.animate(
	                            attribs,
	                            pick(
	                                series.chart.options.chart.animation,
	                                stateOptions[state] && stateOptions[state].animation
	                            )
	                        );
	                        while (series['zone-graph-' + i]) {
	                            series['zone-graph-' + i].attr(attribs);
	                            i = i + 1;
	                        }
	                    }
	
	                }
	            },
	
	            /**
	             * Show or hide the series.
	             *
	             * @param  {Boolean} [visible]
	             *         True to show the series, false to hide. If undefined, the
	             *         visibility is toggled.
	             * @param  {Boolean} [redraw=true]
	             *         Whether to redraw the chart after the series is altered. If doing
	             *         more operations on the chart, it is a good idea to set redraw to
	             *         false and call {@link Chart#redraw|chart.redraw()} after.
	             */
	            setVisible: function(vis, redraw) {
	                var series = this,
	                    chart = series.chart,
	                    legendItem = series.legendItem,
	                    showOrHide,
	                    ignoreHiddenSeries = chart.options.chart.ignoreHiddenSeries,
	                    oldVisibility = series.visible;
	
	                // if called without an argument, toggle visibility
	                series.visible = vis = series.options.visible = series.userOptions.visible = vis === undefined ? !oldVisibility : vis; // #5618
	                showOrHide = vis ? 'show' : 'hide';
	
	                // show or hide elements
	                each(['group', 'dataLabelsGroup', 'markerGroup', 'tracker', 'tt'], function(key) {
	                    if (series[key]) {
	                        series[key][showOrHide]();
	                    }
	                });
	
	
	                // hide tooltip (#1361)
	                if (chart.hoverSeries === series || (chart.hoverPoint && chart.hoverPoint.series) === series) {
	                    series.onMouseOut();
	                }
	
	
	                if (legendItem) {
	                    chart.legend.colorizeItem(series, vis);
	                }
	
	
	                // rescale or adapt to resized chart
	                series.isDirty = true;
	                // in a stack, all other series are affected
	                if (series.options.stacking) {
	                    each(chart.series, function(otherSeries) {
	                        if (otherSeries.options.stacking && otherSeries.visible) {
	                            otherSeries.isDirty = true;
	                        }
	                    });
	                }
	
	                // show or hide linked series
	                each(series.linkedSeries, function(otherSeries) {
	                    otherSeries.setVisible(vis, false);
	                });
	
	                if (ignoreHiddenSeries) {
	                    chart.isDirtyBox = true;
	                }
	                if (redraw !== false) {
	                    chart.redraw();
	                }
	
	                fireEvent(series, showOrHide);
	            },
	
	            /**
	             * Show the series if hidden.
	             *
	             * @sample highcharts/members/series-hide/
	             *         Toggle visibility from a button
	             */
	            show: function() {
	                this.setVisible(true);
	            },
	
	            /**
	             * Hide the series if visible. If the {@link
	             * https://api.highcharts.com/highcharts/chart.ignoreHiddenSeries|
	             * chart.ignoreHiddenSeries} option is true, the chart is redrawn without
	             * this series.
	             *
	             * @sample highcharts/members/series-hide/
	             *         Toggle visibility from a button
	             */
	            hide: function() {
	                this.setVisible(false);
	            },
	
	
	            /**
	             * Select or unselect the series. This means its {@link
	             * Highcharts.Series.selected|selected} property is set, the checkbox in the
	             * legend is toggled and when selected, the series is returned by the
	             * {@link Highcharts.Chart#getSelectedSeries} function.
	             *
	             * @param  {Boolean} [selected]
	             *         True to select the series, false to unselect. If	undefined, the
	             *         selection state is toggled.
	             *
	             * @sample highcharts/members/series-select/
	             *         Select a series from a button
	             */
	            select: function(selected) {
	                var series = this;
	
	                series.selected = selected = (selected === undefined) ?
	                    !series.selected :
	                    selected;
	
	                if (series.checkbox) {
	                    series.checkbox.checked = selected;
	                }
	
	                fireEvent(series, selected ? 'select' : 'unselect');
	            },
	
	            drawTracker: TrackerMixin.drawTrackerGraph
	        });
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var Chart = H.Chart,
	            each = H.each,
	            inArray = H.inArray,
	            isArray = H.isArray,
	            isObject = H.isObject,
	            pick = H.pick,
	            splat = H.splat;
	
	        /**
	         * Update the chart based on the current chart/document size and options for
	         * responsiveness.
	         */
	        Chart.prototype.setResponsive = function(redraw) {
	            var options = this.options.responsive,
	                ruleIds = [],
	                currentResponsive = this.currentResponsive,
	                currentRuleIds;
	
	            if (options && options.rules) {
	                each(options.rules, function(rule) {
	                    if (rule._id === undefined) {
	                        rule._id = H.uniqueKey();
	                    }
	
	                    this.matchResponsiveRule(rule, ruleIds, redraw);
	                }, this);
	            }
	
	            // Merge matching rules
	            var mergedOptions = H.merge.apply(0, H.map(ruleIds, function(ruleId) {
	                return H.find(options.rules, function(rule) {
	                    return rule._id === ruleId;
	                }).chartOptions;
	            }));
	
	            // Stringified key for the rules that currently apply.
	            ruleIds = ruleIds.toString() || undefined;
	            currentRuleIds = currentResponsive && currentResponsive.ruleIds;
	
	
	            // Changes in what rules apply
	            if (ruleIds !== currentRuleIds) {
	
	                // Undo previous rules. Before we apply a new set of rules, we need to
	                // roll back completely to base options (#6291).
	                if (currentResponsive) {
	                    this.update(currentResponsive.undoOptions, redraw);
	                }
	
	                if (ruleIds) {
	                    // Get undo-options for matching rules
	                    this.currentResponsive = {
	                        ruleIds: ruleIds,
	                        mergedOptions: mergedOptions,
	                        undoOptions: this.currentOptions(mergedOptions)
	                    };
	
	                    this.update(mergedOptions, redraw);
	
	                } else {
	                    this.currentResponsive = undefined;
	                }
	            }
	        };
	
	        /**
	         * Handle a single responsiveness rule
	         */
	        Chart.prototype.matchResponsiveRule = function(rule, matches) {
	            var condition = rule.condition,
	                fn = condition.callback || function() {
	                    return this.chartWidth <= pick(condition.maxWidth, Number.MAX_VALUE) &&
	                        this.chartHeight <= pick(condition.maxHeight, Number.MAX_VALUE) &&
	                        this.chartWidth >= pick(condition.minWidth, 0) &&
	                        this.chartHeight >= pick(condition.minHeight, 0);
	                };
	
	            if (fn.call(this)) {
	                matches.push(rule._id);
	            }
	
	        };
	
	        /**
	         * Get the current values for a given set of options. Used before we update
	         * the chart with a new responsiveness rule.
	         * TODO: Restore axis options (by id?)
	         */
	        Chart.prototype.currentOptions = function(options) {
	
	            var ret = {};
	
	            /**
	             * Recurse over a set of options and its current values,
	             * and store the current values in the ret object.
	             */
	            function getCurrent(options, curr, ret, depth) {
	                var i;
	                H.objectEach(options, function(val, key) {
	                    if (!depth && inArray(key, ['series', 'xAxis', 'yAxis']) > -1) {
	                        options[key] = splat(options[key]);
	
	                        ret[key] = [];
	
	                        // Iterate over collections like series, xAxis or yAxis and map
	                        // the items by index.
	                        for (i = 0; i < options[key].length; i++) {
	                            if (curr[key][i]) { // Item exists in current data (#6347)
	                                ret[key][i] = {};
	                                getCurrent(
	                                    val[i],
	                                    curr[key][i],
	                                    ret[key][i],
	                                    depth + 1
	                                );
	                            }
	                        }
	                    } else if (isObject(val)) {
	                        ret[key] = isArray(val) ? [] : {};
	                        getCurrent(val, curr[key] || {}, ret[key], depth + 1);
	                    } else {
	                        ret[key] = curr[key] || null;
	                    }
	                });
	            }
	
	            getCurrent(options, this.options, ret, 0);
	            return ret;
	        };
	
	    }(Highcharts));
	    var Highcharts = (function(Highcharts) {
	
	        return Highcharts;
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var addEvent = H.addEvent,
	            Axis = H.Axis,
	            Chart = H.Chart,
	            css = H.css,
	            dateFormat = H.dateFormat,
	            defined = H.defined,
	            each = H.each,
	            extend = H.extend,
	            noop = H.noop,
	            Series = H.Series,
	            timeUnits = H.timeUnits,
	            wrap = H.wrap;
	
	        /* ****************************************************************************
	         * Start ordinal axis logic                                                   *
	         *****************************************************************************/
	
	
	        wrap(Series.prototype, 'init', function(proceed) {
	            var series = this,
	                xAxis;
	
	            // call the original function
	            proceed.apply(this, Array.prototype.slice.call(arguments, 1));
	
	            xAxis = series.xAxis;
	
	            // Destroy the extended ordinal index on updated data
	            if (xAxis && xAxis.options.ordinal) {
	                addEvent(series, 'updatedData', function() {
	                    delete xAxis.ordinalIndex;
	                });
	            }
	        });
	
	        /**
	         * In an ordinal axis, there might be areas with dense consentrations of points, then large
	         * gaps between some. Creating equally distributed ticks over this entire range
	         * may lead to a huge number of ticks that will later be removed. So instead, break the
	         * positions up in segments, find the tick positions for each segment then concatenize them.
	         * This method is used from both data grouping logic and X axis tick position logic.
	         */
	        wrap(Axis.prototype, 'getTimeTicks', function(proceed, normalizedInterval, min, max, startOfWeek, positions, closestDistance, findHigherRanks) {
	
	            var start = 0,
	                end,
	                segmentPositions,
	                higherRanks = {},
	                hasCrossedHigherRank,
	                info,
	                posLength,
	                outsideMax,
	                groupPositions = [],
	                lastGroupPosition = -Number.MAX_VALUE,
	                tickPixelIntervalOption = this.options.tickPixelInterval;
	
	            // The positions are not always defined, for example for ordinal positions when data
	            // has regular interval (#1557, #2090)
	            if ((!this.options.ordinal && !this.options.breaks) || !positions || positions.length < 3 || min === undefined) {
	                return proceed.call(this, normalizedInterval, min, max, startOfWeek);
	            }
	
	            // Analyze the positions array to split it into segments on gaps larger than 5 times
	            // the closest distance. The closest distance is already found at this point, so
	            // we reuse that instead of computing it again.
	            posLength = positions.length;
	
	            for (end = 0; end < posLength; end++) {
	
	                outsideMax = end && positions[end - 1] > max;
	
	                if (positions[end] < min) { // Set the last position before min
	                    start = end;
	                }
	
	                if (end === posLength - 1 || positions[end + 1] - positions[end] > closestDistance * 5 || outsideMax) {
	
	                    // For each segment, calculate the tick positions from the getTimeTicks utility
	                    // function. The interval will be the same regardless of how long the segment is.
	                    if (positions[end] > lastGroupPosition) { // #1475
	
	                        segmentPositions = proceed.call(this, normalizedInterval, positions[start], positions[end], startOfWeek);
	
	                        // Prevent duplicate groups, for example for multiple segments within one larger time frame (#1475)
	                        while (segmentPositions.length && segmentPositions[0] <= lastGroupPosition) {
	                            segmentPositions.shift();
	                        }
	                        if (segmentPositions.length) {
	                            lastGroupPosition = segmentPositions[segmentPositions.length - 1];
	                        }
	
	                        groupPositions = groupPositions.concat(segmentPositions);
	                    }
	                    // Set start of next segment
	                    start = end + 1;
	                }
	
	                if (outsideMax) {
	                    break;
	                }
	            }
	
	            // Get the grouping info from the last of the segments. The info is the same for
	            // all segments.
	            info = segmentPositions.info;
	
	            // Optionally identify ticks with higher rank, for example when the ticks
	            // have crossed midnight.
	            if (findHigherRanks && info.unitRange <= timeUnits.hour) {
	                end = groupPositions.length - 1;
	
	                // Compare points two by two
	                for (start = 1; start < end; start++) {
	                    if (dateFormat('%d', groupPositions[start]) !== dateFormat('%d', groupPositions[start - 1])) {
	                        higherRanks[groupPositions[start]] = 'day';
	                        hasCrossedHigherRank = true;
	                    }
	                }
	
	                // If the complete array has crossed midnight, we want to mark the first
	                // positions also as higher rank
	                if (hasCrossedHigherRank) {
	                    higherRanks[groupPositions[0]] = 'day';
	                }
	                info.higherRanks = higherRanks;
	            }
	
	            // Save the info
	            groupPositions.info = info;
	
	
	
	            // Don't show ticks within a gap in the ordinal axis, where the space between
	            // two points is greater than a portion of the tick pixel interval
	            if (findHigherRanks && defined(tickPixelIntervalOption)) { // check for squashed ticks
	
	                var length = groupPositions.length,
	                    i = length,
	                    itemToRemove,
	                    translated,
	                    translatedArr = [],
	                    lastTranslated,
	                    medianDistance,
	                    distance,
	                    distances = [];
	
	                // Find median pixel distance in order to keep a reasonably even distance between
	                // ticks (#748)
	                while (i--) {
	                    translated = this.translate(groupPositions[i]);
	                    if (lastTranslated) {
	                        distances[i] = lastTranslated - translated;
	                    }
	                    translatedArr[i] = lastTranslated = translated;
	                }
	                distances.sort();
	                medianDistance = distances[Math.floor(distances.length / 2)];
	                if (medianDistance < tickPixelIntervalOption * 0.6) {
	                    medianDistance = null;
	                }
	
	                // Now loop over again and remove ticks where needed
	                i = groupPositions[length - 1] > max ? length - 1 : length; // #817
	                lastTranslated = undefined;
	                while (i--) {
	                    translated = translatedArr[i];
	                    distance = Math.abs(lastTranslated - translated);
	                    // #4175 - when axis is reversed, the distance, is negative but 
	                    // tickPixelIntervalOption positive, so we need to compare the same values
	
	                    // Remove ticks that are closer than 0.6 times the pixel interval from the one to the right,
	                    // but not if it is close to the median distance (#748).
	                    if (lastTranslated && distance < tickPixelIntervalOption * 0.8 &&
	                        (medianDistance === null || distance < medianDistance * 0.8)) {
	
	                        // Is this a higher ranked position with a normal position to the right?
	                        if (higherRanks[groupPositions[i]] && !higherRanks[groupPositions[i + 1]]) {
	
	                            // Yes: remove the lower ranked neighbour to the right
	                            itemToRemove = i + 1;
	                            lastTranslated = translated; // #709
	
	                        } else {
	
	                            // No: remove this one
	                            itemToRemove = i;
	                        }
	
	                        groupPositions.splice(itemToRemove, 1);
	
	                    } else {
	                        lastTranslated = translated;
	                    }
	                }
	            }
	            return groupPositions;
	        });
	
	        // Extend the Axis prototype
	        extend(Axis.prototype, /** @lends Axis.prototype */ {
	
	            /**
	             * Calculate the ordinal positions before tick positions are calculated.
	             */
	            beforeSetTickPositions: function() {
	                var axis = this,
	                    len,
	                    ordinalPositions = [],
	                    useOrdinal = false,
	                    dist,
	                    extremes = axis.getExtremes(),
	                    min = extremes.min,
	                    max = extremes.max,
	                    minIndex,
	                    maxIndex,
	                    slope,
	                    hasBreaks = axis.isXAxis && !!axis.options.breaks,
	                    isOrdinal = axis.options.ordinal,
	                    ignoreHiddenSeries = axis.chart.options.chart.ignoreHiddenSeries,
	                    i;
	
	                // apply the ordinal logic
	                if (isOrdinal || hasBreaks) { // #4167 YAxis is never ordinal ?
	
	                    each(axis.series, function(series, i) {
	
	                        if ((!ignoreHiddenSeries || series.visible !== false) && (series.takeOrdinalPosition !== false || hasBreaks)) {
	
	                            // concatenate the processed X data into the existing positions, or the empty array
	                            ordinalPositions = ordinalPositions.concat(series.processedXData);
	                            len = ordinalPositions.length;
	
	                            // remove duplicates (#1588)
	                            ordinalPositions.sort(function(a, b) {
	                                return a - b; // without a custom function it is sorted as strings
	                            });
	
	                            if (len) {
	                                i = len - 1;
	                                while (i--) {
	                                    if (ordinalPositions[i] === ordinalPositions[i + 1]) {
	                                        ordinalPositions.splice(i, 1);
	                                    }
	                                }
	                            }
	                        }
	
	                    });
	
	                    // cache the length
	                    len = ordinalPositions.length;
	
	                    // Check if we really need the overhead of mapping axis data against the ordinal positions.
	                    // If the series consist of evenly spaced data any way, we don't need any ordinal logic.
	                    if (len > 2) { // two points have equal distance by default
	                        dist = ordinalPositions[1] - ordinalPositions[0];
	                        i = len - 1;
	                        while (i-- && !useOrdinal) {
	                            if (ordinalPositions[i + 1] - ordinalPositions[i] !== dist) {
	                                useOrdinal = true;
	                            }
	                        }
	
	                        // When zooming in on a week, prevent axis padding for weekends even though the data within
	                        // the week is evenly spaced.
	                        if (!axis.options.keepOrdinalPadding && (ordinalPositions[0] - min > dist || max - ordinalPositions[ordinalPositions.length - 1] > dist)) {
	                            useOrdinal = true;
	                        }
	                    }
	
	                    // Record the slope and offset to compute the linear values from the array index.
	                    // Since the ordinal positions may exceed the current range, get the start and
	                    // end positions within it (#719, #665b)
	                    if (useOrdinal) {
	
	                        // Register
	                        axis.ordinalPositions = ordinalPositions;
	
	                        // This relies on the ordinalPositions being set. Use Math.max
	                        // and Math.min to prevent padding on either sides of the data.
	                        minIndex = axis.ordinal2lin( // #5979
	                            Math.max(
	                                min,
	                                ordinalPositions[0]
	                            ),
	                            true
	                        );
	                        maxIndex = Math.max(axis.ordinal2lin(
	                            Math.min(
	                                max,
	                                ordinalPositions[ordinalPositions.length - 1]
	                            ),
	                            true
	                        ), 1); // #3339
	
	                        // Set the slope and offset of the values compared to the indices in the ordinal positions
	                        axis.ordinalSlope = slope = (max - min) / (maxIndex - minIndex);
	                        axis.ordinalOffset = min - (minIndex * slope);
	
	                    } else {
	                        axis.ordinalPositions = axis.ordinalSlope = axis.ordinalOffset = undefined;
	                    }
	                }
	                axis.isOrdinal = isOrdinal && useOrdinal; // #3818, #4196, #4926
	                axis.groupIntervalFactor = null; // reset for next run
	            },
	            /**
	             * Translate from a linear axis value to the corresponding ordinal axis position. If there
	             * are no gaps in the ordinal axis this will be the same. The translated value is the value
	             * that the point would have if the axis were linear, using the same min and max.
	             *
	             * @param Number val The axis value
	             * @param Boolean toIndex Whether to return the index in the ordinalPositions or the new value
	             */
	            val2lin: function(val, toIndex) {
	                var axis = this,
	                    ordinalPositions = axis.ordinalPositions,
	                    ret;
	
	                if (!ordinalPositions) {
	                    ret = val;
	
	                } else {
	
	                    var ordinalLength = ordinalPositions.length,
	                        i,
	                        distance,
	                        ordinalIndex;
	
	                    // first look for an exact match in the ordinalpositions array
	                    i = ordinalLength;
	                    while (i--) {
	                        if (ordinalPositions[i] === val) {
	                            ordinalIndex = i;
	                            break;
	                        }
	                    }
	
	                    // if that failed, find the intermediate position between the two nearest values
	                    i = ordinalLength - 1;
	                    while (i--) {
	                        if (val > ordinalPositions[i] || i === 0) { // interpolate
	                            distance = (val - ordinalPositions[i]) / (ordinalPositions[i + 1] - ordinalPositions[i]); // something between 0 and 1
	                            ordinalIndex = i + distance;
	                            break;
	                        }
	                    }
	                    ret = toIndex ?
	                        ordinalIndex :
	                        axis.ordinalSlope * (ordinalIndex || 0) + axis.ordinalOffset;
	                }
	                return ret;
	            },
	            /**
	             * Translate from linear (internal) to axis value
	             *
	             * @param Number val The linear abstracted value
	             * @param Boolean fromIndex Translate from an index in the ordinal positions rather than a value
	             */
	            lin2val: function(val, fromIndex) {
	                var axis = this,
	                    ordinalPositions = axis.ordinalPositions,
	                    ret;
	
	                if (!ordinalPositions) { // the visible range contains only equally spaced values
	                    ret = val;
	
	                } else {
	
	                    var ordinalSlope = axis.ordinalSlope,
	                        ordinalOffset = axis.ordinalOffset,
	                        i = ordinalPositions.length - 1,
	                        linearEquivalentLeft,
	                        linearEquivalentRight,
	                        distance;
	
	
	                    // Handle the case where we translate from the index directly, used only
	                    // when panning an ordinal axis
	                    if (fromIndex) {
	
	                        if (val < 0) { // out of range, in effect panning to the left
	                            val = ordinalPositions[0];
	                        } else if (val > i) { // out of range, panning to the right
	                            val = ordinalPositions[i];
	                        } else { // split it up
	                            i = Math.floor(val);
	                            distance = val - i; // the decimal
	                        }
	
	                        // Loop down along the ordinal positions. When the linear equivalent of i matches
	                        // an ordinal position, interpolate between the left and right values.
	                    } else {
	                        while (i--) {
	                            linearEquivalentLeft = (ordinalSlope * i) + ordinalOffset;
	                            if (val >= linearEquivalentLeft) {
	                                linearEquivalentRight = (ordinalSlope * (i + 1)) + ordinalOffset;
	                                distance = (val - linearEquivalentLeft) / (linearEquivalentRight - linearEquivalentLeft); // something between 0 and 1
	                                break;
	                            }
	                        }
	                    }
	
	                    // If the index is within the range of the ordinal positions, return the associated
	                    // or interpolated value. If not, just return the value
	                    return distance !== undefined && ordinalPositions[i] !== undefined ?
	                        ordinalPositions[i] + (distance ? distance * (ordinalPositions[i + 1] - ordinalPositions[i]) : 0) :
	                        val;
	                }
	                return ret;
	            },
	            /**
	             * Get the ordinal positions for the entire data set. This is necessary in chart panning
	             * because we need to find out what points or data groups are available outside the
	             * visible range. When a panning operation starts, if an index for the given grouping
	             * does not exists, it is created and cached. This index is deleted on updated data, so
	             * it will be regenerated the next time a panning operation starts.
	             */
	            getExtendedPositions: function() {
	                var axis = this,
	                    chart = axis.chart,
	                    grouping = axis.series[0].currentDataGrouping,
	                    ordinalIndex = axis.ordinalIndex,
	                    key = grouping ? grouping.count + grouping.unitName : 'raw',
	                    extremes = axis.getExtremes(),
	                    fakeAxis,
	                    fakeSeries;
	
	                // If this is the first time, or the ordinal index is deleted by updatedData,
	                // create it.
	                if (!ordinalIndex) {
	                    ordinalIndex = axis.ordinalIndex = {};
	                }
	
	
	                if (!ordinalIndex[key]) {
	
	                    // Create a fake axis object where the extended ordinal positions are emulated
	                    fakeAxis = {
	                        series: [],
	                        chart: chart,
	                        getExtremes: function() {
	                            return {
	                                min: extremes.dataMin,
	                                max: extremes.dataMax
	                            };
	                        },
	                        options: {
	                            ordinal: true
	                        },
	                        val2lin: Axis.prototype.val2lin, // #2590
	                        ordinal2lin: Axis.prototype.ordinal2lin // #6276
	                    };
	
	                    // Add the fake series to hold the full data, then apply processData to it
	                    each(axis.series, function(series) {
	                        fakeSeries = {
	                            xAxis: fakeAxis,
	                            xData: series.xData,
	                            chart: chart,
	                            destroyGroupedData: noop
	                        };
	                        fakeSeries.options = {
	                            dataGrouping: grouping ? {
	                                enabled: true,
	                                forced: true,
	                                approximation: 'open', // doesn't matter which, use the fastest
	                                units: [
	                                    [grouping.unitName, [grouping.count]]
	                                ]
	                            } : {
	                                enabled: false
	                            }
	                        };
	                        series.processData.apply(fakeSeries);
	
	                        fakeAxis.series.push(fakeSeries);
	                    });
	
	                    // Run beforeSetTickPositions to compute the ordinalPositions
	                    axis.beforeSetTickPositions.apply(fakeAxis);
	
	                    // Cache it
	                    ordinalIndex[key] = fakeAxis.ordinalPositions;
	                }
	                return ordinalIndex[key];
	            },
	
	            /**
	             * Find the factor to estimate how wide the plot area would have been if ordinal
	             * gaps were included. This value is used to compute an imagined plot width in order
	             * to establish the data grouping interval.
	             *
	             * A real world case is the intraday-candlestick
	             * example. Without this logic, it would show the correct data grouping when viewing
	             * a range within each day, but once moving the range to include the gap between two
	             * days, the interval would include the cut-away night hours and the data grouping
	             * would be wrong. So the below method tries to compensate by identifying the most
	             * common point interval, in this case days.
	             *
	             * An opposite case is presented in issue #718. We have a long array of daily data,
	             * then one point is appended one hour after the last point. We expect the data grouping
	             * not to change.
	             *
	             * In the future, if we find cases where this estimation doesn't work optimally, we
	             * might need to add a second pass to the data grouping logic, where we do another run
	             * with a greater interval if the number of data groups is more than a certain fraction
	             * of the desired group count.
	             */
	            getGroupIntervalFactor: function(xMin, xMax, series) {
	                var i,
	                    processedXData = series.processedXData,
	                    len = processedXData.length,
	                    distances = [],
	                    median,
	                    groupIntervalFactor = this.groupIntervalFactor;
	
	                // Only do this computation for the first series, let the other inherit it (#2416)
	                if (!groupIntervalFactor) {
	
	                    // Register all the distances in an array
	                    for (i = 0; i < len - 1; i++) {
	                        distances[i] = processedXData[i + 1] - processedXData[i];
	                    }
	
	                    // Sort them and find the median
	                    distances.sort(function(a, b) {
	                        return a - b;
	                    });
	                    median = distances[Math.floor(len / 2)];
	
	                    // Compensate for series that don't extend through the entire axis extent. #1675.
	                    xMin = Math.max(xMin, processedXData[0]);
	                    xMax = Math.min(xMax, processedXData[len - 1]);
	
	                    this.groupIntervalFactor = groupIntervalFactor = (len * median) / (xMax - xMin);
	                }
	
	                // Return the factor needed for data grouping
	                return groupIntervalFactor;
	            },
	
	            /**
	             * Make the tick intervals closer because the ordinal gaps make the ticks spread out or cluster
	             */
	            postProcessTickInterval: function(tickInterval) {
	                // Problem: http://jsfiddle.net/highcharts/FQm4E/1/
	                // This is a case where this algorithm doesn't work optimally. In this case, the
	                // tick labels are spread out per week, but all the gaps reside within weeks. So
	                // we have a situation where the labels are courser than the ordinal gaps, and
	                // thus the tick interval should not be altered
	                var ordinalSlope = this.ordinalSlope,
	                    ret;
	
	
	                if (ordinalSlope) {
	                    if (!this.options.breaks) {
	                        ret = tickInterval / (ordinalSlope / this.closestPointRange);
	                    } else {
	                        ret = this.closestPointRange;
	                    }
	                } else {
	                    ret = tickInterval;
	                }
	                return ret;
	            }
	        });
	
	        // Record this to prevent overwriting by broken-axis module (#5979)
	        Axis.prototype.ordinal2lin = Axis.prototype.val2lin;
	
	        // Extending the Chart.pan method for ordinal axes
	        wrap(Chart.prototype, 'pan', function(proceed, e) {
	            var chart = this,
	                xAxis = chart.xAxis[0],
	                chartX = e.chartX,
	                runBase = false;
	
	            if (xAxis.options.ordinal && xAxis.series.length) {
	
	                var mouseDownX = chart.mouseDownX,
	                    extremes = xAxis.getExtremes(),
	                    dataMax = extremes.dataMax,
	                    min = extremes.min,
	                    max = extremes.max,
	                    trimmedRange,
	                    hoverPoints = chart.hoverPoints,
	                    closestPointRange = xAxis.closestPointRange,
	                    pointPixelWidth = xAxis.translationSlope * (xAxis.ordinalSlope || closestPointRange),
	                    movedUnits = (mouseDownX - chartX) / pointPixelWidth, // how many ordinal units did we move?
	                    extendedAxis = {
	                        ordinalPositions: xAxis.getExtendedPositions()
	                    }, // get index of all the chart's points
	                    ordinalPositions,
	                    searchAxisLeft,
	                    lin2val = xAxis.lin2val,
	                    val2lin = xAxis.val2lin,
	                    searchAxisRight;
	
	                if (!extendedAxis.ordinalPositions) { // we have an ordinal axis, but the data is equally spaced
	                    runBase = true;
	
	                } else if (Math.abs(movedUnits) > 1) {
	
	                    // Remove active points for shared tooltip
	                    if (hoverPoints) {
	                        each(hoverPoints, function(point) {
	                            point.setState();
	                        });
	                    }
	
	                    if (movedUnits < 0) {
	                        searchAxisLeft = extendedAxis;
	                        searchAxisRight = xAxis.ordinalPositions ? xAxis : extendedAxis;
	                    } else {
	                        searchAxisLeft = xAxis.ordinalPositions ? xAxis : extendedAxis;
	                        searchAxisRight = extendedAxis;
	                    }
	
	                    // In grouped data series, the last ordinal position represents the grouped data, which is
	                    // to the left of the real data max. If we don't compensate for this, we will be allowed
	                    // to pan grouped data series passed the right of the plot area.
	                    ordinalPositions = searchAxisRight.ordinalPositions;
	                    if (dataMax > ordinalPositions[ordinalPositions.length - 1]) {
	                        ordinalPositions.push(dataMax);
	                    }
	
	                    // Get the new min and max values by getting the ordinal index for the current extreme,
	                    // then add the moved units and translate back to values. This happens on the
	                    // extended ordinal positions if the new position is out of range, else it happens
	                    // on the current x axis which is smaller and faster.
	                    chart.fixedRange = max - min;
	                    trimmedRange = xAxis.toFixedRange(null, null,
	                        lin2val.apply(searchAxisLeft, [
	                            val2lin.apply(searchAxisLeft, [min, true]) + movedUnits, // the new index
	                            true // translate from index
	                        ]),
	                        lin2val.apply(searchAxisRight, [
	                            val2lin.apply(searchAxisRight, [max, true]) + movedUnits, // the new index
	                            true // translate from index
	                        ])
	                    );
	
	                    // Apply it if it is within the available data range
	                    if (trimmedRange.min >= Math.min(extremes.dataMin, min) && trimmedRange.max <= Math.max(dataMax, max)) {
	                        xAxis.setExtremes(trimmedRange.min, trimmedRange.max, true, false, {
	                            trigger: 'pan'
	                        });
	                    }
	
	                    chart.mouseDownX = chartX; // set new reference for next run
	                    css(chart.container, {
	                        cursor: 'move'
	                    });
	                }
	
	            } else {
	                runBase = true;
	            }
	
	            // revert to the linear chart.pan version
	            if (runBase) {
	                // call the original function
	                proceed.apply(this, Array.prototype.slice.call(arguments, 1));
	            }
	        });
	
	        /* ****************************************************************************
	         * End ordinal axis logic                                                   *
	         *****************************************************************************/
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2009-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	
	        var pick = H.pick,
	            wrap = H.wrap,
	            each = H.each,
	            extend = H.extend,
	            isArray = H.isArray,
	            fireEvent = H.fireEvent,
	            Axis = H.Axis,
	            Series = H.Series;
	
	        function stripArguments() {
	            return Array.prototype.slice.call(arguments, 1);
	        }
	
	        extend(Axis.prototype, {
	            isInBreak: function(brk, val) {
	                var ret,
	                    repeat = brk.repeat || Infinity,
	                    from = brk.from,
	                    length = brk.to - brk.from,
	                    test = (val >= from ? (val - from) % repeat : repeat - ((from - val) % repeat));
	
	                if (!brk.inclusive) {
	                    ret = test < length && test !== 0;
	                } else {
	                    ret = test <= length;
	                }
	                return ret;
	            },
	
	            isInAnyBreak: function(val, testKeep) {
	
	                var breaks = this.options.breaks,
	                    i = breaks && breaks.length,
	                    inbrk,
	                    keep,
	                    ret;
	
	
	                if (i) {
	
	                    while (i--) {
	                        if (this.isInBreak(breaks[i], val)) {
	                            inbrk = true;
	                            if (!keep) {
	                                keep = pick(breaks[i].showPoints, this.isXAxis ? false : true);
	                            }
	                        }
	                    }
	
	                    if (inbrk && testKeep) {
	                        ret = inbrk && !keep;
	                    } else {
	                        ret = inbrk;
	                    }
	                }
	                return ret;
	            }
	        });
	
	        wrap(Axis.prototype, 'setTickPositions', function(proceed) {
	            proceed.apply(this, Array.prototype.slice.call(arguments, 1));
	
	            if (this.options.breaks) {
	                var axis = this,
	                    tickPositions = this.tickPositions,
	                    info = this.tickPositions.info,
	                    newPositions = [],
	                    i;
	
	                for (i = 0; i < tickPositions.length; i++) {
	                    if (!axis.isInAnyBreak(tickPositions[i])) {
	                        newPositions.push(tickPositions[i]);
	                    }
	                }
	
	                this.tickPositions = newPositions;
	                this.tickPositions.info = info;
	            }
	        });
	
	        wrap(Axis.prototype, 'init', function(proceed, chart, userOptions) {
	            var axis = this,
	                breaks;
	            // Force Axis to be not-ordinal when breaks are defined
	            if (userOptions.breaks && userOptions.breaks.length) {
	                userOptions.ordinal = false;
	            }
	            proceed.call(this, chart, userOptions);
	            breaks = this.options.breaks;
	            axis.isBroken = (isArray(breaks) && !!breaks.length);
	            if (axis.isBroken) {
	                axis.val2lin = function(val) {
	                    var nval = val,
	                        brk,
	                        i;
	
	                    for (i = 0; i < axis.breakArray.length; i++) {
	                        brk = axis.breakArray[i];
	                        if (brk.to <= val) {
	                            nval -= brk.len;
	                        } else if (brk.from >= val) {
	                            break;
	                        } else if (axis.isInBreak(brk, val)) {
	                            nval -= (val - brk.from);
	                            break;
	                        }
	                    }
	
	                    return nval;
	                };
	
	                axis.lin2val = function(val) {
	                    var nval = val,
	                        brk,
	                        i;
	
	                    for (i = 0; i < axis.breakArray.length; i++) {
	                        brk = axis.breakArray[i];
	                        if (brk.from >= nval) {
	                            break;
	                        } else if (brk.to < nval) {
	                            nval += brk.len;
	                        } else if (axis.isInBreak(brk, nval)) {
	                            nval += brk.len;
	                        }
	                    }
	                    return nval;
	                };
	
	                axis.setExtremes = function(newMin, newMax, redraw, animation, eventArguments) {
	                    // If trying to set extremes inside a break, extend it to before and after the break ( #3857 )
	                    while (this.isInAnyBreak(newMin)) {
	                        newMin -= this.closestPointRange;
	                    }
	                    while (this.isInAnyBreak(newMax)) {
	                        newMax -= this.closestPointRange;
	                    }
	                    Axis.prototype.setExtremes.call(this, newMin, newMax, redraw, animation, eventArguments);
	                };
	
	                axis.setAxisTranslation = function(saveOld) {
	                    Axis.prototype.setAxisTranslation.call(this, saveOld);
	
	                    var breaks = axis.options.breaks,
	                        breakArrayT = [], // Temporary one
	                        breakArray = [],
	                        length = 0,
	                        inBrk,
	                        repeat,
	                        min = axis.userMin || axis.min,
	                        max = axis.userMax || axis.max,
	                        pointRangePadding = pick(axis.pointRangePadding, 0),
	                        start,
	                        i;
	
	                    // Min & max check (#4247)
	                    each(breaks, function(brk) {
	                        repeat = brk.repeat || Infinity;
	                        if (axis.isInBreak(brk, min)) {
	                            min += (brk.to % repeat) - (min % repeat);
	                        }
	                        if (axis.isInBreak(brk, max)) {
	                            max -= (max % repeat) - (brk.from % repeat);
	                        }
	                    });
	
	                    // Construct an array holding all breaks in the axis
	                    each(breaks, function(brk) {
	                        start = brk.from;
	                        repeat = brk.repeat || Infinity;
	
	                        while (start - repeat > min) {
	                            start -= repeat;
	                        }
	                        while (start < min) {
	                            start += repeat;
	                        }
	
	                        for (i = start; i < max; i += repeat) {
	                            breakArrayT.push({
	                                value: i,
	                                move: 'in'
	                            });
	                            breakArrayT.push({
	                                value: i + (brk.to - brk.from),
	                                move: 'out',
	                                size: brk.breakSize
	                            });
	                        }
	                    });
	
	                    breakArrayT.sort(function(a, b) {
	                        var ret;
	                        if (a.value === b.value) {
	                            ret = (a.move === 'in' ? 0 : 1) - (b.move === 'in' ? 0 : 1);
	                        } else {
	                            ret = a.value - b.value;
	                        }
	                        return ret;
	                    });
	
	                    // Simplify the breaks
	                    inBrk = 0;
	                    start = min;
	
	                    each(breakArrayT, function(brk) {
	                        inBrk += (brk.move === 'in' ? 1 : -1);
	
	                        if (inBrk === 1 && brk.move === 'in') {
	                            start = brk.value;
	                        }
	                        if (inBrk === 0) {
	                            breakArray.push({
	                                from: start,
	                                to: brk.value,
	                                len: brk.value - start - (brk.size || 0)
	                            });
	                            length += brk.value - start - (brk.size || 0);
	                        }
	                    });
	
	                    axis.breakArray = breakArray;
	
	                    // Used with staticScale, and below, the actual axis length when
	                    // breaks are substracted.
	                    axis.unitLength = max - min - length + pointRangePadding;
	
	                    fireEvent(axis, 'afterBreaks');
	
	                    if (axis.options.staticScale) {
	                        axis.transA = axis.options.staticScale;
	                    } else if (axis.unitLength) {
	                        axis.transA *= (max - axis.min + pointRangePadding) /
	                            axis.unitLength;
	                    }
	
	                    if (pointRangePadding) {
	                        axis.minPixelPadding = axis.transA * axis.minPointOffset;
	                    }
	
	                    axis.min = min;
	                    axis.max = max;
	                };
	            }
	        });
	
	        wrap(Series.prototype, 'generatePoints', function(proceed) {
	
	            proceed.apply(this, stripArguments(arguments));
	
	            var series = this,
	                xAxis = series.xAxis,
	                yAxis = series.yAxis,
	                points = series.points,
	                point,
	                i = points.length,
	                connectNulls = series.options.connectNulls,
	                nullGap;
	
	
	            if (xAxis && yAxis && (xAxis.options.breaks || yAxis.options.breaks)) {
	                while (i--) {
	                    point = points[i];
	
	                    nullGap = point.y === null && connectNulls === false; // respect nulls inside the break (#4275)
	                    if (!nullGap && (xAxis.isInAnyBreak(point.x, true) || yAxis.isInAnyBreak(point.y, true))) {
	                        points.splice(i, 1);
	                        if (this.data[i]) {
	                            this.data[i].destroyElements(); // removes the graphics for this point if they exist
	                        }
	                    }
	                }
	            }
	
	        });
	
	        function drawPointsWrapped(proceed) {
	            proceed.apply(this);
	            this.drawBreaks(this.xAxis, ['x']);
	            this.drawBreaks(this.yAxis, pick(this.pointArrayMap, ['y']));
	        }
	
	        H.Series.prototype.drawBreaks = function(axis, keys) {
	            var series = this,
	                points = series.points,
	                breaks,
	                threshold,
	                eventName,
	                y;
	
	            if (!axis) {
	                return; // #5950
	            }
	
	            each(keys, function(key) {
	                breaks = axis.breakArray || [];
	                threshold = axis.isXAxis ? axis.min : pick(series.options.threshold, axis.min);
	                each(points, function(point) {
	                    y = pick(point['stack' + key.toUpperCase()], point[key]);
	                    each(breaks, function(brk) {
	                        eventName = false;
	
	                        if ((threshold < brk.from && y > brk.to) || (threshold > brk.from && y < brk.from)) {
	                            eventName = 'pointBreak';
	                        } else if ((threshold < brk.from && y > brk.from && y < brk.to) || (threshold > brk.from && y > brk.to && y < brk.from)) { // point falls inside the break
	                            eventName = 'pointInBreak';
	                        }
	                        if (eventName) {
	                            fireEvent(axis, eventName, {
	                                point: point,
	                                brk: brk
	                            });
	                        }
	                    });
	                });
	            });
	        };
	
	
	        /**
	         * Extend getGraphPath by identifying gaps in the data so that we can draw a gap
	         * in the line or area. This was moved from ordinal axis module to broken axis
	         * module as of #5045.
	         */
	        H.Series.prototype.gappedPath = function() {
	            var gapSize = this.options.gapSize,
	                points = this.points.slice(),
	                i = points.length - 1,
	                yAxis = this.yAxis,
	                xRange,
	                stack;
	
	            /**
	             * Defines when to display a gap in the graph, together with the `gapUnit`
	             * option.
	             * 
	             * When the `gapUnit` is `relative` (default), a gap size of 5 means
	             * that if the distance between two points is greater than five times
	             * that of the two closest points, the graph will be broken.
	             *
	             * When the `gapUnit` is `value`, the gap is based on absolute axis values,
	             * which on a datetime axis is milliseconds.
	             * 
	             * In practice, this option is most often used to visualize gaps in
	             * time series. In a stock chart, intraday data is available for daytime
	             * hours, while gaps will appear in nights and weekends.
	             * 
	             * @type {Number}
	             * @see [xAxis.breaks](#xAxis.breaks)
	             * @sample {highstock} stock/plotoptions/series-gapsize/
	             *         Setting the gap size to 2 introduces gaps for weekends in daily
	             *         datasets.
	             * @default 0
	             * @product highstock
	             * @apioption plotOptions.series.gapSize
	             */
	
	            /**
	             * Together with `gapSize`, this option defines where to draw gaps in the 
	             * graph.
	             *
	             * @type {String}
	             * @see [gapSize](plotOptions.series.gapSize)
	             * @default relative
	             * @validvalues ["relative", "value"]
	             * @since 5.0.13
	             * @product highstock
	             * @apioption plotOptions.series.gapUnit
	             */
	
	            if (gapSize && i > 0) { // #5008
	
	                // Gap unit is relative
	                if (this.options.gapUnit !== 'value') {
	                    gapSize *= this.closestPointRange;
	                }
	
	                // extension for ordinal breaks
	                while (i--) {
	                    if (points[i + 1].x - points[i].x > gapSize) {
	                        xRange = (points[i].x + points[i + 1].x) / 2;
	
	                        points.splice( // insert after this one
	                            i + 1,
	                            0, {
	                                isNull: true,
	                                x: xRange
	                            }
	                        );
	
	                        // For stacked chart generate empty stack items, #6546
	                        if (this.options.stacking) {
	                            stack = yAxis.stacks[this.stackKey][xRange] = new H.StackItem(
	                                yAxis,
	                                yAxis.options.stackLabels,
	                                false,
	                                xRange,
	                                this.stack
	                            );
	                            stack.total = 0;
	                        }
	                    }
	                }
	            }
	
	            // Call base method
	            return this.getGraphPath(points);
	        };
	
	        wrap(H.seriesTypes.column.prototype, 'drawPoints', drawPointsWrapped);
	        wrap(H.Series.prototype, 'drawPoints', drawPointsWrapped);
	
	    }(Highcharts));
	    (function() {
	
	
	    }());
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var arrayMax = H.arrayMax,
	            arrayMin = H.arrayMin,
	            Axis = H.Axis,
	            defaultPlotOptions = H.defaultPlotOptions,
	            defined = H.defined,
	            each = H.each,
	            extend = H.extend,
	            format = H.format,
	            isNumber = H.isNumber,
	            merge = H.merge,
	            pick = H.pick,
	            Point = H.Point,
	            Series = H.Series,
	            Tooltip = H.Tooltip,
	            wrap = H.wrap;
	
	        /* ****************************************************************************
	         * Start data grouping module												 *
	         ******************************************************************************/
	
	        var seriesProto = Series.prototype,
	            baseProcessData = seriesProto.processData,
	            baseGeneratePoints = seriesProto.generatePoints,
	            baseDestroy = seriesProto.destroy,
	
	            /** 
	             * 
	             */
	            commonOptions = {
	                approximation: 'average', // average, open, high, low, close, sum
	                //enabled: null, // (true for stock charts, false for basic),
	                //forced: undefined,
	                groupPixelWidth: 2,
	                // the first one is the point or start value, the second is the start value if we're dealing with range,
	                // the third one is the end value if dealing with a range
	                dateTimeLabelFormats: {
	                    millisecond: ['%A, %b %e, %H:%M:%S.%L', '%A, %b %e, %H:%M:%S.%L', '-%H:%M:%S.%L'],
	                    second: ['%A, %b %e, %H:%M:%S', '%A, %b %e, %H:%M:%S', '-%H:%M:%S'],
	                    minute: ['%A, %b %e, %H:%M', '%A, %b %e, %H:%M', '-%H:%M'],
	                    hour: ['%A, %b %e, %H:%M', '%A, %b %e, %H:%M', '-%H:%M'],
	                    day: ['%A, %b %e, %Y', '%A, %b %e', '-%A, %b %e, %Y'],
	                    week: ['Week from %A, %b %e, %Y', '%A, %b %e', '-%A, %b %e, %Y'],
	                    month: ['%B %Y', '%B', '-%B %Y'],
	                    year: ['%Y', '%Y', '-%Y']
	                }
	                // smoothed = false, // enable this for navigator series only
	            },
	
	            specificOptions = { // extends common options
	                line: {},
	                spline: {},
	                area: {},
	                areaspline: {},
	                column: {
	                    approximation: 'sum',
	                    groupPixelWidth: 10
	                },
	                arearange: {
	                    approximation: 'range'
	                },
	                areasplinerange: {
	                    approximation: 'range'
	                },
	                columnrange: {
	                    approximation: 'range',
	                    groupPixelWidth: 10
	                },
	                candlestick: {
	                    approximation: 'ohlc',
	                    groupPixelWidth: 10
	                },
	                ohlc: {
	                    approximation: 'ohlc',
	                    groupPixelWidth: 5
	                }
	            },
	
	            // units are defined in a separate array to allow complete overriding in case of a user option
	            defaultDataGroupingUnits = H.defaultDataGroupingUnits = [
	                [
	                    'millisecond', // unit name
	                    [1, 2, 5, 10, 20, 25, 50, 100, 200, 500] // allowed multiples
	                ],
	                [
	                    'second', [1, 2, 5, 10, 15, 30]
	                ],
	                [
	                    'minute', [1, 2, 5, 10, 15, 30]
	                ],
	                [
	                    'hour', [1, 2, 3, 4, 6, 8, 12]
	                ],
	                [
	                    'day', [1]
	                ],
	                [
	                    'week', [1]
	                ],
	                [
	                    'month', [1, 3, 6]
	                ],
	                [
	                    'year',
	                    null
	                ]
	            ],
	
	
	            /**
	             * Define the available approximation types. The data grouping
	             * approximations takes an array or numbers as the first parameter. In case
	             * of ohlc, four arrays are sent in as four parameters. Each array consists
	             * only of numbers. In case null values belong to the group, the property
	             * .hasNulls will be set to true on the array.
	             */
	            approximations = {
	                sum: function(arr) {
	                    var len = arr.length,
	                        ret;
	
	                    // 1. it consists of nulls exclusively
	                    if (!len && arr.hasNulls) {
	                        ret = null;
	                        // 2. it has a length and real values
	                    } else if (len) {
	                        ret = 0;
	                        while (len--) {
	                            ret += arr[len];
	                        }
	                    }
	                    // 3. it has zero length, so just return undefined
	                    // => doNothing()
	
	                    return ret;
	                },
	                average: function(arr) {
	                    var len = arr.length,
	                        ret = approximations.sum(arr);
	
	                    // If we have a number, return it divided by the length. If not,
	                    // return null or undefined based on what the sum method finds.
	                    if (isNumber(ret) && len) {
	                        ret = ret / len;
	                    }
	
	                    return ret;
	                },
	                // The same as average, but for series with multiple values, like area
	                // ranges.
	                averages: function() { // #5479
	                    var ret = [];
	
	                    each(arguments, function(arr) {
	                        ret.push(approximations.average(arr));
	                    });
	
	                    return ret;
	                },
	                open: function(arr) {
	                    return arr.length ? arr[0] : (arr.hasNulls ? null : undefined);
	                },
	                high: function(arr) {
	                    return arr.length ? arrayMax(arr) : (arr.hasNulls ? null : undefined);
	                },
	                low: function(arr) {
	                    return arr.length ? arrayMin(arr) : (arr.hasNulls ? null : undefined);
	                },
	                close: function(arr) {
	                    return arr.length ? arr[arr.length - 1] : (arr.hasNulls ? null : undefined);
	                },
	                // ohlc and range are special cases where a multidimensional array is input and an array is output
	                ohlc: function(open, high, low, close) {
	                    open = approximations.open(open);
	                    high = approximations.high(high);
	                    low = approximations.low(low);
	                    close = approximations.close(close);
	
	                    if (isNumber(open) || isNumber(high) || isNumber(low) || isNumber(close)) {
	                        return [open, high, low, close];
	                    }
	                    // else, return is undefined
	                },
	                range: function(low, high) {
	                    low = approximations.low(low);
	                    high = approximations.high(high);
	
	                    if (isNumber(low) || isNumber(high)) {
	                        return [low, high];
	                    } else if (low === null && high === null) {
	                        return null;
	                    }
	                    // else, return is undefined
	                }
	            };
	
	
	        /**
	         * Takes parallel arrays of x and y data and groups the data into intervals 
	         * defined by groupPositions, a collection of starting x values for each group.
	         */
	        seriesProto.groupData = function(xData, yData, groupPositions, approximation) {
	            var series = this,
	                data = series.data,
	                dataOptions = series.options.data,
	                groupedXData = [],
	                groupedYData = [],
	                groupMap = [],
	                dataLength = xData.length,
	                pointX,
	                pointY,
	                groupedY,
	                // when grouping the fake extended axis for panning,
	                // we don't need to consider y
	                handleYData = !!yData,
	                values = [],
	                approximationFn = typeof approximation === 'function' ?
	                approximation :
	                approximations[approximation] ||
	                // if the approximation is not found use default series type
	                // approximation (#2914)
	                (
	                    specificOptions[series.type] &&
	                    approximations[specificOptions[series.type].approximation]
	                ) || approximations[commonOptions.approximation],
	                pointArrayMap = series.pointArrayMap,
	                pointArrayMapLength = pointArrayMap && pointArrayMap.length,
	                pos = 0,
	                start = 0,
	                valuesLen,
	                i, j;
	
	            // Calculate values array size from pointArrayMap length
	            if (pointArrayMapLength) {
	                each(pointArrayMap, function() {
	                    values.push([]);
	                });
	            } else {
	                values.push([]);
	            }
	            valuesLen = pointArrayMapLength || 1;
	
	            // Start with the first point within the X axis range (#2696)
	            for (i = 0; i <= dataLength; i++) {
	                if (xData[i] >= groupPositions[0]) {
	                    break;
	                }
	            }
	
	            for (i; i <= dataLength; i++) {
	
	                // when a new group is entered, summarize and initiate 
	                // the previous group
	                while ((
	                        groupPositions[pos + 1] !== undefined &&
	                        xData[i] >= groupPositions[pos + 1]
	                    ) || i === dataLength) { // get the last group
	
	                    // get group x and y
	                    pointX = groupPositions[pos];
	                    series.dataGroupInfo = {
	                        start: start,
	                        length: values[0].length
	                    };
	                    groupedY = approximationFn.apply(series, values);
	
	                    // push the grouped data
	                    if (groupedY !== undefined) {
	                        groupedXData.push(pointX);
	                        groupedYData.push(groupedY);
	                        groupMap.push(series.dataGroupInfo);
	                    }
	
	                    // reset the aggregate arrays
	                    start = i;
	                    for (j = 0; j < valuesLen; j++) {
	                        values[j].length = 0; // faster than values[j] = []
	                        values[j].hasNulls = false;
	                    }
	
	                    // Advance on the group positions
	                    pos += 1;
	
	                    // don't loop beyond the last group
	                    if (i === dataLength) {
	                        break;
	                    }
	                }
	
	                // break out
	                if (i === dataLength) {
	                    break;
	                }
	
	                // for each raw data point, push it to an array that contains all values
	                // for this specific group
	                if (pointArrayMap) {
	
	                    var index = series.cropStart + i,
	                        point = (data && data[index]) ||
	                        series.pointClass.prototype.applyOptions.apply({
	                            series: series
	                        }, [dataOptions[index]]),
	                        val;
	
	                    for (j = 0; j < pointArrayMapLength; j++) {
	                        val = point[pointArrayMap[j]];
	                        if (isNumber(val)) {
	                            values[j].push(val);
	                        } else if (val === null) {
	                            values[j].hasNulls = true;
	                        }
	                    }
	
	                } else {
	                    pointY = handleYData ? yData[i] : null;
	
	                    if (isNumber(pointY)) {
	                        values[0].push(pointY);
	                    } else if (pointY === null) {
	                        values[0].hasNulls = true;
	                    }
	                }
	            }
	
	            return [groupedXData, groupedYData, groupMap];
	        };
	
	        /**
	         * Extend the basic processData method, that crops the data to the current zoom
	         * range, with data grouping logic.
	         */
	        seriesProto.processData = function() {
	            var series = this,
	                chart = series.chart,
	                options = series.options,
	                dataGroupingOptions = options.dataGrouping,
	                groupingEnabled = series.allowDG !== false && dataGroupingOptions &&
	                pick(dataGroupingOptions.enabled, chart.options.isStock),
	                visible = series.visible || !chart.options.chart.ignoreHiddenSeries,
	                hasGroupedData,
	                skip;
	
	            // run base method
	            series.forceCrop = groupingEnabled; // #334
	            series.groupPixelWidth = null; // #2110
	            series.hasProcessed = true; // #2692
	
	            // skip if processData returns false or if grouping is disabled (in that order)
	            skip = baseProcessData.apply(series, arguments) === false || !groupingEnabled;
	            if (!skip) {
	                series.destroyGroupedData();
	
	                var i,
	                    processedXData = series.processedXData,
	                    processedYData = series.processedYData,
	                    plotSizeX = chart.plotSizeX,
	                    xAxis = series.xAxis,
	                    ordinal = xAxis.options.ordinal,
	                    groupPixelWidth = series.groupPixelWidth = xAxis.getGroupPixelWidth && xAxis.getGroupPixelWidth();
	
	                // Execute grouping if the amount of points is greater than the limit defined in groupPixelWidth
	                if (groupPixelWidth) {
	                    hasGroupedData = true;
	
	                    series.isDirty = true; // force recreation of point instances in series.translate, #5699
	                    series.points = null; // #6709
	
	                    var extremes = xAxis.getExtremes(),
	                        xMin = extremes.min,
	                        xMax = extremes.max,
	                        groupIntervalFactor = (ordinal && xAxis.getGroupIntervalFactor(xMin, xMax, series)) || 1,
	                        interval = (groupPixelWidth * (xMax - xMin) / plotSizeX) * groupIntervalFactor,
	                        groupPositions = xAxis.getTimeTicks(
	                            xAxis.normalizeTimeTickInterval(interval, dataGroupingOptions.units || defaultDataGroupingUnits),
	                            Math.min(xMin, processedXData[0]), // Processed data may extend beyond axis (#4907)
	                            Math.max(xMax, processedXData[processedXData.length - 1]),
	                            xAxis.options.startOfWeek,
	                            processedXData,
	                            series.closestPointRange
	                        ),
	                        groupedData = seriesProto.groupData.apply(series, [processedXData, processedYData, groupPositions, dataGroupingOptions.approximation]),
	                        groupedXData = groupedData[0],
	                        groupedYData = groupedData[1];
	
	                    // prevent the smoothed data to spill out left and right, and make
	                    // sure data is not shifted to the left
	                    if (dataGroupingOptions.smoothed) {
	                        i = groupedXData.length - 1;
	                        groupedXData[i] = Math.min(groupedXData[i], xMax);
	                        while (i-- && i > 0) {
	                            groupedXData[i] += interval / 2;
	                        }
	                        groupedXData[0] = Math.max(groupedXData[0], xMin);
	                    }
	
	                    // record what data grouping values were used
	                    series.currentDataGrouping = groupPositions.info;
	                    series.closestPointRange = groupPositions.info.totalRange;
	                    series.groupMap = groupedData[2];
	
	                    // Make sure the X axis extends to show the first group (#2533)
	                    // But only for visible series (#5493, #6393)
	                    if (defined(groupedXData[0]) && groupedXData[0] < xAxis.dataMin && visible) {
	                        if (xAxis.min === xAxis.dataMin) {
	                            xAxis.min = groupedXData[0];
	                        }
	                        xAxis.dataMin = groupedXData[0];
	                    }
	
	                    // set series props
	                    series.processedXData = groupedXData;
	                    series.processedYData = groupedYData;
	                } else {
	                    series.currentDataGrouping = series.groupMap = null;
	                }
	                series.hasGroupedData = hasGroupedData;
	            }
	        };
	
	        /**
	         * Destroy the grouped data points. #622, #740
	         */
	        seriesProto.destroyGroupedData = function() {
	
	            var groupedData = this.groupedData;
	
	            // clear previous groups
	            each(groupedData || [], function(point, i) {
	                if (point) {
	                    groupedData[i] = point.destroy ? point.destroy() : null;
	                }
	            });
	            this.groupedData = null;
	        };
	
	        /**
	         * Override the generatePoints method by adding a reference to grouped data
	         */
	        seriesProto.generatePoints = function() {
	
	            baseGeneratePoints.apply(this);
	
	            // record grouped data in order to let it be destroyed the next time processData runs
	            this.destroyGroupedData(); // #622
	            this.groupedData = this.hasGroupedData ? this.points : null;
	        };
	
	        /**
	         * Override point prototype to throw a warning when trying to update grouped points
	         */
	        wrap(Point.prototype, 'update', function(proceed) {
	            if (this.dataGroup) {
	                H.error(24);
	            } else {
	                proceed.apply(this, [].slice.call(arguments, 1));
	            }
	        });
	
	        /**
	         * Extend the original method, make the tooltip's header reflect the grouped range
	         */
	        wrap(Tooltip.prototype, 'tooltipFooterHeaderFormatter', function(proceed, labelConfig, isFooter) {
	            var tooltip = this,
	                series = labelConfig.series,
	                options = series.options,
	                tooltipOptions = series.tooltipOptions,
	                dataGroupingOptions = options.dataGrouping,
	                xDateFormat = tooltipOptions.xDateFormat,
	                xDateFormatEnd,
	                xAxis = series.xAxis,
	                dateFormat = H.dateFormat,
	                currentDataGrouping,
	                dateTimeLabelFormats,
	                labelFormats,
	                formattedKey;
	
	            // apply only to grouped series
	            if (xAxis && xAxis.options.type === 'datetime' && dataGroupingOptions && isNumber(labelConfig.key)) {
	
	                // set variables
	                currentDataGrouping = series.currentDataGrouping;
	                dateTimeLabelFormats = dataGroupingOptions.dateTimeLabelFormats;
	
	                // if we have grouped data, use the grouping information to get the right format
	                if (currentDataGrouping) {
	                    labelFormats = dateTimeLabelFormats[currentDataGrouping.unitName];
	                    if (currentDataGrouping.count === 1) {
	                        xDateFormat = labelFormats[0];
	                    } else {
	                        xDateFormat = labelFormats[1];
	                        xDateFormatEnd = labelFormats[2];
	                    }
	                    // if not grouped, and we don't have set the xDateFormat option, get the best fit,
	                    // so if the least distance between points is one minute, show it, but if the
	                    // least distance is one day, skip hours and minutes etc.
	                } else if (!xDateFormat && dateTimeLabelFormats) {
	                    xDateFormat = tooltip.getXDateFormat(labelConfig, tooltipOptions, xAxis);
	                }
	
	                // now format the key
	                formattedKey = dateFormat(xDateFormat, labelConfig.key);
	                if (xDateFormatEnd) {
	                    formattedKey += dateFormat(xDateFormatEnd, labelConfig.key + currentDataGrouping.totalRange - 1);
	                }
	
	                // return the replaced format
	                return format(tooltipOptions[(isFooter ? 'footer' : 'header') + 'Format'], {
	                    point: extend(labelConfig.point, {
	                        key: formattedKey
	                    }),
	                    series: series
	                });
	
	            }
	
	            // else, fall back to the regular formatter
	            return proceed.call(tooltip, labelConfig, isFooter);
	        });
	
	        /**
	         * Extend the series destroyer
	         */
	        seriesProto.destroy = function() {
	            var series = this,
	                groupedData = series.groupedData || [],
	                i = groupedData.length;
	
	            while (i--) {
	                if (groupedData[i]) {
	                    groupedData[i].destroy();
	                }
	            }
	            baseDestroy.apply(series);
	        };
	
	
	        // Handle default options for data grouping. This must be set at runtime because some series types are
	        // defined after this.
	        wrap(seriesProto, 'setOptions', function(proceed, itemOptions) {
	
	            var options = proceed.call(this, itemOptions),
	                type = this.type,
	                plotOptions = this.chart.options.plotOptions,
	                defaultOptions = defaultPlotOptions[type].dataGrouping;
	
	            if (specificOptions[type]) { // #1284
	                if (!defaultOptions) {
	                    defaultOptions = merge(commonOptions, specificOptions[type]);
	                }
	
	                options.dataGrouping = merge(
	                    defaultOptions,
	                    plotOptions.series && plotOptions.series.dataGrouping, // #1228
	                    plotOptions[type].dataGrouping, // Set by the StockChart constructor
	                    itemOptions.dataGrouping
	                );
	            }
	
	            if (this.chart.options.isStock) {
	                this.requireSorting = true;
	            }
	
	            return options;
	        });
	
	
	        /**
	         * When resetting the scale reset the hasProccessed flag to avoid taking previous data grouping
	         * of neighbour series into accound when determining group pixel width (#2692).
	         */
	        wrap(Axis.prototype, 'setScale', function(proceed) {
	            proceed.call(this);
	            each(this.series, function(series) {
	                series.hasProcessed = false;
	            });
	        });
	
	        /**
	         * Get the data grouping pixel width based on the greatest defined individual width
	         * of the axis' series, and if whether one of the axes need grouping.
	         */
	        Axis.prototype.getGroupPixelWidth = function() {
	
	            var series = this.series,
	                len = series.length,
	                i,
	                groupPixelWidth = 0,
	                doGrouping = false,
	                dataLength,
	                dgOptions;
	
	            // If multiple series are compared on the same x axis, give them the same
	            // group pixel width (#334)
	            i = len;
	            while (i--) {
	                dgOptions = series[i].options.dataGrouping;
	                if (dgOptions) {
	                    groupPixelWidth = Math.max(groupPixelWidth, dgOptions.groupPixelWidth);
	
	                }
	            }
	
	            // If one of the series needs grouping, apply it to all (#1634)
	            i = len;
	            while (i--) {
	                dgOptions = series[i].options.dataGrouping;
	
	                if (dgOptions && series[i].hasProcessed) { // #2692
	
	                    dataLength = (series[i].processedXData || series[i].data).length;
	
	                    // Execute grouping if the amount of points is greater than the limit defined in groupPixelWidth
	                    if (series[i].groupPixelWidth || dataLength > (this.chart.plotSizeX / groupPixelWidth) || (dataLength && dgOptions.forced)) {
	                        doGrouping = true;
	                    }
	                }
	            }
	
	            return doGrouping ? groupPixelWidth : 0;
	        };
	
	        /**
	         * Highstock only. Force data grouping on all the axis' series.
	         *
	         * @param  {SeriesDatagroupingOptions} [dataGrouping]
	         *         A `dataGrouping` configuration. Use `false` to disable data grouping
	         *         dynamically.
	         * @param  {Boolean} [redraw=true]
	         *         Whether to redraw the chart or wait for a later call to {@link
	         *         Chart#redraw}.
	         *
	         * @function setDataGrouping
	         * @memberOf Axis.prototype
	         */
	        Axis.prototype.setDataGrouping = function(dataGrouping, redraw) {
	            var i;
	
	            redraw = pick(redraw, true);
	
	            if (!dataGrouping) {
	                dataGrouping = {
	                    forced: false,
	                    units: null
	                };
	            }
	
	            // Axis is instantiated, update all series
	            if (this instanceof Axis) {
	                i = this.series.length;
	                while (i--) {
	                    this.series[i].update({
	                        dataGrouping: dataGrouping
	                    }, false);
	                }
	
	                // Axis not yet instanciated, alter series options
	            } else {
	                each(this.chart.options.series, function(seriesOptions) {
	                    seriesOptions.dataGrouping = dataGrouping;
	                }, false);
	            }
	
	            if (redraw) {
	                this.chart.redraw();
	            }
	        };
	
	
	
	        /* ****************************************************************************
	         * End data grouping module												   *
	         ******************************************************************************/
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var each = H.each,
	            Point = H.Point,
	            seriesType = H.seriesType,
	            seriesTypes = H.seriesTypes;
	
	        /**
	         * The ohlc series type.
	         *
	         * @constructor seriesTypes.ohlc
	         * @augments seriesTypes.column
	         */
	        /**
	         * @extends {plotOptions.column}
	         * @optionparent plotOptions.ohlc
	         */
	        seriesType('ohlc', 'column', {
	
	            /**
	             * The pixel width of the line/border. Defaults to `1`.
	             * 
	             * @type {Number}
	             * @sample {highstock} stock/plotoptions/ohlc-linewidth/ A greater line width
	             * @default 1
	             * @product highstock
	             */
	            lineWidth: 1,
	
	            /**
	             */
	            tooltip: {
	
	
	                /**
	                 */
	                pointFormat: '<span style="color:{point.color}">\u25CF</span> <b> {series.name}</b><br/>' +
	                    'Open: {point.open}<br/>' +
	                    'High: {point.high}<br/>' +
	                    'Low: {point.low}<br/>' +
	                    'Close: {point.close}<br/>'
	
	            },
	
	            /**
	             */
	            threshold: null,
	
	
	            /**
	             */
	            states: {
	
	                /**
	                 * @extends plotOptions.column.states.hover
	                 * @product highstock
	                 */
	                hover: {
	
	                    /**
	                     * The pixel width of the line representing the OHLC point. Defaults
	                     * to `3`.
	                     * 
	                     * @type {Number}
	                     * @default 3
	                     * @product highstock
	                     */
	                    lineWidth: 3
	                }
	            },
	
	            /**
	             */
	            stickyTracking: true
	            //upColor: undefined
	
	
	        }, /** @lends seriesTypes.ohlc */ {
	            directTouch: false,
	            pointArrayMap: ['open', 'high', 'low', 'close'], // array point configs are mapped to this
	            toYData: function(point) { // return a plain array for speedy calculation
	                return [point.open, point.high, point.low, point.close];
	            },
	            pointValKey: 'close',
	
	
	            pointAttrToOptions: {
	                'stroke': 'color',
	                'stroke-width': 'lineWidth'
	            },
	
	            /**
	             * Postprocess mapping between options and SVG attributes
	             */
	            pointAttribs: function(point, state) {
	                var attribs = seriesTypes.column.prototype.pointAttribs.call(
	                        this,
	                        point,
	                        state
	                    ),
	                    options = this.options;
	
	                delete attribs.fill;
	
	                if (!point.options.color &&
	                    options.upColor &&
	                    point.open < point.close
	                ) {
	                    attribs.stroke = options.upColor;
	                }
	
	                return attribs;
	            },
	
	
	            /**
	             * Translate data points from raw values x and y to plotX and plotY
	             */
	            translate: function() {
	                var series = this,
	                    yAxis = series.yAxis,
	                    hasModifyValue = !!series.modifyValue,
	                    translated = ['plotOpen', 'plotHigh', 'plotLow', 'plotClose', 'yBottom']; // translate OHLC for
	
	                seriesTypes.column.prototype.translate.apply(series);
	
	                // Do the translation
	                each(series.points, function(point) {
	                    each([point.open, point.high, point.low, point.close, point.low], function(value, i) {
	                        if (value !== null) {
	                            if (hasModifyValue) {
	                                value = series.modifyValue(value);
	                            }
	                            point[translated[i]] = yAxis.toPixels(value, true);
	                        }
	                    });
	
	                    // Align the tooltip to the high value to avoid covering the point
	                    point.tooltipPos[1] =
	                        point.plotHigh + yAxis.pos - series.chart.plotTop;
	                });
	            },
	
	            /**
	             * Draw the data points
	             */
	            drawPoints: function() {
	                var series = this,
	                    points = series.points,
	                    chart = series.chart;
	
	
	                each(points, function(point) {
	                    var plotOpen,
	                        plotClose,
	                        crispCorr,
	                        halfWidth,
	                        path,
	                        graphic = point.graphic,
	                        crispX,
	                        isNew = !graphic;
	
	                    if (point.plotY !== undefined) {
	
	                        // Create and/or update the graphic
	                        if (!graphic) {
	                            point.graphic = graphic = chart.renderer.path()
	                                .add(series.group);
	                        }
	
	
	                        graphic.attr(series.pointAttribs(point, point.selected && 'select')); // #3897
	
	
	                        // crisp vector coordinates
	                        crispCorr = (graphic.strokeWidth() % 2) / 2;
	                        crispX = Math.round(point.plotX) - crispCorr; // #2596
	                        halfWidth = Math.round(point.shapeArgs.width / 2);
	
	                        // the vertical stem
	                        path = [
	                            'M',
	                            crispX, Math.round(point.yBottom),
	                            'L',
	                            crispX, Math.round(point.plotHigh)
	                        ];
	
	                        // open
	                        if (point.open !== null) {
	                            plotOpen = Math.round(point.plotOpen) + crispCorr;
	                            path.push(
	                                'M',
	                                crispX,
	                                plotOpen,
	                                'L',
	                                crispX - halfWidth,
	                                plotOpen
	                            );
	                        }
	
	                        // close
	                        if (point.close !== null) {
	                            plotClose = Math.round(point.plotClose) + crispCorr;
	                            path.push(
	                                'M',
	                                crispX,
	                                plotClose,
	                                'L',
	                                crispX + halfWidth,
	                                plotClose
	                            );
	                        }
	
	                        graphic[isNew ? 'attr' : 'animate']({
	                                d: path
	                            })
	                            .addClass(point.getClassName(), true);
	
	                    }
	
	
	                });
	
	            },
	
	            animate: null // Disable animation
	
	            /**
	             * @constructor seriesTypes.ohlc.prototype.pointClass
	             * @extends {Point}
	             */
	        }, /** @lends seriesTypes.ohlc.prototype.pointClass.prototype */ {
	            /**
	             * Extend the parent method by adding up or down to the class name.
	             */
	            getClassName: function() {
	                return Point.prototype.getClassName.call(this) +
	                    (this.open < this.close ? ' highcharts-point-up' : ' highcharts-point-down');
	            }
	        });
	        /* ****************************************************************************
	         * End OHLC series code													   *
	         *****************************************************************************/
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var defaultPlotOptions = H.defaultPlotOptions,
	            each = H.each,
	            merge = H.merge,
	            seriesType = H.seriesType,
	            seriesTypes = H.seriesTypes;
	
	        /**
	         * @extends {plotOptions.ohlc}
	         * @products highstock
	         * @optionparent plotOptions.candlestick
	         */
	        var candlestickOptions = {
	
	            /**
	             */
	            states: {
	
	                /**
	                 * @extends plotOptions.column.states.hover
	                 * @product highstock
	                 */
	                hover: {
	
	                    /**
	                     * The pixel width of the line/border around the candlestick. Defaults
	                     * to `2`.
	                     * 
	                     * @type {Number}
	                     * @default 2
	                     * @product highstock
	                     */
	                    lineWidth: 2
	                }
	            },
	
	            /**
	             */
	            tooltip: defaultPlotOptions.ohlc.tooltip,
	
	            /**
	             */
	            threshold: null,
	
	
	            /**
	             * The color of the line/border of the candlestick.
	             * 
	             * In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	             * style/style-by-css), the line stroke can be set with the `.highcharts-
	             * candlestick-series .highcahrts-point` rule.
	             * 
	             * @type {Color}
	             * @see [upLineColor](#plotOptions.candlestick.upLineColor)
	             * @sample {highstock} stock/plotoptions/candlestick-linecolor/ Candlestick line colors
	             * @default #000000
	             * @product highstock
	             */
	            lineColor: '#000000',
	
	            /**
	             * The pixel width of the candlestick line/border. Defaults to `1`.
	             * 
	             * 
	             * In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	             * style/style-by-css), the line stroke width can be set with the `.
	             * highcharts-candlestick-series .highcahrts-point` rule.
	             * 
	             * @type {Number}
	             * @default 1
	             * @product highstock
	             */
	            lineWidth: 1,
	
	            /**
	             * The fill color of the candlestick when values are rising.
	             * 
	             * In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	             * style/style-by-css), the up color can be set with the `.highcharts-
	             * candlestick-series .highcharts-point-up` rule.
	             * 
	             * @type {Color}
	             * @sample {highstock} stock/plotoptions/candlestick-color/ Custom colors
	             * @sample {highstock} highcharts/css/candlestick/ Colors in styled mode
	             * @default #ffffff
	             * @product highstock
	             */
	            upColor: '#ffffff',
	
	            /**
	             */
	            stickyTracking: true
	            // upLineColor: null
	
	
	        };
	
	        /**
	         * The candlestick series type.
	         *
	         * @constructor seriesTypes.candlestick
	         * @augments seriesTypes.ohlc
	         */
	        seriesType('candlestick', 'ohlc', merge(
	            defaultPlotOptions.column,
	            candlestickOptions
	        ), /** @lends seriesTypes.candlestick */ {
	
	            /**
	             * Postprocess mapping between options and SVG attributes
	             */
	            pointAttribs: function(point, state) {
	                var attribs = seriesTypes.column.prototype.pointAttribs.call(this, point, state),
	                    options = this.options,
	                    isUp = point.open < point.close,
	                    stroke = options.lineColor || this.color,
	                    stateOptions;
	
	                attribs['stroke-width'] = options.lineWidth;
	
	                attribs.fill = point.options.color || (isUp ? (options.upColor || this.color) : this.color);
	                attribs.stroke = point.lineColor || (isUp ? (options.upLineColor || stroke) : stroke);
	
	                // Select or hover states
	                if (state) {
	                    stateOptions = options.states[state];
	                    attribs.fill = stateOptions.color || attribs.fill;
	                    attribs.stroke = stateOptions.lineColor || attribs.stroke;
	                    attribs['stroke-width'] =
	                        stateOptions.lineWidth || attribs['stroke-width'];
	                }
	
	
	                return attribs;
	            },
	
	            /**
	             * Draw the data points
	             */
	            drawPoints: function() {
	                var series = this, //state = series.state,
	                    points = series.points,
	                    chart = series.chart;
	
	
	                each(points, function(point) {
	
	                    var graphic = point.graphic,
	                        plotOpen,
	                        plotClose,
	                        topBox,
	                        bottomBox,
	                        hasTopWhisker,
	                        hasBottomWhisker,
	                        crispCorr,
	                        crispX,
	                        path,
	                        halfWidth,
	                        isNew = !graphic;
	
	                    if (point.plotY !== undefined) {
	
	                        if (!graphic) {
	                            point.graphic = graphic = chart.renderer.path()
	                                .add(series.group);
	                        }
	
	
	                        graphic
	                            .attr(series.pointAttribs(point, point.selected && 'select')) // #3897
	                            .shadow(series.options.shadow);
	
	
	                        // Crisp vector coordinates
	                        crispCorr = (graphic.strokeWidth() % 2) / 2;
	                        crispX = Math.round(point.plotX) - crispCorr; // #2596
	                        plotOpen = point.plotOpen;
	                        plotClose = point.plotClose;
	                        topBox = Math.min(plotOpen, plotClose);
	                        bottomBox = Math.max(plotOpen, plotClose);
	                        halfWidth = Math.round(point.shapeArgs.width / 2);
	                        hasTopWhisker = Math.round(topBox) !== Math.round(point.plotHigh);
	                        hasBottomWhisker = bottomBox !== point.yBottom;
	                        topBox = Math.round(topBox) + crispCorr;
	                        bottomBox = Math.round(bottomBox) + crispCorr;
	
	                        // Create the path. Due to a bug in Chrome 49, the path is first instanciated
	                        // with no values, then the values pushed. For unknown reasons, instanciated
	                        // the path array with all the values would lead to a crash when updating
	                        // frequently (#5193).
	                        path = [];
	                        path.push(
	                            'M',
	                            crispX - halfWidth, bottomBox,
	                            'L',
	                            crispX - halfWidth, topBox,
	                            'L',
	                            crispX + halfWidth, topBox,
	                            'L',
	                            crispX + halfWidth, bottomBox,
	                            'Z', // Use a close statement to ensure a nice rectangle #2602
	                            'M',
	                            crispX, topBox,
	                            'L',
	                            crispX, hasTopWhisker ? Math.round(point.plotHigh) : topBox, // #460, #2094
	                            'M',
	                            crispX, bottomBox,
	                            'L',
	                            crispX, hasBottomWhisker ? Math.round(point.yBottom) : bottomBox // #460, #2094
	                        );
	
	                        graphic[isNew ? 'attr' : 'animate']({
	                                d: path
	                            })
	                            .addClass(point.getClassName(), true);
	
	                    }
	                });
	
	            }
	
	
	        });
	
	        /* ****************************************************************************
	         * End Candlestick series code												*
	         *****************************************************************************/
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var addEvent = H.addEvent,
	            each = H.each,
	            merge = H.merge,
	            noop = H.noop,
	            Renderer = H.Renderer,
	            Series = H.Series,
	            seriesType = H.seriesType,
	            seriesTypes = H.seriesTypes,
	            SVGRenderer = H.SVGRenderer,
	            TrackerMixin = H.TrackerMixin,
	            VMLRenderer = H.VMLRenderer,
	            symbols = SVGRenderer.prototype.symbols,
	            stableSort = H.stableSort;
	
	        /**
	         * The flags series type.
	         *
	         * @constructor seriesTypes.flags
	         * @augments seriesTypes.column
	         */
	        /**
	         * @extends {plotOptions.column}
	         * @optionparent plotOptions.flags
	         */
	        seriesType('flags', 'column', {
	
	            /**
	             */
	            pointRange: 0, // #673
	            //radius: 2,
	
	            /**
	             * The shape of the marker. Can be one of "flag", "circlepin", "squarepin",
	             * or an image on the format `url(/path-to-image.jpg)`. Individual
	             * shapes can also be set for each point.
	             * 
	             * @validvalue ["flag", "circlepin", "squarepin"]
	             * @type {String}
	             * @sample {highstock} stock/plotoptions/flags/ Different shapes
	             * @default flag
	             * @product highstock
	             */
	            shape: 'flag',
	
	            /**
	             * When multiple flags in the same series fall on the same value, this
	             * number determines the vertical offset between them.
	             * 
	             * @type {Number}
	             * @sample {highstock} stock/plotoptions/flags-stackdistance/ A greater stack distance
	             * @default 12
	             * @product highstock
	             */
	            stackDistance: 12,
	
	            /**
	             * Text alignment for the text inside the flag.
	             * 
	             * @validvalue ["left", "center", "right"]
	             * @type {String}
	             * @default center
	             * @since 5.0.0
	             * @product highstock
	             */
	            textAlign: 'center',
	
	            /**
	             * Specific tooltip options for flag series. Flag series tooltips are
	             * different from most other types in that a flag doesn't have a data
	             * value, so the tooltip rather displays the `text` option for each
	             * point.
	             * 
	             * @type {Object}
	             * @extends plotOptions.series.tooltip
	             * @excluding changeDecimals,valueDecimals,valuePrefix,valueSuffix
	             * @product highstock
	             */
	            tooltip: {
	
	                /**
	                 */
	                pointFormat: '{point.text}<br/>'
	            },
	
	            /**
	             */
	            threshold: null,
	
	            /**
	             * The y position of the top left corner of the flag relative to either
	             * the series (if onSeries is defined), or the x axis. Defaults to
	             * `-30`.
	             * 
	             * @type {Number}
	             * @default -30
	             * @product highstock
	             */
	            y: -30,
	
	
	            /**
	             */
	            fillColor: '#ffffff',
	            // lineColor: color,
	
	            /**
	             * The pixel width of the candlestick line/border. Defaults to `1`.
	             * 
	             * @type {Number}
	             * @default 1
	             * @product highstock
	             */
	            lineWidth: 1,
	
	            /**
	             */
	            states: {
	
	                /**
	                 * @extends plotOptions.column.states.hover
	                 * @product highstock
	                 */
	                hover: {
	
	                    /**
	                     * The color of the line/border of the flag Defaults to `"black"`.
	                     * 
	                     * @type {String}
	                     * @default "black"
	                     * @product highstock
	                     */
	                    lineColor: '#000000',
	
	                    /**
	                     * The fill or background color of the flag Defaults to `"#FCFFC5"`.
	                     * 
	                     * @type {String}
	                     * @default "#FCFFC5"
	                     * @product highstock
	                     */
	                    fillColor: '#ccd6eb'
	                }
	            },
	
	            /**
	             * The text styles of the flag.
	             * 
	             * In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	             * style/style-by-css), the styles are set in the `.highcharts-flag-
	             * series .highcharts-point` rule.
	             * 
	             * @type {CSSObject}
	             * @default { "fontSize": "11px", "fontWeight": "bold" }
	             * @product highstock
	             */
	            style: {
	
	                /**
	                 */
	                fontSize: '11px',
	
	                /**
	                 */
	                fontWeight: 'bold'
	            }
	
	
	        }, /** @lends seriesTypes.flags.prototype */ {
	            sorted: false,
	            noSharedTooltip: true,
	            allowDG: false,
	            takeOrdinalPosition: false, // #1074
	            trackerGroups: ['markerGroup'],
	            forceCrop: true,
	            /**
	             * Inherit the initialization from base Series.
	             */
	            init: Series.prototype.init,
	
	
	            /**
	             * Get presentational attributes
	             */
	            pointAttribs: function(point, state) {
	                var options = this.options,
	                    color = (point && point.color) || this.color,
	                    lineColor = options.lineColor,
	                    lineWidth = (point && point.lineWidth),
	                    fill = (point && point.fillColor) || options.fillColor;
	
	                if (state) {
	                    fill = options.states[state].fillColor;
	                    lineColor = options.states[state].lineColor;
	                    lineWidth = options.states[state].lineWidth;
	                }
	
	                return {
	                    'fill': fill || color,
	                    'stroke': lineColor || color,
	                    'stroke-width': lineWidth || options.lineWidth || 0
	                };
	            },
	
	
	            /**
	             * Extend the translate method by placing the point on the related series
	             */
	            translate: function() {
	
	                seriesTypes.column.prototype.translate.apply(this);
	
	                var series = this,
	                    options = series.options,
	                    chart = series.chart,
	                    points = series.points,
	                    cursor = points.length - 1,
	                    point,
	                    lastPoint,
	                    optionsOnSeries = options.onSeries,
	                    onSeries = optionsOnSeries && chart.get(optionsOnSeries),
	                    onKey = options.onKey || 'y',
	                    step = onSeries && onSeries.options.step,
	                    onData = onSeries && onSeries.points,
	                    i = onData && onData.length,
	                    xAxis = series.xAxis,
	                    yAxis = series.yAxis,
	                    xAxisExt = xAxis.getExtremes(),
	                    xOffset = 0,
	                    leftPoint,
	                    lastX,
	                    rightPoint,
	                    currentDataGrouping;
	
	                // relate to a master series
	                if (onSeries && onSeries.visible && i) {
	                    xOffset = (onSeries.pointXOffset || 0) + (onSeries.barW || 0) / 2;
	                    currentDataGrouping = onSeries.currentDataGrouping;
	                    lastX = onData[i - 1].x + (currentDataGrouping ? currentDataGrouping.totalRange : 0); // #2374
	
	                    // sort the data points
	                    stableSort(points, function(a, b) {
	                        return (a.x - b.x);
	                    });
	
	                    onKey = 'plot' + onKey[0].toUpperCase() + onKey.substr(1);
	                    while (i-- && points[cursor]) {
	                        point = points[cursor];
	                        leftPoint = onData[i];
	                        if (leftPoint.x <= point.x && leftPoint[onKey] !== undefined) {
	                            if (point.x <= lastX) { // #803
	
	                                point.plotY = leftPoint[onKey];
	
	                                // interpolate between points, #666
	                                if (leftPoint.x < point.x && !step) {
	                                    rightPoint = onData[i + 1];
	                                    if (rightPoint && rightPoint[onKey] !== undefined) {
	                                        point.plotY +=
	                                            ((point.x - leftPoint.x) / (rightPoint.x - leftPoint.x)) * // the distance ratio, between 0 and 1
	                                            (rightPoint[onKey] - leftPoint[onKey]); // the y distance
	                                    }
	                                }
	                            }
	                            cursor--;
	                            i++; // check again for points in the same x position
	                            if (cursor < 0) {
	                                break;
	                            }
	                        }
	                    }
	                }
	
	                // Add plotY position and handle stacking
	                each(points, function(point, i) {
	
	                    var stackIndex;
	
	                    // Undefined plotY means the point is either on axis, outside series
	                    // range or hidden series. If the series is outside the range of the
	                    // x axis it should fall through with an undefined plotY, but then
	                    // we must remove the shapeArgs (#847).
	                    if (point.plotY === undefined) {
	                        if (point.x >= xAxisExt.min && point.x <= xAxisExt.max) {
	                            // we're inside xAxis range
	                            point.plotY = chart.chartHeight - xAxis.bottom -
	                                (xAxis.opposite ? xAxis.height : 0) +
	                                xAxis.offset - yAxis.top; // #3517
	                        } else {
	                            point.shapeArgs = {}; // 847
	                        }
	                    }
	                    point.plotX += xOffset; // #2049
	                    // if multiple flags appear at the same x, order them into a stack
	                    lastPoint = points[i - 1];
	                    if (lastPoint && lastPoint.plotX === point.plotX) {
	                        if (lastPoint.stackIndex === undefined) {
	                            lastPoint.stackIndex = 0;
	                        }
	                        stackIndex = lastPoint.stackIndex + 1;
	                    }
	                    point.stackIndex = stackIndex; // #3639
	                });
	
	
	            },
	
	            /**
	             * Draw the markers
	             */
	            drawPoints: function() {
	                var series = this,
	                    points = series.points,
	                    chart = series.chart,
	                    renderer = chart.renderer,
	                    plotX,
	                    plotY,
	                    options = series.options,
	                    optionsY = options.y,
	                    shape,
	                    i,
	                    point,
	                    graphic,
	                    stackIndex,
	                    anchorX,
	                    anchorY,
	                    outsideRight,
	                    yAxis = series.yAxis;
	
	                i = points.length;
	                while (i--) {
	                    point = points[i];
	                    outsideRight = point.plotX > series.xAxis.len;
	                    plotX = point.plotX;
	                    stackIndex = point.stackIndex;
	                    shape = point.options.shape || options.shape;
	                    plotY = point.plotY;
	
	                    if (plotY !== undefined) {
	                        plotY = point.plotY + optionsY - (stackIndex !== undefined && stackIndex * options.stackDistance);
	                    }
	                    anchorX = stackIndex ? undefined : point.plotX; // skip connectors for higher level stacked points
	                    anchorY = stackIndex ? undefined : point.plotY;
	
	                    graphic = point.graphic;
	
	                    // Only draw the point if y is defined and the flag is within the visible area
	                    if (plotY !== undefined && plotX >= 0 && !outsideRight) {
	
	                        // Create the flag
	                        if (!graphic) {
	                            graphic = point.graphic = renderer.label(
	                                    '',
	                                    null,
	                                    null,
	                                    shape,
	                                    null,
	                                    null,
	                                    options.useHTML
	                                )
	
	                                .attr(series.pointAttribs(point))
	                                .css(merge(options.style, point.style))
	
	                                .attr({
	                                    align: shape === 'flag' ? 'left' : 'center',
	                                    width: options.width,
	                                    height: options.height,
	                                    'text-align': options.textAlign
	                                })
	                                .addClass('highcharts-point')
	                                .add(series.markerGroup);
	
	                            // Add reference to the point for tracker (#6303)
	                            if (point.graphic.div) {
	                                point.graphic.div.point = point;
	                            }
	
	
	                            graphic.shadow(options.shadow);
	
	                        }
	
	                        if (plotX > 0) { // #3119
	                            plotX -= graphic.strokeWidth() % 2; // #4285
	                        }
	
	                        // Plant the flag
	                        graphic.attr({
	                            text: point.options.title || options.title || 'A',
	                            x: plotX,
	                            y: plotY,
	                            anchorX: anchorX,
	                            anchorY: anchorY
	                        });
	
	                        // Set the tooltip anchor position
	                        point.tooltipPos = chart.inverted ? [yAxis.len + yAxis.pos - chart.plotLeft - plotY, series.xAxis.len - plotX] : [plotX, plotY + yAxis.pos - chart.plotTop]; // #6327
	
	                    } else if (graphic) {
	                        point.graphic = graphic.destroy();
	                    }
	
	                }
	
	                // Might be a mix of SVG and HTML and we need events for both (#6303)
	                if (options.useHTML) {
	                    H.wrap(series.markerGroup, 'on', function(proceed) {
	                        return H.SVGElement.prototype.on.apply(
	                            proceed.apply(this, [].slice.call(arguments, 1)), // for HTML
	                            [].slice.call(arguments, 1)); // and for SVG
	                    });
	                }
	
	            },
	
	            /**
	             * Extend the column trackers with listeners to expand and contract stacks
	             */
	            drawTracker: function() {
	                var series = this,
	                    points = series.points;
	
	                TrackerMixin.drawTrackerPoint.apply(this);
	
	                // Bring each stacked flag up on mouse over, this allows readability of vertically
	                // stacked elements as well as tight points on the x axis. #1924.
	                each(points, function(point) {
	                    var graphic = point.graphic;
	                    if (graphic) {
	                        addEvent(graphic.element, 'mouseover', function() {
	
	                            // Raise this point
	                            if (point.stackIndex > 0 && !point.raised) {
	                                point._y = graphic.y;
	                                graphic.attr({
	                                    y: point._y - 8
	                                });
	                                point.raised = true;
	                            }
	
	                            // Revert other raised points
	                            each(points, function(otherPoint) {
	                                if (otherPoint !== point && otherPoint.raised && otherPoint.graphic) {
	                                    otherPoint.graphic.attr({
	                                        y: otherPoint._y
	                                    });
	                                    otherPoint.raised = false;
	                                }
	                            });
	                        });
	                    }
	                });
	            },
	
	            animate: noop, // Disable animation
	            buildKDTree: noop,
	            setClip: noop
	
	        });
	
	        // create the flag icon with anchor
	        symbols.flag = function(x, y, w, h, options) {
	            var anchorX = (options && options.anchorX) || x,
	                anchorY = (options && options.anchorY) || y;
	
	            return [
	                'M', anchorX, anchorY,
	                'L', x, y + h,
	                x, y,
	                x + w, y,
	                x + w, y + h,
	                x, y + h,
	                'Z'
	            ];
	        };
	
	        // create the circlepin and squarepin icons with anchor
	        each(['circle', 'square'], function(shape) {
	            symbols[shape + 'pin'] = function(x, y, w, h, options) {
	
	                var anchorX = options && options.anchorX,
	                    anchorY = options && options.anchorY,
	                    path,
	                    labelTopOrBottomY;
	
	                // For single-letter flags, make sure circular flags are not taller than their width
	                if (shape === 'circle' && h > w) {
	                    x -= Math.round((h - w) / 2);
	                    w = h;
	                }
	
	                path = symbols[shape](x, y, w, h);
	
	                if (anchorX && anchorY) {
	                    // if the label is below the anchor, draw the connecting line from the top edge of the label
	                    // otherwise start drawing from the bottom edge
	                    labelTopOrBottomY = (y > anchorY) ? y : y + h;
	                    path.push('M', anchorX, labelTopOrBottomY, 'L', anchorX, anchorY);
	                }
	
	                return path;
	            };
	        });
	
	
	        // The symbol callbacks are generated on the SVGRenderer object in all browsers. Even
	        // VML browsers need this in order to generate shapes in export. Now share
	        // them with the VMLRenderer.
	        if (Renderer === VMLRenderer) {
	            each(['flag', 'circlepin', 'squarepin'], function(shape) {
	                VMLRenderer.prototype.symbols[shape] = symbols[shape];
	            });
	        }
	
	        /* ****************************************************************************
	         * End Flags series code													  *
	         *****************************************************************************/
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var addEvent = H.addEvent,
	            Axis = H.Axis,
	            correctFloat = H.correctFloat,
	            defaultOptions = H.defaultOptions,
	            defined = H.defined,
	            destroyObjectProperties = H.destroyObjectProperties,
	            each = H.each,
	            fireEvent = H.fireEvent,
	            hasTouch = H.hasTouch,
	            isTouchDevice = H.isTouchDevice,
	            merge = H.merge,
	            pick = H.pick,
	            removeEvent = H.removeEvent,
	            svg = H.svg,
	            wrap = H.wrap,
	            swapXY;
	
	        /**
	         * 
	         * The scrollbar is a means of panning over the X axis of a chart.
	         * 
	         * In [styled mode](http://www.highcharts.com/docs/chart-design-
	         * and-style/style-by-css), all the presentational options for the
	         * scrollbar are replaced by the classes `.highcharts-scrollbar-
	         * thumb`, `.highcharts-scrollbar-arrow`, `.highcharts-scrollbar-
	         * button`, `.highcharts-scrollbar-rifles` and `.highcharts-scrollbar-
	         * track`.
	         * 
	         * @product highstock
	         * @optionparent scrollbar
	         */
	        var defaultScrollbarOptions = {
	            //enabled: true
	
	            /**
	             * The height of the scrollbar. The height also applies to the width
	             * of the scroll arrows so that they are always squares. Defaults to
	             * 20 for touch devices and 14 for mouse devices.
	             * 
	             * @type {Number}
	             * @sample {highstock} stock/scrollbar/height/ A 30px scrollbar
	             * @product highstock
	             */
	            height: isTouchDevice ? 20 : 14,
	            // trackBorderRadius: 0
	
	            /**
	             * The border rounding radius of the bar.
	             * 
	             * @type {Number}
	             * @sample {highstock} stock/scrollbar/style/ Scrollbar styling
	             * @default 0
	             * @product highstock
	             */
	            barBorderRadius: 0,
	
	            /**
	             * The corner radius of the scrollbar buttons.
	             * 
	             * @type {Number}
	             * @sample {highstock} stock/scrollbar/style/ Scrollbar styling
	             * @default 0
	             * @product highstock
	             */
	            buttonBorderRadius: 0,
	
	            /**
	             * Whether to redraw the main chart as the scrollbar or the navigator
	             * zoomed window is moved. Defaults to `true` for modern browsers and
	             * `false` for legacy IE browsers as well as mobile devices.
	             * 
	             * @type {Boolean}
	             * @since 1.3
	             * @product highstock
	             */
	            liveRedraw: svg && !isTouchDevice,
	
	            /**
	             */
	            margin: 10,
	
	            /**
	             * The minimum width of the scrollbar.
	             * 
	             * @type {Number}
	             * @default 6
	             * @since 1.2.5
	             * @product highstock
	             */
	            minWidth: 6,
	            //showFull: true,
	            //size: null,
	
	            /**
	             */
	            step: 0.2,
	
	            /**
	             */
	            zIndex: 3,
	
	
	            /**
	             * The background color of the scrollbar itself.
	             * 
	             * @type {Color}
	             * @sample {highstock} stock/scrollbar/style/ Scrollbar styling
	             * @default #cccccc
	             * @product highstock
	             */
	            barBackgroundColor: '#cccccc',
	
	            /**
	             * The width of the bar's border.
	             * 
	             * @type {Number}
	             * @sample {highstock} stock/scrollbar/style/ Scrollbar styling
	             * @default 1
	             * @product highstock
	             */
	            barBorderWidth: 1,
	
	            /**
	             * The color of the scrollbar's border.
	             * 
	             * @type {Color}
	             * @default #cccccc
	             * @product highstock
	             */
	            barBorderColor: '#cccccc',
	
	            /**
	             * The color of the small arrow inside the scrollbar buttons.
	             * 
	             * @type {Color}
	             * @sample {highstock} stock/scrollbar/style/ Scrollbar styling
	             * @default #333333
	             * @product highstock
	             */
	            buttonArrowColor: '#333333',
	
	            /**
	             * The color of scrollbar buttons.
	             * 
	             * @type {Color}
	             * @sample {highstock} stock/scrollbar/style/ Scrollbar styling
	             * @default #e6e6e6
	             * @product highstock
	             */
	            buttonBackgroundColor: '#e6e6e6',
	
	            /**
	             * The color of the border of the scrollbar buttons.
	             * 
	             * @type {Color}
	             * @sample {highstock} stock/scrollbar/style/ Scrollbar styling
	             * @default #cccccc
	             * @product highstock
	             */
	            buttonBorderColor: '#cccccc',
	
	            /**
	             * The border width of the scrollbar buttons.
	             * 
	             * @type {Number}
	             * @sample {highstock} stock/scrollbar/style/ Scrollbar styling
	             * @default 1
	             * @product highstock
	             */
	            buttonBorderWidth: 1,
	
	            /**
	             * The color of the small rifles in the middle of the scrollbar.
	             * 
	             * @type {Color}
	             * @default #333333
	             * @product highstock
	             */
	            rifleColor: '#333333',
	
	            /**
	             * The color of the track background.
	             * 
	             * @type {Color}
	             * @sample {highstock} stock/scrollbar/style/ Scrollbar styling
	             * @default #f2f2f2
	             * @product highstock
	             */
	            trackBackgroundColor: '#f2f2f2',
	
	            /**
	             * The color of the border of the scrollbar track.
	             * 
	             * @type {Color}
	             * @sample {highstock} stock/scrollbar/style/ Scrollbar styling
	             * @default #f2f2f2
	             * @product highstock
	             */
	            trackBorderColor: '#f2f2f2',
	
	            /**
	             * The width of the border of the scrollbar track.
	             * 
	             * @type {Number}
	             * @sample {highstock} stock/scrollbar/style/ Scrollbar styling
	             * @default 1
	             * @product highstock
	             */
	            trackBorderWidth: 1
	
	        };
	
	        defaultOptions.scrollbar = merge(true, defaultScrollbarOptions, defaultOptions.scrollbar);
	
	        /**
	         * When we have vertical scrollbar, rifles and arrow in buttons should be rotated.
	         * The same method is used in Navigator's handles, to rotate them.
	         * @param {Array} path - path to be rotated
	         * @param {Boolean} vertical - if vertical scrollbar, swap x-y values
	         */
	        H.swapXY = swapXY = function(path, vertical) {
	            var i,
	                len = path.length,
	                temp;
	
	            if (vertical) {
	                for (i = 0; i < len; i += 3) {
	                    temp = path[i + 1];
	                    path[i + 1] = path[i + 2];
	                    path[i + 2] = temp;
	                }
	            }
	
	            return path;
	        };
	
	        /**
	         * A reusable scrollbar, internally used in Highstock's navigator and optionally
	         * on individual axes.
	         *
	         * @class
	         * @param {Object} renderer
	         * @param {Object} options
	         * @param {Object} chart
	         */
	        function Scrollbar(renderer, options, chart) { // docs
	            this.init(renderer, options, chart);
	        }
	
	        Scrollbar.prototype = {
	
	            init: function(renderer, options, chart) {
	
	                this.scrollbarButtons = [];
	
	                this.renderer = renderer;
	
	                this.userOptions = options;
	                this.options = merge(defaultScrollbarOptions, options);
	
	                this.chart = chart;
	
	                this.size = pick(this.options.size, this.options.height); // backward compatibility
	
	                // Init
	                if (options.enabled) {
	                    this.render();
	                    this.initEvents();
	                    this.addEvents();
	                }
	            },
	
	            /**
	             * Render scrollbar with all required items.
	             */
	            render: function() {
	                var scroller = this,
	                    renderer = scroller.renderer,
	                    options = scroller.options,
	                    size = scroller.size,
	                    group;
	
	                // Draw the scrollbar group
	                scroller.group = group = renderer.g('scrollbar').attr({
	                    zIndex: options.zIndex,
	                    translateY: -99999
	                }).add();
	
	                // Draw the scrollbar track:
	                scroller.track = renderer.rect()
	                    .addClass('highcharts-scrollbar-track')
	                    .attr({
	                        x: 0,
	                        r: options.trackBorderRadius || 0,
	                        height: size,
	                        width: size
	                    }).add(group);
	
	
	                scroller.track.attr({
	                    fill: options.trackBackgroundColor,
	                    stroke: options.trackBorderColor,
	                    'stroke-width': options.trackBorderWidth
	                });
	
	                this.trackBorderWidth = scroller.track.strokeWidth();
	                scroller.track.attr({
	                    y: -this.trackBorderWidth % 2 / 2
	                });
	
	
	                // Draw the scrollbar itself
	                scroller.scrollbarGroup = renderer.g().add(group);
	
	                scroller.scrollbar = renderer.rect()
	                    .addClass('highcharts-scrollbar-thumb')
	                    .attr({
	                        height: size,
	                        width: size,
	                        r: options.barBorderRadius || 0
	                    }).add(scroller.scrollbarGroup);
	
	                scroller.scrollbarRifles = renderer.path(
	                        swapXY([
	                            'M', -3, size / 4,
	                            'L', -3, 2 * size / 3,
	                            'M',
	                            0, size / 4,
	                            'L',
	                            0, 2 * size / 3,
	                            'M',
	                            3, size / 4,
	                            'L',
	                            3, 2 * size / 3
	                        ], options.vertical))
	                    .addClass('highcharts-scrollbar-rifles')
	                    .add(scroller.scrollbarGroup);
	
	
	                scroller.scrollbar.attr({
	                    fill: options.barBackgroundColor,
	                    stroke: options.barBorderColor,
	                    'stroke-width': options.barBorderWidth
	                });
	                scroller.scrollbarRifles.attr({
	                    stroke: options.rifleColor,
	                    'stroke-width': 1
	                });
	
	                scroller.scrollbarStrokeWidth = scroller.scrollbar.strokeWidth();
	                scroller.scrollbarGroup.translate(-scroller.scrollbarStrokeWidth % 2 / 2, -scroller.scrollbarStrokeWidth % 2 / 2);
	
	                // Draw the buttons:
	                scroller.drawScrollbarButton(0);
	                scroller.drawScrollbarButton(1);
	            },
	
	            /**
	             * Position the scrollbar, method called from a parent with defined dimensions
	             * @param {Number} x - x-position on the chart
	             * @param {Number} y - y-position on the chart
	             * @param {Number} width - width of the scrollbar
	             * @param {Number} height - height of the scorllbar
	             */
	            position: function(x, y, width, height) {
	                var scroller = this,
	                    options = scroller.options,
	                    vertical = options.vertical,
	                    xOffset = height,
	                    yOffset = 0,
	                    method = scroller.rendered ? 'animate' : 'attr';
	
	                scroller.x = x;
	                scroller.y = y + this.trackBorderWidth;
	                scroller.width = width; // width with buttons
	                scroller.height = height;
	                scroller.xOffset = xOffset;
	                scroller.yOffset = yOffset;
	
	                // If Scrollbar is a vertical type, swap options:
	                if (vertical) {
	                    scroller.width = scroller.yOffset = width = yOffset = scroller.size;
	                    scroller.xOffset = xOffset = 0;
	                    scroller.barWidth = height - width * 2; // width without buttons
	                    scroller.x = x = x + scroller.options.margin;
	                } else {
	                    scroller.height = scroller.xOffset = height = xOffset = scroller.size;
	                    scroller.barWidth = width - height * 2; // width without buttons
	                    scroller.y = scroller.y + scroller.options.margin;
	                }
	
	                // Set general position for a group:
	                scroller.group[method]({
	                    translateX: x,
	                    translateY: scroller.y
	                });
	
	                // Resize background/track:
	                scroller.track[method]({
	                    width: width,
	                    height: height
	                });
	
	                // Move right/bottom button ot it's place:
	                scroller.scrollbarButtons[1][method]({
	                    translateX: vertical ? 0 : width - xOffset,
	                    translateY: vertical ? height - yOffset : 0
	                });
	            },
	
	            /**
	             * Draw the scrollbar buttons with arrows
	             * @param {Number} index 0 is left, 1 is right
	             */
	            drawScrollbarButton: function(index) {
	                var scroller = this,
	                    renderer = scroller.renderer,
	                    scrollbarButtons = scroller.scrollbarButtons,
	                    options = scroller.options,
	                    size = scroller.size,
	                    group,
	                    tempElem;
	
	                group = renderer.g().add(scroller.group);
	                scrollbarButtons.push(group);
	
	                // Create a rectangle for the scrollbar button
	                tempElem = renderer.rect()
	                    .addClass('highcharts-scrollbar-button')
	                    .add(group);
	
	
	                // Presentational attributes
	                tempElem.attr({
	                    stroke: options.buttonBorderColor,
	                    'stroke-width': options.buttonBorderWidth,
	                    fill: options.buttonBackgroundColor
	                });
	
	
	                // Place the rectangle based on the rendered stroke width
	                tempElem.attr(tempElem.crisp({
	                    x: -0.5,
	                    y: -0.5,
	                    width: size + 1, // +1 to compensate for crispifying in rect method
	                    height: size + 1,
	                    r: options.buttonBorderRadius
	                }, tempElem.strokeWidth()));
	
	                // Button arrow
	                tempElem = renderer
	                    .path(swapXY([
	                        'M',
	                        size / 2 + (index ? -1 : 1),
	                        size / 2 - 3,
	                        'L',
	                        size / 2 + (index ? -1 : 1),
	                        size / 2 + 3,
	                        'L',
	                        size / 2 + (index ? 2 : -2),
	                        size / 2
	                    ], options.vertical))
	                    .addClass('highcharts-scrollbar-arrow')
	                    .add(scrollbarButtons[index]);
	
	
	                tempElem.attr({
	                    fill: options.buttonArrowColor
	                });
	
	            },
	
	            /**
	             * Set scrollbar size, with a given scale.
	             * @param {Number} from - scale (0-1) where bar should start
	             * @param {Number} to - scale (0-1) where bar should end
	             */
	            setRange: function(from, to) {
	                var scroller = this,
	                    options = scroller.options,
	                    vertical = options.vertical,
	                    minWidth = options.minWidth,
	                    fullWidth = scroller.barWidth,
	                    fromPX,
	                    toPX,
	                    newPos,
	                    newSize,
	                    newRiflesPos,
	                    method = this.rendered && !this.hasDragged ? 'animate' : 'attr';
	
	                if (!defined(fullWidth)) {
	                    return;
	                }
	
	                from = Math.max(from, 0);
	                fromPX = Math.ceil(fullWidth * from);
	                toPX = fullWidth * Math.min(to, 1);
	                scroller.calculatedWidth = newSize = correctFloat(toPX - fromPX);
	
	                // We need to recalculate position, if minWidth is used
	                if (newSize < minWidth) {
	                    fromPX = (fullWidth - minWidth + newSize) * from;
	                    newSize = minWidth;
	                }
	                newPos = Math.floor(fromPX + scroller.xOffset + scroller.yOffset);
	                newRiflesPos = newSize / 2 - 0.5; // -0.5 -> rifle line width / 2
	
	                // Store current position:
	                scroller.from = from;
	                scroller.to = to;
	
	                if (!vertical) {
	                    scroller.scrollbarGroup[method]({
	                        translateX: newPos
	                    });
	                    scroller.scrollbar[method]({
	                        width: newSize
	                    });
	                    scroller.scrollbarRifles[method]({
	                        translateX: newRiflesPos
	                    });
	                    scroller.scrollbarLeft = newPos;
	                    scroller.scrollbarTop = 0;
	                } else {
	                    scroller.scrollbarGroup[method]({
	                        translateY: newPos
	                    });
	                    scroller.scrollbar[method]({
	                        height: newSize
	                    });
	                    scroller.scrollbarRifles[method]({
	                        translateY: newRiflesPos
	                    });
	                    scroller.scrollbarTop = newPos;
	                    scroller.scrollbarLeft = 0;
	                }
	
	                if (newSize <= 12) {
	                    scroller.scrollbarRifles.hide();
	                } else {
	                    scroller.scrollbarRifles.show(true);
	                }
	
	                // Show or hide the scrollbar based on the showFull setting
	                if (options.showFull === false) {
	                    if (from <= 0 && to >= 1) {
	                        scroller.group.hide();
	                    } else {
	                        scroller.group.show();
	                    }
	                }
	
	                scroller.rendered = true;
	            },
	
	            /**
	             * Init events methods, so we have an access to the Scrollbar itself
	             */
	            initEvents: function() {
	                var scroller = this;
	                /**
	                 * Event handler for the mouse move event.
	                 */
	                scroller.mouseMoveHandler = function(e) {
	                    var normalizedEvent = scroller.chart.pointer.normalize(e),
	                        options = scroller.options,
	                        direction = options.vertical ? 'chartY' : 'chartX',
	                        initPositions = scroller.initPositions,
	                        scrollPosition,
	                        chartPosition,
	                        change;
	
	                    // In iOS, a mousemove event with e.pageX === 0 is fired when holding the finger
	                    // down in the center of the scrollbar. This should be ignored.
	                    if (scroller.grabbedCenter && (!e.touches || e.touches[0][direction] !== 0)) { // #4696, scrollbar failed on Android
	                        chartPosition = scroller.cursorToScrollbarPosition(normalizedEvent)[direction];
	                        scrollPosition = scroller[direction];
	
	                        change = chartPosition - scrollPosition;
	
	                        scroller.hasDragged = true;
	                        scroller.updatePosition(initPositions[0] + change, initPositions[1] + change);
	
	                        if (scroller.hasDragged) {
	                            fireEvent(scroller, 'changed', {
	                                from: scroller.from,
	                                to: scroller.to,
	                                trigger: 'scrollbar',
	                                DOMType: e.type,
	                                DOMEvent: e
	                            });
	                        }
	                    }
	                };
	
	                /**
	                 * Event handler for the mouse up event.
	                 */
	                scroller.mouseUpHandler = function(e) {
	                    if (scroller.hasDragged) {
	                        fireEvent(scroller, 'changed', {
	                            from: scroller.from,
	                            to: scroller.to,
	                            trigger: 'scrollbar',
	                            DOMType: e.type,
	                            DOMEvent: e
	                        });
	                    }
	                    scroller.grabbedCenter = scroller.hasDragged = scroller.chartX = scroller.chartY = null;
	                };
	
	                scroller.mouseDownHandler = function(e) {
	                    var normalizedEvent = scroller.chart.pointer.normalize(e),
	                        mousePosition = scroller.cursorToScrollbarPosition(normalizedEvent);
	
	                    scroller.chartX = mousePosition.chartX;
	                    scroller.chartY = mousePosition.chartY;
	                    scroller.initPositions = [scroller.from, scroller.to];
	
	                    scroller.grabbedCenter = true;
	                };
	
	                scroller.buttonToMinClick = function(e) {
	                    var range = correctFloat(scroller.to - scroller.from) * scroller.options.step;
	                    scroller.updatePosition(correctFloat(scroller.from - range), correctFloat(scroller.to - range));
	                    fireEvent(scroller, 'changed', {
	                        from: scroller.from,
	                        to: scroller.to,
	                        trigger: 'scrollbar',
	                        DOMEvent: e
	                    });
	                };
	
	                scroller.buttonToMaxClick = function(e) {
	                    var range = (scroller.to - scroller.from) * scroller.options.step;
	                    scroller.updatePosition(scroller.from + range, scroller.to + range);
	                    fireEvent(scroller, 'changed', {
	                        from: scroller.from,
	                        to: scroller.to,
	                        trigger: 'scrollbar',
	                        DOMEvent: e
	                    });
	                };
	
	                scroller.trackClick = function(e) {
	                    var normalizedEvent = scroller.chart.pointer.normalize(e),
	                        range = scroller.to - scroller.from,
	                        top = scroller.y + scroller.scrollbarTop,
	                        left = scroller.x + scroller.scrollbarLeft;
	
	                    if ((scroller.options.vertical && normalizedEvent.chartY > top) ||
	                        (!scroller.options.vertical && normalizedEvent.chartX > left)) {
	                        // On the top or on the left side of the track:
	                        scroller.updatePosition(scroller.from + range, scroller.to + range);
	                    } else {
	                        // On the bottom or the right side of the track:
	                        scroller.updatePosition(scroller.from - range, scroller.to - range);
	                    }
	
	                    fireEvent(scroller, 'changed', {
	                        from: scroller.from,
	                        to: scroller.to,
	                        trigger: 'scrollbar',
	                        DOMEvent: e
	                    });
	                };
	            },
	
	            /**
	             * Get normalized (0-1) cursor position over the scrollbar
	             * @param {Event} normalizedEvent - normalized event, with chartX and chartY values
	             * @return {Object} Local position {chartX, chartY}
	             */
	            cursorToScrollbarPosition: function(normalizedEvent) {
	                var scroller = this,
	                    options = scroller.options,
	                    minWidthDifference = options.minWidth > scroller.calculatedWidth ? options.minWidth : 0; // minWidth distorts translation
	
	                return {
	                    chartX: (normalizedEvent.chartX - scroller.x - scroller.xOffset) / (scroller.barWidth - minWidthDifference),
	                    chartY: (normalizedEvent.chartY - scroller.y - scroller.yOffset) / (scroller.barWidth - minWidthDifference)
	                };
	            },
	
	            /**
	             * Update position option in the Scrollbar, with normalized 0-1 scale
	             */
	            updatePosition: function(from, to) {
	                if (to > 1) {
	                    from = correctFloat(1 - correctFloat(to - from));
	                    to = 1;
	                }
	
	                if (from < 0) {
	                    to = correctFloat(to - from);
	                    from = 0;
	                }
	
	                this.from = from;
	                this.to = to;
	            },
	
	            /**
	             * Update the scrollbar with new options
	             */
	            update: function(options) {
	                this.destroy();
	                this.init(this.chart.renderer, merge(true, this.options, options), this.chart);
	            },
	
	            /**
	             * Set up the mouse and touch events for the Scrollbar
	             */
	            addEvents: function() {
	                var buttonsOrder = this.options.inverted ? [1, 0] : [0, 1],
	                    buttons = this.scrollbarButtons,
	                    bar = this.scrollbarGroup.element,
	                    track = this.track.element,
	                    mouseDownHandler = this.mouseDownHandler,
	                    mouseMoveHandler = this.mouseMoveHandler,
	                    mouseUpHandler = this.mouseUpHandler,
	                    _events;
	
	                // Mouse events
	                _events = [
	                    [buttons[buttonsOrder[0]].element, 'click', this.buttonToMinClick],
	                    [buttons[buttonsOrder[1]].element, 'click', this.buttonToMaxClick],
	                    [track, 'click', this.trackClick],
	                    [bar, 'mousedown', mouseDownHandler],
	                    [bar.ownerDocument, 'mousemove', mouseMoveHandler],
	                    [bar.ownerDocument, 'mouseup', mouseUpHandler]
	                ];
	
	                // Touch events
	                if (hasTouch) {
	                    _events.push(
	                        [bar, 'touchstart', mouseDownHandler], [bar.ownerDocument, 'touchmove', mouseMoveHandler], [bar.ownerDocument, 'touchend', mouseUpHandler]
	                    );
	                }
	
	                // Add them all
	                each(_events, function(args) {
	                    addEvent.apply(null, args);
	                });
	                this._events = _events;
	            },
	
	            /**
	             * Removes the event handlers attached previously with addEvents.
	             */
	            removeEvents: function() {
	                each(this._events, function(args) {
	                    removeEvent.apply(null, args);
	                });
	                this._events.length = 0;
	            },
	
	            /**
	             * Destroys allocated elements.
	             */
	            destroy: function() {
	
	                var scroller = this.chart.scroller;
	
	                // Disconnect events added in addEvents
	                this.removeEvents();
	
	                // Destroy properties
	                each(['track', 'scrollbarRifles', 'scrollbar', 'scrollbarGroup', 'group'], function(prop) {
	                    if (this[prop] && this[prop].destroy) {
	                        this[prop] = this[prop].destroy();
	                    }
	                }, this);
	
	                if (scroller && this === scroller.scrollbar) { // #6421, chart may have more scrollbars
	                    scroller.scrollbar = null;
	
	                    // Destroy elements in collection
	                    destroyObjectProperties(scroller.scrollbarButtons);
	                }
	            }
	        };
	
	        /**
	         * Wrap axis initialization and create scrollbar if enabled:
	         */
	        wrap(Axis.prototype, 'init', function(proceed) {
	            var axis = this;
	            proceed.apply(axis, Array.prototype.slice.call(arguments, 1));
	
	            if (axis.options.scrollbar && axis.options.scrollbar.enabled) {
	                // Predefined options:
	                axis.options.scrollbar.vertical = !axis.horiz;
	                axis.options.startOnTick = axis.options.endOnTick = false;
	
	                axis.scrollbar = new Scrollbar(axis.chart.renderer, axis.options.scrollbar, axis.chart);
	
	                addEvent(axis.scrollbar, 'changed', function(e) {
	                    var unitedMin = Math.min(pick(axis.options.min, axis.min), axis.min, axis.dataMin),
	                        unitedMax = Math.max(pick(axis.options.max, axis.max), axis.max, axis.dataMax),
	                        range = unitedMax - unitedMin,
	                        to,
	                        from;
	
	                    if ((axis.horiz && !axis.reversed) || (!axis.horiz && axis.reversed)) {
	                        to = unitedMin + range * this.to;
	                        from = unitedMin + range * this.from;
	                    } else {
	                        // y-values in browser are reversed, but this also applies for reversed horizontal axis:
	                        to = unitedMin + range * (1 - this.from);
	                        from = unitedMin + range * (1 - this.to);
	                    }
	
	                    axis.setExtremes(from, to, true, false, e);
	                });
	            }
	        });
	
	        /**
	         * Wrap rendering axis, and update scrollbar if one is created:
	         */
	        wrap(Axis.prototype, 'render', function(proceed) {
	            var axis = this,
	                scrollMin = Math.min(
	                    pick(axis.options.min, axis.min),
	                    axis.min,
	                    pick(axis.dataMin, axis.min) // #6930
	                ),
	                scrollMax = Math.max(
	                    pick(axis.options.max, axis.max),
	                    axis.max,
	                    pick(axis.dataMax, axis.max) // #6930
	                ),
	                scrollbar = axis.scrollbar,
	                titleOffset = axis.titleOffset || 0,
	                offsetsIndex,
	                from,
	                to;
	
	            proceed.apply(axis, Array.prototype.slice.call(arguments, 1));
	
	            if (scrollbar) {
	
	                if (axis.horiz) {
	                    scrollbar.position(
	                        axis.left,
	                        axis.top + axis.height + 2 + axis.chart.scrollbarsOffsets[1] +
	                        (axis.opposite ?
	                            0 :
	                            titleOffset + axis.axisTitleMargin + axis.offset
	                        ),
	                        axis.width,
	                        axis.height
	                    );
	                    offsetsIndex = 1;
	                } else {
	                    scrollbar.position(
	                        axis.left + axis.width + 2 + axis.chart.scrollbarsOffsets[0] +
	                        (axis.opposite ?
	                            titleOffset + axis.axisTitleMargin + axis.offset :
	                            0
	                        ),
	                        axis.top,
	                        axis.width,
	                        axis.height
	                    );
	                    offsetsIndex = 0;
	                }
	
	                if ((!axis.opposite && !axis.horiz) || (axis.opposite && axis.horiz)) {
	                    axis.chart.scrollbarsOffsets[offsetsIndex] +=
	                        axis.scrollbar.size + axis.scrollbar.options.margin;
	                }
	
	                if (isNaN(scrollMin) || isNaN(scrollMax) || !defined(axis.min) || !defined(axis.max)) {
	                    scrollbar.setRange(0, 0); // default action: when there is not extremes on the axis, but scrollbar exists, make it full size
	                } else {
	                    from = (axis.min - scrollMin) / (scrollMax - scrollMin);
	                    to = (axis.max - scrollMin) / (scrollMax - scrollMin);
	
	                    if ((axis.horiz && !axis.reversed) || (!axis.horiz && axis.reversed)) {
	                        scrollbar.setRange(from, to);
	                    } else {
	                        scrollbar.setRange(1 - to, 1 - from); // inverse vertical axis
	                    }
	                }
	            }
	        });
	
	        /**
	         * Make space for a scrollbar
	         */
	        wrap(Axis.prototype, 'getOffset', function(proceed) {
	            var axis = this,
	                index = axis.horiz ? 2 : 1,
	                scrollbar = axis.scrollbar;
	
	            proceed.apply(axis, Array.prototype.slice.call(arguments, 1));
	
	            if (scrollbar) {
	                axis.chart.scrollbarsOffsets = [0, 0]; // reset scrollbars offsets
	                axis.chart.axisOffset[index] += scrollbar.size + scrollbar.options.margin;
	            }
	        });
	
	        /**
	         * Destroy scrollbar when connected to the specific axis
	         */
	        wrap(Axis.prototype, 'destroy', function(proceed) {
	            if (this.scrollbar) {
	                this.scrollbar = this.scrollbar.destroy();
	            }
	
	            proceed.apply(this, Array.prototype.slice.call(arguments, 1));
	        });
	
	        H.Scrollbar = Scrollbar;
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        /* ****************************************************************************
	         * Start Navigator code														*
	         *****************************************************************************/
	        var addEvent = H.addEvent,
	            Axis = H.Axis,
	            Chart = H.Chart,
	            color = H.color,
	            defaultDataGroupingUnits = H.defaultDataGroupingUnits,
	            defaultOptions = H.defaultOptions,
	            defined = H.defined,
	            destroyObjectProperties = H.destroyObjectProperties,
	            each = H.each,
	            erase = H.erase,
	            error = H.error,
	            extend = H.extend,
	            grep = H.grep,
	            hasTouch = H.hasTouch,
	            isArray = H.isArray,
	            isNumber = H.isNumber,
	            isObject = H.isObject,
	            merge = H.merge,
	            pick = H.pick,
	            removeEvent = H.removeEvent,
	            Scrollbar = H.Scrollbar,
	            Series = H.Series,
	            seriesTypes = H.seriesTypes,
	            wrap = H.wrap,
	            swapXY = H.swapXY,
	
	            units = [].concat(defaultDataGroupingUnits), // copy
	            defaultSeriesType,
	
	            // Finding the min or max of a set of variables where we don't know if they are defined,
	            // is a pattern that is repeated several places in Highcharts. Consider making this
	            // a global utility method.
	            numExt = function(extreme) {
	                var numbers = grep(arguments, isNumber);
	                if (numbers.length) {
	                    return Math[extreme].apply(0, numbers);
	                }
	            };
	
	        // add more resolution to units
	        units[4] = ['day', [1, 2, 3, 4]]; // allow more days
	        units[5] = ['week', [1, 2, 3]]; // allow more weeks
	
	        defaultSeriesType = seriesTypes.areaspline === undefined ? 'line' : 'areaspline';
	
	        extend(defaultOptions, {
	
	            /**
	             * The navigator is a small series below the main series, displaying
	             * a view of the entire data set. It provides tools to zoom in and
	             * out on parts of the data as well as panning across the dataset.
	             *
	             * @optionparent navigator
	             * @product highstock
	             */
	            navigator: {
	                //enabled: true,
	
	                /**
	                 * The height of the navigator.
	                 * 
	                 * @type {Number}
	                 * @sample {highstock} stock/navigator/height/ A higher navigator
	                 * @default 40
	                 * @product highstock
	                 */
	                height: 40,
	
	                /**
	                 * The distance from the nearest element, the X axis or X axis labels.
	                 * 
	                 * @type {Number}
	                 * @sample {highstock} stock/navigator/margin/ A margin of 2 draws the     navigator closer to the X axis labels
	                 * @default 25
	                 * @product highstock
	                 */
	                margin: 25,
	
	                /**
	                 * Whether the mask should be inside the range marking the zoomed
	                 * range, or outside. In Highstock 1.x it was always `false`.
	                 * 
	                 * @type {Boolean}
	                 * @sample {highstock} stock/navigator/maskinside-false/ False, mask outside
	                 * @default true
	                 * @since 2.0
	                 * @product highstock
	                 */
	                maskInside: true,
	
	
	                /**
	                 * Options for the handles for dragging the zoomed area. Available
	                 * options are `backgroundColor` (defaults to `#ebe7e8`) and `borderColor`
	                 * (defaults to `#b2b1b6`).
	                 * 
	                 * @type {Object}
	                 * @sample {highstock} stock/navigator/handles/ Colored handles
	                 * @sample {highstock} stock/navigator/handles/ Colored handles
	                 * @product highstock
	                 */
	                handles: {
	
	                    /**
	                     * The fill for the handle.
	                     * 
	                     * @type {Color}
	                     * @default #f2f2f2
	                     * @product highstock
	                     */
	                    backgroundColor: '#f2f2f2',
	
	                    /**
	                     * The stroke for the handle border and the stripes inside.
	                     * 
	                     * @type {Color}
	                     * @default #999999
	                     * @product highstock
	                     */
	                    borderColor: '#999999'
	                },
	
	                /**
	                 * The color of the mask covering the areas of the navigator series
	                 * that are currently not visible in the main series. The default
	                 * color is bluish with an opacity of 0.3 to see the series below.
	                 * 
	                 * @type {Color}
	                 * @see In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), the mask is styled with the `.highcharts-navigator-
	                 * mask` and `.highcharts-navigator-mask-inside` classes.
	                 * @sample {highstock} stock/navigator/maskfill/ Blue, semi transparent mask
	                 * @default rgba(102,133,194,0.3)
	                 * @product highstock
	                 */
	                maskFill: color('#6685c2').setOpacity(0.3).get(),
	
	                /**
	                 * The color of the line marking the currently zoomed area in the
	                 * navigator.
	                 * 
	                 * @type {Color}
	                 * @sample {highstock} stock/navigator/outline/ 2px blue outline
	                 * @default #cccccc
	                 * @product highstock
	                 */
	                outlineColor: '#cccccc',
	
	                /**
	                 * The width of the line marking the currently zoomed area in the
	                 * navigator.
	                 * 
	                 * @type {Number}
	                 * @see In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), the outline stroke width is set with the `.
	                 * highcharts-navigator-outline` class.
	                 * @sample {highstock} stock/navigator/outline/ 2px blue outline
	                 * @default 2
	                 * @product highstock
	                 */
	                outlineWidth: 1,
	
	
	                /**
	                 * Options for the navigator series. Available options are the same
	                 * as any series, documented at [plotOptions](#plotOptions.series)
	                 * and [series](#series).
	                 * 
	                 * Unless data is explicitly defined on navigator.series, the data
	                 * is borrowed from the first series in the chart.
	                 * 
	                 * Default series options for the navigator series are:
	                 * 
	                 * <pre>series: {
	                 * type: 'areaspline',
	                 * color: '#4572A7',
	                 * fillOpacity: 0.05,
	                 * dataGrouping: {
	                 * smoothed: true
	                 * },
	                 * lineWidth: 1,
	                 * marker: {
	                 * enabled: false
	                 * }
	                 * }</pre>
	                 * 
	                 * @type {Object}
	                 * @see In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), the navigator series is styled with the `.
	                 * highcharts-navigator-series` class.
	                 * @sample {highstock} stock/navigator/series-data/ Using a separate data set for the navigator
	                 * @sample {highstock} stock/navigator/series/ A green navigator series
	                 * @product highstock
	                 */
	                series: {
	
	                    /**
	                     */
	                    type: defaultSeriesType,
	
	
	                    /**
	                     */
	                    color: '#335cad',
	
	                    /**
	                     */
	                    fillOpacity: 0.05,
	
	                    /**
	                     */
	                    lineWidth: 1,
	
	
	                    /**
	                     */
	                    compare: null,
	
	                    /**
	                     */
	                    dataGrouping: {
	
	                        /**
	                         */
	                        approximation: 'average',
	
	                        /**
	                         */
	                        enabled: true,
	
	                        /**
	                         */
	                        groupPixelWidth: 2,
	
	                        /**
	                         */
	                        smoothed: true,
	
	                        /**
	                         */
	                        units: units
	                    },
	
	                    /**
	                     */
	                    dataLabels: {
	
	                        /**
	                         */
	                        enabled: false,
	
	                        /**
	                         */
	                        zIndex: 2 // #1839
	                    },
	
	                    /**
	                     */
	                    id: 'highcharts-navigator-series',
	
	                    /**
	                     */
	                    className: 'highcharts-navigator-series',
	
	                    /**
	                     */
	                    lineColor: null, // Allow color setting while disallowing default candlestick setting (#4602)
	
	                    /**
	                     */
	                    marker: {
	
	                        /**
	                         */
	                        enabled: false
	                    },
	
	                    /**
	                     */
	                    pointRange: 0,
	
	                    /**
	                     */
	                    shadow: false,
	
	                    /**
	                     */
	                    threshold: null
	                },
	                //top: undefined,
	                //opposite: undefined,
	
	                /**
	                 * Options for the navigator X axis. Available options are the same
	                 * as any X axis, documented at [xAxis](#xAxis). Default series options
	                 * for the navigator xAxis are:
	                 * 
	                 * <pre>xAxis: {
	                 * tickWidth: 0,
	                 * lineWidth: 0,
	                 * gridLineWidth: 1,
	                 * tickPixelInterval: 200,
	                 * labels: {
	                 * align: 'left',
	                 * style: {
	                 * color: '#888'
	                 * },
	                 * x: 3,
	                 * y: -4
	                 * }
	                 * }</pre>
	                 * 
	                 * @type {Object}
	                 * @product highstock
	                 */
	                xAxis: {
	
	                    /**
	                     */
	                    className: 'highcharts-navigator-xaxis',
	
	                    /**
	                     */
	                    tickLength: 0,
	
	
	                    /**
	                     */
	                    lineWidth: 0,
	
	                    /**
	                     */
	                    gridLineColor: '#e6e6e6',
	
	                    /**
	                     */
	                    gridLineWidth: 1,
	
	
	                    /**
	                     */
	                    tickPixelInterval: 200,
	
	                    /**
	                     */
	                    labels: {
	
	                        /**
	                         */
	                        align: 'left',
	
	
	                        /**
	                         */
	                        style: {
	
	                            /**
	                             */
	                            color: '#999999'
	                        },
	
	
	                        /**
	                         */
	                        x: 3,
	
	                        /**
	                         */
	                        y: -4
	                    },
	
	                    /**
	                     */
	                    crosshair: false
	                },
	
	                /**
	                 * Options for the navigator Y axis. Available options are the same
	                 * as any y axis, documented at [yAxis](#yAxis). Default series options
	                 * for the navigator yAxis are:
	                 * 
	                 * <pre>yAxis: {
	                 * gridLineWidth: 0,
	                 * startOnTick: false,
	                 * endOnTick: false,
	                 * minPadding: 0.1,
	                 * maxPadding: 0.1,
	                 * labels: {
	                 * enabled: false
	                 * },
	                 * title: {
	                 * text: null
	                 * },
	                 * tickWidth: 0
	                 * }</pre>
	                 * 
	                 * @type {Object}
	                 * @product highstock
	                 */
	                yAxis: {
	
	                    /**
	                     */
	                    className: 'highcharts-navigator-yaxis',
	
	
	                    /**
	                     */
	                    gridLineWidth: 0,
	
	
	                    /**
	                     */
	                    startOnTick: false,
	
	                    /**
	                     */
	                    endOnTick: false,
	
	                    /**
	                     */
	                    minPadding: 0.1,
	
	                    /**
	                     */
	                    maxPadding: 0.1,
	
	                    /**
	                     */
	                    labels: {
	
	                        /**
	                         */
	                        enabled: false
	                    },
	
	                    /**
	                     */
	                    crosshair: false,
	
	                    /**
	                     */
	                    title: {
	
	                        /**
	                         */
	                        text: null
	                    },
	
	                    /**
	                     */
	                    tickLength: 0,
	
	                    /**
	                     */
	                    tickWidth: 0
	                }
	            }
	        });
	
	        /**
	         * The Navigator class
	         * @param {Object} chart - Chart object
	         * @class
	         */
	        function Navigator(chart) {
	            this.init(chart);
	        }
	
	        Navigator.prototype = {
	            /**
	             * Draw one of the handles on the side of the zoomed range in the navigator
	             * @param {Number} x The x center for the handle
	             * @param {Number} index 0 for left and 1 for right
	             * @param {Boolean} inverted flag for chart.inverted
	             * @param {String} verb use 'animate' or 'attr'
	             */
	            drawHandle: function(x, index, inverted, verb) {
	                var navigator = this;
	
	                // Place it
	                navigator.handles[index][verb](inverted ? {
	                    translateX: Math.round(navigator.left + navigator.height / 2 - 8),
	                    translateY: Math.round(navigator.top + parseInt(x, 10) + 0.5)
	                } : {
	                    translateX: Math.round(navigator.left + parseInt(x, 10)),
	                    translateY: Math.round(navigator.top + navigator.height / 2 - 8)
	                });
	            },
	
	            /**
	             * Draw one of the handles on the side of the zoomed range in the navigator
	             * @param {Boolean} inverted flag for chart.inverted
	             * @returns {Array} Path to be used in a handle
	             */
	            getHandlePath: function(inverted) {
	                return swapXY([
	                    'M', -4.5, 0.5,
	                    'L',
	                    3.5, 0.5,
	                    'L',
	                    3.5, 15.5,
	                    'L', -4.5, 15.5,
	                    'L', -4.5, 0.5,
	                    'M', -1.5, 4,
	                    'L', -1.5, 12,
	                    'M',
	                    0.5, 4,
	                    'L',
	                    0.5, 12
	                ], inverted);
	            },
	            /**
	             * Render outline around the zoomed range
	             * @param {Number} zoomedMin in pixels position where zoomed range starts
	             * @param {Number} zoomedMax in pixels position where zoomed range ends
	             * @param {Boolean} inverted flag if chart is inverted
	             * @param {String} verb use 'animate' or 'attr'
	             */
	            drawOutline: function(zoomedMin, zoomedMax, inverted, verb) {
	                var navigator = this,
	                    maskInside = navigator.navigatorOptions.maskInside,
	                    outlineWidth = navigator.outline.strokeWidth(),
	                    halfOutline = outlineWidth / 2,
	                    outlineCorrection = (outlineWidth % 2) / 2, // #5800
	                    outlineHeight = navigator.outlineHeight,
	                    scrollbarHeight = navigator.scrollbarHeight,
	                    navigatorSize = navigator.size,
	                    left = navigator.left - scrollbarHeight,
	                    navigatorTop = navigator.top,
	                    verticalMin,
	                    path;
	
	                if (inverted) {
	                    left -= halfOutline;
	                    verticalMin = navigatorTop + zoomedMax + outlineCorrection;
	                    zoomedMax = navigatorTop + zoomedMin + outlineCorrection;
	
	                    path = [
	                        'M',
	                        left + outlineHeight,
	                        navigatorTop - scrollbarHeight - outlineCorrection, // top edge
	                        'L',
	                        left + outlineHeight,
	                        verticalMin, // top right of zoomed range
	                        'L',
	                        left,
	                        verticalMin, // top left of z.r.
	                        'L',
	                        left,
	                        zoomedMax, // bottom left of z.r.
	                        'L',
	                        left + outlineHeight,
	                        zoomedMax, // bottom right of z.r.
	                        'L',
	                        left + outlineHeight,
	                        navigatorTop + navigatorSize + scrollbarHeight // bottom edge
	                    ].concat(maskInside ? [
	                        'M',
	                        left + outlineHeight,
	                        verticalMin - halfOutline, // upper left of zoomed range
	                        'L',
	                        left + outlineHeight,
	                        zoomedMax + halfOutline // upper right of z.r.
	                    ] : []);
	                } else {
	                    zoomedMin += left + scrollbarHeight - outlineCorrection;
	                    zoomedMax += left + scrollbarHeight - outlineCorrection;
	                    navigatorTop += halfOutline;
	
	                    path = [
	                        'M',
	                        left,
	                        navigatorTop, // left
	                        'L',
	                        zoomedMin,
	                        navigatorTop, // upper left of zoomed range
	                        'L',
	                        zoomedMin,
	                        navigatorTop + outlineHeight, // lower left of z.r.
	                        'L',
	                        zoomedMax,
	                        navigatorTop + outlineHeight, // lower right of z.r.
	                        'L',
	                        zoomedMax,
	                        navigatorTop, // upper right of z.r.
	                        'L',
	                        left + navigatorSize + scrollbarHeight * 2,
	                        navigatorTop // right
	                    ].concat(maskInside ? [
	                        'M',
	                        zoomedMin - halfOutline,
	                        navigatorTop, // upper left of zoomed range
	                        'L',
	                        zoomedMax + halfOutline,
	                        navigatorTop // upper right of z.r.
	                    ] : []);
	                }
	                navigator.outline[verb]({
	                    d: path
	                });
	            },
	
	            /**
	             * Render outline around the zoomed range
	             * @param {Number} zoomedMin in pixels position where zoomed range starts
	             * @param {Number} zoomedMax in pixels position where zoomed range ends
	             * @param {Boolean} inverted flag if chart is inverted
	             * @param {String} verb use 'animate' or 'attr'
	             */
	            drawMasks: function(zoomedMin, zoomedMax, inverted, verb) {
	                var navigator = this,
	                    left = navigator.left,
	                    top = navigator.top,
	                    navigatorHeight = navigator.height,
	                    height,
	                    width,
	                    x,
	                    y;
	
	                // Determine rectangle position & size 
	                // According to (non)inverted position:
	                if (inverted) {
	                    x = [left, left, left];
	                    y = [top, top + zoomedMin, top + zoomedMax];
	                    width = [navigatorHeight, navigatorHeight, navigatorHeight];
	                    height = [
	                        zoomedMin,
	                        zoomedMax - zoomedMin,
	                        navigator.size - zoomedMax
	                    ];
	                } else {
	                    x = [left, left + zoomedMin, left + zoomedMax];
	                    y = [top, top, top];
	                    width = [
	                        zoomedMin,
	                        zoomedMax - zoomedMin,
	                        navigator.size - zoomedMax
	                    ];
	                    height = [navigatorHeight, navigatorHeight, navigatorHeight];
	                }
	                each(navigator.shades, function(shade, i) {
	                    shade[verb]({
	                        x: x[i],
	                        y: y[i],
	                        width: width[i],
	                        height: height[i]
	                    });
	                });
	            },
	
	            /**
	             * Generate DOM elements for a navigator:
	             * - main navigator group
	             * - all shades
	             * - outline
	             * - handles
	             */
	            renderElements: function() {
	                var navigator = this,
	                    navigatorOptions = navigator.navigatorOptions,
	                    maskInside = navigatorOptions.maskInside,
	                    chart = navigator.chart,
	                    inverted = chart.inverted,
	                    renderer = chart.renderer,
	                    navigatorGroup;
	
	                // Create the main navigator group
	                navigator.navigatorGroup = navigatorGroup = renderer.g('navigator')
	                    .attr({
	                        zIndex: 8,
	                        visibility: 'hidden'
	                    })
	                    .add();
	
	
	
	                var mouseCursor = {
	                    cursor: inverted ? 'ns-resize' : 'ew-resize'
	                };
	
	
	                // Create masks, each mask will get events and fill:
	                each([!maskInside, maskInside, !maskInside], function(hasMask, index) {
	                    navigator.shades[index] = renderer.rect()
	                        .addClass('highcharts-navigator-mask' +
	                            (index === 1 ? '-inside' : '-outside'))
	
	                        .attr({
	                            fill: hasMask ? navigatorOptions.maskFill : 'rgba(0,0,0,0)'
	                        })
	                        .css(index === 1 && mouseCursor)
	
	                        .add(navigatorGroup);
	                });
	
	                // Create the outline:
	                navigator.outline = renderer.path()
	                    .addClass('highcharts-navigator-outline')
	
	                    .attr({
	                        'stroke-width': navigatorOptions.outlineWidth,
	                        stroke: navigatorOptions.outlineColor
	                    })
	
	                    .add(navigatorGroup);
	
	                // Create the handlers:
	                each([0, 1], function(index) {
	                    navigator.handles[index] = renderer
	                        .path(navigator.getHandlePath(inverted))
	                        // zIndex = 6 for right handle, 7 for left.
	                        // Can't be 10, because of the tooltip in inverted chart #2908
	                        .attr({
	                            zIndex: 7 - index
	                        })
	                        .addClass(
	                            'highcharts-navigator-handle highcharts-navigator-handle-' + ['left', 'right'][index]
	                        ).add(navigatorGroup);
	
	
	                    var handlesOptions = navigatorOptions.handles;
	                    navigator.handles[index]
	                        .attr({
	                            fill: handlesOptions.backgroundColor,
	                            stroke: handlesOptions.borderColor,
	                            'stroke-width': 1
	                        })
	                        .css(mouseCursor);
	
	                });
	            },
	
	            /**
	             * Update navigator
	             * @param {Object} options Options to merge in when updating navigator
	             */
	            update: function(options) {
	                // Remove references to old navigator series in base series
	                each(this.series || [], function(series) {
	                    if (series.baseSeries) {
	                        delete series.baseSeries.navigatorSeries;
	                    }
	                });
	                // Destroy and rebuild navigator
	                this.destroy();
	                var chartOptions = this.chart.options;
	                merge(true, chartOptions.navigator, this.options, options);
	                this.init(this.chart);
	            },
	
	            /**
	             * Render the navigator
	             * @param {Number} min X axis value minimum
	             * @param {Number} max X axis value maximum
	             * @param {Number} pxMin Pixel value minimum
	             * @param {Number} pxMax Pixel value maximum
	             */
	            render: function(min, max, pxMin, pxMax) {
	                var navigator = this,
	                    chart = navigator.chart,
	                    navigatorWidth,
	                    scrollbarLeft,
	                    scrollbarTop,
	                    scrollbarHeight = navigator.scrollbarHeight,
	                    navigatorSize,
	                    xAxis = navigator.xAxis,
	                    scrollbarXAxis = xAxis.fake ? chart.xAxis[0] : xAxis,
	                    navigatorEnabled = navigator.navigatorEnabled,
	                    zoomedMin,
	                    zoomedMax,
	                    rendered = navigator.rendered,
	                    inverted = chart.inverted,
	                    verb,
	                    newMin,
	                    newMax,
	                    minRange = chart.xAxis[0].minRange;
	
	                // Don't redraw while moving the handles (#4703).
	                if (this.hasDragged && !defined(pxMin)) {
	                    return;
	                }
	
	                // Don't render the navigator until we have data (#486, #4202, #5172).
	                if (!isNumber(min) || !isNumber(max)) {
	                    // However, if navigator was already rendered, we may need to resize
	                    // it. For example hidden series, but visible navigator (#6022).
	                    if (rendered) {
	                        pxMin = 0;
	                        pxMax = xAxis.width;
	                    } else {
	                        return;
	                    }
	                }
	
	                navigator.left = pick(
	                    xAxis.left,
	                    // in case of scrollbar only, without navigator
	                    chart.plotLeft + scrollbarHeight + (inverted ? chart.plotWidth : 0)
	                );
	
	                navigator.size = zoomedMax = navigatorSize = pick(
	                    xAxis.len,
	                    (inverted ? chart.plotHeight : chart.plotWidth) - 2 * scrollbarHeight
	                );
	
	                if (inverted) {
	                    navigatorWidth = scrollbarHeight;
	                } else {
	                    navigatorWidth = navigatorSize + 2 * scrollbarHeight;
	                }
	
	                // Get the pixel position of the handles
	                pxMin = pick(pxMin, xAxis.toPixels(min, true));
	                pxMax = pick(pxMax, xAxis.toPixels(max, true));
	
	                if (!isNumber(pxMin) || Math.abs(pxMin) === Infinity) { // Verify (#1851, #2238)
	                    pxMin = 0;
	                    pxMax = navigatorWidth;
	                }
	
	                // Are we below the minRange? (#2618, #6191)
	                newMin = xAxis.toValue(pxMin, true);
	                newMax = xAxis.toValue(pxMax, true);
	                if (Math.abs(newMax - newMin) < minRange) {
	                    if (this.grabbedLeft) {
	                        pxMin = xAxis.toPixels(newMax - minRange, true);
	                    } else if (this.grabbedRight) {
	                        pxMax = xAxis.toPixels(newMin + minRange, true);
	                    } else {
	                        return;
	                    }
	                }
	
	                // Handles are allowed to cross, but never exceed the plot area
	                navigator.zoomedMax = Math.min(Math.max(pxMin, pxMax, 0), zoomedMax);
	                navigator.zoomedMin = Math.min(
	                    Math.max(
	                        navigator.fixedWidth ?
	                        navigator.zoomedMax - navigator.fixedWidth :
	                        Math.min(pxMin, pxMax),
	                        0
	                    ),
	                    zoomedMax
	                );
	
	                navigator.range = navigator.zoomedMax - navigator.zoomedMin;
	
	                zoomedMax = Math.round(navigator.zoomedMax);
	                zoomedMin = Math.round(navigator.zoomedMin);
	
	                if (navigatorEnabled) {
	                    navigator.navigatorGroup.attr({
	                        visibility: 'visible'
	                    });
	                    // Place elements
	                    verb = rendered && !navigator.hasDragged ? 'animate' : 'attr';
	
	                    navigator.drawMasks(zoomedMin, zoomedMax, inverted, verb);
	                    navigator.drawOutline(zoomedMin, zoomedMax, inverted, verb);
	                    navigator.drawHandle(zoomedMin, 0, inverted, verb);
	                    navigator.drawHandle(zoomedMax, 1, inverted, verb);
	                }
	
	                if (navigator.scrollbar) {
	                    if (inverted) {
	                        scrollbarTop = navigator.top - scrollbarHeight;
	                        scrollbarLeft = navigator.left - scrollbarHeight +
	                            (navigatorEnabled || !scrollbarXAxis.opposite ? 0 :
	                                // Multiple axes has offsets:
	                                (scrollbarXAxis.titleOffset || 0) +
	                                // Self margin from the axis.title
	                                scrollbarXAxis.axisTitleMargin
	                            );
	                        scrollbarHeight = navigatorSize + 2 * scrollbarHeight;
	                    } else {
	                        scrollbarTop = navigator.top +
	                            (navigatorEnabled ? navigator.height : -scrollbarHeight);
	                        scrollbarLeft = navigator.left - scrollbarHeight;
	                    }
	                    // Reposition scrollbar
	                    navigator.scrollbar.position(
	                        scrollbarLeft,
	                        scrollbarTop,
	                        navigatorWidth,
	                        scrollbarHeight
	                    );
	                    // Keep scale 0-1
	                    navigator.scrollbar.setRange(
	                        // Use real value, not rounded because range can be very small (#1716)
	                        navigator.zoomedMin / navigatorSize,
	                        navigator.zoomedMax / navigatorSize
	                    );
	                }
	                navigator.rendered = true;
	            },
	
	            /**
	             * Set up the mouse and touch events for the navigator
	             */
	            addMouseEvents: function() {
	                var navigator = this,
	                    chart = navigator.chart,
	                    container = chart.container,
	                    eventsToUnbind = [],
	                    mouseMoveHandler,
	                    mouseUpHandler;
	
	                /**
	                 * Create mouse events' handlers.
	                 * Make them as separate functions to enable wrapping them:
	                 */
	                navigator.mouseMoveHandler = mouseMoveHandler = function(e) {
	                    navigator.onMouseMove(e);
	                };
	                navigator.mouseUpHandler = mouseUpHandler = function(e) {
	                    navigator.onMouseUp(e);
	                };
	
	                // Add shades and handles mousedown events
	                eventsToUnbind = navigator.getPartsEvents('mousedown');
	                // Add mouse move and mouseup events. These are bind to doc/container,
	                // because Navigator.grabbedSomething flags are stored in mousedown events:
	                eventsToUnbind.push(
	                    addEvent(container, 'mousemove', mouseMoveHandler),
	                    addEvent(container.ownerDocument, 'mouseup', mouseUpHandler)
	                );
	
	                // Touch events
	                if (hasTouch) {
	                    eventsToUnbind.push(
	                        addEvent(container, 'touchmove', mouseMoveHandler),
	                        addEvent(container.ownerDocument, 'touchend', mouseUpHandler)
	                    );
	                    eventsToUnbind.concat(navigator.getPartsEvents('touchstart'));
	                }
	
	                navigator.eventsToUnbind = eventsToUnbind;
	
	                // Data events
	                if (navigator.series && navigator.series[0]) {
	                    eventsToUnbind.push(
	                        addEvent(navigator.series[0].xAxis, 'foundExtremes', function() {
	                            chart.navigator.modifyNavigatorAxisExtremes();
	                        })
	                    );
	                }
	            },
	
	            /**
	             * Generate events for handles and masks
	             * @param {String} eventName Event name handler, 'mousedown' or 'touchstart'
	             * @returns {Array} An array of arrays: [DOMElement, eventName, callback].
	             */
	            getPartsEvents: function(eventName) {
	                var navigator = this,
	                    events = [];
	                each(['shades', 'handles'], function(name) {
	                    each(navigator[name], function(navigatorItem, index) {
	                        events.push(
	                            addEvent(
	                                navigatorItem.element,
	                                eventName,
	                                function(e) {
	                                    navigator[name + 'Mousedown'](e, index);
	                                }
	                            )
	                        );
	                    });
	                });
	                return events;
	            },
	
	            /**
	             * Mousedown on a shaded mask, either:
	             * - will be stored for future drag&drop 
	             * - will directly shift to a new range
	             *
	             * @param {Object} e Mouse event
	             * @param {Number} index Index of a mask in Navigator.shades array
	             */
	            shadesMousedown: function(e, index) {
	                e = this.chart.pointer.normalize(e);
	
	                var navigator = this,
	                    chart = navigator.chart,
	                    xAxis = navigator.xAxis,
	                    zoomedMin = navigator.zoomedMin,
	                    navigatorPosition = navigator.left,
	                    navigatorSize = navigator.size,
	                    range = navigator.range,
	                    chartX = e.chartX,
	                    fixedMax,
	                    ext,
	                    left;
	
	                // For inverted chart, swap some options:
	                if (chart.inverted) {
	                    chartX = e.chartY;
	                    navigatorPosition = navigator.top;
	                }
	
	                if (index === 1) {
	                    // Store information for drag&drop
	                    navigator.grabbedCenter = chartX;
	                    navigator.fixedWidth = range;
	                    navigator.dragOffset = chartX - zoomedMin;
	                } else {
	                    // Shift the range by clicking on shaded areas
	                    left = chartX - navigatorPosition - range / 2;
	                    if (index === 0) {
	                        left = Math.max(0, left);
	                    } else if (index === 2 && left + range >= navigatorSize) {
	                        left = navigatorSize - range;
	                        fixedMax = navigator.getUnionExtremes().dataMax; // #2293, #3543
	                    }
	                    if (left !== zoomedMin) { // it has actually moved
	                        navigator.fixedWidth = range; // #1370
	
	                        ext = xAxis.toFixedRange(left, left + range, null, fixedMax);
	                        chart.xAxis[0].setExtremes(
	                            Math.min(ext.min, ext.max),
	                            Math.max(ext.min, ext.max),
	                            true,
	                            null, // auto animation
	                            {
	                                trigger: 'navigator'
	                            }
	                        );
	                    }
	                }
	            },
	
	            /**
	             * Mousedown on a handle mask.
	             * Will store necessary information for drag&drop.
	             *
	             * @param {Object} e Mouse event
	             * @param {Number} index Index of a handle in Navigator.handles array
	             */
	            handlesMousedown: function(e, index) {
	                e = this.chart.pointer.normalize(e);
	
	                var navigator = this,
	                    chart = navigator.chart,
	                    baseXAxis = chart.xAxis[0],
	                    // For reversed axes, min and max are chagned,
	                    // so the other extreme should be stored
	                    reverse = (chart.inverted && !baseXAxis.reversed) ||
	                    (!chart.inverted && baseXAxis.reversed);
	
	                if (index === 0) {
	                    // Grab the left handle
	                    navigator.grabbedLeft = true;
	                    navigator.otherHandlePos = navigator.zoomedMax;
	                    navigator.fixedExtreme = reverse ? baseXAxis.min : baseXAxis.max;
	                } else {
	                    // Grab the right handle
	                    navigator.grabbedRight = true;
	                    navigator.otherHandlePos = navigator.zoomedMin;
	                    navigator.fixedExtreme = reverse ? baseXAxis.max : baseXAxis.min;
	                }
	
	                chart.fixedRange = null;
	            },
	            /**
	             * Mouse move event based on x/y mouse position.
	             * @param {Object} e Mouse event
	             */
	            onMouseMove: function(e) {
	                var navigator = this,
	                    chart = navigator.chart,
	                    left = navigator.left,
	                    navigatorSize = navigator.navigatorSize,
	                    range = navigator.range,
	                    dragOffset = navigator.dragOffset,
	                    inverted = chart.inverted,
	                    chartX;
	
	
	                // In iOS, a mousemove event with e.pageX === 0 is fired when holding the finger
	                // down in the center of the scrollbar. This should be ignored.
	                if (!e.touches || e.touches[0].pageX !== 0) { // #4696, scrollbar failed on Android
	
	                    e = chart.pointer.normalize(e);
	                    chartX = e.chartX;
	
	                    // Swap some options for inverted chart
	                    if (inverted) {
	                        left = navigator.top;
	                        chartX = e.chartY;
	                    }
	
	                    // Drag left handle or top handle
	                    if (navigator.grabbedLeft) {
	                        navigator.hasDragged = true;
	                        navigator.render(
	                            0,
	                            0,
	                            chartX - left,
	                            navigator.otherHandlePos
	                        );
	                        // Drag right handle or bottom handle
	                    } else if (navigator.grabbedRight) {
	                        navigator.hasDragged = true;
	                        navigator.render(
	                            0,
	                            0,
	                            navigator.otherHandlePos,
	                            chartX - left
	                        );
	                        // Drag scrollbar or open area in navigator
	                    } else if (navigator.grabbedCenter) {
	                        navigator.hasDragged = true;
	                        if (chartX < dragOffset) { // outside left
	                            chartX = dragOffset;
	                        } else if (chartX > navigatorSize + dragOffset - range) { // outside right
	                            chartX = navigatorSize + dragOffset - range;
	                        }
	
	                        navigator.render(
	                            0,
	                            0,
	                            chartX - dragOffset,
	                            chartX - dragOffset + range
	                        );
	                    }
	                    if (navigator.hasDragged && navigator.scrollbar && navigator.scrollbar.options.liveRedraw) {
	                        e.DOMType = e.type; // DOMType is for IE8 because it can't read type async
	                        setTimeout(function() {
	                            navigator.onMouseUp(e);
	                        }, 0);
	                    }
	                }
	            },
	
	            /**
	             * Mouse up event based on x/y mouse position.
	             * @param {Object} e Mouse event
	             */
	            onMouseUp: function(e) {
	                var navigator = this,
	                    chart = navigator.chart,
	                    xAxis = navigator.xAxis,
	                    scrollbar = navigator.scrollbar,
	                    fixedMin,
	                    fixedMax,
	                    ext,
	                    DOMEvent = e.DOMEvent || e;
	
	                if (
	                    // MouseUp is called for both, navigator and scrollbar (that order),
	                    // which causes calling afterSetExtremes twice. Prevent first call
	                    // by checking if scrollbar is going to set new extremes (#6334)
	                    (navigator.hasDragged && (!scrollbar || !scrollbar.hasDragged)) ||
	                    e.trigger === 'scrollbar'
	                ) {
	                    // When dragging one handle, make sure the other one doesn't change
	                    if (navigator.zoomedMin === navigator.otherHandlePos) {
	                        fixedMin = navigator.fixedExtreme;
	                    } else if (navigator.zoomedMax === navigator.otherHandlePos) {
	                        fixedMax = navigator.fixedExtreme;
	                    }
	                    // Snap to right edge (#4076)
	                    if (navigator.zoomedMax === navigator.size) {
	                        fixedMax = navigator.getUnionExtremes().dataMax;
	                    }
	                    ext = xAxis.toFixedRange(
	                        navigator.zoomedMin,
	                        navigator.zoomedMax,
	                        fixedMin,
	                        fixedMax
	                    );
	
	                    if (defined(ext.min)) {
	                        chart.xAxis[0].setExtremes(
	                            Math.min(ext.min, ext.max),
	                            Math.max(ext.min, ext.max),
	                            true,
	                            navigator.hasDragged ? false : null, // Run animation when clicking buttons, scrollbar track etc, but not when dragging handles or scrollbar
	                            {
	                                trigger: 'navigator',
	                                triggerOp: 'navigator-drag',
	                                DOMEvent: DOMEvent // #1838
	                            }
	                        );
	                    }
	                }
	
	                if (e.DOMType !== 'mousemove') {
	                    navigator.grabbedLeft = navigator.grabbedRight =
	                        navigator.grabbedCenter = navigator.fixedWidth =
	                        navigator.fixedExtreme = navigator.otherHandlePos =
	                        navigator.hasDragged = navigator.dragOffset = null;
	                }
	            },
	
	            /**
	             * Removes the event handlers attached previously with addEvents.
	             */
	            removeEvents: function() {
	                if (this.eventsToUnbind) {
	                    each(this.eventsToUnbind, function(unbind) {
	                        unbind();
	                    });
	                    this.eventsToUnbind = undefined;
	                }
	                this.removeBaseSeriesEvents();
	            },
	
	            /**
	             * Remove data events.
	             */
	            removeBaseSeriesEvents: function() {
	                var baseSeries = this.baseSeries || [];
	                if (this.navigatorEnabled && baseSeries[0]) {
	                    if (this.navigatorOptions.adaptToUpdatedData !== false) {
	                        each(baseSeries, function(series) {
	                            removeEvent(series, 'updatedData', this.updatedDataHandler);
	                        }, this);
	                    }
	
	                    // We only listen for extremes-events on the first baseSeries
	                    if (baseSeries[0].xAxis) {
	                        removeEvent(baseSeries[0].xAxis, 'foundExtremes', this.modifyBaseAxisExtremes);
	                    }
	                }
	            },
	
	            /**
	             * Initiate the Navigator object
	             */
	            init: function(chart) {
	                var chartOptions = chart.options,
	                    navigatorOptions = chartOptions.navigator,
	                    navigatorEnabled = navigatorOptions.enabled,
	                    scrollbarOptions = chartOptions.scrollbar,
	                    scrollbarEnabled = scrollbarOptions.enabled,
	                    height = navigatorEnabled ? navigatorOptions.height : 0,
	                    scrollbarHeight = scrollbarEnabled ? scrollbarOptions.height : 0;
	
	                this.handles = [];
	                this.shades = [];
	
	                this.chart = chart;
	                this.setBaseSeries();
	
	                this.height = height;
	                this.scrollbarHeight = scrollbarHeight;
	                this.scrollbarEnabled = scrollbarEnabled;
	                this.navigatorEnabled = navigatorEnabled;
	                this.navigatorOptions = navigatorOptions;
	                this.scrollbarOptions = scrollbarOptions;
	                this.outlineHeight = height + scrollbarHeight;
	
	                this.opposite = pick(navigatorOptions.opposite, !navigatorEnabled && chart.inverted); // #6262
	
	                var navigator = this,
	                    baseSeries = navigator.baseSeries,
	                    xAxisIndex = chart.xAxis.length,
	                    yAxisIndex = chart.yAxis.length,
	                    baseXaxis = baseSeries && baseSeries[0] && baseSeries[0].xAxis || chart.xAxis[0];
	
	                // Make room for the navigator, can be placed around the chart:
	                chart.extraMargin = {
	                    type: navigator.opposite ? 'plotTop' : 'marginBottom',
	                    value: (navigatorEnabled || !chart.inverted ? navigator.outlineHeight : 0) + navigatorOptions.margin
	                };
	                if (chart.inverted) {
	                    chart.extraMargin.type = navigator.opposite ? 'marginRight' : 'plotLeft';
	                }
	                chart.isDirtyBox = true;
	
	                if (navigator.navigatorEnabled) {
	                    // an x axis is required for scrollbar also
	                    navigator.xAxis = new Axis(chart, merge({
	                        // inherit base xAxis' break and ordinal options
	                        breaks: baseXaxis.options.breaks,
	                        ordinal: baseXaxis.options.ordinal
	                    }, navigatorOptions.xAxis, {
	                        id: 'navigator-x-axis',
	                        yAxis: 'navigator-y-axis',
	                        isX: true,
	                        type: 'datetime',
	                        index: xAxisIndex,
	                        offset: 0,
	                        keepOrdinalPadding: true, // #2436
	                        startOnTick: false,
	                        endOnTick: false,
	                        minPadding: 0,
	                        maxPadding: 0,
	                        zoomEnabled: false
	                    }, chart.inverted ? {
	                        offsets: [scrollbarHeight, 0, -scrollbarHeight, 0],
	                        width: height
	                    } : {
	                        offsets: [0, -scrollbarHeight, 0, scrollbarHeight],
	                        height: height
	                    }));
	
	                    navigator.yAxis = new Axis(chart, merge(navigatorOptions.yAxis, {
	                        id: 'navigator-y-axis',
	                        alignTicks: false,
	                        offset: 0,
	                        index: yAxisIndex,
	                        zoomEnabled: false
	                    }, chart.inverted ? {
	                        width: height
	                    } : {
	                        height: height
	                    }));
	
	                    // If we have a base series, initialize the navigator series
	                    if (baseSeries || navigatorOptions.series.data) {
	                        navigator.updateNavigatorSeries();
	
	                        // If not, set up an event to listen for added series
	                    } else if (chart.series.length === 0) {
	
	                        wrap(chart, 'redraw', function(proceed, animation) {
	                            // We've got one, now add it as base and reset chart.redraw
	                            if (chart.series.length > 0 && !navigator.series) {
	                                navigator.setBaseSeries();
	                                chart.redraw = proceed; // reset
	                            }
	                            proceed.call(chart, animation);
	                        });
	                    }
	
	                    // Render items, so we can bind events to them:
	                    navigator.renderElements();
	                    // Add mouse events
	                    navigator.addMouseEvents();
	
	                    // in case of scrollbar only, fake an x axis to get translation
	                } else {
	                    navigator.xAxis = {
	                        translate: function(value, reverse) {
	                            var axis = chart.xAxis[0],
	                                ext = axis.getExtremes(),
	                                scrollTrackWidth = axis.len - 2 * scrollbarHeight,
	                                min = numExt('min', axis.options.min, ext.dataMin),
	                                valueRange = numExt('max', axis.options.max, ext.dataMax) - min;
	
	                            return reverse ?
	                                // from pixel to value
	                                (value * valueRange / scrollTrackWidth) + min :
	                                // from value to pixel
	                                scrollTrackWidth * (value - min) / valueRange;
	                        },
	                        toPixels: function(value) {
	                            return this.translate(value);
	                        },
	                        toValue: function(value) {
	                            return this.translate(value, true);
	                        },
	                        toFixedRange: Axis.prototype.toFixedRange,
	                        fake: true
	                    };
	                }
	
	
	                // Initialize the scrollbar
	                if (chart.options.scrollbar.enabled) {
	                    chart.scrollbar = navigator.scrollbar = new Scrollbar(
	                        chart.renderer,
	                        merge(chart.options.scrollbar, {
	                            margin: navigator.navigatorEnabled ? 0 : 10,
	                            vertical: chart.inverted
	                        }),
	                        chart
	                    );
	                    addEvent(navigator.scrollbar, 'changed', function(e) {
	                        var range = navigator.size,
	                            to = range * this.to,
	                            from = range * this.from;
	
	                        navigator.hasDragged = navigator.scrollbar.hasDragged;
	                        navigator.render(0, 0, from, to);
	
	                        if (chart.options.scrollbar.liveRedraw || e.DOMType !== 'mousemove') {
	                            setTimeout(function() {
	                                navigator.onMouseUp(e);
	                            });
	                        }
	                    });
	                }
	
	                // Add data events
	                navigator.addBaseSeriesEvents();
	                // Add redraw events
	                navigator.addChartEvents();
	            },
	
	            /**
	             * Get the union data extremes of the chart - the outer data extremes of the base
	             * X axis and the navigator axis.
	             * @param {boolean} returnFalseOnNoBaseSeries - as the param says.
	             */
	            getUnionExtremes: function(returnFalseOnNoBaseSeries) {
	                var baseAxis = this.chart.xAxis[0],
	                    navAxis = this.xAxis,
	                    navAxisOptions = navAxis.options,
	                    baseAxisOptions = baseAxis.options,
	                    ret;
	
	                if (!returnFalseOnNoBaseSeries || baseAxis.dataMin !== null) {
	                    ret = {
	                        dataMin: pick( // #4053
	                            navAxisOptions && navAxisOptions.min,
	                            numExt(
	                                'min',
	                                baseAxisOptions.min,
	                                baseAxis.dataMin,
	                                navAxis.dataMin,
	                                navAxis.min
	                            )
	                        ),
	                        dataMax: pick(
	                            navAxisOptions && navAxisOptions.max,
	                            numExt(
	                                'max',
	                                baseAxisOptions.max,
	                                baseAxis.dataMax,
	                                navAxis.dataMax,
	                                navAxis.max
	                            )
	                        )
	                    };
	                }
	                return ret;
	            },
	
	            /**
	             * Set the base series and update the navigator series from this. With a bit 
	             * of modification we should be able to make this an API method to be called 
	             * from the outside
	             * @param {Object} baseSeriesOptions - additional series options for a navigator
	             */
	            setBaseSeries: function(baseSeriesOptions) {
	                var chart = this.chart,
	                    baseSeries = this.baseSeries = [];
	
	                baseSeriesOptions = baseSeriesOptions || chart.options && chart.options.navigator.baseSeries || 0;
	
	                // Iterate through series and add the ones that should be shown in navigator.
	                each(chart.series || [], function(series, i) {
	                    if (!series.options.isInternal && // Don't include existing nav series
	                        (
	                            series.options.showInNavigator ||
	                            (
	                                i === baseSeriesOptions ||
	                                series.options.id === baseSeriesOptions
	                            ) &&
	                            series.options.showInNavigator !== false
	                        )
	                    ) {
	                        baseSeries.push(series);
	                    }
	                });
	
	                // When run after render, this.xAxis already exists
	                if (this.xAxis && !this.xAxis.fake) {
	                    this.updateNavigatorSeries();
	                }
	            },
	
	            /*
	             * Update series in the navigator from baseSeries, adding new if does not
	             * exist.
	             */
	            updateNavigatorSeries: function() {
	                var navigator = this,
	                    chart = navigator.chart,
	                    baseSeries = navigator.baseSeries,
	                    baseOptions,
	                    mergedNavSeriesOptions,
	                    chartNavigatorSeriesOptions = navigator.navigatorOptions.series,
	                    baseNavigatorOptions,
	                    navSeriesMixin = {
	                        enableMouseTracking: false,
	                        index: null, // #6162
	                        linkedTo: null, // #6734
	                        group: 'nav', // for columns
	                        padXAxis: false,
	                        xAxis: 'navigator-x-axis',
	                        yAxis: 'navigator-y-axis',
	                        showInLegend: false,
	                        stacking: false, // #4823
	                        isInternal: true,
	                        visible: true
	                    },
	                    // Remove navigator series that are no longer in the baseSeries
	                    navigatorSeries = navigator.series = H.grep(
	                        navigator.series || [],
	                        function(navSeries) {
	                            var base = navSeries.baseSeries;
	                            if (H.inArray(base, baseSeries) < 0) { // Not in array
	                                // If there is still a base series connected to this series,
	                                // remove event handler and reference.
	                                if (base) {
	                                    removeEvent(
	                                        base,
	                                        'updatedData',
	                                        navigator.updatedDataHandler
	                                    );
	                                    delete base.navigatorSeries;
	                                }
	                                // Kill the nav series
	                                navSeries.destroy();
	                                return false;
	                            }
	                            return true;
	                        }
	                    );
	
	                // Go through each base series and merge the options to create new series
	                if (baseSeries && baseSeries.length) {
	                    each(baseSeries, function(base, i) {
	                        var linkedNavSeries = base.navigatorSeries,
	                            userNavOptions = !isArray(chartNavigatorSeriesOptions) ?
	                            chartNavigatorSeriesOptions : {};
	
	                        // Don't update if the series exists in nav and we have disabled
	                        // adaptToUpdatedData.
	                        if (
	                            linkedNavSeries &&
	                            navigator.navigatorOptions.adaptToUpdatedData === false
	                        ) {
	                            return;
	                        }
	
	                        navSeriesMixin.name = 'Navigator ' + (i + 1);
	
	                        baseOptions = base.options || {};
	                        baseNavigatorOptions = baseOptions.navigatorOptions || {};
	                        mergedNavSeriesOptions = merge(
	                            baseOptions,
	                            navSeriesMixin,
	                            userNavOptions,
	                            baseNavigatorOptions
	                        );
	
	                        // Merge data separately. Do a slice to avoid mutating the navigator options from base series (#4923).
	                        var navigatorSeriesData = baseNavigatorOptions.data || userNavOptions.data;
	                        navigator.hasNavigatorData = navigator.hasNavigatorData || !!navigatorSeriesData;
	                        mergedNavSeriesOptions.data = navigatorSeriesData || baseOptions.data && baseOptions.data.slice(0);
	
	                        // Update or add the series
	                        if (linkedNavSeries) {
	                            linkedNavSeries.update(mergedNavSeriesOptions);
	                        } else {
	                            base.navigatorSeries = chart.initSeries(mergedNavSeriesOptions);
	                            base.navigatorSeries.baseSeries = base; // Store ref
	                            navigatorSeries.push(base.navigatorSeries);
	                        }
	                    });
	                }
	
	                // If user has defined data (and no base series) or explicitly defined 
	                // navigator.series as an array, we create these series on top of any 
	                // base series.
	                if (
	                    chartNavigatorSeriesOptions.data &&
	                    !(baseSeries && baseSeries.length) ||
	                    isArray(chartNavigatorSeriesOptions)
	                ) {
	                    navigator.hasNavigatorData = false;
	                    // Allow navigator.series to be an array
	                    chartNavigatorSeriesOptions = H.splat(chartNavigatorSeriesOptions);
	                    each(chartNavigatorSeriesOptions, function(userSeriesOptions, i) {
	                        mergedNavSeriesOptions = merge({
	                                // Since we don't have a base series to pull color from,
	                                // try to fake it by using color from series with same
	                                // index. Otherwise pull from the colors array. We need 
	                                // an explicit color as otherwise updates will increment
	                                // color counter and we'll get a new color for each
	                                // update of the nav series.
	                                color: chart.series[i] &&
	                                    !chart.series[i].options.isInternal &&
	                                    chart.series[i].color ||
	                                    chart.options.colors[i] ||
	                                    chart.options.colors[0]
	                            },
	                            userSeriesOptions,
	                            navSeriesMixin
	                        );
	                        mergedNavSeriesOptions.data = userSeriesOptions.data;
	                        if (mergedNavSeriesOptions.data) {
	                            navigator.hasNavigatorData = true;
	                            navigatorSeries.push(chart.initSeries(mergedNavSeriesOptions));
	                        }
	                    });
	                }
	
	                this.addBaseSeriesEvents();
	            },
	
	            /**
	             * Add data events.
	             * For example when main series is updated we need to recalculate extremes
	             */
	            addBaseSeriesEvents: function() {
	                var navigator = this,
	                    baseSeries = navigator.baseSeries || [];
	
	                // Bind modified extremes event to first base's xAxis only.
	                // In event of > 1 base-xAxes, the navigator will ignore those.
	                // Adding this multiple times to the same axis is no problem, as 
	                // duplicates should be discarded by the browser.
	                if (baseSeries[0] && baseSeries[0].xAxis) {
	                    addEvent(baseSeries[0].xAxis, 'foundExtremes', this.modifyBaseAxisExtremes);
	                }
	
	                each(baseSeries, function(base) {
	                    // Link base series show/hide to navigator series visibility
	                    addEvent(base, 'show', function() {
	                        if (this.navigatorSeries) {
	                            this.navigatorSeries.show();
	                        }
	                    });
	                    addEvent(base, 'hide', function() {
	                        if (this.navigatorSeries) {
	                            this.navigatorSeries.hide();
	                        }
	                    });
	
	                    // Respond to updated data in the base series, unless explicitily 
	                    // not adapting to data changes.
	                    if (this.navigatorOptions.adaptToUpdatedData !== false) {
	                        if (base.xAxis) {
	                            addEvent(base, 'updatedData', this.updatedDataHandler);
	                        }
	                    }
	
	                    // Handle series removal
	                    addEvent(base, 'remove', function() {
	                        if (this.navigatorSeries) {
	                            erase(navigator.series, this.navigatorSeries);
	                            this.navigatorSeries.remove(false);
	                            delete this.navigatorSeries;
	                        }
	                    });
	                }, this);
	            },
	
	            /**
	             * Set the navigator x axis extremes to reflect the total. The navigator extremes
	             * should always be the extremes of the union of all series in the chart as
	             * well as the navigator series.
	             */
	            modifyNavigatorAxisExtremes: function() {
	                var xAxis = this.xAxis,
	                    unionExtremes;
	
	                if (xAxis.getExtremes) {
	                    unionExtremes = this.getUnionExtremes(true);
	                    if (unionExtremes && (unionExtremes.dataMin !== xAxis.min || unionExtremes.dataMax !== xAxis.max)) {
	                        xAxis.min = unionExtremes.dataMin;
	                        xAxis.max = unionExtremes.dataMax;
	                    }
	                }
	            },
	
	            /**
	             * Hook to modify the base axis extremes with information from the Navigator
	             */
	            modifyBaseAxisExtremes: function() {
	                var baseXAxis = this,
	                    navigator = baseXAxis.chart.navigator,
	                    baseExtremes = baseXAxis.getExtremes(),
	                    baseMin = baseExtremes.min,
	                    baseMax = baseExtremes.max,
	                    baseDataMin = baseExtremes.dataMin,
	                    baseDataMax = baseExtremes.dataMax,
	                    range = baseMax - baseMin,
	                    stickToMin = navigator.stickToMin,
	                    stickToMax = navigator.stickToMax,
	                    newMax,
	                    newMin,
	                    navigatorSeries = navigator.series && navigator.series[0],
	                    hasSetExtremes = !!baseXAxis.setExtremes,
	
	                    // When the extremes have been set by range selector button, don't stick to min or max.
	                    // The range selector buttons will handle the extremes. (#5489)
	                    unmutable = baseXAxis.eventArgs && baseXAxis.eventArgs.trigger === 'rangeSelectorButton';
	
	                if (!unmutable) {
	
	                    // If the zoomed range is already at the min, move it to the right as new data
	                    // comes in
	                    if (stickToMin) {
	                        newMin = baseDataMin;
	                        newMax = newMin + range;
	                    }
	
	                    // If the zoomed range is already at the max, move it to the right as new data
	                    // comes in
	                    if (stickToMax) {
	                        newMax = baseDataMax;
	                        if (!stickToMin) { // if stickToMin is true, the new min value is set above
	                            newMin = Math.max(
	                                newMax - range,
	                                navigatorSeries && navigatorSeries.xData ?
	                                navigatorSeries.xData[0] : -Number.MAX_VALUE
	                            );
	                        }
	                    }
	
	                    // Update the extremes
	                    if (hasSetExtremes && (stickToMin || stickToMax)) {
	                        if (isNumber(newMin)) {
	                            baseXAxis.min = baseXAxis.userMin = newMin;
	                            baseXAxis.max = baseXAxis.userMax = newMax;
	                        }
	                    }
	                }
	
	                // Reset
	                navigator.stickToMin = navigator.stickToMax = null;
	            },
	
	            /**
	             * Handler for updated data on the base series. When data is modified, the navigator series
	             * must reflect it. This is called from the Chart.redraw function before axis and series
	             * extremes are computed.
	             */
	            updatedDataHandler: function() {
	                var navigator = this.chart.navigator,
	                    baseSeries = this,
	                    navigatorSeries = this.navigatorSeries;
	
	                // If the scrollbar is scrolled all the way to the right, keep right as new data 
	                // comes in.
	                navigator.stickToMax = Math.round(navigator.zoomedMax) >= Math.round(navigator.size);
	
	                // Detect whether the zoomed area should stick to the minimum or maximum. If the current
	                // axis minimum falls outside the new updated dataset, we must adjust.
	                navigator.stickToMin = isNumber(baseSeries.xAxis.min) &&
	                    (baseSeries.xAxis.min <= baseSeries.xData[0]) &&
	                    (!this.chart.fixedRange || !navigator.stickToMax);
	
	                // Set the navigator series data to the new data of the base series
	                if (navigatorSeries && !navigator.hasNavigatorData) {
	                    navigatorSeries.options.pointStart = baseSeries.xData[0];
	                    navigatorSeries.setData(baseSeries.options.data, false, null, false); // #5414
	                }
	            },
	
	            /**
	             * Add chart events, like redrawing navigator, when chart requires that.
	             */
	            addChartEvents: function() {
	                addEvent(this.chart, 'redraw', function() {
	                    // Move the scrollbar after redraw, like after data updata even if axes don't redraw
	                    var navigator = this.navigator,
	                        xAxis = navigator && (
	                            navigator.baseSeries &&
	                            navigator.baseSeries[0] &&
	                            navigator.baseSeries[0].xAxis ||
	                            navigator.scrollbar && this.xAxis[0]
	                        ); // #5709
	
	                    if (xAxis) {
	                        navigator.render(xAxis.min, xAxis.max);
	                    }
	                });
	            },
	
	            /**
	             * Destroys allocated elements.
	             */
	            destroy: function() {
	
	                // Disconnect events added in addEvents
	                this.removeEvents();
	
	                if (this.xAxis) {
	                    erase(this.chart.xAxis, this.xAxis);
	                    erase(this.chart.axes, this.xAxis);
	                }
	                if (this.yAxis) {
	                    erase(this.chart.yAxis, this.yAxis);
	                    erase(this.chart.axes, this.yAxis);
	                }
	                // Destroy series
	                each(this.series || [], function(s) {
	                    if (s.destroy) {
	                        s.destroy();
	                    }
	                });
	
	                // Destroy properties
	                each([
	                    'series', 'xAxis', 'yAxis', 'shades', 'outline', 'scrollbarTrack',
	                    'scrollbarRifles', 'scrollbarGroup', 'scrollbar', 'navigatorGroup',
	                    'rendered'
	                ], function(prop) {
	                    if (this[prop] && this[prop].destroy) {
	                        this[prop].destroy();
	                    }
	                    this[prop] = null;
	                }, this);
	
	                // Destroy elements in collection
	                each([this.handles], function(coll) {
	                    destroyObjectProperties(coll);
	                }, this);
	            }
	        };
	
	        H.Navigator = Navigator;
	
	        /**
	         * For Stock charts, override selection zooming with some special features because
	         * X axis zooming is already allowed by the Navigator and Range selector.
	         */
	        wrap(Axis.prototype, 'zoom', function(proceed, newMin, newMax) {
	            var chart = this.chart,
	                chartOptions = chart.options,
	                zoomType = chartOptions.chart.zoomType,
	                previousZoom,
	                navigator = chartOptions.navigator,
	                rangeSelector = chartOptions.rangeSelector,
	                ret;
	
	            if (this.isXAxis && ((navigator && navigator.enabled) ||
	                    (rangeSelector && rangeSelector.enabled))) {
	
	                // For x only zooming, fool the chart.zoom method not to create the zoom button
	                // because the property already exists
	                if (zoomType === 'x') {
	                    chart.resetZoomButton = 'blocked';
	
	                    // For y only zooming, ignore the X axis completely
	                } else if (zoomType === 'y') {
	                    ret = false;
	
	                    // For xy zooming, record the state of the zoom before zoom selection, then when
	                    // the reset button is pressed, revert to this state
	                } else if (zoomType === 'xy') {
	                    previousZoom = this.previousZoom;
	                    if (defined(newMin)) {
	                        this.previousZoom = [this.min, this.max];
	                    } else if (previousZoom) {
	                        newMin = previousZoom[0];
	                        newMax = previousZoom[1];
	                        delete this.previousZoom;
	                    }
	                }
	
	            }
	            return ret !== undefined ? ret : proceed.call(this, newMin, newMax);
	        });
	
	        // Initialize navigator for stock charts
	        wrap(Chart.prototype, 'init', function(proceed, options, callback) {
	
	            addEvent(this, 'beforeRender', function() {
	                var options = this.options;
	                if (options.navigator.enabled || options.scrollbar.enabled) {
	                    this.scroller = this.navigator = new Navigator(this);
	                }
	            });
	
	            proceed.call(this, options, callback);
	
	        });
	
	        /**
	         * For stock charts, extend the Chart.setChartSize method so that we can set the final top position
	         * of the navigator once the height of the chart, including the legend, is determined. #367.
	         * We can't use Chart.getMargins, because labels offsets are not calculated yet.
	         */
	        wrap(Chart.prototype, 'setChartSize', function(proceed) {
	
	            var legend = this.legend,
	                navigator = this.navigator,
	                scrollbarHeight,
	                legendOptions,
	                xAxis,
	                yAxis;
	
	            proceed.apply(this, [].slice.call(arguments, 1));
	
	            if (navigator) {
	                legendOptions = legend.options;
	                xAxis = navigator.xAxis;
	                yAxis = navigator.yAxis;
	                scrollbarHeight = navigator.scrollbarHeight;
	
	                // Compute the top position
	                if (this.inverted) {
	                    navigator.left = navigator.opposite ?
	                        this.chartWidth - scrollbarHeight - navigator.height :
	                        this.spacing[3] + scrollbarHeight;
	                    navigator.top = this.plotTop + scrollbarHeight;
	                } else {
	                    navigator.left = this.plotLeft + scrollbarHeight;
	                    navigator.top = navigator.navigatorOptions.top ||
	                        this.chartHeight - navigator.height - scrollbarHeight - this.spacing[2] -
	                        (legendOptions.verticalAlign === 'bottom' && legendOptions.enabled && !legendOptions.floating ?
	                            legend.legendHeight + pick(legendOptions.margin, 10) : 0);
	                }
	
	                if (xAxis && yAxis) { // false if navigator is disabled (#904)
	
	                    if (this.inverted) {
	                        xAxis.options.left = yAxis.options.left = navigator.left;
	                    } else {
	                        xAxis.options.top = yAxis.options.top = navigator.top;
	                    }
	
	                    xAxis.setAxisSize();
	                    yAxis.setAxisSize();
	                }
	            }
	        });
	
	        // Pick up badly formatted point options to addPoint
	        wrap(Series.prototype, 'addPoint', function(proceed, options, redraw, shift, animation) {
	            var turboThreshold = this.options.turboThreshold;
	            if (turboThreshold && this.xData.length > turboThreshold && isObject(options, true) && this.chart.navigator) {
	                error(20, true);
	            }
	            proceed.call(this, options, redraw, shift, animation);
	        });
	
	        // Handle adding new series
	        wrap(Chart.prototype, 'addSeries', function(proceed, options, redraw, animation) {
	            var series = proceed.call(this, options, false, animation);
	            if (this.navigator) {
	                this.navigator.setBaseSeries(); // Recompute which series should be shown in navigator, and add them
	            }
	            if (pick(redraw, true)) {
	                this.redraw();
	            }
	            return series;
	        });
	
	        // Handle updating series
	        wrap(Series.prototype, 'update', function(proceed, newOptions, redraw) {
	            proceed.call(this, newOptions, false);
	            if (this.chart.navigator && !this.options.isInternal) {
	                this.chart.navigator.setBaseSeries();
	            }
	            if (pick(redraw, true)) {
	                this.chart.redraw();
	            }
	        });
	
	        Chart.prototype.callbacks.push(function(chart) {
	            var extremes,
	                navigator = chart.navigator;
	
	            // Initiate the navigator
	            if (navigator) {
	                extremes = chart.xAxis[0].getExtremes();
	                navigator.render(extremes.min, extremes.max);
	            }
	        });
	
	        /* ****************************************************************************
	         * End Navigator code														  *
	         *****************************************************************************/
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var addEvent = H.addEvent,
	            Axis = H.Axis,
	            Chart = H.Chart,
	            css = H.css,
	            createElement = H.createElement,
	            dateFormat = H.dateFormat,
	            defaultOptions = H.defaultOptions,
	            useUTC = defaultOptions.global.useUTC,
	            defined = H.defined,
	            destroyObjectProperties = H.destroyObjectProperties,
	            discardElement = H.discardElement,
	            each = H.each,
	            extend = H.extend,
	            fireEvent = H.fireEvent,
	            HCDate = H.Date,
	            isNumber = H.isNumber,
	            merge = H.merge,
	            pick = H.pick,
	            pInt = H.pInt,
	            splat = H.splat,
	            wrap = H.wrap;
	
	        /* ****************************************************************************
	         * Start Range Selector code												  *
	         *****************************************************************************/
	        extend(defaultOptions, {
	
	            /**
	             * The range selector is a tool for selecting ranges to display within
	             * the chart. It provides buttons to select preconfigured ranges in
	             * the chart, like 1 day, 1 week, 1 month etc. It also provides input
	             * boxes where min and max dates can be manually input.
	             *
	             * @optionparent rangeSelector
	             * @product highstock
	             */
	            rangeSelector: {
	                // allButtonsEnabled: false,
	                // enabled: true,
	                // buttons: {Object}
	                // buttonSpacing: 0,
	
	                /**
	                 * A collection of attributes for the buttons. The object takes SVG
	                 * attributes like `fill`, `stroke`, `stroke-width`, as well as `style`,
	                 * a collection of CSS properties for the text.
	                 * 
	                 * The object can also be extended with states, so you can set presentational
	                 * options for `hover`, `select` or `disabled` button states.
	                 * 
	                 * CSS styles for the text label.
	                 * 
	                 * In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), the buttons are styled by the `.highcharts-
	                 * range-selector-buttons .highcharts-button` rule with its different
	                 * states.
	                 * 
	                 * @type {Object}
	                 * @sample {highstock} stock/rangeselector/styling/ Styling the buttons and inputs
	                 * @product highstock
	                 */
	                buttonTheme: {
	
	                    /**
	                     */
	                    'stroke-width': 0,
	
	                    /**
	                     */
	                    width: 28,
	
	                    /**
	                     */
	                    height: 18,
	
	                    /**
	                     */
	                    padding: 2,
	
	                    /**
	                     */
	                    zIndex: 7 // #484, #852
	                },
	
	                /**
	                 * The height of the range selector, used to reserve space for buttons
	                 * and input.
	                 * 
	                 * @type {Number}
	                 * @default 35
	                 * @since 2.1.9
	                 * @product highstock
	                 */
	                height: 35, // reserved space for buttons and input
	
	                /**
	                 * Positioning for the input boxes. Allowed properties are `align`,
	                 *  `verticalAlign`, `x` and `y`.
	                 * 
	                 * @type {Object}
	                 * @default { align: "right" }
	                 * @since 1.2.5
	                 * @product highstock
	                 */
	                inputPosition: {
	
	                    /**
	                     */
	                    align: 'right'
	                },
	                // inputDateFormat: '%b %e, %Y',
	                // inputEditDateFormat: '%Y-%m-%d',
	                // inputEnabled: true,
	                // selected: undefined,
	
	                // inputStyle: {},
	
	                /**
	                 * CSS styles for the labels - the Zoom, From and To texts.
	                 * 
	                 * In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), the labels are styled by the `.highcharts-
	                 * range-label` class.
	                 * 
	                 * @type {CSSObject}
	                 * @sample {highstock} stock/rangeselector/styling/ Styling the buttons and inputs
	                 * @product highstock
	                 */
	                labelStyle: {
	
	                    /**
	                     */
	                    color: '#666666'
	                }
	
	            }
	        });
	
	        defaultOptions.lang = merge(
	            defaultOptions.lang,
	            /**
	             * Language object. The language object is global and it can't be set
	             * on each chart initiation. Instead, use `Highcharts.setOptions` to
	             * set it before any chart is initialized.
	             * 
	             * <pre>Highcharts.setOptions({
	             * lang: {
	             * months: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
	             * 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
	             * 
	             * weekdays: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi',
	             * 'Samedi']
	             * }
	             * });</pre>
	             *
	             * @optionparent lang
	             * @product highstock
	             */
	            {
	
	                /**
	                 * The text for the label for the range selector buttons.
	                 * 
	                 * @type {String}
	                 * @default Zoom
	                 * @product highstock
	                 */
	                rangeSelectorZoom: 'Zoom',
	
	                /**
	                 * The text for the label for the "from" input box in the range
	                 * selector.
	                 * 
	                 * @type {String}
	                 * @default From
	                 * @product highstock
	                 */
	                rangeSelectorFrom: 'From',
	
	                /**
	                 * The text for the label for the "to" input box in the range selector.
	                 * 
	                 * @type {String}
	                 * @default To
	                 * @product highstock
	                 */
	                rangeSelectorTo: 'To'
	            }
	        );
	
	        /**
	         * The range selector.
	         * @class
	         * @param {Object} chart
	         */
	        function RangeSelector(chart) {
	
	            // Run RangeSelector
	            this.init(chart);
	        }
	
	        RangeSelector.prototype = {
	            /**
	             * The method to run when one of the buttons in the range selectors is clicked
	             * @param {Number} i The index of the button
	             * @param {Object} rangeOptions
	             * @param {Boolean} redraw
	             */
	            clickButton: function(i, redraw) {
	                var rangeSelector = this,
	                    chart = rangeSelector.chart,
	                    rangeOptions = rangeSelector.buttonOptions[i],
	                    baseAxis = chart.xAxis[0],
	                    unionExtremes = (chart.scroller && chart.scroller.getUnionExtremes()) || baseAxis || {},
	                    dataMin = unionExtremes.dataMin,
	                    dataMax = unionExtremes.dataMax,
	                    newMin,
	                    newMax = baseAxis && Math.round(Math.min(baseAxis.max, pick(dataMax, baseAxis.max))), // #1568
	                    type = rangeOptions.type,
	                    baseXAxisOptions,
	                    range = rangeOptions._range,
	                    rangeMin,
	                    minSetting,
	                    rangeSetting,
	                    ctx,
	                    ytdExtremes,
	                    dataGrouping = rangeOptions.dataGrouping;
	
	                if (dataMin === null || dataMax === null) { // chart has no data, base series is removed
	                    return;
	                }
	
	                // Set the fixed range before range is altered
	                chart.fixedRange = range;
	
	                // Apply dataGrouping associated to button
	                if (dataGrouping) {
	                    this.forcedDataGrouping = true;
	                    Axis.prototype.setDataGrouping.call(baseAxis || {
	                        chart: this.chart
	                    }, dataGrouping, false);
	                }
	
	                // Apply range
	                if (type === 'month' || type === 'year') {
	                    if (!baseAxis) {
	                        // This is set to the user options and picked up later when the axis is instantiated
	                        // so that we know the min and max.
	                        range = rangeOptions;
	                    } else {
	                        ctx = {
	                            range: rangeOptions,
	                            max: newMax,
	                            dataMin: dataMin,
	                            dataMax: dataMax
	                        };
	                        newMin = baseAxis.minFromRange.call(ctx);
	                        if (isNumber(ctx.newMax)) {
	                            newMax = ctx.newMax;
	                        }
	                    }
	
	                    // Fixed times like minutes, hours, days
	                } else if (range) {
	                    newMin = Math.max(newMax - range, dataMin);
	                    newMax = Math.min(newMin + range, dataMax);
	
	                } else if (type === 'ytd') {
	
	                    // On user clicks on the buttons, or a delayed action running from the beforeRender
	                    // event (below), the baseAxis is defined.
	                    if (baseAxis) {
	                        // When "ytd" is the pre-selected button for the initial view, its calculation
	                        // is delayed and rerun in the beforeRender event (below). When the series
	                        // are initialized, but before the chart is rendered, we have access to the xData
	                        // array (#942).
	                        if (dataMax === undefined) {
	                            dataMin = Number.MAX_VALUE;
	                            dataMax = Number.MIN_VALUE;
	                            each(chart.series, function(series) {
	                                var xData = series.xData; // reassign it to the last item
	                                dataMin = Math.min(xData[0], dataMin);
	                                dataMax = Math.max(xData[xData.length - 1], dataMax);
	                            });
	                            redraw = false;
	                        }
	                        ytdExtremes = rangeSelector.getYTDExtremes(dataMax, dataMin, useUTC);
	                        newMin = rangeMin = ytdExtremes.min;
	                        newMax = ytdExtremes.max;
	
	                        // "ytd" is pre-selected. We don't yet have access to processed point and extremes data
	                        // (things like pointStart and pointInterval are missing), so we delay the process (#942)
	                    } else {
	                        addEvent(chart, 'beforeRender', function() {
	                            rangeSelector.clickButton(i);
	                        });
	                        return;
	                    }
	                } else if (type === 'all' && baseAxis) {
	                    newMin = dataMin;
	                    newMax = dataMax;
	                }
	                rangeSelector.setSelected(i);
	
	                // Update the chart
	                if (!baseAxis) {
	                    // Axis not yet instanciated. Temporarily set min and range
	                    // options and remove them on chart load (#4317).
	                    baseXAxisOptions = splat(chart.options.xAxis)[0];
	                    rangeSetting = baseXAxisOptions.range;
	                    baseXAxisOptions.range = range;
	                    minSetting = baseXAxisOptions.min;
	                    baseXAxisOptions.min = rangeMin;
	                    addEvent(chart, 'load', function resetMinAndRange() {
	                        baseXAxisOptions.range = rangeSetting;
	                        baseXAxisOptions.min = minSetting;
	                    });
	                } else {
	                    // Existing axis object. Set extremes after render time.
	                    baseAxis.setExtremes(
	                        newMin,
	                        newMax,
	                        pick(redraw, 1),
	                        null, // auto animation
	                        {
	                            trigger: 'rangeSelectorButton',
	                            rangeSelectorButton: rangeOptions
	                        }
	                    );
	                }
	            },
	
	            /**
	             * Set the selected option. This method only sets the internal flag, it doesn't
	             * update the buttons or the actual zoomed range.
	             */
	            setSelected: function(selected) {
	                this.selected = this.options.selected = selected;
	            },
	
	            /**
	             * The default buttons for pre-selecting time frames
	             */
	            defaultButtons: [{
	                type: 'month',
	                count: 1,
	                text: '1m'
	            }, {
	                type: 'month',
	                count: 3,
	                text: '3m'
	            }, {
	                type: 'month',
	                count: 6,
	                text: '6m'
	            }, {
	                type: 'ytd',
	                text: 'YTD'
	            }, {
	                type: 'year',
	                count: 1,
	                text: '1y'
	            }, {
	                type: 'all',
	                text: 'All'
	            }],
	
	            /**
	             * Initialize the range selector
	             */
	            init: function(chart) {
	                var rangeSelector = this,
	                    options = chart.options.rangeSelector,
	                    buttonOptions = options.buttons || [].concat(rangeSelector.defaultButtons),
	                    selectedOption = options.selected,
	                    blurInputs = function() {
	                        var minInput = rangeSelector.minInput,
	                            maxInput = rangeSelector.maxInput;
	                        if (minInput && minInput.blur) { //#3274 in some case blur is not defined
	                            fireEvent(minInput, 'blur'); //#3274
	                        }
	                        if (maxInput && maxInput.blur) { //#3274 in some case blur is not defined
	                            fireEvent(maxInput, 'blur'); //#3274
	                        }
	                    };
	
	                rangeSelector.chart = chart;
	                rangeSelector.options = options;
	                rangeSelector.buttons = [];
	
	                chart.extraTopMargin = options.height;
	                rangeSelector.buttonOptions = buttonOptions;
	
	                this.unMouseDown = addEvent(chart.container, 'mousedown', blurInputs);
	                this.unResize = addEvent(chart, 'resize', blurInputs);
	
	                // Extend the buttonOptions with actual range
	                each(buttonOptions, rangeSelector.computeButtonRange);
	
	                // zoomed range based on a pre-selected button index
	                if (selectedOption !== undefined && buttonOptions[selectedOption]) {
	                    this.clickButton(selectedOption, false);
	                }
	
	
	                addEvent(chart, 'load', function() {
	                    // If a data grouping is applied to the current button, release it when extremes change
	                    addEvent(chart.xAxis[0], 'setExtremes', function(e) {
	                        if (this.max - this.min !== chart.fixedRange && e.trigger !== 'rangeSelectorButton' &&
	                            e.trigger !== 'updatedData' && rangeSelector.forcedDataGrouping) {
	                            this.setDataGrouping(false, false);
	                        }
	                    });
	                });
	            },
	
	            /**
	             * Dynamically update the range selector buttons after a new range has been set
	             */
	            updateButtonStates: function() {
	                var rangeSelector = this,
	                    chart = this.chart,
	                    baseAxis = chart.xAxis[0],
	                    actualRange = Math.round(baseAxis.max - baseAxis.min),
	                    hasNoData = !baseAxis.hasVisibleSeries,
	                    day = 24 * 36e5, // A single day in milliseconds
	                    unionExtremes = (chart.scroller && chart.scroller.getUnionExtremes()) || baseAxis,
	                    dataMin = unionExtremes.dataMin,
	                    dataMax = unionExtremes.dataMax,
	                    ytdExtremes = rangeSelector.getYTDExtremes(dataMax, dataMin, useUTC),
	                    ytdMin = ytdExtremes.min,
	                    ytdMax = ytdExtremes.max,
	                    selected = rangeSelector.selected,
	                    selectedExists = isNumber(selected),
	                    allButtonsEnabled = rangeSelector.options.allButtonsEnabled,
	                    buttons = rangeSelector.buttons;
	
	                each(rangeSelector.buttonOptions, function(rangeOptions, i) {
	                    var range = rangeOptions._range,
	                        type = rangeOptions.type,
	                        count = rangeOptions.count || 1,
	                        button = buttons[i],
	                        state = 0,
	                        disable,
	                        select,
	                        isSelected = i === selected,
	                        // Disable buttons where the range exceeds what is allowed in the current view
	                        isTooGreatRange = range > dataMax - dataMin,
	                        // Disable buttons where the range is smaller than the minimum range
	                        isTooSmallRange = range < baseAxis.minRange,
	                        // Do not select the YTD button if not explicitly told so
	                        isYTDButNotSelected = false,
	                        // Disable the All button if we're already showing all
	                        isAllButAlreadyShowingAll = false,
	                        isSameRange = range === actualRange;
	                    // Months and years have a variable range so we check the extremes
	                    if (
	                        (type === 'month' || type === 'year') &&
	                        (actualRange >= {
	                            month: 28,
	                            year: 365
	                        }[type] * day * count) &&
	                        (actualRange <= {
	                            month: 31,
	                            year: 366
	                        }[type] * day * count)
	                    ) {
	                        isSameRange = true;
	                    } else if (type === 'ytd') {
	                        isSameRange = (ytdMax - ytdMin) === actualRange;
	                        isYTDButNotSelected = !isSelected;
	                    } else if (type === 'all') {
	                        isSameRange = baseAxis.max - baseAxis.min >= dataMax - dataMin;
	                        isAllButAlreadyShowingAll = !isSelected && selectedExists && isSameRange;
	                    }
	                    // The new zoom area happens to match the range for a button - mark it selected.
	                    // This happens when scrolling across an ordinal gap. It can be seen in the intraday
	                    // demos when selecting 1h and scroll across the night gap.
	                    disable = (!allButtonsEnabled &&
	                        (
	                            isTooGreatRange ||
	                            isTooSmallRange ||
	                            isAllButAlreadyShowingAll ||
	                            hasNoData
	                        )
	                    );
	                    select = (
	                        (isSelected && isSameRange) ||
	                        (isSameRange && !selectedExists && !isYTDButNotSelected)
	                    );
	
	                    if (disable) {
	                        state = 3;
	                    } else if (select) {
	                        selectedExists = true; // Only one button can be selected
	                        state = 2;
	                    }
	
	                    // If state has changed, update the button
	                    if (button.state !== state) {
	                        button.setState(state);
	                    }
	                });
	            },
	
	            /**
	             * Compute and cache the range for an individual button
	             */
	            computeButtonRange: function(rangeOptions) {
	                var type = rangeOptions.type,
	                    count = rangeOptions.count || 1,
	
	                    // these time intervals have a fixed number of milliseconds, as opposed
	                    // to month, ytd and year
	                    fixedTimes = {
	                        millisecond: 1,
	                        second: 1000,
	                        minute: 60 * 1000,
	                        hour: 3600 * 1000,
	                        day: 24 * 3600 * 1000,
	                        week: 7 * 24 * 3600 * 1000
	                    };
	
	                // Store the range on the button object
	                if (fixedTimes[type]) {
	                    rangeOptions._range = fixedTimes[type] * count;
	                } else if (type === 'month' || type === 'year') {
	                    rangeOptions._range = {
	                        month: 30,
	                        year: 365
	                    }[type] * 24 * 36e5 * count;
	                }
	            },
	
	            /**
	             * Set the internal and displayed value of a HTML input for the dates
	             * @param {String} name
	             * @param {Number} time
	             */
	            setInputValue: function(name, time) {
	                var options = this.chart.options.rangeSelector,
	                    input = this[name + 'Input'];
	
	                if (defined(time)) {
	                    input.previousValue = input.HCTime;
	                    input.HCTime = time;
	                }
	
	                input.value = dateFormat(
	                    options.inputEditDateFormat || '%Y-%m-%d',
	                    input.HCTime
	                );
	                this[name + 'DateBox'].attr({
	                    text: dateFormat(options.inputDateFormat || '%b %e, %Y', input.HCTime)
	                });
	            },
	
	            showInput: function(name) {
	                var inputGroup = this.inputGroup,
	                    dateBox = this[name + 'DateBox'];
	
	                css(this[name + 'Input'], {
	                    left: (inputGroup.translateX + dateBox.x) + 'px',
	                    top: inputGroup.translateY + 'px',
	                    width: (dateBox.width - 2) + 'px',
	                    height: (dateBox.height - 2) + 'px',
	                    border: '2px solid silver'
	                });
	            },
	
	            hideInput: function(name) {
	                css(this[name + 'Input'], {
	                    border: 0,
	                    width: '1px',
	                    height: '1px'
	                });
	                this.setInputValue(name);
	            },
	
	            /**
	             * Draw either the 'from' or the 'to' HTML input box of the range selector
	             * @param {Object} name
	             */
	            drawInput: function(name) {
	                var rangeSelector = this,
	                    chart = rangeSelector.chart,
	                    chartStyle = chart.renderer.style || {},
	                    renderer = chart.renderer,
	                    options = chart.options.rangeSelector,
	                    lang = defaultOptions.lang,
	                    div = rangeSelector.div,
	                    isMin = name === 'min',
	                    input,
	                    label,
	                    dateBox,
	                    inputGroup = this.inputGroup;
	
	                function updateExtremes() {
	                    var inputValue = input.value,
	                        value = (options.inputDateParser || Date.parse)(inputValue),
	                        chartAxis = chart.xAxis[0],
	                        dataAxis = chart.scroller && chart.scroller.xAxis ? chart.scroller.xAxis : chartAxis,
	                        dataMin = dataAxis.dataMin,
	                        dataMax = dataAxis.dataMax;
	                    if (value !== input.previousValue) {
	                        input.previousValue = value;
	                        // If the value isn't parsed directly to a value by the browser's Date.parse method,
	                        // like YYYY-MM-DD in IE, try parsing it a different way
	                        if (!isNumber(value)) {
	                            value = inputValue.split('-');
	                            value = Date.UTC(pInt(value[0]), pInt(value[1]) - 1, pInt(value[2]));
	                        }
	
	                        if (isNumber(value)) {
	
	                            // Correct for timezone offset (#433)
	                            if (!useUTC) {
	                                value = value + new Date().getTimezoneOffset() * 60 * 1000;
	                            }
	
	                            // Validate the extremes. If it goes beyound the data min or max, use the
	                            // actual data extreme (#2438).
	                            if (isMin) {
	                                if (value > rangeSelector.maxInput.HCTime) {
	                                    value = undefined;
	                                } else if (value < dataMin) {
	                                    value = dataMin;
	                                }
	                            } else {
	                                if (value < rangeSelector.minInput.HCTime) {
	                                    value = undefined;
	                                } else if (value > dataMax) {
	                                    value = dataMax;
	                                }
	                            }
	
	                            // Set the extremes
	                            if (value !== undefined) {
	                                chartAxis.setExtremes(
	                                    isMin ? value : chartAxis.min,
	                                    isMin ? chartAxis.max : value,
	                                    undefined,
	                                    undefined, {
	                                        trigger: 'rangeSelectorInput'
	                                    }
	                                );
	                            }
	                        }
	                    }
	                }
	
	                // Create the text label
	                this[name + 'Label'] = label = renderer.label(lang[isMin ? 'rangeSelectorFrom' : 'rangeSelectorTo'], this.inputGroup.offset)
	                    .addClass('highcharts-range-label')
	                    .attr({
	                        padding: 2
	                    })
	                    .add(inputGroup);
	                inputGroup.offset += label.width + 5;
	
	                // Create an SVG label that shows updated date ranges and and records click events that
	                // bring in the HTML input.
	                this[name + 'DateBox'] = dateBox = renderer.label('', inputGroup.offset)
	                    .addClass('highcharts-range-input')
	                    .attr({
	                        padding: 2,
	                        width: options.inputBoxWidth || 90,
	                        height: options.inputBoxHeight || 17,
	                        stroke: options.inputBoxBorderColor || '#cccccc',
	                        'stroke-width': 1,
	                        'text-align': 'center'
	                    })
	                    .on('click', function() {
	                        rangeSelector.showInput(name); // If it is already focused, the onfocus event doesn't fire (#3713)
	                        rangeSelector[name + 'Input'].focus();
	                    })
	                    .add(inputGroup);
	                inputGroup.offset += dateBox.width + (isMin ? 10 : 0);
	
	
	                // Create the HTML input element. This is rendered as 1x1 pixel then set to the right size
	                // when focused.
	                this[name + 'Input'] = input = createElement('input', {
	                    name: name,
	                    className: 'highcharts-range-selector',
	                    type: 'text'
	                }, {
	                    top: chart.plotTop + 'px' // prevent jump on focus in Firefox
	                }, div);
	
	
	                // Styles
	                label.css(merge(chartStyle, options.labelStyle));
	
	                dateBox.css(merge({
	                    color: '#333333'
	                }, chartStyle, options.inputStyle));
	
	                css(input, extend({
	                    position: 'absolute',
	                    border: 0,
	                    width: '1px', // Chrome needs a pixel to see it
	                    height: '1px',
	                    padding: 0,
	                    textAlign: 'center',
	                    fontSize: chartStyle.fontSize,
	                    fontFamily: chartStyle.fontFamily,
	                    left: '-9em' // #4798
	                }, options.inputStyle));
	
	
	                // Blow up the input box
	                input.onfocus = function() {
	                    rangeSelector.showInput(name);
	                };
	                // Hide away the input box
	                input.onblur = function() {
	                    rangeSelector.hideInput(name);
	                };
	
	                // handle changes in the input boxes
	                input.onchange = updateExtremes;
	
	                input.onkeypress = function(event) {
	                    // IE does not fire onchange on enter
	                    if (event.keyCode === 13) {
	                        updateExtremes();
	                    }
	                };
	            },
	
	            /**
	             * Get the position of the range selector buttons and inputs. This can be overridden from outside for custom positioning.
	             */
	            getPosition: function() {
	                var chart = this.chart,
	                    options = chart.options.rangeSelector,
	                    buttonTop = pick((options.buttonPosition || {}).y, chart.plotTop - chart.axisOffset[0] - options.height);
	
	                return {
	                    buttonTop: buttonTop,
	                    inputTop: buttonTop - 10
	                };
	            },
	            /**
	             * Get the extremes of YTD. 
	             * Will choose dataMax if its value is lower than the current timestamp.
	             * Will choose dataMin if its value is higher than the timestamp for
	             * 	the start of current year.
	             * @param  {number} dataMax
	             * @param  {number} dataMin
	             * @return {object} Returns min and max for the YTD
	             */
	            getYTDExtremes: function(dataMax, dataMin, useUTC) {
	                var min,
	                    now = new HCDate(dataMax),
	                    year = now[HCDate.hcGetFullYear](),
	                    startOfYear = useUTC ? HCDate.UTC(year, 0, 1) : +new HCDate(year, 0, 1); // eslint-disable-line new-cap
	                min = Math.max(dataMin || 0, startOfYear);
	                now = now.getTime();
	                return {
	                    max: Math.min(dataMax || now, now),
	                    min: min
	                };
	            },
	
	            /**
	             * Render the range selector including the buttons and the inputs. The first time render
	             * is called, the elements are created and positioned. On subsequent calls, they are
	             * moved and updated.
	             * @param {Number} min X axis minimum
	             * @param {Number} max X axis maximum
	             */
	            render: function(min, max) {
	
	                var rangeSelector = this,
	                    chart = rangeSelector.chart,
	                    renderer = chart.renderer,
	                    container = chart.container,
	                    chartOptions = chart.options,
	                    navButtonOptions = chartOptions.exporting && chartOptions.exporting.enabled !== false &&
	                    chartOptions.navigation && chartOptions.navigation.buttonOptions,
	                    options = chartOptions.rangeSelector,
	                    buttons = rangeSelector.buttons,
	                    lang = defaultOptions.lang,
	                    div = rangeSelector.div,
	                    inputGroup = rangeSelector.inputGroup,
	                    buttonTheme = options.buttonTheme,
	                    buttonPosition = options.buttonPosition || {},
	                    inputEnabled = options.inputEnabled,
	                    states = buttonTheme && buttonTheme.states,
	                    plotLeft = chart.plotLeft,
	                    buttonLeft,
	                    pos = this.getPosition(),
	                    buttonGroup = rangeSelector.group,
	                    buttonBBox,
	                    rendered = rangeSelector.rendered;
	
	                if (options.enabled === false) {
	                    return;
	                }
	
	                // create the elements
	                if (!rendered) {
	
	                    rangeSelector.group = buttonGroup = renderer.g('range-selector-buttons').add();
	
	                    rangeSelector.zoomText = renderer.text(lang.rangeSelectorZoom, pick(buttonPosition.x, plotLeft), 15)
	                        .css(options.labelStyle)
	                        .add(buttonGroup);
	
	                    // button starting position
	                    buttonLeft = pick(buttonPosition.x, plotLeft) + rangeSelector.zoomText.getBBox().width + 5;
	
	                    each(rangeSelector.buttonOptions, function(rangeOptions, i) {
	                        buttons[i] = renderer.button(
	                                rangeOptions.text,
	                                buttonLeft,
	                                0,
	                                function() {
	                                    rangeSelector.clickButton(i);
	                                    rangeSelector.isActive = true;
	                                },
	                                buttonTheme,
	                                states && states.hover,
	                                states && states.select,
	                                states && states.disabled
	                            )
	                            .attr({
	                                'text-align': 'center'
	                            })
	                            .add(buttonGroup);
	
	                        // increase button position for the next button
	                        buttonLeft += buttons[i].width + pick(options.buttonSpacing, 5);
	                    });
	
	                    // first create a wrapper outside the container in order to make
	                    // the inputs work and make export correct
	                    if (inputEnabled !== false) {
	                        rangeSelector.div = div = createElement('div', null, {
	                            position: 'relative',
	                            height: 0,
	                            zIndex: 1 // above container
	                        });
	
	                        container.parentNode.insertBefore(div, container);
	
	                        // Create the group to keep the inputs
	                        rangeSelector.inputGroup = inputGroup = renderer.g('input-group')
	                            .add();
	                        inputGroup.offset = 0;
	
	                        rangeSelector.drawInput('min');
	                        rangeSelector.drawInput('max');
	                    }
	                }
	                rangeSelector.updateButtonStates();
	
	                // Set or update the group position
	                buttonGroup[rendered ? 'animate' : 'attr']({
	                    translateY: pos.buttonTop
	                });
	
	                if (inputEnabled !== false) {
	
	                    // Update the alignment to the updated spacing box
	                    inputGroup.align(extend({
	                        y: pos.inputTop,
	                        width: inputGroup.offset,
	                        // Detect collision with the exporting buttons
	                        x: navButtonOptions && (pos.inputTop < (navButtonOptions.y || 0) + navButtonOptions.height - chart.spacing[0]) ?
	                            -40 : 0
	                    }, options.inputPosition), true, chart.spacingBox);
	
	                    // Hide if overlapping - inputEnabled is null or undefined
	                    if (!defined(inputEnabled)) {
	                        buttonBBox = buttonGroup.getBBox();
	                        inputGroup[inputGroup.alignAttr.translateX < buttonBBox.x + buttonBBox.width + 10 ? 'hide' : 'show']();
	                    }
	
	                    // Set or reset the input values
	                    rangeSelector.setInputValue('min', min);
	                    rangeSelector.setInputValue('max', max);
	                }
	
	                rangeSelector.rendered = true;
	            },
	
	            /**
	             * Update the range selector with new options
	             */
	            update: function(options) {
	                var chart = this.chart;
	                merge(true, chart.options.rangeSelector, options);
	                this.destroy();
	                this.init(chart);
	            },
	
	            /**
	             * Destroys allocated elements.
	             */
	            destroy: function() {
	                var rSelector = this,
	                    minInput = rSelector.minInput,
	                    maxInput = rSelector.maxInput;
	
	                rSelector.unMouseDown();
	                rSelector.unResize();
	
	                // Destroy elements in collections
	                destroyObjectProperties(rSelector.buttons);
	
	                // Clear input element events
	                if (minInput) {
	                    minInput.onfocus = minInput.onblur = minInput.onchange = null;
	                }
	                if (maxInput) {
	                    maxInput.onfocus = maxInput.onblur = maxInput.onchange = null;
	                }
	
	                // Destroy HTML and SVG elements
	                H.objectEach(rSelector, function(val, key) {
	                    if (val && key !== 'chart') {
	                        if (val.destroy) { // SVGElement
	                            val.destroy();
	                        } else if (val.nodeType) { // HTML element
	                            discardElement(this[key]);
	                        }
	                    }
	                    if (val !== RangeSelector.prototype[key]) {
	                        rSelector[key] = null;
	                    }
	                }, this);
	            }
	        };
	
	        /**
	         * Add logic to normalize the zoomed range in order to preserve the pressed state of range selector buttons
	         */
	        Axis.prototype.toFixedRange = function(pxMin, pxMax, fixedMin, fixedMax) {
	            var fixedRange = this.chart && this.chart.fixedRange,
	                newMin = pick(fixedMin, this.translate(pxMin, true, !this.horiz)),
	                newMax = pick(fixedMax, this.translate(pxMax, true, !this.horiz)),
	                changeRatio = fixedRange && (newMax - newMin) / fixedRange;
	
	            // If the difference between the fixed range and the actual requested range is
	            // too great, the user is dragging across an ordinal gap, and we need to release
	            // the range selector button.
	            if (changeRatio > 0.7 && changeRatio < 1.3) {
	                if (fixedMax) {
	                    newMin = newMax - fixedRange;
	                } else {
	                    newMax = newMin + fixedRange;
	                }
	            }
	            if (!isNumber(newMin)) { // #1195
	                newMin = newMax = undefined;
	            }
	
	            return {
	                min: newMin,
	                max: newMax
	            };
	        };
	
	        /**
	         * Get the axis min value based on the range option and the current max. For
	         * stock charts this is extended via the {@link RangeSelector} so that if the
	         * selected range is a multiple of months or years, it is compensated for
	         * various month lengths.
	         * 
	         * @return {number} The new minimum value.
	         */
	        Axis.prototype.minFromRange = function() {
	            var rangeOptions = this.range,
	                type = rangeOptions.type,
	                timeName = {
	                    month: 'Month',
	                    year: 'FullYear'
	                }[type],
	                min,
	                max = this.max,
	                dataMin,
	                range,
	                // Get the true range from a start date
	                getTrueRange = function(base, count) {
	                    var date = new Date(base),
	                        basePeriod = date['get' + timeName]();
	
	                    date['set' + timeName](basePeriod + count);
	
	                    if (basePeriod === date['get' + timeName]()) {
	                        date.setDate(0); // #6537
	                    }
	
	                    return date.getTime() - base;
	                };
	
	            if (isNumber(rangeOptions)) {
	                min = max - rangeOptions;
	                range = rangeOptions;
	            } else {
	                min = max + getTrueRange(max, -rangeOptions.count);
	
	                // Let the fixedRange reflect initial settings (#5930)
	                if (this.chart) {
	                    this.chart.fixedRange = max - min;
	                }
	            }
	
	            dataMin = pick(this.dataMin, Number.MIN_VALUE);
	            if (!isNumber(min)) {
	                min = dataMin;
	            }
	            if (min <= dataMin) {
	                min = dataMin;
	                if (range === undefined) { // #4501
	                    range = getTrueRange(min, rangeOptions.count);
	                }
	                this.newMax = Math.min(min + range, this.dataMax);
	            }
	            if (!isNumber(max)) {
	                min = undefined;
	            }
	            return min;
	
	        };
	
	        // Initialize scroller for stock charts
	        wrap(Chart.prototype, 'init', function(proceed, options, callback) {
	
	            addEvent(this, 'init', function() {
	                if (this.options.rangeSelector.enabled) {
	                    this.rangeSelector = new RangeSelector(this);
	                }
	            });
	
	            proceed.call(this, options, callback);
	
	        });
	
	        Chart.prototype.callbacks.push(function(chart) {
	            var extremes,
	                rangeSelector = chart.rangeSelector,
	                unbindRender,
	                unbindSetExtremes;
	
	            function renderRangeSelector() {
	                extremes = chart.xAxis[0].getExtremes();
	                if (isNumber(extremes.min)) {
	                    rangeSelector.render(extremes.min, extremes.max);
	                }
	            }
	
	            if (rangeSelector) {
	                // redraw the scroller on setExtremes
	                unbindSetExtremes = addEvent(
	                    chart.xAxis[0],
	                    'afterSetExtremes',
	                    function(e) {
	                        rangeSelector.render(e.min, e.max);
	                    }
	                );
	
	                // redraw the scroller chart resize
	                unbindRender = addEvent(chart, 'redraw', renderRangeSelector);
	
	                // do it now
	                renderRangeSelector();
	            }
	
	            // Remove resize/afterSetExtremes at chart destroy
	            addEvent(chart, 'destroy', function destroyEvents() {
	                if (rangeSelector) {
	                    unbindRender();
	                    unbindSetExtremes();
	                }
	            });
	        });
	
	
	        H.RangeSelector = RangeSelector;
	
	        /* ****************************************************************************
	         * End Range Selector code													*
	         *****************************************************************************/
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var arrayMax = H.arrayMax,
	            arrayMin = H.arrayMin,
	            Axis = H.Axis,
	            Chart = H.Chart,
	            defined = H.defined,
	            each = H.each,
	            extend = H.extend,
	            format = H.format,
	            grep = H.grep,
	            inArray = H.inArray,
	            isNumber = H.isNumber,
	            isString = H.isString,
	            map = H.map,
	            merge = H.merge,
	            pick = H.pick,
	            Point = H.Point,
	            Renderer = H.Renderer,
	            Series = H.Series,
	            splat = H.splat,
	            SVGRenderer = H.SVGRenderer,
	            VMLRenderer = H.VMLRenderer,
	            wrap = H.wrap,
	
	
	            seriesProto = Series.prototype,
	            seriesInit = seriesProto.init,
	            seriesProcessData = seriesProto.processData,
	            pointTooltipFormatter = Point.prototype.tooltipFormatter;
	
	        /**
	         * Factory function for creating new stock charts. Creates a new {@link Chart|
	         * Chart} object with different default options than the basic Chart.
	         * 
	         * @function #stockChart
	         * @memberOf Highcharts
	         *
	         * @param  {String|HTMLDOMElement} renderTo
	         *         The DOM element to render to, or its id.
	         * @param  {Options} options
	         *         The chart options structure as described in the {@link
	         *         https://api.highcharts.com/highstock|options reference}.
	         * @param  {Function} callback
	         *         A function to execute when the chart object is finished loading and
	         *         rendering. In most cases the chart is built in one thread, but in
	         *         Internet Explorer version 8 or less the chart is sometimes initialized
	         *         before the document is ready, and in these cases the chart object
	         *         will not be finished synchronously. As a consequence, code that
	         *         relies on the newly built Chart object should always run in the
	         *         callback. Defining a {@link https://api.highcharts.com/highstock/chart.events.load|
	         *         chart.event.load} handler is equivalent.
	         *
	         * @return {Chart}
	         *         The chart object.
	         *
	         * @example
	         * var chart = Highcharts.stockChart('container', {
	         *     series: [{
	         *         data: [1, 2, 3, 4, 5, 6, 7, 8, 9],
	         *         pointInterval: 24 * 60 * 60 * 1000
	         *     }]
	         * });
	         */
	        H.StockChart = H.stockChart = function(a, b, c) {
	            var hasRenderToArg = isString(a) || a.nodeName,
	                options = arguments[hasRenderToArg ? 1 : 0],
	                seriesOptions = options.series, // to increase performance, don't merge the data
	                defaultOptions = H.getOptions(),
	                opposite,
	
	                // Always disable startOnTick:true on the main axis when the navigator
	                // is enabled (#1090)
	                navigatorEnabled = pick(
	                    options.navigator && options.navigator.enabled,
	                    defaultOptions.navigator.enabled,
	                    true
	                ),
	                disableStartOnTick = navigatorEnabled ? {
	                    startOnTick: false,
	                    endOnTick: false
	                } : null,
	
	                lineOptions = {
	
	                    marker: {
	                        enabled: false,
	                        radius: 2
	                    }
	                    // gapSize: 0
	                },
	                columnOptions = {
	                    shadow: false,
	                    borderWidth: 0
	                };
	
	            // apply X axis options to both single and multi y axes
	            options.xAxis = map(splat(options.xAxis || {}), function(xAxisOptions) {
	                return merge({ // defaults
	                        minPadding: 0,
	                        maxPadding: 0,
	                        ordinal: true,
	                        title: {
	                            text: null
	                        },
	                        labels: {
	                            overflow: 'justify'
	                        },
	                        showLastLabel: true
	                    },
	                    defaultOptions.xAxis, // #3802
	                    xAxisOptions, // user options
	                    { // forced options
	                        type: 'datetime',
	                        categories: null
	                    },
	                    disableStartOnTick
	                );
	            });
	
	            // apply Y axis options to both single and multi y axes
	            options.yAxis = map(splat(options.yAxis || {}), function(yAxisOptions) {
	                opposite = pick(yAxisOptions.opposite, true);
	                return merge({ // defaults
	                        labels: {
	                            y: -2
	                        },
	                        opposite: opposite,
	                        showLastLabel: false,
	                        title: {
	                            text: null
	                        }
	                    },
	                    defaultOptions.yAxis, // #3802
	                    yAxisOptions // user options
	                );
	            });
	
	            options.series = null;
	
	            options = merge({
	                    chart: {
	                        panning: true,
	                        pinchType: 'x'
	                    },
	                    navigator: {
	                        enabled: navigatorEnabled
	                    },
	                    scrollbar: {
	                        // #4988 - check if setOptions was called
	                        enabled: pick(defaultOptions.scrollbar.enabled, true)
	                    },
	                    rangeSelector: {
	                        // #4988 - check if setOptions was called
	                        enabled: pick(defaultOptions.rangeSelector.enabled, true)
	                    },
	                    title: {
	                        text: null
	                    },
	                    tooltip: {
	                        shared: true,
	                        crosshairs: true
	                    },
	                    legend: {
	                        enabled: false
	                    },
	
	                    plotOptions: {
	                        line: lineOptions,
	                        spline: lineOptions,
	                        area: lineOptions,
	                        areaspline: lineOptions,
	                        arearange: lineOptions,
	                        areasplinerange: lineOptions,
	                        column: columnOptions,
	                        columnrange: columnOptions,
	                        candlestick: columnOptions,
	                        ohlc: columnOptions
	                    }
	
	                },
	
	                options, // user's options
	
	                { // forced options
	                    isStock: true // internal flag
	                }
	            );
	
	            options.series = seriesOptions;
	
	            return hasRenderToArg ?
	                new Chart(a, options, c) :
	                new Chart(options, b);
	        };
	
	        // Override the automatic label alignment so that the first Y axis' labels
	        // are drawn on top of the grid line, and subsequent axes are drawn outside
	        wrap(Axis.prototype, 'autoLabelAlign', function(proceed) {
	            var chart = this.chart,
	                options = this.options,
	                panes = chart._labelPanes = chart._labelPanes || {},
	                key,
	                labelOptions = this.options.labels;
	            if (this.chart.options.isStock && this.coll === 'yAxis') {
	                key = options.top + ',' + options.height;
	                if (!panes[key] && labelOptions.enabled) { // do it only for the first Y axis of each pane
	                    if (labelOptions.x === 15) { // default
	                        labelOptions.x = 0;
	                    }
	                    if (labelOptions.align === undefined) {
	                        labelOptions.align = 'right';
	                    }
	                    panes[key] = this;
	                    return 'right';
	                }
	            }
	            return proceed.apply(this, [].slice.call(arguments, 1));
	        });
	
	        // Clear axis from label panes (#6071)
	        wrap(Axis.prototype, 'destroy', function(proceed) {
	            var chart = this.chart,
	                key = this.options && (this.options.top + ',' + this.options.height);
	
	            if (key && chart._labelPanes && chart._labelPanes[key] === this) {
	                delete chart._labelPanes[key];
	            }
	
	            return proceed.apply(this, Array.prototype.slice.call(arguments, 1));
	        });
	
	        // Override getPlotLinePath to allow for multipane charts
	        wrap(Axis.prototype, 'getPlotLinePath', function(proceed, value, lineWidth, old, force, translatedValue) {
	            var axis = this,
	                series = (this.isLinked && !this.series ? this.linkedParent.series : this.series),
	                chart = axis.chart,
	                renderer = chart.renderer,
	                axisLeft = axis.left,
	                axisTop = axis.top,
	                x1,
	                y1,
	                x2,
	                y2,
	                result = [],
	                axes = [], //#3416 need a default array
	                axes2,
	                uniqueAxes,
	                transVal;
	
	            /**
	             * Return the other axis based on either the axis option or on related series.
	             */
	            function getAxis(coll) {
	                var otherColl = coll === 'xAxis' ? 'yAxis' : 'xAxis',
	                    opt = axis.options[otherColl];
	
	                // Other axis indexed by number
	                if (isNumber(opt)) {
	                    return [chart[otherColl][opt]];
	                }
	
	                // Other axis indexed by id (like navigator)
	                if (isString(opt)) {
	                    return [chart.get(opt)];
	                }
	
	                // Auto detect based on existing series
	                return map(series, function(s) {
	                    return s[otherColl];
	                });
	            }
	
	            // Ignore in case of colorAxis or zAxis. #3360, #3524, #6720
	            if (axis.coll !== 'xAxis' && axis.coll !== 'yAxis') {
	                return proceed.apply(this, [].slice.call(arguments, 1));
	            }
	
	            // Get the related axes based on series
	            axes = getAxis(axis.coll);
	
	            // Get the related axes based options.*Axis setting #2810
	            axes2 = (axis.isXAxis ? chart.yAxis : chart.xAxis);
	            each(axes2, function(A) {
	                if (defined(A.options.id) ? A.options.id.indexOf('navigator') === -1 : true) {
	                    var a = (A.isXAxis ? 'yAxis' : 'xAxis'),
	                        rax = (defined(A.options[a]) ? chart[a][A.options[a]] : chart[a][0]);
	
	                    if (axis === rax) {
	                        axes.push(A);
	                    }
	                }
	            });
	
	
	            // Remove duplicates in the axes array. If there are no axes in the axes array,
	            // we are adding an axis without data, so we need to populate this with grid
	            // lines (#2796).
	            uniqueAxes = axes.length ? [] : [axis.isXAxis ? chart.yAxis[0] : chart.xAxis[0]]; //#3742
	            each(axes, function(axis2) {
	                if (
	                    inArray(axis2, uniqueAxes) === -1 &&
	                    // Do not draw on axis which overlap completely. #5424
	                    !H.find(uniqueAxes, function(unique) {
	                        return unique.pos === axis2.pos && unique.len && axis2.len;
	                    })
	                ) {
	                    uniqueAxes.push(axis2);
	                }
	            });
	
	            transVal = pick(translatedValue, axis.translate(value, null, null, old));
	            if (isNumber(transVal)) {
	                if (axis.horiz) {
	                    each(uniqueAxes, function(axis2) {
	                        var skip;
	
	                        y1 = axis2.pos;
	                        y2 = y1 + axis2.len;
	                        x1 = x2 = Math.round(transVal + axis.transB);
	
	                        if (x1 < axisLeft || x1 > axisLeft + axis.width) { // outside plot area
	                            if (force) {
	                                x1 = x2 = Math.min(Math.max(axisLeft, x1), axisLeft + axis.width);
	                            } else {
	                                skip = true;
	                            }
	                        }
	                        if (!skip) {
	                            result.push('M', x1, y1, 'L', x2, y2);
	                        }
	                    });
	                } else {
	                    each(uniqueAxes, function(axis2) {
	                        var skip;
	
	                        x1 = axis2.pos;
	                        x2 = x1 + axis2.len;
	                        y1 = y2 = Math.round(axisTop + axis.height - transVal);
	
	                        if (y1 < axisTop || y1 > axisTop + axis.height) { // outside plot area
	                            if (force) {
	                                y1 = y2 = Math.min(Math.max(axisTop, y1), axis.top + axis.height);
	                            } else {
	                                skip = true;
	                            }
	                        }
	                        if (!skip) {
	                            result.push('M', x1, y1, 'L', x2, y2);
	                        }
	                    });
	                }
	            }
	            return result.length > 0 ?
	                renderer.crispPolyLine(result, lineWidth || 1) :
	                null; //#3557 getPlotLinePath in regular Highcharts also returns null
	        });
	
	        // Override getPlotBandPath to allow for multipane charts
	        Axis.prototype.getPlotBandPath = function(from, to) {
	            var toPath = this.getPlotLinePath(to, null, null, true),
	                path = this.getPlotLinePath(from, null, null, true),
	                result = [],
	                i;
	
	            if (path && toPath) {
	                if (path.toString() === toPath.toString()) {
	                    // #6166
	                    result = path;
	                    result.flat = true;
	                } else {
	                    // Go over each subpath
	                    for (i = 0; i < path.length; i += 6) {
	                        result.push(
	                            'M', path[i + 1], path[i + 2],
	                            'L', path[i + 4], path[i + 5],
	                            toPath[i + 4], toPath[i + 5],
	                            toPath[i + 1], toPath[i + 2],
	                            'z'
	                        );
	                    }
	                }
	            } else { // outside the axis area
	                result = null;
	            }
	
	            return result;
	        };
	
	        // Function to crisp a line with multiple segments
	        SVGRenderer.prototype.crispPolyLine = function(points, width) {
	            // points format: ['M', 0, 0, 'L', 100, 0]		
	            // normalize to a crisp line
	            var i;
	            for (i = 0; i < points.length; i = i + 6) {
	                if (points[i + 1] === points[i + 4]) {
	                    // Substract due to #1129. Now bottom and left axis gridlines behave the same.
	                    points[i + 1] = points[i + 4] = Math.round(points[i + 1]) - (width % 2 / 2);
	                }
	                if (points[i + 2] === points[i + 5]) {
	                    points[i + 2] = points[i + 5] = Math.round(points[i + 2]) + (width % 2 / 2);
	                }
	            }
	            return points;
	        };
	
	        if (Renderer === VMLRenderer) {
	            VMLRenderer.prototype.crispPolyLine = SVGRenderer.prototype.crispPolyLine;
	        }
	
	
	        // Wrapper to hide the label
	        wrap(Axis.prototype, 'hideCrosshair', function(proceed, i) {
	
	            proceed.call(this, i);
	
	            if (this.crossLabel) {
	                this.crossLabel = this.crossLabel.hide();
	            }
	        });
	
	        // Wrapper to draw the label
	        wrap(Axis.prototype, 'drawCrosshair', function(proceed, e, point) {
	
	            // Draw the crosshair
	            proceed.call(this, e, point);
	
	            // Check if the label has to be drawn
	            if (!defined(this.crosshair.label) || !this.crosshair.label.enabled || !this.cross) {
	                return;
	            }
	
	            var chart = this.chart,
	                options = this.options.crosshair.label, // the label's options
	                horiz = this.horiz, // axis orientation
	                opposite = this.opposite, // axis position
	                left = this.left, // left position
	                top = this.top, // top position
	                crossLabel = this.crossLabel, // reference to the svgElement
	                posx,
	                posy,
	                crossBox,
	                formatOption = options.format,
	                formatFormat = '',
	                limit,
	                align,
	                tickInside = this.options.tickPosition === 'inside',
	                snap = this.crosshair.snap !== false,
	                value,
	                offset = 0;
	
	            // Use last available event (#5287)
	            if (!e) {
	                e = this.cross && this.cross.e;
	            }
	
	            align = (horiz ? 'center' : opposite ?
	                (this.labelAlign === 'right' ? 'right' : 'left') :
	                (this.labelAlign === 'left' ? 'left' : 'center'));
	
	            // If the label does not exist yet, create it.
	            if (!crossLabel) {
	                crossLabel = this.crossLabel = chart.renderer.label(null, null, null, options.shape || 'callout')
	                    .addClass('highcharts-crosshair-label' +
	                        (this.series[0] && ' highcharts-color-' + this.series[0].colorIndex))
	                    .attr({
	                        align: options.align || align,
	                        padding: pick(options.padding, 8),
	                        r: pick(options.borderRadius, 3),
	                        zIndex: 2
	                    })
	                    .add(this.labelGroup);
	
	
	                // Presentational
	                crossLabel
	                    .attr({
	                        fill: options.backgroundColor ||
	                            (this.series[0] && this.series[0].color) || '#666666',
	                        stroke: options.borderColor || '',
	                        'stroke-width': options.borderWidth || 0
	                    })
	                    .css(extend({
	                        color: '#ffffff',
	                        fontWeight: 'normal',
	                        fontSize: '11px',
	                        textAlign: 'center'
	                    }, options.style));
	
	            }
	
	            if (horiz) {
	                posx = snap ? point.plotX + left : e.chartX;
	                posy = top + (opposite ? 0 : this.height);
	            } else {
	                posx = opposite ? this.width + left : 0;
	                posy = snap ? point.plotY + top : e.chartY;
	            }
	
	            if (!formatOption && !options.formatter) {
	                if (this.isDatetimeAxis) {
	                    formatFormat = '%b %d, %Y';
	                }
	                formatOption = '{value' + (formatFormat ? ':' + formatFormat : '') + '}';
	            }
	
	            // Show the label
	            value = snap ? point[this.isXAxis ? 'x' : 'y'] : this.toValue(horiz ? e.chartX : e.chartY);
	            crossLabel.attr({
	                text: formatOption ? format(formatOption, {
	                    value: value
	                }) : options.formatter.call(this, value),
	                x: posx,
	                y: posy,
	                visibility: 'visible'
	            });
	
	            crossBox = crossLabel.getBBox();
	
	            // now it is placed we can correct its position
	            if (horiz) {
	                if ((tickInside && !opposite) || (!tickInside && opposite)) {
	                    posy = crossLabel.y - crossBox.height;
	                }
	            } else {
	                posy = crossLabel.y - (crossBox.height / 2);
	            }
	
	            // check the edges
	            if (horiz) {
	                limit = {
	                    left: left - crossBox.x,
	                    right: left + this.width - crossBox.x
	                };
	            } else {
	                limit = {
	                    left: this.labelAlign === 'left' ? left : 0,
	                    right: this.labelAlign === 'right' ? left + this.width : chart.chartWidth
	                };
	            }
	
	            // left edge
	            if (crossLabel.translateX < limit.left) {
	                offset = limit.left - crossLabel.translateX;
	            }
	            // right edge
	            if (crossLabel.translateX + crossBox.width >= limit.right) {
	                offset = -(crossLabel.translateX + crossBox.width - limit.right);
	            }
	
	            // show the crosslabel
	            crossLabel.attr({
	                x: posx + offset,
	                y: posy,
	                // First set x and y, then anchorX and anchorY, when box is actually calculated, #5702
	                anchorX: horiz ? posx : (this.opposite ? 0 : chart.chartWidth),
	                anchorY: horiz ? (this.opposite ? chart.chartHeight : 0) : posy + crossBox.height / 2
	            });
	        });
	
	        /* ****************************************************************************
	         * Start value compare logic												  *
	         *****************************************************************************/
	
	        /**
	         * Extend series.init by adding a method to modify the y value used for plotting
	         * on the y axis. This method is called both from the axis when finding dataMin
	         * and dataMax, and from the series.translate method.
	         */
	        seriesProto.init = function() {
	
	            // Call base method
	            seriesInit.apply(this, arguments);
	
	            // Set comparison mode
	            this.setCompare(this.options.compare);
	        };
	
	        /**
	         * Highstock only. Set the {@link
	         * http://api.highcharts.com/highstock/plotOptions.series.compare|
	         * compare} mode of the series after render time. In most cases it is more
	         * useful running {@link Axis#setCompare} on the X axis to update all its
	         * series.
	         *
	         * @function setCompare
	         * @memberOf Series.prototype
	         *
	         * @param  {String} compare
	         *         Can be one of `null`, `"percent"` or `"value"`.
	         */
	        seriesProto.setCompare = function(compare) {
	
	            // Set or unset the modifyValue method
	            this.modifyValue = (compare === 'value' || compare === 'percent') ? function(value, point) {
	                var compareValue = this.compareValue;
	
	                if (value !== undefined && compareValue !== undefined) { // #2601, #5814
	
	                    // Get the modified value
	                    if (compare === 'value') {
	                        value -= compareValue;
	
	                        // Compare percent
	                    } else {
	                        value = 100 * (value / compareValue) -
	                            (this.options.compareBase === 100 ? 0 : 100);
	                    }
	
	                    // record for tooltip etc.
	                    if (point) {
	                        point.change = value;
	                    }
	
	                    return value;
	                }
	            } : null;
	
	            // Survive to export, #5485
	            this.userOptions.compare = compare;
	
	            // Mark dirty
	            if (this.chart.hasRendered) {
	                this.isDirty = true;
	            }
	
	        };
	
	        /**
	         * Extend series.processData by finding the first y value in the plot area,
	         * used for comparing the following values
	         */
	        seriesProto.processData = function() {
	            var series = this,
	                i,
	                keyIndex = -1,
	                processedXData,
	                processedYData,
	                length,
	                compareValue;
	
	            // call base method
	            seriesProcessData.apply(this, arguments);
	
	            if (series.xAxis && series.processedYData) { // not pies
	
	                // local variables
	                processedXData = series.processedXData;
	                processedYData = series.processedYData;
	                length = processedYData.length;
	
	                // For series with more than one value (range, OHLC etc), compare against
	                // close or the pointValKey (#4922, #3112)
	                if (series.pointArrayMap) {
	                    // Use close if present (#3112)
	                    keyIndex = inArray('close', series.pointArrayMap);
	                    if (keyIndex === -1) {
	                        keyIndex = inArray(series.pointValKey || 'y', series.pointArrayMap);
	                    }
	                }
	
	                // find the first value for comparison
	                for (i = 0; i < length - 1; i++) {
	                    compareValue = processedYData[i] && keyIndex > -1 ?
	                        processedYData[i][keyIndex] :
	                        processedYData[i];
	                    if (isNumber(compareValue) && processedXData[i + 1] >= series.xAxis.min && compareValue !== 0) {
	                        series.compareValue = compareValue;
	                        break;
	                    }
	                }
	            }
	        };
	
	        /**
	         * Modify series extremes
	         */
	        wrap(seriesProto, 'getExtremes', function(proceed) {
	            var extremes;
	
	            proceed.apply(this, [].slice.call(arguments, 1));
	
	            if (this.modifyValue) {
	                extremes = [this.modifyValue(this.dataMin), this.modifyValue(this.dataMax)];
	                this.dataMin = arrayMin(extremes);
	                this.dataMax = arrayMax(extremes);
	            }
	        });
	
	        /**
	         * Highstock only. Set the compare mode on all series belonging to an Y axis
	         * after render time.
	         *
	         * @param  {String} compare
	         *         The compare mode. Can be one of `null`, `"value"` or `"percent"`.
	         * @param  {Boolean} [redraw=true]
	         *         Whether to redraw the chart or to wait for a later call to {@link
	         *         Chart#redraw},
	         *
	         * @function setCompare
	         * @memberOf Axis.prototype
	         *
	         * @see    {@link https://api.highcharts.com/highstock/series.plotOptions.compare|
	         *         series.plotOptions.compare}
	         *
	         * @sample stock/members/axis-setcompare/
	         *         Set compoare
	         */
	        Axis.prototype.setCompare = function(compare, redraw) {
	            if (!this.isXAxis) {
	                each(this.series, function(series) {
	                    series.setCompare(compare);
	                });
	                if (pick(redraw, true)) {
	                    this.chart.redraw();
	                }
	            }
	        };
	
	        /**
	         * Extend the tooltip formatter by adding support for the point.change variable
	         * as well as the changeDecimals option
	         */
	        Point.prototype.tooltipFormatter = function(pointFormat) {
	            var point = this;
	
	            pointFormat = pointFormat.replace(
	                '{point.change}',
	                (point.change > 0 ? '+' : '') +
	                H.numberFormat(point.change, pick(point.series.tooltipOptions.changeDecimals, 2))
	            );
	
	            return pointTooltipFormatter.apply(this, [pointFormat]);
	        };
	
	        /* ****************************************************************************
	         * End value compare logic													*
	         *****************************************************************************/
	
	
	        /**
	         * Extend the Series prototype to create a separate series clip box. This is
	         * related to using multiple panes, and a future pane logic should incorporate
	         * this feature (#2754).
	         */
	        wrap(Series.prototype, 'render', function(proceed) {
	            // Only do this on not 3d (#2939, #5904) nor polar (#6057) charts, and only
	            // if the series type handles clipping in the animate method (#2975).
	            if (!(this.chart.is3d && this.chart.is3d()) &&
	                !this.chart.polar &&
	                this.xAxis &&
	                !this.xAxis.isRadial // Gauge, #6192
	            ) {
	
	                // First render, initial clip box
	                if (!this.clipBox && this.animate) {
	                    this.clipBox = merge(this.chart.clipBox);
	                    this.clipBox.width = this.xAxis.len;
	                    this.clipBox.height = this.yAxis.len;
	
	                    // On redrawing, resizing etc, update the clip rectangle
	                } else if (this.chart[this.sharedClipKey]) {
	                    this.chart[this.sharedClipKey].attr({
	                        width: this.xAxis.len,
	                        height: this.yAxis.len
	                    });
	                    // #3111
	                } else if (this.clipBox) {
	                    this.clipBox.width = this.xAxis.len;
	                    this.clipBox.height = this.yAxis.len;
	                }
	            }
	            proceed.call(this);
	        });
	
	        wrap(Chart.prototype, 'getSelectedPoints', function(proceed) {
	            var points = proceed.call(this);
	
	            each(this.series, function(serie) {
	                // series.points - for grouped points (#6445)
	                if (serie.hasGroupedData) {
	                    points = points.concat(grep(serie.points || [], function(point) {
	                        return point.selected;
	                    }));
	                }
	            });
	            return points;
	        });
	
	        wrap(Chart.prototype, 'update', function(proceed, options) {
	            // Use case: enabling scrollbar from a disabled state.
	            // Scrollbar needs to be initialized from a controller, Navigator in this
	            // case (#6615)
	            if ('scrollbar' in options && this.navigator) {
	                merge(true, this.options.scrollbar, options.scrollbar);
	                this.navigator.update({}, false);
	                delete options.scrollbar;
	            }
	
	            return proceed.apply(this, Array.prototype.slice.call(arguments, 1));
	        });
	
	    }(Highcharts));
	    (function() {
	
	
	    }());
	    return Highcharts
	}));


/***/ }),
/* 903 */
/***/ (function(module, exports) {

	/*
	 Highcharts JS v5.0.14 (2017-07-28)
	
	 (c) 2009-2016 Torstein Honsi
	
	 License: www.highcharts.com/license
	*/
	(function(x){"object"===typeof module&&module.exports?module.exports=x:x(Highcharts)})(function(x){(function(b){function r(b,a){this.init(b,a)}var v=b.CenteredSeriesMixin,w=b.each,n=b.extend,h=b.merge,g=b.splat;n(r.prototype,{coll:"pane",init:function(b,a){this.chart=a;this.background=[];a.pane.push(this);this.setOptions(b)},setOptions:function(b){this.options=h(this.defaultOptions,this.chart.angular?{background:{}}:void 0,b)},render:function(){var b=this.options,a=this.options.background,c=this.chart.renderer;
	this.group||(this.group=c.g("pane-group").attr({zIndex:b.zIndex||0}).add());this.updateCenter();if(a)for(a=g(a),b=Math.max(a.length,this.background.length||0),c=0;c<b;c++)a[c]&&this.axis?this.renderBackground(h(this.defaultBackgroundOptions,a[c]),c):this.background[c]&&(this.background[c]=this.background[c].destroy(),this.background.splice(c,1))},renderBackground:function(b,a){var c="animate";this.background[a]||(this.background[a]=this.chart.renderer.path().add(this.group),c="attr");this.background[a][c]({d:this.axis.getPlotBandPath(b.from,
	b.to,b)}).attr({fill:b.backgroundColor,stroke:b.borderColor,"stroke-width":b.borderWidth,"class":"highcharts-pane "+(b.className||"")})},defaultOptions:{center:["50%","50%"],size:"85%",startAngle:0},defaultBackgroundOptions:{shape:"circle",borderWidth:1,borderColor:"#cccccc",backgroundColor:{linearGradient:{x1:0,y1:0,x2:0,y2:1},stops:[[0,"#ffffff"],[1,"#e6e6e6"]]},from:-Number.MAX_VALUE,innerRadius:0,to:Number.MAX_VALUE,outerRadius:"105%"},updateCenter:function(b){this.center=(b||this.axis||{}).center=
	v.getCenter.call(this)},update:function(b,a){h(!0,this.options,b);this.setOptions(this.options);this.render();w(this.chart.axes,function(c){c.pane===this&&(c.pane=null,c.update({},a))},this)}});b.Pane=r})(x);(function(b){var r=b.each,v=b.extend,w=b.map,n=b.merge,h=b.noop,g=b.pick,m=b.pInt,a=b.wrap,c,k,f=b.Axis.prototype;b=b.Tick.prototype;c={getOffset:h,redraw:function(){this.isDirty=!1},render:function(){this.isDirty=!1},setScale:h,setCategories:h,setTitle:h};k={defaultRadialGaugeOptions:{labels:{align:"center",
	x:0,y:null},minorGridLineWidth:0,minorTickInterval:"auto",minorTickLength:10,minorTickPosition:"inside",minorTickWidth:1,tickLength:10,tickPosition:"inside",tickWidth:2,title:{rotation:0},zIndex:2},defaultRadialXOptions:{gridLineWidth:1,labels:{align:null,distance:15,x:0,y:null},maxPadding:0,minPadding:0,showLastLabel:!1,tickLength:0},defaultRadialYOptions:{gridLineInterpolation:"circle",labels:{align:"right",x:-3,y:-2},showLastLabel:!1,title:{x:4,text:null,rotation:90}},setOptions:function(a){a=
	this.options=n(this.defaultOptions,this.defaultRadialOptions,a);a.plotBands||(a.plotBands=[])},getOffset:function(){f.getOffset.call(this);this.chart.axisOffset[this.side]=0},getLinePath:function(a,c){a=this.center;var e=this.chart,d=g(c,a[2]/2-this.offset);this.isCircular||void 0!==c?c=this.chart.renderer.symbols.arc(this.left+a[0],this.top+a[1],d,d,{start:this.startAngleRad,end:this.endAngleRad,open:!0,innerR:0}):(c=this.postTranslate(this.angleRad,d),c=["M",a[0]+e.plotLeft,a[1]+e.plotTop,"L",c.x,
	c.y]);return c},setAxisTranslation:function(){f.setAxisTranslation.call(this);this.center&&(this.transA=this.isCircular?(this.endAngleRad-this.startAngleRad)/(this.max-this.min||1):this.center[2]/2/(this.max-this.min||1),this.minPixelPadding=this.isXAxis?this.transA*this.minPointOffset:0)},beforeSetTickPositions:function(){if(this.autoConnect=this.isCircular&&void 0===g(this.userMax,this.options.max)&&this.endAngleRad-this.startAngleRad===2*Math.PI)this.max+=this.categories&&1||this.pointRange||this.closestPointRange||
	0},setAxisSize:function(){f.setAxisSize.call(this);this.isRadial&&(this.pane.updateCenter(this),this.isCircular&&(this.sector=this.endAngleRad-this.startAngleRad),this.len=this.width=this.height=this.center[2]*g(this.sector,1)/2)},getPosition:function(a,c){return this.postTranslate(this.isCircular?this.translate(a):this.angleRad,g(this.isCircular?c:this.translate(a),this.center[2]/2)-this.offset)},postTranslate:function(a,c){var e=this.chart,d=this.center;a=this.startAngleRad+a;return{x:e.plotLeft+
	d[0]+Math.cos(a)*c,y:e.plotTop+d[1]+Math.sin(a)*c}},getPlotBandPath:function(a,c,p){var e=this.center,d=this.startAngleRad,k=e[2]/2,b=[g(p.outerRadius,"100%"),p.innerRadius,g(p.thickness,10)],f=Math.min(this.offset,0),t=/%$/,h,n=this.isCircular;"polygon"===this.options.gridLineInterpolation?e=this.getPlotLinePath(a).concat(this.getPlotLinePath(c,!0)):(a=Math.max(a,this.min),c=Math.min(c,this.max),n||(b[0]=this.translate(a),b[1]=this.translate(c)),b=w(b,function(a){t.test(a)&&(a=m(a,10)*k/100);return a}),
	"circle"!==p.shape&&n?(a=d+this.translate(a),c=d+this.translate(c)):(a=-Math.PI/2,c=1.5*Math.PI,h=!0),b[0]-=f,b[2]-=f,e=this.chart.renderer.symbols.arc(this.left+e[0],this.top+e[1],b[0],b[0],{start:Math.min(a,c),end:Math.max(a,c),innerR:g(b[1],b[0]-b[2]),open:h}));return e},getPlotLinePath:function(a,c){var e=this,d=e.center,b=e.chart,k=e.getPosition(a),f,g,t;e.isCircular?t=["M",d[0]+b.plotLeft,d[1]+b.plotTop,"L",k.x,k.y]:"circle"===e.options.gridLineInterpolation?(a=e.translate(a))&&(t=e.getLinePath(0,
	a)):(r(b.xAxis,function(a){a.pane===e.pane&&(f=a)}),t=[],a=e.translate(a),d=f.tickPositions,f.autoConnect&&(d=d.concat([d[0]])),c&&(d=[].concat(d).reverse()),r(d,function(c,e){g=f.getPosition(c,a);t.push(e?"L":"M",g.x,g.y)}));return t},getTitlePosition:function(){var a=this.center,c=this.chart,b=this.options.title;return{x:c.plotLeft+a[0]+(b.x||0),y:c.plotTop+a[1]-{high:.5,middle:.25,low:0}[b.align]*a[2]+(b.y||0)}}};a(f,"init",function(a,d,b){var e=d.angular,p=d.polar,f=b.isX,y=e&&f,h,t=d.options,
	m=this.pane=d.pane[b.pane||0],r=m.options;if(e){if(v(this,y?c:k),h=!f)this.defaultRadialOptions=this.defaultRadialGaugeOptions}else p&&(v(this,k),this.defaultRadialOptions=(h=f)?this.defaultRadialXOptions:n(this.defaultYAxisOptions,this.defaultRadialYOptions));e||p?(this.isRadial=!0,d.inverted=!1,t.chart.zoomType=null):this.isRadial=!1;h&&(m.axis=this);a.call(this,d,b);y||!e&&!p||(a=this.options,this.angleRad=(a.angle||0)*Math.PI/180,this.startAngleRad=(r.startAngle-90)*Math.PI/180,this.endAngleRad=
	(g(r.endAngle,r.startAngle+360)-90)*Math.PI/180,this.offset=a.offset||0,this.isCircular=h)});a(f,"autoLabelAlign",function(a){if(!this.isRadial)return a.apply(this,[].slice.call(arguments,1))});a(b,"getPosition",function(a,c,b,k,f){var e=this.axis;return e.getPosition?e.getPosition(b):a.call(this,c,b,k,f)});a(b,"getLabelPosition",function(a,c,b,k,f,q,y,h,t){var d=this.axis,e=q.y,p=20,l=q.align,u=(d.translate(this.pos)+d.startAngleRad+Math.PI/2)/Math.PI*180%360;d.isRadial?(a=d.getPosition(this.pos,
	d.center[2]/2+g(q.distance,-25)),"auto"===q.rotation?k.attr({rotation:u}):null===e&&(e=d.chart.renderer.fontMetrics(k.styles.fontSize).b-k.getBBox().height/2),null===l&&(d.isCircular?(this.label.getBBox().width>d.len*d.tickInterval/(d.max-d.min)&&(p=0),l=u>p&&u<180-p?"left":u>180+p&&u<360-p?"right":"center"):l="center",k.attr({align:l})),a.x+=q.x,a.y+=e):a=a.call(this,c,b,k,f,q,y,h,t);return a});a(b,"getMarkPath",function(a,c,b,k,f,q,y){var d=this.axis;d.isRadial?(a=d.getPosition(this.pos,d.center[2]/
	2+k),c=["M",c,b,"L",a.x,a.y]):c=a.call(this,c,b,k,f,q,y);return c})})(x);(function(b){var r=b.each,v=b.pick,w=b.defined,n=b.seriesType,h=b.seriesTypes,g=b.Series.prototype,m=b.Point.prototype;n("arearange","area",{lineWidth:1,threshold:null,tooltip:{pointFormat:'\x3cspan style\x3d"color:{series.color}"\x3e\u25cf\x3c/span\x3e {series.name}: \x3cb\x3e{point.low}\x3c/b\x3e - \x3cb\x3e{point.high}\x3c/b\x3e\x3cbr/\x3e'},trackByArea:!0,dataLabels:{align:null,verticalAlign:null,xLow:0,xHigh:0,yLow:0,yHigh:0}},
	{pointArrayMap:["low","high"],dataLabelCollections:["dataLabel","dataLabelUpper"],toYData:function(a){return[a.low,a.high]},pointValKey:"low",deferTranslatePolar:!0,highToXY:function(a){var c=this.chart,b=this.xAxis.postTranslate(a.rectPlotX,this.yAxis.len-a.plotHigh);a.plotHighX=b.x-c.plotLeft;a.plotHigh=b.y-c.plotTop;a.plotLowX=a.plotX},translate:function(){var a=this,c=a.yAxis,b=!!a.modifyValue;h.area.prototype.translate.apply(a);r(a.points,function(k){var e=k.low,d=k.high,p=k.plotY;null===d||
	null===e?(k.isNull=!0,k.plotY=null):(k.plotLow=p,k.plotHigh=c.translate(b?a.modifyValue(d,k):d,0,1,0,1),b&&(k.yBottom=k.plotHigh))});this.chart.polar&&r(this.points,function(c){a.highToXY(c);c.tooltipPos=[(c.plotHighX+c.plotLowX)/2,(c.plotHigh+c.plotLow)/2]})},getGraphPath:function(a){var c=[],b=[],f,e=h.area.prototype.getGraphPath,d,p,u;u=this.options;var l=this.chart.polar&&!1!==u.connectEnds,q=u.connectNulls,y=u.step;a=a||this.points;for(f=a.length;f--;)d=a[f],d.isNull||l||q||a[f+1]&&!a[f+1].isNull||
	b.push({plotX:d.plotX,plotY:d.plotY,doCurve:!1}),p={polarPlotY:d.polarPlotY,rectPlotX:d.rectPlotX,yBottom:d.yBottom,plotX:v(d.plotHighX,d.plotX),plotY:d.plotHigh,isNull:d.isNull},b.push(p),c.push(p),d.isNull||l||q||a[f-1]&&!a[f-1].isNull||b.push({plotX:d.plotX,plotY:d.plotY,doCurve:!1});a=e.call(this,a);y&&(!0===y&&(y="left"),u.step={left:"right",center:"center",right:"left"}[y]);c=e.call(this,c);b=e.call(this,b);u.step=y;u=[].concat(a,c);this.chart.polar||"M"!==b[0]||(b[0]="L");this.graphPath=u;
	this.areaPath=this.areaPath.concat(a,b);u.isArea=!0;u.xMap=a.xMap;this.areaPath.xMap=a.xMap;return u},drawDataLabels:function(){var a=this.data,c=a.length,b,f=[],e=this.options.dataLabels,d=e.align,p=e.verticalAlign,u=e.inside,l,q,y=this.chart.inverted;if(e.enabled||this._hasPointLabels){for(b=c;b--;)if(l=a[b])q=u?l.plotHigh<l.plotLow:l.plotHigh>l.plotLow,l.y=l.high,l._plotY=l.plotY,l.plotY=l.plotHigh,f[b]=l.dataLabel,l.dataLabel=l.dataLabelUpper,l.below=q,y?d||(e.align=q?"right":"left"):p||(e.verticalAlign=
	q?"top":"bottom"),e.x=e.xHigh,e.y=e.yHigh;g.drawDataLabels&&g.drawDataLabels.apply(this,arguments);for(b=c;b--;)if(l=a[b])q=u?l.plotHigh<l.plotLow:l.plotHigh>l.plotLow,l.dataLabelUpper=l.dataLabel,l.dataLabel=f[b],l.y=l.low,l.plotY=l._plotY,l.below=!q,y?d||(e.align=q?"left":"right"):p||(e.verticalAlign=q?"bottom":"top"),e.x=e.xLow,e.y=e.yLow;g.drawDataLabels&&g.drawDataLabels.apply(this,arguments)}e.align=d;e.verticalAlign=p},alignDataLabel:function(){h.column.prototype.alignDataLabel.apply(this,
	arguments)},drawPoints:function(){var a=this.points.length,c,b;g.drawPoints.apply(this,arguments);for(b=0;b<a;)c=this.points[b],c.lowerGraphic=c.graphic,c.graphic=c.upperGraphic,c._plotY=c.plotY,c._plotX=c.plotX,c.plotY=c.plotHigh,w(c.plotHighX)&&(c.plotX=c.plotHighX),b++;g.drawPoints.apply(this,arguments);for(b=0;b<a;)c=this.points[b],c.upperGraphic=c.graphic,c.graphic=c.lowerGraphic,c.plotY=c._plotY,c.plotX=c._plotX,b++},setStackedPoints:b.noop},{setState:function(){var a=this.state,c=this.series,
	b=c.chart.polar;w(this.plotHigh)||(this.plotHigh=c.yAxis.toPixels(this.high,!0));w(this.plotLow)||(this.plotLow=this.plotY=c.yAxis.toPixels(this.low,!0));m.setState.apply(this,arguments);this.graphic=this.upperGraphic;this.plotY=this.plotHigh;b&&(this.plotX=this.plotHighX);this.state=a;c.stateMarkerGraphic&&(c.lowerStateMarkerGraphic=c.stateMarkerGraphic,c.stateMarkerGraphic=c.upperStateMarkerGraphic);m.setState.apply(this,arguments);this.plotY=this.plotLow;this.graphic=this.lowerGraphic;b&&(this.plotX=
	this.plotLowX);c.stateMarkerGraphic&&(c.upperStateMarkerGraphic=c.stateMarkerGraphic,c.stateMarkerGraphic=c.lowerStateMarkerGraphic)},haloPath:function(){var a=this.series.chart.polar,c;this.plotY=this.plotLow;a&&(this.plotX=this.plotLowX);c=m.haloPath.apply(this,arguments);this.plotY=this.plotHigh;a&&(this.plotX=this.plotHighX);return c=c.concat(m.haloPath.apply(this,arguments))},destroy:function(){this.upperGraphic&&(this.upperGraphic=this.upperGraphic.destroy());return m.destroy.apply(this,arguments)}})})(x);
	(function(b){var r=b.seriesType;r("areasplinerange","arearange",null,{getPointSpline:b.seriesTypes.spline.prototype.getPointSpline})})(x);(function(b){var r=b.defaultPlotOptions,v=b.each,w=b.merge,n=b.noop,h=b.pick,g=b.seriesType,m=b.seriesTypes.column.prototype;g("columnrange","arearange",w(r.column,r.arearange,{lineWidth:1,pointRange:null,marker:null,states:{hover:{halo:!1}}}),{translate:function(){var a=this,c=a.yAxis,b=a.xAxis,f=b.startAngleRad,e,d=a.chart,p=a.xAxis.isRadial,u=Math.max(d.chartWidth,
	d.chartHeight)+999,l;m.translate.apply(a);v(a.points,function(k){var q=k.shapeArgs,g=a.options.minPointLength,t,m;k.plotHigh=l=Math.min(Math.max(-u,c.translate(k.high,0,1,0,1)),u);k.plotLow=Math.min(Math.max(-u,k.plotY),u);m=l;t=h(k.rectPlotY,k.plotY)-l;Math.abs(t)<g?(g-=t,t+=g,m-=g/2):0>t&&(t*=-1,m-=t);p?(e=k.barX+f,k.shapeType="path",k.shapeArgs={d:a.polarArc(m+t,m,e,e+k.pointWidth)}):(q.height=t,q.y=m,k.tooltipPos=d.inverted?[c.len+c.pos-d.plotLeft-m-t/2,b.len+b.pos-d.plotTop-q.x-q.width/2,t]:
	[b.left-d.plotLeft+q.x+q.width/2,c.pos-d.plotTop+m+t/2,t])})},directTouch:!0,trackerGroups:["group","dataLabelsGroup"],drawGraph:n,getSymbol:n,crispCol:m.crispCol,drawPoints:m.drawPoints,drawTracker:m.drawTracker,getColumnMetrics:m.getColumnMetrics,animate:function(){return m.animate.apply(this,arguments)},polarArc:function(){return m.polarArc.apply(this,arguments)},pointAttribs:m.pointAttribs},{setState:m.pointClass.prototype.setState})})(x);(function(b){var r=b.each,v=b.isNumber,w=b.merge,n=b.pick,
	h=b.pInt,g=b.Series,m=b.seriesType,a=b.TrackerMixin;m("gauge","line",{dataLabels:{enabled:!0,defer:!1,y:15,borderRadius:3,crop:!1,verticalAlign:"top",zIndex:2,borderWidth:1,borderColor:"#cccccc"},dial:{},pivot:{},tooltip:{headerFormat:""},showInLegend:!1},{angular:!0,directTouch:!0,drawGraph:b.noop,fixedBox:!0,forceDL:!0,noSharedTooltip:!0,trackerGroups:["group","dataLabelsGroup"],translate:function(){var a=this.yAxis,b=this.options,f=a.center;this.generatePoints();r(this.points,function(c){var d=
	w(b.dial,c.dial),e=h(n(d.radius,80))*f[2]/200,k=h(n(d.baseLength,70))*e/100,l=h(n(d.rearLength,10))*e/100,q=d.baseWidth||3,g=d.topWidth||1,m=b.overshoot,t=a.startAngleRad+a.translate(c.y,null,null,null,!0);v(m)?(m=m/180*Math.PI,t=Math.max(a.startAngleRad-m,Math.min(a.endAngleRad+m,t))):!1===b.wrap&&(t=Math.max(a.startAngleRad,Math.min(a.endAngleRad,t)));t=180*t/Math.PI;c.shapeType="path";c.shapeArgs={d:d.path||["M",-l,-q/2,"L",k,-q/2,e,-g/2,e,g/2,k,q/2,-l,q/2,"z"],translateX:f[0],translateY:f[1],
	rotation:t};c.plotX=f[0];c.plotY=f[1]})},drawPoints:function(){var a=this,b=a.yAxis.center,f=a.pivot,e=a.options,d=e.pivot,p=a.chart.renderer;r(a.points,function(c){var b=c.graphic,d=c.shapeArgs,k=d.d,f=w(e.dial,c.dial);b?(b.animate(d),d.d=k):(c.graphic=p[c.shapeType](d).attr({rotation:d.rotation,zIndex:1}).addClass("highcharts-dial").add(a.group),c.graphic.attr({stroke:f.borderColor||"none","stroke-width":f.borderWidth||0,fill:f.backgroundColor||"#000000"}))});f?f.animate({translateX:b[0],translateY:b[1]}):
	(a.pivot=p.circle(0,0,n(d.radius,5)).attr({zIndex:2}).addClass("highcharts-pivot").translate(b[0],b[1]).add(a.group),a.pivot.attr({"stroke-width":d.borderWidth||0,stroke:d.borderColor||"#cccccc",fill:d.backgroundColor||"#000000"}))},animate:function(a){var c=this;a||(r(c.points,function(a){var b=a.graphic;b&&(b.attr({rotation:180*c.yAxis.startAngleRad/Math.PI}),b.animate({rotation:a.shapeArgs.rotation},c.options.animation))}),c.animate=null)},render:function(){this.group=this.plotGroup("group","series",
	this.visible?"visible":"hidden",this.options.zIndex,this.chart.seriesGroup);g.prototype.render.call(this);this.group.clip(this.chart.clipRect)},setData:function(a,b){g.prototype.setData.call(this,a,!1);this.processData();this.generatePoints();n(b,!0)&&this.chart.redraw()},drawTracker:a&&a.drawTrackerPoint},{setState:function(a){this.state=a}})})(x);(function(b){var r=b.each,v=b.noop,w=b.pick,n=b.seriesType,h=b.seriesTypes;n("boxplot","column",{threshold:null,tooltip:{pointFormat:'\x3cspan style\x3d"color:{point.color}"\x3e\u25cf\x3c/span\x3e \x3cb\x3e {series.name}\x3c/b\x3e\x3cbr/\x3eMaximum: {point.high}\x3cbr/\x3eUpper quartile: {point.q3}\x3cbr/\x3eMedian: {point.median}\x3cbr/\x3eLower quartile: {point.q1}\x3cbr/\x3eMinimum: {point.low}\x3cbr/\x3e'},
	whiskerLength:"50%",fillColor:"#ffffff",lineWidth:1,medianWidth:2,states:{hover:{brightness:-.3}},whiskerWidth:2},{pointArrayMap:["low","q1","median","q3","high"],toYData:function(b){return[b.low,b.q1,b.median,b.q3,b.high]},pointValKey:"high",pointAttribs:function(b){var h=this.options,a=b&&b.color||this.color;return{fill:b.fillColor||h.fillColor||a,stroke:h.lineColor||a,"stroke-width":h.lineWidth||0}},drawDataLabels:v,translate:function(){var b=this.yAxis,m=this.pointArrayMap;h.column.prototype.translate.apply(this);
	r(this.points,function(a){r(m,function(c){null!==a[c]&&(a[c+"Plot"]=b.translate(a[c],0,1,0,1))})})},drawPoints:function(){var b=this,h=b.options,a=b.chart.renderer,c,k,f,e,d,p,u=0,l,q,y,n,t=!1!==b.doQuartiles,v,A=b.options.whiskerLength;r(b.points,function(g){var m=g.graphic,r=m?"animate":"attr",J=g.shapeArgs,x={},C={},H={},I=g.color||b.color;void 0!==g.plotY&&(l=J.width,q=Math.floor(J.x),y=q+l,n=Math.round(l/2),c=Math.floor(t?g.q1Plot:g.lowPlot),k=Math.floor(t?g.q3Plot:g.lowPlot),f=Math.floor(g.highPlot),
	e=Math.floor(g.lowPlot),m||(g.graphic=m=a.g("point").add(b.group),g.stem=a.path().addClass("highcharts-boxplot-stem").add(m),A&&(g.whiskers=a.path().addClass("highcharts-boxplot-whisker").add(m)),t&&(g.box=a.path(void 0).addClass("highcharts-boxplot-box").add(m)),g.medianShape=a.path(void 0).addClass("highcharts-boxplot-median").add(m)),x.stroke=g.stemColor||h.stemColor||I,x["stroke-width"]=w(g.stemWidth,h.stemWidth,h.lineWidth),x.dashstyle=g.stemDashStyle||h.stemDashStyle,g.stem.attr(x),A&&(C.stroke=
	g.whiskerColor||h.whiskerColor||I,C["stroke-width"]=w(g.whiskerWidth,h.whiskerWidth,h.lineWidth),g.whiskers.attr(C)),t&&(m=b.pointAttribs(g),g.box.attr(m)),H.stroke=g.medianColor||h.medianColor||I,H["stroke-width"]=w(g.medianWidth,h.medianWidth,h.lineWidth),g.medianShape.attr(H),p=g.stem.strokeWidth()%2/2,u=q+n+p,g.stem[r]({d:["M",u,k,"L",u,f,"M",u,c,"L",u,e]}),t&&(p=g.box.strokeWidth()%2/2,c=Math.floor(c)+p,k=Math.floor(k)+p,q+=p,y+=p,g.box[r]({d:["M",q,k,"L",q,c,"L",y,c,"L",y,k,"L",q,k,"z"]})),
	A&&(p=g.whiskers.strokeWidth()%2/2,f+=p,e+=p,v=/%$/.test(A)?n*parseFloat(A)/100:A/2,g.whiskers[r]({d:["M",u-v,f,"L",u+v,f,"M",u-v,e,"L",u+v,e]})),d=Math.round(g.medianPlot),p=g.medianShape.strokeWidth()%2/2,d+=p,g.medianShape[r]({d:["M",q,d,"L",y,d]}))})},setStackedPoints:v})})(x);(function(b){var r=b.each,v=b.noop,w=b.seriesType,n=b.seriesTypes;w("errorbar","boxplot",{color:"#000000",grouping:!1,linkedTo:":previous",tooltip:{pointFormat:'\x3cspan style\x3d"color:{point.color}"\x3e\u25cf\x3c/span\x3e {series.name}: \x3cb\x3e{point.low}\x3c/b\x3e - \x3cb\x3e{point.high}\x3c/b\x3e\x3cbr/\x3e'},
	whiskerWidth:null},{type:"errorbar",pointArrayMap:["low","high"],toYData:function(b){return[b.low,b.high]},pointValKey:"high",doQuartiles:!1,drawDataLabels:n.arearange?function(){var b=this.pointValKey;n.arearange.prototype.drawDataLabels.call(this);r(this.data,function(g){g.y=g[b]})}:v,getColumnMetrics:function(){return this.linkedParent&&this.linkedParent.columnMetrics||n.column.prototype.getColumnMetrics.call(this)}})})(x);(function(b){var r=b.correctFloat,v=b.isNumber,w=b.pick,n=b.Point,h=b.Series,
	g=b.seriesType,m=b.seriesTypes;g("waterfall","column",{dataLabels:{inside:!0},lineWidth:1,lineColor:"#333333",dashStyle:"dot",borderColor:"#333333",states:{hover:{lineWidthPlus:0}}},{pointValKey:"y",translate:function(){var a=this.options,c=this.yAxis,b,f,e,d,p,g,l,q,h,n,t=w(a.minPointLength,5),v=t/2,x=a.threshold,D=a.stacking,z;m.column.prototype.translate.apply(this);q=h=x;f=this.points;b=0;for(a=f.length;b<a;b++)e=f[b],l=this.processedYData[b],d=e.shapeArgs,p=D&&c.stacks[(this.negStacks&&l<x?"-":
	"")+this.stackKey],z=this.getStackIndicator(z,e.x,this.index),n=p?p[e.x].points[z.key]:[0,l],e.isSum?e.y=r(l):e.isIntermediateSum&&(e.y=r(l-h)),g=Math.max(q,q+e.y)+n[0],d.y=c.translate(g,0,1,0,1),e.isSum?(d.y=c.translate(n[1],0,1,0,1),d.height=Math.min(c.translate(n[0],0,1,0,1),c.len)-d.y):e.isIntermediateSum?(d.y=c.translate(n[1],0,1,0,1),d.height=Math.min(c.translate(h,0,1,0,1),c.len)-d.y,h=n[1]):(d.height=0<l?c.translate(q,0,1,0,1)-d.y:c.translate(q,0,1,0,1)-c.translate(q-l,0,1,0,1),q+=p&&p[e.x]?
	p[e.x].total:l),0>d.height&&(d.y+=d.height,d.height*=-1),e.plotY=d.y=Math.round(d.y)-this.borderWidth%2/2,d.height=Math.max(Math.round(d.height),.001),e.yBottom=d.y+d.height,d.height<=t&&!e.isNull?(d.height=t,d.y-=v,e.plotY=d.y,e.minPointLengthOffset=0>e.y?-v:v):e.minPointLengthOffset=0,d=e.plotY+(e.negative?d.height:0),this.chart.inverted?e.tooltipPos[0]=c.len-d:e.tooltipPos[1]=d},processData:function(a){var b=this.yData,k=this.options.data,f,e=b.length,d,p,g,l,q,n;p=d=g=l=this.options.threshold||
	0;for(n=0;n<e;n++)q=b[n],f=k&&k[n]?k[n]:{},"sum"===q||f.isSum?b[n]=r(p):"intermediateSum"===q||f.isIntermediateSum?b[n]=r(d):(p+=q,d+=q),g=Math.min(p,g),l=Math.max(p,l);h.prototype.processData.call(this,a);this.options.stacking||(this.dataMin=g,this.dataMax=l)},toYData:function(a){return a.isSum?0===a.x?null:"sum":a.isIntermediateSum?0===a.x?null:"intermediateSum":a.y},pointAttribs:function(a,b){var c=this.options.upColor;c&&!a.options.color&&(a.color=0<a.y?c:null);a=m.column.prototype.pointAttribs.call(this,
	a,b);delete a.dashstyle;return a},getGraphPath:function(){return["M",0,0]},getCrispPath:function(){var a=this.data,b=a.length,k=this.graph.strokeWidth()+this.borderWidth,k=Math.round(k)%2/2,f=this.yAxis.reversed,e=[],d,p,g;for(g=1;g<b;g++){p=a[g].shapeArgs;d=a[g-1].shapeArgs;p=["M",d.x+d.width,d.y+a[g-1].minPointLengthOffset+k,"L",p.x,d.y+a[g-1].minPointLengthOffset+k];if(0>a[g-1].y&&!f||0<a[g-1].y&&f)p[2]+=d.height,p[5]+=d.height;e=e.concat(p)}return e},drawGraph:function(){h.prototype.drawGraph.call(this);
	this.graph.attr({d:this.getCrispPath()})},setStackedPoints:function(){var a=this.options,b,k;h.prototype.setStackedPoints.apply(this,arguments);b=this.stackedYData?this.stackedYData.length:0;for(k=1;k<b;k++)a.data[k].isSum||a.data[k].isIntermediateSum||(this.stackedYData[k]+=this.stackedYData[k-1])},getExtremes:function(){if(this.options.stacking)return h.prototype.getExtremes.apply(this,arguments)}},{getClassName:function(){var a=n.prototype.getClassName.call(this);this.isSum?a+=" highcharts-sum":
	this.isIntermediateSum&&(a+=" highcharts-intermediate-sum");return a},isValid:function(){return v(this.y,!0)||this.isSum||this.isIntermediateSum}})})(x);(function(b){var r=b.Series,v=b.seriesType,w=b.seriesTypes;v("polygon","scatter",{marker:{enabled:!1,states:{hover:{enabled:!1}}},stickyTracking:!1,tooltip:{followPointer:!0,pointFormat:""},trackByArea:!0},{type:"polygon",getGraphPath:function(){for(var b=r.prototype.getGraphPath.call(this),h=b.length+1;h--;)(h===b.length||"M"===b[h])&&0<h&&b.splice(h,
	0,"z");return this.areaPath=b},drawGraph:function(){this.options.fillColor=this.color;w.area.prototype.drawGraph.call(this)},drawLegendSymbol:b.LegendSymbolMixin.drawRectangle,drawTracker:r.prototype.drawTracker,setStackedPoints:b.noop})})(x);(function(b){var r=b.arrayMax,v=b.arrayMin,w=b.Axis,n=b.color,h=b.each,g=b.isNumber,m=b.noop,a=b.pick,c=b.pInt,k=b.Point,f=b.Series,e=b.seriesType,d=b.seriesTypes;e("bubble","scatter",{dataLabels:{formatter:function(){return this.point.z},inside:!0,verticalAlign:"middle"},
	marker:{lineColor:null,lineWidth:1,radius:null,states:{hover:{radiusPlus:0}},symbol:"circle"},minSize:8,maxSize:"20%",softThreshold:!1,states:{hover:{halo:{size:5}}},tooltip:{pointFormat:"({point.x}, {point.y}), Size: {point.z}"},turboThreshold:0,zThreshold:0,zoneAxis:"z"},{pointArrayMap:["y","z"],parallelArrays:["x","y","z"],trackerGroups:["group","dataLabelsGroup"],specialGroup:"group",bubblePadding:!0,zoneAxis:"z",directTouch:!0,pointAttribs:function(b,c){var d=a(this.options.marker.fillOpacity,
	.5);b=f.prototype.pointAttribs.call(this,b,c);1!==d&&(b.fill=n(b.fill).setOpacity(d).get("rgba"));return b},getRadii:function(a,b,c,d){var e,k,f,g=this.zData,p=[],l=this.options,q="width"!==l.sizeBy,h=l.zThreshold,u=b-a;k=0;for(e=g.length;k<e;k++)f=g[k],l.sizeByAbsoluteValue&&null!==f&&(f=Math.abs(f-h),b=Math.max(b-h,Math.abs(a-h)),a=0),null===f?f=null:f<a?f=c/2-1:(f=0<u?(f-a)/u:.5,q&&0<=f&&(f=Math.sqrt(f)),f=Math.ceil(c+f*(d-c))/2),p.push(f);this.radii=p},animate:function(a){var b=this.options.animation;
	a||(h(this.points,function(a){var c=a.graphic,d;c&&c.width&&(d={x:c.x,y:c.y,width:c.width,height:c.height},c.attr({x:a.plotX,y:a.plotY,width:1,height:1}),c.animate(d,b))}),this.animate=null)},translate:function(){var a,c=this.data,e,f,k=this.radii;d.scatter.prototype.translate.call(this);for(a=c.length;a--;)e=c[a],f=k?k[a]:0,g(f)&&f>=this.minPxSize/2?(e.marker=b.extend(e.marker,{radius:f,width:2*f,height:2*f}),e.dlBox={x:e.plotX-f,y:e.plotY-f,width:2*f,height:2*f}):e.shapeArgs=e.plotY=e.dlBox=void 0},
	alignDataLabel:d.column.prototype.alignDataLabel,buildKDTree:m,applyZones:m},{haloPath:function(a){return k.prototype.haloPath.call(this,0===a?0:(this.marker?this.marker.radius||0:0)+a)},ttBelow:!1});w.prototype.beforePadding=function(){var b=this,d=this.len,e=this.chart,f=0,k=d,n=this.isXAxis,m=n?"xData":"yData",w=this.min,x={},D=Math.min(e.plotWidth,e.plotHeight),z=Number.MAX_VALUE,E=-Number.MAX_VALUE,F=this.max-w,B=d/F,G=[];h(this.series,function(d){var f=d.options;!d.bubblePadding||!d.visible&&
	e.options.chart.ignoreHiddenSeries||(b.allowZoomOutside=!0,G.push(d),n&&(h(["minSize","maxSize"],function(a){var b=f[a],d=/%$/.test(b),b=c(b);x[a]=d?D*b/100:b}),d.minPxSize=x.minSize,d.maxPxSize=Math.max(x.maxSize,x.minSize),d=d.zData,d.length&&(z=a(f.zMin,Math.min(z,Math.max(v(d),!1===f.displayNegative?f.zThreshold:-Number.MAX_VALUE))),E=a(f.zMax,Math.max(E,r(d))))))});h(G,function(a){var c=a[m],d=c.length,e;n&&a.getRadii(z,E,a.minPxSize,a.maxPxSize);if(0<F)for(;d--;)g(c[d])&&b.dataMin<=c[d]&&c[d]<=
	b.dataMax&&(e=a.radii[d],f=Math.min((c[d]-w)*B-e,f),k=Math.max((c[d]-w)*B+e,k))});G.length&&0<F&&!this.isLog&&(k-=d,B*=(d+f-k)/d,h([["min","userMin",f],["max","userMax",k]],function(c){void 0===a(b.options[c[0]],b[c[1]])&&(b[c[0]]+=c[2]/B)}))}})(x);(function(b){function r(a,b){var c=this.chart,f=this.options.animation,e=this.group,d=this.markerGroup,g=this.xAxis.center,h=c.plotLeft,l=c.plotTop;c.polar?c.renderer.isSVG&&(!0===f&&(f={}),b?(a={translateX:g[0]+h,translateY:g[1]+l,scaleX:.001,scaleY:.001},
	e.attr(a),d&&d.attr(a)):(a={translateX:h,translateY:l,scaleX:1,scaleY:1},e.animate(a,f),d&&d.animate(a,f),this.animate=null)):a.call(this,b)}var v=b.each,w=b.pick,n=b.seriesTypes,h=b.wrap,g=b.Series.prototype,m=b.Pointer.prototype;g.searchPointByAngle=function(a){var b=this.chart,k=this.xAxis.pane.center;return this.searchKDTree({clientX:180+-180/Math.PI*Math.atan2(a.chartX-k[0]-b.plotLeft,a.chartY-k[1]-b.plotTop)})};g.getConnectors=function(a,b,k,f){var c,d,g,h,l,n,m,r;d=f?1:0;c=0<=b&&b<=a.length-
	1?b:0>b?a.length-1+b:0;b=0>c-1?a.length-(1+d):c-1;d=c+1>a.length-1?d:c+1;g=a[b];d=a[d];h=g.plotX;g=g.plotY;l=d.plotX;n=d.plotY;d=a[c].plotX;c=a[c].plotY;h=(1.5*d+h)/2.5;g=(1.5*c+g)/2.5;l=(1.5*d+l)/2.5;m=(1.5*c+n)/2.5;n=Math.sqrt(Math.pow(h-d,2)+Math.pow(g-c,2));r=Math.sqrt(Math.pow(l-d,2)+Math.pow(m-c,2));h=Math.atan2(g-c,h-d);m=Math.PI/2+(h+Math.atan2(m-c,l-d))/2;Math.abs(h-m)>Math.PI/2&&(m-=Math.PI);h=d+Math.cos(m)*n;g=c+Math.sin(m)*n;l=d+Math.cos(Math.PI+m)*r;m=c+Math.sin(Math.PI+m)*r;d={rightContX:l,
	rightContY:m,leftContX:h,leftContY:g,plotX:d,plotY:c};k&&(d.prevPointCont=this.getConnectors(a,b,!1,f));return d};h(g,"buildKDTree",function(a){this.chart.polar&&(this.kdByAngle?this.searchPoint=this.searchPointByAngle:this.options.findNearestPointBy="xy");a.apply(this)});g.toXY=function(a){var b,g=this.chart,f=a.plotX;b=a.plotY;a.rectPlotX=f;a.rectPlotY=b;b=this.xAxis.postTranslate(a.plotX,this.yAxis.len-b);a.plotX=a.polarPlotX=b.x-g.plotLeft;a.plotY=a.polarPlotY=b.y-g.plotTop;this.kdByAngle?(g=
	(f/Math.PI*180+this.xAxis.pane.options.startAngle)%360,0>g&&(g+=360),a.clientX=g):a.clientX=a.plotX};n.spline&&(h(n.spline.prototype,"getPointSpline",function(a,b,g,f){this.chart.polar?f?(a=this.getConnectors(b,f,!0,this.connectEnds),a=["C",a.prevPointCont.rightContX,a.prevPointCont.rightContY,a.leftContX,a.leftContY,a.plotX,a.plotY]):a=["M",g.plotX,g.plotY]:a=a.call(this,b,g,f);return a}),n.areasplinerange&&(n.areasplinerange.prototype.getPointSpline=n.spline.prototype.getPointSpline));h(g,"translate",
	function(a){var b=this.chart;a.call(this);if(b.polar&&(this.kdByAngle=b.tooltip&&b.tooltip.shared,!this.preventPostTranslate))for(a=this.points,b=a.length;b--;)this.toXY(a[b])});h(g,"getGraphPath",function(a,b){var c=this,f,e,d;if(this.chart.polar){b=b||this.points;for(f=0;f<b.length;f++)if(!b[f].isNull){e=f;break}!1!==this.options.connectEnds&&void 0!==e&&(this.connectEnds=!0,b.splice(b.length,0,b[e]),d=!0);v(b,function(a){void 0===a.polarPlotY&&c.toXY(a)})}f=a.apply(this,[].slice.call(arguments,
	1));d&&b.pop();return f});h(g,"animate",r);n.column&&(n=n.column.prototype,n.polarArc=function(a,b,g,f){var c=this.xAxis.center,d=this.yAxis.len;return this.chart.renderer.symbols.arc(c[0],c[1],d-b,null,{start:g,end:f,innerR:d-w(a,d)})},h(n,"animate",r),h(n,"translate",function(a){var b=this.xAxis,g=b.startAngleRad,f,e,d;this.preventPostTranslate=!0;a.call(this);if(b.isRadial)for(f=this.points,d=f.length;d--;)e=f[d],a=e.barX+g,e.shapeType="path",e.shapeArgs={d:this.polarArc(e.yBottom,e.plotY,a,a+
	e.pointWidth)},this.toXY(e),e.tooltipPos=[e.plotX,e.plotY],e.ttBelow=e.plotY>b.center[1]}),h(n,"alignDataLabel",function(a,b,k,f,e,d){this.chart.polar?(a=b.rectPlotX/Math.PI*180,null===f.align&&(f.align=20<a&&160>a?"left":200<a&&340>a?"right":"center"),null===f.verticalAlign&&(f.verticalAlign=45>a||315<a?"bottom":135<a&&225>a?"top":"middle"),g.alignDataLabel.call(this,b,k,f,e,d)):a.call(this,b,k,f,e,d)}));h(m,"getCoordinates",function(a,b){var c=this.chart,f={xAxis:[],yAxis:[]};c.polar?v(c.axes,function(a){var d=
	a.isXAxis,e=a.center,g=b.chartX-e[0]-c.plotLeft,e=b.chartY-e[1]-c.plotTop;f[d?"xAxis":"yAxis"].push({axis:a,value:a.translate(d?Math.PI-Math.atan2(g,e):Math.sqrt(Math.pow(g,2)+Math.pow(e,2)),!0)})}):f=a.call(this,b);return f});h(b.Chart.prototype,"getAxes",function(a){this.pane||(this.pane=[]);v(b.splat(this.options.pane),function(a){new b.Pane(a,this)},this);a.call(this)});h(b.Chart.prototype,"drawChartBox",function(a){a.call(this);v(this.pane,function(a){a.render()})});h(b.Chart.prototype,"get",
	function(a,c){return b.find(this.pane,function(a){return a.options.id===c})||a.call(this,c)})})(x)});


/***/ }),
/* 904 */
/***/ (function(module, exports) {

	/*
	  Highcharts JS v5.0.14 (2017-07-28)
	 Solid angular gauge module
	
	 (c) 2010-2017 Torstein Honsi
	
	 License: www.highcharts.com/license
	*/
	(function(l){"object"===typeof module&&module.exports?module.exports=l:l(Highcharts)})(function(l){(function(e){var l=e.pInt,u=e.pick,m=e.each,r=e.isNumber,w=e.wrap,v;w(e.Renderer.prototype.symbols,"arc",function(a,f,d,c,e,b){a=a(f,d,c,e,b);b.rounded&&(c=((b.r||c)-b.innerR)/2,b=["A",c,c,0,1,1,a[12],a[13]],a.splice.apply(a,[a.length-1,0].concat(["A",c,c,0,1,1,a[1],a[2]])),a.splice.apply(a,[11,3].concat(b)));return a});v={initDataClasses:function(a){var f=this.chart,d,c=0,t=this.options;this.dataClasses=
	d=[];m(a.dataClasses,function(b,h){b=e.merge(b);d.push(b);b.color||("category"===t.dataClassColor?(h=f.options.colors,b.color=h[c++],c===h.length&&(c=0)):b.color=e.color(t.minColor).tweenTo(e.color(t.maxColor),h/(a.dataClasses.length-1)))})},initStops:function(a){this.stops=a.stops||[[0,this.options.minColor],[1,this.options.maxColor]];m(this.stops,function(a){a.color=e.color(a[1])})},toColor:function(a,f){var d=this.stops,c,e,b=this.dataClasses,h,g;if(b)for(g=b.length;g--;){if(h=b[g],c=h.from,d=
	h.to,(void 0===c||a>=c)&&(void 0===d||a<=d)){e=h.color;f&&(f.dataClass=g);break}}else{this.isLog&&(a=this.val2lin(a));a=1-(this.max-a)/(this.max-this.min);for(g=d.length;g--&&!(a>d[g][0]););c=d[g]||d[g+1];d=d[g+1]||c;a=1-(d[0]-a)/(d[0]-c[0]||1);e=c.color.tweenTo(d.color,a)}return e}};e.seriesType("solidgauge","gauge",{colorByPoint:!0},{translate:function(){var a=this.yAxis;e.extend(a,v);!a.dataClasses&&a.options.dataClasses&&a.initDataClasses(a.options);a.initStops(a.options);e.seriesTypes.gauge.prototype.translate.call(this)},
	drawPoints:function(){var a=this,f=a.yAxis,d=f.center,c=a.options,t=a.chart.renderer,b=c.overshoot,h=r(b)?b/180*Math.PI:0,g;r(c.threshold)&&(g=f.startAngleRad+f.translate(c.threshold,null,null,null,!0));this.thresholdAngleRad=u(g,f.startAngleRad);m(a.points,function(b){var g=b.graphic,k=f.startAngleRad+f.translate(b.y,null,null,null,!0),m=l(u(b.options.radius,c.radius,100))*d[2]/200,n=l(u(b.options.innerRadius,c.innerRadius,60))*d[2]/200,p=f.toColor(b.y,b),q=Math.min(f.startAngleRad,f.endAngleRad),
	r=Math.max(f.startAngleRad,f.endAngleRad);"none"===p&&(p=b.color||a.color||"none");"none"!==p&&(b.color=p);k=Math.max(q-h,Math.min(r+h,k));!1===c.wrap&&(k=Math.max(q,Math.min(r,k)));q=Math.min(k,a.thresholdAngleRad);k=Math.max(k,a.thresholdAngleRad);k-q>2*Math.PI&&(k=q+2*Math.PI);b.shapeArgs=n={x:d[0],y:d[1],r:m,innerR:n,start:q,end:k,rounded:c.rounded};b.startR=m;g?(b=n.d,g.animate(e.extend({fill:p},n)),b&&(n.d=b)):(b.graphic=t.arc(n).addClass(b.getClassName(),!0).attr({fill:p,"sweep-flag":0}).add(a.group),
	"square"!==c.linecap&&b.graphic.attr({"stroke-linecap":"round","stroke-linejoin":"round"}),b.graphic.attr({stroke:c.borderColor||"none","stroke-width":c.borderWidth||0}))})},animate:function(a){a||(this.startAngleRad=this.thresholdAngleRad,e.seriesTypes.pie.prototype.animate.call(this,a))}})})(l)});


/***/ }),
/* 905 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 contenido\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n        <div class=\"carousel slide\" id=\"carousel\" data-interval=\"false\">\n            <div class=\"carousel-inner\">\n                <div id=\"principalSucursales\" class=\"item active\">\n                    <h3>Sucursales</h3>\n                    <div class=\"recuadros-container\">\n                        <div *ngFor=\"let sucursal of sucursales\" class=\"recuadroExterno\">\n                            <div class=\"recuadro\" (click)=\"cambiarSlide(sucursal._id)\">\n                                <div class=\"datos-texto\">\n                                    <h3>{{sucursal.descripcion}}</h3>\n                                    <p>{{sucursal.empresa.descripcion}}</p>\n                                </div>\n                                <div class=\"datos-grafico\">\n                                    <svg *ngIf=\"!sucursal.alarmaActiva\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"\n                                         viewBox=\"0 0 130.2 130.2\">\n                                        <circle class=\"path circle\" fill=\"none\" stroke=\"#73AF55\" stroke-width=\"6\"\n                                                stroke-miterlimit=\"10\" cx=\"65.1\" cy=\"65.1\" r=\"62.1\"/>\n                                        <polyline class=\"path check\" fill=\"none\" stroke=\"#73AF55\" stroke-width=\"6\"\n                                                  stroke-linecap=\"round\" stroke-miterlimit=\"10\"\n                                                  points=\"100.2,40.2 51.5,88.8 29.8,67.5 \"/>\n                                    </svg>\n                                    <svg *ngIf=\"sucursal.alarmaActiva && sucursal.color && sucursal.color=='Amarillo'\"\n                                         version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 130.2 130.2\">\n                                        <circle class=\"path circle\" fill=\"none\" stroke=\"#FBD749\" stroke-width=\"6\"\n                                                stroke-miterlimit=\"10\" cx=\"65.1\" cy=\"65.1\" r=\"62.1\"/>\n                                        <line class=\"path line\" fill=\"none\" stroke=\"#FBD749\" stroke-width=\"6\"\n                                              stroke-linecap=\"round\" stroke-miterlimit=\"10\" x1=\"34.4\" y1=\"37.9\"\n                                              x2=\"95.8\" y2=\"92.3\"/>\n                                        <line class=\"path line\" fill=\"none\" stroke=\"#FBD749\" stroke-width=\"6\"\n                                              stroke-linecap=\"round\" stroke-miterlimit=\"10\" x1=\"95.8\" y1=\"38\" x2=\"34.4\"\n                                              y2=\"92.2\"/>\n                                    </svg>\n                                    <svg *ngIf=\"sucursal.alarmaActiva && (!sucursal.color || sucursal.color=='Rojo')\"\n                                         version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 130.2 130.2\">\n                                        <circle class=\"path circle\" fill=\"none\" stroke=\"#cd3b48\" stroke-width=\"6\"\n                                                stroke-miterlimit=\"10\" cx=\"65.1\" cy=\"65.1\" r=\"62.1\"/>\n                                        <line class=\"path line\" fill=\"none\" stroke=\"#cd3b48\" stroke-width=\"6\"\n                                              stroke-linecap=\"round\" stroke-miterlimit=\"10\" x1=\"34.4\" y1=\"37.9\"\n                                              x2=\"95.8\" y2=\"92.3\"/>\n                                        <line class=\"path line\" fill=\"none\" stroke=\"#cd3b48\" stroke-width=\"6\"\n                                              stroke-linecap=\"round\" stroke-miterlimit=\"10\" x1=\"95.8\" y1=\"38\" x2=\"34.4\"\n                                              y2=\"92.2\"/>\n                                    </svg>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div id={{sucursal._id}} class=\"item\" *ngFor=\"let sucursal of sucursales\">\n                    <h3>{{\"Sucursal: \"+sucursal.descripcion}}</h3>\n                    <div class=\"recuadros-container\">\n                        <div *ngFor=\"let ubicacion of sucursal.ubicaciones\"\n                             class=\"recuadroExterno\">\n                            <div class=\"recuadro\" (click)=\"cambiarSlide(ubicacion._id)\">\n                                <div class=\"datos-texto\">\n                                    <h4>{{ubicacion.descripcion}}</h4>\n                                    <small>{{ubicacion.area}}</small>\n                                </div>\n                                <div class=\"datos-grafico\">\n                                    <svg *ngIf=\"!ubicacion.alarmaActiva\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"\n                                         viewBox=\"0 0 130.2 130.2\">\n                                        <circle class=\"path circle\" fill=\"none\" stroke=\"#73AF55\" stroke-width=\"6\"\n                                                stroke-miterlimit=\"10\" cx=\"65.1\" cy=\"65.1\" r=\"62.1\"/>\n                                        <polyline class=\"path check\" fill=\"none\" stroke=\"#73AF55\" stroke-width=\"6\"\n                                                  stroke-linecap=\"round\" stroke-miterlimit=\"10\"\n                                                  points=\"100.2,40.2 51.5,88.8 29.8,67.5 \"/>\n                                    </svg>\n                                    <svg *ngIf=\"ubicacion.alarmaActiva && ubicacion.color && ubicacion.color=='Amarillo'\"\n                                         version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 130.2 130.2\">\n                                        <circle class=\"path circle\" fill=\"none\" stroke=\"#FBD749\" stroke-width=\"6\"\n                                                stroke-miterlimit=\"10\" cx=\"65.1\" cy=\"65.1\" r=\"62.1\"/>\n                                        <line class=\"path line\" fill=\"none\" stroke=\"#FBD749\" stroke-width=\"6\"\n                                              stroke-linecap=\"round\" stroke-miterlimit=\"10\" x1=\"34.4\" y1=\"37.9\"\n                                              x2=\"95.8\" y2=\"92.3\"/>\n                                        <line class=\"path line\" fill=\"none\" stroke=\"#FBD749\" stroke-width=\"6\"\n                                              stroke-linecap=\"round\" stroke-miterlimit=\"10\" x1=\"95.8\" y1=\"38\" x2=\"34.4\"\n                                              y2=\"92.2\"/>\n                                    </svg>\n                                    <svg *ngIf=\"ubicacion.alarmaActiva && (!ubicacion.color || ubicacion.color=='Rojo')\"\n                                         version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 130.2 130.2\">\n                                        <circle class=\"path circle\" fill=\"none\" stroke=\"#cd3b48\" stroke-width=\"6\"\n                                                stroke-miterlimit=\"10\" cx=\"65.1\" cy=\"65.1\" r=\"62.1\"/>\n                                        <line class=\"path line\" fill=\"none\" stroke=\"#cd3b48\" stroke-width=\"6\"\n                                              stroke-linecap=\"round\" stroke-miterlimit=\"10\" x1=\"34.4\" y1=\"37.9\"\n                                              x2=\"95.8\" y2=\"92.3\"/>\n                                        <line class=\"path line\" fill=\"none\" stroke=\"#cd3b48\" stroke-width=\"6\"\n                                              stroke-linecap=\"round\" stroke-miterlimit=\"10\" x1=\"95.8\" y1=\"38\" x2=\"34.4\"\n                                              y2=\"92.2\"/>\n                                    </svg>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"recuadroExterno\">\n                            <div class=\"recuadro\" (click)=\"cambiarSlide(principal)\">\n                                <div class=\"datos-texto\">\n                                    <p>Volver</p>\n                                    <h4>sucursales</h4>\n                                </div>\n                                <div class=\"datos-grafico\">\n                                <span class=\"glyphicon glyphicon-arrow-left simbolo\" aria-hidden=\"true\"\n                                      style=\"color: white;\"></span>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n\n\n                <template ngFor let-sucursal=\"$implicit\" [ngForOf]=\"sucursales\" let-index=\"index\">\n                    <div id={{ubicacion._id}} class=\"item\" *ngFor=\"let ubicacion of sucursal.ubicaciones\">\n                        <h3>{{\"Ubicación: \"+ubicacion.descripcion}}</h3>\n                        <div class=\"recuadros-container\">\n                            <div *ngFor=\"let nodo of ubicacion.nodos\"\n                                 class=\"recuadroExterno\">\n                                <div class=\"recuadro\" (click)=\"cambiarSlide(nodo._id)\">\n                                    <div class=\"datos-texto\">\n                                        <h4>{{nodo.nombre}}</h4>\n                                        <small>{{nodo.etiqueta}}</small>\n                                        <small>{{nodo.nroSerie}}</small>\n                                    </div>\n                                    <div class=\"datos-grafico\">\n                                        <svg *ngIf=\"!nodo.alarmaActiva\" version=\"1.1\"\n                                             xmlns=\"http://www.w3.org/2000/svg\"\n                                             viewBox=\"0 0 130.2 130.2\">\n                                            <circle class=\"path circle\" fill=\"none\" stroke=\"#73AF55\" stroke-width=\"6\"\n                                                    stroke-miterlimit=\"10\" cx=\"65.1\" cy=\"65.1\" r=\"62.1\"/>\n                                            <polyline class=\"path check\" fill=\"none\" stroke=\"#73AF55\" stroke-width=\"6\"\n                                                      stroke-linecap=\"round\" stroke-miterlimit=\"10\"\n                                                      points=\"100.2,40.2 51.5,88.8 29.8,67.5 \"/>\n                                        </svg>\n                                        <svg *ngIf=\"nodo.alarmaActiva && nodo.color && nodo.color=='Amarillo'\"\n                                             version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 130.2 130.2\">\n                                            <circle class=\"path circle\" fill=\"none\" stroke=\"#FBD749\" stroke-width=\"6\"\n                                                    stroke-miterlimit=\"10\" cx=\"65.1\" cy=\"65.1\" r=\"62.1\"/>\n                                            <line class=\"path line\" fill=\"none\" stroke=\"#FBD749\" stroke-width=\"6\"\n                                                  stroke-linecap=\"round\" stroke-miterlimit=\"10\" x1=\"34.4\" y1=\"37.9\"\n                                                  x2=\"95.8\" y2=\"92.3\"/>\n                                            <line class=\"path line\" fill=\"none\" stroke=\"#FBD749\" stroke-width=\"6\"\n                                                  stroke-linecap=\"round\" stroke-miterlimit=\"10\" x1=\"95.8\" y1=\"38\"\n                                                  x2=\"34.4\"\n                                                  y2=\"92.2\"/>\n                                        </svg>\n                                        <svg *ngIf=\"nodo.alarmaActiva && (!nodo.color || nodo.color=='Rojo')\"\n                                             version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 130.2 130.2\">\n                                            <circle class=\"path circle\" fill=\"none\" stroke=\"#cd3b48\" stroke-width=\"6\"\n                                                    stroke-miterlimit=\"10\" cx=\"65.1\" cy=\"65.1\" r=\"62.1\"/>\n                                            <line class=\"path line\" fill=\"none\" stroke=\"#cd3b48\" stroke-width=\"6\"\n                                                  stroke-linecap=\"round\" stroke-miterlimit=\"10\" x1=\"34.4\" y1=\"37.9\"\n                                                  x2=\"95.8\" y2=\"92.3\"/>\n                                            <line class=\"path line\" fill=\"none\" stroke=\"#cd3b48\" stroke-width=\"6\"\n                                                  stroke-linecap=\"round\" stroke-miterlimit=\"10\" x1=\"95.8\" y1=\"38\"\n                                                  x2=\"34.4\"\n                                                  y2=\"92.2\"/>\n                                        </svg>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"recuadroExterno\">\n                                <div class=\"recuadro\" (click)=\"cambiarSlide(sucursal._id)\">\n                                    <div class=\"datos-texto\">\n                                        <p>Volver a </p>\n                                        <h4>{{sucursal.descripcion}}</h4>\n                                    </div>\n                                    <div class=\"datos-grafico\">\n                                    <span class=\"glyphicon glyphicon-arrow-left simbolo\" aria-hidden=\"true\"\n                                          style=\"color: white;\"></span>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </template>\n                <template ngFor let-sucursal=\"$implicit\" [ngForOf]=\"sucursales\" let-index=\"index\">\n                    <template ngFor let-ubicacion=\"$implicit\" [ngForOf]=\"sucursal.ubicaciones\" let-index=\"index2\">\n                        <div id={{nodo._id}} class=\"item\" *ngFor=\"let nodo of ubicacion.nodos\">\n                            <h3>{{\"Nodo: \"+nodo.nombre}}</h3>\n                            <div class=\"recuadros-container\">\n                                <template ngFor let-sensor=\"$implicit\" [ngForOf]=\"nodo.sensores_id\">\n                                    <div *ngIf=\"sensor.posicionString!=9 || (sensor.posicionString==9 && (usuarioConectado.rol == 'Administrador' || usuarioConectado.rol == 'Tecnico'))\"\n                                         class=\"recuadroExterno\">\n                                        <div class=\"recuadro\">\n                                            <div class=\"datos-texto sensor\">\n                                                <h4>{{sensor.etiqueta}}</h4>\n                                                <small>{{sensor.tipo_id.descripcion}}</small>\n\n                                            </div>\n                                            <div class=\"datos-grafico sensor\">\n                                                <div id={{sensor._id}} style=\" float: left\"></div>\n                                            </div>\n                                            <div class=\"ultimaActualizacion\">\n                                                <small *ngIf=\"sensor.fechaUltimaMedicion!=null\">\n                                                    {{\"Última Actualización: \"+(sensor.fechaUltimaMedicion | dateTimeZone: 'DD/MM/yyyy HH:mm' : (sucursal.husoHorario_id ? sucursal.husoHorario_id.offset : \"-03:00\"))}}\n                                                </small>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </template>\n                                <div class=\"recuadroExterno\">\n                                    <div class=\"recuadro sensor\" (click)=\"cambiarSlide(ubicacion._id)\">\n                                        <div class=\"datos-texto\">\n                                            <p>Volver a </p>\n                                            <h4>{{ubicacion.descripcion}}</h4>\n                                        </div>\n                                        <div class=\"datos-grafico\">\n                                        <span class=\"glyphicon glyphicon-arrow-left simbolo\" aria-hidden=\"true\"\n                                              style=\"color: white;\"></span>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </template>\n                </template>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 906 */
/***/ (function(module, exports) {

	module.exports = ".recuadros-container {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n\n}\n\n.recuadro {\n    text-align: center;\n    border: 1px solid rgba(59, 66, 74, .5);\n    background-color: #273135;\n    border-radius: 10px;\n    padding: 10px;\n    margin: 10px;\n    cursor: pointer;\n    display: flex;\n    width: 245px;\n    min-height: 133px;\n    flex-wrap: wrap;\n}\n\n.recuadroExterno {\n    padding: 0px;\n    margin: 0px;\n}\n\n.recuadro.sensor {\n    min-height: 138px;\n}\n\n@media (max-width: 769px) {\n\n    .recuadro {\n        width: 100%;\n        margin: 10px 0px;\n    }\n\n    .recuadroExterno {\n        width: 100%\n    }\n}\n\n.simbolo {\n    font-size: 40px;\n}\n\n.datos-texto {\n    padding: 0px;\n    color: white;\n    width: 75%;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-around;\n    padding-right: 8px;\n}\n\n.datos-texto.sensor {\n    width: 55%;\n}\n\n.datos-texto h2 {\n    font-size: 16px;\n    font-family: \"Raleway Bold\";\n    margin-top: 5px;\n}\n\n.datos-grafico {\n    padding: 0px;\n    width: 25%;\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    align-items: center;\n}\n\n.datos-grafico.sensor {\n    width: 45%;\n}\n\n.datos-grafico span {\n    width: 100%;\n}\n\n.item h3 {\n    font-family: 'Raleway Bold';\n    font-size: 16px;\n    overflow: hidden;\n}\n\n.datos-texto h4 {\n    font-size: 16px;\n}\n\n.ultimaActualizacion {\n    color: white;\n}\n\nsvg {\n    width: 100%;\n    display: block;\n    margin: 5px;\n}\n\n.path {\n    stroke-dasharray: 1000;\n    stroke-dashoffset: 0;\n}\n\n.path.circle {\n    -webkit-animation: dash 0.9s ease-in-out;\n    animation: dash 0.9s ease-in-out;\n}\n\n.path.line {\n    stroke-dashoffset: 1000;\n    -webkit-animation: dash 0.9s 0.35s ease-in-out forwards;\n    animation: dash 0.9s 0.35s ease-in-out forwards;\n}\n\n.path.check {\n    stroke-dashoffset: -100;\n    -webkit-animation: dash-check 0.9s 0.35s ease-in-out forwards;\n    animation: dash-check 0.9s 0.35s ease-in-out forwards;\n}\n\n@-webkit-keyframes dash {\n    0% {\n        stroke-dashoffset: 1000;\n    }\n    100% {\n        stroke-dashoffset: 0;\n    }\n}\n\n@keyframes dash {\n    0% {\n        stroke-dashoffset: 1000;\n    }\n    100% {\n        stroke-dashoffset: 0;\n    }\n}\n\n@-webkit-keyframes dash-check {\n    0% {\n        stroke-dashoffset: -100;\n    }\n    100% {\n        stroke-dashoffset: 900;\n    }\n}\n\n@keyframes dash-check {\n    0% {\n        stroke-dashoffset: -100;\n    }\n    100% {\n        stroke-dashoffset: 900;\n    }\n}\n"

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var login_service_1 = __webpack_require__(381);
	var sucursal_1 = __webpack_require__(908);
	var regAlarma_service_1 = __webpack_require__(572);
	var nodo_service_1 = __webpack_require__(433);
	var io = __webpack_require__(593);
	var myGlobals = __webpack_require__(414);
	var dateTimeZonePipe_1 = __webpack_require__(645);
	var moment = __webpack_require__(435);
	var HomeTecnicoComponent = (function () {
	    function HomeTecnicoComponent(regAlarmaService, nodoService, loginService) {
	        this.regAlarmaService = regAlarmaService;
	        this.nodoService = nodoService;
	        this.loginService = loginService;
	        this.usuario = '';
	        this.mostrarTodo = false;
	    }
	    HomeTecnicoComponent.prototype.ngOnDestroy = function () {
	        this.socket.disconnect();
	        this.socketSensor.disconnect();
	    };
	    HomeTecnicoComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        window.scrollTo(0, 0);
	        this.sucursalSeleccionada = new sucursal_1.Sucursal();
	        this.usuarioConectado = this.loginService.getDecodeToken();
	        //Desactivar auto slide
	        $("#myCarousel").carousel({
	            interval: false
	        });
	        //Conectar al socket con configuración específica
	        this.socket = io.connect(myGlobals.default.URL_MQTT_ALARMAS, {
	            path: myGlobals.default.PATH_MQTT_ALARMAS,
	            transports: ['websocket', 'polling'],
	            upgrade: true,
	            rememberUpgrade: true
	        });
	        this.socketSensor = io.connect(myGlobals.default.URL_MQTT, {
	            path: myGlobals.default.PATH_MQTT,
	            transports: ['websocket', 'polling'],
	            upgrade: true,
	            rememberUpgrade: true
	        });
	        // Debug de conexiones
	        this.socket.on('connect', function () {
	            console.log('Socket alarmas conectado via:', _this.socket.io.engine.transport.name);
	            _this.socket.io.engine.on('upgrade', function () {
	                console.log('Socket alarmas actualizado a:', _this.socket.io.engine.transport.name);
	            });
	        });
	        this.socketSensor.on('connect', function () {
	            console.log('Socket sensor conectado via:', _this.socketSensor.io.engine.transport.name);
	            _this.socketSensor.io.engine.on('upgrade', function () {
	                console.log('Socket sensor actualizado a:', _this.socketSensor.io.engine.transport.name);
	            });
	        });
	        this.inicializarSocketAlarma();
	        //Cargar arbol
	        this.recargar();
	    };
	    HomeTecnicoComponent.prototype.recargar = function () {
	        var _this = this;
	        //Arbol de sucursales->ubicaciones->nodos->sensores segun usuario logueado
	        this.nodoService.getNodosInfoBasica().subscribe(function (sucursalesConTodo) {
	            _this.sucursales = sucursalesConTodo;
	            var _loop_1 = function(s) {
	                var sucursal = _this.sucursales[s];
	                if (_this.sucursalSeleccionada && _this.sucursalSeleccionada._id && _this.sucursalSeleccionada._id == sucursal._id)
	                    _this.sucursalSeleccionada = sucursal;
	                sucursal.alarmaSinActividadActiva = false;
	                sucursal.alarmaActiva = false;
	                sucursal.alarmaBateriaBajaActiva = false;
	                sucursal.alarmaSensorNullActivo = false;
	                sucursal.nodoMantenimiento = false;
	                if (!sucursal.estado) {
	                    _this.sucursales.splice(_this.sucursales.indexOf(sucursal), 1);
	                    s--;
	                    return out_s_1 = s, "continue";
	                }
	                for (var u = 0; u < sucursal.ubicaciones.length; u++) {
	                    var ubicacion = sucursal.ubicaciones[u];
	                    if (!ubicacion.estado) {
	                        sucursal.ubicaciones.splice(sucursal.ubicaciones.indexOf(ubicacion), 1);
	                        u--;
	                        continue;
	                    }
	                    for (var n = 0; n < ubicacion.nodos.length; n++) {
	                        var nodo = ubicacion.nodos[n];
	                        if (!nodo.estado) {
	                            ubicacion.nodos.splice(ubicacion.nodos.indexOf(nodo), 1);
	                            n--;
	                            continue;
	                        }
	                        sucursal.alarmaSinActividadActiva = !sucursal.alarmaSinActividadActiva ? nodo.regAlarmas.length > 0 : sucursal.alarmaSinActividadActiva;
	                        sucursal.nodoMantenimiento = !sucursal.nodoMantenimiento ? nodo.mantenimiento : sucursal.nodoMantenimiento;
	                        nodo.regAlarmas.forEach(function (regAlarma) {
	                            if (regAlarma.tipoEspecial == 'SINACTIVIDAD') {
	                                var dias = moment().diff(moment(regAlarma.fechaActivado), "days");
	                                sucursal.tiempoAlarmaSinActividadActiva = !sucursal.tiempoAlarmaSinActividadActiva || sucursal.tiempoAlarmaSinActividadActiva < dias ? dias : sucursal.tiempoAlarmaSinActividadActiva;
	                            }
	                        });
	                        var _loop_2 = function(s_1) {
	                            var sensor = nodo.sensores_id[s_1];
	                            sensor.regAlarmas.some(function (regAlarma) {
	                                if (regAlarma.tipoEspecial == 'BATERIABAJA') {
	                                    sucursal.alarmaBateriaBajaActiva = true;
	                                    sucursal.colorAlarmaBateriaBajaActiva == null ? sucursal.colorAlarmaBateriaBajaActiva = regAlarma.color : sucursal.colorAlarmaBateriaBajaActiva == "Amarillo" ? sucursal.colorAlarmaBateriaBajaActiva = regAlarma.color : "";
	                                }
	                                else if (regAlarma.tipoEspecial == 'SENSORNULL') {
	                                    sucursal.alarmaSensorNullActivo = true;
	                                    sensor.alarmaSensorNull = true;
	                                }
	                                else if (regAlarma.tipoEspecial == null) {
	                                    sucursal.alarmaActiva = true;
	                                    sucursal.color == null ? sucursal.color = regAlarma.color : (sucursal.color == "Amarillo" ? sucursal.color = regAlarma.color : "");
	                                    sensor.color == null ? sensor.color = regAlarma.color : (sensor.color == "Amarillo" ? sensor.color = regAlarma.color : "");
	                                }
	                                return false;
	                            });
	                        };
	                        for (var s_1 = 0; s_1 < nodo.sensores_id.length; s_1++) {
	                            _loop_2(s_1);
	                        }
	                    }
	                }
	                out_s_1 = s;
	            };
	            var out_s_1;
	            for (var s = 0; s < _this.sucursales.length; s++) {
	                _loop_1(s);
	                s = out_s_1;
	            }
	            setTimeout(function () {
	                $('[data-toggle="tooltip"]').tooltip({
	                    animated: 'fade',
	                    placement: 'left',
	                    trigger: 'click'
	                });
	            }, 1000);
	        });
	    };
	    HomeTecnicoComponent.prototype.inicializarSocketAlarma = function () {
	        //Inicilizo socket para alarmas
	        this.socket.on("alarma", function (alarma) {
	            this.recargar();
	        }.bind(this));
	    };
	    HomeTecnicoComponent.prototype.openModal = function (idSucursal) {
	        var _this = this;
	        $("#modalGateway").modal("show");
	        this.sucursales.some(function (sucursal) {
	            if (sucursal._id == idSucursal) {
	                _this.sucursalSeleccionada = sucursal;
	                return true;
	            }
	            return false;
	        });
	        setTimeout(function () {
	            $('[data-toggle="tooltip"]').tooltip({
	                animated: 'fade',
	                placement: 'left',
	                trigger: 'click'
	            });
	        }, 1000);
	    };
	    HomeTecnicoComponent.prototype.cambiar = function (id) {
	        if ($('#' + id).hasClass("in")) {
	            $("#" + id + "nombre").attr('class', 'glyphicon glyphicon-plus');
	            $('#' + id).collapse("hide");
	        }
	        else {
	            $("#" + id + "nombre").attr('class', 'glyphicon glyphicon-minus');
	            $('#' + id).collapse("show");
	        }
	    };
	    HomeTecnicoComponent.prototype.handleChangeMostrarTodos = function () {
	        this.mostrarTodo = !this.mostrarTodo;
	    };
	    HomeTecnicoComponent = __decorate([
	        core_1.Component({
	            selector: 'home',
	            template: __webpack_require__(909),
	            styles: [__webpack_require__(910)],
	            pipes: [dateTimeZonePipe_1.DateTimeZonePipe]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof regAlarma_service_1.RegAlarmaService !== 'undefined' && regAlarma_service_1.RegAlarmaService) === 'function' && _a) || Object, (typeof (_b = typeof nodo_service_1.NodoService !== 'undefined' && nodo_service_1.NodoService) === 'function' && _b) || Object, (typeof (_c = typeof login_service_1.LoginService !== 'undefined' && login_service_1.LoginService) === 'function' && _c) || Object])
	    ], HomeTecnicoComponent);
	    return HomeTecnicoComponent;
	    var _a, _b, _c;
	}());
	exports.HomeTecnicoComponent = HomeTecnicoComponent;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(419)))

/***/ }),
/* 908 */
/***/ (function(module, exports) {

	"use strict";
	var Sucursal = (function () {
	    function Sucursal() {
	    }
	    return Sucursal;
	}());
	exports.Sucursal = Sucursal;


/***/ }),
/* 909 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 contenido\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n        <div style=\"display: flex; justify-content: space-between; align-items: center\">\n            <h3>Sucursales</h3>\n            <button type=\"button\" class=\"btn btn-default btn-sm btn-default\" data-dismiss=\"modal\" aria-label=\"Close\"\n                    (click)=\"handleChangeMostrarTodos()\">\n                <span *ngIf=\"(!mostrarTodo)\">Ver más</span>\n                <span *ngIf=\"(mostrarTodo)\">Ver menos</span>\n            </button>\n        </div>\n        <div class=\"recuadros-container\">\n            <div *ngFor=\"let sucursal of sucursales\" class=\"recuadroExterno\">\n                <div class=\"recuadro\" id={{sucursal._id}} (click)=\"openModal(sucursal._id)\"\n                     *ngIf=\"(!mostrarTodo && (sucursal.alarmaBateriaBajaActiva || sucursal.alarmaSinActividadActiva || sucursal.alarmaSensorNullActivo)) || mostrarTodo\">\n                    <div class=\"datos-texto\">\n                        <h2>{{sucursal.descripcion}}</h2>\n                        <p>{{sucursal.empresa.descripcion}}</p>\n                    </div>\n                    <div class=\"datos-grafico\">\n                        <img *ngIf=\"!sucursal.alarmaBateriaBajaActiva\" class=\"verde\" src=\"/img/battery.png\">\n                        <img *ngIf=\"sucursal.alarmaBateriaBajaActiva && (sucursal.colorAlarmaBateriaBajaActiva == 'Rojo' || !sucursal.colorAlarmaBateriaBajaActiva)\"\n                             class=\"rojo\" src=\"/img/batteryLow.png\">\n                        <img *ngIf=\"sucursal.alarmaBateriaBajaActiva && sucursal.colorAlarmaBateriaBajaActiva == 'Amarillo'\"\n                             class=\"amarillo\" src=\"/img/batteryMedium.png\">\n                        <img *ngIf=\"!sucursal.alarmaSinActividadActiva\" class=\"verde\" src=\"/img/datatransfer.png\">\n                        <img *ngIf=\"sucursal.alarmaSinActividadActiva\" class=\"rojo\" src=\"/img/nodatatransfer.png\">\n                        <img *ngIf=\"!sucursal.alarmaActiva\" class=\"verde\" src=\"/img/campanaVerde.png\">\n                        <img *ngIf=\"sucursal.alarmaActiva && sucursal.color == 'Rojo'\" class=\"rojo\"\n                             src=\"/img/campanaRoja.png\">\n                        <img *ngIf=\"sucursal.alarmaActiva && sucursal.color == 'Amarillo'\" class=\"amarillo\"\n                             src=\"/img/campanaAmarilla.png\">\n                        <img *ngIf=\"sucursal.alarmaSensorNullActivo\" class=\"rojo\"\n                             src=\"/img/nullRojo2.png\">\n                        <img *ngIf=\"!sucursal.alarmaSensorNullActivo\" class=\"verde\"\n                             src=\"/img/nullVerde2.png\">\n                        <img *ngIf=\"sucursal.nodoMantenimiento\" class=\"rojo\"\n                             src=\"/img/mantenimiento-rojo.png\">\n                        <img *ngIf=\"!sucursal.nodoMantenimiento\" class=\"verde\"\n                             src=\"/img/mantenimiento-verde.png\">\n                        <img *ngIf=\"!sucursal.tiempoAlarmaSinActividadActiva || sucursal.tiempoAlarmaSinActividadActiva < 1\" class=\"verde\"\n                             src=\"/img/24-hours-verde.png\">\n                        <img *ngIf=\"sucursal.tiempoAlarmaSinActividadActiva && sucursal.tiempoAlarmaSinActividadActiva >= 1\" class=\"rojo\"\n                             src=\"/img/24-hours-rojo.png\">\n\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<!-- Modal -->\n<div class=\"modal\" id=\"modalGateway\" tabindex=\"-1\" role=\"dialog\"\n     aria-labelledby=\"myModalLabel\"\n     style=\"z-indez:99999999\">\n    <div class=\"modal-dialog modal-lg\" role=\"document\" style=\"z-indez:99999\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span\n                        aria-hidden=\"true\">&times;</span></button>\n                <h4 class=\"modal-title\" id=\"myModalLabel\">\n                    Resumen de estado de la sucursal {{sucursalSeleccionada ? sucursalSeleccionada.descripcion : \"\"}}\n                </h4>\n                <p>{{sucursalSeleccionada && sucursalSeleccionada.empresa ? sucursalSeleccionada.empresa.descripcion :\n                    \"\"}}</p>\n            </div>\n            <div class=\"modal-body\">\n                <div class=\"list-group\">\n                    <div *ngFor=\"let ubicacion of sucursalSeleccionada.ubicaciones\">\n                        <div class=\"list-group-item ubicacion\" *ngIf=\"ubicacion.estado == true\">\n                            <div class=\"nombre\" (click)=\"cambiar(ubicacion._id)\">\n                                <span id=\"{{ubicacion._id+'nombre'}}\" class=\"glyphicon glyphicon-minus\"></span>\n                                {{ubicacion.descripcion}}\n                            </div>\n                        </div>\n                        <div class=\"collapse in\" id={{ubicacion._id}}>\n                            <div *ngFor=\"let nodo of ubicacion.nodos\">\n                                <div class=\"list-group-item nodo\" *ngIf=\"nodo.estado == true\">\n                                    <div class=\"nombre\" (click)=\"cambiar(nodo._id)\">\n                                        <span id=\"{{nodo._id+'nombre'}}\" class=\"glyphicon glyphicon-minus\"></span>\n                                        {{nodo.nombre + \" (\"+ nodo.etiqueta+\")\" + (nodo.nroSerie ? \" (Serie: \"+\n                                        nodo.nroSerie+\")\" : \"\")}}\n                                    </div>\n                                    <img *ngIf=\"nodo.regAlarmas.length == 0\" class=\"verde\" src=\"/img/datatransfer.png\">\n                                    <img *ngIf=\"nodo.regAlarmas.length > 0\" class=\"rojo\" src=\"/img/nodatatransfer.png\"\n                                         data-toggle=\"tooltip\" trigger=\"click\"\n                                         title=\"Alarma sin actividad disparada {{nodo.regAlarmas[0].fechaActivado | dateTimeZone: 'DD/MM/yyyy HH:mm' : (sucursalSeleccionada.husoHorario_id ? sucursalSeleccionada.husoHorario_id.offset : '-03:00')}}\">\n                                </div>\n\n                                <div class=\"collapse in\" id={{nodo._id}}>\n                                    <div *ngFor=\"let sensor of nodo.sensores_id\">\n                                        <div class=\"list-group-item sensor\" *ngIf=\"sensor.estado == true\">\n                                            <div class=\"nombre\">\n                                                <!--<span class=\"glyphicon glyphicon-transfer\"></span> -->\n                                                {{sensor.etiqueta}}\n                                            </div>\n                                            <div class=\"simbolos\">\n                                                <img *ngIf=\"sensor.posicionString == 9 && sensor.regAlarmas.length == 0\"\n                                                     class=\"verde\" src=\"/img/battery.png\">\n                                                <img *ngIf=\"sensor.posicionString == 9 && sensor.regAlarmas.length == 1 && sensor.regAlarmas[0].color == 'Amarillo'\"\n                                                     class=\"amarillo\" src=\"/img/batteryMedium.png\" data-toggle=\"tooltip\"\n                                                     title=\"Alarma bateria baja disparada {{sensor.regAlarmas[0].fechaActivado | dateTimeZone: 'DD/MM/yyyy HH:mm' : (sucursalSeleccionada.husoHorario_id ? sucursalSeleccionada.husoHorario_id.offset : '-03:00')}} por duración estimada\">\n                                                <img *ngIf=\"sensor.posicionString == 9 && (sensor.regAlarmas.length == 2 || (sensor.regAlarmas.length == 1 && (sensor.regAlarmas[0].color == 'Rojo' || !sensor.regAlarmas[0].color)))\"\n                                                     class=\"rojo\" src=\"/img/batteryLow.png\" data-toggle=\"tooltip\"\n                                                     title=\"Alarma bateria baja disparada {{sensor.regAlarmas[0].fechaActivado | dateTimeZone: 'DD/MM/yyyy HH:mm' : (sucursalSeleccionada.husoHorario_id ? sucursalSeleccionada.husoHorario_id.offset : '-03:00')}} con un valor de {{sensor.regAlarmas[0].valorMedido}}V\">\n                                                <img *ngIf=\"sensor.posicionString != 9 && sensor.regAlarmas.length == 0\"\n                                                     class=\"verde\" src=\"/img/campanaVerde.png\">\n                                                <div *ngIf=\"sensor.posicionString != 9 && sensor.regAlarmas.length > 0\">\n                                                    <div *ngFor=\"let alarma of sensor.alarmas\">\n                                                        <div *ngIf=\"alarma.regAlarmas.length > 0 && alarma.estado\">\n                                                            <img *ngIf=\"sensor.color == 'Rojo'\"\n                                                                 class=\"rojo\"\n                                                                 src=\"/img/campanaRoja.png\"\n                                                                 data-toggle=\"tooltip\" trigger=\"click\"\n                                                                 title=\"Alarma {{alarma.descripcion}} roja disparada {{alarma.regAlarmas[0].color == 'Rojo' ? (alarma.regAlarmas[0].fechaActivado | dateTimeZone: 'DD/MM/yyyy HH:mm' : (sucursalSeleccionada.husoHorario_id ? sucursalSeleccionada.husoHorario_id.offset : '-03:00')) : (alarma.regAlarmas.length == 2 ? (alarma.regAlarmas[1].fechaActivado | dateTimeZone: 'DD/MM/yyyy HH:mm' : (sucursalSeleccionada.husoHorario_id ? sucursalSeleccionada.husoHorario_id.offset : '-03:00')) : '')}}\">\n                                                            <img *ngIf=\"sensor.color == 'Amarillo'\"\n                                                                 class=\"amarillo\"\n                                                                 src=\"/img/campanaAmarilla.png\" trigger=\"click\"\n                                                                 data-toggle=\"tooltip\"\n                                                                 title=\"Alarma {{alarma.descripcion}} amarilla disparada {{alarma.regAlarmas[0].color == 'Amarillo' ? (alarma.regAlarmas[0].fechaActivado | dateTimeZone: 'DD/MM/yyyy HH:mm' : (sucursalSeleccionada.husoHorario_id ? sucursalSeleccionada.husoHorario_id.offset : '-03:00')) : (alarma.regAlarmas.length == 2 ? (alarma.regAlarmas[1].fechaActivado | dateTimeZone: 'DD/MM/yyyy HH:mm' : (sucursalSeleccionada.husoHorario_id ? sucursalSeleccionada.husoHorario_id.offset : '-03:00')) : '')}}\">\n                                                        </div>\n                                                    </div>\n                                                </div>\n                                                <img *ngIf=\"sensor.alarmaSensorNull\" class=\"rojo\" src=\"/img/nullRojo2.png\"\n                                                     data-toggle=\"tooltip\" trigger=\"click\"\n                                                     title=\"Sensor sin información\">\n                                                <img *ngIf=\"!sensor.alarmaSensorNull\" class=\"verde\" src=\"/img/nullVerde2.png\">\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n\n                </div>\n\n            </div>\n\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Cerrar</button>\n            </div>\n        </div>\n    </div>\n</div>\n\n\n\n\n";

/***/ }),
/* 910 */
/***/ (function(module, exports) {

	module.exports = ".recuadros-container {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n}\n\n.recuadro {\n    text-align: center;\n    border: 1px solid rgba(59, 66, 74, .5);\n    background-color: #273135;\n    border-radius: 10px;\n    padding: 12px;\n    margin: 10px;\n    cursor: pointer;\n    display: flex;\n    width: 200px;\n    min-height: 126px;\n}\n\n@media (max-width: 769px) {\n\n    .recuadro {\n        width: 100%;\n        margin: 10px 0px;\n    }\n\n    .recuadroExterno {\n        width: 100%\n    }\n}\n\n.recuadroExterno {\n    padding: 0px;\n    margin: 0px;\n}\n\n.simbolo {\n    font-size: 80px;\n    padding-top: 16px;\n}\n\n.datos-texto {\n    padding: 0px;\n    color: white;\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-around;\n    padding-right: 8px;\n    max-width: 72%;\n}\n\n.datos-texto h2 {\n    font-size: 16px;\n    font-family: \"Raleway Bold\";\n    margin-top: 5px;\n}\n\n.datos-grafico {\n    padding: 0px;\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    align-items: center;\n    max-height: 100px;\n    flex-wrap: wrap;\n    gap: 5px;\n}\n\n.datos-grafico img {\n    width: 22px;\n    height: 22px;\n    padding: 3px;\n    border-radius: 100%;\n}\n\n.datos-grafico img.verde {\n    border: 2px solid #43B05B;\n}\n\n.datos-grafico img.rojo {\n    border: 2px solid #cd3b48;\n}\n\n.datos-grafico img.amarillo {\n    border: 2px solid #FBD749;\n}\n\n.item h3 {\n    font-family: 'Raleway Bold';\n    font-size: 16px;\n    overflow: hidden;\n}\n\n.datos-texto h4 {\n    font-size: 16px;\n}\n\n.ultimaActualizacion {\n    position: absolute;\n    bottom: 16px;\n    color: white;\n    right: 22px;\n}\n\n.list-group-item {\n    display: flex;\n    justify-content: space-between;\n}\n\n.list-group-item .nombre{\n    margin-right: 10px;\n}\n\n.list-group-item.nodo {\n    padding-left: 45px;\n}\n\n.list-group-item.sensor {\n    padding-left: 90px;\n}\n\n.list-group-item img {\n    width: 25px;\n    height: 25px;\n    padding: 4px;\n    border-radius: 100%;\n    margin-bottom: 5px;\n    float: right;\n}\n\n.list-group-item span {\n    padding-right: 10px;\n}\n\n.list-group-item img.verde {\n    border: 2px solid #43B05B;\n}\n\n.list-group-item img.rojo {\n    border: 2px solid #cd3b48;\n    cursor: pointer;\n}\n\n.list-group-item img.amarillo {\n    border: 2px solid #FBD749;\n    cursor: pointer;\n}\n\n.list-group-item:last-child {\n    margin-bottom: -1px;\n    border-bottom-right-radius: 0px;\n    border-bottom-left-radius: 0px;\n}\n\n.list-group-item:first-child {\n    border-top-right-radius: 0px;\n    border-top-left-radius: 0px;\n}\n\n.simbolos {\n    display: flex;\n    float: right;\n    gap: 4px;\n}"

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var empresa_service_1 = __webpack_require__(425);
	var sucursal_service_1 = __webpack_require__(429);
	var nodo_service_1 = __webpack_require__(433);
	var medicion_service_1 = __webpack_require__(434);
	var regAlarma_service_1 = __webpack_require__(572);
	var login_service_1 = __webpack_require__(381);
	var ubicacion_1 = __webpack_require__(912);
	var io = __webpack_require__(593);
	var myGlobals = __webpack_require__(414);
	var Highcharts = __webpack_require__(902);
	// Load module after Highcharts is loaded
	__webpack_require__(913)(Highcharts);
	__webpack_require__(914)(Highcharts);
	var moment = __webpack_require__(435);
	var dateTimeZonePipe_1 = __webpack_require__(645);
	var ChartGlobal;
	var GraficosComponent = (function () {
	    function GraficosComponent(empresaService, sucursalService, nodoService, medicionService, regAlarmaService, loginService) {
	        this.empresaService = empresaService;
	        this.sucursalService = sucursalService;
	        this.nodoService = nodoService;
	        this.medicionService = medicionService;
	        this.regAlarmaService = regAlarmaService;
	        this.loginService = loginService;
	    }
	    GraficosComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        window.scrollTo(0, 0);
	        this.usuarioConectado = this.loginService.getDecodeToken();
	        this.regAlarma = [];
	        this.regAlarmaNodos = [];
	        this.asignacionColor = new Map();
	        this.abierto = true;
	        this.ultimoColor = 0;
	        this.ejeY = true;
	        this.noData = true;
	        this.ultimaFecha = new Map();
	        this.ubicaciones = [];
	        this.colors = ['#058DC7', '#50B432', '#ED561B', '#ae1316', '#8d02f7', '#64E572', '#FF9655', '#0da6a1', '#ff0000'];
	        this.offsetTimeZone = "-03:00";
	        //Conectar al socket con configuración específica
	        this.socket = io.connect(myGlobals.default.URL_MQTT, {
	            path: myGlobals.default.PATH_MQTT,
	            transports: ['websocket', 'polling'],
	            upgrade: true,
	            rememberUpgrade: true
	        });
	        // Debug de conexiones
	        this.socket.on('connect', function () {
	            console.log('Socket gráficos conectado via:', _this.socket.io.engine.transport.name);
	            _this.socket.io.engine.on('upgrade', function () {
	                console.log('Socket gráficos actualizado a:', _this.socket.io.engine.transport.name);
	            });
	        });
	        //Obtener empresas de ese usuario
	        this.empresaService.getEmpresas()
	            .subscribe(function (data) {
	            _this.empresas = data;
	            if (data.length > 0)
	                _this.cambiarSucursales(data[0]._id);
	        });
	        Highcharts.setOptions({
	            lang: {
	                loading: 'Cargando...',
	                months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
	                weekdays: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
	                shortMonths: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
	                exportButtonTitle: "Exportar",
	                printButtonTitle: "Importar",
	                rangeSelectorFrom: "Desde",
	                rangeSelectorTo: "Hasta",
	                rangeSelectorZoom: "Zoom",
	                downloadPNG: 'Descargar imagen PNG',
	                downloadJPEG: 'Descargar imagen JPEG',
	                downloadPDF: 'Descargar imagen PDF',
	                downloadSVG: 'Descargar imagen SVG',
	                printChart: 'Imprimir',
	                resetZoom: 'Reiniciar zoom',
	                resetZoomTitle: 'Reiniciar zoom',
	                thousandsSep: ",",
	                decimalPoint: '.'
	            }
	        });
	        ChartGlobal = Highcharts.chart('container', {
	            chart: {
	                type: 'spline',
	                zoomType: 'xy',
	                marginTop: 150,
	            },
	            lang: { noData: "Seleccione los datos que desea mostrar" },
	            title: null,
	            yAxis: {
	                title: null,
	            },
	            xAxis: {
	                type: 'datetime',
	                dateTimeLabelFormats: {
	                    millisecond: '%H:%M:%S.%L',
	                    second: '%H:%M:%S',
	                    minute: '%H:%M',
	                    hour: '%H:%M',
	                    day: '%e. %b',
	                    week: '%e. %b',
	                    month: '%b \'%y',
	                    year: '%Y'
	                },
	                crosshair: true,
	            },
	            tooltip: {
	                shared: true,
	            },
	            legend: {
	                layout: 'vertical',
	                align: 'left',
	                x: 10,
	                verticalAlign: 'top',
	                y: 2,
	                floating: true,
	                backgroundColor: '#FFFFFF',
	                maxHeight: 100,
	            },
	            credits: {
	                enabled: false
	            },
	            exporting: {
	                chart: {
	                    marginBottom: 110,
	                },
	                enabled: false,
	                csv: {
	                    dateFormat: '%d-%m-%Y %H:%M:%S'
	                },
	                chartOptions: {
	                    marginBottom: 110,
	                    title: {
	                        text: "Gráficos",
	                        style: {
	                            fontSize: '26px'
	                        }
	                    },
	                    subtitle: {
	                        text: 'fecha'
	                    },
	                    xAxis: {
	                        labels: {
	                            style: {
	                                fontSize: '16px'
	                            }
	                        },
	                    },
	                    legend: {
	                        x: -135,
	                        adjustChartSize: true,
	                        align: 'right',
	                        navigation: {
	                            enabled: false
	                        },
	                        fontSize: '8px',
	                        width: 100,
	                        floating: true,
	                        itemWidth: 60
	                    },
	                    yAxis: {
	                        labels: {
	                            style: {
	                                fontSize: '26px'
	                            }
	                        }
	                    }
	                }
	            },
	            responsive: {
	                rules: [{
	                        condition: {
	                            maxWidth: 769
	                        },
	                        chartOptions: {
	                            legend: {
	                                y: 40,
	                                maxHeight: 100
	                            },
	                            chart: {
	                                marginTop: 200
	                            }
	                        }
	                    }]
	            },
	            events: {
	                load: function () {
	                    if (this.options.chart.forExport) {
	                        Highcharts.each(this.series, function (series) {
	                            series.yAxis.update({
	                                labels: {
	                                    style: {
	                                        fontSize: 6
	                                    }
	                                }
	                            });
	                        });
	                    }
	                }
	            }
	        });
	        setTimeout(function () {
	            ChartGlobal.reflow();
	        }, 300);
	        if ($(window).width() < 769)
	            //Ocultar la barra cuando hace click afuera
	            $(document).bind("mouseup touchend", function (e) {
	                var container = $("#barraSelectora");
	                if (!container.is(e.target) // if the target of the click isn't the container...
	                    && container.has(e.target).length === 0
	                    && e.target.id != "iconoBarraSelectora" && e.target.className != "botonConfig" && e.target.id != "desBarraSelectora"
	                    && e.target.id != "flechaBarraSelectora") {
	                    $('#barraSelectora').css("display", "none");
	                }
	            });
	    };
	    GraficosComponent.prototype.ngOnDestroy = function () {
	        this.socket.disconnect();
	    };
	    GraficosComponent.prototype.cambiarSucursales = function (id) {
	        var _this = this;
	        //Buscar empresa
	        this.empresas.forEach(function (empresa) {
	            if (empresa._id == id) {
	                this.empresaSeleccionada = empresa;
	                return;
	            }
	        }.bind(this));
	        //Vaciar grafico cuando cambio de variable
	        this.noData = true;
	        for (var _i = 0, _a = this.ubicaciones; _i < _a.length; _i++) {
	            var ubicacion = _a[_i];
	            for (var _b = 0, _c = ubicacion.sensores; _b < _c.length; _b++) {
	                var sensor = _c[_b];
	                if (document.getElementById(sensor._id).checked == true) {
	                    $("#" + sensor._id).attr('checked', false);
	                    var e = { target: document.getElementById(sensor._id) };
	                    this.graficar(e, sensor);
	                }
	            }
	        }
	        this.sucursalService.getSucursalByEmpresa(id).subscribe(function (data) {
	            _this.sucursales = data;
	            if (data.length > 0)
	                _this.cambiarSensores(data[0]._id);
	            else {
	                _this.sucursales = [];
	                _this.ubicaciones = [];
	            }
	        });
	    };
	    GraficosComponent.prototype.cambiarSensores = function (id) {
	        var _this = this;
	        //Buscar sucursal
	        this.sucursales.forEach(function (sucursal) {
	            if (sucursal._id == id) {
	                this.sucursalSeleccionada = sucursal;
	                return;
	            }
	        }.bind(this));
	        //Vaciar grafico cuando cambio de variable
	        this.noData = true;
	        for (var _i = 0, _a = this.ubicaciones; _i < _a.length; _i++) {
	            var ubicacion = _a[_i];
	            for (var _b = 0, _c = ubicacion.sensores; _b < _c.length; _b++) {
	                var sensor = _c[_b];
	                if (document.getElementById(sensor._id).checked == true) {
	                    $("#" + sensor._id).attr('checked', false);
	                    var e = { target: document.getElementById(sensor._id) };
	                    this.graficar(e, sensor);
	                }
	            }
	        }
	        //Calcular offset huso horario
	        this.sucursales.forEach(function (sucursal) {
	            if (sucursal._id == id) {
	                this.sucursalSeleccionada = sucursal;
	                if (sucursal && sucursal.husoHorario_id && sucursal.husoHorario_id.offset)
	                    this.offsetTimeZone = sucursal.husoHorario_id.offset;
	                else
	                    this.offsetTimeZone = "-03:00";
	                return;
	            }
	        }.bind(this));
	        this.nodoService.getNodosBySucursal(id).subscribe(function (data) {
	            var i = 0;
	            var ubicacionAnt = null;
	            var nodo = null;
	            _this.nodos = data;
	            var ubicacion = null;
	            _this.ubicaciones = [];
	            while (i < _this.nodos.length) {
	                nodo = _this.nodos[i];
	                ubicacionAnt = nodo.ubicacion_id._id;
	                ubicacion = new ubicacion_1.Ubicacion();
	                ubicacion = nodo.ubicacion_id;
	                ubicacion.sensores = [];
	                while (i < _this.nodos.length && ubicacionAnt == nodo.ubicacion_id._id) {
	                    ubicacion.sensores = ubicacion.sensores.concat(nodo.sensores_id);
	                    i++;
	                    nodo = _this.nodos[i];
	                }
	                _this.ubicaciones.push(ubicacion);
	            }
	        });
	    };
	    GraficosComponent.prototype.graficar = function (e, sensor) {
	        var _this = this;
	        var chart = ChartGlobal;
	        if (e.target.checked) {
	            this.noData = false;
	            setTimeout(function () {
	                ChartGlobal.reflow();
	            }, 100);
	            this.medicionService.getMedicionesBySensor(sensor._id).subscribe(function (data) {
	                //Guardo puntos de la serie
	                var valores = [];
	                //Recorro las mediciones
	                for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
	                    var medicion = data_1[_i];
	                    //Calculo fecha
	                    //var str=medicion.fecha.toString().replace(".000Z","-0300");
	                    var fechaMedicion = moment(medicion.fecha.toString()).utcOffset(_this.offsetTimeZone);
	                    var day = fechaMedicion.date();
	                    var monthIndex = fechaMedicion.month();
	                    var year = fechaMedicion.year();
	                    var hour = fechaMedicion.hour();
	                    var minutes = fechaMedicion.minutes();
	                    var seconds = fechaMedicion.seconds();
	                    //Calculo eje x
	                    var x = Date.UTC(year, monthIndex, day, hour, minutes, seconds);
	                    //Armo medicion
	                    var nuevo = [];
	                    nuevo.push(x);
	                    nuevo.push(medicion.valor);
	                    //Guardo medicion
	                    valores.push(nuevo);
	                }
	                //Asignacion de color
	                var colorAsignado;
	                if (_this.asignacionColor.get(sensor._id) == undefined) {
	                    if (_this.ultimoColor == _this.colors.length)
	                        _this.ultimoColor = 0;
	                    colorAsignado = _this.colors[_this.ultimoColor];
	                    _this.asignacionColor.set(sensor._id, colorAsignado);
	                    _this.ultimoColor++;
	                }
	                else {
	                    colorAsignado = _this.asignacionColor.get(sensor._id);
	                }
	                //Evaluo si el eje esta agregado
	                if (chart.get(sensor.tipo_id._id + "-ejeY") == null) {
	                    //Agrego eje y
	                    chart.addAxis({
	                        id: sensor.tipo_id._id + "-ejeY",
	                        labels: {
	                            format: '{value}' + sensor.tipo_id.tipo,
	                            style: {
	                                color: "black"
	                            }
	                        },
	                        title: {
	                            text: sensor.tipo_id.descripcion,
	                            style: {
	                                color: "black"
	                            }
	                        },
	                        //lineWidth: 2,
	                        //lineColor: '#08F',
	                        opposite: false,
	                        //xAxis:1,
	                        lineWidth: 1,
	                        minorGridLineWidth: 0,
	                        lineColor: "black",
	                    });
	                }
	                //Agrego serie
	                chart.addSeries({
	                    id: sensor._id + "-serie",
	                    name: sensor.etiqueta,
	                    type: 'line',
	                    lineWidth: 2,
	                    color: colorAsignado,
	                    yAxis: sensor.tipo_id._id + "-ejeY",
	                    data: valores,
	                    tooltip: {
	                        valueSuffix: ' ' + sensor.tipo_id.tipo
	                    }
	                });
	                //Establecer socket
	                _this.socket.on(sensor._id, function (data) {
	                    var _this = this;
	                    //Busco la serie que corresponda
	                    var series = chart.get(sensor._id + "-serie");
	                    //Calculo fecha
	                    //var str=data.fecha.toString().replace(".000Z","-0300");
	                    var fechaMedicion = moment(data.fecha.toString()).utcOffset(this.offsetTimeZone);
	                    //var date = new Date(data.fecha.toString());
	                    var day = fechaMedicion.date();
	                    var monthIndex = fechaMedicion.month();
	                    var year = fechaMedicion.year();
	                    var hour = fechaMedicion.hour();
	                    var minutes = fechaMedicion.minutes();
	                    var seconds = fechaMedicion.seconds();
	                    var x = Date.UTC(year, monthIndex, day, hour, minutes, seconds);
	                    //Controlo puntos
	                    if (series.xData.length < 10)
	                        //Agrego punto a la serie
	                        series.addPoint([x, data.valor], true, false);
	                    else
	                        //Agrego punto a la serie
	                        series.addPoint([x, data.valor], true, true);
	                    //RecargoAlarmas
	                    var borradoNodo = false;
	                    var cantidadBorrados = 0;
	                    for (var i = 0; i < this.regAlarma.length; i++) {
	                        var alarma = this.regAlarma[i];
	                        if ((alarma.sensor_id == null && cantidadBorrados > 0) || (alarma.sensor_id != null && alarma.sensor_id._id == sensor._id)) {
	                            var index = this.regAlarma.indexOf(alarma);
	                            this.regAlarma.splice(index, 1);
	                            i--;
	                            cantidadBorrados++;
	                        }
	                    }
	                    if (series.data.length > 0) {
	                        //var d = new Date(series.data[0].x); // The 0 there is the key, which sets the date to the epoch
	                        var d = new Date(1);
	                        d.setUTCMilliseconds(series.data[0].x);
	                        var tzoffset = (new Date().getTimezoneOffset() * 60000);
	                        d = new Date(series.data[0].x + tzoffset); // The 0 there is the key, which sets the date to the epoch
	                        this.regAlarmaService.getRegAlarmasBySensorYFecha(sensor._id, d.toISOString(), data.fecha)
	                            .subscribe(function (regAlarmas) {
	                            _this.regAlarma.push.apply(_this.regAlarma, regAlarmas);
	                        });
	                    }
	                }.bind(_this));
	                //Obtengo alarmas
	                if (data.length > 0) {
	                    //Alarmas Por Sensor
	                    _this.regAlarmaService.getRegAlarmasBySensorYFecha(sensor._id, data[0].fecha, data[data.length - 1].fecha, _this.offsetTimeZone)
	                        .subscribe(function (regAlarmas) {
	                        _this.regAlarma.push.apply(_this.regAlarma, regAlarmas);
	                    });
	                    //Alarmas Por nodo
	                    var buscarAlarmasPorNodo = true;
	                    for (var i = 0; i < _this.regAlarmaNodos.length; i++) {
	                        var alarma = _this.regAlarmaNodos[i];
	                        if (alarma.nodo_id != null && alarma.nodo_id._id == sensor.nodo_id) {
	                            buscarAlarmasPorNodo = false;
	                            break;
	                        }
	                    }
	                    if (buscarAlarmasPorNodo)
	                        _this.regAlarmaService.getRegAlarmasByNodoYFecha(sensor._id, data[0].fecha, data[data.length - 1].fecha, _this.offsetTimeZone)
	                            .subscribe(function (regAlarmas) {
	                            _this.regAlarmaNodos.push.apply(_this.regAlarmaNodos, regAlarmas);
	                        });
	                }
	            });
	        }
	        else {
	            //Borrar eje y
	            if (chart.get(sensor.tipo_id._id + "-ejeY").series.length == 1)
	                chart.get(sensor.tipo_id._id + "-ejeY").remove();
	            else
	                chart.get(sensor._id + "-serie").remove();
	            //Remover listener
	            this.socket.removeAllListeners(sensor._id);
	            //Borrar Alarmas por sensor
	            for (var i = 0; i < this.regAlarma.length; i++) {
	                var alarma = this.regAlarma[i];
	                if (alarma.sensor_id != null && alarma.sensor_id._id == sensor._id) {
	                    var index = this.regAlarma.indexOf(alarma);
	                    this.regAlarma.splice(index, 1);
	                    i--;
	                }
	            }
	            //Borrar Alarmas por nodo
	            var borrarNodo = true;
	            for (var _i = 0, _a = this.ubicaciones; _i < _a.length; _i++) {
	                var ubicacion = _a[_i];
	                for (var _b = 0, _c = ubicacion.sensores; _b < _c.length; _b++) {
	                    var s = _c[_b];
	                    if (document.getElementById(s._id).checked) {
	                        if (s.nodo_id == sensor.nodo_id) {
	                            borrarNodo = false;
	                        }
	                    }
	                }
	            }
	            if (borrarNodo) {
	                for (var i = 0; i < this.regAlarmaNodos.length; i++) {
	                    var alarma = this.regAlarmaNodos[i];
	                    if (alarma.nodo_id != null && alarma.nodo_id._id == sensor.nodo_id) {
	                        var index = this.regAlarmaNodos.indexOf(alarma);
	                        this.regAlarmaNodos.splice(index, 1);
	                        i--;
	                    }
	                }
	            }
	            //Muestro cartel de sin datos
	            if (chart.series.length == 0)
	                this.noData = true;
	            //Recargo grafico
	            setTimeout(function () {
	                ChartGlobal.reflow();
	            }, 100);
	        }
	    };
	    GraficosComponent.prototype.modificarBarra = function () {
	        setTimeout(function () {
	            ChartGlobal.reflow();
	        }, 100);
	    };
	    GraficosComponent.prototype.ocultarEje = function () {
	        //var chart = $('#container').highcharts();
	        var chart = ChartGlobal;
	        this.ejeY = !this.ejeY;
	        for (var _i = 0, _a = chart.yAxis; _i < _a.length; _i++) {
	            var eje = _a[_i];
	            eje.update({
	                visible: this.ejeY
	            });
	        }
	    };
	    GraficosComponent.prototype.export = function (tipo) {
	        //var chart = $('#container').highcharts();
	        var chart = ChartGlobal;
	        var d = new Date();
	        var datestring = ("0" + d.getDate()).slice(-2) + "-" + ("0" + (d.getMonth() + 1)).slice(-2) + "-" +
	            d.getFullYear() + " " + ("0" + d.getHours()).slice(-2) + ":" + ("0" + d.getMinutes()).slice(-2);
	        chart.options.exporting.url = myGlobals.default.BASE_URL + '/informe/grafico';
	        chart.options.exporting.chartOptions.title.text = this.empresaSeleccionada.descripcion + " - " + this.sucursalSeleccionada.descripcion;
	        chart.options.exporting.chartOptions.subtitle.text = datestring + " - " + this.usuarioConectado.nombre + " " + this.usuarioConectado.apellido;
	        chart.options.exporting.chartOptions.subtitle.verticalAlign = 'bottom';
	        chart.options.exporting.chartOptions.subtitle.align = 'left';
	        chart.options.exporting.chartOptions.chart = { spacing: [20, 20, 60, 20] };
	        chart.options.exporting.chartOptions.chart.marginTop = 230;
	        chart.options.exporting.chartOptions.legend.y = 30;
	        chart.options.exporting.chartOptions.legend.x = -700;
	        chart.options.exporting.chartOptions.legend.maxHeight = 200;
	        chart.options.exporting.chartOptions.legend.navigation = { enabled: false };
	        // chart.options.exporting.chartOptions.yAxis.labels.style.fontSize = "30px";
	        if (tipo == 'application/pdf') {
	            chart.options.exporting.chartOptions.legend.itemStyle = { fontSize: '10px' };
	            chart.options.exporting.sourceWidth = 842;
	            chart.options.exporting.sourceHeight = 595;
	            chart.options.exporting.scale = 0.2;
	        }
	        else {
	            chart.options.exporting.chartOptions.legend.itemStyle = { fontSize: '12px' };
	            chart.options.exporting.chartOptions.legend.x = -1000;
	            chart.options.exporting.sourceWidth = 3508 / 3;
	            chart.options.exporting.sourceHeight = 2480 / 3;
	            chart.options.exporting.scale = 3;
	            chart.options.exporting.chartOptions.legend.x = -1000;
	        }
	        chart.exportChart({
	            type: tipo
	        });
	    };
	    GraficosComponent.prototype.exportCSV = function () {
	        var chart = ChartGlobal;
	        var linkSource = "data:text/csv;charset=utf-8," + escape(chart.getCSV());
	        var downloadLink = document.createElement("a");
	        var fileName = "datosSensoresTiempoReal" + ".csv";
	        downloadLink.href = linkSource;
	        downloadLink.download = fileName;
	        downloadLink.click();
	    };
	    GraficosComponent.prototype.ocultarBarraSelectora = function () {
	        if ($('#barraSelectora').css("display") == "block")
	            $('#barraSelectora').css("display", "none");
	        else
	            $('#barraSelectora').css("display", "block");
	    };
	    GraficosComponent = __decorate([
	        core_1.Component({
	            selector: 'graficos',
	            template: __webpack_require__(915),
	            styles: [__webpack_require__(921)],
	            pipes: [dateTimeZonePipe_1.DateTimeZonePipe]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof empresa_service_1.EmpresaService !== 'undefined' && empresa_service_1.EmpresaService) === 'function' && _a) || Object, (typeof (_b = typeof sucursal_service_1.SucursalService !== 'undefined' && sucursal_service_1.SucursalService) === 'function' && _b) || Object, (typeof (_c = typeof nodo_service_1.NodoService !== 'undefined' && nodo_service_1.NodoService) === 'function' && _c) || Object, (typeof (_d = typeof medicion_service_1.MedicionService !== 'undefined' && medicion_service_1.MedicionService) === 'function' && _d) || Object, (typeof (_e = typeof regAlarma_service_1.RegAlarmaService !== 'undefined' && regAlarma_service_1.RegAlarmaService) === 'function' && _e) || Object, (typeof (_f = typeof login_service_1.LoginService !== 'undefined' && login_service_1.LoginService) === 'function' && _f) || Object])
	    ], GraficosComponent);
	    return GraficosComponent;
	    var _a, _b, _c, _d, _e, _f;
	}());
	exports.GraficosComponent = GraficosComponent;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(419)))

/***/ }),
/* 912 */
/***/ (function(module, exports) {

	"use strict";
	var Ubicacion = (function () {
	    function Ubicacion() {
	    }
	    return Ubicacion;
	}());
	exports.Ubicacion = Ubicacion;


/***/ }),
/* 913 */
/***/ (function(module, exports) {

	/*
	 Highcharts JS v5.0.14 (2017-07-28)
	 Exporting module
	
	 (c) 2010-2017 Torstein Honsi
	
	 License: www.highcharts.com/license
	*/
	(function(k){"object"===typeof module&&module.exports?module.exports=k:k(Highcharts)})(function(k){(function(f){var k=f.defaultOptions,p=f.doc,B=f.Chart,x=f.addEvent,I=f.removeEvent,F=f.fireEvent,r=f.createElement,C=f.discardElement,v=f.css,n=f.merge,D=f.pick,h=f.each,G=f.objectEach,t=f.extend,J=f.isTouchDevice,E=f.win,H=E.navigator.userAgent,K=f.Renderer.prototype.symbols;/Edge\/|Trident\/|MSIE /.test(H);/firefox/i.test(H);t(k.lang,{printChart:"Print chart",downloadPNG:"Download PNG image",downloadJPEG:"Download JPEG image",
	downloadPDF:"Download PDF document",downloadSVG:"Download SVG vector image",contextButtonTitle:"Chart context menu"});k.navigation={buttonOptions:{theme:{},symbolSize:14,symbolX:12.5,symbolY:10.5,align:"right",buttonSpacing:3,height:22,verticalAlign:"top",width:24}};n(!0,k.navigation,{menuStyle:{border:"1px solid #999999",background:"#ffffff",padding:"5px 0"},menuItemStyle:{padding:"0.5em 1em",background:"none",color:"#333333",fontSize:J?"14px":"11px",transition:"background 250ms, color 250ms"},menuItemHoverStyle:{background:"#335cad",
	color:"#ffffff"},buttonOptions:{symbolFill:"#666666",symbolStroke:"#666666",symbolStrokeWidth:3,theme:{fill:"#ffffff",stroke:"none",padding:5}}});k.exporting={type:"image/png",url:"https://export.highcharts.com/",printMaxWidth:780,scale:2,buttons:{contextButton:{className:"highcharts-contextbutton",menuClassName:"highcharts-contextmenu",symbol:"menu",_titleKey:"contextButtonTitle",menuItems:"printChart separator downloadPNG downloadJPEG downloadPDF downloadSVG".split(" ")}},menuItemDefinitions:{printChart:{textKey:"printChart",
	onclick:function(){this.print()}},separator:{separator:!0},downloadPNG:{textKey:"downloadPNG",onclick:function(){this.exportChart()}},downloadJPEG:{textKey:"downloadJPEG",onclick:function(){this.exportChart({type:"image/jpeg"})}},downloadPDF:{textKey:"downloadPDF",onclick:function(){this.exportChart({type:"application/pdf"})}},downloadSVG:{textKey:"downloadSVG",onclick:function(){this.exportChart({type:"image/svg+xml"})}}}};f.post=function(a,b,e){var c=r("form",n({method:"post",action:a,enctype:"multipart/form-data"},
	e),{display:"none"},p.body);G(b,function(a,b){r("input",{type:"hidden",name:b,value:a},null,c)});c.submit();C(c)};t(B.prototype,{sanitizeSVG:function(a,b){if(b&&b.exporting&&b.exporting.allowHTML){var e=a.match(/<\/svg>(.*?$)/);e&&e[1]&&(e='\x3cforeignObject x\x3d"0" y\x3d"0" width\x3d"'+b.chart.width+'" height\x3d"'+b.chart.height+'"\x3e\x3cbody xmlns\x3d"http://www.w3.org/1999/xhtml"\x3e'+e[1]+"\x3c/body\x3e\x3c/foreignObject\x3e",a=a.replace("\x3c/svg\x3e",e+"\x3c/svg\x3e"))}a=a.replace(/zIndex="[^"]+"/g,
	"").replace(/isShadow="[^"]+"/g,"").replace(/symbolName="[^"]+"/g,"").replace(/jQuery[0-9]+="[^"]+"/g,"").replace(/url\(("|&quot;)(\S+)("|&quot;)\)/g,"url($2)").replace(/url\([^#]+#/g,"url(#").replace(/<svg /,'\x3csvg xmlns:xlink\x3d"http://www.w3.org/1999/xlink" ').replace(/ (NS[0-9]+\:)?href=/g," xlink:href\x3d").replace(/\n/," ").replace(/<\/svg>.*?$/,"\x3c/svg\x3e").replace(/(fill|stroke)="rgba\(([ 0-9]+,[ 0-9]+,[ 0-9]+),([ 0-9\.]+)\)"/g,'$1\x3d"rgb($2)" $1-opacity\x3d"$3"').replace(/&nbsp;/g,
	"\u00a0").replace(/&shy;/g,"\u00ad");return a=a.replace(/<IMG /g,"\x3cimage ").replace(/<(\/?)TITLE>/g,"\x3c$1title\x3e").replace(/height=([^" ]+)/g,'height\x3d"$1"').replace(/width=([^" ]+)/g,'width\x3d"$1"').replace(/hc-svg-href="([^"]+)">/g,'xlink:href\x3d"$1"/\x3e').replace(/ id=([^" >]+)/g,' id\x3d"$1"').replace(/class=([^" >]+)/g,'class\x3d"$1"').replace(/ transform /g," ").replace(/:(path|rect)/g,"$1").replace(/style="([^"]+)"/g,function(a){return a.toLowerCase()})},getChartHTML:function(){return this.container.innerHTML},
	getSVG:function(a){var b,e,c,w,m,g=n(this.options,a);p.createElementNS||(p.createElementNS=function(a,b){return p.createElement(b)});e=r("div",null,{position:"absolute",top:"-9999em",width:this.chartWidth+"px",height:this.chartHeight+"px"},p.body);c=this.renderTo.style.width;m=this.renderTo.style.height;c=g.exporting.sourceWidth||g.chart.width||/px$/.test(c)&&parseInt(c,10)||600;m=g.exporting.sourceHeight||g.chart.height||/px$/.test(m)&&parseInt(m,10)||400;t(g.chart,{animation:!1,renderTo:e,forExport:!0,
	renderer:"SVGRenderer",width:c,height:m});g.exporting.enabled=!1;delete g.data;g.series=[];h(this.series,function(a){w=n(a.userOptions,{animation:!1,enableMouseTracking:!1,showCheckbox:!1,visible:a.visible});w.isInternal||g.series.push(w)});h(this.axes,function(a){a.userOptions.internalKey||(a.userOptions.internalKey=f.uniqueKey())});b=new f.Chart(g,this.callback);a&&h(["xAxis","yAxis","series"],function(c){var d={};a[c]&&(d[c]=a[c],b.update(d))});h(this.axes,function(a){var c=f.find(b.axes,function(b){return b.options.internalKey===
	a.userOptions.internalKey}),d=a.getExtremes(),e=d.userMin,d=d.userMax;!c||void 0===e&&void 0===d||c.setExtremes(e,d,!0,!1)});c=b.getChartHTML();c=this.sanitizeSVG(c,g);g=null;b.destroy();C(e);return c},getSVGForExport:function(a,b){var e=this.options.exporting;return this.getSVG(n({chart:{borderRadius:0}},e.chartOptions,b,{exporting:{sourceWidth:a&&a.sourceWidth||e.sourceWidth,sourceHeight:a&&a.sourceHeight||e.sourceHeight}}))},exportChart:function(a,b){b=this.getSVGForExport(a,b);a=n(this.options.exporting,
	a);f.post(a.url,{filename:a.filename||"chart",type:a.type,width:a.width||0,scale:a.scale,svg:b},a.formAttributes)},print:function(){var a=this,b=a.container,e=[],c=b.parentNode,f=p.body,m=f.childNodes,g=a.options.exporting.printMaxWidth,d,u;if(!a.isPrinting){a.isPrinting=!0;a.pointer.reset(null,0);F(a,"beforePrint");if(u=g&&a.chartWidth>g)d=[a.options.chart.width,void 0,!1],a.setSize(g,void 0,!1);h(m,function(a,b){1===a.nodeType&&(e[b]=a.style.display,a.style.display="none")});f.appendChild(b);E.focus();
	E.print();setTimeout(function(){c.appendChild(b);h(m,function(a,b){1===a.nodeType&&(a.style.display=e[b])});a.isPrinting=!1;u&&a.setSize.apply(a,d);F(a,"afterPrint")},1E3)}},contextMenu:function(a,b,e,c,w,m,g){var d=this,u=d.options.navigation,k=d.chartWidth,q=d.chartHeight,n="cache-"+a,l=d[n],y=Math.max(w,m),z,A;l||(d[n]=l=r("div",{className:a},{position:"absolute",zIndex:1E3,padding:y+"px"},d.container),z=r("div",{className:"highcharts-menu"},null,l),v(z,t({MozBoxShadow:"3px 3px 10px #888",WebkitBoxShadow:"3px 3px 10px #888",
	boxShadow:"3px 3px 10px #888"},u.menuStyle)),A=function(){v(l,{display:"none"});g&&g.setState(0);d.openMenu=!1},d.exportEvents.push(x(l,"mouseleave",function(){l.hideTimer=setTimeout(A,500)}),x(l,"mouseenter",function(){clearTimeout(l.hideTimer)}),x(p,"mouseup",function(b){d.pointer.inClass(b.target,a)||A()})),h(b,function(a){"string"===typeof a&&(a=d.options.exporting.menuItemDefinitions[a]);if(f.isObject(a,!0)){var b;a.separator?b=r("hr",null,null,z):(b=r("div",{className:"highcharts-menu-item",
	onclick:function(b){b&&b.stopPropagation();A();a.onclick&&a.onclick.apply(d,arguments)},innerHTML:a.text||d.options.lang[a.textKey]},null,z),b.onmouseover=function(){v(this,u.menuItemHoverStyle)},b.onmouseout=function(){v(this,u.menuItemStyle)},v(b,t({cursor:"pointer"},u.menuItemStyle)));d.exportDivElements.push(b)}}),d.exportDivElements.push(z,l),d.exportMenuWidth=l.offsetWidth,d.exportMenuHeight=l.offsetHeight);b={display:"block"};e+d.exportMenuWidth>k?b.right=k-e-w-y+"px":b.left=e-y+"px";c+m+d.exportMenuHeight>
	q&&"top"!==g.alignOptions.verticalAlign?b.bottom=q-c-y+"px":b.top=c+m-y+"px";v(l,b);d.openMenu=!0},addButton:function(a){var b=this,e=b.renderer,c=n(b.options.navigation.buttonOptions,a),f=c.onclick,m=c.menuItems,g,d,k=c.symbolSize||12;b.btnCount||(b.btnCount=0);b.exportDivElements||(b.exportDivElements=[],b.exportSVGElements=[]);if(!1!==c.enabled){var h=c.theme,q=h.states,p=q&&q.hover,q=q&&q.select,l;delete h.states;f?l=function(a){a.stopPropagation();f.call(b,a)}:m&&(l=function(){b.contextMenu(d.menuClassName,
	m,d.translateX,d.translateY,d.width,d.height,d);d.setState(2)});c.text&&c.symbol?h.paddingLeft=D(h.paddingLeft,25):c.text||t(h,{width:c.width,height:c.height,padding:0});d=e.button(c.text,0,0,l,h,p,q).addClass(a.className).attr({"stroke-linecap":"round",title:b.options.lang[c._titleKey],zIndex:3});d.menuClassName=a.menuClassName||"highcharts-menu-"+b.btnCount++;c.symbol&&(g=e.symbol(c.symbol,c.symbolX-k/2,c.symbolY-k/2,k,k).addClass("highcharts-button-symbol").attr({zIndex:1}).add(d),g.attr({stroke:c.symbolStroke,
	fill:c.symbolFill,"stroke-width":c.symbolStrokeWidth||1}));d.add().align(t(c,{width:d.width,x:D(c.x,b.buttonOffset)}),!0,"spacingBox");b.buttonOffset+=(d.width+c.buttonSpacing)*("right"===c.align?-1:1);b.exportSVGElements.push(d,g)}},destroyExport:function(a){var b=a?a.target:this;a=b.exportSVGElements;var e=b.exportDivElements,c=b.exportEvents,f;a&&(h(a,function(a,c){a&&(a.onclick=a.ontouchstart=null,f="cache-"+a.menuClassName,b[f]&&delete b[f],b.exportSVGElements[c]=a.destroy())}),a.length=0);e&&
	(h(e,function(a,c){clearTimeout(a.hideTimer);I(a,"mouseleave");b.exportDivElements[c]=a.onmouseout=a.onmouseover=a.ontouchstart=a.onclick=null;C(a)}),e.length=0);c&&(h(c,function(a){a()}),c.length=0)}});K.menu=function(a,b,e,c){return["M",a,b+2.5,"L",a+e,b+2.5,"M",a,b+c/2+.5,"L",a+e,b+c/2+.5,"M",a,b+c-1.5,"L",a+e,b+c-1.5]};B.prototype.renderExporting=function(){var a=this,b=a.options.exporting,e=b.buttons,c=a.isDirtyExporting||!a.exportSVGElements;a.buttonOffset=0;a.isDirtyExporting&&a.destroyExport();
	c&&!1!==b.enabled&&(a.exportEvents=[],G(e,function(b){a.addButton(b)}),a.isDirtyExporting=!1);x(a,"destroy",a.destroyExport)};B.prototype.callbacks.push(function(a){a.renderExporting();x(a,"redraw",a.renderExporting);h(["exporting","navigation"],function(b){a[b]={update:function(e,c){a.isDirtyExporting=!0;n(!0,a.options[b],e);D(c,!0)&&a.redraw()}}})})})(k)});


/***/ }),
/* 914 */
/***/ (function(module, exports) {

	/**
	 * A Highcharts plugin for exporting data from a rendered chart as CSV, XLS or HTML table
	 *
	 * Author:   Torstein Honsi
	 * Licence:  MIT
	 * Version:  1.4.3
	 */
	/*global Highcharts, window, document, Blob */
	(function (factory) {
	    if (typeof module === 'object' && module.exports) {
	        module.exports = factory;
	    } else {
	        factory(Highcharts);
	    }
	})(function (Highcharts) {
	
	    'use strict';
	
	    var each = Highcharts.each,
	        pick = Highcharts.pick,
	        seriesTypes = Highcharts.seriesTypes,
	        downloadAttrSupported = document.createElement('a').download !== undefined;
	
	    Highcharts.setOptions({
	        lang: {
	            downloadCSV: 'Download CSV',
	            downloadXLS: 'Download XLS',
	            viewData: 'View data table'
	        }
	    });
	
	
	    /**
	     * Get the data rows as a two dimensional array
	     */
	    Highcharts.Chart.prototype.getDataRows = function () {
	        var options = (this.options.exporting || {}).csv || {},
	            xAxis = this.xAxis[0],
	            rows = {},
	            rowArr = [],
	            dataRows,
	            names = [],
	            i,
	            x,
	            xTitle,
	            // Options
	            dateFormat = options.dateFormat || '%Y-%m-%d %H:%M:%S',
	            columnHeaderFormatter = options.columnHeaderFormatter || function (item, key, keyLength) {
	                if (item instanceof Highcharts.Axis) {
	                    return (item.options.title && item.options.title.text) ||
	                        (item.isDatetimeAxis ? 'DateTime' : 'Category');
	                }
	                return item.name + (keyLength > 1 ? ' ('+ key + ')' : '');
	            };
	
	        // Loop the series and index values
	        i = 0;
	        each(this.series, function (series) {
	            var keys = series.options.keys,
	                pointArrayMap = keys || series.pointArrayMap || ['y'],
	                valueCount = pointArrayMap.length,
	                requireSorting = series.requireSorting,
	                categoryMap = {},
	                j;
	
	            // Map the categories for value axes
	            each(pointArrayMap, function (prop) {
	                categoryMap[prop] = (series[prop + 'Axis'] && series[prop + 'Axis'].categories) || [];
	            });
	
	            if (series.options.includeInCSVExport !== false && series.visible !== false) { // #55
	                j = 0;
	                while (j < valueCount) {
	                    names.push(columnHeaderFormatter(series, pointArrayMap[j], pointArrayMap.length));
	                    j = j + 1;
	                }
	
	                each(series.points, function (point, pIdx) {
	                    var key = requireSorting ? point.x : pIdx,
	                        prop,
	                        val;
	
	                    j = 0;
	
	                    if (!rows[key]) {
	                        rows[key] = [];
	                    }
	                    rows[key].x = point.x;
	
	                    // Pies, funnels, geo maps etc. use point name in X row
	                    if (!series.xAxis || series.exportKey === 'name') {
	                        rows[key].name = point.name;
	                    }
	
	                    while (j < valueCount) {
	                        prop = pointArrayMap[j]; // y, z etc
	                        val = point[prop];
	                        rows[key][i + j] = pick(categoryMap[prop][val], val); // Pick a Y axis category if present
	                        j = j + 1;
	                    }
	
	                });
	                i = i + j;
	            }
	        });
	
	        // Make a sortable array
	        for (x in rows) {
	            if (rows.hasOwnProperty(x)) {
	                rowArr.push(rows[x]);
	            }
	        }
	        // Sort it by X values
	        rowArr.sort(function (a, b) {
	            return a.x - b.x;
	        });
	
	        // Add header row
	        xTitle = columnHeaderFormatter(xAxis);
	        dataRows = [[xTitle].concat(names)];
	
	        // Add the category column
	        each(rowArr, function (row) {
	
	            var category = row.name;
	            if (!category) {
	                if (xAxis.isDatetimeAxis) {
	                    if (row.x instanceof Date) {
	                        row.x = row.x.getTime();
	                    }
	                    category = Highcharts.dateFormat(dateFormat, row.x);
	                } else if (xAxis.categories) {
	                    category = pick(xAxis.names[row.x], xAxis.categories[row.x], row.x)
	                } else {
	                    category = row.x;
	                }
	            }
	
	            // Add the X/date/category
	            row.unshift(category);
	            dataRows.push(row);
	        });
	
	        return dataRows;
	    };
	
	    /**
	     * Get a CSV string
	     */
	    Highcharts.Chart.prototype.getCSV = function (useLocalDecimalPoint) {
	        var csv = '',
	            rows = this.getDataRows(),
	            options = (this.options.exporting || {}).csv || {},
	            itemDelimiter = options.itemDelimiter || ',', // use ';' for direct import to Excel
	            lineDelimiter = options.lineDelimiter || '\n'; // '\n' isn't working with the js csv data extraction
	
	        // Transform the rows to CSV
	        each(rows, function (row, i) {
	            var val = '',
	                j = row.length,
	                n = useLocalDecimalPoint ? (1.1).toLocaleString()[1] : '.';
	            while (j--) {
	                val = row[j];
	                if (typeof val === "string") {
	                    val = '"' + val + '"';
	                }
	                if (typeof val === 'number') {
	                    if (n === ',') {
	                        val = val.toString().replace(".", ",");
	                    }
	                }
	                row[j] = val;
	            }
	            // Add the values
	            csv += row.join(itemDelimiter);
	
	            // Add the line delimiter
	            if (i < rows.length - 1) {
	                csv += lineDelimiter;
	            }
	        });
	        return csv;
	    };
	
	    /**
	     * Build a HTML table with the data
	     */
	    Highcharts.Chart.prototype.getTable = function (useLocalDecimalPoint) {
	        var html = '<table>',
	            rows = this.getDataRows();
	
	        // Transform the rows to HTML
	        each(rows, function (row, i) {
	            var tag = i ? 'td' : 'th',
	                val,
	                j,
	                n = useLocalDecimalPoint ? (1.1).toLocaleString()[1] : '.';
	
	            html += '<tr>';
	            for (j = 0; j < row.length; j = j + 1) {
	                val = row[j];
	                // Add the cell
	                if (typeof val === 'number') {
	                    val = val.toString();
	                    if (n === ',') {
	                        val = val.replace('.', n);
	                    }
	                    html += '<' + tag + ' class="number">' + val + '</' + tag + '>';
	
	                } else {
	                    html += '<' + tag + '>' + (val === undefined ? '' : val) + '</' + tag + '>';
	                }
	            }
	
	            html += '</tr>';
	        });
	        html += '</table>';
	        return html;
	    };
	
	    function getContent(chart, href, extension, content, MIME) {
	        var a,
	            blobObject,
	            name,
	            options = (chart.options.exporting || {}).csv || {},
	            url = options.url || 'http://www.highcharts.com/studies/csv-export/download.php';
	
	        if (chart.options.exporting.filename) {
	            name = chart.options.exporting.filename;
	        } else if (chart.title) {
	            name = chart.title.textStr.replace(/ /g, '-').toLowerCase();
	        } else {
	            name = 'chart';
	        }
	
	        // MS specific. Check this first because of bug with Edge (#76)
	        if (window.Blob && window.navigator.msSaveOrOpenBlob) {
	            // Falls to msSaveOrOpenBlob if download attribute is not supported
	            blobObject = new Blob([content]);
	            window.navigator.msSaveOrOpenBlob(blobObject, name + '.' + extension);
	
	        // Download attribute supported
	        } else if (downloadAttrSupported) {
	            a = document.createElement('a');
	            a.href = href;
	            a.target = '_blank';
	            a.download = name + '.' + extension;
	            document.body.appendChild(a);
	            a.click();
	            a.remove();
	
	        } else {
	            // Fall back to server side handling
	            Highcharts.post(url, {
	                data: content,
	                type: MIME,
	                extension: extension
	            });
	        }
	    }
	
	    /**
	     * Call this on click of 'Download CSV' button
	     */
	    Highcharts.Chart.prototype.downloadCSV = function () {
	        var csv = this.getCSV(true);
	        getContent(
	            this,
	            'data:text/csv,\uFEFF' + csv.replace(/\n/g, '%0A'),
	            'csv',
	            csv,
	            'text/csv'
	        );
	    };
	
	    /**
	     * Call this on click of 'Download XLS' button
	     */
	    Highcharts.Chart.prototype.downloadXLS = function () {
	        var uri = 'data:application/vnd.ms-excel;base64,',
	            template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">' +
	                '<head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>' +
	                '<x:Name>Ark1</x:Name>' +
	                '<x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]-->' +
	                '<style>td{border:none;font-family: Calibri, sans-serif;} .number{mso-number-format:"0.00";}</style>' +
	                '<meta name=ProgId content=Excel.Sheet>' +
	                '<meta charset=UTF-8>' +
	                '</head><body>' +
	                this.getTable(true) +
	                '</body></html>',
	            base64 = function (s) { 
	                return window.btoa(unescape(encodeURIComponent(s))); // #50
	            };
	        getContent(
	            this,
	            uri + base64(template),
	            'xls',
	            template,
	            'application/vnd.ms-excel'
	        );
	    };
	
	    /**
	     * View the data in a table below the chart
	     */
	    Highcharts.Chart.prototype.viewData = function () {
	        if (!this.insertedTable) {
	            var div = document.createElement('div');
	            div.className = 'highcharts-data-table';
	            // Insert after the chart container
	            this.renderTo.parentNode.insertBefore(div, this.renderTo.nextSibling);
	            div.innerHTML = this.getTable();
	            this.insertedTable = true;
	        }
	    };
	
	
	    // Add "Download CSV" to the exporting menu. Use download attribute if supported, else
	    // run a simple PHP script that returns a file. The source code for the PHP script can be viewed at
	    // https://raw.github.com/highslide-software/highcharts.com/master/studies/csv-export/csv.php
	    if (Highcharts.getOptions().exporting) {
	        Highcharts.getOptions().exporting.buttons.contextButton.menuItems.push({
	            textKey: 'downloadCSV',
	            onclick: function () { this.downloadCSV(); }
	        }, {
	            textKey: 'downloadXLS',
	            onclick: function () { this.downloadXLS(); }
	        }, {
	            textKey: 'viewData',
	            onclick: function () { this.viewData(); }
	        });
	    }
	
	    // Series specific
	    if (seriesTypes.map) {
	        seriesTypes.map.prototype.exportKey = 'name';
	    }
	    if (seriesTypes.mapbubble) {
	        seriesTypes.mapbubble.prototype.exportKey = 'name';
	    }
	
	});


/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 contenido\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 titulo\">\n        <div class=\"marcoTitulo\">\n            <h2>Gráficos</h2>\n            <p>Home / Gráficos</p>\n        </div>\n    </div>\n    <div class=\"botonConfig visible-xs col-xs-12\" (click)=\"ocultarBarraSelectora()\">\n        <div id=\"iconoBarraSelectora\" class=\"col-xs-2\">\n            <i class=\"fa fa-cogs fa-spin fa-2x fa-fw\" style=\"color:white\"></i>\n        </div>\n        <div id=\"desBarraSelectora\" class=\"col-xs-10\" style=\"text-align: left;padding-left: 35px;\">\n            Seleccione las variables ...\n            <b class=\"caret\" id=\"flechaBarraSelectora\"></b>\n        </div>\n    </div>\n    <div id=\"barraSelectora\" class=\"col-lg-3 col-md-3 col-sm-3 col-xs-12 barraArbolBase\"\n         [ngClass]=\"{'barraArbolBaseOcultar':!abierto}\">\n        <div class=\"barraArbolCuerpo\" [ngClass]=\"{'barraArbolCuerpoOcultar':!abierto}\">\n            <div class=\"informacionArbol\">\n                <div class=\"form-group\">\n                    <label for=\"sucursal\">Empresa</label>\n                    <select class=\"form-control\" id=\"empresa\" placeholder=\"Empresa\"\n                            (change)=\"cambiarSucursales($event.target.value)\">\n                        <option *ngFor=\"let empresa of empresas\" value={{empresa._id}}>{{empresa.descripcion}}</option>\n                    </select>\n                </div>\n                <div class=\"form-group\">\n                    <label for=\"sucursal\">Sucursal</label>\n                    <select class=\"form-control\" id=\"sucursal\" placeholder=\"Sucursal\"\n                            (change)=\"cambiarSensores($event.target.value)\">\n                        <option *ngFor=\"let sucursal of sucursales\" value={{sucursal._id}}>{{sucursal.descripcion}}\n                        </option>\n                    </select>\n                </div>\n                <p>{{sucursalSeleccionada && sucursalSeleccionada.husoHorario_id ? sucursalSeleccionada.husoHorario_id.zonaHoraria + \" (\" + offsetTimeZone + \")\" : \"\"}}</p>\n                <div class=\"panel-group\" id=\"accordion\">\n                    <template ngFor let-ubicacion=\"$implicit\" [ngForOf]=\"ubicaciones\" let-index=\"index\">\n                        <div class=\"panel panel-default\" [hidden]=\"!(ubicacion.estado)\">\n                            <div class=\"panel-heading\">\n                                <h4 class=\"panel-title\">\n                                    <a data-toggle=\"collapse\" data-parent=\"#accordion\" href=\"#collapseOne\">\n                                        {{ubicacion.descripcion}}\n                                    </a>\n                                    <!--<div class=\"checkbox checkbox-warning\" style=\"display:inline;margin-left:20px;\">\n                                        <input checked=\"true\" type=\"checkbox\">\n                                        <label></label>\n                                    </div>-->\n                                </h4>\n                            </div>\n                            <div id=\"collapseOne\" class=\"panel-collapse collapse in\">\n                                <div class=\"panel-body\">\n                                    <template ngFor let-sensor [ngForOf]=\"ubicacion.sensores\" let-index=\"index2\">\n                                        <div [hidden]=\"!(sensor.estado) || (sensor.posicionString == 9  && usuarioConectado.rol != 'Administrador' && usuarioConectado.rol != 'Tecnico')\">\n                                            <div class=\"checkbox checkbox-warning\">\n                                                <input type=\"checkbox\" value={{sensor._id}} id={{sensor._id}}\n                                                       (change)=\"graficar($event,sensor)\">\n                                                <label> {{sensor.etiqueta}} </label>\n                                            </div>\n                                        </div>\n                                    </template>\n                                </div>\n                            </div>\n                        </div>\n                    </template>\n                </div>\n            </div>\n        </div>\n        <div class=\"barraArbolBoton hidden-xs\">\n            <button (click)=\"abierto=!abierto;modificarBarra()\"><i class=\"fa fa-cogs fa-spin fa-1x fa-fw\"\n                                                                   style=\"color:white\"></i></button>\n        </div>\n    </div>\n    <div [ngClass]=\"{'medicionesComprimido':abierto,'medicionesExtendido':!abierto,'col-lg-9':abierto,'col-md-9':abierto,'col-sm-9':abierto,'col-xs-12':true,'col-lg-12':!abierto,'col-md-12':!abierto,'col-sm-12':!abierto}\">\n        <div class=\"botonera col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n            <button *ngIf=\"!noData\" type=\"button\" class=\"btn btn-sm btn-default\" (click)=\"ocultarEje()\"\n                    style=\"padding-right: 5px; padding-left:5px; float: right; margin: 5px;\">\n                <img *ngIf=\"ejeY\" src=\"" + __webpack_require__(916) + "\" width=\"25px\">\n                <img *ngIf=\"!ejeY\" src=\"" + __webpack_require__(917) + "\" width=\"25px\">\n            </button>\n            <a id=\"csv\" *ngIf=\"!noData\" type=\"button\" class=\"btn btn-sm btn-default\" (click)=\"exportCSV()\"\n               style=\"padding-right: 5px; padding-left:5px; float: right;margin: 5px;\">\n                <img src=\"" + __webpack_require__(918) + "\" width=\"25px\">\n            </a>\n            <button *ngIf=\"!noData\" type=\"button\" class=\"btn btn-sm btn-default\" (click)=\"export('application/pdf')\"\n                    style=\"padding-right: 5px; padding-left:5px; float: right;margin: 5px;\">\n                <img src=\"" + __webpack_require__(919) + "\" width=\"25px\">\n            </button>\n            <button *ngIf=\"!noData\" type=\"button\" class=\"btn btn-sm btn-default\" (click)=\"export('image/jpeg')\"\n                    style=\"padding-right: 5px; padding-left:5px; float: right;margin: 5px;\">\n                <img src=\"" + __webpack_require__(920) + "\" width=\"25px\">\n            </button>\n        </div>\n        <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n            <div [style.display]=\"noData?'none':'block'\" id=\"container\"></div>\n        </div>\n        <div *ngIf=\"noData\" class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 noChartData\" style=\"text-align: center\">\n            <span class=\"glyphicon glyphicon-check nota\" aria-hidden=\"true\"\n                  style=\"font-size: 70px; padding: 20px\"></span>\n            <h2 class=\"nota\">Seleccione las variables que quiera observar</h2>\n        </div>\n    </div>\n    <div class=\"clearfix visible-lg-block\"></div>\n    <div class=\"clearfix visible-md-block\"></div>\n    <div class=\"clearfix visible-sm-block\"></div>\n    <div class=\"clearfix visible-xs-block\"></div>\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 marcoDatos\">\n        <div class=\"datos col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n            <ul class=\"nav nav-tabs\">\n                <li class=\"active\"><a data-toggle=\"tab\" href=\"#sensor\">Sensor</a></li>\n                <li><a data-toggle=\"tab\" href=\"#nodo\">Nodo</a></li>\n            </ul>\n            <div class=\"tab-content\">\n                <div id=\"sensor\" class=\"tab-pane fade in active\">\n                    <h3>Alarmas por Sensor</h3>\n                    <div class=\"table-responsive\">\n                        <table class=\"table\">\n                            <thead>\n                            <tr>\n                                <th>Nodo</th>\n                                <th>Sensor</th>\n                                <th>Tipo Alarma</th>\n                                <th>Fecha Activación</th>\n                                <th>Fecha Normalización</th>\n                                <th>Color</th>\n                                <th>Valor Mínimo</th>\n                                <th>Valor Máximo</th>\n                                <th>Valor Detectado</th>\n                                <th>Promedio</th>\n                            </tr>\n                            </thead>\n                            <tbody>\n                            <tr>\n                                <td *ngIf=\"regAlarma.length==0\" colSpan=\"8\" style=\"text-align: center\">No hay alarmas\n                                    registradas para el período\n                                </td>\n                            </tr>\n                            <tr *ngFor=\"let alarma of regAlarma; let i = index\">\n                                <td>{{alarma.nodo_id.nombre}}</td>\n                                <td>\n                                        <span *ngIf=\"alarma.sensor_id!=null\" class=\"label label-danger\"\n                                              [style.background]=\"alarma.sensor_id!=null?asignacionColor.get(alarma.sensor_id._id):white\">\n                                            {{alarma.sensor_id!=null?alarma.sensor_id.etiqueta:\"\"}}\n                                        </span>\n                                </td>\n                                <td>{{alarma.tipoEspecial==null?\"Alarma por rango\":(alarma.tipoEspecial==\"SENSORNULL\"?\"Sensor sin valor\":\"Bateria Baja\")}}\n                                </td>\n                                <td>{{alarma.fechaActivado | dateTimeZone: 'DD/MM/yyyy HH:mm' : offsetTimeZone}}</td>\n                                <td>{{alarma.fechaDesactivado | dateTimeZone: 'DD/MM/yyyy HH:mm' : offsetTimeZone}}</td>\n                                <td>\n                                    <label [ngClass]=\"{'label': true, 'label-warning': alarma.color=='Amarillo', 'label-danger': alarma.color=='Rojo'}\">\n                                        {{alarma.color}}\n                                    </label>\n                                </td>\n                                <td>{{alarma.tipoEspecial!=null?\"\":alarma.valorMinimo}}</td>\n                                <td>{{alarma.tipoEspecial!=null?\"\":alarma.valorMaximo}}</td>\n                                <td>{{alarma.tipoEspecial!=null?\"\":alarma.valorMedido}}</td>\n                                <td>{{alarma.tipoEspecial!=null?\"\":alarma.promedio}}</td>\n                            </tr>\n                            </tbody>\n                        </table>\n                    </div>\n                </div>\n                <div id=\"nodo\" class=\"tab-pane fade\">\n                    <h3>Alarmas por Nodo</h3>\n                    <div class=\"table-responsive\">\n                        <table class=\"table\">\n                            <thead>\n                            <tr>\n                                <th>Nodo</th>\n                                <th>Tipo Alarma</th>\n                                <th>Fecha Activación</th>\n                                <th>Fecha Normalización</th>\n                            </tr>\n                            </thead>\n                            <tbody>\n                            <tr>\n                                <td *ngIf=\"regAlarmaNodos.length==0\" colSpan=\"8\" style=\"text-align: center\">No hay\n                                    alarmas registradas para el período\n                                </td>\n                            </tr>\n                            <tr *ngFor=\"let alarma of regAlarmaNodos; let i = index\">\n                                <td>{{alarma.nodo_id.nombre}}</td>\n                                <td>{{alarma.tipoEspecial==null?\"Alarma por\n                                    rango\":(alarma.tipoEspecial==\"SINACTIVIDAD\"?\"Sin Actividad\":\"Bateria Baja\")}}\n                                </td>\n                                <td>{{alarma.fechaActivado | dateTimeZone: 'DD/MM/yyyy HH:mm' : offsetTimeZone}}</td>\n                                <td>{{alarma.fechaDesactivado | dateTimeZone: 'DD/MM/yyyy HH:mm' : offsetTimeZone}}</td>\n                            </tr>\n                            </tbody>\n                        </table>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/sinEjeY.b1fd95c00e7e1cb3382450156a110976.svg";

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/conEjeY.bcf8b5567a04b432f061b451e72e2e9d.svg";

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/csv.fc9d55f08f4999e51bf3724674b95044.svg";

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/pdf.64170880b2b4d64a6e486908d41575f7.svg";

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/jpg.fe83d00020f3d7e62d70ea6a389e076c.svg";

/***/ }),
/* 921 */
867,
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var usuario_service_1 = __webpack_require__(430);
	var sucursal_service_1 = __webpack_require__(429);
	var nodo_service_1 = __webpack_require__(433);
	var medicion_service_1 = __webpack_require__(434);
	var ubicacion_1 = __webpack_require__(912);
	var rol_service_1 = __webpack_require__(432);
	var empresa_service_1 = __webpack_require__(425);
	var permiso_service_1 = __webpack_require__(427);
	var router_1 = __webpack_require__(329);
	var login_service_1 = __webpack_require__(381);
	var regAlarma_service_1 = __webpack_require__(572);
	__webpack_require__(653);
	var myGlobals = __webpack_require__(414);
	var moment = __webpack_require__(435);
	var AlarmasComponent = (function () {
	    function AlarmasComponent(usuarioService, sucursalService, empresaService, route, loginService, permisoService, rolService, regAlarmaService, nodoService, medicionService, router) {
	        this.usuarioService = usuarioService;
	        this.sucursalService = sucursalService;
	        this.empresaService = empresaService;
	        this.route = route;
	        this.loginService = loginService;
	        this.permisoService = permisoService;
	        this.rolService = rolService;
	        this.regAlarmaService = regAlarmaService;
	        this.nodoService = nodoService;
	        this.medicionService = medicionService;
	        this.router = router;
	        this.abierto = true;
	    }
	    AlarmasComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        window.scrollTo(0, 0);
	        this.usuarioConectado = this.loginService.getDecodeToken();
	        //Perdir permisos
	        this.abierto = true;
	        this.regAlarma = [];
	        this.regAlarmaNodos = [];
	        this.idSensores = [];
	        this.idNodos = [];
	        this.sucursalSeleccionada = null;
	        this.mostrarEliminados = false;
	        this.fechaDesde = new Date().toISOString().substring(0, 10);
	        this.fechaHasta = new Date().toISOString().substring(0, 10);
	        this.offsetTimeZone = "-03:00";
	        //Obtener empresas de ese usuario
	        this.empresaService.getEmpresas()
	            .subscribe(function (data) {
	            _this.empresas = data;
	            if (data.length > 0)
	                _this.cambiarSucursales(data[0]._id);
	        });
	        this.permisos = new Map();
	        this.permisoService.getPermiso("alarma").subscribe(function (permisos) {
	            for (var _i = 0, _a = permisos.tipoPermiso; _i < _a.length; _i++) {
	                var permiso = _a[_i];
	                _this.permisos.set(permiso.descripcion, true);
	            }
	            //Si no tiene permiso para ver redirijo
	            if (!_this.permisos.get("read"))
	                _this.router.navigate(['/home']);
	        });
	        //Inicializar tabla
	        $("#alertSeleccion").hide();
	        //Ocultar la barra cuando hace click afuera
	        if ($(window).width() < 769)
	            $(document).bind("mouseup touchend", function (e) {
	                console.log(e.target);
	                var container = $("#barraSelectora");
	                if (!container.is(e.target) // if the target of the click isn't the container...
	                    && container.has(e.target).length === 0
	                    && e.target.id != "iconoBarraSelectora" && e.target.className != "botonConfig" && e.target.id != "desBarraSelectora"
	                    && e.target.id != "flechaBarraSelectora") {
	                    $('#barraSelectora').css("display", "none");
	                }
	            });
	    };
	    AlarmasComponent.prototype.ngOnDestroy = function () {
	    };
	    AlarmasComponent.prototype.cambiarSucursales = function (id) {
	        var _this = this;
	        this.idSensores = [];
	        this.idNodos = [];
	        $("#grid-dataNodo").bootgrid("destroy");
	        $("#grid-data").bootgrid("destroy");
	        this.sucursalService.getSucursalByEmpresa(id).subscribe(function (data) {
	            _this.sucursales = data;
	            if (data.length > 0) {
	                //Calcular fechaDesde para mostrar histórico
	                var fechaDesde = new Date();
	                fechaDesde.setDate(fechaDesde.getDate() - data[0].historico_dias);
	                _this.fechaDesde = fechaDesde.toISOString().substring(0, 10);
	                _this.cambiarSensores(data[0]._id);
	            }
	            else {
	                _this.sucursales = [];
	                _this.ubicaciones = [];
	            }
	        });
	    };
	    AlarmasComponent.prototype.buscarAlarmas = function (e, sensor) {
	        if (e.target.checked) {
	            var index = this.idSensores.indexOf(sensor._id);
	            if (index == -1) {
	                this.idSensores.push(sensor._id);
	            }
	            this.idNodos.push(sensor.nodo_id);
	            this.noData = false;
	            //Alarmas Por Sensor
	            $("#grid-data").bootgrid({
	                ajax: true,
	                selection: true,
	                multiSelect: false,
	                rowSelect: false,
	                formatters: {
	                    "nodo": function (column, row) {
	                        return row.nodo_id != undefined ? row.nodo_id.nombre : "Nodo sin nombre";
	                    },
	                    "sensor": function (column, row) {
	                        return row.sensor_id != undefined ? row.sensor_id.etiqueta : "Sensor sin etiqueta";
	                    },
	                    "valorMinimo": function (column, row) {
	                        return row.alarma_id != undefined ? row.valorMinimo : row.tipoEspecial;
	                    },
	                    "valorMaximo": function (column, row) {
	                        return row.alarma_id != undefined ? row.valorMaximo : row.tipoEspecial;
	                    },
	                    "color": function (column, row) {
	                        if (row.color == 'Amarillo')
	                            return "<span class='label label-warning'>Amarillo</span>";
	                        else
	                            return "<span class='label label-danger'>Rojo</span>";
	                    },
	                    "fechaActivado": function (column, row) {
	                        var date_str = row.fechaActivado;
	                        if (moment(date_str).isValid())
	                            return moment(date_str).utcOffset(this.offsetTimeZone).format("DD-MM-YYYY HH:mm");
	                        else
	                            return "";
	                    }.bind(this),
	                    "fechaDesactivado": function (column, row) {
	                        if (row.fechaDesactivado != null) {
	                            var date_str = row.fechaDesactivado;
	                            if (moment(date_str).isValid())
	                                return moment(date_str).utcOffset(this.offsetTimeZone).format("DD-MM-YYYY HH:mm");
	                            else
	                                return "";
	                        }
	                        else {
	                            return "Aún activa";
	                        }
	                    }.bind(this)
	                },
	                ajaxSettings: {
	                    headers: {
	                        "Authorization": this.loginService.getToken()
	                    },
	                    method: "GET"
	                },
	                requestHandler: function (request) {
	                    request.sensores = JSON.stringify({ sensores_id: this.idSensores });
	                    if (this.fechaDesde != null) {
	                        request.fechaDesde = moment(this.fechaDesde).utcOffset(this.offsetTimeZone).startOf("day").format();
	                    }
	                    if (this.fechaHasta != null) {
	                        request.fechaHasta = moment(this.fechaHasta).utcOffset(this.offsetTimeZone).endOf("day").format();
	                    }
	                    return request;
	                }.bind(this),
	                url: myGlobals.default.BASE_URL + "/regAlarma/regAlarmasTable/"
	            }).bind(this);
	            $("#grid-data").bootgrid("reload");
	            //Alarmas Por nodo
	            var buscarAlarmasPorNodo = true;
	            /*for (let i = 0; i < this.regAlarmaNodos.length; i++) {
	             let alarma = this.regAlarmaNodos[i];
	             if (alarma.nodo_id != null && alarma.nodo_id._id == sensor.nodo_id._id) {
	             buscarAlarmasPorNodo = false;
	             break;
	             }
	             }*/
	            //let buscarAlarmasPorNodo = true;
	            if (buscarAlarmasPorNodo)
	                $("#grid-dataNodo").bootgrid({
	                    ajax: true,
	                    selection: true,
	                    multiSelect: false,
	                    rowSelect: false,
	                    formatters: {
	                        "nodo": function (column, row) {
	                            return row.nodo_id.nombre;
	                        },
	                        "tipoAlarma": function (column, row) {
	                            return row.tipoEspecial == null ? "Alarma por rango" : (row.tipoEspecial == "SINACTIVIDAD" ? "Sin Actividad" : "Bateria Baja");
	                        },
	                        "fechaActivado": function (column, row) {
	                            var date_str = row.fechaActivado;
	                            if (moment(date_str).isValid())
	                                return moment(date_str).utcOffset(this.offsetTimeZone).format("DD-MM-YYYY HH:mm");
	                            else
	                                return "";
	                        }.bind(this),
	                        "fechaDesactivado": function (column, row) {
	                            if (row.fechaDesactivado != null) {
	                                var date_str = row.fechaDesactivado;
	                                if (moment(date_str).isValid())
	                                    return moment(date_str).utcOffset(this.offsetTimeZone).format("DD-MM-YYYY HH:mm");
	                                else
	                                    return "";
	                            }
	                            else {
	                                return "Aún activa";
	                            }
	                        }.bind(this)
	                    },
	                    ajaxSettings: {
	                        headers: {
	                            "Authorization": this.loginService.getToken()
	                        },
	                        method: "GET"
	                    },
	                    requestHandler: function (request) {
	                        if (sensor != undefined) {
	                            request.sensores = JSON.stringify({ sensores_id: this.idSensores });
	                            request.nodo = JSON.stringify({ nodos: this.idNodos });
	                        }
	                        if (this.fechaDesde != null) {
	                            request.fechaDesde = moment(this.fechaDesde).utcOffset(this.offsetTimeZone).startOf("day").format();
	                        }
	                        if (this.fechaHasta != null) {
	                            request.fechaHasta = moment(this.fechaHasta).utcOffset(this.offsetTimeZone).endOf("day").format();
	                        }
	                        return request;
	                    }.bind(this),
	                    url: myGlobals.default.BASE_URL + "/regAlarma/regAlarmasTableNodo/"
	                }).bind(this);
	            $("#grid-dataNodo").bootgrid("reload");
	            for (var _i = 0, _a = this.ubicaciones; _i < _a.length; _i++) {
	                var ubicacion = _a[_i];
	                for (var _b = 0, _c = ubicacion.sensores; _b < _c.length; _b++) {
	                    var sensor_1 = _c[_b];
	                    $("#" + sensor_1._id).attr('disabled', false);
	                }
	            }
	        }
	        else {
	            var index = this.idSensores.indexOf(sensor._id);
	            if (index != -1) {
	                this.idSensores.splice(index, 1);
	            }
	            var index = this.idNodos.indexOf(sensor.nodo_id);
	            if (index != -1) {
	                this.idNodos.splice(index, 1);
	            }
	            $("#grid-data").bootgrid("reload");
	            $("#grid-dataNodo").bootgrid("reload");
	        }
	    };
	    AlarmasComponent.prototype.cambiarFecha = function () {
	        for (var _i = 0, _a = this.ubicaciones; _i < _a.length; _i++) {
	            var ubicacion = _a[_i];
	            for (var _b = 0, _c = ubicacion.sensores; _b < _c.length; _b++) {
	                var sensor = _c[_b];
	                if (document.getElementById(sensor._id).checked == true) {
	                    this.idSensores = [];
	                    this.idNodos = [];
	                    $("#grid-data").bootgrid("reload");
	                    $("#grid-dataNodo").bootgrid("reload");
	                    $("#" + sensor._id).attr('checked', false);
	                    var e = { target: document.getElementById(sensor._id) };
	                }
	            }
	        }
	    };
	    AlarmasComponent.prototype.cambiarSensores = function (id) {
	        var _this = this;
	        this.idSensores = [];
	        this.idNodos = [];
	        $("#grid-dataNodo").bootgrid("destroy");
	        $("#grid-data").bootgrid("destroy");
	        //Calcular fechaDesde
	        for (var _i = 0, _a = this.sucursales; _i < _a.length; _i++) {
	            var sucursal = _a[_i];
	            if (sucursal._id == id) {
	                this.sucursalSeleccionada = sucursal;
	                if (sucursal && sucursal.husoHorario_id && sucursal.husoHorario_id.offset)
	                    this.offsetTimeZone = sucursal.husoHorario_id.offset;
	                else
	                    this.offsetTimeZone = "-03:00";
	                break;
	            }
	        }
	        var fechaDesde = new Date();
	        fechaDesde.setDate(fechaDesde.getDate() - this.sucursalSeleccionada.historico_dias);
	        this.fechaDesde = fechaDesde.toISOString().substring(0, 10);
	        this.ubicaciones = [];
	        //Buscar sensores
	        this.nodoService.getNodosBySucursal(id)
	            .subscribe(function (data) {
	            var i = 0;
	            var ubicacionAnt = null;
	            var nodo = null;
	            _this.nodos = data;
	            var ubicacion = null;
	            _this.ubicaciones = [];
	            while (i < _this.nodos.length) {
	                nodo = _this.nodos[i];
	                ubicacionAnt = nodo.ubicacion_id._id;
	                ubicacion = new ubicacion_1.Ubicacion();
	                ubicacion = nodo.ubicacion_id;
	                ubicacion.sensores = [];
	                while (i < _this.nodos.length && ubicacionAnt == nodo.ubicacion_id._id) {
	                    ubicacion.sensores = ubicacion.sensores.concat(nodo.sensores_id);
	                    i++;
	                    nodo = _this.nodos[i];
	                }
	                _this.ubicaciones.push(ubicacion);
	            }
	        });
	    };
	    AlarmasComponent.prototype.ocultarBarraSelectora = function () {
	        if ($('#barraSelectora').css("display") == "block")
	            $('#barraSelectora').css("display", "none");
	        else
	            $('#barraSelectora').css("display", "block");
	    };
	    AlarmasComponent = __decorate([
	        core_1.Component({
	            selector: 'alarmas',
	            template: __webpack_require__(923),
	            styles: [__webpack_require__(924)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof usuario_service_1.UsuariosService !== 'undefined' && usuario_service_1.UsuariosService) === 'function' && _a) || Object, (typeof (_b = typeof sucursal_service_1.SucursalService !== 'undefined' && sucursal_service_1.SucursalService) === 'function' && _b) || Object, (typeof (_c = typeof empresa_service_1.EmpresaService !== 'undefined' && empresa_service_1.EmpresaService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _d) || Object, (typeof (_e = typeof login_service_1.LoginService !== 'undefined' && login_service_1.LoginService) === 'function' && _e) || Object, (typeof (_f = typeof permiso_service_1.PermisoService !== 'undefined' && permiso_service_1.PermisoService) === 'function' && _f) || Object, (typeof (_g = typeof rol_service_1.RolService !== 'undefined' && rol_service_1.RolService) === 'function' && _g) || Object, (typeof (_h = typeof regAlarma_service_1.RegAlarmaService !== 'undefined' && regAlarma_service_1.RegAlarmaService) === 'function' && _h) || Object, (typeof (_j = typeof nodo_service_1.NodoService !== 'undefined' && nodo_service_1.NodoService) === 'function' && _j) || Object, (typeof (_k = typeof medicion_service_1.MedicionService !== 'undefined' && medicion_service_1.MedicionService) === 'function' && _k) || Object, (typeof (_l = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _l) || Object])
	    ], AlarmasComponent);
	    return AlarmasComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
	}());
	exports.AlarmasComponent = AlarmasComponent;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(419)))

/***/ }),
/* 923 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 contenido\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 titulo\">\n        <div class=\"marcoTitulo\">\n            <h2>Alarmas</h2>\n            <p>Home / Alarmas</p>\n        </div>\n    </div>\n    <div class=\"botonConfig visible-xs col-xs-12\" (click)=\"ocultarBarraSelectora()\">\n        <div id=\"iconoBarraSelectora\" class=\"col-xs-2\">\n            <i class=\"fa fa-cogs fa-spin fa-2x fa-fw\" style=\"color:white\"></i>\n        </div>\n        <div id=\"desBarraSelectora\" class=\"col-xs-10\" style=\"text-align: left;padding-left: 35px;\">\n            Seleccione las variables ...\n            <b class=\"caret\" id=\"flechaBarraSelectora\"></b>\n        </div>\n    </div>\n    <div id=\"barraSelectora\" class=\"col-lg-3 col-md-3 col-sm-3 col-xs-12 barraArbolBase\" [ngClass]=\"{'barraArbolBaseOcultar':!abierto}\">\n        <div class=\"barraArbolCuerpo\" [ngClass]=\"{'barraArbolCuerpoOcultar':!abierto}\">\n            <div class=\"informacionArbol\" style=\"max-height: inherit; height: inherit;\">\n                <div class=\"form-group\">\n                    <label for=\"sucursal\">Empresa</label>\n                    <select class=\"form-control\" id=\"empresa\" placeholder=\"Empresa\" (change)=\"cambiarSucursales($event.target.value)\">\n                        <option *ngFor=\"let empresa of empresas\" value={{empresa._id}}>{{empresa.descripcion}}</option>\n                    </select>\n                </div>\n                <div class=\"form-group\">\n                    <label for=\"sucursal\">Sucursal</label>\n                    <select class=\"form-control\" id=\"sucursal\" placeholder=\"Sucursal\" (change)=\"cambiarSensores($event.target.value)\">\n                        <option *ngFor=\"let sucursal of sucursales\" value={{sucursal._id}}>{{sucursal.descripcion}}\n                        </option>\n                    </select>\n                </div>\n                <p>{{sucursalSeleccionada && sucursalSeleccionada.husoHorario_id ? sucursalSeleccionada.husoHorario_id.zonaHoraria + \" (\" + offsetTimeZone + \")\" : \"\"}}</p>\n                <div class=\"form-group\">\n                    <label for=\"sucursal\">Fecha Desde</label>\n                    <input type=\"date\" class=\"form-control\" id=\"fechaDesde\" [(ngModel)]=\"fechaDesde\" (change)=\"cambiarFecha()\" />\n                </div>\n                <div class=\"form-group\">\n                    <label for=\"sucursal\">Fecha Hasta</label>\n                    <input type=\"date\" class=\"form-control\" id=\"fechaHasta\" [(ngModel)]=\"fechaHasta\" (change)=\"cambiarFecha()\" />\n                </div>\n                <div class=\"checkbox checkbox-warning\">\n                    <input type=\"checkbox\" id=\"mostrarEliminados\" [(ngModel)]=\"mostrarEliminados\">\n                    <label> Mostrar Eliminados </label>\n                </div>\n                <div class=\"panel-group\" id=\"accordion\">\n                    <template ngFor let-ubicacion=\"$implicit\" [ngForOf]=\"ubicaciones\" let-index=\"index\">\n                        <div class=\"panel panel-default\">\n                            <div class=\"panel-heading\">\n                                <h4 class=\"panel-title\">\n                                        <a data-toggle=\"collapse\" data-parent=\"#accordion\" href=\"#collapseOne\">\n                                            {{ubicacion.descripcion}}\n                                        </a>\n                                    </h4>\n                            </div>\n                            <div id=\"collapseOne\" class=\"panel-collapse collapse in\">\n                                <div class=\"panel-body\">\n                                    <template ngFor let-sensor [ngForOf]=\"ubicacion.sensores\" let-index=\"index2\">\n                                        <div [hidden]=\"!(mostrarEliminados || sensor.estado) || (sensor.posicionString == 9  && usuarioConectado.rol != 'Administrador' && usuarioConectado.rol != 'Tecnico')\">\n                                            <div class=\"checkbox checkbox-warning\">\n                                                <input type=\"checkbox\" value={{sensor._id}} id={{sensor._id}} (change)=\"buscarAlarmas($event,sensor)\">\n                                                <label> {{sensor.etiqueta}}\n                                                    <span style=\"padding-right: 10px; color: red; vertical-align: middle;\" *ngIf=\"!sensor.estado\" class=\"glyphicon glyphicon-remove\"></span>\n                                                </label>\n                                            </div>\n                                        </div>\n                                    </template>\n                                </div>\n                            </div>\n                        </div>\n                    </template>\n                </div>\n            </div>\n        </div>\n        <div class=\"barraArbolBoton hidden-xs\">\n            <button (click)=\"abierto=!abierto\"><i class=\"fa fa-cogs fa-spin fa-1x fa-fw\" style=\"color:white\"></i></button>\n        </div>\n    </div>\n    <div [ngClass]=\"{'medicionesComprimido':abierto,'medicionesExtendido':!abierto,'col-lg-9':abierto,'col-md-9':abierto,'col-sm-9':abierto,'col-xs-12':true,'col-lg-12':!abierto,'col-md-12':!abierto,'col-sm-12':!abierto}\" style=\"max-height: inherit; height: inherit; min-height: 100vh;\">\n        <div class=\"datos col-lg-12 col-md-12 col-sm-12 col-xs-12\" [style.display]=\"idNodos.length>0 ?'block':'none'\">\n            <ul class=\"nav nav-tabs\">\n                <li class=\"active\"><a data-toggle=\"tab\" href=\"#sensor\">Canal de Monitorización</a></li>\n                <li><a data-toggle=\"tab\" href=\"#nodo\">Nodo</a></li>\n            </ul>\n            <div class=\"tab-content\">\n                <div id=\"sensor\" class=\"tab-pane fade in active\">\n                    <h3>Alarmas por Canal de Monitorización</h3>\n                    <div class=\"table-responsive\">\n                        <table id=\"grid-data\" class=\"table table-condensed table-hover \">\n                            <thead>\n                                <tr>\n                                    <!--<th data-column-id=\"_id\" data-identifier=\"true\" data-visible=\"false\" data-visible-in-selection=\"false\">_id</th>-->\n                                    <th data-column-id=\"nodo_id\" data-formatter=\"nodo\">Nodo</th>\n                                    <th data-column-id=\"sensor_id\" data-formatter=\"sensor\">Canal de Monitorización</th>\n                                    <th data-column-id=\"fechaActivado\" data-formatter=\"fechaActivado\" data-order=\"desc\"> Fecha Activación</th>\n                                    <th data-column-id=\"fechaDesactivado\" data-formatter=\"fechaDesactivado\">Fecha Normalización</th>\n                                    <th data-column-id=\"color\" data-formatter=\"color\">Color</th>\n                                    <th data-column-id=\"valorMinimo\" data-formatter=\"valorMinimo\">Valor Mínimo</th>\n                                    <th data-column-id=\"valorMaximo\" data-formatter=\"valorMaximo\">Valor Máximo</th>\n                                    <th data-column-id=\"valorMedido\">Valor Detectado</th>\n                                    <th data-column-id=\"promedio\">Promedio</th>\n                                </tr>\n                            </thead>\n                            <tbody>\n                            </tbody>\n                        </table>\n                    </div>\n                </div>\n                <div id=\"nodo\" class=\"tab-pane fade\">\n                    <h3>Alarmas por Nodo</h3>\n                    <div class=\"table-responsive\">\n                        <table id=\"grid-dataNodo\" class=\"table table-condensed table-hover \">\n                            <thead>\n                                <tr>\n                                    <!--<th data-column-id=\"_id\" data-identifier=\"true\" data-visible=\"false\" data-visible-in-selection=\"false\">_id</th>-->\n                                    <th data-column-id=\"nodo\" data-formatter=\"nodo\">Nodo</th>\n                                    <th data-column-id=\"tipoAlarma\" data-formatter=\"tipoAlarma\">Tipo Alarma</th>\n                                    <th data-column-id=\"fechaActivado\" data-formatter=\"fechaActivado\" data-order=\"desc\"> Fecha Activación</th>\n                                    <th data-column-id=\"fechaDesactivado\" data-formatter=\"fechaDesactivado\">Fecha Normalización</th>\n                                    <!--  <th data-column-id=>Valor Detectado</th> -->\n                                </tr>\n                            </thead>\n                            <tbody>\n                            </tbody>\n                        </table>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div *ngIf=\"idNodos.length==0\" class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 noChartData\" style=\"text-align: center\">\n            <span class=\"glyphicon glyphicon-check nota\" aria-hidden=\"true\" style=\"font-size: 70px; padding: 20px\"></span>\n            <h2 class=\"nota\">Seleccione las variables que quiera observar</h2>\n        </div>\n    </div>\n    <div class=\"clearfix visible-lg-block\"></div>\n    <div class=\"clearfix visible-md-block\"></div>\n    <div class=\"clearfix visible-sm-block\"></div>\n    <div class=\"clearfix visible-xs-block\"></div>\n</div>\n";

/***/ }),
/* 924 */
/***/ (function(module, exports) {

	module.exports = "h3 {\n    font-family: \"Raleway\" !important;\n    border-bottom: 1px solid #ccc9c9;\n    padding-bottom: 15px;\n    padding-right: 10px;\n    padding-left: 10px;\n    margin-bottom: 20px;\n    font-size: 18px;\n    font-weight: 300;\n}"

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var platform_browser_1 = __webpack_require__(259);
	var empresa_service_1 = __webpack_require__(425);
	var provincia_service_1 = __webpack_require__(426);
	var permiso_service_1 = __webpack_require__(427);
	var notificacion_service_1 = __webpack_require__(894);
	var login_service_1 = __webpack_require__(381);
	var empresa_1 = __webpack_require__(926);
	var contacto_1 = __webpack_require__(927);
	var recargaCredito_service_1 = __webpack_require__(895);
	var router_1 = __webpack_require__(329);
	var recargaCredito_component_1 = __webpack_require__(928);
	var plan_service_1 = __webpack_require__(899);
	__webpack_require__(653);
	var myGlobals = __webpack_require__(414);
	var EmpresaComponent = (function () {
	    function EmpresaComponent(empresaService, provinciaService, notificacionService, recargaCreditoService, planService, route, loginService, permisoService, sanitizer, router) {
	        this.empresaService = empresaService;
	        this.provinciaService = provinciaService;
	        this.notificacionService = notificacionService;
	        this.recargaCreditoService = recargaCreditoService;
	        this.planService = planService;
	        this.route = route;
	        this.loginService = loginService;
	        this.permisoService = permisoService;
	        this.sanitizer = sanitizer;
	        this.router = router;
	    }
	    EmpresaComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        window.scrollTo(0, 0);
	        //Pedir permisos
	        this.urlLogo = "";
	        this.permisos = new Map();
	        this.permisoService.getPermiso("empresa").subscribe(function (permisos) {
	            for (var _i = 0, _a = permisos.tipoPermiso; _i < _a.length; _i++) {
	                var permiso = _a[_i];
	                _this.permisos.set(permiso.descripcion, true);
	            }
	            //Si no tiene permiso para ver redirijo
	            if (!_this.permisos.get("read"))
	                _this.router.navigate(['/home']);
	        });
	        this.permisosRecargas = new Map();
	        //Cargar planes
	        this.planService.getPlanes()
	            .subscribe(function (planes) {
	            _this.planes = planes;
	            //Inicializar tabla después de cargar planes
	            $("#grid-data").bootgrid({
	                ajax: true,
	                url: myGlobals.default.BASE_URL + "/empresa/empresasTable",
	                selection: true,
	                multiSelect: false,
	                rowSelect: true,
	                formatters: {
	                    "estado": function (column, row) {
	                        return row.estado == true ? "Activo" : "<span class=\"label label-danger\">Inactivo</span>";
	                    },
	                    "plan": function (column, row) {
	                        if (row.plan) {
	                            var planEncontrado = this.planes.find(function (plan) { return plan._id === row.plan; });
	                            return planEncontrado ? planEncontrado.descripcion : "Plan no encontrado";
	                        }
	                        return "Sin plan asignado";
	                    }.bind(_this)
	                },
	                ajaxSettings: {
	                    headers: {
	                        "Authorization": _this.loginService.getToken()
	                    },
	                    method: "GET"
	                }
	            });
	        });
	        //Cerrar alert
	        $("#alertSeleccion").hide();
	        //Inicializar banderas para resetear forms
	        this.active = true;
	        this.active2 = true;
	        //Incializar contacto
	        this.contacto = new contacto_1.Contacto();
	        //Inicializar empresa
	        this.empresa = new empresa_1.Empresa();
	        this.empresa.contacto = [];
	        //Inicilizar bandera
	        this.modificoContacto = false;
	        //Inicializar bandera deshabilitar
	        this.deshabilitar = true;
	        //Cargar provincias
	        this.provinciaService.getProvincias()
	            .subscribe(function (provincias) {
	            _this.provincias = provincias;
	        });
	        this.mensajesRecargasMes = 0;
	        this.mensajesGastadosMes = 0;
	        this.getRecargasMensajes = this.getRecargasMensajes.bind(this);
	        this.usuario = this.loginService.getDecodeToken();
	    };
	    EmpresaComponent.prototype.ngOnDestroy = function () {
	    };
	    EmpresaComponent.prototype.agregar = function () {
	        //Inicializo variables
	        this.empresa = new empresa_1.Empresa();
	        this.contacto = new contacto_1.Contacto();
	        this.mensajesGastadosMes = 0;
	        this.notificaciones = null;
	        this.mensajesRecargasMes = 0;
	        this.recargasCredito = null;
	        //Seteo bandera para deshabilitar
	        this.deshabilitar = false;
	        this.urlLogo = "";
	        this.filesToUpload = "";
	        this.modificoContacto = false;
	        //Muestro modal
	        $("#modalEmpresa").modal("show");
	        //Cerrar alert
	        $("#alertSeleccion").hide();
	    };
	    EmpresaComponent.prototype.modificar = function () {
	        var _this = this;
	        //Limpio foto
	        this.urlLogo = "";
	        this.filesToUpload = "";
	        this.modificoContacto = false;
	        //Obtener id seleccionado
	        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
	        //Si no hay nada seleccionado mostrar alert
	        if (this.idSeleccionado == undefined) {
	            $("#alertSeleccion").show();
	        }
	        else {
	            if (this.idSeleccionado != "0") {
	                //Cerrar alert
	                $("#alertSeleccion").hide();
	                //Busco empresa
	                this.empresaService
	                    .getEmpresa(this.idSeleccionado)
	                    .subscribe(function (empresa) {
	                    //Cargo datos de la empresa
	                    _this.empresa = empresa;
	                    _this.cambiarLocalidades(empresa.provincia);
	                    //Cargo foto
	                    var byteArray = new Uint8Array(empresa.logo.data.data);
	                    var file = new Blob([byteArray], { type: empresa.logo.contentType });
	                    var reader = new FileReader();
	                    reader.onloadend = function () {
	                        this.urlLogo = reader.result;
	                    }.bind(_this);
	                    if (file) {
	                        reader.readAsDataURL(file);
	                    }
	                    else {
	                        _this.urlLogo = "";
	                    }
	                });
	                //Pedir notificaciones
	                this.mensajesGastadosMes = 0;
	                this.notificaciones = null;
	                this.notificacionService.getResumenNotificaciones(this.idSeleccionado).subscribe(function (resumenNotificaciones) {
	                    _this.notificaciones = resumenNotificaciones;
	                    _this.notificaciones.some(function (notificacion) {
	                        if (notificacion._id.year == new Date().getFullYear() &&
	                            notificacion._id.month == new Date().getMonth() + 1) {
	                            _this.mensajesGastadosMes += notificacion.total;
	                            return true;
	                        }
	                    });
	                });
	                //Pedir recargas
	                this.getRecargasMensajes();
	                //Seteo bandera para deshabilitar
	                this.deshabilitar = false;
	                //Muestro modal
	                $("#modalEmpresa").modal("show");
	            }
	        }
	    };
	    EmpresaComponent.prototype.eliminar = function () {
	        var _this = this;
	        //Obtener id seleccionado
	        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
	        //Si no hay nada seleccionado mostrar alert
	        if (this.idSeleccionado == undefined) {
	            $("#alertSeleccion").show();
	        }
	        else {
	            if (this.idSeleccionado != "0") {
	                //Cerrar alert
	                $("#alertSeleccion").hide();
	                //Busco empresa
	                this.empresaService
	                    .getEmpresa(this.idSeleccionado)
	                    .subscribe(function (empresa) {
	                    _this.empresaService.delete(empresa).subscribe(function () { return $("#grid-data").bootgrid("reload"); });
	                });
	            }
	        }
	    };
	    EmpresaComponent.prototype.ver = function () {
	        var _this = this;
	        //Limpio foto
	        this.urlLogo = "";
	        this.filesToUpload = "";
	        //Obtener id seleccionado
	        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
	        //Si no hay nada seleccionado mostrar alert
	        if (this.idSeleccionado == undefined) {
	            $("#alertSeleccion").show();
	        }
	        else {
	            if (this.idSeleccionado != "0") {
	                //Cerrar alert
	                $("#alertSeleccion").hide();
	                //Busco empresa
	                this.empresaService
	                    .getEmpresa(this.idSeleccionado)
	                    .subscribe(function (empresa) {
	                    _this.cambiarLocalidades(empresa.provincia);
	                    _this.empresa = empresa;
	                    if (empresa.logo) {
	                        var byteArray = new Uint8Array(empresa.logo.data.data);
	                        var file = new Blob([byteArray], { type: empresa.logo.contentType });
	                        var reader = new FileReader();
	                        reader.onloadend = function () {
	                            this.urlLogo = reader.result;
	                        }.bind(_this);
	                        if (file) {
	                            reader.readAsDataURL(file);
	                        }
	                        else {
	                            _this.urlLogo = "";
	                        }
	                    }
	                });
	                //Pedir notificaciones
	                this.mensajesGastadosMes = 0;
	                this.notificaciones = null;
	                this.notificacionService.getResumenNotificaciones(this.idSeleccionado).subscribe(function (resumenNotificaciones) {
	                    _this.notificaciones = resumenNotificaciones;
	                    _this.notificaciones.some(function (notificacion) {
	                        if (notificacion._id.year == new Date().getFullYear() &&
	                            notificacion._id.month == new Date().getMonth() + 1) {
	                            _this.mensajesGastadosMes += notificacion.total;
	                            return true;
	                        }
	                    });
	                });
	                //Pedir recargas
	                this.getRecargasMensajes();
	                //Seteo bandera para deshabilitar
	                this.deshabilitar = true;
	                //Muestro modal
	                $("#modalEmpresa").modal("show");
	            }
	        }
	    };
	    EmpresaComponent.prototype.save = function () {
	        var _this = this;
	        this.empresaService
	            .save(this.empresa, this.filesToUpload)
	            .subscribe(function (empresa) {
	            _this.empresa = empresa;
	            //Inicializo variables
	            _this.empresa = new empresa_1.Empresa();
	            //this.empresa.logo=this.filesToUpload;
	            _this.contacto = new contacto_1.Contacto();
	            //Ocultar modal
	            $("#modalEmpresa").modal("hide");
	            //Reseteo formEmpresa para eliminar errores
	            _this.active = false;
	            setTimeout(function () { return _this.active = true; }, 0);
	            //Recargo tabla
	            $("#grid-data").bootgrid("reload");
	        });
	    };
	    EmpresaComponent.prototype.getRecargasMensajes = function () {
	        var _this = this;
	        this.mensajesRecargasMes = 0;
	        this.recargasCredito = null;
	        if (this.permisosRecargas.get("read"))
	            this.recargaCreditoService.getRecargasCreditoByEmpresa(this.idSeleccionado).subscribe(function (recargas) {
	                _this.recargasCredito = recargas;
	                _this.recargasCredito.forEach(function (recarga) {
	                    if (new Date(recarga.fechaRecarga).getFullYear() == new Date().getFullYear() &&
	                        new Date(recarga.fechaRecarga).getMonth() == new Date().getMonth() && recarga.estado) {
	                        _this.mensajesRecargasMes += recarga.valor;
	                    }
	                });
	            });
	    };
	    EmpresaComponent.prototype.agregarContacto = function () {
	        var _this = this;
	        if (!this.modificoContacto) {
	            //Inicializar arreglo
	            if (this.empresa.contacto == undefined)
	                this.empresa.contacto = [];
	            //Agregar contacto
	            this.empresa.contacto.push(this.contacto);
	            //Limpiar contacto
	            this.contacto = new contacto_1.Contacto();
	        }
	        else {
	            //Limpiar contacto
	            this.contacto = new contacto_1.Contacto();
	            //Seteo bandera
	            this.modificoContacto = false;
	        }
	        //Reseteo formContacto para eliminar errores
	        setTimeout(function () { return _this.active2 = false; }, 0);
	        setTimeout(function () { return _this.active2 = true; }, 0);
	    };
	    EmpresaComponent.prototype.modificarContacto = function (index) {
	        //Traer contacto
	        this.contacto = this.empresa.contacto[index];
	        //Seteo bandera
	        this.modificoContacto = true;
	    };
	    EmpresaComponent.prototype.eliminarContacto = function (index) {
	        //Eliminar contacto de la lista
	        this.empresa.contacto.splice(index, 1);
	    };
	    EmpresaComponent.prototype.hideAlert = function () {
	        $("#alertSeleccion").hide();
	    };
	    EmpresaComponent.prototype.cambiarLocalidades = function (nombre) {
	        var _this = this;
	        this.provinciaService.getProvincia(nombre)
	            .subscribe(function (provincia) {
	            _this.localidades = provincia.localidades;
	        });
	    };
	    EmpresaComponent.prototype.verFoto = function (input) {
	        if (input.files.length > 0) {
	            var file = input.files[0];
	            if (file.size > 1000000) {
	                alert("La imagen no puede pesar mas de 1 mb.");
	            }
	            else {
	                var reader = new FileReader();
	                reader.onloadend = function () {
	                    this.urlLogo = this.sanitizer.bypassSecurityTrustUrl(reader.result);
	                }.bind(this);
	                if (file) {
	                    reader.readAsDataURL(file);
	                }
	                else {
	                    this.urlLogo = "";
	                }
	                this.filesToUpload = file;
	            }
	        }
	    };
	    EmpresaComponent.prototype.cerrarModal = function () {
	        var _this = this;
	        //Reseteo formEmpresa para eliminar errores
	        this.active = false;
	        setTimeout(function () { return _this.active = true; }, 0);
	        //Reseteo formContacto para eliminar errores
	        setTimeout(function () { return _this.active2 = false; }, 0);
	        setTimeout(function () { return _this.active2 = true; }, 0);
	        this.empresa = new empresa_1.Empresa();
	        $("#modalEmpresa").modal("hide");
	    };
	    EmpresaComponent = __decorate([
	        core_1.Component({
	            selector: 'empresa',
	            template: __webpack_require__(932),
	            styles: [__webpack_require__(937)],
	            directives: [recargaCredito_component_1.RecargaCreditoComponent],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof empresa_service_1.EmpresaService !== 'undefined' && empresa_service_1.EmpresaService) === 'function' && _a) || Object, (typeof (_b = typeof provincia_service_1.ProvinciaService !== 'undefined' && provincia_service_1.ProvinciaService) === 'function' && _b) || Object, (typeof (_c = typeof notificacion_service_1.NotificacionService !== 'undefined' && notificacion_service_1.NotificacionService) === 'function' && _c) || Object, (typeof (_d = typeof recargaCredito_service_1.RecargaCreditoService !== 'undefined' && recargaCredito_service_1.RecargaCreditoService) === 'function' && _d) || Object, (typeof (_e = typeof plan_service_1.PlanService !== 'undefined' && plan_service_1.PlanService) === 'function' && _e) || Object, (typeof (_f = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _f) || Object, (typeof (_g = typeof login_service_1.LoginService !== 'undefined' && login_service_1.LoginService) === 'function' && _g) || Object, (typeof (_h = typeof permiso_service_1.PermisoService !== 'undefined' && permiso_service_1.PermisoService) === 'function' && _h) || Object, (typeof (_j = typeof platform_browser_1.DomSanitizationService !== 'undefined' && platform_browser_1.DomSanitizationService) === 'function' && _j) || Object, (typeof (_k = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _k) || Object])
	    ], EmpresaComponent);
	    return EmpresaComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
	}());
	exports.EmpresaComponent = EmpresaComponent;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(419)))

/***/ }),
/* 926 */
/***/ (function(module, exports) {

	"use strict";
	var Empresa = (function () {
	    function Empresa() {
	    }
	    return Empresa;
	}());
	exports.Empresa = Empresa;


/***/ }),
/* 927 */
/***/ (function(module, exports) {

	"use strict";
	var Contacto = (function () {
	    function Contacto() {
	    }
	    return Contacto;
	}());
	exports.Contacto = Contacto;


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var platform_browser_1 = __webpack_require__(259);
	var recargaCredito_service_1 = __webpack_require__(895);
	var permiso_service_1 = __webpack_require__(427);
	var recargaCredito_1 = __webpack_require__(929);
	var router_1 = __webpack_require__(329);
	__webpack_require__(653);
	var RecargaCreditoComponent = (function () {
	    function RecargaCreditoComponent(recargaCreditoService, permisoService, sanitizer, router) {
	        this.recargaCreditoService = recargaCreditoService;
	        this.permisoService = permisoService;
	        this.sanitizer = sanitizer;
	        this.router = router;
	        this.permisos = new core_1.EventEmitter();
	    }
	    RecargaCreditoComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        window.scrollTo(0, 0);
	        //Inicializar banderas para resetear forms
	        this.active = true;
	        //Inicializar recargaCredito
	        this.recargaCredito = new recargaCredito_1.RecargaCredito();
	        //Inicializar bandera deshabilitar
	        this.deshabilitar = false;
	        //Pedir permisos
	        var resultadoPermisos = new Map();
	        this.permisoService.getPermiso("recargaCredito").subscribe(function (permisos) {
	            if (permisos.tipoPermiso)
	                for (var _i = 0, _a = permisos.tipoPermiso; _i < _a.length; _i++) {
	                    var permiso = _a[_i];
	                    resultadoPermisos.set(permiso.descripcion, true);
	                }
	            _this.permisos.emit({ permisos: resultadoPermisos });
	            //Si no tiene permiso para ver redirijo
	            if (!resultadoPermisos.get("read"))
	                _this.deshabilitar = true;
	        });
	    };
	    RecargaCreditoComponent.prototype.ngOnDestroy = function () {
	    };
	    RecargaCreditoComponent.prototype.eliminar = function (idRecarga) {
	        var _this = this;
	        this.recargaCreditoService.delete(idRecarga).subscribe(function (recargaCredito) {
	            setTimeout(function () { return $(document.body).addClass('modal-open'); }, 3000);
	            setTimeout(function () { return $(document.body).addClass('modal-open'); }, 4000);
	            _this.getRecargasMensajes();
	        });
	    };
	    RecargaCreditoComponent.prototype.save = function () {
	        var _this = this;
	        this.recargaCredito.empresa_id = this.idEmpresa;
	        this.recargaCreditoService
	            .save(this.recargaCredito)
	            .subscribe(function (recargaCredito) {
	            //Inicializo variables
	            _this.recargaCredito = new recargaCredito_1.RecargaCredito();
	            //Reseteo formEmpresa para eliminar errores
	            _this.active = false;
	            setTimeout(function () { return _this.active = true; }, 0);
	            setTimeout(function () { return $(document.body).addClass('modal-open'); }, 3000);
	            setTimeout(function () { return $(document.body).addClass('modal-open'); }, 4000);
	            _this.getRecargasMensajes();
	        });
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], RecargaCreditoComponent.prototype, "idEmpresa", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], RecargaCreditoComponent.prototype, "recargasCredito", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Number)
	    ], RecargaCreditoComponent.prototype, "mensajesRecargasMes", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], RecargaCreditoComponent.prototype, "getRecargasMensajes", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], RecargaCreditoComponent.prototype, "permisos", void 0);
	    RecargaCreditoComponent = __decorate([
	        core_1.Component({
	            selector: 'recargaCredito',
	            template: __webpack_require__(930),
	            styles: [__webpack_require__(931)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof recargaCredito_service_1.RecargaCreditoService !== 'undefined' && recargaCredito_service_1.RecargaCreditoService) === 'function' && _a) || Object, (typeof (_b = typeof permiso_service_1.PermisoService !== 'undefined' && permiso_service_1.PermisoService) === 'function' && _b) || Object, (typeof (_c = typeof platform_browser_1.DomSanitizationService !== 'undefined' && platform_browser_1.DomSanitizationService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object])
	    ], RecargaCreditoComponent);
	    return RecargaCreditoComponent;
	    var _a, _b, _c, _d;
	}());
	exports.RecargaCreditoComponent = RecargaCreditoComponent;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(419)))

/***/ }),
/* 929 */
/***/ (function(module, exports) {

	"use strict";
	var RecargaCredito = (function () {
	    function RecargaCredito() {
	    }
	    return RecargaCredito;
	}());
	exports.RecargaCredito = RecargaCredito;


/***/ }),
/* 930 */
/***/ (function(module, exports) {

	module.exports = "<div>\n    <div class=\"table-responsive\">\n        <h4>Recargas de crédito</h4>\n        <table class=\"table\">\n            <thead>\n            <tr>\n                <th>Fecha recarga</th>\n                <th>Cantidad de mensajes a recargar</th>\n            </tr>\n\n            <tr *ngFor=\"let recargaCredito of recargasCredito; let i = index\">\n                <ng-container *ngIf=\"recargaCredito.estado\">\n                <td>{{recargaCredito.fechaRecarga | date:'dd/MM/yyyy HH:mm'}}</td>\n                <td>{{recargaCredito.valor}}</td>\n                <td class=\"td-btn\">\n                    <button class=\"btn btn-default\" (click)=\"eliminar(recargaCredito._id)\"\n                            [disabled]=\"deshabilitar\">\n                        <span class=\"glyphicon glyphicon-trash\"></span>\n                    </button>\n                </td>\n                </ng-container>\n            </tr>\n\n            </thead>\n            <tbody>\n            <td class=\"text-center\"\n                *ngIf=\"!recargasCredito|| recargasCredito.length==0\" colspan=\"6\">No\n                hay registros de recargas de crédito\n            </td>\n            </tbody>\n        </table>\n    </div>\n    <form #recargaForm=\"ngForm\" *ngIf=\"active\">\n        <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"\n             style=\"border: 1px solid rgba(176, 176, 178, 0.3); padding-top:15px; padding-bottom:15px\">\n            <h5 style=\"font-family:'Raleway 2'; text-align:center\">Agregar recarga de mensajes</h5>\n            <div class=\"form-group\">\n                <label for=\"valor\">Cantidad de mensajes a recargar</label>\n                <input type=\"number\" class=\"form-control\" id=\"valor\" name=\"valor\" placeholder=\"Cantidad de mensajes a recargar\"\n                       [(ngModel)]=\"recargaCredito.valor\" required #valor=\"ngModel\" autocomplete=\"off\"\n                       [disabled]=\"deshabilitar\">\n                <div [hidden]=\"valor.valid || valor.pristine\" class=\"alert alert-danger\">\n                    Valor de recarga es requerido\n                </div>\n            </div>\n\n            <button class=\"btn btn-block btn-success\"\n                    (click)=\"save()\" [disabled]=\"deshabilitar || !recargaForm.form.valid\">\n                Agregar recarga\n            </button>\n        </div>\n    </form>\n</div>";

/***/ }),
/* 931 */
867,
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 contenido\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 titulo\">\n        <div class=\"marcoTitulo\">\n            <h2>Empresas</h2>\n            <p>Home / Carga Datos / Empresas</p>\n        </div>\n    </div>\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 marcoDatos\">\n        <div class=\"datos\">\n            <div class=\"alert alert-warning\" id=\"alertSeleccion\" name=\"alertSeleccion\">\n                <a class=\"close\" (click)=\"hideAlert()\">&times;</a> Debe selecccionar una casilla primero.\n            </div>\n            <div class=\"table-responsive\">\n                <table id=\"grid-data\" class=\"table table-condensed table-hover \">\n                    <thead>\n                    <tr>\n                        <th data-column-id=\"_id\" data-identifier=\"true\" data-visible=\"false\"\n                            data-visible-in-selection=\"false\" data-order=\"desc\">_id\n                        </th>\n                        <th data-column-id=\"plan\" data-formatter=\"plan\">Plan</th>\n                        <th data-column-id=\"descripcion\">Nombre</th>\n                        <th data-column-id=\"direccion\">Dirección</th>\n                        <th data-column-id=\"localidad\">Localidad</th>\n                        <th data-column-id=\"provincia\">Provincia</th>\n                        <th data-column-id=\"estado\" data-formatter=\"estado\">Estado</th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n    <button data-toggle=\"tooltip\" data-placement=\"top\" title=\"Eliminar\" animation=\"true\"\n            class=\"btn btn-default btn-sm botonFlotante btn-danger\" (click)=\"eliminar()\"\n            [disabled]=\"permisos.get('delete')!=true\">\n        <img src=\"" + __webpack_require__(933) + "\" width=\"20px\"/>\n    </button>\n    <button data-toggle=\"tooltip\" data-placement=\"top\" title=\"Modificar\" animation=\"true\"\n            class=\"btn btn-default btn-sm botonFlotante2 btn-warning\" (click)=\"modificar()\"\n            [disabled]=\"permisos.get('update')!=true\">\n        <img src=\"" + __webpack_require__(934) + "\" width=\"25px\"/>\n    </button>\n    <button data-toggle=\"tooltip\" data-placement=\"top\" title=\"Agregar\" animation=\"true\"\n            class=\"btn btn-default btn-sm botonFlotante3 btn-success\" [disabled]=\"permisos.get('create')!=true\"\n            (click)=\"agregar()\">\n        <img src=\"" + __webpack_require__(935) + "\" width=\"25px\"/>\n    </button>\n    <button data-toggle=\"tooltip\" data-placement=\"top\" title=\"Ver\" animation=\"true\"\n            class=\"btn btn-default btn-sm botonFlotante4 btn-primary\" (click)=\"ver()\"\n            [disabled]=\"permisos.get('read')!=true\">\n        <img src=\"" + __webpack_require__(936) + "\" width=\"30px\"/>\n    </button>\n</div>\n<!-- Modal -->\n<div class=\"modal fade\" id=\"modalEmpresa\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\">\n    <div class=\"modal-dialog\" role=\"document\">\n\n        <div class=\"modal-content\">\n            <form #empresaForm=\"ngForm\" *ngIf=\"active\" enctype=\"multipart/form-data\">\n                <div style=\"padding: 15px\">\n                    <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"cerrarModal()\">\n                        <span aria-hidden=\"true\">&times;</span></button>\n                    <ul class=\"nav nav-tabs\">\n                        <li role=\"presentation\" class=\"active\"><a data-toggle=\"tab\" href=\"#empresa\">Empresa</a></li>\n                        <li role=\"presentation\" [ngClass]=\"{'disabled': !empresa._id}\" *ngIf=\"usuario.rol == 'Administrador' || usuario.rol == 'Tecnico'\"><a disabled=\"!empresa._id\" data-toggle=\"tab\" [attr.href]=\"!empresa._id ? null : '#sms'\">SMS</a></li>\n                    </ul>\n                </div>\n                <div class=\"modal-body\">\n                    <div class=\"tab-content\">\n                        <div id=\"empresa\" class=\"tab-pane fade in active\">\n                            <h4>Datos empresa</h4>\n                            <div class=\"form-group\">\n                                <label for=\"plan\">Plan</label>\n                                <select class=\"form-control\" required id=\"plan\" name=\"planId\"\n                                        [(ngModel)]=\"empresa.plan\" autocomplete=\"off\"\n                                        #plan=\"ngModel\"\n                                        [disabled]=\"deshabilitar\">\n                                    <option></option>\n                                    <option *ngFor=\"let plan of planes\" [value]=\"plan._id\">{{plan.descripcion}}\n                                    </option>\n                                </select>\n                                <div [hidden]=\"plan.valid || plan.pristine\" class=\"alert alert-danger\">\n                                    Plan es requerido\n                                </div>\n                            </div>\n                            <div class=\"form-group\">\n                                <label for=\"logo\">Logo (hasta 1 mb)</label>\n                                <div class=\"previewFotoPerfil\">\n                                    <img id=\"logoEmpresa\" [src]=\"urlLogo\" class=\"\"/>\n                                </div>\n                                <input type=\"file\" id=\"logo\" name=\"logo\" className=\"upload-file\"\n                                       (change)=\"verFoto($event.target)\" [disabled]=\"deshabilitar\" accept=\"image/*\"\n                                       #logo=\"ngModel\" [(ngModel)]=\"empresa.logo\"/>\n                            </div>\n                            <div class=\"form-group\">\n                                <label for=\"descripcion\">Descripción</label>\n                                <input type=\"text\" class=\"form-control\" id=\"descripcion\" placeholder=\"Descripción\"\n                                       required\n                                       [(ngModel)]=\"empresa.descripcion\" name=\"descripcion\" #descripcion=\"ngModel\"\n                                       autocomplete=\"off\" [disabled]=\"deshabilitar\">\n                                <div [hidden]=\"descripcion.valid || descripcion.pristine\" class=\"alert alert-danger\">\n                                    Descripción es requerido\n                                </div>\n                            </div>\n                            <div class=\"form-group\">\n                                <label for=\"direccion\">Dirección</label>\n                                <input type=\"text\" required class=\"form-control\" id=\"direccion\" name=\"direccion\"\n                                       placeholder=\"Dirección\" [(ngModel)]=\"empresa.direccion\" #direccion=\"ngModel\"\n                                       autocomplete=\"off\" [disabled]=\"deshabilitar\">\n                                <div [hidden]=\"direccion.valid || direccion.pristine\" class=\"alert alert-danger\">\n                                    Dirección es requerido\n                                </div>\n                            </div>\n                            <div class=\"form-group\">\n                                <label for=\"provincia\">Provincia</label>\n                                <select class=\"form-control\" required id=\"provincia\" name=\"provincia\"\n                                        [(ngModel)]=\"empresa.provincia\" autocomplete=\"off\"\n                                        (change)=\"cambiarLocalidades($event.target.value)\" #provincia=\"ngModel\"\n                                        [disabled]=\"deshabilitar\">\n                                    <option></option>\n                                    <option *ngFor=\"let provincia of provincias\" [value]=\"provincia.nombreProvincia\">\n                                        {{provincia.nombreProvincia}}\n                                    </option>\n                                </select>\n                                <div [hidden]=\"provincia.valid || provincia.pristine\" class=\"alert alert-danger\">\n                                    Provincia es requerido\n                                </div>\n                            </div>\n                            <div class=\"form-group\">\n                                <label for=\"localidad\">Localidad</label>\n                                <select class=\"form-control\" required id=\"localidad\" name=\"localidad\"\n                                        [(ngModel)]=\"empresa.localidad\" #localidad=\"ngModel\" autocomplete=\"off\"\n                                        [disabled]=\"deshabilitar\">\n                                    <option></option>\n                                    <option *ngFor=\"let localidad of localidades\" [value]=\"localidad.nombre\">\n                                        {{localidad.nombre}}\n                                    </option>\n                                </select>\n                                <div [hidden]=\"localidad.valid || localidad.pristine\" class=\"alert alert-danger\">\n                                    Localidad es requerido\n                                </div>\n                            </div>\n                            <div class=\"form-group\">\n                                <label for=\"direccion\">Limitación de SMS</label>\n                                <input type=\"text\" required class=\"form-control\" id=\"limitacionSMS\" name=\"limitacionSMS\"\n                                       placeholder=\"Limitación de SMS\" [(ngModel)]=\"empresa.limitacionSMS\"\n                                       #limitacionSMS=\"ngModel\"\n                                       autocomplete=\"off\" [disabled]=\"deshabilitar\">\n                                <div [hidden]=\"limitacionSMS.valid || limitacionSMS.pristine\"\n                                     class=\"alert alert-danger\">\n                                    El número límite de SMS que se pueden enviar por empresa es requerido\n                                </div>\n                            </div>\n                            <br/>\n                            <h4>Contactos</h4>\n                            <div>\n                                <div class=\"table-responsive\">\n                                    <table class=\"table\">\n                                        <thead>\n                                        <tr>\n                                            <th>Nombre</th>\n                                            <th>Puesto</th>\n                                            <th>Email</th>\n                                            <th>Teléfono</th>\n                                            <th></th>\n                                            <th></th>\n                                        </tr>\n                                        <tr *ngFor=\"let contacto of empresa.contacto; let i = index\">\n                                            <td>{{contacto.nombre}}</td>\n                                            <td>{{contacto.puesto}}</td>\n                                            <td>{{contacto.mail}}</td>\n                                            <td>{{contacto.telefono}}</td>\n                                            <td class=\"td-btn\">\n                                                <button class=\"btn btn-default\" id={{i}} (click)=\"modificarContacto(i)\"\n                                                        [disabled]=\"deshabilitar\">\n                                                    <span class=\"glyphicon glyphicon-pencil\"></span>\n                                                </button>\n                                            </td>\n                                            <td class=\"td-btn\">\n                                                <button class=\"btn btn-default\" (click)=\"eliminarContacto(i)\"\n                                                        [disabled]=\"deshabilitar\">\n                                                    <span class=\"glyphicon glyphicon-trash\"></span>\n                                                </button>\n                                            </td>\n                                        </tr>\n                                        </thead>\n                                        <tbody>\n                                        <td class=\"text-center\"\n                                            *ngIf=\"empresa.contacto == undefined || empresa.contacto.length==0\"\n                                            colspan=\"6\">No\n                                            hay contactos guardados\n                                        </td>\n                                        </tbody>\n                                    </table>\n                                </div>\n                            </div>\n\n                            <form #contactoForm=\"ngForm\" *ngIf=\"active2\">\n                                <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"\n                                     style=\"border: 1px solid rgba(176, 176, 178, 0.3); padding-top:15px; padding-bottom:15px\">\n                                    <h5 style=\"font-family:'Raleway 2'; text-align:center\">Agregar Contacto</h5>\n                                    <div class=\"form-group\">\n                                        <label for=\"nombre\">Nombre</label>\n                                        <input type=\"text\" class=\"form-control\" id=\"nombre\" name=\"nombre\"\n                                               placeholder=\"Nombre\"\n                                               [(ngModel)]=\"contacto.nombre\" required #nombre=\"ngModel\"\n                                               autocomplete=\"off\"\n                                               [disabled]=\"deshabilitar\">\n                                        <div [hidden]=\"nombre.valid || nombre.pristine\" class=\"alert alert-danger\">\n                                            Nombre es requerido\n                                        </div>\n                                    </div>\n                                    <div class=\"form-group\">\n                                        <label for=\"puesto\">Puesto</label>\n                                        <input type=\"text\" class=\"form-control\" id=\"puesto\" name=\"puesto\"\n                                               placeholder=\"Puesto\"\n                                               [(ngModel)]=\"contacto.puesto\" required #puesto=\"ngModel\"\n                                               autocomplete=\"off\"\n                                               [disabled]=\"deshabilitar\">\n                                        <div [hidden]=\"puesto.valid || puesto.pristine\" class=\"alert alert-danger\">\n                                            Puesto es requerido\n                                        </div>\n                                    </div>\n                                    <div class=\"form-group\">\n                                        <label for=\"mail\">Email</label>\n                                        <input type=\"email\" class=\"form-control\" id=\"mail\" name=\"mail\"\n                                               placeholder=\"Email\"\n                                               [(ngModel)]=\"contacto.mail\"\n                                               pattern=\"^[_a-z0-9-]+(\\.[_a-z0-9-]+)*@[a-z0-9-]+(\\.[a-z0-9-]+)*(\\.[a-z]{2,3})$\"\n                                               #mail=\"ngModel\" required autocomplete=\"off\" [disabled]=\"deshabilitar\">\n                                        <div [hidden]=\"mail.valid || mail.pristine\" class=\"alert alert-danger\">\n                                            El email debe tener un formato correcto y es requerido\n                                        </div>\n                                    </div>\n                                    <div class=\"form-group\">\n                                        <label for=\"telefono\">Teléfono</label>\n                                        <input type=\"text\" class=\"form-control\" id=\"telefono\" name=\"telefono\"\n                                               placeholder=\"xxxxxx-xxxxxxxxxx\" [(ngModel)]=\"contacto.telefono\"\n                                               #telefono=\"ngModel\"\n                                               required autocomplete=\"off\" [disabled]=\"deshabilitar\"\n                                               pattern='\\d{1,6}[\\-]\\d{7,9}'>\n                                        <div [hidden]=\"telefono.valid || telefono.pristine\" class=\"alert alert-danger\">\n                                            Teléfono es requerido y debe cumplir con el formato (xxxx-xxxxxxxxxx)\n                                        </div>\n                                    </div>\n                                    <button *ngIf=\"!modificoContacto\" class=\"btn btn-block btn-success\"\n                                            (click)=\"agregarContacto()\"\n                                            [disabled]=\"deshabilitar || !contactoForm.form.valid\">\n                                        Agregar contacto\n                                    </button>\n                                    <button *ngIf=\"modificoContacto\" class=\"btn btn-block btn-primary\"\n                                            (click)=\"agregarContacto()\"\n                                            [disabled]=\"deshabilitar || !contactoForm.form.valid\">\n                                        Aceptar\n                                    </button>\n                                </div>\n                            </form>\n                        </div>\n                        <div id=\"sms\" class=\"tab-pane fade in\">\n                            <h4>Resumen del mes actual</h4>\n                            <p>Mensajes disponibles: {{mensajesRecargasMes + empresa.limitacionSMS}}</p>\n                            <p>Mensajes utilizados: {{mensajesGastadosMes}}</p>\n                            <p>Mensajes restantes: {{(mensajesRecargasMes + empresa.limitacionSMS) -\n                                mensajesGastadosMes}}</p>\n                            <div>\n                                <div class=\"table-responsive\">\n                                    <h4>Resumen de mensajes enviados</h4>\n                                    <table class=\"table\">\n                                        <thead>\n                                        <tr>\n                                            <th>Mes</th>\n                                            <th>Año</th>\n                                            <th>Mensajes enviados</th>\n                                        </tr>\n                                        <tr *ngFor=\"let notificacion of notificaciones; let i = index\">\n                                            <td>{{notificacion._id.month}}</td>\n                                            <td>{{notificacion._id.year}}</td>\n                                            <td>{{notificacion.total}}</td>\n                                        </tr>\n                                        </thead>\n                                        <tbody>\n                                        <td class=\"text-center\"\n                                            *ngIf=\"!notificaciones|| notificaciones.length==0\" colspan=\"6\">No\n                                            hay registros de mensajes enviados\n                                        </td>\n                                        </tbody>\n                                    </table>\n                                </div>\n                            </div>\n                            <recargaCredito [idEmpresa]=\"idSeleccionado\"\n                                            [recargasCredito]=\"recargasCredito\"\n                                            [mensajesRecargasMes]=\"mensajesRecargasMes\"\n                                            [getRecargasMensajes]=\"getRecargasMensajes\"\n                                            (permisos)=\"permisosRecargas = $event.permisos\"></recargaCredito>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"clearfix visible-md-block\"></div>\n                <div class=\"clearfix visible-lg-block\"></div>\n                <div class=\"clearfix visible-sm-block\"></div>\n                <div class=\"clearfix visible-xs-block\"></div>\n                <div class=\"modal-footer\">\n                    <button type=\"button\" class=\"btn btn-default\" (click)=\"cerrarModal()\">\n                        Cancelar\n                    </button>\n                    <button type=\"button\" (click)=\"save()\" class=\"btn btn-success\"\n                            [disabled]=\"deshabilitar ||  !empresaForm.form.valid\">Guardar\n                    </button>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/cancel.585b265fd0d75a6aeb5fef08a48e5970.svg";

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/edit.fd78fd7fe19c97c4aaa59b663273a2d2.svg";

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/agregar.c3104b91653e63e056eb0d4975c36f15.svg";

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/ver.26426c6f8a290fec25d8f1d5aa918f43.svg";

/***/ }),
/* 937 */
/***/ (function(module, exports) {

	module.exports = ".td-btn{\n\tpadding-left: 0px;\n\tpadding-right: 0px;\n}\n\n.circular {\n    object-fit: cover;\n}\n\n/*.previewFotoPerfil {\n    width: auto;\n    height: auto;\n    max-width: 100px;\n    max-height: 100px;\n    float: right;\n    margin-bottom: 10px;\n}*/\n\n.previewFotoPerfil {\n    width: 100px;\n    height: 100px;\n    max-width: 100px;\n    max-height: 100px;\n    margin-bottom: 10px;\n    position: relative;\n    float: right;\n}\n\n.previewFotoPerfil img{\n    width: auto;\n    height: auto;\n    max-width: 100%;\n    max-height: 100%;\n    position: absolute;\n    margin: auto;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n}\n\n"

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var sucursal_service_1 = __webpack_require__(429);
	var provincia_service_1 = __webpack_require__(426);
	var informe_service_1 = __webpack_require__(896);
	var medicion_service_1 = __webpack_require__(434);
	var sucursal_1 = __webpack_require__(908);
	var contacto_1 = __webpack_require__(939);
	var empresa_service_1 = __webpack_require__(425);
	var permiso_service_1 = __webpack_require__(427);
	var router_1 = __webpack_require__(329);
	var login_service_1 = __webpack_require__(381);
	__webpack_require__(653);
	var myGlobals = __webpack_require__(414);
	var husoHorario_service_1 = __webpack_require__(898);
	var nodo_service_1 = __webpack_require__(433);
	var moment = __webpack_require__(435);
	var SucursalComponent = (function () {
	    function SucursalComponent(sucursalService, empresaService, provinciaService, informeService, medicionService, route, loginService, permisoService, nodoService, router, husoHorarioService) {
	        this.sucursalService = sucursalService;
	        this.empresaService = empresaService;
	        this.provinciaService = provinciaService;
	        this.informeService = informeService;
	        this.medicionService = medicionService;
	        this.route = route;
	        this.loginService = loginService;
	        this.permisoService = permisoService;
	        this.nodoService = nodoService;
	        this.router = router;
	        this.husoHorarioService = husoHorarioService;
	    }
	    SucursalComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        window.scrollTo(0, 0);
	        //Perdir permisos
	        this.permisos = new Map();
	        this.permisoService.getPermiso("sucursal").subscribe(function (permisos) {
	            for (var _i = 0, _a = permisos.tipoPermiso; _i < _a.length; _i++) {
	                var permiso = _a[_i];
	                _this.permisos.set(permiso.descripcion, true);
	            }
	            //Si no tiene permiso para ver redirijo
	            if (!_this.permisos.get("read"))
	                _this.router.navigate(['/home']);
	        });
	        //Inicializar tabla
	        $("#grid-data").bootgrid({
	            ajax: true,
	            url: myGlobals.default.BASE_URL + "/sucursal/sucursalesTable",
	            selection: true,
	            multiSelect: false,
	            rowSelect: true,
	            formatters: {
	                "empresa": function (column, row) {
	                    return row.empresa.descripcion;
	                },
	                "estado": function (column, row) {
	                    return row.estado == true ? "Activo" : "<span class=\"label label-danger\">Inactivo</span>";
	                },
	                "central": function (column, row) {
	                    return row.central == true ? "Sí" : "No";
	                },
	                "fechaCalibracion": function (column, row) {
	                    if (row.fechaCalibracion) {
	                        return moment(row.fechaCalibracion, "YYYY-MM-DD").format("DD-MM-YYYY");
	                    }
	                    else
	                        return "";
	                },
	            },
	            ajaxSettings: {
	                headers: {
	                    "Authorization": this.loginService.getToken()
	                },
	                method: "GET"
	            }
	        });
	        //Cerrar alert
	        $("#alertSeleccion").hide();
	        //Inicializar banderas para resetear forms
	        this.active = true;
	        this.active2 = true;
	        //Inicializar sucursal
	        this.sucursal = new sucursal_1.Sucursal();
	        //Incializar contacto
	        this.contacto = new contacto_1.Contacto();
	        //Inicializar bandera deshabilitar
	        this.deshabilitar = false;
	        //Cargar empresas
	        this.empresaService.getEmpresas()
	            .subscribe(function (empresas) {
	            _this.empresas = empresas;
	        });
	        this.sucursal.contacto = [];
	        //Inicilizar bandera
	        this.modificoContacto = false;
	        //Cargar provincias
	        this.provinciaService.getProvincias()
	            .subscribe(function (provincias) {
	            _this.provincias = provincias;
	        });
	        //Cargar husos horarios
	        this.husoHorarioService.getHusosHorarios()
	            .subscribe(function (husosHorario) {
	            _this.husosHorarios = husosHorario;
	        });
	        //Usuario logueado
	        this.usuario = this.loginService.getDecodeToken();
	        //Reporte
	        this.reporte = {};
	        this.today = new Date().toJSON().split('T')[0];
	    };
	    SucursalComponent.prototype.ngOnDestroy = function () {
	    };
	    SucursalComponent.prototype.agregar = function () {
	        var _this = this;
	        //Inicializo variables
	        this.sucursal = new sucursal_1.Sucursal();
	        this.contacto = new contacto_1.Contacto();
	        this.deshabilitar = false;
	        this.modificoContacto = false;
	        //Mostrar modal
	        $("#modalSucursal").modal("show");
	        //Cerrar alert
	        $("#alertSeleccion").hide();
	        //Reseteo formSucursal para eliminar errores
	        this.active = false;
	        setTimeout(function () { return _this.active = true; }, 0);
	        //Reseteo formContacto para eliminar errores
	        setTimeout(function () { return _this.active2 = false; }, 0);
	        setTimeout(function () { return _this.active2 = true; }, 0);
	    };
	    SucursalComponent.prototype.modificar = function () {
	        var _this = this;
	        this.modificoContacto = false;
	        //Obtener id seleccionado
	        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
	        //Si no hay nada seleccionado mostrar alert
	        if (this.idSeleccionado == undefined) {
	            $("#alertSeleccion").show();
	        }
	        else {
	            if (this.idSeleccionado != "0") {
	                //Cerrar alert
	                $("#alertSeleccion").hide();
	                //Busco sucursal
	                this.sucursalService
	                    .getSucursal(this.idSeleccionado)
	                    .subscribe(function (sucursal) {
	                    _this.sucursal = sucursal;
	                    _this.cambiarLocalidades(sucursal.provincia);
	                    _this.sucursal.fechaCalibracion = _this.sucursal.fechaCalibracion.toString().slice(0, 10);
	                });
	                //Seteo bandera para deshabilitar
	                this.deshabilitar = false;
	                //Ocultar modal
	                $("#modalSucursal").modal("show");
	            }
	        }
	    };
	    SucursalComponent.prototype.eliminar = function () {
	        var _this = this;
	        //Obtener id seleccionado
	        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
	        //Si no hay nada seleccionado mostrar alert
	        if (this.idSeleccionado == undefined) {
	            $("#alertSeleccion").show();
	        }
	        else {
	            if (this.idSeleccionado != "0") {
	                //Cerrar alert
	                $("#alertSeleccion").hide();
	                //Busco sucursal
	                this.sucursalService
	                    .getSucursal(this.idSeleccionado)
	                    .subscribe(function (sucursal) {
	                    _this.sucursalService.delete(sucursal).subscribe(function () { return $("#grid-data").bootgrid("reload"); });
	                });
	            }
	        }
	    };
	    SucursalComponent.prototype.ver = function () {
	        var _this = this;
	        //Obtener id seleccionado
	        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
	        //Si no hay nada seleccionado mostrar alert
	        if (this.idSeleccionado == undefined) {
	            $("#alertSeleccion").show();
	        }
	        else {
	            if (this.idSeleccionado != "0") {
	                //Cerrar alert
	                $("#alertSeleccion").hide();
	                //Busco sucursal
	                this.sucursalService
	                    .getSucursal(this.idSeleccionado)
	                    .subscribe(function (sucursal) {
	                    _this.sucursal = sucursal;
	                    _this.cambiarLocalidades(sucursal.provincia);
	                });
	                //Seteo bandera para deshabilitar
	                this.deshabilitar = true;
	                //Muestro modal
	                $("#modalSucursal").modal("show");
	            }
	        }
	    };
	    SucursalComponent.prototype.verReporte = function () {
	        //Obtener id seleccionado
	        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
	        //Si no hay nada seleccionado mostrar alert
	        if (this.idSeleccionado == undefined) {
	            $("#alertSeleccion").show();
	        }
	        else {
	            if (this.idSeleccionado != "0") {
	                //Cerrar alert
	                $("#alertSeleccion").hide();
	                //Seteo bandera para deshabilitar
	                this.deshabilitar = false;
	                //Muestro modal
	                $("#modalReporte").modal("show");
	            }
	        }
	    };
	    SucursalComponent.prototype.save = function () {
	        var _this = this;
	        this.sucursalService
	            .save(this.sucursal)
	            .subscribe(function (sucursal) {
	            _this.sucursal = sucursal;
	            //Inicializo variables
	            _this.sucursal = new sucursal_1.Sucursal();
	            _this.contacto = new contacto_1.Contacto();
	            //Ocultar modal
	            $("#modalSucursal").modal("hide");
	            //Reseteo formSucursal para eliminar errores
	            _this.active = false;
	            setTimeout(function () { return _this.active = true; }, 0);
	            //Recargo tabla
	            $("#grid-data").bootgrid("reload");
	        });
	    };
	    SucursalComponent.prototype.generarReporte = function () {
	        var _this = this;
	        this.deshabilitar = true;
	        //Obtener id seleccionado
	        var id = $("#grid-data").bootgrid("getSelectedRows")[0];
	        var tblData = $("#grid-data").bootgrid("getCurrentRows");
	        var filename = '';
	        for (var i = 0; i < tblData.length; i++) {
	            if (tblData[i]['_id'] == id) {
	                filename = filename + tblData[i]['descripcion'] + '-' + tblData[i]['empresa']['descripcion'];
	                break;
	            }
	        }
	        this.informeService.getInformeMantenimiento(this.idSeleccionado, this.reporte, filename)
	            .subscribe(function (res) {
	            _this.deshabilitar = false;
	            _this.reporte = {};
	            //Ocultar modal
	            $("#modalReporte").modal("hide");
	            //Reseteo formSucursal para eliminar errores
	            _this.active = false;
	            setTimeout(function () { return _this.active = true; }, 0);
	            //Recargo tabla
	            $("#grid-data").bootgrid("reload");
	        });
	    };
	    SucursalComponent.prototype.handleAcceptReport = function () {
	        if (this.reporte.type === 'mediciones')
	            this.exportMediciones();
	        else
	            this.generarReporteGeneral();
	    };
	    SucursalComponent.prototype.generarReporteGeneral = function () {
	        var _this = this;
	        this.deshabilitar = true;
	        this.informeService.getInformeGeneral(this.idSeleccionado, this.reporte)
	            .subscribe(function (res) {
	            _this.deshabilitar = false;
	            _this.reporte = {};
	            //Ocultar modal
	            $("#modalMediciones").modal("hide");
	            //Reseteo formSucursal para eliminar errores
	            _this.active = false;
	            setTimeout(function () { return _this.active = true; }, 0);
	        });
	    };
	    SucursalComponent.prototype.generarConfiguracionSucursal = function () {
	        var _this = this;
	        this.deshabilitar = true;
	        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
	        this.informeService.getConfiguracionSucursal(this.idSeleccionado)
	            .subscribe(function (res) {
	            _this.deshabilitar = false;
	            _this.reporte = {};
	        });
	    };
	    SucursalComponent.prototype.exportMediciones = function () {
	        var _this = this;
	        this.deshabilitar = true;
	        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
	        this.medicionService.getAllMedicionesBySucursalYFecha(this.idSeleccionado, this.reporte.fechaDesde, this.reporte.fechaHasta, null)
	            .subscribe(function (res) {
	            _this.deshabilitar = false;
	            _this.reporte = {};
	            //Ocultar modal
	            $("#modalReporte").modal("hide");
	            //Reseteo formSucursal para eliminar errores
	            _this.active = false;
	            setTimeout(function () { return _this.active = true; }, 0);
	            _this.cerrarModalMediciones();
	        });
	    };
	    SucursalComponent.prototype.agregarContacto = function () {
	        var _this = this;
	        if (!this.modificoContacto) {
	            //Inicializar arreglo
	            if (this.sucursal.contacto == undefined)
	                this.sucursal.contacto = [];
	            //Agregar contacto
	            this.sucursal.contacto.push(this.contacto);
	            //Limpiar contacto
	            this.contacto = new contacto_1.Contacto();
	        }
	        else {
	            //Limpiar contacto
	            this.contacto = new contacto_1.Contacto();
	            //Seteo bandera
	            this.modificoContacto = false;
	        }
	        //Reseteo formContacto para eliminar errores
	        setTimeout(function () { return _this.active2 = false; }, 0);
	        setTimeout(function () { return _this.active2 = true; }, 0);
	    };
	    SucursalComponent.prototype.modificarContacto = function (index) {
	        //Traer contacto
	        this.contacto = this.sucursal.contacto[index];
	        //Seteo bandera
	        this.modificoContacto = true;
	    };
	    SucursalComponent.prototype.eliminarContacto = function (index) {
	        //Eliminar contacto de la lista
	        this.sucursal.contacto.splice(index, 1);
	    };
	    SucursalComponent.prototype.hideAlert = function () {
	        $("#alertSeleccion").hide();
	    };
	    SucursalComponent.prototype.cambiarLocalidades = function (nombre) {
	        var _this = this;
	        this.provinciaService.getProvincia(nombre)
	            .subscribe(function (provincia) {
	            _this.localidades = provincia.localidades;
	        });
	        console.log(this.sucursal);
	    };
	    SucursalComponent.prototype.setearEmpresa = function (id) {
	        this.sucursal.empresa = id;
	    };
	    SucursalComponent.prototype.cerrarModal = function () {
	        var _this = this;
	        //Reseteo formSucursal para eliminar errores
	        this.active = false;
	        setTimeout(function () { return _this.active = true; }, 0);
	        //Reseteo formContacto para eliminar errores
	        setTimeout(function () { return _this.active2 = false; }, 0);
	        setTimeout(function () { return _this.active2 = true; }, 0);
	        this.sucursal = new sucursal_1.Sucursal();
	        $("#modalSucursal").modal("hide");
	    };
	    SucursalComponent.prototype.cerrarModalReporte = function () {
	        var _this = this;
	        //Reseteo formSucursal para eliminar errores
	        this.active = false;
	        setTimeout(function () { return _this.active = true; }, 0);
	        //Reseteo formContacto para eliminar errores
	        setTimeout(function () { return _this.active2 = false; }, 0);
	        setTimeout(function () { return _this.active2 = true; }, 0);
	        this.sucursal = new sucursal_1.Sucursal();
	        $("#modalReporte").modal("hide");
	    };
	    SucursalComponent.prototype.cerrarModalMediciones = function () {
	        var _this = this;
	        //Reseteo formSucursal para eliminar errores
	        this.active = false;
	        setTimeout(function () { return _this.active = true; }, 0);
	        //Reseteo formContacto para eliminar errores
	        setTimeout(function () { return _this.active2 = false; }, 0);
	        setTimeout(function () { return _this.active2 = true; }, 0);
	        $("#modalMediciones").modal("hide");
	    };
	    SucursalComponent.prototype.openModalMediciones = function (type) {
	        var _this = this;
	        this.reporte.type = type;
	        if (type === 'mediciones') {
	            //Obtener id seleccionado
	            this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
	            //Si no hay nada seleccionado mostrar alert
	            if (this.idSeleccionado == undefined) {
	                $("#alertSeleccion").show();
	            }
	            else {
	                if (this.idSeleccionado != "0") {
	                    //Cerrar alert
	                    $("#alertSeleccion").hide();
	                    //Seteo bandera para deshabilitar
	                    this.deshabilitar = false;
	                    //Muestro modal
	                    $("#modalMediciones").modal("show");
	                    var date = new Date();
	                    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
	                    var lastDay = new Date();
	                    this.reporte.fechaDesde = firstDay.toISOString().split('T')[0];
	                    this.reporte.fechaHasta = lastDay.toISOString().split('T')[0];
	                }
	            }
	        }
	        else {
	            //Obtener id seleccionado
	            this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
	            //Cerrar alert
	            $("#alertSeleccion").hide();
	            //Seteo bandera para deshabilitar
	            this.deshabilitar = false;
	            //Muestro modal
	            $("#modalMediciones").modal("show");
	            var date = new Date();
	            var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
	            var lastDay = new Date();
	            if (this.idSeleccionado && this.idSeleccionado != "0") {
	                this.reporte.sucursal_id = (this.idSeleccionado);
	                this.nodoService.getNodosBySucursal((this.idSeleccionado)).subscribe(function (data) {
	                    _this.nodos = data;
	                });
	            }
	            this.reporte.fechaDesde = firstDay.toISOString().split('T')[0];
	            this.reporte.fechaHasta = lastDay.toISOString().split('T')[0];
	        }
	    };
	    SucursalComponent.prototype.seleccionarNodo = function (e, nodo) {
	        if (!this.reporte.nodos) {
	            this.reporte.nodos = [];
	        }
	        var index = this.reporte.nodos.indexOf(nodo._id);
	        if (e.target.checked) {
	            if (index === -1) {
	                this.reporte.nodos.push(nodo._id);
	            }
	        }
	        else {
	            if (index !== -1) {
	                this.reporte.nodos.splice(index, 1);
	            }
	        }
	    };
	    SucursalComponent = __decorate([
	        core_1.Component({
	            selector: 'sucursal',
	            template: __webpack_require__(940),
	            styles: [__webpack_require__(944)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof sucursal_service_1.SucursalService !== 'undefined' && sucursal_service_1.SucursalService) === 'function' && _a) || Object, (typeof (_b = typeof empresa_service_1.EmpresaService !== 'undefined' && empresa_service_1.EmpresaService) === 'function' && _b) || Object, (typeof (_c = typeof provincia_service_1.ProvinciaService !== 'undefined' && provincia_service_1.ProvinciaService) === 'function' && _c) || Object, (typeof (_d = typeof informe_service_1.InformeService !== 'undefined' && informe_service_1.InformeService) === 'function' && _d) || Object, (typeof (_e = typeof medicion_service_1.MedicionService !== 'undefined' && medicion_service_1.MedicionService) === 'function' && _e) || Object, (typeof (_f = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _f) || Object, (typeof (_g = typeof login_service_1.LoginService !== 'undefined' && login_service_1.LoginService) === 'function' && _g) || Object, (typeof (_h = typeof permiso_service_1.PermisoService !== 'undefined' && permiso_service_1.PermisoService) === 'function' && _h) || Object, (typeof (_j = typeof nodo_service_1.NodoService !== 'undefined' && nodo_service_1.NodoService) === 'function' && _j) || Object, (typeof (_k = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _k) || Object, (typeof (_l = typeof husoHorario_service_1.HusoHorarioService !== 'undefined' && husoHorario_service_1.HusoHorarioService) === 'function' && _l) || Object])
	    ], SucursalComponent);
	    return SucursalComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
	}());
	exports.SucursalComponent = SucursalComponent;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(419)))

/***/ }),
/* 939 */
927,
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 contenido\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 titulo\">\n        <div class=\"marcoTitulo\">\n            <h2>Sucursales</h2>\n            <p>Home / Carga Datos / Sucursales</p>\n        </div>\n    </div>\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 marcoDatos\">\n        <div class=\"datos\">\n            <div class=\"alert alert-warning\" id=\"alertSeleccion\" name=\"alertSeleccion\">\n                <a class=\"close\" (click)=\"hideAlert()\">&times;</a> Debe selecccionar una casilla primero.\n            </div>\n            <div class=\"table-responsive\">\n                <table id=\"grid-data\" class=\"table table-condensed table-hover \">\n                    <thead>\n                    <tr>\n                        <th data-column-id=\"_id\" data-identifier=\"true\" data-visible=\"false\"\n                            data-visible-in-selection=\"false\" data-order=\"desc\">_id\n                        </th>\n                        <th data-column-id=\"empresa\" data-formatter=\"empresa\">Empresa</th>\n                        <th data-column-id=\"descripcion\">Nombre</th>\n                        <th data-column-id=\"fechaCalibracion\" data-formatter=\"fechaCalibracion\">Fecha calibración</th>\n                        <th data-column-id=\"direccion\">Dirección</th>\n                        <th data-column-id=\"localidad\">Localidad</th>\n                        <th data-column-id=\"provincia\">Provincia</th>\n                        <th data-column-id=\"central\" data-formatter=\"central\">Central</th>\n                        <th data-column-id=\"estado\" data-formatter=\"estado\">Estado</th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n    <button data-toggle=\"tooltip\" data-placement=\"top\" title=\"Eliminar\" animation=\"true\"\n            class=\"btn btn-default btn-sm botonFlotante btn-danger\" (click)=\"eliminar()\"\n            [disabled]=\"permisos.get('delete')!=true\">\n        <img src=\"" + __webpack_require__(933) + "\" width=\"20px\"/>\n    </button>\n    <button data-toggle=\"tooltip\" data-placement=\"top\" title=\"Modificar\" animation=\"true\"\n            class=\"btn btn-default btn-sm botonFlotante2 btn-warning\" (click)=\"modificar()\"\n            [disabled]=\"permisos.get('update')!=true\">\n        <img src=\"" + __webpack_require__(934) + "\" width=\"25px\"/>\n    </button>\n    <button data-toggle=\"tooltip\" data-placement=\"top\" title=\"Agregar\" animation=\"true\"\n            class=\"btn btn-default btn-sm botonFlotante3 btn-success\" (click)=\"agregar()\"\n            [disabled]=\"permisos.get('create')!=true\">\n        <img src=\"" + __webpack_require__(935) + "\" width=\"25px\"/>\n    </button>\n    <button data-toggle=\"tooltip\" data-placement=\"top\" title=\"Ver\" animation=\"true\"\n            class=\"btn btn-default btn-sm botonFlotante4 btn-primary\" (click)=\"ver()\"\n            [disabled]=\"permisos.get('read')!=true\">\n        <img src=\"" + __webpack_require__(936) + "\" width=\"30px\"/>\n    </button>\n    <button *ngIf=\"usuario.rol === 'Administrador' || usuario.rol === 'Tecnico'\" data-toggle=\"tooltip\"\n            data-placement=\"top\" title=\"Reporte mensual\" animation=\"true\"\n            class=\"btn btn-default btn-sm botonFlotante5 btn-info\" (click)=\"verReporte()\"\n            [disabled]=\"permisos.get('update')!=true\">\n        <img src=\"" + __webpack_require__(941) + "\" width=\"30px\"/>\n    </button>\n    <button *ngIf=\"usuario.rol === 'Administrador' || usuario.rol === 'Tecnico'\" data-toggle=\"tooltip\"\n            data-placement=\"top\" title=\"Exportar mediciones\" animation=\"true\"\n            class=\"btn btn-default btn-sm botonFlotante6 btn-info\" (click)=\"openModalMediciones('mediciones')\"\n            [disabled]=\"permisos.get('update')!=true\">\n        <img src=\"" + __webpack_require__(942) + "\" width=\"30px\"/>\n    </button>\n    <button *ngIf=\"usuario.rol === 'Administrador' || usuario.rol === 'Tecnico'\" data-toggle=\"tooltip\"\n            data-placement=\"top\" title=\"Reporte general\" animation=\"true\"\n            class=\"btn btn-default btn-sm botonFlotante7 btn-info\" (click)=\"openModalMediciones('general')\"\n            [disabled]=\"permisos.get('update')!=true\">\n        <img src=\"" + __webpack_require__(943) + "\" width=\"30px\"/>\n    </button>\n    <button *ngIf=\"usuario.rol === 'Administrador' || usuario.rol === 'Tecnico'\" data-toggle=\"tooltip\"\n            data-placement=\"top\" title=\"Configuración sucursal\" animation=\"true\"\n            class=\"btn btn-default btn-sm botonFlotante9 btn-info\" (click)=\"generarConfiguracionSucursal()\"\n            [disabled]=\"permisos.get('update')!=true\">\n        <img src=\"" + __webpack_require__(942) + "\" width=\"30px\"/>\n    </button>\n</div>\n<!-- Modal -->\n<div class=\"modal fade\" id=\"modalSucursal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\">\n    <div class=\"modal-dialog\" role=\"document\">\n        <div class=\"modal-content\">\n            <form #sucursalForm=\"ngForm\" *ngIf=\"active\">\n                <div class=\"modal-header\">\n                    <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"cerrarModal()\"><span\n                            aria-hidden=\"true\">&times;</span></button>\n                    <h4 class=\"modal-title\" id=\"myModalLabel\">Sucursal</h4>\n                </div>\n                <div class=\"modal-body\">\n\n                    <div class=\"form-group\">\n                        <label for=\"empresa\">Empresa</label>\n                        <select class=\"form-control\" required id=\"empresa\" name=\"empresaId\"\n                                [(ngModel)]=\"sucursal.empresa\" autocomplete=\"off\"\n                                #empresa=\"ngModel\"\n                                [disabled]=\"deshabilitar\">\n                            <option></option>\n                            <option *ngFor=\"let empresa of empresas\" [value]=\"empresa._id\">{{empresa.descripcion}}\n                            </option>\n                        </select>\n                        <div [hidden]=\"empresa.valid || empresa.pristine\" class=\"alert alert-danger\">\n                            Empresa es requerido\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"descripcion\">Descripción sucursal</label>\n                        <input type=\"text\" class=\"form-control\" id=\"descripcion\" placeholder=\"Descripción\" required\n                               [(ngModel)]=\"sucursal.descripcion\" name=\"descripcion\" #descripcion=\"ngModel\"\n                               autocomplete=\"off\" [disabled]=\"deshabilitar\">\n                        <div [hidden]=\"descripcion.valid || descripcion.pristine\" class=\"alert alert-danger\">\n                            Descripción es requerido\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"direccion\">Dirección</label>\n                        <input type=\"text\" required class=\"form-control\" id=\"direccion\" name=\"direccion\"\n                               placeholder=\"Dirección\" [(ngModel)]=\"sucursal.direccion\" #direccion=\"ngModel\"\n                               autocomplete=\"off\" [disabled]=\"deshabilitar\">\n                        <div [hidden]=\"direccion.valid || direccion.pristine\" class=\"alert alert-danger\">\n                            Dirección es requerido\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"empresa\">Huso horario</label>\n                        <select class=\"form-control\" required id=\"husoHorario\" name=\"husoHorarioId\"\n                                [(ngModel)]=\"sucursal.husoHorario_id\" autocomplete=\"off\"\n                                #husoHorario=\"ngModel\"\n                                [disabled]=\"deshabilitar\">\n                            <option></option>\n                            <option *ngFor=\"let husoHorario of husosHorarios\"\n                                    [value]=\"husoHorario._id\">{{husoHorario.zonaHoraria + \" (\" + husoHorario.offset + \")\"}}\n                            </option>\n                        </select>\n                        <div [hidden]=\"empresa.valid || empresa.pristine\" class=\"alert alert-danger\">\n                            Empresa es requerido\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"fechaCalibracion\">Fecha próxima calibración</label>\n                        <input type=\"date\" required class=\"form-control\" id=\"fechaCalibracion\" name=\"fechaCalibracion\"\n                               placeholder=\"Fecha calibración\" [(ngModel)]=\"sucursal.fechaCalibracion\"\n                               #fechaCalibracion=\"ngModel\"\n                               autocomplete=\"off\" [disabled]=\"deshabilitar || usuario.rol != 'Administrador'\">\n                        <div [hidden]=\"fechaCalibracion.valid || fechaCalibracion.pristine\" class=\"alert alert-danger\">\n                            Fecha calibración es requerido\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"idFolderGoogleDrive\">Id carpeta Google Drive</label>\n                        <input type=\"text\" class=\"form-control\" id=\"idFolderGoogleDrive\" name=\"idFolderGoogleDrive\"\n                               placeholder=\"Id carpeta Google Drive\" [(ngModel)]=\"sucursal.idFolderGoogleDrive\"\n                               #idFolderGoogleDrive=\"ngModel\"\n                               autocomplete=\"off\" [disabled]=\"deshabilitar || usuario.rol != 'Administrador'\">\n                        <div [hidden]=\"idFolderGoogleDrive.valid || idFolderGoogleDrive.pristine\" class=\"alert alert-danger\">\n                            Id carpeta Google Drive es requerido\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label>¿Es la casa central de la empresa?</label>\n                        <select class=\"form-control\" required id=\"central\" name=\"central\" [(ngModel)]=\"sucursal.central\"\n                                autocomplete=\"off\" #central=\"ngModel\" [disabled]=\"deshabilitar\">\n                            <option value=\"true\">Si</option>\n                            <option value=\"false\">No</option>\n                        </select>\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"provincia\">Provincia</label>\n                        <select class=\"form-control\" required id=\"provincia\" name=\"provincia\"\n                                [(ngModel)]=\"sucursal.provincia\" autocomplete=\"off\"\n                                (change)=\"cambiarLocalidades($event.target.value)\" #provincia=\"ngModel\"\n                                [disabled]=\"deshabilitar\">\n                            <option></option>\n                            <option *ngFor=\"let provincia of provincias\" [value]=\"provincia.nombreProvincia\">\n                                {{provincia.nombreProvincia}}\n                            </option>\n                        </select>\n                        <div [hidden]=\"provincia.valid || provincia.pristine\" class=\"alert alert-danger\">\n                            Provincia es requerido\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"localidad\">Localidad</label>\n                        <select class=\"form-control\" required id=\"localidad\" name=\"localidad\"\n                                [(ngModel)]=\"sucursal.localidad\" #localidad=\"ngModel\" autocomplete=\"off\"\n                                [disabled]=\"deshabilitar\">\n                            <option></option>\n                            <option *ngFor=\"let localidad of localidades\" [value]=\"localidad.nombre\">\n                                {{localidad.nombre}}\n                            </option>\n                        </select>\n                        <div [hidden]=\"localidad.valid || localidad.pristine\" class=\"alert alert-danger\">\n                            Localidad es requerido\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"historico_dias\">Cantidad de días por defecto para gráfico historico</label>\n                        <span class=\"glyphicon glyphicon-question-sign ayuda\" data-toggle=\"tooltip\" data-placement=\"top\"\n                              title=\"En el menú Histórico se busca por defecto las mediciones en un rango comprendido entre de la fecha actual y la fecha actual menos el valor indicado en este campo.\"></span>\n                        <input type=\"text\" required class=\"form-control\" id=\"historico_dias\" name=\"historico_dias\"\n                               placeholder=\"Cantidad de días por defecto para gráfico historico\"\n                               [(ngModel)]=\"sucursal.historico_dias\"\n                               #historico_dias=\"ngModel\" autocomplete=\"off\" [disabled]=\"deshabilitar\"\n                               pattern=\"^[1-9][0-9]*$\">\n                        <div [hidden]=\"historico_dias.valid || historico_dias.pristine\" class=\"alert alert-danger\">\n                            Días para gráfico historico es requerido, debe ser numerico y mayor a 0\n                        </div>\n                    </div>\n                    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                        <div class=\"table-responsive\">\n                            <table class=\"table\">\n                                <thead>\n                                <tr>\n                                    <th>Nombre</th>\n                                    <th>Puesto</th>\n                                    <th>Email</th>\n                                    <th>Teléfono</th>\n                                    <th></th>\n                                    <th></th>\n                                </tr>\n                                <tr *ngFor=\"let contacto of sucursal.contacto; let i = index\">\n                                    <td>{{contacto.nombre}}</td>\n                                    <td>{{contacto.puesto}}</td>\n                                    <td>{{contacto.mail}}</td>\n                                    <td>{{contacto.telefono}}</td>\n                                    <td class=\"td-btn\">\n                                        <button class=\"btn btn-default\" id={{i}} (click)=\"modificarContacto(i)\"\n                                                [disabled]=\"deshabilitar\">\n                                            <span class=\"glyphicon glyphicon-pencil\"></span>\n                                        </button>\n                                    </td>\n                                    <td class=\"td-btn\">\n                                        <button class=\"btn btn-default\" (click)=\"eliminarContacto(i)\"\n                                                [disabled]=\"deshabilitar\">\n                                            <span class=\"glyphicon glyphicon-trash\"></span>\n                                        </button>\n                                    </td>\n                                </tr>\n                                </thead>\n                                <tbody>\n                                <td class=\"text-center\"\n                                    *ngIf=\"sucursal.contacto == undefined || sucursal.contacto.length==0\" colspan=\"6\">No\n                                    hay contactos guardados\n                                </td>\n                                </tbody>\n                            </table>\n                        </div>\n                    </div>\n\n                    <form #contactoForm=\"ngForm\" *ngIf=\"active2\">\n                        <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"\n                             style=\"border: 1px solid rgba(176, 176, 178, 0.3); padding-top:15px; padding-bottom:15px\">\n                            <h5 style=\"font-family:'Raleway 2'; text-align:center\">Agregar Contacto</h5>\n                            <div class=\"form-group\">\n                                <label for=\"nombre\">Nombre</label>\n                                <input type=\"text\" class=\"form-control\" id=\"nombre\" name=\"nombre\" placeholder=\"Nombre\"\n                                       [(ngModel)]=\"contacto.nombre\" required #nombre=\"ngModel\" autocomplete=\"off\"\n                                       [disabled]=\"deshabilitar\">\n                                <div [hidden]=\"nombre.valid || nombre.pristine\" class=\"alert alert-danger\">\n                                    Nombre es requerido\n                                </div>\n                            </div>\n                            <div class=\"form-group\">\n                                <label for=\"puesto\">Puesto</label>\n                                <input type=\"text\" class=\"form-control\" id=\"puesto\" name=\"puesto\" placeholder=\"Puesto\"\n                                       [(ngModel)]=\"contacto.puesto\" required #puesto=\"ngModel\" autocomplete=\"off\"\n                                       [disabled]=\"deshabilitar\">\n                                <div [hidden]=\"puesto.valid || puesto.pristine\" class=\"alert alert-danger\">\n                                    Puesto es requerido\n                                </div>\n                            </div>\n                            <div class=\"form-group\">\n                                <label for=\"mail\">Email</label>\n                                <input type=\"email\" class=\"form-control\" id=\"mail\" name=\"mail\" placeholder=\"Email\"\n                                       [(ngModel)]=\"contacto.mail\"\n                                       pattern=\"^[_a-z0-9-]+(\\.[_a-z0-9-]+)*@[a-z0-9-]+(\\.[a-z0-9-]+)*(\\.[a-z]{2,3})$\"\n                                       #mail=\"ngModel\" required autocomplete=\"off\" [disabled]=\"deshabilitar\">\n                                <div [hidden]=\"mail.valid || mail.pristine\" class=\"alert alert-danger\">\n                                    El email debe tener un formato correcto y es requerido\n                                </div>\n                            </div>\n                            <div class=\"form-group\">\n                                <label for=\"telefono\">Teléfono</label>\n                                <input type=\"text\" class=\"form-control\" id=\"telefono\" name=\"telefono\"\n                                       pattern=\"\\d{1,6}[\\-]\\d{5,9}\"\n                                       placeholder=\"xxxxxx-xxxxxxxxxx\" [(ngModel)]=\"contacto.telefono\"\n                                       #telefono=\"ngModel\"\n                                       required autocomplete=\"off\" [disabled]=\"deshabilitar\">\n                                <div [hidden]=\"telefono.valid || telefono.pristine\" class=\"alert alert-danger\">\n                                    Teléfono es requerido y debe cumplir con el formato (xxxx-xxxxxxxxxx)\n                                </div>\n                            </div>\n                            <button *ngIf=\"!modificoContacto\" class=\"btn btn-block btn-success\"\n                                    (click)=\"agregarContacto()\" [disabled]=\"deshabilitar || !contactoForm.form.valid\">\n                                Agregar contacto\n                            </button>\n                            <button *ngIf=\"modificoContacto\" class=\"btn btn-block btn-primary\"\n                                    (click)=\"agregarContacto()\" [disabled]=\"deshabilitar || !contactoForm.form.valid\">\n                                Aceptar\n                            </button>\n                        </div>\n                    </form>\n                </div>\n                <div class=\"clearfix visible-md-block\"></div>\n                <div class=\"clearfix visible-lg-block\"></div>\n                <div class=\"clearfix visible-sm-block\"></div>\n                <div class=\"clearfix visible-xs-block\"></div>\n                <div class=\"modal-footer\">\n                    <button type=\"button\" class=\"btn btn-default\" (click)=\"cerrarModal()\">Cancelar</button>\n                    <button type=\"button\" (click)=\"save()\" class=\"btn btn-success\"\n                            [disabled]=\"deshabilitar || !sucursalForm.form.valid\">Guardar\n                    </button>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>\n\n\n<!-- Modal -->\n<div class=\"modal fade\" id=\"modalReporte\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\">\n    <div class=\"modal-dialog\" role=\"document\">\n        <div class=\"modal-content\">\n            <form #reporteForm=\"ngForm\" *ngIf=\"active\">\n                <div class=\"modal-header\">\n                    <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"cerrarModalReporte()\"><span\n                            aria-hidden=\"true\">&times;</span></button>\n                    <h4 class=\"modal-title\">Reporte mantenimiento preventivo de Bemakoha</h4>\n                </div>\n                <div class=\"modal-body\">\n\n                    <div class=\"form-group\">\n                        <label for=\"mes\">Mes del informe</label>\n                        <select class=\"form-control\" required id=\"mes\" name=\"mes\"\n                                [(ngModel)]=\"reporte.mes\" autocomplete=\"off\"\n                                #mes=\"ngModel\"\n                                [disabled]=\"deshabilitar\">\n                            <option></option>\n                            <option value=\"01\">Enero</option>\n                            <option value=\"02\">Febrero</option>\n                            <option value=\"03\">Marzo</option>\n                            <option value=\"04\">Abril</option>\n                            <option value=\"05\">Mayo</option>\n                            <option value=\"06\">Junio</option>\n                            <option value=\"07\">Julio</option>\n                            <option value=\"08\">Agosto</option>\n                            <option value=\"09\">Septiembre</option>\n                            <option value=\"10\">Octubre</option>\n                            <option value=\"11\">Noviembre</option>\n                            <option value=\"12\">Diciembre</option>\n                        </select>\n                        <div [hidden]=\"mes.valid || mes.pristine\" class=\"alert alert-danger\">\n                            Mes es requerido\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"descripcion\">Año</label>\n                        <input type=\"number\" class=\"form-control\" id=\"anio\" placeholder=\"Año\" required\n                               [(ngModel)]=\"reporte.anio\" name=\"anio\" #anio=\"ngModel\"\n                               autocomplete=\"off\" [disabled]=\"deshabilitar\">\n                        <div [hidden]=\"anio.valid || anio.pristine\" class=\"alert alert-danger\">\n                            Año es requerido\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"descripcion\">Prueba de conectividad en el concentrador</label>\n                        <input type=\"text\" class=\"form-control\" id=\"conectividad\" placeholder=\"Prueba de conectividad\"\n                               required\n                               [(ngModel)]=\"reporte.conectividad\" name=\"conectividad\" #conectividad=\"ngModel\"\n                               autocomplete=\"off\" [disabled]=\"deshabilitar\">\n                        <div [hidden]=\"conectividad.valid || conectividad.pristine\" class=\"alert alert-danger\">\n                            Prueba de conectividad es requerido\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"observaciones\">Observaciones</label>\n                        <textarea required class=\"form-control\" id=\"observaciones\" name=\"observaciones\"\n                                  placeholder=\"Observaciones\" [(ngModel)]=\"reporte.observaciones\"\n                                  #observaciones=\"ngModel\"\n                                  autocomplete=\"off\" [disabled]=\"deshabilitar\"></textarea>\n                        <div [hidden]=\"observaciones.valid || observaciones.pristine\" class=\"alert alert-danger\">\n                            Observaciones es requerido\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"recomendaciones\">Recomendaciones</label>\n                        <textarea required class=\"form-control\" id=\"recomendaciones\" name=\"recomendaciones\"\n                                  placeholder=\"Recomendaciones\" [(ngModel)]=\"reporte.recomendaciones\"\n                                  #recomendaciones=\"ngModel\"\n                                  autocomplete=\"off\" [disabled]=\"deshabilitar\"></textarea>\n                        <div [hidden]=\"recomendaciones.valid || recomendaciones.pristine\" class=\"alert alert-danger\">\n                            Recomendaciones es requerido\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"realizadoPor\">Realizado por</label>\n                        <input type=\"text\" class=\"form-control\" id=\"realizadoPor\" placeholder=\"Realizado por\" required\n                               [(ngModel)]=\"reporte.realizadoPor\" name=\"realizadoPor\" #realizadoPor=\"ngModel\"\n                               autocomplete=\"off\" [disabled]=\"deshabilitar\">\n                        <div [hidden]=\"realizadoPor.valid || realizadoPor.pristine\" class=\"alert alert-danger\">\n                            Realizado por es requerido\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"fechaCalibracion\">Fecha próximo mantenimiento</label>\n                        <input type=\"date\" required class=\"form-control\" id=\"fechaProximoMantenimiento\"\n                               name=\"fechaProximoMantenimiento\"\n                               placeholder=\"Fecha próximo mantenimiento\" [(ngModel)]=\"reporte.fechaProximoMantenimiento\"\n                               #fechaProximoMantenimiento=\"ngModel\"\n                               autocomplete=\"off\" [disabled]=\"deshabilitar\">\n                        <div [hidden]=\"fechaProximoMantenimiento.valid || fechaProximoMantenimiento.pristine\"\n                             class=\"alert alert-danger\">\n                            Fecha próximo mantenimiento es requerido\n                        </div>\n                    </div>\n                </div>\n                <div class=\"clearfix visible-md-block\"></div>\n                <div class=\"clearfix visible-lg-block\"></div>\n                <div class=\"clearfix visible-sm-block\"></div>\n                <div class=\"clearfix visible-xs-block\"></div>\n                <div class=\"modal-footer\">\n                    <button type=\"button\" class=\"btn btn-default\" (click)=\"cerrarModalReporte()\">Cancelar</button>\n                    <button type=\"button\" (click)=\"generarReporte()\" class=\"btn btn-success\"\n                            [disabled]=\"deshabilitar || !reporteForm.form.valid\">Generar reporte\n                    </button>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>\n\n<!-- Modal -->\n<div class=\"modal fade\" id=\"modalMediciones\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\">\n    <div class=\"modal-dialog\" role=\"document\">\n        <div class=\"modal-content\">\n            <form #reporteForm=\"ngForm\" *ngIf=\"active\" (ngSubmit)=\"handleAcceptReport()\">\n                <div class=\"modal-header\">\n                    <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"cerrarModalMediciones()\"><span\n                            aria-hidden=\"true\">&times;</span></button>\n                    <h4 class=\"modal-title\" *ngIf=\"reporte.type === 'mediciones'\">Descarga de mediciones</h4>\n                    <h4 class=\"modal-title\" *ngIf=\"reporte.type === 'general'\">Descarga de reporte general</h4>\n                </div>\n                <div class=\"modal-body\">\n                    <div class=\"form-group\">\n                        <label for=\"fechaDesde\">Fecha Desde</label>\n                        <input required type=\"date\" class=\"form-control\" id=\"fechaDesde\" name=\"fechaDesde\" [(ngModel)]=\"reporte.fechaDesde\"\n                               #fechaDesde=\"ngModel\" [disabled]=\"deshabilitar\"/>\n                        <div [hidden]=\"fechaDesde.valid || fechaDesde.pristine\"\n                             class=\"alert alert-danger\">\n                            Fecha desde\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"fechaHasta\">Fecha Hasta</label>\n                        <input required type=\"date\" class=\"form-control\" id=\"fechaHasta\" name=\"fechaHasta\" [(ngModel)]=\"reporte.fechaHasta\"\n                               #fechaHasta=\"ngModel\" [disabled]=\"deshabilitar\" [max]=\"today\"/>\n                        <div [hidden]=\"fechaHasta.valid || fechaHasta.pristine\"\n                             class=\"alert alert-danger\">\n                            Fecha hasta\n                        </div>\n                    </div>\n\n                </div>\n                <div *ngIf=\"reporte.type != 'mediciones' && reporte.sucursal_id\">\n                    <div class=\"panel-body\">\n                        <label> Seleccionar los nodos a incluir en reporte\n                        </label>\n                        <div class=\"checkbox checkbox-warning\">\n                            <input type=\"checkbox\" id=\"todos\">\n                            <label> Todos\n                            </label>\n                        </div>\n                        <template ngFor let-nodo [ngForOf]=\"nodos\" let-index=\"index2\">\n                            <div>\n                                <div class=\"checkbox checkbox-warning\">\n                                    <input type=\"checkbox\" id=\"nodo_id\" (change)=\"seleccionarNodo($event,nodo)\">\n                                    <label> {{nodo.etiqueta}} - {{nodo.nombre}}\n                                    </label>\n                                </div>\n                            </div>\n                        </template>\n                    </div>\n                </div>\n                <div class=\"clearfix visible-md-block\"></div>\n                <div class=\"clearfix visible-lg-block\"></div>\n                <div class=\"clearfix visible-sm-block\"></div>\n                <div class=\"clearfix visible-xs-block\"></div>\n                <div class=\"modal-footer\">\n                    <button type=\"button\" class=\"btn btn-default\" (click)=\"cerrarModalMediciones()\">Cancelar</button>\n                    <button type=\"submit\" class=\"btn btn-success\"\n                            [disabled]=\"deshabilitar || !reporteForm.form.valid\">Generar archivo\n                    </button>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/reporte.5dbf29532e3badcdc0e913765249c62a.svg";

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/download.51f874324f7dc0090253dc020559aa20.png";

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/settings.e20ded87d53092d9bd155809d5926363.png";

/***/ }),
/* 944 */
/***/ (function(module, exports) {

	module.exports = ".td-btn{\n\tpadding-left: 0px;\n\tpadding-right: 0px;\n}\n"

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var sucursal_1 = __webpack_require__(908);
	var ubicacion_1 = __webpack_require__(912);
	var ubicacion_service_1 = __webpack_require__(573);
	var permiso_service_1 = __webpack_require__(427);
	var login_service_1 = __webpack_require__(381);
	var _ = __webpack_require__(580);
	var UbicacionComponent = (function () {
	    function UbicacionComponent(ubicacionService, permisoService, loginService) {
	        this.ubicacionService = ubicacionService;
	        this.permisoService = permisoService;
	        this.loginService = loginService;
	        this.permisos = new core_1.EventEmitter();
	    }
	    UbicacionComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.ubicacion = new ubicacion_1.Ubicacion();
	        this.active = true;
	        //Pedir permisos
	        this.permisoService.getPermiso("ubicacion").subscribe(function (permisos) {
	            var respuesta = new Map();
	            for (var _i = 0, _a = permisos.tipoPermiso; _i < _a.length; _i++) {
	                var permiso = _a[_i];
	                respuesta.set(permiso.descripcion, true);
	            }
	            _this.permisos.emit({ permisos: respuesta });
	        });
	        this.usuario = this.loginService.getDecodeToken();
	    };
	    UbicacionComponent.prototype.closeModal = function () {
	        var _this = this;
	        //Reseteo form para eliminar errores
	        this.active = false;
	        setTimeout(function () { return _this.active = true; }, 0);
	        //Inicializo variables
	        if (this.ubicacion._id != undefined && this.ubicacion._id != "" && this.ubicacion._id != null)
	            this.ubicacionService.getUbicacion(this.ubicacion._id).subscribe(function (ubicacion) {
	                _this.ubicacion.descripcion = ubicacion.descripcion;
	                _this.ubicacion.area = ubicacion.area;
	            });
	        //this.ubicacion = new Ubicacion();
	        //Seteo bandera para deshabilitar
	        this.deshabilitar = false;
	        //Ocultar modal
	        $("#modalUbicacion").modal("hide");
	        $("#confirmacionUbicacion").modal("hide");
	    };
	    UbicacionComponent.prototype.eliminar = function () {
	        var _this = this;
	        //Busco ubicacion
	        this.ubicacionService
	            .getUbicacion(this.ubicacion._id)
	            .subscribe(function (ubicacion) {
	            _this.ubicacionService.delete(ubicacion).subscribe(function (ubicacion) {
	                for (var _i = 0, _a = _this.sucursal.ubicaciones; _i < _a.length; _i++) {
	                    var ubicacionL = _a[_i];
	                    if (ubicacionL._id == ubicacion._id) {
	                        ubicacionL.estado = ubicacion.estado;
	                        if (!ubicacion.estado)
	                            for (var _b = 0, _c = ubicacionL.nodos; _b < _c.length; _b++) {
	                                var nodo = _c[_b];
	                                nodo.estado = ubicacion.estado;
	                                for (var _d = 0, _e = nodo.sensores_id; _d < _e.length; _d++) {
	                                    var sensor = _e[_d];
	                                    sensor.estado = ubicacionL.estado;
	                                    for (var _f = 0, _g = sensor.alarmas; _f < _g.length; _f++) {
	                                        var alarma = _g[_f];
	                                        alarma.estado = ubicacion.estado;
	                                        for (var _h = 0, _j = alarma.avisosLista; _h < _j.length; _h++) {
	                                            var aviso = _j[_h];
	                                            aviso.estado = ubicacion.estado;
	                                        }
	                                    }
	                                }
	                            }
	                        break;
	                    }
	                }
	            });
	            $("#confirmacionUbicacion").modal("hide");
	        });
	    };
	    UbicacionComponent.prototype.save = function () {
	        var _this = this;
	        //Determino operacion
	        var operacion = "";
	        if (this.ubicacion._id == "" || this.ubicacion._id == undefined)
	            operacion = "agregar";
	        else
	            operacion = "modificar";
	        //Elimino redundancia
	        this.ubicacion.sucursal_id = this.sucursal._id;
	        var ubicacionSimplificada = _.cloneDeep(this.ubicacion);
	        delete ubicacionSimplificada.nodos;
	        //Guardo
	        this.ubicacionService
	            .save(ubicacionSimplificada)
	            .subscribe(function (ubicacion) {
	            //Inicializo variables
	            _this.ubicacion = ubicacion;
	            //Actualizo listas
	            if (operacion == "agregar")
	                _this.sucursal.ubicaciones.push(ubicacion);
	            else {
	                _this.ubicacion.descripcion = ubicacion.descripcion;
	                _this.ubicacion.area = ubicacion.area;
	                for (var _i = 0, _a = _this.sucursal.ubicaciones; _i < _a.length; _i++) {
	                    var ubicacionL = _a[_i];
	                    if (ubicacionL._id == ubicacion._id) {
	                        ubicacionL.descripcion = ubicacion.descripcion;
	                        ubicacionL.area = ubicacion.area;
	                        break;
	                    }
	                }
	            }
	            //Ocultar modal
	            $("#modalUbicacion").modal("hide");
	            //Reseteo formEmpresa para eliminar errores
	            _this.active = false;
	            setTimeout(function () { return _this.active = true; }, 0);
	        });
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof sucursal_1.Sucursal !== 'undefined' && sucursal_1.Sucursal) === 'function' && _a) || Object)
	    ], UbicacionComponent.prototype, "sucursal", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_b = typeof ubicacion_1.Ubicacion !== 'undefined' && ubicacion_1.Ubicacion) === 'function' && _b) || Object)
	    ], UbicacionComponent.prototype, "ubicacion", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], UbicacionComponent.prototype, "permisos", void 0);
	    UbicacionComponent = __decorate([
	        core_1.Component({
	            selector: 'ubicacion',
	            template: __webpack_require__(946),
	            styles: [__webpack_require__(947)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_c = typeof ubicacion_service_1.UbicacionService !== 'undefined' && ubicacion_service_1.UbicacionService) === 'function' && _c) || Object, (typeof (_d = typeof permiso_service_1.PermisoService !== 'undefined' && permiso_service_1.PermisoService) === 'function' && _d) || Object, (typeof (_e = typeof login_service_1.LoginService !== 'undefined' && login_service_1.LoginService) === 'function' && _e) || Object])
	    ], UbicacionComponent);
	    return UbicacionComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.UbicacionComponent = UbicacionComponent;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(419)))

/***/ }),
/* 946 */
/***/ (function(module, exports) {

	module.exports = "<!-- Modal -->\n<div class=\"modal fade\" id=\"modalUbicacion\" data-backdrop=\"static\"  tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modalUbicacionLabel\" style=\"z-indez:99999999\">\n    <div class=\"modal-dialog modal-md\" role=\"document\" style=\"z-indez:99999\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" (click)=\"closeModal()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n                <h4 class=\"modal-title\" id=\"modalUbicacionLabel\">Ubicación</h4>\n            </div>\n            <form #ubicacionForm=\"ngForm\" *ngIf=\"active\">\n                <div class=\"modal-body\">\n                    <div class=\"form-group\">\n                        <label for=\"sucursal\">Sucursal</label>\n                        <input *ngIf=\"sucursal\" type=\"text\" disabled class=\"form-control\" id=\"sucursal\" placeholder=\"Descripción\" [(ngModel)]=\"sucursal.descripcion\" name=\"sucursal\">\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"descripcion\">Descripción</label>\n                        <span class=\"glyphicon glyphicon-question-sign ayuda\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Descripción de referencia para la ubicación.\"></span>\n                        <input type=\"text\" class=\"form-control\" required id=\"descripcion\" placeholder=\"Descripción\" [(ngModel)]=\"ubicacion.descripcion\" name=\"descripcion\" #descripcion=\"ngModel\" autocomplete=\"off\" [disabled]=\"deshabilitar\">\n                        <div [hidden]=\"descripcion.valid || descripcion.pristine\" class=\"alert alert-danger\">\n                            Descripción es requerido\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"area\">Área</label>\n                        <span class=\"glyphicon glyphicon-question-sign ayuda\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Área en la cual se encuentra la ubicación.\"></span>\n                        <input type=\"text\" class=\"form-control\" required id=\"area\" placeholder=\"Área\" [(ngModel)]=\"ubicacion.area\" name=\"area\" #area=\"ngModel\" autocomplete=\"off\" [disabled]=\"deshabilitar\">\n                        <div [hidden]=\"area.valid || area.pristine\" class=\"alert alert-danger\">\n                            Área es requerido\n                        </div>\n                    </div>\n                    <div class=\"form-group\" *ngIf=\"usuario.rol == 'Administrador' || usuario.rol == 'Tecnico'\">\n                        <label for=\"enviaSms\">Envía SMS</label>\n                        <span class=\"glyphicon glyphicon-question-sign ayuda\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Habilita el envío de SMS.\"></span>\n                        <select class=\"form-control\" required id=\"enviaSms\" name=\"enviaSms\" [(ngModel)]=\"ubicacion.enviaSms\" autocomplete=\"off\" #enviaSms=\"ngModel\" [disabled]=\"deshabilitar\">\n                            <option value={{false}}>No</option>\n                            <option value={{true}}>Sí</option>\n                        </select>\n                        <div [hidden]=\"enviaSms.valid || enviaSms.pristine\" class=\"alert alert-danger\">\n                            Envía SMS es requerido\n                        </div>\n                    </div>\n                </div>\n                <div class=\"clearfix visible-md-block\"></div>\n                <div class=\"clearfix visible-lg-block\"></div>\n                <div class=\"clearfix visible-sm-block\"></div>\n                <div class=\"clearfix visible-xs-block\"></div>\n                <div class=\"modal-footer\">\n                    <button type=\"button\" class=\"btn btn-default\" (click)=\"closeModal()\">Cancelar</button>\n                    <button type=\"button\" class=\"btn btn-success\" (click)=\"save()\" class=\"btn btn-success\" [disabled]=\"deshabilitar || (ubicacionForm!=undefined && !ubicacionForm.form.valid)\">Guardar</button>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>\n<div id=\"confirmacionUbicacion\" class=\"modal fade\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" aria-hidden=\"true\">&times;</button>\n                <h4 class=\"modal-title\">Confirmación</h4>\n            </div>\n            <div class=\"modal-body\">\n                <p *ngIf=\"ubicacion.estado\">Está seguro que desea eliminar la ubicación?</p>\n                <p *ngIf=\"!ubicacion.estado\">Está seguro que desea restaurar la ubicación?</p>\n                <p class=\"text-warning\"><small>Los datos relacionados también se eliminarán.</small></p>\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-default\" (click)=\"closeModal()\">Cerrar</button>\n                <button type=\"button\" class=\"btn btn-danger\" (click)=\"eliminar()\">Aceptar</button>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 947 */
867,
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var sucursal_service_1 = __webpack_require__(429);
	var empresa_service_1 = __webpack_require__(425);
	var permiso_service_1 = __webpack_require__(427);
	var router_1 = __webpack_require__(329);
	var login_service_1 = __webpack_require__(381);
	var gateway_1 = __webpack_require__(949);
	var gateway_service_1 = __webpack_require__(574);
	var nodo_service_1 = __webpack_require__(433);
	__webpack_require__(653);
	var myGlobals = __webpack_require__(414);
	var GatewayComponent = (function () {
	    function GatewayComponent(sucursalService, empresaService, loginService, permisoService, gatewayService, nodoService, router) {
	        this.sucursalService = sucursalService;
	        this.empresaService = empresaService;
	        this.loginService = loginService;
	        this.permisoService = permisoService;
	        this.gatewayService = gatewayService;
	        this.nodoService = nodoService;
	        this.router = router;
	    }
	    GatewayComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        window.scrollTo(0, 0);
	        //Pedir permisos
	        this.permisos = new Map();
	        this.permisoService.getPermiso("gateway").subscribe(function (permisos) {
	            for (var _i = 0, _a = permisos.tipoPermiso; _i < _a.length; _i++) {
	                var permiso = _a[_i];
	                _this.permisos.set(permiso.descripcion, true);
	            }
	            //Si no tiene permiso para ver redirijo
	            if (!_this.permisos.get("read"))
	                _this.router.navigate(['/home']);
	        });
	        //Inicializar tabla
	        $("#grid-data").bootgrid({
	            ajax: true,
	            url: myGlobals.default.BASE_URL + "/gateway/gatewayTable",
	            selection: true,
	            multiSelect: false,
	            rowSelect: true,
	            formatters: {
	                "empresa": function (column, row) {
	                    return row.sucursal_id.empresa.descripcion;
	                },
	                "sucursal": function (column, row) {
	                    return row.sucursal_id.descripcion;
	                },
	                "estado": function (column, row) {
	                    return row.estado == true ? "Activo" : "<span class=\"label label-danger\">Inactivo</span>";
	                }
	            },
	            ajaxSettings: {
	                headers: {
	                    "Authorization": this.loginService.getToken()
	                },
	                method: "GET"
	            }
	        });
	        //Cerrar alert
	        $("#alertSeleccion").hide();
	        //Inicializar banderas para resetear forms
	        this.active = true;
	        //Inicializar gateway
	        this.gateway = new gateway_1.Gateway();
	        //Inicializar bandera deshabilitar
	        this.deshabilitar = true;
	        //Cargar empresas
	        this.empresaService.getEmpresas()
	            .subscribe(function (empresas) {
	            _this.empresas = empresas;
	        });
	    };
	    GatewayComponent.prototype.ngOnDestroy = function () {
	    };
	    GatewayComponent.prototype.agregar = function () {
	        var _this = this;
	        //Reseteo formEmpresa para eliminar errores
	        this.active = false;
	        setTimeout(function () { return _this.active = true; }, 0);
	        //Inicializo variables
	        this.gateway = new gateway_1.Gateway();
	        //Seteo bandera para deshabilitar
	        this.deshabilitar = false;
	        //Muestro modal
	        $("#modalGateway").modal("show");
	        //Cerrar alert
	        $("#alertSeleccion").hide();
	    };
	    GatewayComponent.prototype.modificar = function () {
	        var _this = this;
	        //Obtener id seleccionado
	        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
	        //Si no hay nada seleccionado mostrar alert
	        if (this.idSeleccionado == undefined) {
	            $("#alertSeleccion").show();
	        }
	        else {
	            if (this.idSeleccionado != "0") {
	                //Cerrar alert
	                $("#alertSeleccion").hide();
	                //Busco usuario
	                this.gatewayService
	                    .getGateway(this.idSeleccionado)
	                    .subscribe(function (gateway) {
	                    _this.gateway = gateway;
	                    _this.cargarSucursales(gateway.sucursal_id.empresa);
	                });
	                //Seteo bandera para deshabilitar
	                this.deshabilitar = false;
	                //Muestro modal
	                $("#modalGateway").modal("show");
	            }
	        }
	    };
	    GatewayComponent.prototype.eliminar = function () {
	        var _this = this;
	        //Obtener id seleccionado
	        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
	        //Si no hay nada seleccionado mostrar alert
	        if (this.idSeleccionado == undefined) {
	            $("#alertSeleccion").show();
	        }
	        else {
	            if (this.idSeleccionado != "0") {
	                //Cerrar alert
	                $("#alertSeleccion").hide();
	                //Busco gateway
	                this.gatewayService
	                    .getGateway(this.idSeleccionado)
	                    .subscribe(function (gateway) {
	                    _this.gatewayService.delete(gateway).subscribe(function () { return $("#grid-data").bootgrid("reload"); });
	                });
	            }
	        }
	    };
	    GatewayComponent.prototype.ver = function () {
	        var _this = this;
	        //Obtener id seleccionado
	        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
	        //Si no hay nada seleccionado mostrar alert
	        if (this.idSeleccionado == undefined) {
	            $("#alertSeleccion").show();
	        }
	        else {
	            if (this.idSeleccionado != "0") {
	                //Cerrar alert
	                $("#alertSeleccion").hide();
	                //Busco gateway
	                this.gatewayService
	                    .getGateway(this.idSeleccionado)
	                    .subscribe(function (gateway) {
	                    _this.gateway = gateway;
	                });
	                //Seteo bandera para deshabilitar
	                this.deshabilitar = true;
	                //Muestro modal
	                $("#modalGateway").modal("show");
	            }
	        }
	    };
	    GatewayComponent.prototype.exportar = function () {
	        var _this = this;
	        //Obtener id seleccionado
	        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
	        //Si no hay nada seleccionado mostrar alert
	        if (this.idSeleccionado == undefined) {
	            $("#alertSeleccion").show();
	        }
	        else {
	            if (this.idSeleccionado != "0") {
	                //Cerrar alert
	                $("#alertSeleccion").hide();
	                //Busco gateway
	                this.nodoService
	                    .getNodosByGateway(this.idSeleccionado)
	                    .subscribe(function (nodos) {
	                    _this.nodos = nodos;
	                    var desGateway = "";
	                    if (nodos.length > 0) {
	                        var dataString_1 = "";
	                        var csvContent_1 = nodos[0].gateway_id._id + "," + nodos[0].gateway_id.pass + "\n";
	                        nodos.forEach(function (nodo, index) {
	                            desGateway = nodo.gateway_id.descripcion.replace(" ", "");
	                            dataString_1 = nodo.etiqueta + "," + nodo.tipo_id.descripcion + "," + nodo.sensores_id.length;
	                            //if (nodo.tipo_id.rangoDesde != undefined && nodo.tipo_id.rangoHasta != undefined)
	                            //dataString += "," + nodo.tipo_id.rangoDesde + "," + nodo.tipo_id.rangoHasta;
	                            csvContent_1 += dataString_1;
	                            if (nodo.tipo_id.descripcion.toLowerCase().trim() == "corriente"
	                                || nodo.tipo_id.descripcion.toLowerCase().trim() == "tension"
	                                || nodo.tipo_id.descripcion.toLowerCase().trim() == "tensión") {
	                                csvContent_1 += ",";
	                                nodo.sensores_id.forEach(function (sensor, index) {
	                                    dataString_1 = sensor.tipo_id.rangoDesde + "," + sensor.tipo_id.rangoHasta;
	                                    console.log(index);
	                                    csvContent_1 += index < nodo.sensores_id.length - 1 ? dataString_1 + "," : (dataString_1 + "");
	                                });
	                            }
	                            csvContent_1 += "/";
	                            nodo.sensores_id.forEach(function (sensor, index) {
	                                if (sensor.tipo_id.m && sensor.tipo_id.h) {
	                                    dataString_1 = sensor.tipo_id.m + "," + sensor.tipo_id.h;
	                                    console.log(index);
	                                    csvContent_1 += index < nodo.sensores_id.length - 1 ? dataString_1 + "," : (dataString_1 + "");
	                                }
	                                // else
	                                //     csvContent += "\n";
	                            });
	                            csvContent_1 += "\n";
	                        });
	                        /*for(let gateway of this.gateways){
	                         if(gateway._id == this.idSeleccionado){
	                         this.gateway = gateway;
	                         break;
	                         }
	                         }*/
	                        var a = document.createElement('a');
	                        a.href = 'data:attachment/csv,' + encodeURIComponent(csvContent_1);
	                        a.target = '_blank';
	                        var d = new Date();
	                        var datestring = d.getDate() + "" + (d.getMonth() + 1) + "" + d.getFullYear() + " " +
	                            d.getHours() + "" + d.getMinutes();
	                        a.download = desGateway + "-" + datestring + '.csv';
	                        document.body.appendChild(a);
	                        a.click();
	                    }
	                    else
	                        alert("El gateway seleccionado no tiene nodos cargados.");
	                });
	                this.deshabilitar = true;
	            }
	        }
	    };
	    GatewayComponent.prototype.save = function () {
	        var _this = this;
	        this.gatewayService
	            .save(this.gateway)
	            .subscribe(function (gateway) {
	            _this.gateway = gateway;
	            //Inicializo variables
	            _this.gateway = new gateway_1.Gateway();
	            //Ocultar modal
	            $("#modalGateway").modal("hide");
	            //Reseteo formGateway para eliminar errores
	            _this.active = false;
	            setTimeout(function () { return _this.active = true; }, 0);
	            //Recargo tabla
	            $("#grid-data").bootgrid("reload");
	        });
	    };
	    GatewayComponent.prototype.cargarSucursales = function (idEmpresa) {
	        var _this = this;
	        this.sucursalService.getSucursalByEmpresa(idEmpresa)
	            .subscribe(function (sucursales) {
	            _this.sucursales = sucursales;
	        });
	    };
	    GatewayComponent.prototype.hideAlert = function () {
	        $("#alertSeleccion").hide();
	    };
	    GatewayComponent = __decorate([
	        core_1.Component({
	            selector: 'gateway',
	            template: __webpack_require__(950),
	            styles: [__webpack_require__(951)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof sucursal_service_1.SucursalService !== 'undefined' && sucursal_service_1.SucursalService) === 'function' && _a) || Object, (typeof (_b = typeof empresa_service_1.EmpresaService !== 'undefined' && empresa_service_1.EmpresaService) === 'function' && _b) || Object, (typeof (_c = typeof login_service_1.LoginService !== 'undefined' && login_service_1.LoginService) === 'function' && _c) || Object, (typeof (_d = typeof permiso_service_1.PermisoService !== 'undefined' && permiso_service_1.PermisoService) === 'function' && _d) || Object, (typeof (_e = typeof gateway_service_1.GatewayService !== 'undefined' && gateway_service_1.GatewayService) === 'function' && _e) || Object, (typeof (_f = typeof nodo_service_1.NodoService !== 'undefined' && nodo_service_1.NodoService) === 'function' && _f) || Object, (typeof (_g = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _g) || Object])
	    ], GatewayComponent);
	    return GatewayComponent;
	    var _a, _b, _c, _d, _e, _f, _g;
	}());
	exports.GatewayComponent = GatewayComponent;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(419)))

/***/ }),
/* 949 */
/***/ (function(module, exports) {

	"use strict";
	var Gateway = (function () {
	    function Gateway() {
	    }
	    return Gateway;
	}());
	exports.Gateway = Gateway;


/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 contenido\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 titulo\">\n        <div class=\"marcoTitulo\">\n            <h2>Gateway</h2>\n            <p>Home / Carga Datos / Gateway</p>\n        </div>\n    </div>\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 marcoDatos\">\n        <div class=\"datos\">\n            <div class=\"alert alert-warning\" id=\"alertSeleccion\" name=\"alertSeleccion\">\n                <a class=\"close\" (click)=\"hideAlert()\">&times;</a> Debe selecccionar una casilla primero.\n            </div>\n            <div class=\"table-responsive\">\n                <table id=\"grid-data\" class=\"table table-condensed table-hover \">\n                    <thead>\n                    <tr>\n                        <th data-column-id=\"_id\" data-identifier=\"true\" data-visible=\"false\"\n                            data-visible-in-selection=\"false\" data-order=\"desc\">_id\n                        </th>\n                        <th data-column-id=\"sucursal_id.empresa\" data-sortable=\"false\" data-formatter=\"empresa\">Empresa</th>\n                        <th data-column-id=\"sucursal_id\" data-sortable=\"false\" data-formatter=\"sucursal\">Nombre Sucursal</th>\n                        <th data-column-id=\"etiqueta\">Etiqueta</th>\n                        <th data-column-id=\"descripcion\">Descripcion</th>\n                        <th data-column-id=\"url\">URL</th>\n                        <th data-column-id=\"puerto\">Puerto</th>\n                        <th data-column-id=\"estado\" data-formatter=\"estado\">Estado</th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n    <button data-toggle=\"tooltip\" data-placement=\"top\" title=\"Deshabilitar\" animation=\"true\"\n            class=\"btn btn-default btn-sm botonFlotante btn-danger\" (click)=\"eliminar()\"\n            [disabled]=\"permisos.get('delete')!=true\">\n        <img src=\"" + __webpack_require__(933) + "\" width=\"20px\"/>\n    </button>\n    <button data-toggle=\"tooltip\" data-placement=\"top\" title=\"Modificar\" animation=\"true\"\n            class=\"btn btn-default btn-sm botonFlotante2 btn-warning\" (click)=\"modificar()\"\n            [disabled]=\"permisos.get('update')!=true\">\n        <img src=\"" + __webpack_require__(934) + "\" width=\"25px\"/>\n    </button>\n    <button data-toggle=\"tooltip\" data-placement=\"top\" title=\"Agregar\" animation=\"true\"\n            class=\"btn btn-default btn-sm botonFlotante3 btn-success\" (click)=\"agregar()\"\n            [disabled]=\"permisos.get('create')!=true\">\n        <img src=\"" + __webpack_require__(935) + "\" width=\"25px\"/>\n    </button>\n    <button data-toggle=\"tooltip\" data-placement=\"top\" title=\"Ver\" animation=\"true\"\n            class=\"btn btn-default btn-sm botonFlotante4 btn-primary\" (click)=\"ver()\"\n            [disabled]=\"permisos.get('read')!=true\">\n        <img src=\"" + __webpack_require__(936) + "\" width=\"30px\"/>\n    </button>\n    <button data-toggle=\"tooltip\" data-placement=\"top\" title=\"Exportar Configuración\" animation=\"true\"\n            class=\"btn btn-default btn-sm botonFlotante5 btn-default\" (click)=\"exportar()\"\n            [disabled]=\"permisos.get('export')!=true\">\n        <img src=\"" + __webpack_require__(918) + "\" width=\"25px\"/>\n    </button>\n    <!-- Modal -->\n    <div class=\"modal fade\" id=\"modalGateway\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\"\n         style=\"z-indez:99999999\">\n        <div class=\"modal-dialog modal-md\" role=\"document\" style=\"z-indez:99999\">\n            <div class=\"modal-content\">\n                <form #gatewayForm=\"ngForm\" *ngIf=\"active\">\n                    <div class=\"modal-header\">\n                        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span\n                                aria-hidden=\"true\">&times;</span></button>\n                        <h4 class=\"modal-title\" id=\"myModalLabel\">Gateway</h4>\n                    </div>\n                    <div class=\"modal-body\">\n                        <div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\">\n                            <div class=\"form-group\">\n                                <label for=\"empresa\">Empresa</label>\n                                <div>\n                                    <select class=\"form-control\" required id=\"empresa\" name=\"empresaId\"\n                                            [(ngModel)]=\"gateway.sucursal_id!=undefined?(gateway.sucursal_id.empresa!=undefined?gateway.sucursal_id.empresa:empresa._id):empresa._id\" autocomplete=\"off\"\n                                            (change)=\"cargarSucursales($event.target.value); empresa._id=$event.target.value;\" #empresa=\"ngModel\"\n                                            [disabled]=\"deshabilitar\">'\n                                        <option></option>\n                                        <option *ngFor=\"let empresa of empresas\" [value]=\"empresa._id\">\n                                            {{empresa.descripcion}}\n                                        </option>\n                                    </select>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\">\n                            <div class=\"form-group\">\n                                <label for=\"sucursal\">Sucursal</label>\n                                <select class=\"form-control\" required id=\"sucursal\" name=\"sucursal\"\n                                        [(ngModel)]=\"gateway.sucursal_id!=undefined?gateway.sucursal_id._id:gateway.sucursal_id\" autocomplete=\"off\" #sucursal=\"ngModel\"\n                                        [disabled]=\"deshabilitar\">\n                                    <option></option>\n                                    <option *ngFor=\"let sucursal of sucursales\" [value]=\"sucursal._id\">\n                                        {{sucursal.descripcion}}\n                                    </option>\n                                </select>\n                                <div [hidden]=\"sucursal.valid || sucursal.pristine\" class=\"alert alert-danger\">\n                                    Sucursal es requerido\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"form-group\">\n                            <label for=\"etiqueta\">Etiqueta</label>\n                            <input type=\"text\" class=\"form-control\" id=\"etiqueta\" placeholder=\"Etiqueta\" required\n                                   [(ngModel)]=\"gateway.etiqueta\" name=\"etiqueta\" #etiqueta=\"ngModel\" autocomplete=\"off\"\n                                   [disabled]=\"deshabilitar\">\n                            <div [hidden]=\"etiqueta.valid || etiqueta.pristine\" class=\"alert alert-danger\">\n                                Etiqueta es requerido\n                            </div>\n                        </div>\n                        <div class=\"form-group\">\n                            <label for=\"descripcion\">Descripcion</label>\n                            <input type=\"text\" class=\"form-control\" id=\"descripcion\" placeholder=\"Descripcion\" required\n                                   [(ngModel)]=\"gateway.descripcion\" name=\"descripcion\" #descripcion=\"ngModel\"\n                                   autocomplete=\"off\" [disabled]=\"deshabilitar\">\n                            <div [hidden]=\"descripcion.valid || descripcion.pristine\" class=\"alert alert-danger\">\n                                Descripcion es requerido\n                            </div>\n                        </div>\n                        <div class=\"form-group\">\n                            <label for=\"url\">IP</label>\n                            <span class=\"glyphicon glyphicon-question-sign ayuda\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Campo informativo.\"></span>\n                            <input type=\"text\" class=\"form-control\" id=\"url\" placeholder=\"IP\"\n                                   [(ngModel)]=\"gateway.url\" name=\"url\" #url=\"ngModel\" autocomplete=\"off\"\n                                   [disabled]=\"deshabilitar\">\n                            <div [hidden]=\"url.valid || url.pristine\" class=\"alert alert-danger\">\n                                IP es requerido\n                            </div>\n                        </div>\n                        <div class=\"form-group\">\n                            <label for=\"puerto\">Puerto</label>\n                            <span class=\"glyphicon glyphicon-question-sign ayuda\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Campo informativo.\"></span>\n                            <input type=\"number\" class=\"form-control\" id=\"puerto\" placeholder=\"Puerto\"\n                                   [(ngModel)]=\"gateway.puerto\" name=\"puerto\" #puerto=\"ngModel\" autocomplete=\"off\"\n                                   [disabled]=\"deshabilitar\">\n                            <div [hidden]=\"puerto.valid || puerto.pristine\" class=\"alert alert-danger\">\n                                Puerto es requerido\n                            </div>\n                        </div>\n\n                    </div>\n                    <div class=\"clearfix visible-md-block\"></div>\n                    <div class=\"clearfix visible-lg-block\"></div>\n                    <div class=\"clearfix visible-sm-block\"></div>\n                    <div class=\"clearfix visible-xs-block\"></div>\n                    <div class=\"modal-footer\">\n                        <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Cancelar</button>\n                        <button type=\"button\" (click)=\"save(sucursal_id)\" class=\"btn btn-success\"\n                                [disabled]=\"deshabilitar ||  !gatewayForm.form.valid\">Guardar\n                        </button>\n                    </div>\n                </form>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 951 */
867,
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var ubicacion_1 = __webpack_require__(912);
	var nodo_1 = __webpack_require__(953);
	var nodo_service_1 = __webpack_require__(433);
	var gateway_service_1 = __webpack_require__(574);
	var tipoSensor_service_1 = __webpack_require__(576);
	var tipoBateria_service_1 = __webpack_require__(577);
	var permiso_service_1 = __webpack_require__(427);
	var login_service_1 = __webpack_require__(381);
	var _ = __webpack_require__(580);
	var NodoComponent = (function () {
	    function NodoComponent(nodoService, gatewayService, tipoSensorService, tipoBateriaService, permisoService, loginService) {
	        this.nodoService = nodoService;
	        this.gatewayService = gatewayService;
	        this.tipoSensorService = tipoSensorService;
	        this.tipoBateriaService = tipoBateriaService;
	        this.permisoService = permisoService;
	        this.loginService = loginService;
	        this.permisos = new core_1.EventEmitter();
	    }
	    NodoComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.nodo = new nodo_1.Nodo();
	        this.ubicacion = new ubicacion_1.Ubicacion();
	        this.active = true;
	        //Pedir permisos
	        this.permisoService.getPermiso("nodo").subscribe(function (permisos) {
	            var respuesta = new Map();
	            for (var _i = 0, _a = permisos.tipoPermiso; _i < _a.length; _i++) {
	                var permiso = _a[_i];
	                respuesta.set(permiso.descripcion, true);
	            }
	            _this.permisos.emit({ permisos: respuesta });
	        });
	        this.usuario = this.loginService.getDecodeToken();
	    };
	    NodoComponent.prototype.ngOnChanges = function (changes) {
	        var _this = this;
	        if (this.ubicacion != undefined && this.ubicacion.sucursal_id != undefined)
	            this.gatewayService.getGatewaysBySucursal(this.ubicacion.sucursal_id)
	                .subscribe(function (gateways) { return _this.gateways = gateways; });
	        this.tipoSensorService.getTipoSensores()
	            .subscribe(function (tipos) { return _this.tiposSensores = tipos; });
	        this.tipoBateriaService.getTipoBaterias()
	            .subscribe(function (tipos) { return _this.tiposBaterias = tipos; });
	        if (this.nodo != undefined && this.nodo._id != undefined) {
	            this.nodo.fechaAlta = this.nodo.fechaAlta.toString().slice(0, 10);
	            this.nodo.fechaAltaBateria = this.nodo.fechaAltaBateria.toString().slice(0, 10);
	        }
	    };
	    NodoComponent.prototype.onBlurFrecuencia = function () {
	        if (this.nodo.frecuenciaMedicion && !this.nodo.tiempoActividad)
	            this.nodo.tiempoActividad = parseInt((this.nodo.frecuenciaMedicion * 2.2).toFixed(0));
	    };
	    NodoComponent.prototype.closeModal = function () {
	        var _this = this;
	        //Reseteo formEmpresa para eliminar errores
	        this.active = false;
	        setTimeout(function () { return _this.active = true; }, 0);
	        //Inicializo variables
	        if (this.nodo._id != undefined && this.nodo._id != "" && this.nodo._id != null)
	            this.nodoService.getNodo(this.nodo._id).subscribe(function (nodo) {
	                for (var _i = 0, _a = _this.ubicacion.nodos; _i < _a.length; _i++) {
	                    var nodoL = _a[_i];
	                    if (nodoL._id == nodo._id) {
	                        nodoL.etiqueta = nodo.etiqueta;
	                        nodoL.nombre = nodo.nombre;
	                        nodoL.fechaAlta = nodo.fechaAlta;
	                        nodoL.fechaAltaBateria = nodo.fechaAltaBateria;
	                        nodoL.tiempoActividad = nodo.tiempoActividad;
	                        nodoL.frecuenciaMedicion = nodo.frecuenciaMedicion;
	                        nodoL.tipo_id = nodo.tipo_id;
	                        nodoL.tipoBateria_id = nodo.tipoBateria_id;
	                        nodoL.duracionEstimada = nodo.duracionEstimada;
	                        nodoL.gateway_id = nodo.gateway_id;
	                        break;
	                    }
	                }
	            });
	        //Seteo bandera para deshabilitar
	        this.deshabilitar = false;
	        //Ocultar modal
	        $("#modalNodo").modal("hide");
	        $("#confirmacionNodo").modal("hide");
	    };
	    NodoComponent.prototype.eliminar = function () {
	        var _this = this;
	        if (this.nodo.borradoPermanente === true)
	            this.nodoService.deleteStrict(this.nodo).subscribe(function () {
	                _this.ubicacion.nodos = _this.ubicacion.nodos.filter(function (nodoL) { return nodoL._id !== _this.nodo._id; });
	                $("#confirmacionNodo").modal("hide");
	                _this.nodo = new nodo_1.Nodo();
	            });
	        else
	            this.nodoService
	                .getNodo(this.nodo._id)
	                .subscribe(function (nodo) {
	                _this.nodoService.delete(nodo).subscribe(function (nodo) {
	                    for (var _i = 0, _a = _this.ubicacion.nodos; _i < _a.length; _i++) {
	                        var nodoL = _a[_i];
	                        if (nodoL._id == nodo._id) {
	                            nodoL.estado = nodo.estado;
	                            if (!nodo.estado)
	                                for (var _b = 0, _c = nodoL.sensores_id; _b < _c.length; _b++) {
	                                    var sensor = _c[_b];
	                                    sensor.estado = nodo.estado;
	                                    for (var _d = 0, _e = sensor.alarmas; _d < _e.length; _d++) {
	                                        var alarma = _e[_d];
	                                        alarma.estado = nodo.estado;
	                                        for (var _f = 0, _g = alarma.avisosLista; _f < _g.length; _f++) {
	                                            var aviso = _g[_f];
	                                            aviso.estado = nodo.estado;
	                                        }
	                                    }
	                                }
	                            break;
	                        }
	                    }
	                });
	                $("#confirmacionNodo").modal("hide");
	                //setTimeout(function(){$('body').removeClass('modal-open');},4000);
	            });
	    };
	    NodoComponent.prototype.save = function () {
	        var _this = this;
	        var operacion = "";
	        if (this.nodo._id == "" || this.nodo._id == undefined)
	            operacion = "agregar";
	        else
	            operacion = "modificar";
	        this.nodo.ubicacion_id = this.ubicacion;
	        var nodoSimplificado = _.cloneDeep(this.nodo);
	        delete nodoSimplificado.ubicacion_id.nodos;
	        this.nodoService
	            .save(nodoSimplificado)
	            .subscribe(function (nodo) {
	            //Inicializo variables
	            _this.nodo = nodo;
	            //Actualizo listas
	            if (operacion == "agregar") {
	                if (_this.ubicacion.nodos == undefined)
	                    _this.ubicacion.nodos = [];
	                _this.ubicacion.nodos.push(nodo);
	            }
	            else {
	                for (var _i = 0, _a = _this.ubicacion.nodos; _i < _a.length; _i++) {
	                    var nodoL = _a[_i];
	                    if (nodoL._id == nodo._id) {
	                        nodoL.etiqueta = nodo.etiqueta;
	                        nodoL.nombre = nodo.nombre;
	                        nodoL.fechaAlta = nodo.fechaAlta;
	                        nodoL.fechaAltaBateria = nodo.fechaAltaBateria;
	                        nodoL.tiempoActividad = nodo.tiempoActividad;
	                        nodoL.frecuenciaMedicion = nodo.frecuenciaMedicion;
	                        nodoL.tipo_id = nodo.tipo_id;
	                        nodoL.gateway_id = nodo.gateway_id;
	                        nodoL.tipoBateria_id = nodo.tipoBateria_id;
	                        nodoL.duracionEstimada = nodo.duracionEstimada;
	                        nodoL.repeatable = nodo.repeatable;
	                        break;
	                    }
	                }
	            }
	            _this.nodo.fechaAlta = _this.nodo.fechaAlta.toString().slice(0, 10);
	            _this.nodo.fechaAltaBateria = _this.nodo.fechaAltaBateria.toString().slice(0, 10);
	            //Ocultar modal
	            $("#modalNodo").modal("hide");
	            //Reseteo formEmpresa para eliminar errores
	            _this.active = false;
	            setTimeout(function () { return _this.active = true; }, 0);
	        });
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof ubicacion_1.Ubicacion !== 'undefined' && ubicacion_1.Ubicacion) === 'function' && _a) || Object)
	    ], NodoComponent.prototype, "ubicacion", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_b = typeof nodo_1.Nodo !== 'undefined' && nodo_1.Nodo) === 'function' && _b) || Object)
	    ], NodoComponent.prototype, "nodo", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], NodoComponent.prototype, "permisos", void 0);
	    NodoComponent = __decorate([
	        core_1.Component({
	            selector: 'nodo',
	            template: __webpack_require__(954),
	            styles: [__webpack_require__(955)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_c = typeof nodo_service_1.NodoService !== 'undefined' && nodo_service_1.NodoService) === 'function' && _c) || Object, (typeof (_d = typeof gateway_service_1.GatewayService !== 'undefined' && gateway_service_1.GatewayService) === 'function' && _d) || Object, (typeof (_e = typeof tipoSensor_service_1.TipoSensorService !== 'undefined' && tipoSensor_service_1.TipoSensorService) === 'function' && _e) || Object, (typeof (_f = typeof tipoBateria_service_1.TipoBateriaService !== 'undefined' && tipoBateria_service_1.TipoBateriaService) === 'function' && _f) || Object, (typeof (_g = typeof permiso_service_1.PermisoService !== 'undefined' && permiso_service_1.PermisoService) === 'function' && _g) || Object, (typeof (_h = typeof login_service_1.LoginService !== 'undefined' && login_service_1.LoginService) === 'function' && _h) || Object])
	    ], NodoComponent);
	    return NodoComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h;
	}());
	exports.NodoComponent = NodoComponent;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(419)))

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var moment = __webpack_require__(435);
	var Nodo = (function () {
	    function Nodo() {
	    }
	    Nodo.toString = function (data) {
	        return ("Fecha alta bateria: " + (data.fechaAltaBateria ? moment(data.fechaAltaBateria).format('DD-MM-YYYY') : 'N/A') + "\n") +
	            ("Fecha alta: " + (data.fechaAlta ? moment(data.fechaAlta).format('DD-MM-YYYY') : 'N/A') + " <br/> ") +
	            ("Sensores: " + (data.sensores_id ? data.sensores_id.length : 0));
	    };
	    return Nodo;
	}());
	exports.Nodo = Nodo;


/***/ }),
/* 954 */
/***/ (function(module, exports) {

	module.exports = "<!-- Modal -->\n<div class=\"modal fade\" id=\"modalNodo\" data-backdrop=\"static\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modalNodoLabel\" style=\"z-indez:99999999\">\n    <div class=\"modal-dialog modal-md\" role=\"document\" style=\"z-indez:99999\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" (click)=\"closeModal()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n                <h4 class=\"modal-title\" id=\"modalNodoLabel\">Nodo</h4>\n            </div>\n            <form #nodoForm=\"ngForm\" *ngIf=\"active\">\n                <div class=\"modal-body\">\n                    <div class=\"form-group\">\n                        <label for=\"ubicacion\">Ubicación</label>\n                        <input *ngIf=\"ubicacion\" type=\"text\" disabled class=\"form-control\" id=\"ubicacion\" placeholder=\"Descripción\" [(ngModel)]=\"ubicacion.descripcion\" name=\"ubicacion\">\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"descripcion\">Descripción</label>\n                        <span class=\"glyphicon glyphicon-question-sign ayuda\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Descripción de referencia para el nodo.\"></span>\n                        <input type=\"text\" class=\"form-control\" required id=\"descripcion\" placeholder=\"Descripción\" [(ngModel)]=\"nodo.nombre\" name=\"descripcion\" #descripcion=\"ngModel\" autocomplete=\"off\" [disabled]=\"deshabilitar\">\n                        <div [hidden]=\"descripcion.valid || descripcion.pristine\" class=\"alert alert-danger\">\n                            Descripción es requerido\n                        </div>\n                    </div>\n                    <div class=\"form-group\" *ngIf=\"usuario.rol == 'Administrador' || usuario.rol == 'Tecnico'\">\n                        <label for=\"nroSerie\">Número de serie</label>\n                        <span class=\"glyphicon glyphicon-question-sign ayuda\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Dirección MAC del dispositivo.\"></span>\n                        <input type=\"text\" class=\"form-control\" id=\"nroSerie\" placeholder=\"Número de serie\" [(ngModel)]=\"nodo.nroSerie\" name=\"nroSerie\" #nroSerie=\"ngModel\" autocomplete=\"off\" [disabled]=\"deshabilitar\">\n                    </div>\n                    <div class=\"form-group\" *ngIf=\"usuario.rol == 'Administrador' || usuario.rol == 'Tecnico'\">\n                        <label for=\"etiqueta\">Dirección MAC</label>\n                        <span class=\"glyphicon glyphicon-question-sign ayuda\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Dirección MAC del dispositivo.\"></span>\n                        <input type=\"text\" class=\"form-control\" required id=\"etiqueta\" placeholder=\"Dirección MAC\" [(ngModel)]=\"nodo.etiqueta\" name=\"etiqueta\" #etiqueta=\"ngModel\" autocomplete=\"off\" [disabled]=\"deshabilitar\">\n                        <div [hidden]=\"etiqueta.valid || etiqueta.pristine\" class=\"alert alert-danger\">\n                            Dirección MAC es requerido\n                        </div>\n                    </div>\n                    <div class=\"form-group\" *ngIf=\"usuario.rol == 'Administrador' || usuario.rol == 'Tecnico'\">\n                        <label for=\"fechaAlta\">Fecha Alta</label>\n                        <span class=\"glyphicon glyphicon-question-sign ayuda\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Fecha en que se instaló el dispositivo.\"></span>\n                        <input type=\"date\" class=\"form-control\" required id=\"fechaAlta\" [(ngModel)]=\"nodo.fechaAlta\" name=\"fechaAlta\" #fechaAlta=\"ngModel\" autocomplete=\"off\" [disabled]=\"deshabilitar\">\n                        <div [hidden]=\"fechaAlta.valid || fechaAlta.pristine\" class=\"alert alert-danger\">\n                            Fecha Alta es requerido\n                        </div>\n                    </div>\n                    <div class=\"form-group\" *ngIf=\"usuario.rol == 'Administrador' || usuario.rol == 'Tecnico'\">\n                        <label for=\"frecuenciaMedicion\">Frecuencia de Medición (en minutos)</label>\n                        <span class=\"glyphicon glyphicon-question-sign ayuda\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Tiempo entre datos enviados por el nodo.\"></span>\n                        <input type=\"text\" class=\"form-control\" required id=\"frecuenciaMedicion\" placeholder=\"Frecuencia de Medición (en minutos)\" [(ngModel)]=\"nodo.frecuenciaMedicion\" name=\"frecuenciaMedicion\" #frecuenciaMedicion=\"ngModel\" autocomplete=\"off\" [disabled]=\"deshabilitar\" pattern=\"^[1-9][0-9]*$\" (blur)=\"onBlurFrecuencia()\">\n                        <div [hidden]=\"frecuenciaMedicion.valid || frecuenciaMedicion.pristine\" class=\"alert alert-danger\">\n                            Frecuencia de Medición es requerido, debe ser numérico y mayor a cero.\n                        </div>\n                    </div>\n                    <div class=\"form-group\" *ngIf=\"usuario.rol == 'Administrador' || usuario.rol == 'Tecnico'\">\n                        <label for=\"tiempoActividad\">Tiempo de Alarma por Inactividad Tolerado (en minutos)</label>\n                        <span class=\"glyphicon glyphicon-question-sign ayuda\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Tiempo máximo que el nodo puede permancer inactivo (sin enviar datos), antes de generar una alarma por inactividad.\"></span>\n                        <input type=\"text\" class=\"form-control\" required id=\"tiempoActividad\" placeholder=\"Tiempo de Alarma por Inactividad Tolerado (en minutos)\" [(ngModel)]=\"nodo.tiempoActividad\" name=\"tiempoActividad\" #tiempoActividad=\"ngModel\" autocomplete=\"off\" [disabled]=\"deshabilitar\" pattern=\"^[1-9][0-9]*$\">\n                        <div [hidden]=\"tiempoActividad.valid || tiempoActividad.pristine\" class=\"alert alert-danger\">\n                            Tiempo de Alarma por Inactividad Tolerado es requerido, debe ser numérico y mayor a 0.\n                        </div>\n                    </div>\n                    <div class=\"form-group\" *ngIf=\"usuario.rol == 'Administrador' || usuario.rol == 'Tecnico'\">\n                        <label for=\"gateway\">Gateway</label>\n                        <span class=\"glyphicon glyphicon-question-sign ayuda\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Gateway al cual responde el nodo.\"></span>\n                        <select class=\"form-control\" id=\"gateway\" name=\"gatewayId\" [(ngModel)]=\"nodo.gateway_id\" autocomplete=\"off\" #gateway=\"ngModel\" [disabled]=\"deshabilitar\">\n                            <option></option>\n                            <option *ngFor=\"let gateway of gateways\" value={{gateway._id}}>{{gateway.descripcion}}\n                            </option>\n                        </select>\n                    </div>\n\n                    <div class=\"form-group\" *ngIf=\"usuario.rol == 'Administrador' || usuario.rol == 'Tecnico'\">\n                        <label for=\"tipoSensor\">Tipo de Sensores</label>\n                        <span class=\"glyphicon glyphicon-question-sign ayuda\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Tipo de sensores conectados al nodo.\"></span>\n                        <select class=\"form-control\" required id=\"tipoSensor\" name=\"tipoSensor\" [(ngModel)]=\"nodo.tipo_id\" autocomplete=\"off\" #tipoSensor=\"ngModel\" [disabled]=\"deshabilitar\">\n                            <option></option>\n                            <option *ngFor=\"let tipo of tiposSensores\" value={{tipo._id}}>{{tipo.descripcion+ (tipo.rangoDesde!=undefined ? (\"- Rango: \"+tipo.rangoDesde+\"-\"+tipo.rangoHasta) : \"\")}}\n                            </option>\n                        </select>\n                        <div [hidden]=\"tipoSensor.valid || tipoSensor.pristine\" class=\"alert alert-danger\">\n                            Tipo de Sensor es requerido\n                        </div>\n                    </div>\n\n                    <div class=\"form-group\" *ngIf=\"usuario.rol == 'Administrador' || usuario.rol == 'Tecnico'\">\n                        <label for=\"fechaAltaBateria\">Fecha Alta Bateria</label>\n                        <span class=\"glyphicon glyphicon-question-sign ayuda\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Fecha en que se instaló la batería del nodo.\"></span>\n                        <input type=\"date\" class=\"form-control\" required id=\"fechaAltaBateria\" [(ngModel)]=\"nodo.fechaAltaBateria\" [(ngModel)]=\"nodo.fechaAltaBateria\" name=\"fechaAltaBateria\" #fechaAltaBateria=\"ngModel\" autocomplete=\"off\" [disabled]=\"deshabilitar\">\n                        <div [hidden]=\"fechaAltaBateria.valid || fechaAltaBateria.pristine\" class=\"alert alert-danger\">\n                            Fecha Alta Bateria es requerido\n                        </div>\n                    </div>\n                    <div class=\"form-group\" *ngIf=\"usuario.rol == 'Administrador' || usuario.rol == 'Tecnico'\">\n                        <label for=\"tipoSensor\">Tipo de Bateria</label>\n                        <span class=\"glyphicon glyphicon-question-sign ayuda\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Tipo de bateria del nodo.\"></span>\n                        <select class=\"form-control\" required id=\"tipoBateria\" name=\"tipoBateria\" [(ngModel)]=\"nodo.tipoBateria_id\" autocomplete=\"off\" #tipoBateria=\"ngModel\" [disabled]=\"deshabilitar\">\n                            <option></option>\n                            <option *ngFor=\"let tipo of tiposBaterias\" value={{tipo._id}}>{{tipo.descripcion+ (tipo.valorLimite ? (\"- Valor límite: \"+tipo.valorLimite) : \"\")+ (tipo.duracionEstimada ? (\"- Duración estimada promedio: \"+tipo.duracionEstimada) : \"\")}}\n                            </option>\n                        </select>\n                        <div [hidden]=\"tipoBateria.valid || tipoBateria.pristine\" class=\"alert alert-danger\">\n                            Tipo de Bateria es requerido\n                        </div>\n                    </div>\n                    <div class=\"form-group\" *ngIf=\"usuario.rol == 'Administrador' || usuario.rol == 'Tecnico'\">\n                        <label for=\"duracionEstimada\">Duracion estimada de bateria (en días)</label>\n                        <span class=\"glyphicon glyphicon-question-sign ayuda\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Duración que se estima que durará la bateria según las condiciones de a instalación.\"></span>\n                        <input type=\"text\" class=\"form-control\" required id=\"duracionEstimada\" placeholder=\"Duracion estimada de bateria (en días)\" [(ngModel)]=\"nodo.duracionEstimada\" name=\"duracionEstimada\" #duracionEstimada=\"ngModel\" autocomplete=\"off\" [disabled]=\"deshabilitar\" pattern=\"^[1-9][0-9]*$\">\n                        <div [hidden]=\"duracionEstimada.valid || duracionEstimada.pristine\" class=\"alert alert-danger\">\n                            Duracion estimada de bateria es requerido, debe ser numérico y mayor a cero.\n                        </div>\n                    </div>\n\n                    <div class=\"form-group\" *ngIf=\"usuario.rol == 'Administrador' || usuario.rol == 'Tecnico'\">\n                        <label for=\"mantenimiento\">Nodo en mantenimiento</label>\n                        <span class=\"glyphicon glyphicon-question-sign ayuda\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Previene el disparo de alarmas cuando el nodo está en mantenimiento\"></span>\n                        <select class=\"form-control\" required id=\"mantenimiento\" name=\"mantenimiento\" [(ngModel)]=\"nodo.mantenimiento\" autocomplete=\"off\" #mantenimiento=\"ngModel\" [disabled]=\"deshabilitar\">\n                            <option value={{false}}>No</option>\n                            <option value={{true}}>Sí</option>\n                        </select>\n                        <div [hidden]=\"mantenimiento.valid || mantenimiento.pristine\" class=\"alert alert-danger\">\n                            Nodo en mantenimiento es requerido\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"repeatable\">Reconocimiento de alarmas</label>\n                        <span class=\"glyphicon glyphicon-question-sign ayuda\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Obliga al usuario a avisar que le llegaron las alarmas\"></span>\n                        <select class=\"form-control\" required id=\"repeatable\" name=\"repeatable\" [(ngModel)]=\"nodo.repeatable\" autocomplete=\"off\" #repeatable=\"ngModel\" [disabled]=\"deshabilitar\">\n                            <option value={{false}}>No</option>\n                            <option value={{true}}>Sí</option>\n                        </select>\n                        <div [hidden]=\"repeatable.valid || repeatable.pristine\" class=\"alert alert-danger\">\n                            Reconocimiento de alarmas es requerido\n                        </div>\n                    </div>\n                </div>\n                <div class=\"clearfix visible-md-block\"></div>\n                <div class=\"clearfix visible-lg-block\"></div>\n                <div class=\"clearfix visible-sm-block\"></div>\n                <div class=\"clearfix visible-xs-block\"></div>\n                <div class=\"modal-footer\">\n                    <button type=\"button\" class=\"btn btn-default\" (click)=\"closeModal()\">Cancelar</button>\n                    <button type=\"button\" class=\"btn btn-success\" (click)=\"save()\" class=\"btn btn-success\" [disabled]=\"deshabilitar || (nodoForm!=undefined && !nodoForm.form.valid)\">Guardar</button>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>\n<div id=\"confirmacionNodo\" class=\"modal fade\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">&times;</button>\n                <h4 class=\"modal-title\">Confirmación</h4>\n            </div>\n            <div class=\"modal-body\">\n                <p *ngIf=\"nodo.estado || (!nodo.estado && nodo.borradoPermanente)\">Está seguro que desea eliminar el nodo?</p>\n                <p *ngIf=\"!nodo.estado && !nodo.borradoPermanente\">Está seguro que desea restaurar el nodo?</p>\n                <p class=\"text-warning\"><small>Los datos relacionados también se eliminarán.</small></p>\n                <div class=\"form-group\" *ngIf=\"usuario.rol == 'Administrador' && (nodo.estado || (!nodo.estado && nodo.borradoPermanente))\">\n                    <label for=\"mantenimiento\">Desea borrar permanentemente el nodo y las entidades relacionadas?</label>\n                    <span class=\"glyphicon glyphicon-question-sign ayuda\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Previene el disparo de alarmas cuando el nodo está en mantenimiento\"></span>\n                    <select class=\"form-control\" required id=\"borradoPermanente\" name=\"borradoPermanente\" [(ngModel)]=\"nodo.borradoPermanente\" autocomplete=\"off\" #borradoPermanente=\"ngModel\">\n                        <option [ngValue]=\"false\">No</option>\n                        <option [ngValue]=\"true\">Sí</option>\n                    </select>\n                </div>\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-default\" (click)=\"closeModal()\">Cerrar</button>\n                <button type=\"button\" class=\"btn btn-danger\" (click)=\"eliminar()\">Aceptar</button>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 955 */
867,
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var nodo_1 = __webpack_require__(953);
	var sensor_1 = __webpack_require__(957);
	var sucursal_1 = __webpack_require__(908);
	var sensor_service_1 = __webpack_require__(575);
	var tipoVariable_service_1 = __webpack_require__(431);
	var permiso_service_1 = __webpack_require__(427);
	var login_service_1 = __webpack_require__(381);
	var _ = __webpack_require__(580);
	var SensorComponent = (function () {
	    function SensorComponent(sensorService, tipoVariableService, permisoService, loginService) {
	        this.sensorService = sensorService;
	        this.tipoVariableService = tipoVariableService;
	        this.permisoService = permisoService;
	        this.loginService = loginService;
	        this.permisos = new core_1.EventEmitter();
	    }
	    SensorComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.nodo = new nodo_1.Nodo();
	        this.sensor = new sensor_1.Sensor();
	        this.active = true;
	        //Pedir permisos
	        this.permisoService.getPermiso("sensor").subscribe(function (permisos) {
	            var respuesta = new Map();
	            for (var _i = 0, _a = permisos.tipoPermiso; _i < _a.length; _i++) {
	                var permiso = _a[_i];
	                respuesta.set(permiso.descripcion, true);
	            }
	            _this.permisos.emit({ permisos: respuesta });
	        });
	        this.usuario = this.loginService.getDecodeToken();
	    };
	    SensorComponent.prototype.ngOnChanges = function (changes) {
	        var _this = this;
	        this.tipoVariableService.getTipoVariables()
	            .subscribe(function (tipos) { return _this.tiposVariables = tipos; });
	    };
	    SensorComponent.prototype.closeModal = function () {
	        var _this = this;
	        //Reseteo formEmpresa para eliminar errores
	        this.active = false;
	        setTimeout(function () { return _this.active = true; }, 0);
	        //Inicializo variables
	        if (this.sensor._id != undefined && this.sensor._id != "" && this.sensor._id != null)
	            this.sensorService.getSensor(this.sensor._id).subscribe(function (sensor) {
	                for (var _i = 0, _a = _this.nodo.sensores_id; _i < _a.length; _i++) {
	                    var sensorL = _a[_i];
	                    if (sensorL._id == sensor._id) {
	                        sensorL.etiqueta = sensor.etiqueta;
	                        sensorL.posicionString = sensor.posicionString;
	                        sensorL.numeroMediciones = sensor.numeroMediciones;
	                        sensorL.tipo_id = sensor.tipo_id;
	                        break;
	                    }
	                }
	            });
	        //Seteo bandera para deshabilitar
	        this.deshabilitar = false;
	        //Ocultar modal
	        $("#modalSensor").modal("hide");
	        $("#confirmacionSensor").modal("hide");
	    };
	    SensorComponent.prototype.eliminar = function () {
	        var _this = this;
	        //Busco sensor
	        this.sensorService
	            .getSensor(this.sensor._id)
	            .subscribe(function (sensor) {
	            _this.sensorService.delete(sensor).subscribe(function (sensor) {
	                for (var _i = 0, _a = _this.nodo.sensores_id; _i < _a.length; _i++) {
	                    var sensorL = _a[_i];
	                    if (sensorL._id == sensor._id) {
	                        sensorL.estado = sensor.estado;
	                        if (!sensor.estado && sensorL.alarmas)
	                            for (var _b = 0, _c = sensorL.alarmas; _b < _c.length; _b++) {
	                                var alarma = _c[_b];
	                                alarma.estado = sensor.estado;
	                                for (var _d = 0, _e = alarma.avisosLista; _d < _e.length; _d++) {
	                                    var aviso = _e[_d];
	                                    aviso.estado = sensor.estado;
	                                }
	                            }
	                        break;
	                    }
	                }
	            });
	            $("#confirmacionSensor").modal("hide");
	        });
	    };
	    SensorComponent.prototype.save = function () {
	        var _this = this;
	        //Determino operacion
	        var operacion = "";
	        if (this.sensor._id == "" || this.sensor._id == undefined)
	            operacion = "agregar";
	        else
	            operacion = "modificar";
	        //Elimino redundancia
	        this.sensor.nodo_id = this.nodo;
	        var sensorSimplificado = _.cloneDeep(this.sensor);
	        delete sensorSimplificado.alarmas;
	        sensorSimplificado.nodo_id = this.nodo._id;
	        sensorSimplificado.sucursal_id = this.sucursal._id;
	        //Guardo
	        this.sensorService
	            .save(sensorSimplificado)
	            .subscribe(function (sensor) {
	            //Inicializo variables
	            _this.sensor = sensor;
	            //Actualizo listas
	            if (operacion == "agregar") {
	                if (_this.nodo.sensores_id == undefined)
	                    _this.nodo.sensores_id = [];
	                _this.nodo.sensores_id.push(sensor);
	            }
	            else
	                for (var _i = 0, _a = _this.nodo.sensores_id; _i < _a.length; _i++) {
	                    var sensorL = _a[_i];
	                    if (sensorL._id == sensor._id) {
	                        sensorL.etiqueta = sensor.etiqueta;
	                        sensorL.posicionString = sensor.posicionString;
	                        sensorL.numeroMediciones = sensor.numeroMediciones;
	                        sensorL.tipo_id = sensor.tipo_id;
	                        break;
	                    }
	                }
	            //this.sensor = sensor;
	            //Ocultar modal
	            $("#modalSensor").modal("hide");
	            //Reseteo formEmpresa para eliminar errores
	            _this.active = false;
	            setTimeout(function () { return _this.active = true; }, 0);
	        });
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof nodo_1.Nodo !== 'undefined' && nodo_1.Nodo) === 'function' && _a) || Object)
	    ], SensorComponent.prototype, "nodo", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_b = typeof sensor_1.Sensor !== 'undefined' && sensor_1.Sensor) === 'function' && _b) || Object)
	    ], SensorComponent.prototype, "sensor", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_c = typeof sucursal_1.Sucursal !== 'undefined' && sucursal_1.Sucursal) === 'function' && _c) || Object)
	    ], SensorComponent.prototype, "sucursal", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], SensorComponent.prototype, "permisos", void 0);
	    SensorComponent = __decorate([
	        core_1.Component({
	            selector: 'sensor',
	            template: __webpack_require__(958),
	            styles: [__webpack_require__(959)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_d = typeof sensor_service_1.SensorService !== 'undefined' && sensor_service_1.SensorService) === 'function' && _d) || Object, (typeof (_e = typeof tipoVariable_service_1.TipoVariableService !== 'undefined' && tipoVariable_service_1.TipoVariableService) === 'function' && _e) || Object, (typeof (_f = typeof permiso_service_1.PermisoService !== 'undefined' && permiso_service_1.PermisoService) === 'function' && _f) || Object, (typeof (_g = typeof login_service_1.LoginService !== 'undefined' && login_service_1.LoginService) === 'function' && _g) || Object])
	    ], SensorComponent);
	    return SensorComponent;
	    var _a, _b, _c, _d, _e, _f, _g;
	}());
	exports.SensorComponent = SensorComponent;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(419)))

/***/ }),
/* 957 */
/***/ (function(module, exports) {

	"use strict";
	var Sensor = (function () {
	    function Sensor() {
	    }
	    return Sensor;
	}());
	exports.Sensor = Sensor;


/***/ }),
/* 958 */
/***/ (function(module, exports) {

	module.exports = "<!-- Modal -->\n<div class=\"modal fade\" id=\"modalSensor\" data-backdrop=\"static\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modalSensorLabel\" style=\"z-indez:99999999\">\n    <div class=\"modal-dialog modal-md\" role=\"document\" style=\"z-indez:99999\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" (click)=\"closeModal()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n                <h4 class=\"modal-title\" id=\"modalSensorLabel\">Canal de Monitorización</h4>\n            </div>\n            <form #nodoForm=\"ngForm\" *ngIf=\"active\">\n                <div class=\"modal-body\">\n                    <div class=\"form-group\">\n                        <label for=\"nodo\">Nodo</label>\n                        <input *ngIf=\"nodo\" type=\"text\" disabled class=\"form-control\" id=\"nodo\" placeholder=\"Descripción\" [(ngModel)]=\"nodo.nombre\" name=\"nodo\">\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"descripcion\">Etiqueta</label>\n                        <span class=\"glyphicon glyphicon-question-sign ayuda\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Descripción de referencia para el sensor.\"></span>\n                        <input type=\"text\" class=\"form-control\" maxlength=\"30\" required id=\"descripcion\" placeholder=\"Descripción\" [(ngModel)]=\"sensor.etiqueta\" name=\"etiqueta\" #etiqueta=\"ngModel\" autocomplete=\"off\" [disabled]=\"deshabilitar\">\n                        <div [hidden]=\"etiqueta.valid || etiqueta.pristine\" class=\"alert alert-danger\">\n                            Etiqueta es requerido\n                        </div>\n                    </div>\n                    <div class=\"form-group\" *ngIf=\"usuario.rol == 'Administrador' || usuario.rol == 'Tecnico'\">\n                        <label for=\"posicionString\">Posición String</label>\n                        <span class=\"glyphicon glyphicon-question-sign ayuda\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Número que describe la posición del sensor en el mensaje enviado por el nodo.\"></span>\n                        <input type=\"text\" min=\"0\" max=\"9\" class=\"form-control\" required id=\"posicionString\" placeholder=\"Posición String\" [(ngModel)]=\"sensor.posicionString\" name=\"posicionString\" #posicionString=\"ngModel\" autocomplete=\"off\" [disabled]=\"deshabilitar\" pattern=\"[0-9]\">\n                        <div [hidden]=\"posicionString.valid || posicionString.pristine\" class=\"alert alert-danger\">\n                            Posición String es requerido, debe ser numérico y un valor entre 1 y 9.\n                        </div>\n                    </div>\n                    <div class=\"form-group\" *ngIf=\"usuario.rol == 'Administrador' || usuario.rol == 'Tecnico'\">\n                        <label for=\"numeroMediciones\">Número de Mediciones</label>\n                        <span class=\"glyphicon glyphicon-question-sign ayuda\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Cantidad de mediciones que son promediadas para evaluar las alarmas.\"></span>\n                        <input type=\"text\" class=\"form-control\" required id=\"numeroMediciones\" placeholder=\"Frecuencia de Medición\" [(ngModel)]=\"sensor.numeroMediciones\" name=\"numeroMediciones\" #numeroMediciones=\"ngModel\" autocomplete=\"off\" [disabled]=\"deshabilitar\" pattern=\"^[1-9][0-9]*$\">\n                        <div [hidden]=\"numeroMediciones.valid || numeroMediciones.pristine\" class=\"alert alert-danger\">\n                            Número de Mediciones es requerido, debe ser numérico y mayor a cero.\n                        </div>\n                    </div>\n                    <div class=\"form-group\" *ngIf=\"usuario.rol == 'Administrador' || usuario.rol == 'Tecnico'\">\n                        <label for=\"tipoSensor\">Tipo de Variable</label>\n                        <span class=\"glyphicon glyphicon-question-sign ayuda\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Tipo de variable clasificado según variable medida.\"></span>\n                        <select class=\"form-control\" required id=\"tipoSensor\" name=\"tipoSensor\" [(ngModel)]=\"sensor.tipo_id\" autocomplete=\"off\" #tipoSensor=\"ngModel\" [disabled]=\"deshabilitar\">\n                            <option></option>\n                            <option *ngFor=\"let tipo of tiposVariables\" value={{tipo._id}}>{{tipo.descripcion+ \"- Rango: \"+tipo.rangoDesde+\"-\"+tipo.rangoHasta}}\n                            </option>\n                        </select>\n                        <div [hidden]=\"tipoSensor.valid || tipoSensor.pristine\" class=\"alert alert-danger\">\n                            Tipo de Variable es requerido\n                        </div>\n                    </div>\n                    <div class=\"form-group\" *ngIf=\"usuario.rol == 'Administrador' || usuario.rol == 'Tecnico'\">\n                        <label for=\"m\">m</label>\n                        <span class=\"glyphicon glyphicon-question-sign ayuda\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Parámetro de calibración m.\"></span>\n                        <input type=\"text\" class=\"form-control\" id=\"m\" placeholder=\"m\" [(ngModel)]=\"sensor.m\" name=\"m\" #m=\"ngModel\" autocomplete=\"off\" [disabled]=\"deshabilitar\">\n                        <div [hidden]=\"m.valid || m.pristine\" class=\"alert alert-danger\">\n                            M es requerido\n                        </div>\n                    </div>\n                    <div class=\"form-group\" *ngIf=\"usuario.rol == 'Administrador' || usuario.rol == 'Tecnico'\">\n                        <label for=\"h\">h</label>\n                        <span class=\"glyphicon glyphicon-question-sign ayuda\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Parámetro de calibración h.\"></span>\n                        <input type=\"text\" class=\"form-control\" id=\"h\" placeholder=\"h\" [(ngModel)]=\"sensor.h\" name=\"h\" #h=\"ngModel\" autocomplete=\"off\" [disabled]=\"deshabilitar\">\n                        <div [hidden]=\"h.valid || h.pristine\" class=\"alert alert-danger\">\n                            H es requerido\n                        </div>\n                    </div>\n                </div>\n                <div class=\"clearfix visible-md-block\"></div>\n                <div class=\"clearfix visible-lg-block\"></div>\n                <div class=\"clearfix visible-sm-block\"></div>\n                <div class=\"clearfix visible-xs-block\"></div>\n                <div class=\"modal-footer\">\n                    <button type=\"button\" class=\"btn btn-default\" (click)=\"closeModal()\">Cancelar</button>\n                    <button type=\"button\" class=\"btn btn-success\" (click)=\"save()\" class=\"btn btn-success\" [disabled]=\"deshabilitar || !nodoForm.form.valid\">Guardar</button>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>\n<div id=\"confirmacionSensor\" class=\"modal fade\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">&times;</button>\n                <h4 class=\"modal-title\">Confirmación</h4>\n            </div>\n            <div class=\"modal-body\">\n                <p *ngIf=\"sensor.estado\">Está seguro que desea eliminar el sensor?</p>\n                <p *ngIf=\"!sensor.estado\">Está seguro que desea restaurar el sensor?</p>\n                <p class=\"text-warning\"><small>Los datos relacionados también se eliminarán.</small></p>\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-default\" (click)=\"closeModal()\">Cerrar</button>\n                <button type=\"button\" class=\"btn btn-danger\" (click)=\"eliminar()\">Aceptar</button>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 959 */
867,
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var permiso_service_1 = __webpack_require__(427);
	var router_1 = __webpack_require__(329);
	var tipoSensor_service_1 = __webpack_require__(576);
	var tipoSensor_1 = __webpack_require__(961);
	var login_service_1 = __webpack_require__(381);
	__webpack_require__(653);
	var myGlobals = __webpack_require__(414);
	var TipoSensorComponent = (function () {
	    function TipoSensorComponent(tipoSensorService, permisoService, loginService, router) {
	        this.tipoSensorService = tipoSensorService;
	        this.permisoService = permisoService;
	        this.loginService = loginService;
	        this.router = router;
	    }
	    TipoSensorComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        window.scrollTo(0, 0);
	        //Perdir permisos
	        this.permisos = new Map();
	        this.permisoService.getPermiso("tipoSensor").subscribe(function (permisos) {
	            for (var _i = 0, _a = permisos.tipoPermiso; _i < _a.length; _i++) {
	                var permiso = _a[_i];
	                _this.permisos.set(permiso.descripcion, true);
	            }
	            //Si no tiene permiso para ver redirijo
	            if (!_this.permisos.get("read"))
	                _this.router.navigate(['/home']);
	        });
	        //Inicializar tabla
	        $("#grid-data").bootgrid({
	            ajax: true,
	            url: myGlobals.default.BASE_URL + "/tipoSensor/tipoSensorTable",
	            selection: true,
	            multiSelect: false,
	            rowSelect: true,
	            formatters: {
	                "estado": function (column, row) {
	                    return row.estado == true ? "Activo" : "<span class=\"label label-danger\">Inactivo</span>";
	                }
	            },
	            ajaxSettings: {
	                headers: {
	                    "Authorization": this.loginService.getToken()
	                },
	                method: "GET"
	            }
	        });
	        //Cerrar alert
	        $("#alertSeleccion").hide();
	        //Inicializar banderas para resetear forms
	        this.active = true;
	        //Inicializar
	        this.tipoSensor = new tipoSensor_1.TipoSensor();
	        //Inicializar bandera deshabilitar
	        this.deshabilitar = false;
	    };
	    TipoSensorComponent.prototype.ngOnDestroy = function () {
	    };
	    TipoSensorComponent.prototype.agregar = function () {
	        var _this = this;
	        //Inicializo variables
	        this.tipoSensor = new tipoSensor_1.TipoSensor();
	        this.deshabilitar = false;
	        $("#modalTipoSensor").modal("show");
	        //Reseteo form para eliminar errores
	        this.active = false;
	        setTimeout(function () { return _this.active = true; }, 0);
	    };
	    TipoSensorComponent.prototype.modificar = function () {
	        var _this = this;
	        //Obtener id seleccionado
	        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
	        //Si no hay nada seleccionado mostrar alert
	        if (this.idSeleccionado == undefined) {
	            $("#alertSeleccion").show();
	        }
	        else {
	            if (this.idSeleccionado != "0") {
	                //Cerrar alert
	                $("#alertSeleccion").hide();
	                //Busco tipoSensor
	                this.tipoSensorService
	                    .getTipoSensor(this.idSeleccionado)
	                    .subscribe(function (tipoSensor) {
	                    _this.tipoSensor = tipoSensor;
	                });
	                this.deshabilitar = false;
	                $("#modalTipoSensor").modal("show");
	            }
	        }
	    };
	    TipoSensorComponent.prototype.eliminar = function () {
	        var _this = this;
	        //Obtener id seleccionado
	        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
	        //Si no hay nada seleccionado mostrar alert
	        if (this.idSeleccionado == undefined) {
	            $("#alertSeleccion").show();
	        }
	        else {
	            if (this.idSeleccionado != "0") {
	                //Cerrar alert
	                $("#alertSeleccion").hide();
	                //Busco tipoSensor
	                this.tipoSensorService
	                    .getTipoSensor(this.idSeleccionado)
	                    .subscribe(function (tipoSensor) {
	                    _this.tipoSensorService.delete(tipoSensor).subscribe(function () { return $("#grid-data").bootgrid("reload"); });
	                });
	            }
	        }
	    };
	    TipoSensorComponent.prototype.ver = function () {
	        var _this = this;
	        //Obtener id seleccionado
	        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
	        //Si no hay nada seleccionado mostrar alert
	        if (this.idSeleccionado == undefined) {
	            $("#alertSeleccion").show();
	        }
	        else {
	            if (this.idSeleccionado != "0") {
	                //Cerrar alert
	                $("#alertSeleccion").hide();
	                //Busco tipoSensor
	                this.tipoSensorService
	                    .getTipoSensor(this.idSeleccionado)
	                    .subscribe(function (tipoSensor) {
	                    _this.tipoSensor = tipoSensor;
	                });
	                //Seteo bandera para deshabilitar
	                this.deshabilitar = true;
	                $("#modalTipoSensor").modal("show");
	            }
	        }
	    };
	    TipoSensorComponent.prototype.save = function () {
	        var _this = this;
	        this.tipoSensorService
	            .save(this.tipoSensor)
	            .subscribe(function (tipoSensor) {
	            _this.tipoSensor = tipoSensor;
	            //Inicializo variables
	            _this.tipoSensor = new tipoSensor_1.TipoSensor();
	            console.log(_this.tipoSensor);
	            //Ocultar modal
	            $("#modalTipoSensor").modal("hide");
	            //Reseteo formtipoSensor para eliminar errores
	            _this.active = false;
	            setTimeout(function () { return _this.active = true; }, 0);
	            //Recargo tabla
	            $("#grid-data").bootgrid("reload");
	        });
	    };
	    TipoSensorComponent.prototype.hideAlert = function () {
	        $("#alertSeleccion").hide();
	    };
	    TipoSensorComponent = __decorate([
	        core_1.Component({
	            selector: 'tipoSensor',
	            template: __webpack_require__(962),
	            styles: [__webpack_require__(963)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof tipoSensor_service_1.TipoSensorService !== 'undefined' && tipoSensor_service_1.TipoSensorService) === 'function' && _a) || Object, (typeof (_b = typeof permiso_service_1.PermisoService !== 'undefined' && permiso_service_1.PermisoService) === 'function' && _b) || Object, (typeof (_c = typeof login_service_1.LoginService !== 'undefined' && login_service_1.LoginService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object])
	    ], TipoSensorComponent);
	    return TipoSensorComponent;
	    var _a, _b, _c, _d;
	}());
	exports.TipoSensorComponent = TipoSensorComponent;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(419)))

/***/ }),
/* 961 */
/***/ (function(module, exports) {

	"use strict";
	var TipoSensor = (function () {
	    function TipoSensor() {
	    }
	    return TipoSensor;
	}());
	exports.TipoSensor = TipoSensor;


/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 contenido\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 titulo\">\n        <div class=\"marcoTitulo\">\n            <h2>Tipos de Sensores</h2>\n            <p>Home / Carga Datos / Tipos de Sensores</p>\n        </div>\n    </div>\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 marcoDatos\">\n        <div class=\"datos\">\n            <div class=\"alert alert-warning\" id=\"alertSeleccion\" name=\"alertSeleccion\">\n                <a class=\"close\" (click)=\"hideAlert()\">&times;</a> Debe selecccionar una casilla primero.\n            </div>\n            <div class=\"table-responsive\">\n                <table id=\"grid-data\" class=\"table table-condensed table-hover \">\n                    <thead>\n                    <tr>\n                        <th data-column-id=\"_id\" data-identifier=\"true\" data-visible=\"false\"\n                            data-visible-in-selection=\"false\" data-order=\"desc\">_id\n                        </th>\n                        <th data-column-id=\"descripcion\">Descripcion</th>\n                        <!--  <th data-column-id=\"tipo\">Unidad de Medida</th> -->\n                        <!--<th data-column-id=\"rangoDesde\">Rango Desde</th>\n                        <th data-column-id=\"rangoHasta\">Rango Hasta</th>-->\n                        <th data-column-id=\"estado\" data-formatter=\"estado\">Estado</th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n    <button data-toggle=\"tooltip\" data-placement=\"top\" title=\"Eliminar\" animation=\"true\"\n            class=\"btn btn-default btn-sm botonFlotante btn-danger\" (click)=\"eliminar()\"\n            [disabled]=\"permisos.get('delete')!=true\">\n        <img src=\"" + __webpack_require__(933) + "\" width=\"20px\"/>\n    </button>\n    <button data-toggle=\"tooltip\" data-placement=\"top\" title=\"Modificar\" animation=\"true\"\n            class=\"btn btn-default btn-sm botonFlotante2 btn-warning\" (click)=\"modificar()\"\n            [disabled]=\"permisos.get('update')!=true\">\n        <img src=\"" + __webpack_require__(934) + "\" width=\"25px\"/>\n    </button>\n    <button data-toggle=\"tooltip\" data-placement=\"top\" title=\"Agregar\" animation=\"true\"\n            class=\"btn btn-default btn-sm botonFlotante3 btn-success\" (click)=\"agregar()\"\n            [disabled]=\"permisos.get('create')!=true\">\n        <img src=\"" + __webpack_require__(935) + "\" width=\"25px\"/>\n    </button>\n    <button data-toggle=\"tooltip\" data-placement=\"top\" title=\"Ver\" animation=\"true\"\n            class=\"btn btn-default btn-sm botonFlotante4 btn-primary\" (click)=\"ver()\"\n            [disabled]=\"permisos.get('read')!=true\">\n        <img src=\"" + __webpack_require__(936) + "\" width=\"30px\"/>\n    </button>\n</div>\n<!-- Modal -->\n<div class=\"modal fade\" id=\"modalTipoSensor\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\">\n    <div class=\"modal-dialog\" role=\"document\">\n\n        <div class=\"modal-content\">\n            <form #tipoSensorForm=\"ngForm\" *ngIf=\"active\">\n                <div class=\"modal-header\">\n                    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span\n                            aria-hidden=\"true\">&times;</span></button>\n                    <h4 class=\"modal-title\" id=\"myModalLabel\">Tipo de Sensor</h4>\n                </div>\n                <div class=\"modal-body\">\n\n                    <div class=\"form-group\">\n                        <label for=\"descripcion\">Descripción Del Tipo de Sensor</label>\n                        <input type=\"text\" class=\"form-control\" id=\"descripcion\" placeholder=\"Descripción\" required\n                               [(ngModel)]=\"tipoSensor.descripcion\" name=\"descripcion\" #descripcion=\"ngModel\"\n                               autocomplete=\"off\" [disabled]=\"deshabilitar\">\n                        <div [hidden]=\"descripcion.valid || descripcion.pristine\" class=\"alert alert-danger\">\n                            Descripción es requerido\n                        </div>\n                    </div>\n                    <!--    <div class=\"form-group\">\n                            <label for=\"tipo\">Unidad de Medida</label>\n                            <input type=\"text\" required class=\"form-control\" id=\"tipo\" name=\"tipo\" placeholder=\"Unidad de Medida\" [(ngModel)]=\"tipoSensor.tipo\" #tipo=\"ngModel\" autocomplete=\"off\" [disabled]=\"deshabilitar\">\n                            <div [hidden]=\"tipo.valid || tipo.pristine\" class=\"alert alert-danger\">\n                                Tipo de Sensor es requerido\n                            </div>\n                        </div> -->\n                    <!--<div class=\"form-group\">\n                        <label for=\"rangoDesde\">Límite inferior del rango del Tipo de Sensor</label>\n                        <input type=\"number\" class=\"form-control\" id=\"rangoDesde\" name=\"rangoDesde\"\n                               placeholder=\"Valor Mínimo\" [(ngModel)]=\"tipoSensor.rangoDesde\" #rangoDesde=\"ngModel\"\n                               autocomplete=\"off\" [disabled]=\"deshabilitar\">\n                        <div [hidden]=\"rangoDesde.valid || rangoDesde.pristine\" class=\"alert alert-danger\">\n                            Rango Desde es requerido\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"rangoHasta\">Límite superior del rango del Tipo de Sensor</label>\n                        <input type=\"number\" min={{rangoDesde.value}} class=\"form-control\" id=\"rangoHasta\"\n                               name=\"rangoHasta\" placeholder=\"Valor Máximo\" [(ngModel)]=\"tipoSensor.rangoHasta\"\n                               #rangoHasta=\"ngModel\" autocomplete=\"off\" [disabled]=\"deshabilitar\">\n                        <div [hidden]=\"rangoHasta.valid || rangoHasta.pristine\" class=\"alert alert-danger\">\n                            Rango Hasta es requerido\n                        </div>\n                    </div>-->\n\n                </div>\n                <div class=\"clearfix visible-md-block\"></div>\n                <div class=\"clearfix visible-lg-block\"></div>\n                <div class=\"clearfix visible-sm-block\"></div>\n                <div class=\"clearfix visible-xs-block\"></div>\n                <div class=\"modal-footer\">\n                    <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Cancelar</button>\n                    <button type=\"button\" (click)=\"save()\" class=\"btn btn-success\"\n                            [disabled]=\"deshabilitar || (tipoSensorForm!=undefined && !tipoSensorForm.form.valid)\">\n                        Guardar\n                    </button>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 963 */
944,
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var owl_carousel_component_1 = __webpack_require__(965);
	var ubicacion_component_1 = __webpack_require__(945);
	var nodo_component_1 = __webpack_require__(952);
	var sensor_component_1 = __webpack_require__(956);
	var abmalarmas_component_1 = __webpack_require__(972);
	var aviso_component_1 = __webpack_require__(976);
	var nodo_service_1 = __webpack_require__(433);
	var progress_service_1 = __webpack_require__(980);
	var permiso_service_1 = __webpack_require__(427);
	var login_service_1 = __webpack_require__(381);
	var sucursal_1 = __webpack_require__(908);
	var ubicacion_1 = __webpack_require__(912);
	var nodo_1 = __webpack_require__(953);
	var sensor_1 = __webpack_require__(957);
	var alarma_1 = __webpack_require__(973);
	var aviso_1 = __webpack_require__(977);
	var _ = __webpack_require__(580);
	var ABMGeneralComponent = (function () {
	    function ABMGeneralComponent(nodoService, progressService, permisoService, loginService) {
	        this.nodoService = nodoService;
	        this.progressService = progressService;
	        this.permisoService = permisoService;
	        this.loginService = loginService;
	    }
	    ABMGeneralComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        window.scrollTo(0, 0);
	        this.permisosSucursal = new Map();
	        this.permisosAviso = new Map();
	        this.permisosAlarma = new Map();
	        this.permisosNodo = new Map();
	        this.permisosSensor = new Map();
	        this.permisosUbicacion = new Map();
	        this.usuarioConectado = this.loginService.getDecodeToken();
	        this.sucursalSeleccionada = new sucursal_1.Sucursal;
	        //Arbol de sucursales->ubicaciones->nodos->sensores segun usuario logueado
	        this.nodoService.getNodos().subscribe(function (sucursalesConTodo) {
	            _this.sucursales = sucursalesConTodo;
	            _this.sucursales.map(function (sucursal) {
	                sucursal.ubicaciones.map(function (ubicacion) {
	                    ubicacion.nodos.map(function (nodo) {
	                        nodo.resumen = nodo_1.Nodo.toString(nodo);
	                    });
	                });
	            });
	        });
	        //Pedir permisos
	        this.permisosSucursal = new Map();
	        this.permisoService.getPermiso("gateway").subscribe(function (permisos) {
	            for (var _i = 0, _a = permisos.tipoPermiso; _i < _a.length; _i++) {
	                var permiso = _a[_i];
	                _this.permisosSucursal.set(permiso.descripcion, true);
	            }
	        });
	        /*$('.tabla').on( 'mousewheel DOMMouseScroll', function (e) {
	         console.log(e);
	         var e0 = e.originalEvent;
	         var delta = e0.wheelDelta || -e0.detail;
	
	         this.scrollTop += ( delta < 0 ? 1 : -1 ) * 5;
	         e.preventDefault();
	         });*/
	    };
	    ABMGeneralComponent.prototype.ngOnDestroy = function () {
	    };
	    ABMGeneralComponent.prototype.recargar = function () {
	        var _this = this;
	        this.nodoService.getNodos().subscribe(function (sucursalesConTodo) {
	            _this.sucursales = sucursalesConTodo;
	        });
	    };
	    ABMGeneralComponent.prototype.seleccionarSucursal = function (id) {
	        for (var _i = 0, _a = this.sucursales; _i < _a.length; _i++) {
	            var sucursal = _a[_i];
	            if (sucursal._id == id) {
	                this.sucursalSeleccionada = sucursal;
	                break;
	            }
	        }
	        if ($(window).width() < 769)
	            this.proximaSlide(1);
	        this.ubicacionSeleccionada = new ubicacion_1.Ubicacion();
	        this.nodoSeleccionado = new nodo_1.Nodo();
	        this.sensorSeleccionado = new sensor_1.Sensor();
	        this.alarmaSeleccionada = new alarma_1.Alarma();
	        this.avisoSeleccionado = new aviso_1.Aviso();
	        $("#circuloUbicacion").addClass("active");
	        $("#circuloNodo").removeClass("active");
	        $("#circuloSensor").removeClass("active");
	        $("#circuloAlarma").removeClass("active");
	        $("#circuloAviso").removeClass("active");
	    };
	    ABMGeneralComponent.prototype.seleccionarUbicacion = function (id) {
	        this.ubicacionSeleccionada = new ubicacion_1.Ubicacion();
	        for (var _i = 0, _a = this.sucursalSeleccionada.ubicaciones; _i < _a.length; _i++) {
	            var ubicacion = _a[_i];
	            if (ubicacion._id == id) {
	                this.ubicacionSeleccionada = ubicacion;
	                break;
	            }
	        }
	        if ($(window).width() < 769)
	            this.proximaSlide(2);
	        else
	            this.proximaSlide(1);
	        this.nodoSeleccionado = new nodo_1.Nodo();
	        this.sensorSeleccionado = new sensor_1.Sensor();
	        this.alarmaSeleccionada = new alarma_1.Alarma();
	        this.avisoSeleccionado = new aviso_1.Aviso();
	        $("#circuloUbicacion").removeClass("active");
	        $("#circuloNodo").addClass("active");
	        $("#circuloSensor").removeClass("active");
	        $("#circuloAlarma").removeClass("active");
	        $("#circuloAviso").removeClass("active");
	        setTimeout(function () { return $('[data-toggle="tooltip"]').tooltip(); }, 500);
	    };
	    ABMGeneralComponent.prototype.agregarUbicacion = function () {
	        this.ubicacionSeleccionada = new ubicacion_1.Ubicacion();
	        this.modificacion = "agregarUbicacion";
	        $("#modalUbicacion").modal("show");
	    };
	    ABMGeneralComponent.prototype.modificarUbicacion = function (e, id) {
	        this.ubicacionSeleccionada = new ubicacion_1.Ubicacion();
	        for (var _i = 0, _a = this.sucursalSeleccionada.ubicaciones; _i < _a.length; _i++) {
	            var ubicacion = _a[_i];
	            if (ubicacion._id == id) {
	                this.ubicacionSeleccionada = ubicacion;
	                break;
	            }
	        }
	        $("#modalUbicacion").modal("show");
	        this.modificacion = "modificarUbicacion";
	        e.stopPropagation();
	    };
	    ABMGeneralComponent.prototype.eliminarUbicacion = function (e, id) {
	        for (var _i = 0, _a = this.sucursalSeleccionada.ubicaciones; _i < _a.length; _i++) {
	            var ubicacion = _a[_i];
	            if (ubicacion._id == id) {
	                this.ubicacionSeleccionada = ubicacion;
	                break;
	            }
	        }
	        $("#confirmacionUbicacion").modal("show");
	        this.modificacion = "eliminarUbicacion";
	        this.nodoSeleccionado = new nodo_1.Nodo();
	        this.sensorSeleccionado = new sensor_1.Sensor();
	        this.alarmaSeleccionada = new alarma_1.Alarma();
	        this.avisoSeleccionado = new aviso_1.Aviso();
	        $("#circuloUbicacion").removeClass("active");
	        $("#circuloNodo").removeClass("active");
	        $("#circuloSensor").removeClass("active");
	        $("#circuloAlarma").removeClass("active");
	        $("#circuloAviso").removeClass("active");
	        e.stopPropagation();
	    };
	    ABMGeneralComponent.prototype.seleccionarNodo = function (id) {
	        for (var _i = 0, _a = this.ubicacionSeleccionada.nodos; _i < _a.length; _i++) {
	            var nodo = _a[_i];
	            if (nodo._id == id) {
	                this.nodoSeleccionado = nodo;
	                break;
	            }
	        }
	        if ($(window).width() < 769)
	            this.proximaSlide(3);
	        else
	            this.proximaSlide(2);
	        this.sensorSeleccionado = new sensor_1.Sensor();
	        this.alarmaSeleccionada = new alarma_1.Alarma();
	        this.avisoSeleccionado = new aviso_1.Aviso();
	        $("#circuloUbicacion").removeClass("active");
	        $("#circuloNodo").removeClass("active");
	        $("#circuloSensor").addClass("active");
	        $("#circuloAlarma").removeClass("active");
	        $("#circuloAviso").removeClass("active");
	    };
	    ABMGeneralComponent.prototype.agregarNodo = function () {
	        this.nodoSeleccionado = new nodo_1.Nodo();
	        this.modificacion = "agregarNodo";
	        $("#modalNodo").modal("show");
	    };
	    ABMGeneralComponent.prototype.modificarNodo = function (e, id) {
	        for (var _i = 0, _a = this.ubicacionSeleccionada.nodos; _i < _a.length; _i++) {
	            var nodo = _a[_i];
	            if (nodo._id == id) {
	                this.nodoSeleccionado = nodo;
	                break;
	            }
	        }
	        this.modificacion = "modificarNodo";
	        $("#modalNodo").modal("show");
	        e.stopPropagation();
	    };
	    ABMGeneralComponent.prototype.duplicarNodo = function (e, id) {
	        for (var _i = 0, _a = this.ubicacionSeleccionada.nodos; _i < _a.length; _i++) {
	            var nodo = _a[_i];
	            if (nodo._id == id) {
	                this.nodoSeleccionado = _.cloneDeep(nodo);
	                delete this.nodoSeleccionado._id;
	                break;
	            }
	        }
	        this.modificacion = "duplicarNodo";
	        $("#modalNodo").modal("show");
	        e.stopPropagation();
	    };
	    ABMGeneralComponent.prototype.eliminarNodo = function (e, id) {
	        for (var _i = 0, _a = this.ubicacionSeleccionada.nodos; _i < _a.length; _i++) {
	            var nodo = _a[_i];
	            if (nodo._id == id) {
	                this.nodoSeleccionado = nodo;
	                break;
	            }
	        }
	        this.nodoSeleccionado.borradoPermanente = false;
	        this.modificacion = "eliminarNodo";
	        $("#confirmacionNodo").modal("show");
	        this.sensorSeleccionado = new sensor_1.Sensor();
	        this.alarmaSeleccionada = new alarma_1.Alarma();
	        this.avisoSeleccionado = new aviso_1.Aviso();
	        $("#circuloUbicacion").removeClass("active");
	        $("#circuloNodo").removeClass("active");
	        $("#circuloSensor").addClass("active");
	        $("#circuloAlarma").removeClass("active");
	        $("#circuloAviso").removeClass("active");
	        e.stopPropagation();
	    };
	    ABMGeneralComponent.prototype.eliminarPermanenteNodo = function (e, id) {
	        for (var _i = 0, _a = this.ubicacionSeleccionada.nodos; _i < _a.length; _i++) {
	            var nodo = _a[_i];
	            if (nodo._id == id) {
	                this.nodoSeleccionado = nodo;
	                break;
	            }
	        }
	        this.nodoSeleccionado.borradoPermanente = true;
	        this.modificacion = "eliminarNodo";
	        $("#confirmacionNodo").modal("show");
	        this.sensorSeleccionado = new sensor_1.Sensor();
	        this.alarmaSeleccionada = new alarma_1.Alarma();
	        this.avisoSeleccionado = new aviso_1.Aviso();
	        $("#circuloUbicacion").removeClass("active");
	        $("#circuloNodo").removeClass("active");
	        $("#circuloSensor").addClass("active");
	        $("#circuloAlarma").removeClass("active");
	        $("#circuloAviso").removeClass("active");
	        e.stopPropagation();
	    };
	    ABMGeneralComponent.prototype.seleccionarSensor = function (id) {
	        for (var _i = 0, _a = this.nodoSeleccionado.sensores_id; _i < _a.length; _i++) {
	            var sensor = _a[_i];
	            if (sensor._id == id) {
	                this.sensorSeleccionado = sensor;
	                break;
	            }
	        }
	        if ($(window).width() < 769)
	            this.proximaSlide(4);
	        else
	            this.proximaSlide(3);
	        this.alarmaSeleccionada = new alarma_1.Alarma();
	        this.avisoSeleccionado = new aviso_1.Aviso();
	        $("#circuloUbicacion").removeClass("active");
	        $("#circuloNodo").removeClass("active");
	        $("#circuloSensor").removeClass("active");
	        $("#circuloAlarma").addClass("active");
	        $("#circuloAviso").removeClass("active");
	    };
	    ABMGeneralComponent.prototype.agregarSensor = function () {
	        this.sensorSeleccionado = new sensor_1.Sensor();
	        this.modificacion = "agregarSensor";
	        $("#modalSensor").modal("show");
	    };
	    ABMGeneralComponent.prototype.modificarSensor = function (e, id) {
	        for (var _i = 0, _a = this.nodoSeleccionado.sensores_id; _i < _a.length; _i++) {
	            var sensor = _a[_i];
	            if (sensor._id == id) {
	                if (sensor.tipo_id != undefined && sensor.tipo_id._id != undefined)
	                    sensor.tipo_id = sensor.tipo_id._id;
	                this.sensorSeleccionado = sensor;
	                break;
	            }
	        }
	        this.modificacion = "modificarSensor";
	        $("#modalSensor").modal("show");
	        e.stopPropagation();
	    };
	    ABMGeneralComponent.prototype.eliminarSensor = function (e, id) {
	        for (var _i = 0, _a = this.nodoSeleccionado.sensores_id; _i < _a.length; _i++) {
	            var sensor = _a[_i];
	            if (sensor._id == id) {
	                this.sensorSeleccionado = sensor;
	                break;
	            }
	        }
	        this.modificacion = "eliminarSensor";
	        $("#confirmacionSensor").modal("show");
	        this.alarmaSeleccionada = new alarma_1.Alarma();
	        this.avisoSeleccionado = new aviso_1.Aviso();
	        $("#circuloUbicacion").removeClass("active");
	        $("#circuloNodo").removeClass("active");
	        $("#circuloSensor").removeClass("active");
	        $("#circuloAlarma").addClass("active");
	        $("#circuloAviso").removeClass("active");
	        e.stopPropagation();
	    };
	    ABMGeneralComponent.prototype.seleccionarAlarma = function (id) {
	        for (var _i = 0, _a = this.sensorSeleccionado.alarmas; _i < _a.length; _i++) {
	            var alarma = _a[_i];
	            if (alarma._id == id) {
	                this.alarmaSeleccionada = alarma;
	                break;
	            }
	        }
	        if ($(window).width() < 769)
	            this.proximaSlide(5);
	        else
	            this.proximaSlide(4);
	        this.avisoSeleccionado = new aviso_1.Aviso();
	        $("#circuloUbicacion").removeClass("active");
	        $("#circuloNodo").removeClass("active");
	        $("#circuloSensor").removeClass("active");
	        $("#circuloAlarma").removeClass("active");
	        $("#circuloAviso").addClass("active");
	    };
	    ABMGeneralComponent.prototype.agregarAlarma = function () {
	        this.alarmaSeleccionada = new alarma_1.Alarma();
	        this.modificacion = "agregarAlarma";
	        $("#modalAlarma").modal("show");
	    };
	    ABMGeneralComponent.prototype.modificarAlarma = function (e, id) {
	        for (var _i = 0, _a = this.sensorSeleccionado.alarmas; _i < _a.length; _i++) {
	            var alarma = _a[_i];
	            if (alarma._id == id) {
	                this.alarmaSeleccionada = alarma;
	                break;
	            }
	        }
	        this.modificacion = "modificarAlarma";
	        $("#modalAlarma").modal("show");
	        e.stopPropagation();
	    };
	    ABMGeneralComponent.prototype.eliminarAlarma = function (e, id) {
	        for (var _i = 0, _a = this.sensorSeleccionado.alarmas; _i < _a.length; _i++) {
	            var alarma = _a[_i];
	            if (alarma._id == id) {
	                this.alarmaSeleccionada = alarma;
	                break;
	            }
	        }
	        this.modificacion = "eliminarAlarma";
	        $("#confirmacionAlarma").modal("show");
	        this.avisoSeleccionado = new aviso_1.Aviso();
	        $("#circuloUbicacion").removeClass("active");
	        $("#circuloNodo").removeClass("active");
	        $("#circuloSensor").removeClass("active");
	        $("#circuloAlarma").removeClass("active");
	        $("#circuloAviso").addClass("active");
	        e.stopPropagation();
	    };
	    ABMGeneralComponent.prototype.agregarAviso = function () {
	        this.avisoSeleccionado = new aviso_1.Aviso();
	        this.avisoSeleccionado.lunes = false;
	        this.avisoSeleccionado.martes = false;
	        this.avisoSeleccionado.miercoles = false;
	        this.avisoSeleccionado.jueves = false;
	        this.avisoSeleccionado.viernes = false;
	        this.avisoSeleccionado.sabado = false;
	        this.avisoSeleccionado.domingo = false;
	        this.modificacion = "agregarAviso";
	        $("#modalAviso").modal("show");
	    };
	    ABMGeneralComponent.prototype.modificarAviso = function (e, id) {
	        for (var _i = 0, _a = this.alarmaSeleccionada.avisosLista; _i < _a.length; _i++) {
	            var aviso = _a[_i];
	            if (aviso._id == id) {
	                this.avisoSeleccionado = aviso;
	                break;
	            }
	        }
	        this.modificacion = "modificarAviso";
	        $("#modalAviso").modal("show");
	        e.stopPropagation();
	    };
	    ABMGeneralComponent.prototype.eliminarAviso = function (e, id) {
	        for (var _i = 0, _a = this.alarmaSeleccionada.avisosLista; _i < _a.length; _i++) {
	            var aviso = _a[_i];
	            if (aviso._id == id) {
	                this.avisoSeleccionado = aviso;
	                break;
	            }
	        }
	        this.modificacion = "eliminarAviso";
	        $("#confirmacionAviso").modal("show");
	        e.stopPropagation();
	    };
	    ABMGeneralComponent.prototype.proximaSlide = function (posicion) {
	        var owl = $('.owl-carousel');
	        owl.owlCarousel();
	        // Go to the next item
	        owl.trigger('to.owl.carousel', [posicion, 1000, true]);
	    };
	    ABMGeneralComponent.prototype.avanzar = function () {
	        var owl = $('.owl-carousel');
	        owl.trigger('next.owl.carousel');
	    };
	    ABMGeneralComponent.prototype.retroceder = function () {
	        var owl = $('.owl-carousel');
	        owl.trigger('prev.owl.carousel');
	    };
	    ABMGeneralComponent.prototype.exportar = function () {
	        var csvContent = "Ubicación,Nodo,Canal de Monitorización,Alarma,Aviso \n";
	        for (var _i = 0, _a = this.sucursalSeleccionada.ubicaciones; _i < _a.length; _i++) {
	            var ubicacion = _a[_i];
	            csvContent += ubicacion.descripcion + "\n";
	            for (var _b = 0, _c = ubicacion.nodos; _b < _c.length; _b++) {
	                var nodo = _c[_b];
	                csvContent += "," + nodo.nombre + " - " + nodo.etiqueta + "\n";
	                for (var _d = 0, _e = nodo.sensores_id; _d < _e.length; _d++) {
	                    var sensor = _e[_d];
	                    csvContent += ",," + sensor.etiqueta + "\n";
	                    for (var _f = 0, _g = sensor.alarmas; _f < _g.length; _f++) {
	                        var alarma = _g[_f];
	                        csvContent += ",,," + alarma.descripcion + "\n";
	                        for (var _h = 0, _j = alarma.avisosLista; _h < _j.length; _h++) {
	                            var aviso = _j[_h];
	                            csvContent += ",,,," + aviso.nombre + "\n";
	                        }
	                    }
	                }
	            }
	        }
	        var a = document.createElement('a');
	        a.href = 'data:attachment/csv,' + encodeURIComponent(csvContent);
	        a.target = '_blank';
	        var d = new Date();
	        var datestring = d.getDate() + "" + (d.getMonth() + 1) + "" + d.getFullYear() + " " +
	            d.getHours() + "" + d.getMinutes();
	        a.download = this.sucursalSeleccionada.descripcion + "-" + datestring + '.csv';
	        document.body.appendChild(a);
	        a.click();
	    };
	    ABMGeneralComponent = __decorate([
	        core_1.Component({
	            selector: 'AbmGeneral',
	            template: __webpack_require__(981),
	            styles: [__webpack_require__(982)],
	            directives: [owl_carousel_component_1.OwlCarousel, ubicacion_component_1.UbicacionComponent, nodo_component_1.NodoComponent, sensor_component_1.SensorComponent, abmalarmas_component_1.AbmAlarmasComponent, aviso_component_1.AvisoComponent],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof nodo_service_1.NodoService !== 'undefined' && nodo_service_1.NodoService) === 'function' && _a) || Object, (typeof (_b = typeof progress_service_1.ProgressService !== 'undefined' && progress_service_1.ProgressService) === 'function' && _b) || Object, (typeof (_c = typeof permiso_service_1.PermisoService !== 'undefined' && permiso_service_1.PermisoService) === 'function' && _c) || Object, (typeof (_d = typeof login_service_1.LoginService !== 'undefined' && login_service_1.LoginService) === 'function' && _d) || Object])
	    ], ABMGeneralComponent);
	    return ABMGeneralComponent;
	    var _a, _b, _c, _d;
	}());
	exports.ABMGeneralComponent = ABMGeneralComponent;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(419)))

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	//import 'owl-carousel';
	__webpack_require__(966);
	__webpack_require__(971);
	var OwlCarousel = (function () {
	    function OwlCarousel(el) {
	        this.el = el;
	        this.defaultClass = 'owl-carousel';
	        this.defaultOptions = {};
	    }
	    OwlCarousel.prototype.ngAfterViewInit = function () {
	        // use default - empty
	        for (var key in this.options) {
	            this.defaultOptions[key] = this.options[key];
	        }
	        if ($(window).width() < 769) {
	            this.defaultOptions["items"] = 1;
	            this.defaultOptions["mouseDrag"] = true;
	        }
	        else
	            this.defaultOptions["items"] = 3;
	        this.$owlElement = $(this.el.nativeElement).owlCarousel(this.defaultOptions);
	        this.$owlElement.on('initialized.owl.carousel', function (event) {
	        });
	        //Cambiar opciones cuando cambia de tamaño la pantalla
	        window.onresize = function () {
	            var carousel = this.$owlElement.data('owl.carousel');
	            if ($(window).width() < 769) {
	                carousel.options.items = 1;
	                carousel.options.mouseDrag = true;
	            }
	            else {
	                carousel.options.items = 3;
	                carousel.options.mouseDrag = false;
	            }
	            this.$owlElement.trigger('refresh.owl.carousel');
	        }.bind(this);
	    };
	    OwlCarousel.prototype.ngOnDestroy = function () {
	        //this.$owlElement.data('owlCarousel').destroy();
	        this.$owlElement = null;
	    };
	    __decorate([
	        core_1.HostBinding('class'), 
	        __metadata('design:type', Object)
	    ], OwlCarousel.prototype, "defaultClass", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], OwlCarousel.prototype, "options", void 0);
	    OwlCarousel = __decorate([
	        core_1.Component({
	            selector: 'owl-carousel',
	            template: "<ng-content></ng-content>"
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.ElementRef !== 'undefined' && core_1.ElementRef) === 'function' && _a) || Object])
	    ], OwlCarousel);
	    return OwlCarousel;
	    var _a;
	}());
	exports.OwlCarousel = OwlCarousel;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(419)))

/***/ }),
/* 966 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/*** IMPORTS FROM imports-loader ***/
	var jQuery = __webpack_require__(419);
	
	/**
	 * Owl Carousel v2.3.4
	 * Copyright 2013-2018 David Deutsch
	 * Licensed under: SEE LICENSE IN https://github.com/OwlCarousel2/OwlCarousel2/blob/master/LICENSE
	 */
	/**
	 * Owl carousel
	 * @version 2.3.4
	 * @author Bartosz Wojciechowski
	 * @author David Deutsch
	 * @license The MIT License (MIT)
	 * @todo Lazy Load Icon
	 * @todo prevent animationend bubling
	 * @todo itemsScaleUp
	 * @todo Test Zepto
	 * @todo stagePadding calculate wrong active classes
	 */
	;(function($, window, document, undefined) {
	
		/**
		 * Creates a carousel.
		 * @class The Owl Carousel.
		 * @public
		 * @param {HTMLElement|jQuery} element - The element to create the carousel for.
		 * @param {Object} [options] - The options
		 */
		function Owl(element, options) {
	
			/**
			 * Current settings for the carousel.
			 * @public
			 */
			this.settings = null;
	
			/**
			 * Current options set by the caller including defaults.
			 * @public
			 */
			this.options = $.extend({}, Owl.Defaults, options);
	
			/**
			 * Plugin element.
			 * @public
			 */
			this.$element = $(element);
	
			/**
			 * Proxied event handlers.
			 * @protected
			 */
			this._handlers = {};
	
			/**
			 * References to the running plugins of this carousel.
			 * @protected
			 */
			this._plugins = {};
	
			/**
			 * Currently suppressed events to prevent them from being retriggered.
			 * @protected
			 */
			this._supress = {};
	
			/**
			 * Absolute current position.
			 * @protected
			 */
			this._current = null;
	
			/**
			 * Animation speed in milliseconds.
			 * @protected
			 */
			this._speed = null;
	
			/**
			 * Coordinates of all items in pixel.
			 * @todo The name of this member is missleading.
			 * @protected
			 */
			this._coordinates = [];
	
			/**
			 * Current breakpoint.
			 * @todo Real media queries would be nice.
			 * @protected
			 */
			this._breakpoint = null;
	
			/**
			 * Current width of the plugin element.
			 */
			this._width = null;
	
			/**
			 * All real items.
			 * @protected
			 */
			this._items = [];
	
			/**
			 * All cloned items.
			 * @protected
			 */
			this._clones = [];
	
			/**
			 * Merge values of all items.
			 * @todo Maybe this could be part of a plugin.
			 * @protected
			 */
			this._mergers = [];
	
			/**
			 * Widths of all items.
			 */
			this._widths = [];
	
			/**
			 * Invalidated parts within the update process.
			 * @protected
			 */
			this._invalidated = {};
	
			/**
			 * Ordered list of workers for the update process.
			 * @protected
			 */
			this._pipe = [];
	
			/**
			 * Current state information for the drag operation.
			 * @todo #261
			 * @protected
			 */
			this._drag = {
				time: null,
				target: null,
				pointer: null,
				stage: {
					start: null,
					current: null
				},
				direction: null
			};
	
			/**
			 * Current state information and their tags.
			 * @type {Object}
			 * @protected
			 */
			this._states = {
				current: {},
				tags: {
					'initializing': [ 'busy' ],
					'animating': [ 'busy' ],
					'dragging': [ 'interacting' ]
				}
			};
	
			$.each([ 'onResize', 'onThrottledResize' ], $.proxy(function(i, handler) {
				this._handlers[handler] = $.proxy(this[handler], this);
			}, this));
	
			$.each(Owl.Plugins, $.proxy(function(key, plugin) {
				this._plugins[key.charAt(0).toLowerCase() + key.slice(1)]
					= new plugin(this);
			}, this));
	
			$.each(Owl.Workers, $.proxy(function(priority, worker) {
				this._pipe.push({
					'filter': worker.filter,
					'run': $.proxy(worker.run, this)
				});
			}, this));
	
			this.setup();
			this.initialize();
		}
	
		/**
		 * Default options for the carousel.
		 * @public
		 */
		Owl.Defaults = {
			items: 3,
			loop: false,
			center: false,
			rewind: false,
			checkVisibility: true,
	
			mouseDrag: true,
			touchDrag: true,
			pullDrag: true,
			freeDrag: false,
	
			margin: 0,
			stagePadding: 0,
	
			merge: false,
			mergeFit: true,
			autoWidth: false,
	
			startPosition: 0,
			rtl: false,
	
			smartSpeed: 250,
			fluidSpeed: false,
			dragEndSpeed: false,
	
			responsive: {},
			responsiveRefreshRate: 200,
			responsiveBaseElement: window,
	
			fallbackEasing: 'swing',
			slideTransition: '',
	
			info: false,
	
			nestedItemSelector: false,
			itemElement: 'div',
			stageElement: 'div',
	
			refreshClass: 'owl-refresh',
			loadedClass: 'owl-loaded',
			loadingClass: 'owl-loading',
			rtlClass: 'owl-rtl',
			responsiveClass: 'owl-responsive',
			dragClass: 'owl-drag',
			itemClass: 'owl-item',
			stageClass: 'owl-stage',
			stageOuterClass: 'owl-stage-outer',
			grabClass: 'owl-grab'
		};
	
		/**
		 * Enumeration for width.
		 * @public
		 * @readonly
		 * @enum {String}
		 */
		Owl.Width = {
			Default: 'default',
			Inner: 'inner',
			Outer: 'outer'
		};
	
		/**
		 * Enumeration for types.
		 * @public
		 * @readonly
		 * @enum {String}
		 */
		Owl.Type = {
			Event: 'event',
			State: 'state'
		};
	
		/**
		 * Contains all registered plugins.
		 * @public
		 */
		Owl.Plugins = {};
	
		/**
		 * List of workers involved in the update process.
		 */
		Owl.Workers = [ {
			filter: [ 'width', 'settings' ],
			run: function() {
				this._width = this.$element.width();
			}
		}, {
			filter: [ 'width', 'items', 'settings' ],
			run: function(cache) {
				cache.current = this._items && this._items[this.relative(this._current)];
			}
		}, {
			filter: [ 'items', 'settings' ],
			run: function() {
				this.$stage.children('.cloned').remove();
			}
		}, {
			filter: [ 'width', 'items', 'settings' ],
			run: function(cache) {
				var margin = this.settings.margin || '',
					grid = !this.settings.autoWidth,
					rtl = this.settings.rtl,
					css = {
						'width': 'auto',
						'margin-left': rtl ? margin : '',
						'margin-right': rtl ? '' : margin
					};
	
				!grid && this.$stage.children().css(css);
	
				cache.css = css;
			}
		}, {
			filter: [ 'width', 'items', 'settings' ],
			run: function(cache) {
				var width = (this.width() / this.settings.items).toFixed(3) - this.settings.margin,
					merge = null,
					iterator = this._items.length,
					grid = !this.settings.autoWidth,
					widths = [];
	
				cache.items = {
					merge: false,
					width: width
				};
	
				while (iterator--) {
					merge = this._mergers[iterator];
					merge = this.settings.mergeFit && Math.min(merge, this.settings.items) || merge;
	
					cache.items.merge = merge > 1 || cache.items.merge;
	
					widths[iterator] = !grid ? this._items[iterator].width() : width * merge;
				}
	
				this._widths = widths;
			}
		}, {
			filter: [ 'items', 'settings' ],
			run: function() {
				var clones = [],
					items = this._items,
					settings = this.settings,
					// TODO: Should be computed from number of min width items in stage
					view = Math.max(settings.items * 2, 4),
					size = Math.ceil(items.length / 2) * 2,
					repeat = settings.loop && items.length ? settings.rewind ? view : Math.max(view, size) : 0,
					append = '',
					prepend = '';
	
				repeat /= 2;
	
				while (repeat > 0) {
					// Switch to only using appended clones
					clones.push(this.normalize(clones.length / 2, true));
					append = append + items[clones[clones.length - 1]][0].outerHTML;
					clones.push(this.normalize(items.length - 1 - (clones.length - 1) / 2, true));
					prepend = items[clones[clones.length - 1]][0].outerHTML + prepend;
					repeat -= 1;
				}
	
				this._clones = clones;
	
				$(append).addClass('cloned').appendTo(this.$stage);
				$(prepend).addClass('cloned').prependTo(this.$stage);
			}
		}, {
			filter: [ 'width', 'items', 'settings' ],
			run: function() {
				var rtl = this.settings.rtl ? 1 : -1,
					size = this._clones.length + this._items.length,
					iterator = -1,
					previous = 0,
					current = 0,
					coordinates = [];
	
				while (++iterator < size) {
					previous = coordinates[iterator - 1] || 0;
					current = this._widths[this.relative(iterator)] + this.settings.margin;
					coordinates.push(previous + current * rtl);
				}
	
				this._coordinates = coordinates;
			}
		}, {
			filter: [ 'width', 'items', 'settings' ],
			run: function() {
				var padding = this.settings.stagePadding,
					coordinates = this._coordinates,
					css = {
						'width': Math.ceil(Math.abs(coordinates[coordinates.length - 1])) + padding * 2,
						'padding-left': padding || '',
						'padding-right': padding || ''
					};
	
				this.$stage.css(css);
			}
		}, {
			filter: [ 'width', 'items', 'settings' ],
			run: function(cache) {
				var iterator = this._coordinates.length,
					grid = !this.settings.autoWidth,
					items = this.$stage.children();
	
				if (grid && cache.items.merge) {
					while (iterator--) {
						cache.css.width = this._widths[this.relative(iterator)];
						items.eq(iterator).css(cache.css);
					}
				} else if (grid) {
					cache.css.width = cache.items.width;
					items.css(cache.css);
				}
			}
		}, {
			filter: [ 'items' ],
			run: function() {
				this._coordinates.length < 1 && this.$stage.removeAttr('style');
			}
		}, {
			filter: [ 'width', 'items', 'settings' ],
			run: function(cache) {
				cache.current = cache.current ? this.$stage.children().index(cache.current) : 0;
				cache.current = Math.max(this.minimum(), Math.min(this.maximum(), cache.current));
				this.reset(cache.current);
			}
		}, {
			filter: [ 'position' ],
			run: function() {
				this.animate(this.coordinates(this._current));
			}
		}, {
			filter: [ 'width', 'position', 'items', 'settings' ],
			run: function() {
				var rtl = this.settings.rtl ? 1 : -1,
					padding = this.settings.stagePadding * 2,
					begin = this.coordinates(this.current()) + padding,
					end = begin + this.width() * rtl,
					inner, outer, matches = [], i, n;
	
				for (i = 0, n = this._coordinates.length; i < n; i++) {
					inner = this._coordinates[i - 1] || 0;
					outer = Math.abs(this._coordinates[i]) + padding * rtl;
	
					if ((this.op(inner, '<=', begin) && (this.op(inner, '>', end)))
						|| (this.op(outer, '<', begin) && this.op(outer, '>', end))) {
						matches.push(i);
					}
				}
	
				this.$stage.children('.active').removeClass('active');
				this.$stage.children(':eq(' + matches.join('), :eq(') + ')').addClass('active');
	
				this.$stage.children('.center').removeClass('center');
				if (this.settings.center) {
					this.$stage.children().eq(this.current()).addClass('center');
				}
			}
		} ];
	
		/**
		 * Create the stage DOM element
		 */
		Owl.prototype.initializeStage = function() {
			this.$stage = this.$element.find('.' + this.settings.stageClass);
	
			// if the stage is already in the DOM, grab it and skip stage initialization
			if (this.$stage.length) {
				return;
			}
	
			this.$element.addClass(this.options.loadingClass);
	
			// create stage
			this.$stage = $('<' + this.settings.stageElement + '>', {
				"class": this.settings.stageClass
			}).wrap( $( '<div/>', {
				"class": this.settings.stageOuterClass
			}));
	
			// append stage
			this.$element.append(this.$stage.parent());
		};
	
		/**
		 * Create item DOM elements
		 */
		Owl.prototype.initializeItems = function() {
			var $items = this.$element.find('.owl-item');
	
			// if the items are already in the DOM, grab them and skip item initialization
			if ($items.length) {
				this._items = $items.get().map(function(item) {
					return $(item);
				});
	
				this._mergers = this._items.map(function() {
					return 1;
				});
	
				this.refresh();
	
				return;
			}
	
			// append content
			this.replace(this.$element.children().not(this.$stage.parent()));
	
			// check visibility
			if (this.isVisible()) {
				// update view
				this.refresh();
			} else {
				// invalidate width
				this.invalidate('width');
			}
	
			this.$element
				.removeClass(this.options.loadingClass)
				.addClass(this.options.loadedClass);
		};
	
		/**
		 * Initializes the carousel.
		 * @protected
		 */
		Owl.prototype.initialize = function() {
			this.enter('initializing');
			this.trigger('initialize');
	
			this.$element.toggleClass(this.settings.rtlClass, this.settings.rtl);
	
			if (this.settings.autoWidth && !this.is('pre-loading')) {
				var imgs, nestedSelector, width;
				imgs = this.$element.find('img');
				nestedSelector = this.settings.nestedItemSelector ? '.' + this.settings.nestedItemSelector : undefined;
				width = this.$element.children(nestedSelector).width();
	
				if (imgs.length && width <= 0) {
					this.preloadAutoWidthImages(imgs);
				}
			}
	
			this.initializeStage();
			this.initializeItems();
	
			// register event handlers
			this.registerEventHandlers();
	
			this.leave('initializing');
			this.trigger('initialized');
		};
	
		/**
		 * @returns {Boolean} visibility of $element
		 *                    if you know the carousel will always be visible you can set `checkVisibility` to `false` to
		 *                    prevent the expensive browser layout forced reflow the $element.is(':visible') does
		 */
		Owl.prototype.isVisible = function() {
			return this.settings.checkVisibility
				? this.$element.is(':visible')
				: true;
		};
	
		/**
		 * Setups the current settings.
		 * @todo Remove responsive classes. Why should adaptive designs be brought into IE8?
		 * @todo Support for media queries by using `matchMedia` would be nice.
		 * @public
		 */
		Owl.prototype.setup = function() {
			var viewport = this.viewport(),
				overwrites = this.options.responsive,
				match = -1,
				settings = null;
	
			if (!overwrites) {
				settings = $.extend({}, this.options);
			} else {
				$.each(overwrites, function(breakpoint) {
					if (breakpoint <= viewport && breakpoint > match) {
						match = Number(breakpoint);
					}
				});
	
				settings = $.extend({}, this.options, overwrites[match]);
				if (typeof settings.stagePadding === 'function') {
					settings.stagePadding = settings.stagePadding();
				}
				delete settings.responsive;
	
				// responsive class
				if (settings.responsiveClass) {
					this.$element.attr('class',
						this.$element.attr('class').replace(new RegExp('(' + this.options.responsiveClass + '-)\\S+\\s', 'g'), '$1' + match)
					);
				}
			}
	
			this.trigger('change', { property: { name: 'settings', value: settings } });
			this._breakpoint = match;
			this.settings = settings;
			this.invalidate('settings');
			this.trigger('changed', { property: { name: 'settings', value: this.settings } });
		};
	
		/**
		 * Updates option logic if necessery.
		 * @protected
		 */
		Owl.prototype.optionsLogic = function() {
			if (this.settings.autoWidth) {
				this.settings.stagePadding = false;
				this.settings.merge = false;
			}
		};
	
		/**
		 * Prepares an item before add.
		 * @todo Rename event parameter `content` to `item`.
		 * @protected
		 * @returns {jQuery|HTMLElement} - The item container.
		 */
		Owl.prototype.prepare = function(item) {
			var event = this.trigger('prepare', { content: item });
	
			if (!event.data) {
				event.data = $('<' + this.settings.itemElement + '/>')
					.addClass(this.options.itemClass).append(item)
			}
	
			this.trigger('prepared', { content: event.data });
	
			return event.data;
		};
	
		/**
		 * Updates the view.
		 * @public
		 */
		Owl.prototype.update = function() {
			var i = 0,
				n = this._pipe.length,
				filter = $.proxy(function(p) { return this[p] }, this._invalidated),
				cache = {};
	
			while (i < n) {
				if (this._invalidated.all || $.grep(this._pipe[i].filter, filter).length > 0) {
					this._pipe[i].run(cache);
				}
				i++;
			}
	
			this._invalidated = {};
	
			!this.is('valid') && this.enter('valid');
		};
	
		/**
		 * Gets the width of the view.
		 * @public
		 * @param {Owl.Width} [dimension=Owl.Width.Default] - The dimension to return.
		 * @returns {Number} - The width of the view in pixel.
		 */
		Owl.prototype.width = function(dimension) {
			dimension = dimension || Owl.Width.Default;
			switch (dimension) {
				case Owl.Width.Inner:
				case Owl.Width.Outer:
					return this._width;
				default:
					return this._width - this.settings.stagePadding * 2 + this.settings.margin;
			}
		};
	
		/**
		 * Refreshes the carousel primarily for adaptive purposes.
		 * @public
		 */
		Owl.prototype.refresh = function() {
			this.enter('refreshing');
			this.trigger('refresh');
	
			this.setup();
	
			this.optionsLogic();
	
			this.$element.addClass(this.options.refreshClass);
	
			this.update();
	
			this.$element.removeClass(this.options.refreshClass);
	
			this.leave('refreshing');
			this.trigger('refreshed');
		};
	
		/**
		 * Checks window `resize` event.
		 * @protected
		 */
		Owl.prototype.onThrottledResize = function() {
			window.clearTimeout(this.resizeTimer);
			this.resizeTimer = window.setTimeout(this._handlers.onResize, this.settings.responsiveRefreshRate);
		};
	
		/**
		 * Checks window `resize` event.
		 * @protected
		 */
		Owl.prototype.onResize = function() {
			if (!this._items.length) {
				return false;
			}
	
			if (this._width === this.$element.width()) {
				return false;
			}
	
			if (!this.isVisible()) {
				return false;
			}
	
			this.enter('resizing');
	
			if (this.trigger('resize').isDefaultPrevented()) {
				this.leave('resizing');
				return false;
			}
	
			this.invalidate('width');
	
			this.refresh();
	
			this.leave('resizing');
			this.trigger('resized');
		};
	
		/**
		 * Registers event handlers.
		 * @todo Check `msPointerEnabled`
		 * @todo #261
		 * @protected
		 */
		Owl.prototype.registerEventHandlers = function() {
			if ($.support.transition) {
				this.$stage.on($.support.transition.end + '.owl.core', $.proxy(this.onTransitionEnd, this));
			}
	
			if (this.settings.responsive !== false) {
				this.on(window, 'resize', this._handlers.onThrottledResize);
			}
	
			if (this.settings.mouseDrag) {
				this.$element.addClass(this.options.dragClass);
				this.$stage.on('mousedown.owl.core', $.proxy(this.onDragStart, this));
				this.$stage.on('dragstart.owl.core selectstart.owl.core', function() { return false });
			}
	
			if (this.settings.touchDrag){
				this.$stage.on('touchstart.owl.core', $.proxy(this.onDragStart, this));
				this.$stage.on('touchcancel.owl.core', $.proxy(this.onDragEnd, this));
			}
		};
	
		/**
		 * Handles `touchstart` and `mousedown` events.
		 * @todo Horizontal swipe threshold as option
		 * @todo #261
		 * @protected
		 * @param {Event} event - The event arguments.
		 */
		Owl.prototype.onDragStart = function(event) {
			var stage = null;
	
			if (event.which === 3) {
				return;
			}
	
			if ($.support.transform) {
				stage = this.$stage.css('transform').replace(/.*\(|\)| /g, '').split(',');
				stage = {
					x: stage[stage.length === 16 ? 12 : 4],
					y: stage[stage.length === 16 ? 13 : 5]
				};
			} else {
				stage = this.$stage.position();
				stage = {
					x: this.settings.rtl ?
						stage.left + this.$stage.width() - this.width() + this.settings.margin :
						stage.left,
					y: stage.top
				};
			}
	
			if (this.is('animating')) {
				$.support.transform ? this.animate(stage.x) : this.$stage.stop()
				this.invalidate('position');
			}
	
			this.$element.toggleClass(this.options.grabClass, event.type === 'mousedown');
	
			this.speed(0);
	
			this._drag.time = new Date().getTime();
			this._drag.target = $(event.target);
			this._drag.stage.start = stage;
			this._drag.stage.current = stage;
			this._drag.pointer = this.pointer(event);
	
			$(document).on('mouseup.owl.core touchend.owl.core', $.proxy(this.onDragEnd, this));
	
			$(document).one('mousemove.owl.core touchmove.owl.core', $.proxy(function(event) {
				var delta = this.difference(this._drag.pointer, this.pointer(event));
	
				$(document).on('mousemove.owl.core touchmove.owl.core', $.proxy(this.onDragMove, this));
	
				if (Math.abs(delta.x) < Math.abs(delta.y) && this.is('valid')) {
					return;
				}
	
				event.preventDefault();
	
				this.enter('dragging');
				this.trigger('drag');
			}, this));
		};
	
		/**
		 * Handles the `touchmove` and `mousemove` events.
		 * @todo #261
		 * @protected
		 * @param {Event} event - The event arguments.
		 */
		Owl.prototype.onDragMove = function(event) {
			var minimum = null,
				maximum = null,
				pull = null,
				delta = this.difference(this._drag.pointer, this.pointer(event)),
				stage = this.difference(this._drag.stage.start, delta);
	
			if (!this.is('dragging')) {
				return;
			}
	
			event.preventDefault();
	
			if (this.settings.loop) {
				minimum = this.coordinates(this.minimum());
				maximum = this.coordinates(this.maximum() + 1) - minimum;
				stage.x = (((stage.x - minimum) % maximum + maximum) % maximum) + minimum;
			} else {
				minimum = this.settings.rtl ? this.coordinates(this.maximum()) : this.coordinates(this.minimum());
				maximum = this.settings.rtl ? this.coordinates(this.minimum()) : this.coordinates(this.maximum());
				pull = this.settings.pullDrag ? -1 * delta.x / 5 : 0;
				stage.x = Math.max(Math.min(stage.x, minimum + pull), maximum + pull);
			}
	
			this._drag.stage.current = stage;
	
			this.animate(stage.x);
		};
	
		/**
		 * Handles the `touchend` and `mouseup` events.
		 * @todo #261
		 * @todo Threshold for click event
		 * @protected
		 * @param {Event} event - The event arguments.
		 */
		Owl.prototype.onDragEnd = function(event) {
			var delta = this.difference(this._drag.pointer, this.pointer(event)),
				stage = this._drag.stage.current,
				direction = delta.x > 0 ^ this.settings.rtl ? 'left' : 'right';
	
			$(document).off('.owl.core');
	
			this.$element.removeClass(this.options.grabClass);
	
			if (delta.x !== 0 && this.is('dragging') || !this.is('valid')) {
				this.speed(this.settings.dragEndSpeed || this.settings.smartSpeed);
				this.current(this.closest(stage.x, delta.x !== 0 ? direction : this._drag.direction));
				this.invalidate('position');
				this.update();
	
				this._drag.direction = direction;
	
				if (Math.abs(delta.x) > 3 || new Date().getTime() - this._drag.time > 300) {
					this._drag.target.one('click.owl.core', function() { return false; });
				}
			}
	
			if (!this.is('dragging')) {
				return;
			}
	
			this.leave('dragging');
			this.trigger('dragged');
		};
	
		/**
		 * Gets absolute position of the closest item for a coordinate.
		 * @todo Setting `freeDrag` makes `closest` not reusable. See #165.
		 * @protected
		 * @param {Number} coordinate - The coordinate in pixel.
		 * @param {String} direction - The direction to check for the closest item. Ether `left` or `right`.
		 * @return {Number} - The absolute position of the closest item.
		 */
		Owl.prototype.closest = function(coordinate, direction) {
			var position = -1,
				pull = 30,
				width = this.width(),
				coordinates = this.coordinates();
	
			if (!this.settings.freeDrag) {
				// check closest item
				$.each(coordinates, $.proxy(function(index, value) {
					// on a left pull, check on current index
					if (direction === 'left' && coordinate > value - pull && coordinate < value + pull) {
						position = index;
					// on a right pull, check on previous index
					// to do so, subtract width from value and set position = index + 1
					} else if (direction === 'right' && coordinate > value - width - pull && coordinate < value - width + pull) {
						position = index + 1;
					} else if (this.op(coordinate, '<', value)
						&& this.op(coordinate, '>', coordinates[index + 1] !== undefined ? coordinates[index + 1] : value - width)) {
						position = direction === 'left' ? index + 1 : index;
					}
					return position === -1;
				}, this));
			}
	
			if (!this.settings.loop) {
				// non loop boundries
				if (this.op(coordinate, '>', coordinates[this.minimum()])) {
					position = coordinate = this.minimum();
				} else if (this.op(coordinate, '<', coordinates[this.maximum()])) {
					position = coordinate = this.maximum();
				}
			}
	
			return position;
		};
	
		/**
		 * Animates the stage.
		 * @todo #270
		 * @public
		 * @param {Number} coordinate - The coordinate in pixels.
		 */
		Owl.prototype.animate = function(coordinate) {
			var animate = this.speed() > 0;
	
			this.is('animating') && this.onTransitionEnd();
	
			if (animate) {
				this.enter('animating');
				this.trigger('translate');
			}
	
			if ($.support.transform3d && $.support.transition) {
				this.$stage.css({
					transform: 'translate3d(' + coordinate + 'px,0px,0px)',
					transition: (this.speed() / 1000) + 's' + (
						this.settings.slideTransition ? ' ' + this.settings.slideTransition : ''
					)
				});
			} else if (animate) {
				this.$stage.animate({
					left: coordinate + 'px'
				}, this.speed(), this.settings.fallbackEasing, $.proxy(this.onTransitionEnd, this));
			} else {
				this.$stage.css({
					left: coordinate + 'px'
				});
			}
		};
	
		/**
		 * Checks whether the carousel is in a specific state or not.
		 * @param {String} state - The state to check.
		 * @returns {Boolean} - The flag which indicates if the carousel is busy.
		 */
		Owl.prototype.is = function(state) {
			return this._states.current[state] && this._states.current[state] > 0;
		};
	
		/**
		 * Sets the absolute position of the current item.
		 * @public
		 * @param {Number} [position] - The new absolute position or nothing to leave it unchanged.
		 * @returns {Number} - The absolute position of the current item.
		 */
		Owl.prototype.current = function(position) {
			if (position === undefined) {
				return this._current;
			}
	
			if (this._items.length === 0) {
				return undefined;
			}
	
			position = this.normalize(position);
	
			if (this._current !== position) {
				var event = this.trigger('change', { property: { name: 'position', value: position } });
	
				if (event.data !== undefined) {
					position = this.normalize(event.data);
				}
	
				this._current = position;
	
				this.invalidate('position');
	
				this.trigger('changed', { property: { name: 'position', value: this._current } });
			}
	
			return this._current;
		};
	
		/**
		 * Invalidates the given part of the update routine.
		 * @param {String} [part] - The part to invalidate.
		 * @returns {Array.<String>} - The invalidated parts.
		 */
		Owl.prototype.invalidate = function(part) {
			if ($.type(part) === 'string') {
				this._invalidated[part] = true;
				this.is('valid') && this.leave('valid');
			}
			return $.map(this._invalidated, function(v, i) { return i });
		};
	
		/**
		 * Resets the absolute position of the current item.
		 * @public
		 * @param {Number} position - The absolute position of the new item.
		 */
		Owl.prototype.reset = function(position) {
			position = this.normalize(position);
	
			if (position === undefined) {
				return;
			}
	
			this._speed = 0;
			this._current = position;
	
			this.suppress([ 'translate', 'translated' ]);
	
			this.animate(this.coordinates(position));
	
			this.release([ 'translate', 'translated' ]);
		};
	
		/**
		 * Normalizes an absolute or a relative position of an item.
		 * @public
		 * @param {Number} position - The absolute or relative position to normalize.
		 * @param {Boolean} [relative=false] - Whether the given position is relative or not.
		 * @returns {Number} - The normalized position.
		 */
		Owl.prototype.normalize = function(position, relative) {
			var n = this._items.length,
				m = relative ? 0 : this._clones.length;
	
			if (!this.isNumeric(position) || n < 1) {
				position = undefined;
			} else if (position < 0 || position >= n + m) {
				position = ((position - m / 2) % n + n) % n + m / 2;
			}
	
			return position;
		};
	
		/**
		 * Converts an absolute position of an item into a relative one.
		 * @public
		 * @param {Number} position - The absolute position to convert.
		 * @returns {Number} - The converted position.
		 */
		Owl.prototype.relative = function(position) {
			position -= this._clones.length / 2;
			return this.normalize(position, true);
		};
	
		/**
		 * Gets the maximum position for the current item.
		 * @public
		 * @param {Boolean} [relative=false] - Whether to return an absolute position or a relative position.
		 * @returns {Number}
		 */
		Owl.prototype.maximum = function(relative) {
			var settings = this.settings,
				maximum = this._coordinates.length,
				iterator,
				reciprocalItemsWidth,
				elementWidth;
	
			if (settings.loop) {
				maximum = this._clones.length / 2 + this._items.length - 1;
			} else if (settings.autoWidth || settings.merge) {
				iterator = this._items.length;
				if (iterator) {
					reciprocalItemsWidth = this._items[--iterator].width();
					elementWidth = this.$element.width();
					while (iterator--) {
						reciprocalItemsWidth += this._items[iterator].width() + this.settings.margin;
						if (reciprocalItemsWidth > elementWidth) {
							break;
						}
					}
				}
				maximum = iterator + 1;
			} else if (settings.center) {
				maximum = this._items.length - 1;
			} else {
				maximum = this._items.length - settings.items;
			}
	
			if (relative) {
				maximum -= this._clones.length / 2;
			}
	
			return Math.max(maximum, 0);
		};
	
		/**
		 * Gets the minimum position for the current item.
		 * @public
		 * @param {Boolean} [relative=false] - Whether to return an absolute position or a relative position.
		 * @returns {Number}
		 */
		Owl.prototype.minimum = function(relative) {
			return relative ? 0 : this._clones.length / 2;
		};
	
		/**
		 * Gets an item at the specified relative position.
		 * @public
		 * @param {Number} [position] - The relative position of the item.
		 * @return {jQuery|Array.<jQuery>} - The item at the given position or all items if no position was given.
		 */
		Owl.prototype.items = function(position) {
			if (position === undefined) {
				return this._items.slice();
			}
	
			position = this.normalize(position, true);
			return this._items[position];
		};
	
		/**
		 * Gets an item at the specified relative position.
		 * @public
		 * @param {Number} [position] - The relative position of the item.
		 * @return {jQuery|Array.<jQuery>} - The item at the given position or all items if no position was given.
		 */
		Owl.prototype.mergers = function(position) {
			if (position === undefined) {
				return this._mergers.slice();
			}
	
			position = this.normalize(position, true);
			return this._mergers[position];
		};
	
		/**
		 * Gets the absolute positions of clones for an item.
		 * @public
		 * @param {Number} [position] - The relative position of the item.
		 * @returns {Array.<Number>} - The absolute positions of clones for the item or all if no position was given.
		 */
		Owl.prototype.clones = function(position) {
			var odd = this._clones.length / 2,
				even = odd + this._items.length,
				map = function(index) { return index % 2 === 0 ? even + index / 2 : odd - (index + 1) / 2 };
	
			if (position === undefined) {
				return $.map(this._clones, function(v, i) { return map(i) });
			}
	
			return $.map(this._clones, function(v, i) { return v === position ? map(i) : null });
		};
	
		/**
		 * Sets the current animation speed.
		 * @public
		 * @param {Number} [speed] - The animation speed in milliseconds or nothing to leave it unchanged.
		 * @returns {Number} - The current animation speed in milliseconds.
		 */
		Owl.prototype.speed = function(speed) {
			if (speed !== undefined) {
				this._speed = speed;
			}
	
			return this._speed;
		};
	
		/**
		 * Gets the coordinate of an item.
		 * @todo The name of this method is missleanding.
		 * @public
		 * @param {Number} position - The absolute position of the item within `minimum()` and `maximum()`.
		 * @returns {Number|Array.<Number>} - The coordinate of the item in pixel or all coordinates.
		 */
		Owl.prototype.coordinates = function(position) {
			var multiplier = 1,
				newPosition = position - 1,
				coordinate;
	
			if (position === undefined) {
				return $.map(this._coordinates, $.proxy(function(coordinate, index) {
					return this.coordinates(index);
				}, this));
			}
	
			if (this.settings.center) {
				if (this.settings.rtl) {
					multiplier = -1;
					newPosition = position + 1;
				}
	
				coordinate = this._coordinates[position];
				coordinate += (this.width() - coordinate + (this._coordinates[newPosition] || 0)) / 2 * multiplier;
			} else {
				coordinate = this._coordinates[newPosition] || 0;
			}
	
			coordinate = Math.ceil(coordinate);
	
			return coordinate;
		};
	
		/**
		 * Calculates the speed for a translation.
		 * @protected
		 * @param {Number} from - The absolute position of the start item.
		 * @param {Number} to - The absolute position of the target item.
		 * @param {Number} [factor=undefined] - The time factor in milliseconds.
		 * @returns {Number} - The time in milliseconds for the translation.
		 */
		Owl.prototype.duration = function(from, to, factor) {
			if (factor === 0) {
				return 0;
			}
	
			return Math.min(Math.max(Math.abs(to - from), 1), 6) * Math.abs((factor || this.settings.smartSpeed));
		};
	
		/**
		 * Slides to the specified item.
		 * @public
		 * @param {Number} position - The position of the item.
		 * @param {Number} [speed] - The time in milliseconds for the transition.
		 */
		Owl.prototype.to = function(position, speed) {
			var current = this.current(),
				revert = null,
				distance = position - this.relative(current),
				direction = (distance > 0) - (distance < 0),
				items = this._items.length,
				minimum = this.minimum(),
				maximum = this.maximum();
	
			if (this.settings.loop) {
				if (!this.settings.rewind && Math.abs(distance) > items / 2) {
					distance += direction * -1 * items;
				}
	
				position = current + distance;
				revert = ((position - minimum) % items + items) % items + minimum;
	
				if (revert !== position && revert - distance <= maximum && revert - distance > 0) {
					current = revert - distance;
					position = revert;
					this.reset(current);
				}
			} else if (this.settings.rewind) {
				maximum += 1;
				position = (position % maximum + maximum) % maximum;
			} else {
				position = Math.max(minimum, Math.min(maximum, position));
			}
	
			this.speed(this.duration(current, position, speed));
			this.current(position);
	
			if (this.isVisible()) {
				this.update();
			}
		};
	
		/**
		 * Slides to the next item.
		 * @public
		 * @param {Number} [speed] - The time in milliseconds for the transition.
		 */
		Owl.prototype.next = function(speed) {
			speed = speed || false;
			this.to(this.relative(this.current()) + 1, speed);
		};
	
		/**
		 * Slides to the previous item.
		 * @public
		 * @param {Number} [speed] - The time in milliseconds for the transition.
		 */
		Owl.prototype.prev = function(speed) {
			speed = speed || false;
			this.to(this.relative(this.current()) - 1, speed);
		};
	
		/**
		 * Handles the end of an animation.
		 * @protected
		 * @param {Event} event - The event arguments.
		 */
		Owl.prototype.onTransitionEnd = function(event) {
	
			// if css2 animation then event object is undefined
			if (event !== undefined) {
				event.stopPropagation();
	
				// Catch only owl-stage transitionEnd event
				if ((event.target || event.srcElement || event.originalTarget) !== this.$stage.get(0)) {
					return false;
				}
			}
	
			this.leave('animating');
			this.trigger('translated');
		};
	
		/**
		 * Gets viewport width.
		 * @protected
		 * @return {Number} - The width in pixel.
		 */
		Owl.prototype.viewport = function() {
			var width;
			if (this.options.responsiveBaseElement !== window) {
				width = $(this.options.responsiveBaseElement).width();
			} else if (window.innerWidth) {
				width = window.innerWidth;
			} else if (document.documentElement && document.documentElement.clientWidth) {
				width = document.documentElement.clientWidth;
			} else {
				console.warn('Can not detect viewport width.');
			}
			return width;
		};
	
		/**
		 * Replaces the current content.
		 * @public
		 * @param {HTMLElement|jQuery|String} content - The new content.
		 */
		Owl.prototype.replace = function(content) {
			this.$stage.empty();
			this._items = [];
	
			if (content) {
				content = (content instanceof jQuery) ? content : $(content);
			}
	
			if (this.settings.nestedItemSelector) {
				content = content.find('.' + this.settings.nestedItemSelector);
			}
	
			content.filter(function() {
				return this.nodeType === 1;
			}).each($.proxy(function(index, item) {
				item = this.prepare(item);
				this.$stage.append(item);
				this._items.push(item);
				this._mergers.push(item.find('[data-merge]').addBack('[data-merge]').attr('data-merge') * 1 || 1);
			}, this));
	
			this.reset(this.isNumeric(this.settings.startPosition) ? this.settings.startPosition : 0);
	
			this.invalidate('items');
		};
	
		/**
		 * Adds an item.
		 * @todo Use `item` instead of `content` for the event arguments.
		 * @public
		 * @param {HTMLElement|jQuery|String} content - The item content to add.
		 * @param {Number} [position] - The relative position at which to insert the item otherwise the item will be added to the end.
		 */
		Owl.prototype.add = function(content, position) {
			var current = this.relative(this._current);
	
			position = position === undefined ? this._items.length : this.normalize(position, true);
			content = content instanceof jQuery ? content : $(content);
	
			this.trigger('add', { content: content, position: position });
	
			content = this.prepare(content);
	
			if (this._items.length === 0 || position === this._items.length) {
				this._items.length === 0 && this.$stage.append(content);
				this._items.length !== 0 && this._items[position - 1].after(content);
				this._items.push(content);
				this._mergers.push(content.find('[data-merge]').addBack('[data-merge]').attr('data-merge') * 1 || 1);
			} else {
				this._items[position].before(content);
				this._items.splice(position, 0, content);
				this._mergers.splice(position, 0, content.find('[data-merge]').addBack('[data-merge]').attr('data-merge') * 1 || 1);
			}
	
			this._items[current] && this.reset(this._items[current].index());
	
			this.invalidate('items');
	
			this.trigger('added', { content: content, position: position });
		};
	
		/**
		 * Removes an item by its position.
		 * @todo Use `item` instead of `content` for the event arguments.
		 * @public
		 * @param {Number} position - The relative position of the item to remove.
		 */
		Owl.prototype.remove = function(position) {
			position = this.normalize(position, true);
	
			if (position === undefined) {
				return;
			}
	
			this.trigger('remove', { content: this._items[position], position: position });
	
			this._items[position].remove();
			this._items.splice(position, 1);
			this._mergers.splice(position, 1);
	
			this.invalidate('items');
	
			this.trigger('removed', { content: null, position: position });
		};
	
		/**
		 * Preloads images with auto width.
		 * @todo Replace by a more generic approach
		 * @protected
		 */
		Owl.prototype.preloadAutoWidthImages = function(images) {
			images.each($.proxy(function(i, element) {
				this.enter('pre-loading');
				element = $(element);
				$(new Image()).one('load', $.proxy(function(e) {
					element.attr('src', e.target.src);
					element.css('opacity', 1);
					this.leave('pre-loading');
					!this.is('pre-loading') && !this.is('initializing') && this.refresh();
				}, this)).attr('src', element.attr('src') || element.attr('data-src') || element.attr('data-src-retina'));
			}, this));
		};
	
		/**
		 * Destroys the carousel.
		 * @public
		 */
		Owl.prototype.destroy = function() {
	
			this.$element.off('.owl.core');
			this.$stage.off('.owl.core');
			$(document).off('.owl.core');
	
			if (this.settings.responsive !== false) {
				window.clearTimeout(this.resizeTimer);
				this.off(window, 'resize', this._handlers.onThrottledResize);
			}
	
			for (var i in this._plugins) {
				this._plugins[i].destroy();
			}
	
			this.$stage.children('.cloned').remove();
	
			this.$stage.unwrap();
			this.$stage.children().contents().unwrap();
			this.$stage.children().unwrap();
			this.$stage.remove();
			this.$element
				.removeClass(this.options.refreshClass)
				.removeClass(this.options.loadingClass)
				.removeClass(this.options.loadedClass)
				.removeClass(this.options.rtlClass)
				.removeClass(this.options.dragClass)
				.removeClass(this.options.grabClass)
				.attr('class', this.$element.attr('class').replace(new RegExp(this.options.responsiveClass + '-\\S+\\s', 'g'), ''))
				.removeData('owl.carousel');
		};
	
		/**
		 * Operators to calculate right-to-left and left-to-right.
		 * @protected
		 * @param {Number} [a] - The left side operand.
		 * @param {String} [o] - The operator.
		 * @param {Number} [b] - The right side operand.
		 */
		Owl.prototype.op = function(a, o, b) {
			var rtl = this.settings.rtl;
			switch (o) {
				case '<':
					return rtl ? a > b : a < b;
				case '>':
					return rtl ? a < b : a > b;
				case '>=':
					return rtl ? a <= b : a >= b;
				case '<=':
					return rtl ? a >= b : a <= b;
				default:
					break;
			}
		};
	
		/**
		 * Attaches to an internal event.
		 * @protected
		 * @param {HTMLElement} element - The event source.
		 * @param {String} event - The event name.
		 * @param {Function} listener - The event handler to attach.
		 * @param {Boolean} capture - Wether the event should be handled at the capturing phase or not.
		 */
		Owl.prototype.on = function(element, event, listener, capture) {
			if (element.addEventListener) {
				element.addEventListener(event, listener, capture);
			} else if (element.attachEvent) {
				element.attachEvent('on' + event, listener);
			}
		};
	
		/**
		 * Detaches from an internal event.
		 * @protected
		 * @param {HTMLElement} element - The event source.
		 * @param {String} event - The event name.
		 * @param {Function} listener - The attached event handler to detach.
		 * @param {Boolean} capture - Wether the attached event handler was registered as a capturing listener or not.
		 */
		Owl.prototype.off = function(element, event, listener, capture) {
			if (element.removeEventListener) {
				element.removeEventListener(event, listener, capture);
			} else if (element.detachEvent) {
				element.detachEvent('on' + event, listener);
			}
		};
	
		/**
		 * Triggers a public event.
		 * @todo Remove `status`, `relatedTarget` should be used instead.
		 * @protected
		 * @param {String} name - The event name.
		 * @param {*} [data=null] - The event data.
		 * @param {String} [namespace=carousel] - The event namespace.
		 * @param {String} [state] - The state which is associated with the event.
		 * @param {Boolean} [enter=false] - Indicates if the call enters the specified state or not.
		 * @returns {Event} - The event arguments.
		 */
		Owl.prototype.trigger = function(name, data, namespace, state, enter) {
			var status = {
				item: { count: this._items.length, index: this.current() }
			}, handler = $.camelCase(
				$.grep([ 'on', name, namespace ], function(v) { return v })
					.join('-').toLowerCase()
			), event = $.Event(
				[ name, 'owl', namespace || 'carousel' ].join('.').toLowerCase(),
				$.extend({ relatedTarget: this }, status, data)
			);
	
			if (!this._supress[name]) {
				$.each(this._plugins, function(name, plugin) {
					if (plugin.onTrigger) {
						plugin.onTrigger(event);
					}
				});
	
				this.register({ type: Owl.Type.Event, name: name });
				this.$element.trigger(event);
	
				if (this.settings && typeof this.settings[handler] === 'function') {
					this.settings[handler].call(this, event);
				}
			}
	
			return event;
		};
	
		/**
		 * Enters a state.
		 * @param name - The state name.
		 */
		Owl.prototype.enter = function(name) {
			$.each([ name ].concat(this._states.tags[name] || []), $.proxy(function(i, name) {
				if (this._states.current[name] === undefined) {
					this._states.current[name] = 0;
				}
	
				this._states.current[name]++;
			}, this));
		};
	
		/**
		 * Leaves a state.
		 * @param name - The state name.
		 */
		Owl.prototype.leave = function(name) {
			$.each([ name ].concat(this._states.tags[name] || []), $.proxy(function(i, name) {
				this._states.current[name]--;
			}, this));
		};
	
		/**
		 * Registers an event or state.
		 * @public
		 * @param {Object} object - The event or state to register.
		 */
		Owl.prototype.register = function(object) {
			if (object.type === Owl.Type.Event) {
				if (!$.event.special[object.name]) {
					$.event.special[object.name] = {};
				}
	
				if (!$.event.special[object.name].owl) {
					var _default = $.event.special[object.name]._default;
					$.event.special[object.name]._default = function(e) {
						if (_default && _default.apply && (!e.namespace || e.namespace.indexOf('owl') === -1)) {
							return _default.apply(this, arguments);
						}
						return e.namespace && e.namespace.indexOf('owl') > -1;
					};
					$.event.special[object.name].owl = true;
				}
			} else if (object.type === Owl.Type.State) {
				if (!this._states.tags[object.name]) {
					this._states.tags[object.name] = object.tags;
				} else {
					this._states.tags[object.name] = this._states.tags[object.name].concat(object.tags);
				}
	
				this._states.tags[object.name] = $.grep(this._states.tags[object.name], $.proxy(function(tag, i) {
					return $.inArray(tag, this._states.tags[object.name]) === i;
				}, this));
			}
		};
	
		/**
		 * Suppresses events.
		 * @protected
		 * @param {Array.<String>} events - The events to suppress.
		 */
		Owl.prototype.suppress = function(events) {
			$.each(events, $.proxy(function(index, event) {
				this._supress[event] = true;
			}, this));
		};
	
		/**
		 * Releases suppressed events.
		 * @protected
		 * @param {Array.<String>} events - The events to release.
		 */
		Owl.prototype.release = function(events) {
			$.each(events, $.proxy(function(index, event) {
				delete this._supress[event];
			}, this));
		};
	
		/**
		 * Gets unified pointer coordinates from event.
		 * @todo #261
		 * @protected
		 * @param {Event} - The `mousedown` or `touchstart` event.
		 * @returns {Object} - Contains `x` and `y` coordinates of current pointer position.
		 */
		Owl.prototype.pointer = function(event) {
			var result = { x: null, y: null };
	
			event = event.originalEvent || event || window.event;
	
			event = event.touches && event.touches.length ?
				event.touches[0] : event.changedTouches && event.changedTouches.length ?
					event.changedTouches[0] : event;
	
			if (event.pageX) {
				result.x = event.pageX;
				result.y = event.pageY;
			} else {
				result.x = event.clientX;
				result.y = event.clientY;
			}
	
			return result;
		};
	
		/**
		 * Determines if the input is a Number or something that can be coerced to a Number
		 * @protected
		 * @param {Number|String|Object|Array|Boolean|RegExp|Function|Symbol} - The input to be tested
		 * @returns {Boolean} - An indication if the input is a Number or can be coerced to a Number
		 */
		Owl.prototype.isNumeric = function(number) {
			return !isNaN(parseFloat(number));
		};
	
		/**
		 * Gets the difference of two vectors.
		 * @todo #261
		 * @protected
		 * @param {Object} - The first vector.
		 * @param {Object} - The second vector.
		 * @returns {Object} - The difference.
		 */
		Owl.prototype.difference = function(first, second) {
			return {
				x: first.x - second.x,
				y: first.y - second.y
			};
		};
	
		/**
		 * The jQuery Plugin for the Owl Carousel
		 * @todo Navigation plugin `next` and `prev`
		 * @public
		 */
		$.fn.owlCarousel = function(option) {
			var args = Array.prototype.slice.call(arguments, 1);
	
			return this.each(function() {
				var $this = $(this),
					data = $this.data('owl.carousel');
	
				if (!data) {
					data = new Owl(this, typeof option == 'object' && option);
					$this.data('owl.carousel', data);
	
					$.each([
						'next', 'prev', 'to', 'destroy', 'refresh', 'replace', 'add', 'remove'
					], function(i, event) {
						data.register({ type: Owl.Type.Event, name: event });
						data.$element.on(event + '.owl.carousel.core', $.proxy(function(e) {
							if (e.namespace && e.relatedTarget !== this) {
								this.suppress([ event ]);
								data[event].apply(this, [].slice.call(arguments, 1));
								this.release([ event ]);
							}
						}, data));
					});
				}
	
				if (typeof option == 'string' && option.charAt(0) !== '_') {
					data[option].apply(data, args);
				}
			});
		};
	
		/**
		 * The constructor for the jQuery Plugin
		 * @public
		 */
		$.fn.owlCarousel.Constructor = Owl;
	
	})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);
	
	/**
	 * AutoRefresh Plugin
	 * @version 2.3.4
	 * @author Artus Kolanowski
	 * @author David Deutsch
	 * @license The MIT License (MIT)
	 */
	;(function($, window, document, undefined) {
	
		/**
		 * Creates the auto refresh plugin.
		 * @class The Auto Refresh Plugin
		 * @param {Owl} carousel - The Owl Carousel
		 */
		var AutoRefresh = function(carousel) {
			/**
			 * Reference to the core.
			 * @protected
			 * @type {Owl}
			 */
			this._core = carousel;
	
			/**
			 * Refresh interval.
			 * @protected
			 * @type {number}
			 */
			this._interval = null;
	
			/**
			 * Whether the element is currently visible or not.
			 * @protected
			 * @type {Boolean}
			 */
			this._visible = null;
	
			/**
			 * All event handlers.
			 * @protected
			 * @type {Object}
			 */
			this._handlers = {
				'initialized.owl.carousel': $.proxy(function(e) {
					if (e.namespace && this._core.settings.autoRefresh) {
						this.watch();
					}
				}, this)
			};
	
			// set default options
			this._core.options = $.extend({}, AutoRefresh.Defaults, this._core.options);
	
			// register event handlers
			this._core.$element.on(this._handlers);
		};
	
		/**
		 * Default options.
		 * @public
		 */
		AutoRefresh.Defaults = {
			autoRefresh: true,
			autoRefreshInterval: 500
		};
	
		/**
		 * Watches the element.
		 */
		AutoRefresh.prototype.watch = function() {
			if (this._interval) {
				return;
			}
	
			this._visible = this._core.isVisible();
			this._interval = window.setInterval($.proxy(this.refresh, this), this._core.settings.autoRefreshInterval);
		};
	
		/**
		 * Refreshes the element.
		 */
		AutoRefresh.prototype.refresh = function() {
			if (this._core.isVisible() === this._visible) {
				return;
			}
	
			this._visible = !this._visible;
	
			this._core.$element.toggleClass('owl-hidden', !this._visible);
	
			this._visible && (this._core.invalidate('width') && this._core.refresh());
		};
	
		/**
		 * Destroys the plugin.
		 */
		AutoRefresh.prototype.destroy = function() {
			var handler, property;
	
			window.clearInterval(this._interval);
	
			for (handler in this._handlers) {
				this._core.$element.off(handler, this._handlers[handler]);
			}
			for (property in Object.getOwnPropertyNames(this)) {
				typeof this[property] != 'function' && (this[property] = null);
			}
		};
	
		$.fn.owlCarousel.Constructor.Plugins.AutoRefresh = AutoRefresh;
	
	})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);
	
	/**
	 * Lazy Plugin
	 * @version 2.3.4
	 * @author Bartosz Wojciechowski
	 * @author David Deutsch
	 * @license The MIT License (MIT)
	 */
	;(function($, window, document, undefined) {
	
		/**
		 * Creates the lazy plugin.
		 * @class The Lazy Plugin
		 * @param {Owl} carousel - The Owl Carousel
		 */
		var Lazy = function(carousel) {
	
			/**
			 * Reference to the core.
			 * @protected
			 * @type {Owl}
			 */
			this._core = carousel;
	
			/**
			 * Already loaded items.
			 * @protected
			 * @type {Array.<jQuery>}
			 */
			this._loaded = [];
	
			/**
			 * Event handlers.
			 * @protected
			 * @type {Object}
			 */
			this._handlers = {
				'initialized.owl.carousel change.owl.carousel resized.owl.carousel': $.proxy(function(e) {
					if (!e.namespace) {
						return;
					}
	
					if (!this._core.settings || !this._core.settings.lazyLoad) {
						return;
					}
	
					if ((e.property && e.property.name == 'position') || e.type == 'initialized') {
						var settings = this._core.settings,
							n = (settings.center && Math.ceil(settings.items / 2) || settings.items),
							i = ((settings.center && n * -1) || 0),
							position = (e.property && e.property.value !== undefined ? e.property.value : this._core.current()) + i,
							clones = this._core.clones().length,
							load = $.proxy(function(i, v) { this.load(v) }, this);
						//TODO: Need documentation for this new option
						if (settings.lazyLoadEager > 0) {
							n += settings.lazyLoadEager;
							// If the carousel is looping also preload images that are to the "left"
							if (settings.loop) {
	              position -= settings.lazyLoadEager;
	              n++;
	            }
						}
	
						while (i++ < n) {
							this.load(clones / 2 + this._core.relative(position));
							clones && $.each(this._core.clones(this._core.relative(position)), load);
							position++;
						}
					}
				}, this)
			};
	
			// set the default options
			this._core.options = $.extend({}, Lazy.Defaults, this._core.options);
	
			// register event handler
			this._core.$element.on(this._handlers);
		};
	
		/**
		 * Default options.
		 * @public
		 */
		Lazy.Defaults = {
			lazyLoad: false,
			lazyLoadEager: 0
		};
	
		/**
		 * Loads all resources of an item at the specified position.
		 * @param {Number} position - The absolute position of the item.
		 * @protected
		 */
		Lazy.prototype.load = function(position) {
			var $item = this._core.$stage.children().eq(position),
				$elements = $item && $item.find('.owl-lazy');
	
			if (!$elements || $.inArray($item.get(0), this._loaded) > -1) {
				return;
			}
	
			$elements.each($.proxy(function(index, element) {
				var $element = $(element), image,
	                url = (window.devicePixelRatio > 1 && $element.attr('data-src-retina')) || $element.attr('data-src') || $element.attr('data-srcset');
	
				this._core.trigger('load', { element: $element, url: url }, 'lazy');
	
				if ($element.is('img')) {
					$element.one('load.owl.lazy', $.proxy(function() {
						$element.css('opacity', 1);
						this._core.trigger('loaded', { element: $element, url: url }, 'lazy');
					}, this)).attr('src', url);
	            } else if ($element.is('source')) {
	                $element.one('load.owl.lazy', $.proxy(function() {
	                    this._core.trigger('loaded', { element: $element, url: url }, 'lazy');
	                }, this)).attr('srcset', url);
				} else {
					image = new Image();
					image.onload = $.proxy(function() {
						$element.css({
							'background-image': 'url("' + url + '")',
							'opacity': '1'
						});
						this._core.trigger('loaded', { element: $element, url: url }, 'lazy');
					}, this);
					image.src = url;
				}
			}, this));
	
			this._loaded.push($item.get(0));
		};
	
		/**
		 * Destroys the plugin.
		 * @public
		 */
		Lazy.prototype.destroy = function() {
			var handler, property;
	
			for (handler in this.handlers) {
				this._core.$element.off(handler, this.handlers[handler]);
			}
			for (property in Object.getOwnPropertyNames(this)) {
				typeof this[property] != 'function' && (this[property] = null);
			}
		};
	
		$.fn.owlCarousel.Constructor.Plugins.Lazy = Lazy;
	
	})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);
	
	/**
	 * AutoHeight Plugin
	 * @version 2.3.4
	 * @author Bartosz Wojciechowski
	 * @author David Deutsch
	 * @license The MIT License (MIT)
	 */
	;(function($, window, document, undefined) {
	
		/**
		 * Creates the auto height plugin.
		 * @class The Auto Height Plugin
		 * @param {Owl} carousel - The Owl Carousel
		 */
		var AutoHeight = function(carousel) {
			/**
			 * Reference to the core.
			 * @protected
			 * @type {Owl}
			 */
			this._core = carousel;
	
			this._previousHeight = null;
	
			/**
			 * All event handlers.
			 * @protected
			 * @type {Object}
			 */
			this._handlers = {
				'initialized.owl.carousel refreshed.owl.carousel': $.proxy(function(e) {
					if (e.namespace && this._core.settings.autoHeight) {
						this.update();
					}
				}, this),
				'changed.owl.carousel': $.proxy(function(e) {
					if (e.namespace && this._core.settings.autoHeight && e.property.name === 'position'){
						this.update();
					}
				}, this),
				'loaded.owl.lazy': $.proxy(function(e) {
					if (e.namespace && this._core.settings.autoHeight
						&& e.element.closest('.' + this._core.settings.itemClass).index() === this._core.current()) {
						this.update();
					}
				}, this)
			};
	
			// set default options
			this._core.options = $.extend({}, AutoHeight.Defaults, this._core.options);
	
			// register event handlers
			this._core.$element.on(this._handlers);
			this._intervalId = null;
			var refThis = this;
	
			// These changes have been taken from a PR by gavrochelegnou proposed in #1575
			// and have been made compatible with the latest jQuery version
			$(window).on('load', function() {
				if (refThis._core.settings.autoHeight) {
					refThis.update();
				}
			});
	
			// Autoresize the height of the carousel when window is resized
			// When carousel has images, the height is dependent on the width
			// and should also change on resize
			$(window).resize(function() {
				if (refThis._core.settings.autoHeight) {
					if (refThis._intervalId != null) {
						clearTimeout(refThis._intervalId);
					}
	
					refThis._intervalId = setTimeout(function() {
						refThis.update();
					}, 250);
				}
			});
	
		};
	
		/**
		 * Default options.
		 * @public
		 */
		AutoHeight.Defaults = {
			autoHeight: false,
			autoHeightClass: 'owl-height'
		};
	
		/**
		 * Updates the view.
		 */
		AutoHeight.prototype.update = function() {
			var start = this._core._current,
				end = start + this._core.settings.items,
				lazyLoadEnabled = this._core.settings.lazyLoad,
				visible = this._core.$stage.children().toArray().slice(start, end),
				heights = [],
				maxheight = 0;
	
			$.each(visible, function(index, item) {
				heights.push($(item).height());
			});
	
			maxheight = Math.max.apply(null, heights);
	
			if (maxheight <= 1 && lazyLoadEnabled && this._previousHeight) {
				maxheight = this._previousHeight;
			}
	
			this._previousHeight = maxheight;
	
			this._core.$stage.parent()
				.height(maxheight)
				.addClass(this._core.settings.autoHeightClass);
		};
	
		AutoHeight.prototype.destroy = function() {
			var handler, property;
	
			for (handler in this._handlers) {
				this._core.$element.off(handler, this._handlers[handler]);
			}
			for (property in Object.getOwnPropertyNames(this)) {
				typeof this[property] !== 'function' && (this[property] = null);
			}
		};
	
		$.fn.owlCarousel.Constructor.Plugins.AutoHeight = AutoHeight;
	
	})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);
	
	/**
	 * Video Plugin
	 * @version 2.3.4
	 * @author Bartosz Wojciechowski
	 * @author David Deutsch
	 * @license The MIT License (MIT)
	 */
	;(function($, window, document, undefined) {
	
		/**
		 * Creates the video plugin.
		 * @class The Video Plugin
		 * @param {Owl} carousel - The Owl Carousel
		 */
		var Video = function(carousel) {
			/**
			 * Reference to the core.
			 * @protected
			 * @type {Owl}
			 */
			this._core = carousel;
	
			/**
			 * Cache all video URLs.
			 * @protected
			 * @type {Object}
			 */
			this._videos = {};
	
			/**
			 * Current playing item.
			 * @protected
			 * @type {jQuery}
			 */
			this._playing = null;
	
			/**
			 * All event handlers.
			 * @todo The cloned content removale is too late
			 * @protected
			 * @type {Object}
			 */
			this._handlers = {
				'initialized.owl.carousel': $.proxy(function(e) {
					if (e.namespace) {
						this._core.register({ type: 'state', name: 'playing', tags: [ 'interacting' ] });
					}
				}, this),
				'resize.owl.carousel': $.proxy(function(e) {
					if (e.namespace && this._core.settings.video && this.isInFullScreen()) {
						e.preventDefault();
					}
				}, this),
				'refreshed.owl.carousel': $.proxy(function(e) {
					if (e.namespace && this._core.is('resizing')) {
						this._core.$stage.find('.cloned .owl-video-frame').remove();
					}
				}, this),
				'changed.owl.carousel': $.proxy(function(e) {
					if (e.namespace && e.property.name === 'position' && this._playing) {
						this.stop();
					}
				}, this),
				'prepared.owl.carousel': $.proxy(function(e) {
					if (!e.namespace) {
						return;
					}
	
					var $element = $(e.content).find('.owl-video');
	
					if ($element.length) {
						$element.css('display', 'none');
						this.fetch($element, $(e.content));
					}
				}, this)
			};
	
			// set default options
			this._core.options = $.extend({}, Video.Defaults, this._core.options);
	
			// register event handlers
			this._core.$element.on(this._handlers);
	
			this._core.$element.on('click.owl.video', '.owl-video-play-icon', $.proxy(function(e) {
				this.play(e);
			}, this));
		};
	
		/**
		 * Default options.
		 * @public
		 */
		Video.Defaults = {
			video: false,
			videoHeight: false,
			videoWidth: false
		};
	
		/**
		 * Gets the video ID and the type (YouTube/Vimeo/vzaar only).
		 * @protected
		 * @param {jQuery} target - The target containing the video data.
		 * @param {jQuery} item - The item containing the video.
		 */
		Video.prototype.fetch = function(target, item) {
				var type = (function() {
						if (target.attr('data-vimeo-id')) {
							return 'vimeo';
						} else if (target.attr('data-vzaar-id')) {
							return 'vzaar'
						} else {
							return 'youtube';
						}
					})(),
					id = target.attr('data-vimeo-id') || target.attr('data-youtube-id') || target.attr('data-vzaar-id'),
					width = target.attr('data-width') || this._core.settings.videoWidth,
					height = target.attr('data-height') || this._core.settings.videoHeight,
					url = target.attr('href');
	
			if (url) {
	
				/*
						Parses the id's out of the following urls (and probably more):
						https://www.youtube.com/watch?v=:id
						https://youtu.be/:id
						https://vimeo.com/:id
						https://vimeo.com/channels/:channel/:id
						https://vimeo.com/groups/:group/videos/:id
						https://app.vzaar.com/videos/:id
	
						Visual example: https://regexper.com/#(http%3A%7Chttps%3A%7C)%5C%2F%5C%2F(player.%7Cwww.%7Capp.)%3F(vimeo%5C.com%7Cyoutu(be%5C.com%7C%5C.be%7Cbe%5C.googleapis%5C.com)%7Cvzaar%5C.com)%5C%2F(video%5C%2F%7Cvideos%5C%2F%7Cembed%5C%2F%7Cchannels%5C%2F.%2B%5C%2F%7Cgroups%5C%2F.%2B%5C%2F%7Cwatch%5C%3Fv%3D%7Cv%5C%2F)%3F(%5BA-Za-z0-9._%25-%5D*)(%5C%26%5CS%2B)%3F
				*/
	
				id = url.match(/(http:|https:|)\/\/(player.|www.|app.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com|be\-nocookie\.com)|vzaar\.com)\/(video\/|videos\/|embed\/|channels\/.+\/|groups\/.+\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/);
	
				if (id[3].indexOf('youtu') > -1) {
					type = 'youtube';
				} else if (id[3].indexOf('vimeo') > -1) {
					type = 'vimeo';
				} else if (id[3].indexOf('vzaar') > -1) {
					type = 'vzaar';
				} else {
					throw new Error('Video URL not supported.');
				}
				id = id[6];
			} else {
				throw new Error('Missing video URL.');
			}
	
			this._videos[url] = {
				type: type,
				id: id,
				width: width,
				height: height
			};
	
			item.attr('data-video', url);
	
			this.thumbnail(target, this._videos[url]);
		};
	
		/**
		 * Creates video thumbnail.
		 * @protected
		 * @param {jQuery} target - The target containing the video data.
		 * @param {Object} info - The video info object.
		 * @see `fetch`
		 */
		Video.prototype.thumbnail = function(target, video) {
			var tnLink,
				icon,
				path,
				dimensions = video.width && video.height ? 'width:' + video.width + 'px;height:' + video.height + 'px;' : '',
				customTn = target.find('img'),
				srcType = 'src',
				lazyClass = '',
				settings = this._core.settings,
				create = function(path) {
					icon = '<div class="owl-video-play-icon"></div>';
	
					if (settings.lazyLoad) {
						tnLink = $('<div/>',{
							"class": 'owl-video-tn ' + lazyClass,
							"srcType": path
						});
					} else {
						tnLink = $( '<div/>', {
							"class": "owl-video-tn",
							"style": 'opacity:1;background-image:url(' + path + ')'
						});
					}
					target.after(tnLink);
					target.after(icon);
				};
	
			// wrap video content into owl-video-wrapper div
			target.wrap( $( '<div/>', {
				"class": "owl-video-wrapper",
				"style": dimensions
			}));
	
			if (this._core.settings.lazyLoad) {
				srcType = 'data-src';
				lazyClass = 'owl-lazy';
			}
	
			// custom thumbnail
			if (customTn.length) {
				create(customTn.attr(srcType));
				customTn.remove();
				return false;
			}
	
			if (video.type === 'youtube') {
				path = "//img.youtube.com/vi/" + video.id + "/hqdefault.jpg";
				create(path);
			} else if (video.type === 'vimeo') {
				$.ajax({
					type: 'GET',
					url: '//vimeo.com/api/v2/video/' + video.id + '.json',
					jsonp: 'callback',
					dataType: 'jsonp',
					success: function(data) {
						path = data[0].thumbnail_large;
						create(path);
					}
				});
			} else if (video.type === 'vzaar') {
				$.ajax({
					type: 'GET',
					url: '//vzaar.com/api/videos/' + video.id + '.json',
					jsonp: 'callback',
					dataType: 'jsonp',
					success: function(data) {
						path = data.framegrab_url;
						create(path);
					}
				});
			}
		};
	
		/**
		 * Stops the current video.
		 * @public
		 */
		Video.prototype.stop = function() {
			this._core.trigger('stop', null, 'video');
			this._playing.find('.owl-video-frame').remove();
			this._playing.removeClass('owl-video-playing');
			this._playing = null;
			this._core.leave('playing');
			this._core.trigger('stopped', null, 'video');
		};
	
		/**
		 * Starts the current video.
		 * @public
		 * @param {Event} event - The event arguments.
		 */
		Video.prototype.play = function(event) {
			var target = $(event.target),
				item = target.closest('.' + this._core.settings.itemClass),
				video = this._videos[item.attr('data-video')],
				width = video.width || '100%',
				height = video.height || this._core.$stage.height(),
				html,
				iframe;
	
			if (this._playing) {
				return;
			}
	
			this._core.enter('playing');
			this._core.trigger('play', null, 'video');
	
			item = this._core.items(this._core.relative(item.index()));
	
			this._core.reset(item.index());
	
			html = $( '<iframe frameborder="0" allowfullscreen mozallowfullscreen webkitAllowFullScreen ></iframe>' );
			html.attr( 'height', height );
			html.attr( 'width', width );
			if (video.type === 'youtube') {
				html.attr( 'src', '//www.youtube.com/embed/' + video.id + '?autoplay=1&rel=0&v=' + video.id );
			} else if (video.type === 'vimeo') {
				html.attr( 'src', '//player.vimeo.com/video/' + video.id + '?autoplay=1' );
			} else if (video.type === 'vzaar') {
				html.attr( 'src', '//view.vzaar.com/' + video.id + '/player?autoplay=true' );
			}
	
			iframe = $(html).wrap( '<div class="owl-video-frame" />' ).insertAfter(item.find('.owl-video'));
	
			this._playing = item.addClass('owl-video-playing');
		};
	
		/**
		 * Checks whether an video is currently in full screen mode or not.
		 * @todo Bad style because looks like a readonly method but changes members.
		 * @protected
		 * @returns {Boolean}
		 */
		Video.prototype.isInFullScreen = function() {
			var element = document.fullscreenElement || document.mozFullScreenElement ||
					document.webkitFullscreenElement;
	
			return element && $(element).parent().hasClass('owl-video-frame');
		};
	
		/**
		 * Destroys the plugin.
		 */
		Video.prototype.destroy = function() {
			var handler, property;
	
			this._core.$element.off('click.owl.video');
	
			for (handler in this._handlers) {
				this._core.$element.off(handler, this._handlers[handler]);
			}
			for (property in Object.getOwnPropertyNames(this)) {
				typeof this[property] != 'function' && (this[property] = null);
			}
		};
	
		$.fn.owlCarousel.Constructor.Plugins.Video = Video;
	
	})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);
	
	/**
	 * Animate Plugin
	 * @version 2.3.4
	 * @author Bartosz Wojciechowski
	 * @author David Deutsch
	 * @license The MIT License (MIT)
	 */
	;(function($, window, document, undefined) {
	
		/**
		 * Creates the animate plugin.
		 * @class The Navigation Plugin
		 * @param {Owl} scope - The Owl Carousel
		 */
		var Animate = function(scope) {
			this.core = scope;
			this.core.options = $.extend({}, Animate.Defaults, this.core.options);
			this.swapping = true;
			this.previous = undefined;
			this.next = undefined;
	
			this.handlers = {
				'change.owl.carousel': $.proxy(function(e) {
					if (e.namespace && e.property.name == 'position') {
						this.previous = this.core.current();
						this.next = e.property.value;
					}
				}, this),
				'drag.owl.carousel dragged.owl.carousel translated.owl.carousel': $.proxy(function(e) {
					if (e.namespace) {
						this.swapping = e.type == 'translated';
					}
				}, this),
				'translate.owl.carousel': $.proxy(function(e) {
					if (e.namespace && this.swapping && (this.core.options.animateOut || this.core.options.animateIn)) {
						this.swap();
					}
				}, this)
			};
	
			this.core.$element.on(this.handlers);
		};
	
		/**
		 * Default options.
		 * @public
		 */
		Animate.Defaults = {
			animateOut: false,
			animateIn: false
		};
	
		/**
		 * Toggles the animation classes whenever an translations starts.
		 * @protected
		 * @returns {Boolean|undefined}
		 */
		Animate.prototype.swap = function() {
	
			if (this.core.settings.items !== 1) {
				return;
			}
	
			if (!$.support.animation || !$.support.transition) {
				return;
			}
	
			this.core.speed(0);
	
			var left,
				clear = $.proxy(this.clear, this),
				previous = this.core.$stage.children().eq(this.previous),
				next = this.core.$stage.children().eq(this.next),
				incoming = this.core.settings.animateIn,
				outgoing = this.core.settings.animateOut;
	
			if (this.core.current() === this.previous) {
				return;
			}
	
			if (outgoing) {
				left = this.core.coordinates(this.previous) - this.core.coordinates(this.next);
				previous.one($.support.animation.end, clear)
					.css( { 'left': left + 'px' } )
					.addClass('animated owl-animated-out')
					.addClass(outgoing);
			}
	
			if (incoming) {
				next.one($.support.animation.end, clear)
					.addClass('animated owl-animated-in')
					.addClass(incoming);
			}
		};
	
		Animate.prototype.clear = function(e) {
			$(e.target).css( { 'left': '' } )
				.removeClass('animated owl-animated-out owl-animated-in')
				.removeClass(this.core.settings.animateIn)
				.removeClass(this.core.settings.animateOut);
			this.core.onTransitionEnd();
		};
	
		/**
		 * Destroys the plugin.
		 * @public
		 */
		Animate.prototype.destroy = function() {
			var handler, property;
	
			for (handler in this.handlers) {
				this.core.$element.off(handler, this.handlers[handler]);
			}
			for (property in Object.getOwnPropertyNames(this)) {
				typeof this[property] != 'function' && (this[property] = null);
			}
		};
	
		$.fn.owlCarousel.Constructor.Plugins.Animate = Animate;
	
	})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);
	
	/**
	 * Autoplay Plugin
	 * @version 2.3.4
	 * @author Bartosz Wojciechowski
	 * @author Artus Kolanowski
	 * @author David Deutsch
	 * @author Tom De Caluwé
	 * @license The MIT License (MIT)
	 */
	;(function($, window, document, undefined) {
	
		/**
		 * Creates the autoplay plugin.
		 * @class The Autoplay Plugin
		 * @param {Owl} scope - The Owl Carousel
		 */
		var Autoplay = function(carousel) {
			/**
			 * Reference to the core.
			 * @protected
			 * @type {Owl}
			 */
			this._core = carousel;
	
			/**
			 * The autoplay timeout id.
			 * @type {Number}
			 */
			this._call = null;
	
			/**
			 * Depending on the state of the plugin, this variable contains either
			 * the start time of the timer or the current timer value if it's
			 * paused. Since we start in a paused state we initialize the timer
			 * value.
			 * @type {Number}
			 */
			this._time = 0;
	
			/**
			 * Stores the timeout currently used.
			 * @type {Number}
			 */
			this._timeout = 0;
	
			/**
			 * Indicates whenever the autoplay is paused.
			 * @type {Boolean}
			 */
			this._paused = true;
	
			/**
			 * All event handlers.
			 * @protected
			 * @type {Object}
			 */
			this._handlers = {
				'changed.owl.carousel': $.proxy(function(e) {
					if (e.namespace && e.property.name === 'settings') {
						if (this._core.settings.autoplay) {
							this.play();
						} else {
							this.stop();
						}
					} else if (e.namespace && e.property.name === 'position' && this._paused) {
						// Reset the timer. This code is triggered when the position
						// of the carousel was changed through user interaction.
						this._time = 0;
					}
				}, this),
				'initialized.owl.carousel': $.proxy(function(e) {
					if (e.namespace && this._core.settings.autoplay) {
						this.play();
					}
				}, this),
				'play.owl.autoplay': $.proxy(function(e, t, s) {
					if (e.namespace) {
						this.play(t, s);
					}
				}, this),
				'stop.owl.autoplay': $.proxy(function(e) {
					if (e.namespace) {
						this.stop();
					}
				}, this),
				'mouseover.owl.autoplay': $.proxy(function() {
					if (this._core.settings.autoplayHoverPause && this._core.is('rotating')) {
						this.pause();
					}
				}, this),
				'mouseleave.owl.autoplay': $.proxy(function() {
					if (this._core.settings.autoplayHoverPause && this._core.is('rotating')) {
						this.play();
					}
				}, this),
				'touchstart.owl.core': $.proxy(function() {
					if (this._core.settings.autoplayHoverPause && this._core.is('rotating')) {
						this.pause();
					}
				}, this),
				'touchend.owl.core': $.proxy(function() {
					if (this._core.settings.autoplayHoverPause) {
						this.play();
					}
				}, this)
			};
	
			// register event handlers
			this._core.$element.on(this._handlers);
	
			// set default options
			this._core.options = $.extend({}, Autoplay.Defaults, this._core.options);
		};
	
		/**
		 * Default options.
		 * @public
		 */
		Autoplay.Defaults = {
			autoplay: false,
			autoplayTimeout: 5000,
			autoplayHoverPause: false,
			autoplaySpeed: false
		};
	
		/**
		 * Transition to the next slide and set a timeout for the next transition.
		 * @private
		 * @param {Number} [speed] - The animation speed for the animations.
		 */
		Autoplay.prototype._next = function(speed) {
			this._call = window.setTimeout(
				$.proxy(this._next, this, speed),
				this._timeout * (Math.round(this.read() / this._timeout) + 1) - this.read()
			);
	
			if (this._core.is('interacting') || document.hidden) {
				return;
			}
			this._core.next(speed || this._core.settings.autoplaySpeed);
		}
	
		/**
		 * Reads the current timer value when the timer is playing.
		 * @public
		 */
		Autoplay.prototype.read = function() {
			return new Date().getTime() - this._time;
		};
	
		/**
		 * Starts the autoplay.
		 * @public
		 * @param {Number} [timeout] - The interval before the next animation starts.
		 * @param {Number} [speed] - The animation speed for the animations.
		 */
		Autoplay.prototype.play = function(timeout, speed) {
			var elapsed;
	
			if (!this._core.is('rotating')) {
				this._core.enter('rotating');
			}
	
			timeout = timeout || this._core.settings.autoplayTimeout;
	
			// Calculate the elapsed time since the last transition. If the carousel
			// wasn't playing this calculation will yield zero.
			elapsed = Math.min(this._time % (this._timeout || timeout), timeout);
	
			if (this._paused) {
				// Start the clock.
				this._time = this.read();
				this._paused = false;
			} else {
				// Clear the active timeout to allow replacement.
				window.clearTimeout(this._call);
			}
	
			// Adjust the origin of the timer to match the new timeout value.
			this._time += this.read() % timeout - elapsed;
	
			this._timeout = timeout;
			this._call = window.setTimeout($.proxy(this._next, this, speed), timeout - elapsed);
		};
	
		/**
		 * Stops the autoplay.
		 * @public
		 */
		Autoplay.prototype.stop = function() {
			if (this._core.is('rotating')) {
				// Reset the clock.
				this._time = 0;
				this._paused = true;
	
				window.clearTimeout(this._call);
				this._core.leave('rotating');
			}
		};
	
		/**
		 * Pauses the autoplay.
		 * @public
		 */
		Autoplay.prototype.pause = function() {
			if (this._core.is('rotating') && !this._paused) {
				// Pause the clock.
				this._time = this.read();
				this._paused = true;
	
				window.clearTimeout(this._call);
			}
		};
	
		/**
		 * Destroys the plugin.
		 */
		Autoplay.prototype.destroy = function() {
			var handler, property;
	
			this.stop();
	
			for (handler in this._handlers) {
				this._core.$element.off(handler, this._handlers[handler]);
			}
			for (property in Object.getOwnPropertyNames(this)) {
				typeof this[property] != 'function' && (this[property] = null);
			}
		};
	
		$.fn.owlCarousel.Constructor.Plugins.autoplay = Autoplay;
	
	})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);
	
	/**
	 * Navigation Plugin
	 * @version 2.3.4
	 * @author Artus Kolanowski
	 * @author David Deutsch
	 * @license The MIT License (MIT)
	 */
	;(function($, window, document, undefined) {
		'use strict';
	
		/**
		 * Creates the navigation plugin.
		 * @class The Navigation Plugin
		 * @param {Owl} carousel - The Owl Carousel.
		 */
		var Navigation = function(carousel) {
			/**
			 * Reference to the core.
			 * @protected
			 * @type {Owl}
			 */
			this._core = carousel;
	
			/**
			 * Indicates whether the plugin is initialized or not.
			 * @protected
			 * @type {Boolean}
			 */
			this._initialized = false;
	
			/**
			 * The current paging indexes.
			 * @protected
			 * @type {Array}
			 */
			this._pages = [];
	
			/**
			 * All DOM elements of the user interface.
			 * @protected
			 * @type {Object}
			 */
			this._controls = {};
	
			/**
			 * Markup for an indicator.
			 * @protected
			 * @type {Array.<String>}
			 */
			this._templates = [];
	
			/**
			 * The carousel element.
			 * @type {jQuery}
			 */
			this.$element = this._core.$element;
	
			/**
			 * Overridden methods of the carousel.
			 * @protected
			 * @type {Object}
			 */
			this._overrides = {
				next: this._core.next,
				prev: this._core.prev,
				to: this._core.to
			};
	
			/**
			 * All event handlers.
			 * @protected
			 * @type {Object}
			 */
			this._handlers = {
				'prepared.owl.carousel': $.proxy(function(e) {
					if (e.namespace && this._core.settings.dotsData) {
						this._templates.push('<div class="' + this._core.settings.dotClass + '">' +
							$(e.content).find('[data-dot]').addBack('[data-dot]').attr('data-dot') + '</div>');
					}
				}, this),
				'added.owl.carousel': $.proxy(function(e) {
					if (e.namespace && this._core.settings.dotsData) {
						this._templates.splice(e.position, 0, this._templates.pop());
					}
				}, this),
				'remove.owl.carousel': $.proxy(function(e) {
					if (e.namespace && this._core.settings.dotsData) {
						this._templates.splice(e.position, 1);
					}
				}, this),
				'changed.owl.carousel': $.proxy(function(e) {
					if (e.namespace && e.property.name == 'position') {
						this.draw();
					}
				}, this),
				'initialized.owl.carousel': $.proxy(function(e) {
					if (e.namespace && !this._initialized) {
						this._core.trigger('initialize', null, 'navigation');
						this.initialize();
						this.update();
						this.draw();
						this._initialized = true;
						this._core.trigger('initialized', null, 'navigation');
					}
				}, this),
				'refreshed.owl.carousel': $.proxy(function(e) {
					if (e.namespace && this._initialized) {
						this._core.trigger('refresh', null, 'navigation');
						this.update();
						this.draw();
						this._core.trigger('refreshed', null, 'navigation');
					}
				}, this)
			};
	
			// set default options
			this._core.options = $.extend({}, Navigation.Defaults, this._core.options);
	
			// register event handlers
			this.$element.on(this._handlers);
		};
	
		/**
		 * Default options.
		 * @public
		 * @todo Rename `slideBy` to `navBy`
		 */
		Navigation.Defaults = {
			nav: false,
			navText: [
				'<span aria-label="' + 'Previous' + '">&#x2039;</span>',
				'<span aria-label="' + 'Next' + '">&#x203a;</span>'
			],
			navSpeed: false,
			navElement: 'button type="button" role="presentation"',
			navContainer: false,
			navContainerClass: 'owl-nav',
			navClass: [
				'owl-prev',
				'owl-next'
			],
			slideBy: 1,
			dotClass: 'owl-dot',
			dotsClass: 'owl-dots',
			dots: true,
			dotsEach: false,
			dotsData: false,
			dotsSpeed: false,
			dotsContainer: false
		};
	
		/**
		 * Initializes the layout of the plugin and extends the carousel.
		 * @protected
		 */
		Navigation.prototype.initialize = function() {
			var override,
				settings = this._core.settings;
	
			// create DOM structure for relative navigation
			this._controls.$relative = (settings.navContainer ? $(settings.navContainer)
				: $('<div>').addClass(settings.navContainerClass).appendTo(this.$element)).addClass('disabled');
	
			this._controls.$previous = $('<' + settings.navElement + '>')
				.addClass(settings.navClass[0])
				.html(settings.navText[0])
				.prependTo(this._controls.$relative)
				.on('click', $.proxy(function(e) {
					this.prev(settings.navSpeed);
				}, this));
			this._controls.$next = $('<' + settings.navElement + '>')
				.addClass(settings.navClass[1])
				.html(settings.navText[1])
				.appendTo(this._controls.$relative)
				.on('click', $.proxy(function(e) {
					this.next(settings.navSpeed);
				}, this));
	
			// create DOM structure for absolute navigation
			if (!settings.dotsData) {
				this._templates = [ $('<button role="button">')
					.addClass(settings.dotClass)
					.append($('<span>'))
					.prop('outerHTML') ];
			}
	
			this._controls.$absolute = (settings.dotsContainer ? $(settings.dotsContainer)
				: $('<div>').addClass(settings.dotsClass).appendTo(this.$element)).addClass('disabled');
	
			this._controls.$absolute.on('click', 'button', $.proxy(function(e) {
				var index = $(e.target).parent().is(this._controls.$absolute)
					? $(e.target).index() : $(e.target).parent().index();
	
				e.preventDefault();
	
				this.to(index, settings.dotsSpeed);
			}, this));
	
			/*$el.on('focusin', function() {
				$(document).off(".carousel");
	
				$(document).on('keydown.carousel', function(e) {
					if(e.keyCode == 37) {
						$el.trigger('prev.owl')
					}
					if(e.keyCode == 39) {
						$el.trigger('next.owl')
					}
				});
			});*/
	
			// override public methods of the carousel
			for (override in this._overrides) {
				this._core[override] = $.proxy(this[override], this);
			}
		};
	
		/**
		 * Destroys the plugin.
		 * @protected
		 */
		Navigation.prototype.destroy = function() {
			var handler, control, property, override, settings;
			settings = this._core.settings;
	
			for (handler in this._handlers) {
				this.$element.off(handler, this._handlers[handler]);
			}
			for (control in this._controls) {
				if (control === '$relative' && settings.navContainer) {
					this._controls[control].html('');
				} else {
					this._controls[control].remove();
				}
			}
			for (override in this.overides) {
				this._core[override] = this._overrides[override];
			}
			for (property in Object.getOwnPropertyNames(this)) {
				typeof this[property] != 'function' && (this[property] = null);
			}
		};
	
		/**
		 * Updates the internal state.
		 * @protected
		 */
		Navigation.prototype.update = function() {
			var i, j, k,
				lower = this._core.clones().length / 2,
				upper = lower + this._core.items().length,
				maximum = this._core.maximum(true),
				settings = this._core.settings,
				size = settings.center || settings.autoWidth || settings.dotsData
					? 1 : settings.dotsEach || settings.items;
	
			if (settings.slideBy !== 'page') {
				settings.slideBy = Math.min(settings.slideBy, settings.items);
			}
	
			if (settings.dots || settings.slideBy == 'page') {
				this._pages = [];
	
				for (i = lower, j = 0, k = 0; i < upper; i++) {
					if (j >= size || j === 0) {
						this._pages.push({
							start: Math.min(maximum, i - lower),
							end: i - lower + size - 1
						});
						if (Math.min(maximum, i - lower) === maximum) {
							break;
						}
						j = 0, ++k;
					}
					j += this._core.mergers(this._core.relative(i));
				}
			}
		};
	
		/**
		 * Draws the user interface.
		 * @todo The option `dotsData` wont work.
		 * @protected
		 */
		Navigation.prototype.draw = function() {
			var difference,
				settings = this._core.settings,
				disabled = this._core.items().length <= settings.items,
				index = this._core.relative(this._core.current()),
				loop = settings.loop || settings.rewind;
	
			this._controls.$relative.toggleClass('disabled', !settings.nav || disabled);
	
			if (settings.nav) {
				this._controls.$previous.toggleClass('disabled', !loop && index <= this._core.minimum(true));
				this._controls.$next.toggleClass('disabled', !loop && index >= this._core.maximum(true));
			}
	
			this._controls.$absolute.toggleClass('disabled', !settings.dots || disabled);
	
			if (settings.dots) {
				difference = this._pages.length - this._controls.$absolute.children().length;
	
				if (settings.dotsData && difference !== 0) {
					this._controls.$absolute.html(this._templates.join(''));
				} else if (difference > 0) {
					this._controls.$absolute.append(new Array(difference + 1).join(this._templates[0]));
				} else if (difference < 0) {
					this._controls.$absolute.children().slice(difference).remove();
				}
	
				this._controls.$absolute.find('.active').removeClass('active');
				this._controls.$absolute.children().eq($.inArray(this.current(), this._pages)).addClass('active');
			}
		};
	
		/**
		 * Extends event data.
		 * @protected
		 * @param {Event} event - The event object which gets thrown.
		 */
		Navigation.prototype.onTrigger = function(event) {
			var settings = this._core.settings;
	
			event.page = {
				index: $.inArray(this.current(), this._pages),
				count: this._pages.length,
				size: settings && (settings.center || settings.autoWidth || settings.dotsData
					? 1 : settings.dotsEach || settings.items)
			};
		};
	
		/**
		 * Gets the current page position of the carousel.
		 * @protected
		 * @returns {Number}
		 */
		Navigation.prototype.current = function() {
			var current = this._core.relative(this._core.current());
			return $.grep(this._pages, $.proxy(function(page, index) {
				return page.start <= current && page.end >= current;
			}, this)).pop();
		};
	
		/**
		 * Gets the current succesor/predecessor position.
		 * @protected
		 * @returns {Number}
		 */
		Navigation.prototype.getPosition = function(successor) {
			var position, length,
				settings = this._core.settings;
	
			if (settings.slideBy == 'page') {
				position = $.inArray(this.current(), this._pages);
				length = this._pages.length;
				successor ? ++position : --position;
				position = this._pages[((position % length) + length) % length].start;
			} else {
				position = this._core.relative(this._core.current());
				length = this._core.items().length;
				successor ? position += settings.slideBy : position -= settings.slideBy;
			}
	
			return position;
		};
	
		/**
		 * Slides to the next item or page.
		 * @public
		 * @param {Number} [speed=false] - The time in milliseconds for the transition.
		 */
		Navigation.prototype.next = function(speed) {
			$.proxy(this._overrides.to, this._core)(this.getPosition(true), speed);
		};
	
		/**
		 * Slides to the previous item or page.
		 * @public
		 * @param {Number} [speed=false] - The time in milliseconds for the transition.
		 */
		Navigation.prototype.prev = function(speed) {
			$.proxy(this._overrides.to, this._core)(this.getPosition(false), speed);
		};
	
		/**
		 * Slides to the specified item or page.
		 * @public
		 * @param {Number} position - The position of the item or page.
		 * @param {Number} [speed] - The time in milliseconds for the transition.
		 * @param {Boolean} [standard=false] - Whether to use the standard behaviour or not.
		 */
		Navigation.prototype.to = function(position, speed, standard) {
			var length;
	
			if (!standard && this._pages.length) {
				length = this._pages.length;
				$.proxy(this._overrides.to, this._core)(this._pages[((position % length) + length) % length].start, speed);
			} else {
				$.proxy(this._overrides.to, this._core)(position, speed);
			}
		};
	
		$.fn.owlCarousel.Constructor.Plugins.Navigation = Navigation;
	
	})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);
	
	/**
	 * Hash Plugin
	 * @version 2.3.4
	 * @author Artus Kolanowski
	 * @author David Deutsch
	 * @license The MIT License (MIT)
	 */
	;(function($, window, document, undefined) {
		'use strict';
	
		/**
		 * Creates the hash plugin.
		 * @class The Hash Plugin
		 * @param {Owl} carousel - The Owl Carousel
		 */
		var Hash = function(carousel) {
			/**
			 * Reference to the core.
			 * @protected
			 * @type {Owl}
			 */
			this._core = carousel;
	
			/**
			 * Hash index for the items.
			 * @protected
			 * @type {Object}
			 */
			this._hashes = {};
	
			/**
			 * The carousel element.
			 * @type {jQuery}
			 */
			this.$element = this._core.$element;
	
			/**
			 * All event handlers.
			 * @protected
			 * @type {Object}
			 */
			this._handlers = {
				'initialized.owl.carousel': $.proxy(function(e) {
					if (e.namespace && this._core.settings.startPosition === 'URLHash') {
						$(window).trigger('hashchange.owl.navigation');
					}
				}, this),
				'prepared.owl.carousel': $.proxy(function(e) {
					if (e.namespace) {
						var hash = $(e.content).find('[data-hash]').addBack('[data-hash]').attr('data-hash');
	
						if (!hash) {
							return;
						}
	
						this._hashes[hash] = e.content;
					}
				}, this),
				'changed.owl.carousel': $.proxy(function(e) {
					if (e.namespace && e.property.name === 'position') {
						var current = this._core.items(this._core.relative(this._core.current())),
							hash = $.map(this._hashes, function(item, hash) {
								return item === current ? hash : null;
							}).join();
	
						if (!hash || window.location.hash.slice(1) === hash) {
							return;
						}
	
						window.location.hash = hash;
					}
				}, this)
			};
	
			// set default options
			this._core.options = $.extend({}, Hash.Defaults, this._core.options);
	
			// register the event handlers
			this.$element.on(this._handlers);
	
			// register event listener for hash navigation
			$(window).on('hashchange.owl.navigation', $.proxy(function(e) {
				var hash = window.location.hash.substring(1),
					items = this._core.$stage.children(),
					position = this._hashes[hash] && items.index(this._hashes[hash]);
	
				if (position === undefined || position === this._core.current()) {
					return;
				}
	
				this._core.to(this._core.relative(position), false, true);
			}, this));
		};
	
		/**
		 * Default options.
		 * @public
		 */
		Hash.Defaults = {
			URLhashListener: false
		};
	
		/**
		 * Destroys the plugin.
		 * @public
		 */
		Hash.prototype.destroy = function() {
			var handler, property;
	
			$(window).off('hashchange.owl.navigation');
	
			for (handler in this._handlers) {
				this._core.$element.off(handler, this._handlers[handler]);
			}
			for (property in Object.getOwnPropertyNames(this)) {
				typeof this[property] != 'function' && (this[property] = null);
			}
		};
	
		$.fn.owlCarousel.Constructor.Plugins.Hash = Hash;
	
	})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);
	
	/**
	 * Support Plugin
	 *
	 * @version 2.3.4
	 * @author Vivid Planet Software GmbH
	 * @author Artus Kolanowski
	 * @author David Deutsch
	 * @license The MIT License (MIT)
	 */
	;(function($, window, document, undefined) {
	
		var style = $('<support>').get(0).style,
			prefixes = 'Webkit Moz O ms'.split(' '),
			events = {
				transition: {
					end: {
						WebkitTransition: 'webkitTransitionEnd',
						MozTransition: 'transitionend',
						OTransition: 'oTransitionEnd',
						transition: 'transitionend'
					}
				},
				animation: {
					end: {
						WebkitAnimation: 'webkitAnimationEnd',
						MozAnimation: 'animationend',
						OAnimation: 'oAnimationEnd',
						animation: 'animationend'
					}
				}
			},
			tests = {
				csstransforms: function() {
					return !!test('transform');
				},
				csstransforms3d: function() {
					return !!test('perspective');
				},
				csstransitions: function() {
					return !!test('transition');
				},
				cssanimations: function() {
					return !!test('animation');
				}
			};
	
		function test(property, prefixed) {
			var result = false,
				upper = property.charAt(0).toUpperCase() + property.slice(1);
	
			$.each((property + ' ' + prefixes.join(upper + ' ') + upper).split(' '), function(i, property) {
				if (style[property] !== undefined) {
					result = prefixed ? property : true;
					return false;
				}
			});
	
			return result;
		}
	
		function prefixed(property) {
			return test(property, true);
		}
	
		if (tests.csstransitions()) {
			/* jshint -W053 */
			$.support.transition = new String(prefixed('transition'))
			$.support.transition.end = events.transition.end[ $.support.transition ];
		}
	
		if (tests.cssanimations()) {
			/* jshint -W053 */
			$.support.animation = new String(prefixed('animation'))
			$.support.animation.end = events.animation.end[ $.support.animation ];
		}
	
		if (tests.csstransforms()) {
			/* jshint -W053 */
			$.support.transform = new String(prefixed('transform'));
			$.support.transform3d = tests.csstransforms3d();
		}
	
	})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(419)))

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var sensor_1 = __webpack_require__(957);
	var alarma_1 = __webpack_require__(973);
	var sucursal_1 = __webpack_require__(908);
	var alarma_service_1 = __webpack_require__(578);
	var permiso_service_1 = __webpack_require__(427);
	var _ = __webpack_require__(580);
	var AbmAlarmasComponent = (function () {
	    function AbmAlarmasComponent(alarmaService, permisoService) {
	        this.alarmaService = alarmaService;
	        this.permisoService = permisoService;
	        this.permisos = new core_1.EventEmitter();
	    }
	    AbmAlarmasComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.alarma = new alarma_1.Alarma();
	        this.sensor = new sensor_1.Sensor();
	        this.active = true;
	        //Pedir permisos
	        this.permisoService.getPermiso("alarma").subscribe(function (permisos) {
	            var respuesta = new Map();
	            for (var _i = 0, _a = permisos.tipoPermiso; _i < _a.length; _i++) {
	                var permiso = _a[_i];
	                respuesta.set(permiso.descripcion, true);
	            }
	            _this.permisos.emit({ permisos: respuesta });
	        });
	    };
	    AbmAlarmasComponent.prototype.closeModal = function () {
	        var _this = this;
	        //Reseteo formEmpresa para eliminar errores
	        this.active = false;
	        setTimeout(function () { return _this.active = true; }, 0);
	        //Inicializo variables
	        if (this.alarma._id != undefined && this.alarma._id != "" && this.alarma._id != null)
	            this.alarmaService.getAlarma(this.alarma._id).subscribe(function (alarma) {
	                for (var _i = 0, _a = _this.sensor.alarmas; _i < _a.length; _i++) {
	                    var alarmaL = _a[_i];
	                    if (alarmaL._id == alarma._id) {
	                        alarmaL.descripcion = alarma.descripcion;
	                        alarmaL.valorMaximo = alarma.valorMaximo;
	                        alarmaL.valorMinimo = alarma.valorMinimo;
	                        break;
	                    }
	                }
	            });
	        //Seteo bandera para deshabilitar
	        this.deshabilitar = false;
	        //Ocultar modal
	        $("#modalAlarma").modal("hide");
	        $("#confirmacionAlarma").modal("hide");
	    };
	    AbmAlarmasComponent.prototype.eliminar = function () {
	        var _this = this;
	        //Busco alarma
	        this.alarmaService
	            .getAlarma(this.alarma._id)
	            .subscribe(function (alarma) {
	            _this.alarmaService.delete(alarma).subscribe(function (alarma) {
	                for (var _i = 0, _a = _this.sensor.alarmas; _i < _a.length; _i++) {
	                    var alarmaL = _a[_i];
	                    if (alarmaL._id == alarma._id) {
	                        alarmaL.estado = alarma.estado;
	                        if (!alarma.estado) {
	                            for (var _b = 0, _c = alarmaL.avisosLista; _b < _c.length; _b++) {
	                                var aviso = _c[_b];
	                                aviso.estado = alarma.estado;
	                            }
	                        }
	                        break;
	                    }
	                }
	            });
	            $("#confirmacionAlarma").modal("hide");
	        });
	    };
	    AbmAlarmasComponent.prototype.save = function () {
	        var _this = this;
	        //Determino operacion
	        var operacion = "";
	        console.log(this.alarma, this.sensor);
	        if (this.alarma._id == "" || this.alarma._id == undefined)
	            operacion = "agregar";
	        else
	            operacion = "modificar";
	        //Elimino redundancia
	        this.alarma.sensor_id = this.sensor._id;
	        var alarmaSimplificado = _.cloneDeep(this.alarma);
	        //Armar los avisos lista
	        if (this.alarma.avisosLista != undefined) {
	            var idsAvisosLista = [];
	            this.alarma.avisosLista.forEach(function (aviso) {
	                idsAvisosLista.push(aviso._id);
	            });
	            //delete alarmaSimplificado.avisosLista;
	            alarmaSimplificado.avisosLista = idsAvisosLista;
	        }
	        alarmaSimplificado.sucursal_id = this.sucursal._id;
	        //Guardo
	        this.alarmaService
	            .save(alarmaSimplificado)
	            .subscribe(function (alarma) {
	            //Inicializo variables
	            _this.alarma = alarma;
	            //Actualizo listas
	            if (operacion == "agregar") {
	                if (_this.sensor.alarmas == undefined)
	                    _this.sensor.alarmas = [];
	                _this.sensor.alarmas.push(alarma);
	            }
	            else
	                for (var _i = 0, _a = _this.sensor.alarmas; _i < _a.length; _i++) {
	                    var alarmaL = _a[_i];
	                    if (alarmaL._id == alarma._id) {
	                        alarmaL.descripcion = alarma.descripcion;
	                        alarmaL.valorMaximo = alarma.valorMaximo;
	                        alarmaL.valorMinimo = alarma.valorMinimo;
	                        break;
	                    }
	                }
	            //Ocultar modal
	            $("#modalAlarma").modal("hide");
	            //Reseteo formEmpresa para eliminar errores
	            _this.active = false;
	            setTimeout(function () { return _this.active = true; }, 0);
	        });
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof alarma_1.Alarma !== 'undefined' && alarma_1.Alarma) === 'function' && _a) || Object)
	    ], AbmAlarmasComponent.prototype, "alarma", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_b = typeof sensor_1.Sensor !== 'undefined' && sensor_1.Sensor) === 'function' && _b) || Object)
	    ], AbmAlarmasComponent.prototype, "sensor", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_c = typeof sucursal_1.Sucursal !== 'undefined' && sucursal_1.Sucursal) === 'function' && _c) || Object)
	    ], AbmAlarmasComponent.prototype, "sucursal", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], AbmAlarmasComponent.prototype, "permisos", void 0);
	    AbmAlarmasComponent = __decorate([
	        core_1.Component({
	            selector: 'abmalarmas',
	            template: __webpack_require__(974),
	            styles: [__webpack_require__(975)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_d = typeof alarma_service_1.AlarmaService !== 'undefined' && alarma_service_1.AlarmaService) === 'function' && _d) || Object, (typeof (_e = typeof permiso_service_1.PermisoService !== 'undefined' && permiso_service_1.PermisoService) === 'function' && _e) || Object])
	    ], AbmAlarmasComponent);
	    return AbmAlarmasComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.AbmAlarmasComponent = AbmAlarmasComponent;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(419)))

/***/ }),
/* 973 */
/***/ (function(module, exports) {

	"use strict";
	var Alarma = (function () {
	    function Alarma() {
	    }
	    return Alarma;
	}());
	exports.Alarma = Alarma;


/***/ }),
/* 974 */
/***/ (function(module, exports) {

	module.exports = "<!-- Modal -->\n<div class=\"modal fade\" id=\"modalAlarma\" data-backdrop=\"static\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modalAlarmaLabel\" style=\"z-indez:99999999\">\n    <div class=\"modal-dialog modal-md\" role=\"document\" style=\"z-indez:99999\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" (click)=\"closeModal()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n                <h4 class=\"modal-title\" id=\"modalAlarmaLabel\">Alarma</h4>\n            </div>\n            <form #nodoForm=\"ngForm\" *ngIf=\"active\">\n                <div class=\"modal-body\">\n                    <div class=\"form-group\">\n                        <label for=\"sensor\">Canal de Monitorización</label>\n                        <input *ngIf=\"sensor\" type=\"text\" disabled class=\"form-control\" id=\"sensor\" placeholder=\"Descripción\" [(ngModel)]=\"sensor.etiqueta\" name=\"sensor\">\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"descripcion\">Descripción</label>\n                        <span class=\"glyphicon glyphicon-question-sign ayuda\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Descripción de referencia para la alarma.\"></span>\n                        <input type=\"text\" class=\"form-control\" required id=\"descripcion\" placeholder=\"Descripción\" [(ngModel)]=\"alarma.descripcion\" name=\"descripcion\" #descripcion=\"ngModel\" autocomplete=\"off\" [disabled]=\"deshabilitar\">\n                        <div [hidden]=\"descripcion.valid || descripcion.pristine\" class=\"alert alert-danger\">\n                            Descripción es requerido\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"valorMinimo\">Valor Mínimo Alerta Roja</label>\n                        <span class=\"glyphicon glyphicon-question-sign ayuda\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Por debajo de este valor se disparará la alarma alerta roja de máxima atención.\"></span>\n                        <input type=\"number\" class=\"form-control\" required id=\"valorMinimo\" placeholder=\"Valor Mínimo Alerta Roja\" [(ngModel)]=\"alarma.valorMinimo\" name=\"valorMinimo\" #valorMinimo=\"ngModel\" autocomplete=\"off\" [disabled]=\"deshabilitar\">\n                        <div [hidden]=\"valorMinimo.valid || valorMinimo.pristine\" class=\"alert alert-danger\">\n                            Valor Mínimo es requerido y debe ser numérico\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"valorMaximo\">Valor Maximo Alerta Roja</label>\n                        <span class=\"glyphicon glyphicon-question-sign ayuda\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Por encima de este valor se disparará la alarma alerta roja de máxima atención.\"></span>\n                        <input type=\"number\" class=\"form-control\" required id=\"valorMaximo\" placeholder=\"Valor Maximo Alerta Roja\" [(ngModel)]=\"alarma.valorMaximo\" name=\"valorMaximo\" #valorMaximo=\"ngModel\" autocomplete=\"off\" [disabled]=\"deshabilitar\">\n                        <div [hidden]=\"valorMaximo.valid || valorMaximo.pristine\" class=\"alert alert-danger\">\n                            Valor Maximo es requerido y debe ser numérico\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"valorMinimoAmarillo\">Valor Mínimo Alerta Amarilla</label>\n                        <span class=\"glyphicon glyphicon-question-sign ayuda\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Por debajo de este valor se disparará la alarma alerta amarilla de precaución.\"></span>\n                        <input type=\"number\" class=\"form-control\" id=\"valorMinimoAmarillo\" placeholder=\"Valor Mínimo Alerta Amarilla\" [(ngModel)]=\"alarma.valorMinimoAmarillo\" name=\"valorMinimoAmarillo\" #valorMinimoAmarillo=\"ngModel\" autocomplete=\"off\" [disabled]=\"deshabilitar\">\n                        <div [hidden]=\"valorMinimoAmarillo.valid || valorMinimoAmarillo.pristine \" class=\"alert alert-danger\">\n                            Valor Mínimo debe ser numérico\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"valorMaximoAmarillo\">Valor Maximo Alerta Amarilla</label>\n                        <span class=\"glyphicon glyphicon-question-sign ayuda\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Por encima de este valor se disparará la alarma alerta amarilla de precaución.\"></span>\n                        <input type=\"number\" class=\"form-control\" id=\"valorMaximoAmarillo\" placeholder=\"Valor Maximo Alerta Amarilla\" [(ngModel)]=\"alarma.valorMaximoAmarillo\" name=\"valorMaximoAmarillo\" #valorMaximoAmarillo=\"ngModel\" autocomplete=\"off\" [disabled]=\"deshabilitar\">\n                        <div [hidden]=\"valorMaximoAmarillo.valid || valorMaximoAmarillo.pristine\" class=\"alert alert-danger\">\n                            Valor Maximo debe ser numérico\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"repeatable\">Reconocimiento de alarmas</label>\n                        <span class=\"glyphicon glyphicon-question-sign ayuda\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Obliga al usuario a avisar que le llegaron las alarmas\"></span>\n                        <select class=\"form-control\" required id=\"repeatable\" name=\"repeatable\" [(ngModel)]=\"alarma.repeatable\" autocomplete=\"off\" #repeatable=\"ngModel\" [disabled]=\"deshabilitar\">\n                            <option value={{false}}>No</option>\n                            <option value={{true}}>Sí</option>\n                        </select>\n                        <div [hidden]=\"repeatable.valid || repeatable.pristine\" class=\"alert alert-danger\">\n                            Reconocimiento de alarmas es requerido\n                        </div>\n                    </div>\n                    <label>Visualización</label>\n                    <div class=\"progress\" [hidden]=\"alarma.valorMinimoAmarillo==null || alarma.valorMaximoAmarillo==null || alarma.valorMinimo==null || alarma.valorMaximo==null\">\n                        <div class=\"progress-bar progress-bar-danger\" [style.width]=\"10+'%'\" style=\"text-align: right; padding-right: 5px\">\n                            {{alarma.valorMinimo}}\n                        </div>\n                        <div class=\"progress-bar progress-bar-warning\" [style.width]=\"((alarma.valorMinimoAmarillo-alarma.valorMinimo)*80)/(alarma.valorMaximo-alarma.valorMinimo)+'%'\" style=\"text-align: right; padding-right: 5px\">\n                            {{alarma.valorMinimoAmarillo}}\n                        </div>\n                        <div class=\"progress-bar progress-bar-success\" [style.width]=\"((alarma.valorMaximoAmarillo-alarma.valorMinimoAmarillo)*80)/(alarma.valorMaximo-alarma.valorMinimo)+'%'\">\n\n                        </div>\n                        <div class=\"progress-bar progress-bar-warning\" [style.width]=\"((alarma.valorMaximo-alarma.valorMaximoAmarillo)*80)/(alarma.valorMaximo-alarma.valorMinimo)+'%'\" style=\"text-align: left; padding-left: 5px\">\n                            {{alarma.valorMaximoAmarillo}}\n                        </div>\n                        <div class=\"progress-bar progress-bar-danger\" [style.width]=\"10+'%'\" style=\"text-align: left; padding-left: 5px\">\n                            {{alarma.valorMaximo}}\n                        </div>\n                    </div>\n                    <div class=\"progress\" [hidden]=\"!(alarma.valorMinimo!=null && alarma.valorMaximo!=null && !alarma.valorMinimoAmarillo && !alarma.valorMaximoAmarillo)\">\n                        <div class=\"progress-bar progress-bar-danger\" [style.width]=\"20+'%'\" style=\"text-align: right; padding-right: 5px\">\n                            {{alarma.valorMinimo}}\n                        </div>\n                        <div class=\"progress-bar progress-bar-success\" [style.width]=\"60+'%'\">\n\n                        </div>\n                        <div class=\"progress-bar progress-bar-danger\" [style.width]=\"20+'%'\" style=\"text-align: left; padding-left: 5px\">\n                            {{alarma.valorMaximo}}\n                        </div>\n                    </div>\n                    <div class=\"progress\">\n                        <div class=\"progress-bar progress-bar-danger\" [style.width]=\"20+'%'\" style=\"text-align: right; padding-right: 5px\">\n                            Mínimo Roja\n                        </div>\n                        <div class=\"progress-bar progress-bar-warning\" [style.width]=\"20+'%'\" style=\"text-align: right; padding-right: 5px\">\n                            Mínimo Amarilla\n                        </div>\n                        <div class=\"progress-bar progress-bar-success\" [style.width]=\"20+'%'\">\n                            Rango Aceptado\n                        </div>\n                        <div class=\"progress-bar progress-bar-warning\" [style.width]=\"20+'%'\" style=\"text-align: left; padding-left: 5px\">\n                            Maximo Amarilla\n                        </div>\n                        <div class=\"progress-bar progress-bar-danger\" [style.width]=\"20+'%'\" style=\"text-align: left; padding-left: 5px\">\n                            Maximo Roja\n                        </div>\n                    </div>\n                </div>\n                <div class=\"clearfix visible-md-block\"></div>\n                <div class=\"clearfix visible-lg-block\"></div>\n                <div class=\"clearfix visible-sm-block\"></div>\n                <div class=\"clearfix visible-xs-block\"></div>\n                <div class=\"modal-footer\">\n                    <button type=\"button\" class=\"btn btn-default\" (click)=\"closeModal()\">Cancelar</button>\n                    <button type=\"button\" class=\"btn btn-success\" (click)=\"save()\" class=\"btn btn-success\" [disabled]=\"deshabilitar || !nodoForm.form.valid\">Guardar</button>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>\n<div id=\"confirmacionAlarma\" class=\"modal fade\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">&times;</button>\n                <h4 class=\"modal-title\">Confirmación</h4>\n            </div>\n            <div class=\"modal-body\">\n                <p *ngIf=\"alarma.estado\">Está seguro que desea eliminar la alarma?</p>\n                <p *ngIf=\"!alarma.estado\">Está seguro que desea restaurar la alarma?</p>\n                <p class=\"text-warning\"><small>Los datos relacionados también se eliminarán.</small></p>\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-default\" (click)=\"closeModal()\">Cerrar</button>\n                <button type=\"button\" class=\"btn btn-danger\" (click)=\"eliminar()\">Aceptar</button>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 975 */
867,
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var aviso_1 = __webpack_require__(977);
	var alarma_1 = __webpack_require__(973);
	var sucursal_1 = __webpack_require__(908);
	var aviso_service_1 = __webpack_require__(579);
	var usuario_service_1 = __webpack_require__(430);
	var permiso_service_1 = __webpack_require__(427);
	var AvisoComponent = (function () {
	    function AvisoComponent(avisoService, usuarioService, permisoService) {
	        this.avisoService = avisoService;
	        this.usuarioService = usuarioService;
	        this.permisoService = permisoService;
	        this.permisos = new core_1.EventEmitter();
	    }
	    AvisoComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.alarma = new alarma_1.Alarma();
	        this.aviso = new aviso_1.Aviso();
	        this.active = true;
	        this.active2 = true;
	        //Pedir permisos
	        this.permisoService.getPermiso("aviso").subscribe(function (permisos) {
	            var respuesta = new Map();
	            for (var _i = 0, _a = permisos.tipoPermiso; _i < _a.length; _i++) {
	                var permiso = _a[_i];
	                respuesta.set(permiso.descripcion, true);
	            }
	            _this.permisos.emit({ permisos: respuesta });
	        });
	    };
	    AvisoComponent.prototype.ngOnChanges = function (changes) {
	        var _this = this;
	        if (this.alarma != undefined && this.sucursal != undefined && this.sucursal._id != undefined)
	            this.usuarioService.getUsuarioBySucursal(this.sucursal._id)
	                .subscribe(function (usuarios) { return _this.usuarios = usuarios; });
	        this.formatAviso();
	    };
	    AvisoComponent.prototype.formatAviso = function () {
	        if (this.aviso != undefined && this.aviso._id != undefined) {
	            var horaDesdeStr = this.aviso.horaDesde.toString();
	            if (horaDesdeStr.indexOf(":") == -1) {
	                if (horaDesdeStr.length == 3)
	                    horaDesdeStr = "0".concat(horaDesdeStr);
	                else if (horaDesdeStr.length == 2)
	                    horaDesdeStr = "00".concat(horaDesdeStr);
	                else if (horaDesdeStr.length == 1)
	                    horaDesdeStr = "000".concat(horaDesdeStr);
	                this.aviso.horaDesde = horaDesdeStr.slice(0, 2) + ":" + horaDesdeStr.slice(2);
	            }
	            var horaHastaStr = this.aviso.horaHasta.toString();
	            if (horaHastaStr.indexOf(":") == -1) {
	                if (horaHastaStr.length == 3)
	                    horaHastaStr = "0".concat(horaHastaStr);
	                else if (horaHastaStr.length == 2)
	                    horaHastaStr = "00".concat(horaHastaStr);
	                if (horaHastaStr.length == 1)
	                    horaHastaStr = "000".concat(horaHastaStr);
	                this.aviso.horaHasta = horaHastaStr.slice(0, 2) + ":" + horaHastaStr.slice(2);
	            }
	        }
	    };
	    AvisoComponent.prototype.closeModal = function () {
	        var _this = this;
	        //Reseteo formSucursal para eliminar errores
	        this.active = false;
	        setTimeout(function () { return _this.active = true; }, 0);
	        //Reseteo formContacto para eliminar errores
	        setTimeout(function () { return _this.active2 = false; }, 0);
	        setTimeout(function () { return _this.active2 = true; }, 0);
	        //Inicializo variables
	        if (this.aviso._id != undefined && this.aviso._id != "" && this.aviso._id != null)
	            this.avisoService.getAviso(this.aviso._id).subscribe(function (aviso) {
	                for (var _i = 0, _a = _this.alarma.avisosLista; _i < _a.length; _i++) {
	                    var avisoL = _a[_i];
	                    if (avisoL._id == aviso._id) {
	                        avisoL.nombre = aviso.nombre;
	                        avisoL.lunes = aviso.lunes;
	                        avisoL.martes = aviso.martes;
	                        avisoL.miercoles = aviso.miercoles;
	                        avisoL.jueves = aviso.jueves;
	                        avisoL.viernes = aviso.viernes;
	                        avisoL.sabado = aviso.sabado;
	                        avisoL.domingo = aviso.domingo;
	                        avisoL.usuarios = aviso.usuarios;
	                        avisoL.horaDesde = aviso.horaDesde;
	                        avisoL.horaHasta = aviso.horaHasta;
	                        break;
	                    }
	                }
	            });
	        //Seteo bandera para deshabilitar
	        this.deshabilitar = false;
	        //Ocultar modal
	        $("#modalAviso").modal("hide");
	        $("#confirmacionAviso").modal("hide");
	    };
	    AvisoComponent.prototype.eliminar = function () {
	        var _this = this;
	        //Busco aviso
	        this.avisoService
	            .getAviso(this.aviso._id)
	            .subscribe(function (aviso) {
	            _this.avisoService.delete(aviso).subscribe(function (aviso) {
	                for (var _i = 0, _a = _this.alarma.avisosLista; _i < _a.length; _i++) {
	                    var avisoL = _a[_i];
	                    if (avisoL._id == aviso._id) {
	                        avisoL.estado = aviso.estado;
	                        break;
	                    }
	                }
	            });
	            $("#confirmacionAviso").modal("hide");
	        });
	    };
	    AvisoComponent.prototype.save = function () {
	        var _this = this;
	        //Determino operacion
	        var operacion = "";
	        if (this.aviso._id == "" || this.aviso._id == undefined)
	            operacion = "agregar";
	        else
	            operacion = "modificar";
	        this.aviso.sucursal_id = this.sucursal._id;
	        this.avisoService
	            .save(this.aviso, this.alarma)
	            .subscribe(function (aviso) {
	            //Inicializo variables
	            _this.aviso._id = aviso._id;
	            //Actualizo listas
	            if (operacion == "agregar") {
	                if (_this.alarma.avisosLista == undefined)
	                    _this.alarma.avisosLista = [];
	                _this.alarma.avisosLista.push(aviso);
	            }
	            else
	                for (var _i = 0, _a = _this.alarma.avisosLista; _i < _a.length; _i++) {
	                    var avisoL = _a[_i];
	                    if (avisoL._id == aviso._id) {
	                        avisoL.nombre = aviso.nombre;
	                        avisoL.lunes = aviso.lunes;
	                        avisoL.martes = aviso.martes;
	                        avisoL.miercoles = aviso.miercoles;
	                        avisoL.jueves = aviso.jueves;
	                        avisoL.viernes = aviso.viernes;
	                        avisoL.sabado = aviso.sabado;
	                        avisoL.domingo = aviso.domingo;
	                        avisoL.usuarios = aviso.usuarios;
	                        avisoL.horaDesde = aviso.horaDesde;
	                        avisoL.horaHasta = aviso.horaHasta;
	                        break;
	                    }
	                }
	            _this.formatAviso();
	            //Ocultar modal
	            $("#modalAviso").modal("hide");
	            //Reseteo form para eliminar errores
	            _this.active = false;
	            setTimeout(function () { return _this.active = true; }, 0);
	            //Reseteo formContacto para eliminar errores
	            setTimeout(function () { return _this.active2 = false; }, 0);
	            setTimeout(function () { return _this.active2 = true; }, 0);
	        }, function (err) {
	        });
	    };
	    AvisoComponent.prototype.agregarUsuario = function () {
	        var _this = this;
	        //Inicializar arreglo
	        if (this.aviso.usuarios == undefined)
	            this.aviso.usuarios = [];
	        for (var _i = 0, _a = this.usuarios; _i < _a.length; _i++) {
	            var usuario = _a[_i];
	            if (usuario._id == this.usuario) {
	                if (this.aviso.usuarios.filter(function (e) {
	                    return e._id == this.usuario;
	                }.bind(this)).length == 0)
	                    //Agregar contacto
	                    this.aviso.usuarios.push(usuario);
	                else
	                    alert("El usuario ya esta agregado al aviso");
	                break;
	            }
	        }
	        //Limpiar contacto
	        this.usuario = "";
	        //Reseteo form para eliminar errores
	        this.active = false;
	        setTimeout(function () { return _this.active = true; }, 0);
	        //Reseteo formContacto para eliminar errores
	        setTimeout(function () { return _this.active2 = false; }, 0);
	        setTimeout(function () { return _this.active2 = true; }, 0);
	    };
	    AvisoComponent.prototype.eliminarUsuario = function (index) {
	        //Eliminar contacto de la lista
	        this.aviso.usuarios.splice(index, 1);
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof alarma_1.Alarma !== 'undefined' && alarma_1.Alarma) === 'function' && _a) || Object)
	    ], AvisoComponent.prototype, "alarma", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_b = typeof aviso_1.Aviso !== 'undefined' && aviso_1.Aviso) === 'function' && _b) || Object)
	    ], AvisoComponent.prototype, "aviso", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_c = typeof sucursal_1.Sucursal !== 'undefined' && sucursal_1.Sucursal) === 'function' && _c) || Object)
	    ], AvisoComponent.prototype, "sucursal", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], AvisoComponent.prototype, "permisos", void 0);
	    AvisoComponent = __decorate([
	        core_1.Component({
	            selector: 'aviso',
	            template: __webpack_require__(978),
	            styles: [__webpack_require__(979)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_d = typeof aviso_service_1.AvisoService !== 'undefined' && aviso_service_1.AvisoService) === 'function' && _d) || Object, (typeof (_e = typeof usuario_service_1.UsuariosService !== 'undefined' && usuario_service_1.UsuariosService) === 'function' && _e) || Object, (typeof (_f = typeof permiso_service_1.PermisoService !== 'undefined' && permiso_service_1.PermisoService) === 'function' && _f) || Object])
	    ], AvisoComponent);
	    return AvisoComponent;
	    var _a, _b, _c, _d, _e, _f;
	}());
	exports.AvisoComponent = AvisoComponent;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(419)))

/***/ }),
/* 977 */
/***/ (function(module, exports) {

	"use strict";
	var Aviso = (function () {
	    function Aviso() {
	    }
	    return Aviso;
	}());
	exports.Aviso = Aviso;


/***/ }),
/* 978 */
/***/ (function(module, exports) {

	module.exports = "<!-- Modal -->\n<div class=\"modal fade\" id=\"modalAviso\" data-backdrop=\"static\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modalAvisoLabel\" style=\"z-indez:99999999\">\n    <div class=\"modal-dialog modal-md\" role=\"document\" style=\"z-indez:99999\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" (click)=\"closeModal()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n                <h4 class=\"modal-title\" id=\"modalAvisoLabel\">Aviso</h4>\n            </div>\n            <form #avisoForm=\"ngForm\" *ngIf=\"active\">\n                <div class=\"modal-body\">\n                    <div class=\"form-group\">\n                        <label for=\"inputPassword\">Alarma</label>\n                        <input *ngIf=\"alarma\" type=\"text\" disabled class=\"form-control\" id=\"alarma\" placeholder=\"Descripción\" [(ngModel)]=\"alarma.descripcion\" name=\"alarma\">\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"inputPassword\">Nombre</label>\n                        <span class=\"glyphicon glyphicon-question-sign ayuda\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Descripción de referencia para el aviso.\"></span>\n                        <input type=\"text\" class=\"form-control\" required id=\"nombre\" placeholder=\"Nombre\" [(ngModel)]=\"aviso.nombre\" name=\"nombre\" #nombre=\"ngModel\" autocomplete=\"off\" [disabled]=\"deshabilitar\">\n                        <div [hidden]=\"nombre.valid || nombre.pristine\" class=\"alert alert-danger\">\n                            Nombre es requerido\n                        </div>\n                    </div>\n                    \n                    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" style=\"border: 1px solid rgba(176, 176, 178, 0.3); padding-top:15px; padding-bottom:15px; margin-bottom: 15px\">\n                        <h5 style=\"font-family:'Raleway 2'; text-align:center\">Días de la semana</h5>\n                        <div class=\"checkboxDias\">\n                            <label>\n                                <input type=\"checkbox\" id=\"lunes\" name=\"lunes\" [(ngModel)]=\"aviso.lunes\"> Lunes\n                            </label>\n                        </div>\n                        <div class=\"checkboxDias\">\n                            <label>\n                                <input type=\"checkbox\" id=\"martes\" [(ngModel)]=\"aviso.martes\" name=\"martes\" #martes=\"ngModel\" autocomplete=\"off\" [disabled]=\"deshabilitar\" value=\"true\"> Martes\n                            </label>\n                        </div>\n                        <div class=\"checkboxDias\">\n                            <label>\n                                <input type=\"checkbox\" id=\"miercoles\" [(ngModel)]=\"aviso.miercoles\" name=\"miercoles\" #miercoles=\"ngModel\" autocomplete=\"off\" [disabled]=\"deshabilitar\" value=\"true\"> Miércoles\n                            </label>\n                        </div>\n                        <div class=\"checkboxDias\">\n                            <label>\n                                <input type=\"checkbox\" id=\"jueves\" [(ngModel)]=\"aviso.jueves\" name=\"jueves\" autocomplete=\"off\" [disabled]=\"deshabilitar\" value=\"true\"> Jueves\n                            </label>\n                        </div>\n                        <div class=\"checkboxDias\">\n                            <label>\n                                <input type=\"checkbox\" required id=\"viernes\" [(ngModel)]=\"aviso.viernes\" name=\"viernes\" #viernes=\"ngModel\" autocomplete=\"off\" [disabled]=\"deshabilitar\" value=\"true\"> Viernes\n                            </label>\n                        </div>\n                        <div class=\"checkboxDias\">\n                            <label>\n                                <input type=\"checkbox\" id=\"sabado\" placeholder=\"Lunes\" [(ngModel)]=\"aviso.sabado\" name=\"sabado\" #sabado=\"ngModel\" autocomplete=\"off\" [disabled]=\"deshabilitar\" value=\"true\"> Sábado\n                            </label>\n                        </div>\n                        <div class=\"checkboxDias\">\n                            <label>\n                                <input type=\"checkbox\" id=\"domingo\" [(ngModel)]=\"aviso.domingo\" name=\"domingo\" #domingo=\"ngModel\" autocomplete=\"off\" [disabled]=\"deshabilitar\" value=\"true\"> Domingo\n                            </label>\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"inputPassword\">Hora Desde</label>\n                        <span class=\"glyphicon glyphicon-question-sign ayuda\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"A partir de este horario se le notificará de los sucesos ocurridos a las personas registradas en este aviso.\"></span>\n                        <input type=\"text\" class=\"form-control\" required id=\"horaDesde\" [(ngModel)]=\"aviso.horaDesde\" name=\"horaDesde\" #horaDesde=\"ngModel\" autocomplete=\"off\" [disabled]=\"deshabilitar\" pattern=\"([01]?[0-9]{1}|2[0-3]{1}):[0-5]{1}[0-9]{1}\" placeholder=\"hh:mm\">\n                        <div [hidden]=\"horaDesde.valid || horaDesde.pristine\" class=\"alert alert-danger\">\n                            Hora Desde es requerido y el formato debe ser hh:mm (24hs)\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"inputPassword\">Hora Hasta</label>\n                        <span class=\"glyphicon glyphicon-question-sign ayuda\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"A partir de este horario NO se le notificará de los sucesos ocurridos a las personas registradas en este aviso.\"></span>\n                        <input type=\"text\" class=\"form-control\" required id=\"horaHasta\" [(ngModel)]=\"aviso.horaHasta\" name=\"horaHasta\" #horaHasta=\"ngModel\" autocomplete=\"off\" [disabled]=\"deshabilitar\" pattern=\"([01]?[0-9]{1}|2[0-3]{1}):[0-5]{1}[0-9]{1}\" placeholder=\"hh:mm\">\n                        <div [hidden]=\"horaHasta.valid || horaHasta.pristine\" class=\"alert alert-danger\">\n                            Hora Hasta es requerido y el formato debe ser hh:mm (24hs)\n                        </div>\n                    </div>\n                    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                    <h5 style=\"font-family:'Raleway 2'; text-align:center\">Usuarios a los que se les emitirá aviso</h5>\n                        <div class=\"table-responsive\">\n                            <table class=\"table\">\n                                <thead>\n                                    <tr>\n                                        <th>Nombre</th>\n                                        <th>Apellido</th>\n                                        <th>DNI</th>\n                                        <th>Email</th>\n                                        <th>Teléfono</th>\n                                        <th>Puesto</th>\n                                        <th></th>\n                                    </tr>\n                                    <tr *ngFor=\"let u of aviso.usuarios; let i = index\" [ngClass]=\"{'danger': !u.estado}\">\n                                        <td>{{u.nombre}}</td>\n                                        <td>{{u.apellido}}</td>\n                                        <td>{{u.dni}}</td>\n                                        <td>{{u.email}}</td>\n                                        <td>{{u.celular}}</td>\n                                        <td>{{u.puesto}}</td>\n                                        <td class=\"td-btn\">\n                                            <button class=\"btn btn-default\" (click)=\"eliminarUsuario(i)\" [disabled]=\"deshabilitar\">\n                                                <span class=\"glyphicon glyphicon-trash\"></span>\n                                            </button>\n                                        </td>\n                                    </tr>\n                                </thead>\n                                <tbody>\n                                    <td class=\"text-center\" *ngIf=\"aviso.usuarios == undefined || aviso.usuarios.length==0\" colspan=\"6\">No hay usuarios guardados</td>\n                                </tbody>\n                            </table>\n                        </div>\n                    </div>\n                    <form #contactoForm=\"ngForm\" *ngIf=\"active2\">\n                        <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" style=\"border: 1px solid rgba(176, 176, 178, 0.3); padding-top:15px; padding-bottom:15px\">\n                            <h5 style=\"font-family:'Raleway 2'; text-align:center\">Agregar Usuario</h5>\n                            <div class=\"form-group\">\n                                <label for=\"empresa\">Usuario</label>\n                                <span class=\"glyphicon glyphicon-question-sign ayuda\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Agregar usuarios al aviso\"></span>\n                                <select class=\"form-control\" required id=\"usuario\" name=\"usuarioId\" [(ngModel)]=\"usuario\" autocomplete=\"off\" #usuarioM=\"ngModel\" [disabled]=\"deshabilitar\">\n                                    <option></option>\n                                    <option *ngFor=\"let usuario of usuarios\" value={{usuario._id}}  [disabled]=\"!usuario.estado\">{{usuario.nombre +\" \"+usuario.apellido}}\n                                    </option>\n                                </select>\n                                <div [hidden]=\"usuarioM.valid || usuarioM.pristine\" class=\"alert alert-danger\">\n                                    Usuario es requerido\n                                </div>\n                            </div>\n                            <button class=\"btn btn-block btn-success\" (click)=\"agregarUsuario()\" [disabled]=\"deshabilitar || !contactoForm.form.valid\">Agregar usuario</button>\n                        </div>\n                    </form>\n                </div>\n                <div class=\"clearfix visible-md-block\"></div>\n                <div class=\"clearfix visible-lg-block\"></div>\n                <div class=\"clearfix visible-sm-block\"></div>\n                <div class=\"clearfix visible-xs-block\"></div>\n                <div class=\"modal-footer\">\n                    <button type=\"button\" class=\"btn btn-default\" (click)=\"closeModal()\">Cancelar</button>\n                    <button type=\"button\" class=\"btn btn-success\" (click)=\"save()\" class=\"btn btn-success\" [disabled]=\"deshabilitar || (!avisoForm.form.valid)\">Guardar</button>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>\n<div id=\"confirmacionAviso\" class=\"modal fade\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">&times;</button>\n                <h4 class=\"modal-title\">Confirmación</h4>\n            </div>\n            <div class=\"modal-body\">\n                <p *ngIf=\"aviso.estado\">Está seguro que desea eliminar el aviso?</p>\n                <p *ngIf=\"!aviso.estado\">Está seguro que desea restaurar el aviso?</p>\n                <p class=\"text-warning\"><small>Los datos relacionados también se eliminarán.</small></p>\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-default\" (click)=\"closeModal()\">Cerrar</button>\n                <button type=\"button\" class=\"btn btn-danger\" (click)=\"eliminar()\">Aceptar</button>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 979 */
867,
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Rx_1 = __webpack_require__(653);
	var ProgressService = (function () {
	    function ProgressService() {
	        this.progressEventObservable = new Rx_1.Subject();
	    }
	    return ProgressService;
	}());
	exports.ProgressService = ProgressService;


/***/ }),
/* 981 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 contenido\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 titulo\">\n        <div class=\"marcoTitulo\">\n            <h2>Configuración</h2>\n            <p>Home / Configuración</p>\n        </div>\n    </div>\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 marcoConfiguracion\">\n        <div class=\"control control-izq\" (click)=\"retroceder()\">\n            <span class=\"glyphicon glyphicon-menu-left\" aria-hidden=\"true\"></span>\n        </div>\n        <div class=\"control control-der\" (click)=\"avanzar()\">\n            <span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span>\n        </div>\n        <owl-carousel [options]=\"{navigation: true, pagination: false, rewindNav : false, mouseDrag: false}\">\n            <div class=\"item col-xs-12\">\n                <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" style=\"padding: 0px\">\n                    <div class=\"col-xs-4\">\n                        <div id=\"circuloSucursal\" class=\"circulo\">1</div>\n                        <h5 class=\"nombre\">Sucursales</h5>\n                    </div>\n                    <div class=\"col-xs-8 linea\" [ngClass]=\"{'col-xs-8': true,'linea':true,'animarLinea': sucursalSeleccionada!= undefined && sucursalSeleccionada._id != undefined }\">\n                    </div>\n                </div>\n                <div class=\"tabla col-xs-12\">\n                    <div class=\"table-responsive\">\n                        <table class=\"table\">\n                            <thead>\n                                <tr>\n                                    <th>Sucursal</th>\n                                    <th>Empresa</th>\n                                </tr>\n                            </thead>\n                            <tbody>\n                                <tr *ngFor=\"let sucursal of sucursales\" (click)=\"seleccionarSucursal(sucursal._id)\" [ngClass]=\"{'warning': sucursalSeleccionada != undefined && sucursal._id == sucursalSeleccionada._id, 'danger': !sucursal.estado && sucursal._id != sucursalSeleccionada._id}\">\n                                    <td>{{sucursal.descripcion}}</td>\n                                    <td>{{sucursal.empresa.descripcion}}</td>\n                                </tr>\n                            </tbody>\n                        </table>\n                    </div>\n                </div>\n                <button data-toggle=\"tooltip\" data-placement=\"top\" title=\"Exportar\" animation=\"true\" class=\"btn btn-default btn-block btn-success\" (click)=\"exportar()\" [disabled]=\"sucursalSeleccionada==undefined || sucursalSeleccionada._id==undefined || !sucursalSeleccionada.estado || !permisosSucursal.get('export')\" style=\"margin-top:20px\">\n                    Exportar configuración\n                </button>\n            </div>\n            <div class=\"item col-xs-12\">\n                <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" style=\"padding: 0px\">\n                    <div class=\"col-xs-4\">\n                        <div id=\"circuloUbicacion\" class=\"circulo\" style=\"padding-top: 11px\">2</div>\n                        <h5 class=\"nombre\">Ubicaciones</h5>\n                    </div>\n                    <div class=\"col-xs-8 linea\" [ngClass]=\"{'col-xs-8': true,'linea':true,'animarLinea': ubicacionSeleccionada!= undefined && ubicacionSeleccionada._id != undefined }\">\n                    </div>\n                </div>\n                <div class=\"tabla col-xs-12\">\n                    <div class=\"table-responsive\" *ngIf=\"sucursalSeleccionada\">\n                        <table class=\"table\">\n                            <thead>\n                                <tr>\n                                    <th>Descripción</th>\n                                    <th>Área</th>\n                                    <th></th>\n                                    <th></th>\n                                </tr>\n                            </thead>\n                            <tbody>\n                                <tr *ngFor=\"let ubicacion of sucursalSeleccionada.ubicaciones\" (click)=\"seleccionarUbicacion(ubicacion._id)\" [ngClass]=\"{'warning': ubicacionSeleccionada != undefined && ubicacion._id == ubicacionSeleccionada._id, 'danger': !ubicacion.estado && ubicacion._id != ubicacionSeleccionada._id}\">\n                                    <td>{{ubicacion.descripcion}}</td>\n                                    <td>{{ubicacion.area}}</td>\n                                    <td>\n                                        <button id=\"edit\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Editar\" class=\"btn btn-default btn-sm btn-warning botonFila\" (click)=\"modificarUbicacion($event,ubicacion._id)\" [disabled]=\"!ubicacion.estado || !permisosUbicacion.get('update')\">\n                                            <img src=\"/img/edit.svg\" width=\"20px\" />\n                                        </button>\n                                    </td>\n                                    <td>\n                                        <button *ngIf=\"ubicacion.estado\" id=\"edit\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Eliminar\" class=\"btn btn-default btn-sm btn-danger botonFila\" data-toggle=\"modal\" data-target=\"#confirmacionUbicacion\" (click)=\"eliminarUbicacion($event,ubicacion._id)\" [disabled]=\"!permisosUbicacion.get('delete')\">\n                                            <img [src]=\"ubicacion.estado==true ? '/img/bin.svg' : '/img/restaurar.svg'\" width=\"20px\" />                                \n                                        </button>\n                                        <button *ngIf=\"!ubicacion.estado\" id=\"edit\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Restaurar\" class=\"btn btn-default btn-sm btn-danger botonFila\" data-toggle=\"modal\" data-target=\"#confirmacionUbicacion\" (click)=\"eliminarUbicacion($event,ubicacion._id)\" [disabled]=\"!permisosUbicacion.get('delete')\">\n                                            <img [src]=\"ubicacion.estado==true ? '/img/bin.svg' : '/img/restaurar.svg'\" width=\"20px\" />\n                                        </button>\n                                    </td>\n                                </tr>\n                            </tbody>\n                        </table>\n                    </div>\n                </div>\n                <button data-toggle=\"tooltip\" data-placement=\"top\" title=\"Agregar\" animation=\"true\" class=\"btn btn-default btn-block btn-success\" (click)=\"agregarUbicacion()\" [disabled]=\"sucursalSeleccionada==undefined || sucursalSeleccionada._id==undefined || !sucursalSeleccionada.estado || !permisosUbicacion.get('create')\" style=\"margin-top:20px\">\n                    Agregar Ubicación\n                </button>\n            </div>\n            <div class=\"item col-xs-12\">\n                <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" style=\"padding: 0px\">\n                    <div class=\"col-xs-4\">\n                        <div id=\"circuloNodo\" class=\"circulo\" style=\"padding-top: 10px\">3</div>\n                        <h5 class=\"nombre\">Nodos</h5>\n                    </div>\n                    <div class=\"col-xs-8 linea\" [ngClass]=\"{'col-xs-8': true,'linea':true,'animarLinea': nodoSeleccionado!= undefined && nodoSeleccionado._id != undefined }\">\n                    </div>\n                </div>\n                <div class=\"tabla col-xs-12\">\n                    <div class=\"table-responsive\" *ngIf=\"ubicacionSeleccionada\">\n                        <table class=\"table\">\n                            <thead>\n                                <tr>\n                                    <th>Nombre</th>\n                                    <th>Etiqueta</th>\n                                    <th></th>\n                                    <th></th>\n                                </tr>\n                            </thead>\n                            <tbody>\n                                <tr *ngFor=\"let nodo of ubicacionSeleccionada.nodos\" (click)=\"seleccionarNodo(nodo._id)\" [ngClass]=\"{'warning': nodoSeleccionado != undefined && nodo._id == nodoSeleccionado._id, 'danger': !nodo.estado && nodo._id != nodoSeleccionado._id}\">\n                                    <td><span data-trigger=\"hover\" data-toggle=\"tooltip\" data-placement=\"right\" data-html=\"true\" title=\"{{nodo.resumen}}\">{{nodo.nombre}}</span></td>\n                                    <td>{{nodo.etiqueta}}</td>\n                                    <td>\n                                        <button id=\"duplicate\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Clonar\" class=\"btn btn-default btn-sm btn-success botonFila\" data-toggle=\"modal\" data-target=\"#modalNodo\" (click)=\"duplicarNodo($event,nodo._id)\" [disabled]=\"(!nodo.estado && usuarioConectado.rol != 'Administrador') || !permisosNodo.get('create')\">\n                                            <img src=\"/img/agregar.svg\" width=\"20px\" />\n                                        </button>\n                                    </td>\n                                    <td>\n                                        <button id=\"edit\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Editar\" class=\"btn btn-default btn-sm btn-warning botonFila\" data-toggle=\"modal\" data-target=\"#modalNodo\" (click)=\"modificarNodo($event,nodo._id)\" [disabled]=\"(!nodo.estado && usuarioConectado.rol != 'Administrador') || !permisosNodo.get('update')\">\n                                            <img src=\"/img/edit.svg\" width=\"20px\" />\n                                        </button>\n                                    </td>\n                                    <td>\n                                        <button *ngIf=\"nodo.estado\" id=\"delete\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Eliminar\" class=\"btn btn-default btn-sm btn-danger botonFila\" data-toggle=\"modal\" data-target=\"#confirmacionNodo\" (click)=\"eliminarNodo($event,nodo._id)\" [disabled]=\"!permisosNodo.get('delete')\">\n                                            <img [src]=\"nodo.estado==true ? '/img/bin.svg' : '/img/restaurar.svg'\" width=\"20px\" />\n                                        </button>\n                                        <button *ngIf=\"!nodo.estado\" id=\"edit\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Restaurar\" class=\"btn btn-default btn-sm btn-danger botonFila\" data-toggle=\"modal\" data-target=\"#confirmacionNodo\" (click)=\"eliminarNodo($event,nodo._id)\" [disabled]=\"!permisosNodo.get('delete')\">\n                                            <img [src]=\"nodo.estado==true ? '/img/bin.svg' : '/img/restaurar.svg'\" width=\"20px\" />\n                                        </button>\n                                    </td>\n                                    <td *ngIf=\"!nodo.estado\">\n                                        <button *ngIf=\"!nodo.estado\" id=\"edit\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Eliminar permanentemente\" class=\"btn btn-default btn-sm btn-danger botonFila\" data-toggle=\"modal\" data-target=\"#confirmacionNodo\" (click)=\"eliminarPermanenteNodo($event,nodo._id)\" [disabled]=\"!permisosNodo.get('delete')\">\n                                            <img src=\"/img/bin.svg\" width=\"20px\" />\n                                        </button>\n                                    </td>\n                                </tr>\n                            </tbody>\n                        </table>\n                    </div>\n                </div>\n                <button data-toggle=\"tooltip\" data-placement=\"top\" title=\"Agregar\" animation=\"true\" class=\"btn btn-default btn-block btn-success\" (click)=\"agregarNodo()\" [disabled]=\"ubicacionSeleccionada==undefined || ubicacionSeleccionada._id==undefined || !ubicacionSeleccionada.estado || !permisosNodo.get('create')\">\n                    Agregar Nodo\n                </button>\n            </div>\n            <div class=\"item col-xs-12\">\n                <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" style=\"padding: 0px\">\n                    <div class=\"col-xs-4\">\n                        <div id=\"circuloSensor\" class=\"circulo\">4</div>\n                        <h5 class=\"nombre\">Canal de Monitorización</h5>\n                    </div>\n                    <div class=\"col-xs-8 linea\" [ngClass]=\"{'col-xs-8': true,'linea':true,'animarLinea': sensorSeleccionado!= undefined && sensorSeleccionado._id != undefined }\">\n                    </div>\n                </div>\n                <div class=\"tabla col-xs-12\">\n                    <div class=\"table-responsive\" *ngIf=\"nodoSeleccionado\">\n                        <table class=\"table\">\n                            <thead>\n                                <tr>\n                                    <th>Etiqueta</th>\n                                    <th></th>\n                                    <th></th>\n                                </tr>\n                            </thead>\n                            <tbody>\n                                <tr *ngFor=\"let sensor of nodoSeleccionado.sensores_id\" (click)=\"seleccionarSensor(sensor._id)\" [ngClass]=\"{'warning': sensorSeleccionado != undefined && sensor._id == sensorSeleccionado._id, 'danger': !sensor.estado && sensor._id != sensorSeleccionado._id}\" [hidden]=\"(sensor.posicionString == 9  && usuarioConectado.rol != 'Administrador' && usuarioConectado.rol != 'Tecnico')\">\n                                    <td>{{sensor.etiqueta}}</td>\n                                    <td>\n                                        <button id=\"edit\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Editar\" class=\"btn btn-default btn-sm btn-warning botonFila\" (click)=\"modificarSensor($event,sensor._id)\" [disabled]=\"!sensor.estado || !permisosSensor.get('update')\">\n                                            <img src=\"/img/edit.svg\" width=\"20px\" />\n                                        </button>\n                                    </td>\n                                    <td>\n                                        <button *ngIf=\"sensor.estado\" id=\"edit\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Eliminar\" class=\"btn btn-default btn-sm btn-danger botonFila\" (click)=\"eliminarSensor($event,sensor._id)\" [disabled]=\"!permisosSensor.get('delete')\">\n                                            <img [src]=\"sensor.estado==true ? '/img/bin.svg' : '/img/restaurar.svg'\" width=\"20px\" />\n                                        </button>\n                                        <button *ngIf=\"!sensor.estado\" id=\"edit\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Restaurar\" class=\"btn btn-default btn-sm btn-danger botonFila\" (click)=\"eliminarSensor($event,sensor._id)\" [disabled]=\"!permisosSensor.get('delete')\">\n                                            <img [src]=\"sensor.estado==true ? '/img/bin.svg' : '/img/restaurar.svg'\" width=\"20px\" />\n                                        </button>\n                                    </td>\n                                </tr>\n                            </tbody>\n                        </table>\n                    </div>\n                </div>\n                <button data-toggle=\"tooltip\" data-placement=\"top\" title=\"Agregar\" animation=\"true\" class=\"btn btn-default btn-block btn-success\" (click)=\"agregarSensor()\" [disabled]=\"nodoSeleccionado==undefined || nodoSeleccionado._id==undefined || !nodoSeleccionado.estado || !permisosSensor.get('create')\">\n                    Agregar Canal\n                </button>\n            </div>\n            <div class=\"item col-xs-12\">\n                <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" style=\"padding: 0px\">\n                    <div class=\"col-xs-4\">\n                        <div id=\"circuloAlarma\" class=\"circulo\">5</div>\n                        <h5 class=\"nombre\">Alarmas</h5>\n                    </div>\n                    <div class=\"col-xs-8 linea\" [ngClass]=\"{'col-xs-8': true,'linea':true,'animarLinea': alarmaSeleccionada!= undefined && alarmaSeleccionada._id != undefined }\">\n                    </div>\n                </div>\n                <div class=\"tabla col-xs-12\">\n                    <div class=\"table-responsive\" *ngIf=\"sensorSeleccionado\">\n                        <table class=\"table\">\n                            <thead>\n                                <tr>\n                                    <th>Etiqueta</th>\n                                    <th>Valor Mínimo</th>\n                                    <th>Valor Máximo</th>\n                                    <th></th>\n                                    <th></th>\n                                </tr>\n                            </thead>\n                            <tbody>\n                                <tr *ngFor=\"let alarma of sensorSeleccionado.alarmas\" (click)=\"seleccionarAlarma(alarma._id)\" [ngClass]=\"{'warning': alarmaSeleccionada != undefined && alarma._id == alarmaSeleccionada._id, 'danger': !alarma.estado && alarma._id != alarmaSeleccionada._id}\">\n                                    <td>{{alarma.descripcion}}</td>\n                                    <td>{{alarma.valorMinimo}}</td>\n                                    <td>{{alarma.valorMaximo}}</td>\n                                    <td>\n                                        <button id=\"edit\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Editar\" class=\"btn btn-default btn-sm btn-warning botonFila\" (click)=\"modificarAlarma($event,alarma._id)\" [disabled]=\"!alarma.estado || !permisosAlarma.get('update')\">\n                                            <img src=\"/img/edit.svg\" width=\"20px\" />\n                                        </button>\n                                    </td>\n                                    <td>\n                                        <button *ngIf=\"alarma.estado\" id=\"edit\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Eliminar\" class=\"btn btn-default btn-sm btn-danger botonFila\" (click)=\"eliminarAlarma($event,alarma._id)\" [disabled]=\"!permisosAlarma.get('delete')\">\n                                            <img [src]=\"alarma.estado==true ? '/img/bin.svg' : '/img/restaurar.svg'\" width=\"20px\" />\n                                        </button>\n                                        <button *ngIf=\"!alarma.estado\" id=\"edit\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Restaurar\" class=\"btn btn-default btn-sm btn-danger botonFila\" (click)=\"eliminarAlarma($event,alarma._id)\" [disabled]=\"!permisosAlarma.get('delete')\">\n                                            <img [src]=\"alarma.estado==true ? '/img/bin.svg' : '/img/restaurar.svg'\" width=\"20px\" />\n                                        </button>\n                                    </td>\n                                </tr>\n                            </tbody>\n                        </table>\n                    </div>\n                </div>\n                <button data-toggle=\"tooltip\" data-placement=\"top\" title=\"Agregar\" animation=\"true\" class=\"btn btn-default btn-block btn-success\" (click)=\"agregarAlarma()\" [disabled]=\"sensorSeleccionado==undefined || sensorSeleccionado._id==undefined || !sensorSeleccionado.estado || !permisosAlarma.get('create')\">\n                    Agregar Alarma\n                </button>\n            </div>\n            <div class=\"item col-xs-12\">\n                <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" style=\"padding: 0px\">\n                    <div class=\"col-xs-4\">\n                        <div id=\"circuloAviso\" class=\"circulo\" style=\"padding-top: 16px\">6</div>\n                        <h5 class=\"nombre\">Avisos</h5>\n                    </div>\n                    <div class=\"col-xs-8 linea\" [ngClass]=\"{'col-xs-8': true,'linea':true,'animarLinea': avisoSeleccionado!= undefined && avisoSeleccionado._id != undefined }\">\n                    </div>\n                </div>\n                <div class=\"tabla col-xs-12\" style=\"padding-right: 30px;\">\n                    <div class=\"table-responsive\" *ngIf=\"alarmaSeleccionada\">\n                        <table class=\"table\">\n                            <thead>\n                                <tr>\n                                    <th>Nombre</th>\n                                    <th></th>\n                                    <th></th>\n                                </tr>\n                            </thead>\n                            <tbody>\n                                <tr *ngFor=\"let aviso of alarmaSeleccionada.avisosLista\" [ngClass]=\"{'warning': avisoSeleccionado != undefined && aviso._id == avisoSeleccionado._id, 'danger': !aviso.estado && aviso._id != avisoSeleccionado._id}\">\n                                    <td>{{aviso.nombre}}</td>\n                                    <td>\n                                        <button id=\"edit\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Editar\" class=\"btn btn-default btn-sm btn-warning botonFila\" (click)=\"modificarAviso($event,aviso._id)\" [disabled]=\"!aviso.estado || !permisosAviso.get('update')\">\n                                            <img src=\"/img/edit.svg\" width=\"20px\" />\n                                        </button>\n                                    </td>\n                                    <td>\n                                        <button *ngIf=\"aviso.estado\" id=\"edit\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Eliminar\" class=\"btn btn-default btn-sm btn-danger botonFila\" (click)=\"eliminarAviso($event,aviso._id)\" [disabled]=\"!permisosAviso.get('delete')\">\n                                            <img [src]=\"aviso.estado==true ? '/img/bin.svg' : '/img/restaurar.svg'\" width=\"20px\" />\n                                        </button>\n                                        <button *ngIf=\"!aviso.estado\" id=\"edit\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Resturar\" class=\"btn btn-default btn-sm btn-danger botonFila\" (click)=\"eliminarAviso($event,aviso._id)\" [disabled]=\"!permisosAviso.get('delete')\">\n                                            <img [src]=\"aviso.estado==true ? '/img/bin.svg' : '/img/restaurar.svg'\" width=\"20px\" />\n                                        </button>\n                                    </td>\n                                </tr>\n                            </tbody>\n                        </table>\n                    </div>\n                </div>\n                <button data-toggle=\"tooltip\" data-placement=\"top\" title=\"Agregar\" animation=\"true\" class=\"btn btn-default btn-block btn-success\" (click)=\"agregarAviso()\" [disabled]=\"alarmaSeleccionada==undefined || alarmaSeleccionada._id==undefined || !alarmaSeleccionada.estado || !permisosAviso.get('create')\">\n                    Agregar Aviso\n                </button>\n            </div>\n        </owl-carousel>\n    </div>\n</div>\n<ubicacion [sucursal]=\"sucursalSeleccionada\" [ubicacion]=\"ubicacionSeleccionada\" (permisos)=\"permisosUbicacion = $event.permisos\"></ubicacion>\n<nodo [nodo]=\"nodoSeleccionado\" [ubicacion]=\"ubicacionSeleccionada\" (permisos)=\"permisosNodo = $event.permisos\"></nodo>\n<sensor [nodo]=\"nodoSeleccionado\" [sensor]=\"sensorSeleccionado\" [sucursal]=\"sucursalSeleccionada\" (permisos)=\"permisosSensor = $event.permisos\"></sensor>\n<abmalarmas [alarma]=\"alarmaSeleccionada\" [sensor]=\"sensorSeleccionado\" [sucursal]=\"sucursalSeleccionada\" (permisos)=\"permisosAlarma = $event.permisos\"></abmalarmas>\n<aviso [alarma]=\"alarmaSeleccionada\" [aviso]=\"avisoSeleccionado\" [sucursal]=\"sucursalSeleccionada\" (permisos)=\"permisosAviso = $event.permisos\"></aviso>\n\n";

/***/ }),
/* 982 */
/***/ (function(module, exports) {

	module.exports = ".item {\n    background-color: white;\n    border: 1px solid rgba(226, 222, 222, .3);\n    padding: 10px;\n    min-height: 80vh;\n}\n\n.tabla {\n    overflow: scroll;\n    height: 50vh;\n    margin-top: 35px;\n    margin-bottom: 20px;\n}\n\n.botonAgregar {\n    position: absolute;\n    bottom: 15px;\n    border-radius: 100%;\n    width: 50px;\n    height: 50px;\n    right: 15px;\n}\n\n.botonFila {\n    width: 30px;\n    height: 30px;\n    padding: 6px;\n    border-radius: 100%;\n}\n\n.circulo {\n    border: 3px solid #DCDCDC;\n    width: 70px;\n    height: 70px;\n    border-radius: 50%;\n    padding-top: 10px;\n    color: #DCDCDC;\n    font-size: 30px;\n    text-align: center;\n}\n\n.circulo.active {\n    background-color: #E76049;\n    border: none;\n    color: white;\n}\n\n.nombre{\n    min-height: 30px;\n}\n\n.linea {\n    border-bottom: 3px solid #DCDCDC;\n    height: 35px;\n    transform-origin: 0% 50%;\n    display: none;\n}\n\n.animarLinea {\n    animation: extender 2s;\n    display: inline;\n}\n\n@keyframes extender {\n    from {\n        transform: scaleX(0);\n    }\n    to {\n        transform: scaleX(1);\n    }\n}\n\n.control {\n    position: absolute;\n    top: 0px;\n    height: 100%;\n    width: 5%;\n    z-index: 10;\n    text-align: center;\n    vertical-align: middle;\n    color: transparent;\n    font-size: 40px;\n    padding-top: 25%;\n}\n\n.control-der {\n    right: 15px;\n}\n\n.control-izq:hover {\n    background-image: linear-gradient(to left, rgba(0, 0, 0, .0001) 0, rgba(0, 0, 0, .5) 100%);\n    opacity: .9;\n    color: white;\n}\n\n.control-der:hover {\n    background-image: linear-gradient(to right, rgba(0, 0, 0, .0001) 0, rgba(0, 0, 0, .5) 100%);\n    opacity: .9;\n    color: white;\n}\n\n.h5 {\n    font-family: \"Raleway Bold\";\n}\n\n@media (max-width: 769px) {\n    .marcoConfiguracion {\n        padding-right: 0px;\n        padding-left: 0px;\n    }\n}"

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var usuario_service_1 = __webpack_require__(430);
	var sucursal_1 = __webpack_require__(908);
	var usuario_1 = __webpack_require__(984);
	var sucursal_service_1 = __webpack_require__(429);
	var rol_service_1 = __webpack_require__(432);
	var empresa_service_1 = __webpack_require__(425);
	var permiso_service_1 = __webpack_require__(427);
	var router_1 = __webpack_require__(329);
	var login_service_1 = __webpack_require__(381);
	__webpack_require__(653);
	var myGlobals = __webpack_require__(414);
	var UsuariosComponent = (function () {
	    function UsuariosComponent(usuarioService, sucursalService, empresaService, loginService, permisoService, rolService, router) {
	        this.usuarioService = usuarioService;
	        this.sucursalService = sucursalService;
	        this.empresaService = empresaService;
	        this.loginService = loginService;
	        this.permisoService = permisoService;
	        this.rolService = rolService;
	        this.router = router;
	    }
	    UsuariosComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        window.scrollTo(0, 0);
	        //Perdir permisos
	        this.permisos = new Map();
	        this.permisoService.getPermiso("usuarios").subscribe(function (permisos) {
	            for (var _i = 0, _a = permisos.tipoPermiso; _i < _a.length; _i++) {
	                var permiso = _a[_i];
	                _this.permisos.set(permiso.descripcion, true);
	            }
	            //Si no tiene permiso para ver redirijo
	            if (!_this.permisos.get("read"))
	                _this.router.navigate(['/home']);
	        });
	        //Inicializar tabla
	        $("#grid-data").bootgrid({
	            ajax: true,
	            url: myGlobals.default.BASE_URL + "/usuarios/usuariosTable",
	            selection: true,
	            multiSelect: false,
	            rowSelect: true,
	            formatters: {
	                "empresa": function (column, row) {
	                    return row.sucursales[0] != undefined ? row.sucursales[0].empresa.descripcion : "Usuario Ilimitado";
	                },
	                "estado": function (column, row) {
	                    return row.estado == true ? "Activo" : "<span class=\"label label-danger\">Inactivo</span>";
	                },
	                "rol": function (column, row) {
	                    return row.rol != undefined ? row.rol.descripcion : "Sin Rol";
	                },
	            },
	            ajaxSettings: {
	                headers: {
	                    "Authorization": this.loginService.getToken()
	                },
	                method: "GET"
	            }
	        });
	        $("#alertSeleccion").hide();
	        //Inicializar banderas para resetear forms
	        this.active = true;
	        this.active2 = true;
	        //  Cargar empresas
	        this.empresaService.getEmpresas()
	            .subscribe(function (empresas) {
	            _this.empresas = empresas;
	        });
	        this.rolService.getRoles()
	            .subscribe(function (roles) {
	            _this.roles = roles;
	            //Buscar admin
	            _this.roles.forEach(function (rol) {
	                if (rol.descripcion == "Administrador") {
	                    this.administrador = rol._id;
	                }
	            }.bind(_this));
	        });
	        //Inicializar sucursal
	        this.sucursal = new sucursal_1.Sucursal();
	        this.usuario = new usuario_1.Usuario();
	        this.usuario.sucursales = [];
	        //Inicializar bandera deshabilitar
	        this.deshabilitar = false;
	        //Inicializar pruebaSMS
	        this.pruebaSMS = false;
	        this.probando = false;
	        this.saving = false;
	    };
	    UsuariosComponent.prototype.ngOnDestroy = function () {
	    };
	    UsuariosComponent.prototype.agregar = function () {
	        var _this = this;
	        //Cerrar alert
	        $("#alertUsuario").hide();
	        //Inicializo variables
	        this.usuario = new usuario_1.Usuario();
	        this.sucursal = new sucursal_1.Sucursal();
	        this.deshabilitar = false;
	        $("#pass").show();
	        this.passRequired = true;
	        //Mostrar modal
	        $("#modalUsuario").modal("show");
	        //Reseteo form1 para eliminar errores
	        this.active = false;
	        setTimeout(function () { return _this.active = true; }, 0);
	        //Reseteo form2 para eliminar errores
	        setTimeout(function () { return _this.active2 = false; }, 0);
	        setTimeout(function () { return _this.active2 = true; }, 0);
	        this.pruebaSMS = false;
	    };
	    UsuariosComponent.prototype.modificar = function () {
	        var _this = this;
	        $("#pass").hide();
	        this.passRequired = false;
	        //Obtener id seleccionado
	        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
	        //Si no hay nada seleccionado mostrar alert
	        if (this.idSeleccionado == undefined) {
	            $("#alertSeleccion").show();
	        }
	        else {
	            if (this.idSeleccionado != "0") {
	                //Cerrar alert
	                $("#alertSeleccion").hide();
	                //Busco usuario
	                this.usuarioService
	                    .getUsuario(this.idSeleccionado)
	                    .subscribe(function (user) {
	                    _this.usuario = user;
	                });
	                //Seteo bandera para deshabilitar
	                this.deshabilitar = false;
	                //Ocultar modal
	                $("#modalUsuario").modal("show");
	                this.pruebaSMS = false;
	            }
	        }
	    };
	    UsuariosComponent.prototype.eliminar = function () {
	        var _this = this;
	        //Obtener id seleccionado
	        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
	        //Si no hay nada seleccionado mostrar alert
	        if (this.idSeleccionado == undefined) {
	            $("#alertSeleccion").show();
	        }
	        else {
	            if (this.idSeleccionado != "0") {
	                //Cerrar alert
	                $("#alertSeleccion").hide();
	                //Busco usuario
	                this.usuarioService
	                    .getUsuario(this.idSeleccionado)
	                    .subscribe(function (usuario) {
	                    _this.usuarioService.delete(usuario).subscribe(function () { return $("#grid-data").bootgrid("reload"); });
	                });
	            }
	        }
	    };
	    UsuariosComponent.prototype.ver = function () {
	        var _this = this;
	        //Obtener id seleccionado
	        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
	        //Si no hay nada seleccionado mostrar alert
	        if (this.idSeleccionado == undefined) {
	            $("#alertSeleccion").show();
	        }
	        else {
	            if (this.idSeleccionado != "0") {
	                //Cerrar alert
	                $("#alertSeleccion").hide();
	                //Busco sucursal
	                this.usuarioService
	                    .getUsuario(this.idSeleccionado)
	                    .subscribe(function (usuario) {
	                    _this.usuario = usuario;
	                });
	                this.deshabilitar = true;
	                //Muestro modal
	                $("#modalUsuario").modal("show");
	                this.pruebaSMS = false;
	            }
	        }
	    };
	    UsuariosComponent.prototype.save = function () {
	        var _this = this;
	        if (this.usuario.rol == this.administrador) {
	            this.usuario.sucursales = [];
	        }
	        this.saving = true;
	        this.usuarioService
	            .save(this.usuario)
	            .subscribe(function (usuario) {
	            _this.usuario = usuario;
	            //Inicializo variables
	            _this.saving = false;
	            _this.usuario = new usuario_1.Usuario();
	            //Ocultar modal
	            $("#modalUsuario").modal("hide");
	            //Reseteo formUsuario para eliminar errores
	            _this.active = false;
	            setTimeout(function () { return _this.active = true; }, 0);
	            //Recargo tabla
	            $("#grid-data").bootgrid("reload");
	        }, function (error) {
	            _this.saving = false;
	        });
	    };
	    UsuariosComponent.prototype.agregarSucursal = function (sucursalId) {
	        var _this = this;
	        if (!this.modificoSucursal && sucursalId != "") {
	            //Inicializar arreglo
	            if (this.usuario.sucursales == undefined)
	                this.usuario.sucursales = [];
	            //Agregar Sucursal
	            this.sucursalService.getSucursal(sucursalId)
	                .subscribe(function (sucursal) {
	                if (_this.usuario.sucursales.filter(function (e) {
	                    return e._id == sucursal._id;
	                }.bind(_this)).length == 0) {
	                    _this.sucursal = sucursal;
	                    _this.usuario.sucursales.push(_this.sucursal);
	                    //Limpiar Sucursal
	                    _this.sucursal = new sucursal_1.Sucursal();
	                }
	                else
	                    alert("La sucursal seleccionada ya esta habilitada para el usuario.");
	            });
	        }
	        else {
	            //Limpiar sucursal
	            this.sucursal = new sucursal_1.Sucursal();
	            //Seteo bandera
	            this.modificoSucursal = false;
	        }
	        //Reseteo formSucursal para eliminar errores
	        setTimeout(function () { return _this.active2 = false; }, 0);
	        setTimeout(function () { return _this.active2 = true; }, 0);
	    };
	    UsuariosComponent.prototype.eliminarSucursal = function (index) {
	        //Eliminar sucursal de la lista
	        this.usuario.sucursales.splice(index, 1);
	    };
	    UsuariosComponent.prototype.cargarSucursales = function (idEmpresa) {
	        var _this = this;
	        if (idEmpresa != "") {
	            this.sucursalService.getSucursalByEmpresa(idEmpresa)
	                .subscribe(function (sucursales) {
	                _this.sucursales = sucursales;
	            });
	        }
	    };
	    UsuariosComponent.prototype.hideAlert = function () {
	        $("#alertSeleccion").hide();
	    };
	    UsuariosComponent.prototype.probarCelular = function () {
	        var _this = this;
	        this.pruebaSMS = false;
	        this.probando = true;
	        if (this.usuario.celular != "") {
	            console.log("OK");
	            this.usuarioService.probarCelular(this.usuario.celular)
	                .subscribe(function (result) {
	                console.log("OK");
	                _this.pruebaSMS = true;
	                _this.probando = false;
	                $(document).on('hidden.bs.modal', '.modal', function () {
	                    $('.modal:visible').length && $(document.body).addClass('modal-open');
	                });
	            }, function (error) {
	                _this.probando = false;
	            });
	        }
	    };
	    UsuariosComponent = __decorate([
	        core_1.Component({
	            selector: 'usuario',
	            template: __webpack_require__(985),
	            styles: [__webpack_require__(986)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof usuario_service_1.UsuariosService !== 'undefined' && usuario_service_1.UsuariosService) === 'function' && _a) || Object, (typeof (_b = typeof sucursal_service_1.SucursalService !== 'undefined' && sucursal_service_1.SucursalService) === 'function' && _b) || Object, (typeof (_c = typeof empresa_service_1.EmpresaService !== 'undefined' && empresa_service_1.EmpresaService) === 'function' && _c) || Object, (typeof (_d = typeof login_service_1.LoginService !== 'undefined' && login_service_1.LoginService) === 'function' && _d) || Object, (typeof (_e = typeof permiso_service_1.PermisoService !== 'undefined' && permiso_service_1.PermisoService) === 'function' && _e) || Object, (typeof (_f = typeof rol_service_1.RolService !== 'undefined' && rol_service_1.RolService) === 'function' && _f) || Object, (typeof (_g = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _g) || Object])
	    ], UsuariosComponent);
	    return UsuariosComponent;
	    var _a, _b, _c, _d, _e, _f, _g;
	}());
	exports.UsuariosComponent = UsuariosComponent;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(419)))

/***/ }),
/* 984 */
/***/ (function(module, exports) {

	"use strict";
	var Usuario = (function () {
	    function Usuario() {
	    }
	    return Usuario;
	}());
	exports.Usuario = Usuario;


/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 contenido\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 titulo\">\n        <div class=\"marcoTitulo\">\n            <h2>Usuarios</h2>\n            <p>Home / Carga Datos / Usuarios</p>\n        </div>\n    </div>\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 marcoDatos\">\n        <div class=\"datos\">\n            <div class=\"alert alert-warning\" id=\"alertSeleccion\" name=\"alertSeleccion\">\n                <a class=\"close\" (click)=\"hideAlert()\">&times;</a> Debe selecccionar una casilla primero.\n            </div>\n            <div class=\"table-responsive\">\n                <table id=\"grid-data\" class=\"table table-condensed table-hover \">\n                    <thead>\n                    <tr>\n                        <th data-column-id=\"_id\" data-identifier=\"true\" data-visible=\"false\"\n                            data-visible-in-selection=\"false\" data-order=\"desc\">_id\n                        </th>\n                        <th data-column-id=\"empresa\" data-formatter=\"empresa\" data-sortable=\"false\">Empresa</th>\n                        <th data-column-id=\"dni\">DNI</th>\n                        <th data-column-id=\"apellido\">Apellido</th>\n                        <th data-column-id=\"nombre\">Nombre</th>\n                        <th data-column-id=\"rol\" data-formatter=\"rol\">Rol</th>\n                        <th data-column-id=\"estado\" data-formatter=\"estado\">Estado</th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n    <button data-toggle=\"tooltip\" data-placement=\"top\" title=\"Eliminar\" animation=\"true\"\n            class=\"btn btn-default btn-sm botonFlotante btn-danger\" (click)=\"eliminar()\"\n            [disabled]=\"permisos.get('delete')!=true\">\n        <img src=\"" + __webpack_require__(933) + "\" width=\"20px\"/>\n    </button>\n    <button data-toggle=\"tooltip\" data-placement=\"top\" title=\"Modificar\" animation=\"true\"\n            class=\"btn btn-default btn-sm botonFlotante2 btn-warning\" (click)=\"modificar()\"\n            [disabled]=\"permisos.get('update')!=true\">\n        <img src=\"" + __webpack_require__(934) + "\" width=\"25px\"/>\n    </button>\n    <button data-toggle=\"tooltip\" data-placement=\"top\" title=\"Agregar\" animation=\"true\"\n            class=\"btn btn-default btn-sm botonFlotante3 btn-success\" (click)=\"agregar()\"\n            [disabled]=\"permisos.get('create')!=true\">\n        <img src=\"" + __webpack_require__(935) + "\" width=\"25px\"/>\n    </button>\n    <button data-toggle=\"tooltip\" data-placement=\"top\" title=\"Ver\" animation=\"true\"\n            class=\"btn btn-default btn-sm botonFlotante4 btn-primary\" (click)=\"ver()\"\n            [disabled]=\"permisos.get('read')!=true\">\n        <img src=\"" + __webpack_require__(936) + "\" width=\"30px\"/>\n    </button>\n</div>\n<!-- Modal -->\n<div class=\"modal fade\" id=\"modalUsuario\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\">\n    <div class=\"modal-dialog\" role=\"document\">\n        <div class=\"modal-content\">\n            <form #usuarioForm=\"ngForm\" *ngIf=\"active\">\n                <div class=\"modal-header\">\n                    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span\n                            aria-hidden=\"true\">&times;</span></button>\n                    <h4 class=\"modal-title\" id=\"myModalLabel\">Usuario</h4>\n                </div>\n                <div class=\"modal-body\">\n                    <p *ngIf=\"usuario._id==null || usuario._id==undefined\">Se le enviará un email al nuevo usuario\n                        informando contraseña provisoria.</p>\n                    <div class=\"form-group\">\n                        <label for=\"rol\">Rol</label>\n                        <select class=\"form-control\" required id=\"rol\" name=\"rol\" [(ngModel)]=\"usuario.rol\"\n                                autocomplete=\"off\" #rol=\"ngModel\" [disabled]=\"deshabilitar\">\n                            <option></option>\n                            <option *ngFor=\"let rol of roles\" [value]=\"rol._id\">{{rol.descripcion}}</option>\n                        </select>\n                        <div [hidden]=\"rol.valid || rol.pristine\" class=\"alert alert-danger\">\n                            Rol es requerido\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"apellido\">Apellido</label>\n                        <input type=\"text\" required class=\"form-control\" id=\"apellido\" name=\"apellido\"\n                               placeholder=\"Apellido\" [(ngModel)]=\"usuario.apellido\" #apellido=\"ngModel\"\n                               autocomplete=\"off\" [disabled]=\"deshabilitar\">\n                        <div [hidden]=\"apellido.valid || apellido.pristine\" class=\"alert alert-danger\">\n                            Apellido es requerido\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"nombre\">Nombre</label>\n                        <input type=\"text\" required class=\"form-control\" id=\"nombre\" name=\"nombre\" placeholder=\"Nombre\"\n                               [(ngModel)]=\"usuario.nombre\" #nombre=\"ngModel\" autocomplete=\"off\"\n                               [disabled]=\"deshabilitar\">\n                        <div [hidden]=\"nombre.valid || nombre.pristine\" class=\"alert alert-danger\">\n                            Nombre es requerido\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"dni\">DNI</label>\n                        <input type=\"number\" required class=\"form-control\" id=\"dni\" name=\"dni\" placeholder=\"Dni\"\n                               [(ngModel)]=\"usuario.dni\" #dni=\"ngModel\" autocomplete=\"off\" [disabled]=\"deshabilitar\">\n                        <div [hidden]=\"dni.valid || dni.pristine\" class=\"alert alert-danger\">\n                            DNI es requerido\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"puesto\">Puesto</label>\n                        <input type=\"text\" required class=\"form-control\" id=\"puesto\" name=\"puesto\" placeholder=\"Puesto\"\n                               [(ngModel)]=\"usuario.puesto\" #puesto=\"ngModel\" autocomplete=\"off\"\n                               [disabled]=\"deshabilitar\">\n                        <div [hidden]=\"puesto.valid || puesto.pristine\" class=\"alert alert-danger\">\n                            Puesto es requerido\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"mail\">E-mail</label>\n                        <input type=\"text\" required class=\"form-control\" id=\"mail\" name=\"mail\" placeholder=\"Mail\"\n                               [(ngModel)]=\"usuario.email\"\n                               pattern=\"^[_a-z0-9-]+(\\.[_a-z0-9-]+)*@[a-z0-9-]+(\\.[a-z0-9-]+)*(\\.[a-z]{2,3})$\"\n                               #mail=\"ngModel\" autocomplete=\"off\" [disabled]=\"deshabilitar\">\n                        <div [hidden]=\"mail.valid || mail.pristine\" class=\"alert alert-danger\">\n                            E-mail es requerido\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"celular\">Celular (+549 + código de área + número de celular sin el 15)</label>\n                        <p class=\"text-success\" [hidden]=\"!pruebaSMS\">Mensaje enviado! Verifica si el mensaje llego correctamente.\n                            Si no es así verifica que el número tenga el formato correcto.</p>\n                        <div class=\"input-group\">\n                            <input type=\"text\" class=\"form-control\" id=\"celular\" pattern='\\+549\\d{1,14}$'\n                                   name=\"celular\" placeholder=\"+5493410000000\" [(ngModel)]=\"usuario.celular\"\n                                   #celular=\"ngModel\" autocomplete=\"off\" [disabled]=\"deshabilitar\">\n                            <span class=\"input-group-btn\">\n                                <button class=\"btn btn-default\" type=\"button\" [disabled]=\"!celular.valid || !usuario.celular || probando\" (click)=\"probarCelular()\">\n                                    Probar\n                                </button>\n                            </span>\n                        </div>\n                        <div [hidden]=\"celular.valid || celular.pristine\" class=\"alert alert-danger\">\n                            Celular es requerido y debe cumplir con el formato (+549 + código de área + número de celular sin el 15)\n                        </div>\n                    </div>\n\n                    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                        <div class=\"table-responsive\">\n                            <table class=\"table\">\n                                <thead>\n                                <tr>\n                                    <th>Sucursal</th>\n                                    <th>Direccion</th>\n                                    <th></th>\n                                </tr>\n                                <tr *ngFor=\"let sucursal of usuario.sucursales; let i = index\">\n                                    <td>{{sucursal.descripcion}}</td>\n                                    <td>{{sucursal.direccion}}</td>\n                                    <td class=\"td-btn\">\n                                        <button class=\"btn btn-default\" (click)=\"eliminarSucursal(i)\"\n                                                [disabled]=\"deshabilitar\">\n                                            <span class=\"glyphicon glyphicon-trash\"></span>\n                                        </button>\n                                    </td>\n                                </tr>\n                                </thead>\n                                <tbody>\n                                <td class=\"text-center\"\n                                    *ngIf=\"usuario.sucursales == undefined || usuario.sucursales.length==0\" colspan=\"6\">\n                                    No hay sucursales asignadas\n                                </td>\n                                </tbody>\n                            </table>\n                        </div>\n                    </div>\n\n                    <form #sucursalForm=\"ngForm\" *ngIf=\"active2\">\n                        <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" [hidden]=\"administrador==usuario.rol\"\n                             style=\"border: 1px solid rgba(176, 176, 178, 0.3); padding-top:15px; padding-bottom:15px\">\n                            <h5 style=\"font-family:'Raleway 2'; text-align:center\">Agregar Sucursal</h5>\n                            <div class=\"form-group\">\n                                <label for=\"empresa\">Empresa</label>\n                                <div>\n                                    <select class=\"form-control\" required id=\"empresa\" name=\"empresaId\"\n                                            [(ngModel)]=\"empresa._id\" autocomplete=\"off\"\n                                            (change)=\"cargarSucursales($event.target.value)\" #empresa=\"ngModel\"\n                                            [disabled]=\"deshabilitar\">\n                                        <option></option>\n                                        <option *ngFor=\"let empresa of empresas\" value={{empresa._id}}>\n                                            {{empresa.descripcion}}\n                                        </option>\n                                    </select>\n                                </div>\n                            </div>\n                            <div class=\"form-group\">\n                                <label for=\"sucursal\">Sucursal</label>\n                                <select class=\"form-control\" required id=\"sucursal\" name=\"sucursalId\"\n                                        [(ngModel)]=\"sucursal.descripcion\" autocomplete=\"off\" #sucursal=\"ngModel\"\n                                        [disabled]=\"deshabilitar\">\n                                    <option></option>\n                                    <option *ngFor=\"let sucursal of sucursales\" value={{sucursal._id}}>\n                                        {{sucursal.descripcion}}\n                                    </option>\n                                </select>\n                                <div [hidden]=\"sucursal.valid || sucursal.pristine\" class=\"alert alert-danger\">\n                                    Sucursal es requerido\n                                </div>\n                            </div>\n                            <button *ngIf=\"!modificoSucursal\" class=\"btn btn-block btn-success\"\n                                    (click)=\"agregarSucursal(sucursal.value)\"\n                                    [disabled]=\"deshabilitar || !sucursalForm.form.valid\">Agregar Sucursal\n                            </button>\n                            <button *ngIf=\"modificoSucursal\" class=\"btn btn-block btn-primary\"\n                                    (click)=\"agregarSucursal(sucursal.value)\"\n                                    [disabled]=\"deshabilitar || !sucursalForm.form.valid\">Aceptar\n                            </button>\n                        </div>\n                    </form>\n                </div>\n                <div class=\"clearfix visible-md-block\"></div>\n                <div class=\"clearfix visible-lg-block\"></div>\n                <div class=\"clearfix visible-sm-block\"></div>\n                <div class=\"clearfix visible-xs-block\"></div>\n                <div class=\"modal-footer\">\n                    <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Cancelar</button>\n                    <button type=\"button\" (click)=\"save()\" class=\"btn btn-success\"\n                            [disabled]=\"deshabilitar || !usuarioForm.form.valid || saving\">Guardar\n                    </button>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 986 */
944,
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var permiso_service_1 = __webpack_require__(427);
	var router_1 = __webpack_require__(329);
	var tipoVariable_service_1 = __webpack_require__(431);
	var tipoVariable_1 = __webpack_require__(988);
	var login_service_1 = __webpack_require__(381);
	__webpack_require__(653);
	var myGlobals = __webpack_require__(414);
	var TipoVariableComponent = (function () {
	    function TipoVariableComponent(tipoVariableService, permisoService, loginService, router) {
	        this.tipoVariableService = tipoVariableService;
	        this.permisoService = permisoService;
	        this.loginService = loginService;
	        this.router = router;
	    }
	    TipoVariableComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        window.scrollTo(0, 0);
	        //Perdir permisos
	        this.permisos = new Map();
	        this.permisoService.getPermiso("tipoVariable").subscribe(function (permisos) {
	            for (var _i = 0, _a = permisos.tipoPermiso; _i < _a.length; _i++) {
	                var permiso = _a[_i];
	                _this.permisos.set(permiso.descripcion, true);
	            }
	            //Si no tiene permiso para ver redirijo
	            if (!_this.permisos.get("read"))
	                _this.router.navigate(['/home']);
	        });
	        //Inicializar tabla
	        $("#grid-data").bootgrid({
	            ajax: true,
	            url: myGlobals.default.BASE_URL + "/tipoVariable/tipoVariableTable",
	            selection: true,
	            multiSelect: false,
	            rowSelect: true,
	            formatters: {
	                "estado": function (column, row) {
	                    return row.estado == true ? "Activo" : "<span class=\"label label-danger\">Inactivo</span>";
	                }
	            },
	            ajaxSettings: {
	                headers: {
	                    "Authorization": this.loginService.getToken()
	                },
	                method: "GET"
	            }
	        });
	        //Cerrar alert
	        $("#alertSeleccion").hide();
	        //Inicializar banderas para resetear forms
	        this.active = true;
	        //Inicializar
	        this.tipoVariable = new tipoVariable_1.TipoVariable();
	        //Inicializar bandera deshabilitar
	        this.deshabilitar = false;
	    };
	    TipoVariableComponent.prototype.ngOnDestroy = function () {
	    };
	    TipoVariableComponent.prototype.agregar = function () {
	        var _this = this;
	        //Inicializo variables
	        this.tipoVariable = new tipoVariable_1.TipoVariable();
	        this.deshabilitar = false;
	        $("#modalTipoVariable").modal("show");
	        //Reseteo form para eliminar errores
	        this.active = false;
	        setTimeout(function () { return _this.active = true; }, 0);
	    };
	    TipoVariableComponent.prototype.modificar = function () {
	        var _this = this;
	        //Obtener id seleccionado
	        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
	        //Si no hay nada seleccionado mostrar alert
	        if (this.idSeleccionado == undefined) {
	            $("#alertSeleccion").show();
	        }
	        else {
	            if (this.idSeleccionado != "0") {
	                //Cerrar alert
	                $("#alertSeleccion").hide();
	                //Busco tipoVariable
	                this.tipoVariableService
	                    .getTipoVariable(this.idSeleccionado)
	                    .subscribe(function (tipoVariable) {
	                    _this.tipoVariable = tipoVariable;
	                });
	                this.deshabilitar = false;
	                $("#modalTipoVariable").modal("show");
	            }
	        }
	    };
	    TipoVariableComponent.prototype.eliminar = function () {
	        var _this = this;
	        //Obtener id seleccionado
	        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
	        //Si no hay nada seleccionado mostrar alert
	        if (this.idSeleccionado == undefined) {
	            $("#alertSeleccion").show();
	        }
	        else {
	            if (this.idSeleccionado != "0") {
	                //Cerrar alert
	                $("#alertSeleccion").hide();
	                //Busco tipoVariable
	                this.tipoVariableService
	                    .getTipoVariable(this.idSeleccionado)
	                    .subscribe(function (tipoVariable) {
	                    _this.tipoVariableService.delete(tipoVariable).subscribe(function () { return $("#grid-data").bootgrid("reload"); });
	                });
	            }
	        }
	    };
	    TipoVariableComponent.prototype.ver = function () {
	        var _this = this;
	        //Obtener id seleccionado
	        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
	        //Si no hay nada seleccionado mostrar alert
	        if (this.idSeleccionado == undefined) {
	            $("#alertSeleccion").show();
	        }
	        else {
	            if (this.idSeleccionado != "0") {
	                //Cerrar alert
	                $("#alertSeleccion").hide();
	                //Busco tipoVariable
	                this.tipoVariableService
	                    .getTipoVariable(this.idSeleccionado)
	                    .subscribe(function (tipoVariable) {
	                    _this.tipoVariable = tipoVariable;
	                });
	                //Seteo bandera para deshabilitar
	                this.deshabilitar = true;
	                $("#modalTipoVariable").modal("show");
	            }
	        }
	    };
	    TipoVariableComponent.prototype.save = function () {
	        var _this = this;
	        this.tipoVariableService
	            .save(this.tipoVariable)
	            .subscribe(function (tipoVariable) {
	            _this.tipoVariable = tipoVariable;
	            //Inicializo variables
	            _this.tipoVariable = new tipoVariable_1.TipoVariable();
	            console.log(_this.tipoVariable);
	            //Ocultar modal
	            $("#modalTipoVariable").modal("hide");
	            //Reseteo formtipoVariable para eliminar errores
	            _this.active = false;
	            setTimeout(function () { return _this.active = true; }, 0);
	            //Recargo tabla
	            $("#grid-data").bootgrid("reload");
	        });
	    };
	    TipoVariableComponent.prototype.hideAlert = function () {
	        $("#alertSeleccion").hide();
	    };
	    TipoVariableComponent = __decorate([
	        core_1.Component({
	            selector: 'tipoVariable',
	            template: __webpack_require__(989),
	            styles: [__webpack_require__(990)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof tipoVariable_service_1.TipoVariableService !== 'undefined' && tipoVariable_service_1.TipoVariableService) === 'function' && _a) || Object, (typeof (_b = typeof permiso_service_1.PermisoService !== 'undefined' && permiso_service_1.PermisoService) === 'function' && _b) || Object, (typeof (_c = typeof login_service_1.LoginService !== 'undefined' && login_service_1.LoginService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object])
	    ], TipoVariableComponent);
	    return TipoVariableComponent;
	    var _a, _b, _c, _d;
	}());
	exports.TipoVariableComponent = TipoVariableComponent;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(419)))

/***/ }),
/* 988 */
/***/ (function(module, exports) {

	"use strict";
	var TipoVariable = (function () {
	    function TipoVariable() {
	    }
	    return TipoVariable;
	}());
	exports.TipoVariable = TipoVariable;


/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 contenido\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 titulo\">\n        <div class=\"marcoTitulo\">\n            <h2>Tipos de Variables</h2>\n            <p>Home / Carga Datos / Tipos de Variables</p>\n        </div>\n    </div>\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 marcoDatos\">\n        <div class=\"datos\">\n            <div class=\"alert alert-warning\" id=\"alertSeleccion\" name=\"alertSeleccion\">\n                <a class=\"close\" (click)=\"hideAlert()\">&times;</a> Debe selecccionar una casilla primero.\n            </div>\n            <div class=\"table-responsive\">\n                <table id=\"grid-data\" class=\"table table-condensed table-hover \">\n                    <thead>\n                    <tr>\n                        <th data-column-id=\"_id\" data-identifier=\"true\" data-visible=\"false\"\n                            data-visible-in-selection=\"false\" data-order=\"desc\">_id\n                        </th>\n                        <th data-column-id=\"descripcion\">Descripcion</th>\n                        <th data-column-id=\"tipo\">Unidad de Medida</th>\n                        <th data-column-id=\"rangoDesde\">Rango Desde</th>\n                        <th data-column-id=\"rangoHasta\">Rango Hasta</th>\n                        <th data-column-id=\"estado\" data-formatter=\"estado\">Estado</th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n    <button data-toggle=\"tooltip\" data-placement=\"top\" title=\"Eliminar\" animation=\"true\"\n            class=\"btn btn-default btn-sm botonFlotante btn-danger\" (click)=\"eliminar()\"\n            [disabled]=\"permisos.get('delete')!=true\">\n        <img src=\"" + __webpack_require__(933) + "\" width=\"20px\"/>\n    </button>\n    <button data-toggle=\"tooltip\" data-placement=\"top\" title=\"Modificar\" animation=\"true\"\n            class=\"btn btn-default btn-sm botonFlotante2 btn-warning\" (click)=\"modificar()\"\n            [disabled]=\"permisos.get('update')!=true\">\n        <img src=\"" + __webpack_require__(934) + "\" width=\"25px\"/>\n    </button>\n    <button data-toggle=\"tooltip\" data-placement=\"top\" title=\"Agregar\" animation=\"true\"\n            class=\"btn btn-default btn-sm botonFlotante3 btn-success\" (click)=\"agregar()\"\n            [disabled]=\"permisos.get('create')!=true\">\n        <img src=\"" + __webpack_require__(935) + "\" width=\"25px\"/>\n    </button>\n    <button data-toggle=\"tooltip\" data-placement=\"top\" title=\"Ver\" animation=\"true\"\n            class=\"btn btn-default btn-sm botonFlotante4 btn-primary\" (click)=\"ver()\"\n            [disabled]=\"permisos.get('read')!=true\">\n        <img src=\"" + __webpack_require__(936) + "\" width=\"30px\"/>\n    </button>\n</div>\n<!-- Modal -->\n<div class=\"modal fade\" id=\"modalTipoVariable\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\">\n    <div class=\"modal-dialog\" role=\"document\">\n        <div class=\"modal-content\">\n            <form #tipoVariableForm=\"ngForm\" *ngIf=\"active\">\n                <div class=\"modal-header\">\n                    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span\n                            aria-hidden=\"true\">&times;</span></button>\n                    <h4 class=\"modal-title\" id=\"myModalLabel\">Tipo de Variable</h4>\n                </div>\n                <div class=\"modal-body\">\n                    <div class=\"form-group\">\n                        <label for=\"descripcion\">Descripción Del Tipo de Variable</label>\n                        <input type=\"text\" class=\"form-control\" id=\"descripcion\" placeholder=\"Descripción\" required\n                               [(ngModel)]=\"tipoVariable.descripcion\" name=\"descripcion\" #descripcion=\"ngModel\"\n                               autocomplete=\"off\" [disabled]=\"deshabilitar\">\n                        <div [hidden]=\"descripcion.valid || descripcion.pristine\" class=\"alert alert-danger\">\n                            Descripción es requerido\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"tipo\">Unidad de Medida</label>\n                        <input type=\"text\" required class=\"form-control\" id=\"tipo\" name=\"tipo\"\n                               placeholder=\"Unidad de Medida\" [(ngModel)]=\"tipoVariable.tipo\" #tipo=\"ngModel\"\n                               autocomplete=\"off\" [disabled]=\"deshabilitar\">\n                        <div [hidden]=\"tipo.valid || tipo.pristine\" class=\"alert alert-danger\">\n                            Tipo de Variable es requerido\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"rangoDesde\">Límite inferior del rango del Tipo de Variable</label>\n                        <input type=\"number\" required class=\"form-control\" id=\"rangoDesde\" name=\"rangoDesde\"\n                               placeholder=\"Valor Mínimo\" [(ngModel)]=\"tipoVariable.rangoDesde\" #rangoDesde=\"ngModel\"\n                               autocomplete=\"off\" [disabled]=\"deshabilitar\">\n                        <div [hidden]=\"rangoDesde.valid || rangoDesde.pristine\" class=\"alert alert-danger\">\n                            Rango Desde es requerido\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"rangoHasta\">Límite superior del rango del Tipo de Variable</label>\n                        <input type=\"number\" min={{rangoDesde.value}} required class=\"form-control\" id=\"rangoHasta\"\n                               name=\"rangoHasta\" placeholder=\"Valor Máximo\" [(ngModel)]=\"tipoVariable.rangoHasta\"\n                               #rangoHasta=\"ngModel\" autocomplete=\"off\" [disabled]=\"deshabilitar\">\n                        <div [hidden]=\"rangoHasta.valid || rangoHasta.pristine\" class=\"alert alert-danger\">\n                            Rango Hasta es requerido\n                        </div>\n                    </div>\n\n                </div>\n                <div class=\"clearfix visible-md-block\"></div>\n                <div class=\"clearfix visible-lg-block\"></div>\n                <div class=\"clearfix visible-sm-block\"></div>\n                <div class=\"clearfix visible-xs-block\"></div>\n                <div class=\"modal-footer\">\n                    <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Cancelar</button>\n                    <button type=\"button\" (click)=\"save()\" class=\"btn btn-success\"\n                            [disabled]=\"deshabilitar || (tipoVariableForm!=undefined && !tipoVariableForm.form.valid)\">\n                        Guardar\n                    </button>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 990 */
944,
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var permiso_service_1 = __webpack_require__(427);
	var router_1 = __webpack_require__(329);
	var tipoBateria_service_1 = __webpack_require__(577);
	var tipoBateria_1 = __webpack_require__(992);
	var login_service_1 = __webpack_require__(381);
	__webpack_require__(653);
	var myGlobals = __webpack_require__(414);
	var TipoBateriaComponent = (function () {
	    function TipoBateriaComponent(tipoBateriaService, permisoService, loginService, router) {
	        this.tipoBateriaService = tipoBateriaService;
	        this.permisoService = permisoService;
	        this.loginService = loginService;
	        this.router = router;
	    }
	    TipoBateriaComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        window.scrollTo(0, 0);
	        //Perdir permisos
	        this.permisos = new Map();
	        this.permisoService.getPermiso("tipoBateria").subscribe(function (permisos) {
	            for (var _i = 0, _a = permisos.tipoPermiso; _i < _a.length; _i++) {
	                var permiso = _a[_i];
	                _this.permisos.set(permiso.descripcion, true);
	            }
	            //Si no tiene permiso para ver redirijo
	            if (!_this.permisos.get("read"))
	                _this.router.navigate(['/home']);
	        });
	        //Inicializar tabla
	        $("#grid-data").bootgrid({
	            ajax: true,
	            url: myGlobals.default.BASE_URL + "/tipoBateria/tipoBateriaTable",
	            selection: true,
	            multiSelect: false,
	            rowSelect: true,
	            formatters: {
	                "estado": function (column, row) {
	                    return row.estado == true ? "Activo" : "<span class=\"label label-danger\">Inactivo</span>";
	                }
	            },
	            ajaxSettings: {
	                headers: {
	                    "Authorization": this.loginService.getToken()
	                },
	                method: "GET"
	            }
	        });
	        //Cerrar alert
	        $("#alertSeleccion").hide();
	        //Inicializar banderas para resetear forms
	        this.active = true;
	        //Inicializar
	        this.tipoBateria = new tipoBateria_1.TipoBateria();
	        //Inicializar bandera deshabilitar
	        this.deshabilitar = false;
	    };
	    TipoBateriaComponent.prototype.ngOnDestroy = function () {
	    };
	    TipoBateriaComponent.prototype.agregar = function () {
	        var _this = this;
	        //Inicializo variables
	        this.tipoBateria = new tipoBateria_1.TipoBateria();
	        this.deshabilitar = false;
	        $("#modalTipoBateria").modal("show");
	        //Reseteo form para eliminar errores
	        this.active = false;
	        setTimeout(function () { return _this.active = true; }, 0);
	    };
	    TipoBateriaComponent.prototype.modificar = function () {
	        var _this = this;
	        //Obtener id seleccionado
	        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
	        //Si no hay nada seleccionado mostrar alert
	        if (this.idSeleccionado == undefined) {
	            $("#alertSeleccion").show();
	        }
	        else {
	            if (this.idSeleccionado != "0") {
	                //Cerrar alert
	                $("#alertSeleccion").hide();
	                //Busco tipoBateria
	                this.tipoBateriaService
	                    .getTipoBateria(this.idSeleccionado)
	                    .subscribe(function (tipoBateria) {
	                    _this.tipoBateria = tipoBateria;
	                });
	                this.deshabilitar = false;
	                $("#modalTipoBateria").modal("show");
	            }
	        }
	    };
	    TipoBateriaComponent.prototype.eliminar = function () {
	        var _this = this;
	        //Obtener id seleccionado
	        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
	        //Si no hay nada seleccionado mostrar alert
	        if (this.idSeleccionado == undefined) {
	            $("#alertSeleccion").show();
	        }
	        else {
	            if (this.idSeleccionado != "0") {
	                //Cerrar alert
	                $("#alertSeleccion").hide();
	                //Busco tipoBateria
	                this.tipoBateriaService
	                    .getTipoBateria(this.idSeleccionado)
	                    .subscribe(function (tipoBateria) {
	                    _this.tipoBateriaService.delete(tipoBateria).subscribe(function () { return $("#grid-data").bootgrid("reload"); });
	                });
	            }
	        }
	    };
	    TipoBateriaComponent.prototype.ver = function () {
	        var _this = this;
	        //Obtener id seleccionado
	        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
	        //Si no hay nada seleccionado mostrar alert
	        if (this.idSeleccionado == undefined) {
	            $("#alertSeleccion").show();
	        }
	        else {
	            if (this.idSeleccionado != "0") {
	                //Cerrar alert
	                $("#alertSeleccion").hide();
	                //Busco tipoBateria
	                this.tipoBateriaService
	                    .getTipoBateria(this.idSeleccionado)
	                    .subscribe(function (tipoBateria) {
	                    _this.tipoBateria = tipoBateria;
	                });
	                //Seteo bandera para deshabilitar
	                this.deshabilitar = true;
	                $("#modalTipoBateria").modal("show");
	            }
	        }
	    };
	    TipoBateriaComponent.prototype.save = function () {
	        var _this = this;
	        this.tipoBateriaService
	            .save(this.tipoBateria)
	            .subscribe(function (tipoBateria) {
	            _this.tipoBateria = tipoBateria;
	            //Inicializo variables
	            _this.tipoBateria = new tipoBateria_1.TipoBateria();
	            console.log(_this.tipoBateria);
	            //Ocultar modal
	            $("#modalTipoBateria").modal("hide");
	            //Reseteo formtipoBateria para eliminar errores
	            _this.active = false;
	            setTimeout(function () { return _this.active = true; }, 0);
	            //Recargo tabla
	            $("#grid-data").bootgrid("reload");
	        });
	    };
	    TipoBateriaComponent.prototype.hideAlert = function () {
	        $("#alertSeleccion").hide();
	    };
	    TipoBateriaComponent = __decorate([
	        core_1.Component({
	            selector: 'tipoBateria',
	            template: __webpack_require__(993),
	            styles: [__webpack_require__(994)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof tipoBateria_service_1.TipoBateriaService !== 'undefined' && tipoBateria_service_1.TipoBateriaService) === 'function' && _a) || Object, (typeof (_b = typeof permiso_service_1.PermisoService !== 'undefined' && permiso_service_1.PermisoService) === 'function' && _b) || Object, (typeof (_c = typeof login_service_1.LoginService !== 'undefined' && login_service_1.LoginService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object])
	    ], TipoBateriaComponent);
	    return TipoBateriaComponent;
	    var _a, _b, _c, _d;
	}());
	exports.TipoBateriaComponent = TipoBateriaComponent;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(419)))

/***/ }),
/* 992 */
/***/ (function(module, exports) {

	"use strict";
	var TipoBateria = (function () {
	    function TipoBateria() {
	    }
	    return TipoBateria;
	}());
	exports.TipoBateria = TipoBateria;


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 contenido\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 titulo\">\n        <div class=\"marcoTitulo\">\n            <h2>Tipos de Baterias</h2>\n            <p>Home / Carga Datos / Tipos de Baterias</p>\n        </div>\n    </div>\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 marcoDatos\">\n        <div class=\"datos\">\n            <div class=\"alert alert-warning\" id=\"alertSeleccion\" name=\"alertSeleccion\">\n                <a class=\"close\" (click)=\"hideAlert()\">&times;</a> Debe selecccionar una casilla primero.\n            </div>\n            <div class=\"table-responsive\">\n                <table id=\"grid-data\" class=\"table table-condensed table-hover \">\n                    <thead>\n                    <tr>\n                        <th data-column-id=\"_id\" data-identifier=\"true\" data-visible=\"false\"\n                            data-visible-in-selection=\"false\" data-order=\"desc\">_id\n                        </th>\n                        <th data-column-id=\"descripcion\">Descripcion</th>\n                        <th data-column-id=\"valorLimite\">Valor límite</th>\n                        <th data-column-id=\"duracionEstimada\">Duración Estimada</th>\n                        <th data-column-id=\"estado\" data-formatter=\"estado\">Estado</th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n    <button data-toggle=\"tooltip\" data-placement=\"top\" title=\"Eliminar\" animation=\"true\"\n            class=\"btn btn-default btn-sm botonFlotante btn-danger\" (click)=\"eliminar()\"\n            [disabled]=\"permisos.get('delete')!=true\">\n        <img src=\"" + __webpack_require__(933) + "\" width=\"20px\"/>\n    </button>\n    <button data-toggle=\"tooltip\" data-placement=\"top\" title=\"Modificar\" animation=\"true\"\n            class=\"btn btn-default btn-sm botonFlotante2 btn-warning\" (click)=\"modificar()\"\n            [disabled]=\"permisos.get('update')!=true\">\n        <img src=\"" + __webpack_require__(934) + "\" width=\"25px\"/>\n    </button>\n    <button data-toggle=\"tooltip\" data-placement=\"top\" title=\"Agregar\" animation=\"true\"\n            class=\"btn btn-default btn-sm botonFlotante3 btn-success\" (click)=\"agregar()\"\n            [disabled]=\"permisos.get('create')!=true\">\n        <img src=\"" + __webpack_require__(935) + "\" width=\"25px\"/>\n    </button>\n    <button data-toggle=\"tooltip\" data-placement=\"top\" title=\"Ver\" animation=\"true\"\n            class=\"btn btn-default btn-sm botonFlotante4 btn-primary\" (click)=\"ver()\"\n            [disabled]=\"permisos.get('read')!=true\">\n        <img src=\"" + __webpack_require__(936) + "\" width=\"30px\"/>\n    </button>\n</div>\n<!-- Modal -->\n<div class=\"modal fade\" id=\"modalTipoBateria\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\">\n    <div class=\"modal-dialog\" role=\"document\">\n\n        <div class=\"modal-content\">\n            <form #tipoBateriaForm=\"ngForm\" *ngIf=\"active\">\n                <div class=\"modal-header\">\n                    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span\n                            aria-hidden=\"true\">&times;</span></button>\n                    <h4 class=\"modal-title\" id=\"myModalLabel\">Tipo de Bateria</h4>\n                </div>\n                <div class=\"modal-body\">\n\n                    <div class=\"form-group\">\n                        <label for=\"descripcion\">Descripción Del Tipo de Bateria</label>\n                        <input type=\"text\" class=\"form-control\" id=\"descripcion\" placeholder=\"Descripción\" required\n                               [(ngModel)]=\"tipoBateria.descripcion\" name=\"descripcion\" #descripcion=\"ngModel\"\n                               autocomplete=\"off\" [disabled]=\"deshabilitar\">\n                        <div [hidden]=\"descripcion.valid || descripcion.pristine\" class=\"alert alert-danger\">\n                            Descripción es requerido\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"valorLimite\">Valor límite de voltaje para correcto funcionamiento</label>\n                        <input type=\"number\" class=\"form-control\" id=\"valorLimite\" name=\"valorLimite\"\n                               placeholder=\"Valor límite de voltaje para correcto funcionamiento\" [(ngModel)]=\"tipoBateria.valorLimite\" #valorLimite=\"ngModel\"\n                               required autocomplete=\"off\" [disabled]=\"deshabilitar\">\n                        <div [hidden]=\"valorLimite.valid || valorLimite.pristine\" class=\"alert alert-danger\">\n                            Valor límite de voltaje es requerido\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"duracionEstimada\">Duración estimada de bateria promedio (en días)</label>\n                        <input type=\"number\" class=\"form-control\" id=\"duracionEstimada\"\n                               required name=\"duracionEstimada\" placeholder=\"Duración estimada de bateria (en días)\" [(ngModel)]=\"tipoBateria.duracionEstimada\"\n                               #duracionEstimada=\"ngModel\" autocomplete=\"off\" [disabled]=\"deshabilitar\">\n                        <div [hidden]=\"duracionEstimada.valid || duracionEstimada.pristine\" class=\"alert alert-danger\">\n                            Duración estimada de bateria es requerido\n                        </div>\n                    </div>\n\n                </div>\n                <div class=\"clearfix visible-md-block\"></div>\n                <div class=\"clearfix visible-lg-block\"></div>\n                <div class=\"clearfix visible-sm-block\"></div>\n                <div class=\"clearfix visible-xs-block\"></div>\n                <div class=\"modal-footer\">\n                    <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Cancelar</button>\n                    <button type=\"button\" (click)=\"save()\" class=\"btn btn-success\"\n                            [disabled]=\"deshabilitar || (tipoBateriaForm!=undefined && !tipoBateriaForm.form.valid)\">\n                        Guardar\n                    </button>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 994 */
944,
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var empresa_service_1 = __webpack_require__(425);
	var sucursal_service_1 = __webpack_require__(429);
	var nodo_service_1 = __webpack_require__(433);
	var medicion_service_1 = __webpack_require__(434);
	var regAlarma_service_1 = __webpack_require__(572);
	var progress_service_1 = __webpack_require__(980);
	var login_service_1 = __webpack_require__(381);
	var error_notifier_1 = __webpack_require__(652);
	var ubicacion_1 = __webpack_require__(912);
	var informe_service_1 = __webpack_require__(896);
	var dateTimeZonePipe_1 = __webpack_require__(645);
	var myGlobals = __webpack_require__(414);
	var Highcharts = __webpack_require__(902);
	// Load module after Highcharts is loaded
	__webpack_require__(913)(Highcharts);
	var moment = __webpack_require__(435);
	var ChartGlobal;
	var HistoricoComponent = (function () {
	    function HistoricoComponent(empresaService, sucursalService, nodoService, medicionService, regAlarmaService, progressService, loginService, informeService, errorNotifier) {
	        this.empresaService = empresaService;
	        this.sucursalService = sucursalService;
	        this.nodoService = nodoService;
	        this.medicionService = medicionService;
	        this.regAlarmaService = regAlarmaService;
	        this.progressService = progressService;
	        this.loginService = loginService;
	        this.informeService = informeService;
	        this.errorNotifier = errorNotifier;
	    }
	    HistoricoComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        window.scrollTo(0, 0);
	        this.usuarioConectado = this.loginService.getDecodeToken();
	        this.progressBar = 0;
	        this.loading = false;
	        this.regAlarma = [];
	        this.regAlarmaNodos = [];
	        this.promedios = new Map();
	        this.promediosMKT = new Map();
	        this.minMaxValues = new Map();
	        this.asignacionColor = new Map();
	        this.abierto = true;
	        this.ultimoColor = 0;
	        this.ejeY = true;
	        this.noData = true;
	        this.mostrarEliminados = false;
	        this.mostrarTemperaturaMedia = true;
	        this.ubicaciones = [];
	        this.colors = ['#058DC7', '#50B432', '#ED561B', '#ae1316', '#8d02f7', '#64E572', '#FF9655', '#0da6a1', '#ff0000'];
	        this.offsetTimeZone = "-03:00";
	        this.fechaDesde = new Date().toISOString().substring(0, 10);
	        this.fechaHasta = new Date().toISOString().substring(0, 10);
	        //Suscribirse a errores
	        this.errorNotifier.onError(function (error) {
	            _this.loading = false;
	            _this.progressBar = 0;
	            _this.uncheckAllSensors();
	        });
	        //Obtener empresas de ese usuario
	        this.empresaService.getEmpresas()
	            .subscribe(function (data) {
	            _this.empresas = data;
	            if (data.length > 0)
	                _this.cambiarSucursales(data[0]._id);
	        });
	        Highcharts.setOptions({
	            lang: {
	                loading: 'Cargando...',
	                months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
	                weekdays: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
	                shortMonths: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
	                exportButtonTitle: "Exportar",
	                printButtonTitle: "Importar",
	                rangeSelectorFrom: "Desde",
	                rangeSelectorTo: "Hasta",
	                rangeSelectorZoom: "Zoom",
	                downloadPNG: 'Descargar imagen PNG',
	                downloadJPEG: 'Descargar imagen JPEG',
	                downloadPDF: 'Descargar imagen PDF',
	                downloadSVG: 'Descargar imagen SVG',
	                printChart: 'Imprimir',
	                resetZoom: 'Reiniciar zoom',
	                resetZoomTitle: 'Reiniciar zoom',
	                thousandsSep: ",",
	                decimalPoint: '.'
	            }
	        });
	        ChartGlobal = Highcharts.stockChart('container', {
	            chart: {
	                zoomType: 'xy',
	                marginTop: 150,
	            },
	            title: null,
	            tooltip: {
	                shared: true,
	            },
	            xAxis: {
	                ordinal: false
	            },
	            legend: {
	                enabled: true,
	                maxHeight: 100,
	                layout: 'vertical',
	                align: 'left',
	                x: 10,
	                verticalAlign: 'top',
	                y: 2,
	                floating: true,
	                backgroundColor: '#FFFFFF',
	                labelFormatter: function () {
	                    if (this.name.indexOf('Bateria') !== -1) {
	                        return this.name + ' <span style="font-size: 10px; font-style: italic">(---- para alimentación externa)</span>';
	                    }
	                    else {
	                        return this.name;
	                    }
	                }
	            },
	            credits: {
	                enabled: false
	            },
	            rangeSelector: {
	                buttons: [{
	                        type: 'hour',
	                        count: 1,
	                        text: '1 hora'
	                    }, {
	                        type: 'day',
	                        count: 1,
	                        text: '24hs'
	                    }, {
	                        type: 'month',
	                        count: 1,
	                        text: '1 mes'
	                    }, {
	                        type: 'year',
	                        count: 1,
	                        text: '1 año'
	                    }, {
	                        type: 'all',
	                        count: 1,
	                        text: 'Todo'
	                    }],
	                selected: 4,
	                inputEnabled: true,
	                inputEditDateFormat: '%d-%m-%Y',
	                inputDateFormat: '%d-%m-%Y',
	                xAxis: {
	                    ordinal: false
	                },
	            },
	            exporting: {
	                enabled: false,
	                csv: {
	                    dateFormat: '%d-%m-%Y %H:%M:%S'
	                },
	                chartOptions: {
	                    title: {
	                        text: "Gráficos",
	                        style: {
	                            fontSize: '26px'
	                        }
	                    },
	                    subtitle: {
	                        text: 'fecha'
	                    },
	                    xAxis: {
	                        labels: {
	                            style: {
	                                fontSize: '16px'
	                            }
	                        },
	                    },
	                    legend: {
	                        itemStyle: {
	                            fontSize: '16px'
	                        }
	                    },
	                    yAxis: {
	                        labels: {
	                            style: {
	                                fontSize: '26px'
	                            }
	                        }
	                    }
	                }
	            },
	            navigator: {
	                series: {
	                    includeInCSVExport: false
	                },
	                adaptToUpdatedData: true
	            },
	            responsive: {
	                rules: [{
	                        condition: {
	                            maxWidth: 769
	                        },
	                        chartOptions: {
	                            legend: {
	                                y: 40,
	                                maxHeight: 100
	                            },
	                            chart: {
	                                marginTop: 200,
	                                pinchType: 'x',
	                                panning: true
	                            },
	                            rangeSelector: {
	                                buttonPosition: {},
	                                inputPosition: {
	                                    y: 160
	                                }
	                            },
	                            scrollbar: {
	                                liveRedraw: true
	                            }
	                        }
	                    }]
	            },
	            series: [{
	                    showInLegend: false,
	                    type: 'scatter',
	                    marker: {
	                        enabled: false
	                    },
	                    enableMouseTracking: false,
	                    data: null
	                }]
	        });
	        //Corregir defecto de nombre en plotlines en versiones viejas
	        Highcharts.wrap(Highcharts.Axis.prototype, 'getPlotLinePath', function (proceed) {
	            var path = proceed.apply(this, Array.prototype.slice.call(arguments, 1));
	            if (path) {
	                path.flat = false;
	            }
	            return path;
	        });
	        setTimeout(function () {
	            ChartGlobal.reflow();
	        }, 300);
	        //Ocultar la barra cuando hace click afuera
	        if ($(window).width() < 769)
	            $(document).bind("mouseup touchend", function (e) {
	                var container = $("#barraSelectora");
	                if (!container.is(e.target) // if the target of the click isn't the container...
	                    && container.has(e.target).length === 0
	                    && e.target.id != "iconoBarraSelectora" && e.target.className != "botonConfig" && e.target.id != "desBarraSelectora"
	                    && e.target.id != "flechaBarraSelectora") {
	                    $('#barraSelectora').css("display", "none");
	                }
	            });
	    };
	    HistoricoComponent.prototype.ngOnDestroy = function () {
	    };
	    HistoricoComponent.prototype.cambiarSucursales = function (id) {
	        var _this = this;
	        //Buscar empresa
	        this.empresas.forEach(function (empresa) {
	            if (empresa._id == id) {
	                this.empresaSeleccionada = empresa;
	                return;
	            }
	        }.bind(this));
	        //Vaciar grafico cuando cambio de variable
	        this.noData = true;
	        for (var _i = 0, _a = this.ubicaciones; _i < _a.length; _i++) {
	            var ubicacion = _a[_i];
	            for (var _b = 0, _c = ubicacion.sensores; _b < _c.length; _b++) {
	                var sensor = _c[_b];
	                if (document.getElementById(sensor._id).checked == true) {
	                    $("#" + sensor._id).attr('checked', false);
	                    var e = { target: document.getElementById(sensor._id) };
	                    this.graficar(e, sensor);
	                }
	            }
	        }
	        this.sucursalService.getSucursalByEmpresa(id).subscribe(function (data) {
	            _this.sucursales = data;
	            if (data.length > 0) {
	                //Calcular fechaDesde para mostrar histórico
	                var fechaDesde = new Date();
	                fechaDesde.setDate(fechaDesde.getDate() - data[0].historico_dias);
	                _this.fechaDesde = fechaDesde.toISOString().substring(0, 10);
	                _this.cambiarSensores(data[0]._id);
	            }
	            else {
	                _this.sucursales = [];
	                _this.ubicaciones = [];
	            }
	        });
	    };
	    HistoricoComponent.prototype.cambiarFecha = function () {
	        //Vaciar grafico cuando cambio de variable
	        this.noData = true;
	        for (var _i = 0, _a = this.ubicaciones; _i < _a.length; _i++) {
	            var ubicacion = _a[_i];
	            for (var _b = 0, _c = ubicacion.sensores; _b < _c.length; _b++) {
	                var sensor = _c[_b];
	                if (document.getElementById(sensor._id).checked == true) {
	                    $("#" + sensor._id).attr('checked', false);
	                    var e = { target: document.getElementById(sensor._id) };
	                    this.graficar(e, sensor);
	                }
	            }
	        }
	        if (this.fechaDesde > this.fechaHasta)
	            alert("La fecha desde no puede ser mayor a la fecha hasta.");
	    };
	    HistoricoComponent.prototype.cambiarSensores = function (id) {
	        var _this = this;
	        //Vaciar grafico cuando cambio de variable
	        this.noData = true;
	        for (var _i = 0, _a = this.ubicaciones; _i < _a.length; _i++) {
	            var ubicacion = _a[_i];
	            for (var _b = 0, _c = ubicacion.sensores; _b < _c.length; _b++) {
	                var sensor = _c[_b];
	                if (document.getElementById(sensor._id).checked == true) {
	                    $("#" + sensor._id).attr('checked', false);
	                    var e = { target: document.getElementById(sensor._id) };
	                    this.graficar(e, sensor);
	                }
	            }
	        }
	        //Calcular offset huso horario
	        this.sucursales.forEach(function (sucursal) {
	            if (sucursal._id == id) {
	                this.sucursalSeleccionada = sucursal;
	                if (sucursal && sucursal.husoHorario_id && sucursal.husoHorario_id.offset)
	                    this.offsetTimeZone = sucursal.husoHorario_id.offset;
	                else
	                    this.offsetTimeZone = "-03:00";
	                return;
	            }
	        }.bind(this));
	        //Calcular fechaDesde para mostrar histórico
	        var fechaDesde = new Date();
	        fechaDesde.setDate(fechaDesde.getDate() - this.sucursalSeleccionada.historico_dias);
	        this.fechaDesde = fechaDesde.toISOString().substring(0, 10);
	        this.ubicaciones = [];
	        //Buscar sensores
	        this.nodoService.getNodosBySucursal(id).subscribe(function (data) {
	            var i = 0;
	            var ubicacionAnt = null;
	            var nodo = null;
	            _this.nodos = data;
	            var ubicacion = null;
	            _this.ubicaciones = [];
	            while (i < _this.nodos.length) {
	                nodo = _this.nodos[i];
	                ubicacionAnt = nodo.ubicacion_id._id;
	                ubicacion = new ubicacion_1.Ubicacion();
	                ubicacion = nodo.ubicacion_id;
	                ubicacion.sensores = [];
	                while (i < _this.nodos.length && ubicacionAnt == nodo.ubicacion_id._id) {
	                    ubicacion.sensores = ubicacion.sensores.concat(nodo.sensores_id);
	                    i++;
	                    nodo = _this.nodos[i];
	                }
	                _this.ubicaciones.push(ubicacion);
	            }
	        });
	    };
	    HistoricoComponent.prototype.roundNumber = function (num, scale) {
	        if (!("" + num).includes("e")) {
	            return +(Math.round(parseFloat(num + "e+" + scale)) + "e-" + scale);
	        }
	        else {
	            var arr = ("" + num).split("e");
	            var sig = "";
	            if (+arr[1] + scale > 0) {
	                sig = "+";
	            }
	            return +(Math.round(parseFloat(+arr[0] + "e" + sig + (+arr[1] + scale))) + "e-" + scale);
	        }
	    };
	    HistoricoComponent.prototype.graficar = function (e, sensor) {
	        var _this = this;
	        var chart = ChartGlobal;
	        //Borrar los rango de alarma de referencia
	        if (this.checkAlarmasDiferentes() === true)
	            chart.yAxis.forEach(function (axis) {
	                axis.removePlotLine();
	            });
	        if (e.target.checked) {
	            setTimeout(function () {
	                chart.reflow();
	            }, 100);
	            //Deshabilitar
	            // for (let ubicacion of this.ubicaciones) {
	            //     for (let sensor of ubicacion.sensores) {
	            //         $("#" + sensor._id).attr('disabled', true);
	            //     }
	            // }
	            this.progressBar = 1;
	            this.progressService.progressEventObservable.subscribe(function (progreso) {
	                if (progreso.currentTarget.responseURL.indexOf("medicion") > -1) {
	                    var progresoPorc = (progreso.loaded * 100) / progreso.total;
	                    if (progreso !== _this.progressBar) {
	                        _this.progressBar = progresoPorc;
	                    }
	                    if (_this.progressBar == 100)
	                        setTimeout(function () { return _this.progressBar = 0; }, 5000);
	                }
	            });
	            this.loading = true;
	            this.medicionService.getAllMedicionesBySensorYFecha(sensor._id, this.fechaDesde, this.fechaHasta, this.offsetTimeZone).subscribe(function (data) {
	                _this.loading = false;
	                //Guardo puntos de la serie
	                var valores = [];
	                //Zonas para alimentacion externa bateria
	                var zonas = [];
	                var tipoAlimentacionAnt = null;
	                //Recorro las mediciones
	                var i = 0;
	                for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
	                    var medicion = data_1[_i];
	                    i++;
	                    //Calculo fecha
	                    var fechaMedicion = moment(medicion.fecha.toString()).utcOffset(_this.offsetTimeZone);
	                    //Armo medicion
	                    var nuevo = [];
	                    var day = fechaMedicion.date();
	                    var monthIndex = fechaMedicion.month();
	                    var year = fechaMedicion.year();
	                    var hour = fechaMedicion.hour();
	                    var minutes = fechaMedicion.minutes();
	                    var seconds = fechaMedicion.seconds();
	                    //Calculo eje x
	                    var x = Date.UTC(year, monthIndex, day, hour, minutes, seconds);
	                    nuevo.push(x);
	                    nuevo.push(medicion.valor);
	                    //Guardo medicion
	                    valores.push(nuevo);
	                    //Tipo alimentacion
	                    if (tipoAlimentacionAnt !== null && medicion.alimentacionExterna !== tipoAlimentacionAnt && sensor.posicionString === 9) {
	                        tipoAlimentacionAnt = medicion.alimentacionExterna;
	                        zonas.push({
	                            value: x,
	                            dashStyle: tipoAlimentacionAnt !== true ? 'longdash' : "solid",
	                        });
	                    }
	                    else if (tipoAlimentacionAnt === null)
	                        tipoAlimentacionAnt = medicion.alimentacionExterna;
	                    else if (i === data.length)
	                        zonas.push({
	                            value: x,
	                            dashStyle: tipoAlimentacionAnt == true ? 'longdash' : "solid",
	                        });
	                }
	                //Asignacion de color
	                var colorAsignado;
	                if (_this.asignacionColor.get(sensor._id) == undefined) {
	                    if (_this.ultimoColor == _this.colors.length)
	                        _this.ultimoColor = 0;
	                    colorAsignado = _this.colors[_this.ultimoColor];
	                    _this.asignacionColor.set(sensor._id, colorAsignado);
	                    _this.ultimoColor++;
	                }
	                else {
	                    colorAsignado = _this.asignacionColor.get(sensor._id);
	                }
	                //Alarmas
	                var alarmas = [];
	                if (chart.series.length === 2 || _this.checkAlarmasDiferentes() === false) {
	                    console.log('plot');
	                    alarmas = _this.getPlotLinesBySensor(sensor);
	                }
	                //Evaluo si el eje esta agregado
	                if (chart.get(sensor.tipo_id._id + "-ejeY") == null) {
	                    //Agrego eje y
	                    chart.addAxis({
	                        id: sensor.tipo_id._id + "-ejeY",
	                        labels: {
	                            format: '{value}' + sensor.tipo_id.tipo,
	                            style: {
	                                color: "black"
	                            }
	                        },
	                        title: {
	                            text: sensor.tipo_id.descripcion,
	                            style: {
	                                color: "black"
	                            }
	                        },
	                        opposite: false,
	                        //xAxis:1,
	                        lineWidth: 1,
	                        minorGridLineWidth: 0,
	                        lineColor: "black",
	                        plotLines: alarmas
	                    });
	                }
	                //Agrego serie
	                chart.addSeries({
	                    id: sensor._id + "-serie",
	                    name: sensor.etiqueta,
	                    type: 'line',
	                    lineWidth: 2,
	                    color: colorAsignado,
	                    yAxis: sensor.tipo_id._id + "-ejeY",
	                    data: valores,
	                    zones: zonas,
	                    zoneAxis: "x",
	                    tooltip: {
	                        valueSuffix: ' ' + sensor.tipo_id.tipo
	                    },
	                    dataGrouping: {
	                        enabled: (valores.length > 30000),
	                        approximation: "high"
	                    },
	                    showInNavigator: true
	                });
	                //Obtengo alarmas
	                if (data.length > 0) {
	                    //Alarmas Por Sensor
	                    _this.regAlarmaService.getRegAlarmasBySensorYFecha(sensor._id, _this.fechaDesde, _this.fechaHasta, _this.offsetTimeZone)
	                        .subscribe(function (regAlarmas) {
	                        _this.regAlarma.push.apply(_this.regAlarma, regAlarmas);
	                    });
	                    //Alarmas Por nodo
	                    var buscarAlarmasPorNodo = true;
	                    for (var i_1 = 0; i_1 < _this.regAlarmaNodos.length; i_1++) {
	                        var alarma = _this.regAlarmaNodos[i_1];
	                        if (alarma.nodo_id != null && alarma.nodo_id._id == sensor.nodo_id) {
	                            buscarAlarmasPorNodo = false;
	                            break;
	                        }
	                    }
	                    if (buscarAlarmasPorNodo)
	                        _this.regAlarmaService.getRegAlarmasByNodoYFecha(sensor._id, _this.fechaDesde, _this.fechaHasta, _this.offsetTimeZone)
	                            .subscribe(function (regAlarmas) {
	                            _this.regAlarmaNodos.push.apply(_this.regAlarmaNodos, regAlarmas);
	                        });
	                }
	                //Habilitar
	                // for (let ubicacion of this.ubicaciones) {
	                //     for (let sensor of ubicacion.sensores) {
	                //         $("#" + sensor._id).attr('disabled', false);
	                //     }
	                // }
	                _this.noData = false;
	            });
	            //Obtengo promedio
	            if (sensor.tipo_id && sensor.tipo_id.descripcion.toLowerCase().includes("temperatura")) {
	                this.medicionService.getPromedioMedicionesBySensorYFecha(sensor._id, this.fechaDesde, this.fechaHasta, this.offsetTimeZone).subscribe(function (promedio) {
	                    if (promedio.length > 0)
	                        _this.promedios.set(promedio[0]._id, {
	                            valor: _this.roundNumber(promedio[0].markAvg, 2) + (sensor.tipo_id ? (" " + sensor.tipo_id.tipo) : ""),
	                            etiqueta: sensor.etiqueta
	                        });
	                });
	                this.medicionService.getMKTMedicionesBySensorYFecha(sensor._id, this.fechaDesde, this.fechaHasta, this.offsetTimeZone).subscribe(function (promedio) {
	                    if (promedio.mkt)
	                        _this.promediosMKT.set(promedio._id, {
	                            valor: _this.roundNumber(promedio.mkt, 2) + (sensor.tipo_id ? (" " + sensor.tipo_id.tipo) : ""),
	                            etiqueta: sensor.etiqueta
	                        });
	                });
	                //Obtengo minimo y maximo
	                this.medicionService.getMinMaxMedicionesBySensorYFecha(sensor._id, this.fechaDesde, this.fechaHasta, this.offsetTimeZone).subscribe(function (data) {
	                    if (data && data.minima && data.maxima) {
	                        _this.minMaxValues.set(data._id, {
	                            minima: _this.roundNumber(data.minima.valor, 2) + (sensor.tipo_id ? (" " + sensor.tipo_id.tipo) : ""),
	                            maxima: _this.roundNumber(data.maxima.valor, 2) + (sensor.tipo_id ? (" " + sensor.tipo_id.tipo) : ""),
	                            etiqueta: sensor.etiqueta
	                        });
	                    }
	                });
	            }
	        }
	        else {
	            //Borrar eje y
	            if (chart.get(sensor.tipo_id._id + "-ejeY").series.length == 1) {
	                chart.get(sensor.tipo_id._id + "-ejeY").remove();
	                //Para arreglar error de que se repiten ejes por mas que el eje no se vea en el gráfico
	                chart.userOptions.yAxis.some(function (eje, i) {
	                    if (eje.id == sensor.tipo_id._id + "-ejeY") {
	                        chart.userOptions.yAxis.splice(i, 1);
	                        return true;
	                    }
	                });
	            }
	            else
	                chart.get(sensor._id + "-serie").remove();
	            //Borrar Alarmas por sensor
	            for (var i = 0; i < this.regAlarma.length; i++) {
	                var alarma = this.regAlarma[i];
	                if (alarma.sensor_id != null && alarma.sensor_id._id == sensor._id) {
	                    var index = this.regAlarma.indexOf(alarma);
	                    this.regAlarma.splice(index, 1);
	                    i--;
	                }
	            }
	            //Borrar promedio por sensor
	            this.promedios.delete(sensor._id);
	            this.promediosMKT.delete(sensor._id);
	            this.minMaxValues.delete(sensor._id);
	            //Borrar Alarmas por nodo
	            var borrarNodo = true;
	            var cantSensoresSeleccionados = 0;
	            var ultimoSensorSeleccionado = null;
	            for (var _i = 0, _a = this.ubicaciones; _i < _a.length; _i++) {
	                var ubicacion = _a[_i];
	                for (var _b = 0, _c = ubicacion.sensores; _b < _c.length; _b++) {
	                    var s = _c[_b];
	                    if (document.getElementById(s._id).checked) {
	                        if (s.nodo_id == sensor.nodo_id) {
	                            borrarNodo = false;
	                        }
	                        cantSensoresSeleccionados++;
	                        ultimoSensorSeleccionado = s;
	                    }
	                }
	            }
	            if (borrarNodo) {
	                for (var i = 0; i < this.regAlarmaNodos.length; i++) {
	                    var alarma = this.regAlarmaNodos[i];
	                    if (alarma.nodo_id != null && alarma.nodo_id._id == sensor.nodo_id) {
	                        var index = this.regAlarmaNodos.indexOf(alarma);
	                        this.regAlarmaNodos.splice(index, 1);
	                        i--;
	                    }
	                }
	            }
	            //Muestro cartel de sin datos
	            if (chart.series.length == 0)
	                this.noData = true;
	            setTimeout(function () {
	                ChartGlobal.reflow();
	            }, 100);
	            //Muestro rango de alarmas en caso de que quede un solo sensor seleccionado
	            if (cantSensoresSeleccionados === 1 || this.checkAlarmasDiferentes() === false) {
	                var ejeY_1 = chart.get(ultimoSensorSeleccionado.tipo_id._id + "-ejeY");
	                var alarmas = this.getPlotLinesBySensor(ultimoSensorSeleccionado);
	                alarmas.forEach(function (alarma) {
	                    ejeY_1.addPlotLine(alarma);
	                });
	            }
	        }
	    };
	    HistoricoComponent.prototype.getPlotLinesBySensor = function (sensor) {
	        var alarmas = [];
	        sensor.alarmas.forEach(function (alarma) {
	            if (alarma.estado === true) {
	                if (alarma && alarma.valorMinimo)
	                    alarmas.push({
	                        value: alarma.valorMinimo,
	                        color: '#D8534E',
	                        dashStyle: 'shortdash',
	                        width: 2,
	                        label: {
	                            text: "Min (" + alarma.valorMinimo + sensor.tipo_id.tipo + ")"
	                        }
	                    });
	                if (alarma && alarma.valorMaximo)
	                    alarmas.push({
	                        value: alarma.valorMaximo,
	                        color: '#D8534E',
	                        dashStyle: 'shortdash',
	                        width: 2,
	                        label: {
	                            text: "Max (" + alarma.valorMaximo + sensor.tipo_id.tipo + ")"
	                        }
	                    });
	                if (alarma && alarma.valorMinimoAmarillo)
	                    alarmas.push({
	                        value: alarma.valorMinimoAmarillo,
	                        color: '#F0AE4E',
	                        dashStyle: 'shortdash',
	                        width: 2,
	                        label: {
	                            text: "Min (" + alarma.valorMinimoAmarillo + sensor.tipo_id.tipo + ")"
	                        }
	                    });
	                if (alarma && alarma.valorMaximoAmarillo)
	                    alarmas.push({
	                        value: alarma.valorMaximoAmarillo,
	                        color: '#F0AE4E',
	                        dashStyle: 'shortdash',
	                        width: 2,
	                        label: {
	                            text: "Max (" + alarma.valorMaximoAmarillo + sensor.tipo_id.tipo + ")"
	                        }
	                    });
	            }
	        });
	        return alarmas;
	    };
	    HistoricoComponent.prototype.checkAlarmasDiferentes = function () {
	        var alarmas = null;
	        var areDifferent = false;
	        for (var _i = 0, _a = this.ubicaciones; _i < _a.length; _i++) {
	            var ubicacion = _a[_i];
	            for (var _b = 0, _c = ubicacion.sensores; _b < _c.length; _b++) {
	                var sensor = _c[_b];
	                if (document.getElementById(sensor._id).checked == true) {
	                    sensor.alarmas.forEach(function (alarma, i) {
	                        if (alarma.estado === true) {
	                            if (!alarmas)
	                                alarmas = {
	                                    valorMaximo: alarma.valorMaximo,
	                                    valorMinimo: alarma.valorMinimo,
	                                    valorMaximoAmarillo: alarma.valorMaximoAmarillo,
	                                    valorMinimoAmarillo: alarma.valorMinimoAmarillo,
	                                };
	                            if (alarma && alarmas && alarma.valorMinimo && alarmas.valorMinimo && alarma.valorMinimo !== alarmas.valorMinimo)
	                                areDifferent = true;
	                            if (alarma && alarmas && alarma.valorMaximo && alarmas.valorMaximo && alarma.valorMaximo !== alarmas.valorMaximo)
	                                areDifferent = true;
	                            if (alarma && alarmas && alarma.valorMinimoAmarillo && alarmas.valorMinimoAmarillo && alarma.valorMinimoAmarillo !== alarmas.valorMinimoAmarillo)
	                                areDifferent = true;
	                            if (alarma && alarmas && alarma.valorMaximoAmarillo && alarmas.valorMaximoAmarillo && alarma.valorMaximoAmarillo !== alarmas.valorMaximoAmarillo)
	                                areDifferent = true;
	                        }
	                    });
	                }
	            }
	        }
	        return areDifferent;
	    };
	    HistoricoComponent.prototype.changeColor = function (e, sensor) {
	        var chart = ChartGlobal;
	        chart.get(sensor._id + "-serie").update({
	            color: e.target.value
	        });
	        this.asignacionColor.set(sensor._id, e.target.value);
	    };
	    HistoricoComponent.prototype.isChecked = function (s) {
	        if (document.getElementById(s._id))
	            return document.getElementById(s._id).checked;
	        else
	            return false;
	    };
	    HistoricoComponent.prototype.modificarBarra = function () {
	        setTimeout(function () {
	            ChartGlobal.reflow();
	        }, 200);
	    };
	    HistoricoComponent.prototype.ocultarEje = function () {
	        var chart = ChartGlobal;
	        this.ejeY = !this.ejeY;
	        for (var _i = 0, _a = chart.yAxis; _i < _a.length; _i++) {
	            var eje = _a[_i];
	            eje.update({
	                visible: this.ejeY
	            });
	        }
	    };
	    HistoricoComponent.prototype.export = function (tipo) {
	        var _this = this;
	        var chart = ChartGlobal;
	        var d = new Date();
	        var datestring = ("0" + d.getDate()).slice(-2) + "-" + ("0" + (d.getMonth() + 1)).slice(-2) + "-" +
	            d.getFullYear() + " " + ("0" + d.getHours()).slice(-2) + ":" + ("0" + d.getMinutes()).slice(-2);
	        chart.options.exporting.url = myGlobals.default.BASE_URL + '/informe/grafico';
	        chart.options.exporting.chartOptions.title.text = this.empresaSeleccionada.descripcion + " - " + this.sucursalSeleccionada.descripcion;
	        chart.options.exporting.chartOptions.subtitle.text = datestring + " - " + this.usuarioConectado.nombre + " " + this.usuarioConectado.apellido;
	        chart.options.exporting.chartOptions.subtitle.verticalAlign = 'bottom';
	        chart.options.exporting.chartOptions.subtitle.align = 'left';
	        chart.options.exporting.chartOptions.chart = { spacing: [20, 20, 60, 20] };
	        chart.options.exporting.chartOptions.legend.y = 30;
	        chart.options.exporting.chartOptions.legend.maxHeight = 200;
	        chart.options.exporting.chartOptions.legend.navigation = { enabled: false };
	        var ajuste = this.promedios.size * 30; // Increased space for additional min/max values
	        chart.options.exporting.chartOptions.chart.marginTop = 180 + ajuste;
	        var fechaDesde = this.fechaDesde.split("-").reverse().join("-");
	        var fechaHasta = this.fechaHasta.split("-").reverse().join("-");
	        var legenda = "";
	        this.promedios.forEach(function (value, key) {
	            var minMax = _this.minMaxValues.get(key);
	            var mkt = _this.promediosMKT.get(key);
	            legenda += "<br/><b>" + value.etiqueta + "</b><br/> Media: " + value.valor + ". MKT: " + (mkt ? mkt.valor : "N/A") + ".";
	            if (minMax) {
	                legenda += " Min: " + minMax.minima + ". Max: " + minMax.maxima + ".";
	            }
	        });
	        if (tipo == 'application/pdf') {
	            if (this.promedios.size > 0)
	                chart.options.exporting.chartOptions.chart.events = {
	                    load: function () {
	                        var renderer = this.renderer;
	                        renderer.label('Valores calculados para el período<br/> <b>Desde: </b>' + fechaDesde + " <b>Hasta: </b>" + fechaHasta + ".  " + legenda, 550, chart.plotTop - 120).attr({
	                            zIndex: 5,
	                            fill: '#FFFFEF',
	                            stroke: 'gray',
	                            'stroke-width': 1,
	                        }).css({
	                            width: '250px',
	                            padding: "5px",
	                        })
	                            .add();
	                    }
	                };
	            chart.options.exporting.chartOptions.legend.itemStyle = { fontSize: '10px' };
	            chart.options.exporting.sourceWidth = 842;
	            chart.options.exporting.sourceHeight = 595;
	            chart.options.exporting.scale = 0.2;
	        }
	        else {
	            if (this.promedios.size > 0)
	                chart.options.exporting.chartOptions.chart.events = {
	                    load: function () {
	                        var renderer = this.renderer;
	                        renderer.label('Valores calculados para el período<br/> <b>Desde: </b>' + fechaDesde + " <b>Hasta: </b>" + fechaHasta + ".  " + legenda, 900, chart.plotTop - 110).attr({
	                            zIndex: 5,
	                            fill: '#FFFFEF',
	                            stroke: 'gray',
	                            'stroke-width': 1,
	                        }).css({
	                            width: '250px',
	                            padding: "5px",
	                        })
	                            .add();
	                    }
	                };
	            chart.options.exporting.chartOptions.legend.itemStyle = { fontSize: '12px' };
	            chart.options.exporting.sourceWidth = 3508 / 3;
	            chart.options.exporting.sourceHeight = 2480 / 3;
	            chart.options.exporting.scale = 3;
	        }
	        chart.options.exporting.filename = this.empresaSeleccionada.descripcion + "-" + this.sucursalSeleccionada.descripcion + "-" + datestring;
	        chart.exportChart({
	            type: tipo
	        });
	    };
	    HistoricoComponent.prototype.exportCSV = function () {
	        var chart = ChartGlobal;
	        var linkSource = "data:text/csv;charset=utf-8," + escape(chart.getCSV());
	        var downloadLink = document.createElement("a");
	        var fileName = "datosSensoresHistorico" + ".csv";
	        downloadLink.href = linkSource;
	        downloadLink.download = fileName;
	        downloadLink.click();
	    };
	    HistoricoComponent.prototype.exportInformeResumen = function () {
	        var _this = this;
	        var reporte = {};
	        reporte.fechaDesde = this.fechaDesde;
	        reporte.fechaHasta = this.fechaHasta;
	        reporte.nodos = [];
	        reporte.sensores = [];
	        var chart = ChartGlobal;
	        reporte.svg = chart.getSVG({
	            title: { text: this.empresaSeleccionada.descripcion + " - " + this.sucursalSeleccionada.descripcion },
	            exporting: { sourceWidth: 3508 / 3, sourceHeight: 2480 / 3 }
	        });
	        var doc = new DOMParser().parseFromString(reporte.svg, "text/xml");
	        reporte.svg = window.btoa(unescape(encodeURIComponent(new XMLSerializer().serializeToString(doc))));
	        for (var _i = 0, _a = this.ubicaciones; _i < _a.length; _i++) {
	            var ubicacion = _a[_i];
	            for (var _b = 0, _c = ubicacion.sensores; _b < _c.length; _b++) {
	                var sensor = _c[_b];
	                if (document.getElementById(sensor._id).checked == true) {
	                    var nodoId = typeof sensor.nodo_id === 'string' ? sensor.nodo_id : sensor.nodo_id._id;
	                    if (reporte.nodos.indexOf(nodoId) == -1)
	                        reporte.nodos.push(nodoId);
	                    if (reporte.sensores.indexOf(sensor._id) == -1)
	                        reporte.sensores.push(sensor._id);
	                }
	            }
	        }
	        this.loading = true;
	        this.informeService.getInformeResumen(this.sucursalSeleccionada._id, reporte)
	            .subscribe(function (res) {
	            _this.loading = false;
	        });
	    };
	    HistoricoComponent.prototype.ocultarBarraSelectora = function () {
	        if ($('#barraSelectora').css("display") == "block")
	            $('#barraSelectora').css("display", "none");
	        else
	            $('#barraSelectora').css("display", "block");
	    };
	    HistoricoComponent.prototype.uncheckAllSensors = function () {
	        for (var _i = 0, _a = this.ubicaciones; _i < _a.length; _i++) {
	            var ubicacion = _a[_i];
	            for (var _b = 0, _c = ubicacion.sensores; _b < _c.length; _b++) {
	                var sensor = _c[_b];
	                var checkbox = document.getElementById(sensor._id);
	                if (checkbox && checkbox.checked) {
	                    checkbox.checked = false;
	                }
	            }
	        }
	    };
	    HistoricoComponent = __decorate([
	        core_1.Component({
	            selector: 'historico',
	            //directives: [CHART_DIRECTIVES],
	            template: __webpack_require__(996),
	            styles: [__webpack_require__(999)],
	            pipes: [dateTimeZonePipe_1.DateTimeZonePipe]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof empresa_service_1.EmpresaService !== 'undefined' && empresa_service_1.EmpresaService) === 'function' && _a) || Object, (typeof (_b = typeof sucursal_service_1.SucursalService !== 'undefined' && sucursal_service_1.SucursalService) === 'function' && _b) || Object, (typeof (_c = typeof nodo_service_1.NodoService !== 'undefined' && nodo_service_1.NodoService) === 'function' && _c) || Object, (typeof (_d = typeof medicion_service_1.MedicionService !== 'undefined' && medicion_service_1.MedicionService) === 'function' && _d) || Object, (typeof (_e = typeof regAlarma_service_1.RegAlarmaService !== 'undefined' && regAlarma_service_1.RegAlarmaService) === 'function' && _e) || Object, (typeof (_f = typeof progress_service_1.ProgressService !== 'undefined' && progress_service_1.ProgressService) === 'function' && _f) || Object, (typeof (_g = typeof login_service_1.LoginService !== 'undefined' && login_service_1.LoginService) === 'function' && _g) || Object, (typeof (_h = typeof informe_service_1.InformeService !== 'undefined' && informe_service_1.InformeService) === 'function' && _h) || Object, (typeof (_j = typeof error_notifier_1.ErrorNotifierService !== 'undefined' && error_notifier_1.ErrorNotifierService) === 'function' && _j) || Object])
	    ], HistoricoComponent);
	    return HistoricoComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
	}());
	exports.HistoricoComponent = HistoricoComponent;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(419)))

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 contenido\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 titulo\">\n        <div class=\"marcoTitulo\">\n            <h2>Histórico</h2>\n            <p>Home / Histórico</p>\n        </div>\n    </div>\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 barraProgreso\">\n        <div class=\"progress progress-striped\">\n            <div class=\"progress-bar\" [style.width]=\"progressBar+'%'\">\n            </div>\n        </div>\n    </div>\n    <div class=\"botonConfig visible-xs col-xs-12\" (click)=\"ocultarBarraSelectora()\">\n        <div id=\"iconoBarraSelectora\" class=\"col-xs-2\">\n            <i class=\"fa fa-cogs fa-spin fa-2x fa-fw\" style=\"color:white\"></i>\n        </div>\n        <div id=\"desBarraSelectora\" class=\"col-xs-10\" style=\"text-align: left;padding-left: 35px;\">\n            Seleccione las variables ...\n            <b class=\"caret\" id=\"flechaBarraSelectora\"></b>\n        </div>\n    </div>\n    <div id=\"barraSelectora\" class=\"col-lg-3 col-md-3 col-sm-3 col-xs-12 barraArbolBase\"\n         [ngClass]=\"{'barraArbolBaseOcultar':!abierto}\">\n        <div class=\"barraArbolCuerpo\" [ngClass]=\"{'barraArbolCuerpoOcultar':!abierto}\">\n            <div class=\"informacionArbol\">\n                <div class=\"form-group\">\n                    <label for=\"sucursal\">Empresa</label>\n                    <select class=\"form-control\" id=\"empresa\" placeholder=\"Empresa\"\n                            (change)=\"cambiarSucursales($event.target.value)\">\n                        <option *ngFor=\"let empresa of empresas\" value={{empresa._id}}>{{empresa.descripcion}}</option>\n                    </select>\n                </div>\n                <div class=\"form-group\">\n                    <label for=\"sucursal\">Sucursal</label>\n                    <select class=\"form-control\" id=\"sucursal\" placeholder=\"Sucursal\"\n                            (change)=\"cambiarSensores($event.target.value)\">\n                        <option *ngFor=\"let sucursal of sucursales\" value={{sucursal._id}}>{{sucursal.descripcion}}\n                        </option>\n                    </select>\n                </div>\n                <p>{{sucursalSeleccionada && sucursalSeleccionada.husoHorario_id ?\n                    sucursalSeleccionada.husoHorario_id.zonaHoraria + \" (\" + offsetTimeZone + \")\" : \"\"}}</p>\n                <div class=\"form-group\">\n                    <label for=\"sucursal\">Fecha Desde</label>\n                    <input type=\"date\" class=\"form-control\" id=\"fechaDesde\" [(ngModel)]=\"fechaDesde\"\n                           (change)=\"cambiarFecha()\"/>\n                </div>\n                <div class=\"form-group\">\n                    <label for=\"sucursal\">Fecha Hasta</label>\n                    <input type=\"date\" class=\"form-control\" id=\"fechaHasta\" [(ngModel)]=\"fechaHasta\"\n                           (change)=\"cambiarFecha()\"/>\n                </div>\n                <div class=\"checkbox checkbox-warning\">\n                    <input type=\"checkbox\" id=\"mostrarEliminados\" [(ngModel)]=\"mostrarEliminados\">\n                    <label> Mostrar eliminados </label>\n                </div>\n                <div class=\"checkbox checkbox-warning\">\n                    <input type=\"checkbox\" id=\"mostrarTemperaturaMedia\" [(ngModel)]=\"mostrarTemperaturaMedia\">\n                    <label> Mostrar estadísticas de temperatura </label>\n                </div>\n                <div class=\"panel-group\" id=\"accordion\">\n                    <template ngFor let-ubicacion=\"$implicit\" [ngForOf]=\"ubicaciones\" let-index=\"index\">\n                        <div class=\"panel panel-default\" [hidden]=\"!(mostrarEliminados || ubicacion.estado)\">\n                            <div class=\"panel-heading\">\n                                <h4 class=\"panel-title\">\n                                    <a data-toggle=\"collapse\" data-parent=\"#accordion\" href=\"#collapseOne\">\n                                        {{ubicacion.descripcion}}\n                                    </a>\n                                    <!--<div class=\"checkbox checkbox-warning\" style=\"display:inline;margin-left:20px;\">\n                                        <input checked=\"true\" type=\"checkbox\">\n                                        <label></label>\n                                    </div>-->\n                                </h4>\n                            </div>\n                            <div id=\"collapseOne\" class=\"panel-collapse collapse in\">\n                                <div class=\"panel-body\">\n                                    <template ngFor let-sensor [ngForOf]=\"ubicacion.sensores\" let-index=\"index2\">\n                                        <div style=\"flex-wrap: wrap\"\n                                             [style.display]=\"!(mostrarEliminados || sensor.estado) || (sensor.posicionString == 9  && usuarioConectado.rol != 'Administrador' && usuarioConectado.rol != 'Tecnico')?'none':'flex'\">\n                                            <div style=\"display: flex; justify-content: space-between; width: 100%; align-items: center\">\n                                                <div class=\"checkbox checkbox-warning\">\n                                                    <input type=\"checkbox\" id={{sensor._id}} value={{sensor._id}}\n                                                           (change)=\"graficar($event,sensor)\">\n                                                    <label> {{sensor.etiqueta}}\n                                                        <span style=\"padding-right: 10px; color: red; vertical-align: middle;\"\n                                                              *ngIf=\"!sensor.estado\"\n                                                              class=\"glyphicon glyphicon-remove\"></span>\n                                                    </label>\n                                                </div>\n                                                <input type=\"color\" *ngIf=\"isChecked(sensor)\"\n                                                       value={{asignacionColor.get(sensor._id)}}\n                                                       (change)=\"changeColor($event,sensor)\" style=\"width: 40px; min-width: 40px\"/>\n                                            </div>\n                                            <div style=\"display: flex; justify-content: flex-start; width: 100%; align-items: center; gap: 10px; flex-wrap: wrap;\">\n                                                <span class=\"label\"\n                                                      style=\"border: 1px solid #FA7252; padding: 5px; color: black\"\n                                                      [style.display]=\"!mostrarTemperaturaMedia || !promedios.get(sensor._id)?'none':'inline'\">{{promedios.get(sensor._id) ? \"Media: \"+promedios.get(sensor._id).valor : \"\"}}</span>\n                                                <span class=\"label\"\n                                                      style=\"border: 1px solid #FA7252; padding: 5px; color: black\"\n                                                      [style.display]=\"!mostrarTemperaturaMedia || !promediosMKT.get(sensor._id)?'none':'inline'\">{{promediosMKT.get(sensor._id) ? \"MKT: \"+promediosMKT.get(sensor._id).valor : \"\"}}</span>\n                                                <span class=\"label\"\n                                                      style=\"border: 1px solid #FA7252; padding: 5px; color: black\"\n                                                      [style.display]=\"!mostrarTemperaturaMedia || !minMaxValues.get(sensor._id)?'none':'inline'\">{{minMaxValues.get(sensor._id) ? \"Mín: \"+minMaxValues.get(sensor._id).minima : \"\"}}</span>\n                                                <span class=\"label\"\n                                                      style=\"border: 1px solid #FA7252; padding: 5px; color: black\"\n                                                      [style.display]=\"!mostrarTemperaturaMedia || !minMaxValues.get(sensor._id)?'none':'inline'\">{{minMaxValues.get(sensor._id) ? \"Máx: \"+minMaxValues.get(sensor._id).maxima : \"\"}}</span>\n                                            </div>\n                                        </div>\n                                    </template>\n                                </div>\n                            </div>\n                        </div>\n                    </template>\n                </div>\n            </div>\n        </div>\n        <div class=\"barraArbolBoton hidden-xs\">\n            <button (click)=\"abierto=!abierto;modificarBarra()\"><i class=\"fa fa-cogs fa-spin fa-1x fa-fw\"\n                                                                   style=\"color:white\"></i></button>\n        </div>\n    </div>\n    <div [ngClass]=\"{'medicionesComprimido':abierto,'medicionesExtendido':!abierto,'col-lg-9':abierto,'col-md-9':abierto,'col-sm-9':abierto,'col-xs-12':true,'col-lg-12':!abierto,'col-md-12':!abierto,'col-sm-12':!abierto}\">\n        <div class=\"botonera col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n            <button *ngIf=\"!noData\" type=\"button\" class=\"btn btn-sm btn-default\" (click)=\"ocultarEje()\"\n                    style=\"padding-right: 5px; padding-left:5px; float: right; margin: 5px;\" [disabled]=\"loading\">\n                <img *ngIf=\"ejeY\" src=\"" + __webpack_require__(916) + "\" width=\"25px\">\n                <img *ngIf=\"!ejeY\" src=\"" + __webpack_require__(917) + "\" width=\"25px\">\n            </button>\n            <button id=\"csv\" *ngIf=\"!noData\" type=\"button\" class=\"btn btn-sm btn-default\" (click)=\"exportCSV()\"\n                    style=\"padding-right: 5px; padding-left:5px; float: right;margin: 5px;\" [disabled]=\"loading\">\n                <img src=\"" + __webpack_require__(918) + "\" width=\"25px\">\n            </button>\n            <button *ngIf=\"!noData\" type=\"button\" class=\"btn btn-sm btn-default\" (click)=\"export('application/pdf')\"\n                    style=\"padding-right: 5px; padding-left:5px; float: right;margin: 5px;\" [disabled]=\"loading\">\n                <img src=\"" + __webpack_require__(919) + "\" width=\"25px\">\n            </button>\n            <button *ngIf=\"!noData\" type=\"button\" class=\"btn btn-sm btn-default\" (click)=\"export('image/jpeg')\"\n                    style=\"padding-right: 5px; padding-left:5px; float: right;margin: 5px;\" [disabled]=\"loading\">\n                <img src=\"" + __webpack_require__(920) + "\" width=\"25px\">\n            </button>\n            <button *ngIf=\"!noData\" type=\"button\" class=\"btn btn-sm btn-default\" (click)=\"exportInformeResumen()\"\n                    style=\"padding-right: 5px; padding-left:5px; float: right;margin: 5px;\" [disabled]=\"loading\">\n                <img src=\"" + __webpack_require__(997) + "\" width=\"25px\">\n            </button>\n        </div>\n        <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n            <div *ngIf=\"noData && !loading\" class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 noChartData\"\n                 style=\"text-align: center\" style=\"position: absolute\">\n                <span class=\"glyphicon glyphicon-check nota\" aria-hidden=\"true\"\n                      style=\"font-size: 70px; padding: 20px\">\n                </span>\n                <h2 class=\"nota\">Seleccione las variables que quiera observar</h2>\n            </div>\n            <div *ngIf=\"loading\" class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 noChartData\"\n                 style=\"text-align: center; position: absolute\">\n                <img src=\"" + __webpack_require__(998) + "\" width=\"100px\">\n            </div>\n            <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                <div [ngClass]=\"{'ocultarGrafico': (noData && loading) || noData}\" id=\"container\"></div>\n            </div>\n            <div *ngIf=\"loading\" class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 backdrop\"></div>\n\n\n        </div>\n\n\n        <!--{{loading}}-->\n    </div>\n    <div class=\"clearfix visible-lg-block\"></div>\n    <div class=\"clearfix visible-md-block\"></div>\n    <div class=\"clearfix visible-sm-block\"></div>\n    <div class=\"clearfix visible-xs-block\"></div>\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 marcoDatos\">\n        <div class=\"datos col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n            <ul class=\"nav nav-tabs\">\n                <li class=\"active\"><a data-toggle=\"tab\" href=\"#sensor\">Sensor</a></li>\n                <li><a data-toggle=\"tab\" href=\"#nodo\">Nodo</a></li>\n            </ul>\n            <div class=\"tab-content\">\n                <div id=\"sensor\" class=\"tab-pane fade in active\">\n                    <h3>Alarmas por Sensor</h3>\n                    <div class=\"table-responsive\">\n                        <table class=\"table\">\n                            <thead>\n                            <tr>\n                                <th>Nodo</th>\n                                <th>Sensor</th>\n                                <th>Tipo Alarma</th>\n                                <th>Fecha Activación</th>\n                                <th>Fecha Normalización</th>\n                                <th>Color</th>\n                                <th>Valor Mínimo</th>\n                                <th>Valor Máximo</th>\n                                <th>Valor Detectado</th>\n                                <th>Promedio</th>\n                            </tr>\n                            </thead>\n                            <tbody>\n                            <tr>\n                                <td *ngIf=\"regAlarma.length==0\" colSpan=\"8\" style=\"text-align: center\">No hay alarmas\n                                    registradas para el período\n                                </td>\n                            </tr>\n                            <tr *ngFor=\"let alarma of regAlarma; let i = index\">\n                                <td>{{alarma.nodo_id.nombre}}</td>\n                                <td>\n                                        <span *ngIf=\"alarma.sensor_id!=null\" class=\"label label-danger\"\n                                              [style.background]=\"alarma.sensor_id!=null?asignacionColor.get(alarma.sensor_id._id):white\">\n                                            {{alarma.sensor_id!=null?alarma.sensor_id.etiqueta:\"\"}}\n                                        </span>\n                                </td>\n                                <td>{{alarma.tipoEspecial==null?\"Alarma por\n                                    rango\":(alarma.tipoEspecial==\"SENSORNULL\"?\"Sensor sin valor\":\"Bateria Baja\")}}\n                                </td>\n                                <td>{{alarma.fechaActivado | dateTimeZone: 'DD/MM/yyyy HH:mm' : offsetTimeZone}}</td>\n                                <td>{{alarma.fechaDesactivado | dateTimeZone: 'DD/MM/yyyy HH:mm' : offsetTimeZone}}</td>\n                                <td>\n                                    <label [ngClass]=\"{'label': true, 'label-warning': alarma.color=='Amarillo', 'label-danger': alarma.color=='Rojo'}\">\n                                        {{alarma.color}}\n                                    </label>\n                                </td>\n                                <td>{{alarma.tipoEspecial!=null?\"\":alarma.valorMinimo}}</td>\n                                <td>{{alarma.tipoEspecial!=null?\"\":alarma.valorMaximo}}</td>\n                                <td>{{alarma.tipoEspecial!=null?\"\":alarma.valorMedido}}</td>\n                                <td>{{alarma.tipoEspecial!=null?\"\":alarma.promedio}}</td>\n                            </tr>\n                            </tbody>\n                        </table>\n                    </div>\n                </div>\n                <div id=\"nodo\" class=\"tab-pane fade\">\n                    <h3>Alarmas por Nodo</h3>\n                    <div class=\"table-responsive\">\n                        <table class=\"table\">\n                            <thead>\n                            <tr>\n                                <th>Nodo</th>\n                                <th>Tipo Alarma</th>\n                                <th>Fecha Activación</th>\n                                <th>Fecha Normalización</th>\n                            </tr>\n                            </thead>\n                            <tbody>\n                            <tr>\n                                <td *ngIf=\"regAlarmaNodos.length==0\" colSpan=\"8\" style=\"text-align: center\">No hay\n                                    alarmas registradas para el período\n                                </td>\n                            </tr>\n                            <tr *ngFor=\"let alarma of regAlarmaNodos; let i = index\">\n                                <td>{{alarma.nodo_id.nombre}}</td>\n                                <td>{{alarma.tipoEspecial==null?\"Alarma por\n                                    rango\":(alarma.tipoEspecial==\"SINACTIVIDAD\"?\"Sin Actividad\":\"Bateria Baja\")}}\n                                </td>\n                                <td>{{alarma.fechaActivado | dateTimeZone: 'DD/MM/yyyy HH:mm' : offsetTimeZone}}</td>\n                                <td>{{alarma.fechaDesactivado | dateTimeZone: 'DD/MM/yyyy HH:mm' : offsetTimeZone}}</td>\n                            </tr>\n                            </tbody>\n                        </table>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/reporte.eb79fec67123954050ee3effa7c6be61.png";

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/loader.5d4e7d5eca90efc08918c9e2e5465512.gif";

/***/ }),
/* 999 */
/***/ (function(module, exports) {

	module.exports = ".barraProgreso {\n    position: fixed;\n    bottom: 0px;\n    left: 85px;\n    z-index: 10;\n    height: 10px;\n}\n\n@media (max-width: 769px) {\n    .barraProgreso {\n        left: 0px;\n    }\n}\n.progress-bar {\n    background-color: #fa7252;\n}\n\n.progress {\n    border-radius: 0px;\n}\n\n.ocultarGrafico {\n    visibility: hidden;\n    opacity: 0;\n}\n\n.noChartData{\n    width: 95%;\n    top: 35vh;\n}\n\n.backdrop{\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(240, 240, 240, 0.4) ;\n    margin-left: -15px;\n    pointer-events: none;\n}"

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var usuario_service_1 = __webpack_require__(430);
	var sucursal_service_1 = __webpack_require__(429);
	var nodo_service_1 = __webpack_require__(433);
	var medicion_service_1 = __webpack_require__(434);
	var rol_service_1 = __webpack_require__(432);
	var empresa_service_1 = __webpack_require__(425);
	var permiso_service_1 = __webpack_require__(427);
	var router_1 = __webpack_require__(329);
	var login_service_1 = __webpack_require__(381);
	var regAlarma_service_1 = __webpack_require__(572);
	__webpack_require__(653);
	var logActividad_service_1 = __webpack_require__(897);
	var myGlobals = __webpack_require__(414);
	var moment = __webpack_require__(435);
	var ActividadesComponent = (function () {
	    function ActividadesComponent(usuarioService, sucursalService, empresaService, route, loginService, permisoService, rolService, regAlarmaService, nodoService, medicionService, logActividadService, router) {
	        var _this = this;
	        this.usuarioService = usuarioService;
	        this.sucursalService = sucursalService;
	        this.empresaService = empresaService;
	        this.route = route;
	        this.loginService = loginService;
	        this.permisoService = permisoService;
	        this.rolService = rolService;
	        this.regAlarmaService = regAlarmaService;
	        this.nodoService = nodoService;
	        this.medicionService = medicionService;
	        this.logActividadService = logActividadService;
	        this.router = router;
	        this.abierto = true;
	        this.loginService.logIn.subscribe(function (mode) {
	            if (mode) {
	                _this.usuarioConectado = _this.loginService.getDecodeToken();
	            }
	        });
	    }
	    ActividadesComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        window.scrollTo(0, 0);
	        this.usuarioConectado = this.loginService.getDecodeToken();
	        //Perdir permisos
	        this.abierto = true;
	        this.regAlarma = [];
	        this.regAlarmaNodos = [];
	        this.sucursalSeleccionada = "";
	        this.mostrarEliminados = false;
	        this.fechaDesde = new Date().toISOString().substring(0, 10);
	        this.fechaHasta = new Date().toISOString().substring(0, 10);
	        this.loading = false;
	        this.offsetTimeZone = "-03:00";
	        //Obtener empresas de ese usuario
	        this.empresaService.getEmpresas()
	            .subscribe(function (data) {
	            _this.empresas = data;
	            if (data.length > 0)
	                _this.cambiarSucursales(data[0]._id);
	        });
	        this.permisos = new Map();
	        this.permisoService.getPermiso("alarma").subscribe(function (permisos) {
	            for (var _i = 0, _a = permisos.tipoPermiso; _i < _a.length; _i++) {
	                var permiso = _a[_i];
	                _this.permisos.set(permiso.descripcion, true);
	            }
	            //Si no tiene permiso para ver redirijo
	            if (!_this.permisos.get("read"))
	                _this.router.navigate(['/home']);
	        });
	        //Inicializar tabla
	        $("#alertSeleccion").hide();
	        //Ocultar la barra cuando hace click afuera
	        if ($(window).width() < 769)
	            $(document).bind("mouseup touchend", function (e) {
	                var container = $("#barraSelectora");
	                if (!container.is(e.target) // if the target of the click isn't the container...
	                    && container.has(e.target).length === 0
	                    && e.target.id != "iconoBarraSelectora" && e.target.className != "botonConfig" && e.target.id != "desBarraSelectora"
	                    && e.target.id != "flechaBarraSelectora") {
	                    $('#barraSelectora').css("display", "none");
	                }
	            });
	    };
	    ActividadesComponent.prototype.ngOnDestroy = function () {
	        var boton = document.getElementById("exportButton");
	        if (boton)
	            boton.removeEventListener("click", this.func);
	    };
	    ActividadesComponent.prototype.cambiarSucursales = function (id) {
	        var _this = this;
	        $("#grid-dataNodo").bootgrid("destroy");
	        $("#grid-data").bootgrid("destroy");
	        this.sucursalService.getSucursalByEmpresa(id).subscribe(function (data) {
	            _this.sucursales = data;
	            if (data.length > 0) {
	                //Calcular fechaDesde para mostrar histórico
	                var fechaDesde = new Date();
	                fechaDesde.setDate(fechaDesde.getDate() - data[0].historico_dias);
	                _this.fechaDesde = fechaDesde.toISOString().substring(0, 10);
	                //this.cambiarSensores(data[0]._id);
	                _this.cambiarFechaPorSucu(data[0]._id);
	            }
	            else {
	                _this.sucursales = [];
	            }
	        });
	    };
	    ActividadesComponent.prototype.buscarRegistroActividad = function (e) {
	        this.noData = false;
	        //Alarmas Por Sensor
	        $("#grid-data").on("initialized.rs.jquery.bootgrid", function () {
	            $("#grid-data-header").find('.actions.btn-group').append('<button class="btn btn-default" id="exportButton" type="button" (click)="exportInformeActividades()">Exportar <span class="icon glyphicon glyphicon-export"></span></button>');
	            var boton = document.getElementById("exportButton");
	            this.func = this.exportInformeActividades.bind(this);
	            if (boton) {
	                boton.disabled = this.loading;
	                boton.addEventListener("click", this.func);
	            }
	        }.bind(this)).bootgrid({
	            ajax: true,
	            selection: true,
	            multiSelect: false,
	            rowSelect: false,
	            formatters: {
	                "accion": function (column, row) {
	                    switch (row.motivo) {
	                        case "create":
	                            return "<div><span class=\"label label-info\">Alta</span></div>";
	                        case "update":
	                            return "<div><span class=\"label label-warning\">Modificación</span></div>";
	                        case "delete":
	                            return "<div><span class=\"label label-danger\">Baja</span></div>";
	                    }
	                },
	                "sucursal": function (column, row) {
	                    return row.sucursal_id ? row.sucursal_id.descripcion : "-";
	                },
	                "fecha": function (column, row) {
	                    var date_str = row.fecha;
	                    if (moment(date_str).isValid())
	                        return moment(date_str).utcOffset(this.offsetTimeZone).format("DD-MM-YYYY HH:mm");
	                    else
	                        return "";
	                }.bind(this),
	                "json": function (column, row) {
	                    if (row.json) {
	                        var j = row.json.split('\"').join(' ');
	                        j = j.split(', ').join(', <br>');
	                        return "<div id=\"accordion\" class=\"panel-group\"> " +
	                            "<div class=\"panel panel-default\"> " +
	                            "<div class=\"panel-heading\"> " +
	                            "<h4 class=\"panel-title\"> " +
	                            "<a onClick='$(\"#" + row._id + "\").collapse(\"toggle\")'>Ver datos</a> " +
	                            "</h4> " +
	                            "</div> " +
	                            "<div id=\"" + row._id + "\" class=\"panel-collapse collapse\"> " +
	                            "<div class=\"panel-body\"> " +
	                            "<p style='overflow: scroll'><pre>" + JSON.stringify(j, null, 4) + "</pre></p>" +
	                            "</div> " +
	                            "</div> " +
	                            "</div>" +
	                            "</div>";
	                    }
	                    else
	                        return "";
	                }
	            },
	            ajaxSettings: {
	                headers: {
	                    "Authorization": this.loginService.getToken()
	                },
	                method: "GET"
	            },
	            requestHandler: function (request) {
	                //request.sensores = JSON.stringify({sensores_id: this.idSensores});
	                request.idSucursal = this.sucursalSeleccionada._id;
	                if (this.fechaDesde != null) {
	                    var fechaDesdeStr = moment(this.fechaDesde).toISOString();
	                    request.fechaDesde = fechaDesdeStr;
	                }
	                if (this.fechaHasta != null) {
	                    var fechaHastaStr = moment(this.fechaHasta).endOf('day').toISOString();
	                    request.fechaHasta = fechaHastaStr;
	                }
	                return request;
	            }.bind(this),
	            url: myGlobals.default.BASE_URL + "/logActividad/logActividadTable/"
	        });
	        $("#grid-data").bootgrid("reload");
	    };
	    ActividadesComponent.prototype.cambiarFecha = function () {
	        this.buscarRegistroActividad(null);
	    };
	    ActividadesComponent.prototype.cambiarFechaPorSucu = function (id) {
	        $("#grid-data").bootgrid("destroy");
	        //Calcular fechaDesde
	        var sucursalSeleccionada = null;
	        for (var _i = 0, _a = this.sucursales; _i < _a.length; _i++) {
	            var sucursal = _a[_i];
	            if (sucursal._id == id) {
	                sucursalSeleccionada = sucursal;
	                this.sucursalSeleccionada = sucursal;
	                if (sucursal && sucursal.husoHorario_id && sucursal.husoHorario_id.offset)
	                    this.offsetTimeZone = sucursal.husoHorario_id.offset;
	                else
	                    this.offsetTimeZone = "-03:00";
	                break;
	            }
	        }
	        var fechaDesde = new Date();
	        fechaDesde.setDate(fechaDesde.getDate() - sucursalSeleccionada.historico_dias);
	        this.fechaDesde = fechaDesde.toISOString().substring(0, 10);
	        this.ubicaciones = [];
	        this.cambiarFecha();
	    };
	    ActividadesComponent.prototype.ocultarBarraSelectora = function () {
	        if ($('#barraSelectora').css("display") == "block")
	            $('#barraSelectora').css("display", "none");
	        else
	            $('#barraSelectora').css("display", "block");
	    };
	    ActividadesComponent.prototype.exportInformeActividades = function () {
	        var _this = this;
	        var filtros = {};
	        var fechaDesdeStr = moment(this.fechaDesde).toISOString();
	        filtros.fechaDesde = fechaDesdeStr;
	        var fechaHastaStr = moment(this.fechaHasta).endOf('day').toISOString();
	        filtros.fechaHasta = fechaHastaStr;
	        filtros.idSucursal = this.sucursalSeleccionada._id;
	        this.loading = true;
	        var boton = document.getElementById("exportButton");
	        if (boton)
	            boton.disabled = this.loading;
	        var inputs = document.getElementsByClassName("search-field form-control");
	        if (inputs.length === 1)
	            filtros.searchPhrase = inputs[0].value;
	        this.logActividadService.export(filtros)
	            .subscribe(function (res) {
	            _this.loading = false;
	            if (boton)
	                boton.disabled = _this.loading;
	        });
	    };
	    ActividadesComponent = __decorate([
	        core_1.Component({
	            selector: 'actividades',
	            template: __webpack_require__(1001),
	            styles: [__webpack_require__(1002)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof usuario_service_1.UsuariosService !== 'undefined' && usuario_service_1.UsuariosService) === 'function' && _a) || Object, (typeof (_b = typeof sucursal_service_1.SucursalService !== 'undefined' && sucursal_service_1.SucursalService) === 'function' && _b) || Object, (typeof (_c = typeof empresa_service_1.EmpresaService !== 'undefined' && empresa_service_1.EmpresaService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _d) || Object, (typeof (_e = typeof login_service_1.LoginService !== 'undefined' && login_service_1.LoginService) === 'function' && _e) || Object, (typeof (_f = typeof permiso_service_1.PermisoService !== 'undefined' && permiso_service_1.PermisoService) === 'function' && _f) || Object, (typeof (_g = typeof rol_service_1.RolService !== 'undefined' && rol_service_1.RolService) === 'function' && _g) || Object, (typeof (_h = typeof regAlarma_service_1.RegAlarmaService !== 'undefined' && regAlarma_service_1.RegAlarmaService) === 'function' && _h) || Object, (typeof (_j = typeof nodo_service_1.NodoService !== 'undefined' && nodo_service_1.NodoService) === 'function' && _j) || Object, (typeof (_k = typeof medicion_service_1.MedicionService !== 'undefined' && medicion_service_1.MedicionService) === 'function' && _k) || Object, (typeof (_l = typeof logActividad_service_1.LogActividadService !== 'undefined' && logActividad_service_1.LogActividadService) === 'function' && _l) || Object, (typeof (_m = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _m) || Object])
	    ], ActividadesComponent);
	    return ActividadesComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
	}());
	exports.ActividadesComponent = ActividadesComponent;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(419)))

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 contenido\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 titulo\">\n        <div class=\"marcoTitulo\">\n            <h2>Actividades</h2>\n            <p>Home / Actividades</p>\n        </div>\n    </div>\n    <div class=\"botonConfig visible-xs col-xs-12\" (click)=\"ocultarBarraSelectora()\">\n        <div id=\"iconoBarraSelectora\" class=\"col-xs-2\">\n            <i class=\"fa fa-cogs fa-spin fa-2x fa-fw\" style=\"color:white\"></i>\n        </div>\n        <div id=\"desBarraSelectora\" class=\"col-xs-10\" style=\"text-align: left;padding-left: 35px;\">\n            Seleccione las variables ...\n            <b class=\"caret\" id=\"flechaBarraSelectora\"></b>\n        </div>\n    </div>\n    <div id=\"barraSelectora\" class=\"col-lg-3 col-md-3 col-sm-3 col-xs-12 barraArbolBase\"\n         [ngClass]=\"{'barraArbolBaseOcultar':!abierto}\">\n        <div class=\"barraArbolCuerpo\" [ngClass]=\"{'barraArbolCuerpoOcultar':!abierto}\">\n            <div class=\"informacionArbol\">\n                <div class=\"form-group\">\n                    <label for=\"sucursal\">Empresa</label>\n                    <select class=\"form-control\" id=\"empresa\" placeholder=\"Empresa\"\n                            (change)=\"cambiarSucursales($event.target.value)\">\n                        <option *ngFor=\"let empresa of empresas\" value={{empresa._id}}>{{empresa.descripcion}}</option>\n                    </select>\n                </div>\n                <div class=\"form-group\">\n                    <label for=\"sucursal\">Sucursal</label>\n                    <select class=\"form-control\" id=\"sucursal\" placeholder=\"Sucursal\"\n                            (change)=\"cambiarFechaPorSucu($event.target.value)\">\n                        <option *ngFor=\"let sucursal of sucursales\" value={{sucursal._id}}>{{sucursal.descripcion}}\n                        </option>\n                    </select>\n                </div>\n                <p>{{sucursalSeleccionada && sucursalSeleccionada.husoHorario_id ? sucursalSeleccionada.husoHorario_id.zonaHoraria + \" (\" + offsetTimeZone + \")\" : \"\"}}</p>\n                <div class=\"form-group\">\n                    <label for=\"sucursal\">Fecha Desde</label>\n                    <input type=\"date\" class=\"form-control\" id=\"fechaDesde\" [(ngModel)]=\"fechaDesde\"\n                           (change)=\"cambiarFecha()\"/>\n                </div>\n                <div class=\"form-group\">\n                    <label for=\"sucursal\">Fecha Hasta</label>\n                    <input type=\"date\" class=\"form-control\" id=\"fechaHasta\" [(ngModel)]=\"fechaHasta\"\n                           (change)=\"cambiarFecha()\"/>\n                </div>\n            </div>\n        </div>\n        <div class=\"barraArbolBoton hidden-xs\">\n            <button (click)=\"abierto=!abierto\"><i class=\"fa fa-cogs fa-spin fa-1x fa-fw\" style=\"color:white\"></i>\n            </button>\n        </div>\n    </div>\n\n    <div [ngClass]=\"{'medicionesComprimido':abierto,'medicionesExtendido':!abierto,'col-lg-9':abierto,'col-md-9':abierto,'col-sm-9':abierto,'col-xs-12':true,'col-lg-12':!abierto,'col-md-12':!abierto,'col-sm-12':!abierto}\"\n         style=\"max-height: inherit; height: inherit; min-height: 100vh;\">\n        <div class=\"table-responsive col-xs-12\">\n            <div *ngIf=\"loading\" class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 noChartData\" style=\"text-align: center; position: absolute\">\n                <img src=\"" + __webpack_require__(998) + "\" width=\"100px\">\n            </div>\n        <table id=\"grid-data\" class=\"table table-condensed table-hover\">\n            <thead>\n            <tr>\n                <!--<th data-column-id=\"_id\" data-identifier=\"true\" data-visible=\"false\" data-visible-in-selection=\"false\">_id</th>-->\n                <th data-column-id=\"fecha\" data-formatter=\"fecha\" data-order=\"desc\">Fecha</th>\n                <th data-column-id=\"motivo\" data-formatter=\"accion\">Acción</th>\n                <th data-column-id=\"tabla\">Entidad</th>\n                <th data-column-id=\"usuario_name\">Usuario</th>\n                <th data-column-id=\"resumen\">Resumen</th>\n                <th data-column-id=\"sucursal_id\" data-formatter=\"sucursal\">Sucursal</th>\n                <!--<th data-column-id=\"commands\" data-formatter=\"commands\" data-sortable=\"false\">Commands</th>-->\n                <th *ngIf=\"usuarioConectado.rol == 'Administrador' || usuarioConectado.rol == 'Tecnico'\" data-column-id=\"json\" data-formatter=\"json\">Datos</th>\n            </tr>\n            </thead>\n            <tbody>\n            </tbody>\n        </table>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 1002 */
/***/ (function(module, exports) {

	module.exports = "h3 {\n    font-family: \"Raleway\" !important;\n    border-bottom: 1px solid #ccc9c9;\n    padding-bottom: 15px;\n    padding-right: 10px;\n    padding-left: 10px;\n    margin-bottom: 20px;\n    font-size: 18px;\n    font-weight: 300;\n}\n\n.barraArbolBase {\n    position: -webkit-sticky;\n    position: sticky;\n    top: 60px;\n}\n\n.informacionArbol {\n    height: calc(100vh - 60px);\n}\n\n.barraArbolBaseOcultar {\n    margin-top: 88px !important;\n}"

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var login_service_1 = __webpack_require__(381);
	var router_1 = __webpack_require__(329);
	var ResetComponent = (function () {
	    function ResetComponent(loginService, router, activatedRoute) {
	        var _this = this;
	        this.loginService = loginService;
	        this.router = router;
	        this.activatedRoute = activatedRoute;
	        this.password = "";
	        this.repetirPassword = "";
	        this.error = "";
	        this.token = "";
	        loginService.error.subscribe(function (error) { return _this.error = error; });
	    }
	    ResetComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.activatedRoute.params.subscribe(function (params) {
	            _this.token = params['token'];
	            console.log(_this.token);
	            _this.loginService.validateReset(_this.token);
	        });
	        //Detectar ojo pass
	        $("#ojo").mousedown(function () {
	            $(".noVisible").css("display", "none");
	            $(".visible").css("display", "inline");
	        });
	        $("#ojo").mouseup(function () {
	            $(".noVisible").css("display", "inline");
	            $(".visible").css("display", "none");
	        });
	    };
	    ResetComponent.prototype.cambiarRepetirPassword = function () {
	        var input = $("#repetirPassword");
	        if (this.password != this.repetirPassword)
	            $("#repetirPassword").get(0).setCustomValidity("Las contraseñas deben coincidir");
	        else
	            $("#repetirPassword").get(0).setCustomValidity("");
	    };
	    ResetComponent.prototype.resetPassword = function (e) {
	        //e.preventDefault();
	        if ($("#formulario")[0].checkValidity())
	            this.loginService.resetPassword(this.token, this.password);
	    };
	    ResetComponent = __decorate([
	        core_1.Component({
	            selector: 'reset',
	            template: __webpack_require__(1004),
	            styles: [__webpack_require__(1006)],
	            directives: [router_1.ROUTER_DIRECTIVES]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof login_service_1.LoginService !== 'undefined' && login_service_1.LoginService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object])
	    ], ResetComponent);
	    return ResetComponent;
	    var _a, _b, _c;
	}());
	exports.ResetComponent = ResetComponent;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(419)))

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"login-fondo\">\n    <div class=\"col-lg-offset-4 col-md-offset-4 col-lg-4 col-md-4\">\n        <div class=\"login-all\">\n            <div class=\"login-titulo\">\n                <div style=\"text-align:center\">\n                    <h4>Formulario de Restablecimiento de Contraseña</h4>\n                    <p>Ingrese su nueva Contraseña.</p>\n                </div>\n            </div>\n            <div class=\"login-cuerpo\">\n                <p>{{error}}</p>\n                <form id=\"formulario\" *ngIf=\"error==''\" >\n                    <div class=\"form-group\">\n                        <div class=\"input-group\">\n                            <span id=\"ojo\" class=\"input-group-addon login\" style=\"\"><img src=\"" + __webpack_require__(1005) + "\" style=\"width:20px;\" /></span>\n                            <input id=\"password\" name=\"password\" type=\"password\" [(ngModel)]=\"password\" class=\"form-control login noVisible\" placeholder=\"Contraseña\" required onfocus=\"$('#borderLogin').addClass('borderFocus');\" onfocusout=\"$('#borderLogin').removeClass('borderFocus');\">\n                            <input id=\"password2\" name=\"password\" type=\"text\" [(ngModel)]=\"password\" class=\"form-control login visible\" placeholder=\"Contraseña\" required onfocus=\"$('#borderLogin').addClass('borderFocus');\" onfocusout=\"$('#borderLogin').removeClass('borderFocus');\" style=\"display: none\">\n                        </div>\n                        <div class=\"col-md-12 borderLogin\" id=\"borderLogin\"></div>\n                    </div>\n                    <div class=\"form-group\">\n                        <div class=\"input-group\">\n                            <span class=\"input-group-addon login\"><img src=\"" + __webpack_require__(423) + "\" style=\"width:20px;\" /></span>\n                            <input type=\"password\" id=\"repetirPassword\" name=\"repetirPassword\" [(ngModel)]=\"repetirPassword\" class=\"form-control login\" placeholder=\"Repetir Contraseña\" required onfocus=\"$('#borderLogin1').addClass('borderFocus');\" onfocusout=\"$('#borderLogin1').removeClass('borderFocus');\" (change)=\"cambiarRepetirPassword()\">\n                        </div>\n                        <div class=\"col-md-12 borderLogin\" id=\"borderLogin1\"></div>\n                    </div>\n                    <button type=\"submit\" (click)=\"resetPassword($event)\" class=\"btn btn-primary btn-block login\">Cambiar Contraseña</button>\n                </form>\n            </div>\n            <a [routerLink]=\"['/login']\">Volver al Login</a>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/ojo.e884c56cf4b4b443c09e19b14c59ecdf.svg";

/***/ }),
/* 1006 */
/***/ (function(module, exports) {

	module.exports = ".login-fondo{\n    background-color: #273135;\n    min-height: 100vh;\n    height: 100%;\n    width: 100vw;\n}\n\n.login-all{\n    width: 100%;\n    border-radius: 10%;\n    padding-top: 20%;\n}\n\n.login-titulo{\n    background-color: #273135;\n    color: white;\n    padding: 15px 30px 15px 30px;\n    min-height: 118px;\n}\n\n.ng-invalid {\n    border-left: none;\n}\n.ng-valid[required] {\n    border-left: none;\n}\n\nbutton.login {\n    border-radius: 0px;\n    height: 50px;\n    background-color: #E76049;\n    border-color: #E76049;\n    margin-top: 60px;\n}\nbutton.login:hover {\n    background-color: #E76049;\n    border-color: #E76049;\n}\n\n.login-cuerpo p {\n    text-align: center;\n    color: red;\n}"

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var router_1 = __webpack_require__(329);
	var usuario_service_1 = __webpack_require__(430);
	var rol_service_1 = __webpack_require__(432);
	var login_service_1 = __webpack_require__(381);
	var miCuenta_service_1 = __webpack_require__(893);
	var MiCuentaComponent = (function () {
	    function MiCuentaComponent(router, usuarioService, rolService, loginService, miCuentaService) {
	        this.router = router;
	        this.usuarioService = usuarioService;
	        this.rolService = rolService;
	        this.loginService = loginService;
	        this.miCuentaService = miCuentaService;
	    }
	    MiCuentaComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.tiposAlarmas = [{ titulo: 'Notificaciones de sin actividad en los nodos:', value: 'sinactividad' },
	            { titulo: 'Notificaciones de calibración:', value: 'calibracion' },
	            { titulo: 'Notificaciones de valores anormales de alarmas para canales:', value: 'rango' }];
	        this.tiposAlarmasAdmin = [
	            { titulo: 'Notificaciones de bateria:', value: 'bateria' },
	            { titulo: 'Notificaciones de sensor sin información:', value: 'sensornull' }];
	        this.medios = ["SMS", "WhatsApp", "Email"];
	        this.usuarioConectado = this.loginService.getDecodeToken();
	        //Busco usuario
	        this.usuarioService
	            .getUsuario(this.loginService.getDecodeToken().id)
	            .subscribe(function (user) {
	            _this.usuario = user;
	            _this.tiposAlarmasAdmin.forEach(function (tipo) {
	                if (!_this.usuario[tipo.value])
	                    _this.usuario[tipo.value] = {};
	            });
	            _this.tiposAlarmas.forEach(function (tipo) {
	                if (!_this.usuario[tipo.value])
	                    _this.usuario[tipo.value] = {};
	            });
	        });
	        //Inicializar banderas para resetear forms
	        this.active = true;
	        //Obtener roles
	        this.rolService.getRoles()
	            .subscribe(function (roles) {
	            _this.roles = roles;
	        });
	        //Seteo bandera para deshabilitar
	        this.deshabilitar = false;
	        this.pruebaSMS = false;
	        this.probando = false;
	    };
	    MiCuentaComponent.prototype.guardarCambios = function () {
	        var _this = this;
	        this.deshabilitar = true;
	        this.miCuentaService
	            .save(this.usuario)
	            .subscribe(function (usuario) {
	            _this.usuario = usuario;
	            _this.deshabilitar = false;
	        });
	    };
	    MiCuentaComponent.prototype.cancelar = function () {
	        var _this = this;
	        //Busco usuario
	        this.deshabilitar = true;
	        this.usuarioService
	            .getUsuario(this.loginService.getDecodeToken().id)
	            .subscribe(function (user) {
	            _this.usuario = user;
	            _this.deshabilitar = false;
	            _this.tiposAlarmasAdmin.forEach(function (tipo) {
	                if (!_this.usuario[tipo.value])
	                    _this.usuario[tipo.value] = {};
	            });
	            _this.tiposAlarmas.forEach(function (tipo) {
	                if (!_this.usuario[tipo.value])
	                    _this.usuario[tipo.value] = {};
	            });
	        });
	        var link = ['/home'];
	        this.router.navigate(link);
	    };
	    MiCuentaComponent.prototype.probarCelular = function () {
	        var _this = this;
	        this.pruebaSMS = false;
	        this.probando = true;
	        if (this.usuario.celular != "") {
	            console.log("OK");
	            this.usuarioService.probarCelular(this.usuario.celular)
	                .subscribe(function (result) {
	                console.log("OK");
	                _this.pruebaSMS = true;
	                _this.probando = false;
	                $(document).on('hidden.bs.modal', '.modal', function () {
	                    $('.modal:visible').length && $(document.body).addClass('modal-open');
	                });
	            }, function (error) {
	                _this.probando = false;
	            });
	        }
	    };
	    MiCuentaComponent = __decorate([
	        core_1.Component({
	            selector: 'miCuenta',
	            template: __webpack_require__(1008),
	            styles: [__webpack_require__(1010)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _a) || Object, (typeof (_b = typeof usuario_service_1.UsuariosService !== 'undefined' && usuario_service_1.UsuariosService) === 'function' && _b) || Object, (typeof (_c = typeof rol_service_1.RolService !== 'undefined' && rol_service_1.RolService) === 'function' && _c) || Object, (typeof (_d = typeof login_service_1.LoginService !== 'undefined' && login_service_1.LoginService) === 'function' && _d) || Object, (typeof (_e = typeof miCuenta_service_1.MiCuentaService !== 'undefined' && miCuenta_service_1.MiCuentaService) === 'function' && _e) || Object])
	    ], MiCuentaComponent);
	    return MiCuentaComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.MiCuentaComponent = MiCuentaComponent;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(419)))

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 contenido\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 titulo\">\n        <div class=\"marcoTitulo\">\n            <h2>Cambiar datos de Cuenta</h2>\n            <p>Home / Mi Cuenta</p>\n        </div>\n    </div>\n    <div class=\"rowdiv\">\n        <div class=\"col-lg-6 col-md-6 col-xs-12 marcoDatos coldiv\" *ngIf=\"usuario\">\n            <div class=\"datos\">\n                <div class=\"marcoTitulo marcoSubtitulo\">\n                    <h3>Datos de la cuenta</h3>\n                    <p>Modifique los datos de la cuenta</p>\n                </div>\n                <form #usuarioForm=\"ngForm\" *ngIf=\"active\">\n                    <div class=\"form-group\">\n                        <label for=\"rol\">Rol</label>\n                        <select class=\"form-control\" required id=\"rol\" name=\"rol\" [(ngModel)]=\"usuario.rol\"\n                                autocomplete=\"off\" #rol=\"ngModel\" [disabled]=\"true\">\n                            <option></option>\n                            <option *ngFor=\"let rol of roles\" [value]=\"rol._id\">{{rol.descripcion}}</option>\n                        </select>\n                        <div [hidden]=\"rol.valid || rol.pristine\" class=\"alert alert-danger\">\n                            Rol es requerido\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"apellido\">Apellido</label>\n                        <input type=\"text\" required class=\"form-control\" id=\"apellido\" name=\"apellido\"\n                               placeholder=\"Apellido\" [(ngModel)]=\"usuario.apellido\" #apellido=\"ngModel\"\n                               autocomplete=\"off\" [disabled]=\"deshabilitar\">\n                        <div [hidden]=\"apellido.valid || apellido.pristine\" class=\"alert alert-danger\">\n                            Apellido es requerido\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"nombre\">Nombre</label>\n                        <input type=\"text\" required class=\"form-control\" id=\"nombre\" name=\"nombre\" placeholder=\"Nombre\"\n                               [(ngModel)]=\"usuario.nombre\" #nombre=\"ngModel\" autocomplete=\"off\"\n                               [disabled]=\"deshabilitar\">\n                        <div [hidden]=\"nombre.valid || nombre.pristine\" class=\"alert alert-danger\">\n                            Nombre es requerido\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"dni\">DNI</label>\n                        <input type=\"number\" required class=\"form-control\" id=\"dni\" name=\"dni\" placeholder=\"Dni\"\n                               [(ngModel)]=\"usuario.dni\" #dni=\"ngModel\" autocomplete=\"off\" [disabled]=\"deshabilitar\">\n                        <div [hidden]=\"dni.valid || dni.pristine\" class=\"alert alert-danger\">\n                            DNI es requerido\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"puesto\">Puesto</label>\n                        <input type=\"text\" required class=\"form-control\" id=\"puesto\" name=\"puesto\" placeholder=\"Puesto\"\n                               [(ngModel)]=\"usuario.puesto\" #puesto=\"ngModel\" autocomplete=\"off\"\n                               [disabled]=\"deshabilitar\">\n                        <div [hidden]=\"puesto.valid || puesto.pristine\" class=\"alert alert-danger\">\n                            Puesto es requerido\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"mail\">E-mail</label>\n                        <input type=\"text\" required class=\"form-control\" id=\"mail\" name=\"mail\" placeholder=\"Mail\"\n                               [(ngModel)]=\"usuario.email\"\n                               pattern=\"^[_a-z0-9-]+(\\.[_a-z0-9-]+)*@[a-z0-9-]+(\\.[a-z0-9-]+)*(\\.[a-z]{2,3})$\"\n                               #mail=\"ngModel\" autocomplete=\"off\" [disabled]=\"deshabilitar\">\n                        <div [hidden]=\"mail.valid || mail.pristine\" class=\"alert alert-danger\">\n                            E-mail es requerido\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"celular\">Celular (+549 + código de área + número de celular sin el 15)</label>\n                        <p class=\"text-success\" [hidden]=\"!pruebaSMS\">Mensaje enviado! Verifica si el mensaje llego\n                            correctamente.\n                            Si no es así verifica que el número tenga el formato correcto.</p>\n                        <div class=\"input-group\">\n                            <input type=\"text\" class=\"form-control\" id=\"celular\" pattern='\\+549\\d{1,14}$'\n                                   name=\"celular\" placeholder=\"+5493410000000\" [(ngModel)]=\"usuario.celular\"\n                                   #celular=\"ngModel\" autocomplete=\"off\" [disabled]=\"deshabilitar\">\n                            <span class=\"input-group-btn\">\n                                <button class=\"btn btn-default\" type=\"button\"\n                                        [disabled]=\"!celular.valid || !usuario.celular || probando\"\n                                        (click)=\"probarCelular()\">\n                                    Probar\n                                </button>\n                            </span>\n                        </div>\n                        <div [hidden]=\"celular.valid || celular.pristine\" class=\"alert alert-danger\">\n                            Celular es requerido y debe cumplir con el formato (+549 + código de área + número de\n                            celular\n                            sin el\n                            15)\n                        </div>\n                    </div>\n                    <div class=\"table-responsive\">\n                        <table class=\"table\">\n                            <thead>\n                            <tr>\n                                <th>Sucursal</th>\n                                <th>Direccion</th>\n                            </tr>\n                            <tr *ngFor=\"let sucursal of usuario.sucursales; let i = index\">\n                                <td>{{sucursal.descripcion}}</td>\n                                <td>{{sucursal.direccion}}</td>\n                            </tr>\n                            </thead>\n                            <tbody>\n                            <td class=\"text-center\"\n                                *ngIf=\"usuario.sucursales == undefined || usuario.sucursales.length==0\" colspan=\"6\">\n                                No hay sucursales asignadas\n                            </td>\n                            </tbody>\n                        </table>\n                    </div>\n                    <button type='submit' data-toggle=\"tooltip\" data-placement=\"top\" title=\"Guardar\" animation=\"true\"\n                            class=\"btn btn-default btn-sm botonFlotante btn-success\" (click)=\"guardarCambios()\">\n                        <img src=\"" + __webpack_require__(1009) + "\" width=\"20px\"/>\n                    </button>\n                    <button data-toggle=\"tooltip\" data-placement=\"top\" title=\"Cancelar\" animation=\"true\"\n                            class=\"btn btn-default btn-sm botonFlotante2 btn-danger\" (click)=\"cancelar()\">\n                        <img src=\"" + __webpack_require__(933) + "\" width=\"25px\"/>\n                    </button>\n                </form>\n            </div>\n        </div>\n        <div class=\"col-lg-6 col-md-6 col-xs-12 marcoDatos coldiv\" *ngIf=\"usuario\">\n            <div class=\"datos\">\n                <div class=\"marcoTitulo marcoSubtitulo\">\n                    <h3>Notificaciones</h3>\n                    <p>¿Cómo desea recibir las notificaciones? Seleccione los medios por lo que desea recibir el aviso\n                        en\n                        cada caso.</p>\n                </div>\n                <div *ngFor=\"let tipo of tiposAlarmas\">\n                    <p>{{tipo.titulo}}</p>\n                    <div class=\"checkbox checkbox-warning\" *ngFor=\"let medio of medios\">\n                        <input type=\"checkbox\" [(ngModel)]=\"usuario[tipo.value][medio.toLowerCase()]\"\n                               [disabled]=\"deshabilitar\">\n                        <label>{{medio}}</label>\n                    </div>\n                </div>\n                <div *ngIf=\"usuarioConectado.rol == 'Administrador' || usuarioConectado.rol == 'Tecnico'\">\n                    <div *ngFor=\"let tipo of tiposAlarmasAdmin\">\n                        <p>{{tipo.titulo}}</p>\n                        <div class=\"checkbox checkbox-warning\" *ngFor=\"let medio of medios\">\n                            <input type=\"checkbox\" [(ngModel)]=\"usuario[tipo.value][medio.toLowerCase()]\"\n                                   [disabled]=\"deshabilitar\">\n                            <label>{{medio}}</label>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/save.5be2e7c377eed892fb9f3e5fc82f3591.svg";

/***/ }),
/* 1010 */
/***/ (function(module, exports) {

	module.exports = ".marcoSubtitulo {\n    padding: 0px !important;\n}\n\n.marcoSubtitulo p {\n    margin-bottom: 20px;\n}\n\n.marcoSubtitulo h3 {\n    margin-bottom: 10px;\n}\n\n.rowdiv {\n    display: flex; /* equal height of the children */\n    clear: both;\n    flex-wrap: wrap;\n}\n\n@media (max-width: 766px) {\n    .rowdiv {\n        display: block; /* equal height of the children */\n    }\n}\n\n.coldiv {\n    flex: 1;\n}\n\n.datos {\n    height: 100%;\n}"

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var router_1 = __webpack_require__(329);
	var router_2 = __webpack_require__(329);
	var usuario_service_1 = __webpack_require__(430);
	var login_service_1 = __webpack_require__(381);
	var miCuenta_service_1 = __webpack_require__(893);
	var CambiarPasswordComponent = (function () {
	    function CambiarPasswordComponent(router, usuarioService, loginService, miCuentaService) {
	        this.router = router;
	        this.usuarioService = usuarioService;
	        this.loginService = loginService;
	        this.miCuentaService = miCuentaService;
	    }
	    CambiarPasswordComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        //Busco usuario
	        if (this.loginService.getDecodeToken().id)
	            this.usuarioService
	                .getUsuario(this.loginService.getDecodeToken().id)
	                .subscribe(function (user) {
	                _this.usuario = user;
	            });
	        //Inicializar banderas para resetear forms
	        this.active = true;
	        //Seteo bandera para deshabilitar
	        this.deshabilitar = false;
	        //Detectar ojo pass
	        $("#ojo").mousedown(function () {
	            $(".noVisible").css("display", "none");
	            $(".visible").css("display", "inline");
	        });
	        $("#ojo").mouseup(function () {
	            $(".noVisible").css("display", "inline");
	            $(".visible").css("display", "none");
	        });
	        $("#ojo2").mousedown(function () {
	            $(".noVisible2").css("display", "none");
	            $(".visible2").css("display", "inline");
	        });
	        $("#ojo2").mouseup(function () {
	            $(".noVisible2").css("display", "inline");
	            $(".visible2").css("display", "none");
	        });
	    };
	    CambiarPasswordComponent.prototype.guardarCambios = function () {
	        var _this = this;
	        this.miCuentaService
	            .cambiarPassword(this.usuario)
	            .subscribe(function (usuario) {
	            _this.usuario = usuario;
	            _this.loginService.logout();
	        });
	    };
	    CambiarPasswordComponent.prototype.ojoDown = function () {
	        $(".noVisible").css("display", "none");
	        $(".visible").css("display", "inline");
	    };
	    CambiarPasswordComponent.prototype.ojoUp = function () {
	        $(".noVisible").css("display", "inline");
	        $(".visible").css("display", "none");
	    };
	    CambiarPasswordComponent.prototype.ojo2Down = function () {
	        $(".noVisible2").css("display", "none");
	        $(".visible2").css("display", "inline");
	    };
	    CambiarPasswordComponent.prototype.ojo2Up = function () {
	        $(".noVisible2").css("display", "inline");
	        $(".visible2").css("display", "none");
	    };
	    CambiarPasswordComponent = __decorate([
	        core_1.Component({
	            selector: 'cambiarPassword',
	            template: __webpack_require__(1012),
	            styles: [__webpack_require__(1013)],
	            directives: [router_2.ROUTER_DIRECTIVES]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _a) || Object, (typeof (_b = typeof usuario_service_1.UsuariosService !== 'undefined' && usuario_service_1.UsuariosService) === 'function' && _b) || Object, (typeof (_c = typeof login_service_1.LoginService !== 'undefined' && login_service_1.LoginService) === 'function' && _c) || Object, (typeof (_d = typeof miCuenta_service_1.MiCuentaService !== 'undefined' && miCuenta_service_1.MiCuentaService) === 'function' && _d) || Object])
	    ], CambiarPasswordComponent);
	    return CambiarPasswordComponent;
	    var _a, _b, _c, _d;
	}());
	exports.CambiarPasswordComponent = CambiarPasswordComponent;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(419)))

/***/ }),
/* 1012 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 contenido\"\n     [ngClass]=\"{'fondoNegro':loginService.getDecodeToken().cambiarPassword}\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 titulo\">\n        <div class=\"marcoTitulo\">\n            <h2>Cambiar Contraseña</h2>\n            <p>Home / Mi Cuenta</p>\n        </div>\n    </div>\n\n    <div class=\"col-lg-offset-2 col-md-offset-2 col-lg-8 col-md-8 col-xs-12\" *ngIf=\"usuario\">\n        <div *ngIf=\"loginService.getDecodeToken().cambiarPassword\" class=\"col-xs-12\"\n             style=\"margin-top: 15px;margin-bottom: 20px\">\n            <p>Por su seguridad, debe cambiar la contraseña provisoria.</p>\n        </div>\n        <form #usuarioForm=\"ngForm\" *ngIf=\"active\">\n            <div class=\"form-group\">\n                <div class=\"col-xs-12\">\n                    <label for=\"passwordAnterior\">Contraseña Anterior *</label>\n                    <div class=\"input-group\">\n                        <input type=\"password\" id=\"passwordAnterior\" name=\"passwordAnterior\"\n                               class=\"form-control noVisible2\"\n                               autoComplete=\"off\" required\n                               placeholder=\"Contraseña\" [(ngModel)]=\"usuario.passwordAnterior\"\n                               #passwordAnterior=\"ngModel\"/>\n\n                        <input type=\"text\" id=\"passwordAnterior\" name=\"passwordAnterior\" class=\"form-control visible2\"\n                               autoComplete=\"off\"\n                               placeholder=\"Contraseña\" [(ngModel)]=\"usuario.passwordAnterior\" style=\"display: none\"/>\n                        <span id=\"ojo2\" class=\"input-group-addon\" data-toggle=\"tooltip\" data-placement=\"top\"\n                              title=\"Ver Contraseña\" animation=\"true\" (mousedown)=\"ojo2Down()\" (mouseup)=\"ojo2Up()\">\n                                    <span class=\"glyphicon glyphicon-eye-open\">\n                                    </span>\n                                </span>\n                    </div>\n                    <div [hidden]=\"passwordAnterior.valid || passwordAnterior.pristine\"\n                         class=\"alert alert-danger col-xs-12\">\n                        Contraseña Anterior es requerido\n                    </div>\n                </div>\n            </div>\n            <div class=\"form-group\">\n                <div class=\"col-xs-12\">\n                    <label for=\"password\">Contraseña Nueva *</label>\n                    <div class=\"input-group\">\n\n                        <input type=\"password\" id=\"password\" name=\"password\" class=\"form-control noVisible\"\n                               autoComplete=\"off\" required\n                               placeholder=\"Contraseña\" [(ngModel)]=\"usuario.password\" #password=\"ngModel\"\n                               autocomplete=\"off\" [disabled]=\"deshabilitar\"/>\n                        <input type=\"text\" id=\"password\" name=\"password\" class=\"form-control visible\" autoComplete=\"off\"\n                               placeholder=\"Contraseña\" [(ngModel)]=\"usuario.password\" style=\"display: none\"/>\n                        <span id=\"ojo\" class=\"input-group-addon\" data-toggle=\"tooltip\" data-placement=\"top\"\n                              title=\"Ver Contraseña\"\n                              animation=\"true\" (mousedown)=\"ojoDown()\" (mouseup)=\"ojoUp()\">\n                                    <span class=\"glyphicon glyphicon-eye-open\">\n                                    </span>\n                                </span>\n                    </div>\n                    <div [hidden]=\"password.valid || password.pristine\" class=\"alert alert-danger col-xs-12\">\n                        Contraseña es requerido\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"form-group\">\n                <div class=\"col-xs-12\">\n                    <label for=\"repetir\">Repetir Contraseña Nueva *</label>\n                    <input type=\"password\" id=\"repetir\" class=\"form-control\" autoComplete=\"off\" id=\"repetirPassword\"\n                           name=\"repetirPassword\" required #repetirPassword=\"ngModel\"\n                           [(ngModel)]=\"usuario.repetirPassword\"/>\n                    <div [hidden]=\"repetirPassword.valid || repetirPassword.pristine\" class=\"alert alert-danger\">\n                        Repetir Contraseña Nueva es requerido\n                    </div>\n                </div>\n            </div>\n            <div class=\"col-xs-12\" style=\"margin-top: 15px\">\n                <button type=\"submit\" class=\"btn btn-block btn-success\" (click)=\"guardarCambios()\">Guardar Cambios\n                </button>\n            </div>\n            <div class=\"col-xs-12\" style=\"margin-top: 15px; text-align: right\">\n                <a *ngIf=\"loginService.getDecodeToken().cambiarPassword\" (click)=\"loginService.logout()\">Volver al\n                    Login</a>\n            </div>\n        </form>\n    </div>\n</div>";

/***/ }),
/* 1013 */
/***/ (function(module, exports) {

	module.exports = ".contenido{\n    min-height: 100vh;\n}\n\n.fondoNegro{\n    background-color: #273135 !important;\n}"

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var sucursal_service_1 = __webpack_require__(429);
	var router_1 = __webpack_require__(329);
	var router_2 = __webpack_require__(329);
	__webpack_require__(653);
	var CalibracionComponent = (function () {
	    function CalibracionComponent(sucursalService, router, route) {
	        this.sucursalService = sucursalService;
	        this.router = router;
	        this.route = route;
	    }
	    CalibracionComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        window.scrollTo(0, 0);
	        this.loading = true;
	        this.route.params.subscribe(function (params) {
	            _this.id = params['id'];
	            //Enviar mail
	            _this.sucursalService.getPresupuestoCalibracion(_this.id).subscribe(function () {
	                _this.loading = false;
	                setTimeout(function () { return _this.router.navigate(['/home']); }, 10000);
	            });
	        });
	    };
	    CalibracionComponent.prototype.ngOnDestroy = function () {
	    };
	    CalibracionComponent = __decorate([
	        core_1.Component({
	            selector: 'calibracion',
	            template: __webpack_require__(1015),
	            styles: [__webpack_require__(1016)],
	            directives: [],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof sucursal_service_1.SucursalService !== 'undefined' && sucursal_service_1.SucursalService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof router_2.ActivatedRoute !== 'undefined' && router_2.ActivatedRoute) === 'function' && _c) || Object])
	    ], CalibracionComponent);
	    return CalibracionComponent;
	    var _a, _b, _c;
	}());
	exports.CalibracionComponent = CalibracionComponent;


/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 contenido\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 titulo\">\n        <div class=\"marcoTitulo\">\n            <h2>Solicitud presupuesto</h2>\n        </div>\n    </div>\n    <div *ngIf=\"loading\" class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 marcoDatos\" style=\"text-align: center\">\n        Enviando solicitud de presupuesto<img src=\"" + __webpack_require__(998) + "\" width=\"100px\">\n    </div>\n    <div *ngIf=\"!loading\" class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 marcoDatos\" style=\"text-align: center\">\n        Enviado! Le responderemos en breve.\n    </div>\n</div>\n";

/***/ }),
/* 1016 */
937,
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var platform_browser_1 = __webpack_require__(259);
	var documento_service_1 = __webpack_require__(588);
	var permiso_service_1 = __webpack_require__(427);
	var login_service_1 = __webpack_require__(381);
	var documento_1 = __webpack_require__(1018);
	var router_1 = __webpack_require__(329);
	var recargaCredito_component_1 = __webpack_require__(928);
	__webpack_require__(653);
	var myGlobals = __webpack_require__(414);
	var sucursal_service_1 = __webpack_require__(429);
	var moment = __webpack_require__(435);
	var DocumentoComponent = (function () {
	    function DocumentoComponent(documentoService, route, loginService, permisoService, sucursalService, sanitizer, router) {
	        this.documentoService = documentoService;
	        this.route = route;
	        this.loginService = loginService;
	        this.permisoService = permisoService;
	        this.sucursalService = sucursalService;
	        this.sanitizer = sanitizer;
	        this.router = router;
	    }
	    DocumentoComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        window.scrollTo(0, 0);
	        //Usuario logueado
	        this.usuario = this.loginService.getDecodeToken();
	        //Pedir permisos
	        this.offsetTimeZone = "-03:00";
	        this.urlLogo = "";
	        this.permisos = new Map();
	        this.permisoService.getPermiso("documento").subscribe(function (permisos) {
	            for (var _i = 0, _a = permisos.tipoPermiso; _i < _a.length; _i++) {
	                var permiso = _a[_i];
	                _this.permisos.set(permiso.descripcion, true);
	            }
	            //Si no tiene permiso para ver redirijo
	            if (!_this.permisos.get("read"))
	                _this.router.navigate(['/home']);
	        });
	        //Sucursales
	        this.sucursalService.getSucursales().subscribe(function (data) {
	            _this.sucursales = data;
	        });
	        //Inicializar tabla
	        var grid = $("#grid-data").on("initialized.rs.jquery.bootgrid", function () {
	        }.bind(this)).bootgrid({
	            ajax: true,
	            selection: true,
	            multiSelect: false,
	            rowSelect: true,
	            formatters: {
	                "estado": function (column, row) {
	                    return row.estado == true ? (row.usuariosNotificados.indexOf(_this.loginService.getDecodeToken().id) === -1 ? "<span class=\"label label-success\">Nuevo</span>" : "Activo") : "<span class=\"label label-danger\">Inactivo</span>";
	                },
	                "usuarioUltMdf_id": function (column, row) {
	                    return row.usuarioUltMdf_id ? row.usuarioUltMdf_id.nombre + " " + row.usuarioUltMdf_id.apellido : "";
	                },
	                "ext": function (column, row) {
	                    var re = /(?:\.([^.]+))?$/;
	                    var ext = re.exec(row.filename)[1];
	                    return row.filename && ext ? ext : "";
	                },
	                "sucursal_id": function (column, row) {
	                    return row.sucursal_id ? row.sucursal_id.descripcion : "";
	                },
	                "fechaUltMdf": function (column, row) {
	                    var date_str = row.fechaUltMdf;
	                    if (moment(date_str).isValid())
	                        return moment(date_str).utcOffset(this.offsetTimeZone).format("DD-MM-YYYY HH:mm");
	                    else
	                        return "";
	                }.bind(this),
	                "commands": function (column, row) {
	                    return "<button type=\"button\" class=\"btn btn-xs btn-default command-edit\" data-row-id=\"" + row._id + "\" " + ((!row.contentType || (!row.contentType.includes('image') && !row.contentType.includes('pdf'))) ? " disabled" : '') + "><span class=\"fa fa-eye\"></span></button> " +
	                        "<button type=\"button\" class=\"btn btn-xs btn-default command-delete\" data-row-id=\"" + row._id + "\"><span class=\"fa fa-cloud-download\"></span></button>";
	                }
	            },
	            requestHandler: (function (request) {
	                //Add your id property or anything else
	                request.sucursal_id = _this.sucursal_id;
	                return request;
	            }),
	            responseHandler: function (data) {
	                this.documentos = data.rows;
	                return data;
	            }.bind(this),
	            ajaxSettings: {
	                headers: {
	                    "Authorization": this.loginService.getToken()
	                },
	                method: "GET"
	            },
	            url: myGlobals.default.BASE_URL + "/documento/documentosTable",
	        }).bind(this).on("loaded.rs.jquery.bootgrid", function () {
	            /* Executes after data is loaded and rendered */
	            var documentComponent = this;
	            grid.find(".command-edit", documentComponent).on("click", function (e) {
	                this.previewImagen($(e.currentTarget).attr("data-row-id"));
	            }.bind(this)).end().find(".command-delete").on("click", function (e) {
	                this.downloadImagen($(e.currentTarget).attr("data-row-id"));
	            }.bind(this));
	        }.bind(this));
	        //Cerrar alert
	        $("#alertSeleccion").hide();
	        //Inicializar banderas para resetear forms
	        this.active = true;
	        this.active2 = true;
	        //Inicializar documento
	        this.documento = new documento_1.Documento();
	        //Inicializar bandera deshabilitar
	        this.deshabilitar = true;
	        this.usuario = this.loginService.getDecodeToken();
	    };
	    DocumentoComponent.prototype.ngOnDestroy = function () {
	    };
	    DocumentoComponent.prototype.agregar = function () {
	        //Inicializo variables
	        this.documento = new documento_1.Documento();
	        //Seteo bandera para deshabilitar
	        this.deshabilitar = false;
	        this.urlLogo = "";
	        this.filesToUpload = "";
	        //Muestro modal
	        $("#modalDocumento").modal("show");
	        //Cerrar alert
	        $("#alertSeleccion").hide();
	        setTimeout(function () { return $("#logo").click(); }, 300);
	    };
	    DocumentoComponent.prototype.modificar = function () {
	        var _this = this;
	        //Limpio foto
	        this.urlLogo = "";
	        this.filesToUpload = "";
	        //Obtener id seleccionado
	        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
	        //Si no hay nada seleccionado mostrar alert
	        if (this.idSeleccionado == undefined) {
	            $("#alertSeleccion").show();
	        }
	        else {
	            if (this.idSeleccionado != "0") {
	                //Cerrar alert
	                $("#alertSeleccion").hide();
	                //Busco documento
	                this.documentoService
	                    .getDocumento(this.idSeleccionado)
	                    .subscribe(function (documento) {
	                    //Cargo datos de la documento
	                    _this.documento = documento;
	                    //Cargo foto
	                    var byteArray = new Uint8Array(documento.logo.data.data);
	                    var file = new Blob([byteArray], { type: documento.logo.contentType });
	                    var reader = new FileReader();
	                    reader.onloadend = function () {
	                        this.urlLogo = reader.result;
	                    }.bind(_this);
	                    if (file) {
	                        reader.readAsDataURL(file);
	                    }
	                    else {
	                        _this.urlLogo = "";
	                    }
	                });
	                //Seteo bandera para deshabilitar
	                this.deshabilitar = false;
	                //Muestro modal
	                $("#modalDocumento").modal("show");
	            }
	        }
	    };
	    DocumentoComponent.prototype.eliminar = function () {
	        var _this = this;
	        //Obtener id seleccionado
	        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
	        //Si no hay nada seleccionado mostrar alert
	        if (this.idSeleccionado == undefined) {
	            $("#alertSeleccion").show();
	        }
	        else {
	            if (this.idSeleccionado != "0") {
	                //Cerrar alert
	                $("#alertSeleccion").hide();
	                //Busco documento
	                this.documentoService
	                    .getDocumento(this.idSeleccionado)
	                    .subscribe(function (documento) {
	                    _this.documentoService.delete(documento).subscribe(function () { return $("#grid-data").bootgrid("reload"); });
	                });
	            }
	        }
	    };
	    DocumentoComponent.prototype.ver = function () {
	        var _this = this;
	        //Limpio foto
	        this.urlLogo = "";
	        this.filesToUpload = "";
	        //Obtener id seleccionado
	        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
	        //Si no hay nada seleccionado mostrar alert
	        if (this.idSeleccionado == undefined) {
	            $("#alertSeleccion").show();
	        }
	        else {
	            if (this.idSeleccionado != "0") {
	                //Cerrar alert
	                $("#alertSeleccion").hide();
	                //Busco documento
	                this.documentoService
	                    .getDocumento(this.idSeleccionado)
	                    .subscribe(function (documento) {
	                    _this.documento = documento;
	                    if (documento.logo) {
	                        var byteArray = new Uint8Array(documento.logo.data.data);
	                        var file = new Blob([byteArray], { type: documento.logo.contentType });
	                        var reader = new FileReader();
	                        reader.onloadend = function () {
	                            if (file.type === "application/pdf" || file.type === "application/doc" || file.type === "application/docx")
	                                this.urlLogo = null;
	                            else
	                                this.urlLogo = reader.result;
	                        }.bind(_this);
	                        if (file) {
	                            reader.readAsDataURL(file);
	                        }
	                        else {
	                            _this.urlLogo = "";
	                        }
	                    }
	                    _this.documentoService.getDocumentos().subscribe();
	                    $("#grid-data").bootgrid("reload");
	                });
	                //Seteo bandera para deshabilitar
	                this.deshabilitar = true;
	                //Muestro modal
	                $("#modalDocumento").modal("show");
	            }
	        }
	    };
	    DocumentoComponent.prototype.save = function () {
	        var _this = this;
	        this.documentoService
	            .save(this.documento, this.filesToUpload)
	            .subscribe(function (documento) {
	            _this.documento = documento;
	            //Inicializo variables
	            _this.documento = new documento_1.Documento();
	            //this.documento.logo=this.filesToUpload;
	            //Ocultar modal
	            $("#modalDocumento").modal("hide");
	            //Reseteo formDocumento para eliminar errores
	            _this.active = false;
	            setTimeout(function () { return _this.active = true; }, 0);
	            //Recargo tabla
	            $("#grid-data").bootgrid("reload");
	            _this.documentoService.getDocumentos().subscribe();
	        });
	    };
	    DocumentoComponent.prototype.hideAlert = function () {
	        $("#alertSeleccion").hide();
	    };
	    DocumentoComponent.prototype.verFoto = function (input) {
	        if (input.files.length > 0) {
	            var file = input.files[0];
	            var reader = new FileReader();
	            reader.onloadend = function () {
	                if (file.type === "application/pdf" || file.type === "application/doc" || file.type === "application/docx")
	                    this.urlLogo = null;
	                else
	                    this.urlLogo = this.sanitizer.bypassSecurityTrustUrl(reader.result);
	            }.bind(this);
	            if (file) {
	                reader.readAsDataURL(file);
	            }
	            else {
	                this.urlLogo = "";
	            }
	            this.filesToUpload = file;
	        }
	    };
	    DocumentoComponent.prototype.getDocumentoById = function (id) {
	        var encontrado = null;
	        if (this.documentos)
	            this.documentos.forEach(function (documento) {
	                if (documento._id == id) {
	                    encontrado = documento;
	                    return;
	                }
	            }.bind(this));
	        return encontrado;
	    };
	    DocumentoComponent.prototype.previewImagen = function (_id) {
	        var _this = this;
	        this.documentoService.getDocumentoFile(_id).subscribe(function (file) {
	            var documento = _this.getDocumentoById(_id);
	            if (documento.contentType === "application/pdf") {
	                var byteCharacters = atob(encodeURI(file));
	                var byteNumbers = new Array(byteCharacters.length);
	                for (var i = 0; i < byteCharacters.length; i++) {
	                    byteNumbers[i] = byteCharacters.charCodeAt(i);
	                }
	                var byteArray = new Uint8Array(byteNumbers);
	                var file2 = new Blob([byteArray], { type: 'application/pdf;base64' });
	                var fileURL = URL.createObjectURL(file2);
	                window.open(fileURL);
	            }
	            else {
	                var linkSource = "data:" + documento.contentFile + ";base64," + file;
	                document.getElementById('imgPreviewFullscreen').classList.add("visible");
	                document.getElementById('divPreviewFullscreen').classList.add("visible");
	                document.getElementById('imgPreviewFullscreen').src = linkSource;
	                $("body").css("overflow", "hidden");
	            }
	            _this.documentoService.getDocumentos().subscribe();
	            $("#grid-data").bootgrid("reload");
	        });
	    };
	    DocumentoComponent.prototype.downloadImagen = function (_id) {
	        var _this = this;
	        this.documentoService.getDocumentoFile(_id).subscribe(function (file) {
	            var documento = _this.getDocumentoById(_id);
	            var linkSource = "data:" + documento.contentFile + ";base64," + file;
	            var downloadLink = document.createElement("a");
	            var fileName = documento.filename;
	            downloadLink.href = linkSource;
	            downloadLink.download = fileName;
	            downloadLink.click();
	            _this.documentoService.getDocumentos().subscribe();
	            $("#grid-data").bootgrid("reload");
	        });
	    };
	    DocumentoComponent.prototype.cerrarPreviewImagen = function () {
	        document.getElementById('imgPreviewFullscreen').classList.remove("visible");
	        document.getElementById('divPreviewFullscreen').classList.remove("visible");
	        // eslint-disable-next-line
	        // noinspection TypeScriptUnresolvedVariable
	        document.getElementById('imgPreviewFullscreen').src = "";
	        $("body").css("overflow", "auto");
	    };
	    DocumentoComponent.prototype.onChangeSucursal = function (e) {
	        this.sucursal_id = e.target.value;
	        $("#grid-data").bootgrid("reload");
	    };
	    DocumentoComponent.prototype.cerrarModal = function () {
	        var _this = this;
	        //Reseteo formDocumento para eliminar errores
	        this.active = false;
	        setTimeout(function () { return _this.active = true; }, 0);
	        //Reseteo formContacto para eliminar errores
	        setTimeout(function () { return _this.active2 = false; }, 0);
	        setTimeout(function () { return _this.active2 = true; }, 0);
	        this.documento = new documento_1.Documento();
	        $("#modalDocumento").modal("hide");
	    };
	    DocumentoComponent.prototype.synchronizeDrive = function () {
	        this.documentoService.synchronizeDrive().subscribe();
	    };
	    DocumentoComponent = __decorate([
	        core_1.Component({
	            selector: 'documento',
	            template: __webpack_require__(1019),
	            styles: [__webpack_require__(1021)],
	            directives: [recargaCredito_component_1.RecargaCreditoComponent],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof documento_service_1.DocumentoService !== 'undefined' && documento_service_1.DocumentoService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _b) || Object, (typeof (_c = typeof login_service_1.LoginService !== 'undefined' && login_service_1.LoginService) === 'function' && _c) || Object, (typeof (_d = typeof permiso_service_1.PermisoService !== 'undefined' && permiso_service_1.PermisoService) === 'function' && _d) || Object, (typeof (_e = typeof sucursal_service_1.SucursalService !== 'undefined' && sucursal_service_1.SucursalService) === 'function' && _e) || Object, (typeof (_f = typeof platform_browser_1.DomSanitizationService !== 'undefined' && platform_browser_1.DomSanitizationService) === 'function' && _f) || Object, (typeof (_g = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _g) || Object])
	    ], DocumentoComponent);
	    return DocumentoComponent;
	    var _a, _b, _c, _d, _e, _f, _g;
	}());
	exports.DocumentoComponent = DocumentoComponent;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(419)))

/***/ }),
/* 1018 */
/***/ (function(module, exports) {

	"use strict";
	var Documento = (function () {
	    function Documento() {
	    }
	    return Documento;
	}());
	exports.Documento = Documento;


/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 contenido\">\n    <div id=\"divPreviewFullscreen\" class=\"previewFullscreen\" aria-hidden=\"true\">\n                    <span class=\"glyphicon glyphicon-remove-circle\" aria-hidden=\"true\" (click)=\"cerrarPreviewImagen()\">\n                    </span>\n        <img id=\"imgPreviewFullscreen\" class=\"previewFullscreen\"/>\n    </div>\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 titulo\">\n        <div class=\"marcoTitulo\">\n            <h2>Documentos</h2>\n            <p>Home / Documentos</p>\n        </div>\n    </div>\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 marcoDatos\">\n        <div class=\"datos\">\n            <div class=\"alert alert-warning\" id=\"alertSeleccion\" name=\"alertSeleccion\">\n                <a class=\"close\" (click)=\"hideAlert()\">&times;</a> Debe selecccionar una casilla primero.\n            </div>\n            <div class=\"sucursal form-group\">\n                <label for=\"sucursal_id2\">Sucursal</label>\n                <select class=\"form-control\" id=\"sucursal_id2\" placeholder=\"Sucursal\" (change)=\"onChangeSucursal($event)\">\n                    <option value={{null}}>Todos</option>\n                    <option *ngFor=\"let sucursal of sucursales\" value={{sucursal._id}}>\n                        {{sucursal.descripcion}}\n                    </option>\n                </select>\n            </div>\n            <div class=\"table-responsive\">\n                <table id=\"grid-data\" class=\"table table-condensed table-hover \">\n                    <thead>\n                    <tr>\n                        <th data-column-id=\"_id\" data-identifier=\"true\" data-visible=\"false\"\n                            data-visible-in-selection=\"false\" data-order=\"desc\">_id\n                        </th>\n                        <th data-column-id=\"contentType\" data-formatter='sucursal_id'>Sucursal</th>\n                        <th data-column-id=\"contentType\" data-formatter='ext'>Tipo</th>\n                        <th data-column-id=\"descripcion\">Descripción</th>\n                        <th data-column-id=\"usuarioUltMdf\" data-formatter='usuarioUltMdf_id'>Usuario últ. modif.</th>\n                        <th data-column-id=\"fechaUltMdf\" data-order=\"desc\" data-formatter=\"fechaUltMdf\">Fecha últ. modif.</th>\n                        <th data-column-id=\"estado\" data-formatter=\"estado\">Estado</th>\n                        <th data-column-id=\"commands\" data-formatter=\"commands\" data-sortable=\"false\"></th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n    <button data-toggle=\"tooltip\" data-placement=\"top\" title=\"Eliminar\" animation=\"true\"\n            class=\"btn btn-default btn-sm botonFlotante btn-danger\" (click)=\"eliminar()\"\n            [disabled]=\"permisos.get('delete')!=true\">\n        <img src=\"" + __webpack_require__(933) + "\" width=\"20px\"/>\n    </button>\n    <button data-toggle=\"tooltip\" data-placement=\"top\" title=\"Modificar\" animation=\"true\"\n            class=\"btn btn-default btn-sm botonFlotante2 btn-warning\" (click)=\"modificar()\"\n            [disabled]=\"permisos.get('update')!=true\">\n        <img src=\"" + __webpack_require__(934) + "\" width=\"25px\"/>\n    </button>\n    <button data-toggle=\"tooltip\" data-placement=\"top\" title=\"Agregar\" animation=\"true\"\n            class=\"btn btn-default btn-sm botonFlotante3 btn-success\" [disabled]=\"permisos.get('create')!=true\"\n            (click)=\"agregar()\">\n        <img src=\"" + __webpack_require__(935) + "\" width=\"25px\"/>\n    </button>\n    <button data-toggle=\"tooltip\" data-placement=\"top\" title=\"Ver\" animation=\"true\"\n            class=\"btn btn-default btn-sm botonFlotante4 btn-primary\" (click)=\"ver()\"\n            [disabled]=\"permisos.get('read')!=true\">\n        <img src=\"" + __webpack_require__(936) + "\" width=\"30px\"/>\n    </button>\n    <button *ngIf=\"usuario.rol === 'Administrador' || usuario.rol === 'Tecnico'\" data-toggle=\"tooltip\"\n            data-placement=\"top\" title=\"Sincronizar con Google Drive\" animation=\"true\"\n            class=\"btn btn-default btn-sm botonFlotante5 btn-info\" (click)=\"synchronizeDrive()\"\n            [disabled]=\"permisos.get('update')!=true\">\n        <img src=\"" + __webpack_require__(1020) + "\" width=\"30px\"/>\n    </button>\n</div>\n<!-- Modal -->\n<div class=\"modal fade\" id=\"modalDocumento\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\">\n    <div class=\"modal-dialog\" role=\"document\">\n\n        <div class=\"modal-content\">\n            <form #documentoForm=\"ngForm\" *ngIf=\"active\" enctype=\"multipart/form-data\">\n                <div class=\"modal-body\">\n                    <div class=\"tab-content\">\n                        <div id=\"documento\" class=\"tab-pane fade in active\">\n                            <h4>Datos documento</h4>\n                            <div class=\"form-group\">\n                                <label for=\"logo\">Archivo</label>\n                                <div class=\"previewFotoPerfil\">\n                                    <img id=\"logoDocumento\" *ngIf=\"urlLogo\" [src]=\"urlLogo\" class=\"\"/>\n                                </div>\n                                <input type=\"file\" id=\"logo\" name=\"logo\" className=\"upload-file\"\n                                       (change)=\"verFoto($event.target)\" [disabled]=\"deshabilitar\"\n                                       accept=\"application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,text/plain, application/pdf, image/*\"\n                                       #logo=\"ngModel\" [(ngModel)]=\"documento.logo\"/>\n                                <div [hidden]=\"logo.valid || logo.pristine\" class=\"alert alert-danger\">\n                                    Archivo es requerido\n                                </div>\n                            </div>\n                            <div class=\"clearfix visible-md-block\"></div>\n                            <div class=\"clearfix visible-lg-block\"></div>\n                            <div class=\"clearfix visible-sm-block\"></div>\n                            <div class=\"clearfix visible-xs-block\"></div>\n                            <div class=\"form-group\">\n                                <label for=\"descripcion\">Descripción</label>\n                                <input type=\"text\" class=\"form-control\" required id=\"descripcion\" placeholder=\"Descripción\"\n                                       [(ngModel)]=\"documento.descripcion\" name=\"descripcion\" #descripcion=\"ngModel\"\n                                       autocomplete=\"off\" [disabled]=\"deshabilitar\">\n                                <div [hidden]=\"descripcion.valid || descripcion.pristine\" class=\"alert alert-danger\">\n                                    Descripción es requerido\n                                </div>\n                            </div>\n                            <div class=\"form-group\">\n                                <label for=\"sucursal_id\">Sucursal</label>\n                                <select class=\"form-control\" id=\"sucursal_id\" name=\"sucursal_id\"\n                                        placeholder=\"Sucursal\" [(ngModel)]=\"documento.sucursal_id\"\n                                        #sucursal_id=\"ngModel\">\n                                    <option></option>\n                                    <option *ngFor=\"let sucursal of sucursales\" value={{sucursal._id}}>\n                                        {{sucursal.descripcion}}\n                                    </option>\n                                </select>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"clearfix visible-md-block\"></div>\n                <div class=\"clearfix visible-lg-block\"></div>\n                <div class=\"clearfix visible-sm-block\"></div>\n                <div class=\"clearfix visible-xs-block\"></div>\n                <div class=\"modal-footer\">\n                    <button type=\"button\" class=\"btn btn-default\" (click)=\"cerrarModal()\">\n                        Cancelar\n                    </button>\n                    <button type=\"button\" (click)=\"save()\" class=\"btn btn-success\"\n                            [disabled]=\"deshabilitar ||  !documentoForm.form.valid\">Guardar\n                    </button>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/synchronize.201787cfd9b1a52275407afcdc8217eb.svg";

/***/ }),
/* 1021 */
/***/ (function(module, exports) {

	module.exports = ".td-btn {\n    padding-left: 0px;\n    padding-right: 0px;\n}\n\n.circular {\n    object-fit: cover;\n}\n\n/*.previewFotoPerfil {\n    width: auto;\n    height: auto;\n    max-width: 100px;\n    max-height: 100px;\n    float: right;\n    margin-bottom: 10px;\n}*/\n\n.previewFotoPerfil {\n    width: 100px;\n    height: 100px;\n    max-width: 100px;\n    max-height: 100px;\n    margin-bottom: 10px;\n    position: relative;\n    float: right;\n}\n\n.previewFotoPerfil img {\n    width: auto;\n    height: auto;\n    max-width: 100%;\n    max-height: 100%;\n    position: absolute;\n    margin: auto;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n}\n\n.previewFullscreen {\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    max-width: 100%;\n    max-height: 100%;\n    margin: auto;\n    overflow: auto;\n    z-index: 999999999;\n    border-radius: 0px;\n    display: none;\n}\n\ndiv.previewFullscreen {\n    background-color: rgba(68, 66, 66, 0.9);\n}\n\n.previewFullscreen.visible {\n    display: block !important;\n    overflow: hidden;\n}\n\n.previewFullscreen.visible span {\n    position: fixed;\n    top: 20px;\n    right: 20px;\n    color: white;\n    font-size: 30px;\n    z-index: 999999999999;\n}\n.sucursal.form-group{\n    width: 250px;\n}"

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var usuario_service_1 = __webpack_require__(430);
	var sucursal_service_1 = __webpack_require__(429);
	var nodo_service_1 = __webpack_require__(433);
	var medicion_service_1 = __webpack_require__(434);
	var ubicacion_1 = __webpack_require__(912);
	var rol_service_1 = __webpack_require__(432);
	var empresa_service_1 = __webpack_require__(425);
	var permiso_service_1 = __webpack_require__(427);
	var router_1 = __webpack_require__(329);
	var login_service_1 = __webpack_require__(381);
	var regAlarma_service_1 = __webpack_require__(572);
	__webpack_require__(653);
	var myGlobals = __webpack_require__(414);
	var moment = __webpack_require__(435);
	var RegAlarmasComponent = (function () {
	    function RegAlarmasComponent(usuarioService, sucursalService, empresaService, route, loginService, permisoService, rolService, regAlarmaService, nodoService, medicionService, router) {
	        this.usuarioService = usuarioService;
	        this.sucursalService = sucursalService;
	        this.empresaService = empresaService;
	        this.route = route;
	        this.loginService = loginService;
	        this.permisoService = permisoService;
	        this.rolService = rolService;
	        this.regAlarmaService = regAlarmaService;
	        this.nodoService = nodoService;
	        this.medicionService = medicionService;
	        this.router = router;
	        this.abierto = true;
	    }
	    RegAlarmasComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        window.scrollTo(0, 0);
	        this.usuarioConectado = this.loginService.getDecodeToken();
	        //Perdir permisos
	        this.abierto = true;
	        this.regAlarma = [];
	        this.regAlarmaNodos = [];
	        this.idSensores = [];
	        this.idNodos = [];
	        this.sucursalSeleccionada = null;
	        this.mostrarEliminados = false;
	        this.fechaDesde = new Date().toISOString().substring(0, 10);
	        this.fechaHasta = new Date().toISOString().substring(0, 10);
	        this.offsetTimeZone = "-03:00";
	        //Obtener empresas de ese usuario
	        this.empresaService.getEmpresas()
	            .subscribe(function (data) {
	            _this.empresas = data;
	            if (data.length > 0)
	                _this.cambiarSucursales(data[0]._id);
	        });
	        this.permisos = new Map();
	        this.permisoService.getPermiso("alarma").subscribe(function (permisos) {
	            for (var _i = 0, _a = permisos.tipoPermiso; _i < _a.length; _i++) {
	                var permiso = _a[_i];
	                _this.permisos.set(permiso.descripcion, true);
	            }
	            //Si no tiene permiso para ver redirijo
	            if (!_this.permisos.get("read"))
	                _this.router.navigate(['/home']);
	        });
	        //Inicializar tabla
	        $("#alertSeleccion").hide();
	        //Ocultar la barra cuando hace click afuera
	        if ($(window).width() < 769)
	            $(document).bind("mouseup touchend", function (e) {
	                var container = $("#barraSelectora");
	                if (!container.is(e.target) // if the target of the click isn't the container...
	                    && container.has(e.target).length === 0
	                    && e.target.id != "iconoBarraSelectora" && e.target.className != "botonConfig" && e.target.id != "desBarraSelectora"
	                    && e.target.id != "flechaBarraSelectora") {
	                    $('#barraSelectora').css("display", "none");
	                }
	            });
	        setTimeout(function () { return _this.loadTable(); }, 1000);
	        setTimeout(function () { return $("#grid-data").bootgrid("reload"); }, 1000);
	        $("#grid-data").bootgrid("reload");
	    };
	    RegAlarmasComponent.prototype.ngOnDestroy = function () {
	    };
	    RegAlarmasComponent.prototype.cambiarSucursales = function (id) {
	        var _this = this;
	        this.idSensores = [];
	        this.idNodos = [];
	        $("#grid-data").bootgrid("destroy");
	        this.sucursalService.getSucursalByEmpresa(id).subscribe(function (data) {
	            _this.sucursales = data;
	            if (data.length > 0) {
	                //Calcular fechaDesde para mostrar histórico
	                var fechaDesde = new Date();
	                fechaDesde.setDate(fechaDesde.getDate() - data[0].historico_dias);
	                _this.fechaDesde = fechaDesde.toISOString().substring(0, 10);
	                _this.cambiarSensores(data[0]._id);
	            }
	            else {
	                _this.sucursales = [];
	                _this.ubicaciones = [];
	            }
	        });
	    };
	    RegAlarmasComponent.prototype.loadTable = function () {
	        //Alarmas Por Sensor
	        $("#grid-data").bootgrid({
	            ajax: true,
	            selection: true,
	            multiSelect: false,
	            rowSelect: false,
	            templates: {
	                search: ""
	            },
	            formatters: {
	                "nodo": function (column, row) {
	                    return (row.nodo_id != undefined ? row.nodo_id.nombre : "") + (row.sensor_id != undefined ? ' - ' + row.sensor_id.etiqueta : "");
	                },
	                "color": function (column, row) {
	                    var info = '';
	                    var displayName = row.tipoEspecial == null ? "Alarma por rango" : (row.tipoEspecial == "SINACTIVIDAD" ? "Sin Actividad" : row.tipoEspecial == "SENSORNULL" ? "Sensor sin información" : (row.tipoEspecial == "CALIBRACION" ? "Próxima calibración" : "Bateria Baja"));
	                    info = info + '<b>' + displayName + '</b></br></br>';
	                    if (row.color == 'Amarillo')
	                        info += "<span class='label label-warning'>Amarillo</span></br>";
	                    else
	                        info += "<span class='label label-danger'>Rojo</span></br>";
	                    return info;
	                },
	                "fechaActivado": function (column, row) {
	                    var date_str = row.fechaActivado;
	                    if (moment(date_str).isValid())
	                        return moment(date_str).utcOffset(this.offsetTimeZone).format("DD-MM-YYYY HH:mm");
	                    else
	                        return "";
	                }.bind(this),
	                "fechaDesactivado": function (column, row) {
	                    if (row.fechaDesactivado != null) {
	                        var date_str = row.fechaDesactivado;
	                        if (moment(date_str).isValid())
	                            return moment(date_str).utcOffset(this.offsetTimeZone).format("DD-MM-YYYY HH:mm");
	                        else
	                            return "";
	                    }
	                    else {
	                        return "Aún activa";
	                    }
	                }.bind(this),
	                "usuarios": function (column, row) {
	                    var key = row.tipoEspecial == null ? "rango" : (row.tipoEspecial == "SINACTIVIDAD" ? "sinactividad" : row.tipoEspecial == "SENSORNULL" ? "sensornull" : (row.tipoEspecial == "CALIBRACION" ? "calibracion" : "bateria"));
	                    if (row.usuarios.length > 0) {
	                        return row.usuarios.map(function (usuario) { return '<b style="font-family: Raleway Bold !important">' + (usuario.nombre + ' ' + usuario.apellido) + '</b><br/>' + Object.entries(usuario[key]).map(function (_a) {
	                            var channel = _a[0], value = _a[1];
	                            return value === true ? channel.toUpperCase() : ' - ';
	                        }).join(''); }).join('<br/>');
	                    }
	                    else {
	                        return "Sin avisos";
	                    }
	                }.bind(this),
	                "notificaciones": function (column, row) {
	                    var _this = this;
	                    if (row.notificaciones.length > 0) {
	                        var usuarios_1 = {};
	                        row.notificaciones.forEach(function (notificacion) {
	                            var usuario = usuarios_1[notificacion.usuario_id._id];
	                            if (!usuario) {
	                                usuarios_1[notificacion.usuario_id._id] = {
	                                    usuario: notificacion.usuario_id.nombre + ' ' + notificacion.usuario_id.apellido,
	                                    avisos: []
	                                };
	                            }
	                            usuarios_1[notificacion.usuario_id._id].avisos.push({
	                                tipo: notificacion.tipo,
	                                fecha: moment(notificacion.fechaEnvio).utcOffset(_this.offsetTimeZone).format("DD-MM-YYYY HH:mm")
	                            });
	                        });
	                        return Object.values(usuarios_1).map(function (usuario) { return '<b style="font-family: Raleway Bold !important">' + usuario.usuario + '</b><br/>' + usuario.avisos.map(function (aviso) { return aviso.tipo + ' ' + aviso.fecha; }).join('<br/>'); }).join('<br/>');
	                    }
	                    else {
	                        return "Sin avisos";
	                    }
	                }.bind(this),
	            },
	            ajaxSettings: {
	                headers: {
	                    "Authorization": this.loginService.getToken()
	                },
	                method: "GET"
	            },
	            requestHandler: function (request) {
	                request.sensores = JSON.stringify({ sensores_id: this.idSensores });
	                request.idSucursal = this.sucursalSeleccionada._id;
	                if (this.fechaDesde != null) {
	                    request.fechaDesde = moment(this.fechaDesde).utcOffset(this.offsetTimeZone).startOf("day").format();
	                }
	                if (this.fechaHasta != null) {
	                    request.fechaHasta = moment(this.fechaHasta).utcOffset(this.offsetTimeZone).endOf("day").format();
	                }
	                return request;
	            }.bind(this),
	            url: myGlobals.default.BASE_URL + "/regAlarma/regAlarmasNotificacionTable/"
	        }).bind(this);
	        $("#grid-data").bootgrid("reload");
	    };
	    RegAlarmasComponent.prototype.buscarAlarmas = function (e, sensor) {
	        if (e.target.checked) {
	            var index = this.idSensores.indexOf(sensor._id);
	            if (index == -1) {
	                this.idSensores.push(sensor._id);
	            }
	            this.idNodos.push(sensor.nodo_id);
	            this.noData = false;
	            this.loadTable();
	            for (var _i = 0, _a = this.ubicaciones; _i < _a.length; _i++) {
	                var ubicacion = _a[_i];
	                for (var _b = 0, _c = ubicacion.sensores; _b < _c.length; _b++) {
	                    var sensor_1 = _c[_b];
	                    $("#" + sensor_1._id).attr('disabled', false);
	                }
	            }
	        }
	        else {
	            var index = this.idSensores.indexOf(sensor._id);
	            if (index != -1) {
	                this.idSensores.splice(index, 1);
	            }
	            var index = this.idNodos.indexOf(sensor.nodo_id);
	            if (index != -1) {
	                this.idNodos.splice(index, 1);
	            }
	            $("#grid-data").bootgrid("reload");
	        }
	    };
	    RegAlarmasComponent.prototype.cambiarFecha = function () {
	        this.loadTable();
	    };
	    RegAlarmasComponent.prototype.cambiarSensores = function (id) {
	        var _this = this;
	        this.idSensores = [];
	        this.idNodos = [];
	        $("#grid-data").bootgrid("destroy");
	        //Calcular fechaDesde
	        for (var _i = 0, _a = this.sucursales; _i < _a.length; _i++) {
	            var sucursal = _a[_i];
	            if (sucursal._id == id) {
	                this.sucursalSeleccionada = sucursal;
	                if (sucursal && sucursal.husoHorario_id && sucursal.husoHorario_id.offset)
	                    this.offsetTimeZone = sucursal.husoHorario_id.offset;
	                else
	                    this.offsetTimeZone = "-03:00";
	                break;
	            }
	        }
	        var fechaDesde = new Date();
	        fechaDesde.setDate(fechaDesde.getDate() - this.sucursalSeleccionada.historico_dias);
	        this.fechaDesde = fechaDesde.toISOString().substring(0, 10);
	        this.ubicaciones = [];
	        //Buscar sensores
	        this.nodoService.getNodosBySucursal(id)
	            .subscribe(function (data) {
	            var i = 0;
	            var ubicacionAnt = null;
	            var nodo = null;
	            _this.nodos = data;
	            var ubicacion = null;
	            _this.ubicaciones = [];
	            while (i < _this.nodos.length) {
	                nodo = _this.nodos[i];
	                ubicacionAnt = nodo.ubicacion_id._id;
	                ubicacion = new ubicacion_1.Ubicacion();
	                ubicacion = nodo.ubicacion_id;
	                ubicacion.sensores = [];
	                while (i < _this.nodos.length && ubicacionAnt == nodo.ubicacion_id._id) {
	                    ubicacion.sensores = ubicacion.sensores.concat(nodo.sensores_id);
	                    i++;
	                    nodo = _this.nodos[i];
	                }
	                _this.ubicaciones.push(ubicacion);
	            }
	        });
	        this.loadTable();
	    };
	    RegAlarmasComponent.prototype.ocultarBarraSelectora = function () {
	        if ($('#barraSelectora').css("display") == "block")
	            $('#barraSelectora').css("display", "none");
	        else
	            $('#barraSelectora').css("display", "block");
	    };
	    RegAlarmasComponent = __decorate([
	        core_1.Component({
	            selector: 'alarmasNotificacion',
	            template: __webpack_require__(1023),
	            styles: [__webpack_require__(1024)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof usuario_service_1.UsuariosService !== 'undefined' && usuario_service_1.UsuariosService) === 'function' && _a) || Object, (typeof (_b = typeof sucursal_service_1.SucursalService !== 'undefined' && sucursal_service_1.SucursalService) === 'function' && _b) || Object, (typeof (_c = typeof empresa_service_1.EmpresaService !== 'undefined' && empresa_service_1.EmpresaService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _d) || Object, (typeof (_e = typeof login_service_1.LoginService !== 'undefined' && login_service_1.LoginService) === 'function' && _e) || Object, (typeof (_f = typeof permiso_service_1.PermisoService !== 'undefined' && permiso_service_1.PermisoService) === 'function' && _f) || Object, (typeof (_g = typeof rol_service_1.RolService !== 'undefined' && rol_service_1.RolService) === 'function' && _g) || Object, (typeof (_h = typeof regAlarma_service_1.RegAlarmaService !== 'undefined' && regAlarma_service_1.RegAlarmaService) === 'function' && _h) || Object, (typeof (_j = typeof nodo_service_1.NodoService !== 'undefined' && nodo_service_1.NodoService) === 'function' && _j) || Object, (typeof (_k = typeof medicion_service_1.MedicionService !== 'undefined' && medicion_service_1.MedicionService) === 'function' && _k) || Object, (typeof (_l = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _l) || Object])
	    ], RegAlarmasComponent);
	    return RegAlarmasComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
	}());
	exports.RegAlarmasComponent = RegAlarmasComponent;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(419)))

/***/ }),
/* 1023 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 contenido\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 titulo\">\n        <div class=\"marcoTitulo\">\n            <h2>Notificaciones de alarmas</h2>\n            <p>Home / Notificaciones de alarmas</p>\n        </div>\n    </div>\n    <div class=\"botonConfig visible-xs col-xs-12\" (click)=\"ocultarBarraSelectora()\">\n        <div id=\"iconoBarraSelectora\" class=\"col-xs-2\">\n            <i class=\"fa fa-cogs fa-spin fa-2x fa-fw\" style=\"color:white\"></i>\n        </div>\n        <div id=\"desBarraSelectora\" class=\"col-xs-10\" style=\"text-align: left;padding-left: 35px;\">\n            Seleccione las variables ...\n            <b class=\"caret\" id=\"flechaBarraSelectora\"></b>\n        </div>\n    </div>\n    <div id=\"barraSelectora\" class=\"col-lg-3 col-md-3 col-sm-3 col-xs-12 barraArbolBase\" [ngClass]=\"{'barraArbolBaseOcultar':!abierto}\">\n        <div class=\"barraArbolCuerpo\" [ngClass]=\"{'barraArbolCuerpoOcultar':!abierto}\">\n            <div class=\"informacionArbol\" style=\"max-height: inherit; height: inherit;\">\n                <div class=\"form-group\">\n                    <label for=\"sucursal\">Empresa</label>\n                    <select class=\"form-control\" id=\"empresa\" placeholder=\"Empresa\" (change)=\"cambiarSucursales($event.target.value)\">\n                        <option *ngFor=\"let empresa of empresas\" value={{empresa._id}}>{{empresa.descripcion}}</option>\n                    </select>\n                </div>\n                <div class=\"form-group\">\n                    <label for=\"sucursal\">Sucursal</label>\n                    <select class=\"form-control\" id=\"sucursal\" placeholder=\"Sucursal\" (change)=\"cambiarSensores($event.target.value)\">\n                        <option *ngFor=\"let sucursal of sucursales\" value={{sucursal._id}}>{{sucursal.descripcion}}\n                        </option>\n                    </select>\n                </div>\n                <p>{{sucursalSeleccionada && sucursalSeleccionada.husoHorario_id ? sucursalSeleccionada.husoHorario_id.zonaHoraria + \" (\" + offsetTimeZone + \")\" : \"\"}}</p>\n                <div class=\"form-group\">\n                    <label for=\"sucursal\">Fecha Desde</label>\n                    <input type=\"date\" class=\"form-control\" id=\"fechaDesde\" [(ngModel)]=\"fechaDesde\" (change)=\"cambiarFecha()\" />\n                </div>\n                <div class=\"form-group\">\n                    <label for=\"sucursal\">Fecha Hasta</label>\n                    <input type=\"date\" class=\"form-control\" id=\"fechaHasta\" [(ngModel)]=\"fechaHasta\" (change)=\"cambiarFecha()\" />\n                </div>\n                <div class=\"checkbox checkbox-warning\">\n                    <input type=\"checkbox\" id=\"mostrarEliminados\" [(ngModel)]=\"mostrarEliminados\">\n                    <label> Mostrar Eliminados </label>\n                </div>\n                <div class=\"panel-group\" id=\"accordion\">\n                    <template ngFor let-ubicacion=\"$implicit\" [ngForOf]=\"ubicaciones\" let-index=\"index\">\n                        <div class=\"panel panel-default\">\n                            <div class=\"panel-heading\">\n                                <h4 class=\"panel-title\">\n                                    <a data-toggle=\"collapse\" data-parent=\"#accordion\" href=\"#collapseOne\">\n                                        {{ubicacion.descripcion}}\n                                    </a>\n                                </h4>\n                            </div>\n                            <div id=\"collapseOne\" class=\"panel-collapse collapse in\">\n                                <div class=\"panel-body\">\n                                    <template ngFor let-sensor [ngForOf]=\"ubicacion.sensores\" let-index=\"index2\">\n                                        <div [hidden]=\"!(mostrarEliminados || sensor.estado) || (sensor.posicionString == 9  && usuarioConectado.rol != 'Administrador' && usuarioConectado.rol != 'Tecnico')\">\n                                            <div class=\"checkbox checkbox-warning\">\n                                                <input type=\"checkbox\" value={{sensor._id}} id={{sensor._id}} (change)=\"buscarAlarmas($event,sensor)\">\n                                                <label> {{sensor.etiqueta}}\n                                                    <span style=\"padding-right: 10px; color: red; vertical-align: middle;\" *ngIf=\"!sensor.estado\" class=\"glyphicon glyphicon-remove\"></span>\n                                                </label>\n                                            </div>\n                                        </div>\n                                    </template>\n                                </div>\n                            </div>\n                        </div>\n                    </template>\n                </div>\n            </div>\n        </div>\n        <div class=\"barraArbolBoton hidden-xs\">\n            <button (click)=\"abierto=!abierto\"><i class=\"fa fa-cogs fa-spin fa-1x fa-fw\" style=\"color:white\"></i></button>\n        </div>\n    </div>\n    <div [ngClass]=\"{'medicionesComprimido':abierto,'medicionesExtendido':!abierto,'col-lg-9':abierto,'col-md-9':abierto,'col-sm-9':abierto,'col-xs-12':true,'col-lg-12':!abierto,'col-md-12':!abierto,'col-sm-12':!abierto}\" style=\"max-height: inherit; height: inherit; min-height: 100vh;\">\n        <div class=\"datos col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n\n                <div id=\"sensor\" class=\"tab-pane fade in active\">\n                    <div class=\"table-responsive\">\n                        <table id=\"grid-data\" class=\"table table-condensed table-hover \">\n                            <thead>\n                            <tr>\n                                <th data-column-id=\"nodo_id\" data-formatter=\"nodo\">Nodo/Canal</th>\n                                <th data-column-id=\"fechaActivado\" data-formatter=\"fechaActivado\" data-order=\"desc\"> Fecha Activación</th>\n                                <th data-column-id=\"fechaDesactivado\" data-formatter=\"fechaDesactivado\">Fecha Normalización</th>\n                                <th data-column-id=\"color\" data-formatter=\"color\">Alarma</th>\n                                <th data-column-id=\"usuarios\" data-formatter=\"usuarios\">Usuarios a avisar</th>\n                                <th data-column-id=\"notificaciones\" data-formatter=\"notificaciones\">Notificaciones</th>\n                            </tr>\n                            </thead>\n                            <tbody>\n                            </tbody>\n                        </table>\n                    </div>\n                </div>\n        </div>\n<!--        <div *ngIf=\"idNodos.length==0\" class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 noChartData\" style=\"text-align: center\">-->\n<!--            <span class=\"glyphicon glyphicon-check nota\" aria-hidden=\"true\" style=\"font-size: 70px; padding: 20px\"></span>-->\n<!--            <h2 class=\"nota\">Seleccione las variables que quiera observar</h2>-->\n<!--        </div>-->\n    </div>\n    <div class=\"clearfix visible-lg-block\"></div>\n    <div class=\"clearfix visible-md-block\"></div>\n    <div class=\"clearfix visible-sm-block\"></div>\n    <div class=\"clearfix visible-xs-block\"></div>\n</div>\n";

/***/ }),
/* 1024 */
/***/ (function(module, exports) {

	module.exports = "h3 {\n    font-family: \"Raleway\" !important;\n    border-bottom: 1px solid #ccc9c9;\n    padding-bottom: 15px;\n    padding-right: 10px;\n    padding-left: 10px;\n    margin-bottom: 20px;\n    font-size: 18px;\n    font-weight: 300;\n}\n\nb {\n    font-family: \"Raleway Bold\" !important;\n}\n\ntd {\n    vertical-align: baseline !important;\n}"

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var router_1 = __webpack_require__(329);
	var menu_service_1 = __webpack_require__(428);
	var AuthorizationGuard = (function () {
	    function AuthorizationGuard(menuService, router) {
	        this.menuService = menuService;
	        this.router = router;
	    }
	    AuthorizationGuard.prototype.canActivate = function (route, state) {
	        var url = state.url;
	        if (this.menuService.isUrlEnabled(url)) {
	            return true;
	        }
	        // Redirect to home if not authorized
	        this.router.navigate(['/home']);
	        return false;
	    };
	    AuthorizationGuard = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof menu_service_1.MenuService !== 'undefined' && menu_service_1.MenuService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object])
	    ], AuthorizationGuard);
	    return AuthorizationGuard;
	    var _a, _b;
	}());
	exports.AuthorizationGuard = AuthorizationGuard;


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var permiso_service_1 = __webpack_require__(427);
	var router_1 = __webpack_require__(329);
	var plan_service_1 = __webpack_require__(899);
	var plan_1 = __webpack_require__(1027);
	var menu_service_1 = __webpack_require__(428);
	var login_service_1 = __webpack_require__(381);
	__webpack_require__(653);
	var myGlobals = __webpack_require__(414);
	var PlanComponent = (function () {
	    function PlanComponent(planService, menuService, permisoService, loginService, router) {
	        this.planService = planService;
	        this.menuService = menuService;
	        this.permisoService = permisoService;
	        this.loginService = loginService;
	        this.router = router;
	    }
	    PlanComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        window.scrollTo(0, 0);
	        //Perdir permisos
	        this.permisos = new Map();
	        this.permisoService.getPermiso("plan").subscribe(function (permisos) {
	            for (var _i = 0, _a = permisos.tipoPermiso; _i < _a.length; _i++) {
	                var permiso = _a[_i];
	                _this.permisos.set(permiso.descripcion, true);
	            }
	            //Si no tiene permiso para ver redirijo
	            if (!_this.permisos.get("read"))
	                _this.router.navigate(['/home']);
	        });
	        //Inicializar tabla
	        $("#grid-data").bootgrid({
	            ajax: true,
	            url: myGlobals.default.BASE_URL + "/plan/planTable",
	            selection: true,
	            multiSelect: false,
	            rowSelect: true,
	            formatters: {
	                "estado": function (column, row) {
	                    return row.estado == true ? "Activo" : "<span class=\"label label-danger\">Inactivo</span>";
	                },
	                "mkt": function (column, row) {
	                    return row.mkt == true ? "Sí" : "No";
	                },
	                "alarmas_rango": function (column, row) {
	                    return row.alarmas_rango == true ? "Sí" : "No";
	                }
	            },
	            ajaxSettings: {
	                headers: {
	                    "Authorization": this.loginService.getToken()
	                },
	                method: "GET"
	            }
	        });
	        //Cerrar alert
	        $("#alertSeleccion").hide();
	        //Inicializar banderas para resetear forms
	        this.active = true;
	        //Inicializar
	        this.plan = new plan_1.Plan();
	        //Inicializar bandera deshabilitar
	        this.deshabilitar = false;
	        //Cargar menus
	        this.menuService.getMenus()
	            .subscribe(function (menus) {
	            _this.menus = menus;
	        });
	    };
	    PlanComponent.prototype.ngOnDestroy = function () {
	    };
	    PlanComponent.prototype.agregar = function () {
	        var _this = this;
	        //Inicializo variables
	        this.plan = new plan_1.Plan();
	        this.deshabilitar = false;
	        $("#modalPlan").modal("show");
	        //Reseteo form para eliminar errores
	        this.active = false;
	        setTimeout(function () { return _this.active = true; }, 0);
	    };
	    PlanComponent.prototype.modificar = function () {
	        var _this = this;
	        //Obtener id seleccionado
	        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
	        //Si no hay nada seleccionado mostrar alert
	        if (this.idSeleccionado == undefined) {
	            $("#alertSeleccion").show();
	        }
	        else {
	            if (this.idSeleccionado != "0") {
	                //Cerrar alert
	                $("#alertSeleccion").hide();
	                //Busco plan
	                this.planService
	                    .getPlan(this.idSeleccionado)
	                    .subscribe(function (plan) {
	                    _this.plan = plan;
	                });
	                this.deshabilitar = false;
	                $("#modalPlan").modal("show");
	            }
	        }
	    };
	    PlanComponent.prototype.eliminar = function () {
	        var _this = this;
	        //Obtener id seleccionado
	        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
	        //Si no hay nada seleccionado mostrar alert
	        if (this.idSeleccionado == undefined) {
	            $("#alertSeleccion").show();
	        }
	        else {
	            if (this.idSeleccionado != "0") {
	                //Cerrar alert
	                $("#alertSeleccion").hide();
	                //Busco plan
	                this.planService
	                    .getPlan(this.idSeleccionado)
	                    .subscribe(function (plan) {
	                    _this.planService.delete(plan).subscribe(function () { return $("#grid-data").bootgrid("reload"); });
	                });
	            }
	        }
	    };
	    PlanComponent.prototype.ver = function () {
	        var _this = this;
	        //Obtener id seleccionado
	        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
	        //Si no hay nada seleccionado mostrar alert
	        if (this.idSeleccionado == undefined) {
	            $("#alertSeleccion").show();
	        }
	        else {
	            if (this.idSeleccionado != "0") {
	                //Cerrar alert
	                $("#alertSeleccion").hide();
	                //Busco plan
	                this.planService
	                    .getPlan(this.idSeleccionado)
	                    .subscribe(function (plan) {
	                    _this.plan = plan;
	                });
	                //Seteo bandera para deshabilitar
	                this.deshabilitar = true;
	                $("#modalPlan").modal("show");
	            }
	        }
	    };
	    PlanComponent.prototype.save = function () {
	        var _this = this;
	        this.planService
	            .save(this.plan)
	            .subscribe(function (plan) {
	            _this.plan = plan;
	            //Inicializo variables
	            _this.plan = new plan_1.Plan();
	            console.log(_this.plan);
	            //Ocultar modal
	            $("#modalPlan").modal("hide");
	            //Reseteo formplan para eliminar errores
	            _this.active = false;
	            setTimeout(function () { return _this.active = true; }, 0);
	            //Recargo tabla
	            $("#grid-data").bootgrid("reload");
	        });
	    };
	    PlanComponent.prototype.hideAlert = function () {
	        $("#alertSeleccion").hide();
	    };
	    PlanComponent.prototype.isMenuSelected = function (menuId) {
	        return this.plan.menus && this.plan.menus.includes(menuId);
	    };
	    PlanComponent.prototype.toggleMenu = function (menuId, event) {
	        if (!this.plan.menus) {
	            this.plan.menus = [];
	        }
	        if (event.target.checked) {
	            if (!this.plan.menus.includes(menuId)) {
	                this.plan.menus.push(menuId);
	            }
	        }
	        else {
	            var index = this.plan.menus.indexOf(menuId);
	            if (index > -1) {
	                this.plan.menus.splice(index, 1);
	            }
	        }
	    };
	    PlanComponent = __decorate([
	        core_1.Component({
	            selector: 'plan',
	            template: __webpack_require__(1028),
	            styles: [__webpack_require__(1029)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof plan_service_1.PlanService !== 'undefined' && plan_service_1.PlanService) === 'function' && _a) || Object, (typeof (_b = typeof menu_service_1.MenuService !== 'undefined' && menu_service_1.MenuService) === 'function' && _b) || Object, (typeof (_c = typeof permiso_service_1.PermisoService !== 'undefined' && permiso_service_1.PermisoService) === 'function' && _c) || Object, (typeof (_d = typeof login_service_1.LoginService !== 'undefined' && login_service_1.LoginService) === 'function' && _d) || Object, (typeof (_e = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _e) || Object])
	    ], PlanComponent);
	    return PlanComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.PlanComponent = PlanComponent;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(419)))

/***/ }),
/* 1027 */
/***/ (function(module, exports) {

	"use strict";
	var Plan = (function () {
	    function Plan() {
	    }
	    return Plan;
	}());
	exports.Plan = Plan;


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 contenido\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 titulo\">\n        <div class=\"marcoTitulo\">\n            <h2>Planes</h2>\n            <p>Home / Carga Datos / Planes</p>\n        </div>\n    </div>\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 marcoDatos\">\n        <div class=\"datos\">\n            <div\n                class=\"alert alert-warning\"\n                id=\"alertSeleccion\"\n                name=\"alertSeleccion\"\n            >\n                <a class=\"close\" (click)=\"hideAlert()\">&times;</a> Debe\n                selecccionar una casilla primero.\n            </div>\n            <div class=\"table-responsive\">\n                <table id=\"grid-data\" class=\"table table-condensed table-hover\">\n                    <thead>\n                        <tr>\n                            <th\n                                data-column-id=\"_id\"\n                                data-identifier=\"true\"\n                                data-visible=\"false\"\n                                data-visible-in-selection=\"false\"\n                                data-order=\"desc\"\n                            >\n                                _id\n                            </th>\n                            <th data-column-id=\"descripcion\">Descripción</th>\n                            <th data-column-id=\"historico_dias\">\n                                Días Histórico\n                            </th>\n                            <th data-column-id=\"max_nodos\">Max Nodos</th>\n                            <th data-column-id=\"orden\">Orden</th>\n                            <th data-column-id=\"mkt\" data-formatter=\"mkt\">\n                                Mkt\n                            </th>\n                            <th data-column-id=\"estado\" data-formatter=\"estado\">\n                                Estado\n                            </th>\n                        </tr>\n                    </thead>\n                    <tbody></tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n    <button\n        data-toggle=\"tooltip\"\n        data-placement=\"top\"\n        title=\"Eliminar\"\n        animation=\"true\"\n        class=\"btn btn-default btn-sm botonFlotante btn-danger\"\n        (click)=\"eliminar()\"\n        [disabled]=\"permisos.get('delete') != true\"\n    >\n        <img src=\"" + __webpack_require__(933) + "\" width=\"20px\" />\n    </button>\n    <button\n        data-toggle=\"tooltip\"\n        data-placement=\"top\"\n        title=\"Modificar\"\n        animation=\"true\"\n        class=\"btn btn-default btn-sm botonFlotante2 btn-warning\"\n        (click)=\"modificar()\"\n        [disabled]=\"permisos.get('update') != true\"\n    >\n        <img src=\"" + __webpack_require__(934) + "\" width=\"25px\" />\n    </button>\n    <button\n        data-toggle=\"tooltip\"\n        data-placement=\"top\"\n        title=\"Agregar\"\n        animation=\"true\"\n        class=\"btn btn-default btn-sm botonFlotante3 btn-success\"\n        (click)=\"agregar()\"\n        [disabled]=\"permisos.get('create') != true\"\n    >\n        <img src=\"" + __webpack_require__(935) + "\" width=\"25px\" />\n    </button>\n    <button\n        data-toggle=\"tooltip\"\n        data-placement=\"top\"\n        title=\"Ver\"\n        animation=\"true\"\n        class=\"btn btn-default btn-sm botonFlotante4 btn-primary\"\n        (click)=\"ver()\"\n        [disabled]=\"permisos.get('read') != true\"\n    >\n        <img src=\"" + __webpack_require__(936) + "\" width=\"30px\" />\n    </button>\n</div>\n<!-- Modal -->\n<div\n    class=\"modal fade\"\n    id=\"modalPlan\"\n    tabindex=\"-1\"\n    role=\"dialog\"\n    aria-labelledby=\"myModalLabel\"\n>\n    <div class=\"modal-dialog modal-lg\" role=\"document\">\n        <div class=\"modal-content\">\n            <form #planForm=\"ngForm\" *ngIf=\"active\">\n                <div class=\"modal-header\">\n                    <button\n                        type=\"button\"\n                        class=\"close\"\n                        data-dismiss=\"modal\"\n                        aria-label=\"Close\"\n                    >\n                        <span aria-hidden=\"true\">&times;</span>\n                    </button>\n                    <h4 class=\"modal-title\" id=\"myModalLabel\">Plan</h4>\n                </div>\n                <div class=\"modal-body\">\n                    <div class=\"row\">\n                        <div class=\"col-md-6\">\n                            <div class=\"form-group\">\n                                <label for=\"descripcion\"\n                                    >Descripción Del Plan</label\n                                >\n                                <input\n                                    type=\"text\"\n                                    class=\"form-control\"\n                                    id=\"descripcion\"\n                                    placeholder=\"Descripción\"\n                                    required\n                                    [(ngModel)]=\"plan.descripcion\"\n                                    name=\"descripcion\"\n                                    #descripcion=\"ngModel\"\n                                    autocomplete=\"off\"\n                                    [disabled]=\"deshabilitar\"\n                                />\n                                <div\n                                    [hidden]=\"\n                                        descripcion.valid ||\n                                        descripcion.pristine\n                                    \"\n                                    class=\"alert alert-danger\"\n                                >\n                                    Descripción es requerido\n                                </div>\n                            </div>\n                            <div class=\"form-group\">\n                                <label for=\"historico_dias\"\n                                    >Días de Histórico</label\n                                >\n                                <input\n                                    type=\"number\"\n                                    required\n                                    class=\"form-control\"\n                                    id=\"historico_dias\"\n                                    name=\"historico_dias\"\n                                    placeholder=\"Cantidad de días\"\n                                    [(ngModel)]=\"plan.historico_dias\"\n                                    #historico_dias=\"ngModel\"\n                                    autocomplete=\"off\"\n                                    [disabled]=\"deshabilitar\"\n                                />\n                                <div\n                                    [hidden]=\"\n                                        historico_dias.valid ||\n                                        historico_dias.pristine\n                                    \"\n                                    class=\"alert alert-danger\"\n                                >\n                                    Días de histórico es requerido\n                                </div>\n                            </div>\n                            <div class=\"form-group\">\n                                <label for=\"max_nodos\">Máximo de Nodos</label>\n                                <input\n                                    type=\"number\"\n                                    required\n                                    class=\"form-control\"\n                                    id=\"max_nodos\"\n                                    name=\"max_nodos\"\n                                    placeholder=\"Cantidad máxima de nodos\"\n                                    [(ngModel)]=\"plan.max_nodos\"\n                                    #max_nodos=\"ngModel\"\n                                    autocomplete=\"off\"\n                                    [disabled]=\"deshabilitar\"\n                                />\n                                <div\n                                    [hidden]=\"\n                                        max_nodos.valid || max_nodos.pristine\n                                    \"\n                                    class=\"alert alert-danger\"\n                                >\n                                    Máximo de nodos es requerido\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"col-md-6\">\n                            <div class=\"form-group\">\n                                <label>Características del Plan</label>\n                                <div>\n                                    <label>\n                                        <input type=\"checkbox\" id=\"mkt\" [(ngModel)]=\"plan.mkt\" name=\"mkt\" #mkt=\"ngModel\" autocomplete=\"off\" [disabled]=\"deshabilitar\" value=\"true\"/>\n                                        Cálculo de mkt\n                                    </label>\n                                </div>\n                                <div>\n                                    <label>\n                                        <input\n                                            type=\"checkbox\"\n                                            [(ngModel)]=\"plan.alarmas_rango\"\n                                            name=\"alarmas_rango\"\n                                            [disabled]=\"deshabilitar\"\n                                        />\n                                        Alarmas de Rango\n                                    </label>\n                                </div>\n                                <div>\n                                    <label>\n                                        <input\n                                            type=\"checkbox\"\n                                            [(ngModel)]=\"\n                                                plan.alarmas_calibracion\n                                            \"\n                                            name=\"alarmas_calibracion\"\n                                            [disabled]=\"deshabilitar\"\n                                        />\n                                        Alarmas de Calibración\n                                    </label>\n                                </div>\n                                <div>\n                                    <label>\n                                        <input\n                                            type=\"checkbox\"\n                                            [(ngModel)]=\"\n                                                plan.alarmas_sin_actividad\n                                            \"\n                                            name=\"alarmas_sin_actividad\"\n                                            [disabled]=\"deshabilitar\"\n                                        />\n                                        Alarmas Sin Actividad\n                                    </label>\n                                </div>\n                                <div>\n                                    <label>\n                                        <input\n                                            type=\"checkbox\"\n                                            [(ngModel)]=\"\n                                                plan.alarmas_sin_informacion\n                                            \"\n                                            name=\"alarmas_sin_informacion\"\n                                            [disabled]=\"deshabilitar\"\n                                        />\n                                        Alarmas Sin Información\n                                    </label>\n                                </div>\n                                <div>\n                                    <label>\n                                        <input\n                                            type=\"checkbox\"\n                                            [(ngModel)]=\"plan.alarmas_bateria\"\n                                            name=\"alarmas_bateria\"\n                                            [disabled]=\"deshabilitar\"\n                                        />\n                                        Alarmas de Batería\n                                    </label>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-md-12\">\n                            <div class=\"form-group\">\n                                <label>Menús incluidos en el plan</label>\n                                <div class=\"panel panel-default\" style=\"max-height: 200px; overflow-y: auto;\">\n                                    <div class=\"panel-body\">\n                                        <div *ngFor=\"let menu of menus\">\n                                            <label>\n                                                <input\n                                                    type=\"checkbox\"\n                                                    [checked]=\"isMenuSelected(menu._id)\"\n                                                    (change)=\"toggleMenu(menu._id, $event)\"\n                                                    [disabled]=\"deshabilitar\"\n                                                />\n                                                {{menu.descripcion}}\n                                            </label>\n                                        </div>\n                                        <div *ngIf=\"!menus || menus.length === 0\" class=\"text-muted\">\n                                            No hay menús disponibles\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"clearfix visible-md-block\"></div>\n                <div class=\"clearfix visible-lg-block\"></div>\n                <div class=\"clearfix visible-sm-block\"></div>\n                <div class=\"clearfix visible-xs-block\"></div>\n                <div class=\"modal-footer\">\n                    <button\n                        type=\"button\"\n                        class=\"btn btn-default\"\n                        data-dismiss=\"modal\"\n                    >\n                        Cancelar\n                    </button>\n                    <button\n                        type=\"button\"\n                        (click)=\"save()\"\n                        class=\"btn btn-success\"\n                        [disabled]=\"\n                            deshabilitar ||\n                            (planForm != undefined && !planForm.form.valid)\n                        \"\n                    >\n                        Guardar\n                    </button>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 1029 */
944,
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(1031));
	//# sourceMappingURL=index.js.map

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	/**
	 * @module
	 * @description
	 * This module is used for handling user input, by defining and building a {@link FormGroup} that
	 * consists of
	 * {@link FormControl} objects, and mapping them onto the DOM. {@link FormControl} objects can then
	 * be used
	 * to read information
	 * from the form DOM elements.
	 *
	 * Forms providers are not included in default providers; you must import these providers
	 * explicitly.
	 */
	var directives_1 = __webpack_require__(1032);
	exports.FORM_DIRECTIVES = directives_1.FORM_DIRECTIVES;
	exports.REACTIVE_FORM_DIRECTIVES = directives_1.REACTIVE_FORM_DIRECTIVES;
	var abstract_control_directive_1 = __webpack_require__(1043);
	exports.AbstractControlDirective = abstract_control_directive_1.AbstractControlDirective;
	var checkbox_value_accessor_1 = __webpack_require__(1033);
	exports.CheckboxControlValueAccessor = checkbox_value_accessor_1.CheckboxControlValueAccessor;
	var control_container_1 = __webpack_require__(1055);
	exports.ControlContainer = control_container_1.ControlContainer;
	var control_value_accessor_1 = __webpack_require__(1034);
	exports.NG_VALUE_ACCESSOR = control_value_accessor_1.NG_VALUE_ACCESSOR;
	var default_value_accessor_1 = __webpack_require__(1035);
	exports.DefaultValueAccessor = default_value_accessor_1.DefaultValueAccessor;
	var ng_control_1 = __webpack_require__(1038);
	exports.NgControl = ng_control_1.NgControl;
	var ng_control_status_1 = __webpack_require__(1037);
	exports.NgControlStatus = ng_control_status_1.NgControlStatus;
	var ng_form_1 = __webpack_require__(1044);
	exports.NgForm = ng_form_1.NgForm;
	var ng_model_1 = __webpack_require__(1056);
	exports.NgModel = ng_model_1.NgModel;
	var ng_model_group_1 = __webpack_require__(1057);
	exports.NgModelGroup = ng_model_group_1.NgModelGroup;
	var form_array_name_1 = __webpack_require__(1059);
	exports.FormArrayName = form_array_name_1.FormArrayName;
	var form_control_directive_1 = __webpack_require__(1060);
	exports.FormControlDirective = form_control_directive_1.FormControlDirective;
	var form_control_name_1 = __webpack_require__(1061);
	exports.FormControlName = form_control_name_1.FormControlName;
	var form_group_directive_1 = __webpack_require__(1062);
	exports.FormGroupDirective = form_group_directive_1.FormGroupDirective;
	var form_group_name_1 = __webpack_require__(1063);
	exports.FormGroupName = form_group_name_1.FormGroupName;
	var select_control_value_accessor_1 = __webpack_require__(1053);
	exports.NgSelectOption = select_control_value_accessor_1.NgSelectOption;
	exports.SelectControlValueAccessor = select_control_value_accessor_1.SelectControlValueAccessor;
	var validators_1 = __webpack_require__(1064);
	exports.MaxLengthValidator = validators_1.MaxLengthValidator;
	exports.MinLengthValidator = validators_1.MinLengthValidator;
	exports.PatternValidator = validators_1.PatternValidator;
	exports.RequiredValidator = validators_1.RequiredValidator;
	var form_builder_1 = __webpack_require__(1065);
	exports.FormBuilder = form_builder_1.FormBuilder;
	var model_1 = __webpack_require__(1047);
	exports.AbstractControl = model_1.AbstractControl;
	exports.FormArray = model_1.FormArray;
	exports.FormControl = model_1.FormControl;
	exports.FormGroup = model_1.FormGroup;
	var validators_2 = __webpack_require__(1049);
	exports.NG_ASYNC_VALIDATORS = validators_2.NG_ASYNC_VALIDATORS;
	exports.NG_VALIDATORS = validators_2.NG_VALIDATORS;
	exports.Validators = validators_2.Validators;
	__export(__webpack_require__(1066));
	//# sourceMappingURL=forms.js.map

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var checkbox_value_accessor_1 = __webpack_require__(1033);
	var default_value_accessor_1 = __webpack_require__(1035);
	var ng_control_status_1 = __webpack_require__(1037);
	var ng_form_1 = __webpack_require__(1044);
	var ng_model_1 = __webpack_require__(1056);
	var ng_model_group_1 = __webpack_require__(1057);
	var number_value_accessor_1 = __webpack_require__(1051);
	var radio_control_value_accessor_1 = __webpack_require__(1052);
	var form_array_name_1 = __webpack_require__(1059);
	var form_control_directive_1 = __webpack_require__(1060);
	var form_control_name_1 = __webpack_require__(1061);
	var form_group_directive_1 = __webpack_require__(1062);
	var form_group_name_1 = __webpack_require__(1063);
	var select_control_value_accessor_1 = __webpack_require__(1053);
	var select_multiple_control_value_accessor_1 = __webpack_require__(1054);
	var validators_1 = __webpack_require__(1064);
	var checkbox_value_accessor_2 = __webpack_require__(1033);
	exports.CheckboxControlValueAccessor = checkbox_value_accessor_2.CheckboxControlValueAccessor;
	var default_value_accessor_2 = __webpack_require__(1035);
	exports.DefaultValueAccessor = default_value_accessor_2.DefaultValueAccessor;
	var ng_control_1 = __webpack_require__(1038);
	exports.NgControl = ng_control_1.NgControl;
	var ng_control_status_2 = __webpack_require__(1037);
	exports.NgControlStatus = ng_control_status_2.NgControlStatus;
	var ng_form_2 = __webpack_require__(1044);
	exports.NgForm = ng_form_2.NgForm;
	var ng_model_2 = __webpack_require__(1056);
	exports.NgModel = ng_model_2.NgModel;
	var ng_model_group_2 = __webpack_require__(1057);
	exports.NgModelGroup = ng_model_group_2.NgModelGroup;
	var number_value_accessor_2 = __webpack_require__(1051);
	exports.NumberValueAccessor = number_value_accessor_2.NumberValueAccessor;
	var radio_control_value_accessor_2 = __webpack_require__(1052);
	exports.RadioControlValueAccessor = radio_control_value_accessor_2.RadioControlValueAccessor;
	var form_array_name_2 = __webpack_require__(1059);
	exports.FormArrayName = form_array_name_2.FormArrayName;
	var form_control_directive_2 = __webpack_require__(1060);
	exports.FormControlDirective = form_control_directive_2.FormControlDirective;
	var form_control_name_2 = __webpack_require__(1061);
	exports.FormControlName = form_control_name_2.FormControlName;
	var form_group_directive_2 = __webpack_require__(1062);
	exports.FormGroupDirective = form_group_directive_2.FormGroupDirective;
	var form_group_name_2 = __webpack_require__(1063);
	exports.FormGroupName = form_group_name_2.FormGroupName;
	var select_control_value_accessor_2 = __webpack_require__(1053);
	exports.NgSelectOption = select_control_value_accessor_2.NgSelectOption;
	exports.SelectControlValueAccessor = select_control_value_accessor_2.SelectControlValueAccessor;
	var select_multiple_control_value_accessor_2 = __webpack_require__(1054);
	exports.NgSelectMultipleOption = select_multiple_control_value_accessor_2.NgSelectMultipleOption;
	exports.SelectMultipleControlValueAccessor = select_multiple_control_value_accessor_2.SelectMultipleControlValueAccessor;
	var validators_2 = __webpack_require__(1064);
	exports.MaxLengthValidator = validators_2.MaxLengthValidator;
	exports.MinLengthValidator = validators_2.MinLengthValidator;
	exports.PatternValidator = validators_2.PatternValidator;
	exports.RequiredValidator = validators_2.RequiredValidator;
	/**
	 *
	 * A list of all the form directives used as part of a `@Component` annotation.
	 *
	 *  This is a shorthand for importing them each individually.
	 *
	 * ### Example
	 *
	 * ```typescript
	 * @Component({
	 *   selector: 'my-app',
	 *   directives: [FORM_DIRECTIVES]
	 * })
	 * class MyApp {}
	 * ```
	 * @experimental
	 */
	exports.FORM_DIRECTIVES = [
	    ng_model_1.NgModel, ng_model_group_1.NgModelGroup, ng_form_1.NgForm,
	    select_control_value_accessor_1.NgSelectOption, select_multiple_control_value_accessor_1.NgSelectMultipleOption, default_value_accessor_1.DefaultValueAccessor, number_value_accessor_1.NumberValueAccessor,
	    checkbox_value_accessor_1.CheckboxControlValueAccessor, select_control_value_accessor_1.SelectControlValueAccessor, select_multiple_control_value_accessor_1.SelectMultipleControlValueAccessor,
	    radio_control_value_accessor_1.RadioControlValueAccessor, ng_control_status_1.NgControlStatus,
	    validators_1.RequiredValidator, validators_1.MinLengthValidator, validators_1.MaxLengthValidator, validators_1.PatternValidator
	];
	/**
	 * @experimental
	 */
	exports.REACTIVE_FORM_DIRECTIVES = 
	/*@ts2dart_const*/ [
	    form_control_directive_1.FormControlDirective, form_group_directive_1.FormGroupDirective, form_control_name_1.FormControlName, form_group_name_1.FormGroupName, form_array_name_1.FormArrayName
	];
	//# sourceMappingURL=directives.js.map

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var core_1 = __webpack_require__(5);
	var control_value_accessor_1 = __webpack_require__(1034);
	exports.CHECKBOX_VALUE_ACCESSOR = {
	    provide: control_value_accessor_1.NG_VALUE_ACCESSOR,
	    useExisting: core_1.forwardRef(function () { return CheckboxControlValueAccessor; }),
	    multi: true
	};
	var CheckboxControlValueAccessor = (function () {
	    function CheckboxControlValueAccessor(_renderer, _elementRef) {
	        this._renderer = _renderer;
	        this._elementRef = _elementRef;
	        this.onChange = function (_) { };
	        this.onTouched = function () { };
	    }
	    CheckboxControlValueAccessor.prototype.writeValue = function (value) {
	        this._renderer.setElementProperty(this._elementRef.nativeElement, 'checked', value);
	    };
	    CheckboxControlValueAccessor.prototype.registerOnChange = function (fn) { this.onChange = fn; };
	    CheckboxControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
	    /** @nocollapse */
	    CheckboxControlValueAccessor.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: 'input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]',
	                    host: { '(change)': 'onChange($event.target.checked)', '(blur)': 'onTouched()' },
	                    providers: [exports.CHECKBOX_VALUE_ACCESSOR]
	                },] },
	    ];
	    /** @nocollapse */
	    CheckboxControlValueAccessor.ctorParameters = [
	        { type: core_1.Renderer, },
	        { type: core_1.ElementRef, },
	    ];
	    return CheckboxControlValueAccessor;
	}());
	exports.CheckboxControlValueAccessor = CheckboxControlValueAccessor;
	//# sourceMappingURL=checkbox_value_accessor.js.map

/***/ }),
/* 1034 */
146,
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var core_1 = __webpack_require__(5);
	var lang_1 = __webpack_require__(1036);
	var control_value_accessor_1 = __webpack_require__(1034);
	exports.DEFAULT_VALUE_ACCESSOR = 
	/* @ts2dart_Provider */ {
	    provide: control_value_accessor_1.NG_VALUE_ACCESSOR,
	    useExisting: core_1.forwardRef(function () { return DefaultValueAccessor; }),
	    multi: true
	};
	var DefaultValueAccessor = (function () {
	    function DefaultValueAccessor(_renderer, _elementRef) {
	        this._renderer = _renderer;
	        this._elementRef = _elementRef;
	        this.onChange = function (_) { };
	        this.onTouched = function () { };
	    }
	    DefaultValueAccessor.prototype.writeValue = function (value) {
	        var normalizedValue = lang_1.isBlank(value) ? '' : value;
	        this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', normalizedValue);
	    };
	    DefaultValueAccessor.prototype.registerOnChange = function (fn) { this.onChange = fn; };
	    DefaultValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
	    /** @nocollapse */
	    DefaultValueAccessor.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: 'input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]',
	                    // TODO: vsavkin replace the above selector with the one below it once
	                    // https://github.com/angular/angular/issues/3011 is implemented
	                    // selector: '[ngControl],[ngModel],[ngFormControl]',
	                    host: { '(input)': 'onChange($event.target.value)', '(blur)': 'onTouched()' },
	                    providers: [exports.DEFAULT_VALUE_ACCESSOR]
	                },] },
	    ];
	    /** @nocollapse */
	    DefaultValueAccessor.ctorParameters = [
	        { type: core_1.Renderer, },
	        { type: core_1.ElementRef, },
	    ];
	    return DefaultValueAccessor;
	}());
	exports.DefaultValueAccessor = DefaultValueAccessor;
	//# sourceMappingURL=default_value_accessor.js.map

/***/ }),
/* 1036 */
9,
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var core_1 = __webpack_require__(5);
	var lang_1 = __webpack_require__(1036);
	var ng_control_1 = __webpack_require__(1038);
	var NgControlStatus = (function () {
	    function NgControlStatus(cd) {
	        this._cd = cd;
	    }
	    Object.defineProperty(NgControlStatus.prototype, "ngClassUntouched", {
	        get: function () {
	            return lang_1.isPresent(this._cd.control) ? this._cd.control.untouched : false;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgControlStatus.prototype, "ngClassTouched", {
	        get: function () {
	            return lang_1.isPresent(this._cd.control) ? this._cd.control.touched : false;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgControlStatus.prototype, "ngClassPristine", {
	        get: function () {
	            return lang_1.isPresent(this._cd.control) ? this._cd.control.pristine : false;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgControlStatus.prototype, "ngClassDirty", {
	        get: function () {
	            return lang_1.isPresent(this._cd.control) ? this._cd.control.dirty : false;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgControlStatus.prototype, "ngClassValid", {
	        get: function () {
	            return lang_1.isPresent(this._cd.control) ? this._cd.control.valid : false;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgControlStatus.prototype, "ngClassInvalid", {
	        get: function () {
	            return lang_1.isPresent(this._cd.control) ? !this._cd.control.valid : false;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** @nocollapse */
	    NgControlStatus.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: '[formControlName],[ngModel],[formControl]',
	                    host: {
	                        '[class.ng-untouched]': 'ngClassUntouched',
	                        '[class.ng-touched]': 'ngClassTouched',
	                        '[class.ng-pristine]': 'ngClassPristine',
	                        '[class.ng-dirty]': 'ngClassDirty',
	                        '[class.ng-valid]': 'ngClassValid',
	                        '[class.ng-invalid]': 'ngClassInvalid'
	                    }
	                },] },
	    ];
	    /** @nocollapse */
	    NgControlStatus.ctorParameters = [
	        { type: ng_control_1.NgControl, decorators: [{ type: core_1.Self },] },
	    ];
	    return NgControlStatus;
	}());
	exports.NgControlStatus = NgControlStatus;
	//# sourceMappingURL=ng_control_status.js.map

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var exceptions_1 = __webpack_require__(1039);
	var abstract_control_directive_1 = __webpack_require__(1043);
	/**
	 * A base class that all control directive extend.
	 * It binds a {@link Control} object to a DOM element.
	 *
	 * Used internally by Angular forms.
	 *
	 * @experimental
	 */
	var NgControl = (function (_super) {
	    __extends(NgControl, _super);
	    function NgControl() {
	        _super.apply(this, arguments);
	        this.name = null;
	        this.valueAccessor = null;
	    }
	    Object.defineProperty(NgControl.prototype, "validator", {
	        get: function () { return exceptions_1.unimplemented(); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgControl.prototype, "asyncValidator", {
	        get: function () { return exceptions_1.unimplemented(); },
	        enumerable: true,
	        configurable: true
	    });
	    return NgControl;
	}(abstract_control_directive_1.AbstractControlDirective));
	exports.NgControl = NgControl;
	//# sourceMappingURL=ng_control.js.map

/***/ }),
/* 1039 */
[1358, 1040, 1041, 1041],
/* 1040 */
21,
/* 1041 */
[1359, 1040, 1042, 1036],
/* 1042 */
[1360, 1036],
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var exceptions_1 = __webpack_require__(1039);
	var lang_1 = __webpack_require__(1036);
	/**
	 * Base class for control directives.
	 *
	 * Only used internally in the forms module.
	 *
	 * @experimental
	 */
	var AbstractControlDirective = (function () {
	    function AbstractControlDirective() {
	    }
	    Object.defineProperty(AbstractControlDirective.prototype, "control", {
	        get: function () { return exceptions_1.unimplemented(); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControlDirective.prototype, "value", {
	        get: function () { return lang_1.isPresent(this.control) ? this.control.value : null; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControlDirective.prototype, "valid", {
	        get: function () { return lang_1.isPresent(this.control) ? this.control.valid : null; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControlDirective.prototype, "errors", {
	        get: function () {
	            return lang_1.isPresent(this.control) ? this.control.errors : null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControlDirective.prototype, "pristine", {
	        get: function () { return lang_1.isPresent(this.control) ? this.control.pristine : null; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControlDirective.prototype, "dirty", {
	        get: function () { return lang_1.isPresent(this.control) ? this.control.dirty : null; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControlDirective.prototype, "touched", {
	        get: function () { return lang_1.isPresent(this.control) ? this.control.touched : null; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControlDirective.prototype, "untouched", {
	        get: function () { return lang_1.isPresent(this.control) ? this.control.untouched : null; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControlDirective.prototype, "statusChanges", {
	        get: function () {
	            return lang_1.isPresent(this.control) ? this.control.statusChanges : null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControlDirective.prototype, "valueChanges", {
	        get: function () {
	            return lang_1.isPresent(this.control) ? this.control.valueChanges : null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControlDirective.prototype, "path", {
	        get: function () { return null; },
	        enumerable: true,
	        configurable: true
	    });
	    return AbstractControlDirective;
	}());
	exports.AbstractControlDirective = AbstractControlDirective;
	//# sourceMappingURL=abstract_control_directive.js.map

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var core_1 = __webpack_require__(5);
	var async_1 = __webpack_require__(1045);
	var collection_1 = __webpack_require__(1042);
	var lang_1 = __webpack_require__(1036);
	var model_1 = __webpack_require__(1047);
	var validators_1 = __webpack_require__(1049);
	var control_container_1 = __webpack_require__(1055);
	var shared_1 = __webpack_require__(1048);
	exports.formDirectiveProvider = 
	/*@ts2dart_const*/ { provide: control_container_1.ControlContainer, useExisting: core_1.forwardRef(function () { return NgForm; }) };
	var NgForm = (function (_super) {
	    __extends(NgForm, _super);
	    function NgForm(validators, asyncValidators) {
	        _super.call(this);
	        this._submitted = false;
	        this.ngSubmit = new async_1.EventEmitter();
	        this.form = new model_1.FormGroup({}, null, shared_1.composeValidators(validators), shared_1.composeAsyncValidators(asyncValidators));
	    }
	    Object.defineProperty(NgForm.prototype, "submitted", {
	        get: function () { return this._submitted; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgForm.prototype, "formDirective", {
	        get: function () { return this; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgForm.prototype, "control", {
	        get: function () { return this.form; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgForm.prototype, "path", {
	        get: function () { return []; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgForm.prototype, "controls", {
	        get: function () { return this.form.controls; },
	        enumerable: true,
	        configurable: true
	    });
	    NgForm.prototype.addControl = function (dir) {
	        var _this = this;
	        async_1.PromiseWrapper.scheduleMicrotask(function () {
	            var container = _this._findContainer(dir.path);
	            dir._control = container.registerControl(dir.name, dir.control);
	            shared_1.setUpControl(dir.control, dir);
	            dir.control.updateValueAndValidity({ emitEvent: false });
	        });
	    };
	    NgForm.prototype.getControl = function (dir) { return this.form.find(dir.path); };
	    NgForm.prototype.removeControl = function (dir) {
	        var _this = this;
	        async_1.PromiseWrapper.scheduleMicrotask(function () {
	            var container = _this._findContainer(dir.path);
	            if (lang_1.isPresent(container)) {
	                container.removeControl(dir.name);
	            }
	        });
	    };
	    NgForm.prototype.addFormGroup = function (dir) {
	        var _this = this;
	        async_1.PromiseWrapper.scheduleMicrotask(function () {
	            var container = _this._findContainer(dir.path);
	            var group = new model_1.FormGroup({});
	            shared_1.setUpFormContainer(group, dir);
	            container.registerControl(dir.name, group);
	            group.updateValueAndValidity({ emitEvent: false });
	        });
	    };
	    NgForm.prototype.removeFormGroup = function (dir) {
	        var _this = this;
	        async_1.PromiseWrapper.scheduleMicrotask(function () {
	            var container = _this._findContainer(dir.path);
	            if (lang_1.isPresent(container)) {
	                container.removeControl(dir.name);
	            }
	        });
	    };
	    NgForm.prototype.getFormGroup = function (dir) { return this.form.find(dir.path); };
	    NgForm.prototype.updateModel = function (dir, value) {
	        var _this = this;
	        async_1.PromiseWrapper.scheduleMicrotask(function () {
	            var ctrl = _this.form.find(dir.path);
	            ctrl.updateValue(value);
	        });
	    };
	    NgForm.prototype.onSubmit = function () {
	        this._submitted = true;
	        async_1.ObservableWrapper.callEmit(this.ngSubmit, null);
	        return false;
	    };
	    /** @internal */
	    NgForm.prototype._findContainer = function (path) {
	        path.pop();
	        return collection_1.ListWrapper.isEmpty(path) ? this.form : this.form.find(path);
	    };
	    /** @nocollapse */
	    NgForm.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: 'form:not([ngNoForm]):not([formGroup]),ngForm,[ngForm]',
	                    providers: [exports.formDirectiveProvider],
	                    host: {
	                        '(submit)': 'onSubmit()',
	                    },
	                    outputs: ['ngSubmit'],
	                    exportAs: 'ngForm'
	                },] },
	    ];
	    /** @nocollapse */
	    NgForm.ctorParameters = [
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [validators_1.NG_VALIDATORS,] },] },
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [validators_1.NG_ASYNC_VALIDATORS,] },] },
	    ];
	    return NgForm;
	}(control_container_1.ControlContainer));
	exports.NgForm = NgForm;
	//# sourceMappingURL=ng_form.js.map

/***/ }),
/* 1045 */
[1361, 1036, 1046],
/* 1046 */
58,
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var shared_1 = __webpack_require__(1048);
	var async_1 = __webpack_require__(1045);
	var collection_1 = __webpack_require__(1042);
	var lang_1 = __webpack_require__(1036);
	/**
	 * Indicates that a FormControl is valid, i.e. that no errors exist in the input value.
	 */
	exports.VALID = 'VALID';
	/**
	 * Indicates that a FormControl is invalid, i.e. that an error exists in the input value.
	 */
	exports.INVALID = 'INVALID';
	/**
	 * Indicates that a FormControl is pending, i.e. that async validation is occurring and
	 * errors are not yet available for the input value.
	 */
	exports.PENDING = 'PENDING';
	function isControl(control) {
	    return control instanceof AbstractControl;
	}
	exports.isControl = isControl;
	function _find(control, path) {
	    if (lang_1.isBlank(path))
	        return null;
	    if (!(path instanceof Array)) {
	        path = path.split('/');
	    }
	    if (path instanceof Array && collection_1.ListWrapper.isEmpty(path))
	        return null;
	    return path.reduce(function (v, name) {
	        if (v instanceof FormGroup) {
	            return lang_1.isPresent(v.controls[name]) ? v.controls[name] : null;
	        }
	        else if (v instanceof FormArray) {
	            var index = name;
	            return lang_1.isPresent(v.at(index)) ? v.at(index) : null;
	        }
	        else {
	            return null;
	        }
	    }, control);
	}
	function toObservable(r) {
	    return lang_1.isPromise(r) ? async_1.ObservableWrapper.fromPromise(r) : r;
	}
	function coerceToValidator(validator) {
	    return Array.isArray(validator) ? shared_1.composeValidators(validator) : validator;
	}
	function coerceToAsyncValidator(asyncValidator) {
	    return Array.isArray(asyncValidator) ? shared_1.composeAsyncValidators(asyncValidator) : asyncValidator;
	}
	/**
	 * @experimental
	 */
	var AbstractControl = (function () {
	    function AbstractControl(validator, asyncValidator) {
	        this.validator = validator;
	        this.asyncValidator = asyncValidator;
	        this._pristine = true;
	        this._touched = false;
	    }
	    Object.defineProperty(AbstractControl.prototype, "value", {
	        get: function () { return this._value; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControl.prototype, "status", {
	        get: function () { return this._status; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControl.prototype, "valid", {
	        get: function () { return this._status === exports.VALID; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControl.prototype, "errors", {
	        /**
	         * Returns the errors of this control.
	         */
	        get: function () { return this._errors; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControl.prototype, "pristine", {
	        get: function () { return this._pristine; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControl.prototype, "dirty", {
	        get: function () { return !this.pristine; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControl.prototype, "touched", {
	        get: function () { return this._touched; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControl.prototype, "untouched", {
	        get: function () { return !this._touched; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControl.prototype, "valueChanges", {
	        get: function () { return this._valueChanges; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControl.prototype, "statusChanges", {
	        get: function () { return this._statusChanges; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControl.prototype, "pending", {
	        get: function () { return this._status == exports.PENDING; },
	        enumerable: true,
	        configurable: true
	    });
	    AbstractControl.prototype.setAsyncValidators = function (newValidator) {
	        this.asyncValidator = coerceToAsyncValidator(newValidator);
	    };
	    AbstractControl.prototype.clearAsyncValidators = function () { this.asyncValidator = null; };
	    AbstractControl.prototype.setValidators = function (newValidator) {
	        this.validator = coerceToValidator(newValidator);
	    };
	    AbstractControl.prototype.clearValidators = function () { this.validator = null; };
	    AbstractControl.prototype.markAsTouched = function () { this._touched = true; };
	    AbstractControl.prototype.markAsDirty = function (_a) {
	        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
	        onlySelf = lang_1.normalizeBool(onlySelf);
	        this._pristine = false;
	        if (lang_1.isPresent(this._parent) && !onlySelf) {
	            this._parent.markAsDirty({ onlySelf: onlySelf });
	        }
	    };
	    AbstractControl.prototype.markAsPending = function (_a) {
	        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
	        onlySelf = lang_1.normalizeBool(onlySelf);
	        this._status = exports.PENDING;
	        if (lang_1.isPresent(this._parent) && !onlySelf) {
	            this._parent.markAsPending({ onlySelf: onlySelf });
	        }
	    };
	    AbstractControl.prototype.setParent = function (parent) { this._parent = parent; };
	    AbstractControl.prototype.updateValueAndValidity = function (_a) {
	        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
	        onlySelf = lang_1.normalizeBool(onlySelf);
	        emitEvent = lang_1.isPresent(emitEvent) ? emitEvent : true;
	        this._updateValue();
	        this._errors = this._runValidator();
	        this._status = this._calculateStatus();
	        if (this._status == exports.VALID || this._status == exports.PENDING) {
	            this._runAsyncValidator(emitEvent);
	        }
	        if (emitEvent) {
	            async_1.ObservableWrapper.callEmit(this._valueChanges, this._value);
	            async_1.ObservableWrapper.callEmit(this._statusChanges, this._status);
	        }
	        if (lang_1.isPresent(this._parent) && !onlySelf) {
	            this._parent.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
	        }
	    };
	    AbstractControl.prototype._runValidator = function () {
	        return lang_1.isPresent(this.validator) ? this.validator(this) : null;
	    };
	    AbstractControl.prototype._runAsyncValidator = function (emitEvent) {
	        var _this = this;
	        if (lang_1.isPresent(this.asyncValidator)) {
	            this._status = exports.PENDING;
	            this._cancelExistingSubscription();
	            var obs = toObservable(this.asyncValidator(this));
	            this._asyncValidationSubscription = async_1.ObservableWrapper.subscribe(obs, function (res) { return _this.setErrors(res, { emitEvent: emitEvent }); });
	        }
	    };
	    AbstractControl.prototype._cancelExistingSubscription = function () {
	        if (lang_1.isPresent(this._asyncValidationSubscription)) {
	            async_1.ObservableWrapper.dispose(this._asyncValidationSubscription);
	        }
	    };
	    /**
	     * Sets errors on a form control.
	     *
	     * This is used when validations are run not automatically, but manually by the user.
	     *
	     * Calling `setErrors` will also update the validity of the parent control.
	     *
	     * ## Usage
	     *
	     * ```
	     * var login = new FormControl("someLogin");
	     * login.setErrors({
	     *   "notUnique": true
	     * });
	     *
	     * expect(login.valid).toEqual(false);
	     * expect(login.errors).toEqual({"notUnique": true});
	     *
	     * login.updateValue("someOtherLogin");
	     *
	     * expect(login.valid).toEqual(true);
	     * ```
	     */
	    AbstractControl.prototype.setErrors = function (errors, _a) {
	        var emitEvent = (_a === void 0 ? {} : _a).emitEvent;
	        emitEvent = lang_1.isPresent(emitEvent) ? emitEvent : true;
	        this._errors = errors;
	        this._updateControlsErrors(emitEvent);
	    };
	    AbstractControl.prototype.find = function (path) { return _find(this, path); };
	    AbstractControl.prototype.getError = function (errorCode, path) {
	        if (path === void 0) { path = null; }
	        var control = lang_1.isPresent(path) && !collection_1.ListWrapper.isEmpty(path) ? this.find(path) : this;
	        if (lang_1.isPresent(control) && lang_1.isPresent(control._errors)) {
	            return collection_1.StringMapWrapper.get(control._errors, errorCode);
	        }
	        else {
	            return null;
	        }
	    };
	    AbstractControl.prototype.hasError = function (errorCode, path) {
	        if (path === void 0) { path = null; }
	        return lang_1.isPresent(this.getError(errorCode, path));
	    };
	    Object.defineProperty(AbstractControl.prototype, "root", {
	        get: function () {
	            var x = this;
	            while (lang_1.isPresent(x._parent)) {
	                x = x._parent;
	            }
	            return x;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** @internal */
	    AbstractControl.prototype._updateControlsErrors = function (emitEvent) {
	        this._status = this._calculateStatus();
	        if (emitEvent) {
	            async_1.ObservableWrapper.callEmit(this._statusChanges, this._status);
	        }
	        if (lang_1.isPresent(this._parent)) {
	            this._parent._updateControlsErrors(emitEvent);
	        }
	    };
	    /** @internal */
	    AbstractControl.prototype._initObservables = function () {
	        this._valueChanges = new async_1.EventEmitter();
	        this._statusChanges = new async_1.EventEmitter();
	    };
	    AbstractControl.prototype._calculateStatus = function () {
	        if (lang_1.isPresent(this._errors))
	            return exports.INVALID;
	        if (this._anyControlsHaveStatus(exports.PENDING))
	            return exports.PENDING;
	        if (this._anyControlsHaveStatus(exports.INVALID))
	            return exports.INVALID;
	        return exports.VALID;
	    };
	    return AbstractControl;
	}());
	exports.AbstractControl = AbstractControl;
	/**
	 * Defines a part of a form that cannot be divided into other controls. `FormControl`s have values
	 * and
	 * validation state, which is determined by an optional validation function.
	 *
	 * `FormControl` is one of the three fundamental building blocks used to define forms in Angular,
	 * along
	 * with {@link FormGroup} and {@link FormArray}.
	 *
	 * ## Usage
	 *
	 * By default, a `FormControl` is created for every `<input>` or other form component.
	 * With {@link FormControlDirective} or {@link FormGroupDirective} an existing {@link FormControl}
	 * can be bound to a DOM element instead. This `FormControl` can be configured with a custom
	 * validation function.
	 *
	 * @experimental
	 */
	var FormControl = (function (_super) {
	    __extends(FormControl, _super);
	    function FormControl(value, validator, asyncValidator) {
	        if (value === void 0) { value = null; }
	        if (validator === void 0) { validator = null; }
	        if (asyncValidator === void 0) { asyncValidator = null; }
	        _super.call(this, coerceToValidator(validator), coerceToAsyncValidator(asyncValidator));
	        /** @internal */
	        this._onChange = [];
	        this._value = value;
	        this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
	        this._initObservables();
	    }
	    /**
	     * Set the value of the form control to `value`.
	     *
	     * If `onlySelf` is `true`, this change will only affect the validation of this `FormControl`
	     * and not its parent component. If `emitEvent` is `true`, this change will cause a
	     * `valueChanges` event on the `FormControl` to be emitted. Both of these options default to
	     * `false`.
	     *
	     * If `emitModelToViewChange` is `true`, the view will be notified about the new value
	     * via an `onChange` event. This is the default behavior if `emitModelToViewChange` is not
	     * specified.
	     */
	    FormControl.prototype.updateValue = function (value, _a) {
	        var _this = this;
	        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent, emitModelToViewChange = _b.emitModelToViewChange;
	        emitModelToViewChange = lang_1.isPresent(emitModelToViewChange) ? emitModelToViewChange : true;
	        this._value = value;
	        if (this._onChange.length && emitModelToViewChange) {
	            this._onChange.forEach(function (changeFn) { return changeFn(_this._value); });
	        }
	        this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
	    };
	    /**
	     * @internal
	     */
	    FormControl.prototype._updateValue = function () { };
	    /**
	     * @internal
	     */
	    FormControl.prototype._anyControlsHaveStatus = function (status) { return false; };
	    /**
	     * Register a listener for change events.
	     */
	    FormControl.prototype.registerOnChange = function (fn) { this._onChange.push(fn); };
	    return FormControl;
	}(AbstractControl));
	exports.FormControl = FormControl;
	/**
	 * Defines a part of a form, of fixed length, that can contain other controls.
	 *
	 * A `FormGroup` aggregates the values of each {@link FormControl} in the group.
	 * The status of a `FormGroup` depends on the status of its children.
	 * If one of the controls in a group is invalid, the entire group is invalid.
	 * Similarly, if a control changes its value, the entire group changes as well.
	 *
	 * `FormGroup` is one of the three fundamental building blocks used to define forms in Angular,
	 * along with {@link FormControl} and {@link FormArray}. {@link FormArray} can also contain other
	 * controls, but is of variable length.
	 *
	 * ### Example ([live demo](http://plnkr.co/edit/23DESOpbNnBpBHZt1BR4?p=preview))
	 *
	 * @experimental
	 */
	var FormGroup = (function (_super) {
	    __extends(FormGroup, _super);
	    function FormGroup(controls, optionals, validator, asyncValidator) {
	        if (optionals === void 0) { optionals = null; }
	        if (validator === void 0) { validator = null; }
	        if (asyncValidator === void 0) { asyncValidator = null; }
	        _super.call(this, validator, asyncValidator);
	        this.controls = controls;
	        this._optionals = lang_1.isPresent(optionals) ? optionals : {};
	        this._initObservables();
	        this._setParentForControls();
	        this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
	    }
	    /**
	     * Register a control with the group's list of controls.
	     */
	    FormGroup.prototype.registerControl = function (name, control) {
	        if (this.controls[name])
	            return this.controls[name];
	        this.controls[name] = control;
	        control.setParent(this);
	        return control;
	    };
	    /**
	     * Add a control to this group.
	     */
	    FormGroup.prototype.addControl = function (name, control) {
	        this.registerControl(name, control);
	        this.updateValueAndValidity();
	    };
	    /**
	     * Remove a control from this group.
	     */
	    FormGroup.prototype.removeControl = function (name) {
	        collection_1.StringMapWrapper.delete(this.controls, name);
	        this.updateValueAndValidity();
	    };
	    /**
	     * Mark the named control as non-optional.
	     */
	    FormGroup.prototype.include = function (controlName) {
	        collection_1.StringMapWrapper.set(this._optionals, controlName, true);
	        this.updateValueAndValidity();
	    };
	    /**
	     * Mark the named control as optional.
	     */
	    FormGroup.prototype.exclude = function (controlName) {
	        collection_1.StringMapWrapper.set(this._optionals, controlName, false);
	        this.updateValueAndValidity();
	    };
	    /**
	     * Check whether there is a control with the given name in the group.
	     */
	    FormGroup.prototype.contains = function (controlName) {
	        var c = collection_1.StringMapWrapper.contains(this.controls, controlName);
	        return c && this._included(controlName);
	    };
	    /** @internal */
	    FormGroup.prototype._setParentForControls = function () {
	        var _this = this;
	        collection_1.StringMapWrapper.forEach(this.controls, function (control, name) { control.setParent(_this); });
	    };
	    /** @internal */
	    FormGroup.prototype._updateValue = function () { this._value = this._reduceValue(); };
	    /** @internal */
	    FormGroup.prototype._anyControlsHaveStatus = function (status) {
	        var _this = this;
	        var res = false;
	        collection_1.StringMapWrapper.forEach(this.controls, function (control, name) {
	            res = res || (_this.contains(name) && control.status == status);
	        });
	        return res;
	    };
	    /** @internal */
	    FormGroup.prototype._reduceValue = function () {
	        return this._reduceChildren({}, function (acc, control, name) {
	            acc[name] = control.value;
	            return acc;
	        });
	    };
	    /** @internal */
	    FormGroup.prototype._reduceChildren = function (initValue, fn) {
	        var _this = this;
	        var res = initValue;
	        collection_1.StringMapWrapper.forEach(this.controls, function (control, name) {
	            if (_this._included(name)) {
	                res = fn(res, control, name);
	            }
	        });
	        return res;
	    };
	    /** @internal */
	    FormGroup.prototype._included = function (controlName) {
	        var isOptional = collection_1.StringMapWrapper.contains(this._optionals, controlName);
	        return !isOptional || collection_1.StringMapWrapper.get(this._optionals, controlName);
	    };
	    return FormGroup;
	}(AbstractControl));
	exports.FormGroup = FormGroup;
	/**
	 * Defines a part of a form, of variable length, that can contain other controls.
	 *
	 * A `FormArray` aggregates the values of each {@link FormControl} in the group.
	 * The status of a `FormArray` depends on the status of its children.
	 * If one of the controls in a group is invalid, the entire array is invalid.
	 * Similarly, if a control changes its value, the entire array changes as well.
	 *
	 * `FormArray` is one of the three fundamental building blocks used to define forms in Angular,
	 * along with {@link FormControl} and {@link FormGroup}. {@link FormGroup} can also contain
	 * other controls, but is of fixed length.
	 *
	 * ## Adding or removing controls
	 *
	 * To change the controls in the array, use the `push`, `insert`, or `removeAt` methods
	 * in `FormArray` itself. These methods ensure the controls are properly tracked in the
	 * form's hierarchy. Do not modify the array of `AbstractControl`s used to instantiate
	 * the `FormArray` directly, as that will result in strange and unexpected behavior such
	 * as broken change detection.
	 *
	 * ### Example ([live demo](http://plnkr.co/edit/23DESOpbNnBpBHZt1BR4?p=preview))
	 *
	 * @experimental
	 */
	var FormArray = (function (_super) {
	    __extends(FormArray, _super);
	    function FormArray(controls, validator, asyncValidator) {
	        if (validator === void 0) { validator = null; }
	        if (asyncValidator === void 0) { asyncValidator = null; }
	        _super.call(this, validator, asyncValidator);
	        this.controls = controls;
	        this._initObservables();
	        this._setParentForControls();
	        this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
	    }
	    /**
	     * Get the {@link AbstractControl} at the given `index` in the array.
	     */
	    FormArray.prototype.at = function (index) { return this.controls[index]; };
	    /**
	     * Insert a new {@link AbstractControl} at the end of the array.
	     */
	    FormArray.prototype.push = function (control) {
	        this.controls.push(control);
	        control.setParent(this);
	        this.updateValueAndValidity();
	    };
	    /**
	     * Insert a new {@link AbstractControl} at the given `index` in the array.
	     */
	    FormArray.prototype.insert = function (index, control) {
	        collection_1.ListWrapper.insert(this.controls, index, control);
	        control.setParent(this);
	        this.updateValueAndValidity();
	    };
	    /**
	     * Remove the control at the given `index` in the array.
	     */
	    FormArray.prototype.removeAt = function (index) {
	        collection_1.ListWrapper.removeAt(this.controls, index);
	        this.updateValueAndValidity();
	    };
	    Object.defineProperty(FormArray.prototype, "length", {
	        /**
	         * Length of the control array.
	         */
	        get: function () { return this.controls.length; },
	        enumerable: true,
	        configurable: true
	    });
	    /** @internal */
	    FormArray.prototype._updateValue = function () { this._value = this.controls.map(function (control) { return control.value; }); };
	    /** @internal */
	    FormArray.prototype._anyControlsHaveStatus = function (status) {
	        return this.controls.some(function (c) { return c.status == status; });
	    };
	    /** @internal */
	    FormArray.prototype._setParentForControls = function () {
	        var _this = this;
	        this.controls.forEach(function (control) { control.setParent(_this); });
	    };
	    return FormArray;
	}(AbstractControl));
	exports.FormArray = FormArray;
	//# sourceMappingURL=model.js.map

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var collection_1 = __webpack_require__(1042);
	var exceptions_1 = __webpack_require__(1039);
	var lang_1 = __webpack_require__(1036);
	var validators_1 = __webpack_require__(1049);
	var checkbox_value_accessor_1 = __webpack_require__(1033);
	var default_value_accessor_1 = __webpack_require__(1035);
	var normalize_validator_1 = __webpack_require__(1050);
	var number_value_accessor_1 = __webpack_require__(1051);
	var radio_control_value_accessor_1 = __webpack_require__(1052);
	var select_control_value_accessor_1 = __webpack_require__(1053);
	var select_multiple_control_value_accessor_1 = __webpack_require__(1054);
	function controlPath(name, parent) {
	    var p = collection_1.ListWrapper.clone(parent.path);
	    p.push(name);
	    return p;
	}
	exports.controlPath = controlPath;
	function setUpControl(control, dir) {
	    if (lang_1.isBlank(control))
	        _throwError(dir, 'Cannot find control');
	    if (lang_1.isBlank(dir.valueAccessor))
	        _throwError(dir, 'No value accessor for');
	    control.validator = validators_1.Validators.compose([control.validator, dir.validator]);
	    control.asyncValidator = validators_1.Validators.composeAsync([control.asyncValidator, dir.asyncValidator]);
	    dir.valueAccessor.writeValue(control.value);
	    // view -> model
	    dir.valueAccessor.registerOnChange(function (newValue) {
	        dir.viewToModelUpdate(newValue);
	        control.updateValue(newValue, { emitModelToViewChange: false });
	        control.markAsDirty();
	    });
	    // model -> view
	    control.registerOnChange(function (newValue) { return dir.valueAccessor.writeValue(newValue); });
	    // touched
	    dir.valueAccessor.registerOnTouched(function () { return control.markAsTouched(); });
	}
	exports.setUpControl = setUpControl;
	function setUpFormContainer(control, dir) {
	    if (lang_1.isBlank(control))
	        _throwError(dir, 'Cannot find control');
	    control.validator = validators_1.Validators.compose([control.validator, dir.validator]);
	    control.asyncValidator = validators_1.Validators.composeAsync([control.asyncValidator, dir.asyncValidator]);
	}
	exports.setUpFormContainer = setUpFormContainer;
	function _throwError(dir, message) {
	    var path = dir.path.join(' -> ');
	    throw new exceptions_1.BaseException(message + " '" + path + "'");
	}
	function composeValidators(validators) {
	    return lang_1.isPresent(validators) ? validators_1.Validators.compose(validators.map(normalize_validator_1.normalizeValidator)) : null;
	}
	exports.composeValidators = composeValidators;
	function composeAsyncValidators(validators) {
	    return lang_1.isPresent(validators) ? validators_1.Validators.composeAsync(validators.map(normalize_validator_1.normalizeAsyncValidator)) :
	        null;
	}
	exports.composeAsyncValidators = composeAsyncValidators;
	function isPropertyUpdated(changes, viewModel) {
	    if (!collection_1.StringMapWrapper.contains(changes, 'model'))
	        return false;
	    var change = changes['model'];
	    if (change.isFirstChange())
	        return true;
	    return !lang_1.looseIdentical(viewModel, change.currentValue);
	}
	exports.isPropertyUpdated = isPropertyUpdated;
	// TODO: vsavkin remove it once https://github.com/angular/angular/issues/3011 is implemented
	function selectValueAccessor(dir, valueAccessors) {
	    if (lang_1.isBlank(valueAccessors))
	        return null;
	    var defaultAccessor;
	    var builtinAccessor;
	    var customAccessor;
	    valueAccessors.forEach(function (v) {
	        if (lang_1.hasConstructor(v, default_value_accessor_1.DefaultValueAccessor)) {
	            defaultAccessor = v;
	        }
	        else if (lang_1.hasConstructor(v, checkbox_value_accessor_1.CheckboxControlValueAccessor) || lang_1.hasConstructor(v, number_value_accessor_1.NumberValueAccessor) ||
	            lang_1.hasConstructor(v, select_control_value_accessor_1.SelectControlValueAccessor) ||
	            lang_1.hasConstructor(v, select_multiple_control_value_accessor_1.SelectMultipleControlValueAccessor) ||
	            lang_1.hasConstructor(v, radio_control_value_accessor_1.RadioControlValueAccessor)) {
	            if (lang_1.isPresent(builtinAccessor))
	                _throwError(dir, 'More than one built-in value accessor matches');
	            builtinAccessor = v;
	        }
	        else {
	            if (lang_1.isPresent(customAccessor))
	                _throwError(dir, 'More than one custom value accessor matches');
	            customAccessor = v;
	        }
	    });
	    if (lang_1.isPresent(customAccessor))
	        return customAccessor;
	    if (lang_1.isPresent(builtinAccessor))
	        return builtinAccessor;
	    if (lang_1.isPresent(defaultAccessor))
	        return defaultAccessor;
	    _throwError(dir, 'No valid value accessor for');
	    return null;
	}
	exports.selectValueAccessor = selectValueAccessor;
	//# sourceMappingURL=shared.js.map

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var core_1 = __webpack_require__(5);
	var async_1 = __webpack_require__(1045);
	var collection_1 = __webpack_require__(1042);
	var lang_1 = __webpack_require__(1036);
	var promise_1 = __webpack_require__(1046);
	/**
	 * Providers for validators to be used for {@link FormControl}s in a form.
	 *
	 * Provide this using `multi: true` to add validators.
	 *
	 * ### Example
	 *
	 * {@example core/forms/ts/ng_validators/ng_validators.ts region='ng_validators'}
	 * @experimental
	 */
	exports.NG_VALIDATORS = new core_1.OpaqueToken('NgValidators');
	/**
	 * Providers for asynchronous validators to be used for {@link FormControl}s
	 * in a form.
	 *
	 * Provide this using `multi: true` to add validators.
	 *
	 * See {@link NG_VALIDATORS} for more details.
	 *
	 * @experimental
	 */
	exports.NG_ASYNC_VALIDATORS = 
	/*@ts2dart_const*/ new core_1.OpaqueToken('NgAsyncValidators');
	/**
	 * Provides a set of validators used by form controls.
	 *
	 * A validator is a function that processes a {@link FormControl} or collection of
	 * controls and returns a map of errors. A null map means that validation has passed.
	 *
	 * ### Example
	 *
	 * ```typescript
	 * var loginControl = new FormControl("", Validators.required)
	 * ```
	 *
	 * @experimental
	 */
	var Validators = (function () {
	    function Validators() {
	    }
	    /**
	     * Validator that requires controls to have a non-empty value.
	     */
	    Validators.required = function (control) {
	        return lang_1.isBlank(control.value) || (lang_1.isString(control.value) && control.value == '') ?
	            { 'required': true } :
	            null;
	    };
	    /**
	     * Validator that requires controls to have a value of a minimum length.
	     */
	    Validators.minLength = function (minLength) {
	        return function (control) {
	            if (lang_1.isPresent(Validators.required(control)))
	                return null;
	            var v = control.value;
	            return v.length < minLength ?
	                { 'minlength': { 'requiredLength': minLength, 'actualLength': v.length } } :
	                null;
	        };
	    };
	    /**
	     * Validator that requires controls to have a value of a maximum length.
	     */
	    Validators.maxLength = function (maxLength) {
	        return function (control) {
	            if (lang_1.isPresent(Validators.required(control)))
	                return null;
	            var v = control.value;
	            return v.length > maxLength ?
	                { 'maxlength': { 'requiredLength': maxLength, 'actualLength': v.length } } :
	                null;
	        };
	    };
	    /**
	     * Validator that requires a control to match a regex to its value.
	     */
	    Validators.pattern = function (pattern) {
	        return function (control) {
	            if (lang_1.isPresent(Validators.required(control)))
	                return null;
	            var regex = new RegExp("^" + pattern + "$");
	            var v = control.value;
	            return regex.test(v) ? null :
	                { 'pattern': { 'requiredPattern': "^" + pattern + "$", 'actualValue': v } };
	        };
	    };
	    /**
	     * No-op validator.
	     */
	    Validators.nullValidator = function (c) { return null; };
	    /**
	     * Compose multiple validators into a single function that returns the union
	     * of the individual error maps.
	     */
	    Validators.compose = function (validators) {
	        if (lang_1.isBlank(validators))
	            return null;
	        var presentValidators = validators.filter(lang_1.isPresent);
	        if (presentValidators.length == 0)
	            return null;
	        return function (control) {
	            return _mergeErrors(_executeValidators(control, presentValidators));
	        };
	    };
	    Validators.composeAsync = function (validators) {
	        if (lang_1.isBlank(validators))
	            return null;
	        var presentValidators = validators.filter(lang_1.isPresent);
	        if (presentValidators.length == 0)
	            return null;
	        return function (control) {
	            var promises = _executeAsyncValidators(control, presentValidators).map(_convertToPromise);
	            return promise_1.PromiseWrapper.all(promises).then(_mergeErrors);
	        };
	    };
	    return Validators;
	}());
	exports.Validators = Validators;
	function _convertToPromise(obj) {
	    return lang_1.isPromise(obj) ? obj : async_1.ObservableWrapper.toPromise(obj);
	}
	function _executeValidators(control, validators) {
	    return validators.map(function (v) { return v(control); });
	}
	function _executeAsyncValidators(control, validators) {
	    return validators.map(function (v) { return v(control); });
	}
	function _mergeErrors(arrayOfErrors) {
	    var res = arrayOfErrors.reduce(function (res, errors) {
	        return lang_1.isPresent(errors) ? collection_1.StringMapWrapper.merge(res, errors) : res;
	    }, {});
	    return collection_1.StringMapWrapper.isEmpty(res) ? null : res;
	}
	//# sourceMappingURL=validators.js.map

/***/ }),
/* 1050 */
158,
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var core_1 = __webpack_require__(5);
	var lang_1 = __webpack_require__(1036);
	var control_value_accessor_1 = __webpack_require__(1034);
	exports.NUMBER_VALUE_ACCESSOR = {
	    provide: control_value_accessor_1.NG_VALUE_ACCESSOR,
	    useExisting: core_1.forwardRef(function () { return NumberValueAccessor; }),
	    multi: true
	};
	var NumberValueAccessor = (function () {
	    function NumberValueAccessor(_renderer, _elementRef) {
	        this._renderer = _renderer;
	        this._elementRef = _elementRef;
	        this.onChange = function (_) { };
	        this.onTouched = function () { };
	    }
	    NumberValueAccessor.prototype.writeValue = function (value) {
	        this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', value);
	    };
	    NumberValueAccessor.prototype.registerOnChange = function (fn) {
	        this.onChange = function (value) { fn(value == '' ? null : lang_1.NumberWrapper.parseFloat(value)); };
	    };
	    NumberValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
	    /** @nocollapse */
	    NumberValueAccessor.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: 'input[type=number][formControlName],input[type=number][formControl],input[type=number][ngModel]',
	                    host: {
	                        '(change)': 'onChange($event.target.value)',
	                        '(input)': 'onChange($event.target.value)',
	                        '(blur)': 'onTouched()'
	                    },
	                    providers: [exports.NUMBER_VALUE_ACCESSOR]
	                },] },
	    ];
	    /** @nocollapse */
	    NumberValueAccessor.ctorParameters = [
	        { type: core_1.Renderer, },
	        { type: core_1.ElementRef, },
	    ];
	    return NumberValueAccessor;
	}());
	exports.NumberValueAccessor = NumberValueAccessor;
	//# sourceMappingURL=number_value_accessor.js.map

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var core_1 = __webpack_require__(5);
	var collection_1 = __webpack_require__(1042);
	var exceptions_1 = __webpack_require__(1039);
	var lang_1 = __webpack_require__(1036);
	var control_value_accessor_1 = __webpack_require__(1034);
	var ng_control_1 = __webpack_require__(1038);
	exports.RADIO_VALUE_ACCESSOR = {
	    provide: control_value_accessor_1.NG_VALUE_ACCESSOR,
	    useExisting: core_1.forwardRef(function () { return RadioControlValueAccessor; }),
	    multi: true
	};
	var RadioControlRegistry = (function () {
	    function RadioControlRegistry() {
	        this._accessors = [];
	    }
	    RadioControlRegistry.prototype.add = function (control, accessor) {
	        this._accessors.push([control, accessor]);
	    };
	    RadioControlRegistry.prototype.remove = function (accessor) {
	        var indexToRemove = -1;
	        for (var i = 0; i < this._accessors.length; ++i) {
	            if (this._accessors[i][1] === accessor) {
	                indexToRemove = i;
	            }
	        }
	        collection_1.ListWrapper.removeAt(this._accessors, indexToRemove);
	    };
	    RadioControlRegistry.prototype.select = function (accessor) {
	        var _this = this;
	        this._accessors.forEach(function (c) {
	            if (_this._isSameGroup(c, accessor) && c[1] !== accessor) {
	                c[1].fireUncheck(accessor.value);
	            }
	        });
	    };
	    RadioControlRegistry.prototype._isSameGroup = function (controlPair, accessor) {
	        if (!controlPair[0].control)
	            return false;
	        return controlPair[0].control.root === accessor._control.control.root &&
	            controlPair[1].name === accessor.name;
	    };
	    /** @nocollapse */
	    RadioControlRegistry.decorators = [
	        { type: core_1.Injectable },
	    ];
	    return RadioControlRegistry;
	}());
	exports.RadioControlRegistry = RadioControlRegistry;
	var RadioControlValueAccessor = (function () {
	    function RadioControlValueAccessor(_renderer, _elementRef, _registry, _injector) {
	        this._renderer = _renderer;
	        this._elementRef = _elementRef;
	        this._registry = _registry;
	        this._injector = _injector;
	        this.onChange = function () { };
	        this.onTouched = function () { };
	    }
	    RadioControlValueAccessor.prototype.ngOnInit = function () {
	        this._control = this._injector.get(ng_control_1.NgControl);
	        this._checkName();
	        this._registry.add(this._control, this);
	    };
	    RadioControlValueAccessor.prototype.ngOnDestroy = function () { this._registry.remove(this); };
	    RadioControlValueAccessor.prototype.writeValue = function (value) {
	        this._state = value === this.value;
	        if (lang_1.isPresent(value)) {
	            this._renderer.setElementProperty(this._elementRef.nativeElement, 'checked', this._state);
	        }
	    };
	    RadioControlValueAccessor.prototype.registerOnChange = function (fn) {
	        var _this = this;
	        this._fn = fn;
	        this.onChange = function () {
	            fn(_this.value);
	            _this._registry.select(_this);
	        };
	    };
	    RadioControlValueAccessor.prototype.fireUncheck = function (value) { this.writeValue(value); };
	    RadioControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
	    RadioControlValueAccessor.prototype._checkName = function () {
	        if (this.name && this.formControlName && this.name !== this.formControlName) {
	            this._throwNameError();
	        }
	        if (!this.name && this.formControlName)
	            this.name = this.formControlName;
	    };
	    RadioControlValueAccessor.prototype._throwNameError = function () {
	        throw new exceptions_1.BaseException("\n      If you define both a name and a formControlName attribute on your radio button, their values\n      must match. Ex: <input type=\"radio\" formControlName=\"food\" name=\"food\">\n    ");
	    };
	    /** @nocollapse */
	    RadioControlValueAccessor.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: 'input[type=radio][formControlName],input[type=radio][formControl],input[type=radio][ngModel]',
	                    host: { '(change)': 'onChange()', '(blur)': 'onTouched()' },
	                    providers: [exports.RADIO_VALUE_ACCESSOR]
	                },] },
	    ];
	    /** @nocollapse */
	    RadioControlValueAccessor.ctorParameters = [
	        { type: core_1.Renderer, },
	        { type: core_1.ElementRef, },
	        { type: RadioControlRegistry, },
	        { type: core_1.Injector, },
	    ];
	    /** @nocollapse */
	    RadioControlValueAccessor.propDecorators = {
	        'name': [{ type: core_1.Input },],
	        'formControlName': [{ type: core_1.Input },],
	        'value': [{ type: core_1.Input },],
	    };
	    return RadioControlValueAccessor;
	}());
	exports.RadioControlValueAccessor = RadioControlValueAccessor;
	//# sourceMappingURL=radio_control_value_accessor.js.map

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var core_1 = __webpack_require__(5);
	var collection_1 = __webpack_require__(1042);
	var lang_1 = __webpack_require__(1036);
	var control_value_accessor_1 = __webpack_require__(1034);
	exports.SELECT_VALUE_ACCESSOR = {
	    provide: control_value_accessor_1.NG_VALUE_ACCESSOR,
	    useExisting: core_1.forwardRef(function () { return SelectControlValueAccessor; }),
	    multi: true
	};
	function _buildValueString(id, value) {
	    if (lang_1.isBlank(id))
	        return "" + value;
	    if (!lang_1.isPrimitive(value))
	        value = 'Object';
	    return lang_1.StringWrapper.slice(id + ": " + value, 0, 50);
	}
	function _extractId(valueString) {
	    return valueString.split(':')[0];
	}
	var SelectControlValueAccessor = (function () {
	    function SelectControlValueAccessor(_renderer, _elementRef) {
	        this._renderer = _renderer;
	        this._elementRef = _elementRef;
	        /** @internal */
	        this._optionMap = new Map();
	        /** @internal */
	        this._idCounter = 0;
	        this.onChange = function (_) { };
	        this.onTouched = function () { };
	    }
	    SelectControlValueAccessor.prototype.writeValue = function (value) {
	        this.value = value;
	        var valueString = _buildValueString(this._getOptionId(value), value);
	        this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', valueString);
	    };
	    SelectControlValueAccessor.prototype.registerOnChange = function (fn) {
	        var _this = this;
	        this.onChange = function (valueString) {
	            _this.value = valueString;
	            fn(_this._getOptionValue(valueString));
	        };
	    };
	    SelectControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
	    /** @internal */
	    SelectControlValueAccessor.prototype._registerOption = function () { return (this._idCounter++).toString(); };
	    /** @internal */
	    SelectControlValueAccessor.prototype._getOptionId = function (value) {
	        for (var _i = 0, _a = collection_1.MapWrapper.keys(this._optionMap); _i < _a.length; _i++) {
	            var id = _a[_i];
	            if (lang_1.looseIdentical(this._optionMap.get(id), value))
	                return id;
	        }
	        return null;
	    };
	    /** @internal */
	    SelectControlValueAccessor.prototype._getOptionValue = function (valueString) {
	        var value = this._optionMap.get(_extractId(valueString));
	        return lang_1.isPresent(value) ? value : valueString;
	    };
	    /** @nocollapse */
	    SelectControlValueAccessor.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: 'select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]',
	                    host: { '(change)': 'onChange($event.target.value)', '(blur)': 'onTouched()' },
	                    providers: [exports.SELECT_VALUE_ACCESSOR]
	                },] },
	    ];
	    /** @nocollapse */
	    SelectControlValueAccessor.ctorParameters = [
	        { type: core_1.Renderer, },
	        { type: core_1.ElementRef, },
	    ];
	    return SelectControlValueAccessor;
	}());
	exports.SelectControlValueAccessor = SelectControlValueAccessor;
	var NgSelectOption = (function () {
	    function NgSelectOption(_element, _renderer, _select) {
	        this._element = _element;
	        this._renderer = _renderer;
	        this._select = _select;
	        if (lang_1.isPresent(this._select))
	            this.id = this._select._registerOption();
	    }
	    Object.defineProperty(NgSelectOption.prototype, "ngValue", {
	        set: function (value) {
	            if (this._select == null)
	                return;
	            this._select._optionMap.set(this.id, value);
	            this._setElementValue(_buildValueString(this.id, value));
	            this._select.writeValue(this._select.value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgSelectOption.prototype, "value", {
	        set: function (value) {
	            this._setElementValue(value);
	            if (lang_1.isPresent(this._select))
	                this._select.writeValue(this._select.value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** @internal */
	    NgSelectOption.prototype._setElementValue = function (value) {
	        this._renderer.setElementProperty(this._element.nativeElement, 'value', value);
	    };
	    NgSelectOption.prototype.ngOnDestroy = function () {
	        if (lang_1.isPresent(this._select)) {
	            this._select._optionMap.delete(this.id);
	            this._select.writeValue(this._select.value);
	        }
	    };
	    /** @nocollapse */
	    NgSelectOption.decorators = [
	        { type: core_1.Directive, args: [{ selector: 'option' },] },
	    ];
	    /** @nocollapse */
	    NgSelectOption.ctorParameters = [
	        { type: core_1.ElementRef, },
	        { type: core_1.Renderer, },
	        { type: SelectControlValueAccessor, decorators: [{ type: core_1.Optional }, { type: core_1.Host },] },
	    ];
	    /** @nocollapse */
	    NgSelectOption.propDecorators = {
	        'ngValue': [{ type: core_1.Input, args: ['ngValue',] },],
	        'value': [{ type: core_1.Input, args: ['value',] },],
	    };
	    return NgSelectOption;
	}());
	exports.NgSelectOption = NgSelectOption;
	//# sourceMappingURL=select_control_value_accessor.js.map

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var core_1 = __webpack_require__(5);
	var collection_1 = __webpack_require__(1042);
	var lang_1 = __webpack_require__(1036);
	var control_value_accessor_1 = __webpack_require__(1034);
	var SELECT_MULTIPLE_VALUE_ACCESSOR = {
	    provide: control_value_accessor_1.NG_VALUE_ACCESSOR,
	    useExisting: core_1.forwardRef(function () { return SelectMultipleControlValueAccessor; }),
	    multi: true
	};
	function _buildValueString(id, value) {
	    if (lang_1.isBlank(id))
	        return "" + value;
	    if (lang_1.isString(value))
	        value = "'" + value + "'";
	    if (!lang_1.isPrimitive(value))
	        value = 'Object';
	    return lang_1.StringWrapper.slice(id + ": " + value, 0, 50);
	}
	function _extractId(valueString) {
	    return valueString.split(':')[0];
	}
	/** Mock interface for HTMLCollection */
	var HTMLCollection = (function () {
	    function HTMLCollection() {
	    }
	    return HTMLCollection;
	}());
	var SelectMultipleControlValueAccessor = (function () {
	    function SelectMultipleControlValueAccessor() {
	        /** @internal */
	        this._optionMap = new Map();
	        /** @internal */
	        this._idCounter = 0;
	        this.onChange = function (_) { };
	        this.onTouched = function () { };
	    }
	    SelectMultipleControlValueAccessor.prototype.writeValue = function (value) {
	        var _this = this;
	        this.value = value;
	        if (value == null)
	            return;
	        var values = value;
	        // convert values to ids
	        var ids = values.map(function (v) { return _this._getOptionId(v); });
	        this._optionMap.forEach(function (opt, o) { opt._setSelected(ids.indexOf(o.toString()) > -1); });
	    };
	    SelectMultipleControlValueAccessor.prototype.registerOnChange = function (fn) {
	        var _this = this;
	        this.onChange = function (_) {
	            var selected = [];
	            if (_.hasOwnProperty('selectedOptions')) {
	                var options = _.selectedOptions;
	                for (var i = 0; i < options.length; i++) {
	                    var opt = options.item(i);
	                    var val = _this._getOptionValue(opt.value);
	                    selected.push(val);
	                }
	            }
	            else {
	                var options = _.options;
	                for (var i = 0; i < options.length; i++) {
	                    var opt = options.item(i);
	                    if (opt.selected) {
	                        var val = _this._getOptionValue(opt.value);
	                        selected.push(val);
	                    }
	                }
	            }
	            fn(selected);
	        };
	    };
	    SelectMultipleControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
	    /** @internal */
	    SelectMultipleControlValueAccessor.prototype._registerOption = function (value) {
	        var id = (this._idCounter++).toString();
	        this._optionMap.set(id, value);
	        return id;
	    };
	    /** @internal */
	    SelectMultipleControlValueAccessor.prototype._getOptionId = function (value) {
	        for (var _i = 0, _a = collection_1.MapWrapper.keys(this._optionMap); _i < _a.length; _i++) {
	            var id = _a[_i];
	            if (lang_1.looseIdentical(this._optionMap.get(id)._value, value))
	                return id;
	        }
	        return null;
	    };
	    /** @internal */
	    SelectMultipleControlValueAccessor.prototype._getOptionValue = function (valueString) {
	        var opt = this._optionMap.get(_extractId(valueString));
	        return lang_1.isPresent(opt) ? opt._value : valueString;
	    };
	    /** @nocollapse */
	    SelectMultipleControlValueAccessor.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: 'select[multiple][formControlName],select[multiple][formControl],select[multiple][ngModel]',
	                    host: { '(input)': 'onChange($event.target)', '(blur)': 'onTouched()' },
	                    providers: [SELECT_MULTIPLE_VALUE_ACCESSOR]
	                },] },
	    ];
	    /** @nocollapse */
	    SelectMultipleControlValueAccessor.ctorParameters = [];
	    return SelectMultipleControlValueAccessor;
	}());
	exports.SelectMultipleControlValueAccessor = SelectMultipleControlValueAccessor;
	var NgSelectMultipleOption = (function () {
	    function NgSelectMultipleOption(_element, _renderer, _select) {
	        this._element = _element;
	        this._renderer = _renderer;
	        this._select = _select;
	        if (lang_1.isPresent(this._select)) {
	            this.id = this._select._registerOption(this);
	        }
	    }
	    Object.defineProperty(NgSelectMultipleOption.prototype, "ngValue", {
	        set: function (value) {
	            if (this._select == null)
	                return;
	            this._value = value;
	            this._setElementValue(_buildValueString(this.id, value));
	            this._select.writeValue(this._select.value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgSelectMultipleOption.prototype, "value", {
	        set: function (value) {
	            if (lang_1.isPresent(this._select)) {
	                this._value = value;
	                this._setElementValue(_buildValueString(this.id, value));
	                this._select.writeValue(this._select.value);
	            }
	            else {
	                this._setElementValue(value);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** @internal */
	    NgSelectMultipleOption.prototype._setElementValue = function (value) {
	        this._renderer.setElementProperty(this._element.nativeElement, 'value', value);
	    };
	    /** @internal */
	    NgSelectMultipleOption.prototype._setSelected = function (selected) {
	        this._renderer.setElementProperty(this._element.nativeElement, 'selected', selected);
	    };
	    NgSelectMultipleOption.prototype.ngOnDestroy = function () {
	        if (lang_1.isPresent(this._select)) {
	            this._select._optionMap.delete(this.id);
	            this._select.writeValue(this._select.value);
	        }
	    };
	    /** @nocollapse */
	    NgSelectMultipleOption.decorators = [
	        { type: core_1.Directive, args: [{ selector: 'option' },] },
	    ];
	    /** @nocollapse */
	    NgSelectMultipleOption.ctorParameters = [
	        { type: core_1.ElementRef, },
	        { type: core_1.Renderer, },
	        { type: SelectMultipleControlValueAccessor, decorators: [{ type: core_1.Optional }, { type: core_1.Host },] },
	    ];
	    /** @nocollapse */
	    NgSelectMultipleOption.propDecorators = {
	        'ngValue': [{ type: core_1.Input, args: ['ngValue',] },],
	        'value': [{ type: core_1.Input, args: ['value',] },],
	    };
	    return NgSelectMultipleOption;
	}());
	exports.NgSelectMultipleOption = NgSelectMultipleOption;
	exports.SELECT_DIRECTIVES = [SelectMultipleControlValueAccessor, NgSelectMultipleOption];
	//# sourceMappingURL=select_multiple_control_value_accessor.js.map

/***/ }),
/* 1055 */
[1363, 1043],
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var core_1 = __webpack_require__(5);
	var async_1 = __webpack_require__(1045);
	var exceptions_1 = __webpack_require__(1039);
	var model_1 = __webpack_require__(1047);
	var validators_1 = __webpack_require__(1049);
	var control_container_1 = __webpack_require__(1055);
	var control_value_accessor_1 = __webpack_require__(1034);
	var ng_control_1 = __webpack_require__(1038);
	var shared_1 = __webpack_require__(1048);
	exports.formControlBinding = 
	/*@ts2dart_const*/ /* @ts2dart_Provider */ {
	    provide: ng_control_1.NgControl,
	    useExisting: core_1.forwardRef(function () { return NgModel; })
	};
	var NgModel = (function (_super) {
	    __extends(NgModel, _super);
	    function NgModel(_parent, _validators, _asyncValidators, valueAccessors) {
	        _super.call(this);
	        this._parent = _parent;
	        this._validators = _validators;
	        this._asyncValidators = _asyncValidators;
	        /** @internal */
	        this._control = new model_1.FormControl();
	        /** @internal */
	        this._registered = false;
	        this.update = new async_1.EventEmitter();
	        this.valueAccessor = shared_1.selectValueAccessor(this, valueAccessors);
	    }
	    NgModel.prototype.ngOnChanges = function (changes) {
	        this._checkName();
	        if (!this._registered)
	            this._setUpControl();
	        if (shared_1.isPropertyUpdated(changes, this.viewModel)) {
	            this._updateValue(this.model);
	            this.viewModel = this.model;
	        }
	    };
	    NgModel.prototype.ngOnDestroy = function () { this.formDirective && this.formDirective.removeControl(this); };
	    Object.defineProperty(NgModel.prototype, "control", {
	        get: function () { return this._control; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgModel.prototype, "path", {
	        get: function () {
	            return this._parent ? shared_1.controlPath(this.name, this._parent) : [];
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgModel.prototype, "formDirective", {
	        get: function () { return this._parent ? this._parent.formDirective : null; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgModel.prototype, "validator", {
	        get: function () { return shared_1.composeValidators(this._validators); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgModel.prototype, "asyncValidator", {
	        get: function () {
	            return shared_1.composeAsyncValidators(this._asyncValidators);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    NgModel.prototype.viewToModelUpdate = function (newValue) {
	        this.viewModel = newValue;
	        async_1.ObservableWrapper.callEmit(this.update, newValue);
	    };
	    NgModel.prototype._setUpControl = function () {
	        this._isStandalone() ? this._setUpStandalone() :
	            this.formDirective.addControl(this);
	        this._registered = true;
	    };
	    NgModel.prototype._isStandalone = function () {
	        return !this._parent || (this.options && this.options.standalone);
	    };
	    NgModel.prototype._setUpStandalone = function () {
	        shared_1.setUpControl(this._control, this);
	        this._control.updateValueAndValidity({ emitEvent: false });
	    };
	    NgModel.prototype._checkName = function () {
	        if (this.options && this.options.name)
	            this.name = this.options.name;
	        if (!this._isStandalone() && !this.name) {
	            throw new exceptions_1.BaseException("If ngModel is used within a form tag, either the name attribute must be set\n                      or the form control must be defined as 'standalone' in ngModelOptions.\n\n                      Example 1: <input [(ngModel)]=\"person.firstName\" name=\"first\">\n                      Example 2: <input [(ngModel)]=\"person.firstName\" [ngModelOptions]=\"{standalone: true}\">\n                   ");
	        }
	    };
	    NgModel.prototype._updateValue = function (value) {
	        var _this = this;
	        async_1.PromiseWrapper.scheduleMicrotask(function () { _this.control.updateValue(value); });
	    };
	    /** @nocollapse */
	    NgModel.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: '[ngModel]:not([formControlName]):not([formControl])',
	                    providers: [exports.formControlBinding],
	                    exportAs: 'ngModel'
	                },] },
	    ];
	    /** @nocollapse */
	    NgModel.ctorParameters = [
	        { type: control_container_1.ControlContainer, decorators: [{ type: core_1.Optional }, { type: core_1.Host },] },
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [validators_1.NG_VALIDATORS,] },] },
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [validators_1.NG_ASYNC_VALIDATORS,] },] },
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [control_value_accessor_1.NG_VALUE_ACCESSOR,] },] },
	    ];
	    /** @nocollapse */
	    NgModel.propDecorators = {
	        'model': [{ type: core_1.Input, args: ['ngModel',] },],
	        'name': [{ type: core_1.Input },],
	        'options': [{ type: core_1.Input, args: ['ngModelOptions',] },],
	        'update': [{ type: core_1.Output, args: ['ngModelChange',] },],
	    };
	    return NgModel;
	}(ng_control_1.NgControl));
	exports.NgModel = NgModel;
	//# sourceMappingURL=ng_model.js.map

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var core_1 = __webpack_require__(5);
	var validators_1 = __webpack_require__(1049);
	var abstract_form_group_directive_1 = __webpack_require__(1058);
	var control_container_1 = __webpack_require__(1055);
	exports.modelGroupProvider = 
	/*@ts2dart_const*/ /* @ts2dart_Provider */ {
	    provide: control_container_1.ControlContainer,
	    useExisting: core_1.forwardRef(function () { return NgModelGroup; })
	};
	var NgModelGroup = (function (_super) {
	    __extends(NgModelGroup, _super);
	    function NgModelGroup(parent, validators, asyncValidators) {
	        _super.call(this);
	        this._parent = parent;
	        this._validators = validators;
	        this._asyncValidators = asyncValidators;
	    }
	    /** @nocollapse */
	    NgModelGroup.decorators = [
	        { type: core_1.Directive, args: [{ selector: '[ngModelGroup]', providers: [exports.modelGroupProvider], exportAs: 'ngModelGroup' },] },
	    ];
	    /** @nocollapse */
	    NgModelGroup.ctorParameters = [
	        { type: control_container_1.ControlContainer, decorators: [{ type: core_1.Host }, { type: core_1.SkipSelf },] },
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [validators_1.NG_VALIDATORS,] },] },
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [validators_1.NG_ASYNC_VALIDATORS,] },] },
	    ];
	    /** @nocollapse */
	    NgModelGroup.propDecorators = {
	        'name': [{ type: core_1.Input, args: ['ngModelGroup',] },],
	    };
	    return NgModelGroup;
	}(abstract_form_group_directive_1.AbstractFormGroupDirective));
	exports.NgModelGroup = NgModelGroup;
	//# sourceMappingURL=ng_model_group.js.map

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var control_container_1 = __webpack_require__(1055);
	var shared_1 = __webpack_require__(1048);
	/**
	  This is a base class for code shared between {@link NgModelGroup} and {@link FormGroupName}.
	 */
	var AbstractFormGroupDirective = (function (_super) {
	    __extends(AbstractFormGroupDirective, _super);
	    function AbstractFormGroupDirective() {
	        _super.apply(this, arguments);
	    }
	    AbstractFormGroupDirective.prototype.ngOnInit = function () { this.formDirective.addFormGroup(this); };
	    AbstractFormGroupDirective.prototype.ngOnDestroy = function () { this.formDirective.removeFormGroup(this); };
	    Object.defineProperty(AbstractFormGroupDirective.prototype, "control", {
	        /**
	         * Get the {@link FormGroup} backing this binding.
	         */
	        get: function () { return this.formDirective.getFormGroup(this); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractFormGroupDirective.prototype, "path", {
	        /**
	         * Get the path to this control group.
	         */
	        get: function () { return shared_1.controlPath(this.name, this._parent); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractFormGroupDirective.prototype, "formDirective", {
	        /**
	         * Get the {@link Form} to which this group belongs.
	         */
	        get: function () { return this._parent.formDirective; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractFormGroupDirective.prototype, "validator", {
	        get: function () { return shared_1.composeValidators(this._validators); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractFormGroupDirective.prototype, "asyncValidator", {
	        get: function () { return shared_1.composeAsyncValidators(this._asyncValidators); },
	        enumerable: true,
	        configurable: true
	    });
	    return AbstractFormGroupDirective;
	}(control_container_1.ControlContainer));
	exports.AbstractFormGroupDirective = AbstractFormGroupDirective;
	//# sourceMappingURL=abstract_form_group_directive.js.map

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var core_1 = __webpack_require__(5);
	var validators_1 = __webpack_require__(1049);
	var control_container_1 = __webpack_require__(1055);
	var shared_1 = __webpack_require__(1048);
	exports.formArrayNameProvider = 
	/*@ts2dart_const*/ /* @ts2dart_Provider */ {
	    provide: control_container_1.ControlContainer,
	    useExisting: core_1.forwardRef(function () { return FormArrayName; })
	};
	var FormArrayName = (function (_super) {
	    __extends(FormArrayName, _super);
	    function FormArrayName(parent, validators, asyncValidators) {
	        _super.call(this);
	        this._parent = parent;
	        this._validators = validators;
	        this._asyncValidators = asyncValidators;
	    }
	    FormArrayName.prototype.ngOnInit = function () { this.formDirective.addFormArray(this); };
	    FormArrayName.prototype.ngOnDestroy = function () { this.formDirective.removeFormArray(this); };
	    Object.defineProperty(FormArrayName.prototype, "control", {
	        get: function () { return this.formDirective.getFormArray(this); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormArrayName.prototype, "formDirective", {
	        get: function () { return this._parent.formDirective; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormArrayName.prototype, "path", {
	        get: function () { return shared_1.controlPath(this.name, this._parent); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormArrayName.prototype, "validator", {
	        get: function () { return shared_1.composeValidators(this._validators); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormArrayName.prototype, "asyncValidator", {
	        get: function () { return shared_1.composeAsyncValidators(this._asyncValidators); },
	        enumerable: true,
	        configurable: true
	    });
	    /** @nocollapse */
	    FormArrayName.decorators = [
	        { type: core_1.Directive, args: [{ selector: '[formArrayName]', providers: [exports.formArrayNameProvider] },] },
	    ];
	    /** @nocollapse */
	    FormArrayName.ctorParameters = [
	        { type: control_container_1.ControlContainer, decorators: [{ type: core_1.Host }, { type: core_1.SkipSelf },] },
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [validators_1.NG_VALIDATORS,] },] },
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [validators_1.NG_ASYNC_VALIDATORS,] },] },
	    ];
	    /** @nocollapse */
	    FormArrayName.propDecorators = {
	        'name': [{ type: core_1.Input, args: ['formArrayName',] },],
	    };
	    return FormArrayName;
	}(control_container_1.ControlContainer));
	exports.FormArrayName = FormArrayName;
	//# sourceMappingURL=form_array_name.js.map

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var core_1 = __webpack_require__(5);
	var async_1 = __webpack_require__(1045);
	var collection_1 = __webpack_require__(1042);
	var validators_1 = __webpack_require__(1049);
	var control_value_accessor_1 = __webpack_require__(1034);
	var ng_control_1 = __webpack_require__(1038);
	var shared_1 = __webpack_require__(1048);
	exports.formControlBinding = 
	/*@ts2dart_const*/ /* @ts2dart_Provider */ {
	    provide: ng_control_1.NgControl,
	    useExisting: core_1.forwardRef(function () { return FormControlDirective; })
	};
	var FormControlDirective = (function (_super) {
	    __extends(FormControlDirective, _super);
	    function FormControlDirective(_validators, _asyncValidators, valueAccessors) {
	        _super.call(this);
	        this._validators = _validators;
	        this._asyncValidators = _asyncValidators;
	        this.update = new async_1.EventEmitter();
	        this.valueAccessor = shared_1.selectValueAccessor(this, valueAccessors);
	    }
	    FormControlDirective.prototype.ngOnChanges = function (changes) {
	        if (this._isControlChanged(changes)) {
	            shared_1.setUpControl(this.form, this);
	            this.form.updateValueAndValidity({ emitEvent: false });
	        }
	        if (shared_1.isPropertyUpdated(changes, this.viewModel)) {
	            this.form.updateValue(this.model);
	            this.viewModel = this.model;
	        }
	    };
	    Object.defineProperty(FormControlDirective.prototype, "path", {
	        get: function () { return []; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormControlDirective.prototype, "validator", {
	        get: function () { return shared_1.composeValidators(this._validators); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormControlDirective.prototype, "asyncValidator", {
	        get: function () {
	            return shared_1.composeAsyncValidators(this._asyncValidators);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormControlDirective.prototype, "control", {
	        get: function () { return this.form; },
	        enumerable: true,
	        configurable: true
	    });
	    FormControlDirective.prototype.viewToModelUpdate = function (newValue) {
	        this.viewModel = newValue;
	        async_1.ObservableWrapper.callEmit(this.update, newValue);
	    };
	    FormControlDirective.prototype._isControlChanged = function (changes) {
	        return collection_1.StringMapWrapper.contains(changes, 'form');
	    };
	    /** @nocollapse */
	    FormControlDirective.decorators = [
	        { type: core_1.Directive, args: [{ selector: '[formControl]', providers: [exports.formControlBinding], exportAs: 'ngForm' },] },
	    ];
	    /** @nocollapse */
	    FormControlDirective.ctorParameters = [
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [validators_1.NG_VALIDATORS,] },] },
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [validators_1.NG_ASYNC_VALIDATORS,] },] },
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [control_value_accessor_1.NG_VALUE_ACCESSOR,] },] },
	    ];
	    /** @nocollapse */
	    FormControlDirective.propDecorators = {
	        'form': [{ type: core_1.Input, args: ['formControl',] },],
	        'model': [{ type: core_1.Input, args: ['ngModel',] },],
	        'update': [{ type: core_1.Output, args: ['ngModelChange',] },],
	    };
	    return FormControlDirective;
	}(ng_control_1.NgControl));
	exports.FormControlDirective = FormControlDirective;
	//# sourceMappingURL=form_control_directive.js.map

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var core_1 = __webpack_require__(5);
	var async_1 = __webpack_require__(1045);
	var validators_1 = __webpack_require__(1049);
	var control_container_1 = __webpack_require__(1055);
	var control_value_accessor_1 = __webpack_require__(1034);
	var ng_control_1 = __webpack_require__(1038);
	var shared_1 = __webpack_require__(1048);
	exports.controlNameBinding = 
	/*@ts2dart_const*/ /* @ts2dart_Provider */ {
	    provide: ng_control_1.NgControl,
	    useExisting: core_1.forwardRef(function () { return FormControlName; })
	};
	var FormControlName = (function (_super) {
	    __extends(FormControlName, _super);
	    function FormControlName(_parent, _validators, _asyncValidators, valueAccessors) {
	        _super.call(this);
	        this._parent = _parent;
	        this._validators = _validators;
	        this._asyncValidators = _asyncValidators;
	        this._added = false;
	        this.update = new async_1.EventEmitter();
	        this.valueAccessor = shared_1.selectValueAccessor(this, valueAccessors);
	    }
	    FormControlName.prototype.ngOnChanges = function (changes) {
	        if (!this._added) {
	            this.formDirective.addControl(this);
	            this._added = true;
	        }
	        if (shared_1.isPropertyUpdated(changes, this.viewModel)) {
	            this.viewModel = this.model;
	            this.formDirective.updateModel(this, this.model);
	        }
	    };
	    FormControlName.prototype.ngOnDestroy = function () { this.formDirective.removeControl(this); };
	    FormControlName.prototype.viewToModelUpdate = function (newValue) {
	        this.viewModel = newValue;
	        async_1.ObservableWrapper.callEmit(this.update, newValue);
	    };
	    Object.defineProperty(FormControlName.prototype, "path", {
	        get: function () { return shared_1.controlPath(this.name, this._parent); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormControlName.prototype, "formDirective", {
	        get: function () { return this._parent.formDirective; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormControlName.prototype, "validator", {
	        get: function () { return shared_1.composeValidators(this._validators); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormControlName.prototype, "asyncValidator", {
	        get: function () {
	            return shared_1.composeAsyncValidators(this._asyncValidators);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormControlName.prototype, "control", {
	        get: function () { return this.formDirective.getControl(this); },
	        enumerable: true,
	        configurable: true
	    });
	    /** @nocollapse */
	    FormControlName.decorators = [
	        { type: core_1.Directive, args: [{ selector: '[formControlName]', providers: [exports.controlNameBinding] },] },
	    ];
	    /** @nocollapse */
	    FormControlName.ctorParameters = [
	        { type: control_container_1.ControlContainer, decorators: [{ type: core_1.Host }, { type: core_1.SkipSelf },] },
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [validators_1.NG_VALIDATORS,] },] },
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [validators_1.NG_ASYNC_VALIDATORS,] },] },
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [control_value_accessor_1.NG_VALUE_ACCESSOR,] },] },
	    ];
	    /** @nocollapse */
	    FormControlName.propDecorators = {
	        'name': [{ type: core_1.Input, args: ['formControlName',] },],
	        'model': [{ type: core_1.Input, args: ['ngModel',] },],
	        'update': [{ type: core_1.Output, args: ['ngModelChange',] },],
	    };
	    return FormControlName;
	}(ng_control_1.NgControl));
	exports.FormControlName = FormControlName;
	//# sourceMappingURL=form_control_name.js.map

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var core_1 = __webpack_require__(5);
	var async_1 = __webpack_require__(1045);
	var collection_1 = __webpack_require__(1042);
	var exceptions_1 = __webpack_require__(1039);
	var lang_1 = __webpack_require__(1036);
	var validators_1 = __webpack_require__(1049);
	var control_container_1 = __webpack_require__(1055);
	var shared_1 = __webpack_require__(1048);
	exports.formDirectiveProvider = 
	/*@ts2dart_const*/ /* @ts2dart_Provider */ {
	    provide: control_container_1.ControlContainer,
	    useExisting: core_1.forwardRef(function () { return FormGroupDirective; })
	};
	var FormGroupDirective = (function (_super) {
	    __extends(FormGroupDirective, _super);
	    function FormGroupDirective(_validators, _asyncValidators) {
	        _super.call(this);
	        this._validators = _validators;
	        this._asyncValidators = _asyncValidators;
	        this._submitted = false;
	        this.directives = [];
	        this.form = null;
	        this.ngSubmit = new async_1.EventEmitter();
	    }
	    FormGroupDirective.prototype.ngOnChanges = function (changes) {
	        this._checkFormPresent();
	        if (collection_1.StringMapWrapper.contains(changes, 'form')) {
	            var sync = shared_1.composeValidators(this._validators);
	            this.form.validator = validators_1.Validators.compose([this.form.validator, sync]);
	            var async = shared_1.composeAsyncValidators(this._asyncValidators);
	            this.form.asyncValidator = validators_1.Validators.composeAsync([this.form.asyncValidator, async]);
	            this.form.updateValueAndValidity({ onlySelf: true, emitEvent: false });
	        }
	        this._updateDomValue();
	    };
	    Object.defineProperty(FormGroupDirective.prototype, "submitted", {
	        get: function () { return this._submitted; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormGroupDirective.prototype, "formDirective", {
	        get: function () { return this; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormGroupDirective.prototype, "control", {
	        get: function () { return this.form; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormGroupDirective.prototype, "path", {
	        get: function () { return []; },
	        enumerable: true,
	        configurable: true
	    });
	    FormGroupDirective.prototype.addControl = function (dir) {
	        var ctrl = this.form.find(dir.path);
	        shared_1.setUpControl(ctrl, dir);
	        ctrl.updateValueAndValidity({ emitEvent: false });
	        this.directives.push(dir);
	    };
	    FormGroupDirective.prototype.getControl = function (dir) { return this.form.find(dir.path); };
	    FormGroupDirective.prototype.removeControl = function (dir) { collection_1.ListWrapper.remove(this.directives, dir); };
	    FormGroupDirective.prototype.addFormGroup = function (dir) {
	        var ctrl = this.form.find(dir.path);
	        shared_1.setUpFormContainer(ctrl, dir);
	        ctrl.updateValueAndValidity({ emitEvent: false });
	    };
	    FormGroupDirective.prototype.removeFormGroup = function (dir) { };
	    FormGroupDirective.prototype.getFormGroup = function (dir) { return this.form.find(dir.path); };
	    FormGroupDirective.prototype.addFormArray = function (dir) {
	        var ctrl = this.form.find(dir.path);
	        shared_1.setUpFormContainer(ctrl, dir);
	        ctrl.updateValueAndValidity({ emitEvent: false });
	    };
	    FormGroupDirective.prototype.removeFormArray = function (dir) { };
	    FormGroupDirective.prototype.getFormArray = function (dir) { return this.form.find(dir.path); };
	    FormGroupDirective.prototype.updateModel = function (dir, value) {
	        var ctrl = this.form.find(dir.path);
	        ctrl.updateValue(value);
	    };
	    FormGroupDirective.prototype.onSubmit = function () {
	        this._submitted = true;
	        async_1.ObservableWrapper.callEmit(this.ngSubmit, null);
	        return false;
	    };
	    /** @internal */
	    FormGroupDirective.prototype._updateDomValue = function () {
	        var _this = this;
	        this.directives.forEach(function (dir) {
	            var ctrl = _this.form.find(dir.path);
	            dir.valueAccessor.writeValue(ctrl.value);
	        });
	    };
	    FormGroupDirective.prototype._checkFormPresent = function () {
	        if (lang_1.isBlank(this.form)) {
	            throw new exceptions_1.BaseException("formGroup expects a FormGroup instance. Please pass one in.\n           Example: <form [formGroup]=\"myFormGroup\">\n      ");
	        }
	    };
	    /** @nocollapse */
	    FormGroupDirective.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: '[formGroup]',
	                    providers: [exports.formDirectiveProvider],
	                    host: { '(submit)': 'onSubmit()' },
	                    exportAs: 'ngForm'
	                },] },
	    ];
	    /** @nocollapse */
	    FormGroupDirective.ctorParameters = [
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [validators_1.NG_VALIDATORS,] },] },
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [validators_1.NG_ASYNC_VALIDATORS,] },] },
	    ];
	    /** @nocollapse */
	    FormGroupDirective.propDecorators = {
	        'form': [{ type: core_1.Input, args: ['formGroup',] },],
	        'ngSubmit': [{ type: core_1.Output },],
	    };
	    return FormGroupDirective;
	}(control_container_1.ControlContainer));
	exports.FormGroupDirective = FormGroupDirective;
	//# sourceMappingURL=form_group_directive.js.map

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var core_1 = __webpack_require__(5);
	var validators_1 = __webpack_require__(1049);
	var abstract_form_group_directive_1 = __webpack_require__(1058);
	var control_container_1 = __webpack_require__(1055);
	exports.formGroupNameProvider = 
	/*@ts2dart_const*/ /* @ts2dart_Provider */ {
	    provide: control_container_1.ControlContainer,
	    useExisting: core_1.forwardRef(function () { return FormGroupName; })
	};
	var FormGroupName = (function (_super) {
	    __extends(FormGroupName, _super);
	    function FormGroupName(parent, validators, asyncValidators) {
	        _super.call(this);
	        this._parent = parent;
	        this._validators = validators;
	        this._asyncValidators = asyncValidators;
	    }
	    /** @nocollapse */
	    FormGroupName.decorators = [
	        { type: core_1.Directive, args: [{ selector: '[formGroupName]', providers: [exports.formGroupNameProvider] },] },
	    ];
	    /** @nocollapse */
	    FormGroupName.ctorParameters = [
	        { type: control_container_1.ControlContainer, decorators: [{ type: core_1.Host }, { type: core_1.SkipSelf },] },
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [validators_1.NG_VALIDATORS,] },] },
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [validators_1.NG_ASYNC_VALIDATORS,] },] },
	    ];
	    /** @nocollapse */
	    FormGroupName.propDecorators = {
	        'name': [{ type: core_1.Input, args: ['formGroupName',] },],
	    };
	    return FormGroupName;
	}(abstract_form_group_directive_1.AbstractFormGroupDirective));
	exports.FormGroupName = FormGroupName;
	//# sourceMappingURL=form_group_name.js.map

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var core_1 = __webpack_require__(5);
	var lang_1 = __webpack_require__(1036);
	var validators_1 = __webpack_require__(1049);
	var REQUIRED = validators_1.Validators.required;
	exports.REQUIRED_VALIDATOR = {
	    provide: validators_1.NG_VALIDATORS,
	    useValue: REQUIRED,
	    multi: true
	};
	var RequiredValidator = (function () {
	    function RequiredValidator() {
	    }
	    /** @nocollapse */
	    RequiredValidator.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: '[required][formControlName],[required][formControl],[required][ngModel]',
	                    providers: [exports.REQUIRED_VALIDATOR]
	                },] },
	    ];
	    return RequiredValidator;
	}());
	exports.RequiredValidator = RequiredValidator;
	/**
	 * Provivder which adds {@link MinLengthValidator} to {@link NG_VALIDATORS}.
	 *
	 * ## Example:
	 *
	 * {@example common/forms/ts/validators/validators.ts region='min'}
	 */
	exports.MIN_LENGTH_VALIDATOR = {
	    provide: validators_1.NG_VALIDATORS,
	    useExisting: core_1.forwardRef(function () { return MinLengthValidator; }),
	    multi: true
	};
	var MinLengthValidator = (function () {
	    function MinLengthValidator(minLength) {
	        this._validator = validators_1.Validators.minLength(lang_1.NumberWrapper.parseInt(minLength, 10));
	    }
	    MinLengthValidator.prototype.validate = function (c) { return this._validator(c); };
	    /** @nocollapse */
	    MinLengthValidator.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: '[minlength][formControlName],[minlength][formControl],[minlength][ngModel]',
	                    providers: [exports.MIN_LENGTH_VALIDATOR]
	                },] },
	    ];
	    /** @nocollapse */
	    MinLengthValidator.ctorParameters = [
	        { type: undefined, decorators: [{ type: core_1.Attribute, args: ['minlength',] },] },
	    ];
	    return MinLengthValidator;
	}());
	exports.MinLengthValidator = MinLengthValidator;
	/**
	 * Provider which adds {@link MaxLengthValidator} to {@link NG_VALIDATORS}.
	 *
	 * ## Example:
	 *
	 * {@example common/forms/ts/validators/validators.ts region='max'}
	 */
	exports.MAX_LENGTH_VALIDATOR = {
	    provide: validators_1.NG_VALIDATORS,
	    useExisting: core_1.forwardRef(function () { return MaxLengthValidator; }),
	    multi: true
	};
	var MaxLengthValidator = (function () {
	    function MaxLengthValidator(maxLength) {
	        this._validator = validators_1.Validators.maxLength(lang_1.NumberWrapper.parseInt(maxLength, 10));
	    }
	    MaxLengthValidator.prototype.validate = function (c) { return this._validator(c); };
	    /** @nocollapse */
	    MaxLengthValidator.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: '[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]',
	                    providers: [exports.MAX_LENGTH_VALIDATOR]
	                },] },
	    ];
	    /** @nocollapse */
	    MaxLengthValidator.ctorParameters = [
	        { type: undefined, decorators: [{ type: core_1.Attribute, args: ['maxlength',] },] },
	    ];
	    return MaxLengthValidator;
	}());
	exports.MaxLengthValidator = MaxLengthValidator;
	exports.PATTERN_VALIDATOR = {
	    provide: validators_1.NG_VALIDATORS,
	    useExisting: core_1.forwardRef(function () { return PatternValidator; }),
	    multi: true
	};
	var PatternValidator = (function () {
	    function PatternValidator(pattern) {
	        this._validator = validators_1.Validators.pattern(pattern);
	    }
	    PatternValidator.prototype.validate = function (c) { return this._validator(c); };
	    /** @nocollapse */
	    PatternValidator.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: '[pattern][formControlName],[pattern][formControl],[pattern][ngModel]',
	                    providers: [exports.PATTERN_VALIDATOR]
	                },] },
	    ];
	    /** @nocollapse */
	    PatternValidator.ctorParameters = [
	        { type: undefined, decorators: [{ type: core_1.Attribute, args: ['pattern',] },] },
	    ];
	    return PatternValidator;
	}());
	exports.PatternValidator = PatternValidator;
	//# sourceMappingURL=validators.js.map

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var core_1 = __webpack_require__(5);
	var collection_1 = __webpack_require__(1042);
	var lang_1 = __webpack_require__(1036);
	var model_1 = __webpack_require__(1047);
	var FormBuilder = (function () {
	    function FormBuilder() {
	    }
	    /**
	     * Construct a new {@link FormGroup} with the given map of configuration.
	     * Valid keys for the `extra` parameter map are `optionals` and `validator`.
	     *
	     * See the {@link FormGroup} constructor for more details.
	     */
	    FormBuilder.prototype.group = function (controlsConfig, extra) {
	        if (extra === void 0) { extra = null; }
	        var controls = this._reduceControls(controlsConfig);
	        var optionals = (lang_1.isPresent(extra) ? collection_1.StringMapWrapper.get(extra, 'optionals') : null);
	        var validator = lang_1.isPresent(extra) ? collection_1.StringMapWrapper.get(extra, 'validator') : null;
	        var asyncValidator = lang_1.isPresent(extra) ? collection_1.StringMapWrapper.get(extra, 'asyncValidator') : null;
	        return new model_1.FormGroup(controls, optionals, validator, asyncValidator);
	    };
	    /**
	     * Construct a new {@link FormControl} with the given `value`,`validator`, and `asyncValidator`.
	     */
	    FormBuilder.prototype.control = function (value, validator, asyncValidator) {
	        if (validator === void 0) { validator = null; }
	        if (asyncValidator === void 0) { asyncValidator = null; }
	        return new model_1.FormControl(value, validator, asyncValidator);
	    };
	    /**
	     * Construct an array of {@link FormControl}s from the given `controlsConfig` array of
	     * configuration, with the given optional `validator` and `asyncValidator`.
	     */
	    FormBuilder.prototype.array = function (controlsConfig, validator, asyncValidator) {
	        var _this = this;
	        if (validator === void 0) { validator = null; }
	        if (asyncValidator === void 0) { asyncValidator = null; }
	        var controls = controlsConfig.map(function (c) { return _this._createControl(c); });
	        return new model_1.FormArray(controls, validator, asyncValidator);
	    };
	    /** @internal */
	    FormBuilder.prototype._reduceControls = function (controlsConfig) {
	        var _this = this;
	        var controls = {};
	        collection_1.StringMapWrapper.forEach(controlsConfig, function (controlConfig, controlName) {
	            controls[controlName] = _this._createControl(controlConfig);
	        });
	        return controls;
	    };
	    /** @internal */
	    FormBuilder.prototype._createControl = function (controlConfig) {
	        if (controlConfig instanceof model_1.FormControl || controlConfig instanceof model_1.FormGroup ||
	            controlConfig instanceof model_1.FormArray) {
	            return controlConfig;
	        }
	        else if (lang_1.isArray(controlConfig)) {
	            var value = controlConfig[0];
	            var validator = controlConfig.length > 1 ? controlConfig[1] : null;
	            var asyncValidator = controlConfig.length > 2 ? controlConfig[2] : null;
	            return this.control(value, validator, asyncValidator);
	        }
	        else {
	            return this.control(controlConfig);
	        }
	    };
	    /** @nocollapse */
	    FormBuilder.decorators = [
	        { type: core_1.Injectable },
	    ];
	    return FormBuilder;
	}());
	exports.FormBuilder = FormBuilder;
	//# sourceMappingURL=form_builder.js.map

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var common_1 = __webpack_require__(2);
	var compiler_1 = __webpack_require__(176);
	var core_1 = __webpack_require__(5);
	var directives_1 = __webpack_require__(1032);
	var radio_control_value_accessor_1 = __webpack_require__(1052);
	var collection_1 = __webpack_require__(1042);
	var form_builder_1 = __webpack_require__(1065);
	/**
	 * Shorthand set of providers used for building Angular forms.
	 *
	 * ### Example
	 *
	 * ```typescript
	 * bootstrap(MyApp, [FORM_PROVIDERS]);
	 * ```
	 *
	 * @experimental
	 */
	exports.FORM_PROVIDERS = [form_builder_1.FormBuilder, radio_control_value_accessor_1.RadioControlRegistry];
	function flatten(platformDirectives) {
	    var flattenedDirectives = [];
	    platformDirectives.forEach(function (directives) {
	        if (Array.isArray(directives)) {
	            flattenedDirectives = flattenedDirectives.concat(directives);
	        }
	        else {
	            flattenedDirectives.push(directives);
	        }
	    });
	    return flattenedDirectives;
	}
	/**
	 * @experimental
	 */
	function disableDeprecatedForms() {
	    return [{
	            provide: compiler_1.CompilerConfig,
	            useFactory: function (platformDirectives, platformPipes) {
	                var flattenedDirectives = flatten(platformDirectives);
	                collection_1.ListWrapper.remove(flattenedDirectives, common_1.FORM_DIRECTIVES);
	                return new compiler_1.CompilerConfig({ platformDirectives: flattenedDirectives, platformPipes: platformPipes });
	            },
	            deps: [core_1.PLATFORM_DIRECTIVES, core_1.PLATFORM_PIPES]
	        }];
	}
	exports.disableDeprecatedForms = disableDeprecatedForms;
	/**
	 * @experimental
	 */
	function provideForms() {
	    return [
	        { provide: core_1.PLATFORM_DIRECTIVES, useValue: directives_1.FORM_DIRECTIVES, multi: true }, exports.FORM_PROVIDERS
	    ];
	}
	exports.provideForms = provideForms;
	//# sourceMappingURL=form_providers.js.map

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var http_1 = __webpack_require__(382);
	var Rx_1 = __webpack_require__(653);
	var error_notifier_1 = __webpack_require__(652);
	var CustomHttp = (function (_super) {
	    __extends(CustomHttp, _super);
	    function CustomHttp(backend, defaultOptions, errorService) {
	        _super.call(this, backend, defaultOptions);
	        this.errorService = errorService;
	        this.err = null;
	    }
	    CustomHttp.prototype.request = function (url, options) {
	        var _this = this;
	        // console.log('Before the request...');
	        return _super.prototype.request.call(this, url, options)
	            .catch(function (err) {
	            _this.errorService.notifyError(err);
	            return Rx_1.Observable.empty();
	        })
	            .retryWhen(function (error) { return error.delay(500); })
	            .finally(function () {
	            // console.log('After the request...');
	        });
	    };
	    CustomHttp.prototype.get = function (url, options) {
	        var _this = this;
	        var headers;
	        this.err = null;
	        if (this.err == null && url.indexOf("/reset") == -1) {
	            if (options == undefined) {
	                options = {};
	                headers = new http_1.Headers();
	            }
	            else {
	                headers = options.headers;
	            }
	            options.headers = this.createAuthorizationHeader(headers);
	            return _super.prototype.get.call(this, url, options)
	                .catch(function (err) {
	                console.log(err);
	                if (err.status === 400 || err.status === 422) {
	                    return Rx_1.Observable.throw(err);
	                }
	                else {
	                    _this.errorService.notifyError(err);
	                    return Rx_1.Observable.empty();
	                }
	            })
	                .retryWhen(function (error) { return error.delay(500); })
	                .finally(function () {
	                // console.log('After the request...');
	            });
	        }
	        else
	            return _super.prototype.get.call(this, url, options);
	    };
	    CustomHttp.prototype.post = function (url, body, options) {
	        var _this = this;
	        this.err = null;
	        var headers;
	        if (this.err == null && url.indexOf("/authenticate") == -1 && url.indexOf("/forgot") == -1) {
	            if (options == undefined) {
	                options = {};
	                headers = new http_1.Headers();
	            }
	            else {
	                headers = options.headers;
	            }
	            options.headers = this.createAuthorizationHeader(headers);
	            return _super.prototype.post.call(this, url, body, options)
	                .catch(function (err) {
	                if (err.status === 400 || err.status === 422) {
	                    return Rx_1.Observable.throw(err);
	                }
	                else {
	                    console.log(err);
	                    console.log(err.status);
	                    _this.err = err;
	                    _this.errorService.notifyError(err);
	                    //return Observable.empty();
	                    return Rx_1.Observable.throw(err);
	                }
	            })
	                .finally(function () {
	                if (_this.err == null)
	                    _this.errorService.notifyOk();
	            });
	        }
	        else
	            return _super.prototype.post.call(this, url, body, options);
	    };
	    CustomHttp.prototype.put = function (url, body, options) {
	        var _this = this;
	        var headers;
	        if (options == undefined) {
	            options = {};
	            headers = new http_1.Headers();
	        }
	        else {
	            headers = options.headers;
	        }
	        options.headers = this.createAuthorizationHeader(headers);
	        this.err = null;
	        return _super.prototype.put.call(this, url, body, options)
	            .catch(function (err) {
	            if (err.status === 400 || err.status === 422) {
	                return Rx_1.Observable.throw(err);
	            }
	            else {
	                _this.err = err;
	                _this.errorService.notifyError(err);
	                return Rx_1.Observable.empty();
	            }
	        })
	            .finally(function () {
	            if (_this.err == null)
	                _this.errorService.notifyOk();
	        });
	    };
	    CustomHttp.prototype.delete = function (url, body, options) {
	        var _this = this;
	        var headers;
	        if (options == undefined) {
	            options = {};
	            headers = new http_1.Headers();
	        }
	        else {
	            headers = options.headers;
	        }
	        options.headers = this.createAuthorizationHeader(headers);
	        this.err = null;
	        return _super.prototype.delete.call(this, url, options)
	            .catch(function (err) {
	            if (err.status === 400 || err.status === 422) {
	                return Rx_1.Observable.throw(err);
	            }
	            else {
	                _this.err = err;
	                _this.errorService.notifyError(err);
	                return Rx_1.Observable.empty();
	            }
	        })
	            .finally(function () {
	            if (_this.err == null)
	                _this.errorService.notifyOk();
	        });
	    };
	    CustomHttp.prototype.createAuthorizationHeader = function (headers) {
	        headers.append('Authorization', localStorage.getItem('jwtSGDI'));
	        return headers;
	    };
	    CustomHttp = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.ConnectionBackend !== 'undefined' && http_1.ConnectionBackend) === 'function' && _a) || Object, (typeof (_b = typeof http_1.RequestOptions !== 'undefined' && http_1.RequestOptions) === 'function' && _b) || Object, (typeof (_c = typeof error_notifier_1.ErrorNotifierService !== 'undefined' && error_notifier_1.ErrorNotifierService) === 'function' && _c) || Object])
	    ], CustomHttp);
	    return CustomHttp;
	    var _a, _b, _c;
	}(http_1.Http));
	exports.CustomHttp = CustomHttp;


/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var http_1 = __webpack_require__(382);
	__webpack_require__(374);
	var progress_service_1 = __webpack_require__(980);
	var CustomBrowserXhr = (function (_super) {
	    __extends(CustomBrowserXhr, _super);
	    function CustomBrowserXhr(service) {
	        _super.call(this);
	        this.service = service;
	    }
	    CustomBrowserXhr.prototype.build = function () {
	        var _this = this;
	        var xhr = _super.prototype.build.call(this);
	        xhr.onprogress = function (event) {
	            _this.service.progressEventObservable.next(event);
	        };
	        return (xhr);
	    };
	    CustomBrowserXhr = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof progress_service_1.ProgressService !== 'undefined' && progress_service_1.ProgressService) === 'function' && _a) || Object])
	    ], CustomBrowserXhr);
	    return CustomBrowserXhr;
	    var _a;
	}(http_1.BrowserXhr));
	exports.CustomBrowserXhr = CustomBrowserXhr;


/***/ }),
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/* WEBPACK VAR INJECTION */(function(process) {
	/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(__webpack_module_template_argument_0__);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	  return (typeof document !== 'undefined' && 'WebkitAppearance' in document.documentElement.style) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (window.console && (console.firebug || (console.exception && console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31);
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  try {
	    return JSON.stringify(v);
	  } catch (err) {
	    return '[UnexpectedJSONParseError]: ' + err.message;
	  }
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs() {
	  var args = arguments;
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return args;
	
	  var c = 'color: ' + this.color;
	  args = [args[0], c, 'color: inherit'].concat(Array.prototype.slice.call(args, 1));
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	  return args;
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    return exports.storage.debug;
	  } catch(e) {}
	
	  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	  if (typeof process !== 'undefined' && 'env' in process) {
	    return ({"ENV":"production"}).DEBUG;
	  }
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage(){
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(597)))

/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = debug.debug = debug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lowercased letter, i.e. "n".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previously assigned color.
	 */
	
	var prevColor = 0;
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 *
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor() {
	  return exports.colors[prevColor++ % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function debug(namespace) {
	
	  // define the `disabled` version
	  function disabled() {
	  }
	  disabled.enabled = false;
	
	  // define the `enabled` version
	  function enabled() {
	
	    var self = enabled;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // add the `color` if not set
	    if (null == self.useColors) self.useColors = exports.useColors();
	    if (null == self.color && self.useColors) self.color = selectColor();
	
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %o
	      args = ['%o'].concat(args);
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    // apply env-specific formatting
	    args = exports.formatArgs.apply(self, args);
	
	    var logFn = enabled.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	  enabled.enabled = true;
	
	  var fn = exports.enabled(namespace) ? enabled : disabled;
	
	  fn.namespace = namespace;
	
	  return fn;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  var split = (namespaces || '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/[\\^$+?.()|[\]{}]/g, '\\$&').replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ })
]);


// WEBPACK FOOTER //
// app.49066da0a71d2d7eb6d9.js